(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var __keys_key = Object.keys(x), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var __keys_key = Object.keys(oldRecord), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		newRecord[key] = oldRecord[key];
	}

	for (var __keys_key = Object.keys(updatedFields), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var __keys_k = Object.keys(value), __i_k = 0; __i_k < __keys_k.length; __i_k++) { var k = __keys_k[__i_k];
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var __keys_i = Object.keys(value), __i_i = 0; __i_i < __keys_i.length; __i_i++) { var i = __keys_i[__i_i];
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var __keys_key = Object.keys(value), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.iS.eE === region.j6.eE)
	{
		return 'on line ' + region.iS.eE;
	}
	return 'on lines ' + region.iS.eE + ' through ' + region.j6.eE;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var __keys_key = Object.keys(value), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.pj,
		impl.mO,
		impl.mq,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var __keys_key = Object.keys(_Platform_effectManagers), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var __keys_home = Object.keys(managers), __i_home = 0; __i_home < __keys_home.length; __i_home++) { var home = __keys_home[__i_home];
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var __keys_name = Object.keys(exports), __i_name = 0; __i_name < __keys_name.length; __i_name++) { var name = __keys_name[__i_name];
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var __keys_name = Object.keys(exports), __i_name = 0; __i_name < __keys_name.length; __i_name++) { var name = __keys_name[__i_name];
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS
//
// For some reason, tabs can appear in href protocols and it still works.
// So '\tjava\tSCRIPT:alert("!!!")' and 'javascript:alert("!!!")' are the same
// in practice. That is why _VirtualDom_RE_js and _VirtualDom_RE_js_html look
// so freaky.
//
// Pulling the regular expressions out to the top level gives a slight speed
// boost in small benchmarks (4-10%) but hoisting values to reduce allocation
// can be unpredictable in large programs where JIT may have a harder time with
// functions are not fully self-contained. The benefit is more that the js and
// js_html ones are so weird that I prefer to see them near each other.


var _VirtualDom_RE_script = /^script$/i;
var _VirtualDom_RE_on_formAction = /^(on|formAction$)/i;
var _VirtualDom_RE_js = /^\s*j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:/i;
var _VirtualDom_RE_js_html = /^\s*(j\s*a\s*v\s*a\s*s\s*c\s*r\s*i\s*p\s*t\s*:|d\s*a\s*t\s*a\s*:\s*t\s*e\s*x\s*t\s*\/\s*h\s*t\s*m\s*l\s*(,|;))/i;


function _VirtualDom_noScript(tag)
{
	return _VirtualDom_RE_script.test(tag) ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return _VirtualDom_RE_on_formAction.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return _VirtualDom_RE_js.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return _VirtualDom_RE_js_html.test(value)
		? /**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlJson(value)
{
	return (typeof _Json_unwrap(value) === 'string' && _VirtualDom_RE_js_html.test(_Json_unwrap(value)))
		? _Json_wrap(
			/**/''//*//**_UNUSED/'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'//*/
		) : value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		pP: func(record.pP),
		ml: record.ml,
		lF: record.lF
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var __keys_key = Object.keys(facts), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var __keys_key = Object.keys(styles), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var __keys_key = Object.keys(attrs), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var __keys_key = Object.keys(nsAttrs), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var __keys_key = Object.keys(events), __i_key = 0; __i_key < __keys_key.length; __i_key++) { var key = __keys_key[__i_key];
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.pP;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.ml;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.lF) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var __keys_xKey = Object.keys(x), __i_xKey = 0; __i_xKey < __keys_xKey.length; __i_xKey++) { var xKey = __keys_xKey[__i_xKey];
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var __keys_yKey = Object.keys(y), __i_yKey = 0; __i_yKey < __keys_yKey.length; __i_yKey++) { var yKey = __keys_yKey[__i_yKey];
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.pj,
		impl.mO,
		impl.mq,
		function(sendToApp, initialModel) {
			var view = impl.sb;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.pj,
		impl.mO,
		impl.mq,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.iK && impl.iK(sendToApp)
			var view = impl.sb;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.jv);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.Y) && (_VirtualDom_doc.title = title = doc.Y);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.p7;
	var onUrlRequest = impl.p8;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		iK: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.qB === next.qB
							&& curr.fU === next.fU
							&& curr.gu.a === next.gu.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		pj: function(flags)
		{
			return A3(impl.pj, flags, _Browser_getUrl(), key);
		},
		sb: impl.sb,
		mO: impl.mO,
		mq: impl.mq
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { o5: 'hidden', nQ: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { o5: 'mozHidden', nQ: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { o5: 'msHidden', nQ: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { o5: 'webkitHidden', nQ: 'webkitvisibilitychange' }
		: { o5: 'hidden', nQ: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		q7: _Browser_getScene(),
		mX: {
			m3: _Browser_window.pageXOffset,
			m4: _Browser_window.pageYOffset,
			da: _Browser_doc.documentElement.clientWidth,
			cv: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		da: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		cv: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			q7: {
				da: node.scrollWidth,
				cv: node.scrollHeight
			},
			mX: {
				m3: node.scrollLeft,
				m4: node.scrollTop,
				da: node.clientWidth,
				cv: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			q7: _Browser_getScene(),
			mX: {
				m3: x,
				m4: y,
				da: _Browser_doc.documentElement.clientWidth,
				cv: _Browser_doc.documentElement.clientHeight
			},
			j4: {
				m3: x + rect.left,
				m4: y + rect.top,
				da: rect.width,
				cv: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}




// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});



function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});



// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.hK.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.hK.b, xhr)); });
		$elm$core$Maybe$isJust(request.i0) && _Http_track(router, xhr, request.i0.a);

		try {
			xhr.open(request.h8, request.c3, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.c3));
		}

		_Http_configureRequest(xhr, request);

		request.jv.a && xhr.setRequestHeader('Content-Type', request.jv.a);
		xhr.send(request.jv.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.hU; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.iY.a || 0;
	xhr.responseType = request.hK.d;
	xhr.withCredentials = request.nq;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		c3: xhr.responseURL,
		rD: xhr.status,
		rE: xhr.statusText,
		hU: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			rf: event.loaded,
			cX: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			qG: event.loaded,
			cX: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}

function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}

// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.lc) { flags += 'm'; }
	if (options.jA) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}





// VIRTUAL-DOM WIDGETS


var _Markdown_toHtml = F3(function(options, factList, rawMarkdown)
{
	return _VirtualDom_custom(
		factList,
		{
			a: options,
			b: rawMarkdown
		},
		_Markdown_render,
		_Markdown_diff
	);
});



// WIDGET IMPLEMENTATION


function _Markdown_render(model)
{
	return A2(_Markdown_replace, model, _VirtualDom_doc.createElement('div'));
}


function _Markdown_diff(x, y)
{
	return x.b === y.b && x.a === y.a
		? false
		: _Markdown_replace(y);
}


var _Markdown_replace = F2(function(model, div)
{
	div.innerHTML = _Markdown_marked(model.b, _Markdown_formatOptions(model.a));
	return div;
});



// ACTUAL MARKDOWN PARSER


var _Markdown_marked = function() {
	// catch the `marked` object regardless of the outer environment.
	// (ex. a CommonJS module compatible environment.)
	// note that this depends on marked's implementation of environment detection.
	var module = {};
	var exports = module.exports = {};

	/**
	 * marked - a markdown parser
	 * Copyright (c) 2011-2014, Christopher Jeffrey. (MIT Licensed)
	 * https://github.com/chjj/marked
	 * commit cd2f6f5b7091154c5526e79b5f3bfb4d15995a51
	 */
	(function(){var block={newline:/^\n+/,code:/^( {4}[^\n]+\n*)+/,fences:noop,hr:/^( *[-*_]){3,} *(?:\n+|$)/,heading:/^ *(#{1,6}) *([^\n]+?) *#* *(?:\n+|$)/,nptable:noop,lheading:/^([^\n]+)\n *(=|-){2,} *(?:\n+|$)/,blockquote:/^( *>[^\n]+(\n(?!def)[^\n]+)*\n*)+/,list:/^( *)(bull) [\s\S]+?(?:hr|def|\n{2,}(?! )(?!\1bull )\n*|\s*$)/,html:/^ *(?:comment *(?:\n|\s*$)|closed *(?:\n{2,}|\s*$)|closing *(?:\n{2,}|\s*$))/,def:/^ *\[([^\]]+)\]: *<?([^\s>]+)>?(?: +["(]([^\n]+)[")])? *(?:\n+|$)/,table:noop,paragraph:/^((?:[^\n]+\n?(?!hr|heading|lheading|blockquote|tag|def))+)\n*/,text:/^[^\n]+/};block.bullet=/(?:[*+-]|\d+\.)/;block.item=/^( *)(bull) [^\n]*(?:\n(?!\1bull )[^\n]*)*/;block.item=replace(block.item,"gm")(/bull/g,block.bullet)();block.list=replace(block.list)(/bull/g,block.bullet)("hr","\\n+(?=\\1?(?:[-*_] *){3,}(?:\\n+|$))")("def","\\n+(?="+block.def.source+")")();block.blockquote=replace(block.blockquote)("def",block.def)();block._tag="(?!(?:"+"a|em|strong|small|s|cite|q|dfn|abbr|data|time|code"+"|var|samp|kbd|sub|sup|i|b|u|mark|ruby|rt|rp|bdi|bdo"+"|span|br|wbr|ins|del|img)\\b)\\w+(?!:/|[^\\w\\s@]*@)\\b";block.html=replace(block.html)("comment",/<!--[\s\S]*?-->/)("closed",/<(tag)[\s\S]+?<\/\1>/)("closing",/<tag(?:"[^"]*"|'[^']*'|[^'">])*?>/)(/tag/g,block._tag)();block.paragraph=replace(block.paragraph)("hr",block.hr)("heading",block.heading)("lheading",block.lheading)("blockquote",block.blockquote)("tag","<"+block._tag)("def",block.def)();block.normal=merge({},block);block.gfm=merge({},block.normal,{fences:/^ *(`{3,}|~{3,})[ \.]*(\S+)? *\n([\s\S]*?)\s*\1 *(?:\n+|$)/,paragraph:/^/,heading:/^ *(#{1,6}) +([^\n]+?) *#* *(?:\n+|$)/});block.gfm.paragraph=replace(block.paragraph)("(?!","(?!"+block.gfm.fences.source.replace("\\1","\\2")+"|"+block.list.source.replace("\\1","\\3")+"|")();block.tables=merge({},block.gfm,{nptable:/^ *(\S.*\|.*)\n *([-:]+ *\|[-| :]*)\n((?:.*\|.*(?:\n|$))*)\n*/,table:/^ *\|(.+)\n *\|( *[-:]+[-| :]*)\n((?: *\|.*(?:\n|$))*)\n*/});function Lexer(options){this.tokens=[];this.tokens.links={};this.options=options||marked.defaults;this.rules=block.normal;if(this.options.gfm){if(this.options.tables){this.rules=block.tables}else{this.rules=block.gfm}}}Lexer.rules=block;Lexer.lex=function(src,options){var lexer=new Lexer(options);return lexer.lex(src)};Lexer.prototype.lex=function(src){src=src.replace(/\r\n|\r/g,"\n").replace(/\t/g,"    ").replace(/\u00a0/g," ").replace(/\u2424/g,"\n");return this.token(src,true)};Lexer.prototype.token=function(src,top,bq){var src=src.replace(/^ +$/gm,""),next,loose,cap,bull,b,item,space,i,l;while(src){if(cap=this.rules.newline.exec(src)){src=src.substring(cap[0].length);if(cap[0].length>1){this.tokens.push({type:"space"})}}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);cap=cap[0].replace(/^ {4}/gm,"");this.tokens.push({type:"code",text:!this.options.pedantic?cap.replace(/\n+$/,""):cap});continue}if(cap=this.rules.fences.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"code",lang:cap[2],text:cap[3]||""});continue}if(cap=this.rules.heading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[1].length,text:cap[2]});continue}if(top&&(cap=this.rules.nptable.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].split(/ *\| */)}this.tokens.push(item);continue}if(cap=this.rules.lheading.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"heading",depth:cap[2]==="="?1:2,text:cap[1]});continue}if(cap=this.rules.hr.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"hr"});continue}if(cap=this.rules.blockquote.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"blockquote_start"});cap=cap[0].replace(/^ *> ?/gm,"");this.token(cap,top,true);this.tokens.push({type:"blockquote_end"});continue}if(cap=this.rules.list.exec(src)){src=src.substring(cap[0].length);bull=cap[2];this.tokens.push({type:"list_start",ordered:bull.length>1});cap=cap[0].match(this.rules.item);next=false;l=cap.length;i=0;for(;i<l;i++){item=cap[i];space=item.length;item=item.replace(/^ *([*+-]|\d+\.) +/,"");if(~item.indexOf("\n ")){space-=item.length;item=!this.options.pedantic?item.replace(new RegExp("^ {1,"+space+"}","gm"),""):item.replace(/^ {1,4}/gm,"")}if(this.options.smartLists&&i!==l-1){b=block.bullet.exec(cap[i+1])[0];if(bull!==b&&!(bull.length>1&&b.length>1)){src=cap.slice(i+1).join("\n")+src;i=l-1}}loose=next||/\n\n(?!\s*$)/.test(item);if(i!==l-1){next=item.charAt(item.length-1)==="\n";if(!loose)loose=next}this.tokens.push({type:loose?"loose_item_start":"list_item_start"});this.token(item,false,bq);this.tokens.push({type:"list_item_end"})}this.tokens.push({type:"list_end"});continue}if(cap=this.rules.html.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:this.options.sanitize?"paragraph":"html",pre:!this.options.sanitizer&&(cap[1]==="pre"||cap[1]==="script"||cap[1]==="style"),text:cap[0]});continue}if(!bq&&top&&(cap=this.rules.def.exec(src))){src=src.substring(cap[0].length);this.tokens.links[cap[1].toLowerCase()]={href:cap[2],title:cap[3]};continue}if(top&&(cap=this.rules.table.exec(src))){src=src.substring(cap[0].length);item={type:"table",header:cap[1].replace(/^ *| *\| *$/g,"").split(/ *\| */),align:cap[2].replace(/^ *|\| *$/g,"").split(/ *\| */),cells:cap[3].replace(/(?: *\| *)?\n$/,"").split("\n")};for(i=0;i<item.align.length;i++){if(/^ *-+: *$/.test(item.align[i])){item.align[i]="right"}else if(/^ *:-+: *$/.test(item.align[i])){item.align[i]="center"}else if(/^ *:-+ *$/.test(item.align[i])){item.align[i]="left"}else{item.align[i]=null}}for(i=0;i<item.cells.length;i++){item.cells[i]=item.cells[i].replace(/^ *\| *| *\| *$/g,"").split(/ *\| */)}this.tokens.push(item);continue}if(top&&(cap=this.rules.paragraph.exec(src))){src=src.substring(cap[0].length);this.tokens.push({type:"paragraph",text:cap[1].charAt(cap[1].length-1)==="\n"?cap[1].slice(0,-1):cap[1]});continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);this.tokens.push({type:"text",text:cap[0]});continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return this.tokens};var inline={escape:/^\\([\\`*{}\[\]()#+\-.!_>])/,autolink:/^<([^ >]+(@|:\/)[^ >]+)>/,url:noop,tag:/^<!--[\s\S]*?-->|^<\/?\w+(?:"[^"]*"|'[^']*'|[^'">])*?>/,link:/^!?\[(inside)\]\(href\)/,reflink:/^!?\[(inside)\]\s*\[([^\]]*)\]/,nolink:/^!?\[((?:\[[^\]]*\]|[^\[\]])*)\]/,strong:/^_\_([\s\S]+?)_\_(?!_)|^\*\*([\s\S]+?)\*\*(?!\*)/,em:/^\b_((?:[^_]|_\_)+?)_\b|^\*((?:\*\*|[\s\S])+?)\*(?!\*)/,code:/^(`+)\s*([\s\S]*?[^`])\s*\1(?!`)/,br:/^ {2,}\n(?!\s*$)/,del:noop,text:/^[\s\S]+?(?=[\\<!\[_*`]| {2,}\n|$)/};inline._inside=/(?:\[[^\]]*\]|[^\[\]]|\](?=[^\[]*\]))*/;inline._href=/\s*<?([\s\S]*?)>?(?:\s+['"]([\s\S]*?)['"])?\s*/;inline.link=replace(inline.link)("inside",inline._inside)("href",inline._href)();inline.reflink=replace(inline.reflink)("inside",inline._inside)();inline.normal=merge({},inline);inline.pedantic=merge({},inline.normal,{strong:/^_\_(?=\S)([\s\S]*?\S)_\_(?!_)|^\*\*(?=\S)([\s\S]*?\S)\*\*(?!\*)/,em:/^_(?=\S)([\s\S]*?\S)_(?!_)|^\*(?=\S)([\s\S]*?\S)\*(?!\*)/});inline.gfm=merge({},inline.normal,{escape:replace(inline.escape)("])","~|])")(),url:/^(https?:\/\/[^\s<]+[^<.,:;"')\]\s])/,del:/^~~(?=\S)([\s\S]*?\S)~~/,text:replace(inline.text)("]|","~]|")("|","|https?://|")()});inline.breaks=merge({},inline.gfm,{br:replace(inline.br)("{2,}","*")(),text:replace(inline.gfm.text)("{2,}","*")()});function InlineLexer(links,options){this.options=options||marked.defaults;this.links=links;this.rules=inline.normal;this.renderer=this.options.renderer||new Renderer;this.renderer.options=this.options;if(!this.links){throw new Error("Tokens array requires a `links` property.")}if(this.options.gfm){if(this.options.breaks){this.rules=inline.breaks}else{this.rules=inline.gfm}}else if(this.options.pedantic){this.rules=inline.pedantic}}InlineLexer.rules=inline;InlineLexer.output=function(src,links,options){var inline=new InlineLexer(links,options);return inline.output(src)};InlineLexer.prototype.output=function(src){var out="",link,text,href,cap;while(src){if(cap=this.rules.escape.exec(src)){src=src.substring(cap[0].length);out+=cap[1];continue}if(cap=this.rules.autolink.exec(src)){src=src.substring(cap[0].length);if(cap[2]==="@"){text=cap[1].charAt(6)===":"?this.mangle(cap[1].substring(7)):this.mangle(cap[1]);href=this.mangle("mailto:")+text}else{text=escape(cap[1]);href=text}out+=this.renderer.link(href,null,text);continue}if(!this.inLink&&(cap=this.rules.url.exec(src))){src=src.substring(cap[0].length);text=escape(cap[1]);href=text;out+=this.renderer.link(href,null,text);continue}if(cap=this.rules.tag.exec(src)){if(!this.inLink&&/^<a /i.test(cap[0])){this.inLink=true}else if(this.inLink&&/^<\/a>/i.test(cap[0])){this.inLink=false}src=src.substring(cap[0].length);out+=this.options.sanitize?this.options.sanitizer?this.options.sanitizer(cap[0]):escape(cap[0]):cap[0];continue}if(cap=this.rules.link.exec(src)){src=src.substring(cap[0].length);this.inLink=true;out+=this.outputLink(cap,{href:cap[2],title:cap[3]});this.inLink=false;continue}if((cap=this.rules.reflink.exec(src))||(cap=this.rules.nolink.exec(src))){src=src.substring(cap[0].length);link=(cap[2]||cap[1]).replace(/\s+/g," ");link=this.links[link.toLowerCase()];if(!link||!link.href){out+=cap[0].charAt(0);src=cap[0].substring(1)+src;continue}this.inLink=true;out+=this.outputLink(cap,link);this.inLink=false;continue}if(cap=this.rules.strong.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.strong(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.em.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.em(this.output(cap[2]||cap[1]));continue}if(cap=this.rules.code.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.codespan(escape(cap[2],true));continue}if(cap=this.rules.br.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.br();continue}if(cap=this.rules.del.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.del(this.output(cap[1]));continue}if(cap=this.rules.text.exec(src)){src=src.substring(cap[0].length);out+=this.renderer.text(escape(this.smartypants(cap[0])));continue}if(src){throw new Error("Infinite loop on byte: "+src.charCodeAt(0))}}return out};InlineLexer.prototype.outputLink=function(cap,link){var href=escape(link.href),title=link.title?escape(link.title):null;return cap[0].charAt(0)!=="!"?this.renderer.link(href,title,this.output(cap[1])):this.renderer.image(href,title,escape(cap[1]))};InlineLexer.prototype.smartypants=function(text){if(!this.options.smartypants)return text;return text.replace(/---/g,"—").replace(/--/g,"–").replace(/(^|[-\u2014\/(\[{"\s])'/g,"$1‘").replace(/'/g,"’").replace(/(^|[-\u2014\/(\[{\u2018\s])"/g,"$1“").replace(/"/g,"”").replace(/\.{3}/g,"…")};InlineLexer.prototype.mangle=function(text){if(!this.options.mangle)return text;var out="",l=text.length,i=0,ch;for(;i<l;i++){ch=text.charCodeAt(i);if(Math.random()>.5){ch="x"+ch.toString(16)}out+="&#"+ch+";"}return out};function Renderer(options){this.options=options||{}}Renderer.prototype.code=function(code,lang,escaped){if(this.options.highlight){var out=this.options.highlight(code,lang);if(out!=null&&out!==code){escaped=true;code=out}}if(!lang){return"<pre><code>"+(escaped?code:escape(code,true))+"\n</code></pre>"}return'<pre><code class="'+this.options.langPrefix+escape(lang,true)+'">'+(escaped?code:escape(code,true))+"\n</code></pre>\n"};Renderer.prototype.blockquote=function(quote){return"<blockquote>\n"+quote+"</blockquote>\n"};Renderer.prototype.html=function(html){return html};Renderer.prototype.heading=function(text,level,raw){return"<h"+level+' id="'+this.options.headerPrefix+raw.toLowerCase().replace(/[^\w]+/g,"-")+'">'+text+"</h"+level+">\n"};Renderer.prototype.hr=function(){return this.options.xhtml?"<hr/>\n":"<hr>\n"};Renderer.prototype.list=function(body,ordered){var type=ordered?"ol":"ul";return"<"+type+">\n"+body+"</"+type+">\n"};Renderer.prototype.listitem=function(text){return"<li>"+text+"</li>\n"};Renderer.prototype.paragraph=function(text){return"<p>"+text+"</p>\n"};Renderer.prototype.table=function(header,body){return"<table>\n"+"<thead>\n"+header+"</thead>\n"+"<tbody>\n"+body+"</tbody>\n"+"</table>\n"};Renderer.prototype.tablerow=function(content){return"<tr>\n"+content+"</tr>\n"};Renderer.prototype.tablecell=function(content,flags){var type=flags.header?"th":"td";var tag=flags.align?"<"+type+' style="text-align:'+flags.align+'">':"<"+type+">";return tag+content+"</"+type+">\n"};Renderer.prototype.strong=function(text){return"<strong>"+text+"</strong>"};Renderer.prototype.em=function(text){return"<em>"+text+"</em>"};Renderer.prototype.codespan=function(text){return"<code>"+text+"</code>"};Renderer.prototype.br=function(){return this.options.xhtml?"<br/>":"<br>"};Renderer.prototype.del=function(text){return"<del>"+text+"</del>"};Renderer.prototype.link=function(href,title,text){if(this.options.sanitize){try{var prot=decodeURIComponent(unescape(href)).replace(/[^\w:]/g,"").toLowerCase()}catch(e){return""}if(prot.indexOf("javascript:")===0||prot.indexOf("vbscript:")===0||prot.indexOf("data:")===0){return""}}var out='<a href="'+href+'"';if(title){out+=' title="'+title+'"'}out+=">"+text+"</a>";return out};Renderer.prototype.image=function(href,title,text){var out='<img src="'+href+'" alt="'+text+'"';if(title){out+=' title="'+title+'"'}out+=this.options.xhtml?"/>":">";return out};Renderer.prototype.text=function(text){return text};function Parser(options){this.tokens=[];this.token=null;this.options=options||marked.defaults;this.options.renderer=this.options.renderer||new Renderer;this.renderer=this.options.renderer;this.renderer.options=this.options}Parser.parse=function(src,options,renderer){var parser=new Parser(options,renderer);return parser.parse(src)};Parser.prototype.parse=function(src){this.inline=new InlineLexer(src.links,this.options,this.renderer);this.tokens=src.reverse();var out="";while(this.next()){out+=this.tok()}return out};Parser.prototype.next=function(){return this.token=this.tokens.pop()};Parser.prototype.peek=function(){return this.tokens[this.tokens.length-1]||0};Parser.prototype.parseText=function(){var body=this.token.text;while(this.peek().type==="text"){body+="\n"+this.next().text}return this.inline.output(body)};Parser.prototype.tok=function(){switch(this.token.type){case"space":{return""}case"hr":{return this.renderer.hr()}case"heading":{return this.renderer.heading(this.inline.output(this.token.text),this.token.depth,this.token.text)}case"code":{return this.renderer.code(this.token.text,this.token.lang,this.token.escaped)}case"table":{var header="",body="",i,row,cell,flags,j;cell="";for(i=0;i<this.token.header.length;i++){flags={header:true,align:this.token.align[i]};cell+=this.renderer.tablecell(this.inline.output(this.token.header[i]),{header:true,align:this.token.align[i]})}header+=this.renderer.tablerow(cell);for(i=0;i<this.token.cells.length;i++){row=this.token.cells[i];cell="";for(j=0;j<row.length;j++){cell+=this.renderer.tablecell(this.inline.output(row[j]),{header:false,align:this.token.align[j]})}body+=this.renderer.tablerow(cell)}return this.renderer.table(header,body)}case"blockquote_start":{var body="";while(this.next().type!=="blockquote_end"){body+=this.tok()}return this.renderer.blockquote(body)}case"list_start":{var body="",ordered=this.token.ordered;while(this.next().type!=="list_end"){body+=this.tok()}return this.renderer.list(body,ordered)}case"list_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.token.type==="text"?this.parseText():this.tok()}return this.renderer.listitem(body)}case"loose_item_start":{var body="";while(this.next().type!=="list_item_end"){body+=this.tok()}return this.renderer.listitem(body)}case"html":{var html=!this.token.pre&&!this.options.pedantic?this.inline.output(this.token.text):this.token.text;return this.renderer.html(html)}case"paragraph":{return this.renderer.paragraph(this.inline.output(this.token.text))}case"text":{return this.renderer.paragraph(this.parseText())}}};function escape(html,encode){return html.replace(!encode?/&(?!#?\w+;)/g:/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/"/g,"&quot;").replace(/'/g,"&#39;")}function unescape(html){return html.replace(/&(#(?:\d+)|(?:#x[0-9A-Fa-f]+)|(?:\w+));?/g,function(_,n){n=n.toLowerCase();if(n==="colon")return":";if(n.charAt(0)==="#"){return n.charAt(1)==="x"?String.fromCharCode(parseInt(n.substring(2),16)):String.fromCharCode(+n.substring(1))}return""})}function replace(regex,opt){regex=regex.source;opt=opt||"";return function self(name,val){if(!name)return new RegExp(regex,opt);val=val.source||val;val=val.replace(/(^|[^\[])\^/g,"$1");regex=regex.replace(name,val);return self}}function noop(){}noop.exec=noop;function merge(obj){var i=1,target,key;for(;i<arguments.length;i++){target=arguments[i];for(key in target){if(Object.prototype.hasOwnProperty.call(target,key)){obj[key]=target[key]}}}return obj}function marked(src,opt,callback){if(callback||typeof opt==="function"){if(!callback){callback=opt;opt=null}opt=merge({},marked.defaults,opt||{});var highlight=opt.highlight,tokens,pending,i=0;try{tokens=Lexer.lex(src,opt)}catch(e){return callback(e)}pending=tokens.length;var done=function(err){if(err){opt.highlight=highlight;return callback(err)}var out;try{out=Parser.parse(tokens,opt)}catch(e){err=e}opt.highlight=highlight;return err?callback(err):callback(null,out)};if(!highlight||highlight.length<3){return done()}delete opt.highlight;if(!pending)return done();for(;i<tokens.length;i++){(function(token){if(token.type!=="code"){return--pending||done()}return highlight(token.text,token.lang,function(err,code){if(err)return done(err);if(code==null||code===token.text){return--pending||done()}token.text=code;token.escaped=true;--pending||done()})})(tokens[i])}return}try{if(opt)opt=merge({},marked.defaults,opt);return Parser.parse(Lexer.lex(src,opt),opt)}catch(e){e.message+="\nPlease report this to https://github.com/chjj/marked.";if((opt||marked.defaults).silent){return"<p>An error occured:</p><pre>"+escape(e.message+"",true)+"</pre>"}throw e}}marked.options=marked.setOptions=function(opt){merge(marked.defaults,opt);return marked};marked.defaults={gfm:true,tables:true,breaks:false,pedantic:false,sanitize:false,sanitizer:null,mangle:true,smartLists:false,silent:false,highlight:null,langPrefix:"lang-",smartypants:false,headerPrefix:"",renderer:new Renderer,xhtml:false};marked.Parser=Parser;marked.parser=Parser.parse;marked.Renderer=Renderer;marked.Lexer=Lexer;marked.lexer=Lexer.lex;marked.InlineLexer=InlineLexer;marked.inlineLexer=InlineLexer.output;marked.parse=marked;if(typeof module!=="undefined"&&typeof exports==="object"){module.exports=marked}else if(typeof define==="function"&&define.amd){define(function(){return marked})}else{this.marked=marked}}).call(function(){return this||(typeof window!=="undefined"?window:global)}());

	return module.exports;
}();


// FORMAT OPTIONS FOR MARKED IMPLEMENTATION

function _Markdown_formatOptions(options)
{
	function toHighlight(code, lang)
	{
		if (!lang && $elm$core$Maybe$isJust(options.jZ))
		{
			lang = options.jZ.a;
		}

		if (typeof hljs !== 'undefined' && lang && hljs.listLanguages().indexOf(lang) >= 0)
		{
			return hljs.highlight(lang, code, true).value;
		}

		return code;
	}

	var gfm = options.oZ.a;

	return {
		highlight: toHighlight,
		gfm: gfm,
		tables: gfm && gfm.rK,
		breaks: gfm && gfm.nK,
		sanitize: options.q4,
		smartypants: options.ro
	};
}
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.Q) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.X),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.X);
		} else {
			var treeLen = builder.Q * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder._) : builder._;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.Q);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.X) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.X);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{_: nodeList, Q: (len / $elm$core$Array$branchFactor) | 0, X: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {fS: fragment, fU: host, gt: path, gu: port_, qB: protocol, gz: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $author$project$Dashboards2Main$InitializationError = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $author$project$Config$Flags = function (token) {
	return function (user) {
		return function (env) {
			return function (feature) {
				return function (pathPrefix) {
					return function (can) {
						return function (helpMode) {
							return function (supportChatVisible) {
								return function (revision) {
									return function (referrer) {
										return function (extraApiHeaders) {
											return function (platform2Url) {
												return {nM: can, j8: env, oG: extraApiHeaders, hO: feature, ku: helpMode, ip: pathPrefix, lA: platform2Url, qJ: referrer, q_: revision, rJ: supportChatVisible, i$: token, mQ: user};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $elm_community$json_extra$Json$Decode$Extra$andMap = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $author$project$Data$User$User = function (id) {
	return function (email) {
		return function (firstName) {
			return function (lastName) {
				return function (organisationId) {
					return function (organisationName) {
						return function (country) {
							return function (city) {
								return function (jobTitle) {
									return function (planHandle) {
										return function (customerFeatures) {
											return function (industry) {
												return function (sawOnboarding) {
													return function (lastPlatformUsed) {
														return function (accessStart) {
															return {i9: accessStart, jG: city, jP: country, jT: customerFeatures, j: email, ke: firstName, b: id, kA: industry, kT: jobTitle, pA: lastName, pB: lastPlatformUsed, m: organisationId, bL: organisationName, qw: planHandle, lT: sawOnboarding};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$User$CanDowngrade = 1;
var $author$project$Data$User$CanShareOpenAccessDashboard = 16;
var $author$project$Data$User$CanUseDebugButtons = 6;
var $author$project$Data$User$CanUseP1AfterSunset = 15;
var $author$project$Data$User$CanUseTV = 2;
var $author$project$Data$User$CanUseXBFolders = 7;
var $author$project$Data$User$Curator = 4;
var $author$project$Data$User$DashboardsForPlatform2 = 11;
var $author$project$Data$User$DashboardsGWICreator = 12;
var $author$project$Data$User$DashboardsNonGWICreator = 13;
var $author$project$Data$User$DashboardsOnly_NoAudiencesCharts = 14;
var $author$project$Data$User$EmailExports = 0;
var $author$project$Data$User$ExportBlocked = 5;
var $author$project$Data$User$TVForPlatform2 = 3;
var $author$project$Data$User$XB50kTableLimit = 8;
var $author$project$Data$User$XBForPlatform2 = 10;
var $author$project$Data$User$XBSorting = 9;
var $elm$json$Json$Decode$list = _Json_decodeList;
var $elm$json$Json$Decode$string = _Json_decodeString;
var $elm_community$maybe_extra$Maybe$Extra$cons = F2(
	function (item, list) {
		if (!item.$) {
			var v = item.a;
			return A2($elm$core$List$cons, v, list);
		} else {
			return list;
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$values = A2($elm$core$List$foldr, $elm_community$maybe_extra$Maybe$Extra$cons, _List_Nil);
var $author$project$Data$User$customerFeaturesDecoder = function () {
	var fromString = function (feature) {
		switch (feature) {
			case 'email_exports':
				return $elm$core$Maybe$Just(0);
			case 'can_downgrade':
				return $elm$core$Maybe$Just(1);
			case 'tv_rf_user':
				return $elm$core$Maybe$Just(2);
			case 'TVRF 2.0 visible in pro-next':
				return $elm$core$Maybe$Just(3);
			case 'curator':
				return $elm$core$Maybe$Just(4);
			case 'export_blocked':
				return $elm$core$Maybe$Just(5);
			case 'debug_buttons':
				return $elm$core$Maybe$Just(6);
			case 'xb_folders':
				return $elm$core$Maybe$Just(7);
			case 'XB 50k Table Limit (Product Only)':
				return $elm$core$Maybe$Just(8);
			case 'xb_sorting':
				return $elm$core$Maybe$Just(9);
			case 'xb_20_visible_in_pronext':
				return $elm$core$Maybe$Just(10);
			case 'Dashboards 2.0 visible in pro-next':
				return $elm$core$Maybe$Just(11);
			case 'Dashboards GWI creator (Product Only)':
				return $elm$core$Maybe$Just(12);
			case 'Dashboards non-GWI creator (Product Only)':
				return $elm$core$Maybe$Just(13);
			case 'Dashboard Only (excl. Aud/Charts)':
				return $elm$core$Maybe$Just(14);
			case 'P1 User After Sunset':
				return $elm$core$Maybe$Just(15);
			case 'can_share_open_access_dashboard':
				return $elm$core$Maybe$Just(16);
			default:
				return $elm$core$Maybe$Nothing;
		}
	};
	return A2(
		$elm$json$Json$Decode$map,
		$elm_community$maybe_extra$Maybe$Extra$values,
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$map, fromString, $elm$json$Json$Decode$string)));
}();
var $elm$core$String$concat = function (strings) {
	return A2($elm$core$String$join, '', strings);
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString = function (p) {
	switch (p.$) {
		case 0:
			var s = p.a;
			return 'expecting \'' + (s + '\'');
		case 1:
			return 'expecting int';
		case 2:
			return 'expecting hex';
		case 3:
			return 'expecting octal';
		case 4:
			return 'expecting binary';
		case 5:
			return 'expecting float';
		case 6:
			return 'expecting number';
		case 7:
			return 'expecting variable';
		case 8:
			var s = p.a;
			return 'expecting symbol \'' + (s + '\'');
		case 9:
			var s = p.a;
			return 'expecting keyword \'' + (s + '\'');
		case 10:
			return 'expecting end';
		case 11:
			return 'unexpected char';
		case 12:
			var s = p.a;
			return 'problem ' + s;
		default:
			return 'bad repeat';
	}
};
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString = function (deadend) {
	return $rtfeldman$elm_iso8601_date_strings$DeadEnds$problemToString(deadend.lG) + (' at row ' + ($elm$core$String$fromInt(deadend.lS) + (', col ' + $elm$core$String$fromInt(deadend.jK))));
};
var $elm$core$List$intersperse = F2(
	function (sep, xs) {
		if (!xs.b) {
			return _List_Nil;
		} else {
			var hd = xs.a;
			var tl = xs.b;
			var step = F2(
				function (x, rest) {
					return A2(
						$elm$core$List$cons,
						sep,
						A2($elm$core$List$cons, x, rest));
				});
			var spersed = A3($elm$core$List$foldr, step, _List_Nil, tl);
			return A2($elm$core$List$cons, hd, spersed);
		}
	});
var $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString = function (deadEnds) {
	return $elm$core$String$concat(
		A2(
			$elm$core$List$intersperse,
			'; ',
			A2($elm$core$List$map, $rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndToString, deadEnds)));
};
var $elm$json$Json$Decode$fail = _Json_fail;
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$andThen = $elm$parser$Parser$Advanced$andThen;
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {jK: col, n7: contextStack, lG: problem, lS: row};
	});
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.lS, s.jK, x, s.q));
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.f),
			s.lm) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$end = $elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd);
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.f);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.lm, offset) < 0,
					0,
					{jK: col, q: s0.q, x: s0.x, lm: offset, lS: row, f: s0.f});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.lm, s.lS, s.jK, s);
	};
};
var $elm$parser$Parser$chompWhile = $elm$parser$Parser$Advanced$chompWhile;
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.lm, s1.lm, s0.f),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$getChompedString = $elm$parser$Parser$Advanced$getChompedString;
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $elm$parser$Parser$problem = function (msg) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(msg));
};
var $elm$core$Basics$round = _Basics_round;
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$succeed = $elm$parser$Parser$Advanced$succeed;
var $elm$core$String$toFloat = _String_toFloat;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs = A2(
	$elm$parser$Parser$andThen,
	function (str) {
		if ($elm$core$String$length(str) <= 9) {
			var _v0 = $elm$core$String$toFloat('0.' + str);
			if (!_v0.$) {
				var floatVal = _v0.a;
				return $elm$parser$Parser$succeed(
					$elm$core$Basics$round(floatVal * 1000));
			} else {
				return $elm$parser$Parser$problem('Invalid float: \"' + (str + '\"'));
			}
		} else {
			return $elm$parser$Parser$problem(
				'Expected at most 9 digits, but got ' + $elm$core$String$fromInt(
					$elm$core$String$length(str)));
		}
	},
	$elm$parser$Parser$getChompedString(
		$elm$parser$Parser$chompWhile($elm$core$Char$isDigit)));
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts = F6(
	function (monthYearDayMs, hour, minute, second, ms, utcOffsetMinutes) {
		return $elm$time$Time$millisToPosix((((monthYearDayMs + (((hour * 60) * 60) * 1000)) + (((minute - utcOffsetMinutes) * 60) * 1000)) + (second * 1000)) + ms);
	});
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $elm$parser$Parser$ignorer = $elm$parser$Parser$Advanced$ignorer;
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$keeper = $elm$parser$Parser$Advanced$keeper;
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$oneOf = $elm$parser$Parser$Advanced$oneOf;
var $elm$parser$Parser$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$core$String$append = _String_append;
var $elm$parser$Parser$UnexpectedChar = {$: 11};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.lm, s.f);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jK: 1, q: s.q, x: s.x, lm: s.lm + 1, lS: s.lS + 1, f: s.f}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{jK: s.jK + 1, q: s.q, x: s.x, lm: newOffset, lS: s.lS, f: s.f}));
		};
	});
var $elm$parser$Parser$chompIf = function (isGood) {
	return A2($elm$parser$Parser$Advanced$chompIf, isGood, $elm$parser$Parser$UnexpectedChar);
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $elm$parser$Parser$map = $elm$parser$Parser$Advanced$map;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$toAdvancedStep = function (step) {
	if (!step.$) {
		var s = step.a;
		return $elm$parser$Parser$Advanced$Loop(s);
	} else {
		var a = step.a;
		return $elm$parser$Parser$Advanced$Done(a);
	}
};
var $elm$parser$Parser$loop = F2(
	function (state, callback) {
		return A2(
			$elm$parser$Parser$Advanced$loop,
			state,
			function (s) {
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$toAdvancedStep,
					callback(s));
			});
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt = function (quantity) {
	var helper = function (str) {
		if (_Utils_eq(
			$elm$core$String$length(str),
			quantity)) {
			var _v0 = $elm$core$String$toInt(str);
			if (!_v0.$) {
				var intVal = _v0.a;
				return A2(
					$elm$parser$Parser$map,
					$elm$parser$Parser$Done,
					$elm$parser$Parser$succeed(intVal));
			} else {
				return $elm$parser$Parser$problem('Invalid integer: \"' + (str + '\"'));
			}
		} else {
			return A2(
				$elm$parser$Parser$map,
				function (nextChar) {
					return $elm$parser$Parser$Loop(
						A2($elm$core$String$append, str, nextChar));
				},
				$elm$parser$Parser$getChompedString(
					$elm$parser$Parser$chompIf($elm$core$Char$isDigit)));
		}
	};
	return A2($elm$parser$Parser$loop, '', helper);
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$core$Basics$not = _Basics_not;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.lm, s.lS, s.jK, s.f);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{jK: newCol, q: s.q, x: s.x, lm: newOffset, lS: newRow, f: s.f});
	};
};
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $elm$parser$Parser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear = 1970;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay = function (day) {
	return $elm$parser$Parser$problem(
		'Invalid day: ' + $elm$core$String$fromInt(day));
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $elm$core$Basics$neq = _Utils_notEqual;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 4, year)) && ((!(!A2($elm$core$Basics$modBy, 100, year))) || (!A2($elm$core$Basics$modBy, 400, year)));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay = 86400000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear = 31536000000;
var $rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay = function (_v0) {
	var year = _v0.a;
	var month = _v0.b;
	var dayInMonth = _v0.c;
	if (dayInMonth < 0) {
		return $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth);
	} else {
		var succeedWith = function (extraMs) {
			var yearMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerYear * (year - $rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear);
			var days = ((month < 3) || (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year))) ? (dayInMonth - 1) : dayInMonth;
			var dayMs = $rtfeldman$elm_iso8601_date_strings$Iso8601$msPerDay * (days + ($rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore(year) - $rtfeldman$elm_iso8601_date_strings$Iso8601$leapYearsBefore($rtfeldman$elm_iso8601_date_strings$Iso8601$epochYear)));
			return $elm$parser$Parser$succeed((extraMs + yearMs) + dayMs);
		};
		switch (month) {
			case 1:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(0);
			case 2:
				return ((dayInMonth > 29) || ((dayInMonth === 29) && (!$rtfeldman$elm_iso8601_date_strings$Iso8601$isLeapYear(year)))) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(2678400000);
			case 3:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(5097600000);
			case 4:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(7776000000);
			case 5:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(10368000000);
			case 6:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(13046400000);
			case 7:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(15638400000);
			case 8:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(18316800000);
			case 9:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(20995200000);
			case 10:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(23587200000);
			case 11:
				return (dayInMonth > 30) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(26265600000);
			case 12:
				return (dayInMonth > 31) ? $rtfeldman$elm_iso8601_date_strings$Iso8601$invalidDay(dayInMonth) : succeedWith(28857600000);
			default:
				return $elm$parser$Parser$problem(
					'Invalid month: \"' + ($elm$core$String$fromInt(month) + '\"'));
		}
	}
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs = A2(
	$elm$parser$Parser$andThen,
	$rtfeldman$elm_iso8601_date_strings$Iso8601$yearMonthDay,
	A2(
		$elm$parser$Parser$keeper,
		A2(
			$elm$parser$Parser$keeper,
			A2(
				$elm$parser$Parser$keeper,
				$elm$parser$Parser$succeed(
					F3(
						function (year, month, day) {
							return _Utils_Tuple3(year, month, day);
						})),
				$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(4)),
			$elm$parser$Parser$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$ignorer,
							$elm$parser$Parser$succeed($elm$core$Basics$identity),
							$elm$parser$Parser$symbol('-')),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
					]))),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$ignorer,
						$elm$parser$Parser$succeed($elm$core$Basics$identity),
						$elm$parser$Parser$symbol('-')),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
				]))));
var $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes = function () {
	var utcOffsetMinutesFromParts = F3(
		function (multiplier, hours, minutes) {
			return (multiplier * (hours * 60)) + minutes;
		});
	return A2(
		$elm$parser$Parser$keeper,
		$elm$parser$Parser$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$map,
					function (_v0) {
						return 0;
					},
					$elm$parser$Parser$symbol('Z')),
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							$elm$parser$Parser$succeed(utcOffsetMinutesFromParts),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$map,
										function (_v1) {
											return 1;
										},
										$elm$parser$Parser$symbol('+')),
										A2(
										$elm$parser$Parser$map,
										function (_v2) {
											return -1;
										},
										$elm$parser$Parser$symbol('-'))
									]))),
						$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
					$elm$parser$Parser$oneOf(
						_List_fromArray(
							[
								A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$ignorer,
									$elm$parser$Parser$succeed($elm$core$Basics$identity),
									$elm$parser$Parser$symbol(':')),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
								$elm$parser$Parser$succeed(0)
							]))),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(0),
					$elm$parser$Parser$end)
				])));
}();
var $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601 = A2(
	$elm$parser$Parser$andThen,
	function (datePart) {
		return $elm$parser$Parser$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$keeper,
					A2(
						$elm$parser$Parser$keeper,
						A2(
							$elm$parser$Parser$keeper,
							A2(
								$elm$parser$Parser$keeper,
								A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed(
											$rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts(datePart)),
										$elm$parser$Parser$symbol('T')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
								$elm$parser$Parser$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$keeper,
											A2(
												$elm$parser$Parser$ignorer,
												$elm$parser$Parser$succeed($elm$core$Basics$identity),
												$elm$parser$Parser$symbol(':')),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
											$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)
										]))),
							$elm$parser$Parser$oneOf(
								_List_fromArray(
									[
										A2(
										$elm$parser$Parser$keeper,
										A2(
											$elm$parser$Parser$ignorer,
											$elm$parser$Parser$succeed($elm$core$Basics$identity),
											$elm$parser$Parser$symbol(':')),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2)),
										$rtfeldman$elm_iso8601_date_strings$Iso8601$paddedInt(2),
										$elm$parser$Parser$succeed(0)
									]))),
						$elm$parser$Parser$oneOf(
							_List_fromArray(
								[
									A2(
									$elm$parser$Parser$keeper,
									A2(
										$elm$parser$Parser$ignorer,
										$elm$parser$Parser$succeed($elm$core$Basics$identity),
										$elm$parser$Parser$symbol('.')),
									$rtfeldman$elm_iso8601_date_strings$Iso8601$fractionsOfASecondInMs),
									$elm$parser$Parser$succeed(0)
								]))),
					A2($elm$parser$Parser$ignorer, $rtfeldman$elm_iso8601_date_strings$Iso8601$utcOffsetInMinutes, $elm$parser$Parser$end)),
					A2(
					$elm$parser$Parser$ignorer,
					$elm$parser$Parser$succeed(
						A6($rtfeldman$elm_iso8601_date_strings$Iso8601$fromParts, datePart, 0, 0, 0, 0, 0)),
					$elm$parser$Parser$end)
				]));
	},
	$rtfeldman$elm_iso8601_date_strings$Iso8601$monthYearDayInMs);
var $elm$parser$Parser$DeadEnd = F3(
	function (row, col, problem) {
		return {jK: col, lG: problem, lS: row};
	});
var $elm$parser$Parser$problemToDeadEnd = function (p) {
	return A3($elm$parser$Parser$DeadEnd, p.lS, p.jK, p.lG);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{jK: 1, q: _List_Nil, x: 1, lm: 0, lS: 1, f: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $elm$parser$Parser$run = F2(
	function (parser, source) {
		var _v0 = A2($elm$parser$Parser$Advanced$run, parser, source);
		if (!_v0.$) {
			var a = _v0.a;
			return $elm$core$Result$Ok(a);
		} else {
			var problems = _v0.a;
			return $elm$core$Result$Err(
				A2($elm$core$List$map, $elm$parser$Parser$problemToDeadEnd, problems));
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime = function (str) {
	return A2($elm$parser$Parser$run, $rtfeldman$elm_iso8601_date_strings$Iso8601$iso8601, str);
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		var _v0 = $rtfeldman$elm_iso8601_date_strings$Iso8601$toTime(str);
		if (_v0.$ === 1) {
			var deadEnds = _v0.a;
			return $elm$json$Json$Decode$fail(
				$rtfeldman$elm_iso8601_date_strings$DeadEnds$deadEndsToString(deadEnds));
		} else {
			var time = _v0.a;
			return $elm$json$Json$Decode$succeed(time);
		}
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Gwi$Json$Decode$intToString = A2($elm$json$Json$Decode$map, $elm$core$String$fromInt, $elm$json$Json$Decode$int);
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $author$project$Data$User$Api = 4;
var $author$project$Data$User$Dashboards = 2;
var $author$project$Data$User$Free = 0;
var $author$project$Data$User$FreeReports = 1;
var $author$project$Data$User$OpenAccessViewOnly = 7;
var $author$project$Data$User$Professional = 3;
var $author$project$Data$User$Student = 5;
var $author$project$Data$User$ViewOnly = 6;
var $author$project$Data$User$planDecoder = function () {
	var fromString = function (plan) {
		switch (plan) {
			case 'free':
				return $elm$json$Json$Decode$succeed(0);
			case 'free_reports':
				return $elm$json$Json$Decode$succeed(1);
			case 'dashboards':
				return $elm$json$Json$Decode$succeed(2);
			case 'professional':
				return $elm$json$Json$Decode$succeed(3);
			case 'api':
				return $elm$json$Json$Decode$succeed(4);
			case 'student':
				return $elm$json$Json$Decode$succeed(5);
			case 'view_only':
				return $elm$json$Json$Decode$succeed(6);
			case 'open_access_view_only':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Invalid plan ' + plan);
		}
	};
	return A2($elm$json$Json$Decode$andThen, fromString, $elm$json$Json$Decode$string);
}();
var $author$project$Data$User$Platform1 = 0;
var $author$project$Data$User$Platform2 = 1;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Data$User$platformVersionDecoder = function () {
	var decode = function (str) {
		switch (str) {
			case 'platform1':
				return $elm$json$Json$Decode$succeed(0);
			case 'platform2':
				return $elm$json$Json$Decode$succeed(1);
			default:
				var unknownType = str;
				return $elm$json$Json$Decode$fail('Invalid platform type' + unknownType);
		}
	};
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(0),
		$elm$json$Json$Decode$nullable(
			A2($elm$json$Json$Decode$andThen, decode, $elm$json$Json$Decode$string)));
}();
var $author$project$Data$User$featureToString = function (feature) {
	switch (feature) {
		case 0:
			return 'email_exports';
		case 1:
			return 'can_downgrade';
		case 2:
			return 'tv_rf_user';
		case 3:
			return 'TVRF 2.0 visible in pro-next';
		case 4:
			return 'curator';
		case 5:
			return 'export_blocked';
		case 6:
			return 'debug_buttons';
		case 7:
			return 'xb_folders';
		case 8:
			return 'XB 50k Table Limit (Product Only)';
		case 9:
			return 'xb_sorting';
		case 10:
			return 'xb_20_visible_in_pronext';
		case 11:
			return 'Dashboards 2.0 visible in pro-next';
		case 12:
			return 'Dashboards GWI creator (Product Only)';
		case 13:
			return 'Dashboards non-GWI creator (Product Only)';
		case 14:
			return 'Dashboard Only (excl. Aud/Charts)';
		case 15:
			return 'P1 User After Sunset';
		default:
			return 'can_share_open_access_dashboard';
	}
};
var $turboMaCk$any_set$Set$Any$AnySet = $elm$core$Basics$identity;
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $turboMaCk$any_dict$Dict$Any$AnyDict = $elm$core$Basics$identity;
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $turboMaCk$any_dict$Dict$Any$fromList = F2(
	function (f, xs) {
		return {
			i: $elm$core$Dict$fromList(
				A2(
					$elm$core$List$map,
					function (_v0) {
						var k = _v0.a;
						var v = _v0.b;
						return _Utils_Tuple2(
							f(k),
							_Utils_Tuple2(k, v));
					},
					xs)),
			aT: f
		};
	});
var $turboMaCk$any_set$Set$Any$fromList = function (toComparable) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$elm$core$Basics$identity,
			$turboMaCk$any_dict$Dict$Any$fromList(toComparable)),
		$elm$core$List$map(
			function (a) {
				return _Utils_Tuple2(a, 0);
			}));
};
var $author$project$Data$User$toFeatureSet = $turboMaCk$any_set$Set$Any$fromList($author$project$Data$User$featureToString);
var $author$project$Data$User$decoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'access_start', $rtfeldman$elm_iso8601_date_strings$Iso8601$decoder),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'last_platform_used', $author$project$Data$User$platformVersionDecoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'saw_onboarding', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'industry',
					$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Data$User$toFeatureSet,
						A2($elm$json$Json$Decode$field, 'customer_features', $author$project$Data$User$customerFeaturesDecoder)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'plan_handle', $author$project$Data$User$planDecoder),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'job_title',
								$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm$json$Json$Decode$field,
									'city_name',
									$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2(
										$elm$json$Json$Decode$field,
										'country_name',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2(
											$elm$json$Json$Decode$field,
											'organisation_name',
											$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2(
												$elm$json$Json$Decode$field,
												'organisation_id',
												$elm$json$Json$Decode$maybe($author$project$Gwi$Json$Decode$intToString)),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'last_name', $elm$json$Json$Decode$string),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'first_name', $elm$json$Json$Decode$string),
													A2(
														$elm_community$json_extra$Json$Decode$Extra$andMap,
														A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
														A2(
															$elm_community$json_extra$Json$Decode$Extra$andMap,
															A2($elm$json$Json$Decode$field, 'id', $author$project$Gwi$Json$Decode$intToString),
															$elm$json$Json$Decode$succeed($author$project$Data$User$User))))))))))))))));
var $author$project$Config$Main$Development = 0;
var $author$project$Config$Main$Production = 4;
var $author$project$Config$Main$Staging = 3;
var $author$project$Config$Main$TestSuite = 1;
var $author$project$Config$Main$Testing = 2;
var $author$project$Config$Main$envDecoder = function () {
	var decode = function (value) {
		switch (value) {
			case 'development':
				return $elm$json$Json$Decode$succeed(0);
			case 'testsuite':
				return $elm$json$Json$Decode$succeed(1);
			case 'testing':
				return $elm$json$Json$Decode$succeed(2);
			case 'staging':
				return $elm$json$Json$Decode$succeed(3);
			case 'production':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid ENV type' + value);
		}
	};
	return A2($elm$json$Json$Decode$andThen, decode, $elm$json$Json$Decode$string);
}();
var $author$project$Permissions$AccessAudienceBuilder = 5;
var $author$project$Permissions$AccessChartBuilder = 2;
var $author$project$Permissions$AccessDashboards = 3;
var $author$project$Permissions$AccessReports = 4;
var $author$project$Permissions$BeDashboardsGWICreator = 23;
var $author$project$Permissions$BeDashboardsNonGWICreator = 24;
var $author$project$Permissions$CreateAudiences = 0;
var $author$project$Permissions$CreateCuratedAudiences = 6;
var $author$project$Permissions$CreateDashboards = 7;
var $author$project$Permissions$DowngradePlan = 10;
var $author$project$Permissions$DownloadInfographics = 13;
var $author$project$Permissions$DownloadReports = 14;
var $author$project$Permissions$EditAudiencesAndChartsInDashboards2 = 25;
var $author$project$Permissions$Export = 15;
var $author$project$Permissions$ReceiveEmailExports = 8;
var $author$project$Permissions$SearchProducts = 16;
var $author$project$Permissions$SearchQuestionsAndDatapoints = 17;
var $author$project$Permissions$SeeExtendedAudiences = 1;
var $author$project$Permissions$SeeSupportChat = 22;
var $author$project$Permissions$ShareOpenAccessDashboard = 27;
var $author$project$Permissions$UseDashboards2 = 21;
var $author$project$Permissions$UseDebugButtons = 18;
var $author$project$Permissions$UseP1AfterSunset = 26;
var $author$project$Permissions$UseTV1 = 11;
var $author$project$Permissions$UseTV2 = 12;
var $author$project$Permissions$UseXB1 = 9;
var $author$project$Permissions$UseXB2 = 20;
var $author$project$Permissions$UseXB50kTableLimit = 19;
var $author$project$Gwi$List$addIf = function (cond) {
	return cond ? $elm$core$List$cons : $elm$core$Basics$always($elm$core$Basics$identity);
};
var $elm_community$basics_extra$Basics$Extra$flip = F3(
	function (f, b, a) {
		return A2(f, a, b);
	});
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $turboMaCk$any_dict$Dict$Any$member = F2(
	function (k, _v0) {
		var dict = _v0.i;
		var toKey = _v0.aT;
		return A2(
			$elm$core$Dict$member,
			toKey(k),
			dict);
	});
var $turboMaCk$any_set$Set$Any$member = F2(
	function (a, _v0) {
		var dict = _v0;
		return A2($turboMaCk$any_dict$Dict$Any$member, a, dict);
	});
var $author$project$Permissions$toString = function (permission) {
	switch (permission) {
		case 0:
			return 'CreateAudiences';
		case 1:
			return 'SeeExtendedAudiences';
		case 2:
			return 'AccessChartBuilder';
		case 3:
			return 'AccessDashboards';
		case 4:
			return 'AccessReports';
		case 5:
			return 'AccessAudienceBuilder';
		case 6:
			return 'CreateCuratedAudiences';
		case 7:
			return 'CreateDashboards';
		case 8:
			return 'ReceiveEmailExports';
		case 9:
			return 'UseQueryBuilder';
		case 10:
			return 'DowngradePlan';
		case 11:
			return 'UseTV1';
		case 12:
			return 'UseTV2';
		case 13:
			return 'DownloadInfographics';
		case 14:
			return 'DownloadReports';
		case 15:
			return 'Export';
		case 16:
			return 'SearchProducts';
		case 17:
			return 'SearchQuestionsAndDatapoints';
		case 18:
			return 'UseDebugButtons';
		case 19:
			return 'UseXB50kTableLimit';
		case 20:
			return 'UseXB2';
		case 21:
			return 'UseDashboards2';
		case 22:
			return 'SeeSupportChat';
		case 23:
			return 'BeDashboardsGWICreator';
		case 24:
			return 'BeDashboardsNonGWICreator';
		case 25:
			return 'EditAudiencesAndChartsInDashboards2';
		case 26:
			return 'UseP1AfterSunset';
		default:
			return 'ShareOpenAccessDashboard';
	}
};
var $author$project$Permissions$fromUser = function (_v0) {
	var planHandle = _v0.qw;
	var customerFeatures = _v0.jT;
	var planBased = function () {
		switch (planHandle) {
			case 0:
				return _List_fromArray(
					[5, 2, 4, 3, 0, 16, 17, 22]);
			case 1:
				return _List_fromArray(
					[5, 2, 4, 3, 0, 16, 17, 22]);
			case 2:
				return _List_fromArray(
					[5, 3, 4, 1, 16, 17, 22]);
			case 3:
				return _List_fromArray(
					[5, 0, 1, 2, 3, 4, 9, 16, 17, 22]);
			case 4:
				return _List_fromArray(
					[0, 16, 17, 22]);
			case 5:
				return _List_fromArray(
					[4, 16]);
			case 6:
				return _List_fromArray(
					[5, 2, 4, 3, 22]);
			default:
				return _List_fromArray(
					[3]);
		}
	}();
	var canExport = !A2($turboMaCk$any_set$Set$Any$member, 5, customerFeatures);
	return A2(
		$elm_community$basics_extra$Basics$Extra$flip,
		$turboMaCk$any_set$Set$Any$member,
		A2(
			$turboMaCk$any_set$Set$Any$fromList,
			$author$project$Permissions$toString,
			A3(
				$author$project$Gwi$List$addIf,
				!((planHandle === 2) && A2($turboMaCk$any_set$Set$Any$member, 14, customerFeatures)),
				25,
				A3(
					$author$project$Gwi$List$addIf,
					A2($turboMaCk$any_set$Set$Any$member, 15, customerFeatures),
					26,
					A3(
						$author$project$Gwi$List$addIf,
						A2($turboMaCk$any_set$Set$Any$member, 13, customerFeatures),
						24,
						A3(
							$author$project$Gwi$List$addIf,
							A2($turboMaCk$any_set$Set$Any$member, 12, customerFeatures),
							23,
							A3(
								$author$project$Gwi$List$addIf,
								A2($turboMaCk$any_set$Set$Any$member, 11, customerFeatures),
								21,
								A3(
									$author$project$Gwi$List$addIf,
									(planHandle === 3) && A2($turboMaCk$any_set$Set$Any$member, 10, customerFeatures),
									20,
									A3(
										$author$project$Gwi$List$addIf,
										A2($turboMaCk$any_set$Set$Any$member, 8, customerFeatures),
										19,
										A3(
											$author$project$Gwi$List$addIf,
											A2($turboMaCk$any_set$Set$Any$member, 6, customerFeatures),
											18,
											A3(
												$author$project$Gwi$List$addIf,
												canExport,
												15,
												A3(
													$author$project$Gwi$List$addIf,
													(!(!planHandle)) && ((planHandle !== 4) && canExport),
													14,
													A3(
														$author$project$Gwi$List$addIf,
														(!(!planHandle)) && ((planHandle !== 4) && canExport),
														13,
														A3(
															$author$project$Gwi$List$addIf,
															A2($turboMaCk$any_set$Set$Any$member, 1, customerFeatures),
															10,
															A3(
																$author$project$Gwi$List$addIf,
																A2($turboMaCk$any_set$Set$Any$member, 3, customerFeatures),
																12,
																A3(
																	$author$project$Gwi$List$addIf,
																	A2($turboMaCk$any_set$Set$Any$member, 2, customerFeatures),
																	11,
																	A3(
																		$author$project$Gwi$List$addIf,
																		A2($turboMaCk$any_set$Set$Any$member, 0, customerFeatures),
																		8,
																		A3(
																			$author$project$Gwi$List$addIf,
																			A2($turboMaCk$any_set$Set$Any$member, 4, customerFeatures),
																			6,
																			A3(
																				$author$project$Gwi$List$addIf,
																				A2($turboMaCk$any_set$Set$Any$member, 4, customerFeatures),
																				7,
																				A3(
																					$author$project$Gwi$List$addIf,
																					A2($turboMaCk$any_set$Set$Any$member, 16, customerFeatures),
																					27,
																					planBased))))))))))))))))))));
};
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $elm_community$json_extra$Json$Decode$Extra$optionalField = F2(
	function (fieldName, decoder) {
		var finishDecoding = function (json) {
			var _v0 = A2(
				$elm$json$Json$Decode$decodeValue,
				A2($elm$json$Json$Decode$field, fieldName, $elm$json$Json$Decode$value),
				json);
			if (!_v0.$) {
				var val = _v0.a;
				return A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$Just,
					A2($elm$json$Json$Decode$field, fieldName, decoder));
			} else {
				return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
			}
		};
		return A2($elm$json$Json$Decode$andThen, finishDecoding, $elm$json$Json$Decode$value);
	});
var $elm_community$json_extra$Json$Decode$Extra$optionalNullableField = F2(
	function (fieldName, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$andThen($elm$core$Basics$identity),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalField,
				fieldName,
				$elm$json$Json$Decode$nullable(decoder)));
	});
var $author$project$Config$OtherReferrer = 1;
var $author$project$Config$Platform2Referrer = 0;
var $author$project$Config$referrerDecoder = function (p2Url) {
	return A2(
		$elm$json$Json$Decode$map,
		function (url) {
			return A2($elm$core$String$startsWith, p2Url, url) ? 0 : 1;
		},
		$elm$json$Json$Decode$string);
};
var $author$project$Config$decoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'platform2Url', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$andThen,
				function (p2Url) {
					return A2(
						$elm$json$Json$Decode$field,
						'referrer',
						$author$project$Config$referrerDecoder(p2Url));
				},
				A2($elm$json$Json$Decode$field, 'platform2Url', $elm$json$Json$Decode$string)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'revision', $elm$json$Json$Decode$string),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					$elm$json$Json$Decode$succeed(false),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'helpMode', $elm$json$Json$Decode$bool),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Permissions$fromUser,
								A2($elm$json$Json$Decode$field, 'user', $author$project$Data$User$decoder)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'pathPrefix', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2(
										$elm$json$Json$Decode$field,
										'feature',
										$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'env', $author$project$Config$Main$envDecoder),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'user', $author$project$Data$User$decoder),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'token', $elm$json$Json$Decode$string),
												$elm$json$Json$Decode$succeed($author$project$Config$Flags)))))))))))));
var $author$project$Config$decode = function (value) {
	return A2($elm$json$Json$Decode$decodeValue, $author$project$Config$decoder, value);
};
var $author$project$Dashboards2$Router$DashboardsList = {$: 0};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2Main$UpdateZone = function (a) {
	return {$: 25, a: a};
};
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Dashboards2Main$AjaxError = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Dashboards2Main$CreateDashboardCopy = function (a) {
	return {$: 17, a: a};
};
var $author$project$Dashboards2Main$CreateNewAudienceInP2 = {$: 33};
var $author$project$Dashboards2Main$CreateNewChartInP2CB = {$: 7};
var $author$project$Dashboards2Main$DashboardsMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboards2Main$DestroyDashboard = function (a) {
	return {$: 26, a: a};
};
var $author$project$Dashboards2Main$DestroyWidget = F2(
	function (a, b) {
		return {$: 27, a: a, b: b};
	});
var $author$project$Dashboards2Main$EditAudienceInP2 = function (a) {
	return {$: 34, a: a};
};
var $author$project$Dashboards2Main$ForceNavigateTo = function (a) {
	return {$: 22, a: a};
};
var $author$project$Dashboards2Main$NavigateTo = function (a) {
	return {$: 23, a: a};
};
var $author$project$Dashboards2Main$NavigateToCB = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Dashboards2Main$NavigateToGetInTouch = F3(
	function (a, b, c) {
		return {$: 30, a: a, b: b, c: c};
	});
var $author$project$Dashboards2Main$NavigateToInsight = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Dashboards2Main$NoOp = {$: 0};
var $author$project$Dashboards2Main$OpenChartInChartBuilder = function (a) {
	return {$: 6, a: a};
};
var $author$project$Dashboards2Main$OpenSupportChat = function (a) {
	return {$: 37, a: a};
};
var $author$project$Dashboards2Main$Platform2StoreMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Dashboards2Main$RenameDashboard = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Dashboards2Main$SaveDashboard = function (a) {
	return {$: 15, a: a};
};
var $author$project$Dashboards2Main$SaveDashboardAsCreator = F3(
	function (a, b, c) {
		return {$: 18, a: a, b: b, c: c};
	});
var $author$project$Dashboards2Main$SaveDashboardWidgets = function (a) {
	return {$: 19, a: a};
};
var $author$project$Dashboards2Main$ShareDashboard = F2(
	function (a, b) {
		return {$: 16, a: a, b: b};
	});
var $author$project$Dashboards2Main$StoreActionMany = function (a) {
	return {$: 11, a: a};
};
var $author$project$Dashboards2Main$ToggleFavourite = function (a) {
	return {$: 14, a: a};
};
var $author$project$Dashboards2Main$UpdatePlatform2StoreWith = function (a) {
	return {$: 13, a: a};
};
var $author$project$Dashboards2$AddDescriptionClicked = {$: 79};
var $author$project$Dashboards2$AddNewRichTextWidget = F2(
	function (a, b) {
		return {$: 103, a: a, b: b};
	});
var $author$project$Dashboards2$AudiencesReordered = F2(
	function (a, b) {
		return {$: 91, a: a, b: b};
	});
var $author$project$Dashboards2$CancelDashboardExport = {$: 120};
var $author$project$Dashboards2$ChangeActiveDropdown = function (a) {
	return {$: 65, a: a};
};
var $author$project$Dashboards2$ChartBrowserMsg = function (a) {
	return {$: 85, a: a};
};
var $author$project$Dashboards2$CheckStickyHeaderVisibility = {$: 115};
var $author$project$Dashboards2$CopyDashboardLink = function (a) {
	return {$: 133, a: a};
};
var $author$project$Dashboards2$CreateWidgetsFromChartBrowser = function (a) {
	return {$: 104, a: a};
};
var $author$project$Dashboards2$DuplicateDashboard = {$: 8};
var $author$project$Dashboards2$EditAudience = function (a) {
	return {$: 73, a: a};
};
var $author$project$Dashboards2$EditSectionMsg = function (a) {
	return {$: 93, a: a};
};
var $author$project$Dashboards2$EditWidgetDimension = F2(
	function (a, b) {
		return {$: 94, a: a, b: b};
	});
var $author$project$Dashboards2$ExportRequested = {$: 10};
var $author$project$Dashboards2$LinkInsightClicked = {$: 78};
var $author$project$Dashboards2$NavigateToInsight = F2(
	function (a, b) {
		return {$: 129, a: a, b: b};
	});
var $author$project$Dashboards2$NoOp = {$: 0};
var $author$project$Dashboards2$OpenAudienceBrowserModal = function (a) {
	return {$: 24, a: a};
};
var $author$project$Dashboards2$OpenBaseAudienceBrowserModal = {$: 26};
var $author$project$Dashboards2$OpenChartBrowser = F2(
	function (a, b) {
		return {$: 84, a: a, b: b};
	});
var $author$project$Dashboards2$OpenDatasetsDrawer = {$: 77};
var $author$project$Dashboards2$OpenEditModeButtonClicked = {$: 74};
var $author$project$Dashboards2$OpenLocationsDrawer = {$: 14};
var $author$project$Dashboards2$OpenRenameDashboardModal = function (a) {
	return {$: 18, a: a};
};
var $author$project$Dashboards2$OpenReplaceAudienceBrowserModal = F2(
	function (a, b) {
		return {$: 25, a: a, b: b};
	});
var $author$project$Dashboards2$OpenWavesDrawer = {$: 15};
var $author$project$Dashboards2$PlaceholderDimensionsChanged = $elm$core$Basics$identity;
var $author$project$Dashboards2$PreviewAudience = function (a) {
	return {$: 72, a: a};
};
var $author$project$Dashboards2$Redo = {$: 114};
var $author$project$Dashboards2$RemoveAudience = function (a) {
	return {$: 71, a: a};
};
var $author$project$Dashboards2$ReorderAudiencesMsg = function (a) {
	return {$: 92, a: a};
};
var $author$project$Dashboards2$ResetBaseAudience = {$: 67};
var $author$project$Dashboards2$ResetChanges = {$: 56};
var $author$project$Dashboards2$SaveDashboard = {$: 7};
var $author$project$Dashboards2$ScrollBasesPanelLeft = {$: 126};
var $author$project$Dashboards2$ScrollBasesPanelRight = {$: 125};
var $author$project$Dashboards2$SetEditMode = function (a) {
	return {$: 75, a: a};
};
var $author$project$Dashboards2$ShareBtnClicked = {$: 89};
var $author$project$Dashboards2$TabsPanelResized = {$: 128};
var $author$project$Dashboards2$ToggleAddCategory = {$: 122};
var $author$project$Dashboards2$ToggleAudienceVisibility = function (a) {
	return {$: 57, a: a};
};
var $author$project$Dashboards2$ToggleDashboardCategory = F2(
	function (a, b) {
		return {$: 124, a: a, b: b};
	});
var $author$project$Dashboards2$Undo = {$: 113};
var $author$project$Dashboards2$WidgetDragAndDropMsg = function (a) {
	return {$: 90, a: a};
};
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $author$project$DragAndDrop$Move$Config = $elm$core$Basics$identity;
var $author$project$DragAndDrop$Move$defaultOptions = {
	ek: '',
	fE: $elm$core$Maybe$Nothing,
	al: _List_Nil,
	lm: {jy: 0, kY: 0, lQ: 0, mH: 0}
};
var $author$project$DragAndDrop$Move$config = $author$project$DragAndDrop$Move$defaultOptions;
var $author$project$Dashboards2$ChartBrowser$AttributesTaxonomyMsg = function (a) {
	return {$: 12, a: a};
};
var $author$project$Dashboards2$ChartBrowser$TaxonomyAjaxError = function (a) {
	return {$: 13, a: a};
};
var $author$project$Store$AttributesTaxonomy$configure = function (c) {
	return {ox: c.ox, a: c.a};
};
var $author$project$Dashboards2$ChartBrowser$configure = function (cnf) {
	return {
		ob: cnf.ob,
		o_: cnf.o_,
		a: cnf.a,
		eH: cnf.eH,
		l: cnf.l,
		gU: $author$project$Store$AttributesTaxonomy$configure(
			{
				ox: A2($elm$core$Basics$composeL, cnf.a, $author$project$Dashboards2$ChartBrowser$TaxonomyAjaxError),
				a: A2($elm$core$Basics$composeL, cnf.a, $author$project$Dashboards2$ChartBrowser$AttributesTaxonomyMsg)
			})
	};
};
var $author$project$DragAndDrop$Move$GhostModel = $elm$core$Basics$identity;
var $author$project$DragAndDrop$Move$ListModel = $elm$core$Basics$identity;
var $author$project$DragAndDrop$Move$Model = F3(
	function (list, ghost, debouncedMsg) {
		return {cm: debouncedMsg, al: ghost, k_: list};
	});
var $author$project$DragAndDrop$Move$CancelDebounce = {$: 2};
var $author$project$DragAndDrop$Move$DownDragItem = F5(
	function (a, b, c, d, e) {
		return {$: 0, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$DragAndDrop$Move$checkMainMouseButtonPressed = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (button) {
			if (!button) {
				return decoder;
			} else {
				return $elm$json$Json$Decode$fail('Event is only relevant when the main mouse button was pressed.');
			}
		},
		A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
};
var $author$project$DragAndDrop$Move$Position = F2(
	function (x, y) {
		return {m3: x, m4: y};
	});
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$DragAndDrop$Move$pagePosition = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DragAndDrop$Move$Position,
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $author$project$DragAndDrop$Move$checkedPagePosition = $author$project$DragAndDrop$Move$checkMainMouseButtonPressed($author$project$DragAndDrop$Move$pagePosition);
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $elm$html$Html$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $elm$virtual_dom$VirtualDom$MayPreventDefault = function (a) {
	return {$: 2, a: a};
};
var $elm$html$Html$Events$preventDefaultOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayPreventDefault(decoder));
	});
var $author$project$DragAndDrop$Move$dragEvents = F5(
	function (toMsg, dragListId, dragItem, dragIndex, dragElementId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$custom,
				'mousedown',
				A2(
					$elm$json$Json$Decode$map,
					function (msg) {
						return {pP: msg, lF: true, ml: true};
					},
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							A4($author$project$DragAndDrop$Move$DownDragItem, dragListId, dragItem, dragIndex, dragElementId),
							toMsg),
						$author$project$DragAndDrop$Move$checkedPagePosition))),
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'mouseup',
				$elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						toMsg($author$project$DragAndDrop$Move$CancelDebounce),
						true)))
			]);
	});
var $author$project$DragAndDrop$Move$LeaveDropItem = function (a) {
	return {$: 2, a: a};
};
var $author$project$DragAndDrop$Move$OverDropItem = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$DragAndDrop$Move$StateMsg = function (a) {
	return {$: 4, a: a};
};
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Events$on = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $elm$html$Html$Events$onMouseLeave = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseleave',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$DragAndDrop$Move$dropEvents = F4(
	function (toMsg, dropListId, dropIndex, dropElementId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$custom,
				'mouseover',
				$elm$json$Json$Decode$succeed(
					{
						pP: toMsg(
							$author$project$DragAndDrop$Move$StateMsg(
								A3($author$project$DragAndDrop$Move$OverDropItem, dropListId, dropIndex, dropElementId))),
						lF: true,
						ml: true
					})),
				$elm$html$Html$Events$onMouseLeave(
				toMsg(
					$author$project$DragAndDrop$Move$StateMsg(
						$author$project$DragAndDrop$Move$LeaveDropItem(dropListId))))
			]);
	});
var $author$project$DragAndDrop$Move$getGhostState = function (_v0) {
	var maybeState = _v0;
	return maybeState;
};
var $author$project$DragAndDrop$Move$optionalDeclarations = F2(
	function (element, declarations) {
		return A2(
			$elm$core$List$map,
			function (declaration) {
				return declaration(element);
			},
			declarations);
	});
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $elm$html$Html$Attributes$style = $elm$virtual_dom$VirtualDom$style;
var $author$project$DragAndDrop$Move$px = function (n) {
	return $elm$core$String$fromInt(n) + 'px';
};
var $author$project$DragAndDrop$Move$translate = F2(
	function (x, y) {
		return 'translate3d(' + ($author$project$DragAndDrop$Move$px(x) + (', ' + ($author$project$DragAndDrop$Move$px(y) + ', 0)')));
	});
var $author$project$DragAndDrop$Move$transformDeclaration = F2(
	function (_v0, _v1) {
		var element = _v0.j4;
		var x = _v1.m3;
		var y = _v1.m4;
		return A2(
			$elm$html$Html$Attributes$style,
			'transform',
			A2(
				$author$project$DragAndDrop$Move$translate,
				$elm$core$Basics$round(x + element.m3),
				$elm$core$Basics$round(y + element.m4)));
	});
var $author$project$DragAndDrop$Move$ghostStyles = F2(
	function (_v0, _v1) {
		var options = _v0;
		var list = _v1.k_;
		var ghost = _v1.al;
		var _v2 = _Utils_Tuple2(list, ghost);
		if ((!_v2.a.$) && (!_v2.b.$)) {
			var listState = _v2.a.a;
			var ghostState = _v2.b.a;
			var _v3 = listState.dm;
			if (!_v3.$) {
				var dragElement = _v3.a;
				return A2(
					$elm$core$List$cons,
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
					A2(
						$elm$core$List$cons,
						A2($author$project$DragAndDrop$Move$transformDeclaration, dragElement, ghostState.gY),
						A2($author$project$DragAndDrop$Move$optionalDeclarations, dragElement, options.al)));
			} else {
				return _List_Nil;
			}
		} else {
			return _List_Nil;
		}
	});
var $author$project$DragAndDrop$Move$info = function (_v0) {
	var listModel = _v0;
	if (!listModel.$) {
		var listState = listModel.a;
		return ((!_Utils_eq(listState.dm, $elm$core$Maybe$Nothing)) && (!_Utils_eq(listState.eu, $elm$core$Maybe$Nothing))) ? $elm$core$Maybe$Just(
			{j2: listState.j2, op: listState.op, oq: listState.oq, a_: listState.a_, j3: listState.j3}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$DragAndDrop$Move$MoveBrowser = function (a) {
	return {$: 0, a: a};
};
var $author$project$DragAndDrop$Move$Tick = function (a) {
	return {$: 6, a: a};
};
var $author$project$DragAndDrop$Move$TimeToStartTick = function (a) {
	return {$: 3, a: a};
};
var $author$project$DragAndDrop$Move$UpBrowser = {$: 5};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$core$Platform$Sub$none = $elm$core$Platform$Sub$batch(_List_Nil);
var $elm$browser$Browser$AnimationManager$Time = function (a) {
	return {$: 0, a: a};
};
var $elm$browser$Browser$AnimationManager$State = F3(
	function (subs, request, oldTime) {
		return {ij: oldTime, gG: request, mp: subs};
	});
var $elm$browser$Browser$AnimationManager$init = $elm$core$Task$succeed(
	A3($elm$browser$Browser$AnimationManager$State, _List_Nil, $elm$core$Maybe$Nothing, 0));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$browser$Browser$AnimationManager$now = _Browser_now(0);
var $elm$browser$Browser$AnimationManager$rAF = _Browser_rAF(0);
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$browser$Browser$AnimationManager$onEffects = F3(
	function (router, subs, _v0) {
		var request = _v0.gG;
		var oldTime = _v0.ij;
		var _v1 = _Utils_Tuple2(request, subs);
		if (_v1.a.$ === 1) {
			if (!_v1.b.b) {
				var _v2 = _v1.a;
				return $elm$browser$Browser$AnimationManager$init;
			} else {
				var _v4 = _v1.a;
				return A2(
					$elm$core$Task$andThen,
					function (pid) {
						return A2(
							$elm$core$Task$andThen,
							function (time) {
								return $elm$core$Task$succeed(
									A3(
										$elm$browser$Browser$AnimationManager$State,
										subs,
										$elm$core$Maybe$Just(pid),
										time));
							},
							$elm$browser$Browser$AnimationManager$now);
					},
					$elm$core$Process$spawn(
						A2(
							$elm$core$Task$andThen,
							$elm$core$Platform$sendToSelf(router),
							$elm$browser$Browser$AnimationManager$rAF)));
			}
		} else {
			if (!_v1.b.b) {
				var pid = _v1.a.a;
				return A2(
					$elm$core$Task$andThen,
					function (_v3) {
						return $elm$browser$Browser$AnimationManager$init;
					},
					$elm$core$Process$kill(pid));
			} else {
				return $elm$core$Task$succeed(
					A3($elm$browser$Browser$AnimationManager$State, subs, request, oldTime));
			}
		}
	});
var $elm$browser$Browser$AnimationManager$onSelfMsg = F3(
	function (router, newTime, _v0) {
		var subs = _v0.mp;
		var oldTime = _v0.ij;
		var send = function (sub) {
			if (!sub.$) {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(
						$elm$time$Time$millisToPosix(newTime)));
			} else {
				var tagger = sub.a;
				return A2(
					$elm$core$Platform$sendToApp,
					router,
					tagger(newTime - oldTime));
			}
		};
		return A2(
			$elm$core$Task$andThen,
			function (pid) {
				return A2(
					$elm$core$Task$andThen,
					function (_v1) {
						return $elm$core$Task$succeed(
							A3(
								$elm$browser$Browser$AnimationManager$State,
								subs,
								$elm$core$Maybe$Just(pid),
								newTime));
					},
					$elm$core$Task$sequence(
						A2($elm$core$List$map, send, subs)));
			},
			$elm$core$Process$spawn(
				A2(
					$elm$core$Task$andThen,
					$elm$core$Platform$sendToSelf(router),
					$elm$browser$Browser$AnimationManager$rAF)));
	});
var $elm$browser$Browser$AnimationManager$Delta = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$AnimationManager$subMap = F2(
	function (func, sub) {
		if (!sub.$) {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Time(
				A2($elm$core$Basics$composeL, func, tagger));
		} else {
			var tagger = sub.a;
			return $elm$browser$Browser$AnimationManager$Delta(
				A2($elm$core$Basics$composeL, func, tagger));
		}
	});
_Platform_effectManagers['Browser.AnimationManager'] = _Platform_createManager($elm$browser$Browser$AnimationManager$init, $elm$browser$Browser$AnimationManager$onEffects, $elm$browser$Browser$AnimationManager$onSelfMsg, 0, $elm$browser$Browser$AnimationManager$subMap);
var $elm$browser$Browser$AnimationManager$subscription = _Platform_leaf('Browser.AnimationManager');
var $elm$browser$Browser$AnimationManager$onAnimationFrame = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Time(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrame = $elm$browser$Browser$AnimationManager$onAnimationFrame;
var $elm$browser$Browser$AnimationManager$onAnimationFrameDelta = function (tagger) {
	return $elm$browser$Browser$AnimationManager$subscription(
		$elm$browser$Browser$AnimationManager$Delta(tagger));
};
var $elm$browser$Browser$Events$onAnimationFrameDelta = $elm$browser$Browser$AnimationManager$onAnimationFrameDelta;
var $elm$browser$Browser$Events$Document = 0;
var $elm$browser$Browser$Events$MySub = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$browser$Browser$Events$State = F2(
	function (subs, pids) {
		return {lz: pids, mp: subs};
	});
var $elm$browser$Browser$Events$init = $elm$core$Task$succeed(
	A2($elm$browser$Browser$Events$State, _List_Nil, $elm$core$Dict$empty));
var $elm$browser$Browser$Events$nodeToKey = function (node) {
	if (!node) {
		return 'd_';
	} else {
		return 'w_';
	}
};
var $elm$browser$Browser$Events$addKey = function (sub) {
	var node = sub.a;
	var name = sub.b;
	return _Utils_Tuple2(
		_Utils_ap(
			$elm$browser$Browser$Events$nodeToKey(node),
			name),
		sub);
};
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$browser$Browser$Events$Event = F2(
	function (key, event) {
		return {kb: event, h3: key};
	});
var $elm$browser$Browser$Events$spawn = F3(
	function (router, key, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var actualNode = function () {
			if (!node) {
				return _Browser_doc;
			} else {
				return _Browser_window;
			}
		}();
		return A2(
			$elm$core$Task$map,
			function (value) {
				return _Utils_Tuple2(key, value);
			},
			A3(
				_Browser_on,
				actualNode,
				name,
				function (event) {
					return A2(
						$elm$core$Platform$sendToSelf,
						router,
						A2($elm$browser$Browser$Events$Event, key, event));
				}));
	});
var $elm$core$Dict$union = F2(
	function (t1, t2) {
		return A3($elm$core$Dict$foldl, $elm$core$Dict$insert, t2, t1);
	});
var $elm$browser$Browser$Events$onEffects = F3(
	function (router, subs, state) {
		var stepRight = F3(
			function (key, sub, _v6) {
				var deads = _v6.a;
				var lives = _v6.b;
				var news = _v6.c;
				return _Utils_Tuple3(
					deads,
					lives,
					A2(
						$elm$core$List$cons,
						A3($elm$browser$Browser$Events$spawn, router, key, sub),
						news));
			});
		var stepLeft = F3(
			function (_v4, pid, _v5) {
				var deads = _v5.a;
				var lives = _v5.b;
				var news = _v5.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, pid, deads),
					lives,
					news);
			});
		var stepBoth = F4(
			function (key, pid, _v2, _v3) {
				var deads = _v3.a;
				var lives = _v3.b;
				var news = _v3.c;
				return _Utils_Tuple3(
					deads,
					A3($elm$core$Dict$insert, key, pid, lives),
					news);
			});
		var newSubs = A2($elm$core$List$map, $elm$browser$Browser$Events$addKey, subs);
		var _v0 = A6(
			$elm$core$Dict$merge,
			stepLeft,
			stepBoth,
			stepRight,
			state.lz,
			$elm$core$Dict$fromList(newSubs),
			_Utils_Tuple3(_List_Nil, $elm$core$Dict$empty, _List_Nil));
		var deadPids = _v0.a;
		var livePids = _v0.b;
		var makeNewPids = _v0.c;
		return A2(
			$elm$core$Task$andThen,
			function (pids) {
				return $elm$core$Task$succeed(
					A2(
						$elm$browser$Browser$Events$State,
						newSubs,
						A2(
							$elm$core$Dict$union,
							livePids,
							$elm$core$Dict$fromList(pids))));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$sequence(makeNewPids);
				},
				$elm$core$Task$sequence(
					A2($elm$core$List$map, $elm$core$Process$kill, deadPids))));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$browser$Browser$Events$onSelfMsg = F3(
	function (router, _v0, state) {
		var key = _v0.h3;
		var event = _v0.kb;
		var toMessage = function (_v2) {
			var subKey = _v2.a;
			var _v3 = _v2.b;
			var node = _v3.a;
			var name = _v3.b;
			var decoder = _v3.c;
			return _Utils_eq(subKey, key) ? A2(_Browser_decodeEvent, decoder, event) : $elm$core$Maybe$Nothing;
		};
		var messages = A2($elm$core$List$filterMap, toMessage, state.mp);
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Platform$sendToApp(router),
					messages)));
	});
var $elm$browser$Browser$Events$subMap = F2(
	function (func, _v0) {
		var node = _v0.a;
		var name = _v0.b;
		var decoder = _v0.c;
		return A3(
			$elm$browser$Browser$Events$MySub,
			node,
			name,
			A2($elm$json$Json$Decode$map, func, decoder));
	});
_Platform_effectManagers['Browser.Events'] = _Platform_createManager($elm$browser$Browser$Events$init, $elm$browser$Browser$Events$onEffects, $elm$browser$Browser$Events$onSelfMsg, 0, $elm$browser$Browser$Events$subMap);
var $elm$browser$Browser$Events$subscription = _Platform_leaf('Browser.Events');
var $elm$browser$Browser$Events$on = F3(
	function (node, name, decoder) {
		return $elm$browser$Browser$Events$subscription(
			A3($elm$browser$Browser$Events$MySub, node, name, decoder));
	});
var $elm$browser$Browser$Events$onMouseMove = A2($elm$browser$Browser$Events$on, 0, 'mousemove');
var $elm$browser$Browser$Events$onMouseUp = A2($elm$browser$Browser$Events$on, 0, 'mouseup');
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$DragAndDrop$Move$subscriptions = F2(
	function (toMsg, _v0) {
		var list = _v0.k_;
		var ghost = _v0.al;
		var debouncedMsg = _v0.cm;
		var _v1 = _Utils_Tuple3(list, ghost, debouncedMsg);
		if (_v1.c.$ === 1) {
			if ((!_v1.a.$) && (!_v1.b.$)) {
				var _v2 = _v1.c;
				return $elm$core$Platform$Sub$batch(
					_List_fromArray(
						[
							$elm$browser$Browser$Events$onMouseMove(
							A2(
								$elm$json$Json$Decode$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$DragAndDrop$Move$MoveBrowser,
									A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Move$StateMsg, toMsg)),
								$author$project$DragAndDrop$Move$pagePosition)),
							$elm$browser$Browser$Events$onMouseUp(
							$elm$json$Json$Decode$succeed(
								toMsg($author$project$DragAndDrop$Move$UpBrowser))),
							$elm$browser$Browser$Events$onAnimationFrame(
							A2(
								$elm$core$Basics$composeR,
								$elm$time$Time$posixToMillis,
								A2(
									$elm$core$Basics$composeR,
									$author$project$DragAndDrop$Move$Tick,
									A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Move$StateMsg, toMsg))))
						]));
			} else {
				return $elm$core$Platform$Sub$none;
			}
		} else {
			return $elm$browser$Browser$Events$onAnimationFrameDelta(
				A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Move$TimeToStartTick, toMsg));
		}
	});
var $author$project$DragAndDrop$Move$DownDragItemAction = F5(
	function (a, b, c, d, e) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Platform$Cmd$map = _Platform_map;
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $GlobalWebIndex$cmd_extra$Cmd$Extra$perform = A2(
	$elm$core$Basics$composeL,
	$elm$core$Task$perform($elm$core$Basics$identity),
	$elm$core$Task$succeed);
var $author$project$DragAndDrop$Move$updateDownDragItem = F6(
	function (dragListId, dragItem, dragIndex, dragElementId, coordinates, model) {
		return _Utils_Tuple3(
			$elm$core$Maybe$Nothing,
			_Utils_update(
				model,
				{
					al: $elm$core$Maybe$Just(
						{
							bX: coordinates,
							gw: coordinates,
							dP: coordinates,
							gY: A2($author$project$DragAndDrop$Move$Position, 0, 0)
						}),
					k_: $elm$core$Maybe$Just(
						{ej: $elm$core$Maybe$Nothing, dm: $elm$core$Maybe$Nothing, hH: dragElementId, j2: dragIndex, op: dragItem, oq: dragListId, eu: $elm$core$Maybe$Nothing, hI: dragElementId, a_: dragIndex, j3: dragListId})
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$DragAndDrop$Move$GotContainer = function (a) {
	return {$: 5, a: a};
};
var $author$project$DragAndDrop$Move$GotDragItem = function (a) {
	return {$: 3, a: a};
};
var $author$project$DragAndDrop$Move$GotDropItem = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$DragAndDrop$Move$NoOp = {$: 7};
var $elm$browser$Browser$Dom$getViewportOf = _Browser_getViewportOf;
var $author$project$DragAndDrop$Move$Bottom = 5;
var $author$project$DragAndDrop$Move$BottomLeft = 2;
var $author$project$DragAndDrop$Move$BottomRight = 3;
var $author$project$DragAndDrop$Move$Left = 6;
var $author$project$DragAndDrop$Move$None = 8;
var $author$project$DragAndDrop$Move$Right = 7;
var $author$project$DragAndDrop$Move$Top = 4;
var $author$project$DragAndDrop$Move$TopLeft = 0;
var $author$project$DragAndDrop$Move$TopRight = 1;
var $author$project$DragAndDrop$Move$direction = F4(
	function (position, offset, element, viewport) {
		return ((_Utils_cmp(position.m3, element.m3 + offset.kY) < 0) && (_Utils_cmp(position.m4, element.m4 + offset.mH) < 0)) ? 0 : (((_Utils_cmp(position.m3, (element.m3 + viewport.da) - offset.lQ) > 0) && (_Utils_cmp(position.m4, element.m4 + offset.mH) < 0)) ? 1 : (((_Utils_cmp(position.m3, element.m3 + offset.kY) < 0) && (_Utils_cmp(position.m4, (element.m4 + viewport.cv) - offset.jy) > 0)) ? 2 : (((_Utils_cmp(position.m3, (element.m3 + viewport.da) - offset.lQ) > 0) && (_Utils_cmp(position.m4, (element.m4 + viewport.cv) - offset.jy) > 0)) ? 3 : ((_Utils_cmp(position.m4, element.m4 + offset.mH) < 0) ? 4 : ((_Utils_cmp(position.m4, (element.m4 + viewport.cv) - offset.jy) > 0) ? 5 : ((_Utils_cmp(position.m3, element.m3 + offset.kY) < 0) ? 6 : ((_Utils_cmp(position.m3, (element.m3 + viewport.da) - offset.lQ) > 0) ? 7 : 8)))))));
	});
var $elm$browser$Browser$Dom$setViewportOf = _Browser_setViewportOf;
var $author$project$DragAndDrop$Move$scrollByStep = F6(
	function (step, _v0, offset, containerElementId, _v1, _v2) {
		var startPosition = _v0.dP;
		var prevPosition = _v0.gw;
		var currentPosition = _v0.bX;
		var element = _v1.j4;
		var viewport = _v2.mX;
		if (((_Utils_cmp(startPosition.m3, element.m3) < 0) && ((_Utils_cmp(prevPosition.m3, currentPosition.m3) < 0) && (_Utils_cmp(currentPosition.m3, element.m3) < 0))) || ((_Utils_cmp(startPosition.m3, element.m3) < 0) && ((_Utils_cmp(prevPosition.m3, currentPosition.m3) < 0) && (_Utils_cmp(currentPosition.m4, element.m4) < 0)))) {
			return $elm$core$Task$succeed(0);
		} else {
			var _v3 = A4($author$project$DragAndDrop$Move$direction, currentPosition, offset, element, viewport);
			switch (_v3) {
				case 0:
					return $elm$core$Task$succeed(0);
				case 1:
					return $elm$core$Task$succeed(0);
				case 2:
					return $elm$core$Task$succeed(0);
				case 3:
					return $elm$core$Task$succeed(0);
				case 4:
					return A3($elm$browser$Browser$Dom$setViewportOf, containerElementId, viewport.m3, viewport.m4 - step);
				case 5:
					return A3($elm$browser$Browser$Dom$setViewportOf, containerElementId, viewport.m3, viewport.m4 + step);
				case 6:
					return A3($elm$browser$Browser$Dom$setViewportOf, containerElementId, viewport.m3 - step, viewport.m4);
				case 7:
					return A3($elm$browser$Browser$Dom$setViewportOf, containerElementId, viewport.m3 + step, viewport.m4);
				default:
					return $elm$core$Task$succeed(0);
			}
		}
	});
var $author$project$DragAndDrop$Move$autoScrollCmd = F3(
	function (listState, ghostState, _v0) {
		var containerElementId = _v0.ek;
		var offset = _v0.lm;
		var _v1 = listState.ej;
		if (!_v1.$) {
			var containerElement = _v1.a;
			return A2(
				$elm$core$Task$attempt,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Basics$always($author$project$DragAndDrop$Move$NoOp),
					$author$project$DragAndDrop$Move$StateMsg),
				A2(
					$elm$core$Task$andThen,
					A5($author$project$DragAndDrop$Move$scrollByStep, 35, ghostState, offset, containerElementId, containerElement),
					$elm$browser$Browser$Dom$getViewportOf(containerElementId)));
		} else {
			return $elm$core$Platform$Cmd$none;
		}
	});
var $elm$browser$Browser$Dom$getElement = _Browser_getElement;
var $author$project$DragAndDrop$Move$positionWithFence = F3(
	function (_v0, offset, _v1) {
		var startPosition = _v0.dP;
		var currentPosition = _v0.bX;
		var element = _v1.j4;
		if (((_Utils_cmp(startPosition.m3, element.m3) < 0) && (_Utils_cmp(currentPosition.m3, element.m3) < 0)) || ((_Utils_cmp(startPosition.m3, element.m3) < 0) && (_Utils_cmp(currentPosition.m4, element.m4) < 0))) {
			return A2($author$project$DragAndDrop$Move$Position, currentPosition.m3 - startPosition.m3, currentPosition.m4 - startPosition.m4);
		} else {
			var _v2 = A4($author$project$DragAndDrop$Move$direction, currentPosition, offset, element, element);
			switch (_v2) {
				case 0:
					return A2($author$project$DragAndDrop$Move$Position, (element.m3 - startPosition.m3) + offset.kY, (element.m4 - startPosition.m4) + offset.mH);
				case 1:
					return A2($author$project$DragAndDrop$Move$Position, ((element.m3 + element.da) - startPosition.m3) - offset.lQ, (element.m4 - startPosition.m4) + offset.mH);
				case 2:
					return A2($author$project$DragAndDrop$Move$Position, (element.m3 - startPosition.m3) + offset.kY, ((element.m4 + element.cv) - startPosition.m4) - offset.jy);
				case 3:
					return A2($author$project$DragAndDrop$Move$Position, ((element.m3 + element.da) - startPosition.m3) - offset.lQ, ((element.m4 + element.cv) - startPosition.m4) - offset.jy);
				case 4:
					return A2($author$project$DragAndDrop$Move$Position, currentPosition.m3 - startPosition.m3, (element.m4 - startPosition.m4) + offset.mH);
				case 5:
					return A2($author$project$DragAndDrop$Move$Position, currentPosition.m3 - startPosition.m3, ((element.m4 + element.cv) - startPosition.m4) - offset.jy);
				case 6:
					return A2($author$project$DragAndDrop$Move$Position, (element.m3 - startPosition.m3) + offset.kY, currentPosition.m4 - startPosition.m4);
				case 7:
					return A2($author$project$DragAndDrop$Move$Position, ((element.m3 + element.da) - startPosition.m3) - offset.lQ, currentPosition.m4 - startPosition.m4);
				default:
					return A2($author$project$DragAndDrop$Move$Position, currentPosition.m3 - startPosition.m3, currentPosition.m4 - startPosition.m4);
			}
		}
	});
var $author$project$DragAndDrop$Move$updateState = F4(
	function (options, msg, listState, ghostState) {
		switch (msg.$) {
			case 0:
				var coordinates = msg.a;
				return _Utils_Tuple3(
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(
						listState,
						_Utils_update(
							ghostState,
							{bX: coordinates, gw: ghostState.bX})),
					function () {
						var _v1 = listState.dm;
						if (_v1.$ === 1) {
							return $elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										A2(
										$elm$core$Task$attempt,
										A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Move$GotDragItem, $author$project$DragAndDrop$Move$StateMsg),
										$elm$browser$Browser$Dom$getElement(listState.hH)),
										A2(
										$elm$core$Task$attempt,
										A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Move$GotContainer, $author$project$DragAndDrop$Move$StateMsg),
										$elm$browser$Browser$Dom$getElement(options.ek))
									]));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 1:
				var dropListId = msg.a;
				var dropIndex = msg.b;
				var dropElementId = msg.c;
				return _Utils_Tuple3(
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(
						_Utils_update(
							listState,
							{hI: dropElementId, a_: dropIndex, j3: dropListId}),
						ghostState),
					A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Move$GotDropItem, $author$project$DragAndDrop$Move$StateMsg),
						$elm$browser$Browser$Dom$getElement(dropElementId)));
			case 2:
				return _Utils_Tuple3(
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(
						_Utils_update(
							listState,
							{a_: listState.j2, j3: listState.oq}),
						ghostState),
					$elm$core$Platform$Cmd$none);
			case 3:
				if (msg.a.$ === 1) {
					return _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						_Utils_Tuple2(listState, ghostState),
						$elm$core$Platform$Cmd$none);
				} else {
					var dragElement = msg.a.a;
					return _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						_Utils_Tuple2(
							_Utils_update(
								listState,
								{
									dm: $elm$core$Maybe$Just(dragElement),
									eu: $elm$core$Maybe$Just(dragElement)
								}),
							ghostState),
						$elm$core$Platform$Cmd$none);
				}
			case 4:
				if (msg.a.$ === 1) {
					return _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						_Utils_Tuple2(listState, ghostState),
						$elm$core$Platform$Cmd$none);
				} else {
					var dropElement = msg.a.a;
					return _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						_Utils_Tuple2(
							_Utils_update(
								listState,
								{
									eu: $elm$core$Maybe$Just(dropElement)
								}),
							ghostState),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				if (msg.a.$ === 1) {
					return _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						_Utils_Tuple2(listState, ghostState),
						$elm$core$Platform$Cmd$none);
				} else {
					var containerElement = msg.a.a;
					return _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						_Utils_Tuple2(
							_Utils_update(
								listState,
								{
									ej: $elm$core$Maybe$Just(containerElement)
								}),
							ghostState),
						$elm$core$Platform$Cmd$none);
				}
			case 6:
				return _Utils_Tuple3(
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(
						listState,
						_Utils_update(
							ghostState,
							{
								gY: function () {
									var _v2 = listState.ej;
									if (!_v2.$) {
										var containerElement = _v2.a;
										return A3($author$project$DragAndDrop$Move$positionWithFence, ghostState, options.lm, containerElement);
									} else {
										return A2($author$project$DragAndDrop$Move$Position, ghostState.bX.m3 - ghostState.dP.m3, ghostState.bX.m4 - ghostState.dP.m4);
									}
								}()
							})),
					A3($author$project$DragAndDrop$Move$autoScrollCmd, listState, ghostState, options));
			default:
				return _Utils_Tuple3(
					$elm$core$Maybe$Nothing,
					_Utils_Tuple2(listState, ghostState),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$DragAndDrop$Move$update = F4(
	function (_v0, toMsg, msg, model) {
		var options = _v0;
		var list = model.k_;
		var ghost = model.al;
		var _v1 = _Utils_Tuple3(msg, list, ghost);
		_v1$6:
		while (true) {
			switch (_v1.a.$) {
				case 3:
					var tick = _v1.a.a;
					var _v2 = model.cm;
					if (!_v2.$) {
						var _v3 = _v2.a;
						var timteToFireMsg = _v3.a;
						var debouncedMsg = _v3.b;
						var decremented = timteToFireMsg - tick;
						return (decremented > 0) ? _Utils_Tuple3(
							$elm$core$Maybe$Nothing,
							_Utils_update(
								model,
								{
									cm: $elm$core$Maybe$Just(
										_Utils_Tuple2(decremented, debouncedMsg))
								}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple3(
							$elm$core$Maybe$Nothing,
							_Utils_update(
								model,
								{cm: $elm$core$Maybe$Nothing}),
							A2(
								$elm$core$Platform$Cmd$map,
								toMsg,
								$GlobalWebIndex$cmd_extra$Cmd$Extra$perform(debouncedMsg)));
					} else {
						return _Utils_Tuple3($elm$core$Maybe$Nothing, model, $elm$core$Platform$Cmd$none);
					}
				case 2:
					var _v4 = _v1.a;
					return _Utils_Tuple3(
						$elm$core$Maybe$Nothing,
						_Utils_update(
							model,
							{cm: $elm$core$Maybe$Nothing}),
						$elm$core$Platform$Cmd$none);
				case 0:
					var _v5 = _v1.a;
					var dragListId = _v5.a;
					var dragItem = _v5.b;
					var dragIndex = _v5.c;
					var dragElementId = _v5.d;
					var coordinates = _v5.e;
					var _v6 = options.fE;
					if (!_v6.$) {
						var time = _v6.a;
						return _Utils_Tuple3(
							$elm$core$Maybe$Nothing,
							_Utils_update(
								model,
								{
									cm: $elm$core$Maybe$Just(
										_Utils_Tuple2(
											time,
											A5($author$project$DragAndDrop$Move$DownDragItemAction, dragListId, dragItem, dragIndex, dragElementId, coordinates)))
								}),
							$elm$core$Platform$Cmd$none);
					} else {
						return A6($author$project$DragAndDrop$Move$updateDownDragItem, dragListId, dragItem, dragIndex, dragElementId, coordinates, model);
					}
				case 1:
					var _v7 = _v1.a;
					var dragListId = _v7.a;
					var dragItem = _v7.b;
					var dragIndex = _v7.c;
					var dragElementId = _v7.d;
					var coordinates = _v7.e;
					return A6($author$project$DragAndDrop$Move$updateDownDragItem, dragListId, dragItem, dragIndex, dragElementId, coordinates, model);
				case 4:
					if ((!_v1.b.$) && (!_v1.c.$)) {
						var stateMsg = _v1.a.a;
						var listState = _v1.b.a;
						var ghostState = _v1.c.a;
						var _v8 = A4($author$project$DragAndDrop$Move$updateState, options, stateMsg, listState, ghostState);
						var _return = _v8.a;
						var _v9 = _v8.b;
						var newListState = _v9.a;
						var newGhostState = _v9.b;
						var cmds = _v8.c;
						return _Utils_Tuple3(
							_return,
							_Utils_update(
								model,
								{
									al: $elm$core$Maybe$Just(newGhostState),
									k_: $elm$core$Maybe$Just(newListState)
								}),
							A2($elm$core$Platform$Cmd$map, toMsg, cmds));
					} else {
						break _v1$6;
					}
				default:
					if ((!_v1.b.$) && (!_v1.c.$)) {
						var _v10 = _v1.a;
						var listState = _v1.b.a;
						return ((_Utils_eq(listState.oq, listState.j3) && (!_Utils_eq(listState.j2, listState.a_))) || (!_Utils_eq(listState.oq, listState.j3))) ? _Utils_Tuple3(
							$elm$core$Maybe$Just(
								{j2: listState.j2, op: listState.op, oq: listState.oq, a_: listState.a_, j3: listState.j3}),
							_Utils_update(
								model,
								{al: $elm$core$Maybe$Nothing, k_: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none) : _Utils_Tuple3(
							$elm$core$Maybe$Nothing,
							_Utils_update(
								model,
								{al: $elm$core$Maybe$Nothing, k_: $elm$core$Maybe$Nothing}),
							$elm$core$Platform$Cmd$none);
					} else {
						break _v1$6;
					}
			}
		}
		return _Utils_Tuple3(
			$elm$core$Maybe$Nothing,
			_Utils_update(
				model,
				{al: $elm$core$Maybe$Nothing, k_: $elm$core$Maybe$Nothing}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$DragAndDrop$Move$create = F2(
	function (toMsg, configuration) {
		return {
			oo: $author$project$DragAndDrop$Move$dragEvents(toMsg),
			hJ: $author$project$DragAndDrop$Move$dropEvents(toMsg),
			al: $author$project$DragAndDrop$Move$getGhostState,
			oY: $author$project$DragAndDrop$Move$ghostStyles(configuration),
			fX: $author$project$DragAndDrop$Move$info,
			k8: A3($author$project$DragAndDrop$Move$Model, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			mq: $author$project$DragAndDrop$Move$subscriptions(toMsg),
			mO: A2($author$project$DragAndDrop$Move$update, configuration, toMsg)
		};
	});
var $author$project$Dashboards2$Detail$detailScrollContainerId = 'd2-detail-scrollable-container';
var $author$project$DragAndDrop$Move$ghostStyle = F2(
	function (declarations, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{al: declarations});
	});
var $author$project$DragAndDrop$Move$preserveWidth = function (_v0) {
	var element = _v0.j4;
	return A2(
		$elm$html$Html$Attributes$style,
		'width',
		$author$project$DragAndDrop$Move$px(
			$elm$core$Basics$round(element.da)));
};
var $author$project$Dashboards2$DuplicateWidget = function (a) {
	return {$: 32, a: a};
};
var $author$project$Dashboards2$OpenConfirmDeleteWidgetModal = function (a) {
	return {$: 28, a: a};
};
var $author$project$Dashboards2$OpenErrorModal = function (a) {
	return {$: 27, a: a};
};
var $author$project$Dashboards2$OpenHelpMeChooseChartTypeModal = function (a) {
	return {$: 29, a: a};
};
var $author$project$Dashboards2$OpenHelpMeChooseMetricModal = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Dashboards2$OpenMetricInfoModal = {$: 31};
var $author$project$Dashboards2$ProcessWidgetRequests = function (a) {
	return {$: 121, a: a};
};
var $author$project$Dashboards2$RenameChartWidget = F2(
	function (a, b) {
		return {$: 81, a: a, b: b};
	});
var $author$project$Dashboards2$SaveWidget = function (a) {
	return {$: 105, a: a};
};
var $author$project$Dashboards2$ShowQuestionsMetadata = F2(
	function (a, b) {
		return {$: 23, a: a, b: b};
	});
var $author$project$Dashboards2$WidgetMsg = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Dashboards2$Widget$ChartMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Widget$configure = function (rec) {
	return {
		ef: {
			a: A2($elm$core$Basics$composeL, rec.a, $author$project$Dashboards2$Widget$ChartMsg),
			bz: rec.bz
		},
		os: rec.os,
		o3: rec.o3,
		o4: rec.o4,
		pn: rec.pn,
		pQ: rec.pQ,
		a: rec.a,
		eI: rec.eI,
		b0: rec.b0,
		y: rec.y,
		qd: rec.qd,
		ql: rec.ql,
		qy: rec.qy,
		qO: rec.qO,
		q5: rec.q5,
		l: rec.l,
		b8: rec.b8,
		bz: rec.bz
	};
};
var $author$project$Data$Platform2$getChartWidget = function (widget) {
	var _v0 = widget.U;
	if (!_v0.$) {
		var data = _v0.a;
		return $elm$core$Maybe$Just(data);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm_community$maybe_extra$Maybe$Extra$unwrap = F3(
	function (_default, f, m) {
		if (m.$ === 1) {
			return _default;
		} else {
			var a = m.a;
			return f(a);
		}
	});
var $author$project$Dashboards2$widgetConfig = F3(
	function (config, userFilters, widget) {
		return $author$project$Dashboards2$Widget$configure(
			{
				os: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$DuplicateWidget),
				o3: config.a(
					$author$project$Dashboards2$OpenHelpMeChooseChartTypeModal(widget)),
				o4: A2(
					$elm$core$Basics$composeL,
					config.a,
					$author$project$Dashboards2$OpenHelpMeChooseMetricModal(widget)),
				pn: A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$OpenErrorModal),
					$elm$core$List$singleton),
				pQ: config.a($author$project$Dashboards2$OpenMetricInfoModal),
				a: A2(
					$elm$core$Basics$composeL,
					config.a,
					$author$project$Dashboards2$WidgetMsg(widget.b)),
				eI: function (metric) {
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						config.y,
						function (chartWidget) {
							return A3(config.eI, widget, chartWidget, metric);
						},
						$author$project$Data$Platform2$getChartWidget(widget));
				},
				b0: config.b0,
				y: config.y,
				qd: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$OpenConfirmDeleteWidgetModal),
				ql: F2(
					function (c, q) {
						return config.a(
							A2($author$project$Dashboards2$ShowQuestionsMetadata, c, q));
					}),
				qy: A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ProcessWidgetRequests),
					$elm$core$List$map(
						$elm$core$Platform$Cmd$map(
							$author$project$Dashboards2$WidgetMsg(widget.b)))),
				qO: A2(
					$elm$core$Basics$composeL,
					config.a,
					$author$project$Dashboards2$RenameChartWidget(widget)),
				q5: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$SaveWidget),
				l: config.l,
				b8: config.b8,
				bz: userFilters
			});
	});
var $author$project$DragAndDrop$Move$withContainer = F2(
	function (containerElementId, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{ek: containerElementId});
	});
var $author$project$Dashboards2$detailConfigure = function (rec) {
	return {
		nl: rec.a($author$project$Dashboards2$AddDescriptionClicked),
		nm: function (rt) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Dashboards2$AddNewRichTextWidget(rt),
				rec.a);
		},
		nC: $author$project$Dashboards2$AudiencesReordered,
		ec: function ($) {
			return $.ec;
		},
		nN: rec.a($author$project$Dashboards2$CancelDashboardExport),
		nR: $author$project$Dashboards2$ChangeActiveDropdown,
		fq: $author$project$Dashboards2$ChartBrowser$configure(
			{
				ob: A2($elm$core$Basics$composeL, rec.a, $author$project$Dashboards2$CreateWidgetsFromChartBrowser),
				o_: rec.jQ,
				a: A2($elm$core$Basics$composeL, rec.a, $author$project$Dashboards2$ChartBrowserMsg),
				eH: rec.eH,
				l: rec.l
			}),
		nZ: rec.a($author$project$Dashboards2$CheckStickyHeaderVisibility),
		n8: $author$project$Dashboards2$CopyDashboardLink,
		cj: rec.cj,
		bA: rec.bA,
		cp: rec.cp,
		cq: rec.cq,
		dl: A2(
			$author$project$DragAndDrop$Move$create,
			A2($elm$core$Basics$composeR, $author$project$Dashboards2$WidgetDragAndDropMsg, rec.a),
			A2(
				$author$project$DragAndDrop$Move$ghostStyle,
				_List_fromArray(
					[$author$project$DragAndDrop$Move$preserveWidth]),
				A2($author$project$DragAndDrop$Move$withContainer, $author$project$Dashboards2$Detail$detailScrollContainerId, $author$project$DragAndDrop$Move$config))),
		or: $author$project$Dashboards2$DuplicateDashboard,
		fM: $author$project$Dashboards2$EditAudience,
		bG: rec.bG,
		ou: function (id) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Dashboards2$EditWidgetDimension(id),
				rec.a);
		},
		bi: $author$project$Dashboards2$ExportRequested,
		aM: rec.aM,
		pG: rec.a($author$project$Dashboards2$LinkInsightClicked),
		a: rec.a,
		as: rec.as,
		eH: rec.eH,
		eI: rec.eI,
		b0: rec.b0,
		dE: $author$project$Dashboards2$NavigateToInsight,
		y: rec.y,
		pX: $author$project$Dashboards2$NoOp,
		qa: A2($elm$core$Basics$composeR, $author$project$Dashboards2$OpenAudienceBrowserModal, rec.a),
		qb: $author$project$Dashboards2$OpenBaseAudienceBrowserModal,
		qc: function (d) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Dashboards2$OpenChartBrowser(d),
				rec.a);
		},
		qe: rec.a($author$project$Dashboards2$OpenDatasetsDrawer),
		qi: $author$project$Dashboards2$OpenEditModeButtonClicked,
		qj: rec.a($author$project$Dashboards2$OpenLocationsDrawer),
		qm: A2($elm$core$Basics$composeR, $author$project$Dashboards2$OpenRenameDashboardModal, rec.a),
		qo: $author$project$Dashboards2$OpenReplaceAudienceBrowserModal,
		qp: rec.a($author$project$Dashboards2$OpenWavesDrawer),
		qu: A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, $author$project$Dashboards2$EditSectionMsg, rec.a)),
		qx: $author$project$Dashboards2$PreviewAudience,
		qI: $author$project$Dashboards2$Redo,
		qN: $author$project$Dashboards2$RemoveAudience,
		cR: rec.cR,
		qR: $author$project$Dashboards2$ReorderAudiencesMsg,
		qS: $author$project$Dashboards2$ResetBaseAudience,
		qT: $author$project$Dashboards2$ResetChanges,
		cS: rec.a($author$project$Dashboards2$SaveDashboard),
		ag: rec.ag,
		cT: rec.cT,
		cU: rec.cU,
		q8: rec.a($author$project$Dashboards2$ScrollBasesPanelLeft),
		q9: rec.a($author$project$Dashboards2$ScrollBasesPanelRight),
		ri: A2($elm$core$Basics$composeR, $author$project$Dashboards2$SetEditMode, rec.a),
		rj: $author$project$Dashboards2$ShareBtnClicked,
		l: rec.l,
		b8: rec.b8,
		rL: rec.a($author$project$Dashboards2$TabsPanelResized),
		r3: rec.a($author$project$Dashboards2$ToggleAddCategory),
		r4: $author$project$Dashboards2$ToggleAudienceVisibility,
		r5: function (d) {
			return A2(
				$elm$core$Basics$composeR,
				$author$project$Dashboards2$ToggleDashboardCategory(d),
				rec.a);
		},
		b9: rec.b9,
		r7: $author$project$Dashboards2$Undo,
		c1: rec.c1,
		c8: $author$project$Dashboards2$widgetConfig(rec)
	};
};
var $author$project$Dashboards2$CreateNewDashboard = function (a) {
	return {$: 6, a: a};
};
var $author$project$Dashboards2$DashboardsListMsg = function (a) {
	return {$: 13, a: a};
};
var $author$project$Dashboards2$OpenConfirmDeleteDashboardModal = function (a) {
	return {$: 16, a: a};
};
var $author$project$Dashboards2$OpenConfirmDeleteMultipleDashboardsModal = function (a) {
	return {$: 17, a: a};
};
var $author$project$Dashboards2$OpenDuplicateDashboardModal = function (a) {
	return {$: 19, a: a};
};
var $author$project$Dashboards2$ResetEditing = {$: 99};
var $author$project$Dashboards2$listConfig = function (config) {
	return {
		n9: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$CreateNewDashboard),
		a: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$DashboardsListMsg),
		as: config.as,
		qf: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$OpenConfirmDeleteDashboardModal),
		qg: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$OpenConfirmDeleteMultipleDashboardsModal),
		qh: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$OpenDuplicateDashboardModal),
		qn: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$OpenRenameDashboardModal),
		qU: config.a($author$project$Dashboards2$ResetEditing),
		l: config.l,
		b9: config.b9
	};
};
var $author$project$Dashboards2$configure = function (rec) {
	return {
		bQ: rec.bQ,
		cj: rec.cj,
		bA: rec.bA,
		cp: rec.cp,
		cq: rec.cq,
		V: $author$project$Dashboards2$detailConfigure(rec),
		bG: rec.bG,
		aM: rec.aM,
		dy: $author$project$Dashboards2$listConfig(rec),
		a: rec.a,
		as: rec.as,
		b0: rec.b0,
		dE: rec.dE,
		y: rec.y,
		eL: rec.eL,
		cR: rec.cR,
		cS: rec.cS,
		ag: rec.ag,
		eR: rec.eR,
		cT: rec.cT,
		cU: rec.cU,
		eU: rec.eU,
		l: rec.l,
		b8: rec.b8,
		b9: rec.b9,
		c1: rec.c1
	};
};
var $author$project$Dashboards2Main$dashboardsConfig = $author$project$Dashboards2$configure(
	{
		bQ: $author$project$Dashboards2Main$AjaxError,
		cj: $author$project$Dashboards2Main$CreateDashboardCopy,
		bA: $author$project$Dashboards2Main$CreateNewAudienceInP2,
		jQ: $author$project$Dashboards2Main$CreateNewChartInP2CB,
		cp: $author$project$Dashboards2Main$DestroyDashboard,
		cq: $author$project$Dashboards2Main$DestroyWidget,
		bG: $author$project$Dashboards2Main$EditAudienceInP2,
		aM: $author$project$Dashboards2Main$ForceNavigateTo,
		a: $author$project$Dashboards2Main$DashboardsMsg,
		as: $author$project$Dashboards2Main$NavigateTo,
		eH: $author$project$Dashboards2Main$OpenChartInChartBuilder,
		eI: $author$project$Dashboards2Main$NavigateToCB,
		b0: $author$project$Dashboards2Main$NavigateToGetInTouch,
		dE: $author$project$Dashboards2Main$NavigateToInsight,
		y: $author$project$Dashboards2Main$NoOp,
		eL: $author$project$Dashboards2Main$OpenSupportChat,
		cR: $author$project$Dashboards2Main$RenameDashboard,
		cS: $author$project$Dashboards2Main$SaveDashboard,
		ag: $author$project$Dashboards2Main$SaveDashboardAsCreator(
			{kP: false, qM: true}),
		eR: $author$project$Dashboards2Main$SaveDashboardAsCreator(
			{kP: false, qM: false}),
		cT: $author$project$Dashboards2Main$SaveDashboardWidgets,
		cU: $author$project$Dashboards2Main$SaveDashboardAsCreator(
			{kP: true, qM: false}),
		eU: $author$project$Dashboards2Main$ShareDashboard,
		l: $author$project$Dashboards2Main$StoreActionMany,
		b8: $author$project$Dashboards2Main$Platform2StoreMsg,
		b9: $author$project$Dashboards2Main$ToggleFavourite,
		c1: $author$project$Dashboards2Main$UpdatePlatform2StoreWith
	});
var $turboMaCk$any_dict$Dict$Any$empty = function (toKey) {
	return {i: $elm$core$Dict$empty, aT: toKey};
};
var $author$project$Data$Id$unwrap = function (_v0) {
	var string = _v0;
	return string;
};
var $author$project$Data$Id$emptyDict = $turboMaCk$any_dict$Dict$Any$empty($author$project$Data$Id$unwrap);
var $author$project$Data$User$hasOpenAccessPlan = function (_v0) {
	var planHandle = _v0.qw;
	return planHandle === 7;
};
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Dashboards2$Modal$NoModal = {$: 0};
var $author$project$Dashboards2$Detail$NotEditing = {$: 0};
var $author$project$Dashboards2$Detail$NotModifiedYet = 2;
var $author$project$Dashboards2$SetTime = function (a) {
	return {$: 117, a: a};
};
var $GlobalWebIndex$cmd_extra$Cmd$Extra$add = F2(
	function (newCmd, _v0) {
		var model = _v0.a;
		var prevCmd = _v0.b;
		return _Utils_Tuple2(
			model,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[newCmd, prevCmd])));
	});
var $author$project$Dashboards2$Detail$audiencesPanelScrollableId = 'd2-audiences-panel-scrollable-id';
var $author$project$DragAndDrop$Reorder$Config = $elm$core$Basics$identity;
var $author$project$DragAndDrop$Reorder$Free = 0;
var $author$project$DragAndDrop$Reorder$OnDrag = 0;
var $author$project$DragAndDrop$Reorder$defaultOptions = {
	ew: $elm$core$Maybe$Nothing,
	ex: F3(
		function (_v0, _v1, list) {
			return list;
		}),
	dz: 0,
	dD: 0
};
var $author$project$DragAndDrop$Reorder$config = $author$project$DragAndDrop$Reorder$defaultOptions;
var $author$project$DragAndDrop$Reorder$Model = $elm$core$Basics$identity;
var $author$project$DragAndDrop$Reorder$DownDragItem = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$DragAndDrop$Reorder$checkMainMouseButtonPressed = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (button) {
			if (!button) {
				return decoder;
			} else {
				return $elm$json$Json$Decode$fail('Event is only relevant when the main mouse button was pressed.');
			}
		},
		A2($elm$json$Json$Decode$field, 'button', $elm$json$Json$Decode$int));
};
var $author$project$DragAndDrop$Reorder$Position = F2(
	function (x, y) {
		return {m3: x, m4: y};
	});
var $author$project$DragAndDrop$Reorder$pagePosition = A3(
	$elm$json$Json$Decode$map2,
	$author$project$DragAndDrop$Reorder$Position,
	A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
	A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float));
var $author$project$DragAndDrop$Reorder$checkedPagePosition = $author$project$DragAndDrop$Reorder$checkMainMouseButtonPressed($author$project$DragAndDrop$Reorder$pagePosition);
var $author$project$DragAndDrop$Reorder$dragEvents = F3(
	function (toMsg, dragIndex, dragElementId) {
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$Events$preventDefaultOn,
				'mousedown',
				A2(
					$elm$json$Json$Decode$map,
					function (msg) {
						return _Utils_Tuple2(msg, true);
					},
					A2(
						$elm$json$Json$Decode$map,
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$DragAndDrop$Reorder$DownDragItem, dragIndex, dragElementId),
							toMsg),
						$author$project$DragAndDrop$Reorder$checkedPagePosition)))
			]);
	});
var $author$project$DragAndDrop$Reorder$EnterDropItem = {$: 2};
var $author$project$DragAndDrop$Reorder$LeaveDropItem = {$: 3};
var $author$project$DragAndDrop$Reorder$OverDropItem = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$DragAndDrop$Reorder$StateMsg = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$onMouseEnter = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseenter',
		$elm$json$Json$Decode$succeed(msg));
};
var $elm$html$Html$Events$onMouseOver = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mouseover',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$DragAndDrop$Reorder$dropEvents = F3(
	function (toMsg, dropIndex, dropElementId) {
		return _List_fromArray(
			[
				$elm$html$Html$Events$onMouseOver(
				toMsg(
					$author$project$DragAndDrop$Reorder$StateMsg(
						A2($author$project$DragAndDrop$Reorder$OverDropItem, dropIndex, dropElementId)))),
				$elm$html$Html$Events$onMouseEnter(
				toMsg(
					$author$project$DragAndDrop$Reorder$StateMsg($author$project$DragAndDrop$Reorder$EnterDropItem))),
				$elm$html$Html$Events$onMouseLeave(
				toMsg(
					$author$project$DragAndDrop$Reorder$StateMsg($author$project$DragAndDrop$Reorder$LeaveDropItem)))
			]);
	});
var $author$project$DragAndDrop$Reorder$baseStyles = _List_fromArray(
	[
		A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
		A2($elm$html$Html$Attributes$style, 'position', 'fixed'),
		A2($elm$html$Html$Attributes$style, 'left', '0'),
		A2($elm$html$Html$Attributes$style, 'top', '0')
	]);
var $author$project$DragAndDrop$Reorder$px = function (n) {
	return $elm$core$String$fromInt(n) + 'px';
};
var $author$project$DragAndDrop$Reorder$translate = F2(
	function (x, y) {
		return 'translate3d(' + ($author$project$DragAndDrop$Reorder$px(x) + (', ' + ($author$project$DragAndDrop$Reorder$px(y) + ', 0)')));
	});
var $author$project$DragAndDrop$Reorder$free = F2(
	function (_v0, _v1) {
		var x = _v0.m3;
		var y = _v0.m4;
		var element = _v1.j4;
		return A2(
			$elm$html$Html$Attributes$style,
			'transform',
			A2(
				$author$project$DragAndDrop$Reorder$translate,
				$elm$core$Basics$round(x + element.m3),
				$elm$core$Basics$round(y + element.m4)));
	});
var $author$project$DragAndDrop$Reorder$horizontal = F2(
	function (_v0, _v1) {
		var x = _v0.m3;
		var element = _v1.j4;
		return A2(
			$elm$html$Html$Attributes$style,
			'transform',
			A2(
				$author$project$DragAndDrop$Reorder$translate,
				$elm$core$Basics$round(x + element.m3),
				$elm$core$Basics$round(element.m4)));
	});
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$DragAndDrop$Reorder$vertical = F2(
	function (_v0, _v1) {
		var y = _v0.m4;
		var element = _v1.j4;
		return A2(
			$elm$html$Html$Attributes$style,
			'transform',
			A2(
				$author$project$DragAndDrop$Reorder$translate,
				$elm$core$Basics$round(element.m3),
				$elm$core$Basics$round(y + element.m4)));
	});
var $author$project$DragAndDrop$Reorder$ghostStyles = F2(
	function (_v0, _v1) {
		var options = _v0;
		var model = _v1;
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				function (state) {
					return A2(
						$elm$core$Maybe$map,
						function (element) {
							var _v2 = options.dD;
							switch (_v2) {
								case 0:
									return A2(
										$elm$core$List$cons,
										A2($author$project$DragAndDrop$Reorder$free, state.gY, element),
										$author$project$DragAndDrop$Reorder$baseStyles);
								case 1:
									return A2(
										$elm$core$List$cons,
										A2($author$project$DragAndDrop$Reorder$horizontal, state.gY, element),
										$author$project$DragAndDrop$Reorder$baseStyles);
								default:
									return A2(
										$elm$core$List$cons,
										A2($author$project$DragAndDrop$Reorder$vertical, state.gY, element),
										$author$project$DragAndDrop$Reorder$baseStyles);
							}
						},
						state.dm);
				},
				model));
	});
var $elm$core$Maybe$map2 = F3(
	function (func, ma, mb) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				return $elm$core$Maybe$Just(
					A2(func, a, b));
			}
		}
	});
var $author$project$DragAndDrop$Reorder$info = function (_v0) {
	var model = _v0;
	return A2(
		$elm$core$Maybe$andThen,
		function (state) {
			return A3(
				$elm$core$Maybe$map2,
				F2(
					function (dragElement, dropElement) {
						return {dm: dragElement, hH: state.hH, j2: state.j2, eu: dropElement, hI: state.hI, a_: state.a_};
					}),
				state.dm,
				state.eu);
		},
		model);
};
var $author$project$DragAndDrop$Reorder$MoveBrowser = function (a) {
	return {$: 0, a: a};
};
var $author$project$DragAndDrop$Reorder$Tick = {$: 6};
var $author$project$DragAndDrop$Reorder$UpBrowser = {$: 2};
var $author$project$DragAndDrop$Reorder$subscriptions = F2(
	function (toMsg, _v0) {
		var model = _v0;
		if (model.$ === 1) {
			return $elm$core$Platform$Sub$none;
		} else {
			return $elm$core$Platform$Sub$batch(
				_List_fromArray(
					[
						$elm$browser$Browser$Events$onMouseMove(
						A2(
							$elm$json$Json$Decode$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$DragAndDrop$Reorder$MoveBrowser,
								A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Reorder$StateMsg, toMsg)),
							$author$project$DragAndDrop$Reorder$pagePosition)),
						$elm$browser$Browser$Events$onMouseUp(
						$elm$json$Json$Decode$succeed(
							toMsg($author$project$DragAndDrop$Reorder$UpBrowser))),
						$elm$browser$Browser$Events$onAnimationFrameDelta(
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Basics$always($author$project$DragAndDrop$Reorder$Tick),
							A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Reorder$StateMsg, toMsg)))
					]));
		}
	});
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $author$project$DragAndDrop$Reorder$rotateLeft = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return _Utils_ap(
			xs,
			_List_fromArray(
				[x]));
	} else {
		return _List_Nil;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $author$project$DragAndDrop$Reorder$rotate = F3(
	function (i, j, list) {
		var middle = A2(
			$elm$core$List$take,
			(j - i) + 1,
			A2($elm$core$List$drop, i, list));
		var end = A2($elm$core$List$drop, j + 1, list);
		var beginning = A2($elm$core$List$take, i, list);
		return _Utils_ap(
			beginning,
			_Utils_ap(
				$author$project$DragAndDrop$Reorder$rotateLeft(middle),
				end));
	});
var $author$project$DragAndDrop$Reorder$moveItem = F3(
	function (dragIndex, dropIndex, list) {
		if (_Utils_cmp(dragIndex, dropIndex) < 0) {
			return A3($author$project$DragAndDrop$Reorder$rotate, dragIndex, dropIndex, list);
		} else {
			if (_Utils_cmp(dragIndex, dropIndex) > 0) {
				var n = $elm$core$List$length(list) - 1;
				return $elm$core$List$reverse(
					A3(
						$author$project$DragAndDrop$Reorder$rotate,
						n - dragIndex,
						n - dropIndex,
						$elm$core$List$reverse(list)));
			} else {
				return list;
			}
		}
	});
var $author$project$DragAndDrop$Reorder$GotDragItem = function (a) {
	return {$: 4, a: a};
};
var $author$project$DragAndDrop$Reorder$GotDropItem = function (a) {
	return {$: 5, a: a};
};
var $author$project$DragAndDrop$Reorder$updateState = F4(
	function (options, msg, list, state) {
		switch (msg.$) {
			case 0:
				var coordinates = msg.a;
				return _Utils_Tuple3(
					list,
					_Utils_update(
						state,
						{bX: coordinates, cH: state.cH + 1}),
					function () {
						var _v1 = state.dm;
						if (_v1.$ === 1) {
							return A2(
								$elm$core$Task$attempt,
								A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Reorder$GotDragItem, $author$project$DragAndDrop$Reorder$StateMsg),
								$elm$browser$Browser$Dom$getElement(state.hH));
						} else {
							return $elm$core$Platform$Cmd$none;
						}
					}());
			case 1:
				var dropIndex = msg.a;
				var dropElementId = msg.b;
				return _Utils_Tuple3(
					list,
					_Utils_update(
						state,
						{hI: dropElementId, a_: dropIndex}),
					A2(
						$elm$core$Task$attempt,
						A2($elm$core$Basics$composeR, $author$project$DragAndDrop$Reorder$GotDropItem, $author$project$DragAndDrop$Reorder$StateMsg),
						$elm$browser$Browser$Dom$getElement(dropElementId)));
			case 2:
				if ((state.cH > 1) && (!_Utils_eq(state.j2, state.a_))) {
					var _v2 = options.dz;
					if (!_v2) {
						return _Utils_Tuple3(
							A3(
								$author$project$DragAndDrop$Reorder$moveItem,
								state.j2,
								state.a_,
								A3(options.ex, state.j2, state.a_, list)),
							_Utils_update(
								state,
								{j2: state.a_, cH: 0}),
							$elm$core$Platform$Cmd$none);
					} else {
						return _Utils_Tuple3(
							list,
							_Utils_update(
								state,
								{cH: 0}),
							$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple3(list, state, $elm$core$Platform$Cmd$none);
				}
			case 3:
				return _Utils_Tuple3(
					list,
					_Utils_update(
						state,
						{a_: state.j2}),
					$elm$core$Platform$Cmd$none);
			case 4:
				if (msg.a.$ === 1) {
					return _Utils_Tuple3(list, state, $elm$core$Platform$Cmd$none);
				} else {
					var dragElement = msg.a.a;
					return _Utils_Tuple3(
						list,
						_Utils_update(
							state,
							{
								dm: $elm$core$Maybe$Just(dragElement),
								eu: $elm$core$Maybe$Just(dragElement)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 5:
				if (msg.a.$ === 1) {
					return _Utils_Tuple3(list, state, $elm$core$Platform$Cmd$none);
				} else {
					var dropElement = msg.a.a;
					return _Utils_Tuple3(
						list,
						_Utils_update(
							state,
							{
								eu: $elm$core$Maybe$Just(dropElement)
							}),
						$elm$core$Platform$Cmd$none);
				}
			default:
				return _Utils_Tuple3(
					list,
					_Utils_update(
						state,
						{
							gY: A2($author$project$DragAndDrop$Reorder$Position, state.bX.m3 - state.dP.m3, state.bX.m4 - state.dP.m4)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$DragAndDrop$Reorder$update = F5(
	function (_v0, toMsg, msg, list, _v1) {
		var options = _v0;
		var model = _v1;
		var _v2 = _Utils_Tuple2(msg, model);
		_v2$0:
		while (true) {
			if (!_v2.b.$) {
				switch (_v2.a.$) {
					case 0:
						break _v2$0;
					case 1:
						var stateMsg = _v2.a.a;
						var state = _v2.b.a;
						var _v4 = A4($author$project$DragAndDrop$Reorder$updateState, options, stateMsg, list, state);
						var newList = _v4.a;
						var newModel = _v4.b;
						var cmds = _v4.c;
						return _Utils_Tuple3(
							newList,
							$elm$core$Maybe$Just(newModel),
							A2($elm$core$Platform$Cmd$map, toMsg, cmds));
					default:
						var _v5 = _v2.a;
						var state = _v2.b.a;
						if ((!_Utils_eq(state.j2, state.a_)) && (!_Utils_eq(state.hH, state.hI))) {
							var _v6 = options.dz;
							if (!_v6) {
								return _Utils_Tuple3(list, $elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none);
							} else {
								var newList = A3(
									$author$project$DragAndDrop$Reorder$moveItem,
									state.j2,
									state.a_,
									A3(options.ex, state.j2, state.a_, list));
								return _Utils_Tuple3(
									newList,
									$elm$core$Maybe$Nothing,
									A2(
										$elm$core$Maybe$withDefault,
										$elm$core$Platform$Cmd$none,
										A2(
											$elm$core$Maybe$map,
											function (f) {
												return A2(
													$elm$core$Task$perform,
													f(newList),
													$elm$core$Task$succeed(state.a_));
											},
											options.ew)));
							}
						} else {
							return _Utils_Tuple3(
								list,
								$elm$core$Maybe$Nothing,
								A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									A2(
										$elm$core$Maybe$map,
										function (f) {
											return A2(
												$elm$core$Task$perform,
												f(list),
												$elm$core$Task$succeed(state.a_));
										},
										options.ew)));
						}
				}
			} else {
				if (!_v2.a.$) {
					break _v2$0;
				} else {
					var _v7 = _v2.b;
					return _Utils_Tuple3(list, model, $elm$core$Platform$Cmd$none);
				}
			}
		}
		var _v3 = _v2.a;
		var dragIndex = _v3.a;
		var dragElementId = _v3.b;
		var coordinates = _v3.c;
		return _Utils_Tuple3(
			list,
			$elm$core$Maybe$Just(
				{
					bX: coordinates,
					dm: $elm$core$Maybe$Nothing,
					hH: dragElementId,
					j2: dragIndex,
					eu: $elm$core$Maybe$Nothing,
					hI: dragElementId,
					a_: dragIndex,
					cH: 0,
					dP: coordinates,
					gY: A2($author$project$DragAndDrop$Reorder$Position, 0, 0)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$DragAndDrop$Reorder$create = F2(
	function (toMsg, configuration) {
		return {
			oo: $author$project$DragAndDrop$Reorder$dragEvents(toMsg),
			hJ: $author$project$DragAndDrop$Reorder$dropEvents(toMsg),
			oY: $author$project$DragAndDrop$Reorder$ghostStyles(configuration),
			fX: $author$project$DragAndDrop$Reorder$info,
			k8: $elm$core$Maybe$Nothing,
			mq: $author$project$DragAndDrop$Reorder$subscriptions(toMsg),
			mO: A2($author$project$DragAndDrop$Reorder$update, configuration, toMsg)
		};
	});
var $author$project$DragAndDrop$Reorder$freeMovement = function (_v0) {
	var options = _v0;
	return _Utils_update(
		options,
		{dD: 0});
};
var $author$project$DragAndDrop$Reorder$hookCommandsOnReorderFinished = F2(
	function (handler, _v0) {
		var options = _v0;
		return _Utils_update(
			options,
			{
				ew: $elm$core$Maybe$Just(handler)
			});
	});
var $author$project$Dashboards2$audiencesReorderSystem = A2(
	$author$project$DragAndDrop$Reorder$create,
	$author$project$Dashboards2$ReorderAudiencesMsg,
	A2(
		$author$project$DragAndDrop$Reorder$hookCommandsOnReorderFinished,
		$author$project$Dashboards2$AudiencesReordered,
		$author$project$DragAndDrop$Reorder$freeMovement($author$project$DragAndDrop$Reorder$config)));
var $author$project$Dashboards2$CheckWidgetsVisibility = {$: 118};
var $elm$core$Process$sleep = _Process_sleep;
var $author$project$Dashboards2$checkWidgetVisibility = function (config) {
	return $GlobalWebIndex$cmd_extra$Cmd$Extra$add(
		A2(
			$elm$core$Task$perform,
			$elm$core$Basics$always(
				config.a($author$project$Dashboards2$CheckWidgetsVisibility)),
			$elm$core$Process$sleep(300)));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $author$project$Gwi$Browser$Dom$debouncedScrollEvent = _Platform_outgoingPort('debouncedScrollEvent', $elm$json$Json$Encode$string);
var $turboMaCk$queue$Queue$Queue = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $turboMaCk$queue$Queue$empty = A2($turboMaCk$queue$Queue$Queue, _List_Nil, _List_Nil);
var $turboMaCk$any_set$Set$Any$empty = A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $turboMaCk$any_dict$Dict$Any$empty);
var $author$project$Data$Id$emptySet = $turboMaCk$any_set$Set$Any$empty($author$project$Data$Id$unwrap);
var $author$project$UndoRedo$UndoRedo = $elm$core$Basics$identity;
var $author$project$UndoRedo$UndoRedoData = F4(
	function (previous, current, future, maxHistoryLength) {
		return {aq: current, bj: future, gd: maxHistoryLength, a4: previous};
	});
var $author$project$UndoRedo$init = F2(
	function (maxHistoryLength, initState) {
		return A4(
			$author$project$UndoRedo$UndoRedoData,
			_List_Nil,
			_Utils_Tuple2($elm$core$Maybe$Nothing, initState),
			_List_Nil,
			maxHistoryLength);
	});
var $author$project$Dashboards2$Editable$NotReady = {$: 0};
var $author$project$Dashboards2$Editable$initNotReady = $author$project$Dashboards2$Editable$NotReady;
var $author$project$Dashboards2$maxHistoryLimit = 20;
var $author$project$Dashboards2$emptyUndoRedo = A2(
	$author$project$UndoRedo$init,
	$author$project$Dashboards2$maxHistoryLimit,
	{bz: $author$project$Dashboards2$Editable$initNotReady, g: $author$project$Data$Id$emptyDict});
var $author$project$Platform2$Notification$Queue$Capped = function (a) {
	return {$: 1, a: a};
};
var $author$project$Platform2$Notification$Queue$NotificationQueue = $elm$core$Basics$identity;
var $author$project$Platform2$Notification$Queue$empty_ = function (queueType) {
	return {gj: 0, bn: $turboMaCk$queue$Queue$empty, lL: queueType};
};
var $author$project$Platform2$Notification$Queue$emptyWithLimit = function (limit) {
	return $author$project$Platform2$Notification$Queue$empty_(
		$author$project$Platform2$Notification$Queue$Capped(limit));
};
var $author$project$Dashboards2$List$NameAsc = 3;
var $author$project$Dashboards2$List$NoDropdown = {$: 3};
var $author$project$Dashboards2$List$TodoTemporaryHackPromotedDashboardsATC2752 = 5;
var $author$project$Data$Platform2$dashboardsListTabToComparable = function (tab) {
	switch (tab) {
		case 2:
			return 'public';
		case 1:
			return 'shared by my org';
		default:
			return 'user';
	}
};
var $author$project$Dashboards2$List$All = 0;
var $author$project$Dashboards2$List$MyOrg = 1;
var $author$project$Dashboards2$List$defaultTab = function (viewOnly) {
	return viewOnly ? 1 : 0;
};
var $author$project$Data$User$hasViewOnlyPlan = function (_v0) {
	var planHandle = _v0.qw;
	return (planHandle === 6) || (planHandle === 7);
};
var $author$project$Platform2$SearchInput$initialModel = {cW: ''};
var $author$project$Data$Platform2$insightCategoryToComparable = function (category) {
	return _Utils_Tuple2(
		$author$project$Data$Id$unwrap(category.b),
		category.ld);
};
var $author$project$Data$User$planToString = function (plan) {
	switch (plan) {
		case 0:
			return 'free';
		case 1:
			return 'free_reports';
		case 2:
			return 'dashboards';
		case 3:
			return 'professional';
		case 4:
			return 'api';
		case 5:
			return 'student';
		case 6:
			return 'view_only';
		default:
			return 'open_access_view_only';
	}
};
var $author$project$Dashboards2$List$temporaryOrderingPromotedDashboardsATC2752FreePlans = A2(
	$turboMaCk$any_set$Set$Any$fromList,
	$author$project$Data$User$planToString,
	_List_fromArray(
		[0, 1]));
var $author$project$Dashboards2$List$init = function (flags) {
	var viewOnly = $author$project$Data$User$hasViewOnlyPlan(flags.mQ);
	return {
		d$: A2($turboMaCk$any_set$Set$Any$member, flags.mQ.qw, $author$project$Dashboards2$List$temporaryOrderingPromotedDashboardsATC2752FreePlans) ? 5 : 3,
		aV: $turboMaCk$any_set$Set$Any$empty($author$project$Data$Platform2$insightCategoryToComparable),
		az: $turboMaCk$any_set$Set$Any$empty($author$project$Data$Platform2$dashboardsListTabToComparable),
		aZ: $author$project$Data$Id$emptySet,
		aA: _Utils_Tuple2($author$project$Dashboards2$List$NoDropdown, $elm$core$Maybe$Nothing),
		aR: $author$project$Platform2$SearchInput$initialModel,
		J: $author$project$Data$Id$emptySet,
		a9: $author$project$Dashboards2$List$defaultTab(viewOnly),
		K: viewOnly
	};
};
var $author$project$Platform2$Drawers$Closed = {$: 0};
var $author$project$Platform2$Drawers$init = $author$project$Platform2$Drawers$Closed;
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$UndoRedo$current = function (_v0) {
	var data = _v0;
	return data.aq.b;
};
var $author$project$Dashboards2$Detail$currentEditableUserFilters = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.G;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$UndoRedo$current,
		function ($) {
			return $.bz;
		}));
var $author$project$Dashboards2$Editable$get = function (editable) {
	switch (editable.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			var a = editable.a;
			return $elm$core$Maybe$Just(a);
		default:
			var a = editable.a;
			return $elm$core$Maybe$Just(a);
	}
};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Data$Id$Id = $elm$core$Basics$identity;
var $author$project$Data$Id$fromString = $elm$core$Basics$identity;
var $author$project$Data$Labels$coreNamespaceCode = $author$project$Data$Id$fromString('core');
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $elm_community$list_extra$List$Extra$find = F2(
	function (predicate, list) {
		find:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue find;
				}
			}
		}
	});
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$sortBy = _List_sortBy;
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $krisajenkins$remotedata$RemoteData$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(
					f(value));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				var error = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(error);
		}
	});
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $krisajenkins$remotedata$RemoteData$toMaybe = A2(
	$elm$core$Basics$composeR,
	$krisajenkins$remotedata$RemoteData$map($elm$core$Maybe$Just),
	$krisajenkins$remotedata$RemoteData$withDefault($elm$core$Maybe$Nothing));
var $elm$core$Dict$values = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, valueList) {
				return A2($elm$core$List$cons, value, valueList);
			}),
		_List_Nil,
		dict);
};
var $turboMaCk$any_dict$Dict$Any$toList = function (_v0) {
	var dict = _v0.i;
	return $elm$core$Dict$values(dict);
};
var $turboMaCk$any_dict$Dict$Any$values = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$map($elm$core$Tuple$second),
	$turboMaCk$any_dict$Dict$Any$toList);
var $author$project$Store$Platform2$getMainDataset = function (store) {
	var _v0 = A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			$turboMaCk$any_dict$Dict$Any$values,
			$elm_community$list_extra$List$Extra$find(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.jt;
					},
					$elm$core$Basics$eq($author$project$Data$Labels$coreNamespaceCode)))),
		$krisajenkins$remotedata$RemoteData$toMaybe(store.es));
	if (_v0.$ === 1) {
		return A2(
			$elm$core$Maybe$andThen,
			function (datasets) {
				return $elm$core$List$head(
					A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.gq;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.hz;
								},
								$elm$core$Basics$eq(0)),
							$turboMaCk$any_dict$Dict$Any$values(datasets))));
			},
			$krisajenkins$remotedata$RemoteData$toMaybe(store.es));
	} else {
		var dataset = _v0.a;
		return $elm$core$Maybe$Just(dataset);
	}
};
var $author$project$Data$Platform2$PrivateDashboard = {$: 0};
var $author$project$Data$Platform2$emptyDashboardFiltersAudiencesMetadata = $turboMaCk$any_dict$Dict$Any$empty($author$project$Data$Id$unwrap);
var $ryannhg$date_format$DateFormat$Language$Language = F6(
	function (toMonthName, toMonthAbbreviation, toWeekdayName, toWeekdayAbbreviation, toAmPm, toOrdinalSuffix) {
		return {rU: toAmPm, rZ: toMonthAbbreviation, r_: toMonthName, dR: toOrdinalSuffix, r1: toWeekdayAbbreviation, r2: toWeekdayName};
	});
var $ryannhg$date_format$DateFormat$Language$toEnglishAmPm = function (hour) {
	return (hour > 11) ? 'pm' : 'am';
};
var $ryannhg$date_format$DateFormat$Language$toEnglishMonthName = function (month) {
	switch (month) {
		case 0:
			return 'January';
		case 1:
			return 'February';
		case 2:
			return 'March';
		case 3:
			return 'April';
		case 4:
			return 'May';
		case 5:
			return 'June';
		case 6:
			return 'July';
		case 7:
			return 'August';
		case 8:
			return 'September';
		case 9:
			return 'October';
		case 10:
			return 'November';
		default:
			return 'December';
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishSuffix = function (num) {
	var _v0 = A2($elm$core$Basics$modBy, 100, num);
	switch (_v0) {
		case 11:
			return 'th';
		case 12:
			return 'th';
		case 13:
			return 'th';
		default:
			var _v1 = A2($elm$core$Basics$modBy, 10, num);
			switch (_v1) {
				case 1:
					return 'st';
				case 2:
					return 'nd';
				case 3:
					return 'rd';
				default:
					return 'th';
			}
	}
};
var $ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName = function (weekday) {
	switch (weekday) {
		case 0:
			return 'Monday';
		case 1:
			return 'Tuesday';
		case 2:
			return 'Wednesday';
		case 3:
			return 'Thursday';
		case 4:
			return 'Friday';
		case 5:
			return 'Saturday';
		default:
			return 'Sunday';
	}
};
var $ryannhg$date_format$DateFormat$Language$english = A6(
	$ryannhg$date_format$DateFormat$Language$Language,
	$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishMonthName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
	A2(
		$elm$core$Basics$composeR,
		$ryannhg$date_format$DateFormat$Language$toEnglishWeekdayName,
		$elm$core$String$left(3)),
	$ryannhg$date_format$DateFormat$Language$toEnglishAmPm,
	$ryannhg$date_format$DateFormat$Language$toEnglishSuffix);
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.iS, posixMinutes) < 0) {
					return posixMinutes + era.lm;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $ryannhg$date_format$DateFormat$amPm = F3(
	function (language, zone, posix) {
		return language.rU(
			A2($elm$time$Time$toHour, zone, posix));
	});
var $elm$core$Basics$ge = _Utils_ge;
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		jV: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		la: month,
		m5: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).jV;
	});
var $ryannhg$date_format$DateFormat$dayOfMonth = $elm$time$Time$toDay;
var $elm$time$Time$Sun = 6;
var $elm$time$Time$Fri = 4;
var $elm$time$Time$Mon = 0;
var $elm$time$Time$Sat = 5;
var $elm$time$Time$Thu = 3;
var $elm$time$Time$Tue = 1;
var $elm$time$Time$Wed = 2;
var $ryannhg$date_format$DateFormat$days = _List_fromArray(
	[6, 0, 1, 2, 3, 4, 5]);
var $elm$time$Time$toWeekday = F2(
	function (zone, time) {
		var _v0 = A2(
			$elm$core$Basics$modBy,
			7,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60 * 24));
		switch (_v0) {
			case 0:
				return 3;
			case 1:
				return 4;
			case 2:
				return 5;
			case 3:
				return 6;
			case 4:
				return 0;
			case 5:
				return 1;
			default:
				return 2;
		}
	});
var $ryannhg$date_format$DateFormat$dayOfWeek = F2(
	function (zone, posix) {
		return function (_v1) {
			var i = _v1.a;
			return i;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 6),
				$elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (_v0) {
							var day = _v0.b;
							return _Utils_eq(
								day,
								A2($elm$time$Time$toWeekday, zone, posix));
						},
						A2(
							$elm$core$List$indexedMap,
							F2(
								function (i, day) {
									return _Utils_Tuple2(i, day);
								}),
							$ryannhg$date_format$DateFormat$days)))));
	});
var $ryannhg$date_format$DateFormat$isLeapYear = function (year_) {
	return (!(!A2($elm$core$Basics$modBy, 4, year_))) ? false : ((!(!A2($elm$core$Basics$modBy, 100, year_))) ? true : ((!(!A2($elm$core$Basics$modBy, 400, year_))) ? false : true));
};
var $ryannhg$date_format$DateFormat$daysInMonth = F2(
	function (year_, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $ryannhg$date_format$DateFormat$isLeapYear(year_) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $ryannhg$date_format$DateFormat$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).la;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $ryannhg$date_format$DateFormat$monthPair = F2(
	function (zone, posix) {
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(0, 0),
			$elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (_v0) {
						var i = _v0.a;
						var m = _v0.b;
						return _Utils_eq(
							m,
							A2($elm$time$Time$toMonth, zone, posix));
					},
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (a, b) {
								return _Utils_Tuple2(a, b);
							}),
						$ryannhg$date_format$DateFormat$months))));
	});
var $ryannhg$date_format$DateFormat$monthNumber_ = F2(
	function (zone, posix) {
		return 1 + function (_v0) {
			var i = _v0.a;
			var m = _v0.b;
			return i;
		}(
			A2($ryannhg$date_format$DateFormat$monthPair, zone, posix));
	});
var $elm$core$List$sum = function (numbers) {
	return A3($elm$core$List$foldl, $elm$core$Basics$add, 0, numbers);
};
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).m5;
	});
var $ryannhg$date_format$DateFormat$dayOfYear = F2(
	function (zone, posix) {
		var monthsBeforeThisOne = A2(
			$elm$core$List$take,
			A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) - 1,
			$ryannhg$date_format$DateFormat$months);
		var daysBeforeThisMonth = $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				$ryannhg$date_format$DateFormat$daysInMonth(
					A2($elm$time$Time$toYear, zone, posix)),
				monthsBeforeThisOne));
		return daysBeforeThisMonth + A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix);
	});
var $ryannhg$date_format$DateFormat$quarter = F2(
	function (zone, posix) {
		return (A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix) / 4) | 0;
	});
var $elm$core$String$right = F2(
	function (n, string) {
		return (n < 1) ? '' : A3(
			$elm$core$String$slice,
			-n,
			$elm$core$String$length(string),
			string);
	});
var $ryannhg$date_format$DateFormat$toFixedLength = F2(
	function (totalChars, num) {
		var numStr = $elm$core$String$fromInt(num);
		var numZerosNeeded = totalChars - $elm$core$String$length(numStr);
		var zeros = A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				function (_v0) {
					return '0';
				},
				A2($elm$core$List$range, 1, numZerosNeeded)));
		return _Utils_ap(zeros, numStr);
	});
var $elm$core$String$toLower = _String_toLower;
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $ryannhg$date_format$DateFormat$toNonMilitary = function (num) {
	return (!num) ? 12 : ((num <= 12) ? num : (num - 12));
};
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$core$String$toUpper = _String_toUpper;
var $ryannhg$date_format$DateFormat$millisecondsPerYear = $elm$core$Basics$round((((1000 * 60) * 60) * 24) * 365.25);
var $ryannhg$date_format$DateFormat$firstDayOfYear = F2(
	function (zone, time) {
		return $elm$time$Time$millisToPosix(
			$ryannhg$date_format$DateFormat$millisecondsPerYear * A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$weekOfYear = F2(
	function (zone, posix) {
		var firstDay = A2($ryannhg$date_format$DateFormat$firstDayOfYear, zone, posix);
		var firstDayOffset = A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, firstDay);
		var daysSoFar = A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix);
		return (((daysSoFar + firstDayOffset) / 7) | 0) + 1;
	});
var $ryannhg$date_format$DateFormat$year = F2(
	function (zone, time) {
		return $elm$core$String$fromInt(
			A2($elm$time$Time$toYear, zone, time));
	});
var $ryannhg$date_format$DateFormat$piece = F4(
	function (language, zone, posix, token) {
		switch (token.$) {
			case 0:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 1:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.dR(num));
				}(
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 2:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$monthNumber_, zone, posix));
			case 3:
				return language.rZ(
					A2($elm$time$Time$toMonth, zone, posix));
			case 4:
				return language.r_(
					A2($elm$time$Time$toMonth, zone, posix));
			case 17:
				return $elm$core$String$fromInt(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 18:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.dR(num));
				}(
					1 + A2($ryannhg$date_format$DateFormat$quarter, zone, posix));
			case 5:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 6:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.dR(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 7:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$dayOfMonth, zone, posix));
			case 8:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 9:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.dR(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 10:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($ryannhg$date_format$DateFormat$dayOfYear, zone, posix));
			case 11:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 12:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.dR(num));
				}(
					A2($ryannhg$date_format$DateFormat$dayOfWeek, zone, posix));
			case 13:
				return language.r1(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 14:
				return language.r2(
					A2($elm$time$Time$toWeekday, zone, posix));
			case 19:
				return $elm$core$String$fromInt(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 20:
				return function (num) {
					return _Utils_ap(
						$elm$core$String$fromInt(num),
						language.dR(num));
				}(
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 21:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($ryannhg$date_format$DateFormat$weekOfYear, zone, posix));
			case 15:
				return A2(
					$elm$core$String$right,
					2,
					A2($ryannhg$date_format$DateFormat$year, zone, posix));
			case 16:
				return A2($ryannhg$date_format$DateFormat$year, zone, posix);
			case 22:
				return $elm$core$String$toUpper(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 23:
				return $elm$core$String$toLower(
					A3($ryannhg$date_format$DateFormat$amPm, language, zone, posix));
			case 24:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toHour, zone, posix));
			case 25:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toHour, zone, posix));
			case 26:
				return $elm$core$String$fromInt(
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 27:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					$ryannhg$date_format$DateFormat$toNonMilitary(
						A2($elm$time$Time$toHour, zone, posix)));
			case 28:
				return $elm$core$String$fromInt(
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 29:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					1 + A2($elm$time$Time$toHour, zone, posix));
			case 30:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMinute, zone, posix));
			case 31:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toMinute, zone, posix));
			case 32:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toSecond, zone, posix));
			case 33:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					2,
					A2($elm$time$Time$toSecond, zone, posix));
			case 34:
				return $elm$core$String$fromInt(
					A2($elm$time$Time$toMillis, zone, posix));
			case 35:
				return A2(
					$ryannhg$date_format$DateFormat$toFixedLength,
					3,
					A2($elm$time$Time$toMillis, zone, posix));
			default:
				var string = token.a;
				return string;
		}
	});
var $ryannhg$date_format$DateFormat$formatWithLanguage = F4(
	function (language, tokens, zone, time) {
		return A2(
			$elm$core$String$join,
			'',
			A2(
				$elm$core$List$map,
				A3($ryannhg$date_format$DateFormat$piece, language, zone, time),
				tokens));
	});
var $ryannhg$date_format$DateFormat$format = $ryannhg$date_format$DateFormat$formatWithLanguage($ryannhg$date_format$DateFormat$Language$english);
var $ryannhg$date_format$DateFormat$DayOfMonthNumber = {$: 5};
var $ryannhg$date_format$DateFormat$dayOfMonthNumber = $ryannhg$date_format$DateFormat$DayOfMonthNumber;
var $ryannhg$date_format$DateFormat$HourMilitaryFixed = {$: 25};
var $ryannhg$date_format$DateFormat$hourMilitaryFixed = $ryannhg$date_format$DateFormat$HourMilitaryFixed;
var $ryannhg$date_format$DateFormat$MinuteFixed = {$: 31};
var $ryannhg$date_format$DateFormat$minuteFixed = $ryannhg$date_format$DateFormat$MinuteFixed;
var $ryannhg$date_format$DateFormat$MonthNameAbbreviated = {$: 3};
var $ryannhg$date_format$DateFormat$monthNameAbbreviated = $ryannhg$date_format$DateFormat$MonthNameAbbreviated;
var $ryannhg$date_format$DateFormat$Text = function (a) {
	return {$: 36, a: a};
};
var $ryannhg$date_format$DateFormat$text = $ryannhg$date_format$DateFormat$Text;
var $ryannhg$date_format$DateFormat$YearNumberLastTwo = {$: 15};
var $ryannhg$date_format$DateFormat$yearNumberLastTwo = $ryannhg$date_format$DateFormat$YearNumberLastTwo;
var $author$project$Time$Format$format_D_MMM_YY_hh_mm = _List_fromArray(
	[
		$ryannhg$date_format$DateFormat$dayOfMonthNumber,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$monthNameAbbreviated,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$yearNumberLastTwo,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$hourMilitaryFixed,
		$ryannhg$date_format$DateFormat$text(':'),
		$ryannhg$date_format$DateFormat$minuteFixed
	]);
var $author$project$Data$Platform2$newUnsavedDashboardId = $author$project$Data$Id$fromString('new');
var $author$project$Data$Platform2$newDashboard = F4(
	function (dataset, userId, zone, posix) {
		return {
			ac: _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
			bB: $elm$time$Time$millisToPosix(0),
			cl: {
				hB: $elm$core$Maybe$Nothing,
				C: {d9: $elm$core$Maybe$Nothing, nA: $elm$core$Maybe$Nothing, nB: $author$project$Data$Platform2$emptyDashboardFiltersAudiencesMetadata, aU: $elm$core$Maybe$Nothing, cD: $elm$core$Maybe$Nothing, dX: $elm$core$Maybe$Nothing},
				aP: $elm$core$Maybe$Nothing,
				g: _List_Nil
			},
			es: _List_fromArray(
				[dataset.bW]),
			oN: _List_Nil,
			b: $author$project$Data$Platform2$newUnsavedDashboardId,
			kN: false,
			pC: $elm$time$Time$millisToPosix(0),
			ld: 'New dashboard ' + A3($ryannhg$date_format$DateFormat$format, $author$project$Time$Format$format_D_MMM_YY_hh_mm, zone, posix),
			qr: 0,
			dG: userId,
			ah: $author$project$Data$Platform2$PrivateDashboard,
			bN: $elm$time$Time$millisToPosix(0),
			i1: 0
		};
	});
var $author$project$Dashboards2$getNewEmptyDashboard = F3(
	function (flags, store, _v0) {
		var zone = _v0.a;
		var time = _v0.b;
		var _v1 = _Utils_Tuple2(
			$author$project$Store$Platform2$getMainDataset(store),
			store.v);
		if ((!_v1.a.$) && (_v1.b.$ === 3)) {
			var dataset = _v1.a.a;
			return $krisajenkins$remotedata$RemoteData$Success(
				A4($author$project$Data$Platform2$newDashboard, dataset, flags.mQ.b, zone, time));
		} else {
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Dashboards2$Detail$getUserFilters = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.G;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$UndoRedo$current,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.bz;
			},
			$author$project$Dashboards2$Editable$get)));
var $author$project$Dashboards2$getUserFilters = $author$project$Dashboards2$Detail$getUserFilters;
var $turboMaCk$glue$Glue$Internal$Glue = $elm$core$Basics$identity;
var $turboMaCk$glue$Glue$id = {oS: $elm$core$Basics$identity, a: $elm$core$Basics$identity, rg: $elm$core$Basics$always};
var $author$project$Dashboards2$Editable$NotEdited = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Editable$initReady = $author$project$Dashboards2$Editable$NotEdited;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $author$project$Gwi$List$fastConcatMap = function (f) {
	return A2(
		$elm$core$List$foldr,
		A2($elm$core$Basics$composeR, f, $elm$core$Basics$append),
		_List_Nil);
};
var $elm$core$Dict$filter = F2(
	function (isGood, dict) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, d) {
					return A2(isGood, k, v) ? A3($elm$core$Dict$insert, k, v, d) : d;
				}),
			$elm$core$Dict$empty,
			dict);
	});
var $turboMaCk$any_dict$Dict$Any$filter = F2(
	function (f, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				i: A2(
					$elm$core$Dict$filter,
					F2(
						function (_v1, _v2) {
							var k = _v2.a;
							var v = _v2.b;
							return A2(f, k, v);
						}),
					inner.i)
			});
	});
var $turboMaCk$any_dict$Dict$Any$get = F2(
	function (k, _v0) {
		var dict = _v0.i;
		var toKey = _v0.aT;
		return A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$Dict$get,
				toKey(k),
				dict));
	});
var $author$project$Store$Platform2$getLocationsByDashboardId = function (dashboardId) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.pJ;
		},
		A2(
			$elm$core$Basics$composeR,
			$turboMaCk$any_dict$Dict$Any$get(dashboardId),
			$elm$core$Maybe$withDefault($krisajenkins$remotedata$RemoteData$NotAsked)));
};
var $author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId = F2(
	function (store, dashboard) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$turboMaCk$any_dict$Dict$Any$filter(
				$elm$core$Basics$always(
					function ($) {
						return $.fc;
					})),
			A2($author$project$Store$Platform2$getLocationsByDashboardId, dashboard.b, store));
	});
var $author$project$Store$Utils$getByIds = F2(
	function (state, ids) {
		if (state.$ === 3) {
			var dict = state.a;
			return A2(
				$elm$core$List$filterMap,
				function (id) {
					return A2($turboMaCk$any_dict$Dict$Any$get, id, dict);
				},
				ids);
		} else {
			return _List_Nil;
		}
	});
var $author$project$Data$Labels$splitQuestionCode = function (namespaceAndQuestionCode) {
	var unwrapped = $author$project$Data$Id$unwrap(namespaceAndQuestionCode);
	var _v0 = A2($elm$core$String$split, '.', unwrapped);
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var namespaceCode = _v0.a;
		var _v1 = _v0.b;
		var shortQuestionCode = _v1.a;
		return _Utils_Tuple2(
			$author$project$Data$Id$fromString(namespaceCode),
			$author$project$Data$Id$fromString(shortQuestionCode));
	} else {
		return _Utils_Tuple2(
			$author$project$Data$Id$fromString('core'),
			$author$project$Data$Id$fromString(unwrapped));
	}
};
var $author$project$Data$Labels$questionCodeToNamespaceCode = A2($elm$core$Basics$composeR, $author$project$Data$Labels$splitQuestionCode, $elm$core$Tuple$first);
var $author$project$Data$Id$setFromList = $turboMaCk$any_set$Set$Any$fromList($author$project$Data$Id$unwrap);
var $turboMaCk$non_empty_list_alias$List$NonEmpty$toList = function (_v0) {
	var h = _v0.a;
	var t = _v0.b;
	return A2($elm$core$List$cons, h, t);
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$map = F2(
	function (f, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return _Utils_Tuple2(
			f(h),
			A2($elm$core$List$map, f, t));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton = function (h) {
	return _Utils_Tuple2(h, _List_Nil);
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList = function (xs) {
	if (xs.b) {
		var h = xs.a;
		var t = xs.b;
		return $elm$core$Maybe$Just(
			_Utils_Tuple2(h, t));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$uniqueHelper = function (list) {
	var uniqueHelp = F4(
		function (f, existing, remaining, accumulator) {
			uniqueHelp:
			while (true) {
				if (!remaining.b) {
					return $elm$core$List$reverse(accumulator);
				} else {
					var first = remaining.a;
					var rest = remaining.b;
					var computedFirst = f(first);
					if (A2($elm$core$List$member, computedFirst, existing)) {
						var $temp$f = f,
							$temp$existing = existing,
							$temp$remaining = rest,
							$temp$accumulator = accumulator;
						f = $temp$f;
						existing = $temp$existing;
						remaining = $temp$remaining;
						accumulator = $temp$accumulator;
						continue uniqueHelp;
					} else {
						var $temp$f = f,
							$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
							$temp$remaining = rest,
							$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
						f = $temp$f;
						existing = $temp$existing;
						remaining = $temp$remaining;
						accumulator = $temp$accumulator;
						continue uniqueHelp;
					}
				}
			}
		});
	return A4(uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$unique = function (xs) {
	return A2(
		$elm$core$Maybe$withDefault,
		xs,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$uniqueHelper(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(xs))));
};
var $author$project$Data$Platform2$widgetDataQuestionCodes = function (data) {
	if (!data.$) {
		var questionCode = data.a.at;
		return $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(questionCode);
	} else {
		var groups = data.a;
		return $turboMaCk$non_empty_list_alias$List$NonEmpty$unique(
			A2(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
				function ($) {
					return $.at;
				},
				groups));
	}
};
var $author$project$Data$Platform2$dashboardNamespaceCodes = F2(
	function (datasets, dashboard) {
		var questionNamespaces = A2(
			$author$project$Gwi$List$fastConcatMap,
			function (chartWidget) {
				return A2(
					$elm$core$List$map,
					$author$project$Data$Labels$questionCodeToNamespaceCode,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
						$author$project$Data$Platform2$widgetDataQuestionCodes(chartWidget.cl)));
			},
			A2($elm$core$List$filterMap, $author$project$Data$Platform2$getChartWidget, dashboard.cl.g));
		var datasetNamespaces = A2(
			$elm$core$List$map,
			function ($) {
				return $.jt;
			},
			A2($author$project$Store$Utils$getByIds, datasets, dashboard.es));
		return $author$project$Data$Id$setFromList(
			_Utils_ap(questionNamespaces, datasetNamespaces));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$foldr = F2(
	function (f, acc) {
		return A2(
			$elm$core$Basics$composeL,
			A2($elm$core$List$foldr, f, acc),
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList);
	});
var $turboMaCk$any_dict$Dict$Any$union = F2(
	function (_v0, _v1) {
		var inner = _v0;
		var dict = _v1.i;
		return _Utils_update(
			inner,
			{
				i: A2($elm$core$Dict$union, inner.i, dict)
			});
	});
var $author$project$Store$Platform2$getByNamespacesIgnoreErrors = F3(
	function (getter, maybeNamespaceCodes, store) {
		return A3(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$foldr,
			F2(
				function (namespaceCode, soFar) {
					var _v0 = _Utils_Tuple2(
						soFar,
						A2(getter, namespaceCode, store));
					_v0$1:
					while (true) {
						_v0$4:
						while (true) {
							switch (_v0.b.$) {
								case 1:
									if (_v0.a.$ === 1) {
										break _v0$1;
									} else {
										var _v3 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$Loading;
									}
								case 3:
									switch (_v0.a.$) {
										case 0:
											var _v1 = _v0.a;
											var itemsForNamespace = _v0.b.a;
											return $krisajenkins$remotedata$RemoteData$Success(itemsForNamespace);
										case 1:
											break _v0$1;
										case 3:
											var items1 = _v0.a.a;
											var items2 = _v0.b.a;
											return $krisajenkins$remotedata$RemoteData$Success(
												A2($turboMaCk$any_dict$Dict$Any$union, items1, items2));
										default:
											break _v0$4;
									}
								default:
									if (_v0.a.$ === 1) {
										break _v0$1;
									} else {
										break _v0$4;
									}
							}
						}
						return soFar;
					}
					var _v2 = _v0.a;
					return soFar;
				}),
			$krisajenkins$remotedata$RemoteData$NotAsked,
			maybeNamespaceCodes);
	});
var $author$project$Store$Platform2$getByNamespacesWithErrors = F3(
	function (getter, maybeNamespaceCodes, store) {
		return A3(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$foldr,
			F2(
				function (namespaceCode, soFar) {
					var _v0 = _Utils_Tuple2(
						soFar,
						A2(getter, namespaceCode, store));
					_v0$1:
					while (true) {
						_v0$5:
						while (true) {
							switch (_v0.b.$) {
								case 1:
									if (_v0.a.$ === 1) {
										break _v0$1;
									} else {
										var _v3 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$Loading;
									}
								case 3:
									switch (_v0.a.$) {
										case 0:
											var _v1 = _v0.a;
											var itemsForNamespace = _v0.b.a;
											return $krisajenkins$remotedata$RemoteData$Success(itemsForNamespace);
										case 1:
											break _v0$1;
										case 3:
											var items1 = _v0.a.a;
											var items2 = _v0.b.a;
											return $krisajenkins$remotedata$RemoteData$Success(
												A2($turboMaCk$any_dict$Dict$Any$union, items1, items2));
										default:
											break _v0$5;
									}
								case 2:
									if (_v0.a.$ === 1) {
										break _v0$1;
									} else {
										var err = _v0.b.a;
										return $krisajenkins$remotedata$RemoteData$Failure(err);
									}
								default:
									if (_v0.a.$ === 1) {
										break _v0$1;
									} else {
										break _v0$5;
									}
							}
						}
						return soFar;
					}
					var _v2 = _v0.a;
					return soFar;
				}),
			$krisajenkins$remotedata$RemoteData$NotAsked,
			maybeNamespaceCodes);
	});
var $author$project$Store$Platform2$getLocations = function (namespaceCode) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.pK;
		},
		A2(
			$elm$core$Basics$composeR,
			$turboMaCk$any_dict$Dict$Any$get(namespaceCode),
			$elm$core$Maybe$withDefault($krisajenkins$remotedata$RemoteData$NotAsked)));
};
var $author$project$Store$Platform2$getLocationsForNamespaces = F2(
	function (maybeNamespaceCodes, store) {
		var _v0 = A3($author$project$Store$Platform2$getByNamespacesIgnoreErrors, $author$project$Store$Platform2$getLocations, maybeNamespaceCodes, store);
		if (!_v0.$) {
			return A3($author$project$Store$Platform2$getByNamespacesWithErrors, $author$project$Store$Platform2$getLocations, maybeNamespaceCodes, store);
		} else {
			var withoutErrors = _v0;
			return withoutErrors;
		}
	});
var $turboMaCk$any_dict$Dict$Any$keys = A2(
	$elm$core$Basics$composeL,
	$elm$core$List$map($elm$core$Tuple$first),
	$turboMaCk$any_dict$Dict$Any$toList);
var $turboMaCk$any_set$Set$Any$toList = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$keys(dict);
};
var $author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces = F2(
	function (store, dashboard) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict),
			function (namespaceCodes_) {
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$turboMaCk$any_dict$Dict$Any$filter(
						$elm$core$Basics$always(
							function ($) {
								return $.fc;
							})),
					A2($author$project$Store$Platform2$getLocationsForNamespaces, namespaceCodes_, store));
			},
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
				$turboMaCk$any_set$Set$Any$toList(
					A2($author$project$Data$Platform2$dashboardNamespaceCodes, store.es, dashboard))));
	});
var $author$project$Store$Platform2$getWavesByDashboardId = function (dashboardId) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.sd;
		},
		A2(
			$elm$core$Basics$composeR,
			$turboMaCk$any_dict$Dict$Any$get(dashboardId),
			$elm$core$Maybe$withDefault($krisajenkins$remotedata$RemoteData$NotAsked)));
};
var $author$project$Dashboards2$Detail$getWavesForDashboardByDashboardId = F2(
	function (store, dashboard) {
		return A2($author$project$Store$Platform2$getWavesByDashboardId, dashboard.b, store);
	});
var $author$project$Store$Platform2$getWaves = function (namespaceCode) {
	return A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.se;
		},
		A2(
			$elm$core$Basics$composeR,
			$turboMaCk$any_dict$Dict$Any$get(namespaceCode),
			$elm$core$Maybe$withDefault($krisajenkins$remotedata$RemoteData$NotAsked)));
};
var $author$project$Store$Platform2$getWavesForNamespaces = F2(
	function (maybeNamespaceCodes, store) {
		var _v0 = A3($author$project$Store$Platform2$getByNamespacesIgnoreErrors, $author$project$Store$Platform2$getWaves, maybeNamespaceCodes, store);
		if (!_v0.$) {
			return A3($author$project$Store$Platform2$getByNamespacesWithErrors, $author$project$Store$Platform2$getWaves, maybeNamespaceCodes, store);
		} else {
			var withoutErrors = _v0;
			return withoutErrors;
		}
	});
var $author$project$Dashboards2$Detail$getWavesForDashboardByNamespaces = F2(
	function (store, dashboard) {
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict),
			function (namespaceCodes_) {
				return A2($author$project$Store$Platform2$getWavesForNamespaces, namespaceCodes_, store);
			},
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
				$turboMaCk$any_set$Set$Any$toList(
					A2($author$project$Data$Platform2$dashboardNamespaceCodes, store.es, dashboard))));
	});
var $author$project$Dashboards2$UserFilters$Base = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$UserFilters$Default = function (a) {
	return {$: 0, a: a};
};
var $author$project$Palette$DefaultColor = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$UserFilters$UserFilters = $elm$core$Basics$identity;
var $author$project$Palette$basicColor = function (filtersColor) {
	if (!filtersColor.$) {
		var color = filtersColor.a;
		return color;
	} else {
		var color = filtersColor.b;
		return color;
	}
};
var $author$project$Palette$Color1 = 2;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $elm$core$Array$bitMask = 4294967295 >>> (32 - $elm$core$Array$shiftStep);
var $elm$core$Elm$JsArray$unsafeGet = _JsArray_unsafeGet;
var $elm$core$Array$getHelp = F3(
	function (shift, index, tree) {
		getHelp:
		while (true) {
			var pos = $elm$core$Array$bitMask & (index >>> shift);
			var _v0 = A2($elm$core$Elm$JsArray$unsafeGet, pos, tree);
			if (!_v0.$) {
				var subTree = _v0.a;
				var $temp$shift = shift - $elm$core$Array$shiftStep,
					$temp$index = index,
					$temp$tree = subTree;
				shift = $temp$shift;
				index = $temp$index;
				tree = $temp$tree;
				continue getHelp;
			} else {
				var values = _v0.a;
				return A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, values);
			}
		}
	});
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Array$tailIndex = function (len) {
	return (len >>> 5) << 5;
};
var $elm$core$Array$get = F2(
	function (index, _v0) {
		var len = _v0.a;
		var startShift = _v0.b;
		var tree = _v0.c;
		var tail = _v0.d;
		return ((index < 0) || (_Utils_cmp(index, len) > -1)) ? $elm$core$Maybe$Nothing : ((_Utils_cmp(
			index,
			$elm$core$Array$tailIndex(len)) > -1) ? $elm$core$Maybe$Just(
			A2($elm$core$Elm$JsArray$unsafeGet, $elm$core$Array$bitMask & index, tail)) : $elm$core$Maybe$Just(
			A3($elm$core$Array$getHelp, startShift, index, tree)));
	});
var $elm_community$maybe_extra$Maybe$Extra$orElseLazy = F2(
	function (fma, mb) {
		if (mb.$ === 1) {
			return fma(0);
		} else {
			return mb;
		}
	});
var $author$project$Palette$Color2 = 3;
var $author$project$Palette$Color3 = 4;
var $author$project$Palette$Color4 = 5;
var $author$project$Palette$Color5 = 6;
var $author$project$Palette$Color6 = 7;
var $author$project$Palette$Color7 = 8;
var $elm$core$Array$fromListHelp = F3(
	function (list, nodeList, nodeListSize) {
		fromListHelp:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, list);
			var jsArray = _v0.a;
			var remainingItems = _v0.b;
			if (_Utils_cmp(
				$elm$core$Elm$JsArray$length(jsArray),
				$elm$core$Array$branchFactor) < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					true,
					{_: nodeList, Q: nodeListSize, X: jsArray});
			} else {
				var $temp$list = remainingItems,
					$temp$nodeList = A2(
					$elm$core$List$cons,
					$elm$core$Array$Leaf(jsArray),
					nodeList),
					$temp$nodeListSize = nodeListSize + 1;
				list = $temp$list;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue fromListHelp;
			}
		}
	});
var $elm$core$Array$fromList = function (list) {
	if (!list.b) {
		return $elm$core$Array$empty;
	} else {
		return A3($elm$core$Array$fromListHelp, list, _List_Nil, 0);
	}
};
var $author$project$Palette$p2Audiences = $elm$core$Array$fromList(
	_List_fromArray(
		[
			$author$project$Palette$DefaultColor(2),
			$author$project$Palette$DefaultColor(3),
			$author$project$Palette$DefaultColor(4),
			$author$project$Palette$DefaultColor(5),
			$author$project$Palette$DefaultColor(6),
			$author$project$Palette$DefaultColor(7),
			$author$project$Palette$DefaultColor(8)
		]));
var $author$project$Palette$p2AudienceGetFirstNotUsedColor = function (usedColors) {
	var notUsedColor = A3(
		$elm$core$Array$foldr,
		F2(
			function (color, acc) {
				return A2(
					$elm$core$List$member,
					$author$project$Palette$basicColor(color),
					usedColors) ? acc : $elm$core$Maybe$Just(color);
			}),
		$elm$core$Maybe$Nothing,
		$author$project$Palette$p2Audiences);
	if (!notUsedColor.$) {
		var color = notUsedColor.a;
		return color;
	} else {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Palette$DefaultColor(2),
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElseLazy,
				function (_v1) {
					return A2($elm$core$Array$get, 0, $author$project$Palette$p2Audiences);
				},
				A2(
					$elm$core$Maybe$map,
					$author$project$Palette$DefaultColor,
					$elm$core$List$head(usedColors))));
	}
};
var $author$project$Dashboards2$UserFilters$audiencesToColored = F3(
	function (audiencesSoFar, getColor, audiencesList) {
		var colorsSoFar = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.jL;
				},
				$author$project$Palette$basicColor),
			audiencesSoFar);
		return A3(
			$elm$core$List$foldl,
			F2(
				function (audience, _v0) {
					var audiences_ = _v0.a;
					var colorsSoFar_ = _v0.b;
					var color = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Palette$p2AudienceGetFirstNotUsedColor(colorsSoFar_),
						getColor(audience));
					return _Utils_Tuple2(
						_Utils_ap(
							audiences_,
							_List_fromArray(
								[
									{fk: audience, jL: color}
								])),
						A2(
							$elm$core$List$cons,
							$author$project$Palette$basicColor(color),
							colorsSoFar_));
				}),
			_Utils_Tuple2(_List_Nil, colorsSoFar),
			audiencesList).a;
	});
var $author$project$Data$Calc$Platform2$AudienceParam = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$UserFilters$CommonAudience = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$UserFilters$DefaultBaseAudience = {$: 0};
var $author$project$Data$Calc$Platform2$DefaultBaseAudience = {$: 0};
var $author$project$Dashboards2$UserFilters$UserChosenBaseAudience = function (a) {
	return {$: 1, a: a};
};
var $krisajenkins$remotedata$RemoteData$isNotAsked = function (data) {
	if (!data.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Dashboards2$UserFilters$locations = function (_v0) {
	var r = _v0;
	var _v1 = r.cD;
	if (!_v1.$) {
		var locations_ = _v1.a;
		return locations_;
	} else {
		var locations_ = _v1.a;
		return locations_;
	}
};
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $author$project$Gwi$List$appendMaybe = A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, $elm$core$Basics$append);
var $author$project$Data$Calc$Platform2$EmptyAvAAudienceExpression = {$: 1};
var $author$project$Data$Calc$Platform2$InvalidAvAQuery = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Calc$Platform2$UniverseZero = {$: 2};
var $author$project$Data$Core$Error$typeDecoder = A2($elm$json$Json$Decode$field, 'error_type', $elm$json$Json$Decode$string);
var $author$project$Data$Calc$Platform2$avaQueryErrorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorType) {
		switch (errorType) {
			case 'invalid_query':
				return A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Calc$Platform2$InvalidAvAQuery,
					A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string));
			case 'empty_audience_expression':
				return $elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$EmptyAvAAudienceExpression);
			case 'universe_zero':
				return $elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$UniverseZero);
			default:
				return $elm$json$Json$Decode$fail('Failed to determine XBQueryError from error_type: ' + errorType);
		}
	},
	$author$project$Data$Core$Error$typeDecoder);
var $author$project$Data$Audience$Expression$V2 = 1;
var $author$project$Data$Audience$Expression$Exclude = 1;
var $elm$json$Json$Encode$bool = _Json_wrap;
var $author$project$Data$Id$encode = function (_v0) {
	var string = _v0;
	return $elm$json$Json$Encode$string(string);
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Encode$list(f),
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList);
};
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Data$Audience$Expression$encode = F2(
	function (targetApi, expr) {
		switch (expr.$) {
			case 0:
				return $elm$json$Json$Encode$null;
			case 2:
				var data = expr.a;
				var datapointsField = function () {
					if (!targetApi) {
						return 'options';
					} else {
						return 'datapoints';
					}
				}();
				return $elm$json$Json$Encode$object(
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								$elm$core$Maybe$Just(
								_Utils_Tuple2(
									'question',
									$author$project$Data$Id$encode(data.at))),
								$elm$core$Maybe$Just(
								_Utils_Tuple2(
									datapointsField,
									A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, data.hw))),
								$elm$core$Maybe$Just(
								_Utils_Tuple2(
									'min_count',
									$elm$json$Json$Encode$int(data.k6))),
								$elm$core$Maybe$Just(
								_Utils_Tuple2(
									'not',
									$elm$json$Json$Encode$bool(data.kz === 1))),
								$elm$core$List$isEmpty(data.eY) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								_Utils_Tuple2(
									'suffixes',
									A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, data.eY)))
							])));
			default:
				var logic = expr.a;
				var nested = expr.b;
				var key = function () {
					if (!logic) {
						return 'and';
					} else {
						return 'or';
					}
				}();
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							key,
							A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList,
								$author$project$Data$Audience$Expression$encode(targetApi),
								nested))
						]));
		}
	});
var $author$project$Data$Audience$Expression$encodeV2 = $author$project$Data$Audience$Expression$encode(1);
var $author$project$Data$Calc$Platform2$encodeAudienceContent = function (_v0) {
	var id = _v0.b;
	var expression = _v0.bY;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(
					$author$project$Data$Id$unwrap(id))),
				_Utils_Tuple2(
				'expression',
				$author$project$Data$Audience$Expression$encodeV2(expression))
			]));
};
var $author$project$Data$Calc$Platform2$baseAudienceParam = function (maybeBase) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function (base) {
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'base_audience',
						$author$project$Data$Calc$Platform2$encodeAudienceContent(base))
					]);
			},
			maybeBase));
};
var $author$project$Data$Calc$Platform2$encodeAudienceParam = function (params_) {
	if (!params_.$) {
		return $elm$json$Json$Encode$object(_List_Nil);
	} else {
		var param = params_.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'row',
					$author$project$Data$Calc$Platform2$encodeAudienceContent(param))
				]));
	}
};
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $author$project$Gwi$Http$BadBody = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Gwi$Http$BadStatus = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Gwi$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $author$project$Gwi$Http$NetworkError = {$: 2};
var $author$project$Gwi$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $author$project$Gwi$Http$CustomError = F3(
	function (a, b, c) {
		return {$: 6, a: a, b: b, c: c};
	});
var $author$project$Gwi$Http$GenericError = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$Data$Core$Error$BadRequest = {$: 0};
var $author$project$Data$Core$Error$ForbiddenError = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Core$Error$GatewayProxyError = {$: 10};
var $author$project$Data$Core$Error$GatewayTimeout = {$: 11};
var $author$project$Data$Core$Error$InconsistentToken = {$: 6};
var $author$project$Data$Core$Error$InternalServerError = {$: 2};
var $author$project$Data$Core$Error$InvalidToken = {$: 5};
var $author$project$Data$Core$Error$JsonDecodeError = {$: 8};
var $author$project$Data$Core$Error$JsonEncodeError = {$: 7};
var $author$project$Data$Core$Error$NotFound = {$: 9};
var $author$project$Data$Core$Error$Unauthorized = {$: 4};
var $author$project$Data$Core$Error$UnknownError = function (a) {
	return {$: 12, a: a};
};
var $author$project$Data$Core$Error$ValidationError = {$: 1};
var $author$project$Data$Core$Error$ForbiddenErrorMetadata = F3(
	function (questions, locations, waves) {
		return {cD: locations, bt: questions, dX: waves};
	});
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$decodeListHelper = function (xs) {
	var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(xs);
	if (!_v0.$) {
		var res = _v0.a;
		return $elm$json$Json$Decode$succeed(res);
	} else {
		return $elm$json$Json$Decode$fail('Expecting at least ONE ELEMENT array');
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeListHelper,
		$elm$json$Json$Decode$list(decoder));
};
var $author$project$Data$Core$Error$forbiddenMetadataErrorDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['meta', 'forbidden_codes']),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalField,
			'waves',
			$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($elm$json$Json$Decode$string)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm_community$json_extra$Json$Decode$Extra$optionalField,
				'locations',
				$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($elm$json$Json$Decode$string)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm_community$json_extra$Json$Decode$Extra$optionalField,
					'questions',
					$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList(
						A2($elm$json$Json$Decode$field, 'code', $elm$json$Json$Decode$string))),
				$elm$json$Json$Decode$succeed($author$project$Data$Core$Error$ForbiddenErrorMetadata)))));
var $author$project$Data$Core$Error$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorType) {
		switch (errorType) {
			case 'bad_request':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$BadRequest);
			case 'validation_error':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$ValidationError);
			case 'internal_server_error':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$InternalServerError);
			case 'unauthorized':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$Unauthorized);
			case 'invalid_token':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$InvalidToken);
			case 'forbidden':
				return A2($elm$json$Json$Decode$map, $author$project$Data$Core$Error$ForbiddenError, $author$project$Data$Core$Error$forbiddenMetadataErrorDecoder);
			case 'json_encode_error':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$JsonEncodeError);
			case 'json_decode_error':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$JsonDecodeError);
			case 'not_found':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$NotFound);
			case 'proxy_error':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$GatewayProxyError);
			case 'timeout':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$GatewayTimeout);
			case 'inconsistent_token':
				return $elm$json$Json$Decode$succeed($author$project$Data$Core$Error$InconsistentToken);
			default:
				return $elm$json$Json$Decode$succeed(
					$author$project$Data$Core$Error$UnknownError(errorType));
		}
	},
	$author$project$Data$Core$Error$typeDecoder);
var $author$project$Gwi$Http$errorDecoder = F3(
	function (headers, body, customErrorDecoder) {
		var uuid = A2(
			$elm$core$Maybe$withDefault,
			'missing',
			A2($elm$core$Dict$get, 'x-gateway-uuid', headers));
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$map,
					A2($author$project$Gwi$Http$CustomError, uuid, body),
					customErrorDecoder),
					A2(
					$elm$json$Json$Decode$map,
					A2($author$project$Gwi$Http$GenericError, uuid, body),
					$author$project$Data$Core$Error$decoder)
				]));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $author$project$Gwi$Http$resolveResponse = F3(
	function (customErrorDecoder, successBodyDecoder, response) {
		switch (response.$) {
			case 0:
				var e = response.a;
				return $elm$core$Result$Err(
					$author$project$Gwi$Http$BadUrl(e));
			case 1:
				return $elm$core$Result$Err($author$project$Gwi$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Gwi$Http$NetworkError);
			case 3:
				var metadata = response.a;
				var body = response.b;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeString,
					A3($author$project$Gwi$Http$errorDecoder, metadata.hU, body, customErrorDecoder),
					body);
				if (!_v1.$) {
					var err = _v1.a;
					return $elm$core$Result$Err(err);
				} else {
					return $elm$core$Result$Err(
						A2($author$project$Gwi$Http$BadStatus, metadata, body));
				}
			default:
				var metadata = response.a;
				var body = response.b;
				var sanitizedBody = $elm$core$String$isEmpty(body) ? 'null' : body;
				return A2(
					$elm$core$Result$mapError,
					$author$project$Gwi$Http$BadBody(metadata),
					A2($elm$json$Json$Decode$decodeString, successBodyDecoder, sanitizedBody));
		}
	});
var $author$project$Gwi$Http$expectErrorAwareJson = F2(
	function (customErrorDecoder, successBodyDecoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			$elm$core$Basics$identity,
			A2($author$project$Gwi$Http$resolveResponse, customErrorDecoder, successBodyDecoder));
	});
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $author$project$Data$Auth$header = function (token) {
	return A2($elm$http$Http$header, 'Authorization', 'Bearer ' + token);
};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$crossOrigin = F3(
	function (prePath, pathSegments, parameters) {
		return prePath + ('/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters)));
	});
var $elm$url$Url$Builder$QueryParameter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $elm$url$Url$Builder$string = F2(
	function (key, value) {
		return A2(
			$elm$url$Url$Builder$QueryParameter,
			$elm$url$Url$percentEncode(key),
			$elm$url$Url$percentEncode(value));
	});
var $author$project$Config$Main$signOutUrl = F2(
	function (host, _v0) {
		var redirectTo = _v0.qH;
		return A3(
			$elm$url$Url$Builder$crossOrigin,
			host,
			_List_fromArray(
				['sign-out']),
			_List_fromArray(
				[
					A2($elm$url$Url$Builder$string, 'return_to', redirectTo)
				]));
	});
var $author$project$Config$Main$testingUris = {
	d3: 'https://api-testing.globalwebindex.com/v1/analytics',
	d5: 'https://api-testing.globalwebindex.com',
	d6: 'https://legacy-testing.globalwebindex.com',
	d7: 'https://api-testing.globalwebindex.com/v2/attributes',
	d9: 'https://api-testing.globalwebindex.com/v1/audience-builder',
	ea: 'https://api-testing.globalwebindex.com/v2/audiences',
	ei: 'https://api-testing.globalwebindex.com/v1/collections',
	es: 'https://api-testing.globalwebindex.com/v1/datasets',
	eS: 'https://api-testing.globalwebindex.com/platform',
	eW: $author$project$Config$Main$signOutUrl('https://signin-testing.globalwebindex.com')
};
var $author$project$Config$Main$development = {dc: 'auth_gwi_development', dV: $author$project$Config$Main$testingUris};
var $author$project$Config$Main$productionUris = {
	d3: 'https://api.globalwebindex.com/v1/analytics',
	d5: 'https://api.globalwebindex.com',
	d6: 'https://legacy.globalwebindex.com',
	d7: 'https://api.globalwebindex.com/v2/attributes',
	d9: 'https://api.globalwebindex.com/v1/audience-builder',
	ea: 'https://api.globalwebindex.com/v2/audiences',
	ei: 'https://api.globalwebindex.com/v1/collections',
	es: 'https://api.globalwebindex.com/v1/datasets',
	eS: 'https://api.globalwebindex.com/platform',
	eW: $author$project$Config$Main$signOutUrl('https://signin.globalwebindex.com')
};
var $author$project$Config$Main$production = {dc: 'auth_gwi_production', dV: $author$project$Config$Main$productionUris};
var $author$project$Config$Main$stagingUris = {
	d3: 'https://api-staging.globalwebindex.com/v1/analytics',
	d5: 'https://api-staging.globalwebindex.com',
	d6: 'https://legacy-staging.globalwebindex.com',
	d7: 'https://api-staging.globalwebindex.com/v2/attributes',
	d9: 'https://api-staging.globalwebindex.com/v1/audience-builder',
	ea: 'https://api-staging.globalwebindex.com/v2/audiences',
	ei: 'https://api-staging.globalwebindex.com/v1/collections',
	es: 'https://api-staging.globalwebindex.com/v1/datasets',
	eS: 'https://api-staging.globalwebindex.com/platform',
	eW: $author$project$Config$Main$signOutUrl('https://signin-staging.globalwebindex.com')
};
var $author$project$Config$Main$staging = {dc: 'auth_gwi_staging', dV: $author$project$Config$Main$stagingUris};
var $author$project$Config$Main$testing = {dc: 'auth_gwi_testing', dV: $author$project$Config$Main$testingUris};
var $author$project$Config$Main$testsuite = {
	dc: '',
	dV: {
		d3: '',
		d5: '',
		d6: '',
		d7: '',
		d9: '',
		ea: '',
		ei: '',
		es: '',
		eS: '',
		eW: $elm$core$Basics$always('')
	}
};
var $author$project$Config$Main$get = function (stage) {
	switch (stage) {
		case 0:
			return $author$project$Config$Main$development;
		case 1:
			return $author$project$Config$Main$testsuite;
		case 2:
			return $author$project$Config$Main$testing;
		case 3:
			return $author$project$Config$Main$staging;
		default:
			return $author$project$Config$Main$production;
	}
};
var $author$project$Data$Calc$Platform2$host = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.j8;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Config$Main$get,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dV;
			},
			function ($) {
				return $.d5;
			})));
var $author$project$Data$Calc$Platform2$intersectResultDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['intersect', 'sample']),
	$elm$json$Json$Decode$int);
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {lO: reqs, mp: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.i0;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.lO));
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.mp)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					nq: r.nq,
					jv: r.jv,
					hK: A2(_Http_mapExpect, func, r.hK),
					hU: r.hU,
					h8: r.h8,
					iY: r.iY,
					i0: r.i0,
					c3: r.c3
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{nq: false, jv: r.jv, hK: r.hK, hU: r.hU, h8: r.h8, iY: r.iY, i0: r.i0, c3: r.c3}));
};
var $author$project$Data$GettableKeyValueHeader$toHttpHeader = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return A2($elm$http$Http$header, key, value);
};
var $author$project$Data$GettableKeyValueHeader$toHttpHeaderList = $elm$core$List$map($author$project$Data$GettableKeyValueHeader$toHttpHeader);
var $author$project$Data$Calc$Platform2$sampleSizeRequest = F5(
	function (flags, baseAudience, locations, waveCodes, param) {
		var token = flags.i$;
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						A2(
							$elm$core$List$append,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'audiences',
									$author$project$Data$Calc$Platform2$encodeAudienceParam(param)),
									_Utils_Tuple2(
									'locations',
									A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, locations)),
									_Utils_Tuple2(
									'waves',
									A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, waveCodes))
								]),
							$author$project$Data$Calc$Platform2$baseAudienceParam(baseAudience)))),
				hK: A2(
					$author$project$Gwi$Http$expectErrorAwareJson,
					$author$project$Data$Calc$Platform2$avaQueryErrorDecoder,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Calc$Platform2$intersectResultDecoder)),
				hU: A2(
					$author$project$Gwi$List$appendMaybe,
					A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
					_List_fromArray(
						[
							$author$project$Data$Auth$header(token)
						])),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Calc$Platform2$host(flags) + '/v2/query/intersection'
			});
	});
var $author$project$Dashboards2$UserFilters$waves = function (_v0) {
	var r = _v0;
	var _v1 = r.dX;
	if (!_v1.$) {
		var waves_ = _v1.a;
		return waves_;
	} else {
		var waves_ = _v1.a;
		return waves_;
	}
};
var $author$project$Dashboards2$UserFilters$fetchSampleSize = F3(
	function (_v0, flags, wrapped) {
		var gotSampleSizeResponse = _v0.o$;
		var r = wrapped;
		var updateAudienceSampleSizeState = function (colored) {
			var audience = colored.fk;
			return $krisajenkins$remotedata$RemoteData$isNotAsked(audience.eQ) ? _Utils_update(
				colored,
				{
					fk: _Utils_update(
						audience,
						{eQ: $krisajenkins$remotedata$RemoteData$Loading})
				}) : colored;
		};
		var baseAudience_ = function () {
			var _v4 = r.aU;
			if (!_v4.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var id = _v4.a.b;
				var expression = _v4.a.bY;
				return $elm$core$Maybe$Just(
					{bY: expression, b: id});
			}
		}();
		var fetchSampleSizeFn = A4(
			$author$project$Data$Calc$Platform2$sampleSizeRequest,
			flags,
			baseAudience_,
			$turboMaCk$any_set$Set$Any$toList(
				$author$project$Dashboards2$UserFilters$locations(wrapped)),
			$turboMaCk$any_set$Set$Any$toList(
				$author$project$Dashboards2$UserFilters$waves(wrapped)));
		var audiencesRequests = A2(
			$elm$core$List$filterMap,
			function (_v3) {
				var audience = _v3.fk;
				return $krisajenkins$remotedata$RemoteData$isNotAsked(audience.eQ) ? $elm$core$Maybe$Just(
					A2(
						$elm$core$Platform$Cmd$map,
						gotSampleSizeResponse(
							$author$project$Dashboards2$UserFilters$CommonAudience(audience.b)),
						fetchSampleSizeFn(
							$author$project$Data$Calc$Platform2$AudienceParam(
								{bY: audience.bY, b: audience.b})))) : $elm$core$Maybe$Nothing;
			},
			r.d9);
		var _v1 = function () {
			var _v2 = r.aU;
			if (!_v2.$) {
				var sampleSize = _v2.a;
				return $krisajenkins$remotedata$RemoteData$isNotAsked(sampleSize) ? _Utils_Tuple2(
					$author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$Loading),
					A2(
						$elm$core$Platform$Cmd$map,
						gotSampleSizeResponse($author$project$Dashboards2$UserFilters$DefaultBaseAudience),
						fetchSampleSizeFn($author$project$Data$Calc$Platform2$DefaultBaseAudience))) : _Utils_Tuple2(r.aU, $elm$core$Platform$Cmd$none);
			} else {
				var bAudience = _v2.a;
				return $krisajenkins$remotedata$RemoteData$isNotAsked(bAudience.eQ) ? A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(r.aU, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (audience) {
							return _Utils_Tuple2(
								$author$project$Dashboards2$UserFilters$Base(
									_Utils_update(
										bAudience,
										{eQ: $krisajenkins$remotedata$RemoteData$Loading})),
								A2(
									$elm$core$Platform$Cmd$map,
									gotSampleSizeResponse(
										$author$project$Dashboards2$UserFilters$UserChosenBaseAudience(audience.b)),
									fetchSampleSizeFn(
										$author$project$Data$Calc$Platform2$AudienceParam(audience))));
						},
						baseAudience_)) : _Utils_Tuple2(r.aU, $elm$core$Platform$Cmd$none);
			}
		}();
		var updatedBaseAudience = _v1.a;
		var baseAudienceRequest = _v1.b;
		return _Utils_Tuple2(
			_Utils_update(
				r,
				{
					d9: A2($elm$core$List$map, updateAudienceSampleSizeState, r.d9),
					aU: updatedBaseAudience
				}),
			$elm$core$Platform$Cmd$batch(
				A2($elm$core$List$cons, baseAudienceRequest, audiencesRequests)));
	});
var $author$project$Dashboards2$UserFilters$AllAvailableLocations = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$UserFilters$UserSelectedLocations = function (a) {
	return {$: 1, a: a};
};
var $turboMaCk$any_dict$Dict$Any$equal = F2(
	function (_v0, _v1) {
		var r1 = _v0;
		var r2 = _v1;
		return _Utils_eq(r1.i, r2.i);
	});
var $turboMaCk$any_set$Set$Any$equal = F2(
	function (_v0, _v1) {
		var a = _v0;
		var b = _v1;
		return A2($turboMaCk$any_dict$Dict$Any$equal, a, b);
	});
var $author$project$Data$Id$keysToSet = function (dict) {
	return $author$project$Data$Id$setFromList(
		$turboMaCk$any_dict$Dict$Any$keys(dict));
};
var $author$project$Dashboards2$UserFilters$initLocations = F2(
	function (storedLocations, allLocations_) {
		var isLocationAccessible = function (locationCode) {
			var _v0 = A2($turboMaCk$any_dict$Dict$Any$get, locationCode, allLocations_);
			if (_v0.$ === 1) {
				return false;
			} else {
				var location = _v0.a;
				return location.fc;
			}
		};
		var allLocations = $author$project$Data$Id$keysToSet(allLocations_);
		var checkIfLocationsMatchAllAvailable = function (selectedLocations) {
			return A2($turboMaCk$any_set$Set$Any$equal, allLocations, selectedLocations) ? $author$project$Dashboards2$UserFilters$AllAvailableLocations(selectedLocations) : $author$project$Dashboards2$UserFilters$UserSelectedLocations(selectedLocations);
		};
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Dashboards2$UserFilters$AllAvailableLocations(allLocations),
			A2($elm$core$Basics$composeR, $author$project$Data$Id$setFromList, checkIfLocationsMatchAllAvailable),
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$filter(isLocationAccessible),
				storedLocations));
	});
var $author$project$Dashboards2$UserFilters$MostRecentWaves = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$UserFilters$UserSelectedWaves = function (a) {
	return {$: 1, a: a};
};
var $author$project$Gwi$List$reverseSortBy = function (toComparable) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$sortBy(toComparable),
		$elm$core$List$reverse);
};
var $author$project$Data$Labels$sortWavesMostRecentFirst = function (list) {
	return A2(
		$author$project$Gwi$List$reverseSortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.mk;
			},
			$elm$time$Time$posixToMillis),
		list);
};
var $author$project$Data$Labels$getWavesSortedMostRecentFirst = function (dict) {
	return $author$project$Data$Labels$sortWavesMostRecentFirst(
		$turboMaCk$any_dict$Dict$Any$values(dict));
};
var $author$project$Data$Labels$getFourMostRecentWaveCodes = function (waves) {
	return $author$project$Data$Id$setFromList(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.bW;
			},
			A2(
				$elm$core$List$take,
				4,
				$author$project$Data$Labels$getWavesSortedMostRecentFirst(waves))));
};
var $author$project$Dashboards2$UserFilters$initWaves = F2(
	function (storedWaves, allWaves_) {
		var lastFourWaves = $author$project$Data$Labels$getFourMostRecentWaveCodes(allWaves_);
		var isWaveAccessible = function (waveCode) {
			var _v0 = A2($turboMaCk$any_dict$Dict$Any$get, waveCode, allWaves_);
			if (_v0.$ === 1) {
				return false;
			} else {
				var wave = _v0.a;
				return wave.fc;
			}
		};
		var checkIfWavesMatchLastFour = function (selectedWaves) {
			return A2($turboMaCk$any_set$Set$Any$equal, lastFourWaves, selectedWaves) ? $author$project$Dashboards2$UserFilters$MostRecentWaves(selectedWaves) : $author$project$Dashboards2$UserFilters$UserSelectedWaves(selectedWaves);
		};
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Dashboards2$UserFilters$MostRecentWaves(lastFourWaves),
			A2($elm$core$Basics$composeR, $author$project$Data$Id$setFromList, checkIfWavesMatchLastFour),
			A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filter(isWaveAccessible),
					A2(
						$elm$core$Basics$composeR,
						$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
						$elm$core$Maybe$map($turboMaCk$non_empty_list_alias$List$NonEmpty$toList))),
				storedWaves));
	});
var $elm_community$maybe_extra$Maybe$Extra$orElse = F2(
	function (ma, mb) {
		if (mb.$ === 1) {
			return ma;
		} else {
			return mb;
		}
	});
var $author$project$Dashboards2$UserFilters$setSampleSizeForViewOnly = F2(
	function (shortAudiencesDict, _v0) {
		var userFilters = _v0;
		var setSampleSizesForAudiences = function (coloredAudiences) {
			return A2(
				$elm$core$List$map,
				function (coloredAudience) {
					var audience = coloredAudience.fk;
					var sampleSizeFromShortAudiencesDict = A2(
						$elm$core$Maybe$withDefault,
						0,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.iD;
							},
							A2($turboMaCk$any_dict$Dict$Any$get, audience.b, shortAudiencesDict)));
					return _Utils_update(
						coloredAudience,
						{
							fk: _Utils_update(
								audience,
								{
									eQ: $krisajenkins$remotedata$RemoteData$Success(sampleSizeFromShortAudiencesDict)
								})
						});
				},
				coloredAudiences);
		};
		var baseAudienceIdForViewOnly = $author$project$Data$Id$fromString('00000000-0000-0000-0000-000000000000');
		var setSampleSizeForBaseAudience = function (baseAudience) {
			if (!baseAudience.$) {
				var sampleSizeFromShortAudiencesDict = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.iD;
						},
						A2($turboMaCk$any_dict$Dict$Any$get, baseAudienceIdForViewOnly, shortAudiencesDict)));
				return $author$project$Dashboards2$UserFilters$Default(
					$krisajenkins$remotedata$RemoteData$Success(sampleSizeFromShortAudiencesDict));
			} else {
				var audience = baseAudience.a;
				var sampleSizeFromShortAudiencesDict = A2(
					$elm$core$Maybe$withDefault,
					0,
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.iD;
						},
						A2($turboMaCk$any_dict$Dict$Any$get, audience.b, shortAudiencesDict)));
				return $author$project$Dashboards2$UserFilters$Base(
					_Utils_update(
						audience,
						{
							eQ: $krisajenkins$remotedata$RemoteData$Success(sampleSizeFromShortAudiencesDict)
						}));
			}
		};
		return _Utils_Tuple2(
			_Utils_update(
				userFilters,
				{
					d9: setSampleSizesForAudiences(userFilters.d9),
					aU: setSampleSizeForBaseAudience(userFilters.aU)
				}),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Dashboards2$UserFilters$init = F7(
	function (config, flags, storedFilters, shortAudiencesDict, audiences_, waves_, locations_) {
		var retrieveSampleSizeBasedOnPlan = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? $author$project$Dashboards2$UserFilters$setSampleSizeForViewOnly(shortAudiencesDict) : A2($author$project$Dashboards2$UserFilters$fetchSampleSize, config, flags);
		var getAudienceData = function (id) {
			return A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$map,
					function (_v6) {
						var name = _v6.ld;
						var expression = _v6.bY;
						return {bY: expression, ld: name};
					},
					A2($turboMaCk$any_dict$Dict$Any$get, id, audiences_)),
				A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						$turboMaCk$any_dict$Dict$Any$get(id),
						$elm$core$Maybe$map(
							function (_v5) {
								var name = _v5.ld;
								var expression = _v5.bY;
								return {bY: expression, ld: name};
							})),
					storedFilters.nA));
		};
		var baseAudience = function () {
			var _v3 = storedFilters.aU;
			if (_v3.$ === 1) {
				return $author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$NotAsked);
			} else {
				var id = _v3.a;
				var _v4 = getAudienceData(id);
				if (_v4.$ === 1) {
					return $author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$NotAsked);
				} else {
					var expression = _v4.a.bY;
					var name = _v4.a.ld;
					return $author$project$Dashboards2$UserFilters$Base(
						{bY: expression, b: id, pr: false, ld: name, eQ: $krisajenkins$remotedata$RemoteData$NotAsked});
				}
			}
		}();
		return retrieveSampleSizeBasedOnPlan(
			{
				d9: A3(
					$author$project$Dashboards2$UserFilters$audiencesToColored,
					_List_Nil,
					function (_v2) {
						var id = _v2.b;
						return A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.jL;
								},
								$author$project$Palette$DefaultColor),
							A2($turboMaCk$any_dict$Dict$Any$get, id, storedFilters.nB));
					},
					function () {
						var _v0 = storedFilters.d9;
						if (!_v0.$) {
							var list = _v0.a;
							return A2(
								$elm$core$List$filterMap,
								function (id) {
									return A2(
										$elm$core$Maybe$map,
										function (_v1) {
											var expression = _v1.bY;
											var name = _v1.ld;
											return {bY: expression, b: id, pr: false, ld: name, eQ: $krisajenkins$remotedata$RemoteData$NotAsked};
										},
										getAudienceData(id));
								},
								list);
						} else {
							return _List_Nil;
						}
					}()),
				aU: baseAudience,
				cD: A2($author$project$Dashboards2$UserFilters$initLocations, storedFilters.cD, locations_),
				dX: A2($author$project$Dashboards2$UserFilters$initWaves, storedFilters.dX, waves_)
			});
	});
var $turboMaCk$any_dict$Dict$Any$insert = F3(
	function (k, v, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				i: A3(
					$elm$core$Dict$insert,
					inner.aT(k),
					_Utils_Tuple2(k, v),
					inner.i)
			});
	});
var $krisajenkins$remotedata$RemoteData$isSuccess = function (data) {
	if (data.$ === 3) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Dashboards2$StoreActionMany = function (a) {
	return {$: 130, a: a};
};
var $author$project$Dashboards2$Detail$currentWidgets = function (model) {
	return $author$project$UndoRedo$current(model.G).g;
};
var $author$project$Dashboards2$Widget$ChartModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$Widget$ChartTab = 0;
var $author$project$Dashboards2$Widget$EditModeRichTextWidget = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Widget$Hidden = 0;
var $author$project$Dashboards2$Widget$LoadingView = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Widget$NoDropdown = {$: 0};
var $author$project$Dashboards2$Widget$OnlyViewForTextWidget = {$: 0};
var $author$project$Dashboards2$Widget$QuestionErrorView = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$Widget$WaitingForQuestions = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Widget$WidgetDataCollected = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$any = F2(
	function (f, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return f(h) || A2($elm$core$List$any, f, t);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
			$elm$core$List$filterMap(f)),
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList);
};
var $author$project$ResizeObserver$Dimensions = F2(
	function (width, height) {
		return {cv: height, da: width};
	});
var $author$project$Dashboards2$Chart$LineChartModel = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Dashboards2$Chart$Nonpaginated = function (a) {
	return {$: 1, a: a};
};
var $author$project$RemoteData$Loaded$NotAskedL = {$: 0};
var $author$project$Dashboards2$Chart$Paginated = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Chart$StatCardModel = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$Chart$LineChart$init = {fV: _List_Nil};
var $author$project$Dashboards2$Chart$D3Chart = {$: 0};
var $author$project$Dashboards2$Chart$HorizontalBC = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Chart$VerticalBC = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$Chart$GwiChart$init = {fV: $elm$core$Maybe$Nothing};
var $author$project$Dashboards2$Chart$HorizontalBarChart$init = $author$project$Dashboards2$Chart$GwiChart$init;
var $author$project$Dashboards2$Chart$VerticalBarChart$init = $author$project$Dashboards2$Chart$GwiChart$init;
var $author$project$Dashboards2$Chart$initChartModel = function (chartType) {
	switch (chartType) {
		case 3:
			return $author$project$Dashboards2$Chart$HorizontalBC($author$project$Dashboards2$Chart$HorizontalBarChart$init);
		case 11:
			return $author$project$Dashboards2$Chart$VerticalBC($author$project$Dashboards2$Chart$VerticalBarChart$init);
		default:
			return $author$project$Dashboards2$Chart$D3Chart;
	}
};
var $author$project$Dashboards2$Chart$itemsPerPage_ = F4(
	function (_v0, dimensions, chartType, d3Data) {
		var width = _v0.da;
		var height = _v0.cv;
		switch (chartType) {
			case 0:
				return $elm$core$Maybe$Just(666);
			case 9:
				return $elm$core$Maybe$Nothing;
			case 10:
				return $elm$core$Maybe$Nothing;
			case 5:
				return $elm$core$Maybe$Nothing;
			case 2:
				return $elm$core$Maybe$Nothing;
			case 8:
				return $elm$core$Maybe$Nothing;
			case 4:
				return $elm$core$Maybe$Nothing;
			case 7:
				return $elm$core$Maybe$Nothing;
			case 3:
				var labelHeight = 20;
				var groupBottomMargin = 4;
				var gap = 7;
				var barHeight = 17;
				var getGroupHeight = function (audiencesCount) {
					return ((((audiencesCount * barHeight) + labelHeight) + ((audiencesCount - 1) * gap)) + groupBottomMargin) + gap;
				};
				var availableSpace = dimensions.cv;
				var perPageMax = function (i) {
					return $elm$core$Maybe$Just(
						$elm$core$Basics$floor(
							availableSpace / getGroupHeight(i)));
				};
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					perPageMax(1),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.cl;
						},
						A2($elm$core$Basics$composeR, $elm$core$List$length, perPageMax)),
					$elm$core$List$head(d3Data));
			case 1:
				var footerHeight = 40;
				var attributeHeight = 42;
				return $elm$core$Maybe$Just(
					$elm$core$Basics$floor(
						(A2($elm$core$Basics$max, 50, dimensions.cv) - footerHeight) / attributeHeight));
			case 6:
				return $elm$core$Maybe$Just((4 * height) * width);
			default:
				var labelWidth = 20;
				var groupMargin = 10;
				var gap = 7;
				var barWidth = 16;
				var getGroupWidth = function (audiencesCount) {
					return ((((audiencesCount * barWidth) + labelWidth) + ((audiencesCount - 1) * gap)) + groupMargin) + gap;
				};
				var availableSpace = dimensions.da;
				var perPageMax = function (i) {
					return $elm$core$Maybe$Just(
						$elm$core$Basics$floor(
							availableSpace / getGroupWidth(i)));
				};
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					perPageMax(1),
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.cl;
						},
						A2($elm$core$Basics$composeR, $elm$core$List$length, perPageMax)),
					$elm$core$List$head(d3Data));
		}
	});
var $author$project$Dashboards2$Chart$itemsPerPage = F3(
	function (widget, dimensions, data) {
		return A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var chartType = _v0.aI;
				return A4($author$project$Dashboards2$Chart$itemsPerPage_, widget, dimensions, chartType, data);
			},
			$author$project$Data$Platform2$getChartWidget(widget));
	});
var $author$project$Dashboards2$Chart$initChartData = F2(
	function (widget, chartWidget) {
		var _v0 = chartWidget.aI;
		switch (_v0) {
			case 9:
				return $author$project$Dashboards2$Chart$StatCardModel($author$project$RemoteData$Loaded$NotAskedL);
			case 10:
				return $author$project$Dashboards2$Chart$StatCardModel($author$project$RemoteData$Loaded$NotAskedL);
			case 4:
				return A2(
					$author$project$Dashboards2$Chart$LineChartModel,
					{f8: $author$project$Dashboards2$Chart$LineChart$init},
					{
						cl: $author$project$RemoteData$Loaded$NotAskedL,
						t: A2($author$project$ResizeObserver$Dimensions, 0, 0),
						a1: $elm$core$Maybe$Nothing
					});
			default:
				return _Utils_eq(
					A3(
						$author$project$Dashboards2$Chart$itemsPerPage,
						widget,
						A2($author$project$ResizeObserver$Dimensions, 0, 0),
						_List_Nil),
					$elm$core$Maybe$Nothing) ? $author$project$Dashboards2$Chart$Nonpaginated(
					{
						cl: $author$project$RemoteData$Loaded$NotAskedL,
						t: A2($author$project$ResizeObserver$Dimensions, 0, 0),
						a1: $elm$core$Maybe$Nothing
					}) : $author$project$Dashboards2$Chart$Paginated(
					{
						ad: $author$project$Dashboards2$Chart$initChartModel(chartWidget.aI),
						cl: $author$project$RemoteData$Loaded$NotAskedL,
						t: A2($author$project$ResizeObserver$Dimensions, 0, 0)
					});
		}
	});
var $author$project$Dashboards2$Chart$init = F2(
	function (widget, chartWidget) {
		return {
			bc: $elm$core$Maybe$Nothing,
			h: A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget),
			hr: chartWidget.dB
		};
	});
var $author$project$Dashboards2$Widget$RichText$NoDropdown = 0;
var $author$project$Data$Platform2$RichTextWidget$Body = 3;
var $author$project$Data$Platform2$RichTextWidget$Left = 0;
var $author$project$Data$Platform2$RichTextWidget$Normal = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Platform2$RichTextWidget$defaultStyle = {
	de: false,
	ae: $author$project$Data$Platform2$RichTextWidget$Normal(
		{fe: 0}),
	cX: 3,
	dU: false
};
var $author$project$Dashboards2$Widget$RichText$initParagraph = {U: '', k: $author$project$Data$Platform2$RichTextWidget$defaultStyle};
var $author$project$Dashboards2$Widget$RichText$empty = {
	qt: $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton($author$project$Dashboards2$Widget$RichText$initParagraph)
};
var $author$project$Dashboards2$Widget$RichText$init = F2(
	function (_v0, maybeRichText) {
		var uniqueId = _v0.mN;
		var richText = A2($elm$core$Maybe$withDefault, $author$project$Dashboards2$Widget$RichText$empty, maybeRichText);
		return {
			aA: 0,
			bH: $elm$core$Maybe$Nothing,
			bZ: _Utils_eq(richText, $author$project$Dashboards2$Widget$RichText$empty),
			bM: richText,
			mN: uniqueId
		};
	});
var $elm_community$maybe_extra$Maybe$Extra$isJust = function (m) {
	if (m.$ === 1) {
		return false;
	} else {
		return true;
	}
};
var $krisajenkins$remotedata$RemoteData$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$length = function (_v0) {
	var t = _v0.b;
	return $elm$core$List$length(t) + 1;
};
var $author$project$Gwi$NonEmpty$uniqueByHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueByHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueByHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueByHelp;
				}
			}
		}
	});
var $author$project$Gwi$NonEmpty$uniqueBy = F2(
	function (f, xs) {
		var list = $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(xs);
		return A2(
			$elm$core$Maybe$withDefault,
			xs,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
				A4($author$project$Gwi$NonEmpty$uniqueByHelp, f, _List_Nil, list, _List_Nil)));
	});
var $author$project$Dashboards2$Widget$init = F3(
	function (_v0, widget, store) {
		var isEditMode = _v0.ey;
		return {
			d4: false,
			ad: function () {
				var _v1 = widget.U;
				if (!_v1.$) {
					var chartWidget = _v1.a;
					var questionCodes = function () {
						var _v4 = chartWidget.cl;
						if (!_v4.$) {
							var questionCode = _v4.a.at;
							return $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(questionCode);
						} else {
							var groups = _v4.a;
							return $turboMaCk$non_empty_list_alias$List$NonEmpty$unique(
								A2(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
									function ($) {
										return $.at;
									},
									groups));
						}
					}();
					var questions = A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
						function (questionCode) {
							return A2(
								$elm$core$Maybe$withDefault,
								$krisajenkins$remotedata$RemoteData$NotAsked,
								A2($turboMaCk$any_dict$Dict$Any$get, questionCode, store.bt));
						},
						questionCodes);
					var successfullyLoadedQuestions = A2(
						$elm$core$Maybe$map,
						$author$project$Gwi$NonEmpty$uniqueBy(
							function ($) {
								return $.k1;
							}),
						A2($turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap, $krisajenkins$remotedata$RemoteData$toMaybe, questions));
					var errors = A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
						function (q) {
							if (q.$ === 2) {
								var err = q.a;
								return $elm$core$Maybe$Just(err);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						questions);
					var chartModel = A2($author$project$Dashboards2$Chart$init, widget, chartWidget);
					var anyNotAsked = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$any, $krisajenkins$remotedata$RemoteData$isNotAsked, questions);
					var anyLoading = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$any, $krisajenkins$remotedata$RemoteData$isLoading, questions);
					return $author$project$Dashboards2$Widget$ChartModel(
						function () {
							if (anyLoading) {
								return $author$project$Dashboards2$Widget$LoadingView(chartModel);
							} else {
								if (anyNotAsked) {
									return $author$project$Dashboards2$Widget$WaitingForQuestions(chartModel);
								} else {
									if ($elm_community$maybe_extra$Maybe$Extra$isJust(errors)) {
										return A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$Dashboards2$Widget$WaitingForQuestions(chartModel),
											$author$project$Dashboards2$Widget$QuestionErrorView,
											errors);
									} else {
										if (!successfullyLoadedQuestions.$) {
											var readyQuestions = successfullyLoadedQuestions.a;
											return _Utils_eq(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$length(readyQuestions),
												$turboMaCk$non_empty_list_alias$List$NonEmpty$length(questionCodes)) ? A2($author$project$Dashboards2$Widget$WidgetDataCollected, readyQuestions, chartModel) : $author$project$Dashboards2$Widget$WaitingForQuestions(chartModel);
										} else {
											return $author$project$Dashboards2$Widget$WaitingForQuestions(chartModel);
										}
									}
								}
							}
						}());
				} else {
					var richText = _v1.a;
					return isEditMode ? $author$project$Dashboards2$Widget$EditModeRichTextWidget(
						A2(
							$author$project$Dashboards2$Widget$RichText$init,
							{
								mN: $author$project$Data$Id$unwrap(widget.b)
							},
							$elm$core$Maybe$Just(richText))) : $author$project$Dashboards2$Widget$OnlyViewForTextWidget;
				}
			}(),
			eo: 0,
			ev: false,
			cz: false,
			b$: 0,
			w: $author$project$Dashboards2$Widget$NoDropdown
		};
	});
var $author$project$Dashboards2$foldWidgets = F6(
	function (fn, acc, initArgs, dashboard, store, widgetModels) {
		return A3(
			$elm$core$List$foldl,
			function (widget) {
				return A2(
					fn,
					widget,
					function () {
						var _v0 = A2($turboMaCk$any_dict$Dict$Any$get, widget.b, widgetModels);
						if (!_v0.$) {
							var wModel = _v0.a;
							return wModel;
						} else {
							return A3($author$project$Dashboards2$Widget$init, initArgs, widget, store);
						}
					}());
			},
			acc,
			dashboard.cl.g);
	});
var $author$project$Dashboards2$Detail$isEditMode = function (editState) {
	if (!editState.$) {
		return false;
	} else {
		return true;
	}
};
var $author$project$Dashboards2$isEditMode = $author$project$Dashboards2$Detail$isEditMode;
var $author$project$Dashboards2$Export = function (a) {
	return {$: 11, a: a};
};
var $turboMaCk$queue$Queue$queue = F2(
	function (fl, rl) {
		if (!fl.b) {
			return A2(
				$turboMaCk$queue$Queue$Queue,
				$elm$core$List$reverse(rl),
				_List_Nil);
		} else {
			return A2($turboMaCk$queue$Queue$Queue, fl, rl);
		}
	});
var $turboMaCk$queue$Queue$enqueue = F2(
	function (a, _v0) {
		var fl = _v0.a;
		var rl = _v0.b;
		return A2(
			$turboMaCk$queue$Queue$queue,
			fl,
			A2($elm$core$List$cons, a, rl));
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $turboMaCk$glue$Glue$map = F2(
	function (constructor, pair) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$map(constructor),
			pair);
	});
var $author$project$Dashboards2$maxRequestsLimit = 600;
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $author$project$Dashboards2$Widget$getChartModel = function (chartModelData) {
	switch (chartModelData.$) {
		case 0:
			var chartModel = chartModelData.a;
			return $elm$core$Maybe$Just(chartModel);
		case 1:
			var chartModel = chartModelData.a;
			return $elm$core$Maybe$Just(chartModel);
		case 2:
			return $elm$core$Maybe$Nothing;
		default:
			var chartModel = chartModelData.b;
			return $elm$core$Maybe$Just(chartModel);
	}
};
var $author$project$Dashboards2$Widget$modelToChartModel = function (model) {
	var _v0 = model.ad;
	switch (_v0.$) {
		case 2:
			var chartModelData = _v0.a;
			return $author$project$Dashboards2$Widget$getChartModel(chartModelData);
		case 0:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$RemoteData$Loaded$FailureL = function (a) {
	return {$: 2, a: a};
};
var $author$project$RemoteData$Loaded$LoadingL = function (a) {
	return {$: 1, a: a};
};
var $author$project$RemoteData$Loaded$SuccessL = function (a) {
	return {$: 3, a: a};
};
var $author$project$RemoteData$Loaded$map = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var value = data.a;
				return $author$project$RemoteData$Loaded$SuccessL(
					f(value));
			case 1:
				var maybeA = data.a;
				return $author$project$RemoteData$Loaded$LoadingL(
					A2($elm$core$Maybe$map, f, maybeA));
			case 0:
				return $author$project$RemoteData$Loaded$NotAskedL;
			default:
				var e = data.a;
				return $author$project$RemoteData$Loaded$FailureL(e);
		}
	});
var $author$project$Data$Platform2$Explicit = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Platform2$Implicit = {$: 0};
var $author$project$Store$Platform2$getAllLoadedLocations = function (store) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$krisajenkins$remotedata$RemoteData$NotAsked,
		function (namespaces) {
			return A2($author$project$Store$Platform2$getLocationsForNamespaces, namespaces, store);
		},
		$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
			$turboMaCk$any_dict$Dict$Any$keys(store.pK)));
};
var $author$project$Data$Calc$Platform2$activeLocationsByNamespaceCode_ = F2(
	function (store, activeLocations) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$List$filter(
				function (_v0) {
					var code = _v0.bW;
					return A2($elm$core$List$member, code, activeLocations);
				}),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$turboMaCk$any_dict$Dict$Any$values,
				$author$project$Store$Platform2$getAllLoadedLocations(store)));
	});
var $author$project$Store$Platform2$getAllLoadedWaves = function (store) {
	return A3(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$krisajenkins$remotedata$RemoteData$NotAsked,
		function (namespaces) {
			return A2($author$project$Store$Platform2$getWavesForNamespaces, namespaces, store);
		},
		$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
			$turboMaCk$any_dict$Dict$Any$keys(store.se)));
};
var $author$project$Data$Calc$Platform2$activeWavesByNamespaceCode_ = F2(
	function (store, activeWaves) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$elm$core$List$filter(
				function (_v0) {
					var code = _v0.bW;
					return A2($elm$core$List$member, code, activeWaves);
				}),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$turboMaCk$any_dict$Dict$Any$values,
				$author$project$Store$Platform2$getAllLoadedWaves(store)));
	});
var $author$project$Data$Audience$Expression$foldr = F3(
	function (f, acc, expression) {
		switch (expression.$) {
			case 0:
				return acc;
			case 2:
				var leaf = expression.a;
				return A2(f, leaf, acc);
			default:
				var subnodes = expression.b;
				return A3(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$foldr,
					F2(
						function (exp, listAcc) {
							return A3($author$project$Data$Audience$Expression$foldr, f, listAcc, exp);
						}),
					acc,
					subnodes);
		}
	});
var $author$project$Data$Audience$Expression$datapointCodes = function (expression) {
	return A3(
		$author$project$Data$Audience$Expression$foldr,
		F2(
			function (leaf, acc) {
				return _Utils_ap(leaf.hw, acc);
			}),
		_List_Nil,
		expression);
};
var $author$project$Data$Calc$Platform2$audienceDatapoints = function (audiences) {
	return A2(
		$turboMaCk$any_set$Set$Any$fromList,
		$author$project$Data$Id$unwrap,
		A3(
			$elm$core$List$foldr,
			F2(
				function (a, acc) {
					return _Utils_ap(
						$author$project$Data$Audience$Expression$datapointCodes(a.bY),
						acc);
				}),
			_List_Nil,
			audiences));
};
var $author$project$Data$Audience$Expression$questionCodes = function (expression) {
	return A3(
		$author$project$Data$Audience$Expression$foldr,
		F2(
			function (leaf, acc) {
				return A2($elm$core$List$cons, leaf.at, acc);
			}),
		_List_Nil,
		expression);
};
var $author$project$Data$Calc$Platform2$audienceQuestions = function (audiences) {
	return A2(
		$turboMaCk$any_set$Set$Any$fromList,
		$author$project$Data$Id$unwrap,
		A3(
			$elm$core$List$foldr,
			F2(
				function (a, acc) {
					return _Utils_ap(
						$author$project$Data$Audience$Expression$questionCodes(a.bY),
						acc);
				}),
			_List_Nil,
			audiences));
};
var $elm_community$maybe_extra$Maybe$Extra$filter = F2(
	function (f, m) {
		if (!m.$) {
			var a = m.a;
			return f(a) ? m : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$member = F2(
	function (a, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return _Utils_eq(a, h) || A2($elm$core$List$member, a, t);
	});
var $author$project$Data$Platform2$checkValidityOfDatapointCodesForWidget = F2(
	function (question, attribute) {
		var questionCodeAgrees = _Utils_eq(attribute.at, question.k1);
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$filter,
			function (datapointCode) {
				return A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$member,
					datapointCode,
					A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
						function ($) {
							return $.bW;
						},
						question.er));
			},
			A2(
				$elm_community$maybe_extra$Maybe$Extra$filter,
				$elm$core$Basics$always(questionCodeAgrees),
				$elm$core$Maybe$Just(attribute.eq)));
	});
var $author$project$D3Charts$Dashboards$ChartType$NoRestriction = 2;
var $author$project$D3Charts$Dashboards$ChartType$OneDatapointNeeded = 0;
var $author$project$D3Charts$Dashboards$ChartType$ThreeOrMoreDatapointsNeeded = 1;
var $author$project$D3Charts$Dashboards$ChartType$datapointCountRequirement = function (chartType) {
	switch (chartType) {
		case 4:
			return 0;
		case 9:
			return 0;
		case 10:
			return 0;
		case 8:
			return 0;
		case 7:
			return 1;
		default:
			return 2;
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$filter = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		A2(
			$elm$core$Basics$composeL,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
			$elm$core$List$filter(f)),
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList);
};
var $turboMaCk$any_dict$Dict$Any$foldl = F3(
	function (f, acc, _v0) {
		var dict = _v0.i;
		return A3(
			$elm$core$Dict$foldl,
			F2(
				function (_v1, _v2) {
					var k = _v2.a;
					var v = _v2.b;
					return A2(f, k, v);
				}),
			acc,
			dict);
	});
var $turboMaCk$any_dict$Dict$Any$removeAll = function (_v0) {
	var inner = _v0;
	return {i: $elm$core$Dict$empty, aT: inner.aT};
};
var $turboMaCk$any_dict$Dict$Any$filterMap = F2(
	function (f, dict) {
		return A3(
			$turboMaCk$any_dict$Dict$Any$foldl,
			F3(
				function (k, v, acc) {
					var _v0 = A2(f, k, v);
					if (!_v0.$) {
						var newVal = _v0.a;
						return A3($turboMaCk$any_dict$Dict$Any$insert, k, newVal, acc);
					} else {
						return acc;
					}
				}),
			$turboMaCk$any_dict$Dict$Any$removeAll(dict),
			dict);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$findHelper = F2(
	function (predicate, list) {
		findHelper:
		while (true) {
			if (!list.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var first = list.a;
				var rest = list.b;
				if (predicate(first)) {
					return $elm$core$Maybe$Just(first);
				} else {
					var $temp$predicate = predicate,
						$temp$list = rest;
					predicate = $temp$predicate;
					list = $temp$list;
					continue findHelper;
				}
			}
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$find = F2(
	function (predicate, _v0) {
		var x = _v0.a;
		var xs = _v0.b;
		return predicate(x) ? $elm$core$Maybe$Just(x) : A2($turboMaCk$non_empty_list_alias$List$NonEmpty$findHelper, predicate, xs);
	});
var $author$project$Store$Platform2$getQuestion = F2(
	function (questionCode, store) {
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($turboMaCk$any_dict$Dict$Any$get, questionCode, store.bt));
	});
var $author$project$Store$Platform2$getQuestionMaybe = F2(
	function (questionCode, store) {
		return $krisajenkins$remotedata$RemoteData$toMaybe(
			A2($author$project$Store$Platform2$getQuestion, questionCode, store));
	});
var $author$project$Store$Platform2$getSplitters = F2(
	function (namespaceCode, store) {
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($turboMaCk$any_dict$Dict$Any$get, namespaceCode, store.cZ));
	});
var $author$project$Store$Utils$get = F2(
	function (state, id) {
		return A2(
			$elm$core$Maybe$andThen,
			$turboMaCk$any_dict$Dict$Any$get(id),
			$krisajenkins$remotedata$RemoteData$toMaybe(state));
	});
var $krisajenkins$remotedata$RemoteData$andThen = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var a = data.a;
				return f(a);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(e);
			case 0:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
			default:
				return $krisajenkins$remotedata$RemoteData$Loading;
		}
	});
var $author$project$Store$Platform2$getDashboard = F2(
	function (dashboardId, dashboards) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			function (dashboards_) {
				var _v0 = A2($turboMaCk$any_dict$Dict$Any$get, dashboardId, dashboards_);
				if (_v0.$ === 1) {
					return $krisajenkins$remotedata$RemoteData$NotAsked;
				} else {
					var dashboard = _v0.a;
					return $krisajenkins$remotedata$RemoteData$Success(dashboard);
				}
			},
			dashboards);
	});
var $author$project$Data$Platform2$toFullyLoadedDashboard = function (dashboard) {
	return A2(
		$krisajenkins$remotedata$RemoteData$map,
		function (data) {
			return {ac: dashboard.ac, bB: dashboard.bB, cl: data, es: dashboard.es, oN: dashboard.oN, b: dashboard.b, kN: dashboard.kN, pC: dashboard.pC, ld: dashboard.ld, qr: dashboard.qr, dG: dashboard.dG, ah: dashboard.ah, bN: dashboard.bN, i1: dashboard.i1};
		},
		dashboard.cl);
};
var $author$project$Store$Platform2$getDashboardFullyLoaded = F2(
	function (dashboardId, dashboards) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			$author$project$Data$Platform2$toFullyLoadedDashboard,
			A2($author$project$Store$Platform2$getDashboard, dashboardId, dashboards));
	});
var $author$project$Data$Calc$Platform2$toQueryParamsAudience = function (_v0) {
	var id = _v0.b;
	var name = _v0.ld;
	var flags = _v0.oN;
	var expression = _v0.bY;
	return {
		bY: expression,
		oN: $elm$core$Maybe$Just(flags),
		b: id,
		ld: name
	};
};
var $author$project$Data$Calc$Platform2$getWidgetBaseAudienceFromChart = F2(
	function (widget, _v0) {
		var audiences = _v0.d9;
		var dashboards = _v0.v;
		var getAudienceFromAudienceData = function (audienceId) {
			return A2(
				$elm$core$Maybe$andThen,
				function (_v3) {
					var data = _v3.cl;
					return A2(
						$elm$core$Maybe$map,
						function (a) {
							return {bY: a.bY, oN: $elm$core$Maybe$Nothing, b: a.b, ld: a.ld};
						},
						A2(
							$elm$core$Maybe$andThen,
							$turboMaCk$any_dict$Dict$Any$get(audienceId),
							data.C.nA));
				},
				$krisajenkins$remotedata$RemoteData$toMaybe(
					A2($author$project$Store$Platform2$getDashboardFullyLoaded, widget.bf, dashboards)));
		};
		var _v1 = widget.U;
		if (!_v1.$) {
			var chartWidget = _v1.a;
			var _v2 = chartWidget.aU;
			if (!_v2.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				var baseAudience = _v2.a;
				return A2(
					$elm_community$maybe_extra$Maybe$Extra$orElse,
					getAudienceFromAudienceData(baseAudience.b),
					A2(
						$elm$core$Maybe$map,
						$author$project$Data$Calc$Platform2$toQueryParamsAudience,
						A2($author$project$Store$Utils$get, audiences, baseAudience.b)));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$D3Charts$Dashboards$ChartType$LineChart = 4;
var $elm$core$String$endsWith = _String_endsWith;
var $author$project$Store$Utils$getByIdsMatching = F2(
	function (matchingFunction, state) {
		if (state.$ === 3) {
			var dict = state.a;
			return A2(
				$author$project$Store$Utils$getByIds,
				state,
				$turboMaCk$any_dict$Dict$Any$keys(
					A2(
						$turboMaCk$any_dict$Dict$Any$filter,
						F2(
							function (k, _v1) {
								return matchingFunction(k);
							}),
						dict)));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Data$Calc$Platform2$getWidgetSplitter = F2(
	function (widget, splitters) {
		var _v0 = widget.U;
		if (!_v0.$) {
			var chartWidget = _v0.a;
			return (chartWidget.aI === 4) ? $elm$core$List$head(
				A2(
					$author$project$Store$Utils$getByIdsMatching,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Data$Id$unwrap,
						$elm$core$String$endsWith('waves')),
					splitters)) : $elm$core$Maybe$Nothing;
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$head = function (_v0) {
	var h = _v0.a;
	return h;
};
var $author$project$Data$Platform2$oldWidgetDataToGroupedWidgetData = F2(
	function (questions, oldData) {
		var fromBoth = F2(
			function (dpCodes, suffixCodes) {
				return {
					er: $author$project$Data$Platform2$Explicit(
						A2(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
							function (dpCode) {
								return _Utils_Tuple2(dpCode, suffixCodes);
							},
							dpCodes)),
					at: oldData.at
				};
			});
		return A2(
			$elm$core$Maybe$map,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton,
			function () {
				var _v0 = _Utils_Tuple2(oldData.hw, oldData.eY);
				if (_v0.a.$ === 1) {
					if (_v0.b.$ === 1) {
						var dpCodes = _v0.a.a;
						var suffixCodes = _v0.b.a;
						return $elm$core$Maybe$Just(
							A2(
								fromBoth,
								dpCodes,
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(suffixCodes)));
					} else {
						var dpCodes = _v0.a.a;
						var _v2 = _v0.b;
						return A2(
							$elm$core$Maybe$map,
							function (question) {
								var _v3 = question.rI;
								if (_v3.$ === 1) {
									return A2(fromBoth, dpCodes, _List_Nil);
								} else {
									var suffixes = _v3.a;
									return A2(
										fromBoth,
										dpCodes,
										$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
											A2(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
												function ($) {
													return $.bW;
												},
												suffixes)));
								}
							},
							A2($turboMaCk$any_dict$Dict$Any$get, oldData.at, questions));
					}
				} else {
					if (_v0.b.$ === 1) {
						var _v1 = _v0.a;
						var suffixCodes = _v0.b.a;
						return A2(
							$elm$core$Maybe$map,
							function (question) {
								return A2(
									fromBoth,
									A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
										function ($) {
											return $.bW;
										},
										question.er),
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(suffixCodes));
							},
							A2($turboMaCk$any_dict$Dict$Any$get, oldData.at, questions));
					} else {
						var _v4 = _v0.a;
						var _v5 = _v0.b;
						return A2(
							$elm$core$Maybe$map,
							function (question) {
								var dpCodes = A2(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
									function ($) {
										return $.bW;
									},
									question.er);
								var _v6 = question.rI;
								if (_v6.$ === 1) {
									return A2(fromBoth, dpCodes, _List_Nil);
								} else {
									var suffixes = _v6.a;
									return A2(
										fromBoth,
										dpCodes,
										$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
											A2(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
												function ($) {
													return $.bW;
												},
												suffixes)));
								}
							},
							A2($turboMaCk$any_dict$Dict$Any$get, oldData.at, questions));
					}
				}
			}());
	});
var $turboMaCk$non_empty_list_alias$Maybe$NonEmpty$traverseNeHelp = F3(
	function (f, _v0, xs) {
		traverseNeHelp:
		while (true) {
			var head = _v0.a;
			var tail = _v0.b;
			if (!xs.b) {
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						head,
						$elm$core$List$reverse(tail)));
			} else {
				var h = xs.a;
				var t = xs.b;
				var _v2 = f(h);
				if (!_v2.$) {
					var v = _v2.a;
					var $temp$f = f,
						$temp$_v0 = _Utils_Tuple2(
						head,
						A2($elm$core$List$cons, v, tail)),
						$temp$xs = t;
					f = $temp$f;
					_v0 = $temp$_v0;
					xs = $temp$xs;
					continue traverseNeHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $turboMaCk$non_empty_list_alias$Maybe$NonEmpty$traverseNe = F2(
	function (f, _v0) {
		var head = _v0.a;
		var tail = _v0.b;
		var _v1 = f(head);
		if (_v1.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var v = _v1.a;
			return A3(
				$turboMaCk$non_empty_list_alias$Maybe$NonEmpty$traverseNeHelp,
				f,
				_Utils_Tuple2(v, _List_Nil),
				tail);
		}
	});
var $author$project$Data$Calc$Platform2$computeParamsFromWidget = F4(
	function (store, simpleFilters, widget_, widget) {
		var sanitizeOldWidgetDataByDatapointsCountRestrictions = function (chartType) {
			return $turboMaCk$non_empty_list_alias$List$NonEmpty$map(
				function (record) {
					var _v5 = $author$project$D3Charts$Dashboards$ChartType$datapointCountRequirement(chartType);
					switch (_v5) {
						case 0:
							return _Utils_update(
								record,
								{
									er: function () {
										var _v6 = record.er;
										if (!_v6.$) {
											return A3(
												$elm_community$maybe_extra$Maybe$Extra$unwrap,
												$author$project$Data$Platform2$Implicit,
												function (_v7) {
													var datapoints = _v7.er;
													var suffixes = _v7.rI;
													return $author$project$Data$Platform2$Explicit(
														$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
															_Utils_Tuple2(
																$turboMaCk$non_empty_list_alias$List$NonEmpty$head(datapoints).bW,
																A2(
																	$elm$core$List$map,
																	function ($) {
																		return $.bW;
																	},
																	A2(
																		$elm$core$Maybe$withDefault,
																		_List_Nil,
																		A2($elm$core$Maybe$map, $turboMaCk$non_empty_list_alias$List$NonEmpty$toList, suffixes))))));
												},
												A2(
													$elm$core$Maybe$andThen,
													$krisajenkins$remotedata$RemoteData$toMaybe,
													A2($turboMaCk$any_dict$Dict$Any$get, record.at, store.bt)));
										} else {
											if (!_v6.a.b.b) {
												var _v8 = _v6.a;
												return record.er;
											} else {
												var _v9 = _v6.a;
												var first = _v9.a;
												return $author$project$Data$Platform2$Explicit(
													$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(first));
											}
										}
									}()
								});
						case 1:
							return record;
						default:
							return record;
					}
				});
		};
		var paramsFromGroupedData = function (data_) {
			return A2(
				$turboMaCk$non_empty_list_alias$Maybe$NonEmpty$traverseNe,
				function (_v2) {
					var questionCode = _v2.at;
					var datapoints = _v2.er;
					var widgetBaseAudienceFromChart = A2($author$project$Data$Calc$Platform2$getWidgetBaseAudienceFromChart, widget_, store);
					var waves = A2(
						F2(
							function (w1, w2) {
								return $krisajenkins$remotedata$RemoteData$Success(
									_Utils_ap(w1, w2));
							}),
						A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							_List_Nil,
							A2($author$project$Data$Calc$Platform2$activeWavesByNamespaceCode_, store, simpleFilters.dX)),
						A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							_List_Nil,
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								$turboMaCk$any_dict$Dict$Any$values,
								A2($author$project$Store$Platform2$getWavesByDashboardId, widget_.bf, store))));
					var namespaceCode = $author$project$Data$Labels$questionCodeToNamespaceCode(questionCode);
					var splitters = A2($author$project$Store$Platform2$getSplitters, namespaceCode, store);
					var maybeSplitter = A2($author$project$Data$Calc$Platform2$getWidgetSplitter, widget_, splitters);
					var locations = A2(
						F2(
							function (l1, l2) {
								return $krisajenkins$remotedata$RemoteData$Success(
									_Utils_ap(l1, l2));
							}),
						A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							_List_Nil,
							A2($author$project$Data$Calc$Platform2$activeLocationsByNamespaceCode_, store, simpleFilters.cD)),
						A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							_List_Nil,
							A2(
								$krisajenkins$remotedata$RemoteData$map,
								$turboMaCk$any_dict$Dict$Any$values,
								A2($author$project$Store$Platform2$getLocationsByDashboardId, widget_.bf, store))));
					var audiences = simpleFilters.d9;
					var construct = function (question) {
						var getDatapoint = function (code) {
							return A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bW;
									},
									$elm$core$Basics$eq(code)),
								question.er);
						};
						var checkDatapointCodeValidity = function (dtpCode) {
							return $elm_community$maybe_extra$Maybe$Extra$isJust(
								A2(
									$author$project$Data$Platform2$checkValidityOfDatapointCodesForWidget,
									question,
									{eq: dtpCode, at: question.k1, iT: $elm$core$Maybe$Nothing}));
						};
						var _v3 = function () {
							if (!datapoints.$) {
								return _Utils_Tuple2(
									A2(
										$elm$core$Maybe$map,
										$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
										A2(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$filter,
											checkDatapointCodeValidity,
											A2(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
												function ($) {
													return $.bW;
												},
												question.er))),
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $turboMaCk$non_empty_list_alias$List$NonEmpty$toList, question.rI));
							} else {
								var xs = datapoints.a;
								var explicitSuffixCodes = A2(
									$author$project$Gwi$List$fastConcatMap,
									$elm$core$Tuple$second,
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(xs));
								return _Utils_Tuple2(
									A2(
										$elm$core$Maybe$map,
										$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
										A2(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$filter,
											checkDatapointCodeValidity,
											A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $elm$core$Tuple$first, xs))),
									A2(
										$elm$core$List$filter,
										function (suffix) {
											return A2($elm$core$List$member, suffix.bW, explicitSuffixCodes);
										},
										A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $turboMaCk$non_empty_list_alias$List$NonEmpty$toList, question.rI)));
							}
						}();
						var maybeDatapointCodes = _v3.a;
						var suffixCodes = _v3.b;
						return A2(
							$elm$core$Maybe$map,
							function (datapointCodes) {
								return {
									nh: A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.l5;
										},
										maybeSplitter),
									nx: $turboMaCk$any_set$Set$Any$toList(
										$author$project$Data$Calc$Platform2$audienceDatapoints(audiences)),
									nz: $turboMaCk$any_set$Set$Any$toList(
										$author$project$Data$Calc$Platform2$audienceQuestions(audiences)),
									d9: audiences,
									aU: A2($elm_community$maybe_extra$Maybe$Extra$orElse, simpleFilters.aU, widgetBaseAudienceFromChart),
									er: A2($elm$core$List$filterMap, getDatapoint, datapointCodes),
									cD: A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, locations),
									gA: question,
									qF: false,
									ry: maybeSplitter,
									rI: suffixCodes,
									dX: A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, waves)
								};
							},
							A2(
								$elm_community$maybe_extra$Maybe$Extra$filter,
								$elm$core$Basics$always(
									$krisajenkins$remotedata$RemoteData$isSuccess(waves)),
								A2(
									$elm_community$maybe_extra$Maybe$Extra$filter,
									$elm$core$Basics$always(
										$krisajenkins$remotedata$RemoteData$isSuccess(locations)),
									A2(
										$elm_community$maybe_extra$Maybe$Extra$filter,
										$elm$core$Basics$always(
											$krisajenkins$remotedata$RemoteData$isSuccess(store.d9)),
										A2(
											$elm_community$maybe_extra$Maybe$Extra$filter,
											$elm$core$Basics$always(
												$krisajenkins$remotedata$RemoteData$isSuccess(splitters)),
											maybeDatapointCodes)))));
					};
					return A2(
						$elm$core$Maybe$andThen,
						construct,
						A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store));
				},
				data_);
		};
		var _v0 = widget.cl;
		if (!_v0.$) {
			var oldData = _v0.a;
			return A2(
				$elm$core$Maybe$andThen,
				paramsFromGroupedData,
				A2(
					$elm$core$Maybe$map,
					sanitizeOldWidgetDataByDatapointsCountRestrictions(widget.aI),
					A2(
						$author$project$Data$Platform2$oldWidgetDataToGroupedWidgetData,
						A2(
							$turboMaCk$any_dict$Dict$Any$filterMap,
							F2(
								function (_v1, v) {
									return $krisajenkins$remotedata$RemoteData$toMaybe(v);
								}),
							store.bt),
						oldData)));
		} else {
			var groups = _v0.a;
			return paramsFromGroupedData(
				A2(sanitizeOldWidgetDataByDatapointsCountRestrictions, widget.aI, groups));
		}
	});
var $author$project$Data$Calc$Platform2$paramsFromWidget = F3(
	function (store, simpleFilters, widget_) {
		var _v0 = widget_.U;
		if (!_v0.$) {
			var widget = _v0.a;
			var _v1 = A2(
				$turboMaCk$any_dict$Dict$Any$get,
				_Utils_Tuple2(simpleFilters, widget_),
				store.$9);
			if (!_v1.$) {
				var storedParams = _v1.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(storedParams, $elm$core$Basics$identity));
			} else {
				return A2(
					$elm$core$Maybe$map,
					function (qqParams) {
						return _Utils_Tuple2(
							qqParams,
							function (s) {
								return _Utils_update(
									s,
									{
										$9: A3(
											$turboMaCk$any_dict$Dict$Any$insert,
											_Utils_Tuple2(simpleFilters, widget_),
											qqParams,
											s.$9)
									});
							});
					},
					A4($author$project$Data$Calc$Platform2$computeParamsFromWidget, store, simpleFilters, widget_, widget));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Platform2$ChartContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Platform2$GroupedData = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Permissions$Accessible = {$: 0};
var $author$project$Data$Permissions$Unknown = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Permissions$UpsellNeeded = function (a) {
	return {$: 1, a: a};
};
var $turboMaCk$any_set$Set$Any$union = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return A2($turboMaCk$any_dict$Dict$Any$union, d1, d2);
	});
var $author$project$Data$Permissions$mergeUnique = F2(
	function (nl1, nl2) {
		var inBoth = A2(
			$turboMaCk$any_set$Set$Any$union,
			$author$project$Data$Id$setFromList(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(nl1)),
			$author$project$Data$Id$setFromList(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(nl2)));
		return A2(
			$elm$core$Maybe$withDefault,
			nl1,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
				$turboMaCk$any_set$Set$Any$toList(inBoth)));
	});
var $author$project$Data$Permissions$combineMaybeNonemptylists = F2(
	function (mList1, mList2) {
		var _v0 = _Utils_Tuple2(mList1, mList2);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var list1 = _v0.a.a;
				var list2 = _v0.b.a;
				return $elm$core$Maybe$Just(
					A2($author$project$Data$Permissions$mergeUnique, list1, list2));
			} else {
				var _v1 = _v0.b;
				return mList1;
			}
		} else {
			if (!_v0.b.$) {
				var _v2 = _v0.a;
				return mList2;
			} else {
				var _v3 = _v0.a;
				var _v4 = _v0.b;
				return $elm$core$Maybe$Nothing;
			}
		}
	});
var $author$project$Data$Permissions$mergeProblematicData = F2(
	function (data1, data2) {
		return _Utils_update(
			data1,
			{
				er: A2($author$project$Data$Permissions$combineMaybeNonemptylists, data1.er, data2.er),
				cD: A2($author$project$Data$Permissions$combineMaybeNonemptylists, data1.cD, data2.cD),
				cM: A2($author$project$Data$Permissions$combineMaybeNonemptylists, data1.cM, data2.cM),
				cN: A2($author$project$Data$Permissions$combineMaybeNonemptylists, data1.cN, data2.cN),
				bt: A2($author$project$Data$Permissions$combineMaybeNonemptylists, data1.bt, data2.bt),
				cZ: A2($author$project$Data$Permissions$combineMaybeNonemptylists, data1.cZ, data2.cZ),
				dX: A2($author$project$Data$Permissions$combineMaybeNonemptylists, data1.dX, data2.dX)
			});
	});
var $author$project$Data$Permissions$combine = F2(
	function (p1, p2) {
		var _v0 = _Utils_Tuple2(p1, p2);
		_v0$1:
		while (true) {
			_v0$2:
			while (true) {
				switch (_v0.a.$) {
					case 2:
						switch (_v0.b.$) {
							case 2:
								var data1 = _v0.a.a;
								var data2 = _v0.b.a;
								return $author$project$Data$Permissions$Unknown(
									A2($author$project$Data$Permissions$mergeProblematicData, data1, data2));
							case 1:
								break _v0$1;
							default:
								break _v0$1;
						}
					case 1:
						switch (_v0.b.$) {
							case 2:
								break _v0$2;
							case 1:
								var data1 = _v0.a.a;
								var data2 = _v0.b.a;
								return $author$project$Data$Permissions$UpsellNeeded(
									A2($author$project$Data$Permissions$mergeProblematicData, data1, data2));
							default:
								return p1;
						}
					default:
						switch (_v0.b.$) {
							case 2:
								break _v0$2;
							case 1:
								return p2;
							default:
								var _v1 = _v0.a;
								var _v2 = _v0.b;
								return $author$project$Data$Permissions$Accessible;
						}
				}
			}
			return p2;
		}
		return p1;
	});
var $author$project$Data$Permissions$default = $author$project$Data$Permissions$Accessible;
var $author$project$Data$Permissions$fromAccessible = F2(
	function (problematicDataIfInaccessible, accessible) {
		return accessible ? $author$project$Data$Permissions$Accessible : $author$project$Data$Permissions$UpsellNeeded(problematicDataIfInaccessible);
	});
var $author$project$Data$Permissions$emptyProblematicData = {er: $elm$core$Maybe$Nothing, cD: $elm$core$Maybe$Nothing, cM: $elm$core$Maybe$Nothing, cN: $elm$core$Maybe$Nothing, bt: $elm$core$Maybe$Nothing, cZ: $elm$core$Maybe$Nothing, rI: $elm$core$Maybe$Nothing, dX: $elm$core$Maybe$Nothing};
var $author$project$Data$Permissions$problematicQuestion = function (code) {
	return _Utils_update(
		$author$project$Data$Permissions$emptyProblematicData,
		{
			bt: $elm$core$Maybe$Just(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(code))
		});
};
var $author$project$Data$Permissions$problematicDatapoint = function (code) {
	return _Utils_update(
		$author$project$Data$Permissions$emptyProblematicData,
		{
			er: $elm$core$Maybe$Just(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(code))
		});
};
var $author$project$Data$Permissions$questionDatapoints = F2(
	function (datapointCodes, question_) {
		return A3(
			$elm$core$List$foldl,
			F2(
				function (code, acc) {
					var datapointPermission = A2(
						$elm$core$Maybe$withDefault,
						$author$project$Data$Permissions$Unknown(
							$author$project$Data$Permissions$problematicDatapoint(code)),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fc;
								},
								$author$project$Data$Permissions$fromAccessible(
									$author$project$Data$Permissions$problematicDatapoint(code))),
							A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
								function (datapoint) {
									return _Utils_eq(datapoint.bW, code);
								},
								question_.er)));
					return A2($author$project$Data$Permissions$combine, acc, datapointPermission);
				}),
			$author$project$Data$Permissions$Accessible,
			datapointCodes);
	});
var $author$project$Data$Permissions$p2AudienceLeaf = F3(
	function (plan, questions, _v0) {
		var questionCode = _v0.at;
		var datapointCodes = _v0.hw;
		var canBeUsedInAudienceBuilder = plan !== 5;
		var questionAccessible = function (question_) {
			return canBeUsedInAudienceBuilder ? A2(
				$author$project$Data$Permissions$fromAccessible,
				$author$project$Data$Permissions$problematicQuestion(question_.k1),
				question_.fc) : $author$project$Data$Permissions$Unknown(
				$author$project$Data$Permissions$problematicQuestion(question_.k1));
		};
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Permissions$Unknown(
				$author$project$Data$Permissions$problematicQuestion(questionCode)),
			A2(
				$elm$core$Maybe$map,
				function (question_) {
					return A2(
						$author$project$Data$Permissions$combine,
						A2($author$project$Data$Permissions$questionDatapoints, datapointCodes, question_),
						questionAccessible(question_));
				},
				A2(
					$elm$core$Maybe$andThen,
					$krisajenkins$remotedata$RemoteData$toMaybe,
					A2($turboMaCk$any_dict$Dict$Any$get, questionCode, questions))));
	});
var $author$project$Data$Permissions$p2Audience = F3(
	function (plan, questions, _v0) {
		var expression = _v0.bY;
		return A3(
			$author$project$Data$Audience$Expression$foldr,
			F2(
				function (leaf, permissionsSoFar) {
					return A2(
						$author$project$Data$Permissions$combine,
						permissionsSoFar,
						A3($author$project$Data$Permissions$p2AudienceLeaf, plan, questions, leaf));
				}),
			$author$project$Data$Permissions$default,
			expression);
	});
var $author$project$Data$Permissions$problematicP2Audience = function (id) {
	return _Utils_update(
		$author$project$Data$Permissions$emptyProblematicData,
		{
			cN: $elm$core$Maybe$Just(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(id))
		});
};
var $author$project$Data$Permissions$questionV2 = function (_v0) {
	var accessible = _v0.fc;
	var datapoints = _v0.er;
	var longCode = _v0.k1;
	var inaccessibleQuestion = $author$project$Data$Permissions$problematicQuestion(longCode);
	var atLeastOneAccessibleDatapoint = A2(
		$author$project$Data$Permissions$fromAccessible,
		inaccessibleQuestion,
		A2(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$any,
			function ($) {
				return $.fc;
			},
			datapoints));
	return A2(
		$author$project$Data$Permissions$combine,
		atLeastOneAccessibleDatapoint,
		A2($author$project$Data$Permissions$fromAccessible, inaccessibleQuestion, accessible));
};
var $author$project$Data$Permissions$p2Widget = F4(
	function (plan, questions, audiences, _v0) {
		var content = _v0.U;
		if (content.$ === 1) {
			return $author$project$Data$Permissions$Accessible;
		} else {
			var baseAudience = content.a.aU;
			var data = content.a.cl;
			var questionPermissions = function () {
				if (!data.$) {
					var questionCode = data.a.at;
					return _List_fromArray(
						[
							function () {
							var _v14 = A2($turboMaCk$any_dict$Dict$Any$get, questionCode, questions);
							if ((!_v14.$) && (_v14.a.$ === 3)) {
								var question_ = _v14.a.a;
								return $author$project$Data$Permissions$questionV2(question_);
							} else {
								return $author$project$Data$Permissions$Unknown(
									$author$project$Data$Permissions$problematicQuestion(questionCode));
							}
						}()
						]);
				} else {
					var groups = data.a;
					return A2(
						$elm$core$List$map,
						function (group) {
							var _v15 = A2($turboMaCk$any_dict$Dict$Any$get, group.at, questions);
							if ((!_v15.$) && (_v15.a.$ === 3)) {
								var question_ = _v15.a.a;
								return $author$project$Data$Permissions$questionV2(question_);
							} else {
								return $author$project$Data$Permissions$Unknown(
									$author$project$Data$Permissions$problematicQuestion(group.at));
							}
						},
						$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(groups));
				}
			}();
			var getDatapoint = F2(
				function (questionCode, datapointCode) {
					return A2(
						$elm$core$Maybe$andThen,
						function (_v12) {
							var datapoints = _v12.er;
							return A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
								function (dp) {
									return _Utils_eq(dp.bW, datapointCode);
								},
								datapoints);
						},
						A2(
							$elm$core$Maybe$andThen,
							$krisajenkins$remotedata$RemoteData$toMaybe,
							A2($turboMaCk$any_dict$Dict$Any$get, questionCode, questions)));
				});
			var datapointPermissions = function () {
				if (!data.$) {
					var questionCode = data.a.at;
					var datapointCodes = data.a.hw;
					var _v6 = A2($turboMaCk$any_dict$Dict$Any$get, questionCode, questions);
					if ((!_v6.$) && (_v6.a.$ === 3)) {
						var question = _v6.a.a;
						var currentDatapoints = function () {
							if (!datapointCodes.$) {
								return A2(
									$elm$core$List$map,
									function ($) {
										return $.bW;
									},
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(question.er));
							} else {
								var datapointCodes_ = datapointCodes.a;
								return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(datapointCodes_);
							}
						}();
						return A2(
							$elm$core$List$map,
							function (datapointCode) {
								var _v7 = A2(getDatapoint, questionCode, datapointCode);
								if (_v7.$ === 1) {
									return $author$project$Data$Permissions$Unknown(
										$author$project$Data$Permissions$problematicDatapoint(datapointCode));
								} else {
									var datapoint_ = _v7.a;
									return A2(
										$author$project$Data$Permissions$fromAccessible,
										$author$project$Data$Permissions$problematicDatapoint(datapointCode),
										datapoint_.fc);
								}
							},
							currentDatapoints);
					} else {
						return _List_fromArray(
							[
								$author$project$Data$Permissions$Unknown(
								$author$project$Data$Permissions$problematicQuestion(questionCode))
							]);
					}
				} else {
					var groups = data.a;
					return A2(
						$author$project$Gwi$List$fastConcatMap,
						function (group) {
							var _v9 = A2($turboMaCk$any_dict$Dict$Any$get, group.at, questions);
							if ((!_v9.$) && (_v9.a.$ === 3)) {
								var question = _v9.a.a;
								var currentDatapoints = function () {
									var _v11 = group.er;
									if (!_v11.$) {
										return A2(
											$elm$core$List$map,
											function ($) {
												return $.bW;
											},
											$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(question.er));
									} else {
										var list = _v11.a;
										var datapointCodes = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $elm$core$Tuple$first, list);
										return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(datapointCodes);
									}
								}();
								return A2(
									$elm$core$List$map,
									function (datapointCode) {
										var _v10 = A2(getDatapoint, question.k1, datapointCode);
										if (_v10.$ === 1) {
											return $author$project$Data$Permissions$Unknown(
												$author$project$Data$Permissions$problematicDatapoint(datapointCode));
										} else {
											var datapoint_ = _v10.a;
											return A2(
												$author$project$Data$Permissions$fromAccessible,
												$author$project$Data$Permissions$problematicDatapoint(datapointCode),
												datapoint_.fc);
										}
									},
									currentDatapoints);
							} else {
								return _List_fromArray(
									[
										$author$project$Data$Permissions$Unknown(
										$author$project$Data$Permissions$problematicQuestion(group.at))
									]);
							}
						},
						$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(groups));
				}
			}();
			var baseAudienceId = function () {
				if (baseAudience.$ === 1) {
					var id = baseAudience.a.b;
					return $elm$core$Maybe$Just(id);
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}();
			var baseAudiencePermissions = function () {
				if (baseAudienceId.$ === 1) {
					return $author$project$Data$Permissions$Accessible;
				} else {
					var baseAudienceId_ = baseAudienceId.a;
					var foundAudience = A2(
						$elm$core$Maybe$andThen,
						$turboMaCk$any_dict$Dict$Any$get(baseAudienceId_),
						$krisajenkins$remotedata$RemoteData$toMaybe(audiences));
					if (foundAudience.$ === 1) {
						return $author$project$Data$Permissions$Unknown(
							$author$project$Data$Permissions$problematicP2Audience(baseAudienceId_));
					} else {
						var audience_ = foundAudience.a;
						return A3($author$project$Data$Permissions$p2Audience, plan, questions, audience_);
					}
				}
			}();
			var allPermissions = A2(
				$elm$core$List$cons,
				baseAudiencePermissions,
				_Utils_ap(questionPermissions, datapointPermissions));
			return A3($elm$core$List$foldl, $author$project$Data$Permissions$combine, $author$project$Data$Permissions$default, allPermissions);
		}
	});
var $author$project$Dashboards2$Chart$removeDatapointsWithUnknownPermissions = F3(
	function (flags, store, widget) {
		var filterGroupedData = F2(
			function (unknownData, groups) {
				var accessible = function (code) {
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						true,
						A2(
							$elm$core$Basics$composeR,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$member(code),
							$elm$core$Basics$not),
						unknownData.er);
				};
				return A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
					function (group) {
						var _v4 = group.er;
						if (!_v4.$) {
							return $elm$core$Maybe$Just(group);
						} else {
							var list = _v4.a;
							return A2(
								$elm$core$Maybe$map,
								function (newList) {
									return _Utils_update(
										group,
										{
											er: $author$project$Data$Platform2$Explicit(newList)
										});
								},
								A2(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$filter,
									A2($elm$core$Basics$composeR, $elm$core$Tuple$first, accessible),
									list));
						}
					},
					groups);
			});
		var _v0 = A4($author$project$Data$Permissions$p2Widget, flags.mQ.qw, store.bt, store.d9, widget);
		switch (_v0.$) {
			case 0:
				return $elm$core$Maybe$Just(widget);
			case 1:
				return $elm$core$Maybe$Just(widget);
			default:
				var unknownData = _v0.a;
				var _v1 = widget.U;
				if (!_v1.$) {
					var chartWidget = _v1.a;
					var newData = function () {
						var _v2 = chartWidget.cl;
						if (!_v2.$) {
							var oldData = _v2.a;
							return A2(
								$elm$core$Maybe$map,
								$author$project$Data$Platform2$GroupedData,
								A2(
									$elm$core$Maybe$andThen,
									filterGroupedData(unknownData),
									A2(
										$author$project$Data$Platform2$oldWidgetDataToGroupedWidgetData,
										A2(
											$turboMaCk$any_dict$Dict$Any$filterMap,
											F2(
												function (_v3, v) {
													return $krisajenkins$remotedata$RemoteData$toMaybe(v);
												}),
											store.bt),
										oldData)));
						} else {
							var groups = _v2.a;
							return A2(
								$elm$core$Maybe$map,
								$author$project$Data$Platform2$GroupedData,
								A2(filterGroupedData, unknownData, groups));
						}
					}();
					return A2(
						$elm$core$Maybe$map,
						function (newData_) {
							return _Utils_update(
								widget,
								{
									U: $author$project$Data$Platform2$ChartContent(
										_Utils_update(
											chartWidget,
											{cl: newData_}))
								});
						},
						newData);
				} else {
					return $elm$core$Maybe$Just(widget);
				}
		}
	});
var $elm$core$Dict$sizeHelp = F2(
	function (n, dict) {
		sizeHelp:
		while (true) {
			if (dict.$ === -2) {
				return n;
			} else {
				var left = dict.d;
				var right = dict.e;
				var $temp$n = A2($elm$core$Dict$sizeHelp, n + 1, right),
					$temp$dict = left;
				n = $temp$n;
				dict = $temp$dict;
				continue sizeHelp;
			}
		}
	});
var $elm$core$Dict$size = function (dict) {
	return A2($elm$core$Dict$sizeHelp, 0, dict);
};
var $turboMaCk$any_dict$Dict$Any$size = function (_v0) {
	var dict = _v0.i;
	return $elm$core$Dict$size(dict);
};
var $turboMaCk$any_set$Set$Any$size = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$size(dict);
};
var $elm$core$List$sort = function (xs) {
	return A2($elm$core$List$sortBy, $elm$core$Basics$identity, xs);
};
var $author$project$Dashboards2$UserFilters$toComparable = function (wrapped) {
	var userFilters = wrapped;
	return A2(
		$elm$core$String$join,
		'|',
		_List_fromArray(
			[
				'B:' + function () {
				var _v0 = userFilters.aU;
				if (!_v0.$) {
					return '';
				} else {
					var id = _v0.a.b;
					return $author$project$Data$Id$unwrap(id);
				}
			}(),
				'A:' + A2(
				$elm$core$String$join,
				',',
				$elm$core$List$sort(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.fk;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.b;
								},
								$author$project$Data$Id$unwrap)),
						userFilters.d9))),
				'W:' + A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$map,
					$author$project$Data$Id$unwrap,
					$turboMaCk$any_set$Set$Any$toList(
						$author$project$Dashboards2$UserFilters$waves(wrapped)))),
				'L:' + A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$map,
					$author$project$Data$Id$unwrap,
					$turboMaCk$any_set$Set$Any$toList(
						$author$project$Dashboards2$UserFilters$locations(wrapped))))
			]));
};
var $author$project$RemoteData$Loaded$toMaybe = function (data) {
	_v0$2:
	while (true) {
		switch (data.$) {
			case 3:
				var a = data.a;
				return $elm$core$Maybe$Just(a);
			case 1:
				if (!data.a.$) {
					var a = data.a.a;
					return $elm$core$Maybe$Just(a);
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $author$project$Dashboards2$UserFilters$baseAudienceToMaybe = function (_v0) {
	var baseAudience = _v0.aU;
	if (!baseAudience.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var audience = baseAudience.a;
		return $elm$core$Maybe$Just(audience);
	}
};
var $author$project$Dashboards2$UserFilters$toQueryParamsAudience = function (_v0) {
	var id = _v0.b;
	var name = _v0.ld;
	var expression = _v0.bY;
	return {bY: expression, oN: $elm$core$Maybe$Nothing, b: id, ld: name};
};
var $author$project$Dashboards2$UserFilters$toSimpleFilters = function (wrapped) {
	var userFilters = wrapped;
	return {
		d9: A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fk;
				},
				$author$project$Dashboards2$UserFilters$toQueryParamsAudience),
			userFilters.d9),
		aU: A2(
			$elm$core$Maybe$map,
			$author$project$Dashboards2$UserFilters$toQueryParamsAudience,
			$author$project$Dashboards2$UserFilters$baseAudienceToMaybe(wrapped)),
		cD: $turboMaCk$any_set$Set$Any$toList(
			$author$project$Dashboards2$UserFilters$locations(wrapped)),
		dX: $turboMaCk$any_set$Set$Any$toList(
			$author$project$Dashboards2$UserFilters$waves(wrapped))
	};
};
var $author$project$RemoteData$Loaded$withDefault = F2(
	function (_default, data) {
		_v0$2:
		while (true) {
			switch (data.$) {
				case 3:
					var x = data.a;
					return x;
				case 1:
					if (!data.a.$) {
						var x = data.a.a;
						return x;
					} else {
						break _v0$2;
					}
				default:
					break _v0$2;
			}
		}
		return _default;
	});
var $author$project$Dashboards2$Chart$requestsStateCounts = F5(
	function (flags, userFilters, store, widget, model) {
		var paramsListForWidget = A2(
			$elm$core$Maybe$map,
			$elm$core$Tuple$first,
			A3(
				$author$project$Data$Calc$Platform2$paramsFromWidget,
				store,
				$author$project$Dashboards2$UserFilters$toSimpleFilters(userFilters),
				A2(
					$elm$core$Maybe$withDefault,
					widget,
					A3($author$project$Dashboards2$Chart$removeDatapointsWithUnknownPermissions, flags, store, widget))));
		var getCounts = function (data) {
			var _v3 = _Utils_Tuple2(
				paramsListForWidget,
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$any_set$Set$Any$size,
					A2(
						$turboMaCk$any_dict$Dict$Any$get,
						userFilters,
						A2(
							$author$project$RemoteData$Loaded$withDefault,
							$turboMaCk$any_dict$Dict$Any$empty($author$project$Dashboards2$UserFilters$toComparable),
							A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$first, data)))));
			if (!_v3.a.$) {
				if (!_v3.b.$) {
					var list = _v3.a.a;
					var count = _v3.b.a;
					return $elm$core$Maybe$Just(
						{
							eF: $turboMaCk$non_empty_list_alias$List$NonEmpty$length(list) - count
						});
				} else {
					var list = _v3.a.a;
					var _v4 = _v3.b;
					return $elm$core$Maybe$Just(
						{
							eF: $turboMaCk$non_empty_list_alias$List$NonEmpty$length(list)
						});
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		};
		var _v0 = model.h;
		switch (_v0.$) {
			case 0:
				var data = _v0.a.cl;
				return getCounts(data);
			case 2:
				var statCard = _v0.a;
				return A2(
					$elm$core$Maybe$map,
					function (_v1) {
						var data = _v1.a;
						var _v2 = A2($turboMaCk$any_dict$Dict$Any$get, userFilters, data);
						if (!_v2.$) {
							return {eF: 0};
						} else {
							return {eF: 1};
						}
					},
					$author$project$RemoteData$Loaded$toMaybe(statCard));
			case 1:
				var data = _v0.a.cl;
				return getCounts(data);
			default:
				var data = _v0.b.cl;
				return getCounts(data);
		}
	});
var $author$project$Dashboards2$Widget$requestsStateCounts = F5(
	function (flags, userFilters, store, widget, model) {
		return A2(
			$elm$core$Maybe$andThen,
			A4($author$project$Dashboards2$Chart$requestsStateCounts, flags, userFilters, store, widget),
			$author$project$Dashboards2$Widget$modelToChartModel(model));
	});
var $author$project$Dashboards2$processWidgetsRequests = F6(
	function (config, flags, store, dashboard, _v0, _v1) {
		var exportRequested = _v0.bi;
		var listAllMsg = _v1.a;
		var _v2 = _v1.b;
		var model = _v2.a;
		var cmd_ = _v2.b;
		var requestsStateCounts = A2(
			$elm$core$Maybe$andThen,
			function (userFilters) {
				return A6(
					$author$project$Dashboards2$foldWidgets,
					F3(
						function (widget, widgetModel, acc) {
							var _v5 = _Utils_Tuple2(
								acc,
								A5($author$project$Dashboards2$Widget$requestsStateCounts, flags, userFilters, store, widget, widgetModel));
							if (!_v5.b.$) {
								if (!_v5.a.$) {
									var countsSoFar = _v5.a.a;
									var countsForWidget = _v5.b.a;
									return $elm$core$Maybe$Just(
										_Utils_update(
											countsSoFar,
											{eF: countsSoFar.eF + countsForWidget.eF}));
								} else {
									var _v6 = _v5.a;
									var countsForWidget = _v5.b.a;
									return $elm$core$Maybe$Just(countsForWidget);
								}
							} else {
								var _v7 = _v5.b;
								return acc;
							}
						}),
					$elm$core$Maybe$Nothing,
					{
						ey: $author$project$Dashboards2$isEditMode(model.o)
					},
					dashboard,
					store,
					$author$project$Dashboards2$Detail$currentWidgets(model));
			},
			$author$project$Dashboards2$getUserFilters(model));
		var modelWithCounts = _Utils_update(
			model,
			{
				a2: exportRequested ? A2(
					$elm$core$Maybe$map,
					function (_v4) {
						var loading = _v4.eF;
						return {h6: 0, mI: loading};
					},
					requestsStateCounts) : $elm$core$Maybe$Nothing
			});
		var anyLoading = function () {
			if (!requestsStateCounts.$) {
				var loading = requestsStateCounts.a.eF;
				return loading > 0;
			} else {
				return false;
			}
		}();
		return ($elm$core$List$isEmpty(listAllMsg) && ((!anyLoading) && exportRequested)) ? A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
			A2($elm$core$Platform$Cmd$map, config.a, cmd_),
			_Utils_Tuple2(
				model,
				A2(
					$elm$core$Task$perform,
					config.a,
					A2($elm$core$Task$map, $author$project$Dashboards2$Export, $elm$time$Time$now)))) : A2(
			$turboMaCk$glue$Glue$map,
			config.a,
			A3(
				$elm$core$List$foldl,
				$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
				(_Utils_cmp(
					$elm$core$List$length(listAllMsg),
					$author$project$Dashboards2$maxRequestsLimit) > 0) ? _Utils_Tuple2(
					_Utils_update(
						modelWithCounts,
						{
							dh: A3(
								$elm$core$List$foldl,
								$turboMaCk$queue$Queue$enqueue,
								model.dh,
								A2($elm$core$List$drop, $author$project$Dashboards2$maxRequestsLimit, listAllMsg))
						}),
					cmd_) : _Utils_Tuple2(modelWithCounts, $elm$core$Platform$Cmd$none),
				A2($elm$core$List$take, $author$project$Dashboards2$maxRequestsLimit, listAllMsg)));
	});
var $author$project$Dashboards2$Router$NewDashboard = {$: 2};
var $author$project$Dashboards2$Router$getDashboardId = function (r) {
	switch (r.$) {
		case 1:
			var id = r.a;
			return $elm$core$Maybe$Just(id);
		case 0:
			return $elm$core$Maybe$Nothing;
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Dashboards2$routeToSavedDashboard = F4(
	function (flags, route, store, model) {
		return _Utils_eq(route, $author$project$Dashboards2$Router$NewDashboard) ? A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				A2($author$project$Dashboards2$getNewEmptyDashboard, flags, store),
				$krisajenkins$remotedata$RemoteData$toMaybe),
			model.dk) : A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return $krisajenkins$remotedata$RemoteData$toMaybe(
					A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
			},
			$author$project$Dashboards2$Router$getDashboardId(route));
	});
var $author$project$UndoRedo$updateCurrent = F2(
	function (updateState, _v0) {
		var undoRedo = _v0;
		return _Utils_update(
			undoRedo,
			{
				aq: A2($elm$core$Tuple$mapSecond, updateState, undoRedo.aq)
			});
	});
var $author$project$Dashboards2$updateWidgets = F2(
	function (updateWidgetsFn, model) {
		return _Utils_update(
			model,
			{
				G: A2(
					$author$project$UndoRedo$updateCurrent,
					function (undoRedo) {
						return _Utils_update(
							undoRedo,
							{
								g: updateWidgetsFn(undoRedo.g)
							});
					},
					model.G)
			});
	});
var $turboMaCk$glue$Glue$updateWith = F3(
	function (_v0, fc, _v1) {
		var rec = _v0;
		var model = _v1.a;
		var cmd = _v1.b;
		var _v2 = fc(
			rec.oS(model));
		var subModel = _v2.a;
		var subCmd = _v2.b;
		return _Utils_Tuple2(
			A2(rec.rg, subModel, model),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, rec.a, subCmd),
						cmd
					])));
	});
var $GlobalWebIndex$cmd_extra$Cmd$Extra$with = F2(
	function (cmd, model) {
		return _Utils_Tuple2(model, cmd);
	});
var $author$project$Dashboards2$requestDataForAllWidgets_ = F7(
	function (widgetFetchFn, config, flags, route, store, _v0, model) {
		var exportRequested = _v0.bi;
		var updateModel = F3(
			function (widget, widgetModel, _v3) {
				var lstMsg = _v3.a;
				var accModel = _v3.b;
				var _v1 = A8(
					widgetFetchFn,
					$author$project$Dashboards2$WidgetMsg(widget.b),
					{l: $author$project$Dashboards2$StoreActionMany},
					$author$project$Dashboards2$getUserFilters(model),
					flags,
					store,
					widget,
					{
						oQ: exportRequested,
						ez: $author$project$Dashboards2$isEditMode(model.o)
					},
					widgetModel);
				var listMsgs = _v1.a;
				var _v2 = _v1.b;
				var newWidgetModel = _v2.a;
				var updatedMsgs = _v2.b;
				return _Utils_Tuple2(
					_Utils_ap(lstMsg, listMsgs),
					A3(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Dashboards2$updateWidgets(
								A2($turboMaCk$any_dict$Dict$Any$insert, widget.b, newWidgetModel)),
							$GlobalWebIndex$cmd_extra$Cmd$Extra$with(updatedMsgs)),
						accModel));
			});
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$map,
				function (dashboard) {
					return A6(
						$author$project$Dashboards2$processWidgetsRequests,
						config,
						flags,
						store,
						dashboard,
						{bi: exportRequested},
						A6(
							$author$project$Dashboards2$foldWidgets,
							updateModel,
							_Utils_Tuple2(
								_List_Nil,
								_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)),
							{
								ey: $author$project$Dashboards2$isEditMode(model.o)
							},
							dashboard,
							store,
							$author$project$Dashboards2$Detail$currentWidgets(model)));
				},
				A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model)));
	});
var $author$project$RemoteData$Loaded$isNotAsked = function (data) {
	if (!data.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Dashboards2$Chart$isNotAsked = function (_v0) {
	var chartData = _v0.h;
	switch (chartData.$) {
		case 0:
			var data = chartData.a.cl;
			return $author$project$RemoteData$Loaded$isNotAsked(data);
		case 1:
			var data = chartData.a.cl;
			return $author$project$RemoteData$Loaded$isNotAsked(data);
		case 2:
			var webdataStatCardModel = chartData.a;
			return $author$project$RemoteData$Loaded$isNotAsked(webdataStatCardModel);
		default:
			var data = chartData.b.cl;
			return $author$project$RemoteData$Loaded$isNotAsked(data);
	}
};
var $GlobalWebIndex$cmd_extra$Cmd$Extra$pure = function (model) {
	return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
};
var $author$project$Store$Platform2$UpdateStore = function (a) {
	return {$: 28, a: a};
};
var $author$project$Dashboards2$Widget$DataForWidgetReceived = F5(
	function (a, b, c, d, e) {
		return {$: 2, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Dashboards2$Widget$DataForWidgetReceivedViewOnly = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2$Analytics$WidgetAccessDenied = function (a) {
	return {$: 6, a: a};
};
var $author$project$Analytics$Place$Dashboards = 4;
var $author$project$Data$Platform2$PublicDashboard = {$: 3};
var $author$project$Analytics$Common$commaSeparated = function (toString) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$List$map(toString),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$join(','),
			$elm$json$Json$Encode$string));
};
var $author$project$Dashboards2$Analytics$basicAttributes = function (r) {
	var userType = r.nM(23) ? 'gwi-creator' : (r.nM(24) ? 'non-gwi-creator' : 'normal-user');
	var filters = A2(
		$elm$core$List$filterMap,
		$elm$core$Basics$identity,
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$map,
				function (id) {
					return _Utils_Tuple2(
						'base_audience',
						$author$project$Data$Id$encode(id));
				},
				r.ep.cl.C.aU),
				A2(
				$elm$core$Maybe$map,
				function (ids) {
					return _Utils_Tuple2(
						'audiences',
						A2($author$project$Analytics$Common$commaSeparated, $author$project$Data$Id$unwrap, ids));
				},
				r.ep.cl.C.d9),
				A2(
				$elm$core$Maybe$map,
				function (ids) {
					return _Utils_Tuple2(
						'waves',
						A2($author$project$Analytics$Common$commaSeparated, $author$project$Data$Id$unwrap, ids));
				},
				r.ep.cl.C.dX),
				A2(
				$elm$core$Maybe$map,
				function (ids) {
					return _Utils_Tuple2(
						'locations',
						A2($author$project$Analytics$Common$commaSeparated, $author$project$Data$Id$unwrap, ids));
				},
				r.ep.cl.C.cD)
			]));
	var filtersEncoded = $elm$core$List$isEmpty(filters) ? $elm$json$Json$Encode$string('N/A') : $elm$json$Json$Encode$object(filters);
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'dashboard_id',
			$author$project$Data$Id$encode(r.ep.b)),
			_Utils_Tuple2(
			'dashboard_name',
			$elm$json$Json$Encode$string(r.ep.ld)),
			_Utils_Tuple2(
			'user_type',
			$elm$json$Json$Encode$string(userType)),
			_Utils_Tuple2(
			'public_dashboard',
			$elm$json$Json$Encode$bool(
				_Utils_eq(r.ep.ah, $author$project$Data$Platform2$PublicDashboard))),
			_Utils_Tuple2('filters', filtersEncoded)
		]);
};
var $author$project$Analytics$Place$encode = function (place) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (place) {
				case 0:
					return 'audience_builder';
				case 1:
					return 'chart_builder';
				case 2:
					return 'chart_builder_no_data';
				case 3:
					return 'cotw';
				case 4:
					return 'dashboards';
				case 6:
					return 'dashboard_charts_browser';
				case 5:
					return 'dashboard_builder';
				case 7:
					return 'error_dialog';
				case 8:
					return 'filters_panel';
				case 9:
					return 'filters_panel_audiences';
				case 10:
					return 'filters_panel_locations';
				case 11:
					return 'filters_panel_segmentation';
				case 12:
					return 'filters_panel_waves';
				case 13:
					return 'global-search';
				case 14:
					return 'audience';
				case 15:
					return 'saved_query';
				case 16:
					return 'infographics';
				case 17:
					return 'left_hand_menu';
				case 18:
					return 'query_builder';
				case 19:
					return 'query_builder_base';
				case 20:
					return 'query_builder_list';
				case 21:
					return 'question_information_banner';
				case 22:
					return 'reports';
				case 23:
					return 'saved_bookmark';
				case 24:
					return 'tv_planner';
				case 25:
					return 'unknown';
				case 26:
					return 'upsell_modal';
				case 27:
					return 'user_settings_organisation';
				case 28:
					return 'user_settings_overview';
				case 29:
					return 'user_settings_security';
				case 30:
					return 'welcome_screen';
				case 31:
					return 'help_me_choose_modal';
				case 32:
					return 'change_chart_type_dropdown';
				case 33:
					return 'change_metric_dropdown';
				case 34:
					return 'bar';
				case 35:
					return 'tile';
				default:
					return 'persona_cards';
			}
		}());
};
var $author$project$D3Charts$Dashboards$ChartType$toString = function (type_) {
	switch (type_) {
		case 0:
			return 'data_table';
		case 1:
			return 'diverging_bar_chart';
		case 2:
			return 'donut_chart';
		case 3:
			return 'horizontal_bar_chart';
		case 4:
			return 'line_chart';
		case 5:
			return 'pie_chart';
		case 6:
			return 'pie_radar_chart';
		case 7:
			return 'radar_chart';
		case 8:
			return 'radial_bar_chart';
		case 9:
			return 'stat_card';
		case 10:
			return 'stat_card_colored';
		default:
			return 'vertical_bar_chart';
	}
};
var $author$project$D3Charts$Dashboards$ChartType$encode = function (type_) {
	return $elm$json$Json$Encode$string(
		$author$project$D3Charts$Dashboards$ChartType$toString(type_));
};
var $author$project$Data$Metric$toString = function (metric) {
	switch (metric) {
		case 0:
			return 'percentage';
		case 1:
			return 'horizontal_percentage';
		case 2:
			return 'weighted_universe_count';
		case 3:
			return 'index';
		default:
			return 'responses_count';
	}
};
var $author$project$Data$Metric$encode = function (metric) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Metric$toString(metric));
};
var $author$project$Data$Platform2$RichTextWidget$encodeMainStyle = function (style) {
	return $elm$json$Json$Encode$object(
		function () {
			switch (style.$) {
				case 0:
					var align = style.a.fe;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'style_type',
							$elm$json$Json$Encode$string('Normal')),
							_Utils_Tuple2(
							'align',
							$elm$json$Json$Encode$string(
								function () {
									switch (align) {
										case 0:
											return 'Left';
										case 1:
											return 'Center';
										default:
											return 'Right';
									}
								}()))
						]);
				case 1:
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'style_type',
							$elm$json$Json$Encode$string('BulletpointList'))
						]);
				default:
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'style_type',
							$elm$json$Json$Encode$string('Quote'))
						]);
			}
		}());
};
var $author$project$Data$Platform2$RichTextWidget$encodeSize = function (size) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (size) {
				case 0:
					return 'Title';
				case 1:
					return 'Heading1';
				case 2:
					return 'Heading2';
				default:
					return 'Body';
			}
		}());
};
var $author$project$Data$Platform2$RichTextWidget$encodeStyle = function (style) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'size',
				$author$project$Data$Platform2$RichTextWidget$encodeSize(style.cX)),
				_Utils_Tuple2(
				'bold',
				$elm$json$Json$Encode$bool(style.de)),
				_Utils_Tuple2(
				'underline',
				$elm$json$Json$Encode$bool(style.dU)),
				_Utils_Tuple2(
				'main_style',
				$author$project$Data$Platform2$RichTextWidget$encodeMainStyle(style.ae))
			]));
};
var $author$project$Data$Platform2$RichTextWidget$encodeParagraph = function (paragraph) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'content',
				$elm$json$Json$Encode$string(paragraph.U)),
				_Utils_Tuple2(
				'style',
				$author$project$Data$Platform2$RichTextWidget$encodeStyle(paragraph.k))
			]));
};
var $author$project$Data$Platform2$RichTextWidget$encode = function (richText) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'paragraphs',
				A2($turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList, $author$project$Data$Platform2$RichTextWidget$encodeParagraph, richText.qt))
			]));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$core$String$cons = _String_cons;
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$encode = A2($elm$core$Basics$composeR, $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime, $elm$json$Json$Encode$string);
var $turboMaCk$any_set$Set$Any$encode = function (encoder) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$json$Json$Encode$list(encoder),
		$turboMaCk$any_set$Set$Any$toList);
};
var $author$project$Data$User$encodeFeature = A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, $author$project$Data$User$featureToString);
var $author$project$Data$User$encode = function (user) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(
					A2(
						$elm$core$Maybe$withDefault,
						0,
						$elm$core$String$toInt(user.b)))),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(user.j)),
				_Utils_Tuple2(
				'first_name',
				$elm$json$Json$Encode$string(user.ke)),
				_Utils_Tuple2(
				'last_name',
				$elm$json$Json$Encode$string(user.pA)),
				_Utils_Tuple2(
				'organisation_id',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, user.m)),
				_Utils_Tuple2(
				'organisation_name',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, user.bL)),
				_Utils_Tuple2(
				'country_name',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, user.jP)),
				_Utils_Tuple2(
				'city_name',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, user.jG)),
				_Utils_Tuple2(
				'job_title',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, user.kT)),
				_Utils_Tuple2(
				'plan_handle',
				$elm$json$Json$Encode$string(
					$author$project$Data$User$planToString(user.qw))),
				_Utils_Tuple2(
				'customer_features',
				A2($turboMaCk$any_set$Set$Any$encode, $author$project$Data$User$encodeFeature, user.jT)),
				_Utils_Tuple2(
				'industry',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, user.kA)),
				_Utils_Tuple2(
				'saw_onboarding',
				$elm$json$Json$Encode$bool(user.lT)),
				_Utils_Tuple2(
				'access_start',
				$rtfeldman$elm_iso8601_date_strings$Iso8601$encode(user.i9))
			]));
};
var $author$project$Data$Platform2$AuthoredAudience = 1;
var $author$project$Data$Platform2$CuratedAudience = 0;
var $author$project$Data$Platform2$encodeAudienceStatesForAnalytics = function (flags) {
	return $elm$json$Json$Encode$string(
		A2($turboMaCk$any_set$Set$Any$member, 1, flags) ? 'user' : (A2($turboMaCk$any_set$Set$Any$member, 0, flags) ? 'curated' : ''));
};
var $author$project$Gwi$Json$Encode$encodeBoolAsString = function (cond) {
	return cond ? $elm$json$Json$Encode$string('yes') : $elm$json$Json$Encode$string('no');
};
var $author$project$Dashboards2$Analytics$encodeDatapointSort = function (sort) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (sort) {
				case 0:
					return 'descending';
				case 1:
					return 'ascending';
				case 3:
					return 'default';
				default:
					return 'alphabetical';
			}
		}());
};
var $author$project$Data$Platform2$encodeInsightType = function (type_) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (type_) {
				case 1:
					return 'report';
				case 0:
					return 'infographic';
				case 2:
					return 'chart';
				default:
					return 'powerpoint';
			}
		}());
};
var $author$project$Data$Labels$p2Separator = ' » ';
var $author$project$Dashboards2$Chart$AttributeName$concatSuffixNames = function (names) {
	if (!names.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		if (!names.b.b) {
			var single = names.a;
			return $elm$core$Maybe$Just(
				_Utils_ap($author$project$Data$Labels$p2Separator, single));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $author$project$Data$Calc$Platform2$encodeNormalizedQuestionCode = function (questionCode) {
	var _v0 = $author$project$Data$Labels$splitQuestionCode(questionCode);
	var namespaceCode = _v0.a;
	var shortQuestionCode = _v0.b;
	return $elm$json$Json$Encode$string(
		$author$project$Data$Id$unwrap(namespaceCode) + ('.' + $author$project$Data$Id$unwrap(shortQuestionCode)));
};
var $author$project$Analytics$Common$list = function (toString) {
	return $elm$json$Json$Encode$list(
		A2($elm$core$Basics$composeL, $elm$json$Json$Encode$string, toString));
};
var $elm_community$list_extra$List$Extra$uniqueHelp = F4(
	function (f, existing, remaining, accumulator) {
		uniqueHelp:
		while (true) {
			if (!remaining.b) {
				return $elm$core$List$reverse(accumulator);
			} else {
				var first = remaining.a;
				var rest = remaining.b;
				var computedFirst = f(first);
				if (A2($elm$core$List$member, computedFirst, existing)) {
					var $temp$f = f,
						$temp$existing = existing,
						$temp$remaining = rest,
						$temp$accumulator = accumulator;
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				} else {
					var $temp$f = f,
						$temp$existing = A2($elm$core$List$cons, computedFirst, existing),
						$temp$remaining = rest,
						$temp$accumulator = A2($elm$core$List$cons, first, accumulator);
					f = $temp$f;
					existing = $temp$existing;
					remaining = $temp$remaining;
					accumulator = $temp$accumulator;
					continue uniqueHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$unique = function (list) {
	return A4($elm_community$list_extra$List$Extra$uniqueHelp, $elm$core$Basics$identity, _List_Nil, list, _List_Nil);
};
var $elm_community$list_extra$List$Extra$uniqueBy = F2(
	function (f, list) {
		return A4($elm_community$list_extra$List$Extra$uniqueHelp, f, _List_Nil, list, _List_Nil);
	});
var $author$project$Dashboards2$Analytics$encodeWidgetQuestionsQueryParamsForAnalytics = function (qParams) {
	var getList = function (getter) {
		return A2(
			$author$project$Analytics$Common$list,
			getter,
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				getter,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(qParams)));
	};
	var getCommaSeparated = function (getter) {
		return A2(
			$author$project$Analytics$Common$commaSeparated,
			getter,
			A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				getter,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(qParams)));
	};
	var getAll = function (getter) {
		return $elm_community$list_extra$List$Extra$unique(
			A2(
				$author$project$Gwi$List$fastConcatMap,
				getter,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(qParams)));
	};
	var baseAudience = $turboMaCk$non_empty_list_alias$List$NonEmpty$head(qParams).aU;
	var allWaves = A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		function ($) {
			return $.bW;
		},
		A2(
			$author$project$Gwi$List$fastConcatMap,
			function ($) {
				return $.dX;
			},
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(qParams)));
	var allSegments = getAll(
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.nh;
			},
			$elm$core$Maybe$withDefault(_List_Nil)));
	var allLocations = A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		function ($) {
			return $.bW;
		},
		A2(
			$author$project$Gwi$List$fastConcatMap,
			function ($) {
				return $.cD;
			},
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(qParams)));
	var allDatapoints = A2(
		$author$project$Gwi$List$fastConcatMap,
		function ($) {
			return $.er;
		},
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(qParams));
	var allDatapointNames = A2(
		$author$project$Gwi$List$fastConcatMap,
		function (_v0) {
			var datapoints = _v0.er;
			var suffixes = _v0.rI;
			var _v1 = $author$project$Dashboards2$Chart$AttributeName$concatSuffixNames(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.ld;
					},
					suffixes));
			if (!_v1.$) {
				var nameSuffix = _v1.a;
				return A2(
					$elm$core$List$map,
					function (_v2) {
						var name = _v2.ld;
						return _Utils_ap(name, nameSuffix);
					},
					datapoints);
			} else {
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.ld;
					},
					datapoints);
			}
		},
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(qParams));
	var allAudiences = getAll(
		function ($) {
			return $.d9;
		});
	return _List_fromArray(
		[
			_Utils_Tuple2(
			'Widget_question_name',
			getCommaSeparated(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gA;
					},
					function ($) {
						return $.ld;
					}))),
			_Utils_Tuple2(
			'Widget_question_name_list',
			getList(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gA;
					},
					function ($) {
						return $.ld;
					}))),
			_Utils_Tuple2(
			'Widget_question',
			getCommaSeparated(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gA;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bW;
						},
						$author$project$Data$Id$unwrap)))),
			_Utils_Tuple2(
			'Widget_question_list',
			getList(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.gA;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bW;
						},
						$author$project$Data$Id$unwrap)))),
			_Utils_Tuple2(
			'Widget_data_points',
			A2(
				$author$project$Analytics$Common$commaSeparated,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bW;
					},
					$author$project$Data$Id$unwrap),
				allDatapoints)),
			_Utils_Tuple2(
			'Widget_data_points_name',
			A2($author$project$Analytics$Common$commaSeparated, $elm$core$Basics$identity, allDatapointNames)),
			_Utils_Tuple2(
			'Widget_data_points_name_list',
			A2($author$project$Analytics$Common$list, $elm$core$Basics$identity, allDatapointNames)),
			_Utils_Tuple2(
			'Data_points_count',
			$elm$json$Json$Encode$int(
				$elm$core$List$length(allDatapoints))),
			_Utils_Tuple2(
			'audiences',
			A2(
				$author$project$Analytics$Common$commaSeparated,
				function ($) {
					return $.ld;
				},
				allAudiences)),
			_Utils_Tuple2(
			'audiences_list',
			A2(
				$author$project$Analytics$Common$list,
				function ($) {
					return $.ld;
				},
				allAudiences)),
			_Utils_Tuple2(
			'locations',
			A2(
				$author$project$Analytics$Common$commaSeparated,
				function ($) {
					return $.ld;
				},
				allLocations)),
			_Utils_Tuple2(
			'locations_list',
			A2(
				$author$project$Analytics$Common$list,
				function ($) {
					return $.ld;
				},
				allLocations)),
			_Utils_Tuple2(
			'waves',
			A2(
				$author$project$Analytics$Common$commaSeparated,
				function ($) {
					return $.ld;
				},
				allWaves)),
			_Utils_Tuple2(
			'waves_list',
			A2(
				$author$project$Analytics$Common$list,
				function ($) {
					return $.ld;
				},
				allWaves)),
			_Utils_Tuple2(
			'segments',
			A2(
				$author$project$Analytics$Common$commaSeparated,
				function ($) {
					return $.ld;
				},
				allSegments)),
			_Utils_Tuple2(
			'segments_list',
			A2(
				$author$project$Analytics$Common$list,
				function ($) {
					return $.ld;
				},
				allSegments)),
			_Utils_Tuple2(
			'rebase_on_selected_segments',
			$elm$json$Json$Encode$bool(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$head(qParams).qF)),
			_Utils_Tuple2(
			'base_audience_name',
			$elm$json$Json$Encode$string(
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					'n/a',
					function ($) {
						return $.ld;
					},
					baseAudience))),
			_Utils_Tuple2(
			'base_audience_id',
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$json$Json$Encode$string('n/a'),
				A2(
					$elm$core$Basics$composeL,
					$author$project$Data$Id$encode,
					function ($) {
						return $.b;
					}),
				baseAudience)),
			_Utils_Tuple2(
			'base_audience_type',
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$json$Json$Encode$string('n/a'),
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$json$Json$Encode$string('view only user n/a'),
						$author$project$Data$Platform2$encodeAudienceStatesForAnalytics),
					function ($) {
						return $.oN;
					}),
				baseAudience)),
			_Utils_Tuple2(
			'audience_questions',
			A2(
				$elm$json$Json$Encode$list,
				$author$project$Data$Calc$Platform2$encodeNormalizedQuestionCode,
				getAll(
					function ($) {
						return $.nz;
					}))),
			_Utils_Tuple2(
			'audience_datapoints',
			A2(
				$author$project$Analytics$Common$list,
				$author$project$Data$Id$unwrap,
				getAll(
					function ($) {
						return $.nx;
					})))
		]);
};
var $author$project$Dashboards2$Analytics$withChartType = A2(
	$elm$core$Basics$composeR,
	$author$project$Data$Platform2$getChartWidget,
	A2(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Basics$identity,
		function (_v0) {
			var chartType = _v0.aI;
			return $elm$core$List$cons(
				_Utils_Tuple2(
					'widget_chart_type',
					$author$project$D3Charts$Dashboards$ChartType$encode(chartType)));
		}));
var $author$project$Dashboards2$Analytics$encodeEvent = function (event) {
	switch (event.$) {
		case 0:
			var widget = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Data Table Shown',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'widget_id',
							$author$project$Data$Id$encode(widget.b)),
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							function (_v1) {
								var metric = _v1.dB;
								var data = _v1.cl;
								if (!data.$) {
									var questionCode = data.a.at;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'widget_metric_name',
											$author$project$Data$Metric$encode(metric)),
											_Utils_Tuple2(
											'widget_question_codes',
											$author$project$Data$Id$encode(questionCode))
										]);
								} else {
									var groups = data.a;
									return _List_fromArray(
										[
											_Utils_Tuple2(
											'widget_metric_name',
											$author$project$Data$Metric$encode(metric)),
											_Utils_Tuple2(
											'widget_question_codes',
											A2(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList,
												A2(
													$elm$core$Basics$composeL,
													$author$project$Data$Id$encode,
													function ($) {
														return $.at;
													}),
												groups))
										]);
								}
							},
							$author$project$Data$Platform2$getChartWidget(widget)))));
		case 1:
			var dashboard = event.a;
			var widget = event.b;
			var chartWidget = event.c;
			var question = event.d;
			var editMode = event.e;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Question Opened',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(dashboard.b)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(dashboard.ld)),
							_Utils_Tuple2(
							'widget_id',
							$author$project$Data$Id$encode(widget.b)),
							_Utils_Tuple2(
							'widget_name',
							$elm$json$Json$Encode$string(chartWidget.ld)),
							_Utils_Tuple2(
							'question_name',
							$elm$json$Json$Encode$string(question.ld)),
							_Utils_Tuple2(
							'question_code',
							$author$project$Data$Id$encode(question.bW)),
							_Utils_Tuple2(
							'place',
							$author$project$Analytics$Place$encode(4)),
							_Utils_Tuple2(
							'edit_mode',
							$elm$json$Json$Encode$bool(editMode))
						])));
		case 6:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget Access Denied',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC)),
							_Utils_Tuple2(
							'widget_id',
							$author$project$Data$Id$encode(r.sj)),
							_Utils_Tuple2(
							'widget_name',
							$elm$json$Json$Encode$string(r.dZ)),
							_Utils_Tuple2(
							'question_id',
							$author$project$Data$Id$encode(r.at)),
							_Utils_Tuple2(
							'reason',
							$elm$json$Json$Encode$string('Question unavailable'))
						])));
		case 7:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Page Flipped',
				$elm$json$Json$Encode$object(
					A2(
						$author$project$Dashboards2$Analytics$withChartType,
						r.bO,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'dashboard_id',
								$author$project$Data$Id$encode(r.ep.b)),
								_Utils_Tuple2(
								'dashboard_name',
								$elm$json$Json$Encode$string(r.ep.ld)),
								_Utils_Tuple2(
								'widget_id',
								$author$project$Data$Id$encode(r.bO.b)),
								_Utils_Tuple2(
								'widget_name',
								$elm$json$Json$Encode$string(r.dg.ld)),
								_Utils_Tuple2(
								'widget_question_codes',
								A2(
									$elm$json$Json$Encode$list,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Data$Id$encode,
										function ($) {
											return $.bW;
										}),
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(r.bt))),
								_Utils_Tuple2(
								'widget_question_names',
								A2(
									$elm$json$Json$Encode$list,
									A2(
										$elm$core$Basics$composeL,
										$elm$json$Json$Encode$string,
										function ($) {
											return $.ld;
										}),
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(r.bt))),
								_Utils_Tuple2(
								'page',
								$elm$json$Json$Encode$int(r.qs + 1))
							]))));
		case 8:
			var dashboard = event.a;
			var chartType = event.b;
			var questions = event.c;
			var datapoint = event.d;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Datapoint Highlighted',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(dashboard.b)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(dashboard.ld)),
							_Utils_Tuple2(
							'widget_question_codes',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Data$Id$encode,
									function ($) {
										return $.bW;
									}),
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(questions))),
							_Utils_Tuple2(
							'widget_question_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeL,
									$elm$json$Json$Encode$string,
									function ($) {
										return $.ld;
									}),
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(questions))),
							_Utils_Tuple2(
							'widget_chart_type',
							$author$project$D3Charts$Dashboards$ChartType$encode(chartType)),
							_Utils_Tuple2(
							'datapoint_id',
							$author$project$Data$Id$encode(datapoint.bW)),
							_Utils_Tuple2(
							'datapoint_name',
							$elm$json$Json$Encode$string(datapoint.ld))
						])));
		case 9:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Wave Highlighted',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.ep.b)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.ep.ld)),
							_Utils_Tuple2(
							'widget_question_codes',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeL,
									$author$project$Data$Id$encode,
									function ($) {
										return $.bW;
									}),
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(r.bt))),
							_Utils_Tuple2(
							'widget_question_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeL,
									$elm$json$Json$Encode$string,
									function ($) {
										return $.ld;
									}),
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(r.bt))),
							_Utils_Tuple2(
							'widget_chart_type',
							$author$project$D3Charts$Dashboards$ChartType$encode(r.aI)),
							_Utils_Tuple2(
							'wave',
							$elm$json$Json$Encode$string(r.sc))
						])));
		case 10:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Created',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string('N/A')),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'place',
							$author$project$Analytics$Place$encode(r.iq))
						])));
		case 11:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - First change',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string('N/A')),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0))
						])));
		case 12:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Opened',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC)),
							_Utils_Tuple2(
							'datasets',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeL,
									$elm$json$Json$Encode$string,
									function ($) {
										return $.ld;
									}),
								r.es)),
							_Utils_Tuple2(
							'public_dashboard',
							$elm$json$Json$Encode$bool(r.pp)),
							_Utils_Tuple2(
							'is_shared',
							$author$project$Gwi$Json$Encode$encodeBoolAsString(r.pw)),
							_Utils_Tuple2(
							'is_owner',
							$author$project$Gwi$Json$Encode$encodeBoolAsString(r.h2)),
							_Utils_Tuple2(
							'datasets_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.es))),
							_Utils_Tuple2(
							'app',
							$elm$json$Json$Encode$string(r.be)),
							_Utils_Tuple2(
							'audiences_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								r.d9)),
							_Utils_Tuple2(
							'audiences_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.d9))),
							_Utils_Tuple2(
							'waves',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, r.dX)),
							_Utils_Tuple2(
							'waves_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.dX))),
							_Utils_Tuple2(
							'locations',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								r.cD)),
							_Utils_Tuple2(
							'locations_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.cD))),
							_Utils_Tuple2(
							'questions',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bW;
									},
									$author$project$Data$Id$encode),
								r.bt)),
							_Utils_Tuple2(
							'question_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								r.bt)),
							_Utils_Tuple2(
							'question_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.bt))),
							_Utils_Tuple2(
							'attributes_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$sum(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.er;
											},
											$turboMaCk$non_empty_list_alias$List$NonEmpty$length),
										r.bt)))),
							_Utils_Tuple2(
							'newly_saved',
							$elm$json$Json$Encode$bool(r.pW))
						])));
		case 14:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Exported',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.ep.b)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.ep.ld)),
							_Utils_Tuple2(
							'audience_ids',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.b;
									},
									$author$project$Data$Id$encode),
								r.d9)),
							_Utils_Tuple2(
							'audience_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								r.d9)),
							_Utils_Tuple2(
							'base_audience_name',
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$json$Json$Encode$string('n/a'),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								r.aU)),
							_Utils_Tuple2(
							'base_audience_id',
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$json$Json$Encode$string('n/a'),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.b;
									},
									$author$project$Data$Id$encode),
								r.aU)),
							_Utils_Tuple2(
							'base_audience_type',
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$json$Json$Encode$string('n/a'),
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.oN;
									},
									$author$project$Data$Platform2$encodeAudienceStatesForAnalytics),
								r.aU)),
							_Utils_Tuple2(
							'datasets',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, r.ep.es)),
							_Utils_Tuple2(
							'datasets_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.ep.es))),
							_Utils_Tuple2(
							'audiences_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.d9))),
							_Utils_Tuple2(
							'is_shared',
							$elm$json$Json$Encode$bool(
								!_Utils_eq(r.ep.ah, $author$project$Data$Platform2$PrivateDashboard))),
							_Utils_Tuple2(
							'waves',
							A2(
								$elm$json$Json$Encode$list,
								$author$project$Data$Id$encode,
								A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $elm$core$Basics$identity, r.ep.cl.C.dX))),
							_Utils_Tuple2(
							'waves_count',
							$elm$json$Json$Encode$int(
								A3($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $elm$core$List$length, r.ep.cl.C.dX))),
							_Utils_Tuple2(
							'locations',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								r.cD)),
							_Utils_Tuple2(
							'locations_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.cD))),
							_Utils_Tuple2(
							'is_owner',
							$elm$json$Json$Encode$bool(
								_Utils_eq(r.oE, r.ep.dG))),
							_Utils_Tuple2(
							'app',
							$elm$json$Json$Encode$string(r.be)),
							_Utils_Tuple2(
							'question_codes',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bW;
									},
									$author$project$Data$Id$encode),
								r.bt)),
							_Utils_Tuple2(
							'question_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								r.bt)),
							_Utils_Tuple2(
							'question_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.bt))),
							_Utils_Tuple2(
							'attributes_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$sum(
									A2(
										$elm$core$List$map,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.er;
											},
											$turboMaCk$non_empty_list_alias$List$NonEmpty$length),
										r.bt))))
						])));
		case 17:
			var place = event.a;
			var widget = event.b;
			var params = event.c;
			return _Utils_Tuple2(
				'P2 - Dashboards - Question Asked',
				$elm$json$Json$Encode$object(
					A2(
						$author$project$Dashboards2$Analytics$withChartType,
						widget,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'place',
								$author$project$Analytics$Place$encode(place)),
							$author$project$Dashboards2$Analytics$encodeWidgetQuestionsQueryParamsForAnalytics(params)))));
		case 18:
			var dashboard = event.a.ep;
			var widget = event.a.bO;
			var questions = event.a.bt;
			var metric = event.a.dB;
			var place = event.a.iq;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget Metric Changed',
				$elm$json$Json$Encode$object(
					A2(
						$author$project$Dashboards2$Analytics$withChartType,
						widget,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'dashboard_id',
								$author$project$Data$Id$encode(dashboard.b)),
								_Utils_Tuple2(
								'dashboard_name',
								$elm$json$Json$Encode$string(dashboard.ld)),
								_Utils_Tuple2(
								'widget_id',
								$author$project$Data$Id$encode(widget.b)),
								_Utils_Tuple2(
								'widget_question_codes',
								A2(
									$elm$json$Json$Encode$list,
									A2(
										$elm$core$Basics$composeL,
										$author$project$Data$Id$encode,
										function ($) {
											return $.bW;
										}),
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(questions))),
								_Utils_Tuple2(
								'widget_question_names',
								A2(
									$elm$json$Json$Encode$list,
									A2(
										$elm$core$Basics$composeL,
										$elm$json$Json$Encode$string,
										function ($) {
											return $.ld;
										}),
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(questions))),
								_Utils_Tuple2(
								'widget_metric_name',
								$author$project$Data$Metric$encode(metric)),
								_Utils_Tuple2(
								'place',
								$author$project$Analytics$Place$encode(place))
							]))));
		case 20:
			var r = event.a;
			var userType = r.nM(23) ? 'gwi-creator' : (r.nM(24) ? 'non-gwi-creator' : 'normal-user');
			var filters = A2(
				$elm$core$List$filterMap,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always('base'),
						r.ep.cl.C.aU),
						A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always('audiences'),
						r.ep.cl.C.d9),
						A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always('waves'),
						r.ep.cl.C.dX),
						A2(
						$elm$core$Maybe$map,
						$elm$core$Basics$always('locations'),
						r.ep.cl.C.cD)
					]));
			var filtersString = $elm$core$List$isEmpty(filters) ? 'N/A' : A2($elm$core$String$join, ', ', filters);
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Saved',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.ep.b)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.ep.ld)),
							_Utils_Tuple2(
							'user_type',
							$elm$json$Json$Encode$string(userType)),
							_Utils_Tuple2(
							'public_dashboard',
							$elm$json$Json$Encode$bool(
								_Utils_eq(r.ep.ah, $author$project$Data$Platform2$PublicDashboard))),
							_Utils_Tuple2(
							'filters',
							$elm$json$Json$Encode$string(filtersString)),
							_Utils_Tuple2(
							'saving_as_new',
							$elm$json$Json$Encode$bool(r.q6)),
							_Utils_Tuple2(
							'duplicated',
							$elm$json$Json$Encode$bool(r.ot))
						])));
		case 21:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Favourite',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC)),
							_Utils_Tuple2(
							'remove_favourite',
							$elm$json$Json$Encode$bool(!r.pV))
						])));
		case 16:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard deleted',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'widgets_count',
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$json$Json$Encode$string('n/a'),
								$elm$json$Json$Encode$int,
								r.i4)),
							_Utils_Tuple2(
							'audience_count',
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$json$Json$Encode$string('n/a'),
								$elm$json$Json$Encode$int,
								r.jl)),
							_Utils_Tuple2(
							'audience_id',
							A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$json$Json$Encode$string('n/a'),
								$elm$json$Json$Encode$list($author$project$Data$Id$encode),
								r.jo)),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC))
						])));
		case 24:
			var place = event.a;
			var r = event.b;
			return _Utils_Tuple2(
				'P2 - Dashboards - Audience Added',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'audiences_ids',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.b;
									},
									$author$project$Data$Id$encode),
								r.d9)),
							_Utils_Tuple2(
							'audiences_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								r.d9)),
							_Utils_Tuple2(
							'place',
							$author$project$Analytics$Place$encode(place)),
							_Utils_Tuple2(
							'types',
							A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, r.rC)),
							_Utils_Tuple2(
							'audiences_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(r.d9))),
							_Utils_Tuple2(
							'audience_or_base',
							$elm$json$Json$Encode$string(r.hb)),
							_Utils_Tuple2(
							'app',
							$elm$json$Json$Encode$string(r.be))
						])));
		case 25:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget error',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'error_type',
							$elm$json$Json$Encode$string(r.oz)),
							_Utils_Tuple2(
							'question_codes',
							A2(
								$elm$json$Json$Encode$list,
								$author$project$Data$Id$encode,
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(r.qE))),
							_Utils_Tuple2(
							'audience_ids',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, r.jo))
						])));
		case 19:
			var type_ = event.a.mL;
			return _Utils_Tuple2(
				'P2 - Dashboards - Edit widget',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('text')),
							_Utils_Tuple2(
							'widget_name',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'info',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'base_audience',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'chart_type',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'default_metrics',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'sort_by',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(type_))
						])));
		case 15:
			var props = event.a;
			var sharedWithUsersCount = function () {
				var _v14 = props.ah;
				switch (_v14.$) {
					case 1:
						var _v15 = _v14.a;
						var userEmails = _v15.b;
						return $elm$core$List$length(userEmails);
					case 2:
						var _v16 = _v14.a;
						var userEmails = _v16.b;
						return $elm$core$List$length(userEmails);
					case 0:
						return 0;
					case 3:
						return 0;
					case 4:
						return 0;
					case 5:
						return 0;
					case 6:
						var _v17 = _v14.a;
						var userEmails = _v17.b;
						return $elm$core$List$length(userEmails);
					case 7:
						var _v18 = _v14.a;
						var userEmails = _v18.b;
						return $elm$core$List$length(userEmails);
					default:
						return 0;
				}
			}();
			var organisationIds = function () {
				var _v9 = props.ah;
				switch (_v9.$) {
					case 0:
						return _List_Nil;
					case 1:
						var _v10 = _v9.a;
						var orgIds = _v10.a;
						return orgIds;
					case 2:
						var _v11 = _v9.a;
						var maybeOrgId = _v11.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							function (id) {
								return _List_fromArray(
									[id]);
							},
							maybeOrgId);
					case 3:
						return _List_Nil;
					case 4:
						return _List_Nil;
					case 5:
						return _List_Nil;
					case 6:
						var _v12 = _v9.a;
						var orgIds = _v12.a;
						return orgIds;
					case 7:
						var _v13 = _v9.a;
						var maybeOrgId = _v13.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							function (id) {
								return _List_fromArray(
									[id]);
							},
							maybeOrgId);
					default:
						return _List_Nil;
				}
			}();
			var isSharedWithUsers = function () {
				var _v4 = props.ah;
				switch (_v4.$) {
					case 1:
						var _v5 = _v4.a;
						var userEmails = _v5.b;
						return $elm$core$List$length(userEmails) > 0;
					case 2:
						var _v6 = _v4.a;
						var userEmails = _v6.b;
						return $elm$core$List$length(userEmails) > 0;
					case 3:
						return false;
					case 0:
						return false;
					case 4:
						return true;
					case 5:
						return false;
					case 6:
						var _v7 = _v4.a;
						var userEmails = _v7.b;
						return $elm$core$List$length(userEmails) > 0;
					case 7:
						var _v8 = _v4.a;
						var userEmails = _v8.b;
						return $elm$core$List$length(userEmails) > 0;
					default:
						return false;
				}
			}();
			var isPubliclyShared = function () {
				var _v3 = props.ah;
				switch (_v3.$) {
					case 3:
						return true;
					case 1:
						return false;
					case 2:
						return false;
					case 0:
						return false;
					case 4:
						return true;
					case 5:
						return false;
					case 6:
						return true;
					case 7:
						return true;
					default:
						return true;
				}
			}();
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard shared',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'widgets_count',
							$elm$json$Json$Encode$int(props.i4)),
							_Utils_Tuple2(
							'audience_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(props.d9))),
							_Utils_Tuple2(
							'audience_ids',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.b;
									},
									$author$project$Data$Id$encode),
								props.d9)),
							_Utils_Tuple2(
							'audience_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								props.d9)),
							_Utils_Tuple2(
							'organisations_list',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, organisationIds)),
							_Utils_Tuple2(
							'categories',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, props.ac)),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(props.a0)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(props.ep.b)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(props.ep.ld)),
							_Utils_Tuple2(
							'is_shared',
							$elm$json$Json$Encode$bool(
								!_Utils_eq(props.ah, $author$project$Data$Platform2$PrivateDashboard))),
							_Utils_Tuple2(
							'app',
							$elm$json$Json$Encode$string(props.be)),
							_Utils_Tuple2(
							'is_owner',
							$elm$json$Json$Encode$bool(props.h2)),
							_Utils_Tuple2(
							'datasets',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, props.ep.es)),
							_Utils_Tuple2(
							'datasets_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(props.ep.es))),
							_Utils_Tuple2(
							'waves',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, props.dX)),
							_Utils_Tuple2(
							'waves_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(props.dX))),
							_Utils_Tuple2(
							'question_codes',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bW;
									},
									$author$project$Data$Id$encode),
								props.bt)),
							_Utils_Tuple2(
							'question_names',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								props.bt)),
							_Utils_Tuple2(
							'question_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(props.bt))),
							_Utils_Tuple2(
							'locations',
							A2(
								$elm$json$Json$Encode$list,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.ld;
									},
									$elm$json$Json$Encode$string),
								props.cD)),
							_Utils_Tuple2(
							'locations_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(props.cD))),
							_Utils_Tuple2(
							'attributes_count',
							$elm$json$Json$Encode$int(props.g9)),
							_Utils_Tuple2(
							'shared_with_org',
							$elm$json$Json$Encode$bool(props.rk)),
							_Utils_Tuple2(
							'shared_with_users',
							$elm$json$Json$Encode$bool(isSharedWithUsers)),
							_Utils_Tuple2(
							'shared_with_users_count',
							$elm$json$Json$Encode$int(sharedWithUsersCount)),
							_Utils_Tuple2(
							'shared_public',
							$elm$json$Json$Encode$bool(isPubliclyShared)),
							_Utils_Tuple2(
							'method',
							$elm$json$Json$Encode$string(props.dK)),
							_Utils_Tuple2(
							'message',
							$elm$json$Json$Encode$bool(false))
						])));
		case 43:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Intention to Share',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'is_owner',
							$elm$json$Json$Encode$bool(r.h2)),
							_Utils_Tuple2(
							'user',
							$author$project$Data$User$encode(r.mQ))
						])));
		case 13:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Edit mode',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'widgets_count',
							$elm$json$Json$Encode$int(r.i4)),
							_Utils_Tuple2(
							'audience_count',
							$elm$json$Json$Encode$int(r.jl)),
							_Utils_Tuple2(
							'audience_id',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, r.jo)),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC))
						])));
		case 22:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget deleted',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('text')),
							_Utils_Tuple2(
							'chart_name',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'info',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'base_audience',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'chart_type',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'default_metrics',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'sort_by',
							$elm$json$Json$Encode$string('n/a')),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC))
						])));
		case 23:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget deleted',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('chart')),
							_Utils_Tuple2(
							'chart_name',
							$elm$json$Json$Encode$string(r.hh)),
							_Utils_Tuple2(
							'info',
							$elm$core$String$isEmpty(r.fX) ? $elm$json$Json$Encode$string('n/a') : $elm$json$Json$Encode$string(r.fX)),
							_Utils_Tuple2(
							'base_audience',
							$elm$json$Json$Encode$string(
								r.kC ? 'inherited from chart' : 'inherited from DB')),
							_Utils_Tuple2(
							'chart_type',
							$author$project$D3Charts$Dashboards$ChartType$encode(r.aI)),
							_Utils_Tuple2(
							'default_metrics',
							$author$project$Data$Metric$encode(r.dB)),
							_Utils_Tuple2(
							'sort_by',
							$author$project$Dashboards2$Analytics$encodeDatapointSort(r.cY)),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC))
						])));
		case 38:
			var widget = event.a.bO;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget Duplicated',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'widget',
							function () {
								var _v19 = widget.U;
								if (!_v19.$) {
									return $elm$json$Json$Encode$string('chart_widget');
								} else {
									var textWidget = _v19.a;
									return $author$project$Data$Platform2$RichTextWidget$encode(textWidget);
								}
							}())
						])));
		case 2:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Add widget',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(r.mL)),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC)),
							_Utils_Tuple2(
							'place',
							$author$project$Analytics$Place$encode(r.iq))
						])));
		case 3:
			var widget = event.a.bO;
			return _Utils_Tuple2(
				'P2 - Dashboards - Text Widget Saved',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('text')),
							_Utils_Tuple2(
							'number_paragraphs',
							$elm$json$Json$Encode$int(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$length(widget.qt))),
							_Utils_Tuple2(
							'widget',
							$author$project$Data$Platform2$RichTextWidget$encode(widget))
						])));
		case 4:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget saved',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('chart')),
							_Utils_Tuple2(
							'chart_name',
							$elm$json$Json$Encode$string(r.hh)),
							_Utils_Tuple2(
							'info',
							$elm$core$String$isEmpty(r.fX) ? $elm$json$Json$Encode$string('n/a') : $elm$json$Json$Encode$string(r.fX)),
							_Utils_Tuple2(
							'base_audience',
							$elm$json$Json$Encode$string(
								r.kC ? 'inherited from chart' : 'inherited from DB')),
							_Utils_Tuple2(
							'chart_type',
							$author$project$D3Charts$Dashboards$ChartType$encode(r.aI)),
							_Utils_Tuple2(
							'chart_type_changed',
							$elm$json$Json$Encode$bool(r.nW)),
							_Utils_Tuple2(
							'default_metrics',
							$author$project$Data$Metric$encode(r.dB)),
							_Utils_Tuple2(
							'sort_by',
							$author$project$Dashboards2$Analytics$encodeDatapointSort(r.cY)),
							_Utils_Tuple2(
							'edited',
							$elm$json$Json$Encode$bool(r.ov)),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC)),
							_Utils_Tuple2(
							'renamed',
							$elm$json$Json$Encode$bool(r.kP))
						])));
		case 5:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget saved',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string('chart')),
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'chart_type',
							$elm$json$Json$Encode$string('horizontal_bar_chart_default')),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC)),
							_Utils_Tuple2(
							'chart_names',
							A2(
								$elm$json$Json$Encode$list,
								$elm$json$Json$Encode$string,
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(r.nT))),
							_Utils_Tuple2(
							'n_charts_added',
							$elm$json$Json$Encode$int(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$length(r.nT)))
						])));
		case 26:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard renamed',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'rename_and_save',
							$elm$json$Json$Encode$bool(r.pq)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.bf)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.bC))
						])));
		case 27:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Go to insight',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'gwi_creator',
							$elm$json$Json$Encode$bool(r.a0)),
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(r.ep.b)),
							_Utils_Tuple2(
							'dashboard_name',
							$elm$json$Json$Encode$string(r.ep.ld)),
							_Utils_Tuple2(
							'insight_linked',
							$author$project$Data$Id$encode(r.aP.b)),
							_Utils_Tuple2(
							'insight_type',
							$author$project$Data$Platform2$encodeInsightType(r.aP.mL))
						])));
		case 28:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Undo applied',
				$elm$json$Json$Encode$object(
					$author$project$Dashboards2$Analytics$basicAttributes(r)));
		case 29:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Redo applied',
				$elm$json$Json$Encode$object(
					$author$project$Dashboards2$Analytics$basicAttributes(r)));
		case 30:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Dashboards - Audience re-arranged',
				$elm$json$Json$Encode$object(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(
							'audience_count',
							$elm$json$Json$Encode$int(
								A3($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $elm$core$List$length, r.ep.cl.C.d9))),
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(
								'audience_id',
								$author$project$Data$Id$encode(r.fk.b)),
							A2(
								$elm$core$List$cons,
								_Utils_Tuple2(
									'audience_name',
									$elm$json$Json$Encode$string(r.fk.ld)),
								$author$project$Dashboards2$Analytics$basicAttributes(r))))));
		case 31:
			var answer = event.a.jf;
			var rememberChoice = event.a.lM;
			return _Utils_Tuple2(
				'P2 - Dashboards - Continue Analysis Modal',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'answer',
							$elm$json$Json$Encode$bool(answer)),
							_Utils_Tuple2(
							'remember_choice',
							$elm$json$Json$Encode$bool(rememberChoice))
						])));
		case 32:
			var chartName = event.a.hh;
			var numAttributes = event.a.lk;
			var sortingFrom = event.a.rv;
			var sortingTo = event.a.rw;
			var chartType = event.a.aI;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget Sorting Changed',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'chart_name',
							$elm$json$Json$Encode$string(chartName)),
							_Utils_Tuple2(
							'chart_type',
							$author$project$D3Charts$Dashboards$ChartType$encode(chartType)),
							_Utils_Tuple2(
							'chart_sorting_from',
							$author$project$Dashboards2$Analytics$encodeDatapointSort(sortingFrom)),
							_Utils_Tuple2(
							'chart_sorting_to',
							$author$project$Dashboards2$Analytics$encodeDatapointSort(sortingTo)),
							_Utils_Tuple2(
							'n_attributes',
							$elm$json$Json$Encode$int(numAttributes))
						])));
		case 33:
			var chartName = event.a.hh;
			var numAttributes = event.a.lk;
			var chartTypeTo = event.a.nY;
			var chartTypeFrom = event.a.nX;
			var place = event.a.iq;
			return _Utils_Tuple2(
				'P2 - Dashboards - Widget Chart Type Changed',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'chart_name',
							$elm$json$Json$Encode$string(chartName)),
							_Utils_Tuple2(
							'chart_type_from',
							$author$project$D3Charts$Dashboards$ChartType$encode(chartTypeFrom)),
							_Utils_Tuple2(
							'chart_type_to',
							$author$project$D3Charts$Dashboards$ChartType$encode(chartTypeTo)),
							_Utils_Tuple2(
							'n_attributes',
							$elm$json$Json$Encode$int(numAttributes)),
							_Utils_Tuple2(
							'place',
							$author$project$Analytics$Place$encode(place))
						])));
		case 34:
			var chartName = event.a.hh;
			var place = event.a.iq;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Question Opened',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'chart_name',
							$elm$json$Json$Encode$string(chartName)),
							_Utils_Tuple2(
							'place',
							$author$project$Analytics$Place$encode(place)),
							_Utils_Tuple2(
							'edit_mode',
							$elm$json$Json$Encode$bool(true))
						])));
		case 35:
			var place = event.a.iq;
			return _Utils_Tuple2(
				'P2 - Dashboards - Create Chart',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'place',
							$author$project$Analytics$Place$encode(place))
						])));
		case 36:
			var chartName = event.a.hh;
			var chartSelected = event.a.nU;
			return _Utils_Tuple2(
				'P2 - Dashboards - Chart Selected',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'chart_name',
							$elm$json$Json$Encode$string(chartName)),
							_Utils_Tuple2(
							'chart_selected',
							$elm$json$Json$Encode$bool(chartSelected))
						])));
		case 37:
			var chartName = event.a.hh;
			var chartType = event.a.aI;
			return _Utils_Tuple2(
				'P2 - Dashboards - Chart Metadata Open',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'chart_name',
							$elm$json$Json$Encode$string(chartName)),
							_Utils_Tuple2(
							'chart_type',
							$author$project$D3Charts$Dashboards$ChartType$encode(chartType))
						])));
		case 39:
			var filterType = event.a.oL;
			var selection = event.a.rd;
			return _Utils_Tuple2(
				'P2 - Dashboards - Management Filter',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'filter_type',
							$elm$json$Json$Encode$string(filterType)),
							_Utils_Tuple2(
							'selection',
							$elm$json$Json$Encode$string(selection))
						])));
		case 40:
			var widget = event.a.bO;
			return _Utils_Tuple2(
				'P2 - Dashboards - Move Widget',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'type',
							$elm$json$Json$Encode$string(
								function () {
									var _v20 = widget.U;
									if (!_v20.$) {
										return 'chart';
									} else {
										return 'text';
									}
								}()))
						])));
		case 41:
			var datasets = event.a.es;
			var locations = event.a.cD;
			var waves = event.a.dX;
			return _Utils_Tuple2(
				'P2 - Dashboards - Dashboard Filters Changed',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'datasets',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, datasets)),
							_Utils_Tuple2(
							'datasets_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(datasets))),
							_Utils_Tuple2(
							'locations',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, locations)),
							_Utils_Tuple2(
							'locations_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(locations))),
							_Utils_Tuple2(
							'waves',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, waves)),
							_Utils_Tuple2(
							'waves_count',
							$elm$json$Json$Encode$int(
								$elm$core$List$length(waves)))
						])));
		default:
			var r = event.a;
			return _Utils_Tuple2(
				'P2 - Audience Browser - Browser Opened',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'app',
							$elm$json$Json$Encode$string(r.be)),
							_Utils_Tuple2(
							'audience_or_base',
							$elm$json$Json$Encode$string(r.hb)),
							_Utils_Tuple2(
							'dashboard_ids',
							A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, r.hs)),
							_Utils_Tuple2(
							'has_audiences',
							$elm$json$Json$Encode$bool(r.hT))
						])));
	}
};
var $author$project$Analytics$track = _Platform_outgoingPort(
	'track',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$core$Basics$identity(b)
				]));
	});
var $author$project$Dashboards2$Analytics$trackEvent = function (event) {
	return $author$project$Analytics$track(
		$author$project$Dashboards2$Analytics$encodeEvent(event));
};
var $author$project$Dashboards2$Widget$widgetQuestionCodes = function (chartWidget) {
	var _v0 = chartWidget.cl;
	if (!_v0.$) {
		var questionCode = _v0.a.at;
		return $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(questionCode);
	} else {
		var groups = _v0.a;
		return A2(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
			function ($) {
				return $.at;
			},
			groups);
	}
};
var $author$project$Dashboards2$Widget$accessDeniedAnalyticsCmd = F4(
	function (store, widget, chartWidget, modelCmdPair) {
		var notSuccessQuestions = A2(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
			function (questionCode) {
				var _v1 = A2($turboMaCk$any_dict$Dict$Any$get, questionCode, store.bt);
				if (!_v1.$) {
					switch (_v1.a.$) {
						case 3:
							return $elm$core$Maybe$Nothing;
						case 0:
							var _v2 = _v1.a;
							return $elm$core$Maybe$Nothing;
						case 1:
							var _v3 = _v1.a;
							return $elm$core$Maybe$Nothing;
						default:
							return $elm$core$Maybe$Just(questionCode);
					}
				} else {
					return $elm$core$Maybe$Just(questionCode);
				}
			},
			$author$project$Dashboards2$Widget$widgetQuestionCodes(chartWidget));
		if (notSuccessQuestions.$ === 1) {
			return modelCmdPair;
		} else {
			var nonSuccessCodes = notSuccessQuestions.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				modelCmdPair,
				function (dashboard) {
					return A3(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$foldr,
						function (questionCode) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$add(
								$author$project$Dashboards2$Analytics$trackEvent(
									$author$project$Dashboards2$Analytics$WidgetAccessDenied(
										{bf: dashboard.b, bC: dashboard.ld, at: questionCode, sj: widget.b, dZ: chartWidget.ld})));
						},
						modelCmdPair,
						nonSuccessCodes);
				},
				A2($author$project$Store$Utils$get, store.v, widget.bf));
		}
	});
var $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger = function (msg) {
	return $GlobalWebIndex$cmd_extra$Cmd$Extra$add(
		$GlobalWebIndex$cmd_extra$Cmd$Extra$perform(msg));
};
var $author$project$Dashboards2$Analytics$QuestionAsked = F3(
	function (a, b, c) {
		return {$: 17, a: a, b: b, c: c};
	});
var $author$project$Dashboards2$Widget$analyticsEventsForWidget = F3(
	function (maybeUserFilters, store, widget) {
		return A2(
			$elm$core$Maybe$map,
			A2($author$project$Dashboards2$Analytics$QuestionAsked, 4, widget),
			A2(
				$elm$core$Maybe$andThen,
				function (userFilters) {
					return A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$first,
						A3(
							$author$project$Data$Calc$Platform2$paramsFromWidget,
							store,
							$author$project$Dashboards2$UserFilters$toSimpleFilters(userFilters),
							widget));
				},
				maybeUserFilters));
	});
var $author$project$Dashboards2$Widget$DoNothing = 3;
var $author$project$Dashboards2$Widget$FetchNormal = 1;
var $author$project$Dashboards2$Widget$FetchViewOnly = 0;
var $author$project$Dashboards2$Widget$SetNotAsked = 2;
var $author$project$Dashboards2$Widget$makeRequestAction = function (_v0) {
	var widgetIsVisible = _v0.m0;
	var forceFetchWidget = _v0.kh;
	var viewOnlyUser = _v0.mW;
	var externalCall = _v0.bI;
	return (widgetIsVisible || forceFetchWidget) ? (viewOnlyUser ? 0 : 1) : (externalCall ? 2 : 3);
};
var $author$project$Dashboards2$Widget$maxQueryRetries = 3;
var $author$project$Dashboards2$Chart$getDimensions = function (model) {
	var _v0 = model.h;
	switch (_v0.$) {
		case 2:
			return $elm$core$Maybe$Nothing;
		case 0:
			var dimensions = _v0.a.t;
			return $elm$core$Maybe$Just(dimensions);
		case 1:
			var dimensions = _v0.a.t;
			return $elm$core$Maybe$Just(dimensions);
		default:
			var dimensions = _v0.b.t;
			return $elm$core$Maybe$Just(dimensions);
	}
};
var $author$project$Dashboards2$Chart$setChartData = F2(
	function (model, chartData) {
		return _Utils_update(
			model,
			{h: chartData});
	});
var $author$project$Dashboards2$StatCard$howManyAudiencesFitIntoWidth = function (widthPx) {
	return $elm$core$Basics$round((widthPx + 150) / 300);
};
var $elm$core$Basics$min = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) < 0) ? x : y;
	});
var $author$project$Dashboards2$StatCard$calculateAudiencesPerPage = F2(
	function (widthPx, audiences) {
		var audiencesWeHaveSpaceFor = $author$project$Dashboards2$StatCard$howManyAudiencesFitIntoWidth(widthPx);
		var audiencesCount = $elm$core$List$length(audiences);
		return A2($elm$core$Basics$min, audiencesCount, audiencesWeHaveSpaceFor);
	});
var $author$project$Dashboards2$StatCard$isVisible = F2(
	function (model, index) {
		var audiencesCount = $elm$core$List$length(model.d9);
		return A2(
			$elm$core$List$member,
			index,
			A2(
				$elm$core$List$map,
				$elm$core$Basics$modBy(audiencesCount),
				A2($elm$core$List$range, model.ai, (model.ax + model.ai) - 1)));
	});
var $author$project$Dashboards2$StatCard$calculatePageOffset = F2(
	function (model, index) {
		var audiencesCount = $elm$core$List$length(model.d9);
		var newPageOffset = A2($elm$core$Basics$min, index, audiencesCount - model.ax);
		return A2($author$project$Dashboards2$StatCard$isVisible, model, index) ? model.ai : newPageOffset;
	});
var $author$project$Dashboards2$StatCard$setWidth = F2(
	function (widthPx, model) {
		var newModel = _Utils_update(
			model,
			{
				ax: A2($author$project$Dashboards2$StatCard$calculateAudiencesPerPage, widthPx, model.d9),
				sm: widthPx
			});
		return _Utils_update(
			newModel,
			{
				ai: A2($author$project$Dashboards2$StatCard$calculatePageOffset, newModel, newModel.ai)
			});
	});
var $author$project$Dashboards2$Chart$setDimensions = F2(
	function (dimensions, model) {
		return A2(
			$author$project$Dashboards2$Chart$setChartData,
			model,
			function () {
				var _v0 = model.h;
				switch (_v0.$) {
					case 2:
						var m = _v0.a;
						return $author$project$Dashboards2$Chart$StatCardModel(
							A2(
								$author$project$RemoteData$Loaded$map,
								$elm$core$Tuple$mapSecond(
									$author$project$Dashboards2$StatCard$setWidth(
										$elm$core$Basics$floor(dimensions.da))),
								m));
					case 0:
						var paginated = _v0.a;
						return $author$project$Dashboards2$Chart$Paginated(
							_Utils_update(
								paginated,
								{t: dimensions}));
					case 1:
						var nonpaginated = _v0.a;
						return $author$project$Dashboards2$Chart$Nonpaginated(
							_Utils_update(
								nonpaginated,
								{t: dimensions}));
					default:
						var lineChartData = _v0.a;
						var nonpaginated = _v0.b;
						return A2(
							$author$project$Dashboards2$Chart$LineChartModel,
							lineChartData,
							_Utils_update(
								nonpaginated,
								{t: dimensions}));
				}
			}());
	});
var $author$project$RemoteData$Loaded$toLoading = function (remoteData) {
	_v0$2:
	while (true) {
		switch (remoteData.$) {
			case 3:
				var data = remoteData.a;
				return $author$project$RemoteData$Loaded$LoadingL(
					$elm$core$Maybe$Just(data));
			case 1:
				if (!remoteData.a.$) {
					var data = remoteData.a.a;
					return $author$project$RemoteData$Loaded$LoadingL(
						$elm$core$Maybe$Just(data));
				} else {
					break _v0$2;
				}
			default:
				break _v0$2;
		}
	}
	return $author$project$RemoteData$Loaded$LoadingL($elm$core$Maybe$Nothing);
};
var $author$project$Dashboards2$Chart$setLoading = function (model) {
	return _Utils_update(
		model,
		{
			h: function () {
				var _v0 = model.h;
				switch (_v0.$) {
					case 0:
						var paginated = _v0.a;
						return $author$project$Dashboards2$Chart$Paginated(
							_Utils_update(
								paginated,
								{
									cl: $author$project$RemoteData$Loaded$toLoading(paginated.cl)
								}));
					case 1:
						var nonpaginated = _v0.a;
						return $author$project$Dashboards2$Chart$Nonpaginated(
							_Utils_update(
								nonpaginated,
								{
									cl: $author$project$RemoteData$Loaded$toLoading(nonpaginated.cl)
								}));
					case 2:
						var webdataStatCardModel = _v0.a;
						return $author$project$Dashboards2$Chart$StatCardModel(
							$author$project$RemoteData$Loaded$toLoading(webdataStatCardModel));
					default:
						var lcModel = _v0.a;
						var nonpaginated = _v0.b;
						return A2(
							$author$project$Dashboards2$Chart$LineChartModel,
							lcModel,
							_Utils_update(
								nonpaginated,
								{
									cl: $author$project$RemoteData$Loaded$toLoading(nonpaginated.cl)
								}));
				}
			}()
		});
};
var $author$project$Dashboards2$Chart$reInitWithLoading = F3(
	function (widget, chartWidget, model) {
		return $author$project$Dashboards2$Chart$setLoading(
			function () {
				var _v0 = $author$project$Dashboards2$Chart$getDimensions(model);
				if (!_v0.$) {
					var dimensions = _v0.a;
					return $author$project$Dashboards2$Chart$setDimensions(dimensions);
				} else {
					return $elm$core$Basics$identity;
				}
			}()(
				A2($author$project$Dashboards2$Chart$init, widget, chartWidget)));
	});
var $author$project$Data$Calc$Platform2$EmptyAudienceExpression = {$: 1};
var $author$project$Data$Calc$Platform2$InvalidNamespacesCombination = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Calc$Platform2$InvalidQuery = {$: 0};
var $author$project$Data$Calc$Platform2$SplitterNotWhitelisted = function (a) {
	return {$: 3, a: a};
};
var $author$project$Data$Calc$Platform2$dashboardQueryErrorDecoder = F3(
	function (question, baseAudience, audiences) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (errorType) {
				switch (errorType) {
					case 'invalid_query':
						return $elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$InvalidQuery);
					case 'empty_audience_expression':
						return $elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$EmptyAudienceExpression);
					case 'invalid_projects_combination':
						return A2(
							$elm$json$Json$Decode$map,
							function (namespacesCombined) {
								return $author$project$Data$Calc$Platform2$InvalidNamespacesCombination(
									{d9: audiences, aU: baseAudience, lf: namespacesCombined, gA: question});
							},
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['meta', 'incompatible_projects']),
								$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($elm$json$Json$Decode$string)));
					case 'splitter_not_whitelisted_error':
						return $elm$json$Json$Decode$succeed(
							$author$project$Data$Calc$Platform2$SplitterNotWhitelisted(question));
					default:
						return $elm$json$Json$Decode$fail('Failed to determine DashboardQueryError from error_type: ' + errorType);
				}
			},
			$author$project$Data$Core$Error$typeDecoder);
	});
var $author$project$Data$Calc$Platform2$encodeAudience = function (audience) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Data$Id$encode(audience.b)),
				_Utils_Tuple2(
				'expression',
				$author$project$Data$Audience$Expression$encodeV2(audience.bY))
			]));
};
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $author$project$Data$Calc$Platform2$params = function (qParams) {
	var waveCodes = A2(
		$elm$json$Json$Encode$list,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Data$Id$encode,
			function ($) {
				return $.bW;
			}),
		qParams.dX);
	var suffixCodes = A2(
		$elm$json$Json$Encode$list,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.bW;
			},
			$author$project$Data$Id$encode),
		qParams.rI);
	var segmentIds = A2(
		$elm$json$Json$Encode$list,
		$author$project$Data$Id$encode,
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filter(
					function ($) {
						return $.fc;
					}),
				$elm$core$List$map(
					function ($) {
						return $.b;
					})),
			qParams.nh));
	var locationCodes = A2(
		$elm$json$Json$Encode$list,
		A2(
			$elm$core$Basics$composeL,
			$author$project$Data$Id$encode,
			function ($) {
				return $.bW;
			}),
		qParams.cD);
	var datapointCode = A2(
		$elm$json$Json$Encode$list,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.bW;
			},
			$author$project$Data$Id$encode),
		qParams.er);
	var audiences = A2($elm$json$Json$Encode$list, $author$project$Data$Calc$Platform2$encodeAudience, qParams.d9);
	return _Utils_ap(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'question',
				$author$project$Data$Id$encode(qParams.gA.k1)),
				_Utils_Tuple2('audiences', audiences),
				_Utils_Tuple2('waves', waveCodes),
				_Utils_Tuple2('locations', locationCodes),
				_Utils_Tuple2('datapoints', datapointCode),
				_Utils_Tuple2('suffixes', suffixCodes),
				_Utils_Tuple2(
				'segmented_base',
				$elm$json$Json$Encode$bool(qParams.qF)),
				_Utils_Tuple2('segments', segmentIds)
			]),
		_Utils_ap(
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						A2(
							$elm$core$Basics$composeL,
							$elm$core$List$singleton,
							$elm$core$Tuple$pair('splitter')),
						$author$project$Data$Id$encode),
					function ($) {
						return $.bW;
					}),
				qParams.ry),
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$core$List$singleton,
						$elm$core$Tuple$pair('base_audience')),
					$author$project$Data$Calc$Platform2$encodeAudience),
				qParams.aU)));
};
var $author$project$Data$Calc$Platform2$DatapointAudiences = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Data$Id$decode = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string);
var $author$project$Data$Id$decodeFromInt = A2(
	$elm$json$Json$Decode$map,
	A2($elm$core$Basics$composeL, $elm$core$Basics$identity, $elm$core$String$fromInt),
	$elm$json$Json$Decode$int);
var $author$project$Data$Id$decodeFromStringOrInt = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Data$Id$decode, $author$project$Data$Id$decodeFromInt]));
var $author$project$Data$Metrics$Metrics = F5(
	function (responsesCount, weightedUniverse, audiencePercentage, datapointPercentage, index) {
		return {ny: audiencePercentage, oe: datapointPercentage, pi: index, qW: responsesCount, sg: weightedUniverse};
	});
var $author$project$Data$Metrics$decoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'audience_index', $elm$json$Json$Decode$float),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'datapoint_percentage', $elm$json$Json$Decode$float),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'audience_percentage', $elm$json$Json$Decode$float),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'positive_size', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'positive_sample', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$succeed($author$project$Data$Metrics$Metrics))))));
var $author$project$Data$Calc$Platform2$metaDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'question', $author$project$Data$Id$decode),
	$elm$json$Json$Decode$succeed(
		function (code) {
			return {at: code};
		}));
var $author$project$Data$Calc$Platform2$optionalListField = F2(
	function (field, itemDecoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					field,
					$elm$json$Json$Decode$list(itemDecoder))));
	});
var $author$project$Data$Calc$Platform2$datapointAudiencesDecoder = function () {
	var datapointAudienceDecoder = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'metrics', $author$project$Data$Metrics$decoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'audience', $author$project$Data$Id$decodeFromStringOrInt),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($author$project$Data$Calc$Platform2$optionalListField, 'suffixes', $author$project$Data$Id$decodeFromInt),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'datapoint', $author$project$Data$Id$decode),
					$elm$json$Json$Decode$succeed(
						F4(
							function (datapointCode, suffixCodes, audienceId, metrics) {
								return {jn: audienceId, eq: datapointCode, dC: metrics, eY: suffixCodes};
							}))))));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (metaType) {
			if (metaType === 'DATAPOINTS-AUDIENCES') {
				return A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list(datapointAudienceDecoder)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'meta', $author$project$Data$Calc$Platform2$metaDecoder),
						$elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$DatapointAudiences)));
			} else {
				return $elm$json$Json$Decode$fail('DatapointAudiences decoder failed because of ' + ('incorrect meta.type: ' + metaType));
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['meta', 'type']),
			$elm$json$Json$Decode$string));
}();
var $author$project$Data$Calc$Platform2$DatapointSegmentAudiences = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Data$Calc$Platform2$metaSplitterDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'splitter', $author$project$Data$Id$decode),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'question', $author$project$Data$Id$decode),
		$elm$json$Json$Decode$succeed(
			F2(
				function (code, s) {
					return {at: code, gP: s};
				}))));
var $author$project$Data$Calc$Platform2$datapointSegmentAudiencesDecoder = function () {
	var datapointSegmentAudienceDecoder = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'metrics', $author$project$Data$Metrics$decoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'audience', $author$project$Data$Id$decodeFromStringOrInt),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'segment', $author$project$Data$Id$decode),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($author$project$Data$Calc$Platform2$optionalListField, 'suffixes', $author$project$Data$Id$decodeFromInt),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'datapoint', $author$project$Data$Id$decode),
						$elm$json$Json$Decode$succeed(
							F5(
								function (datapointCode, suffixCodes, segmentId, audienceId, metrics) {
									return {jn: audienceId, eq: datapointCode, dC: metrics, l3: segmentId, eY: suffixCodes};
								})))))));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (metaType) {
			if (metaType === 'DATAPOINTS-SEGMENTS-AUDIENCES') {
				return A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list(datapointSegmentAudienceDecoder)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'meta', $author$project$Data$Calc$Platform2$metaSplitterDecoder),
						$elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$DatapointSegmentAudiences)));
			} else {
				return $elm$json$Json$Decode$fail('DatapointSegmentAudiences decoder failed because of ' + ('incorrect meta.type: ' + metaType));
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['meta', 'type']),
			$elm$json$Json$Decode$string));
}();
var $author$project$Data$Calc$Platform2$DatapointSegments = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Data$Calc$Platform2$datapointSegmentsDecoder = function () {
	var datapointSegmentDecoder = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'metrics', $author$project$Data$Metrics$decoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'segment', $author$project$Data$Id$decode),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($author$project$Data$Calc$Platform2$optionalListField, 'suffixes', $author$project$Data$Id$decodeFromInt),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'datapoint', $author$project$Data$Id$decode),
					$elm$json$Json$Decode$succeed(
						F4(
							function (datapointCode, suffixCodes, segmentId, metrics) {
								return {eq: datapointCode, dC: metrics, l3: segmentId, eY: suffixCodes};
							}))))));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (metaType) {
			if (metaType === 'DATAPOINTS-SEGMENTS') {
				return A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list(datapointSegmentDecoder)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'meta', $author$project$Data$Calc$Platform2$metaSplitterDecoder),
						$elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$DatapointSegments)));
			} else {
				return $elm$json$Json$Decode$fail('DatapointSegments decoder failed because of ' + ('incorrect meta.type: ' + metaType));
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['meta', 'type']),
			$elm$json$Json$Decode$string));
}();
var $author$project$Data$Calc$Platform2$Datapoints = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Data$Calc$Platform2$datapointsDecoder = function () {
	var datapointDecoder = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'metrics', $author$project$Data$Metrics$decoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($author$project$Data$Calc$Platform2$optionalListField, 'suffixes', $author$project$Data$Id$decodeFromInt),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'datapoint', $author$project$Data$Id$decode),
				$elm$json$Json$Decode$succeed(
					F3(
						function (datapointCode, suffixCodes, metrics) {
							return {eq: datapointCode, dC: metrics, eY: suffixCodes};
						})))));
	return A2(
		$elm$json$Json$Decode$andThen,
		function (metaType) {
			if (metaType === 'DATAPOINTS') {
				return A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list(datapointDecoder)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'meta', $author$project$Data$Calc$Platform2$metaDecoder),
						$elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$Datapoints)));
			} else {
				return $elm$json$Json$Decode$fail('Datapoints decoder failed because of ' + ('incorrect meta.type: ' + metaType));
			}
		},
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['meta', 'type']),
			$elm$json$Json$Decode$string));
}();
var $author$project$Data$Calc$Platform2$qDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Data$Calc$Platform2$datapointSegmentAudiencesDecoder, $author$project$Data$Calc$Platform2$datapointSegmentsDecoder, $author$project$Data$Calc$Platform2$datapointAudiencesDecoder, $author$project$Data$Calc$Platform2$datapointsDecoder]));
var $author$project$Data$Calc$Platform2$sendFromDashboards = F2(
	function (flags, questionQueryParams) {
		var token = flags.i$;
		var question = questionQueryParams.gA;
		var baseAudience = questionQueryParams.aU;
		var audiences = questionQueryParams.d9;
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						$author$project$Data$Calc$Platform2$params(questionQueryParams))),
				hK: A2(
					$author$project$Gwi$Http$expectErrorAwareJson,
					A3($author$project$Data$Calc$Platform2$dashboardQueryErrorDecoder, question, baseAudience, audiences),
					$author$project$Data$Calc$Platform2$qDecoder),
				hU: A2(
					$author$project$Gwi$List$appendMaybe,
					A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
					_List_fromArray(
						[
							$author$project$Data$Auth$header(token)
						])),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Calc$Platform2$host(flags) + '/v2/query/dashboards'
			});
	});
var $author$project$Data$Calc$Platform2$dashboardQueryErrorDecoderViewOnly = A2(
	$elm$json$Json$Decode$andThen,
	function (errorType) {
		if (errorType === 'invalid_query') {
			return $elm$json$Json$Decode$succeed($author$project$Data$Calc$Platform2$InvalidQuery);
		} else {
			return $elm$json$Json$Decode$fail('Failed to determine DashboardQueryError from error_type: ' + errorType);
		}
	},
	$author$project$Data$Core$Error$typeDecoder);
var $author$project$Data$Calc$Platform2$qDecoderViewOnly = A2(
	$elm$json$Json$Decode$field,
	'widget_data',
	$elm$json$Json$Decode$list(
		A2($elm$json$Json$Decode$field, 'stats_result', $author$project$Data$Calc$Platform2$qDecoder)));
var $author$project$Data$Calc$Platform2$sendFromDashboardsViewOnly = function (_v0) {
	var flags = _v0.oN;
	var dashboardId = _v0.bf;
	var widgetId = _v0.sj;
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$jsonBody(
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dashboard_id',
							$author$project$Data$Id$encode(dashboardId)),
							_Utils_Tuple2(
							'widget_id',
							$author$project$Data$Id$encode(widgetId)),
							_Utils_Tuple2(
							'limit',
							$elm$json$Json$Encode$int(10000)),
							_Utils_Tuple2(
							'offset',
							$elm$json$Json$Encode$int(0))
						]))),
			hK: A2($author$project$Gwi$Http$expectErrorAwareJson, $author$project$Data$Calc$Platform2$dashboardQueryErrorDecoderViewOnly, $author$project$Data$Calc$Platform2$qDecoderViewOnly),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'POST',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Calc$Platform2$host(flags) + '/platform/dashboards/data'
		});
};
var $author$project$Dashboards2$Chart$setNotAsked = function (model) {
	return _Utils_update(
		model,
		{
			h: function () {
				var _v0 = model.h;
				switch (_v0.$) {
					case 0:
						var paginated = _v0.a;
						return $author$project$Dashboards2$Chart$Paginated(
							_Utils_update(
								paginated,
								{cl: $author$project$RemoteData$Loaded$NotAskedL}));
					case 1:
						var nonpaginated = _v0.a;
						return $author$project$Dashboards2$Chart$Nonpaginated(
							_Utils_update(
								nonpaginated,
								{cl: $author$project$RemoteData$Loaded$NotAskedL}));
					case 2:
						return $author$project$Dashboards2$Chart$StatCardModel($author$project$RemoteData$Loaded$NotAskedL);
					default:
						var lcModel = _v0.a;
						var nonpaginated = _v0.b;
						return A2(
							$author$project$Dashboards2$Chart$LineChartModel,
							lcModel,
							_Utils_update(
								nonpaginated,
								{cl: $author$project$RemoteData$Loaded$NotAskedL}));
				}
			}()
		});
};
var $elm$core$Tuple$mapFirst = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			func(x),
			y);
	});
var $author$project$Dashboards2$Widget$updateChartModel = F2(
	function (cm, updateFn) {
		switch (cm.$) {
			case 0:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(cm);
			case 1:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(cm);
			default:
				var chartModelData = cm.a;
				switch (chartModelData.$) {
					case 0:
						var chartModel = chartModelData.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							A2($elm$core$Basics$composeR, $author$project$Dashboards2$Widget$WaitingForQuestions, $author$project$Dashboards2$Widget$ChartModel),
							updateFn(chartModel));
					case 1:
						var chartModel = chartModelData.a;
						return A2(
							$elm$core$Tuple$mapFirst,
							A2($elm$core$Basics$composeR, $author$project$Dashboards2$Widget$LoadingView, $author$project$Dashboards2$Widget$ChartModel),
							updateFn(chartModel));
					case 2:
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(cm);
					default:
						var q = chartModelData.a;
						var chartModel = chartModelData.b;
						return A2(
							$elm$core$Tuple$mapFirst,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Dashboards2$Widget$WidgetDataCollected(q),
								$author$project$Dashboards2$Widget$ChartModel),
							updateFn(chartModel));
				}
		}
	});
var $author$project$Dashboards2$Widget$requestActionWithFiltersParametersAndChart = function (_v0) {
	var chartWidget = _v0.dg;
	var widget = _v0.bO;
	var isEditing = _v0.ez;
	var store = _v0.rF;
	var maybeUserFilters = _v0.k3;
	var msg = _v0.a;
	var userFilters = _v0.bz;
	var model = _v0.k8;
	var flags = _v0.oN;
	var forceFetch = _v0.oQ;
	var externalCall = _v0.bI;
	var updateStoreFn = _v0.g$;
	var storeActionMany = _v0.l;
	var paramsList = _v0.lx;
	var setLoading = function (chartModel) {
		return isEditing ? A3($author$project$Dashboards2$Chart$reInitWithLoading, widget, chartWidget, chartModel) : $author$project$Dashboards2$Chart$setLoading(chartModel);
	};
	var responseMsgViewOnly = function (httpResponse) {
		return msg(
			$author$project$Dashboards2$Widget$DataForWidgetReceivedViewOnly(
				{cx: httpResponse, b5: $author$project$Dashboards2$Widget$maxQueryRetries, c4: userFilters, c9: widget}));
	};
	var responseMsg = F2(
		function (params, httpResponse) {
			return msg(
				A5(
					$author$project$Dashboards2$Widget$DataForWidgetReceived,
					{b5: $author$project$Dashboards2$Widget$maxQueryRetries},
					widget,
					userFilters,
					params,
					httpResponse));
		});
	var requestAction = $author$project$Dashboards2$Widget$makeRequestAction(
		{
			bI: externalCall,
			kh: forceFetch,
			mW: $author$project$Data$User$hasViewOnlyPlan(flags.mQ),
			m0: model.cz
		});
	var questionAskedAnalyticsCmd = function (_v2) {
		var m = _v2.a;
		var cmds = _v2.b;
		return m.d4 ? _Utils_Tuple2(m, cmds) : A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_Utils_Tuple2(m, cmds),
			function (event) {
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(event),
					_Utils_Tuple2(
						_Utils_update(
							m,
							{d4: true}),
						cmds));
			},
			A3($author$project$Dashboards2$Widget$analyticsEventsForWidget, maybeUserFilters, store, widget));
	};
	var analytics = questionAskedAnalyticsCmd(
		A4(
			$author$project$Dashboards2$Widget$accessDeniedAnalyticsCmd,
			store,
			widget,
			chartWidget,
			_Utils_Tuple2(
				_Utils_update(
					model,
					{
						ad: A2(
							$author$project$Dashboards2$Widget$updateChartModel,
							model.ad,
							function (m) {
								return _Utils_Tuple2(
									setLoading(m),
									$elm$core$Platform$Cmd$none);
							}).a
					}),
				$elm$core$Platform$Cmd$none)));
	return A2(
		$elm$core$Tuple$mapSecond,
		$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
			storeActionMany(
				_List_fromArray(
					[
						$author$project$Store$Platform2$UpdateStore(updateStoreFn)
					]))),
		A2(
			$elm$core$Tuple$mapSecond,
			$turboMaCk$glue$Glue$map(msg),
			function () {
				switch (requestAction) {
					case 0:
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2(
									$elm$core$Platform$Cmd$map,
									responseMsgViewOnly,
									$author$project$Data$Calc$Platform2$sendFromDashboardsViewOnly(
										{bf: widget.bf, oN: flags, sj: widget.b}))
								]),
							analytics);
					case 1:
						return _Utils_Tuple2(
							A2(
								$elm$core$List$map,
								function (params) {
									return A2(
										$elm$core$Platform$Cmd$map,
										function (httpResponse) {
											return A2(responseMsg, params, httpResponse);
										},
										A2($author$project$Data$Calc$Platform2$sendFromDashboards, flags, params));
								},
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(paramsList)),
							analytics);
					case 2:
						return _Utils_Tuple2(
							_List_Nil,
							_Utils_Tuple2(
								_Utils_update(
									model,
									{
										ad: A2(
											$author$project$Dashboards2$Widget$updateChartModel,
											model.ad,
											function (m) {
												return _Utils_Tuple2(
													$author$project$Dashboards2$Chart$setNotAsked(m),
													$elm$core$Platform$Cmd$none);
											}).a
									}),
								$elm$core$Platform$Cmd$none));
					default:
						return _Utils_Tuple2(
							_List_Nil,
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
				}
			}()));
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2$Analytics$WidgetError = function (a) {
	return {$: 25, a: a};
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$all = F2(
	function (f, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return f(h) && A2($elm$core$List$all, f, t);
	});
var $author$project$Dashboards2$UserFilters$audienceIds = function (_v0) {
	var r = _v0;
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.fk;
			},
			function ($) {
				return $.b;
			}),
		r.d9);
};
var $author$project$Dashboards2$Chart$getErrorFromViewData = function (cartData) {
	switch (cartData.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			var error = cartData.a.$7;
			return $elm$core$Maybe$Just(error);
	}
};
var $GlobalWebIndex$elm_plural_rules$PluralRules$En$defaultPluralize = function (word) {
	return word + 's';
};
var $elm$core$Basics$abs = function (n) {
	return (n < 0) ? (-n) : n;
};
var $GlobalWebIndex$elm_plural_rules$PluralRules$fromFloat = F4(
	function (_v0, _v1, num, word) {
		var toCardinal = _v0.rW;
		var defaultPluralize = _v0.oh;
		var dict = _v1;
		return A2(
			$elm$core$Maybe$withDefault,
			($elm$core$Basics$abs(num) === 1) ? word : defaultPluralize(word),
			A2(
				$elm$core$Maybe$andThen,
				$turboMaCk$any_dict$Dict$Any$get(
					toCardinal(num)),
				A2($elm$core$Dict$get, word, dict)));
	});
var $GlobalWebIndex$elm_plural_rules$PluralRules$fromInt = F4(
	function (config, rules, num, word) {
		return A4($GlobalWebIndex$elm_plural_rules$PluralRules$fromFloat, config, rules, num, word);
	});
var $GlobalWebIndex$elm_plural_rules$PluralRules$One = 1;
var $GlobalWebIndex$elm_plural_rules$PluralRules$Other = 5;
var $GlobalWebIndex$elm_plural_rules$PluralRules$En$toCardinal = function (_float) {
	return ($elm$core$Basics$abs(_float) === 1) ? 1 : 5;
};
var $GlobalWebIndex$elm_plural_rules$PluralRules$En$pluralize = F3(
	function (rules, n, word) {
		return A4(
			$GlobalWebIndex$elm_plural_rules$PluralRules$fromInt,
			{oh: $GlobalWebIndex$elm_plural_rules$PluralRules$En$defaultPluralize, rW: $GlobalWebIndex$elm_plural_rules$PluralRules$En$toCardinal},
			rules,
			n,
			word);
	});
var $GlobalWebIndex$elm_plural_rules$PluralRules$Rules = $elm$core$Basics$identity;
var $GlobalWebIndex$elm_plural_rules$PluralRules$toComparable = function (cardinal) {
	switch (cardinal) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		default:
			return 5;
	}
};
var $GlobalWebIndex$elm_plural_rules$PluralRules$add = F3(
	function (word, xs, _v0) {
		var dict = _v0;
		return A3(
			$elm$core$Dict$insert,
			word,
			A2($turboMaCk$any_dict$Dict$Any$fromList, $GlobalWebIndex$elm_plural_rules$PluralRules$toComparable, xs),
			dict);
	});
var $GlobalWebIndex$elm_plural_rules$PluralRules$empty = $elm$core$Dict$empty;
var $GlobalWebIndex$elm_plural_rules$PluralRules$fromList = function (list) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, acc) {
				var item = _v0.a;
				var forms = _v0.b;
				return A3($GlobalWebIndex$elm_plural_rules$PluralRules$add, item, forms, acc);
			}),
		$GlobalWebIndex$elm_plural_rules$PluralRules$empty,
		list);
};
var $author$project$Plural$rules = $GlobalWebIndex$elm_plural_rules$PluralRules$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'Query',
			_List_fromArray(
				[
					_Utils_Tuple2(1, 'Query'),
					_Utils_Tuple2(5, 'Queries')
				])),
			_Utils_Tuple2(
			'this',
			_List_fromArray(
				[
					_Utils_Tuple2(1, 'this'),
					_Utils_Tuple2(5, 'these')
				])),
			_Utils_Tuple2(
			'be',
			_List_fromArray(
				[
					_Utils_Tuple2(1, 'is'),
					_Utils_Tuple2(5, 'are')
				])),
			_Utils_Tuple2(
			'have',
			_List_fromArray(
				[
					_Utils_Tuple2(1, 'has'),
					_Utils_Tuple2(5, 'have')
				])),
			_Utils_Tuple2(
			'person',
			_List_fromArray(
				[
					_Utils_Tuple2(1, 'person'),
					_Utils_Tuple2(5, 'people')
				]))
		]));
var $author$project$Plural$fromInt = F2(
	function (n, word) {
		return A3($GlobalWebIndex$elm_plural_rules$PluralRules$En$pluralize, $author$project$Plural$rules, n, word);
	});
var $author$project$Data$Permissions$getProblematicTypes = function (data) {
	var convert = function (name) {
		return A2(
			$elm$core$Basics$composeR,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map($author$project$Data$Id$unwrap),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$pair(name),
					$elm$core$List$cons)));
	};
	return A4(
		$elm_community$maybe_extra$Maybe$Extra$unwrap,
		$elm$core$Basics$identity,
		convert('Splitter'),
		data.cZ,
		A4(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Basics$identity,
			convert('Location'),
			data.cD,
			A4(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Basics$identity,
				convert('Wave'),
				data.dX,
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					convert('Audience'),
					data.cN,
					A4(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$core$Basics$identity,
						convert('Audience'),
						data.cM,
						A4(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Basics$identity,
							convert('Data Point'),
							data.er,
							A4(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Basics$identity,
								convert('Question'),
								data.bt,
								_List_Nil)))))));
};
var $elm$core$Tuple$mapBoth = F3(
	function (funcA, funcB, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			funcA(x),
			funcB(y));
	});
var $elm$core$List$unzip = function (pairs) {
	var step = F2(
		function (_v0, _v1) {
			var x = _v0.a;
			var y = _v0.b;
			var xs = _v1.a;
			var ys = _v1.b;
			return _Utils_Tuple2(
				A2($elm$core$List$cons, x, xs),
				A2($elm$core$List$cons, y, ys));
		});
	return A3(
		$elm$core$List$foldr,
		step,
		_Utils_Tuple2(_List_Nil, _List_Nil),
		pairs);
};
var $author$project$Data$Permissions$getUnknownTypesCopy = F2(
	function (itemName, problematicData) {
		var _v0 = A3(
			$elm$core$Tuple$mapBoth,
			$elm$core$String$join('/'),
			$elm$core$String$join('\n'),
			$elm$core$List$unzip(
				A2(
					$elm$core$List$map,
					function (_v1) {
						var name = _v1.a;
						var list = _v1.b;
						var pluralisedName = _Utils_ap(
							name,
							A2(
								$author$project$Plural$fromInt,
								$elm$core$List$length(list),
								' Code'));
						return _Utils_Tuple2(
							pluralisedName,
							pluralisedName + (': ' + A2($elm$core$String$join, ', ', list)));
					},
					$author$project$Data$Permissions$getProblematicTypes(problematicData))));
		var unknownTypeNames = _v0.a;
		var body = _v0.b;
		return {pP: 'The ' + (itemName + (' contains invalid data: ' + (body + ('. Please rebuild your ' + (itemName + (' using the same ' + (unknownTypeNames + ' or get in touch with us.'))))))), Y: unknownTypeNames + ' Missing'};
	});
var $author$project$Data$Permissions$isUpsellNeeded = function (permissions) {
	if (permissions.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Dashboards2$Chart$DataLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Chart$ErrorView = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Metric$Index = 3;
var $author$project$Dashboards2$Chart$LoadingData = function (a) {
	return {$: 0, a: a};
};
var $author$project$D3Charts$Dashboards$ChartType$RadarChart = 7;
var $author$project$Dashboards2$UserFilters$activeAudienceIds = function (_v0) {
	var r = _v0;
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.fk;
			},
			function ($) {
				return $.b;
			}),
		A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					$elm$core$Basics$not,
					function ($) {
						return $.pr;
					}),
				function ($) {
					return $.fk;
				}),
			r.d9));
};
var $author$project$RemoteData$Loaded$andThen = F2(
	function (fn, data) {
		switch (data.$) {
			case 3:
				var a = data.a;
				return fn(a);
			case 1:
				if (!data.a.$) {
					var a = data.a.a;
					var _v1 = fn(a);
					if (_v1.$ === 3) {
						var b = _v1.a;
						return $author$project$RemoteData$Loaded$LoadingL(
							$elm$core$Maybe$Just(b));
					} else {
						var other = _v1;
						return other;
					}
				} else {
					var _v2 = data.a;
					return $author$project$RemoteData$Loaded$LoadingL($elm$core$Maybe$Nothing);
				}
			case 2:
				var e = data.a;
				return $author$project$RemoteData$Loaded$FailureL(e);
			default:
				return $author$project$RemoteData$Loaded$NotAskedL;
		}
	});
var $author$project$Gwi$List$fastConcat = A2($elm$core$List$foldr, $elm$core$Basics$append, _List_Nil);
var $author$project$RemoteData$Loaded$map2 = F3(
	function (func, remoteA, remoteB) {
		return A2(
			$author$project$RemoteData$Loaded$andThen,
			function (a) {
				return A2(
					$author$project$RemoteData$Loaded$andThen,
					function (b) {
						return $author$project$RemoteData$Loaded$SuccessL(
							A2(func, a, b));
					},
					remoteB);
			},
			remoteA);
	});
var $author$project$RemoteData$Loaded$sequence = function (list) {
	return A3(
		$elm$core$List$foldr,
		$author$project$RemoteData$Loaded$map2($elm$core$List$cons),
		$author$project$RemoteData$Loaded$SuccessL(_List_Nil),
		list);
};
var $author$project$D3Charts$Dashboards$ChartType$AudienceScoped = 2;
var $author$project$D3Charts$Dashboards$ChartType$DataTableShape = 0;
var $author$project$D3Charts$Dashboards$ChartType$DatapointScoped = 1;
var $author$project$D3Charts$Dashboards$ChartType$TimeSeries = 3;
var $author$project$D3Charts$Dashboards$ChartType$shape = function (chartType) {
	switch (chartType) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 1;
		case 4:
			return 3;
		case 5:
			return 2;
		case 6:
			return 1;
		case 7:
			return 2;
		case 8:
			return 1;
		case 9:
			return 2;
		case 10:
			return 2;
		default:
			return 1;
	}
};
var $author$project$Palette$BaseAloneColor = 0;
var $author$project$Palette$BaseWithAudiencesColor = 1;
var $author$project$Dashboards2$UserFilters$baseIsNotAlone = function (_v0) {
	var r = _v0;
	return !$elm$core$List$isEmpty(r.d9);
};
var $author$project$Dashboards2$UserFilters$baseColor = function (userFilters) {
	return $author$project$Dashboards2$UserFilters$baseIsNotAlone(userFilters) ? $author$project$Palette$DefaultColor(1) : $author$project$Palette$DefaultColor(0);
};
var $author$project$Dashboards2$UserFilters$audienceColor = F2(
	function (id, _v0) {
		var r = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Dashboards2$UserFilters$baseColor(r),
			$elm$core$List$head(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.jL;
					},
					A2(
						$elm$core$List$filter,
						function (_v1) {
							var audience = _v1.fk;
							return _Utils_eq(audience.b, id);
						},
						r.d9))));
	});
var $author$project$Dashboards2$UserFilters$audienceName = F2(
	function (id, _v0) {
		var userFilters = _v0;
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fk;
				},
				function ($) {
					return $.ld;
				}),
			A2(
				$elm_community$list_extra$List$Extra$find,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fk;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.b;
						},
						$elm$core$Basics$eq(id))),
				userFilters.d9));
	});
var $author$project$Data$Platform2$defaultAudienceName = 'All Internet Users';
var $author$project$Dashboards2$UserFilters$baseAudienceName = function (_v0) {
	var userFilters = _v0;
	var _v1 = userFilters.aU;
	if (!_v1.$) {
		return $author$project$Data$Platform2$defaultAudienceName;
	} else {
		var name = _v1.a.ld;
		return name;
	}
};
var $author$project$Dashboards2$Chart$datapointAndSuffixName = F2(
	function (datapointName, suffixName) {
		if (suffixName.$ === 1) {
			return datapointName;
		} else {
			var suffixName_ = suffixName.a;
			return datapointName + (' ' + suffixName_);
		}
	});
var $author$project$RemoteData$Loaded$fromMaybe = F2(
	function (error, maybe) {
		if (maybe.$ === 1) {
			return $author$project$RemoteData$Loaded$FailureL(error);
		} else {
			var a = maybe.a;
			return $author$project$RemoteData$Loaded$SuccessL(a);
		}
	});
var $author$project$Dashboards2$Chart$getDatapoint = F2(
	function (datapointCode, datapoints) {
		return A2(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
			function (_v0) {
				var code = _v0.bW;
				return _Utils_eq(code, datapointCode);
			},
			datapoints);
	});
var $author$project$Data$Metrics$getMetricValue = function (metric) {
	switch (metric) {
		case 0:
			return function ($) {
				return $.ny;
			};
		case 1:
			return function ($) {
				return $.oe;
			};
		case 2:
			return A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$toFloat,
				function ($) {
					return $.sg;
				});
		case 3:
			return function ($) {
				return $.pi;
			};
		default:
			return A2(
				$elm$core$Basics$composeL,
				$elm$core$Basics$toFloat,
				function ($) {
					return $.qW;
				});
	}
};
var $elm_community$maybe_extra$Maybe$Extra$join = function (mx) {
	if (!mx.$) {
		var x = mx.a;
		return x;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Dashboards2$Chart$AttributeName$getSuffixName = F2(
	function (suffixCode, suffixes) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.ld;
			},
			$elm_community$maybe_extra$Maybe$Extra$join(
				A2(
					$elm$core$Maybe$map,
					function (suffixes_) {
						return A2(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
							function (_v0) {
								var code = _v0.bW;
								return _Utils_eq(code, suffixCode);
							},
							suffixes_);
					},
					suffixes)));
	});
var $author$project$Dashboards2$Chart$AttributeName$getSuffixesLabel = F2(
	function (suffixCodes, suffixes) {
		return $author$project$Dashboards2$Chart$AttributeName$concatSuffixNames(
			A2(
				$elm$core$List$filterMap,
				function (code) {
					return A2($author$project$Dashboards2$Chart$AttributeName$getSuffixName, code, suffixes);
				},
				suffixCodes));
	});
var $elm_community$maybe_extra$Maybe$Extra$traverseHelp = F3(
	function (f, list, acc) {
		traverseHelp:
		while (true) {
			if (list.b) {
				var head = list.a;
				var tail = list.b;
				var _v1 = f(head);
				if (!_v1.$) {
					var a = _v1.a;
					var $temp$f = f,
						$temp$list = tail,
						$temp$acc = A2($elm$core$List$cons, a, acc);
					f = $temp$f;
					list = $temp$list;
					acc = $temp$acc;
					continue traverseHelp;
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Just(
					$elm$core$List$reverse(acc));
			}
		}
	});
var $elm_community$maybe_extra$Maybe$Extra$traverse = F2(
	function (f, list) {
		return A3($elm_community$maybe_extra$Maybe$Extra$traverseHelp, f, list, _List_Nil);
	});
var $author$project$Dashboards2$Chart$getValueData = F4(
	function (list, metric, datapoints, suffixes) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$traverse,
			function (item) {
				return A2(
					$elm$core$Maybe$map,
					function (datapoint) {
						return {
							fA: datapoint.ld,
							dC: item.dC,
							gq: datapoint.gq,
							dQ: A2($author$project$Dashboards2$Chart$AttributeName$getSuffixesLabel, item.eY, suffixes),
							c5: A2($author$project$Data$Metrics$getMetricValue, metric, item.dC)
						};
					},
					A2($author$project$Dashboards2$Chart$getDatapoint, item.eq, datapoints));
			},
			list);
	});
var $elm$core$List$partition = F2(
	function (pred, list) {
		var step = F2(
			function (x, _v0) {
				var trues = _v0.a;
				var falses = _v0.b;
				return pred(x) ? _Utils_Tuple2(
					A2($elm$core$List$cons, x, trues),
					falses) : _Utils_Tuple2(
					trues,
					A2($elm$core$List$cons, x, falses));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(_List_Nil, _List_Nil),
			list);
	});
var $elm_community$list_extra$List$Extra$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				helper:
				while (true) {
					if (!scattered.b) {
						return $elm$core$List$reverse(gathered);
					} else {
						var toGather = scattered.a;
						var population = scattered.b;
						var _v1 = A2(
							$elm$core$List$partition,
							testFn(toGather),
							population);
						var gathering = _v1.a;
						var remaining = _v1.b;
						var $temp$scattered = remaining,
							$temp$gathered = A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered);
						scattered = $temp$scattered;
						gathered = $temp$gathered;
						continue helper;
					}
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $elm_community$list_extra$List$Extra$gatherEqualsBy = F2(
	function (extract, list) {
		return A2(
			$elm_community$list_extra$List$Extra$gatherWith,
			F2(
				function (a, b) {
					return _Utils_eq(
						extract(a),
						extract(b));
				}),
			list);
	});
var $author$project$Gwi$List$groupBy = F2(
	function (fn, list) {
		return A2(
			$elm$core$List$map,
			function (_v0) {
				var first = _v0.a;
				var rest = _v0.b;
				return {
					f2: _Utils_Tuple2(first, rest),
					h3: fn(first)
				};
			},
			A2($elm_community$list_extra$List$Extra$gatherEqualsBy, fn, list));
	});
var $author$project$Dashboards2$Chart$orderedAndFilteredByAudiences = F2(
	function (userFilters, list) {
		var orderedAudineces = A2(
			$elm$core$List$indexedMap,
			$elm$core$Tuple$pair,
			$author$project$Dashboards2$UserFilters$activeAudienceIds(userFilters));
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$second,
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$first,
				A2(
					$elm$core$List$filterMap,
					function (item) {
						return A2(
							$elm$core$Maybe$map,
							$elm$core$Tuple$mapSecond(
								$elm$core$Basics$always(item)),
							A2(
								$elm_community$list_extra$List$Extra$find,
								function (_v0) {
									var aId = _v0.b;
									return _Utils_eq(aId, item.jn);
								},
								orderedAudineces));
					},
					list)));
	});
var $author$project$Gwi$Http$DBChartTypeIncompatibleWithQResult = function (a) {
	return {$: 2, a: a};
};
var $author$project$Gwi$Http$OtherError = function (a) {
	return {$: 7, a: a};
};
var $author$project$Dashboards2$Chart$qresultError = F2(
	function (qResultType, chartType) {
		return $author$project$RemoteData$Loaded$FailureL(
			$author$project$Gwi$Http$OtherError(
				$author$project$Gwi$Http$DBChartTypeIncompatibleWithQResult(
					{
						aI: $author$project$D3Charts$Dashboards$ChartType$toString(chartType),
						qD: qResultType
					})));
	});
var $author$project$Gwi$Http$DBWidgetQuestionNotFound = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2$Chart$questionNotFoundError = F2(
	function (questionCode, widgetId) {
		return $author$project$Gwi$Http$OtherError(
			$author$project$Gwi$Http$DBWidgetQuestionNotFound(
				{
					at: $author$project$Data$Id$unwrap(questionCode),
					sj: $author$project$Data$Id$unwrap(widgetId)
				}));
	});
var $author$project$Dashboards2$Chart$toAudienceScopedD3Data = F6(
	function (userFilters, store, qresult, metric, _v0, _v1) {
		var id = _v0.b;
		var chartType = _v1.aI;
		switch (qresult.$) {
			case 2:
				return A2($author$project$Dashboards2$Chart$qresultError, 'DatapointSegments', chartType);
			case 3:
				return A2($author$project$Dashboards2$Chart$qresultError, 'DatapointSegmentAudiences', chartType);
			case 0:
				var questionCode = qresult.a.at;
				var list = qresult.b;
				return A2(
					$author$project$RemoteData$Loaded$fromMaybe,
					A2($author$project$Dashboards2$Chart$questionNotFoundError, questionCode, id),
					A2(
						$elm$core$Maybe$andThen,
						function (question) {
							return A2(
								$elm$core$Maybe$map,
								function (list_) {
									var color = $author$project$Dashboards2$UserFilters$baseColor(userFilters);
									var audienceName = $author$project$Dashboards2$UserFilters$baseAudienceName(userFilters);
									return _List_fromArray(
										[
											{
											jL: $elm$core$Maybe$Just(color),
											cl: A2(
												$elm$core$List$map,
												function (_v3) {
													var datapointName = _v3.fA;
													var suffixName = _v3.dQ;
													var value = _v3.c5;
													var metrics = _v3.dC;
													return {
														jL: color,
														fD: $elm$core$Maybe$Nothing,
														dC: metrics,
														ld: A2($author$project$Dashboards2$Chart$datapointAndSuffixName, datapointName, suffixName),
														eP: audienceName,
														c5: value
													};
												},
												list_),
											ld: audienceName
										}
										]);
								},
								A4($author$project$Dashboards2$Chart$getValueData, list, metric, question.er, question.rI));
						},
						A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store)));
			default:
				var questionCode = qresult.a.at;
				var list = qresult.b;
				return A2(
					$author$project$RemoteData$Loaded$fromMaybe,
					A2($author$project$Dashboards2$Chart$questionNotFoundError, questionCode, id),
					A2(
						$elm$core$Maybe$map,
						function (list_) {
							return A2(
								$elm$core$List$map,
								function (group) {
									var _v5 = group.h3;
									var audienceColor = _v5.b;
									var audienceName = _v5.c;
									return {
										jL: $elm$core$Maybe$Just(audienceColor),
										cl: A2(
											$elm$core$List$map,
											function (_v6) {
												var attributeName = _v6.jj;
												var value = _v6.c5;
												var metrics = _v6.dC;
												return {jL: audienceColor, fD: $elm$core$Maybe$Nothing, dC: metrics, ld: attributeName, eP: audienceName, c5: value};
											},
											$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(group.f2)),
										ld: audienceName
									};
								},
								A2(
									$author$project$Gwi$List$groupBy,
									function (_v4) {
										var audienceId = _v4.jn;
										var audienceColor = _v4.bS;
										var audienceName = _v4.jp;
										return _Utils_Tuple3(
											$author$project$Data$Id$unwrap(audienceId),
											audienceColor,
											audienceName);
									},
									list_));
						},
						A2(
							$elm$core$Maybe$andThen,
							function (question) {
								return A2(
									$elm_community$maybe_extra$Maybe$Extra$traverse,
									function (item) {
										return A3(
											$elm$core$Maybe$map2,
											F2(
												function (datapoint, audienceName) {
													var suffixName = A2($author$project$Dashboards2$Chart$AttributeName$getSuffixesLabel, item.eY, question.rI);
													return {
														jj: A2($author$project$Dashboards2$Chart$datapointAndSuffixName, datapoint.ld, suffixName),
														bS: A2($author$project$Dashboards2$UserFilters$audienceColor, item.jn, userFilters),
														jn: item.jn,
														jp: audienceName,
														dC: item.dC,
														gq: datapoint.gq,
														c5: A2($author$project$Data$Metrics$getMetricValue, metric, item.dC)
													};
												}),
											A2($author$project$Dashboards2$Chart$getDatapoint, item.eq, question.er),
											A2($author$project$Dashboards2$UserFilters$audienceName, item.jn, userFilters));
									},
									A2($author$project$Dashboards2$Chart$orderedAndFilteredByAudiences, userFilters, list));
							},
							A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store))));
		}
	});
var $author$project$Dashboards2$Chart$getAudiencesNamesAndValues = F5(
	function (userFilters, list, metric, datapoints, suffixes) {
		return A2(
			$elm_community$maybe_extra$Maybe$Extra$traverse,
			function (item) {
				return A3(
					$elm$core$Maybe$map2,
					F2(
						function (datapoint, audienceName) {
							return {
								bS: A2($author$project$Dashboards2$UserFilters$audienceColor, item.jn, userFilters),
								jp: audienceName,
								hv: datapoint,
								dC: item.dC,
								dQ: A2($author$project$Dashboards2$Chart$AttributeName$getSuffixesLabel, item.eY, suffixes),
								c5: A2($author$project$Data$Metrics$getMetricValue, metric, item.dC)
							};
						}),
					A2($author$project$Dashboards2$Chart$getDatapoint, item.eq, datapoints),
					A2($author$project$Dashboards2$UserFilters$audienceName, item.jn, userFilters));
			},
			A2($author$project$Dashboards2$Chart$orderedAndFilteredByAudiences, userFilters, list));
	});
var $author$project$Dashboards2$Chart$toDatapointScopedD3Data = F6(
	function (userFilters, store, qresult, metric, _v0, _v1) {
		var id = _v0.b;
		var chartType = _v1.aI;
		switch (qresult.$) {
			case 2:
				return A2($author$project$Dashboards2$Chart$qresultError, 'DatapointSegments', chartType);
			case 3:
				return A2($author$project$Dashboards2$Chart$qresultError, 'DatapointSegmentAudiences', chartType);
			case 0:
				var questionCode = qresult.a.at;
				var list = qresult.b;
				return A2(
					$author$project$RemoteData$Loaded$fromMaybe,
					A2($author$project$Dashboards2$Chart$questionNotFoundError, questionCode, id),
					A2(
						$elm$core$Maybe$andThen,
						function (question) {
							return A2(
								$elm$core$Maybe$map,
								$elm$core$List$map(
									function (_v3) {
										var datapointName = _v3.fA;
										var suffixName = _v3.dQ;
										var value = _v3.c5;
										var metrics = _v3.dC;
										return {
											jL: $elm$core$Maybe$Nothing,
											cl: _List_fromArray(
												[
													{
													jL: $author$project$Dashboards2$UserFilters$baseColor(userFilters),
													fD: $elm$core$Maybe$Nothing,
													dC: metrics,
													ld: datapointName,
													eP: $author$project$Dashboards2$UserFilters$baseAudienceName(userFilters),
													c5: value
												}
												]),
											ld: A2($author$project$Dashboards2$Chart$datapointAndSuffixName, datapointName, suffixName)
										};
									}),
								A4($author$project$Dashboards2$Chart$getValueData, list, metric, question.er, question.rI));
						},
						A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store)));
			default:
				var questionCode = qresult.a.at;
				var list = qresult.b;
				return A2(
					$author$project$RemoteData$Loaded$fromMaybe,
					A2($author$project$Dashboards2$Chart$questionNotFoundError, questionCode, id),
					A2(
						$elm$core$Maybe$andThen,
						function (question) {
							return A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Gwi$List$groupBy(
										function (_v4) {
											var datapoint = _v4.hv;
											var suffixName = _v4.dQ;
											return _Utils_Tuple2(
												$author$project$Data$Id$unwrap(datapoint.bW),
												A2($author$project$Dashboards2$Chart$datapointAndSuffixName, datapoint.ld, suffixName));
										}),
									$elm$core$List$map(
										function (group) {
											var attributeName = group.h3.b;
											return {
												jL: $elm$core$Maybe$Nothing,
												cl: A2(
													$elm$core$List$map,
													function (_v5) {
														var audienceColor = _v5.bS;
														var audienceName = _v5.jp;
														var value = _v5.c5;
														var metrics = _v5.dC;
														return {jL: audienceColor, fD: $elm$core$Maybe$Nothing, dC: metrics, ld: attributeName, eP: audienceName, c5: value};
													},
													$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(group.f2)),
												ld: attributeName
											};
										})),
								A5($author$project$Dashboards2$Chart$getAudiencesNamesAndValues, userFilters, list, metric, question.er, question.rI));
						},
						A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store)));
		}
	});
var $author$project$Data$Labels$parseNamespaceCode = function (code) {
	var _v0 = A2(
		$elm$core$String$split,
		'.',
		$author$project$Data$Id$unwrap(code));
	if (!_v0.b) {
		return $author$project$Data$Id$fromString('core');
	} else {
		if (!_v0.b.b) {
			return $author$project$Data$Id$fromString('core');
		} else {
			var h = _v0.a;
			return $author$project$Data$Id$fromString(h);
		}
	}
};
var $author$project$Data$Platform2$namespacesForChartWidget = function (_v0) {
	var data = _v0.cl;
	if (!data.$) {
		var questionCode = data.a.at;
		return _List_fromArray(
			[
				$author$project$Data$Labels$parseNamespaceCode(questionCode)
			]);
	} else {
		var groups = data.a;
		return A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.at;
				},
				$author$project$Data$Labels$parseNamespaceCode),
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(groups));
	}
};
var $author$project$Gwi$Http$DBWidgetSplitterNotFound = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboards2$Chart$splitterNotFoundError = F2(
	function (splitterCode, widgetId) {
		return $author$project$Gwi$Http$OtherError(
			$author$project$Gwi$Http$DBWidgetSplitterNotFound(
				{
					gP: $author$project$Data$Id$unwrap(splitterCode),
					sj: $author$project$Data$Id$unwrap(widgetId)
				}));
	});
var $author$project$Dashboards2$Chart$toTimeSeriesD3Data = F6(
	function (userFilters, store, qresult, metric, _v0, chartWidget) {
		var id = _v0.b;
		var chartType = chartWidget.aI;
		var questionCode = $turboMaCk$non_empty_list_alias$List$NonEmpty$head(
			$author$project$Data$Platform2$widgetDataQuestionCodes(chartWidget.cl));
		var namespaceCode = $author$project$Data$Labels$questionCodeToNamespaceCode(questionCode);
		var splitters = A2($author$project$Store$Platform2$getSplitters, namespaceCode, store);
		switch (qresult.$) {
			case 0:
				return A2($author$project$Dashboards2$Chart$qresultError, 'Datapoints', chartType);
			case 1:
				return A2($author$project$Dashboards2$Chart$qresultError, 'DatapointAudiences', chartType);
			case 2:
				var splitterCode = qresult.a.gP;
				var list = qresult.b;
				return A2(
					$author$project$RemoteData$Loaded$fromMaybe,
					A2($author$project$Dashboards2$Chart$splitterNotFoundError, splitterCode, id),
					A2(
						$elm$core$Maybe$andThen,
						function (splitter) {
							return A2(
								$elm$core$Maybe$map,
								function (list_) {
									var color = $author$project$Dashboards2$UserFilters$baseColor(userFilters);
									var audienceName = $author$project$Dashboards2$UserFilters$baseAudienceName(userFilters);
									return _List_fromArray(
										[
											{
											jL: $elm$core$Maybe$Nothing,
											cl: A2(
												$elm$core$List$filterMap,
												function (_v2) {
													var value = _v2.c5;
													var segment = _v2.gN;
													var metrics = _v2.dC;
													var waveCode = $author$project$Data$Id$fromString(
														$author$project$Data$Id$unwrap(segment.b));
													var namespaceCodes = $author$project$Data$Platform2$namespacesForChartWidget(chartWidget);
													return A2(
														$elm$core$Maybe$andThen,
														function (wave) {
															return (value > 0) ? $elm$core$Maybe$Just(
																{
																	jL: color,
																	fD: $elm$core$Maybe$Just(wave.mk),
																	dC: metrics,
																	ld: segment.ld,
																	eP: audienceName,
																	c5: value
																}) : $elm$core$Maybe$Nothing;
														},
														A2(
															$elm$core$Maybe$andThen,
															function (codes) {
																return A2(
																	$author$project$Store$Utils$get,
																	A2($author$project$Store$Platform2$getWavesForNamespaces, codes, store),
																	waveCode);
															},
															$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(namespaceCodes)));
												},
												list_),
											ld: audienceName
										}
										]);
								},
								A2(
									$elm_community$maybe_extra$Maybe$Extra$traverse,
									function (item) {
										return A2(
											$elm$core$Maybe$map,
											function (segment) {
												return {
													dC: item.dC,
													gN: segment,
													c5: A2($author$project$Data$Metrics$getMetricValue, metric, item.dC)
												};
											},
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (segment) {
													return _Utils_eq(segment.b, item.l3);
												},
												splitter.l5));
									},
									list));
						},
						A2($author$project$Store$Utils$get, splitters, splitterCode)));
			default:
				var data = qresult.a;
				var list = qresult.b;
				var attributeName = A2(
					$elm$core$Maybe$withDefault,
					'The attribute used by this line chart could not be found',
					A2(
						$elm$core$Maybe$andThen,
						$elm$core$List$head,
						A2(
							$elm$core$Maybe$andThen,
							function (question) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$List$map(
										function (_v6) {
											var datapointName = _v6.fA;
											var suffixName = _v6.dQ;
											return A2($author$project$Dashboards2$Chart$datapointAndSuffixName, datapointName, suffixName);
										}),
									A4(
										$author$project$Dashboards2$Chart$getValueData,
										A2(
											$elm$core$List$map,
											function (_v5) {
												var datapointCode = _v5.eq;
												var suffixCodes = _v5.eY;
												var metrics = _v5.dC;
												return {eq: datapointCode, dC: metrics, eY: suffixCodes};
											},
											list),
										metric,
										question.er,
										question.rI));
							},
							A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store))));
				return A2(
					$author$project$RemoteData$Loaded$fromMaybe,
					A2($author$project$Dashboards2$Chart$splitterNotFoundError, data.gP, id),
					A2(
						$elm$core$Maybe$andThen,
						function (splitter) {
							return A2(
								$elm$core$Maybe$map,
								function (list_) {
									return A2(
										$elm$core$List$map,
										function (group) {
											var audienceName = group.h3.b;
											return {
												jL: $elm$core$Maybe$Nothing,
												cl: A2(
													$elm$core$List$filterMap,
													function (_v4) {
														var audienceColor = _v4.bS;
														var value = _v4.c5;
														var segment = _v4.gN;
														var metrics = _v4.dC;
														var waveCode = $author$project$Data$Id$fromString(
															$author$project$Data$Id$unwrap(segment.b));
														var namespaceCodes = $author$project$Data$Platform2$namespacesForChartWidget(chartWidget);
														return A2(
															$elm$core$Maybe$andThen,
															function (wave) {
																return (value > 0) ? $elm$core$Maybe$Just(
																	{
																		jL: audienceColor,
																		fD: $elm$core$Maybe$Just(wave.mk),
																		dC: metrics,
																		ld: audienceName,
																		eP: attributeName,
																		c5: value
																	}) : $elm$core$Maybe$Nothing;
															},
															A2(
																$elm$core$Maybe$andThen,
																function (codes) {
																	return A2(
																		$author$project$Store$Utils$get,
																		A2($author$project$Store$Platform2$getWavesForNamespaces, codes, store),
																		waveCode);
																},
																$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(namespaceCodes)));
													},
													$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(group.f2)),
												ld: attributeName
											};
										},
										A2(
											$author$project$Gwi$List$groupBy,
											function (_v3) {
												var audienceId = _v3.jn;
												var audienceName = _v3.jp;
												return _Utils_Tuple2(
													$author$project$Data$Id$unwrap(audienceId),
													audienceName);
											},
											list_));
								},
								A2(
									$elm_community$maybe_extra$Maybe$Extra$traverse,
									function (item) {
										return A3(
											$elm$core$Maybe$map2,
											F2(
												function (audienceName, segment) {
													return {
														bS: A2($author$project$Dashboards2$UserFilters$audienceColor, item.jn, userFilters),
														jn: item.jn,
														jp: audienceName,
														dC: item.dC,
														gN: segment,
														c5: A2($author$project$Data$Metrics$getMetricValue, metric, item.dC)
													};
												}),
											A2($author$project$Dashboards2$UserFilters$audienceName, item.jn, userFilters),
											A2(
												$elm_community$list_extra$List$Extra$find,
												function (segment) {
													return _Utils_eq(segment.b, item.l3);
												},
												splitter.l5));
									},
									A2($author$project$Dashboards2$Chart$orderedAndFilteredByAudiences, userFilters, list)));
						},
						A2($author$project$Store$Utils$get, splitters, data.gP)));
		}
	});
var $author$project$Dashboards2$Chart$toD3Data = F6(
	function (userFilters, store, metric, widget, chartWidget, qresult) {
		var _v0 = $author$project$D3Charts$Dashboards$ChartType$shape(chartWidget.aI);
		switch (_v0) {
			case 0:
				return A6($author$project$Dashboards2$Chart$toDatapointScopedD3Data, userFilters, store, qresult, metric, widget, chartWidget);
			case 1:
				return A6($author$project$Dashboards2$Chart$toDatapointScopedD3Data, userFilters, store, qresult, metric, widget, chartWidget);
			case 2:
				return A6($author$project$Dashboards2$Chart$toAudienceScopedD3Data, userFilters, store, qresult, metric, widget, chartWidget);
			default:
				return A6($author$project$Dashboards2$Chart$toTimeSeriesD3Data, userFilters, store, qresult, metric, widget, chartWidget);
		}
	});
var $author$project$Dashboards2$Chart$buildNonpaginatedData = F6(
	function (userFilters, store, metric, widget, chartWidget, qResults) {
		return A2(
			$author$project$RemoteData$Loaded$map,
			$author$project$Gwi$List$fastConcat,
			$author$project$RemoteData$Loaded$sequence(
				A2(
					$elm$core$List$map,
					A5($author$project$Dashboards2$Chart$toD3Data, userFilters, store, metric, widget, chartWidget),
					qResults)));
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$html$Html$div = _VirtualDom_node('div');
var $author$project$Data$Calc$Platform2$dashboardQueryErrorToString = function (err) {
	switch (err.$) {
		case 0:
			return 'Invalid query';
		case 1:
			return 'Empty expression';
		case 2:
			return 'Invalid projects combination';
		default:
			return 'Splitter not whitelisted';
	}
};
var $author$project$Data$Core$Error$forbiddenErrorToString = function (metadata) {
	var stuff = A2(
		$elm$core$String$join,
		', ',
		A2(
			$elm$core$List$filterMap,
			function (_v0) {
				var list = _v0.a;
				var label = _v0.b;
				return A2(
					$elm$core$Maybe$map,
					function (l) {
						return ' for these ' + (label + (': ' + A2(
							$elm$core$String$join,
							', ',
							$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(l))));
					},
					list);
			},
			_List_fromArray(
				[
					_Utils_Tuple2(metadata.bt, 'questions'),
					_Utils_Tuple2(metadata.cD, 'locations'),
					_Utils_Tuple2(metadata.dX, 'waves')
				])));
	return 'User permissions are insufficient' + (stuff + '.');
};
var $author$project$Data$Core$Error$errorToString = function (err) {
	switch (err.$) {
		case 0:
			return 'Bad request';
		case 1:
			return 'Validation error';
		case 2:
			return 'Internal server error';
		case 4:
			return 'Unauthorized';
		case 5:
			return 'Invalid Token';
		case 6:
			return 'Inconsistent Token';
		case 3:
			var metadata = err.a;
			return $author$project$Data$Core$Error$forbiddenErrorToString(metadata);
		case 7:
			return 'JSON encode error';
		case 8:
			return 'JSON decode error';
		case 9:
			return 'Not found';
		case 10:
			return 'Proxy error';
		case 11:
			return 'Gateway timeout';
		default:
			var err_ = err.a;
			return 'Unknown error: ' + err_;
	}
};
var $author$project$Gwi$Http$otherErrorToString = function (otherError) {
	switch (otherError.$) {
		case 0:
			return 'Two average values cannot be compared against each other';
		case 7:
			return 'Question for average was not available';
		case 1:
			return 'Please duplicate your project before moving it into a folder.';
		case 2:
			var qResultType = otherError.a.qD;
			var chartType = otherError.a.aI;
			return 'Widget QResult of type ' + (qResultType + (': incompatible with chart type ' + chartType));
		case 3:
			var questionCode = otherError.a.at;
			var widgetId = otherError.a.sj;
			return 'Didn\'t find question code ' + (questionCode + (' for widget ID ' + widgetId));
		case 4:
			var splitterCode = otherError.a.gP;
			var widgetId = otherError.a.sj;
			return 'Didn\'t find splitter code ' + (splitterCode + (' for widget ID ' + widgetId));
		case 5:
			return 'Results data is empty list.';
		case 6:
			return 'Tried to paginate with itemsPerPage = Nothing';
		case 8:
			return 'No channels in the plan';
		case 9:
			return 'This question does not support averages';
		default:
			var info = otherError.a;
			return 'This question has incorrectly defined averages: ' + info;
	}
};
var $author$project$Gwi$Http$errorToString = F2(
	function (customErrorToString, error) {
		switch (error.$) {
			case 0:
				var string = error.a;
				return 'Bad URL: ' + string;
			case 1:
				return 'Your calculation request has timed out';
			case 2:
				return 'Network error';
			case 3:
				var string = error.b;
				return 'Bad status: ' + string;
			case 4:
				var decodeError = error.b;
				return 'Bad body: ' + $elm$json$Json$Decode$errorToString(decodeError);
			case 5:
				var genericError = error.c;
				return $author$project$Data$Core$Error$errorToString(genericError);
			case 6:
				var customError = error.c;
				return customErrorToString(customError);
			default:
				var otherError = error.a;
				return $author$project$Gwi$Http$otherErrorToString(otherError);
		}
	});
var $author$project$Dashboards2$Chart$errorText = function (err) {
	var defaultErrorText = 'ERROR: ' + A2($author$project$Gwi$Http$errorToString, $author$project$Data$Calc$Platform2$dashboardQueryErrorToString, err);
	if (err.$ === 3) {
		var statusCode = err.a.rD;
		return (statusCode === 408) ? 'Oops, your request took too long! Please reload the dashboard and/or remove some audiences from your filters.' : defaultErrorText;
	} else {
		return defaultErrorText;
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current = function (_v0) {
	var f = _v0.b;
	return f;
};
var $author$project$Dashboards2$Chart$emptyD3Data = F2(
	function (store, qresults) {
		return A2(
			$author$project$Gwi$List$fastConcatMap,
			function (qresult) {
				switch (qresult.$) {
					case 0:
						return _List_Nil;
					case 2:
						return _List_Nil;
					case 1:
						var questionCode = qresult.a.at;
						var list = qresult.b;
						var datapointCodes = $author$project$Data$Id$setFromList(
							A2(
								$elm_community$list_extra$List$Extra$uniqueBy,
								$author$project$Data$Id$unwrap,
								A2(
									$elm$core$List$map,
									function ($) {
										return $.eq;
									},
									list)));
						return A2(
							$elm$core$Maybe$withDefault,
							_List_Nil,
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.er;
									},
									A2(
										$elm$core$Basics$composeR,
										$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
										$elm$core$List$filterMap(
											function (_v1) {
												var code = _v1.bW;
												var name = _v1.ld;
												return A2($turboMaCk$any_set$Set$Any$member, code, datapointCodes) ? $elm$core$Maybe$Just(
													{jL: $elm$core$Maybe$Nothing, cl: _List_Nil, ld: name}) : $elm$core$Maybe$Nothing;
											}))),
								A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store)));
					default:
						return _List_Nil;
				}
			},
			qresults);
	});
var $author$project$Dashboards2$Chart$getDashboardWebDataFromZipper = F2(
	function (store, userFilters) {
		return $author$project$RemoteData$Loaded$map(
			function (_v0) {
				var qresultsDict = _v0.a;
				var maybeZipper = _v0.b;
				if (maybeZipper.$ === 1) {
					return A2(
						$author$project$Dashboards2$Chart$emptyD3Data,
						store,
						A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							_List_Nil,
							$turboMaCk$any_set$Set$Any$toList,
							A2($turboMaCk$any_dict$Dict$Any$get, userFilters, qresultsDict)));
				} else {
					var zipper = maybeZipper.a;
					return $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current(zipper);
				}
			});
	});
var $author$project$Data$Platform2$getGroupedWidgetDataDatapointCodes = F2(
	function (question, groupedData) {
		var _v0 = groupedData.er;
		if (!_v0.$) {
			return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
				A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
					function ($) {
						return $.bW;
					},
					question.er));
		} else {
			var xs = _v0.a;
			return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
				A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $elm$core$Tuple$first, xs));
		}
	});
var $author$project$Data$Platform2$getOldWidgetDataDatapointCodes = F2(
	function (question, oldData) {
		var _v0 = oldData.hw;
		if (!_v0.$) {
			return A2(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
				function ($) {
					return $.bW;
				},
				question.er);
		} else {
			var xs = _v0.a;
			return xs;
		}
	});
var $author$project$Data$Platform2$getDatapointCodesForQuestionForWidget = F2(
	function (question, widgetData) {
		if (!widgetData.$) {
			var oldData = widgetData.a;
			return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
				A2($author$project$Data$Platform2$getOldWidgetDataDatapointCodes, question, oldData));
		} else {
			var groups = widgetData.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				A2($elm$core$Basics$composeR, $turboMaCk$non_empty_list_alias$List$NonEmpty$toList, $author$project$Gwi$List$fastConcat),
				A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
					function (group) {
						return _Utils_eq(group.at, question.k1) ? $elm$core$Maybe$Just(
							A2($author$project$Data$Platform2$getGroupedWidgetDataDatapointCodes, question, group)) : $elm$core$Maybe$Nothing;
					},
					groups));
		}
	});
var $author$project$Data$Platform2$partitionUnknownDatapoints = F2(
	function (_v0, widgetDatapointCodes) {
		var datapoints = _v0.er;
		var questionDatapointCodes = A2(
			$elm$core$List$map,
			function ($) {
				return $.bW;
			},
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(datapoints));
		var _v1 = A2(
			$elm$core$List$partition,
			function (widgetDatapointCode) {
				return A2($elm$core$List$member, widgetDatapointCode, questionDatapointCodes);
			},
			widgetDatapointCodes);
		var known = _v1.a;
		var knownSorted = A2(
			$elm$core$List$filter,
			function (code) {
				return A2($elm$core$List$member, code, known);
			},
			questionDatapointCodes);
		return {kW: knownSorted};
	});
var $author$project$D3Charts$Dashboards$ChartType$StatCard = 9;
var $author$project$D3Charts$Dashboards$ChartType$StatCardColored = 10;
var $author$project$Data$Platform2$isOneDatapointChartType = function (chartType) {
	return A2(
		$elm$core$List$member,
		chartType,
		_List_fromArray(
			[4, 9, 10]));
};
var $author$project$Data$Platform2$selectDatapointCodesForChartType = F2(
	function (chartType, datapointCodes) {
		return $author$project$Data$Platform2$isOneDatapointChartType(chartType) ? A2($elm$core$List$take, 1, datapointCodes) : datapointCodes;
	});
var $author$project$Data$Platform2$getValidDatapointCodesForWidget = F2(
	function (question, widget) {
		return A2(
			$author$project$Data$Platform2$selectDatapointCodesForChartType,
			widget.aI,
			A2(
				$author$project$Data$Platform2$partitionUnknownDatapoints,
				question,
				A2($author$project$Data$Platform2$getDatapointCodesForQuestionForWidget, question, widget.cl)).kW);
	});
var $author$project$Dashboards2$Chart$getWidgetQuestions = F2(
	function (chartWidget, store) {
		var _v0 = chartWidget.cl;
		if (!_v0.$) {
			var questionCode = _v0.a.at;
			return A2(
				$elm$core$Maybe$map,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton,
				A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store));
		} else {
			var groups = _v0.a;
			return A2(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
				function (_v1) {
					var questionCode = _v1.at;
					return A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store);
				},
				groups);
		}
	});
var $author$project$D3Charts$Dashboards$ChartType$isValidNumberOfDatapoints = F2(
	function (chartType, n) {
		var _v0 = $author$project$D3Charts$Dashboards$ChartType$datapointCountRequirement(chartType);
		switch (_v0) {
			case 0:
				return n === 1;
			case 1:
				return n >= 3;
			default:
				return true;
		}
	});
var $GlobalWebIndex$class_namespaces$WeakCss$ClassName = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {pi: index, pO: match, p4: number, mo: submatches};
	});
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $GlobalWebIndex$class_namespaces$Escape$removeByRegex = function (regex) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$String$toLower,
		A2(
			$elm$regex$Regex$replace,
			regex,
			function (_v0) {
				return '';
			}));
};
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{jA: false, lc: false},
		string);
};
var $elm$regex$Regex$never = _Regex_never;
var $GlobalWebIndex$class_namespaces$Escape$stuffInvalidInNamespace = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[^_a-zA-Z]+|[^\\w\\-]'));
var $GlobalWebIndex$class_namespaces$Escape$sanitizeNamespace = $GlobalWebIndex$class_namespaces$Escape$removeByRegex($GlobalWebIndex$class_namespaces$Escape$stuffInvalidInNamespace);
var $GlobalWebIndex$class_namespaces$WeakCss$namespace = function (name) {
	return A2(
		$GlobalWebIndex$class_namespaces$WeakCss$ClassName,
		$GlobalWebIndex$class_namespaces$Escape$sanitizeNamespace(name),
		_List_Nil);
};
var $author$project$Dashboards2$Chart$moduleClass = $GlobalWebIndex$class_namespaces$WeakCss$namespace('dashboards-chart-2');
var $GlobalWebIndex$class_namespaces$Escape$stuffInvalidInClass = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^[^_a-zA-Z]+|[^\\w\\-]|_{2,}|-{2,}'));
var $GlobalWebIndex$class_namespaces$Escape$sanitize = $GlobalWebIndex$class_namespaces$Escape$removeByRegex($GlobalWebIndex$class_namespaces$Escape$stuffInvalidInClass);
var $GlobalWebIndex$class_namespaces$WeakCss$add = F2(
	function (name, _v0) {
		var classNamespace = _v0.a;
		var list = _v0.b;
		return A2(
			$GlobalWebIndex$class_namespaces$WeakCss$ClassName,
			classNamespace,
			A2(
				$elm$core$List$cons,
				$GlobalWebIndex$class_namespaces$Escape$sanitize(name),
				list));
	});
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $GlobalWebIndex$class_namespaces$WeakCss$toString = function (_v0) {
	var classNamespace = _v0.a;
	var list = _v0.b;
	var spacer = function (acc) {
		return $elm$core$String$isEmpty(acc) ? '' : '--';
	};
	var foldElement = F2(
		function (name, acc) {
			return _Utils_ap(
				acc,
				_Utils_ap(
					spacer(acc),
					name));
		});
	if (!list.b) {
		return classNamespace;
	} else {
		return classNamespace + ('__' + A3($elm$core$List$foldr, foldElement, '', list));
	}
};
var $GlobalWebIndex$class_namespaces$WeakCss$toClass = A2($elm$core$Basics$composeL, $elm$html$Html$Attributes$class, $GlobalWebIndex$class_namespaces$WeakCss$toString);
var $GlobalWebIndex$class_namespaces$WeakCss$nest = function (name) {
	return A2(
		$elm$core$Basics$composeL,
		$GlobalWebIndex$class_namespaces$WeakCss$toClass,
		$GlobalWebIndex$class_namespaces$WeakCss$add(name));
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm_community$html_extra$Html$Extra$nothing = $elm$html$Html$text('');
var $elm$core$String$foldl = _String_foldl;
var $elm$core$Char$fromCode = _Char_fromCode;
var $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList = _List_fromArray(
	[
		_Utils_Tuple2('Ⓐ', 'A'),
		_Utils_Tuple2('Ａ', 'A'),
		_Utils_Tuple2('À', 'A'),
		_Utils_Tuple2('Á', 'A'),
		_Utils_Tuple2('Â', 'A'),
		_Utils_Tuple2('Ầ', 'A'),
		_Utils_Tuple2('Ấ', 'A'),
		_Utils_Tuple2('Ẫ', 'A'),
		_Utils_Tuple2('Ẩ', 'A'),
		_Utils_Tuple2('Ã', 'A'),
		_Utils_Tuple2('Ā', 'A'),
		_Utils_Tuple2('Ă', 'A'),
		_Utils_Tuple2('Ằ', 'A'),
		_Utils_Tuple2('Ắ', 'A'),
		_Utils_Tuple2('Ẵ', 'A'),
		_Utils_Tuple2('Ẳ', 'A'),
		_Utils_Tuple2('Ȧ', 'A'),
		_Utils_Tuple2('Ǡ', 'A'),
		_Utils_Tuple2('Ä', 'A'),
		_Utils_Tuple2('Ǟ', 'A'),
		_Utils_Tuple2('Ả', 'A'),
		_Utils_Tuple2('Å', 'A'),
		_Utils_Tuple2('Ǻ', 'A'),
		_Utils_Tuple2('Ǎ', 'A'),
		_Utils_Tuple2('Ȁ', 'A'),
		_Utils_Tuple2('Ȃ', 'A'),
		_Utils_Tuple2('Ạ', 'A'),
		_Utils_Tuple2('Ậ', 'A'),
		_Utils_Tuple2('Ặ', 'A'),
		_Utils_Tuple2('Ḁ', 'A'),
		_Utils_Tuple2('Ą', 'A'),
		_Utils_Tuple2('Ⱥ', 'A'),
		_Utils_Tuple2('Ɐ', 'A'),
		_Utils_Tuple2('Ꜳ', 'AA'),
		_Utils_Tuple2('Æ', 'AE'),
		_Utils_Tuple2('Ǽ', 'AE'),
		_Utils_Tuple2('Ǣ', 'AE'),
		_Utils_Tuple2('Ꜵ', 'AO'),
		_Utils_Tuple2('Ꜷ', 'AU'),
		_Utils_Tuple2('Ꜹ', 'AV'),
		_Utils_Tuple2('Ꜻ', 'AV'),
		_Utils_Tuple2('Ꜽ', 'AY'),
		_Utils_Tuple2('Ⓑ', 'B'),
		_Utils_Tuple2('Ｂ', 'B'),
		_Utils_Tuple2('Ḃ', 'B'),
		_Utils_Tuple2('Ḅ', 'B'),
		_Utils_Tuple2('Ḇ', 'B'),
		_Utils_Tuple2('Ƀ', 'B'),
		_Utils_Tuple2('Ƃ', 'B'),
		_Utils_Tuple2('Ɓ', 'B'),
		_Utils_Tuple2('Ⓒ', 'C'),
		_Utils_Tuple2('Ｃ', 'C'),
		_Utils_Tuple2('Ć', 'C'),
		_Utils_Tuple2('Ĉ', 'C'),
		_Utils_Tuple2('Ċ', 'C'),
		_Utils_Tuple2('Č', 'C'),
		_Utils_Tuple2('Ç', 'C'),
		_Utils_Tuple2('Ḉ', 'C'),
		_Utils_Tuple2('Ƈ', 'C'),
		_Utils_Tuple2('Ȼ', 'C'),
		_Utils_Tuple2('Ꜿ', 'C'),
		_Utils_Tuple2('Ⓓ', 'D'),
		_Utils_Tuple2('Ｄ', 'D'),
		_Utils_Tuple2('Ḋ', 'D'),
		_Utils_Tuple2('Ď', 'D'),
		_Utils_Tuple2('Ḍ', 'D'),
		_Utils_Tuple2('Ḑ', 'D'),
		_Utils_Tuple2('Ḓ', 'D'),
		_Utils_Tuple2('Ḏ', 'D'),
		_Utils_Tuple2('Đ', 'D'),
		_Utils_Tuple2('Ƌ', 'D'),
		_Utils_Tuple2('Ɗ', 'D'),
		_Utils_Tuple2('Ɖ', 'D'),
		_Utils_Tuple2('Ꝺ', 'D'),
		_Utils_Tuple2('Ǳ', 'DZ'),
		_Utils_Tuple2('Ǆ', 'DZ'),
		_Utils_Tuple2('ǲ', 'Dz'),
		_Utils_Tuple2('ǅ', 'Dz'),
		_Utils_Tuple2('Ⓔ', 'E'),
		_Utils_Tuple2('Ｅ', 'E'),
		_Utils_Tuple2('È', 'E'),
		_Utils_Tuple2('É', 'E'),
		_Utils_Tuple2('Ê', 'E'),
		_Utils_Tuple2('Ề', 'E'),
		_Utils_Tuple2('Ế', 'E'),
		_Utils_Tuple2('Ễ', 'E'),
		_Utils_Tuple2('Ể', 'E'),
		_Utils_Tuple2('Ẽ', 'E'),
		_Utils_Tuple2('Ē', 'E'),
		_Utils_Tuple2('Ḕ', 'E'),
		_Utils_Tuple2('Ḗ', 'E'),
		_Utils_Tuple2('Ĕ', 'E'),
		_Utils_Tuple2('Ė', 'E'),
		_Utils_Tuple2('Ë', 'E'),
		_Utils_Tuple2('Ẻ', 'E'),
		_Utils_Tuple2('Ě', 'E'),
		_Utils_Tuple2('Ȅ', 'E'),
		_Utils_Tuple2('Ȇ', 'E'),
		_Utils_Tuple2('Ẹ', 'E'),
		_Utils_Tuple2('Ệ', 'E'),
		_Utils_Tuple2('Ȩ', 'E'),
		_Utils_Tuple2('Ḝ', 'E'),
		_Utils_Tuple2('Ę', 'E'),
		_Utils_Tuple2('Ḙ', 'E'),
		_Utils_Tuple2('Ḛ', 'E'),
		_Utils_Tuple2('Ɛ', 'E'),
		_Utils_Tuple2('Ǝ', 'E'),
		_Utils_Tuple2('Ⓕ', 'F'),
		_Utils_Tuple2('Ｆ', 'F'),
		_Utils_Tuple2('Ḟ', 'F'),
		_Utils_Tuple2('Ƒ', 'F'),
		_Utils_Tuple2('Ꝼ', 'F'),
		_Utils_Tuple2('Ⓖ', 'G'),
		_Utils_Tuple2('Ｇ', 'G'),
		_Utils_Tuple2('Ǵ', 'G'),
		_Utils_Tuple2('Ĝ', 'G'),
		_Utils_Tuple2('Ḡ', 'G'),
		_Utils_Tuple2('Ğ', 'G'),
		_Utils_Tuple2('Ġ', 'G'),
		_Utils_Tuple2('Ǧ', 'G'),
		_Utils_Tuple2('Ģ', 'G'),
		_Utils_Tuple2('Ǥ', 'G'),
		_Utils_Tuple2('Ɠ', 'G'),
		_Utils_Tuple2('Ꞡ', 'G'),
		_Utils_Tuple2('Ᵹ', 'G'),
		_Utils_Tuple2('Ꝿ', 'G'),
		_Utils_Tuple2('Ⓗ', 'H'),
		_Utils_Tuple2('Ｈ', 'H'),
		_Utils_Tuple2('Ĥ', 'H'),
		_Utils_Tuple2('Ḣ', 'H'),
		_Utils_Tuple2('Ḧ', 'H'),
		_Utils_Tuple2('Ȟ', 'H'),
		_Utils_Tuple2('Ḥ', 'H'),
		_Utils_Tuple2('Ḩ', 'H'),
		_Utils_Tuple2('Ḫ', 'H'),
		_Utils_Tuple2('Ħ', 'H'),
		_Utils_Tuple2('Ⱨ', 'H'),
		_Utils_Tuple2('Ⱶ', 'H'),
		_Utils_Tuple2('Ɥ', 'H'),
		_Utils_Tuple2('Ⓘ', 'I'),
		_Utils_Tuple2('Ｉ', 'I'),
		_Utils_Tuple2('Ì', 'I'),
		_Utils_Tuple2('Í', 'I'),
		_Utils_Tuple2('Î', 'I'),
		_Utils_Tuple2('Ĩ', 'I'),
		_Utils_Tuple2('Ī', 'I'),
		_Utils_Tuple2('Ĭ', 'I'),
		_Utils_Tuple2('İ', 'I'),
		_Utils_Tuple2('Ï', 'I'),
		_Utils_Tuple2('Ḯ', 'I'),
		_Utils_Tuple2('Ỉ', 'I'),
		_Utils_Tuple2('Ǐ', 'I'),
		_Utils_Tuple2('Ȉ', 'I'),
		_Utils_Tuple2('Ȋ', 'I'),
		_Utils_Tuple2('Ị', 'I'),
		_Utils_Tuple2('Į', 'I'),
		_Utils_Tuple2('Ḭ', 'I'),
		_Utils_Tuple2('Ɨ', 'I'),
		_Utils_Tuple2('Ⓙ', 'J'),
		_Utils_Tuple2('Ｊ', 'J'),
		_Utils_Tuple2('Ĵ', 'J'),
		_Utils_Tuple2('Ɉ', 'J'),
		_Utils_Tuple2('Ⓚ', 'K'),
		_Utils_Tuple2('Ｋ', 'K'),
		_Utils_Tuple2('Ḱ', 'K'),
		_Utils_Tuple2('Ǩ', 'K'),
		_Utils_Tuple2('Ḳ', 'K'),
		_Utils_Tuple2('Ķ', 'K'),
		_Utils_Tuple2('Ḵ', 'K'),
		_Utils_Tuple2('Ƙ', 'K'),
		_Utils_Tuple2('Ⱪ', 'K'),
		_Utils_Tuple2('Ꝁ', 'K'),
		_Utils_Tuple2('Ꝃ', 'K'),
		_Utils_Tuple2('Ꝅ', 'K'),
		_Utils_Tuple2('Ꞣ', 'K'),
		_Utils_Tuple2('Ⓛ', 'L'),
		_Utils_Tuple2('Ｌ', 'L'),
		_Utils_Tuple2('Ŀ', 'L'),
		_Utils_Tuple2('Ĺ', 'L'),
		_Utils_Tuple2('Ľ', 'L'),
		_Utils_Tuple2('Ḷ', 'L'),
		_Utils_Tuple2('Ḹ', 'L'),
		_Utils_Tuple2('Ļ', 'L'),
		_Utils_Tuple2('Ḽ', 'L'),
		_Utils_Tuple2('Ḻ', 'L'),
		_Utils_Tuple2('Ł', 'L'),
		_Utils_Tuple2('Ƚ', 'L'),
		_Utils_Tuple2('Ɫ', 'L'),
		_Utils_Tuple2('Ⱡ', 'L'),
		_Utils_Tuple2('Ꝉ', 'L'),
		_Utils_Tuple2('Ꝇ', 'L'),
		_Utils_Tuple2('Ꞁ', 'L'),
		_Utils_Tuple2('Ǉ', 'LJ'),
		_Utils_Tuple2('ǈ', 'Lj'),
		_Utils_Tuple2('Ⓜ', 'M'),
		_Utils_Tuple2('Ｍ', 'M'),
		_Utils_Tuple2('Ḿ', 'M'),
		_Utils_Tuple2('Ṁ', 'M'),
		_Utils_Tuple2('Ṃ', 'M'),
		_Utils_Tuple2('Ɱ', 'M'),
		_Utils_Tuple2('Ɯ', 'M'),
		_Utils_Tuple2('Ⓝ', 'N'),
		_Utils_Tuple2('Ｎ', 'N'),
		_Utils_Tuple2('Ǹ', 'N'),
		_Utils_Tuple2('Ń', 'N'),
		_Utils_Tuple2('Ñ', 'N'),
		_Utils_Tuple2('Ṅ', 'N'),
		_Utils_Tuple2('Ň', 'N'),
		_Utils_Tuple2('Ṇ', 'N'),
		_Utils_Tuple2('Ņ', 'N'),
		_Utils_Tuple2('Ṋ', 'N'),
		_Utils_Tuple2('Ṉ', 'N'),
		_Utils_Tuple2('Ƞ', 'N'),
		_Utils_Tuple2('Ɲ', 'N'),
		_Utils_Tuple2('Ꞑ', 'N'),
		_Utils_Tuple2('Ꞥ', 'N'),
		_Utils_Tuple2('Ǌ', 'NJ'),
		_Utils_Tuple2('ǋ', 'Nj'),
		_Utils_Tuple2('Ⓞ', 'O'),
		_Utils_Tuple2('Ｏ', 'O'),
		_Utils_Tuple2('Ò', 'O'),
		_Utils_Tuple2('Ó', 'O'),
		_Utils_Tuple2('Ô', 'O'),
		_Utils_Tuple2('Ồ', 'O'),
		_Utils_Tuple2('Ố', 'O'),
		_Utils_Tuple2('Ỗ', 'O'),
		_Utils_Tuple2('Ổ', 'O'),
		_Utils_Tuple2('Õ', 'O'),
		_Utils_Tuple2('Ṍ', 'O'),
		_Utils_Tuple2('Ȭ', 'O'),
		_Utils_Tuple2('Ṏ', 'O'),
		_Utils_Tuple2('Ō', 'O'),
		_Utils_Tuple2('Ṑ', 'O'),
		_Utils_Tuple2('Ṓ', 'O'),
		_Utils_Tuple2('Ŏ', 'O'),
		_Utils_Tuple2('Ȯ', 'O'),
		_Utils_Tuple2('Ȱ', 'O'),
		_Utils_Tuple2('Ö', 'O'),
		_Utils_Tuple2('Ȫ', 'O'),
		_Utils_Tuple2('Ỏ', 'O'),
		_Utils_Tuple2('Ő', 'O'),
		_Utils_Tuple2('Ǒ', 'O'),
		_Utils_Tuple2('Ȍ', 'O'),
		_Utils_Tuple2('Ȏ', 'O'),
		_Utils_Tuple2('Ơ', 'O'),
		_Utils_Tuple2('Ờ', 'O'),
		_Utils_Tuple2('Ớ', 'O'),
		_Utils_Tuple2('Ỡ', 'O'),
		_Utils_Tuple2('Ở', 'O'),
		_Utils_Tuple2('Ợ', 'O'),
		_Utils_Tuple2('Ọ', 'O'),
		_Utils_Tuple2('Ộ', 'O'),
		_Utils_Tuple2('Ǫ', 'O'),
		_Utils_Tuple2('Ǭ', 'O'),
		_Utils_Tuple2('Ø', 'O'),
		_Utils_Tuple2('Ǿ', 'O'),
		_Utils_Tuple2('Ɔ', 'O'),
		_Utils_Tuple2('Ɵ', 'O'),
		_Utils_Tuple2('Ꝋ', 'O'),
		_Utils_Tuple2('Ꝍ', 'O'),
		_Utils_Tuple2('Ƣ', 'OI'),
		_Utils_Tuple2('Ꝏ', 'OO'),
		_Utils_Tuple2('Ȣ', 'OU'),
		_Utils_Tuple2('\u008C', 'OE'),
		_Utils_Tuple2('Œ', 'OE'),
		_Utils_Tuple2('\u009C', 'oe'),
		_Utils_Tuple2('œ', 'oe'),
		_Utils_Tuple2('Ⓟ', 'P'),
		_Utils_Tuple2('Ｐ', 'P'),
		_Utils_Tuple2('Ṕ', 'P'),
		_Utils_Tuple2('Ṗ', 'P'),
		_Utils_Tuple2('Ƥ', 'P'),
		_Utils_Tuple2('Ᵽ', 'P'),
		_Utils_Tuple2('Ꝑ', 'P'),
		_Utils_Tuple2('Ꝓ', 'P'),
		_Utils_Tuple2('Ꝕ', 'P'),
		_Utils_Tuple2('Ⓠ', 'Q'),
		_Utils_Tuple2('Ｑ', 'Q'),
		_Utils_Tuple2('Ꝗ', 'Q'),
		_Utils_Tuple2('Ꝙ', 'Q'),
		_Utils_Tuple2('Ɋ', 'Q'),
		_Utils_Tuple2('Ⓡ', 'R'),
		_Utils_Tuple2('Ｒ', 'R'),
		_Utils_Tuple2('Ŕ', 'R'),
		_Utils_Tuple2('Ṙ', 'R'),
		_Utils_Tuple2('Ř', 'R'),
		_Utils_Tuple2('Ȑ', 'R'),
		_Utils_Tuple2('Ȓ', 'R'),
		_Utils_Tuple2('Ṛ', 'R'),
		_Utils_Tuple2('Ṝ', 'R'),
		_Utils_Tuple2('Ŗ', 'R'),
		_Utils_Tuple2('Ṟ', 'R'),
		_Utils_Tuple2('Ɍ', 'R'),
		_Utils_Tuple2('Ɽ', 'R'),
		_Utils_Tuple2('Ꝛ', 'R'),
		_Utils_Tuple2('Ꞧ', 'R'),
		_Utils_Tuple2('Ꞃ', 'R'),
		_Utils_Tuple2('Ⓢ', 'S'),
		_Utils_Tuple2('Ｓ', 'S'),
		_Utils_Tuple2('ẞ', 'S'),
		_Utils_Tuple2('Ś', 'S'),
		_Utils_Tuple2('Ṥ', 'S'),
		_Utils_Tuple2('Ŝ', 'S'),
		_Utils_Tuple2('Ṡ', 'S'),
		_Utils_Tuple2('Š', 'S'),
		_Utils_Tuple2('Ṧ', 'S'),
		_Utils_Tuple2('Ṣ', 'S'),
		_Utils_Tuple2('Ṩ', 'S'),
		_Utils_Tuple2('Ș', 'S'),
		_Utils_Tuple2('Ş', 'S'),
		_Utils_Tuple2('Ȿ', 'S'),
		_Utils_Tuple2('Ꞩ', 'S'),
		_Utils_Tuple2('Ꞅ', 'S'),
		_Utils_Tuple2('Ⓣ', 'T'),
		_Utils_Tuple2('Ｔ', 'T'),
		_Utils_Tuple2('Ṫ', 'T'),
		_Utils_Tuple2('Ť', 'T'),
		_Utils_Tuple2('Ṭ', 'T'),
		_Utils_Tuple2('Ț', 'T'),
		_Utils_Tuple2('Ţ', 'T'),
		_Utils_Tuple2('Ṱ', 'T'),
		_Utils_Tuple2('Ṯ', 'T'),
		_Utils_Tuple2('Ŧ', 'T'),
		_Utils_Tuple2('Ƭ', 'T'),
		_Utils_Tuple2('Ʈ', 'T'),
		_Utils_Tuple2('Ⱦ', 'T'),
		_Utils_Tuple2('Ꞇ', 'T'),
		_Utils_Tuple2('Ꜩ', 'TZ'),
		_Utils_Tuple2('Ⓤ', 'U'),
		_Utils_Tuple2('Ｕ', 'U'),
		_Utils_Tuple2('Ù', 'U'),
		_Utils_Tuple2('Ú', 'U'),
		_Utils_Tuple2('Û', 'U'),
		_Utils_Tuple2('Ũ', 'U'),
		_Utils_Tuple2('Ṹ', 'U'),
		_Utils_Tuple2('Ū', 'U'),
		_Utils_Tuple2('Ṻ', 'U'),
		_Utils_Tuple2('Ŭ', 'U'),
		_Utils_Tuple2('Ü', 'U'),
		_Utils_Tuple2('Ǜ', 'U'),
		_Utils_Tuple2('Ǘ', 'U'),
		_Utils_Tuple2('Ǖ', 'U'),
		_Utils_Tuple2('Ǚ', 'U'),
		_Utils_Tuple2('Ủ', 'U'),
		_Utils_Tuple2('Ů', 'U'),
		_Utils_Tuple2('Ű', 'U'),
		_Utils_Tuple2('Ǔ', 'U'),
		_Utils_Tuple2('Ȕ', 'U'),
		_Utils_Tuple2('Ȗ', 'U'),
		_Utils_Tuple2('Ư', 'U'),
		_Utils_Tuple2('Ừ', 'U'),
		_Utils_Tuple2('Ứ', 'U'),
		_Utils_Tuple2('Ữ', 'U'),
		_Utils_Tuple2('Ử', 'U'),
		_Utils_Tuple2('Ự', 'U'),
		_Utils_Tuple2('Ụ', 'U'),
		_Utils_Tuple2('Ṳ', 'U'),
		_Utils_Tuple2('Ų', 'U'),
		_Utils_Tuple2('Ṷ', 'U'),
		_Utils_Tuple2('Ṵ', 'U'),
		_Utils_Tuple2('Ʉ', 'U'),
		_Utils_Tuple2('Ⓥ', 'V'),
		_Utils_Tuple2('Ｖ', 'V'),
		_Utils_Tuple2('Ṽ', 'V'),
		_Utils_Tuple2('Ṿ', 'V'),
		_Utils_Tuple2('Ʋ', 'V'),
		_Utils_Tuple2('Ꝟ', 'V'),
		_Utils_Tuple2('Ʌ', 'V'),
		_Utils_Tuple2('Ꝡ', 'VY'),
		_Utils_Tuple2('Ⓦ', 'W'),
		_Utils_Tuple2('Ｗ', 'W'),
		_Utils_Tuple2('Ẁ', 'W'),
		_Utils_Tuple2('Ẃ', 'W'),
		_Utils_Tuple2('Ŵ', 'W'),
		_Utils_Tuple2('Ẇ', 'W'),
		_Utils_Tuple2('Ẅ', 'W'),
		_Utils_Tuple2('Ẉ', 'W'),
		_Utils_Tuple2('Ⱳ', 'W'),
		_Utils_Tuple2('Ⓧ', 'X'),
		_Utils_Tuple2('Ｘ', 'X'),
		_Utils_Tuple2('Ẋ', 'X'),
		_Utils_Tuple2('Ẍ', 'X'),
		_Utils_Tuple2('Ⓨ', 'Y'),
		_Utils_Tuple2('Ｙ', 'Y'),
		_Utils_Tuple2('Ỳ', 'Y'),
		_Utils_Tuple2('Ý', 'Y'),
		_Utils_Tuple2('Ŷ', 'Y'),
		_Utils_Tuple2('Ỹ', 'Y'),
		_Utils_Tuple2('Ȳ', 'Y'),
		_Utils_Tuple2('Ẏ', 'Y'),
		_Utils_Tuple2('Ÿ', 'Y'),
		_Utils_Tuple2('Ỷ', 'Y'),
		_Utils_Tuple2('Ỵ', 'Y'),
		_Utils_Tuple2('Ƴ', 'Y'),
		_Utils_Tuple2('Ɏ', 'Y'),
		_Utils_Tuple2('Ỿ', 'Y'),
		_Utils_Tuple2('Ⓩ', 'Z'),
		_Utils_Tuple2('Ｚ', 'Z'),
		_Utils_Tuple2('Ź', 'Z'),
		_Utils_Tuple2('Ẑ', 'Z'),
		_Utils_Tuple2('Ż', 'Z'),
		_Utils_Tuple2('Ž', 'Z'),
		_Utils_Tuple2('Ẓ', 'Z'),
		_Utils_Tuple2('Ẕ', 'Z'),
		_Utils_Tuple2('Ƶ', 'Z'),
		_Utils_Tuple2('Ȥ', 'Z'),
		_Utils_Tuple2('Ɀ', 'Z'),
		_Utils_Tuple2('Ⱬ', 'Z'),
		_Utils_Tuple2('Ꝣ', 'Z'),
		_Utils_Tuple2('ⓐ', 'a'),
		_Utils_Tuple2('ａ', 'a'),
		_Utils_Tuple2('ẚ', 'a'),
		_Utils_Tuple2('à', 'a'),
		_Utils_Tuple2('á', 'a'),
		_Utils_Tuple2('â', 'a'),
		_Utils_Tuple2('ầ', 'a'),
		_Utils_Tuple2('ấ', 'a'),
		_Utils_Tuple2('ẫ', 'a'),
		_Utils_Tuple2('ẩ', 'a'),
		_Utils_Tuple2('ã', 'a'),
		_Utils_Tuple2('ā', 'a'),
		_Utils_Tuple2('ă', 'a'),
		_Utils_Tuple2('ằ', 'a'),
		_Utils_Tuple2('ắ', 'a'),
		_Utils_Tuple2('ẵ', 'a'),
		_Utils_Tuple2('ẳ', 'a'),
		_Utils_Tuple2('ȧ', 'a'),
		_Utils_Tuple2('ǡ', 'a'),
		_Utils_Tuple2('ä', 'a'),
		_Utils_Tuple2('ǟ', 'a'),
		_Utils_Tuple2('ả', 'a'),
		_Utils_Tuple2('å', 'a'),
		_Utils_Tuple2('ǻ', 'a'),
		_Utils_Tuple2('ǎ', 'a'),
		_Utils_Tuple2('ȁ', 'a'),
		_Utils_Tuple2('ȃ', 'a'),
		_Utils_Tuple2('ạ', 'a'),
		_Utils_Tuple2('ậ', 'a'),
		_Utils_Tuple2('ặ', 'a'),
		_Utils_Tuple2('ḁ', 'a'),
		_Utils_Tuple2('ą', 'a'),
		_Utils_Tuple2('ⱥ', 'a'),
		_Utils_Tuple2('ɐ', 'a'),
		_Utils_Tuple2('ꜳ', 'aa'),
		_Utils_Tuple2('æ', 'ae'),
		_Utils_Tuple2('ǽ', 'ae'),
		_Utils_Tuple2('ǣ', 'ae'),
		_Utils_Tuple2('ꜵ', 'ao'),
		_Utils_Tuple2('ꜷ', 'au'),
		_Utils_Tuple2('ꜹ', 'av'),
		_Utils_Tuple2('ꜻ', 'av'),
		_Utils_Tuple2('ꜽ', 'ay'),
		_Utils_Tuple2('ⓑ', 'b'),
		_Utils_Tuple2('ｂ', 'b'),
		_Utils_Tuple2('ḃ', 'b'),
		_Utils_Tuple2('ḅ', 'b'),
		_Utils_Tuple2('ḇ', 'b'),
		_Utils_Tuple2('ƀ', 'b'),
		_Utils_Tuple2('ƃ', 'b'),
		_Utils_Tuple2('ɓ', 'b'),
		_Utils_Tuple2('ⓒ', 'c'),
		_Utils_Tuple2('ｃ', 'c'),
		_Utils_Tuple2('ć', 'c'),
		_Utils_Tuple2('ĉ', 'c'),
		_Utils_Tuple2('ċ', 'c'),
		_Utils_Tuple2('č', 'c'),
		_Utils_Tuple2('ç', 'c'),
		_Utils_Tuple2('ḉ', 'c'),
		_Utils_Tuple2('ƈ', 'c'),
		_Utils_Tuple2('ȼ', 'c'),
		_Utils_Tuple2('ꜿ', 'c'),
		_Utils_Tuple2('ↄ', 'c'),
		_Utils_Tuple2('ⓓ', 'd'),
		_Utils_Tuple2('ｄ', 'd'),
		_Utils_Tuple2('ḋ', 'd'),
		_Utils_Tuple2('ď', 'd'),
		_Utils_Tuple2('ḍ', 'd'),
		_Utils_Tuple2('ḑ', 'd'),
		_Utils_Tuple2('ḓ', 'd'),
		_Utils_Tuple2('ḏ', 'd'),
		_Utils_Tuple2('đ', 'd'),
		_Utils_Tuple2('ƌ', 'd'),
		_Utils_Tuple2('ɖ', 'd'),
		_Utils_Tuple2('ɗ', 'd'),
		_Utils_Tuple2('ꝺ', 'd'),
		_Utils_Tuple2('ǳ', 'dz'),
		_Utils_Tuple2('ǆ', 'dz'),
		_Utils_Tuple2('ⓔ', 'e'),
		_Utils_Tuple2('ｅ', 'e'),
		_Utils_Tuple2('è', 'e'),
		_Utils_Tuple2('é', 'e'),
		_Utils_Tuple2('ê', 'e'),
		_Utils_Tuple2('ề', 'e'),
		_Utils_Tuple2('ế', 'e'),
		_Utils_Tuple2('ễ', 'e'),
		_Utils_Tuple2('ể', 'e'),
		_Utils_Tuple2('ẽ', 'e'),
		_Utils_Tuple2('ē', 'e'),
		_Utils_Tuple2('ḕ', 'e'),
		_Utils_Tuple2('ḗ', 'e'),
		_Utils_Tuple2('ĕ', 'e'),
		_Utils_Tuple2('ė', 'e'),
		_Utils_Tuple2('ë', 'e'),
		_Utils_Tuple2('ẻ', 'e'),
		_Utils_Tuple2('ě', 'e'),
		_Utils_Tuple2('ȅ', 'e'),
		_Utils_Tuple2('ȇ', 'e'),
		_Utils_Tuple2('ẹ', 'e'),
		_Utils_Tuple2('ệ', 'e'),
		_Utils_Tuple2('ȩ', 'e'),
		_Utils_Tuple2('ḝ', 'e'),
		_Utils_Tuple2('ę', 'e'),
		_Utils_Tuple2('ḙ', 'e'),
		_Utils_Tuple2('ḛ', 'e'),
		_Utils_Tuple2('ɇ', 'e'),
		_Utils_Tuple2('ɛ', 'e'),
		_Utils_Tuple2('ǝ', 'e'),
		_Utils_Tuple2('ⓕ', 'f'),
		_Utils_Tuple2('ｆ', 'f'),
		_Utils_Tuple2('ḟ', 'f'),
		_Utils_Tuple2('ƒ', 'f'),
		_Utils_Tuple2('ꝼ', 'f'),
		_Utils_Tuple2('ⓖ', 'g'),
		_Utils_Tuple2('ｇ', 'g'),
		_Utils_Tuple2('ǵ', 'g'),
		_Utils_Tuple2('ĝ', 'g'),
		_Utils_Tuple2('ḡ', 'g'),
		_Utils_Tuple2('ğ', 'g'),
		_Utils_Tuple2('ġ', 'g'),
		_Utils_Tuple2('ǧ', 'g'),
		_Utils_Tuple2('ģ', 'g'),
		_Utils_Tuple2('ǥ', 'g'),
		_Utils_Tuple2('ɠ', 'g'),
		_Utils_Tuple2('ꞡ', 'g'),
		_Utils_Tuple2('ᵹ', 'g'),
		_Utils_Tuple2('ꝿ', 'g'),
		_Utils_Tuple2('ⓗ', 'h'),
		_Utils_Tuple2('ｈ', 'h'),
		_Utils_Tuple2('ĥ', 'h'),
		_Utils_Tuple2('ḣ', 'h'),
		_Utils_Tuple2('ḧ', 'h'),
		_Utils_Tuple2('ȟ', 'h'),
		_Utils_Tuple2('ḥ', 'h'),
		_Utils_Tuple2('ḩ', 'h'),
		_Utils_Tuple2('ḫ', 'h'),
		_Utils_Tuple2('ẖ', 'h'),
		_Utils_Tuple2('ħ', 'h'),
		_Utils_Tuple2('ⱨ', 'h'),
		_Utils_Tuple2('ⱶ', 'h'),
		_Utils_Tuple2('ɥ', 'h'),
		_Utils_Tuple2('ƕ', 'hv'),
		_Utils_Tuple2('ⓘ', 'i'),
		_Utils_Tuple2('ｉ', 'i'),
		_Utils_Tuple2('ì', 'i'),
		_Utils_Tuple2('í', 'i'),
		_Utils_Tuple2('î', 'i'),
		_Utils_Tuple2('ĩ', 'i'),
		_Utils_Tuple2('ī', 'i'),
		_Utils_Tuple2('ĭ', 'i'),
		_Utils_Tuple2('ï', 'i'),
		_Utils_Tuple2('ḯ', 'i'),
		_Utils_Tuple2('ỉ', 'i'),
		_Utils_Tuple2('ǐ', 'i'),
		_Utils_Tuple2('ȉ', 'i'),
		_Utils_Tuple2('ȋ', 'i'),
		_Utils_Tuple2('ị', 'i'),
		_Utils_Tuple2('į', 'i'),
		_Utils_Tuple2('ḭ', 'i'),
		_Utils_Tuple2('ɨ', 'i'),
		_Utils_Tuple2('ı', 'i'),
		_Utils_Tuple2('ⓙ', 'j'),
		_Utils_Tuple2('ｊ', 'j'),
		_Utils_Tuple2('ĵ', 'j'),
		_Utils_Tuple2('ǰ', 'j'),
		_Utils_Tuple2('ɉ', 'j'),
		_Utils_Tuple2('ⓚ', 'k'),
		_Utils_Tuple2('ｋ', 'k'),
		_Utils_Tuple2('ḱ', 'k'),
		_Utils_Tuple2('ǩ', 'k'),
		_Utils_Tuple2('ḳ', 'k'),
		_Utils_Tuple2('ķ', 'k'),
		_Utils_Tuple2('ḵ', 'k'),
		_Utils_Tuple2('ƙ', 'k'),
		_Utils_Tuple2('ⱪ', 'k'),
		_Utils_Tuple2('ꝁ', 'k'),
		_Utils_Tuple2('ꝃ', 'k'),
		_Utils_Tuple2('ꝅ', 'k'),
		_Utils_Tuple2('ꞣ', 'k'),
		_Utils_Tuple2('ⓛ', 'l'),
		_Utils_Tuple2('ｌ', 'l'),
		_Utils_Tuple2('ŀ', 'l'),
		_Utils_Tuple2('ĺ', 'l'),
		_Utils_Tuple2('ľ', 'l'),
		_Utils_Tuple2('ḷ', 'l'),
		_Utils_Tuple2('ḹ', 'l'),
		_Utils_Tuple2('ļ', 'l'),
		_Utils_Tuple2('ḽ', 'l'),
		_Utils_Tuple2('ḻ', 'l'),
		_Utils_Tuple2('ſ', 'l'),
		_Utils_Tuple2('ł', 'l'),
		_Utils_Tuple2('ƚ', 'l'),
		_Utils_Tuple2('ɫ', 'l'),
		_Utils_Tuple2('ⱡ', 'l'),
		_Utils_Tuple2('ꝉ', 'l'),
		_Utils_Tuple2('ꞁ', 'l'),
		_Utils_Tuple2('ꝇ', 'l'),
		_Utils_Tuple2('ǉ', 'lj'),
		_Utils_Tuple2('ⓜ', 'm'),
		_Utils_Tuple2('ｍ', 'm'),
		_Utils_Tuple2('ḿ', 'm'),
		_Utils_Tuple2('ṁ', 'm'),
		_Utils_Tuple2('ṃ', 'm'),
		_Utils_Tuple2('ɱ', 'm'),
		_Utils_Tuple2('ɯ', 'm'),
		_Utils_Tuple2('ⓝ', 'n'),
		_Utils_Tuple2('ｎ', 'n'),
		_Utils_Tuple2('ǹ', 'n'),
		_Utils_Tuple2('ń', 'n'),
		_Utils_Tuple2('ñ', 'n'),
		_Utils_Tuple2('ṅ', 'n'),
		_Utils_Tuple2('ň', 'n'),
		_Utils_Tuple2('ṇ', 'n'),
		_Utils_Tuple2('ņ', 'n'),
		_Utils_Tuple2('ṋ', 'n'),
		_Utils_Tuple2('ṉ', 'n'),
		_Utils_Tuple2('ƞ', 'n'),
		_Utils_Tuple2('ɲ', 'n'),
		_Utils_Tuple2('ŉ', 'n'),
		_Utils_Tuple2('ꞑ', 'n'),
		_Utils_Tuple2('ꞥ', 'n'),
		_Utils_Tuple2('ǌ', 'nj'),
		_Utils_Tuple2('ⓞ', 'o'),
		_Utils_Tuple2('ｏ', 'o'),
		_Utils_Tuple2('ò', 'o'),
		_Utils_Tuple2('ó', 'o'),
		_Utils_Tuple2('ô', 'o'),
		_Utils_Tuple2('ồ', 'o'),
		_Utils_Tuple2('ố', 'o'),
		_Utils_Tuple2('ỗ', 'o'),
		_Utils_Tuple2('ổ', 'o'),
		_Utils_Tuple2('õ', 'o'),
		_Utils_Tuple2('ṍ', 'o'),
		_Utils_Tuple2('ȭ', 'o'),
		_Utils_Tuple2('ṏ', 'o'),
		_Utils_Tuple2('ō', 'o'),
		_Utils_Tuple2('ṑ', 'o'),
		_Utils_Tuple2('ṓ', 'o'),
		_Utils_Tuple2('ŏ', 'o'),
		_Utils_Tuple2('ȯ', 'o'),
		_Utils_Tuple2('ȱ', 'o'),
		_Utils_Tuple2('ö', 'o'),
		_Utils_Tuple2('ȫ', 'o'),
		_Utils_Tuple2('ỏ', 'o'),
		_Utils_Tuple2('ő', 'o'),
		_Utils_Tuple2('ǒ', 'o'),
		_Utils_Tuple2('ȍ', 'o'),
		_Utils_Tuple2('ȏ', 'o'),
		_Utils_Tuple2('ơ', 'o'),
		_Utils_Tuple2('ờ', 'o'),
		_Utils_Tuple2('ớ', 'o'),
		_Utils_Tuple2('ỡ', 'o'),
		_Utils_Tuple2('ở', 'o'),
		_Utils_Tuple2('ợ', 'o'),
		_Utils_Tuple2('ọ', 'o'),
		_Utils_Tuple2('ộ', 'o'),
		_Utils_Tuple2('ǫ', 'o'),
		_Utils_Tuple2('ǭ', 'o'),
		_Utils_Tuple2('ø', 'o'),
		_Utils_Tuple2('ǿ', 'o'),
		_Utils_Tuple2('ɔ', 'o'),
		_Utils_Tuple2('ꝋ', 'o'),
		_Utils_Tuple2('ꝍ', 'o'),
		_Utils_Tuple2('ɵ', 'o'),
		_Utils_Tuple2('ƣ', 'oi'),
		_Utils_Tuple2('ȣ', 'ou'),
		_Utils_Tuple2('ꝏ', 'oo'),
		_Utils_Tuple2('ⓟ', 'p'),
		_Utils_Tuple2('ｐ', 'p'),
		_Utils_Tuple2('ṕ', 'p'),
		_Utils_Tuple2('ṗ', 'p'),
		_Utils_Tuple2('ƥ', 'p'),
		_Utils_Tuple2('ᵽ', 'p'),
		_Utils_Tuple2('ꝑ', 'p'),
		_Utils_Tuple2('ꝓ', 'p'),
		_Utils_Tuple2('ꝕ', 'p'),
		_Utils_Tuple2('ⓠ', 'q'),
		_Utils_Tuple2('ｑ', 'q'),
		_Utils_Tuple2('ɋ', 'q'),
		_Utils_Tuple2('ꝗ', 'q'),
		_Utils_Tuple2('ꝙ', 'q'),
		_Utils_Tuple2('ⓡ', 'r'),
		_Utils_Tuple2('ｒ', 'r'),
		_Utils_Tuple2('ŕ', 'r'),
		_Utils_Tuple2('ṙ', 'r'),
		_Utils_Tuple2('ř', 'r'),
		_Utils_Tuple2('ȑ', 'r'),
		_Utils_Tuple2('ȓ', 'r'),
		_Utils_Tuple2('ṛ', 'r'),
		_Utils_Tuple2('ṝ', 'r'),
		_Utils_Tuple2('ŗ', 'r'),
		_Utils_Tuple2('ṟ', 'r'),
		_Utils_Tuple2('ɍ', 'r'),
		_Utils_Tuple2('ɽ', 'r'),
		_Utils_Tuple2('ꝛ', 'r'),
		_Utils_Tuple2('ꞧ', 'r'),
		_Utils_Tuple2('ꞃ', 'r'),
		_Utils_Tuple2('ⓢ', 's'),
		_Utils_Tuple2('ｓ', 's'),
		_Utils_Tuple2('ß', 's'),
		_Utils_Tuple2('ś', 's'),
		_Utils_Tuple2('ṥ', 's'),
		_Utils_Tuple2('ŝ', 's'),
		_Utils_Tuple2('ṡ', 's'),
		_Utils_Tuple2('š', 's'),
		_Utils_Tuple2('ṧ', 's'),
		_Utils_Tuple2('ṣ', 's'),
		_Utils_Tuple2('ṩ', 's'),
		_Utils_Tuple2('ș', 's'),
		_Utils_Tuple2('ş', 's'),
		_Utils_Tuple2('ȿ', 's'),
		_Utils_Tuple2('ꞩ', 's'),
		_Utils_Tuple2('ꞅ', 's'),
		_Utils_Tuple2('ẛ', 's'),
		_Utils_Tuple2('ⓣ', 't'),
		_Utils_Tuple2('ｔ', 't'),
		_Utils_Tuple2('ṫ', 't'),
		_Utils_Tuple2('ẗ', 't'),
		_Utils_Tuple2('ť', 't'),
		_Utils_Tuple2('ṭ', 't'),
		_Utils_Tuple2('ț', 't'),
		_Utils_Tuple2('ţ', 't'),
		_Utils_Tuple2('ṱ', 't'),
		_Utils_Tuple2('ṯ', 't'),
		_Utils_Tuple2('ŧ', 't'),
		_Utils_Tuple2('ƭ', 't'),
		_Utils_Tuple2('ʈ', 't'),
		_Utils_Tuple2('ⱦ', 't'),
		_Utils_Tuple2('ꞇ', 't'),
		_Utils_Tuple2('ꜩ', 'tz'),
		_Utils_Tuple2('ⓤ', 'u'),
		_Utils_Tuple2('ｕ', 'u'),
		_Utils_Tuple2('ù', 'u'),
		_Utils_Tuple2('ú', 'u'),
		_Utils_Tuple2('û', 'u'),
		_Utils_Tuple2('ũ', 'u'),
		_Utils_Tuple2('ṹ', 'u'),
		_Utils_Tuple2('ū', 'u'),
		_Utils_Tuple2('ṻ', 'u'),
		_Utils_Tuple2('ŭ', 'u'),
		_Utils_Tuple2('ü', 'u'),
		_Utils_Tuple2('ǜ', 'u'),
		_Utils_Tuple2('ǘ', 'u'),
		_Utils_Tuple2('ǖ', 'u'),
		_Utils_Tuple2('ǚ', 'u'),
		_Utils_Tuple2('ủ', 'u'),
		_Utils_Tuple2('ů', 'u'),
		_Utils_Tuple2('ű', 'u'),
		_Utils_Tuple2('ǔ', 'u'),
		_Utils_Tuple2('ȕ', 'u'),
		_Utils_Tuple2('ȗ', 'u'),
		_Utils_Tuple2('ư', 'u'),
		_Utils_Tuple2('ừ', 'u'),
		_Utils_Tuple2('ứ', 'u'),
		_Utils_Tuple2('ữ', 'u'),
		_Utils_Tuple2('ử', 'u'),
		_Utils_Tuple2('ự', 'u'),
		_Utils_Tuple2('ụ', 'u'),
		_Utils_Tuple2('ṳ', 'u'),
		_Utils_Tuple2('ų', 'u'),
		_Utils_Tuple2('ṷ', 'u'),
		_Utils_Tuple2('ṵ', 'u'),
		_Utils_Tuple2('ʉ', 'u'),
		_Utils_Tuple2('ⓥ', 'v'),
		_Utils_Tuple2('ｖ', 'v'),
		_Utils_Tuple2('ṽ', 'v'),
		_Utils_Tuple2('ṿ', 'v'),
		_Utils_Tuple2('ʋ', 'v'),
		_Utils_Tuple2('ꝟ', 'v'),
		_Utils_Tuple2('ʌ', 'v'),
		_Utils_Tuple2('ꝡ', 'vy'),
		_Utils_Tuple2('ⓦ', 'w'),
		_Utils_Tuple2('ｗ', 'w'),
		_Utils_Tuple2('ẁ', 'w'),
		_Utils_Tuple2('ẃ', 'w'),
		_Utils_Tuple2('ŵ', 'w'),
		_Utils_Tuple2('ẇ', 'w'),
		_Utils_Tuple2('ẅ', 'w'),
		_Utils_Tuple2('ẘ', 'w'),
		_Utils_Tuple2('ẉ', 'w'),
		_Utils_Tuple2('ⱳ', 'w'),
		_Utils_Tuple2('ⓧ', 'x'),
		_Utils_Tuple2('ｘ', 'x'),
		_Utils_Tuple2('ẋ', 'x'),
		_Utils_Tuple2('ẍ', 'x'),
		_Utils_Tuple2('ⓨ', 'y'),
		_Utils_Tuple2('ｙ', 'y'),
		_Utils_Tuple2('ỳ', 'y'),
		_Utils_Tuple2('ý', 'y'),
		_Utils_Tuple2('ŷ', 'y'),
		_Utils_Tuple2('ỹ', 'y'),
		_Utils_Tuple2('ȳ', 'y'),
		_Utils_Tuple2('ẏ', 'y'),
		_Utils_Tuple2('ÿ', 'y'),
		_Utils_Tuple2('ỷ', 'y'),
		_Utils_Tuple2('ẙ', 'y'),
		_Utils_Tuple2('ỵ', 'y'),
		_Utils_Tuple2('ƴ', 'y'),
		_Utils_Tuple2('ɏ', 'y'),
		_Utils_Tuple2('ỿ', 'y'),
		_Utils_Tuple2('ⓩ', 'z'),
		_Utils_Tuple2('ｚ', 'z'),
		_Utils_Tuple2('ź', 'z'),
		_Utils_Tuple2('ẑ', 'z'),
		_Utils_Tuple2('ż', 'z'),
		_Utils_Tuple2('ž', 'z'),
		_Utils_Tuple2('ẓ', 'z'),
		_Utils_Tuple2('ẕ', 'z'),
		_Utils_Tuple2('ƶ', 'z')
	]);
var $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupTable = $elm$core$Dict$fromList($kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList);
var $kuon$elm_string_normalize$String$Normalize$Diacritics$maxUnicode = 1114111;
var $elm$core$List$maximum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$max, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $kuon$elm_string_normalize$String$Normalize$Diacritics$maxCode = A2(
	$elm$core$Maybe$withDefault,
	$kuon$elm_string_normalize$String$Normalize$Diacritics$maxUnicode,
	$elm$core$List$maximum(
		A2(
			$elm$core$List$map,
			$elm$core$Char$toCode,
			A2($elm$core$List$map, $elm$core$Tuple$first, $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList))));
var $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupArray = $elm$core$Array$fromList(
	A2(
		$elm$core$List$map,
		function (i) {
			var _v0 = A2(
				$elm$core$Dict$get,
				$elm$core$Char$fromCode(i),
				$kuon$elm_string_normalize$String$Normalize$Diacritics$lookupTable);
			if (_v0.$ === 1) {
				return $elm$core$String$fromChar(
					$elm$core$Char$fromCode(i));
			} else {
				var str = _v0.a;
				return str;
			}
		},
		A2($elm$core$List$range, 0, $kuon$elm_string_normalize$String$Normalize$Diacritics$maxCode)));
var $elm$core$List$minimum = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(
			A3($elm$core$List$foldl, $elm$core$Basics$min, x, xs));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $kuon$elm_string_normalize$String$Normalize$Diacritics$minCode = A2(
	$elm$core$Maybe$withDefault,
	0,
	$elm$core$List$minimum(
		A2(
			$elm$core$List$map,
			$elm$core$Char$toCode,
			A2($elm$core$List$map, $elm$core$Tuple$first, $kuon$elm_string_normalize$String$Normalize$Diacritics$lookupList))));
var $kuon$elm_string_normalize$String$Normalize$removeDiacritics = function (str) {
	var replace = F2(
		function (c, result) {
			if (_Utils_cmp(
				$elm$core$Char$toCode(c),
				$kuon$elm_string_normalize$String$Normalize$Diacritics$minCode) < 0) {
				return _Utils_ap(
					result,
					$elm$core$String$fromChar(c));
			} else {
				var _v0 = A2(
					$elm$core$Array$get,
					$elm$core$Char$toCode(c),
					$kuon$elm_string_normalize$String$Normalize$Diacritics$lookupArray);
				if (!_v0.$) {
					var candidate = _v0.a;
					return _Utils_ap(result, candidate);
				} else {
					return _Utils_ap(
						result,
						$elm$core$String$fromChar(c));
				}
			}
		});
	return A3($elm$core$String$foldl, replace, '', str);
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$toComparableString = A2($elm$core$Basics$composeL, $elm$core$String$toLower, $kuon$elm_string_normalize$String$Normalize$removeDiacritics);
var $mcordova47$elm_natural_ordering$NaturalOrdering$compareChunks = F2(
	function (chunk1, chunk2) {
		var _v0 = _Utils_Tuple2(chunk1, chunk2);
		if (!_v0.a.$) {
			if (!_v0.b.$) {
				var str1 = _v0.a.a;
				var str2 = _v0.b.a;
				return A2(
					$elm$core$Basics$compare,
					$mcordova47$elm_natural_ordering$NaturalOrdering$toComparableString(str1),
					$mcordova47$elm_natural_ordering$NaturalOrdering$toComparableString(str2));
			} else {
				return 2;
			}
		} else {
			if (!_v0.b.$) {
				return 0;
			} else {
				var int1 = _v0.a.a;
				var int2 = _v0.b.a;
				return A2($elm$core$Basics$compare, int1, int2);
			}
		}
	});
var $mcordova47$elm_natural_ordering$NaturalOrdering$compareChunkLists = F2(
	function (chunkList1, chunkList2) {
		compareChunkLists:
		while (true) {
			var _v0 = _Utils_Tuple2(chunkList1, chunkList2);
			if (!_v0.a.b) {
				if (!_v0.b.b) {
					return 1;
				} else {
					var _v1 = _v0.b;
					return 0;
				}
			} else {
				if (!_v0.b.b) {
					var _v2 = _v0.a;
					return 2;
				} else {
					var _v3 = _v0.a;
					var chunk1 = _v3.a;
					var chunks1 = _v3.b;
					var _v4 = _v0.b;
					var chunk2 = _v4.a;
					var chunks2 = _v4.b;
					var _v5 = A2($mcordova47$elm_natural_ordering$NaturalOrdering$compareChunks, chunk1, chunk2);
					if (_v5 === 1) {
						var $temp$chunkList1 = chunks1,
							$temp$chunkList2 = chunks2;
						chunkList1 = $temp$chunkList1;
						chunkList2 = $temp$chunkList2;
						continue compareChunkLists;
					} else {
						var ord = _v5;
						return ord;
					}
				}
			}
		}
	});
var $mcordova47$elm_natural_ordering$NaturalOrdering$chunkRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('[0-9]+|[^0-9]+'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $mcordova47$elm_natural_ordering$NaturalOrdering$StringChunk = function (a) {
	return {$: 0, a: a};
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$IntChunk = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$isNaN = _Basics_isNaN;
var $mcordova47$elm_natural_ordering$NaturalOrdering$intToChunk = function (_int) {
	return $elm$core$Basics$isNaN(_int) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
		$mcordova47$elm_natural_ordering$NaturalOrdering$IntChunk(_int));
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$toChunk = function (str) {
	return A2(
		$elm$core$Maybe$withDefault,
		$mcordova47$elm_natural_ordering$NaturalOrdering$StringChunk(str),
		A2(
			$elm$core$Maybe$andThen,
			$mcordova47$elm_natural_ordering$NaturalOrdering$intToChunk,
			$elm$core$String$toInt(str)));
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$toChunks = function (str) {
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeL,
			$mcordova47$elm_natural_ordering$NaturalOrdering$toChunk,
			function ($) {
				return $.pO;
			}),
		A2($elm$regex$Regex$find, $mcordova47$elm_natural_ordering$NaturalOrdering$chunkRegex, str));
};
var $mcordova47$elm_natural_ordering$NaturalOrdering$compareOn = F3(
	function (f, x, y) {
		return A2(
			$mcordova47$elm_natural_ordering$NaturalOrdering$compareChunkLists,
			$mcordova47$elm_natural_ordering$NaturalOrdering$toChunks(
				f(x)),
			$mcordova47$elm_natural_ordering$NaturalOrdering$toChunks(
				f(y)));
	});
var $mcordova47$elm_natural_ordering$NaturalOrdering$compare = $mcordova47$elm_natural_ordering$NaturalOrdering$compareOn($elm$core$Basics$identity);
var $elm$core$List$sortWith = _List_sortWith;
var $author$project$Dashboards2$Chart$sortNonpaginatedData = function (chartWidget) {
	var sortData = F3(
		function (getValue, a, b) {
			var _v1 = chartWidget.cY;
			switch (_v1) {
				case 1:
					return A2(
						$elm$core$Basics$compare,
						getValue(a),
						getValue(b));
				case 0:
					return A2(
						$elm$core$Basics$compare,
						getValue(b),
						getValue(a));
				case 2:
					return A2($mcordova47$elm_natural_ordering$NaturalOrdering$compare, a.ld, b.ld);
				default:
					return 1;
			}
		});
	var getGroupValue = function (_v0) {
		var data = _v0.cl;
		return $elm$core$List$sum(
			A2(
				$elm$core$List$map,
				function ($) {
					return $.c5;
				},
				data));
	};
	return $author$project$RemoteData$Loaded$map(
		function (d3Data) {
			return A2(
				$elm$core$List$sortWith,
				sortData(getGroupValue),
				A2(
					$elm$core$List$map,
					function (group) {
						return _Utils_update(
							group,
							{
								cl: A2(
									$elm$core$List$sortWith,
									sortData(
										function ($) {
											return $.c5;
										}),
									group.cl)
							});
					},
					d3Data));
		});
};
var $author$project$Data$Platform2$getAllDatapointCodesForWidgetInOriginalOrder = F2(
	function (questions, widgetData) {
		if (!widgetData.$) {
			var oldData = widgetData.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				function (q) {
					return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
						A2($author$project$Data$Platform2$getOldWidgetDataDatapointCodes, q, oldData));
				},
				A2(
					$elm$core$Maybe$andThen,
					$krisajenkins$remotedata$RemoteData$toMaybe,
					A2($turboMaCk$any_dict$Dict$Any$get, oldData.at, questions)));
		} else {
			var groups = widgetData.a;
			return A2(
				$author$project$Gwi$List$fastConcatMap,
				function (group) {
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						function (q) {
							return A2($author$project$Data$Platform2$getGroupedWidgetDataDatapointCodes, q, group);
						},
						A2(
							$elm$core$Maybe$andThen,
							$krisajenkins$remotedata$RemoteData$toMaybe,
							A2($turboMaCk$any_dict$Dict$Any$get, group.at, questions)));
				},
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(groups));
		}
	});
var $author$project$Dashboards2$Chart$sortResultsByDefaultDatapointOrder = F3(
	function (questions, chartWidget, qResults) {
		var datapointCodesWithOrder = A2(
			$turboMaCk$any_dict$Dict$Any$fromList,
			$author$project$Data$Id$unwrap,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (i, codes) {
						return _Utils_Tuple2(codes, i);
					}),
				A2($author$project$Data$Platform2$getAllDatapointCodesForWidgetInOriginalOrder, questions, chartWidget.cl)));
		var sortAndGetGroupOrder = function (items) {
			var getOrderValue = function (item) {
				return A2(
					$elm$core$Maybe$withDefault,
					0,
					A2($turboMaCk$any_dict$Dict$Any$get, item.eq, datapointCodesWithOrder));
			};
			var sorted = A2($elm$core$List$sortBy, getOrderValue, items);
			return _Utils_Tuple2(
				sorted,
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					0,
					getOrderValue,
					$elm$core$List$head(sorted)));
		};
		var sortAndGetGroupOrderWithAudiences = function (items) {
			var orderForGroup = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$List$minimum(
					A2(
						$elm$core$List$map,
						function (i) {
							return A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($turboMaCk$any_dict$Dict$Any$get, i.eq, datapointCodesWithOrder));
						},
						items)));
			return _Utils_Tuple2(
				sortAndGetGroupOrder(items).a,
				orderForGroup);
		};
		var sortResultAndGetItsOrder = function (result) {
			switch (result.$) {
				case 0:
					var v = result.a;
					var list = result.b;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Data$Calc$Platform2$Datapoints(v),
						sortAndGetGroupOrder(list));
				case 1:
					var v = result.a;
					var list = result.b;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Data$Calc$Platform2$DatapointAudiences(v),
						sortAndGetGroupOrderWithAudiences(list));
				case 2:
					var v = result.a;
					var list = result.b;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Data$Calc$Platform2$DatapointSegments(v),
						sortAndGetGroupOrder(list));
				default:
					var v = result.a;
					var list = result.b;
					return A2(
						$elm$core$Tuple$mapFirst,
						$author$project$Data$Calc$Platform2$DatapointSegmentAudiences(v),
						sortAndGetGroupOrderWithAudiences(list));
			}
		};
		return A2(
			$elm$core$List$map,
			$elm$core$Tuple$first,
			A2(
				$elm$core$List$sortBy,
				$elm$core$Tuple$second,
				A2($elm$core$List$map, sortResultAndGetItsOrder, qResults)));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toNonEmpty = function (_v0) {
	var p = _v0.a;
	var f = _v0.b;
	var n = _v0.c;
	var _v1 = $elm$core$List$reverse(p);
	if (!_v1.b) {
		return _Utils_Tuple2(f, n);
	} else {
		var h = _v1.a;
		var t = _v1.b;
		return _Utils_Tuple2(
			h,
			_Utils_ap(
				t,
				A2($elm$core$List$cons, f, n)));
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toList = A2($elm$core$Basics$composeL, $turboMaCk$non_empty_list_alias$List$NonEmpty$toList, $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toNonEmpty);
var $author$project$D3Charts$Dashboards$ChartType$HorizontalBarChart = 3;
var $author$project$D3Charts$Dashboards$ChartType$VerticalBarChart = 11;
var $author$project$Dashboards2$Chart$initChartModelIfNeeded = F2(
	function (chartType, currentChartModel) {
		switch (currentChartModel.$) {
			case 0:
				return $author$project$Dashboards2$Chart$initChartModel(chartType);
			case 1:
				return (chartType === 3) ? currentChartModel : $author$project$Dashboards2$Chart$initChartModel(chartType);
			default:
				return (chartType === 11) ? currentChartModel : $author$project$Dashboards2$Chart$initChartModel(chartType);
		}
	});
var $author$project$Dashboards2$Chart$toPaginated = F3(
	function (widget, chartWidget, chart) {
		var fromNonpaginatedData = function (data) {
			return $author$project$Dashboards2$Chart$Paginated(
				{
					ad: $author$project$Dashboards2$Chart$initChartModel(chartWidget.aI),
					cl: A2(
						$author$project$RemoteData$Loaded$map,
						$elm$core$Tuple$mapSecond(
							$elm$core$Basics$always($elm$core$Maybe$Nothing)),
						data.cl),
					t: data.t
				});
		};
		switch (chart.$) {
			case 1:
				var data = chart.a;
				return fromNonpaginatedData(data);
			case 3:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
			case 0:
				var data = chart.a;
				return $author$project$Dashboards2$Chart$Paginated(
					_Utils_update(
						data,
						{
							ad: A2($author$project$Dashboards2$Chart$initChartModelIfNeeded, chartWidget.aI, data.ad)
						}));
			default:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
		}
	});
var $author$project$Gwi$Http$DBEmptyResultData = {$: 5};
var $author$project$Dashboards2$StatCard$setColored = F2(
	function (isColored, model) {
		return _Utils_update(
			model,
			{du: isColored});
	});
var $author$project$Dashboards2$StatCard$setData = F4(
	function (audiences, metric, datapointName, model) {
		return _Utils_update(
			model,
			{
				d9: audiences,
				ai: 0,
				ax: A2($author$project$Dashboards2$StatCard$calculateAudiencesPerPage, model.sm, audiences),
				fA: datapointName,
				dB: metric
			});
	});
var $author$project$Dashboards2$Chart$toStatCardData = F4(
	function (userFilters, store, metric, qresult) {
		var toAudience = function (_v2) {
			var audienceName = _v2.jp;
			var audienceColor = _v2.bS;
			var value = _v2.c5;
			return {jL: audienceColor, ld: audienceName, c5: value};
		};
		var getDatapointName = F2(
			function (questionCode, list) {
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (datapoints, item) {
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									function ($) {
										return $.ld;
									},
									A2($author$project$Dashboards2$Chart$getDatapoint, item.eq, datapoints));
							}),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.er;
							},
							A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store)),
						$elm$core$List$head(list)));
			});
		switch (qresult.$) {
			case 0:
				var questionCode = qresult.a.at;
				var list = qresult.b;
				return function (audience) {
					return _Utils_Tuple2(
						A2(getDatapointName, questionCode, list),
						audience);
				}(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							function (_v1) {
								var item = _v1.kS;
								return _List_fromArray(
									[
										toAudience(
										{
											bS: $author$project$Dashboards2$UserFilters$baseColor(userFilters),
											jp: $author$project$Data$Platform2$defaultAudienceName,
											c5: A2($author$project$Data$Metrics$getMetricValue, metric, item.dC)
										})
									]);
							},
							$elm_community$maybe_extra$Maybe$Extra$join(
								A3(
									$elm$core$Maybe$map2,
									F2(
										function (datapoints, item) {
											return A2(
												$elm$core$Maybe$map,
												function (datapoint) {
													return {hv: datapoint, kS: item};
												},
												A2($author$project$Dashboards2$Chart$getDatapoint, item.eq, datapoints));
										}),
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.er;
										},
										A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store)),
									$elm$core$List$head(list))))));
			case 1:
				var questionCode = qresult.a.at;
				var list = qresult.b;
				return function (audience) {
					return _Utils_Tuple2(
						A2(getDatapointName, questionCode, list),
						audience);
				}(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$andThen,
							function (question) {
								return A2(
									$elm$core$Maybe$map,
									$elm$core$List$map(toAudience),
									A5($author$project$Dashboards2$Chart$getAudiencesNamesAndValues, userFilters, list, metric, question.er, question.rI));
							},
							A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store))));
			default:
				return _Utils_Tuple2('', _List_Nil);
		}
	});
var $author$project$Dashboards2$Chart$buildStatCardData = F6(
	function (userFilters, store, metric, chartWidget, qResultWebData, statCardModelWebData) {
		return A3(
			$author$project$RemoteData$Loaded$map2,
			F2(
				function (qresult, statCardModel) {
					var _v0 = A4($author$project$Dashboards2$Chart$toStatCardData, userFilters, store, metric, qresult);
					var datapointName = _v0.a;
					var statCardAudiences = _v0.b;
					return A2(
						$author$project$Dashboards2$StatCard$setColored,
						chartWidget.aI === 10,
						A4($author$project$Dashboards2$StatCard$setData, statCardAudiences, metric, datapointName, statCardModel));
				}),
			qResultWebData,
			statCardModelWebData);
	});
var $author$project$Palette$ShadeIndex = function (a) {
	return {$: 1, a: a};
};
var $author$project$Palette$ShadedColor = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Palette$p2Shade = F2(
	function (filtersColor, shadeLevel) {
		if (!filtersColor.$) {
			var color = filtersColor.a;
			return A2($author$project$Palette$ShadedColor, shadeLevel, color);
		} else {
			var color = filtersColor.b;
			return A2($author$project$Palette$ShadedColor, shadeLevel, color);
		}
	});
var $author$project$Dashboards2$Chart$colorizeD3Data = F3(
	function (userFilters, chartWidget, d3Data) {
		var useMainColorForAllDatapoints = function () {
			var _v0 = chartWidget.aI;
			if (_v0 === 7) {
				return true;
			} else {
				return false;
			}
		}();
		var color = $author$project$Dashboards2$UserFilters$baseColor(userFilters);
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (index, group) {
					var groupColor = A2($elm$core$Maybe$withDefault, color, group.jL);
					var newGroupColor = _Utils_eq(groupColor, color) ? $elm$core$Maybe$Just(
						A2(
							$author$project$Palette$p2Shade,
							color,
							$author$project$Palette$ShadeIndex(
								{
									pi: index,
									f2: $elm$core$List$length(d3Data)
								}))) : $elm$core$Maybe$Just(groupColor);
					return _Utils_update(
						group,
						{
							jL: newGroupColor,
							cl: A2(
								$elm$core$List$indexedMap,
								F2(
									function (subIndex, subGroup) {
										var shadeColor = A2(
											$author$project$Palette$p2Shade,
											groupColor,
											$author$project$Palette$ShadeIndex(
												{
													pi: subIndex,
													f2: $elm$core$List$length(group.cl)
												}));
										return _Utils_update(
											subGroup,
											{
												jL: useMainColorForAllDatapoints ? A2($elm$core$Maybe$withDefault, shadeColor, newGroupColor) : shadeColor
											});
									}),
								group.cl)
						});
				}),
			d3Data);
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromNonEmpty = function (_v0) {
	var h = _v0.a;
	var t = _v0.b;
	return A3($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper, _List_Nil, h, t);
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromList = A2(
	$elm$core$Basics$composeL,
	$elm$core$Maybe$map($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromNonEmpty),
	$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList);
var $author$project$Dashboards2$Chart$itemsPerPageForLegend = F2(
	function (_v0, chartType) {
		var width = _v0.da;
		var height = _v0.cv;
		switch (chartType) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 9:
				return $elm$core$Maybe$Nothing;
			case 10:
				return $elm$core$Maybe$Nothing;
			case 5:
				return (width > 1) ? $elm$core$Maybe$Just(5 * height) : $elm$core$Maybe$Nothing;
			case 2:
				return $elm$core$Maybe$Nothing;
			case 8:
				return $elm$core$Maybe$Nothing;
			case 4:
				return $elm$core$Maybe$Nothing;
			case 7:
				return $elm$core$Maybe$Nothing;
			case 3:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Nothing;
			case 6:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $elm_community$list_extra$List$Extra$splitAt = F2(
	function (n, xs) {
		return _Utils_Tuple2(
			A2($elm$core$List$take, n, xs),
			A2($elm$core$List$drop, n, xs));
	});
var $author$project$Dashboards2$Chart$createLegendForChart = F3(
	function (widget, chartWidget, widgetData) {
		return A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var perPage = _v0.a;
				var data = _v0.b;
				var paginateData = F2(
					function (data_, pagesSoFar) {
						paginateData:
						while (true) {
							var _v1 = A3(
								$elm$core$List$foldr,
								F2(
									function (singleAudienceData, _v2) {
										var restOfData = _v2.a;
										var acc = _v2.b;
										var _v3 = A2($elm_community$list_extra$List$Extra$splitAt, perPage, singleAudienceData.cl);
										var dataPerPage = _v3.a;
										var dataForNextPage = _v3.b;
										return _Utils_Tuple2(
											$elm$core$List$isEmpty(dataForNextPage) ? restOfData : A2(
												$elm$core$List$cons,
												_Utils_update(
													singleAudienceData,
													{cl: dataForNextPage}),
												restOfData),
											A2(
												$elm$core$List$cons,
												_Utils_update(
													singleAudienceData,
													{cl: dataPerPage}),
												acc));
									}),
								_Utils_Tuple2(_List_Nil, _List_Nil),
								data_);
							var restData = _v1.a;
							var page = _v1.b;
							var pages = _Utils_ap(
								pagesSoFar,
								_List_fromArray(
									[page]));
							if ($elm$core$List$isEmpty(restData)) {
								return pages;
							} else {
								var $temp$data_ = restData,
									$temp$pagesSoFar = pages;
								data_ = $temp$data_;
								pagesSoFar = $temp$pagesSoFar;
								continue paginateData;
							}
						}
					});
				var paginatedData = A2(paginateData, data, _List_Nil);
				return $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromList(paginatedData);
			},
			A3(
				$elm$core$Maybe$map2,
				$elm$core$Tuple$pair,
				A2($author$project$Dashboards2$Chart$itemsPerPageForLegend, widget, chartWidget.aI),
				A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$second,
					$author$project$RemoteData$Loaded$toMaybe(widgetData))));
	});
var $author$project$Dashboards2$Chart$groupNonpaginatedDataByAudience = function (data) {
	return A2(
		$elm$core$List$map,
		function (_v0) {
			var first = _v0.a;
			var rest = _v0.b;
			return _Utils_update(
				first,
				{
					cl: _Utils_ap(
						first.cl,
						A2(
							$author$project$Gwi$List$fastConcatMap,
							function ($) {
								return $.cl;
							},
							rest))
				});
		},
		A2(
			$elm_community$list_extra$List$Extra$gatherEqualsBy,
			function ($) {
				return $.ld;
			},
			data));
};
var $author$project$RemoteData$Loaded$isLoading = function (data) {
	if (data.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Gwi$Http$DBPaginationWithNoItemsPerPage = {$: 6};
var $elm_community$list_extra$List$Extra$greedyGroupsOfWithStep = F3(
	function (size, step, list) {
		if ((size <= 0) || (step <= 0)) {
			return _List_Nil;
		} else {
			var go = F2(
				function (xs, acc) {
					go:
					while (true) {
						if ($elm$core$List$isEmpty(xs)) {
							return $elm$core$List$reverse(acc);
						} else {
							var $temp$xs = A2($elm$core$List$drop, step, xs),
								$temp$acc = A2(
								$elm$core$List$cons,
								A2($elm$core$List$take, size, xs),
								acc);
							xs = $temp$xs;
							acc = $temp$acc;
							continue go;
						}
					}
				});
			return A2(go, list, _List_Nil);
		}
	});
var $elm_community$list_extra$List$Extra$greedyGroupsOf = F2(
	function (size, xs) {
		return A3($elm_community$list_extra$List$Extra$greedyGroupsOfWithStep, size, size, xs);
	});
var $author$project$Dashboards2$Chart$paginate = F4(
	function (widget, chartType, dimensions, d3Data) {
		return A2(
			$author$project$RemoteData$Loaded$fromMaybe,
			$author$project$Gwi$Http$OtherError($author$project$Gwi$Http$DBPaginationWithNoItemsPerPage),
			A2(
				$elm$core$Maybe$map,
				function (perPage) {
					return A2($elm_community$list_extra$List$Extra$greedyGroupsOf, perPage, d3Data);
				},
				A4($author$project$Dashboards2$Chart$itemsPerPage_, widget, dimensions, chartType, d3Data)));
	});
var $author$project$Dashboards2$Chart$updateChartDataPure = F6(
	function (userFilters, store, widget, chartWidget, currentMetric, chartData) {
		var prepareNonpaginatedData = function (nonpaginated) {
			var newData = A2(
				$author$project$RemoteData$Loaded$andThen,
				function (_v5) {
					var qResultsDict = _v5.a;
					var needGroupingAndColorizing = function () {
						var _v6 = $author$project$D3Charts$Dashboards$ChartType$datapointCountRequirement(chartWidget.aI);
						switch (_v6) {
							case 0:
								return false;
							case 1:
								return true;
							default:
								return true;
						}
					}();
					var groupAndColorize = needGroupingAndColorizing ? $author$project$RemoteData$Loaded$map(
						A2(
							$elm$core$Basics$composeR,
							$author$project$Dashboards2$Chart$groupNonpaginatedDataByAudience,
							A2($author$project$Dashboards2$Chart$colorizeD3Data, userFilters, chartWidget))) : $elm$core$Basics$identity;
					return A2(
						$author$project$RemoteData$Loaded$map,
						$elm$core$Tuple$pair(qResultsDict),
						A2(
							$author$project$Dashboards2$Chart$sortNonpaginatedData,
							chartWidget,
							groupAndColorize(
								A6(
									$author$project$Dashboards2$Chart$buildNonpaginatedData,
									userFilters,
									store,
									currentMetric,
									widget,
									chartWidget,
									A3(
										$author$project$Dashboards2$Chart$sortResultsByDefaultDatapointOrder,
										store.bt,
										chartWidget,
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											_List_Nil,
											$turboMaCk$any_set$Set$Any$toList,
											A2($turboMaCk$any_dict$Dict$Any$get, userFilters, qResultsDict)))))));
				},
				nonpaginated.cl);
			var newLegend = A3($author$project$Dashboards2$Chart$createLegendForChart, widget, chartWidget, newData);
			return _Utils_update(
				nonpaginated,
				{cl: newData, a1: newLegend});
		};
		switch (chartData.$) {
			case 0:
				var paginated = chartData.a;
				return $author$project$Dashboards2$Chart$Paginated(
					_Utils_update(
						paginated,
						{
							cl: A2(
								$author$project$RemoteData$Loaded$andThen,
								function (_v1) {
									var qResultsDict = _v1.a;
									var _v2 = A2($turboMaCk$any_dict$Dict$Any$get, userFilters, qResultsDict);
									if (_v2.$ === 1) {
										return $author$project$RemoteData$Loaded$isLoading(paginated.cl) ? paginated.cl : $author$project$RemoteData$Loaded$FailureL(
											$author$project$Gwi$Http$OtherError($author$project$Gwi$Http$DBEmptyResultData));
									} else {
										var qResults = _v2.a;
										return $author$project$RemoteData$Loaded$SuccessL(
											_Utils_Tuple2(
												qResultsDict,
												A2(
													$elm$core$Maybe$andThen,
													$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$fromList,
													$author$project$RemoteData$Loaded$toMaybe(
														A2(
															$author$project$RemoteData$Loaded$andThen,
															A3($author$project$Dashboards2$Chart$paginate, widget, chartWidget.aI, paginated.t),
															A2(
																$author$project$Dashboards2$Chart$sortNonpaginatedData,
																chartWidget,
																A6(
																	$author$project$Dashboards2$Chart$buildNonpaginatedData,
																	userFilters,
																	store,
																	currentMetric,
																	widget,
																	chartWidget,
																	A3(
																		$author$project$Dashboards2$Chart$sortResultsByDefaultDatapointOrder,
																		store.bt,
																		chartWidget,
																		$turboMaCk$any_set$Set$Any$toList(qResults)))))))));
									}
								},
								paginated.cl)
						}));
			case 1:
				var nonpaginated = chartData.a;
				return $author$project$Dashboards2$Chart$Nonpaginated(
					prepareNonpaginatedData(nonpaginated));
			case 2:
				var webData = chartData.a;
				return $author$project$Dashboards2$Chart$StatCardModel(
					A2(
						$author$project$RemoteData$Loaded$andThen,
						function (_v3) {
							var qResultsDict = _v3.a;
							var oldStatCardModel = _v3.b;
							var maybeUserFilters = A2($turboMaCk$any_dict$Dict$Any$get, userFilters, qResultsDict);
							var qresult = function () {
								if (maybeUserFilters.$ === 1) {
									return $author$project$RemoteData$Loaded$isLoading(webData) ? $author$project$RemoteData$Loaded$LoadingL(maybeUserFilters) : $author$project$RemoteData$Loaded$FailureL(
										$author$project$Gwi$Http$OtherError($author$project$Gwi$Http$DBEmptyResultData));
								} else {
									var userFilters_ = maybeUserFilters.a;
									return $author$project$RemoteData$Loaded$SuccessL(userFilters_);
								}
							}();
							return A2(
								$author$project$RemoteData$Loaded$map,
								$elm$core$Tuple$pair(qResultsDict),
								A6(
									$author$project$Dashboards2$Chart$buildStatCardData,
									userFilters,
									store,
									currentMetric,
									chartWidget,
									qresult,
									$author$project$RemoteData$Loaded$SuccessL(oldStatCardModel)));
						},
						webData));
			default:
				var lcModel = chartData.a;
				var nonpaginated = chartData.b;
				return A2(
					$author$project$Dashboards2$Chart$LineChartModel,
					lcModel,
					prepareNonpaginatedData(nonpaginated));
		}
	});
var $author$project$Dashboards2$Widget$DataTable$moduleClass = A2(
	$GlobalWebIndex$class_namespaces$WeakCss$add,
	'data-table',
	$GlobalWebIndex$class_namespaces$WeakCss$namespace('dashboard-widget-2'));
var $GlobalWebIndex$class_namespaces$WeakCss$addMany = F2(
	function (listToAdd, className) {
		return A3(
			$elm$core$List$foldl,
			$GlobalWebIndex$class_namespaces$WeakCss$add,
			className,
			A2($elm$core$List$map, $GlobalWebIndex$class_namespaces$Escape$sanitize, listToAdd));
	});
var $GlobalWebIndex$class_namespaces$WeakCss$nestMany = function (listToAdd) {
	return A2(
		$elm$core$Basics$composeL,
		$GlobalWebIndex$class_namespaces$WeakCss$toClass,
		$GlobalWebIndex$class_namespaces$WeakCss$addMany(listToAdd));
};
var $elm$html$Html$Attributes$colspan = function (n) {
	return A2(
		_VirtualDom_attribute,
		'colspan',
		$elm$core$String$fromInt(n));
};
var $elm$virtual_dom$VirtualDom$attribute = F2(
	function (key, value) {
		return A2(
			_VirtualDom_attribute,
			_VirtualDom_noOnOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $elm$html$Html$Attributes$attribute = $elm$virtual_dom$VirtualDom$attribute;
var $author$project$Gwi$Html$Attributes$cssVars = function (vars) {
	return A2(
		$elm$html$Html$Attributes$attribute,
		'style',
		A2(
			$elm$core$String$join,
			';',
			A2(
				$elm$core$List$map,
				function (_v0) {
					var _var = _v0.a;
					var value = _v0.b;
					return _var + (': ' + value);
				},
				vars)));
};
var $author$project$Palette$colorToHex = function (color) {
	switch (color) {
		case 0:
			return '#526482';
		case 1:
			return '#7989a6';
		case 2:
			return '#5461c8';
		case 3:
			return '#008291';
		case 4:
			return '#de1b76';
		case 5:
			return '#007cb6';
		case 6:
			return '#963cbd';
		case 7:
			return '#da3441';
		default:
			return '#008851';
	}
};
var $elm$core$Array$isEmpty = function (_v0) {
	var len = _v0.a;
	return !len;
};
var $elm$core$Array$length = function (_v0) {
	var len = _v0.a;
	return len;
};
var $author$project$Palette$cycledColor = F2(
	function (palette, index) {
		if ($elm$core$Array$isEmpty(palette)) {
			return $elm$core$Result$Err('Palette is empty');
		} else {
			var index_ = A2(
				$elm$core$Basics$modBy,
				$elm$core$Array$length(palette),
				index);
			var _v0 = A2($elm$core$Array$get, index_, palette);
			if (!_v0.$) {
				var color_ = _v0.a;
				return $elm$core$Result$Ok(color_);
			} else {
				return $elm$core$Result$Err('Supposedly untriggerable error in Palette.color');
			}
		}
	});
var $author$project$Palette$getShadesPaletteFromColor = function (color) {
	switch (color) {
		case 0:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#191530', '#CED9EB', '#7989A6', '#ABB8CF', '#526482']));
		case 1:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#191530', '#CED9EB', '#7989A6', '#ABB8CF', '#526482']));
		case 2:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#5461C8', '#BFBFEF', '#222168', '#9BA0E2', '#434CA8']));
		case 3:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#008291', '#B9E9ED', '#3CCBDA', '#8FDFE7', '#154B5B']));
		case 4:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#DE1B76', '#FFCAEA', '#840947', '#F690C4', '#C31668']));
		case 5:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#007CB6', '#B9E1F9', '#00A3E0', '#7BCCF1', '#003C71']));
		case 6:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#963CBD', '#DEBEEB', '#3B1459', '#C693DC', '#782F9C']));
		case 7:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#DA3441', '#F9D2C4', '#FF585D', '#F99C90', '#892937']));
		default:
			return $elm$core$Array$fromList(
				_List_fromArray(
					['#008851', '#D3EFD4', '#48D597', '#A5E6C0', '#1B4F3C']));
	}
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $author$project$Palette$p2ShadesColorFromIndex = F3(
	function (segmentsCount, index, defaultColor) {
		var palette = $author$project$Palette$getShadesPaletteFromColor(defaultColor);
		var safeIndex = (_Utils_eq(index, segmentsCount - 1) && ((A2(
			$elm$core$Basics$modBy,
			$elm$core$Array$length(palette),
			segmentsCount) === 1) && (segmentsCount > 1))) ? (index + 1) : index;
		return A2(
			$elm$core$Result$withDefault,
			$author$project$Palette$colorToHex(defaultColor),
			A2($author$project$Palette$cycledColor, palette, safeIndex));
	});
var $author$project$Palette$filtersColorToHex = function (filtersColor) {
	if (!filtersColor.$) {
		var color = filtersColor.a;
		return $author$project$Palette$colorToHex(color);
	} else {
		if (!filtersColor.a.$) {
			var _v1 = filtersColor.a;
			var color = filtersColor.b;
			return A3($author$project$Palette$p2ShadesColorFromIndex, 3, 3, color);
		} else {
			var items = filtersColor.a.a.f2;
			var index = filtersColor.a.a.pi;
			var color = filtersColor.b;
			return A3($author$project$Palette$p2ShadesColorFromIndex, items, index, color);
		}
	}
};
var $elm$html$Html$i = _VirtualDom_node('i');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$core$String$fromFloat = _String_fromNumber;
var $elm$core$Basics$pow = _Basics_pow;
var $author$project$D3Charts$Dashboards2$scaleWithOneDecimalPlace = F2(
	function (places, n) {
		return $elm$core$Basics$round(
			n / A2($elm$core$Basics$pow, 10, places - 1)) / 10;
	});
var $author$project$D3Charts$Dashboards2$formatDatapoint = F2(
	function (metric, value) {
		var valueString = $elm$core$String$fromFloat(value);
		switch (metric) {
			case 0:
				return valueString + '%';
			case 1:
				return valueString + '%';
			case 2:
				return (value < 10000) ? ($elm$core$String$fromFloat(
					A2($author$project$D3Charts$Dashboards2$scaleWithOneDecimalPlace, 3, value)) + 'k') : ((value < 1000000) ? ($elm$core$String$fromInt(
					$elm$core$Basics$round(value / 1000)) + 'k') : ((value < 1000000000) ? ($elm$core$String$fromFloat(
					A2($author$project$D3Charts$Dashboards2$scaleWithOneDecimalPlace, 6, value)) + 'M') : ($elm$core$String$fromFloat(
					A2($author$project$D3Charts$Dashboards2$scaleWithOneDecimalPlace, 9, value)) + 'B')));
			case 4:
				return (value < 1000) ? $elm$core$String$fromInt(
					$elm$core$Basics$round(value)) : ($elm$core$String$fromFloat(
					A2($author$project$D3Charts$Dashboards2$scaleWithOneDecimalPlace, 3, value)) + 'k');
			default:
				return $elm$core$String$fromFloat(value);
		}
	});
var $author$project$Dashboards2$Widget$DataTable$tdsFromMetrics = function (metrics) {
	return $elm$core$List$map(
		function (metric) {
			return A2(
				$elm$html$Html$td,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'metric-value', $author$project$Dashboards2$Widget$DataTable$moduleClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(
						A2(
							$author$project$D3Charts$Dashboards2$formatDatapoint,
							metric,
							A2($author$project$Data$Metrics$getMetricValue, metric, metrics)))
					]));
		});
};
var $elm$html$Html$th = _VirtualDom_node('th');
var $author$project$Dashboards2$Widget$DataTable$th = function (text) {
	return A2(
		$elm$html$Html$th,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $GlobalWebIndex$class_namespaces$WeakCss$toStringWithStates = F2(
	function (states, className) {
		return A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$cons,
				$GlobalWebIndex$class_namespaces$WeakCss$toString(className),
				A2($elm$core$List$map, $GlobalWebIndex$class_namespaces$Escape$sanitize, states)));
	});
var $GlobalWebIndex$class_namespaces$WeakCss$withStates = function (states) {
	var activeStates = A2(
		$elm$core$List$filterMap,
		function (_v0) {
			var string = _v0.a;
			var state = _v0.b;
			return state ? $elm$core$Maybe$Just(string) : $elm$core$Maybe$Nothing;
		},
		states);
	return A2(
		$elm$core$Basics$composeL,
		$elm$html$Html$Attributes$class,
		$GlobalWebIndex$class_namespaces$WeakCss$toStringWithStates(activeStates));
};
var $author$project$Dashboards2$Widget$DataTable$trByIndex = F4(
	function (index, maybeState, attrs, content) {
		var isOdd = A2($elm$core$Basics$modBy, 2, index) === 1;
		var _class = A2(
			$GlobalWebIndex$class_namespaces$WeakCss$withStates,
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						$elm$core$Maybe$Just(
						_Utils_Tuple2('odd', isOdd)),
						$elm$core$Maybe$Just(
						_Utils_Tuple2('even', !isOdd)),
						A2(
						$elm$core$Maybe$map,
						function (s) {
							return _Utils_Tuple2(s, true);
						},
						maybeState)
					])),
			A2(
				$GlobalWebIndex$class_namespaces$WeakCss$addMany,
				_List_fromArray(
					['table', 'tr']),
				$author$project$Dashboards2$Widget$DataTable$moduleClass));
		return A2(
			$elm$html$Html$tr,
			A2($elm$core$List$cons, _class, attrs),
			content);
	});
var $author$project$Dashboards2$Widget$DataTable$d3DataToHtml = F3(
	function (hasAudiences, metrics, data) {
		return $author$project$Gwi$List$fastConcat(
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index_, group) {
						var index = index_ + 1;
						var audienceRow = function (_v0) {
							return A4(
								$author$project$Dashboards2$Widget$DataTable$trByIndex,
								index,
								$elm$core$Maybe$Just('datapoint'),
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$elm$html$Html$th,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$colspan(
												$elm$core$List$length(metrics) + 1)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(group.ld)
											]))
									]));
						};
						return hasAudiences ? A2(
							$elm$core$List$cons,
							audienceRow(0),
							A2(
								$elm$core$List$map,
								function (point) {
									return A4(
										$author$project$Dashboards2$Widget$DataTable$trByIndex,
										index,
										$elm$core$Maybe$Just('audience'),
										_List_fromArray(
											[
												$author$project$Gwi$Html$Attributes$cssVars(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'--audience-color',
														$author$project$Palette$filtersColorToHex(point.jL))
													]))
											]),
										A2(
											$elm$core$List$cons,
											A2(
												$elm$html$Html$td,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['table', 'tr', 'audience-name']),
														$author$project$Dashboards2$Widget$DataTable$moduleClass)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$i,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['table', 'audience-circle']),
																$author$project$Dashboards2$Widget$DataTable$moduleClass),
																A2(
																$elm$html$Html$Attributes$style,
																'background-color',
																$author$project$Palette$filtersColorToHex(point.jL))
															]),
														_List_Nil),
														$elm$html$Html$text(point.eP)
													])),
											A2($author$project$Dashboards2$Widget$DataTable$tdsFromMetrics, point.dC, metrics)));
								},
								group.cl)) : A2(
							$elm$core$List$indexedMap,
							F2(
								function (dtpIndex, point) {
									return A4(
										$author$project$Dashboards2$Widget$DataTable$trByIndex,
										dtpIndex + index,
										$elm$core$Maybe$Nothing,
										_List_Nil,
										A2(
											$elm$core$List$cons,
											$author$project$Dashboards2$Widget$DataTable$th(point.ld),
											A2($author$project$Dashboards2$Widget$DataTable$tdsFromMetrics, point.dC, metrics)));
								}),
							group.cl);
					}),
				data));
	});
var $author$project$Dashboards2$Widget$DataTable$singleLine = function (text) {
	return A2(
		$elm$html$Html$div,
		_List_Nil,
		_List_fromArray(
			[
				$elm$html$Html$text(text)
			]));
};
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$d = _VirtualDom_attribute('d');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$path = $elm$svg$Svg$trustedNode('path');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $author$project$Platform2$Spinner$view = A2(
	$elm$svg$Svg$svg,
	_List_fromArray(
		[
			$elm$svg$Svg$Attributes$class('p2-spinner'),
			$elm$svg$Svg$Attributes$viewBox('0 0 56 56'),
			$elm$svg$Svg$Attributes$fill('none')
		]),
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M56 28C56 43.464 43.464 56 28 56C12.536 56 0 43.464 0 28C0 12.536 12.536 0 28 0C43.464 0 56 12.536 56 28ZM7.03526 28C7.03526 39.5785 16.4215 48.9647 28 48.9647C39.5785 48.9647 48.9647 39.5785 48.9647 28C48.9647 16.4215 39.5785 7.03526 28 7.03526C16.4215 7.03526 7.03526 16.4215 7.03526 28Z'),
					$elm$svg$Svg$Attributes$fill('#dfe7f5')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d('M28 52.4824C28 54.4251 29.5811 56.0228 31.5085 55.7794C37.6408 55.005 43.3818 52.2161 47.799 47.799C53.05 42.548 56 35.4261 56 28C56 20.5739 53.05 13.452 47.799 8.20101C43.3818 3.78386 37.6408 0.994954 31.5085 0.220579C29.5811 -0.0228125 28 1.5749 28 3.51763C28 5.46036 29.5859 7.00516 31.5013 7.32961C35.7625 8.0514 39.7278 10.0792 42.8243 13.1757C46.756 17.1073 48.9647 22.4398 48.9647 28C48.9647 33.5602 46.756 38.8927 42.8243 42.8243C39.7278 45.9208 35.7625 47.9486 31.5013 48.6704C29.5858 48.9948 28 50.5396 28 52.4824Z'),
					$elm$svg$Svg$Attributes$fill('#de1b76')
				]),
			_List_Nil)
		]));
var $author$project$Dashboards2$Widget$DataTable$tableDataView = F3(
	function (hasAudiences, metrics, data) {
		var tableView = function (content) {
			return A2(
				$elm$html$Html$table,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'table', $author$project$Dashboards2$Widget$DataTable$moduleClass)
					]),
				_List_fromArray(
					[
						A2($elm$html$Html$tbody, _List_Nil, content)
					]));
		};
		switch (data.$) {
			case 3:
				var d3data = data.a;
				return tableView(
					A3($author$project$Dashboards2$Widget$DataTable$d3DataToHtml, hasAudiences, metrics, d3data));
			case 1:
				return $author$project$Platform2$Spinner$view;
			case 0:
				return $author$project$Dashboards2$Widget$DataTable$singleLine('Data was not fetched, please refresh the page or report issue');
			default:
				var err = data.a;
				return $author$project$Dashboards2$Widget$DataTable$singleLine(
					A2($author$project$Gwi$Http$errorToString, $author$project$Data$Calc$Platform2$dashboardQueryErrorToString, err));
		}
	});
var $author$project$Dashboards2$Widget$DataTable$getMetricLabel = function (metric) {
	switch (metric) {
		case 0:
			return 'Audience %';
		case 1:
			return 'Data point %';
		case 2:
			return 'Universe size';
		case 3:
			return 'Index';
		default:
			return 'Responses';
	}
};
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $author$project$Dashboards2$Widget$DataTable$tableHeadView = function (metrics) {
	return A2(
		$elm$html$Html$table,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'table', $author$project$Dashboards2$Widget$DataTable$moduleClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$thead,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$tr,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header-row', $author$project$Dashboards2$Widget$DataTable$moduleClass)
							]),
						A2(
							$elm$core$List$cons,
							$author$project$Dashboards2$Widget$DataTable$th('Data Point'),
							A2(
								$elm$core$List$map,
								A2($elm$core$Basics$composeL, $author$project$Dashboards2$Widget$DataTable$th, $author$project$Dashboards2$Widget$DataTable$getMetricLabel),
								metrics)))
					]))
			]));
};
var $author$project$Dashboards2$Widget$DataTable$visibleMetrics = F4(
	function (minimalWidth, widgetWidth, availableMetrics, widget) {
		var maxVisibleMetrics = $elm$core$Basics$floor((widgetWidth - minimalWidth) / 100);
		var _v0 = widget.U;
		if (!_v0.$) {
			var chartWidget = _v0.a;
			return _Utils_ap(
				A2(
					$elm$core$List$take,
					maxVisibleMetrics,
					A2(
						$elm$core$List$filter,
						$elm$core$Basics$neq(chartWidget.dB),
						availableMetrics)),
				_List_fromArray(
					[chartWidget.dB]));
		} else {
			return _List_Nil;
		}
	});
var $author$project$Dashboards2$Widget$DataTable$widgetElementMinWidth = 250;
var $author$project$Dashboards2$Widget$DataTable$view = F3(
	function (_v0, widget, data) {
		var widgetElementWidth = _v0.si;
		var hasAudiences = _v0.hT;
		var availableMetrics = _v0.nE;
		var metrics = A4($author$project$Dashboards2$Widget$DataTable$visibleMetrics, $author$project$Dashboards2$Widget$DataTable$widgetElementMinWidth, widgetElementWidth, availableMetrics, widget);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass($author$project$Dashboards2$Widget$DataTable$moduleClass)
				]),
			_List_fromArray(
				[
					$author$project$Dashboards2$Widget$DataTable$tableHeadView(metrics),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'scroll-wrapper', $author$project$Dashboards2$Widget$DataTable$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['scroll-wrapper', 'content-scroll']),
									$author$project$Dashboards2$Widget$DataTable$moduleClass)
								]),
							_List_fromArray(
								[
									A3($author$project$Dashboards2$Widget$DataTable$tableDataView, hasAudiences, metrics, data)
								]))
						]))
				]));
	});
var $author$project$Dashboards2$Chart$StatCardMsg = function (a) {
	return {$: 2, a: a};
};
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$html$Html$map = $elm$virtual_dom$VirtualDom$map;
var $author$project$Dashboards2$StatCard$Move = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$StatCard$Next = 1;
var $author$project$Dashboards2$StatCard$Prev = 0;
var $elm$html$Html$Attributes$classList = function (classes) {
	return $elm$html$Html$Attributes$class(
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$first,
				A2($elm$core$List$filter, $elm$core$Tuple$second, classes))));
};
var $elm_community$html_extra$Html$Attributes$Extra$empty = $elm$html$Html$Attributes$classList(_List_Nil);
var $elm_community$html_extra$Html$Attributes$Extra$attributeIf = F2(
	function (condition, attr) {
		return condition ? attr : $elm_community$html_extra$Html$Attributes$Extra$empty;
	});
var $author$project$Gwi$FormatNumber$multiplierToLongString = function (m) {
	switch (m) {
		case 0:
			return 'Thousand';
		case 1:
			return 'Million';
		default:
			return 'Billion';
	}
};
var $author$project$Gwi$FormatNumber$Billions = 2;
var $author$project$Gwi$FormatNumber$Millions = 1;
var $author$project$Gwi$FormatNumber$Thousands = 0;
var $author$project$Gwi$FormatNumber$numberWithMultiplier = function (value) {
	var _v0 = (value < 1000) ? _Utils_Tuple2(value, $elm$core$Maybe$Nothing) : ((value < 10000) ? _Utils_Tuple2(
		$elm$core$Basics$round(value / 100) / 10,
		$elm$core$Maybe$Just(0)) : ((value < 1000000) ? _Utils_Tuple2(
		$elm$core$Basics$round(value / 1000),
		$elm$core$Maybe$Just(0)) : ((value < 1000000000) ? _Utils_Tuple2(
		$elm$core$Basics$round(value / 100000) / 10,
		$elm$core$Maybe$Just(1)) : _Utils_Tuple2(
		$elm$core$Basics$round(value / 100000000) / 10,
		$elm$core$Maybe$Just(2)))));
	var dividedValue = _v0.a;
	var multiplier = _v0.b;
	return _Utils_Tuple2(
		$elm$core$String$fromFloat(dividedValue),
		multiplier);
};
var $author$project$Gwi$FormatNumber$formatNumberWithMultiplier = function (value) {
	return A2(
		$elm$core$Tuple$mapSecond,
		$elm$core$Maybe$map($author$project$Gwi$FormatNumber$multiplierToLongString),
		$author$project$Gwi$FormatNumber$numberWithMultiplier(value));
};
var $author$project$Data$Metric$getLabel = function (metric) {
	switch (metric) {
		case 0:
			return 'Audience %';
		case 1:
			return 'Data point %';
		case 2:
			return 'Universe';
		case 3:
			return 'Index';
		default:
			return 'Responses';
	}
};
var $author$project$Dashboards2$StatCard$moduleClass = $GlobalWebIndex$class_namespaces$WeakCss$namespace('stat-card-2');
var $elm$html$Html$span = _VirtualDom_node('span');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $author$project$Dashboards2$StatCard$toPerc = function (num) {
	return $elm$core$String$fromFloat(num * 100) + '%';
};
var $elm_community$html_extra$Html$Extra$viewMaybe = F2(
	function (fn, maybeThing) {
		return A2(
			$elm$core$Maybe$withDefault,
			$elm_community$html_extra$Html$Extra$nothing,
			A2($elm$core$Maybe$map, fn, maybeThing));
	});
var $author$project$Dashboards2$StatCard$audienceView = F3(
	function (audienceCount, model, audience) {
		var styles = _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$author$project$Dashboards2$StatCard$toPerc(1 / audienceCount)),
				A2(
				$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
				model.du,
				A2(
					$elm$html$Html$Attributes$style,
					'background',
					$author$project$Palette$filtersColorToHex(audience.jL)))
			]);
		var _v0 = $author$project$Gwi$FormatNumber$formatNumberWithMultiplier(audience.c5);
		var formattedValue = _v0.a;
		var maybeMultiplier = _v0.b;
		return A2(
			$elm$html$Html$div,
			A2(
				$elm$core$List$cons,
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'audience', $author$project$Dashboards2$StatCard$moduleClass),
				styles),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['audience', 'value']),
							$author$project$Dashboards2$StatCard$moduleClass),
							A2(
							$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
							!model.du,
							A2(
								$elm$html$Html$Attributes$style,
								'color',
								$author$project$Palette$filtersColorToHex(audience.jL))),
							$elm$html$Html$Attributes$title(
							$elm$core$String$fromFloat(audience.c5))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(formattedValue)
						])),
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (multiplier) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['audience', 'multiplier']),
									$author$project$Dashboards2$StatCard$moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(multiplier)
								]));
					},
					maybeMultiplier),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['audience', 'metric']),
							$author$project$Dashboards2$StatCard$moduleClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							$author$project$Data$Metric$getLabel(model.dB))
						])),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['audience', 'title']),
							$author$project$Dashboards2$StatCard$moduleClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(audience.ld)
						]))
				]));
	});
var $elm$html$Html$button = _VirtualDom_node('button');
var $elm$svg$Svg$Attributes$fillRule = _VirtualDom_attribute('fill-rule');
var $elm$svg$Svg$Attributes$transform = _VirtualDom_attribute('transform');
var $author$project$Icons$Platform2$chevronLeft = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M0.257,10.536 C-0.085,10.87 -0.086,11.413 0.255,11.748 C0.597,12.083 1.151,12.084 1.493,11.75 L6.743,6.622 C7.085,6.288 7.086,5.745 6.745,5.41 L1.497,0.252 C1.156,-0.083 0.602,-0.084 0.26,0.25 C-0.083,0.584 -0.084,1.127 0.258,1.462 L4.888,6.013 L0.258,10.536 L0.257,10.536 Z'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(16.500000, 16.000000) scale(-1, 1) translate(-16.500000, -16.000000) translate(13.000000, 10.000000)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$path = function (d) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d(d)
			]),
		_List_Nil);
};
var $author$project$Icons$Platform2$chevronRight = {
	mr: $author$project$Icons$Platform2$path('M13.257 20.536c-.342.334-.343.877-.002 1.212.342.335.896.336 1.238.002l5.25-5.128c.342-.334.343-.877.002-1.212l-5.248-5.158c-.341-.335-.895-.336-1.237-.002-.343.334-.344.877-.002 1.212l4.63 4.551-4.63 4.523z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm_community$maybe_extra$Maybe$Extra$or = F2(
	function (ma, mb) {
		if (ma.$ === 1) {
			return mb;
		} else {
			return ma;
		}
	});
var $elm$svg$Svg$Attributes$version = _VirtualDom_attribute('version');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $author$project$Icons$icon = F2(
	function (attrs, data) {
		var proportionalWidth = function (h) {
			return $elm$core$Basics$round((data.e6 / data.e5) * h);
		};
		var proportionalHeight = function (w) {
			return $elm$core$Basics$round((data.e5 / data.e6) * w);
		};
		var foldedAttrs = A3(
			$elm$core$List$foldl,
			F2(
				function (attr, acc) {
					if (!attr.$) {
						var w = attr.a;
						return _Utils_update(
							acc,
							{
								da: $elm$core$Maybe$Just(w)
							});
					} else {
						var h = attr.a;
						return _Utils_update(
							acc,
							{
								cv: $elm$core$Maybe$Just(h)
							});
					}
				}),
			{cv: $elm$core$Maybe$Nothing, da: $elm$core$Maybe$Nothing},
			attrs);
		var iconHeight = A2(
			$elm$core$Maybe$withDefault,
			data.e5,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$or,
				foldedAttrs.cv,
				A2($elm$core$Maybe$map, proportionalHeight, foldedAttrs.da)));
		var iconWidth = A2(
			$elm$core$Maybe$withDefault,
			data.e6,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$or,
				foldedAttrs.da,
				A2($elm$core$Maybe$map, proportionalWidth, foldedAttrs.cv)));
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$version('1.1'),
						$elm$svg$Svg$Attributes$width(
						$elm$core$String$fromInt(iconWidth)),
						$elm$svg$Svg$Attributes$height(
						$elm$core$String$fromInt(iconHeight)),
						$elm$svg$Svg$Attributes$viewBox(
						A2(
							$elm$core$String$join,
							' ',
							A2(
								$elm$core$List$map,
								$elm$core$String$fromInt,
								_List_fromArray(
									[data.mT, data.mU, data.e6, data.e5])))),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$fill('currentColor')
					]),
				_List_fromArray(
					[data.mr])));
	});
var $elm$html$Html$Events$onClick = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Dashboards2$StatCard$pagesCss = function (model) {
	var left = model.ai / model.ax;
	var audienceCount = $elm$core$List$length(model.d9);
	var width = audienceCount / model.ax;
	return _List_fromArray(
		[
			A2(
			$elm$html$Html$Attributes$style,
			'width',
			$author$project$Dashboards2$StatCard$toPerc(width)),
			A2(
			$elm$html$Html$Attributes$style,
			'left',
			$author$project$Dashboards2$StatCard$toPerc(-left))
		]);
};
var $GlobalWebIndex$class_namespaces$WeakCss$withActiveStates = function (states) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$html$Html$Attributes$class,
		$GlobalWebIndex$class_namespaces$WeakCss$toStringWithStates(states));
};
var $author$project$Dashboards2$StatCard$view = function (model) {
	var audienceCount = $elm$core$List$length(model.d9);
	var showNav = _Utils_cmp(model.ax, audienceCount) < 0;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2(
				$GlobalWebIndex$class_namespaces$WeakCss$withStates,
				_List_fromArray(
					[
						_Utils_Tuple2('colored', model.du),
						_Utils_Tuple2('high', model.cv > 1)
					]),
				$author$project$Dashboards2$StatCard$moduleClass)
			]),
		showNav ? _List_fromArray(
			[
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['direct-nav', 'btn']),
						$author$project$Dashboards2$StatCard$moduleClass),
						$elm$html$Html$Events$onClick(
						$author$project$Dashboards2$StatCard$Move(0))
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$chevronLeft)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['content']),
						$author$project$Dashboards2$StatCard$moduleClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'pages', $author$project$Dashboards2$StatCard$moduleClass),
							$author$project$Dashboards2$StatCard$pagesCss(model)),
						A2(
							$elm$core$List$map,
							A2($author$project$Dashboards2$StatCard$audienceView, audienceCount, model),
							model.d9))
					])),
				A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['direct-nav', 'btn']),
						$author$project$Dashboards2$StatCard$moduleClass),
						$elm$html$Html$Events$onClick(
						$author$project$Dashboards2$StatCard$Move(1))
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$chevronRight)
					]))
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
						_List_fromArray(
							['without-nav']),
						A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'content', $author$project$Dashboards2$StatCard$moduleClass))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'pages', $author$project$Dashboards2$StatCard$moduleClass),
							$author$project$Dashboards2$StatCard$pagesCss(model)),
						A2(
							$elm$core$List$map,
							A2($author$project$Dashboards2$StatCard$audienceView, audienceCount, model),
							model.d9))
					]))
			]));
};
var $author$project$Dashboards2$Chart$viewError = function (error) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'error', $author$project$Dashboards2$Chart$moduleClass)
			]),
		_List_fromArray(
			[
				$elm$html$Html$text(error)
			]));
};
var $author$project$Dashboards2$Chart$WidgetDimensionsChanged = function (a) {
	return {$: 3, a: a};
};
var $elm$html$Html$Attributes$id = $elm$html$Html$Attributes$stringProperty('id');
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$node = $elm$virtual_dom$VirtualDom$node;
var $author$project$ResizeObserver$targetDimensionsDecoder = A2(
	$elm$json$Json$Decode$field,
	'detail',
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$ResizeObserver$Dimensions,
		A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$float),
		A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$float)));
var $author$project$ResizeObserver$view = F3(
	function (_v0, attrs, children) {
		var targetSelector = _v0.iW;
		var toMsg = _v0.iZ;
		return A3(
			$elm$html$Html$node,
			'x-resize-observer',
			A2(
				$elm$core$List$cons,
				A2($elm$html$Html$Attributes$attribute, 'target-selector', targetSelector),
				A2(
					$elm$core$List$cons,
					A2(
						$elm$html$Html$Events$on,
						'targetresize',
						A2($elm$json$Json$Decode$map, toMsg, $author$project$ResizeObserver$targetDimensionsDecoder)),
					attrs)),
			children);
	});
var $author$project$Dashboards2$Chart$withResizeHandlerView = F3(
	function (config, widgetId, content) {
		var elementId = 'widget-with-resize-observer-' + $author$project$Data$Id$unwrap(widgetId);
		return A3(
			$author$project$ResizeObserver$view,
			{
				iW: '#' + elementId,
				iZ: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$WidgetDimensionsChanged)
			},
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(elementId),
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'resize-observed-element', $author$project$Dashboards2$Chart$moduleClass)
						]),
					_List_fromArray(
						[content]))
				]));
	});
var $author$project$Dashboards2$Chart$viewStatCard = F3(
	function (config, widgetId, model) {
		var viewStatCardData = function (data) {
			return A3(
				$author$project$Dashboards2$Chart$withResizeHandlerView,
				config,
				widgetId,
				A2(
					$elm$html$Html$map,
					A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$StatCardMsg),
					$author$project$Dashboards2$StatCard$view(data)));
		};
		var _v0 = model.h;
		if (_v0.$ === 2) {
			var statCardModel = _v0.a;
			switch (statCardModel.$) {
				case 0:
					return $author$project$Platform2$Spinner$view;
				case 1:
					if (!statCardModel.a.$) {
						var _v2 = statCardModel.a.a;
						var statCardData = _v2.b;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'statcard-with-spinner', $author$project$Dashboards2$Chart$moduleClass)
								]),
							_List_fromArray(
								[
									viewStatCardData(statCardData),
									$author$project$Platform2$Spinner$view
								]));
					} else {
						var _v3 = statCardModel.a;
						return $author$project$Platform2$Spinner$view;
					}
				case 3:
					var _v4 = statCardModel.a;
					var statCardData = _v4.b;
					return viewStatCardData(statCardData);
				default:
					var err = statCardModel.a;
					return $author$project$Dashboards2$Chart$viewError(
						$author$project$Dashboards2$Chart$errorText(err));
			}
		} else {
			return $author$project$Platform2$Spinner$view;
		}
	});
var $author$project$Dashboards2$Chart$LineChartMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Data$Metric$getUnit = function (metric) {
	switch (metric) {
		case 0:
			return $elm$core$Maybe$Just('%');
		case 1:
			return $elm$core$Maybe$Just('%');
		case 2:
			return $elm$core$Maybe$Nothing;
		case 3:
			return $elm$core$Maybe$Nothing;
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Platform2$groupedWidgetDataToExplicitWidgetData = F2(
	function (question, _v0) {
		var datapoints = _v0.er;
		var questionCode = _v0.at;
		if (!datapoints.$) {
			var suffixes = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$turboMaCk$non_empty_list_alias$List$NonEmpty$map(
							function ($) {
								return $.bW;
							}),
						$turboMaCk$non_empty_list_alias$List$NonEmpty$toList),
					question.rI));
			return {
				er: A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
					function (_v2) {
						var code = _v2.bW;
						return _Utils_Tuple2(code, suffixes);
					},
					question.er),
				at: questionCode
			};
		} else {
			var xs = datapoints.a;
			return {er: xs, at: questionCode};
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$length = function (_v0) {
	var p = _v0.a;
	var n = _v0.c;
	return ($elm$core$List$length(p) + $elm$core$List$length(n)) + 1;
};
var $author$project$D3Charts$Dashboards2$maximum = function (data) {
	return $elm$core$List$maximum(
		A2(
			$elm$core$List$map,
			function ($) {
				return $.c5;
			},
			A2(
				$author$project$Gwi$List$fastConcatMap,
				function ($) {
					return $.cl;
				},
				data)));
};
var $author$project$Dashboards2$Chart$resizeObservedElementId = function (widget) {
	return 'widget-with-resize-observer-' + $author$project$Data$Id$unwrap(widget.b);
};
var $author$project$Dashboards2$Chart$LineChart$OnHover = $elm$core$Basics$identity;
var $zwilias$elm_html_string$Html$Types$Attribute = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $zwilias$elm_html_string$Html$String$Attributes$attribute = $zwilias$elm_html_string$Html$Types$Attribute;
var $terezka$elm_charts$Chart$Attributes$background = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{nF: v});
	});
var $terezka$elm_charts$Chart$Attributes$border = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{ap: v});
	});
var $terezka$elm_charts$Chart$Attributes$borderWidth = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{ay: v});
	});
var $terezka$elm_charts$Internal$Svg$Event = F2(
	function (name, handler) {
		return {kr: handler, ld: name};
	});
var $terezka$elm_charts$Internal$Helpers$apply = F2(
	function (funcs, _default) {
		var apply_ = F2(
			function (f, a) {
				return f(a);
			});
		return A3($elm$core$List$foldl, apply_, _default, funcs);
	});
var $elm$svg$Svg$clipPath = $elm$svg$Svg$trustedNode('clipPath');
var $elm$json$Json$Decode$map3 = _Json_map3;
var $debois$elm_dom$DOM$offsetHeight = A2($elm$json$Json$Decode$field, 'offsetHeight', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetWidth = A2($elm$json$Json$Decode$field, 'offsetWidth', $elm$json$Json$Decode$float);
var $elm$json$Json$Decode$map4 = _Json_map4;
var $debois$elm_dom$DOM$offsetLeft = A2($elm$json$Json$Decode$field, 'offsetLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$offsetParent = F2(
	function (x, decoder) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$json$Json$Decode$field,
					'offsetParent',
					$elm$json$Json$Decode$null(x)),
					A2($elm$json$Json$Decode$field, 'offsetParent', decoder)
				]));
	});
var $debois$elm_dom$DOM$offsetTop = A2($elm$json$Json$Decode$field, 'offsetTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$scrollLeft = A2($elm$json$Json$Decode$field, 'scrollLeft', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$scrollTop = A2($elm$json$Json$Decode$field, 'scrollTop', $elm$json$Json$Decode$float);
var $debois$elm_dom$DOM$position = F2(
	function (x, y) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (_v0) {
				var x_ = _v0.a;
				var y_ = _v0.b;
				return A2(
					$debois$elm_dom$DOM$offsetParent,
					_Utils_Tuple2(x_, y_),
					A2($debois$elm_dom$DOM$position, x_, y_));
			},
			A5(
				$elm$json$Json$Decode$map4,
				F4(
					function (scrollLeftP, scrollTopP, offsetLeftP, offsetTopP) {
						return _Utils_Tuple2((x + offsetLeftP) - scrollLeftP, (y + offsetTopP) - scrollTopP);
					}),
				$debois$elm_dom$DOM$scrollLeft,
				$debois$elm_dom$DOM$scrollTop,
				$debois$elm_dom$DOM$offsetLeft,
				$debois$elm_dom$DOM$offsetTop));
	});
var $debois$elm_dom$DOM$boundingClientRect = A4(
	$elm$json$Json$Decode$map3,
	F3(
		function (_v0, width, height) {
			var x = _v0.a;
			var y = _v0.b;
			return {cv: height, kY: x, mH: y, da: width};
		}),
	A2($debois$elm_dom$DOM$position, 0, 0),
	$debois$elm_dom$DOM$offsetWidth,
	$debois$elm_dom$DOM$offsetHeight);
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
var $debois$elm_dom$DOM$parentElement = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'parentElement', decoder);
};
function $terezka$elm_charts$Internal$Svg$cyclic$decodePosition() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$debois$elm_dom$DOM$boundingClientRect,
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return $debois$elm_dom$DOM$parentElement(
						$terezka$elm_charts$Internal$Svg$cyclic$decodePosition());
				})
			]));
}
var $terezka$elm_charts$Internal$Svg$decodePosition = $terezka$elm_charts$Internal$Svg$cyclic$decodePosition();
$terezka$elm_charts$Internal$Svg$cyclic$decodePosition = function () {
	return $terezka$elm_charts$Internal$Svg$decodePosition;
};
var $terezka$elm_charts$Internal$Coordinates$innerLength = function (axis) {
	return A2($elm$core$Basics$max, 1, (axis.kZ - axis.pN) - axis.pM);
};
var $terezka$elm_charts$Internal$Coordinates$innerWidth = function (plane) {
	return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.m3);
};
var $terezka$elm_charts$Internal$Coordinates$range = function (axis) {
	var diff = axis.gc - axis.gg;
	return (diff > 0) ? diff : 1;
};
var $terezka$elm_charts$Internal$Coordinates$scaleCartesianX = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.m3)) / $terezka$elm_charts$Internal$Coordinates$innerWidth(plane);
	});
var $terezka$elm_charts$Internal$Coordinates$toCartesianX = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, value - plane.m3.pN) + plane.m3.gg;
	});
var $terezka$elm_charts$Internal$Coordinates$innerHeight = function (plane) {
	return $terezka$elm_charts$Internal$Coordinates$innerLength(plane.m4);
};
var $terezka$elm_charts$Internal$Coordinates$scaleCartesianY = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$range(plane.m4)) / $terezka$elm_charts$Internal$Coordinates$innerHeight(plane);
	});
var $terezka$elm_charts$Internal$Coordinates$toCartesianY = F2(
	function (plane, value) {
		return ($terezka$elm_charts$Internal$Coordinates$range(plane.m4) - A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, value - plane.m4.pN)) + plane.m4.gg;
	});
var $terezka$elm_charts$Internal$Svg$fromSvg = F2(
	function (plane, point) {
		return {
			m3: A2($terezka$elm_charts$Internal$Coordinates$toCartesianX, plane, point.m3),
			m4: A2($terezka$elm_charts$Internal$Coordinates$toCartesianY, plane, point.m4)
		};
	});
var $debois$elm_dom$DOM$target = function (decoder) {
	return A2($elm$json$Json$Decode$field, 'target', decoder);
};
var $terezka$elm_charts$Internal$Svg$decoder = F2(
	function (plane, toMsg) {
		var handle = F3(
			function (mouseX, mouseY, box) {
				var yPrev = plane.m4;
				var xPrev = plane.m3;
				var widthPercent = box.da / plane.m3.kZ;
				var heightPercent = box.cv / plane.m4.kZ;
				var newPlane = _Utils_update(
					plane,
					{
						m3: _Utils_update(
							xPrev,
							{kZ: box.da, pM: plane.m3.pM * widthPercent, pN: plane.m3.pN * widthPercent}),
						m4: _Utils_update(
							yPrev,
							{kZ: box.cv, pM: plane.m4.pM * heightPercent, pN: plane.m4.pN * heightPercent})
					});
				var searched = A2(
					$terezka$elm_charts$Internal$Svg$fromSvg,
					newPlane,
					{m3: mouseX - box.kY, m4: mouseY - box.mH});
				return A2(toMsg, newPlane, searched);
			});
		return A4(
			$elm$json$Json$Decode$map3,
			handle,
			A2($elm$json$Json$Decode$field, 'pageX', $elm$json$Json$Decode$float),
			A2($elm$json$Json$Decode$field, 'pageY', $elm$json$Json$Decode$float),
			$debois$elm_dom$DOM$target($terezka$elm_charts$Internal$Svg$decodePosition));
	});
var $elm$svg$Svg$defs = $elm$svg$Svg$trustedNode('defs');
var $elm$svg$Svg$Attributes$id = _VirtualDom_attribute('id');
var $elm$svg$Svg$Events$on = $elm$html$Html$Events$on;
var $elm$svg$Svg$rect = $elm$svg$Svg$trustedNode('rect');
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $terezka$elm_charts$Internal$Coordinates$toId = function (plane) {
	var numToStr = A2(
		$elm$core$Basics$composeR,
		$elm$core$String$fromFloat,
		A2($elm$core$String$replace, '.', '-'));
	return A2(
		$elm$core$String$join,
		'_',
		_List_fromArray(
			[
				'elm-charts__id',
				numToStr(plane.m3.kZ),
				numToStr(plane.m3.gg),
				numToStr(plane.m3.gc),
				numToStr(plane.m3.pN),
				numToStr(plane.m3.pM),
				numToStr(plane.m4.kZ),
				numToStr(plane.m4.gg),
				numToStr(plane.m4.gc),
				numToStr(plane.m4.pN),
				numToStr(plane.m4.pM)
			]));
};
var $elm$svg$Svg$Attributes$x = _VirtualDom_attribute('x');
var $elm$svg$Svg$Attributes$y = _VirtualDom_attribute('y');
var $terezka$elm_charts$Internal$Svg$container = F5(
	function (plane, config, below, chartEls, above) {
		var toEvent = function (event) {
			return A2(
				$elm$svg$Svg$Events$on,
				event.ld,
				A2($terezka$elm_charts$Internal$Svg$decoder, plane, event.kr));
		};
		var svgAttrsSize = config.gI ? _List_fromArray(
			[
				$elm$svg$Svg$Attributes$viewBox(
				'0 0 ' + ($elm$core$String$fromFloat(plane.m3.kZ) + (' ' + $elm$core$String$fromFloat(plane.m4.kZ)))),
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]) : _List_fromArray(
			[
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(plane.m3.kZ)),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(plane.m4.kZ)),
				A2($elm$html$Html$Attributes$style, 'display', 'block')
			]);
		var htmlAttrsSize = config.gI ? _List_fromArray(
			[
				A2($elm$html$Html$Attributes$style, 'width', '100%'),
				A2($elm$html$Html$Attributes$style, 'height', '100%')
			]) : _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'width',
				$elm$core$String$fromFloat(plane.m3.kZ) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'height',
				$elm$core$String$fromFloat(plane.m4.kZ) + 'px')
			]);
		var htmlAttrsDef = _List_fromArray(
			[
				$elm$html$Html$Attributes$class('elm-charts__container-inner')
			]);
		var htmlAttrs = _Utils_ap(
			config.fW,
			_Utils_ap(htmlAttrsDef, htmlAttrsSize));
		var chartPosition = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$x(
				$elm$core$String$fromFloat(plane.m3.pN)),
				$elm$svg$Svg$Attributes$y(
				$elm$core$String$fromFloat(plane.m4.pN)),
				$elm$svg$Svg$Attributes$width(
				$elm$core$String$fromFloat(
					$terezka$elm_charts$Internal$Coordinates$innerWidth(plane))),
				$elm$svg$Svg$Attributes$height(
				$elm$core$String$fromFloat(
					$terezka$elm_charts$Internal$Coordinates$innerHeight(plane))),
				$elm$svg$Svg$Attributes$fill('transparent')
			]);
		var clipPathDefs = A2(
			$elm$svg$Svg$defs,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$svg$Svg$clipPath,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$id(
							$terezka$elm_charts$Internal$Coordinates$toId(plane))
						]),
					_List_fromArray(
						[
							A2($elm$svg$Svg$rect, chartPosition, _List_Nil)
						]))
				]));
		var catcher = A2(
			$elm$svg$Svg$rect,
			_Utils_ap(
				chartPosition,
				A2($elm$core$List$map, toEvent, config.oA)),
			_List_Nil);
		var chart = A2(
			$elm$svg$Svg$svg,
			_Utils_ap(svgAttrsSize, config.A),
			_Utils_ap(
				_List_fromArray(
					[clipPathDefs]),
				_Utils_ap(
					chartEls,
					_List_fromArray(
						[catcher]))));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class('elm-charts__container'),
					A2($elm$html$Html$Attributes$style, 'position', 'relative')
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					htmlAttrs,
					_Utils_ap(
						below,
						_Utils_ap(
							_List_fromArray(
								[chart]),
							above)))
				]));
	});
var $terezka$elm_charts$Internal$Coordinates$Position = F4(
	function (x1, x2, y1, y2) {
		return {d_: x1, e8: x2, sp: y1, i6: y2};
	});
var $terezka$elm_charts$Internal$Coordinates$foldPosition = F2(
	function (func, data) {
		var fold = F2(
			function (datum, posM) {
				if (!posM.$) {
					var pos = posM.a;
					return $elm$core$Maybe$Just(
						{
							d_: A2(
								$elm$core$Basics$min,
								func(datum).d_,
								pos.d_),
							e8: A2(
								$elm$core$Basics$max,
								func(datum).e8,
								pos.e8),
							sp: A2(
								$elm$core$Basics$min,
								func(datum).sp,
								pos.sp),
							i6: A2(
								$elm$core$Basics$max,
								func(datum).i6,
								pos.i6)
						});
				} else {
					return $elm$core$Maybe$Just(
						func(datum));
				}
			});
		return A2(
			$elm$core$Maybe$withDefault,
			A4($terezka$elm_charts$Internal$Coordinates$Position, 0, 0, 0, 0),
			A3($elm$core$List$foldl, fold, $elm$core$Maybe$Nothing, data));
	});
var $terezka$elm_charts$Chart$Attributes$lowest = F3(
	function (v, edit, b) {
		return _Utils_update(
			b,
			{
				gg: A3(edit, v, b.gg, b.od)
			});
	});
var $terezka$elm_charts$Chart$Attributes$orLower = F3(
	function (least, real, _v0) {
		return (_Utils_cmp(real, least) > 0) ? least : real;
	});
var $terezka$elm_charts$Chart$definePlane = F2(
	function (config, elements) {
		var width = A2($elm$core$Basics$max, 1, (config.da - config.bs.kY) - config.bs.lQ);
		var toLimit = F5(
			function (length, marginMin, marginMax, min, max) {
				return {oc: max, od: min, kZ: length, pM: marginMax, pN: marginMin, gc: max, gg: min};
			});
		var height = A2($elm$core$Basics$max, 1, (config.cv - config.bs.jy) - config.bs.mH);
		var fixSingles = function (bs) {
			return _Utils_eq(bs.gg, bs.gc) ? _Utils_update(
				bs,
				{gc: bs.gg + 10}) : bs;
		};
		var collectLimits = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						var lims = el.a;
						return _Utils_ap(acc, lims);
					case 2:
						var lims = el.a;
						return _Utils_ap(acc, lims);
					case 3:
						return acc;
					case 4:
						return acc;
					case 5:
						return acc;
					case 6:
						return acc;
					case 7:
						return acc;
					case 8:
						return acc;
					case 9:
						return acc;
					case 10:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, collectLimits, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		var limits_ = function (pos) {
			return function (_v3) {
				var x = _v3.m3;
				var y = _v3.m4;
				return {
					m3: fixSingles(x),
					m4: fixSingles(y)
				};
			}(
				{
					m3: A5(toLimit, width, config.cE.kY, config.cE.lQ, pos.d_, pos.e8),
					m4: A5(toLimit, height, config.cE.mH, config.cE.jy, pos.sp, pos.i6)
				});
		}(
			A2(
				$terezka$elm_charts$Internal$Coordinates$foldPosition,
				$elm$core$Basics$identity,
				A3($elm$core$List$foldl, collectLimits, _List_Nil, elements)));
		var calcRange = function () {
			var _v2 = config.ix;
			if (!_v2.b) {
				return limits_.m3;
			} else {
				var some = _v2;
				return A3(
					$elm$core$List$foldl,
					F2(
						function (f, b) {
							return f(b);
						}),
					limits_.m3,
					some);
			}
		}();
		var calcDomain = function () {
			var _v1 = config.hG;
			if (!_v1.b) {
				return A3($terezka$elm_charts$Chart$Attributes$lowest, 0, $terezka$elm_charts$Chart$Attributes$orLower, limits_.m4);
			} else {
				var some = _v1;
				return A3(
					$elm$core$List$foldl,
					F2(
						function (f, b) {
							return f(b);
						}),
					limits_.m4,
					some);
			}
		}();
		var unpadded = {m3: calcRange, m4: calcDomain};
		var scalePadX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX(unpadded);
		var xMax = calcRange.gc + scalePadX(config.bs.lQ);
		var xMin = calcRange.gg - scalePadX(config.bs.kY);
		var scalePadY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY(unpadded);
		var yMax = calcDomain.gc + scalePadY(config.bs.mH);
		var yMin = calcDomain.gg - scalePadY(config.bs.jy);
		return {
			m3: _Utils_update(
				calcRange,
				{
					kZ: config.da,
					gc: A2($elm$core$Basics$max, xMin, xMax),
					gg: A2($elm$core$Basics$min, xMin, xMax)
				}),
			m4: _Utils_update(
				calcDomain,
				{
					kZ: config.cv,
					gc: A2($elm$core$Basics$max, yMin, yMax),
					gg: A2($elm$core$Basics$min, yMin, yMax)
				})
		};
	});
var $terezka$elm_charts$Chart$getItems = F2(
	function (plane, elements) {
		var toItems = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						var items = el.b;
						return _Utils_ap(acc, items);
					case 2:
						var items = el.b;
						return _Utils_ap(acc, items);
					case 3:
						var item = el.a;
						return _Utils_ap(
							acc,
							_List_fromArray(
								[item]));
					case 4:
						var func = el.a;
						return acc;
					case 5:
						return acc;
					case 6:
						return acc;
					case 7:
						return acc;
					case 8:
						return acc;
					case 9:
						return acc;
					case 10:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, toItems, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		return A3($elm$core$List$foldl, toItems, _List_Nil, elements);
	});
var $terezka$elm_charts$Chart$getLegends = function (elements) {
	var toLegends = F2(
		function (el, acc) {
			switch (el.$) {
				case 0:
					return acc;
				case 1:
					var legends_ = el.c;
					return _Utils_ap(acc, legends_);
				case 2:
					var legends_ = el.c;
					return _Utils_ap(acc, legends_);
				case 3:
					return acc;
				case 4:
					return acc;
				case 5:
					return acc;
				case 6:
					return acc;
				case 7:
					return acc;
				case 8:
					return acc;
				case 9:
					return acc;
				case 10:
					return acc;
				case 11:
					var subs = el.a;
					return A3($elm$core$List$foldl, toLegends, acc, subs);
				case 12:
					return acc;
				default:
					return acc;
			}
		});
	return A3($elm$core$List$foldl, toLegends, _List_Nil, elements);
};
var $terezka$elm_charts$Chart$TickValues = F4(
	function (xAxis, yAxis, xs, ys) {
		return {e9: xAxis, aG: xs, fa: yAxis, bb: ys};
	});
var $terezka$elm_charts$Chart$getTickValues = F3(
	function (plane, items, elements) {
		var toValues = F2(
			function (el, acc) {
				switch (el.$) {
					case 0:
						return acc;
					case 1:
						return acc;
					case 2:
						var func = el.d;
						return A2(func, plane, acc);
					case 3:
						var func = el.b;
						return acc;
					case 4:
						var func = el.a;
						return A2(func, plane, acc);
					case 5:
						var func = el.a;
						return A2(func, plane, acc);
					case 6:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 7:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 8:
						var toC = el.a;
						var func = el.b;
						return A3(
							func,
							plane,
							toC(plane),
							acc);
					case 10:
						var func = el.a;
						return A3(
							$elm$core$List$foldl,
							toValues,
							acc,
							A2(func, plane, items));
					case 9:
						return acc;
					case 11:
						var subs = el.a;
						return A3($elm$core$List$foldl, toValues, acc, subs);
					case 12:
						return acc;
					default:
						return acc;
				}
			});
		return A3(
			$elm$core$List$foldl,
			toValues,
			A4($terezka$elm_charts$Chart$TickValues, _List_Nil, _List_Nil, _List_Nil, _List_Nil),
			elements);
	});
var $terezka$elm_charts$Chart$GridElement = function (a) {
	return {$: 9, a: a};
};
var $terezka$elm_charts$Internal$Svg$Circle = 0;
var $terezka$elm_charts$Chart$Attributes$circle = function (config) {
	return _Utils_update(
		config,
		{
			dJ: $elm$core$Maybe$Just(0)
		});
};
var $terezka$elm_charts$Chart$Attributes$color = F2(
	function (v, config) {
		return (v === '') ? config : _Utils_update(
			config,
			{jL: v});
	});
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $terezka$elm_charts$Internal$Helpers$darkGray = 'rgb(200 200 200)';
var $terezka$elm_charts$Chart$Attributes$dashed = F2(
	function (value, config) {
		return _Utils_update(
			config,
			{fz: value});
	});
var $terezka$elm_charts$Internal$Helpers$pink = '#ea60df';
var $terezka$elm_charts$Internal$Svg$defaultDot = {ap: '', ay: 0, jL: $terezka$elm_charts$Internal$Helpers$pink, P: false, o6: 0, o7: '', o8: 5, bp: 1, dJ: $elm$core$Maybe$Nothing, cX: 6};
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$fillOpacity = _VirtualDom_attribute('fill-opacity');
var $elm$svg$Svg$g = $elm$svg$Svg$trustedNode('g');
var $elm$core$Basics$clamp = F3(
	function (low, high, number) {
		return (_Utils_cmp(number, low) < 0) ? low : ((_Utils_cmp(number, high) > 0) ? high : number);
	});
var $terezka$elm_charts$Internal$Svg$isWithinPlane = F3(
	function (plane, x, y) {
		return _Utils_eq(
			A3($elm$core$Basics$clamp, plane.m3.gg, plane.m3.gc, x),
			x) && _Utils_eq(
			A3($elm$core$Basics$clamp, plane.m4.gg, plane.m4.gc, y),
			y);
	});
var $elm$core$Basics$pi = _Basics_pi;
var $elm$core$Basics$sqrt = _Basics_sqrt;
var $terezka$elm_charts$Internal$Svg$plusPath = F4(
	function (area_, off, x_, y_) {
		var side = $elm$core$Basics$sqrt(area_ / 4) + off;
		var r6 = side / 2;
		var r3 = side;
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M' + ($elm$core$String$fromFloat(x_ - r6) + (' ' + $elm$core$String$fromFloat(((y_ - r3) - r6) + off))),
					'v' + $elm$core$String$fromFloat(r3 - off),
					'h' + $elm$core$String$fromFloat((-r3) + off),
					'v' + $elm$core$String$fromFloat(r3),
					'h' + $elm$core$String$fromFloat(r3 - off),
					'v' + $elm$core$String$fromFloat(r3 - off),
					'h' + $elm$core$String$fromFloat(r3),
					'v' + $elm$core$String$fromFloat((-r3) + off),
					'h' + $elm$core$String$fromFloat(r3 - off),
					'v' + $elm$core$String$fromFloat(-r3),
					'h' + $elm$core$String$fromFloat((-r3) + off),
					'v' + $elm$core$String$fromFloat((-r3) + off),
					'h' + $elm$core$String$fromFloat(-r3),
					'v' + $elm$core$String$fromFloat(r3 - off)
				]));
	});
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeOpacity = _VirtualDom_attribute('stroke-opacity');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$text = $elm$virtual_dom$VirtualDom$text;
var $terezka$elm_charts$Internal$Coordinates$scaleSVGX = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$innerWidth(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.m3);
	});
var $terezka$elm_charts$Internal$Coordinates$toSVGX = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleSVGX, plane, value - plane.m3.gg) + plane.m3.pN;
	});
var $terezka$elm_charts$Internal$Coordinates$scaleSVGY = F2(
	function (plane, value) {
		return (value * $terezka$elm_charts$Internal$Coordinates$innerHeight(plane)) / $terezka$elm_charts$Internal$Coordinates$range(plane.m4);
	});
var $terezka$elm_charts$Internal$Coordinates$toSVGY = F2(
	function (plane, value) {
		return A2($terezka$elm_charts$Internal$Coordinates$scaleSVGY, plane, plane.m4.gc - value) + plane.m4.pN;
	});
var $elm$core$Basics$degrees = function (angleInDegrees) {
	return (angleInDegrees * $elm$core$Basics$pi) / 180;
};
var $elm$core$Basics$tan = _Basics_tan;
var $terezka$elm_charts$Internal$Svg$trianglePath = F4(
	function (area_, off, x_, y_) {
		var side = $elm$core$Basics$sqrt(
			(area_ * 4) / $elm$core$Basics$sqrt(3)) + (off * $elm$core$Basics$sqrt(3));
		var height = ($elm$core$Basics$sqrt(3) * side) / 2;
		var fromMiddle = height - (($elm$core$Basics$tan(
			$elm$core$Basics$degrees(30)) * side) / 2);
		return A2(
			$elm$core$String$join,
			' ',
			_List_fromArray(
				[
					'M' + ($elm$core$String$fromFloat(x_) + (' ' + $elm$core$String$fromFloat(y_ - fromMiddle))),
					'l' + ($elm$core$String$fromFloat((-side) / 2) + (' ' + $elm$core$String$fromFloat(height))),
					'h' + $elm$core$String$fromFloat(side),
					'z'
				]));
	});
var $elm$svg$Svg$Attributes$clipPath = _VirtualDom_attribute('clip-path');
var $terezka$elm_charts$Internal$Svg$withinChartArea = function (plane) {
	return $elm$svg$Svg$Attributes$clipPath(
		'url(#' + ($terezka$elm_charts$Internal$Coordinates$toId(plane) + ')'));
};
var $terezka$elm_charts$Internal$Svg$dot = F5(
	function (plane, toX, toY, config, datum_) {
		var yOrg = toY(datum_);
		var y_ = A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, yOrg);
		var xOrg = toX(datum_);
		var x_ = A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, xOrg);
		var styleAttrs = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke(
				(config.ap === '') ? config.jL : config.ap),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(config.ay)),
				$elm$svg$Svg$Attributes$fillOpacity(
				$elm$core$String$fromFloat(config.bp)),
				$elm$svg$Svg$Attributes$fill(config.jL),
				$elm$svg$Svg$Attributes$class('elm-charts__dot'),
				config.P ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
			]);
		var showDot = A3($terezka$elm_charts$Internal$Svg$isWithinPlane, plane, xOrg, yOrg) || config.P;
		var highlightColor = (config.o7 === '') ? config.jL : config.o7;
		var highlightAttrs = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$stroke(highlightColor),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(config.o8)),
				$elm$svg$Svg$Attributes$strokeOpacity(
				$elm$core$String$fromFloat(config.o6)),
				$elm$svg$Svg$Attributes$fill('transparent'),
				$elm$svg$Svg$Attributes$class('elm-charts__dot-highlight')
			]);
		var view = F3(
			function (toEl, highlightOff, toAttrs) {
				return (config.o6 > 0) ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__dot-container')
						]),
					_List_fromArray(
						[
							A2(
							toEl,
							_Utils_ap(
								toAttrs(highlightOff),
								highlightAttrs),
							_List_Nil),
							A2(
							toEl,
							_Utils_ap(
								toAttrs(0),
								styleAttrs),
							_List_Nil)
						])) : A2(
					toEl,
					_Utils_ap(
						toAttrs(0),
						styleAttrs),
					_List_Nil);
			});
		var area_ = (2 * $elm$core$Basics$pi) * config.cX;
		if (!showDot) {
			return $elm$svg$Svg$text('');
		} else {
			var _v0 = config.dJ;
			if (_v0.$ === 1) {
				return $elm$svg$Svg$text('');
			} else {
				switch (_v0.a) {
					case 0:
						var _v1 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$circle,
							config.o8 / 2,
							function (off) {
								var radius = $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$cx(
										$elm$core$String$fromFloat(x_)),
										$elm$svg$Svg$Attributes$cy(
										$elm$core$String$fromFloat(y_)),
										$elm$svg$Svg$Attributes$r(
										$elm$core$String$fromFloat(radius + off))
									]);
							});
					case 1:
						var _v2 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.o8,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$trianglePath, area_, off, x_, y_))
									]);
							});
					case 2:
						var _v3 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$rect,
							config.o8,
							function (off) {
								var side = $elm$core$Basics$sqrt(area_);
								var sideOff = side + off;
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromFloat(x_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromFloat(y_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat(sideOff))
									]);
							});
					case 3:
						var _v4 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$rect,
							config.o8,
							function (off) {
								var side = $elm$core$Basics$sqrt(area_);
								var sideOff = side + off;
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$x(
										$elm$core$String$fromFloat(x_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$y(
										$elm$core$String$fromFloat(y_ - (sideOff / 2))),
										$elm$svg$Svg$Attributes$width(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$height(
										$elm$core$String$fromFloat(sideOff)),
										$elm$svg$Svg$Attributes$transform(
										'rotate(45 ' + ($elm$core$String$fromFloat(x_) + (' ' + ($elm$core$String$fromFloat(y_) + ')'))))
									]);
							});
					case 4:
						var _v5 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.o8,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$plusPath, area_, off, x_, y_)),
										$elm$svg$Svg$Attributes$transform(
										'rotate(45 ' + ($elm$core$String$fromFloat(x_) + (' ' + ($elm$core$String$fromFloat(y_) + ')'))))
									]);
							});
					default:
						var _v6 = _v0.a;
						return A3(
							view,
							$elm$svg$Svg$path,
							config.o8,
							function (off) {
								return _List_fromArray(
									[
										$elm$svg$Svg$Attributes$d(
										A4($terezka$elm_charts$Internal$Svg$plusPath, area_, off, x_, y_))
									]);
							});
				}
			}
		}
	});
var $terezka$elm_charts$Chart$Svg$dot = F4(
	function (plane, toX, toY, edits) {
		return A4(
			$terezka$elm_charts$Internal$Svg$dot,
			plane,
			toX,
			toY,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultDot));
	});
var $terezka$elm_charts$Internal$Helpers$gray = '#EFF2FA';
var $terezka$elm_charts$Internal$Svg$defaultLine = {A: _List_Nil, nJ: false, jL: 'rgb(210, 210, 210)', fz: _List_Nil, D: false, P: false, bp: 1, rP: -90, rQ: 0, da: 1, d_: $elm$core$Maybe$Nothing, e8: $elm$core$Maybe$Nothing, so: $elm$core$Maybe$Nothing, H: 0, sp: $elm$core$Maybe$Nothing, i6: $elm$core$Maybe$Nothing, sq: $elm$core$Maybe$Nothing, I: 0};
var $terezka$elm_charts$Internal$Commands$Line = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Commands$Move = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Basics$cos = _Basics_cos;
var $terezka$elm_charts$Internal$Commands$joinCommands = function (commands) {
	return A2($elm$core$String$join, ' ', commands);
};
var $terezka$elm_charts$Internal$Commands$stringBoolInt = function (bool) {
	return bool ? '1' : '0';
};
var $terezka$elm_charts$Internal$Commands$stringPoint = function (_v0) {
	var x = _v0.a;
	var y = _v0.b;
	return $elm$core$String$fromFloat(x) + (' ' + $elm$core$String$fromFloat(y));
};
var $terezka$elm_charts$Internal$Commands$stringPoints = function (points) {
	return A2(
		$elm$core$String$join,
		',',
		A2($elm$core$List$map, $terezka$elm_charts$Internal$Commands$stringPoint, points));
};
var $terezka$elm_charts$Internal$Commands$stringCommand = function (command) {
	switch (command.$) {
		case 0:
			var x = command.a;
			var y = command.b;
			return 'M' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 1:
			var x = command.a;
			var y = command.b;
			return 'L' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 2:
			var cx1 = command.a;
			var cy1 = command.b;
			var cx2 = command.c;
			var cy2 = command.d;
			var x = command.e;
			var y = command.f;
			return 'C' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(cx2, cy2),
						_Utils_Tuple2(x, y)
					]));
		case 3:
			var cx1 = command.a;
			var cy1 = command.b;
			var x = command.c;
			var y = command.d;
			return 'Q' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(x, y)
					]));
		case 4:
			var cx1 = command.a;
			var cy1 = command.b;
			var x = command.c;
			var y = command.d;
			return 'Q' + $terezka$elm_charts$Internal$Commands$stringPoints(
				_List_fromArray(
					[
						_Utils_Tuple2(cx1, cy1),
						_Utils_Tuple2(x, y)
					]));
		case 5:
			var x = command.a;
			var y = command.b;
			return 'T' + $terezka$elm_charts$Internal$Commands$stringPoint(
				_Utils_Tuple2(x, y));
		case 6:
			var rx = command.a;
			var ry = command.b;
			var xAxisRotation = command.c;
			var largeArcFlag = command.d;
			var sweepFlag = command.e;
			var x = command.f;
			var y = command.g;
			return 'A ' + $terezka$elm_charts$Internal$Commands$joinCommands(
				_List_fromArray(
					[
						$terezka$elm_charts$Internal$Commands$stringPoint(
						_Utils_Tuple2(rx, ry)),
						$elm$core$String$fromInt(xAxisRotation),
						$terezka$elm_charts$Internal$Commands$stringBoolInt(largeArcFlag),
						$terezka$elm_charts$Internal$Commands$stringBoolInt(sweepFlag),
						$terezka$elm_charts$Internal$Commands$stringPoint(
						_Utils_Tuple2(x, y))
					]));
		default:
			return 'Z';
	}
};
var $terezka$elm_charts$Internal$Commands$Arc = F7(
	function (a, b, c, d, e, f, g) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
	});
var $terezka$elm_charts$Internal$Commands$Close = {$: 7};
var $terezka$elm_charts$Internal$Commands$CubicBeziers = F6(
	function (a, b, c, d, e, f) {
		return {$: 2, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $terezka$elm_charts$Internal$Commands$CubicBeziersShort = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Commands$QuadraticBeziers = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Commands$QuadraticBeziersShort = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Commands$translate = F2(
	function (plane, command) {
		switch (command.$) {
			case 0:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$Move,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 1:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$Line,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 2:
				var cx1 = command.a;
				var cy1 = command.b;
				var cx2 = command.c;
				var cy2 = command.d;
				var x = command.e;
				var y = command.f;
				return A6(
					$terezka$elm_charts$Internal$Commands$CubicBeziers,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx2),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy2),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 3:
				var cx1 = command.a;
				var cy1 = command.b;
				var x = command.c;
				var y = command.d;
				return A4(
					$terezka$elm_charts$Internal$Commands$CubicBeziersShort,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 4:
				var cx1 = command.a;
				var cy1 = command.b;
				var x = command.c;
				var y = command.d;
				return A4(
					$terezka$elm_charts$Internal$Commands$QuadraticBeziers,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, cx1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, cy1),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 5:
				var x = command.a;
				var y = command.b;
				return A2(
					$terezka$elm_charts$Internal$Commands$QuadraticBeziersShort,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			case 6:
				var rx = command.a;
				var ry = command.b;
				var xAxisRotation = command.c;
				var largeArcFlag = command.d;
				var sweepFlag = command.e;
				var x = command.f;
				var y = command.g;
				return A7(
					$terezka$elm_charts$Internal$Commands$Arc,
					rx,
					ry,
					xAxisRotation,
					largeArcFlag,
					sweepFlag,
					A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x),
					A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y));
			default:
				return $terezka$elm_charts$Internal$Commands$Close;
		}
	});
var $terezka$elm_charts$Internal$Commands$description = F2(
	function (plane, commands) {
		return $terezka$elm_charts$Internal$Commands$joinCommands(
			A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					$terezka$elm_charts$Internal$Commands$translate(plane),
					$terezka$elm_charts$Internal$Commands$stringCommand),
				commands));
	});
var $terezka$elm_charts$Internal$Svg$lengthInCartesianX = $terezka$elm_charts$Internal$Coordinates$scaleCartesianX;
var $terezka$elm_charts$Internal$Svg$lengthInCartesianY = $terezka$elm_charts$Internal$Coordinates$scaleCartesianY;
var $elm$core$Basics$sin = _Basics_sin;
var $elm$svg$Svg$Attributes$strokeDasharray = _VirtualDom_attribute('stroke-dasharray');
var $elm$virtual_dom$VirtualDom$mapAttribute = _VirtualDom_mapAttribute;
var $elm$html$Html$Attributes$map = $elm$virtual_dom$VirtualDom$mapAttribute;
var $terezka$elm_charts$Internal$Svg$withAttrs = F3(
	function (attrs, toEl, defaultAttrs) {
		return toEl(
			_Utils_ap(
				defaultAttrs,
				A2(
					$elm$core$List$map,
					$elm$html$Html$Attributes$map($elm$core$Basics$never),
					attrs)));
	});
var $terezka$elm_charts$Internal$Svg$line = F2(
	function (plane, config) {
		var angle = $elm$core$Basics$degrees(config.rP);
		var _v0 = function () {
			var _v3 = _Utils_Tuple3(
				_Utils_Tuple2(config.d_, config.e8),
				_Utils_Tuple2(config.sp, config.i6),
				_Utils_Tuple2(config.so, config.sq));
			if (!_v3.a.a.$) {
				if (!_v3.a.b.$) {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v4 = _v3.a;
							var a = _v4.a.a;
							var b = _v4.b.a;
							var _v5 = _v3.b;
							var _v6 = _v5.a;
							var _v7 = _v5.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(plane.m4.gg, plane.m4.gg));
						} else {
							var _v38 = _v3.a;
							var a = _v38.a.a;
							var b = _v38.b.a;
							var _v39 = _v3.b;
							var _v40 = _v39.a;
							var c = _v39.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(c, c));
						}
					} else {
						if (_v3.b.b.$ === 1) {
							var _v41 = _v3.a;
							var a = _v41.a.a;
							var b = _v41.b.a;
							var _v42 = _v3.b;
							var c = _v42.a.a;
							var _v43 = _v42.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, b),
								_Utils_Tuple2(c, c));
						} else {
							return _Utils_Tuple2(
								_Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, plane.m3.gg, config.d_),
									A2($elm$core$Maybe$withDefault, plane.m3.gc, config.e8)),
								_Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, plane.m4.gg, config.sp),
									A2($elm$core$Maybe$withDefault, plane.m4.gc, config.i6)));
						}
					}
				} else {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v8 = _v3.a;
							var a = _v8.a.a;
							var _v9 = _v8.b;
							var _v10 = _v3.b;
							var _v11 = _v10.a;
							var _v12 = _v10.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(a, a),
								_Utils_Tuple2(plane.m4.gg, plane.m4.gc));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v51 = _v3.a;
									var a = _v51.a.a;
									var _v52 = _v51.b;
									var _v53 = _v3.b;
									var _v54 = _v53.a;
									var b = _v53.b.a;
									var _v55 = _v3.c;
									var xOff = _v55.a.a;
									var yOff = _v55.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v56 = _v3.a;
									var a = _v56.a.a;
									var _v57 = _v56.b;
									var _v58 = _v3.b;
									var _v59 = _v58.a;
									var b = _v58.b.a;
									var _v60 = _v3.c;
									var xOff = _v60.a.a;
									var _v61 = _v60.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v44 = _v3.a;
									var a = _v44.a.a;
									var _v45 = _v44.b;
									var _v46 = _v3.b;
									var _v47 = _v46.a;
									var b = _v46.b.a;
									var _v48 = _v3.c;
									var _v49 = _v48.a;
									var _v50 = _v48.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.m3.gc),
										_Utils_Tuple2(b, b));
								} else {
									var _v62 = _v3.a;
									var a = _v62.a.a;
									var _v63 = _v62.b;
									var _v64 = _v3.b;
									var _v65 = _v64.a;
									var b = _v64.b.a;
									var _v66 = _v3.c;
									var _v67 = _v66.a;
									var yOff = _v66.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					} else {
						if (!_v3.b.b.$) {
							var _v35 = _v3.a;
							var c = _v35.a.a;
							var _v36 = _v35.b;
							var _v37 = _v3.b;
							var a = _v37.a.a;
							var b = _v37.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(c, c),
								_Utils_Tuple2(a, b));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v75 = _v3.a;
									var a = _v75.a.a;
									var _v76 = _v75.b;
									var _v77 = _v3.b;
									var b = _v77.a.a;
									var _v78 = _v77.b;
									var _v79 = _v3.c;
									var xOff = _v79.a.a;
									var yOff = _v79.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v80 = _v3.a;
									var a = _v80.a.a;
									var _v81 = _v80.b;
									var _v82 = _v3.b;
									var b = _v82.a.a;
									var _v83 = _v82.b;
									var _v84 = _v3.c;
									var xOff = _v84.a.a;
									var _v85 = _v84.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v68 = _v3.a;
									var a = _v68.a.a;
									var _v69 = _v68.b;
									var _v70 = _v3.b;
									var b = _v70.a.a;
									var _v71 = _v70.b;
									var _v72 = _v3.c;
									var _v73 = _v72.a;
									var _v74 = _v72.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.m3.gc),
										_Utils_Tuple2(b, b));
								} else {
									var _v86 = _v3.a;
									var a = _v86.a.a;
									var _v87 = _v86.b;
									var _v88 = _v3.b;
									var b = _v88.a.a;
									var _v89 = _v88.b;
									var _v90 = _v3.c;
									var _v91 = _v90.a;
									var yOff = _v90.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					}
				}
			} else {
				if (!_v3.a.b.$) {
					if (_v3.b.a.$ === 1) {
						if (_v3.b.b.$ === 1) {
							var _v13 = _v3.a;
							var _v14 = _v13.a;
							var b = _v13.b.a;
							var _v15 = _v3.b;
							var _v16 = _v15.a;
							var _v17 = _v15.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(b, b),
								_Utils_Tuple2(plane.m4.gg, plane.m4.gc));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v99 = _v3.a;
									var _v100 = _v99.a;
									var a = _v99.b.a;
									var _v101 = _v3.b;
									var _v102 = _v101.a;
									var b = _v101.b.a;
									var _v103 = _v3.c;
									var xOff = _v103.a.a;
									var yOff = _v103.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v104 = _v3.a;
									var _v105 = _v104.a;
									var a = _v104.b.a;
									var _v106 = _v3.b;
									var _v107 = _v106.a;
									var b = _v106.b.a;
									var _v108 = _v3.c;
									var xOff = _v108.a.a;
									var _v109 = _v108.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v92 = _v3.a;
									var _v93 = _v92.a;
									var a = _v92.b.a;
									var _v94 = _v3.b;
									var _v95 = _v94.a;
									var b = _v94.b.a;
									var _v96 = _v3.c;
									var _v97 = _v96.a;
									var _v98 = _v96.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.m3.gc),
										_Utils_Tuple2(b, b));
								} else {
									var _v110 = _v3.a;
									var _v111 = _v110.a;
									var a = _v110.b.a;
									var _v112 = _v3.b;
									var _v113 = _v112.a;
									var b = _v112.b.a;
									var _v114 = _v3.c;
									var _v115 = _v114.a;
									var yOff = _v114.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					} else {
						if (!_v3.b.b.$) {
							var _v32 = _v3.a;
							var _v33 = _v32.a;
							var c = _v32.b.a;
							var _v34 = _v3.b;
							var a = _v34.a.a;
							var b = _v34.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(c, c),
								_Utils_Tuple2(a, b));
						} else {
							if (!_v3.c.a.$) {
								if (!_v3.c.b.$) {
									var _v123 = _v3.a;
									var _v124 = _v123.a;
									var a = _v123.b.a;
									var _v125 = _v3.b;
									var b = _v125.a.a;
									var _v126 = _v125.b;
									var _v127 = _v3.c;
									var xOff = _v127.a.a;
									var yOff = _v127.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								} else {
									var _v128 = _v3.a;
									var _v129 = _v128.a;
									var a = _v128.b.a;
									var _v130 = _v3.b;
									var b = _v130.a.a;
									var _v131 = _v130.b;
									var _v132 = _v3.c;
									var xOff = _v132.a.a;
									var _v133 = _v132.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(
											a,
											a + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, xOff)),
										_Utils_Tuple2(b, b));
								}
							} else {
								if (_v3.c.b.$ === 1) {
									var _v116 = _v3.a;
									var _v117 = _v116.a;
									var a = _v116.b.a;
									var _v118 = _v3.b;
									var b = _v118.a.a;
									var _v119 = _v118.b;
									var _v120 = _v3.c;
									var _v121 = _v120.a;
									var _v122 = _v120.b;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, plane.m3.gc),
										_Utils_Tuple2(b, b));
								} else {
									var _v134 = _v3.a;
									var _v135 = _v134.a;
									var a = _v134.b.a;
									var _v136 = _v3.b;
									var b = _v136.a.a;
									var _v137 = _v136.b;
									var _v138 = _v3.c;
									var _v139 = _v138.a;
									var yOff = _v138.b.a;
									return _Utils_Tuple2(
										_Utils_Tuple2(a, a),
										_Utils_Tuple2(
											b,
											b + A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, yOff)));
								}
							}
						}
					}
				} else {
					if (!_v3.b.a.$) {
						if (!_v3.b.b.$) {
							var _v18 = _v3.a;
							var _v19 = _v18.a;
							var _v20 = _v18.b;
							var _v21 = _v3.b;
							var a = _v21.a.a;
							var b = _v21.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.m3.gg, plane.m3.gg),
								_Utils_Tuple2(a, b));
						} else {
							var _v22 = _v3.a;
							var _v23 = _v22.a;
							var _v24 = _v22.b;
							var _v25 = _v3.b;
							var a = _v25.a.a;
							var _v26 = _v25.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.m3.gg, plane.m3.gc),
								_Utils_Tuple2(a, a));
						}
					} else {
						if (!_v3.b.b.$) {
							var _v27 = _v3.a;
							var _v28 = _v27.a;
							var _v29 = _v27.b;
							var _v30 = _v3.b;
							var _v31 = _v30.a;
							var b = _v30.b.a;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.m3.gg, plane.m3.gc),
								_Utils_Tuple2(b, b));
						} else {
							var _v140 = _v3.a;
							var _v141 = _v140.a;
							var _v142 = _v140.b;
							var _v143 = _v3.b;
							var _v144 = _v143.a;
							var _v145 = _v143.b;
							return _Utils_Tuple2(
								_Utils_Tuple2(plane.m3.gg, plane.m3.gc),
								_Utils_Tuple2(plane.m4.gg, plane.m4.gc));
						}
					}
				}
			}
		}();
		var _v1 = _v0.a;
		var x1 = _v1.a;
		var x2 = _v1.b;
		var _v2 = _v0.b;
		var y1 = _v2.a;
		var y2 = _v2.b;
		var x1_ = x1 + A2($terezka$elm_charts$Internal$Svg$lengthInCartesianX, plane, config.H);
		var x2_ = x2 + A2($terezka$elm_charts$Internal$Svg$lengthInCartesianX, plane, config.H);
		var y1_ = y1 - A2($terezka$elm_charts$Internal$Svg$lengthInCartesianY, plane, config.I);
		var y2_ = y2 - A2($terezka$elm_charts$Internal$Svg$lengthInCartesianY, plane, config.I);
		var _v146 = (config.rQ > 0) ? _Utils_Tuple2(
			A2(
				$terezka$elm_charts$Internal$Svg$lengthInCartesianX,
				plane,
				$elm$core$Basics$cos(angle) * config.rQ),
			A2(
				$terezka$elm_charts$Internal$Svg$lengthInCartesianY,
				plane,
				$elm$core$Basics$sin(angle) * config.rQ)) : _Utils_Tuple2(0, 0);
		var tickOffsetX = _v146.a;
		var tickOffsetY = _v146.b;
		var cmds = config.D ? _Utils_ap(
			(config.rQ > 0) ? _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x2_ + tickOffsetX, y2_ + tickOffsetY),
					A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
				]) : _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x2_, y2_)
				]),
			_Utils_ap(
				config.nJ ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y1_),
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
					]) : _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
					]),
				(config.rQ > 0) ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_ + tickOffsetX, y1_ + tickOffsetY)
					]) : _List_Nil)) : _Utils_ap(
			(config.rQ > 0) ? _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x1_ + tickOffsetX, y1_ + tickOffsetY),
					A2($terezka$elm_charts$Internal$Commands$Line, x1_, y1_)
				]) : _List_fromArray(
				[
					A2($terezka$elm_charts$Internal$Commands$Move, x1_, y1_)
				]),
			_Utils_ap(
				config.nJ ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x1_, y2_),
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
					]) : _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_, y2_)
					]),
				(config.rQ > 0) ? _List_fromArray(
					[
						A2($terezka$elm_charts$Internal$Commands$Line, x2_ + tickOffsetX, y2_ + tickOffsetY)
					]) : _List_Nil));
		return A4(
			$terezka$elm_charts$Internal$Svg$withAttrs,
			config.A,
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$class('elm-charts__line'),
					$elm$svg$Svg$Attributes$fill('transparent'),
					$elm$svg$Svg$Attributes$stroke(config.jL),
					$elm$svg$Svg$Attributes$strokeWidth(
					$elm$core$String$fromFloat(config.da)),
					$elm$svg$Svg$Attributes$strokeOpacity(
					$elm$core$String$fromFloat(config.bp)),
					$elm$svg$Svg$Attributes$strokeDasharray(
					A2(
						$elm$core$String$join,
						' ',
						A2($elm$core$List$map, $elm$core$String$fromFloat, config.fz))),
					$elm$svg$Svg$Attributes$d(
					A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
					config.P ? $terezka$elm_charts$Internal$Svg$withinChartArea(plane) : $elm$svg$Svg$Attributes$class('')
				]),
			_List_Nil);
	});
var $terezka$elm_charts$Chart$Svg$line = F2(
	function (plane, edits) {
		return A2(
			$terezka$elm_charts$Internal$Svg$line,
			plane,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultLine));
	});
var $terezka$elm_charts$Chart$Attributes$size = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{cX: v});
	});
var $terezka$elm_charts$Chart$Attributes$width = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{da: v});
	});
var $terezka$elm_charts$Chart$Attributes$x1 = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{
				d_: $elm$core$Maybe$Just(v)
			});
	});
var $terezka$elm_charts$Chart$Attributes$y1 = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{
				sp: $elm$core$Maybe$Just(v)
			});
	});
var $terezka$elm_charts$Chart$grid = function (edits) {
	var config = A2(
		$terezka$elm_charts$Internal$Helpers$apply,
		edits,
		{jL: '', fz: _List_Nil, et: false, da: 0});
	var width = (!config.da) ? (config.et ? 0.5 : 1) : config.da;
	var color = $elm$core$String$isEmpty(config.jL) ? (config.et ? $terezka$elm_charts$Internal$Helpers$darkGray : $terezka$elm_charts$Internal$Helpers$gray) : config.jL;
	var toDot = F4(
		function (vs, p, x, y) {
			return (A2($elm$core$List$member, x, vs.e9) || A2($elm$core$List$member, y, vs.fa)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A5(
					$terezka$elm_charts$Chart$Svg$dot,
					p,
					function ($) {
						return $.m3;
					},
					function ($) {
						return $.m4;
					},
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$size(width),
							$terezka$elm_charts$Chart$Attributes$circle
						]),
					{m3: x, m4: y}));
		});
	var toXGrid = F3(
		function (vs, p, v) {
			return A2($elm$core$List$member, v, vs.e9) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$terezka$elm_charts$Chart$Svg$line,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$width(width),
							$terezka$elm_charts$Chart$Attributes$x1(v),
							$terezka$elm_charts$Chart$Attributes$dashed(config.fz)
						])));
		});
	var toYGrid = F3(
		function (vs, p, v) {
			return A2($elm$core$List$member, v, vs.fa) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				A2(
					$terezka$elm_charts$Chart$Svg$line,
					p,
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(color),
							$terezka$elm_charts$Chart$Attributes$width(width),
							$terezka$elm_charts$Chart$Attributes$y1(v),
							$terezka$elm_charts$Chart$Attributes$dashed(config.fz)
						])));
		});
	return $terezka$elm_charts$Chart$GridElement(
		F2(
			function (p, vs) {
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__grid')
						]),
					config.et ? A2(
						$elm$core$List$concatMap,
						function (x) {
							return A2(
								$elm$core$List$filterMap,
								A3(toDot, vs, p, x),
								vs.bb);
						},
						vs.aG) : _List_fromArray(
						[
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__x-grid')
								]),
							A2(
								$elm$core$List$filterMap,
								A2(toXGrid, vs, p),
								vs.aG)),
							A2(
							$elm$svg$Svg$g,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class('elm-charts__y-grid')
								]),
							A2(
								$elm$core$List$filterMap,
								A2(toYGrid, vs, p),
								vs.bb))
						]));
			}));
};
var $elm$svg$Svg$Attributes$style = _VirtualDom_attribute('style');
var $terezka$elm_charts$Chart$viewElements = F6(
	function (config, plane, tickValues, allItems, allLegends, elements) {
		var viewOne = F2(
			function (el, _v0) {
				var before = _v0.a;
				var chart_ = _v0.b;
				var after = _v0.c;
				switch (el.$) {
					case 0:
						return _Utils_Tuple3(before, chart_, after);
					case 1:
						var view = el.d;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 2:
						var view = el.e;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 3:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 4:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 5:
						var view = el.b;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					case 6:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 7:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 8:
						var toC = el.a;
						var view = el.c;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(
									view,
									plane,
									toC(plane)),
								chart_),
							after);
					case 9:
						var view = el.a;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								A2(view, plane, tickValues),
								chart_),
							after);
					case 10:
						var func = el.a;
						return A3(
							$elm$core$List$foldr,
							viewOne,
							_Utils_Tuple3(before, chart_, after),
							A2(func, plane, allItems));
					case 11:
						var els = el.a;
						return A3(
							$elm$core$List$foldr,
							viewOne,
							_Utils_Tuple3(before, chart_, after),
							els);
					case 12:
						var view = el.a;
						return _Utils_Tuple3(
							before,
							A2(
								$elm$core$List$cons,
								view(plane),
								chart_),
							after);
					default:
						var view = el.a;
						return _Utils_Tuple3(
							($elm$core$List$length(chart_) > 0) ? A2(
								$elm$core$List$cons,
								A2(view, plane, allLegends),
								before) : before,
							chart_,
							($elm$core$List$length(chart_) > 0) ? after : A2(
								$elm$core$List$cons,
								A2(view, plane, allLegends),
								after));
				}
			});
		return A3(
			$elm$core$List$foldr,
			viewOne,
			_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
			elements);
	});
var $terezka$elm_charts$Chart$chart = F2(
	function (edits, unindexedElements) {
		var indexedElements = function () {
			var toIndexedEl = F2(
				function (el, _v4) {
					var acc = _v4.a;
					var index = _v4.b;
					switch (el.$) {
						case 0:
							var toElAndIndex = el.a;
							var _v6 = toElAndIndex(index);
							var newEl = _v6.a;
							var newIndex = _v6.b;
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[newEl])),
								newIndex);
						case 11:
							var els = el.a;
							return A3(
								$elm$core$List$foldl,
								toIndexedEl,
								_Utils_Tuple2(acc, index),
								els);
						default:
							return _Utils_Tuple2(
								_Utils_ap(
									acc,
									_List_fromArray(
										[el])),
								index);
					}
				});
			return A3(
				$elm$core$List$foldl,
				toIndexedEl,
				_Utils_Tuple2(_List_Nil, 0),
				unindexedElements).a;
		}();
		var elements = function () {
			var isGrid = function (el) {
				if (el.$ === 9) {
					return true;
				} else {
					return false;
				}
			};
			return A2($elm$core$List$any, isGrid, indexedElements) ? indexedElements : A2(
				$elm$core$List$cons,
				$terezka$elm_charts$Chart$grid(_List_Nil),
				indexedElements);
		}();
		var legends_ = $terezka$elm_charts$Chart$getLegends(elements);
		var config = A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{
				A: _List_fromArray(
					[
						$elm$svg$Svg$Attributes$style('overflow: visible;')
					]),
				hG: _List_Nil,
				oA: _List_Nil,
				cv: 300,
				fW: _List_Nil,
				cE: {jy: 0, kY: 0, lQ: 0, mH: 0},
				bs: {jy: 0, kY: 0, lQ: 0, mH: 0},
				ix: _List_Nil,
				gI: true,
				da: 300
			});
		var plane = A2($terezka$elm_charts$Chart$definePlane, config, elements);
		var items = A2($terezka$elm_charts$Chart$getItems, plane, elements);
		var toEvent = function (_v2) {
			var event_ = _v2;
			var _v1 = event_.co;
			var decoder = _v1;
			return A2(
				$terezka$elm_charts$Internal$Svg$Event,
				event_.ld,
				decoder(items));
		};
		var tickValues = A3($terezka$elm_charts$Chart$getTickValues, plane, items, elements);
		var _v0 = A6($terezka$elm_charts$Chart$viewElements, config, plane, tickValues, items, legends_, elements);
		var beforeEls = _v0.a;
		var chartEls = _v0.b;
		var afterEls = _v0.c;
		return A5(
			$terezka$elm_charts$Internal$Svg$container,
			plane,
			{
				A: config.A,
				oA: A2($elm$core$List$map, toEvent, config.oA),
				fW: config.fW,
				gI: config.gI
			},
			beforeEls,
			chartEls,
			afterEls);
	});
var $zwilias$elm_html_string$Html$Types$StringProperty = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $zwilias$elm_html_string$Html$String$Attributes$stringProperty = $zwilias$elm_html_string$Html$Types$StringProperty;
var $zwilias$elm_html_string$Html$String$Attributes$class = function (className) {
	return A2($zwilias$elm_html_string$Html$String$Attributes$stringProperty, 'className', className);
};
var $zwilias$elm_html_string$Html$Types$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $zwilias$elm_html_string$Html$Types$Regular = function (a) {
	return {$: 1, a: a};
};
var $zwilias$elm_html_string$Html$String$node = F3(
	function (tag, attributes, children) {
		return A3(
			$zwilias$elm_html_string$Html$Types$Node,
			tag,
			attributes,
			$zwilias$elm_html_string$Html$Types$Regular(children));
	});
var $zwilias$elm_html_string$Html$String$div = $zwilias$elm_html_string$Html$String$node('div');
var $terezka$elm_charts$Chart$SubElements = function (a) {
	return {$: 10, a: a};
};
var $terezka$elm_charts$Chart$each = F2(
	function (items, func) {
		return $terezka$elm_charts$Chart$SubElements(
			F2(
				function (p, _v0) {
					return A2(
						$elm$core$List$concatMap,
						func(p),
						items);
				}));
	});
var $terezka$elm_charts$Chart$Attributes$exactly = F3(
	function (exact, _v0, _v1) {
		return exact;
	});
var $author$project$Dashboards2$Chart$LineChart$fontColor = '#8792A9';
var $terezka$elm_charts$Chart$Attributes$fontSize = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{
				O: $elm$core$Maybe$Just(v)
			});
	});
var $terezka$elm_charts$Chart$Attributes$format = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{
				aN: $elm$core$Maybe$Just(v)
			});
	});
var $author$project$Dashboards2$Chart$LineChart$formatDate = function (date) {
	var _v0 = A2($elm$time$Time$toMonth, $elm$time$Time$utc, date);
	switch (_v0) {
		case 0:
			return 'Q1';
		case 1:
			return 'Q1 (Feb)';
		case 2:
			return 'Q1 (Mar)';
		case 3:
			return 'Q2';
		case 4:
			return 'Q2 (May)';
		case 5:
			return 'Q2 (Jun)';
		case 6:
			return 'Q3';
		case 7:
			return 'Q3 (Aug)';
		case 8:
			return 'Q3 (Sep)';
		case 9:
			return 'Q4';
		case 10:
			return 'Q4 (Nov)';
		default:
			return 'Q4 (Dec)';
	}
};
var $author$project$Gwi$FormatNumber$multiplierToShortString = function (m) {
	switch (m) {
		case 0:
			return 'k';
		case 1:
			return 'M';
		default:
			return 'B';
	}
};
var $author$project$Gwi$FormatNumber$formatNumber = function (value) {
	var suffix = A2($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $author$project$Gwi$FormatNumber$multiplierToShortString);
	return function (_v0) {
		var valueString = _v0.a;
		var multiplier = _v0.b;
		return _Utils_ap(
			valueString,
			suffix(multiplier));
	}(
		$author$project$Gwi$FormatNumber$numberWithMultiplier(value));
};
var $cuducos$elm_format_number$FormatNumber$Locales$Exact = function (a) {
	return {$: 2, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Min = function (a) {
	return {$: 0, a: a};
};
var $cuducos$elm_format_number$FormatNumber$Locales$Western = 0;
var $cuducos$elm_format_number$FormatNumber$Locales$base = {
	cn: '.',
	jY: $cuducos$elm_format_number$FormatNumber$Locales$Min(0),
	ie: '−',
	$8: '',
	lC: '',
	lD: '',
	gT: 0,
	rN: '',
	m7: '',
	m8: ''
};
var $author$project$Gwi$FormatNumber$defaultLocale = $cuducos$elm_format_number$FormatNumber$Locales$base;
var $cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber = F5(
	function (original, integers, decimals, prefix, suffix) {
		return {jY: decimals, kJ: integers, lu: original, gv: prefix, gS: suffix};
	});
var $cuducos$elm_format_number$FormatNumber$Parser$Negative = 2;
var $cuducos$elm_format_number$FormatNumber$Parser$Positive = 0;
var $cuducos$elm_format_number$FormatNumber$Parser$Zero = 1;
var $cuducos$elm_format_number$FormatNumber$Parser$classify = function (formatted) {
	var onlyZeros = A2(
		$elm$core$String$all,
		function (_char) {
			return _char === '0';
		},
		$elm$core$String$concat(
			A2(
				$elm$core$List$append,
				formatted.kJ,
				$elm$core$List$singleton(formatted.jY))));
	return onlyZeros ? 1 : ((formatted.lu < 0) ? 2 : 0);
};
var $elm$core$String$filter = _String_filter;
var $cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit = F2(
	function (desiredLength, value) {
		var length = $elm$core$String$length(value);
		var missing = (_Utils_cmp(length, desiredLength) < 0) ? $elm$core$Basics$abs(desiredLength - length) : 0;
		return _Utils_ap(
			value,
			A2($elm$core$String$repeat, missing, '0'));
	});
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$removeZeros = function (decimals) {
	return (A2($elm$core$String$right, 1, decimals) !== '0') ? decimals : $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(
		A2($elm$core$String$dropRight, 1, decimals));
};
var $cuducos$elm_format_number$FormatNumber$Parser$getDecimals = F2(
	function (locale, digits) {
		var _v0 = locale.jY;
		switch (_v0.$) {
			case 1:
				return $cuducos$elm_format_number$FormatNumber$Parser$removeZeros(digits);
			case 2:
				return digits;
			default:
				var min = _v0.a;
				return A2($cuducos$elm_format_number$FormatNumber$Parser$addZerosToFit, min, digits);
		}
	});
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $myrho$elm_round$Round$addSign = F2(
	function (signed, str) {
		var isNotZero = A2(
			$elm$core$List$any,
			function (c) {
				return (c !== '0') && (c !== '.');
			},
			$elm$core$String$toList(str));
		return _Utils_ap(
			(signed && isNotZero) ? '-' : '',
			str);
	});
var $myrho$elm_round$Round$increaseNum = function (_v0) {
	var head = _v0.a;
	var tail = _v0.b;
	if (head === '9') {
		var _v1 = $elm$core$String$uncons(tail);
		if (_v1.$ === 1) {
			return '01';
		} else {
			var headtail = _v1.a;
			return A2(
				$elm$core$String$cons,
				'0',
				$myrho$elm_round$Round$increaseNum(headtail));
		}
	} else {
		var c = $elm$core$Char$toCode(head);
		return ((c >= 48) && (c < 57)) ? A2(
			$elm$core$String$cons,
			$elm$core$Char$fromCode(c + 1),
			tail) : '0';
	}
};
var $elm$core$Basics$isInfinite = _Basics_isInfinite;
var $elm$core$String$padRight = F3(
	function (n, _char, string) {
		return _Utils_ap(
			string,
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)));
	});
var $elm$core$String$reverse = _String_reverse;
var $myrho$elm_round$Round$splitComma = function (str) {
	var _v0 = A2($elm$core$String$split, '.', str);
	if (_v0.b) {
		if (_v0.b.b) {
			var before = _v0.a;
			var _v1 = _v0.b;
			var after = _v1.a;
			return _Utils_Tuple2(before, after);
		} else {
			var before = _v0.a;
			return _Utils_Tuple2(before, '0');
		}
	} else {
		return _Utils_Tuple2('0', '0');
	}
};
var $myrho$elm_round$Round$toDecimal = function (fl) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(
			$elm$core$Basics$abs(fl)));
	if (_v0.b) {
		if (_v0.b.b) {
			var num = _v0.a;
			var _v1 = _v0.b;
			var exp = _v1.a;
			var e = A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(
					A2($elm$core$String$startsWith, '+', exp) ? A2($elm$core$String$dropLeft, 1, exp) : exp));
			var _v2 = $myrho$elm_round$Round$splitComma(num);
			var before = _v2.a;
			var after = _v2.b;
			var total = _Utils_ap(before, after);
			var zeroed = (e < 0) ? A2(
				$elm$core$Maybe$withDefault,
				'0',
				A2(
					$elm$core$Maybe$map,
					function (_v3) {
						var a = _v3.a;
						var b = _v3.b;
						return a + ('.' + b);
					},
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($elm$core$String$fromChar),
						$elm$core$String$uncons(
							_Utils_ap(
								A2(
									$elm$core$String$repeat,
									$elm$core$Basics$abs(e),
									'0'),
								total))))) : A3($elm$core$String$padRight, e + 1, '0', total);
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				zeroed);
		} else {
			var num = _v0.a;
			return _Utils_ap(
				(fl < 0) ? '-' : '',
				num);
		}
	} else {
		return '';
	}
};
var $myrho$elm_round$Round$roundFun = F3(
	function (functor, s, fl) {
		if ($elm$core$Basics$isInfinite(fl) || $elm$core$Basics$isNaN(fl)) {
			return $elm$core$String$fromFloat(fl);
		} else {
			var signed = fl < 0;
			var _v0 = $myrho$elm_round$Round$splitComma(
				$myrho$elm_round$Round$toDecimal(
					$elm$core$Basics$abs(fl)));
			var before = _v0.a;
			var after = _v0.b;
			var r = $elm$core$String$length(before) + s;
			var normalized = _Utils_ap(
				A2($elm$core$String$repeat, (-r) + 1, '0'),
				A3(
					$elm$core$String$padRight,
					r,
					'0',
					_Utils_ap(before, after)));
			var totalLen = $elm$core$String$length(normalized);
			var roundDigitIndex = A2($elm$core$Basics$max, 1, r);
			var increase = A2(
				functor,
				signed,
				A3($elm$core$String$slice, roundDigitIndex, totalLen, normalized));
			var remains = A3($elm$core$String$slice, 0, roundDigitIndex, normalized);
			var num = increase ? $elm$core$String$reverse(
				A2(
					$elm$core$Maybe$withDefault,
					'1',
					A2(
						$elm$core$Maybe$map,
						$myrho$elm_round$Round$increaseNum,
						$elm$core$String$uncons(
							$elm$core$String$reverse(remains))))) : remains;
			var numLen = $elm$core$String$length(num);
			var numZeroed = (num === '0') ? num : ((s <= 0) ? _Utils_ap(
				num,
				A2(
					$elm$core$String$repeat,
					$elm$core$Basics$abs(s),
					'0')) : ((_Utils_cmp(
				s,
				$elm$core$String$length(after)) < 0) ? (A3($elm$core$String$slice, 0, numLen - s, num) + ('.' + A3($elm$core$String$slice, numLen - s, numLen, num))) : _Utils_ap(
				before + '.',
				A3($elm$core$String$padRight, s, '0', after))));
			return A2($myrho$elm_round$Round$addSign, signed, numZeroed);
		}
	});
var $myrho$elm_round$Round$round = $myrho$elm_round$Round$roundFun(
	F2(
		function (signed, str) {
			var _v0 = $elm$core$String$uncons(str);
			if (_v0.$ === 1) {
				return false;
			} else {
				if ('5' === _v0.a.a) {
					if (_v0.a.b === '') {
						var _v1 = _v0.a;
						return !signed;
					} else {
						var _v2 = _v0.a;
						return true;
					}
				} else {
					var _v3 = _v0.a;
					var _int = _v3.a;
					return function (i) {
						return ((i > 53) && signed) || ((i >= 53) && (!signed));
					}(
						$elm$core$Char$toCode(_int));
				}
			}
		}));
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitInParts = F2(
	function (locale, value) {
		var toString = function () {
			var _v1 = locale.jY;
			switch (_v1.$) {
				case 1:
					var max = _v1.a;
					return $myrho$elm_round$Round$round(max);
				case 0:
					return $elm$core$String$fromFloat;
				default:
					var exact = _v1.a;
					return $myrho$elm_round$Round$round(exact);
			}
		}();
		var asList = A2(
			$elm$core$String$split,
			'.',
			toString(value));
		var decimals = function () {
			var _v0 = $elm$core$List$tail(asList);
			if (!_v0.$) {
				var values = _v0.a;
				return A2(
					$elm$core$Maybe$withDefault,
					'',
					$elm$core$List$head(values));
			} else {
				return '';
			}
		}();
		var integers = A2(
			$elm$core$Maybe$withDefault,
			'',
			$elm$core$List$head(asList));
		return _Utils_Tuple2(integers, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian = function (integers) {
	var thousand = ($elm$core$String$length(integers) > 3) ? A2($elm$core$String$right, 3, integers) : integers;
	var reversedSplitHundreds = function (value) {
		return ($elm$core$String$length(value) > 2) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 2, value),
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 2, value))) : ((!$elm$core$String$length(value)) ? _List_Nil : _List_fromArray(
			[value]));
	};
	return $elm$core$List$reverse(
		A2(
			$elm$core$List$cons,
			thousand,
			reversedSplitHundreds(
				A2($elm$core$String$dropRight, 3, integers))));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern = function (integers) {
	var reversedSplitThousands = function (value) {
		return ($elm$core$String$length(value) > 3) ? A2(
			$elm$core$List$cons,
			A2($elm$core$String$right, 3, value),
			reversedSplitThousands(
				A2($elm$core$String$dropRight, 3, value))) : _List_fromArray(
			[value]);
	};
	return $elm$core$List$reverse(
		reversedSplitThousands(integers));
};
var $cuducos$elm_format_number$FormatNumber$Parser$splitIntegers = F2(
	function (system, integers) {
		if (!system) {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByWestern(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		} else {
			return $cuducos$elm_format_number$FormatNumber$Parser$splitByIndian(
				A2($elm$core$String$filter, $elm$core$Char$isDigit, integers));
		}
	});
var $cuducos$elm_format_number$FormatNumber$Parser$parse = F2(
	function (locale, original) {
		var parts = A2($cuducos$elm_format_number$FormatNumber$Parser$splitInParts, locale, original);
		var integers = A2(
			$cuducos$elm_format_number$FormatNumber$Parser$splitIntegers,
			locale.gT,
			A2($elm$core$String$filter, $elm$core$Char$isDigit, parts.a));
		var decimals = A2($cuducos$elm_format_number$FormatNumber$Parser$getDecimals, locale, parts.b);
		var partial = A5($cuducos$elm_format_number$FormatNumber$Parser$FormattedNumber, original, integers, decimals, '', '');
		var _v0 = $cuducos$elm_format_number$FormatNumber$Parser$classify(partial);
		switch (_v0) {
			case 2:
				return _Utils_update(
					partial,
					{gv: locale.ie, gS: locale.$8});
			case 0:
				return _Utils_update(
					partial,
					{gv: locale.lC, gS: locale.lD});
			default:
				return _Utils_update(
					partial,
					{gv: locale.m7, gS: locale.m8});
		}
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals = F2(
	function (locale, decimals) {
		return (decimals === '') ? '' : _Utils_ap(locale.cn, decimals);
	});
var $cuducos$elm_format_number$FormatNumber$Stringfy$stringfy = F2(
	function (locale, formatted) {
		var stringfyDecimals = $cuducos$elm_format_number$FormatNumber$Stringfy$formatDecimals(locale);
		var integers = A2($elm$core$String$join, locale.rN, formatted.kJ);
		var decimals = stringfyDecimals(formatted.jY);
		return $elm$core$String$concat(
			_List_fromArray(
				[formatted.gv, integers, decimals, formatted.gS]));
	});
var $cuducos$elm_format_number$FormatNumber$format = F2(
	function (locale, number_) {
		return A2(
			$cuducos$elm_format_number$FormatNumber$Stringfy$stringfy,
			locale,
			A2($cuducos$elm_format_number$FormatNumber$Parser$parse, locale, number_));
	});
var $author$project$Gwi$FormatNumber$toStringWithDecimals = function (decimals) {
	return $cuducos$elm_format_number$FormatNumber$format(
		_Utils_update(
			$author$project$Gwi$FormatNumber$defaultLocale,
			{
				jY: $cuducos$elm_format_number$FormatNumber$Locales$Exact(decimals)
			}));
};
var $author$project$Gwi$FormatNumber$formatToDecimals = F2(
	function (_v0, value) {
		var decimals = _v0.jY;
		var keepZeroValues = _v0.kU;
		var withSuffix = F2(
			function (s, v) {
				return _Utils_ap(v, s);
			});
		var removeDecimalsIfAllZeros = function (string) {
			var _v1 = A2($elm$core$String$split, '.', string);
			if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
				var intPart = _v1.a;
				var _v2 = _v1.b;
				var decimalPart = _v2.a;
				return A2(
					$elm$core$String$all,
					$elm$core$Basics$eq('0'),
					decimalPart) ? intPart : string;
			} else {
				return string;
			}
		};
		var sanitizeZeroDecimals = keepZeroValues ? $elm$core$Basics$identity : removeDecimalsIfAllZeros;
		var toStringWithSanitizedDecimals = A2(
			$elm$core$Basics$composeR,
			$author$project$Gwi$FormatNumber$toStringWithDecimals(decimals),
			sanitizeZeroDecimals);
		return (value < 1000) ? toStringWithSanitizedDecimals(value) : ((value < 1000000) ? A2(
			withSuffix,
			'k',
			toStringWithSanitizedDecimals(
				value / A2($elm$core$Basics$pow, 10, 3))) : ((value < 1000000000) ? A2(
			withSuffix,
			'M',
			toStringWithSanitizedDecimals(
				value / A2($elm$core$Basics$pow, 10, 6))) : A2(
			withSuffix,
			'B',
			toStringWithSanitizedDecimals(
				value / A2($elm$core$Basics$pow, 10, 9)))));
	});
var $terezka$elm_charts$Internal$Svg$generate = F3(
	function (amount, _v0, limits) {
		var func = _v0;
		return A2(func, amount, limits);
	});
var $terezka$elm_charts$Chart$Svg$generate = $terezka$elm_charts$Internal$Svg$generate;
var $terezka$elm_charts$Chart$generate = F5(
	function (num, gen, limit, attrs, func) {
		return $terezka$elm_charts$Chart$SubElements(
			F2(
				function (p, _v0) {
					var items = A3(
						$terezka$elm_charts$Chart$Svg$generate,
						num,
						gen,
						A3(
							$elm$core$List$foldl,
							F2(
								function (f, x) {
									return f(x);
								}),
							limit(p),
							attrs));
					return A2(
						$elm$core$List$concatMap,
						func(p),
						items);
				}));
	});
var $terezka$elm_charts$Internal$Item$getDatum = function (_v0) {
	var item = _v0;
	return item.fu.sa.og;
};
var $terezka$elm_charts$Chart$Item$getData = $terezka$elm_charts$Internal$Item$getDatum;
var $terezka$elm_charts$Internal$Many$getMembers = function (_v0) {
	var group_ = _v0;
	return function (_v1) {
		var x = _v1.a;
		var xs = _v1.b;
		return A2($elm$core$List$cons, x, xs);
	}(group_.fu.f2);
};
var $terezka$elm_charts$Chart$Item$getMembers = $terezka$elm_charts$Internal$Many$getMembers;
var $terezka$elm_charts$Internal$Events$Decoder = $elm$core$Basics$identity;
var $terezka$elm_charts$Internal$Many$apply = F2(
	function (_v0, items) {
		var func = _v0.b;
		return func(items);
	});
var $terezka$elm_charts$Internal$Svg$closestPoint = F2(
	function (pos, searched) {
		return {
			m3: A3($elm$core$Basics$clamp, pos.d_, pos.e8, searched.m3),
			m4: A3($elm$core$Basics$clamp, pos.sp, pos.i6, searched.m4)
		};
	});
var $terezka$elm_charts$Internal$Svg$distanceX = F3(
	function (plane, searched, point) {
		return $elm$core$Basics$abs(
			A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, point.m3) - A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, searched.m3));
	});
var $terezka$elm_charts$Internal$Svg$distanceY = F3(
	function (plane, searched, point) {
		return $elm$core$Basics$abs(
			A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, point.m4) - A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, searched.m4));
	});
var $terezka$elm_charts$Internal$Svg$distanceSquared = F3(
	function (plane, searched, point) {
		return A2(
			$elm$core$Basics$pow,
			A3($terezka$elm_charts$Internal$Svg$distanceX, plane, searched, point),
			2) + A2(
			$elm$core$Basics$pow,
			A3($terezka$elm_charts$Internal$Svg$distanceY, plane, searched, point),
			2);
	});
var $terezka$elm_charts$Internal$Svg$keepOne = function (toPosition) {
	var toArea = function (a) {
		return function (pos) {
			return (pos.d_ - pos.e8) * (pos.sp - pos.i6);
		}(
			toPosition(a));
	};
	var func = F2(
		function (one, acc) {
			var _v0 = $elm$core$List$head(acc);
			if (_v0.$ === 1) {
				return _List_fromArray(
					[one]);
			} else {
				var other = _v0.a;
				return _Utils_eq(
					toPosition(other),
					toPosition(one)) ? A2($elm$core$List$cons, other, acc) : ((_Utils_cmp(
					toArea(other),
					toArea(one)) > 0) ? _List_fromArray(
					[one]) : acc);
			}
		});
	return A2($elm$core$List$foldr, func, _List_Nil);
};
var $terezka$elm_charts$Internal$Svg$getNearestHelp = F4(
	function (toPosition, items, plane, searched) {
		var toPoint = function (i) {
			return A2(
				$terezka$elm_charts$Internal$Svg$closestPoint,
				toPosition(i),
				searched);
		};
		var distanceSquared_ = A2($terezka$elm_charts$Internal$Svg$distanceSquared, plane, searched);
		var getClosest = F2(
			function (item, allClosest) {
				var _v0 = $elm$core$List$head(allClosest);
				if (!_v0.$) {
					var closest = _v0.a;
					return _Utils_eq(
						toPoint(closest),
						toPoint(item)) ? A2($elm$core$List$cons, item, allClosest) : ((_Utils_cmp(
						distanceSquared_(
							toPoint(closest)),
						distanceSquared_(
							toPoint(item))) > 0) ? _List_fromArray(
						[item]) : allClosest);
				} else {
					return _List_fromArray(
						[item]);
				}
			});
		return A2(
			$terezka$elm_charts$Internal$Svg$keepOne,
			toPosition,
			A3($elm$core$List$foldl, getClosest, _List_Nil, items));
	});
var $terezka$elm_charts$Internal$Svg$getNearest = F4(
	function (toPosition, items, plane, searched) {
		return A4($terezka$elm_charts$Internal$Svg$getNearestHelp, toPosition, items, plane, searched);
	});
var $terezka$elm_charts$Internal$Events$getNearest = function (grouping) {
	var toPos = grouping.a;
	return F2(
		function (items, plane) {
			var groups = A2($terezka$elm_charts$Internal$Many$apply, grouping, items);
			return A3(
				$terezka$elm_charts$Internal$Svg$getNearest,
				toPos(plane),
				groups,
				plane);
		});
};
var $terezka$elm_charts$Chart$Events$getNearest = $terezka$elm_charts$Internal$Events$getNearest;
var $zwilias$elm_html_string$Html$String$h4 = $zwilias$elm_html_string$Html$String$node('h4');
var $terezka$elm_charts$Chart$Attributes$height = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{cv: v});
	});
var $terezka$elm_charts$Chart$Attributes$highest = F3(
	function (v, edit, b) {
		return _Utils_update(
			b,
			{
				gc: A3(edit, v, b.gc, b.oc)
			});
	});
var $terezka$elm_charts$Chart$Attributes$htmlAttrs = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{fW: v});
	});
var $elm_community$list_extra$List$Extra$indexedFoldl = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _v0) {
				var i = _v0.a;
				var thisAcc = _v0.b;
				return _Utils_Tuple2(
					i + 1,
					A3(func, i, x, thisAcc));
			});
		return A3(
			$elm$core$List$foldl,
			step,
			_Utils_Tuple2(0, acc),
			list).b;
	});
var $terezka$elm_charts$Internal$Svg$Linear = 0;
var $terezka$elm_charts$Chart$Attributes$linear = function (config) {
	return _Utils_update(
		config,
		{
			h8: $elm$core$Maybe$Just(0)
		});
};
var $terezka$elm_charts$Internal$Property$Property = function (a) {
	return {$: 0, a: a};
};
var $terezka$elm_charts$Internal$Property$property = F3(
	function (value, inter, attrs) {
		return $terezka$elm_charts$Internal$Property$Property(
			{
				A: attrs,
				oF: F5(
					function (_v0, _v1, _v2, _v3, _v4) {
						return _List_Nil;
					}),
				aN: A2(
					$elm$core$Basics$composeR,
					value,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map($elm$core$String$fromFloat),
						$elm$core$Maybe$withDefault('N/A'))),
				pl: inter,
				k4: $elm$core$Maybe$Nothing,
				c5: value,
				e7: value
			});
	});
var $terezka$elm_charts$Chart$interpolated = F2(
	function (y, inter) {
		return A2(
			$terezka$elm_charts$Internal$Property$property,
			A2($elm$core$Basics$composeR, y, $elm$core$Maybe$Just),
			_Utils_ap(
				_List_fromArray(
					[$terezka$elm_charts$Chart$Attributes$linear]),
				inter));
	});
var $terezka$elm_charts$Internal$Svg$Generator = $elm$core$Basics$identity;
var $terezka$intervals$Intervals$Around = function (a) {
	return {$: 1, a: a};
};
var $terezka$intervals$Intervals$around = $terezka$intervals$Intervals$Around;
var $terezka$intervals$Intervals$ceilingTo = F2(
	function (prec, number) {
		return prec * $elm$core$Basics$ceiling(number / prec);
	});
var $terezka$intervals$Intervals$getBeginning = F2(
	function (min, interval) {
		var multiple = min / interval;
		return _Utils_eq(
			multiple,
			$elm$core$Basics$round(multiple)) ? min : A2($terezka$intervals$Intervals$ceilingTo, interval, min);
	});
var $terezka$intervals$Intervals$correctFloat = function (prec) {
	return A2(
		$elm$core$Basics$composeR,
		$myrho$elm_round$Round$round(prec),
		A2(
			$elm$core$Basics$composeR,
			$elm$core$String$toFloat,
			$elm$core$Maybe$withDefault(0)));
};
var $terezka$intervals$Intervals$getMultiples = F3(
	function (magnitude, allowDecimals, hasTickAmount) {
		var defaults = hasTickAmount ? _List_fromArray(
			[1, 1.2, 1.5, 2, 2.5, 3, 4, 5, 6, 8, 10]) : _List_fromArray(
			[1, 2, 2.5, 5, 10]);
		return allowDecimals ? defaults : ((magnitude === 1) ? A2(
			$elm$core$List$filter,
			function (n) {
				return _Utils_eq(
					$elm$core$Basics$round(n),
					n);
			},
			defaults) : ((magnitude <= 0.1) ? _List_fromArray(
			[1 / magnitude]) : defaults));
	});
var $terezka$intervals$Intervals$getPrecision = function (number) {
	var _v0 = A2(
		$elm$core$String$split,
		'e',
		$elm$core$String$fromFloat(number));
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var before = _v0.a;
		var _v1 = _v0.b;
		var after = _v1.a;
		return $elm$core$Basics$abs(
			A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(after)));
	} else {
		var _v2 = A2(
			$elm$core$String$split,
			'.',
			$elm$core$String$fromFloat(number));
		if ((_v2.b && _v2.b.b) && (!_v2.b.b.b)) {
			var before = _v2.a;
			var _v3 = _v2.b;
			var after = _v3.a;
			return $elm$core$String$length(after);
		} else {
			return 0;
		}
	}
};
var $elm$core$Basics$e = _Basics_e;
var $terezka$intervals$Intervals$toMagnitude = function (num) {
	return A2(
		$elm$core$Basics$pow,
		10,
		$elm$core$Basics$floor(
			A2($elm$core$Basics$logBase, $elm$core$Basics$e, num) / A2($elm$core$Basics$logBase, $elm$core$Basics$e, 10)));
};
var $terezka$intervals$Intervals$getInterval = F3(
	function (intervalRaw, allowDecimals, hasTickAmount) {
		var magnitude = $terezka$intervals$Intervals$toMagnitude(intervalRaw);
		var multiples = A3($terezka$intervals$Intervals$getMultiples, magnitude, allowDecimals, hasTickAmount);
		var normalized = intervalRaw / magnitude;
		var findMultipleExact = function (multiples_) {
			findMultipleExact:
			while (true) {
				if (multiples_.b) {
					var m1 = multiples_.a;
					var rest = multiples_.b;
					if (_Utils_cmp(m1 * magnitude, intervalRaw) > -1) {
						return m1;
					} else {
						var $temp$multiples_ = rest;
						multiples_ = $temp$multiples_;
						continue findMultipleExact;
					}
				} else {
					return 1;
				}
			}
		};
		var findMultiple = function (multiples_) {
			findMultiple:
			while (true) {
				if (multiples_.b) {
					if (multiples_.b.b) {
						var m1 = multiples_.a;
						var _v2 = multiples_.b;
						var m2 = _v2.a;
						var rest = _v2.b;
						if (_Utils_cmp(normalized, (m1 + m2) / 2) < 1) {
							return m1;
						} else {
							var $temp$multiples_ = A2($elm$core$List$cons, m2, rest);
							multiples_ = $temp$multiples_;
							continue findMultiple;
						}
					} else {
						var m1 = multiples_.a;
						var rest = multiples_.b;
						if (_Utils_cmp(normalized, m1) < 1) {
							return m1;
						} else {
							var $temp$multiples_ = rest;
							multiples_ = $temp$multiples_;
							continue findMultiple;
						}
					}
				} else {
					return 1;
				}
			}
		};
		var multiple = hasTickAmount ? findMultipleExact(multiples) : findMultiple(multiples);
		var precision = $terezka$intervals$Intervals$getPrecision(magnitude) + $terezka$intervals$Intervals$getPrecision(multiple);
		return A2($terezka$intervals$Intervals$correctFloat, precision, multiple * magnitude);
	});
var $terezka$intervals$Intervals$positions = F5(
	function (range, beginning, interval, m, acc) {
		positions:
		while (true) {
			var nextPosition = A2(
				$terezka$intervals$Intervals$correctFloat,
				$terezka$intervals$Intervals$getPrecision(interval),
				beginning + (m * interval));
			if (_Utils_cmp(nextPosition, range.gc) > 0) {
				return acc;
			} else {
				var $temp$range = range,
					$temp$beginning = beginning,
					$temp$interval = interval,
					$temp$m = m + 1,
					$temp$acc = _Utils_ap(
					acc,
					_List_fromArray(
						[nextPosition]));
				range = $temp$range;
				beginning = $temp$beginning;
				interval = $temp$interval;
				m = $temp$m;
				acc = $temp$acc;
				continue positions;
			}
		}
	});
var $terezka$intervals$Intervals$values = F4(
	function (allowDecimals, exact, amountRough, range) {
		var intervalRough = (range.gc - range.gg) / amountRough;
		var interval = A3($terezka$intervals$Intervals$getInterval, intervalRough, allowDecimals, exact);
		var intervalSafe = (!interval) ? 1 : interval;
		var beginning = A2($terezka$intervals$Intervals$getBeginning, range.gg, intervalSafe);
		var amountRoughSafe = (!amountRough) ? 1 : amountRough;
		return A5($terezka$intervals$Intervals$positions, range, beginning, intervalSafe, 0, _List_Nil);
	});
var $terezka$intervals$Intervals$ints = F2(
	function (amount, range) {
		return A2(
			$elm$core$List$map,
			$elm$core$Basics$round,
			function () {
				if (!amount.$) {
					var number = amount.a;
					return A4($terezka$intervals$Intervals$values, false, true, number, range);
				} else {
					var number = amount.a;
					return A4($terezka$intervals$Intervals$values, false, false, number, range);
				}
			}());
	});
var $terezka$elm_charts$Internal$Svg$ints = F2(
	function (i, b) {
		return A2(
			$terezka$intervals$Intervals$ints,
			$terezka$intervals$Intervals$around(i),
			{gc: b.gc, gg: b.gg});
	});
var $terezka$elm_charts$Chart$Svg$ints = $terezka$elm_charts$Internal$Svg$ints;
var $terezka$elm_charts$Chart$ints = $terezka$elm_charts$Chart$Svg$ints;
var $elm$core$Dict$isEmpty = function (dict) {
	if (dict.$ === -2) {
		return true;
	} else {
		return false;
	}
};
var $terezka$elm_charts$Chart$Attributes$margin = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{cE: v});
	});
var $terezka$elm_charts$Chart$Attributes$moveDown = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{I: config.I + v});
	});
var $terezka$elm_charts$Chart$Attributes$noArrow = function (config) {
	return _Utils_update(
		config,
		{fj: false});
};
var $terezka$elm_charts$Chart$Attributes$offset = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{lm: v});
	});
var $terezka$elm_charts$Internal$Events$getCoords = F3(
	function (_v0, plane, searched) {
		return searched;
	});
var $terezka$elm_charts$Chart$Events$getCoords = $terezka$elm_charts$Internal$Events$getCoords;
var $terezka$elm_charts$Internal$Events$map = F2(
	function (f, _v0) {
		var a = _v0;
		return F3(
			function (ps, s, p) {
				return f(
					A3(a, ps, s, p));
			});
	});
var $terezka$elm_charts$Chart$Events$map = $terezka$elm_charts$Internal$Events$map;
var $terezka$elm_charts$Internal$Events$Event = $elm$core$Basics$identity;
var $terezka$elm_charts$Internal$Events$on = F3(
	function (name, decoder, config) {
		return _Utils_update(
			config,
			{
				oA: A2(
					$elm$core$List$cons,
					{co: decoder, ld: name},
					config.oA)
			});
	});
var $terezka$elm_charts$Chart$Events$on = $terezka$elm_charts$Internal$Events$on;
var $terezka$elm_charts$Chart$Events$onMouseLeave = function (onMsg) {
	return A2(
		$terezka$elm_charts$Chart$Events$on,
		'mouseleave',
		A2(
			$terezka$elm_charts$Chart$Events$map,
			$elm$core$Basics$always(onMsg),
			$terezka$elm_charts$Chart$Events$getCoords));
};
var $terezka$elm_charts$Chart$Events$onMouseMove = F2(
	function (onMsg, decoder) {
		return A2(
			$terezka$elm_charts$Chart$Events$on,
			'mousemove',
			A2($terezka$elm_charts$Chart$Events$map, onMsg, decoder));
	});
var $terezka$elm_charts$Chart$Attributes$padding = F2(
	function (value, config) {
		return _Utils_update(
			config,
			{bs: value});
	});
var $terezka$elm_charts$Chart$Indexed = function (a) {
	return {$: 0, a: a};
};
var $terezka$elm_charts$Chart$SeriesElement = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $terezka$elm_charts$Internal$Item$Rendered = $elm$core$Basics$identity;
var $terezka$elm_charts$Internal$Item$toHtml = function (_v0) {
	var item = _v0;
	return item.rX(item.fu);
};
var $terezka$elm_charts$Internal$Item$toSvg = F2(
	function (plane, _v0) {
		var item = _v0;
		return A3(
			item.r0,
			plane,
			item.fu,
			A2(item.r$, plane, item.fu));
	});
var $terezka$elm_charts$Internal$Item$generalize = F2(
	function (toAny, _v0) {
		var item = _v0;
		return {
			fu: {
				qz: toAny(item.fu.qz),
				rV: $elm$core$Basics$identity,
				gX: item.fu.gX,
				sa: item.fu.sa
			},
			rX: function (c) {
				return $terezka$elm_charts$Internal$Item$toHtml(item);
			},
			rY: function (_v1) {
				return item.rY(item.fu);
			},
			r$: F2(
				function (plane, _v2) {
					return A2(item.r$, plane, item.fu);
				}),
			r0: F3(
				function (plane, _v3, _v4) {
					return A2($terezka$elm_charts$Internal$Item$toSvg, plane, item);
				})
		};
	});
var $terezka$elm_charts$Internal$Many$getGenerals = function (group_) {
	var generalize = function (_v0) {
		var item = _v0;
		return A2($terezka$elm_charts$Internal$Item$generalize, item.fu.rV, item);
	};
	return A2(
		$elm$core$List$map,
		generalize,
		$terezka$elm_charts$Internal$Many$getMembers(group_));
};
var $terezka$elm_charts$Internal$Item$getLimits = function (_v0) {
	var item = _v0;
	return item.rY(item.fu);
};
var $terezka$elm_charts$Internal$Item$map = F2(
	function (func, _v0) {
		var item = _v0;
		return {
			fu: {
				qz: item.fu.qz,
				rV: item.fu.rV,
				gX: item.fu.gX,
				sa: {
					og: func(item.fu.sa.og),
					pu: item.fu.sa.pu,
					d_: item.fu.sa.d_,
					e8: item.fu.sa.e8,
					m4: item.fu.sa.m4
				}
			},
			rX: function (_v1) {
				return $terezka$elm_charts$Internal$Item$toHtml(item);
			},
			rY: function (_v2) {
				return item.rY(item.fu);
			},
			r$: F2(
				function (plane, _v3) {
					return A2(item.r$, plane, item.fu);
				}),
			r0: F3(
				function (plane, _v4, _v5) {
					return A2($terezka$elm_charts$Internal$Item$toSvg, plane, item);
				})
		};
	});
var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
var $terezka$elm_charts$Internal$Property$toConfigs = function (prop) {
	if (!prop.$) {
		var config = prop.a;
		return _List_fromArray(
			[config]);
	} else {
		var configs = prop.a;
		return configs;
	}
};
var $terezka$elm_charts$Internal$Legend$LineLegend = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $terezka$elm_charts$Internal$Svg$defaultInterpolation = {A: _List_Nil, jL: $terezka$elm_charts$Internal$Helpers$pink, fz: _List_Nil, hC: $elm$core$Maybe$Nothing, h8: $elm$core$Maybe$Nothing, bp: 0, da: 1};
var $terezka$elm_charts$Chart$Attributes$opacity = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{bp: v});
	});
var $terezka$elm_charts$Internal$Helpers$blue = '#12A5ED';
var $terezka$elm_charts$Internal$Helpers$brown = '#871c1c';
var $terezka$elm_charts$Internal$Helpers$green = '#71c614';
var $terezka$elm_charts$Internal$Helpers$moss = '#92b42c';
var $terezka$elm_charts$Internal$Helpers$orange = '#FF8400';
var $terezka$elm_charts$Internal$Helpers$purple = '#7b4dff';
var $terezka$elm_charts$Internal$Helpers$red = '#F5325B';
var $terezka$elm_charts$Internal$Helpers$toDefault = F3(
	function (_default, items, index) {
		var dict = $elm$core$Dict$fromList(
			A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, items));
		var numOfItems = $elm$core$Dict$size(dict);
		var itemIndex = index % numOfItems;
		return A2(
			$elm$core$Maybe$withDefault,
			_default,
			A2($elm$core$Dict$get, itemIndex, dict));
	});
var $terezka$elm_charts$Internal$Helpers$turquoise = '#22d2ba';
var $terezka$elm_charts$Internal$Helpers$yellow = '#FFCA00';
var $terezka$elm_charts$Internal$Helpers$toDefaultColor = A2(
	$terezka$elm_charts$Internal$Helpers$toDefault,
	$terezka$elm_charts$Internal$Helpers$pink,
	_List_fromArray(
		[$terezka$elm_charts$Internal$Helpers$purple, $terezka$elm_charts$Internal$Helpers$pink, $terezka$elm_charts$Internal$Helpers$blue, $terezka$elm_charts$Internal$Helpers$green, $terezka$elm_charts$Internal$Helpers$red, $terezka$elm_charts$Internal$Helpers$yellow, $terezka$elm_charts$Internal$Helpers$turquoise, $terezka$elm_charts$Internal$Helpers$orange, $terezka$elm_charts$Internal$Helpers$moss, $terezka$elm_charts$Internal$Helpers$brown]));
var $terezka$elm_charts$Internal$Legend$toDotLegends = F2(
	function (elIndex, properties) {
		var toInterConfig = function (attrs) {
			return A2($terezka$elm_charts$Internal$Helpers$apply, attrs, $terezka$elm_charts$Internal$Svg$defaultInterpolation);
		};
		var toDotLegend = F3(
			function (props, prop, colorIndex) {
				var defaultOpacity = ($elm$core$List$length(props) > 1) ? 0.4 : 0;
				var interAttr = _Utils_ap(
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(
							$terezka$elm_charts$Internal$Helpers$toDefaultColor(colorIndex)),
							$terezka$elm_charts$Chart$Attributes$opacity(defaultOpacity)
						]),
					prop.pl);
				var interConfig = toInterConfig(interAttr);
				var defaultName = 'Property #' + $elm$core$String$fromInt(colorIndex + 1);
				var defaultAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$color(interConfig.jL),
						$terezka$elm_charts$Chart$Attributes$border(interConfig.jL),
						_Utils_eq(interConfig.h8, $elm$core$Maybe$Nothing) ? $terezka$elm_charts$Chart$Attributes$circle : $elm$core$Basics$identity
					]);
				var dotAttrs = _Utils_ap(defaultAttrs, prop.A);
				return A3(
					$terezka$elm_charts$Internal$Legend$LineLegend,
					A2($elm$core$Maybe$withDefault, defaultName, prop.k4),
					interAttr,
					dotAttrs);
			});
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (propIndex, f) {
					return f(elIndex + propIndex);
				}),
			A2(
				$elm$core$List$concatMap,
				function (ps) {
					return A2(
						$elm$core$List$map,
						toDotLegend(ps),
						ps);
				},
				A2($elm$core$List$map, $terezka$elm_charts$Internal$Property$toConfigs, properties)));
	});
var $terezka$elm_charts$Internal$Item$Dot = function (a) {
	return {$: 0, a: a};
};
var $terezka$elm_charts$Internal$Interpolation$linear = $elm$core$List$map(
	$elm$core$List$map(
		function (_v0) {
			var x = _v0.m3;
			var y = _v0.m4;
			return A2($terezka$elm_charts$Internal$Commands$Line, x, y);
		}));
var $terezka$elm_charts$Internal$Interpolation$First = {$: 0};
var $terezka$elm_charts$Internal$Interpolation$Previous = function (a) {
	return {$: 1, a: a};
};
var $terezka$elm_charts$Internal$Interpolation$monotoneCurve = F4(
	function (point0, point1, tangent0, tangent1) {
		var dx = (point1.m3 - point0.m3) / 3;
		return A6($terezka$elm_charts$Internal$Commands$CubicBeziers, point0.m3 + dx, point0.m4 + (dx * tangent0), point1.m3 - dx, point1.m4 - (dx * tangent1), point1.m3, point1.m4);
	});
var $terezka$elm_charts$Internal$Interpolation$slope2 = F3(
	function (point0, point1, t) {
		var h = point1.m3 - point0.m3;
		return (!(!h)) ? ((((3 * (point1.m4 - point0.m4)) / h) - t) / 2) : t;
	});
var $terezka$elm_charts$Internal$Interpolation$sign = function (x) {
	return (x < 0) ? (-1) : 1;
};
var $terezka$elm_charts$Internal$Interpolation$toH = F2(
	function (h0, h1) {
		return (!h0) ? ((h1 < 0) ? (0 * (-1)) : h1) : h0;
	});
var $terezka$elm_charts$Internal$Interpolation$slope3 = F3(
	function (point0, point1, point2) {
		var h1 = point2.m3 - point1.m3;
		var h0 = point1.m3 - point0.m3;
		var s0h = A2($terezka$elm_charts$Internal$Interpolation$toH, h0, h1);
		var s0 = (point1.m4 - point0.m4) / s0h;
		var s1h = A2($terezka$elm_charts$Internal$Interpolation$toH, h1, h0);
		var s1 = (point2.m4 - point1.m4) / s1h;
		var p = ((s0 * h1) + (s1 * h0)) / (h0 + h1);
		var slope = ($terezka$elm_charts$Internal$Interpolation$sign(s0) + $terezka$elm_charts$Internal$Interpolation$sign(s1)) * A2(
			$elm$core$Basics$min,
			A2(
				$elm$core$Basics$min,
				$elm$core$Basics$abs(s0),
				$elm$core$Basics$abs(s1)),
			0.5 * $elm$core$Basics$abs(p));
		return $elm$core$Basics$isNaN(slope) ? 0 : slope;
	});
var $terezka$elm_charts$Internal$Interpolation$monotonePart = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var commands = _v0.b;
		var _v1 = _Utils_Tuple2(tangent, points);
		_v1$4:
		while (true) {
			if (!_v1.a.$) {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var _v2 = _v1.a;
						var _v3 = _v1.b;
						var p0 = _v3.a;
						var _v4 = _v3.b;
						var p1 = _v4.a;
						var _v5 = _v4.b;
						var p2 = _v5.a;
						var rest = _v5.b;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p2);
						var t0 = A3($terezka$elm_charts$Internal$Interpolation$slope2, p0, p1, t1);
						return A2(
							$terezka$elm_charts$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$terezka$elm_charts$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var _v9 = _v1.a;
						var _v10 = _v1.b;
						var p0 = _v10.a;
						var _v11 = _v10.b;
						var p1 = _v11.a;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$terezka$elm_charts$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t1, t1),
										A2($terezka$elm_charts$Internal$Commands$Line, p1.m3, p1.m4)
									])));
					}
				} else {
					break _v1$4;
				}
			} else {
				if (_v1.b.b && _v1.b.b.b) {
					if (_v1.b.b.b.b) {
						var t0 = _v1.a.a;
						var _v6 = _v1.b;
						var p0 = _v6.a;
						var _v7 = _v6.b;
						var p1 = _v7.a;
						var _v8 = _v7.b;
						var p2 = _v8.a;
						var rest = _v8.b;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p2);
						return A2(
							$terezka$elm_charts$Internal$Interpolation$monotonePart,
							A2(
								$elm$core$List$cons,
								p1,
								A2($elm$core$List$cons, p2, rest)),
							_Utils_Tuple2(
								$terezka$elm_charts$Internal$Interpolation$Previous(t1),
								_Utils_ap(
									commands,
									_List_fromArray(
										[
											A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1)
										]))));
					} else {
						var t0 = _v1.a.a;
						var _v12 = _v1.b;
						var p0 = _v12.a;
						var _v13 = _v12.b;
						var p1 = _v13.a;
						var t1 = A3($terezka$elm_charts$Internal$Interpolation$slope3, p0, p1, p1);
						return _Utils_Tuple2(
							$terezka$elm_charts$Internal$Interpolation$Previous(t1),
							_Utils_ap(
								commands,
								_List_fromArray(
									[
										A4($terezka$elm_charts$Internal$Interpolation$monotoneCurve, p0, p1, t0, t1),
										A2($terezka$elm_charts$Internal$Commands$Line, p1.m3, p1.m4)
									])));
					}
				} else {
					break _v1$4;
				}
			}
		}
		return _Utils_Tuple2(tangent, commands);
	});
var $terezka$elm_charts$Internal$Interpolation$monotoneSection = F2(
	function (points, _v0) {
		var tangent = _v0.a;
		var acc = _v0.b;
		var _v1 = function () {
			if (points.b) {
				var p0 = points.a;
				var rest = points.b;
				return A2(
					$terezka$elm_charts$Internal$Interpolation$monotonePart,
					A2($elm$core$List$cons, p0, rest),
					_Utils_Tuple2(
						tangent,
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Line, p0.m3, p0.m4)
							])));
			} else {
				return _Utils_Tuple2(tangent, _List_Nil);
			}
		}();
		var t0 = _v1.a;
		var commands = _v1.b;
		return _Utils_Tuple2(
			t0,
			A2($elm$core$List$cons, commands, acc));
	});
var $terezka$elm_charts$Internal$Interpolation$monotone = function (sections) {
	return A3(
		$elm$core$List$foldr,
		$terezka$elm_charts$Internal$Interpolation$monotoneSection,
		_Utils_Tuple2($terezka$elm_charts$Internal$Interpolation$First, _List_Nil),
		sections).b;
};
var $terezka$elm_charts$Internal$Interpolation$Point = F2(
	function (x, y) {
		return {m3: x, m4: y};
	});
var $terezka$elm_charts$Internal$Interpolation$after = F2(
	function (a, b) {
		return _List_fromArray(
			[
				a,
				A2($terezka$elm_charts$Internal$Interpolation$Point, b.m3, a.m4),
				b
			]);
	});
var $terezka$elm_charts$Internal$Interpolation$stepped = function (sections) {
	var expand = F2(
		function (result, section) {
			expand:
			while (true) {
				if (section.b) {
					if (section.b.b) {
						var a = section.a;
						var _v1 = section.b;
						var b = _v1.a;
						var rest = _v1.b;
						var $temp$result = _Utils_ap(
							result,
							A2($terezka$elm_charts$Internal$Interpolation$after, a, b)),
							$temp$section = A2($elm$core$List$cons, b, rest);
						result = $temp$result;
						section = $temp$section;
						continue expand;
					} else {
						var last = section.a;
						return result;
					}
				} else {
					return result;
				}
			}
		});
	return A2(
		$elm$core$List$map,
		A2(
			$elm$core$Basics$composeR,
			expand(_List_Nil),
			$elm$core$List$map(
				function (_v2) {
					var x = _v2.m3;
					var y = _v2.m4;
					return A2($terezka$elm_charts$Internal$Commands$Line, x, y);
				})),
		sections);
};
var $terezka$elm_charts$Internal$Svg$last = function (list) {
	return $elm$core$List$head(
		A2(
			$elm$core$List$drop,
			$elm$core$List$length(list) - 1,
			list));
};
var $terezka$elm_charts$Internal$Svg$withBorder = F2(
	function (stuff, func) {
		if (stuff.b) {
			var first = stuff.a;
			var rest = stuff.b;
			return $elm$core$Maybe$Just(
				A2(
					func,
					first,
					A2(
						$elm$core$Maybe$withDefault,
						first,
						$terezka$elm_charts$Internal$Svg$last(rest))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $terezka$elm_charts$Internal$Svg$toCommands = F4(
	function (method, toX, toY, data) {
		var toSets = F2(
			function (ps, cmds) {
				return A2(
					$terezka$elm_charts$Internal$Svg$withBorder,
					ps,
					F2(
						function (first, last_) {
							return _Utils_Tuple3(first, cmds, last_);
						}));
			});
		var fold = F2(
			function (datum_, acc) {
				var _v1 = toY(datum_);
				if (!_v1.$) {
					var y_ = _v1.a;
					if (acc.b) {
						var latest = acc.a;
						var rest = acc.b;
						return A2(
							$elm$core$List$cons,
							_Utils_ap(
								latest,
								_List_fromArray(
									[
										{
										m3: toX(datum_),
										m4: y_
									}
									])),
							rest);
					} else {
						return A2(
							$elm$core$List$cons,
							_List_fromArray(
								[
									{
									m3: toX(datum_),
									m4: y_
								}
								]),
							acc);
					}
				} else {
					return A2($elm$core$List$cons, _List_Nil, acc);
				}
			});
		var points = $elm$core$List$reverse(
			A3($elm$core$List$foldl, fold, _List_Nil, data));
		var commands = function () {
			switch (method) {
				case 0:
					return $terezka$elm_charts$Internal$Interpolation$linear(points);
				case 1:
					return $terezka$elm_charts$Internal$Interpolation$monotone(points);
				default:
					return $terezka$elm_charts$Internal$Interpolation$stepped(points);
			}
		}();
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A3($elm$core$List$map2, toSets, points, commands));
	});
var $terezka$elm_charts$Internal$Svg$apply = F2(
	function (funcs, _default) {
		var apply_ = F2(
			function (f, a) {
				return f(a);
			});
		return A3($elm$core$List$foldl, apply_, _default, funcs);
	});
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$linearGradient = $elm$svg$Svg$trustedNode('linearGradient');
var $elm$svg$Svg$Attributes$offset = _VirtualDom_attribute('offset');
var $elm$svg$Svg$pattern = $elm$svg$Svg$trustedNode('pattern');
var $elm$svg$Svg$Attributes$patternTransform = _VirtualDom_attribute('patternTransform');
var $elm$svg$Svg$Attributes$patternUnits = _VirtualDom_attribute('patternUnits');
var $elm$svg$Svg$stop = $elm$svg$Svg$trustedNode('stop');
var $elm$svg$Svg$Attributes$stopColor = _VirtualDom_attribute('stop-color');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $terezka$elm_charts$Internal$Svg$toPattern = F2(
	function (defaultColor, design) {
		var toPatternId = function (props) {
			return A3(
				$elm$core$String$replace,
				'(',
				'-',
				A3(
					$elm$core$String$replace,
					')',
					'-',
					A3(
						$elm$core$String$replace,
						'.',
						'-',
						A3(
							$elm$core$String$replace,
							',',
							'-',
							A3(
								$elm$core$String$replace,
								' ',
								'-',
								A2(
									$elm$core$String$join,
									'-',
									_Utils_ap(
										_List_fromArray(
											[
												'elm-charts__pattern',
												function () {
												switch (design.$) {
													case 0:
														return 'striped';
													case 1:
														return 'dotted';
													default:
														return 'gradient';
												}
											}()
											]),
										props)))))));
		};
		var toPatternDefs = F4(
			function (id, spacing, rotate, inside) {
				return A2(
					$elm$svg$Svg$defs,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$pattern,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$id(id),
									$elm$svg$Svg$Attributes$patternUnits('userSpaceOnUse'),
									$elm$svg$Svg$Attributes$width(
									$elm$core$String$fromFloat(spacing)),
									$elm$svg$Svg$Attributes$height(
									$elm$core$String$fromFloat(spacing)),
									$elm$svg$Svg$Attributes$patternTransform(
									'rotate(' + ($elm$core$String$fromFloat(rotate) + ')'))
								]),
							_List_fromArray(
								[inside]))
						]));
			});
		var _v0 = function () {
			switch (design.$) {
				case 0:
					var edits = design.a;
					var config = A2(
						$terezka$elm_charts$Internal$Svg$apply,
						edits,
						{jL: defaultColor, S: 45, rx: 4, da: 3});
					var theId = toPatternId(
						_List_fromArray(
							[
								config.jL,
								$elm$core$String$fromFloat(config.da),
								$elm$core$String$fromFloat(config.rx),
								$elm$core$String$fromFloat(config.S)
							]));
					return _Utils_Tuple2(
						A4(
							toPatternDefs,
							theId,
							config.rx,
							config.S,
							A2(
								$elm$svg$Svg$line,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$x1('0'),
										$elm$svg$Svg$Attributes$y('0'),
										$elm$svg$Svg$Attributes$x2('0'),
										$elm$svg$Svg$Attributes$y2(
										$elm$core$String$fromFloat(config.rx)),
										$elm$svg$Svg$Attributes$stroke(config.jL),
										$elm$svg$Svg$Attributes$strokeWidth(
										$elm$core$String$fromFloat(config.da))
									]),
								_List_Nil)),
						theId);
				case 1:
					var edits = design.a;
					var config = A2(
						$terezka$elm_charts$Internal$Svg$apply,
						edits,
						{jL: defaultColor, S: 45, rx: 4, da: 3});
					var theId = toPatternId(
						_List_fromArray(
							[
								config.jL,
								$elm$core$String$fromFloat(config.da),
								$elm$core$String$fromFloat(config.rx),
								$elm$core$String$fromFloat(config.S)
							]));
					return _Utils_Tuple2(
						A4(
							toPatternDefs,
							theId,
							config.rx,
							config.S,
							A2(
								$elm$svg$Svg$circle,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$fill(config.jL),
										$elm$svg$Svg$Attributes$cx(
										$elm$core$String$fromFloat(config.da / 3)),
										$elm$svg$Svg$Attributes$cy(
										$elm$core$String$fromFloat(config.da / 3)),
										$elm$svg$Svg$Attributes$r(
										$elm$core$String$fromFloat(config.da / 3))
									]),
								_List_Nil)),
						theId);
				default:
					var edits = design.a;
					var colors = _Utils_eq(edits, _List_Nil) ? _List_fromArray(
						[defaultColor, 'white']) : edits;
					var theId = toPatternId(colors);
					var totalColors = $elm$core$List$length(colors);
					var toPercentage = function (i) {
						return (i * 100) / (totalColors - 1);
					};
					var toStop = F2(
						function (i, c) {
							return A2(
								$elm$svg$Svg$stop,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$offset(
										$elm$core$String$fromFloat(
											toPercentage(i)) + '%'),
										$elm$svg$Svg$Attributes$stopColor(c)
									]),
								_List_Nil);
						});
					return _Utils_Tuple2(
						A2(
							$elm$svg$Svg$defs,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$linearGradient,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$id(theId),
											$elm$svg$Svg$Attributes$x1('0'),
											$elm$svg$Svg$Attributes$x2('0'),
											$elm$svg$Svg$Attributes$y1('0'),
											$elm$svg$Svg$Attributes$y2('1')
										]),
									A2($elm$core$List$indexedMap, toStop, colors))
								])),
						theId);
			}
		}();
		var patternDefs = _v0.a;
		var patternId = _v0.b;
		return _Utils_Tuple2(patternDefs, 'url(#' + (patternId + ')'));
	});
var $terezka$elm_charts$Internal$Svg$area = F6(
	function (plane, toX, toY2M, toY, config, data) {
		var _v0 = function () {
			var _v1 = config.hC;
			if (_v1.$ === 1) {
				return _Utils_Tuple2(
					$elm$svg$Svg$text(''),
					config.jL);
			} else {
				var design = _v1.a;
				return A2($terezka$elm_charts$Internal$Svg$toPattern, config.jL, design);
			}
		}();
		var patternDefs = _v0.a;
		var fill = _v0.b;
		var view = function (cmds) {
			return A4(
				$terezka$elm_charts$Internal$Svg$withAttrs,
				config.A,
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__area-section'),
						$elm$svg$Svg$Attributes$fill(fill),
						$elm$svg$Svg$Attributes$fillOpacity(
						$elm$core$String$fromFloat(config.bp)),
						$elm$svg$Svg$Attributes$strokeWidth('0'),
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$d(
						A2($terezka$elm_charts$Internal$Commands$description, plane, cmds)),
						$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
					]),
				_List_Nil);
		};
		var withUnder = F2(
			function (_v5, _v6) {
				var firstBottom = _v5.a;
				var cmdsBottom = _v5.b;
				var endBottom = _v5.c;
				var firstTop = _v6.a;
				var cmdsTop = _v6.b;
				var endTop = _v6.c;
				return view(
					_Utils_ap(
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Move, firstBottom.m3, firstBottom.m4),
								A2($terezka$elm_charts$Internal$Commands$Line, firstTop.m3, firstTop.m4)
							]),
						_Utils_ap(
							cmdsTop,
							_Utils_ap(
								_List_fromArray(
									[
										A2($terezka$elm_charts$Internal$Commands$Move, firstBottom.m3, firstBottom.m4)
									]),
								_Utils_ap(
									cmdsBottom,
									_List_fromArray(
										[
											A2($terezka$elm_charts$Internal$Commands$Line, endTop.m3, endTop.m4)
										]))))));
			});
		var withoutUnder = function (_v4) {
			var first = _v4.a;
			var cmds = _v4.b;
			var end = _v4.c;
			return view(
				_Utils_ap(
					_List_fromArray(
						[
							A2($terezka$elm_charts$Internal$Commands$Move, first.m3, 0),
							A2($terezka$elm_charts$Internal$Commands$Line, first.m3, first.m4)
						]),
					_Utils_ap(
						cmds,
						_List_fromArray(
							[
								A2($terezka$elm_charts$Internal$Commands$Line, end.m3, 0)
							]))));
		};
		if (config.bp <= 0) {
			return $elm$svg$Svg$text('');
		} else {
			var _v2 = config.h8;
			if (_v2.$ === 1) {
				return $elm$svg$Svg$text('');
			} else {
				var method = _v2.a;
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__area-sections')
						]),
					function () {
						if (toY2M.$ === 1) {
							return A2(
								$elm$core$List$cons,
								patternDefs,
								A2(
									$elm$core$List$map,
									withoutUnder,
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
						} else {
							var toY2 = toY2M.a;
							return A2(
								$elm$core$List$cons,
								patternDefs,
								A3(
									$elm$core$List$map2,
									withUnder,
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY2, data),
									A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
						}
					}());
			}
		}
	});
var $terezka$elm_charts$Internal$Item$getPosition = F2(
	function (plane, _v0) {
		var item = _v0;
		return A2(item.r$, plane, item.fu);
	});
var $terezka$elm_charts$Internal$Svg$interpolation = F5(
	function (plane, toX, toY, config, data) {
		var view = function (_v1) {
			var first = _v1.a;
			var cmds = _v1.b;
			return A4(
				$terezka$elm_charts$Internal$Svg$withAttrs,
				config.A,
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__interpolation-section'),
						$elm$svg$Svg$Attributes$fill('transparent'),
						$elm$svg$Svg$Attributes$stroke(config.jL),
						$elm$svg$Svg$Attributes$strokeDasharray(
						A2(
							$elm$core$String$join,
							' ',
							A2($elm$core$List$map, $elm$core$String$fromFloat, config.fz))),
						$elm$svg$Svg$Attributes$strokeWidth(
						$elm$core$String$fromFloat(config.da)),
						$elm$svg$Svg$Attributes$d(
						A2(
							$terezka$elm_charts$Internal$Commands$description,
							plane,
							A2(
								$elm$core$List$cons,
								A2($terezka$elm_charts$Internal$Commands$Move, first.m3, first.m4),
								cmds))),
						$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
					]),
				_List_Nil);
		};
		var _v0 = config.h8;
		if (_v0.$ === 1) {
			return $elm$svg$Svg$text('');
		} else {
			var method = _v0.a;
			return A2(
				$elm$svg$Svg$g,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$class('elm-charts__interpolation-sections')
					]),
				A2(
					$elm$core$List$map,
					view,
					A4($terezka$elm_charts$Internal$Svg$toCommands, method, toX, toY, data)));
		}
	});
var $terezka$elm_charts$Internal$Produce$toDefaultName = F2(
	function (index, name) {
		return A2(
			$elm$core$Maybe$withDefault,
			'Property #' + $elm$core$String$fromInt(index + 1),
			name);
	});
var $terezka$elm_charts$Internal$Svg$toRadius = F2(
	function (size_, shape) {
		var area_ = (2 * $elm$core$Basics$pi) * size_;
		switch (shape) {
			case 0:
				return $elm$core$Basics$sqrt(area_ / $elm$core$Basics$pi);
			case 1:
				var side = $elm$core$Basics$sqrt(
					(area_ * 4) / $elm$core$Basics$sqrt(3));
				return $elm$core$Basics$sqrt(3) * side;
			case 2:
				return $elm$core$Basics$sqrt(area_) / 2;
			case 3:
				return $elm$core$Basics$sqrt(area_) / 2;
			case 4:
				return $elm$core$Basics$sqrt(area_ / 4);
			default:
				return $elm$core$Basics$sqrt(area_ / 4);
		}
	});
var $terezka$elm_charts$Internal$Produce$tooltipRow = F3(
	function (color, title, text) {
		return A2(
			$elm$html$Html$tr,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'color', color),
							A2($elm$html$Html$Attributes$style, 'padding', '0'),
							A2($elm$html$Html$Attributes$style, 'padding-right', '3px')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title + ':')
						])),
					A2(
					$elm$html$Html$td,
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$style, 'text-align', 'right'),
							A2($elm$html$Html$Attributes$style, 'padding', '0')
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						]))
				]));
	});
var $terezka$elm_charts$Internal$Produce$toDotSeries = F4(
	function (elIndex, toX, properties, data) {
		var toInterConfig = function (attrs) {
			return A2($terezka$elm_charts$Internal$Helpers$apply, attrs, $terezka$elm_charts$Internal$Svg$defaultInterpolation);
		};
		var toDotConfig = function (attrs) {
			return A2($terezka$elm_charts$Internal$Helpers$apply, attrs, $terezka$elm_charts$Internal$Svg$defaultDot);
		};
		var toDotItem = F7(
			function (lineIndex, stackIndex, colorIndex, prop, interConfig, dataIndex, datum_) {
				var y_ = A2(
					$elm$core$Maybe$withDefault,
					0,
					prop.e7(datum_));
				var x_ = toX(datum_);
				var defaultAttrs = _List_fromArray(
					[
						$terezka$elm_charts$Chart$Attributes$color(interConfig.jL),
						$terezka$elm_charts$Chart$Attributes$border(interConfig.jL),
						_Utils_eq(interConfig.h8, $elm$core$Maybe$Nothing) ? $terezka$elm_charts$Chart$Attributes$circle : $elm$core$Basics$identity
					]);
				var dotAttrs = _Utils_ap(
					defaultAttrs,
					_Utils_ap(
						prop.A,
						A5(prop.oF, lineIndex, stackIndex, dataIndex, prop.k4, datum_)));
				var config = toDotConfig(dotAttrs);
				return {
					fu: {
						qz: config,
						rV: $terezka$elm_charts$Internal$Item$Dot,
						gX: {
							ap: config.ap,
							ay: config.ay,
							jL: function () {
								var _v6 = config.jL;
								if (_v6 === 'white') {
									return interConfig.jL;
								} else {
									return config.jL;
								}
							}(),
							cl: dataIndex,
							ow: elIndex,
							ki: prop.aN(datum_),
							pi: colorIndex,
							ld: prop.k4,
							qA: lineIndex,
							rz: stackIndex
						},
						sa: {
							og: datum_,
							pu: function () {
								var _v7 = prop.c5(datum_);
								if (!_v7.$) {
									return true;
								} else {
									return false;
								}
							}(),
							d_: x_,
							e8: x_,
							m4: y_
						}
					},
					rX: function (c) {
						return _List_fromArray(
							[
								A3(
								$terezka$elm_charts$Internal$Produce$tooltipRow,
								c.gX.jL,
								A2($terezka$elm_charts$Internal$Produce$toDefaultName, colorIndex, c.gX.ld),
								prop.aN(datum_))
							]);
					},
					rY: function (_v8) {
						return {d_: x_, e8: x_, sp: y_, i6: y_};
					},
					r$: F2(
						function (plane, _v9) {
							var radius = A2(
								$elm$core$Maybe$withDefault,
								0,
								A2(
									$elm$core$Maybe$map,
									$terezka$elm_charts$Internal$Svg$toRadius(config.cX),
									config.dJ));
							var radiusX_ = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianX, plane, radius);
							var radiusY_ = A2($terezka$elm_charts$Internal$Coordinates$scaleCartesianY, plane, radius);
							return {d_: x_ - radiusX_, e8: x_ + radiusX_, sp: y_ - radiusY_, i6: y_ + radiusY_};
						}),
					r0: F3(
						function (plane, _v10, _v11) {
							var _v12 = prop.c5(datum_);
							if (_v12.$ === 1) {
								return $elm$svg$Svg$text('');
							} else {
								return A5(
									$terezka$elm_charts$Internal$Svg$dot,
									plane,
									function ($) {
										return $.m3;
									},
									function ($) {
										return $.m4;
									},
									config,
									{m3: x_, m4: y_});
							}
						})
				};
			});
		var toSeriesItem = F5(
			function (lineIndex, stacks, stackIndex, prop, colorIndex) {
				var defaultOpacity = ($elm$core$List$length(stacks) > 1) ? 0.4 : 0;
				var interAttr = _Utils_ap(
					_List_fromArray(
						[
							$terezka$elm_charts$Chart$Attributes$color(
							$terezka$elm_charts$Internal$Helpers$toDefaultColor(colorIndex)),
							$terezka$elm_charts$Chart$Attributes$opacity(defaultOpacity)
						]),
					prop.pl);
				var interConfig = toInterConfig(interAttr);
				var dotItems = A2(
					$elm$core$List$indexedMap,
					A5(toDotItem, lineIndex, stackIndex, colorIndex, prop, interConfig),
					data);
				if (!dotItems.b) {
					return $elm$core$Maybe$Nothing;
				} else {
					var first = dotItems.a;
					var rest = dotItems.b;
					return $elm$core$Maybe$Just(
						{
							fu: {
								f2: _Utils_Tuple2(first, rest)
							},
							rX: function (c) {
								return _List_fromArray(
									[
										A2(
										$elm$html$Html$table,
										_List_fromArray(
											[
												A2($elm$html$Html$Attributes$style, 'margin', '0')
											]),
										A2(
											$elm$core$List$concatMap,
											$terezka$elm_charts$Internal$Item$toHtml,
											function (_v1) {
												var x = _v1.a;
												var xs = _v1.b;
												return A2($elm$core$List$cons, x, xs);
											}(c.f2)))
									]);
							},
							rY: function (c) {
								return A2(
									$terezka$elm_charts$Internal$Coordinates$foldPosition,
									$terezka$elm_charts$Internal$Item$getLimits,
									function (_v2) {
										var x = _v2.a;
										var xs = _v2.b;
										return A2($elm$core$List$cons, x, xs);
									}(c.f2));
							},
							r$: F2(
								function (plane, c) {
									return A2(
										$terezka$elm_charts$Internal$Coordinates$foldPosition,
										$terezka$elm_charts$Internal$Item$getPosition(plane),
										function (_v3) {
											var x = _v3.a;
											var xs = _v3.b;
											return A2($elm$core$List$cons, x, xs);
										}(c.f2));
								}),
							r0: F3(
								function (plane, _v4, _v5) {
									var toBottom = function (datum_) {
										return A3(
											$elm$core$Maybe$map2,
											F2(
												function (real, visual) {
													return visual - real;
												}),
											prop.c5(datum_),
											prop.e7(datum_));
									};
									return A2(
										$elm$svg$Svg$g,
										_List_fromArray(
											[
												$elm$svg$Svg$Attributes$class('elm-charts__series')
											]),
										_List_fromArray(
											[
												A6(
												$terezka$elm_charts$Internal$Svg$area,
												plane,
												toX,
												$elm$core$Maybe$Just(toBottom),
												prop.e7,
												interConfig,
												data),
												A5($terezka$elm_charts$Internal$Svg$interpolation, plane, toX, prop.e7, interConfig, data),
												A2(
												$elm$svg$Svg$g,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$class('elm-charts__dots')
													]),
												A2(
													$elm$core$List$map,
													$terezka$elm_charts$Internal$Item$toSvg(plane),
													dotItems))
											]));
								})
						});
				}
			});
		return A2(
			$elm$core$List$filterMap,
			$elm$core$Basics$identity,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (propIndex, f) {
						return f(elIndex + propIndex);
					}),
				$elm$core$List$concat(
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (lineIndex, stacks) {
								return A2(
									$elm$core$List$indexedMap,
									A2(toSeriesItem, lineIndex, stacks),
									stacks);
							}),
						A2($elm$core$List$map, $terezka$elm_charts$Internal$Property$toConfigs, properties)))));
	});
var $terezka$elm_charts$Chart$seriesMap = F4(
	function (mapData, toX, properties, data) {
		return $terezka$elm_charts$Chart$Indexed(
			function (index) {
				var legends_ = A2($terezka$elm_charts$Internal$Legend$toDotLegends, index, properties);
				var items = A4($terezka$elm_charts$Internal$Produce$toDotSeries, index, toX, properties, data);
				var toLimits = A2($elm$core$List$map, $terezka$elm_charts$Internal$Item$getLimits, items);
				var generalized = A2(
					$elm$core$List$map,
					$terezka$elm_charts$Internal$Item$map(mapData),
					A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Many$getGenerals, items));
				return _Utils_Tuple2(
					A4(
						$terezka$elm_charts$Chart$SeriesElement,
						toLimits,
						generalized,
						legends_,
						function (p) {
							return A2(
								$elm$svg$Svg$map,
								$elm$core$Basics$never,
								A2(
									$elm$svg$Svg$g,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class('elm-charts__dot-series')
										]),
									A2(
										$elm$core$List$map,
										$terezka$elm_charts$Internal$Item$toSvg(p),
										items)));
						}),
					index + $elm$core$List$length(
						A2($elm$core$List$concatMap, $terezka$elm_charts$Internal$Property$toConfigs, properties)));
			});
	});
var $terezka$elm_charts$Chart$series = F3(
	function (toX, properties, data) {
		return A4($terezka$elm_charts$Chart$seriesMap, $elm$core$Basics$identity, toX, properties, data);
	});
var $zwilias$elm_html_string$Html$String$span = $zwilias$elm_html_string$Html$String$node('span');
var $terezka$elm_charts$Internal$Many$Remodel = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $terezka$elm_charts$Internal$Helpers$gatherWith = F2(
	function (testFn, list) {
		var helper = F2(
			function (scattered, gathered) {
				if (!scattered.b) {
					return $elm$core$List$reverse(gathered);
				} else {
					var toGather = scattered.a;
					var population = scattered.b;
					var _v1 = A2(
						$elm$core$List$partition,
						testFn(toGather),
						population);
					var gathering = _v1.a;
					var remaining = _v1.b;
					return A2(
						helper,
						remaining,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2(toGather, gathering),
							gathered));
				}
			});
		return A2(helper, list, _List_Nil);
	});
var $terezka$elm_charts$Internal$Many$toGroup = F2(
	function (first, rest) {
		var concatTuple = function (_v1) {
			var x = _v1.a;
			var xs = _v1.b;
			return A2($elm$core$List$cons, x, xs);
		};
		return {
			fu: {
				f2: _Utils_Tuple2(first, rest)
			},
			rX: function (c) {
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$table,
						_List_Nil,
						A2(
							$elm$core$List$concatMap,
							$terezka$elm_charts$Internal$Item$toHtml,
							concatTuple(c.f2)))
					]);
			},
			rY: function (c) {
				return A2(
					$terezka$elm_charts$Internal$Coordinates$foldPosition,
					$terezka$elm_charts$Internal$Item$getLimits,
					concatTuple(c.f2));
			},
			r$: F2(
				function (p, c) {
					return A2(
						$terezka$elm_charts$Internal$Coordinates$foldPosition,
						$terezka$elm_charts$Internal$Item$getPosition(p),
						concatTuple(c.f2));
				}),
			r0: F3(
				function (p, c, _v0) {
					return A2(
						$elm$svg$Svg$g,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$class('elm-charts__group')
							]),
						A2(
							$elm$core$List$map,
							$terezka$elm_charts$Internal$Item$toSvg(p),
							concatTuple(c.f2)));
				})
		};
	});
var $terezka$elm_charts$Internal$Many$groupingHelp = F2(
	function (_v0, items) {
		var shared = _v0.eV;
		var equality = _v0.fO;
		var edits = _v0.fN;
		var toShared = function (_v2) {
			var item = _v2;
			return shared(item.fu);
		};
		var toNewGroup = function (_v1) {
			var i = _v1.a;
			var is = _v1.b;
			return edits(
				A2($terezka$elm_charts$Internal$Many$toGroup, i, is));
		};
		var toEquality = F2(
			function (aO, bO) {
				return A2(
					equality,
					toShared(aO),
					toShared(bO));
			});
		return A2(
			$elm$core$List$map,
			toNewGroup,
			A2($terezka$elm_charts$Internal$Helpers$gatherWith, toEquality, items));
	});
var $terezka$elm_charts$Internal$Many$stacks = A2(
	$terezka$elm_charts$Internal$Many$Remodel,
	$terezka$elm_charts$Internal$Item$getPosition,
	$terezka$elm_charts$Internal$Many$groupingHelp(
		{
			fN: $elm$core$Basics$identity,
			fO: F2(
				function (a, b) {
					return _Utils_eq(a.d_, b.d_) && (_Utils_eq(a.e8, b.e8) && _Utils_eq(a.qA, b.qA));
				}),
			eV: function (config) {
				return {qA: config.gX.qA, d_: config.sa.d_, e8: config.sa.e8};
			}
		}));
var $terezka$elm_charts$Chart$Item$stacks = $terezka$elm_charts$Internal$Many$stacks;
var $zwilias$elm_html_string$Html$Types$TextNode = function (a) {
	return {$: 1, a: a};
};
var $zwilias$elm_html_string$Html$String$text = $zwilias$elm_html_string$Html$Types$TextNode;
var $zwilias$elm_html_string$Html$Types$indent = F3(
	function (perLevel, level, x) {
		return _Utils_ap(
			A2($elm$core$String$repeat, perLevel * level, ' '),
			x);
	});
var $zwilias$elm_html_string$Html$Types$join = F2(
	function (between, list) {
		if (!list.b) {
			return '';
		} else {
			if (!list.b.b) {
				var x = list.a;
				return x;
			} else {
				var x = list.a;
				var xs = list.b;
				return A3(
					$elm$core$List$foldl,
					F2(
						function (y, acc) {
							return _Utils_ap(
								y,
								_Utils_ap(between, acc));
						}),
					x,
					xs);
			}
		}
	});
var $zwilias$elm_html_string$Html$Types$closingTag = function (tagName) {
	return '</' + (tagName + '>');
};
var $zwilias$elm_html_string$Html$Types$escapeHtmlText = A2(
	$elm$core$Basics$composeR,
	A2($elm$core$String$replace, '&', '&amp;'),
	A2(
		$elm$core$Basics$composeR,
		A2($elm$core$String$replace, '<', '&lt;'),
		A2($elm$core$String$replace, '>', '&gt;')));
var $zwilias$elm_html_string$Html$Types$escape = A2(
	$elm$core$String$foldl,
	F2(
		function (_char, acc) {
			return (_char === '\"') ? (acc + '\\\"') : _Utils_ap(
				acc,
				$elm$core$String$fromChar(_char));
		}),
	'');
var $elm$core$Char$toLower = _Char_toLower;
var $zwilias$elm_html_string$Html$Types$hyphenate = A2(
	$elm$core$String$foldl,
	F2(
		function (_char, acc) {
			return $elm$core$Char$isUpper(_char) ? (acc + ('-' + $elm$core$String$fromChar(
				$elm$core$Char$toLower(_char)))) : _Utils_ap(
				acc,
				$elm$core$String$fromChar(_char));
		}),
	'');
var $zwilias$elm_html_string$Html$Types$buildProp = F2(
	function (key, value) {
		return $zwilias$elm_html_string$Html$Types$hyphenate(key) + ('=\"' + ($zwilias$elm_html_string$Html$Types$escape(value) + '\"'));
	});
var $NoRedInk$elm_string_conversions$String$Conversions$fromValue = function (value) {
	return A2($elm$json$Json$Encode$encode, 0, value);
};
var $zwilias$elm_html_string$Html$Types$propName = function (prop) {
	switch (prop) {
		case 'className':
			return 'class';
		case 'defaultValue':
			return 'value';
		case 'htmlFor':
			return 'for';
		default:
			return prop;
	}
};
var $zwilias$elm_html_string$Html$Types$addAttribute = F2(
	function (attribute, acc) {
		var classes = acc.a;
		var styles = acc.b;
		var attrs = acc.c;
		switch (attribute.$) {
			case 0:
				var key = attribute.a;
				var value = attribute.b;
				return _Utils_Tuple3(
					classes,
					styles,
					A2(
						$elm$core$List$cons,
						A2($zwilias$elm_html_string$Html$Types$buildProp, key, value),
						attrs));
			case 1:
				if (attribute.a === 'className') {
					var value = attribute.b;
					return _Utils_Tuple3(
						A2($elm$core$List$cons, value, classes),
						styles,
						attrs);
				} else {
					var string = attribute.a;
					var value = attribute.b;
					return _Utils_Tuple3(
						classes,
						styles,
						A2(
							$elm$core$List$cons,
							A2(
								$zwilias$elm_html_string$Html$Types$buildProp,
								$zwilias$elm_html_string$Html$Types$propName(string),
								value),
							attrs));
				}
			case 2:
				var string = attribute.a;
				var enabled = attribute.b;
				return enabled ? _Utils_Tuple3(
					classes,
					styles,
					A2(
						$elm$core$List$cons,
						$zwilias$elm_html_string$Html$Types$hyphenate(
							$zwilias$elm_html_string$Html$Types$propName(string)),
						attrs)) : acc;
			case 3:
				var string = attribute.a;
				var value = attribute.b;
				return _Utils_Tuple3(
					classes,
					styles,
					A2(
						$elm$core$List$cons,
						A2(
							$zwilias$elm_html_string$Html$Types$buildProp,
							$zwilias$elm_html_string$Html$Types$propName(string),
							$NoRedInk$elm_string_conversions$String$Conversions$fromValue(value)),
						attrs));
			case 4:
				var key = attribute.a;
				var value = attribute.b;
				return _Utils_Tuple3(
					classes,
					A2(
						$elm$core$List$cons,
						$zwilias$elm_html_string$Html$Types$escape(key) + (': ' + $zwilias$elm_html_string$Html$Types$escape(value)),
						styles),
					attrs);
			default:
				return acc;
		}
	});
var $zwilias$elm_html_string$Html$Types$withClasses = F2(
	function (classes, attrs) {
		if (!classes.b) {
			return attrs;
		} else {
			return A2(
				$elm$core$List$cons,
				A2(
					$zwilias$elm_html_string$Html$Types$buildProp,
					'class',
					A2($zwilias$elm_html_string$Html$Types$join, ' ', classes)),
				attrs);
		}
	});
var $zwilias$elm_html_string$Html$Types$withStyles = F2(
	function (styles, attrs) {
		if (!styles.b) {
			return attrs;
		} else {
			return A2(
				$elm$core$List$cons,
				A2(
					$zwilias$elm_html_string$Html$Types$buildProp,
					'style',
					A2($zwilias$elm_html_string$Html$Types$join, '; ', styles)),
				attrs);
		}
	});
var $zwilias$elm_html_string$Html$Types$attributesToString = function (attrs) {
	var _v0 = A3(
		$elm$core$List$foldl,
		$zwilias$elm_html_string$Html$Types$addAttribute,
		_Utils_Tuple3(_List_Nil, _List_Nil, _List_Nil),
		attrs);
	var classes = _v0.a;
	var styles = _v0.b;
	var regular = _v0.c;
	return A2(
		$zwilias$elm_html_string$Html$Types$withStyles,
		styles,
		A2($zwilias$elm_html_string$Html$Types$withClasses, classes, regular));
};
var $zwilias$elm_html_string$Html$Types$tag = F2(
	function (tagName, attributes) {
		return '<' + (A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$cons,
				tagName,
				$zwilias$elm_html_string$Html$Types$attributesToString(attributes))) + '>');
	});
var $zwilias$elm_html_string$Html$Types$toStringHelper = F3(
	function (indenter, tags, acc) {
		toStringHelper:
		while (true) {
			if (!tags.b) {
				var _v1 = acc.rz;
				if (!_v1.b) {
					return acc;
				} else {
					var _v2 = _v1.a;
					var tagName = _v2.a;
					var cont = _v2.b;
					var rest = _v1.b;
					var $temp$indenter = indenter,
						$temp$tags = cont,
						$temp$acc = _Utils_update(
						acc,
						{
							hz: acc.hz - 1,
							iA: A2(
								$elm$core$List$cons,
								A2(
									indenter,
									acc.hz - 1,
									$zwilias$elm_html_string$Html$Types$closingTag(tagName)),
								acc.iA),
							rz: rest
						});
					indenter = $temp$indenter;
					tags = $temp$tags;
					acc = $temp$acc;
					continue toStringHelper;
				}
			} else {
				if (!tags.a.$) {
					var _v3 = tags.a;
					var tagName = _v3.a;
					var attributes = _v3.b;
					var children = _v3.c;
					var rest = tags.b;
					switch (children.$) {
						case 0:
							var $temp$indenter = indenter,
								$temp$tags = rest,
								$temp$acc = _Utils_update(
								acc,
								{
									iA: A2(
										$elm$core$List$cons,
										A2(
											indenter,
											acc.hz,
											A2($zwilias$elm_html_string$Html$Types$tag, tagName, attributes)),
										acc.iA)
								});
							indenter = $temp$indenter;
							tags = $temp$tags;
							acc = $temp$acc;
							continue toStringHelper;
						case 1:
							var childNodes = children.a;
							var $temp$indenter = indenter,
								$temp$tags = childNodes,
								$temp$acc = _Utils_update(
								acc,
								{
									hz: acc.hz + 1,
									iA: A2(
										$elm$core$List$cons,
										A2(
											indenter,
											acc.hz,
											A2($zwilias$elm_html_string$Html$Types$tag, tagName, attributes)),
										acc.iA),
									rz: A2(
										$elm$core$List$cons,
										_Utils_Tuple2(tagName, rest),
										acc.rz)
								});
							indenter = $temp$indenter;
							tags = $temp$tags;
							acc = $temp$acc;
							continue toStringHelper;
						default:
							var childNodes = children.a;
							var $temp$indenter = indenter,
								$temp$tags = A2($elm$core$List$map, $elm$core$Tuple$second, childNodes),
								$temp$acc = _Utils_update(
								acc,
								{
									hz: acc.hz + 1,
									iA: A2(
										$elm$core$List$cons,
										A2(
											indenter,
											acc.hz,
											A2($zwilias$elm_html_string$Html$Types$tag, tagName, attributes)),
										acc.iA),
									rz: A2(
										$elm$core$List$cons,
										_Utils_Tuple2(tagName, rest),
										acc.rz)
								});
							indenter = $temp$indenter;
							tags = $temp$tags;
							acc = $temp$acc;
							continue toStringHelper;
					}
				} else {
					var string = tags.a.a;
					var rest = tags.b;
					var $temp$indenter = indenter,
						$temp$tags = rest,
						$temp$acc = _Utils_update(
						acc,
						{
							iA: A2(
								$elm$core$List$cons,
								A2(
									indenter,
									acc.hz,
									$zwilias$elm_html_string$Html$Types$escapeHtmlText(string)),
								acc.iA)
						});
					indenter = $temp$indenter;
					tags = $temp$tags;
					acc = $temp$acc;
					continue toStringHelper;
				}
			}
		}
	});
var $zwilias$elm_html_string$Html$Types$toString = F2(
	function (depth, html) {
		var joinString = function () {
			if (!depth) {
				return '';
			} else {
				return '\n';
			}
		}();
		var initialAcc = {hz: 0, iA: _List_Nil, rz: _List_Nil};
		var indenter = function () {
			if (!depth) {
				return $elm$core$Basics$always($elm$core$Basics$identity);
			} else {
				return $zwilias$elm_html_string$Html$Types$indent(depth);
			}
		}();
		return A2(
			$zwilias$elm_html_string$Html$Types$join,
			joinString,
			A3(
				$zwilias$elm_html_string$Html$Types$toStringHelper,
				indenter,
				_List_fromArray(
					[html]),
				initialAcc).iA);
	});
var $zwilias$elm_html_string$Html$String$toString = function (indent) {
	return $zwilias$elm_html_string$Html$Types$toString(indent);
};
var $terezka$elm_charts$Chart$HtmlElement = function (a) {
	return {$: 13, a: a};
};
var $terezka$elm_charts$Chart$html = function (func) {
	return $terezka$elm_charts$Chart$HtmlElement(
		F2(
			function (p, _v0) {
				return func(p);
			}));
};
var $terezka$elm_charts$Internal$Svg$defaultTooltip = {fj: true, nF: 'white', ap: '#D8D8D8', fH: $elm$core$Maybe$Nothing, oO: $elm$core$Maybe$Nothing, cv: 0, lm: 8, da: 0};
var $terezka$elm_charts$Internal$Svg$Bottom = 3;
var $terezka$elm_charts$Internal$Svg$Left = 1;
var $terezka$elm_charts$Internal$Svg$Right = 2;
var $terezka$elm_charts$Internal$Svg$Top = 0;
var $terezka$elm_charts$Internal$Coordinates$bottom = function (pos) {
	return {m3: pos.d_ + ((pos.e8 - pos.d_) / 2), m4: pos.sp};
};
var $terezka$elm_charts$Internal$Coordinates$left = function (pos) {
	return {m3: pos.d_, m4: pos.sp + ((pos.i6 - pos.sp) / 2)};
};
var $terezka$elm_charts$Internal$Svg$positionHtml = F7(
	function (plane, x, y, xOff, yOff, attrs, content) {
		var yPercentage = ((A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y) - yOff) * 100) / plane.m4.kZ;
		var xPercentage = ((A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x) + xOff) * 100) / plane.m3.kZ;
		var posititonStyles = _List_fromArray(
			[
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				$elm$core$String$fromFloat(xPercentage) + '%'),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				$elm$core$String$fromFloat(yPercentage) + '%'),
				A2($elm$html$Html$Attributes$style, 'margin-right', '-400px'),
				A2($elm$html$Html$Attributes$style, 'position', 'absolute')
			]);
		return A2(
			$elm$html$Html$div,
			_Utils_ap(posititonStyles, attrs),
			content);
	});
var $terezka$elm_charts$Internal$Coordinates$right = function (pos) {
	return {m3: pos.e8, m4: pos.sp + ((pos.i6 - pos.sp) / 2)};
};
var $terezka$elm_charts$Internal$Svg$tooltipPointerStyle = F4(
	function (direction, className, background, borderColor) {
		var config = function () {
			switch (direction) {
				case 0:
					return {fb: 'right', fl: 'top', fm: 'left'};
				case 3:
					return {fb: 'right', fl: 'bottom', fm: 'left'};
				case 1:
					return {fb: 'bottom', fl: 'left', fm: 'top'};
				case 2:
					return {fb: 'bottom', fl: 'right', fm: 'top'};
				case 4:
					return {fb: 'bottom', fl: 'left', fm: 'top'};
				default:
					return {fb: 'right', fl: 'top', fm: 'left'};
			}
		}();
		return '\n  .' + (className + (':before, .' + (className + (':after {\n    content: "";\n    position: absolute;\n    border-' + (config.fm + (': 5px solid transparent;\n    border-' + (config.fb + (': 5px solid transparent;\n    ' + (config.fl + (': 100%;\n    ' + (config.fm + (': 50%;\n    margin-' + (config.fm + (': -5px;\n  }\n\n  .' + (className + (':after {\n    border-' + (config.fl + (': 5px solid ' + (background + (';\n    margin-' + (config.fl + (': -1px;\n    z-index: 1;\n    height: 0px;\n  }\n\n  .' + (className + (':before {\n    border-' + (config.fl + (': 5px solid ' + (borderColor + ';\n    height: 0px;\n  }\n  ')))))))))))))))))))))))))));
	});
var $terezka$elm_charts$Internal$Coordinates$top = function (pos) {
	return {m3: pos.d_ + ((pos.e8 - pos.d_) / 2), m4: pos.i6};
};
var $terezka$elm_charts$Internal$Svg$tooltip = F5(
	function (plane, pos, config, htmlAttrs, content) {
		var distanceTop = A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, pos.i6);
		var distanceRight = plane.m3.kZ - A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, pos.d_);
		var distanceLeft = A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, pos.e8);
		var distanceBottom = plane.m4.kZ - A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, pos.sp);
		var direction = function () {
			var _v5 = config.fH;
			if (!_v5.$) {
				switch (_v5.a) {
					case 4:
						var _v6 = _v5.a;
						return (config.da > 0) ? ((_Utils_cmp(distanceLeft, config.da + config.lm) > 0) ? 1 : 2) : ((_Utils_cmp(distanceLeft, distanceRight) > 0) ? 1 : 2);
					case 5:
						var _v7 = _v5.a;
						return (config.cv > 0) ? ((_Utils_cmp(distanceTop, config.cv + config.lm) > 0) ? 0 : 3) : ((_Utils_cmp(distanceTop, distanceBottom) > 0) ? 0 : 3);
					default:
						var dir = _v5.a;
						return dir;
				}
			} else {
				var isLargest = function (a) {
					return $elm$core$List$all(
						function (b) {
							return _Utils_cmp(a, b) > -1;
						});
				};
				return A2(
					isLargest,
					distanceTop,
					_List_fromArray(
						[distanceBottom, distanceLeft, distanceRight])) ? 0 : (A2(
					isLargest,
					distanceBottom,
					_List_fromArray(
						[distanceTop, distanceLeft, distanceRight])) ? 3 : (A2(
					isLargest,
					distanceLeft,
					_List_fromArray(
						[distanceTop, distanceBottom, distanceRight])) ? 1 : 2));
			}
		}();
		var focalPoint = function () {
			var _v2 = config.oO;
			if (!_v2.$) {
				var focal = _v2.a;
				switch (direction) {
					case 0:
						return $terezka$elm_charts$Internal$Coordinates$top(
							focal(pos));
					case 3:
						return $terezka$elm_charts$Internal$Coordinates$bottom(
							focal(pos));
					case 1:
						return $terezka$elm_charts$Internal$Coordinates$left(
							focal(pos));
					case 2:
						return $terezka$elm_charts$Internal$Coordinates$right(
							focal(pos));
					case 4:
						return $terezka$elm_charts$Internal$Coordinates$left(
							focal(pos));
					default:
						return $terezka$elm_charts$Internal$Coordinates$right(
							focal(pos));
				}
			} else {
				switch (direction) {
					case 0:
						return $terezka$elm_charts$Internal$Coordinates$top(pos);
					case 3:
						return $terezka$elm_charts$Internal$Coordinates$bottom(pos);
					case 1:
						return $terezka$elm_charts$Internal$Coordinates$left(pos);
					case 2:
						return $terezka$elm_charts$Internal$Coordinates$right(pos);
					case 4:
						return $terezka$elm_charts$Internal$Coordinates$left(pos);
					default:
						return $terezka$elm_charts$Internal$Coordinates$right(pos);
				}
			}
		}();
		var arrowWidth = config.fj ? 4 : 0;
		var _v0 = function () {
			switch (direction) {
				case 0:
					return {hi: 'elm-charts__tooltip-top', c0: 'translate(-50%, -100%)', H: 0, I: config.lm + arrowWidth};
				case 3:
					return {hi: 'elm-charts__tooltip-bottom', c0: 'translate(-50%, 0%)', H: 0, I: (-config.lm) - arrowWidth};
				case 1:
					return {hi: 'elm-charts__tooltip-left', c0: 'translate(-100%, -50%)', H: (-config.lm) - arrowWidth, I: 0};
				case 2:
					return {hi: 'elm-charts__tooltip-right', c0: 'translate(0, -50%)', H: config.lm + arrowWidth, I: 0};
				case 4:
					return {hi: 'elm-charts__tooltip-leftOrRight', c0: 'translate(0, -50%)', H: (-config.lm) - arrowWidth, I: 0};
				default:
					return {hi: 'elm-charts__tooltip-topOrBottom', c0: 'translate(-50%, -100%)', H: 0, I: config.lm + arrowWidth};
			}
		}();
		var xOff = _v0.H;
		var yOff = _v0.I;
		var transformation = _v0.c0;
		var className = _v0.hi;
		var children = config.fj ? A2(
			$elm$core$List$cons,
			A3(
				$elm$html$Html$node,
				'style',
				_List_Nil,
				_List_fromArray(
					[
						$elm$html$Html$text(
						A4($terezka$elm_charts$Internal$Svg$tooltipPointerStyle, direction, className, config.nF, config.ap))
					])),
			content) : content;
		var attributes = _Utils_ap(
			_List_fromArray(
				[
					$elm$html$Html$Attributes$class(className),
					A2($elm$html$Html$Attributes$style, 'transform', transformation),
					A2($elm$html$Html$Attributes$style, 'padding', '5px 8px'),
					A2($elm$html$Html$Attributes$style, 'background', config.nF),
					A2($elm$html$Html$Attributes$style, 'border', '1px solid ' + config.ap),
					A2($elm$html$Html$Attributes$style, 'border-radius', '3px'),
					A2($elm$html$Html$Attributes$style, 'pointer-events', 'none')
				]),
			htmlAttrs);
		return A2(
			$elm$html$Html$map,
			$elm$core$Basics$never,
			A7($terezka$elm_charts$Internal$Svg$positionHtml, plane, focalPoint.m3, focalPoint.m4, xOff, yOff, attributes, children));
	});
var $terezka$elm_charts$Chart$Svg$tooltip = F3(
	function (plane, pos, edits) {
		return A3(
			$terezka$elm_charts$Internal$Svg$tooltip,
			plane,
			pos,
			A2($terezka$elm_charts$Internal$Helpers$apply, edits, $terezka$elm_charts$Internal$Svg$defaultTooltip));
	});
var $terezka$elm_charts$Chart$tooltip = F4(
	function (i, edits, attrs_, content) {
		return $terezka$elm_charts$Chart$html(
			function (p) {
				var pos = $terezka$elm_charts$Internal$Item$getLimits(i);
				var content_ = _Utils_eq(content, _List_Nil) ? $terezka$elm_charts$Internal$Item$toHtml(i) : content;
				return A3($terezka$elm_charts$Internal$Svg$isWithinPlane, p, pos.d_, pos.i6) ? A5(
					$terezka$elm_charts$Chart$Svg$tooltip,
					p,
					A2($terezka$elm_charts$Internal$Item$getPosition, p, i),
					edits,
					attrs_,
					content_) : $elm$html$Html$text('');
			});
	});
var $terezka$elm_charts$Chart$Attributes$withGrid = function (config) {
	return _Utils_update(
		config,
		{E: true});
};
var $terezka$elm_charts$Chart$Attributes$x = F2(
	function (v, config) {
		return _Utils_update(
			config,
			{m3: v});
	});
var $terezka$elm_charts$Chart$LabelElement = F3(
	function (a, b, c) {
		return {$: 8, a: a, b: b, c: c};
	});
var $elm$svg$Svg$foreignObject = $elm$svg$Svg$trustedNode('foreignObject');
var $terezka$elm_charts$Internal$Svg$position = F6(
	function (plane, rotation, x_, y_, xOff_, yOff_) {
		return $elm$svg$Svg$Attributes$transform(
			'translate(' + ($elm$core$String$fromFloat(
				A2($terezka$elm_charts$Internal$Coordinates$toSVGX, plane, x_) + xOff_) + (',' + ($elm$core$String$fromFloat(
				A2($terezka$elm_charts$Internal$Coordinates$toSVGY, plane, y_) + yOff_) + (') rotate(' + ($elm$core$String$fromFloat(rotation) + ')'))))));
	});
var $elm$svg$Svg$text_ = $elm$svg$Svg$trustedNode('text');
var $elm$svg$Svg$tspan = $elm$svg$Svg$trustedNode('tspan');
var $terezka$elm_charts$Internal$Svg$label = F4(
	function (plane, config, inner, point) {
		var _v0 = config.N;
		if (_v0.$ === 1) {
			var withOverflowWrap = function (el) {
				return config.P ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_fromArray(
						[el])) : el;
			};
			var uppercaseStyle = config.T ? 'text-transform: uppercase;' : '';
			var fontStyle = function () {
				var _v5 = config.O;
				if (!_v5.$) {
					var size_ = _v5.a;
					return 'font-size: ' + ($elm$core$String$fromInt(size_) + 'px;');
				} else {
					return '';
				}
			}();
			var anchorStyle = function () {
				var _v1 = config.M;
				if (_v1.$ === 1) {
					return 'text-anchor: middle;';
				} else {
					switch (_v1.a) {
						case 0:
							var _v2 = _v1.a;
							return 'text-anchor: end;';
						case 1:
							var _v3 = _v1.a;
							return 'text-anchor: start;';
						default:
							var _v4 = _v1.a;
							return 'text-anchor: middle;';
					}
				}
			}();
			return withOverflowWrap(
				A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.A,
					$elm$svg$Svg$text_,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__label'),
							$elm$svg$Svg$Attributes$stroke(config.ap),
							$elm$svg$Svg$Attributes$strokeWidth(
							$elm$core$String$fromFloat(config.ay)),
							$elm$svg$Svg$Attributes$fill(config.jL),
							A6($terezka$elm_charts$Internal$Svg$position, plane, -config.S, point.m3, point.m4, config.H, config.I),
							$elm$svg$Svg$Attributes$style(
							A2(
								$elm$core$String$join,
								' ',
								_List_fromArray(
									['pointer-events: none;', fontStyle, anchorStyle, uppercaseStyle])))
						]),
					_List_fromArray(
						[
							A2($elm$svg$Svg$tspan, _List_Nil, inner)
						])));
		} else {
			var ellipsis = _v0.a;
			var xOffWithAnchor = function () {
				var _v11 = config.M;
				if (_v11.$ === 1) {
					return config.H - (ellipsis.da / 2);
				} else {
					switch (_v11.a) {
						case 0:
							var _v12 = _v11.a;
							return config.H - ellipsis.da;
						case 1:
							var _v13 = _v11.a;
							return config.H;
						default:
							var _v14 = _v11.a;
							return config.H - (ellipsis.da / 2);
					}
				}
			}();
			var withOverflowWrap = function (el) {
				return config.P ? A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$terezka$elm_charts$Internal$Svg$withinChartArea(plane)
						]),
					_List_fromArray(
						[el])) : el;
			};
			var uppercaseStyle = config.T ? A2($elm$html$Html$Attributes$style, 'text-transform', 'uppercase') : A2($elm$html$Html$Attributes$style, '', '');
			var fontStyle = function () {
				var _v10 = config.O;
				if (!_v10.$) {
					var size_ = _v10.a;
					return A2(
						$elm$html$Html$Attributes$style,
						'font-size',
						$elm$core$String$fromInt(size_) + 'px');
				} else {
					return A2($elm$html$Html$Attributes$style, '', '');
				}
			}();
			var anchorStyle = function () {
				var _v6 = config.M;
				if (_v6.$ === 1) {
					return A2($elm$html$Html$Attributes$style, 'text-align', 'center');
				} else {
					switch (_v6.a) {
						case 0:
							var _v7 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'right');
						case 1:
							var _v8 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'left');
						default:
							var _v9 = _v6.a;
							return A2($elm$html$Html$Attributes$style, 'text-align', 'center');
					}
				}
			}();
			return withOverflowWrap(
				A4(
					$terezka$elm_charts$Internal$Svg$withAttrs,
					config.A,
					$elm$svg$Svg$foreignObject,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__label'),
							$elm$svg$Svg$Attributes$class('elm-charts__html-label'),
							$elm$svg$Svg$Attributes$width(
							$elm$core$String$fromFloat(ellipsis.da)),
							$elm$svg$Svg$Attributes$height(
							$elm$core$String$fromFloat(ellipsis.cv)),
							A6($terezka$elm_charts$Internal$Svg$position, plane, -config.S, point.m3, point.m4, xOffWithAnchor, config.I - 10)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'xmlns', 'http://www.w3.org/1999/xhtml'),
									A2($elm$html$Html$Attributes$style, 'white-space', 'nowrap'),
									A2($elm$html$Html$Attributes$style, 'overflow', 'hidden'),
									A2($elm$html$Html$Attributes$style, 'text-overflow', 'ellipsis'),
									A2($elm$html$Html$Attributes$style, 'height', '100%'),
									A2($elm$html$Html$Attributes$style, 'pointer-events', 'none'),
									A2($elm$html$Html$Attributes$style, 'color', config.jL),
									fontStyle,
									uppercaseStyle,
									anchorStyle
								]),
							inner)
						])));
		}
	});
var $terezka$elm_charts$Chart$Attributes$middle = function (b) {
	return b.gg + ((b.gc - b.gg) / 2);
};
var $terezka$elm_charts$Chart$Attributes$zero = function (b) {
	return A3($elm$core$Basics$clamp, b.gg, b.gc, 0);
};
var $terezka$elm_charts$Chart$xLabel = F2(
	function (edits, inner) {
		var toTickValues = F3(
			function (p, config, ts) {
				return (!config.E) ? ts : _Utils_update(
					ts,
					{
						aG: _Utils_ap(
							ts.aG,
							_List_fromArray(
								[config.m3]))
					});
			});
		var toConfig = function (p) {
			return A2(
				$terezka$elm_charts$Internal$Helpers$apply,
				edits,
				{
					M: $elm$core$Maybe$Nothing,
					A: _List_Nil,
					ap: 'white',
					ay: 0.1,
					jL: '#808BAB',
					N: $elm$core$Maybe$Nothing,
					D: false,
					O: $elm$core$Maybe$Nothing,
					E: false,
					P: false,
					S: 0,
					T: false,
					m3: $terezka$elm_charts$Chart$Attributes$middle(p.m3),
					H: 0,
					m4: $terezka$elm_charts$Chart$Attributes$zero(p.m4),
					I: 20
				});
		};
		return A3(
			$terezka$elm_charts$Chart$LabelElement,
			toConfig,
			toTickValues,
			F2(
				function (p, config) {
					var string = _Utils_eq(inner, _List_Nil) ? _List_fromArray(
						[
							$elm$svg$Svg$text(
							$elm$core$String$fromFloat(config.m3))
						]) : inner;
					return A4(
						$terezka$elm_charts$Internal$Svg$label,
						p,
						{
							M: config.M,
							A: config.A,
							ap: config.ap,
							ay: config.ay,
							jL: config.jL,
							N: config.N,
							O: config.O,
							P: config.P,
							S: config.S,
							T: config.T,
							H: config.H,
							I: config.D ? ((-config.I) + 10) : config.I
						},
						string,
						{m3: config.m3, m4: config.m4});
				}));
	});
var $terezka$elm_charts$Internal$Svg$End = 0;
var $terezka$elm_charts$Internal$Svg$Floats = {$: 0};
var $terezka$elm_charts$Chart$LabelsElement = F3(
	function (a, b, c) {
		return {$: 7, a: a, b: b, c: c};
	});
var $terezka$elm_charts$Internal$Svg$Start = 1;
var $terezka$elm_charts$Internal$Svg$defaultLabel = {M: $elm$core$Maybe$Nothing, A: _List_Nil, ap: 'white', ay: 0, jL: '#808BAB', N: $elm$core$Maybe$Nothing, O: $elm$core$Maybe$Nothing, P: false, S: 0, T: false, H: 0, I: 0};
var $terezka$intervals$Intervals$floats = function (amount) {
	if (!amount.$) {
		var number = amount.a;
		return A3($terezka$intervals$Intervals$values, true, true, number);
	} else {
		var number = amount.a;
		return A3($terezka$intervals$Intervals$values, true, false, number);
	}
};
var $terezka$elm_charts$Internal$Svg$floats = F2(
	function (i, b) {
		return A2(
			$terezka$intervals$Intervals$floats,
			$terezka$intervals$Intervals$around(i),
			{gc: b.gc, gg: b.gg});
	});
var $terezka$elm_charts$Chart$Svg$floats = $terezka$elm_charts$Internal$Svg$floats;
var $terezka$elm_charts$Internal$Svg$formatClock = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$hourMilitaryFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed
		]));
var $ryannhg$date_format$DateFormat$MillisecondFixed = {$: 35};
var $ryannhg$date_format$DateFormat$millisecondFixed = $ryannhg$date_format$DateFormat$MillisecondFixed;
var $ryannhg$date_format$DateFormat$SecondFixed = {$: 33};
var $ryannhg$date_format$DateFormat$secondFixed = $ryannhg$date_format$DateFormat$SecondFixed;
var $terezka$elm_charts$Internal$Svg$formatClockMillis = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$hourMilitaryFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$secondFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$millisecondFixed
		]));
var $terezka$elm_charts$Internal$Svg$formatClockSecond = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$hourMilitaryFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$minuteFixed,
			$ryannhg$date_format$DateFormat$text(':'),
			$ryannhg$date_format$DateFormat$secondFixed
		]));
var $ryannhg$date_format$DateFormat$MonthNumber = {$: 0};
var $ryannhg$date_format$DateFormat$monthNumber = $ryannhg$date_format$DateFormat$MonthNumber;
var $terezka$elm_charts$Internal$Svg$formatDate = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[
			$ryannhg$date_format$DateFormat$monthNumber,
			$ryannhg$date_format$DateFormat$text('/'),
			$ryannhg$date_format$DateFormat$dayOfMonthNumber
		]));
var $terezka$elm_charts$Internal$Svg$formatMonth = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[$ryannhg$date_format$DateFormat$monthNameAbbreviated]));
var $ryannhg$date_format$DateFormat$DayOfWeekNameFull = {$: 14};
var $ryannhg$date_format$DateFormat$dayOfWeekNameFull = $ryannhg$date_format$DateFormat$DayOfWeekNameFull;
var $terezka$elm_charts$Internal$Svg$formatWeekday = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[$ryannhg$date_format$DateFormat$dayOfWeekNameFull]));
var $ryannhg$date_format$DateFormat$YearNumber = {$: 16};
var $ryannhg$date_format$DateFormat$yearNumber = $ryannhg$date_format$DateFormat$YearNumber;
var $terezka$elm_charts$Internal$Svg$formatYear = $ryannhg$date_format$DateFormat$format(
	_List_fromArray(
		[$ryannhg$date_format$DateFormat$yearNumber]));
var $terezka$elm_charts$Internal$Svg$formatTime = F2(
	function (zone, time) {
		var _v0 = A2($elm$core$Maybe$withDefault, time.r8, time.nQ);
		switch (_v0) {
			case 0:
				return A2($terezka$elm_charts$Internal$Svg$formatClockMillis, zone, time.rS);
			case 1:
				return A2($terezka$elm_charts$Internal$Svg$formatClockSecond, zone, time.rS);
			case 2:
				return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.rS);
			case 3:
				return A2($terezka$elm_charts$Internal$Svg$formatClock, zone, time.rS);
			case 4:
				return (time.pU === 7) ? A2($terezka$elm_charts$Internal$Svg$formatWeekday, zone, time.rS) : A2($terezka$elm_charts$Internal$Svg$formatDate, zone, time.rS);
			case 5:
				return A2($terezka$elm_charts$Internal$Svg$formatMonth, zone, time.rS);
			default:
				return A2($terezka$elm_charts$Internal$Svg$formatYear, zone, time.rS);
		}
	});
var $terezka$elm_charts$Chart$Svg$formatTime = $terezka$elm_charts$Internal$Svg$formatTime;
var $terezka$intervals$Intervals$Day = 4;
var $terezka$intervals$Intervals$Hour = 3;
var $terezka$intervals$Intervals$Millisecond = 0;
var $terezka$intervals$Intervals$Minute = 2;
var $terezka$intervals$Intervals$Month = 5;
var $terezka$intervals$Intervals$Second = 1;
var $terezka$intervals$Intervals$Year = 6;
var $justinmimbs$time_extra$Time$Extra$Day = 11;
var $justinmimbs$date$Date$Days = 3;
var $justinmimbs$time_extra$Time$Extra$Millisecond = 15;
var $justinmimbs$time_extra$Time$Extra$Month = 2;
var $justinmimbs$date$Date$Months = 1;
var $justinmimbs$date$Date$RD = $elm$core$Basics$identity;
var $justinmimbs$date$Date$isLeapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $justinmimbs$date$Date$daysBeforeMonth = F2(
	function (y, m) {
		var leapDays = $justinmimbs$date$Date$isLeapYear(y) ? 1 : 0;
		switch (m) {
			case 0:
				return 0;
			case 1:
				return 31;
			case 2:
				return 59 + leapDays;
			case 3:
				return 90 + leapDays;
			case 4:
				return 120 + leapDays;
			case 5:
				return 151 + leapDays;
			case 6:
				return 181 + leapDays;
			case 7:
				return 212 + leapDays;
			case 8:
				return 243 + leapDays;
			case 9:
				return 273 + leapDays;
			case 10:
				return 304 + leapDays;
			default:
				return 334 + leapDays;
		}
	});
var $justinmimbs$date$Date$floorDiv = F2(
	function (a, b) {
		return $elm$core$Basics$floor(a / b);
	});
var $justinmimbs$date$Date$daysBeforeYear = function (y1) {
	var y = y1 - 1;
	var leapYears = (A2($justinmimbs$date$Date$floorDiv, y, 4) - A2($justinmimbs$date$Date$floorDiv, y, 100)) + A2($justinmimbs$date$Date$floorDiv, y, 400);
	return (365 * y) + leapYears;
};
var $justinmimbs$date$Date$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 0:
				return 31;
			case 1:
				return $justinmimbs$date$Date$isLeapYear(y) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $justinmimbs$date$Date$monthToNumber = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $justinmimbs$date$Date$numberToMonth = function (mn) {
	var _v0 = A2($elm$core$Basics$max, 1, mn);
	switch (_v0) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		default:
			return 11;
	}
};
var $justinmimbs$date$Date$toCalendarDateHelp = F3(
	function (y, m, d) {
		toCalendarDateHelp:
		while (true) {
			var monthDays = A2($justinmimbs$date$Date$daysInMonth, y, m);
			var mn = $justinmimbs$date$Date$monthToNumber(m);
			if ((mn < 12) && (_Utils_cmp(d, monthDays) > 0)) {
				var $temp$y = y,
					$temp$m = $justinmimbs$date$Date$numberToMonth(mn + 1),
					$temp$d = d - monthDays;
				y = $temp$y;
				m = $temp$m;
				d = $temp$d;
				continue toCalendarDateHelp;
			} else {
				return {jV: d, la: m, m5: y};
			}
		}
	});
var $justinmimbs$date$Date$divWithRemainder = F2(
	function (a, b) {
		return _Utils_Tuple2(
			A2($justinmimbs$date$Date$floorDiv, a, b),
			A2($elm$core$Basics$modBy, b, a));
	});
var $justinmimbs$date$Date$year = function (_v0) {
	var rd = _v0;
	var _v1 = A2($justinmimbs$date$Date$divWithRemainder, rd, 146097);
	var n400 = _v1.a;
	var r400 = _v1.b;
	var _v2 = A2($justinmimbs$date$Date$divWithRemainder, r400, 36524);
	var n100 = _v2.a;
	var r100 = _v2.b;
	var _v3 = A2($justinmimbs$date$Date$divWithRemainder, r100, 1461);
	var n4 = _v3.a;
	var r4 = _v3.b;
	var _v4 = A2($justinmimbs$date$Date$divWithRemainder, r4, 365);
	var n1 = _v4.a;
	var r1 = _v4.b;
	var n = (!r1) ? 0 : 1;
	return ((((n400 * 400) + (n100 * 100)) + (n4 * 4)) + n1) + n;
};
var $justinmimbs$date$Date$toOrdinalDate = function (_v0) {
	var rd = _v0;
	var y = $justinmimbs$date$Date$year(rd);
	return {
		il: rd - $justinmimbs$date$Date$daysBeforeYear(y),
		m5: y
	};
};
var $justinmimbs$date$Date$toCalendarDate = function (_v0) {
	var rd = _v0;
	var date = $justinmimbs$date$Date$toOrdinalDate(rd);
	return A3($justinmimbs$date$Date$toCalendarDateHelp, date.m5, 0, date.il);
};
var $justinmimbs$date$Date$add = F3(
	function (unit, n, _v0) {
		var rd = _v0;
		switch (unit) {
			case 0:
				return A3($justinmimbs$date$Date$add, 1, 12 * n, rd);
			case 1:
				var date = $justinmimbs$date$Date$toCalendarDate(rd);
				var wholeMonths = ((12 * (date.m5 - 1)) + ($justinmimbs$date$Date$monthToNumber(date.la) - 1)) + n;
				var m = $justinmimbs$date$Date$numberToMonth(
					A2($elm$core$Basics$modBy, 12, wholeMonths) + 1);
				var y = A2($justinmimbs$date$Date$floorDiv, wholeMonths, 12) + 1;
				return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A2(
					$elm$core$Basics$min,
					date.jV,
					A2($justinmimbs$date$Date$daysInMonth, y, m));
			case 2:
				return rd + (7 * n);
			default:
				return rd + n;
		}
	});
var $justinmimbs$date$Date$fromCalendarDate = F3(
	function (y, m, d) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + A3(
			$elm$core$Basics$clamp,
			1,
			A2($justinmimbs$date$Date$daysInMonth, y, m),
			d);
	});
var $justinmimbs$date$Date$fromPosix = F2(
	function (zone, posix) {
		return A3(
			$justinmimbs$date$Date$fromCalendarDate,
			A2($elm$time$Time$toYear, zone, posix),
			A2($elm$time$Time$toMonth, zone, posix),
			A2($elm$time$Time$toDay, zone, posix));
	});
var $justinmimbs$date$Date$toRataDie = function (_v0) {
	var rd = _v0;
	return rd;
};
var $justinmimbs$time_extra$Time$Extra$dateToMillis = function (date) {
	var daysSinceEpoch = $justinmimbs$date$Date$toRataDie(date) - 719163;
	return daysSinceEpoch * 86400000;
};
var $justinmimbs$time_extra$Time$Extra$timeFromClock = F4(
	function (hour, minute, second, millisecond) {
		return (((hour * 3600000) + (minute * 60000)) + (second * 1000)) + millisecond;
	});
var $justinmimbs$time_extra$Time$Extra$timeFromPosix = F2(
	function (zone, posix) {
		return A4(
			$justinmimbs$time_extra$Time$Extra$timeFromClock,
			A2($elm$time$Time$toHour, zone, posix),
			A2($elm$time$Time$toMinute, zone, posix),
			A2($elm$time$Time$toSecond, zone, posix),
			A2($elm$time$Time$toMillis, zone, posix));
	});
var $justinmimbs$time_extra$Time$Extra$toOffset = F2(
	function (zone, posix) {
		var millis = $elm$time$Time$posixToMillis(posix);
		var localMillis = $justinmimbs$time_extra$Time$Extra$dateToMillis(
			A2($justinmimbs$date$Date$fromPosix, zone, posix)) + A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix);
		return ((localMillis - millis) / 60000) | 0;
	});
var $justinmimbs$time_extra$Time$Extra$posixFromDateTime = F3(
	function (zone, date, time) {
		var millis = $justinmimbs$time_extra$Time$Extra$dateToMillis(date) + time;
		var offset0 = A2(
			$justinmimbs$time_extra$Time$Extra$toOffset,
			zone,
			$elm$time$Time$millisToPosix(millis));
		var posix1 = $elm$time$Time$millisToPosix(millis - (offset0 * 60000));
		var offset1 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix1);
		if (_Utils_eq(offset0, offset1)) {
			return posix1;
		} else {
			var posix2 = $elm$time$Time$millisToPosix(millis - (offset1 * 60000));
			var offset2 = A2($justinmimbs$time_extra$Time$Extra$toOffset, zone, posix2);
			return _Utils_eq(offset1, offset2) ? posix2 : posix1;
		}
	});
var $justinmimbs$time_extra$Time$Extra$add = F4(
	function (interval, n, zone, posix) {
		add:
		while (true) {
			switch (interval) {
				case 15:
					return $elm$time$Time$millisToPosix(
						$elm$time$Time$posixToMillis(posix) + n);
				case 14:
					var $temp$interval = 15,
						$temp$n = n * 1000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 13:
					var $temp$interval = 15,
						$temp$n = n * 60000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 12:
					var $temp$interval = 15,
						$temp$n = n * 3600000,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 11:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							3,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 2:
					return A3(
						$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
						zone,
						A3(
							$justinmimbs$date$Date$add,
							1,
							n,
							A2($justinmimbs$date$Date$fromPosix, zone, posix)),
						A2($justinmimbs$time_extra$Time$Extra$timeFromPosix, zone, posix));
				case 0:
					var $temp$interval = 2,
						$temp$n = n * 12,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 1:
					var $temp$interval = 2,
						$temp$n = n * 3,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				case 3:
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
				default:
					var weekday = interval;
					var $temp$interval = 11,
						$temp$n = n * 7,
						$temp$zone = zone,
						$temp$posix = posix;
					interval = $temp$interval;
					n = $temp$n;
					zone = $temp$zone;
					posix = $temp$posix;
					continue add;
			}
		}
	});
var $justinmimbs$time_extra$Time$Extra$Week = 3;
var $justinmimbs$date$Date$Day = 11;
var $justinmimbs$date$Date$Friday = 8;
var $justinmimbs$date$Date$Monday = 4;
var $justinmimbs$date$Date$Month = 2;
var $justinmimbs$date$Date$Quarter = 1;
var $justinmimbs$date$Date$Saturday = 9;
var $justinmimbs$date$Date$Sunday = 10;
var $justinmimbs$date$Date$Thursday = 7;
var $justinmimbs$date$Date$Tuesday = 5;
var $justinmimbs$date$Date$Wednesday = 6;
var $justinmimbs$date$Date$Week = 3;
var $justinmimbs$date$Date$Year = 0;
var $justinmimbs$date$Date$weekdayNumber = function (_v0) {
	var rd = _v0;
	var _v1 = A2($elm$core$Basics$modBy, 7, rd);
	if (!_v1) {
		return 7;
	} else {
		var n = _v1;
		return n;
	}
};
var $justinmimbs$date$Date$weekdayToNumber = function (wd) {
	switch (wd) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		default:
			return 7;
	}
};
var $justinmimbs$date$Date$daysSincePreviousWeekday = F2(
	function (wd, date) {
		return A2(
			$elm$core$Basics$modBy,
			7,
			($justinmimbs$date$Date$weekdayNumber(date) + 7) - $justinmimbs$date$Date$weekdayToNumber(wd));
	});
var $justinmimbs$date$Date$firstOfMonth = F2(
	function (y, m) {
		return ($justinmimbs$date$Date$daysBeforeYear(y) + A2($justinmimbs$date$Date$daysBeforeMonth, y, m)) + 1;
	});
var $justinmimbs$date$Date$firstOfYear = function (y) {
	return $justinmimbs$date$Date$daysBeforeYear(y) + 1;
};
var $justinmimbs$date$Date$month = A2(
	$elm$core$Basics$composeR,
	$justinmimbs$date$Date$toCalendarDate,
	function ($) {
		return $.la;
	});
var $justinmimbs$date$Date$monthToQuarter = function (m) {
	return (($justinmimbs$date$Date$monthToNumber(m) + 2) / 3) | 0;
};
var $justinmimbs$date$Date$quarter = A2($elm$core$Basics$composeR, $justinmimbs$date$Date$month, $justinmimbs$date$Date$monthToQuarter);
var $justinmimbs$date$Date$quarterToMonth = function (q) {
	return $justinmimbs$date$Date$numberToMonth((q * 3) - 2);
};
var $justinmimbs$date$Date$floor = F2(
	function (interval, date) {
		var rd = date;
		switch (interval) {
			case 0:
				return $justinmimbs$date$Date$firstOfYear(
					$justinmimbs$date$Date$year(date));
			case 1:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$quarterToMonth(
						$justinmimbs$date$Date$quarter(date)));
			case 2:
				return A2(
					$justinmimbs$date$Date$firstOfMonth,
					$justinmimbs$date$Date$year(date),
					$justinmimbs$date$Date$month(date));
			case 3:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 4:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 0, date);
			case 5:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 1, date);
			case 6:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 2, date);
			case 7:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 3, date);
			case 8:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 4, date);
			case 9:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 5, date);
			case 10:
				return rd - A2($justinmimbs$date$Date$daysSincePreviousWeekday, 6, date);
			default:
				return date;
		}
	});
var $justinmimbs$time_extra$Time$Extra$floorDate = F3(
	function (dateInterval, zone, posix) {
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A2(
				$justinmimbs$date$Date$floor,
				dateInterval,
				A2($justinmimbs$date$Date$fromPosix, zone, posix)),
			0);
	});
var $justinmimbs$time_extra$Time$Extra$floor = F3(
	function (interval, zone, posix) {
		switch (interval) {
			case 15:
				return posix;
			case 14:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						A2($elm$time$Time$toSecond, zone, posix),
						0));
			case 13:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						A2($elm$time$Time$toMinute, zone, posix),
						0,
						0));
			case 12:
				return A3(
					$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
					zone,
					A2($justinmimbs$date$Date$fromPosix, zone, posix),
					A4(
						$justinmimbs$time_extra$Time$Extra$timeFromClock,
						A2($elm$time$Time$toHour, zone, posix),
						0,
						0,
						0));
			case 11:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 11, zone, posix);
			case 2:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 2, zone, posix);
			case 0:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 0, zone, posix);
			case 1:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 1, zone, posix);
			case 3:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 3, zone, posix);
			case 4:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 4, zone, posix);
			case 5:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 5, zone, posix);
			case 6:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 6, zone, posix);
			case 7:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 7, zone, posix);
			case 8:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 8, zone, posix);
			case 9:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 9, zone, posix);
			default:
				return A3($justinmimbs$time_extra$Time$Extra$floorDate, 10, zone, posix);
		}
	});
var $justinmimbs$time_extra$Time$Extra$ceiling = F3(
	function (interval, zone, posix) {
		var floored = A3($justinmimbs$time_extra$Time$Extra$floor, interval, zone, posix);
		return _Utils_eq(floored, posix) ? posix : A4($justinmimbs$time_extra$Time$Extra$add, interval, 1, zone, floored);
	});
var $terezka$intervals$Intervals$Time$ceilingDay = F3(
	function (zone, mult, stamp) {
		return (mult === 7) ? A3($justinmimbs$time_extra$Time$Extra$ceiling, 3, zone, stamp) : A3($justinmimbs$time_extra$Time$Extra$ceiling, 11, zone, stamp);
	});
var $justinmimbs$time_extra$Time$Extra$Hour = 12;
var $justinmimbs$time_extra$Time$Extra$partsToPosix = F2(
	function (zone, _v0) {
		var year = _v0.m5;
		var month = _v0.la;
		var day = _v0.jV;
		var hour = _v0.hX;
		var minute = _v0.ib;
		var second = _v0.iH;
		var millisecond = _v0.ia;
		return A3(
			$justinmimbs$time_extra$Time$Extra$posixFromDateTime,
			zone,
			A3($justinmimbs$date$Date$fromCalendarDate, year, month, day),
			A4(
				$justinmimbs$time_extra$Time$Extra$timeFromClock,
				A3($elm$core$Basics$clamp, 0, 23, hour),
				A3($elm$core$Basics$clamp, 0, 59, minute),
				A3($elm$core$Basics$clamp, 0, 59, second),
				A3($elm$core$Basics$clamp, 0, 999, millisecond)));
	});
var $justinmimbs$time_extra$Time$Extra$posixToParts = F2(
	function (zone, posix) {
		return {
			jV: A2($elm$time$Time$toDay, zone, posix),
			hX: A2($elm$time$Time$toHour, zone, posix),
			ia: A2($elm$time$Time$toMillis, zone, posix),
			ib: A2($elm$time$Time$toMinute, zone, posix),
			la: A2($elm$time$Time$toMonth, zone, posix),
			iH: A2($elm$time$Time$toSecond, zone, posix),
			m5: A2($elm$time$Time$toYear, zone, posix)
		};
	});
var $terezka$intervals$Intervals$Time$ceilingHour = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 12, zone, stamp));
		var rem = parts.hX % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 12, mult - rem, zone, _new);
	});
var $justinmimbs$time_extra$Time$Extra$Minute = 13;
var $terezka$intervals$Intervals$Time$ceilingMinute = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 13, zone, stamp));
		var rem = parts.ib % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 13, mult - rem, zone, _new);
	});
var $terezka$intervals$Intervals$Time$intAsMonth = function (_int) {
	switch (_int) {
		case 1:
			return 0;
		case 2:
			return 1;
		case 3:
			return 2;
		case 4:
			return 3;
		case 5:
			return 4;
		case 6:
			return 5;
		case 7:
			return 6;
		case 8:
			return 7;
		case 9:
			return 8;
		case 10:
			return 9;
		case 11:
			return 10;
		case 12:
			return 11;
		default:
			return 11;
	}
};
var $terezka$intervals$Intervals$Time$monthAsInt = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $terezka$intervals$Intervals$Time$ceilingMonth = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 2, zone, stamp));
		var monthInt = $terezka$intervals$Intervals$Time$monthAsInt(parts.la);
		var rem = (monthInt - 1) % mult;
		var newMonth = (!rem) ? monthInt : ((monthInt - rem) + mult);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			(newMonth > 12) ? _Utils_update(
				parts,
				{
					la: $terezka$intervals$Intervals$Time$intAsMonth(newMonth - 12),
					m5: parts.m5 + 1
				}) : _Utils_update(
				parts,
				{
					la: $terezka$intervals$Intervals$Time$intAsMonth(newMonth)
				}));
	});
var $terezka$intervals$Intervals$Time$ceilingMs = F3(
	function (zone, mult, stamp) {
		var parts = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, stamp);
		var rem = parts.ia % mult;
		return (!rem) ? A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts) : A4($justinmimbs$time_extra$Time$Extra$add, 15, mult - rem, zone, stamp);
	});
var $justinmimbs$time_extra$Time$Extra$Second = 14;
var $terezka$intervals$Intervals$Time$ceilingSecond = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 14, zone, stamp));
		var rem = parts.iH % mult;
		var _new = A2($justinmimbs$time_extra$Time$Extra$partsToPosix, zone, parts);
		return (!rem) ? _new : A4($justinmimbs$time_extra$Time$Extra$add, 14, mult - rem, zone, _new);
	});
var $justinmimbs$time_extra$Time$Extra$Year = 0;
var $terezka$intervals$Intervals$Time$ceilingYear = F3(
	function (zone, mult, stamp) {
		var parts = A2(
			$justinmimbs$time_extra$Time$Extra$posixToParts,
			zone,
			A3($justinmimbs$time_extra$Time$Extra$ceiling, 0, zone, stamp));
		var rem = parts.m5 % mult;
		var newYear = (!rem) ? parts.m5 : ((parts.m5 - rem) + mult);
		return A2(
			$justinmimbs$time_extra$Time$Extra$partsToPosix,
			zone,
			_Utils_update(
				parts,
				{m5: newYear}));
	});
var $terezka$intervals$Intervals$Time$ceilingUnit = F3(
	function (zone, unit, mult) {
		switch (unit) {
			case 0:
				return A2($terezka$intervals$Intervals$Time$ceilingMs, zone, mult);
			case 1:
				return A2($terezka$intervals$Intervals$Time$ceilingSecond, zone, mult);
			case 2:
				return A2($terezka$intervals$Intervals$Time$ceilingMinute, zone, mult);
			case 3:
				return A2($terezka$intervals$Intervals$Time$ceilingHour, zone, mult);
			case 4:
				return A2($terezka$intervals$Intervals$Time$ceilingDay, zone, mult);
			case 5:
				return A2($terezka$intervals$Intervals$Time$ceilingMonth, zone, mult);
			default:
				return A2($terezka$intervals$Intervals$Time$ceilingYear, zone, mult);
		}
	});
var $terezka$intervals$Intervals$Time$Day = 4;
var $terezka$intervals$Intervals$Time$Hour = 3;
var $terezka$intervals$Intervals$Time$Millisecond = 0;
var $terezka$intervals$Intervals$Time$Minute = 2;
var $terezka$intervals$Intervals$Time$Month = 5;
var $terezka$intervals$Intervals$Time$Second = 1;
var $terezka$intervals$Intervals$Time$Year = 6;
var $terezka$intervals$Intervals$Time$getChange = F3(
	function (zone, a, b) {
		var bP = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b);
		var aP = A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a);
		return (!_Utils_eq(aP.m5, bP.m5)) ? 6 : ((!_Utils_eq(aP.la, bP.la)) ? 5 : ((!_Utils_eq(aP.jV, bP.jV)) ? 4 : ((!_Utils_eq(aP.hX, bP.hX)) ? 3 : ((!_Utils_eq(aP.ib, bP.ib)) ? 2 : ((!_Utils_eq(aP.iH, bP.iH)) ? 1 : 0)))));
	});
var $danhandrea$elm_time_extra$Util$isLeapYear = function (year) {
	return (!A2($elm$core$Basics$modBy, 400, year)) || ((!(!A2($elm$core$Basics$modBy, 100, year))) && (!A2($elm$core$Basics$modBy, 4, year)));
};
var $danhandrea$elm_time_extra$Month$days = F2(
	function (year, month) {
		switch (month) {
			case 0:
				return 31;
			case 1:
				return $danhandrea$elm_time_extra$Util$isLeapYear(year) ? 29 : 28;
			case 2:
				return 31;
			case 3:
				return 30;
			case 4:
				return 31;
			case 5:
				return 30;
			case 6:
				return 31;
			case 7:
				return 31;
			case 8:
				return 30;
			case 9:
				return 31;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $danhandrea$elm_time_extra$TimeExtra$daysInMonth = $danhandrea$elm_time_extra$Month$days;
var $terezka$intervals$Intervals$Time$toMs = $elm$time$Time$posixToMillis;
var $terezka$intervals$Intervals$Time$getDiff = F3(
	function (zone, a, b) {
		var _v0 = (_Utils_cmp(
			$terezka$intervals$Intervals$Time$toMs(a),
			$terezka$intervals$Intervals$Time$toMs(b)) < 0) ? _Utils_Tuple2(
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a),
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b)) : _Utils_Tuple2(
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, b),
			A2($justinmimbs$time_extra$Time$Extra$posixToParts, zone, a));
		var aP = _v0.a;
		var bP = _v0.b;
		var dMsX = bP.ia - aP.ia;
		var dMs = (dMsX < 0) ? (1000 + dMsX) : dMsX;
		var dSecondX = (bP.iH - aP.iH) + ((dMsX < 0) ? (-1) : 0);
		var dMinuteX = (bP.ib - aP.ib) + ((dSecondX < 0) ? (-1) : 0);
		var dHourX = (bP.hX - aP.hX) + ((dMinuteX < 0) ? (-1) : 0);
		var dDayX = (bP.jV - aP.jV) + ((dHourX < 0) ? (-1) : 0);
		var dDay = (dDayX < 0) ? (A2($danhandrea$elm_time_extra$TimeExtra$daysInMonth, bP.m5, bP.la) + dDayX) : dDayX;
		var dMonthX = ($terezka$intervals$Intervals$Time$monthAsInt(bP.la) - $terezka$intervals$Intervals$Time$monthAsInt(aP.la)) + ((dDayX < 0) ? (-1) : 0);
		var dMonth = (dMonthX < 0) ? (12 + dMonthX) : dMonthX;
		var dHour = (dHourX < 0) ? (24 + dHourX) : dHourX;
		var dMinute = (dMinuteX < 0) ? (60 + dMinuteX) : dMinuteX;
		var dSecond = (dSecondX < 0) ? (60 + dSecondX) : dSecondX;
		var dYearX = (bP.m5 - aP.m5) + ((dMonthX < 0) ? (-1) : 0);
		var dYear = (dYearX < 0) ? ($terezka$intervals$Intervals$Time$monthAsInt(bP.la) + dYearX) : dYearX;
		return {jV: dDay, hX: dHour, ia: dMs, ib: dMinute, la: dMonth, iH: dSecond, m5: dYear};
	});
var $terezka$intervals$Intervals$Time$oneSecond = 1000;
var $terezka$intervals$Intervals$Time$oneMinute = $terezka$intervals$Intervals$Time$oneSecond * 60;
var $terezka$intervals$Intervals$Time$oneHour = $terezka$intervals$Intervals$Time$oneMinute * 60;
var $terezka$intervals$Intervals$Time$oneDay = $terezka$intervals$Intervals$Time$oneHour * 24;
var $terezka$intervals$Intervals$Time$oneMs = 1;
var $terezka$intervals$Intervals$Time$getNumOfTicks = F5(
	function (zone, unit, mult, a, b) {
		var div = F2(
			function (n1, n2) {
				return $elm$core$Basics$floor(n1 / n2);
			});
		var timeDiff = function (ms) {
			var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
			return (_Utils_cmp(
				$terezka$intervals$Intervals$Time$toMs(ceiled),
				$terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(
				div,
				A2(
					div,
					$terezka$intervals$Intervals$Time$toMs(b) - $terezka$intervals$Intervals$Time$toMs(ceiled),
					ms),
				mult);
		};
		var diff = function (property) {
			var ceiled = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, a);
			return (_Utils_cmp(
				$terezka$intervals$Intervals$Time$toMs(ceiled),
				$terezka$intervals$Intervals$Time$toMs(b)) > 0) ? (-1) : A2(
				div,
				property(
					A3($terezka$intervals$Intervals$Time$getDiff, zone, ceiled, b)),
				mult);
		};
		switch (unit) {
			case 0:
				return timeDiff($terezka$intervals$Intervals$Time$oneMs) + 1;
			case 1:
				return timeDiff($terezka$intervals$Intervals$Time$oneSecond) + 1;
			case 2:
				return timeDiff($terezka$intervals$Intervals$Time$oneMinute) + 1;
			case 3:
				return timeDiff($terezka$intervals$Intervals$Time$oneHour) + 1;
			case 4:
				return timeDiff($terezka$intervals$Intervals$Time$oneDay) + 1;
			case 5:
				return diff(
					function (d) {
						return d.la + (d.m5 * 12);
					}) + 1;
			default:
				return diff(
					function ($) {
						return $.m5;
					}) + 1;
		}
	});
var $terezka$intervals$Intervals$Time$largerUnit = function (unit) {
	switch (unit) {
		case 0:
			return $elm$core$Maybe$Just(1);
		case 1:
			return $elm$core$Maybe$Just(2);
		case 2:
			return $elm$core$Maybe$Just(3);
		case 3:
			return $elm$core$Maybe$Just(4);
		case 4:
			return $elm$core$Maybe$Just(5);
		case 5:
			return $elm$core$Maybe$Just(6);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $terezka$intervals$Intervals$Time$niceMultiples = function (unit) {
	switch (unit) {
		case 0:
			return _List_fromArray(
				[1, 2, 5, 10, 20, 25, 50, 100, 200, 500]);
		case 1:
			return _List_fromArray(
				[1, 2, 5, 10, 15, 30]);
		case 2:
			return _List_fromArray(
				[1, 2, 5, 10, 15, 30]);
		case 3:
			return _List_fromArray(
				[1, 2, 3, 4, 6, 8, 12]);
		case 4:
			return _List_fromArray(
				[1, 2, 3, 7, 14]);
		case 5:
			return _List_fromArray(
				[1, 2, 3, 4, 6]);
		default:
			return _List_fromArray(
				[1, 2, 5, 10, 20, 25, 50, 100, 200, 500, 1000, 10000, 1000000, 10000000]);
	}
};
var $terezka$intervals$Intervals$Time$toBestUnit = F4(
	function (zone, amount, min, max) {
		var toNice = function (unit) {
			toNice:
			while (true) {
				var niceNums = $terezka$intervals$Intervals$Time$niceMultiples(unit);
				var maybeNiceNum = A2(
					$elm$core$List$filter,
					function (n) {
						return _Utils_cmp(
							A5($terezka$intervals$Intervals$Time$getNumOfTicks, zone, unit, n, min, max),
							amount) < 1;
					},
					niceNums);
				var div = F2(
					function (n1, n2) {
						return $elm$core$Basics$ceiling(n1 / n2);
					});
				var _v0 = $elm$core$List$head(maybeNiceNum);
				if (!_v0.$) {
					var niceNum = _v0.a;
					return _Utils_Tuple2(unit, niceNum);
				} else {
					var _v1 = $terezka$intervals$Intervals$Time$largerUnit(unit);
					if (!_v1.$) {
						var larger = _v1.a;
						var $temp$unit = larger;
						unit = $temp$unit;
						continue toNice;
					} else {
						return _Utils_Tuple2(6, 100000000);
					}
				}
			}
		};
		return toNice(0);
	});
var $terezka$intervals$Intervals$Time$toExtraUnit = function (unit) {
	switch (unit) {
		case 0:
			return 15;
		case 1:
			return 14;
		case 2:
			return 13;
		case 3:
			return 12;
		case 4:
			return 11;
		case 5:
			return 2;
		default:
			return 0;
	}
};
var $terezka$intervals$Intervals$Time$unitToInt = function (unit) {
	switch (unit) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		case 4:
			return 4;
		case 5:
			return 5;
		default:
			return 6;
	}
};
var $terezka$intervals$Intervals$Time$values = F4(
	function (zone, maxMmount, min, max) {
		var _v0 = A4($terezka$intervals$Intervals$Time$toBestUnit, zone, maxMmount, min, max);
		var unit = _v0.a;
		var mult = _v0.b;
		var amount = A5($terezka$intervals$Intervals$Time$getNumOfTicks, zone, unit, mult, min, max);
		var initial = A4($terezka$intervals$Intervals$Time$ceilingUnit, zone, unit, mult, min);
		var tUnit = $terezka$intervals$Intervals$Time$toExtraUnit(unit);
		var toTick = F3(
			function (x, timestamp, change) {
				return {
					nQ: (_Utils_cmp(
						$terezka$intervals$Intervals$Time$unitToInt(change),
						$terezka$intervals$Intervals$Time$unitToInt(unit)) > 0) ? $elm$core$Maybe$Just(change) : $elm$core$Maybe$Nothing,
					h0: !x,
					pU: mult,
					rS: timestamp,
					r8: unit,
					g3: zone
				};
			});
		var toTicks = F2(
			function (xs, acc) {
				toTicks:
				while (true) {
					if (xs.b) {
						var x = xs.a;
						var rest = xs.b;
						var prev = A4($justinmimbs$time_extra$Time$Extra$add, tUnit, (x - 1) * mult, zone, initial);
						var curr = A4($justinmimbs$time_extra$Time$Extra$add, tUnit, x * mult, zone, initial);
						var change = A3($terezka$intervals$Intervals$Time$getChange, zone, prev, curr);
						var $temp$xs = rest,
							$temp$acc = A2(
							$elm$core$List$cons,
							A3(toTick, x, curr, change),
							acc);
						xs = $temp$xs;
						acc = $temp$acc;
						continue toTicks;
					} else {
						return acc;
					}
				}
			});
		return $elm$core$List$reverse(
			A2(
				toTicks,
				A2($elm$core$List$range, 0, amount - 1),
				_List_Nil));
	});
var $terezka$intervals$Intervals$times = F3(
	function (zone, amount, range) {
		var toUnit = function (unit) {
			switch (unit) {
				case 0:
					return 0;
				case 1:
					return 1;
				case 2:
					return 2;
				case 3:
					return 3;
				case 4:
					return 4;
				case 5:
					return 5;
				default:
					return 6;
			}
		};
		var translateUnit = function (time) {
			return {
				nQ: A2($elm$core$Maybe$map, toUnit, time.nQ),
				h0: time.h0,
				pU: time.pU,
				rS: time.rS,
				r8: toUnit(time.r8),
				g3: time.g3
			};
		};
		var fromMs = function (ts) {
			return $elm$time$Time$millisToPosix(
				$elm$core$Basics$round(ts));
		};
		return A2(
			$elm$core$List$map,
			translateUnit,
			A4(
				$terezka$intervals$Intervals$Time$values,
				zone,
				amount,
				fromMs(range.gg),
				fromMs(range.gc)));
	});
var $terezka$elm_charts$Internal$Svg$times = function (zone) {
	return F2(
		function (i, b) {
			return A3(
				$terezka$intervals$Intervals$times,
				zone,
				i,
				{gc: b.gc, gg: b.gg});
		});
};
var $terezka$elm_charts$Chart$Svg$times = $terezka$elm_charts$Internal$Svg$times;
var $terezka$elm_charts$Chart$generateValues = F4(
	function (amount, tick, maybeFormat, axis) {
		var toTickValues = F2(
			function (toValue, toString) {
				return $elm$core$List$map(
					function (i) {
						return {
							h4: function () {
								if (!maybeFormat.$) {
									var formatter = maybeFormat.a;
									return formatter(
										toValue(i));
								} else {
									return toString(i);
								}
							}(),
							c5: toValue(i)
						};
					});
			});
		switch (tick.$) {
			case 0:
				return A3(
					toTickValues,
					$elm$core$Basics$identity,
					$elm$core$String$fromFloat,
					A3($terezka$elm_charts$Chart$Svg$generate, amount, $terezka$elm_charts$Chart$Svg$floats, axis));
			case 1:
				return A3(
					toTickValues,
					$elm$core$Basics$toFloat,
					$elm$core$String$fromInt,
					A3($terezka$elm_charts$Chart$Svg$generate, amount, $terezka$elm_charts$Chart$Svg$ints, axis));
			default:
				var zone = tick.a;
				return A3(
					toTickValues,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Basics$toFloat, $elm$time$Time$posixToMillis),
						function ($) {
							return $.rS;
						}),
					$terezka$elm_charts$Chart$Svg$formatTime(zone),
					A3(
						$terezka$elm_charts$Chart$Svg$generate,
						amount,
						$terezka$elm_charts$Chart$Svg$times(zone),
						axis));
		}
	});
var $terezka$elm_charts$Chart$yLabels = function (edits) {
	var toTicks = F2(
		function (p, config) {
			return A4(
				$terezka$elm_charts$Chart$generateValues,
				config.bd,
				config.bk,
				config.aN,
				A3(
					$elm$core$List$foldl,
					F2(
						function (f, y) {
							return f(y);
						}),
					p.m4,
					config.an));
		});
	var toTickValues = F3(
		function (p, config, ts) {
			return (!config.E) ? ts : _Utils_update(
				ts,
				{
					bb: _Utils_ap(
						ts.bb,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.c5;
							},
							A2(toTicks, p, config)))
				});
		});
	var toConfig = function (p) {
		return A2(
			$terezka$elm_charts$Internal$Helpers$apply,
			edits,
			{bd: 5, M: $elm$core$Maybe$Nothing, A: _List_Nil, jL: '#808BAB', N: $elm$core$Maybe$Nothing, D: false, O: $elm$core$Maybe$Nothing, aN: $elm$core$Maybe$Nothing, bk: $terezka$elm_charts$Internal$Svg$Floats, E: false, P: false, an: _List_Nil, R: $terezka$elm_charts$Chart$Attributes$zero, S: 0, T: false, H: -10, I: 3});
	};
	return A3(
		$terezka$elm_charts$Chart$LabelsElement,
		toConfig,
		toTickValues,
		F2(
			function (p, config) {
				var _default = $terezka$elm_charts$Internal$Svg$defaultLabel;
				var toLabel = function (item) {
					return A4(
						$terezka$elm_charts$Internal$Svg$label,
						p,
						_Utils_update(
							_default,
							{
								M: function () {
									var _v0 = config.M;
									if (_v0.$ === 1) {
										return $elm$core$Maybe$Just(
											config.D ? 1 : 0);
									} else {
										var anchor = _v0.a;
										return $elm$core$Maybe$Just(anchor);
									}
								}(),
								A: config.A,
								jL: config.jL,
								N: config.N,
								O: config.O,
								P: config.P,
								S: config.S,
								T: config.T,
								H: config.D ? (-config.H) : config.H,
								I: config.I
							}),
						_List_fromArray(
							[
								$elm$svg$Svg$text(item.h4)
							]),
						{
							m3: config.R(p.m3),
							m4: item.c5
						});
				};
				return A2(
					$elm$svg$Svg$g,
					_List_fromArray(
						[
							$elm$svg$Svg$Attributes$class('elm-charts__y-labels')
						]),
					A2(
						$elm$core$List$map,
						toLabel,
						A2(toTicks, p, config)));
			}));
};
var $author$project$Dashboards2$Chart$LineChart$view = F2(
	function (config, model) {
		var sortedData = A2(
			$elm$core$List$map,
			function (line) {
				return _Utils_update(
					line,
					{
						cl: A2(
							$elm$core$List$sortBy,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.fD;
								},
								A2($elm_community$maybe_extra$Maybe$Extra$unwrap, -1, $elm$time$Time$posixToMillis)),
							line.cl)
					});
			},
			config.cl);
		var isHoverOverIndex = function (index) {
			return A2(
				$elm$core$List$any,
				function (items) {
					return A2(
						$elm$core$List$any,
						A2(
							$elm$core$Basics$composeR,
							$terezka$elm_charts$Chart$Item$getData,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$first,
								$elm$core$Basics$eq(index))),
						$terezka$elm_charts$Chart$Item$getMembers(items));
				},
				model.fV);
		};
		var withGridIfHovered = function (index) {
			return ($elm$core$List$isEmpty(model.fV) || (!isHoverOverIndex(index))) ? $elm$core$Basics$identity : $elm$core$List$cons($terezka$elm_charts$Chart$Attributes$withGrid);
		};
		var formatMetricAxis = function (value) {
			var formatted = $author$project$Gwi$FormatNumber$formatNumber(value);
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				formatted,
				function (unit) {
					return _Utils_ap(formatted, unit);
				},
				config.g2);
		};
		var elementId = 'tooltip-' + config.mM;
		var dateToValue = function (date) {
			return $elm$time$Time$posixToMillis(date);
		};
		var dataIndexedDates = A3(
			$elm$core$List$foldl,
			F2(
				function (line, acc) {
					return ((!$elm$core$List$isEmpty(line.cl)) && ($elm$core$Dict$isEmpty(acc) || (_Utils_cmp(
						$elm$core$Dict$size(acc),
						$elm$core$List$length(line.cl)) < 0))) ? A3(
						$elm_community$list_extra$List$Extra$indexedFoldl,
						F2(
							function (index, item) {
								return A2(
									$elm$core$Dict$insert,
									index,
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, dateToValue, item.fD));
							}),
						acc,
						line.cl) : acc;
				}),
			$elm$core$Dict$empty,
			sortedData);
		var chartContent = A2(
			$elm$core$List$map,
			function (line) {
				var color = function () {
					var _v2 = line.cl;
					if (_v2.b) {
						var first = _v2.a;
						return $author$project$Palette$filtersColorToHex(first.jL);
					} else {
						return '';
					}
				}();
				return A3(
					$terezka$elm_charts$Chart$series,
					A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $elm$core$Basics$toFloat),
					_List_fromArray(
						[
							A3(
							$terezka$elm_charts$Chart$interpolated,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Tuple$second,
								function ($) {
									return $.c5;
								}),
							_List_fromArray(
								[
									$terezka$elm_charts$Chart$Attributes$color(color),
									$terezka$elm_charts$Chart$Attributes$width(4)
								]),
							_List_fromArray(
								[
									$terezka$elm_charts$Chart$Attributes$circle,
									$terezka$elm_charts$Chart$Attributes$size(10),
									$terezka$elm_charts$Chart$Attributes$borderWidth(1)
								]))
						]),
					A2($elm$core$List$indexedMap, $elm$core$Tuple$pair, line.cl));
			},
			sortedData);
		var addYearToXIfNeeded = F2(
			function (index, date) {
				return (!index) ? $elm$core$List$cons(
					A2(
						$terezka$elm_charts$Chart$xLabel,
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$x(index),
								$terezka$elm_charts$Chart$Attributes$fontSize(14),
								$terezka$elm_charts$Chart$Attributes$moveDown(14),
								$terezka$elm_charts$Chart$Attributes$borderWidth(1),
								$terezka$elm_charts$Chart$Attributes$border($author$project$Dashboards2$Chart$LineChart$fontColor)
							]),
						_List_fromArray(
							[
								$elm$svg$Svg$text(
								$elm$core$String$fromInt(
									A2($elm$time$Time$toYear, $elm$time$Time$utc, date)))
							]))) : $elm$core$Basics$identity;
			});
		return A2(
			$terezka$elm_charts$Chart$chart,
			_List_fromArray(
				[
					$terezka$elm_charts$Chart$Attributes$height(config.t.cv - 48),
					$terezka$elm_charts$Chart$Attributes$width(config.t.da),
					$terezka$elm_charts$Chart$Attributes$padding(
					{jy: 0, kY: 0, lQ: 0, mH: 32}),
					$terezka$elm_charts$Chart$Attributes$margin(
					{jy: 0, kY: 50, lQ: 16, mH: 32}),
					A2(
					$terezka$elm_charts$Chart$Events$onMouseMove,
					A2($elm$core$Basics$composeL, config.a, $elm$core$Basics$identity),
					$terezka$elm_charts$Chart$Events$getNearest($terezka$elm_charts$Chart$Item$stacks)),
					$terezka$elm_charts$Chart$Events$onMouseLeave(
					config.a(_List_Nil)),
					$terezka$elm_charts$Chart$Attributes$htmlAttrs(
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(elementId)
						]))
				]),
			_Utils_ap(
				_List_fromArray(
					[
						$terezka$elm_charts$Chart$yLabels(
						_List_fromArray(
							[
								$terezka$elm_charts$Chart$Attributes$withGrid,
								$terezka$elm_charts$Chart$Attributes$format(formatMetricAxis),
								$terezka$elm_charts$Chart$Attributes$fontSize(14),
								$terezka$elm_charts$Chart$Attributes$color($author$project$Dashboards2$Chart$LineChart$fontColor)
							])),
						A5(
						$terezka$elm_charts$Chart$generate,
						$elm$core$Dict$size(dataIndexedDates),
						$terezka$elm_charts$Chart$ints,
						function ($) {
							return $.m3;
						},
						_List_fromArray(
							[
								A2($terezka$elm_charts$Chart$Attributes$lowest, 0, $terezka$elm_charts$Chart$Attributes$exactly),
								A2(
								$terezka$elm_charts$Chart$Attributes$highest,
								$elm$core$Dict$size(dataIndexedDates) - 1,
								$terezka$elm_charts$Chart$Attributes$exactly)
							]),
						F2(
							function (_v0, _int) {
								var dateForIndex = A3(
									$elm$core$Basics$composeR,
									$elm$core$Basics$round,
									$elm$time$Time$millisToPosix,
									A2(
										$elm$core$Maybe$withDefault,
										0,
										A2($elm$core$Dict$get, _int, dataIndexedDates)));
								return A3(
									addYearToXIfNeeded,
									_int,
									dateForIndex,
									_List_fromArray(
										[
											A2(
											$terezka$elm_charts$Chart$xLabel,
											A2(
												withGridIfHovered,
												_int,
												_List_fromArray(
													[
														$terezka$elm_charts$Chart$Attributes$x(_int),
														$terezka$elm_charts$Chart$Attributes$fontSize(14),
														$terezka$elm_charts$Chart$Attributes$borderWidth(1),
														$terezka$elm_charts$Chart$Attributes$border($author$project$Dashboards2$Chart$LineChart$fontColor)
													])),
											_List_fromArray(
												[
													$elm$svg$Svg$text(
													$author$project$Dashboards2$Chart$LineChart$formatDate(dateForIndex))
												]))
										]));
							})),
						A2(
						$terezka$elm_charts$Chart$each,
						model.fV,
						F2(
							function (_v1, items) {
								var tooltipContent = A2(
									$zwilias$elm_html_string$Html$String$toString,
									0,
									A2(
										$zwilias$elm_html_string$Html$String$div,
										_List_fromArray(
											[
												$zwilias$elm_html_string$Html$String$Attributes$class(
												$GlobalWebIndex$class_namespaces$WeakCss$toString(
													A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip-container', config.fs)))
											]),
										_List_fromArray(
											[
												A2(
												$zwilias$elm_html_string$Html$String$h4,
												_List_fromArray(
													[
														$zwilias$elm_html_string$Html$String$Attributes$class(
														$GlobalWebIndex$class_namespaces$WeakCss$toString(
															A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip-header', config.fs)))
													]),
												_List_fromArray(
													[
														$zwilias$elm_html_string$Html$String$text(config.nw)
													])),
												A2(
												$zwilias$elm_html_string$Html$String$div,
												_List_Nil,
												A2(
													$elm$core$List$map,
													A2(
														$elm$core$Basics$composeR,
														$terezka$elm_charts$Chart$Item$getData,
														A2(
															$elm$core$Basics$composeR,
															$elm$core$Tuple$second,
															function (d3Point) {
																var formattedValue = A2(
																	$author$project$Gwi$FormatNumber$formatToDecimals,
																	{jY: 1, kU: false},
																	d3Point.c5);
																return A2(
																	$zwilias$elm_html_string$Html$String$div,
																	_List_fromArray(
																		[
																			$zwilias$elm_html_string$Html$String$Attributes$class(
																			$GlobalWebIndex$class_namespaces$WeakCss$toString(
																				A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip', config.fs))),
																			A2(
																			$zwilias$elm_html_string$Html$String$Attributes$attribute,
																			'style',
																			'--line-color:' + $author$project$Palette$filtersColorToHex(d3Point.jL))
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$zwilias$elm_html_string$Html$String$span,
																			_List_fromArray(
																				[
																					$zwilias$elm_html_string$Html$String$Attributes$class(
																					$GlobalWebIndex$class_namespaces$WeakCss$toString(
																						A2(
																							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																							_List_fromArray(
																								['tooltip', 'dot']),
																							config.fs)))
																				]),
																			_List_Nil),
																			A2(
																			$zwilias$elm_html_string$Html$String$span,
																			_List_fromArray(
																				[
																					$zwilias$elm_html_string$Html$String$Attributes$class(
																					$GlobalWebIndex$class_namespaces$WeakCss$toString(
																						A2(
																							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																							_List_fromArray(
																								['tooltip', 'name']),
																							config.fs)))
																				]),
																			_List_fromArray(
																				[
																					$zwilias$elm_html_string$Html$String$text(d3Point.ld)
																				])),
																			A2(
																			$zwilias$elm_html_string$Html$String$span,
																			_List_fromArray(
																				[
																					$zwilias$elm_html_string$Html$String$Attributes$class(
																					$GlobalWebIndex$class_namespaces$WeakCss$toString(
																						A2(
																							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																							_List_fromArray(
																								['tooltip', 'value']),
																							config.fs)))
																				]),
																			_List_fromArray(
																				[
																					$zwilias$elm_html_string$Html$String$text(
																					A3(
																						$elm_community$maybe_extra$Maybe$Extra$unwrap,
																						formattedValue,
																						function (unit) {
																							return _Utils_ap(formattedValue, unit);
																						},
																						config.g2))
																				]))
																		]));
															})),
													$terezka$elm_charts$Chart$Item$getMembers(items)))
											])));
								return _List_fromArray(
									[
										A4(
										$terezka$elm_charts$Chart$tooltip,
										items,
										_List_fromArray(
											[
												$terezka$elm_charts$Chart$Attributes$offset(0),
												$terezka$elm_charts$Chart$Attributes$noArrow,
												$terezka$elm_charts$Chart$Attributes$border('transparent'),
												$terezka$elm_charts$Chart$Attributes$background('transparent')
											]),
										_List_Nil,
										_List_fromArray(
											[
												A3(
												$elm$html$Html$node,
												'x-d3scription',
												_List_fromArray(
													[
														A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + elementId),
														A2($elm$html$Html$Attributes$attribute, 'content', tooltipContent)
													]),
												_List_Nil)
											]))
									]);
							}))
					]),
				chartContent));
	});
var $author$project$Dashboards2$Chart$GoToLegendPage = function (a) {
	return {$: 5, a: a};
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$listPrev = function (_v0) {
	var p = _v0.a;
	return $elm$core$List$reverse(p);
};
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $author$project$Icons$Platform2$doubleArrowsDown = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M15.1294 1.71216C15.4067 1.43486 15.4067 0.985272 15.1294 0.707974C14.8521 0.430675 14.4025 0.430675 14.1252 0.707974L8.00004 6.83318L1.87484 0.707974C1.59754 0.430675 1.14795 0.430675 0.87065 0.707974C0.593351 0.985272 0.593351 1.43486 0.87065 1.71216L7.49795 8.33946C7.77524 8.61676 8.22483 8.61676 8.50213 8.33946L15.1294 1.71216Z'),
				$author$project$Icons$Platform2$path('M13.8041 10.9902C14.0814 10.7129 14.0814 10.2633 13.8041 9.986C13.5268 9.7087 13.0772 9.7087 12.7999 9.986L8.00013 14.7857L3.20039 9.986C2.92309 9.7087 2.4735 9.7087 2.1962 9.986C1.9189 10.2633 1.9189 10.7129 2.1962 10.9902L7.49804 16.292C7.77534 16.5693 8.22493 16.5693 8.50223 16.292L13.8041 10.9902Z')
			])),
	e5: 16,
	mT: 0,
	mU: 0,
	e6: 16
};
var $author$project$Icons$Platform2$doubleArrowsUp = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M0.870572 15.2878C0.593273 15.5651 0.593273 16.0147 0.870572 16.292C1.14787 16.5693 1.59746 16.5693 1.87476 16.292L7.99996 10.1668L14.1252 16.292C14.4025 16.5693 14.8521 16.5693 15.1293 16.292C15.4066 16.0147 15.4066 15.5651 15.1293 15.2878L8.50205 8.66054C8.22476 8.38324 7.77517 8.38324 7.49787 8.66054L0.870572 15.2878Z'),
				$author$project$Icons$Platform2$path('M2.19594 6.00981C1.91864 6.28711 1.91864 6.7367 2.19594 7.014C2.47324 7.2913 2.92283 7.2913 3.20012 7.014L7.99987 2.21425L12.7996 7.014C13.0769 7.2913 13.5265 7.2913 13.8038 7.014C14.0811 6.7367 14.0811 6.28711 13.8038 6.00981L8.50196 0.707975C8.22466 0.430675 7.77507 0.430675 7.49777 0.707975L2.19594 6.00981Z')
			])),
	e5: 16,
	mT: 0,
	mU: 0,
	e6: 16
};
var $author$project$Icons$Platform2$navigationDown = {
	mr: $author$project$Icons$Platform2$path('M15.7293 3.77958C16.0911 4.15018 16.0901 4.75219 15.7271 5.12154L8.6283 12.3441C8.26826 12.7105 7.68772 12.7096 7.32877 12.3421L0.270873 5.11625C-0.0910416 4.74573 -0.0901737 4.14372 0.272762 3.77429C0.632787 3.40783 1.21343 3.40867 1.57244 3.77622L7.98157 10.3378L14.4296 3.77736C14.7897 3.41098 15.3703 3.41195 15.7293 3.77958Z'),
	e5: 16,
	mT: 0,
	mU: 0,
	e6: 16
};
var $author$project$Icons$Platform2$navigationUp = {
	mr: $author$project$Icons$Platform2$path('M0.270732 13.2204C-0.0911044 12.8498 -0.0901055 12.2478 0.272908 11.8785L7.3717 4.65587C7.73174 4.28954 8.31228 4.29045 8.67123 4.65794L15.7291 11.8837C16.091 12.2543 16.0902 12.8563 15.7272 13.2257C15.3672 13.5922 14.7866 13.5913 14.4276 13.2238L8.01843 6.66217L1.57041 13.2226C1.21031 13.589 0.629666 13.5881 0.270732 13.2204Z'),
	e5: 16,
	mT: 0,
	mU: 0,
	e6: 16
};
var $elm_community$html_extra$Html$Extra$viewIf = F2(
	function (condition, html) {
		return condition ? html : $elm_community$html_extra$Html$Extra$nothing;
	});
var $author$project$Dashboards2$Widget$Pagination$view_ = F2(
	function (_v0, config) {
		var showArrows = _v0.iM;
		var showAllpages = _v0.iL;
		var horizontal = _v0.hW;
		var prevPageBtnTooltip = 'Previous page';
		var prevIndex = A2($elm$core$Basics$max, 0, config.jS - 1);
		var nextPageBtnTooltip = 'Next page';
		var navButtonView = F4(
			function (tooltip, action, disabled, icon) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('disabled', disabled)
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'button', config.hi)),
							$elm$html$Html$Events$onClick(action),
							$elm$html$Html$Attributes$disabled(disabled),
							A2($elm$html$Html$Attributes$attribute, 'tooltip-content', tooltip)
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, icon)
						]));
			});
		var maxIndex = config.kZ - 1;
		var nextIndex = A2($elm$core$Basics$min, maxIndex, config.jS + 1);
		var rangeFrom = _Utils_eq(nextIndex, maxIndex) ? A2($elm$core$Basics$max, 0, nextIndex - 2) : prevIndex;
		var rangeTo = (!prevIndex) ? A2($elm$core$Basics$min, prevIndex + 2, maxIndex) : nextIndex;
		var visiblePages = showAllpages ? ((config.kZ > 1) ? A2($elm$core$List$range, 0, config.kZ - 1) : _List_Nil) : A2($elm$core$List$range, rangeFrom, rangeTo);
		var pagesView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'pages', config.hi)
				]),
			A2(
				$elm$core$List$map,
				function (index) {
					return A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'active',
										_Utils_eq(index, config.jS))
									]),
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['pages', 'page']),
									config.hi)),
								$elm$html$Html$Events$onClick(
								config.kn(index))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$elm$core$String$fromInt(index + 1))
							]));
				},
				visiblePages));
		var lastPageBtnTooltip = 'Last page';
		var goToStart = config.kn(0);
		var goToPrevPageAction = config.kn(prevIndex);
		var goToNextPageAction = config.kn(nextIndex);
		var goToEnd = config.kn(maxIndex);
		var firstPageBtnTooltip = 'First page';
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			config.kZ > 1,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2('horizontal', horizontal)
							]),
						config.hi)
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						showArrows,
						A4(navButtonView, firstPageBtnTooltip, goToStart, !config.jS, $author$project$Icons$Platform2$doubleArrowsUp)),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						showArrows,
						A4(navButtonView, prevPageBtnTooltip, goToPrevPageAction, !config.jS, $author$project$Icons$Platform2$navigationUp)),
						pagesView,
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						showArrows,
						A4(
							navButtonView,
							nextPageBtnTooltip,
							goToNextPageAction,
							_Utils_eq(config.jS, maxIndex),
							$author$project$Icons$Platform2$navigationDown)),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						showArrows,
						A4(
							navButtonView,
							lastPageBtnTooltip,
							goToEnd,
							_Utils_eq(config.jS, maxIndex),
							$author$project$Icons$Platform2$doubleArrowsDown))
					])));
	});
var $author$project$Dashboards2$Widget$Pagination$view = $author$project$Dashboards2$Widget$Pagination$view_(
	{hW: false, iL: false, iM: true});
var $author$project$Dashboards2$Chart$viewAttributeNamesPagination = F2(
	function (config, d3Data) {
		var mClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'pagination', $author$project$Dashboards2$Chart$moduleClass);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						['show-over']),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'pagination-wrapper', $author$project$Dashboards2$Chart$moduleClass))
				]),
			_List_fromArray(
				[
					$author$project$Dashboards2$Widget$Pagination$view(
					{
						hi: mClass,
						jS: $elm$core$List$length(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$listPrev(d3Data)),
						kn: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$GoToLegendPage),
						kZ: $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$length(d3Data)
					})
				]));
	});
var $author$project$Dashboards2$Chart$GoToPage = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Chart$viewPagination_ = F2(
	function (config, maybeZipper) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewMaybe,
			function (zipper) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'pagination-wrapper', $author$project$Dashboards2$Chart$moduleClass)
						]),
					_List_fromArray(
						[
							$author$project$Dashboards2$Widget$Pagination$view(
							{
								hi: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'pagination', $author$project$Dashboards2$Chart$moduleClass),
								jS: $elm$core$List$length(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$listPrev(zipper)),
								kn: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$GoToPage),
								kZ: $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$length(zipper)
							})
						]));
			},
			maybeZipper);
	});
var $author$project$Dashboards2$Chart$viewPagination = F2(
	function (config, wrappedZipper) {
		switch (wrappedZipper.$) {
			case 0:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 1:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 2:
				return $elm_community$html_extra$Html$Extra$nothing;
			default:
				var maybeZipper = wrappedZipper.a;
				return A2($author$project$Dashboards2$Chart$viewPagination_, config, maybeZipper);
		}
	});
var $author$project$Dashboards2$Chart$HorizontalBarChartMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Dashboards2$Chart$MouseHoverD3Point = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Dashboards2$Chart$MouseLeaveD3Point = {$: 10};
var $author$project$Dashboards2$Chart$TrackTooltipShown = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboards2$Chart$VerticalBarChartMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$D3Charts$Dashboards2$toTooltipItem = F2(
	function (getLabel, point) {
		return {
			jL: point.jL,
			h4: getLabel(point),
			c5: point.c5
		};
	});
var $zwilias$elm_html_string$Html$String$header = $zwilias$elm_html_string$Html$String$node('header');
var $zwilias$elm_html_string$Html$String$ul = $zwilias$elm_html_string$Html$String$node('ul');
var $zwilias$elm_html_string$Html$String$i = $zwilias$elm_html_string$Html$String$node('i');
var $zwilias$elm_html_string$Html$String$li = $zwilias$elm_html_string$Html$String$node('li');
var $zwilias$elm_html_string$Html$Types$Style = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $zwilias$elm_html_string$Html$String$Attributes$style = $zwilias$elm_html_string$Html$Types$Style;
var $author$project$D3Charts$Dashboards2$viewTooltipItem = F2(
	function (metric, _v0) {
		var value = _v0.c5;
		var color = _v0.jL;
		var label = _v0.h4;
		return A2(
			$zwilias$elm_html_string$Html$String$li,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$zwilias$elm_html_string$Html$String$i,
					_List_fromArray(
						[
							$zwilias$elm_html_string$Html$String$Attributes$class('circle'),
							A2(
							$zwilias$elm_html_string$Html$String$Attributes$style,
							'background-color',
							$author$project$Palette$filtersColorToHex(color))
						]),
					_List_Nil),
					A2(
					$zwilias$elm_html_string$Html$String$span,
					_List_fromArray(
						[
							$zwilias$elm_html_string$Html$String$Attributes$class('label')
						]),
					_List_fromArray(
						[
							$zwilias$elm_html_string$Html$String$text(label)
						])),
					A2(
					$zwilias$elm_html_string$Html$String$span,
					_List_fromArray(
						[
							$zwilias$elm_html_string$Html$String$Attributes$class('value'),
							A2(
							$zwilias$elm_html_string$Html$String$Attributes$style,
							'color',
							$author$project$Palette$filtersColorToHex(color))
						]),
					_List_fromArray(
						[
							$zwilias$elm_html_string$Html$String$text(
							A2($author$project$D3Charts$Dashboards2$formatDatapoint, metric, value))
						]))
				]));
	});
var $author$project$D3Charts$Dashboards2$viewTooltip = F3(
	function (metric, name, items) {
		return A2(
			$zwilias$elm_html_string$Html$String$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$zwilias$elm_html_string$Html$String$header,
					_List_fromArray(
						[
							$zwilias$elm_html_string$Html$String$Attributes$class('tip-header')
						]),
					_List_fromArray(
						[
							$zwilias$elm_html_string$Html$String$text(name)
						])),
					A2(
					$zwilias$elm_html_string$Html$String$ul,
					_List_fromArray(
						[
							$zwilias$elm_html_string$Html$String$Attributes$class('tip-body')
						]),
					A2(
						$elm$core$List$map,
						$author$project$D3Charts$Dashboards2$viewTooltipItem(metric),
						items))
				]));
	});
var $author$project$D3Charts$Dashboards2$audienceScopedGroupPopupContent = F2(
	function (metric, group) {
		return A2(
			$zwilias$elm_html_string$Html$String$toString,
			0,
			A3(
				$author$project$D3Charts$Dashboards2$viewTooltip,
				metric,
				group.ld,
				A2(
					$elm$core$List$map,
					$author$project$D3Charts$Dashboards2$toTooltipItem(
						function ($) {
							return $.ld;
						}),
					group.cl)));
	});
var $author$project$D3Charts$Dashboards2$datapointScopedGroupPopupContent = F2(
	function (metric, group) {
		return A2(
			$zwilias$elm_html_string$Html$String$toString,
			0,
			A3(
				$author$project$D3Charts$Dashboards2$viewTooltip,
				metric,
				group.ld,
				A2(
					$elm$core$List$map,
					$author$project$D3Charts$Dashboards2$toTooltipItem(
						function ($) {
							return $.eP;
						}),
					group.cl)));
	});
var $author$project$D3Charts$Dashboards2$audienceScopedPointPopupContent = F3(
	function (metric, d3data, point) {
		return A2(
			$zwilias$elm_html_string$Html$String$toString,
			0,
			A3(
				$author$project$D3Charts$Dashboards2$viewTooltip,
				metric,
				point.ld,
				A2(
					$elm$core$List$map,
					$author$project$D3Charts$Dashboards2$toTooltipItem(
						function ($) {
							return $.eP;
						}),
					A2(
						$elm$core$List$filterMap,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.cl;
							},
							$elm_community$list_extra$List$Extra$find(
								function (dataItem) {
									return _Utils_eq(dataItem.ld, point.ld);
								})),
						d3data))));
	});
var $author$project$D3Charts$Dashboards2$datapointScopedPointPopupContent = F2(
	function (metric, point) {
		return A2(
			$zwilias$elm_html_string$Html$String$toString,
			0,
			A3(
				$author$project$D3Charts$Dashboards2$viewTooltip,
				metric,
				point.ld,
				_List_fromArray(
					[
						A2(
						$author$project$D3Charts$Dashboards2$toTooltipItem,
						function ($) {
							return $.eP;
						},
						point)
					])));
	});
var $elm$json$Json$Encode$float = _Json_wrap;
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$D3Charts$Dashboards2$timeSeriesPointPopupContent = F3(
	function (metric, d3data, point) {
		return A2(
			$zwilias$elm_html_string$Html$String$toString,
			0,
			A3(
				$author$project$D3Charts$Dashboards2$viewTooltip,
				metric,
				point.eP,
				A2(
					$elm$core$List$map,
					$author$project$D3Charts$Dashboards2$toTooltipItem(
						function ($) {
							return $.ld;
						}),
					A2(
						$elm$core$List$filterMap,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.cl;
							},
							$elm_community$list_extra$List$Extra$find(
								function (dataItem) {
									return _Utils_eq(dataItem.fD, point.fD);
								})),
						d3data))));
	});
var $author$project$D3Charts$Dashboards2$encodeD3Point = F4(
	function (chartType, metric, data, point) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'color',
						$elm$json$Json$Encode$string(
							$author$project$Palette$filtersColorToHex(point.jL))),
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(point.ld)),
						_Utils_Tuple2(
						'value',
						$elm$json$Json$Encode$float(point.c5))
					]),
				function () {
					var _v0 = $author$project$D3Charts$Dashboards$ChartType$shape(chartType);
					switch (_v0) {
						case 0:
							return _List_Nil;
						case 1:
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'popupContent',
									$elm$json$Json$Encode$string(
										A2($author$project$D3Charts$Dashboards2$datapointScopedPointPopupContent, metric, point)))
								]);
						case 2:
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'popupContent',
									$elm$json$Json$Encode$string(
										A3($author$project$D3Charts$Dashboards2$audienceScopedPointPopupContent, metric, data, point)))
								]);
						default:
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'date',
									A2(
										$elm_community$json_extra$Json$Encode$Extra$maybe,
										A2($elm$core$Basics$composeL, $elm$json$Json$Encode$int, $elm$time$Time$posixToMillis),
										point.fD)),
									_Utils_Tuple2(
									'popupContent',
									$elm$json$Json$Encode$string(
										A3($author$project$D3Charts$Dashboards2$timeSeriesPointPopupContent, metric, data, point)))
								]);
					}
				}()));
	});
var $author$project$D3Charts$Dashboards2$encodeD3Group = F4(
	function (chartType, metric, data, group) {
		return $elm$json$Json$Encode$object(
			_Utils_ap(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'name',
						$elm$json$Json$Encode$string(group.ld)),
						_Utils_Tuple2(
						'data',
						A2(
							$elm$json$Json$Encode$list,
							A3($author$project$D3Charts$Dashboards2$encodeD3Point, chartType, metric, data),
							group.cl))
					]),
				function () {
					var _v0 = $author$project$D3Charts$Dashboards$ChartType$shape(chartType);
					switch (_v0) {
						case 0:
							return _List_Nil;
						case 1:
							return _List_fromArray(
								[
									_Utils_Tuple2(
									'popupContent',
									$elm$json$Json$Encode$string(
										A2($author$project$D3Charts$Dashboards2$datapointScopedGroupPopupContent, metric, group)))
								]);
						case 2:
							return $elm_community$maybe_extra$Maybe$Extra$values(
								_List_fromArray(
									[
										$elm$core$Maybe$Just(
										_Utils_Tuple2(
											'popupContent',
											$elm$json$Json$Encode$string(
												A2($author$project$D3Charts$Dashboards2$audienceScopedGroupPopupContent, metric, group)))),
										A2(
										$elm$core$Maybe$map,
										function (color) {
											return _Utils_Tuple2(
												'color',
												$elm$json$Json$Encode$string(
													$author$project$Palette$filtersColorToHex(color)));
										},
										group.jL)
									]));
						default:
							return _List_Nil;
					}
				}()));
	});
var $author$project$D3Charts$Dashboards2$encodeD3Data = F3(
	function (chartType, metric, data) {
		return A2(
			$elm$json$Json$Encode$list,
			A3($author$project$D3Charts$Dashboards2$encodeD3Group, chartType, metric, data),
			data);
	});
var $author$project$D3Charts$Dashboards2$encodeScaleMaxes = function (maxes) {
	switch (maxes.$) {
		case 0:
			var n = maxes.a;
			return $elm$json$Json$Encode$float(n);
		case 1:
			var n = maxes.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'x',
						$elm$json$Json$Encode$float(n))
					]));
		case 2:
			var n = maxes.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'y',
						$elm$json$Json$Encode$float(n))
					]));
		default:
			return $elm$json$Json$Encode$null;
	}
};
var $author$project$D3Charts$Dashboards2$None = {$: 3};
var $author$project$D3Charts$Dashboards2$Scalar = function (a) {
	return {$: 0, a: a};
};
var $author$project$D3Charts$Dashboards2$X = function (a) {
	return {$: 1, a: a};
};
var $author$project$D3Charts$Dashboards2$Y = function (a) {
	return {$: 2, a: a};
};
var $author$project$D3Charts$Dashboards2$scaleMaxes = F3(
	function (metric, chartType, maybeMaximum) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$D3Charts$Dashboards2$None,
			A2(
				$elm$core$Maybe$map,
				function (max) {
					var _v0 = _Utils_Tuple2(metric, chartType);
					_v0$9:
					while (true) {
						switch (_v0.b) {
							case 7:
								switch (_v0.a) {
									case 0:
										var _v3 = _v0.a;
										var _v4 = _v0.b;
										return $author$project$D3Charts$Dashboards2$Scalar(100);
									case 1:
										var _v7 = _v0.a;
										var _v8 = _v0.b;
										return $author$project$D3Charts$Dashboards2$Scalar(100);
									default:
										break _v0$9;
								}
							case 11:
								var _v9 = _v0.b;
								return $author$project$D3Charts$Dashboards2$Y(max);
							case 3:
								var _v10 = _v0.b;
								return $author$project$D3Charts$Dashboards2$X(max);
							case 1:
								var _v11 = _v0.b;
								return $author$project$D3Charts$Dashboards2$X(max);
							case 6:
								var _v12 = _v0.b;
								return $author$project$D3Charts$Dashboards2$X(max);
							case 8:
								switch (_v0.a) {
									case 0:
										var _v1 = _v0.a;
										var _v2 = _v0.b;
										return $author$project$D3Charts$Dashboards2$Scalar(100);
									case 1:
										var _v5 = _v0.a;
										var _v6 = _v0.b;
										return $author$project$D3Charts$Dashboards2$Scalar(100);
									default:
										var _v13 = _v0.b;
										return $author$project$D3Charts$Dashboards2$Scalar(max);
								}
							default:
								break _v0$9;
						}
					}
					return $author$project$D3Charts$Dashboards2$None;
				},
				maybeMaximum));
	});
var $author$project$Dashboards2$Chart$showTooltipDecoder = A2($elm$json$Json$Decode$field, 'detail', $elm$json$Json$Decode$string);
var $author$project$CoolTip$NormalShownWhenEllipsis = function (a) {
	return {$: 3, a: a};
};
var $author$project$CoolTip$Top = 0;
var $turboMaCk$non_empty_list_alias$List$NonEmpty$cons = F2(
	function (a, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return _Utils_Tuple2(
			a,
			A2($elm$core$List$cons, h, t));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$append = F2(
	function (ne1, ne2) {
		var _v0 = $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(ne2);
		if (!_v0.b) {
			return ne1;
		} else {
			return A3($turboMaCk$non_empty_list_alias$List$NonEmpty$foldr, $turboMaCk$non_empty_list_alias$List$NonEmpty$cons, ne2, ne1);
		}
	});
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ColorContrast$hexToRgb = function (hex) {
	var shorthandColorRegex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		A2(
			$elm$regex$Regex$fromStringWith,
			{jA: true, lc: false},
			'^#?([a-f\\d])([a-f\\d])([a-f\\d])$'));
	var parseColorRegex = A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		A2(
			$elm$regex$Regex$fromStringWith,
			{jA: true, lc: false},
			'^#?([a-f\\d]{2})([a-f\\d]{2})([a-f\\d]{2})$'));
	var longHex = A3(
		$elm$regex$Regex$replace,
		shorthandColorRegex,
		function (_v3) {
			var submatches = _v3.mo;
			return '#' + $elm$core$String$concat(
				A2(
					$elm$core$List$map,
					A2(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'',
						function (s) {
							return _Utils_ap(s, s);
						}),
					submatches));
		},
		hex);
	var intRGBValues = A2(
		$elm$core$List$filterMap,
		function (match) {
			return A2(
				$elm$core$Maybe$andThen,
				$elm$core$Result$toMaybe,
				A2($elm$core$Maybe$map, $rtfeldman$elm_hex$Hex$fromString, match));
		},
		A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			function ($) {
				return $.mo;
			},
			$elm$core$List$head(
				A2(
					$elm$regex$Regex$find,
					parseColorRegex,
					$elm$core$String$toLower(longHex)))));
	if ((intRGBValues.b && intRGBValues.b.b) && intRGBValues.b.b.b) {
		var r = intRGBValues.a;
		var _v1 = intRGBValues.b;
		var g = _v1.a;
		var _v2 = _v1.b;
		var b = _v2.a;
		return $elm$core$Maybe$Just(
			{hd: b, hS: g, iy: r});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$ColorContrast$luminance = function (_v0) {
	var red = _v0.iy;
	var green = _v0.hS;
	var blue = _v0.hd;
	var magicForColor = function (c) {
		var v = c / 255;
		return (v <= 0.03928) ? (v / 12.92) : A2($elm$core$Basics$pow, (v + 0.055) / 1.055, 2.4);
	};
	return ((magicForColor(red) * 0.2126) + (magicForColor(green) * 0.7152)) + (magicForColor(blue) * 0.0722);
};
var $author$project$ColorContrast$getRatio = F2(
	function (color1, color2) {
		return A3(
			$elm$core$Maybe$map2,
			F2(
				function (rgb1, rgb2) {
					var color2Luminance = $author$project$ColorContrast$luminance(rgb2);
					var color1Luminance = $author$project$ColorContrast$luminance(rgb1);
					return (_Utils_cmp(color1Luminance, color2Luminance) > 0) ? ((color2Luminance + 0.05) / (color1Luminance + 0.05)) : ((color1Luminance + 0.05) / (color2Luminance + 0.05));
				}),
			$author$project$ColorContrast$hexToRgb(color1),
			$author$project$ColorContrast$hexToRgb(color2));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$sortHelper = F2(
	function (f, ne) {
		var _v0 = f(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(ne));
		if (_v0.b) {
			var h = _v0.a;
			var t = _v0.b;
			return _Utils_Tuple2(h, t);
		} else {
			return ne;
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$sortBy = function (f) {
	return $turboMaCk$non_empty_list_alias$List$NonEmpty$sortHelper(
		$elm$core$List$sortBy(f));
};
var $author$project$ColorContrast$getHighestRatio = F2(
	function (color1, colorOptions) {
		return $turboMaCk$non_empty_list_alias$List$NonEmpty$head(
			A2(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$sortBy,
				$elm$core$Tuple$first,
				A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
					function (color2) {
						return _Utils_Tuple2(
							A2(
								$elm$core$Maybe$withDefault,
								0,
								A2($author$project$ColorContrast$getRatio, color1, color2)),
							color2);
					},
					colorOptions))).b;
	});
var $author$project$Dashboards2$Chart$GwiChart$groupByAudienceTooltipContent = F2(
	function (config, group) {
		return A2(
			$zwilias$elm_html_string$Html$String$toString,
			0,
			A2(
				$zwilias$elm_html_string$Html$String$div,
				_List_fromArray(
					[
						$zwilias$elm_html_string$Html$String$Attributes$class(
						$GlobalWebIndex$class_namespaces$WeakCss$toString(
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip-container', config.fs)))
					]),
				_List_fromArray(
					[
						A2(
						$zwilias$elm_html_string$Html$String$h4,
						_List_fromArray(
							[
								$zwilias$elm_html_string$Html$String$Attributes$class(
								'group-by-audience ' + $GlobalWebIndex$class_namespaces$WeakCss$toString(
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip-header', config.fs)))
							]),
						_List_fromArray(
							[
								$zwilias$elm_html_string$Html$String$text(group.ld)
							])),
						A2(
						$zwilias$elm_html_string$Html$String$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (d3Point) {
								var formattedValue = A2(
									$author$project$Gwi$FormatNumber$formatToDecimals,
									{jY: 1, kU: false},
									d3Point.c5);
								return A2(
									$zwilias$elm_html_string$Html$String$div,
									_List_fromArray(
										[
											$zwilias$elm_html_string$Html$String$Attributes$class(
											$GlobalWebIndex$class_namespaces$WeakCss$toString(
												A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip', config.fs))),
											A2(
											$zwilias$elm_html_string$Html$String$Attributes$attribute,
											'style',
											'--line-color:' + $author$project$Palette$filtersColorToHex(d3Point.jL))
										]),
									_List_fromArray(
										[
											A2(
											$zwilias$elm_html_string$Html$String$span,
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$Attributes$class(
													$GlobalWebIndex$class_namespaces$WeakCss$toString(
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['tooltip', 'dot-container']),
															config.fs)))
												]),
											_List_fromArray(
												[
													A2(
													$zwilias$elm_html_string$Html$String$span,
													_List_fromArray(
														[
															$zwilias$elm_html_string$Html$String$Attributes$class(
															$GlobalWebIndex$class_namespaces$WeakCss$toString(
																A2(
																	$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																	_List_fromArray(
																		['tooltip', 'dot']),
																	config.fs)))
														]),
													_List_Nil)
												])),
											A2(
											$zwilias$elm_html_string$Html$String$span,
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$Attributes$class(
													$GlobalWebIndex$class_namespaces$WeakCss$toString(
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['tooltip', 'name']),
															config.fs)))
												]),
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$text(d3Point.ld)
												])),
											A2(
											$zwilias$elm_html_string$Html$String$span,
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$Attributes$class(
													$GlobalWebIndex$class_namespaces$WeakCss$toString(
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['tooltip', 'value']),
															config.fs)))
												]),
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$text(
													A3(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														formattedValue,
														function (unit) {
															return _Utils_ap(formattedValue, unit);
														},
														config.g2))
												]))
										]));
							},
							group.cl))
					])));
	});
var $author$project$Dashboards2$Chart$GwiChart$tooltipContent = F2(
	function (config, group) {
		return A2(
			$zwilias$elm_html_string$Html$String$toString,
			0,
			A2(
				$zwilias$elm_html_string$Html$String$div,
				_List_fromArray(
					[
						$zwilias$elm_html_string$Html$String$Attributes$class(
						$GlobalWebIndex$class_namespaces$WeakCss$toString(
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip-container', config.fs)))
					]),
				_List_fromArray(
					[
						A2(
						$zwilias$elm_html_string$Html$String$h4,
						_List_fromArray(
							[
								$zwilias$elm_html_string$Html$String$Attributes$class(
								$GlobalWebIndex$class_namespaces$WeakCss$toString(
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip-header', config.fs)))
							]),
						_List_fromArray(
							[
								$zwilias$elm_html_string$Html$String$text(group.ld)
							])),
						A2(
						$zwilias$elm_html_string$Html$String$div,
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (d3Point) {
								var formattedValue = A2(
									$author$project$Gwi$FormatNumber$formatToDecimals,
									{jY: 1, kU: false},
									d3Point.c5);
								return A2(
									$zwilias$elm_html_string$Html$String$div,
									_List_fromArray(
										[
											$zwilias$elm_html_string$Html$String$Attributes$class(
											$GlobalWebIndex$class_namespaces$WeakCss$toString(
												A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'tooltip', config.fs))),
											A2(
											$zwilias$elm_html_string$Html$String$Attributes$attribute,
											'style',
											'--line-color:' + $author$project$Palette$filtersColorToHex(d3Point.jL))
										]),
									_List_fromArray(
										[
											A2(
											$zwilias$elm_html_string$Html$String$span,
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$Attributes$class(
													$GlobalWebIndex$class_namespaces$WeakCss$toString(
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['tooltip', 'dot-container']),
															config.fs)))
												]),
											_List_fromArray(
												[
													A2(
													$zwilias$elm_html_string$Html$String$span,
													_List_fromArray(
														[
															$zwilias$elm_html_string$Html$String$Attributes$class(
															$GlobalWebIndex$class_namespaces$WeakCss$toString(
																A2(
																	$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																	_List_fromArray(
																		['tooltip', 'dot']),
																	config.fs)))
														]),
													_List_Nil)
												])),
											A2(
											$zwilias$elm_html_string$Html$String$span,
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$Attributes$class(
													$GlobalWebIndex$class_namespaces$WeakCss$toString(
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['tooltip', 'name']),
															config.fs)))
												]),
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$text(d3Point.eP)
												])),
											A2(
											$zwilias$elm_html_string$Html$String$span,
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$Attributes$class(
													$GlobalWebIndex$class_namespaces$WeakCss$toString(
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['tooltip', 'value']),
															config.fs)))
												]),
											_List_fromArray(
												[
													$zwilias$elm_html_string$Html$String$text(
													A3(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														formattedValue,
														function (unit) {
															return _Utils_ap(formattedValue, unit);
														},
														config.g2))
												]))
										]));
							},
							group.cl))
					])));
	});
var $author$project$CoolTip$Platform2$p2Class = $elm$html$Html$Attributes$class('p2');
var $elm_community$html_extra$Html$Attributes$Extra$attributeMaybe = function (fn) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(fn),
		$elm$core$Maybe$withDefault($elm_community$html_extra$Html$Attributes$Extra$empty));
};
var $author$project$CoolTip$positionToClass = function (position) {
	switch (position) {
		case 2:
			return 'topleft';
		case 0:
			return 'top';
		case 1:
			return 'topright';
		case 4:
			return 'right';
		case 7:
			return 'bottomright';
		case 5:
			return 'bottom';
		case 6:
			return 'bottomleft';
		case 3:
			return 'left';
		default:
			return 'center';
	}
};
var $author$project$CoolTip$view = function (_v0) {
	var offset = _v0.lm;
	var type_ = _v0.mL;
	var position = _v0.lB;
	var tooltipHtml = _v0.mF;
	var wrapperAttributes = _v0.m2;
	var tooltipAttributes = _v0.mE;
	var targetAttributes = _v0.mt;
	var targetHtml = _v0.mu;
	return A3(
		$elm$html$Html$node,
		'x-cooltip',
		A2(
			$elm$core$List$cons,
			A2(
				$elm_community$html_extra$Html$Attributes$Extra$attributeMaybe,
				function (offset_) {
					return A2(
						$elm$html$Html$Attributes$attribute,
						'offset',
						$elm$core$String$fromInt(offset_));
				},
				offset),
			A2(
				$elm$core$List$cons,
				function () {
					switch (type_.$) {
						case 0:
							return $elm_community$html_extra$Html$Attributes$Extra$empty;
						case 3:
							var selector = type_.a;
							return A2($elm$html$Html$Attributes$attribute, 'show-when-ellipsis', selector);
						case 1:
							var selector = type_.a;
							return A2($elm$html$Html$Attributes$attribute, 'relative-ancestor-selector', selector);
						default:
							return A2($elm$html$Html$Attributes$attribute, 'global', 'true');
					}
				}(),
				wrapperAttributes)),
		_List_fromArray(
			[
				A3($elm$html$Html$node, 'x-cooltip-target', targetAttributes, targetHtml),
				A3(
				$elm$html$Html$node,
				'x-cooltip-tooltip',
				A2(
					$elm$core$List$cons,
					$elm$html$Html$Attributes$class(
						$author$project$CoolTip$positionToClass(position)),
					tooltipAttributes),
				_List_fromArray(
					[tooltipHtml]))
			]));
};
var $author$project$CoolTip$Platform2$view = function (config) {
	return $author$project$CoolTip$view(
		_Utils_update(
			config,
			{
				mt: A2($elm$core$List$cons, $author$project$CoolTip$Platform2$p2Class, config.mt),
				mE: A2($elm$core$List$cons, $author$project$CoolTip$Platform2$p2Class, config.mE)
			}));
};
var $elm_community$html_extra$Html$Extra$viewIfLazy = F2(
	function (condition, htmlF) {
		return condition ? htmlF(0) : $elm_community$html_extra$Html$Extra$nothing;
	});
var $author$project$Dashboards2$Chart$DonutChart$view = function (config) {
	var spaceBetweenSegments = 1;
	var segmentElementSelector = function (index) {
		return 'donut-chart-segment-tooltip-' + ($elm$core$String$fromInt(index) + ('_' + config.mM));
	};
	var legendLabelElementId = function (index) {
		return 'donut-chart-legend-tooltip-' + ($elm$core$String$fromInt(index) + ('--' + config.mM));
	};
	var legendContainerElementId = 'donut-chart-legend-tooltip-scroll-container--' + config.mM;
	var groupedByAudience = A2(
		$author$project$Gwi$List$groupBy,
		function ($) {
			return $.ld;
		},
		A2(
			$author$project$Gwi$List$fastConcatMap,
			function ($) {
				return $.cl;
			},
			config.cl));
	var navigationView = function (_v10) {
		var tooltipView = F3(
			function (index, items, key) {
				return A3(
					$elm$html$Html$node,
					'x-d3scription',
					_List_fromArray(
						[
							A2(
							$elm$html$Html$Attributes$attribute,
							'target-selector',
							'.' + segmentElementSelector(index)),
							A2(
							$elm$html$Html$Attributes$attribute,
							'reinit-trigger',
							$author$project$Data$Metric$toString(config.dB)),
							A2(
							$elm$html$Html$Attributes$attribute,
							'content',
							A2(
								$author$project$Dashboards2$Chart$GwiChart$tooltipContent,
								config,
								{
									jL: $elm$core$Maybe$Nothing,
									cl: $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(items),
									ld: key
								}))
						]),
					_List_Nil);
			});
		return ((config.bO.da > 1) || (config.bO.cv > 1)) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['donuts-group', 'donuts-navigation']),
					config.fs)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['donuts-group', 'donuts-navigation', 'scroll']),
							config.fs),
							$elm$html$Html$Attributes$id(legendContainerElementId)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['donuts-group', 'donuts-navigation', 'wrapper']),
									config.fs)
								]),
							A2(
								$elm$core$List$indexedMap,
								F2(
									function (index, _v7) {
										var items = _v7.f2;
										var key = _v7.h3;
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$withStates,
													_List_fromArray(
														[
															_Utils_Tuple2(
															'active',
															_Utils_eq(
																$elm$core$Maybe$Just(key),
																config.bc)),
															_Utils_Tuple2(
															segmentElementSelector(index),
															true)
														]),
													A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['donuts-group', 'donuts-navigation', 'item']),
														config.fs)),
													$elm$html$Html$Events$onMouseEnter(
													A2(config.o9, $elm$core$Maybe$Nothing, key)),
													$elm$html$Html$Events$onMouseLeave(config.pD),
													$elm$html$Html$Attributes$id(
													legendLabelElementId(index))
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
															_List_fromArray(
																[
																	'colors-' + $elm$core$String$fromInt(
																	$turboMaCk$non_empty_list_alias$List$NonEmpty$length(items))
																]),
															A2(
																$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																_List_fromArray(
																	['donuts-group', 'donuts-navigation', 'item', 'color-points']),
																config.fs))
														]),
													A2(
														$elm$core$List$map,
														function (_v8) {
															var color = _v8.jL;
															return A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		A2(
																		$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																		_List_fromArray(
																			['donuts-group', 'donuts-navigation', 'item', 'color-point']),
																		config.fs),
																		$author$project$Gwi$Html$Attributes$cssVars(
																		_List_fromArray(
																			[
																				_Utils_Tuple2(
																				'--point-color',
																				$author$project$Palette$filtersColorToHex(color))
																			]))
																	]),
																_List_Nil);
														},
														$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(items))),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['donuts-group', 'donuts-navigation', 'item', 'label']),
															config.fs)
														]),
													_List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	A2(
																	$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																	_List_fromArray(
																		['donuts-group', 'donuts-navigation', 'item', 'label', 'visible']),
																	config.fs)
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(key)
																]))
														])),
													A3(tooltipView, index, items, key)
												]));
									}),
								groupedByAudience))
						]))
				])) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$style, 'display', 'none')
				]),
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (index, _v9) {
						var items = _v9.f2;
						var key = _v9.h3;
						return A3(tooltipView, index, items, key);
					}),
				groupedByAudience));
	};
	var segmentSelectorsForTooltip = A3(
		$elm_community$list_extra$List$Extra$indexedFoldl,
		F2(
			function (index, _v6) {
				var key = _v6.h3;
				return A2(
					$elm$core$Dict$insert,
					key,
					segmentElementSelector(index));
			}),
		$elm$core$Dict$empty,
		groupedByAudience);
	var formatMetricAxis = function (value) {
		var formatted = A2(
			$author$project$Gwi$FormatNumber$formatToDecimals,
			{jY: 1, kU: false},
			value);
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			formatted,
			function (unit) {
				return _Utils_ap(formatted, unit);
			},
			config.g2);
	};
	var floatToPx = function (v) {
		return $elm$core$String$fromFloat(v) + 'px';
	};
	var elementId = 'donut-chart-tooltip-' + config.mM;
	var chartThicknessInPercentage = 24;
	var calculateCoordinatesForAngle = F2(
		function (radius, β) {
			var c = radius + 0.5;
			if (β < 90) {
				var α = 90 - β;
				var b = c * $elm$core$Basics$sin(
					$elm$core$Basics$degrees(β));
				var x = $elm$core$String$fromFloat(50 + b);
				var a = c * $elm$core$Basics$sin(
					$elm$core$Basics$degrees(α));
				var y = $elm$core$String$fromFloat(50 - a);
				return _Utils_Tuple2(x, y);
			} else {
				if ((90 <= β) && (β < 180)) {
					var α = 90 - (β - 90);
					var b = (c + 1) * $elm$core$Basics$sin(
						$elm$core$Basics$degrees(β - 90));
					var y = $elm$core$String$fromFloat(50 + b);
					var a = (c + 1) * $elm$core$Basics$sin(
						$elm$core$Basics$degrees(α));
					var x = $elm$core$String$fromFloat(50 + a);
					return _Utils_Tuple2(x, y);
				} else {
					if ((180 <= β) && (β < 270)) {
						var α = 90 - (β - 180);
						var b = c * $elm$core$Basics$sin(
							$elm$core$Basics$degrees(β - 180));
						var x = $elm$core$String$fromFloat(50 - b);
						var a = c * $elm$core$Basics$sin(
							$elm$core$Basics$degrees(α));
						var y = $elm$core$String$fromFloat(50 + a);
						return _Utils_Tuple2(x, y);
					} else {
						var α = 90 - (β - 270);
						var b = c * $elm$core$Basics$sin(
							$elm$core$Basics$degrees(β - 270));
						var y = $elm$core$String$fromFloat(50 - b);
						var a = c * $elm$core$Basics$sin(
							$elm$core$Basics$degrees(α));
						var x = $elm$core$String$fromFloat(50 - a);
						return _Utils_Tuple2(x, y);
					}
				}
			}
		});
	var calculateClipPath = F2(
		function (startAngle, endAngle) {
			var pointsToString = function (_v5) {
				var x = _v5.a;
				var y = _v5.b;
				return x + ('% ' + (y + '%'));
			};
			var startPoint = pointsToString(
				A2(calculateCoordinatesForAngle, 50, startAngle));
			var extraPointsCount = $elm$core$Basics$floor((endAngle - startAngle) / 5);
			var extraPoints = A2(
				$elm$core$List$map,
				A2(
					$elm$core$Basics$composeR,
					calculateCoordinatesForAngle(50),
					pointsToString),
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Basics$toFloat,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Basics$mul(5),
							$elm$core$Basics$add(startAngle))),
					A2($elm$core$List$range, 1, extraPointsCount)));
			var endPoint = pointsToString(
				A2(calculateCoordinatesForAngle, 50, endAngle));
			var allPoints = A2(
				$elm$core$String$join,
				', ',
				A2(
					$elm$core$List$cons,
					startPoint,
					_Utils_ap(
						extraPoints,
						_List_fromArray(
							[endPoint, '50% 50%']))));
			return 'polygon(' + (allPoints + ')');
		});
	var audiencesCount = $elm$core$List$length(config.cl);
	var showValuesInSegmentsForThisSize = function () {
		var _v4 = _Utils_Tuple3(audiencesCount, config.bO.da, config.bO.cv);
		_v4$8:
		while (true) {
			switch (_v4.c) {
				case 1:
					switch (_v4.b) {
						case 1:
							if (_v4.a === 1) {
								return true;
							} else {
								return false;
							}
						case 2:
							if (_v4.a === 1) {
								return true;
							} else {
								return false;
							}
						case 3:
							if (_v4.a === 4) {
								return false;
							} else {
								return true;
							}
						default:
							break _v4$8;
					}
				case 2:
					if (_v4.b === 1) {
						if (_v4.a === 1) {
							return true;
						} else {
							return false;
						}
					} else {
						break _v4$8;
					}
				default:
					break _v4$8;
			}
		}
		return true;
	}();
	var segmentView = F6(
		function (donutClass, groupSum, tooManyAttributes, index, segment, _v3) {
			var offset = _v3.a;
			var acc = _v3.b;
			var β = (groupSum > 0) ? ((360 / groupSum) * segment.c5) : 0;
			var valueRadius = 50 - (chartThicknessInPercentage / 2);
			var valueAngle = offset + (β / 2);
			var tooSmallForValue = function () {
				var _v2 = _Utils_Tuple3(
					config.bO.da,
					config.bO.cv,
					$elm$core$List$length(config.cl));
				_v2$7:
				while (true) {
					switch (_v2.b) {
						case 1:
							if (_v2.c === 1) {
								return β < 20;
							} else {
								break _v2$7;
							}
						case 2:
							switch (_v2.a) {
								case 2:
									if (_v2.c === 1) {
										return β < 15;
									} else {
										break _v2$7;
									}
								case 4:
									if (_v2.c === 1) {
										return β < 15;
									} else {
										return β < 20;
									}
								case 3:
									if (_v2.c === 1) {
										return β < 15;
									} else {
										return β < 20;
									}
								default:
									if (_v2.c === 1) {
										return β < 20;
									} else {
										break _v2$7;
									}
							}
						default:
							break _v2$7;
					}
				}
				return β < 25;
			}();
			var segmentValue = A2(
				$author$project$Gwi$FormatNumber$formatToDecimals,
				{jY: 1, kU: false},
				segment.c5);
			var segmentSelector = A2($elm$core$Dict$get, segment.ld, segmentSelectorsForTooltip);
			var segmentColor = $author$project$Palette$filtersColorToHex(segment.jL);
			var scrollToElements = $elm$core$Maybe$Just(
				{
					j5: legendLabelElementId(index),
					lV: legendContainerElementId
				});
			var possibleValueColors = A2(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$append,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton('#000000'),
				$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton('#ffffff'));
			var valueColor = A2($author$project$ColorContrast$getHighestRatio, segmentColor, possibleValueColors);
			var clipPath = A2(calculateClipPath, offset, (offset + β) - spaceBetweenSegments);
			var canValueFit = ($elm$core$String$length(
				A3($elm$core$String$replace, '.', '', segmentValue)) < 6) || (!(((45 < valueAngle) && (valueAngle < 135)) || ((225 < valueAngle) && (valueAngle < 315))));
			var showValuesInSegments = showValuesInSegmentsForThisSize && (canValueFit && ((!tooSmallForValue) && (!tooManyAttributes)));
			var _v0 = A2(calculateCoordinatesForAngle, valueRadius, valueAngle);
			var leftValuePos = _v0.a;
			var topValuePos = _v0.b;
			return _Utils_Tuple2(
				offset + β,
				_Utils_ap(
					acc,
					_List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							β > 0,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'active',
												_Utils_eq(
													$elm$core$Maybe$Just(segment.ld),
													config.bc)),
												_Utils_Tuple2(
												'opaque',
												(!_Utils_eq(
													$elm$core$Maybe$Just(segment.ld),
													config.bc)) && $elm_community$maybe_extra$Maybe$Extra$isJust(config.bc)),
												_Utils_Tuple2(
												A2($elm$core$Maybe$withDefault, '', segmentSelector),
												$elm_community$maybe_extra$Maybe$Extra$isJust(segmentSelector))
											]),
										A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'segment', donutClass)),
										$author$project$Gwi$Html$Attributes$cssVars(
										_List_fromArray(
											[
												_Utils_Tuple2('--segment-color', segmentColor),
												_Utils_Tuple2('--segment-clip', clipPath),
												_Utils_Tuple2(
												'--segment-beta',
												$elm$core$String$fromFloat(β) + 'deg'),
												_Utils_Tuple2(
												'--segment-rotate',
												$elm$core$String$fromFloat(offset) + 'deg')
											])),
										$elm$html$Html$Events$onMouseEnter(
										A2(config.o9, scrollToElements, segment.ld)),
										$elm$html$Html$Events$onMouseLeave(config.pD)
									]),
								_List_Nil)),
							A2(
							$elm_community$html_extra$Html$Extra$viewIfLazy,
							showValuesInSegments,
							function (_v1) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$withStates,
											_List_fromArray(
												[
													_Utils_Tuple2(
													A2($elm$core$Maybe$withDefault, '', segmentSelector),
													$elm_community$maybe_extra$Maybe$Extra$isJust(segmentSelector))
												]),
											A2(
												$GlobalWebIndex$class_namespaces$WeakCss$addMany,
												_List_fromArray(
													['segment', 'value']),
												donutClass)),
											$elm$html$Html$Events$onMouseEnter(
											A2(config.o9, scrollToElements, segment.ld)),
											$elm$html$Html$Events$onMouseLeave(config.pD),
											A2(
											$elm$html$Html$Attributes$attribute,
											'value',
											$elm$core$String$fromFloat(segment.c5)),
											$author$project$Gwi$Html$Attributes$cssVars(
											_List_fromArray(
												[
													_Utils_Tuple2('--value-color', valueColor),
													_Utils_Tuple2('--left-value-position', leftValuePos + '%'),
													_Utils_Tuple2('--top-value-position', topValuePos + '%')
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(segmentValue)
										]));
							})
						])));
		});
	var donutView = F2(
		function (index, group) {
			var tooManyAttributes = $elm$core$List$length(group.cl) > 10;
			var showCenterTotalLabel = !(((audiencesCount >= 3) && (((config.bO.da <= 2) && (config.bO.cv === 1)) || ((config.bO.da === 1) && (config.bO.cv === 2)))) || ((audiencesCount >= 2) && ((config.bO.da === 1) && (config.bO.cv === 2))));
			var groupSum = $elm$core$List$sum(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.c5;
					},
					group.cl));
			var donutHoverTooltipElementId = 'donut-chart-group-donut-tooltip-' + ($elm$core$String$fromInt(index) + ('--' + config.mM));
			var donutElementId = 'donut-chart-group-donut-element-' + ($elm$core$String$fromInt(index) + ('--' + config.mM));
			var donutClass = A2(
				$GlobalWebIndex$class_namespaces$WeakCss$addMany,
				_List_fromArray(
					['donuts-group', 'donut']),
				config.fs);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
						_List_fromArray(
							[
								'donut-chart-' + $elm$core$String$fromInt(index)
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['donuts-group', 'donut-wrapper']),
							config.fs))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('zero-value', !groupSum)
									]),
								donutClass),
								$elm$html$Html$Attributes$id(donutElementId)
							]),
						_Utils_ap(
							A3(
								$elm_community$list_extra$List$Extra$indexedFoldl,
								A3(segmentView, donutClass, groupSum, tooManyAttributes),
								_Utils_Tuple2(0, _List_Nil),
								group.cl).b,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['center']),
											donutClass),
											$author$project$Gwi$Html$Attributes$cssVars(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'--chart-thickness',
													$elm$core$String$fromFloat(chartThicknessInPercentage) + '%')
												])),
											$elm$html$Html$Attributes$id(donutHoverTooltipElementId)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['center', 'content']),
													donutClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm_community$html_extra$Html$Extra$viewIf,
													showCenterTotalLabel,
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['center', 'label']),
																donutClass)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Total')
															]))),
													$elm$html$Html$text(
													formatMetricAxis(groupSum))
												]))
										]))
								]))),
						A3(
						$elm$html$Html$node,
						'x-resize-observer',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + donutElementId),
								A2($elm$html$Html$Attributes$attribute, 'propagate-values-to-css', 'true'),
								A2($elm$html$Html$Attributes$style, 'display', 'none')
							]),
						_List_Nil),
						$author$project$CoolTip$Platform2$view(
						{
							lm: $elm$core$Maybe$Nothing,
							lB: 0,
							mt: _List_Nil,
							mu: _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'label', donutClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(group.ld)
										]))
								]),
							mE: _List_Nil,
							mF: $elm$html$Html$text(group.ld),
							mL: $author$project$CoolTip$NormalShownWhenEllipsis(
								'.' + $GlobalWebIndex$class_namespaces$WeakCss$toString(
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'label', donutClass))),
							m2: _List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nest,
									'tooltip',
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'label', donutClass))
								])
						}),
						A3(
						$elm$html$Html$node,
						'x-d3scription',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + donutHoverTooltipElementId),
								A2(
								$elm$html$Html$Attributes$attribute,
								'content',
								A2($author$project$Dashboards2$Chart$GwiChart$groupByAudienceTooltipContent, config, group))
							]),
						_List_Nil)
					]));
		});
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				$GlobalWebIndex$class_namespaces$WeakCss$toClass(config.fs),
				$author$project$Gwi$Html$Attributes$cssVars(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'--chart-width',
						floatToPx(config.t.da)),
						_Utils_Tuple2(
						'--chart-height',
						floatToPx(config.t.cv)),
						_Utils_Tuple2(
						'--chart-count',
						$elm$core$String$fromInt(
							$elm$core$List$length(config.cl)))
					])),
				$elm$html$Html$Attributes$id(elementId)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
						_List_fromArray(
							[
								'charts-count-' + $elm$core$String$fromInt(
								$elm$core$List$length(config.cl))
							]),
						A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'donuts-group', config.fs))
					]),
				function (l) {
					return _Utils_ap(
						l,
						_List_fromArray(
							[
								navigationView(0)
							]));
				}(
					A2($elm$core$List$indexedMap, donutView, config.cl)))
			]));
};
var $author$project$Dashboards2$Chart$GwiChart$GroupMouseEnter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Chart$GwiChart$GroupMouseLeave = {$: 1};
var $author$project$Dashboards2$Chart$HorizontalBarChart$view = F2(
	function (config, model) {
		var globalMaxValue = function () {
			var _v0 = config.hR;
			if (!_v0.$) {
				var value = _v0.a;
				return value;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					config.t.da,
					$elm$core$List$maximum(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.c5;
							},
							A2(
								$author$project$Gwi$List$fastConcatMap,
								function ($) {
									return $.cl;
								},
								config.cl))));
			}
		}();
		var getValueWidth = function (value) {
			var v = (!value) ? 0 : ((value / globalMaxValue) * 100);
			return $elm$core$String$fromFloat(v) + '%';
		};
		var formatMetricAxis = function (value) {
			var formatted = A2(
				$author$project$Gwi$FormatNumber$formatToDecimals,
				{jY: 1, kU: false},
				value);
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				formatted,
				function (unit) {
					return _Utils_ap(formatted, unit);
				},
				config.g2);
		};
		var floatToPx = function (v) {
			return $elm$core$String$fromFloat(v) + 'px';
		};
		var elementId = 'horizontal-bar-chart-tooltip-' + config.mM;
		var barView = function (bar) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['group', 'bars', 'bar']),
						config.fs),
						$author$project$Gwi$Html$Attributes$cssVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'--bar-color',
								$author$project$Palette$filtersColorToHex(bar.jL)),
								_Utils_Tuple2(
								'--bar-width',
								getValueWidth(bar.c5))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['group', 'bars', 'bar', 'background']),
								config.fs)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['group', 'bars', 'bar', 'color']),
										config.fs)
									]),
								_List_Nil)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['group', 'bars', 'bar', 'value']),
								config.fs)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								formatMetricAxis(bar.c5))
							]))
					]));
		};
		var groupView = function (group) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'group', config.fs),
						$elm$html$Html$Events$onMouseEnter(
						$author$project$Dashboards2$Chart$GwiChart$GroupMouseEnter(group)),
						$elm$html$Html$Events$onMouseLeave($author$project$Dashboards2$Chart$GwiChart$GroupMouseLeave)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['group', 'label']),
								config.fs)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(group.ld)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['group', 'bars']),
								config.fs)
							]),
						A2($elm$core$List$map, barView, group.cl))
					]));
		};
		return A2(
			$elm$html$Html$map,
			config.a,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$GlobalWebIndex$class_namespaces$WeakCss$toClass(config.fs),
						$author$project$Gwi$Html$Attributes$cssVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'--chart-width',
								floatToPx(config.t.da)),
								_Utils_Tuple2(
								'--chart-height',
								floatToPx(config.t.cv))
							])),
						$elm$html$Html$Attributes$id(elementId)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'groups', config.fs)
							]),
						A2($elm$core$List$map, groupView, config.cl)),
						A3(
						$elm$html$Html$node,
						'x-d3scription',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + elementId),
								A2(
								$elm$html$Html$Attributes$attribute,
								'content',
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									$author$project$Dashboards2$Chart$GwiChart$tooltipContent(config),
									model.fV))
							]),
						_List_Nil)
					])));
	});
var $author$project$Dashboards2$Chart$VerticalBarChart$view = F2(
	function (config, model) {
		var globalMaxValue = function () {
			var _v0 = config.hR;
			if (!_v0.$) {
				var value = _v0.a;
				return value;
			} else {
				return A2(
					$elm$core$Maybe$withDefault,
					config.t.da,
					$elm$core$List$maximum(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.c5;
							},
							A2(
								$author$project$Gwi$List$fastConcatMap,
								function ($) {
									return $.cl;
								},
								config.cl))));
			}
		}();
		var getValueWidth = function (value) {
			var v = (!value) ? 0 : ((value / globalMaxValue) * 100);
			return $elm$core$String$fromFloat(v) + '%';
		};
		var formatMetricAxis = function (value) {
			var formatted = A2(
				$author$project$Gwi$FormatNumber$formatToDecimals,
				{jY: 1, kU: false},
				value);
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				formatted,
				function (unit) {
					return _Utils_ap(formatted, unit);
				},
				config.g2);
		};
		var floatToPx = function (v) {
			return $elm$core$String$fromFloat(v) + 'px';
		};
		var elementId = 'vertical-bar-chart-tooltip-' + config.mM;
		var barView = function (bar) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['group', 'bars', 'bar']),
						config.fs),
						$author$project$Gwi$Html$Attributes$cssVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'--bar-color',
								$author$project$Palette$filtersColorToHex(bar.jL)),
								_Utils_Tuple2(
								'--bar-length',
								getValueWidth(bar.c5))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['group', 'bars', 'bar', 'background']),
								config.fs)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['group', 'bars', 'bar', 'color']),
										config.fs)
									]),
								_List_Nil)
							]))
					]));
		};
		var groupView = function (group) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'group', config.fs),
						$elm$html$Html$Events$onMouseEnter(
						$author$project$Dashboards2$Chart$GwiChart$GroupMouseEnter(group)),
						$elm$html$Html$Events$onMouseLeave($author$project$Dashboards2$Chart$GwiChart$GroupMouseLeave)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['group', 'top']),
								config.fs)
							]),
						A2(
							$elm$core$List$map,
							function (bar) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['group', 'value']),
											config.fs),
											$author$project$Gwi$Html$Attributes$cssVars(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'--bar-color',
													$author$project$Palette$filtersColorToHex(bar.jL))
												]))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											formatMetricAxis(bar.c5))
										]));
							},
							group.cl)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['group', 'bottom']),
								config.fs),
								$author$project$Gwi$Html$Attributes$cssVars(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'--bar-count',
										$elm$core$String$fromInt(
											$elm$core$List$length(group.cl)))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['group', 'label']),
										config.fs)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(group.ld)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['group', 'bars']),
										config.fs)
									]),
								A2($elm$core$List$map, barView, group.cl))
							]))
					]));
		};
		return A2(
			$elm$html$Html$map,
			config.a,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$GlobalWebIndex$class_namespaces$WeakCss$toClass(config.fs),
						$author$project$Gwi$Html$Attributes$cssVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'--chart-width',
								floatToPx(config.t.da)),
								_Utils_Tuple2(
								'--chart-height',
								floatToPx(config.t.cv))
							])),
						$elm$html$Html$Attributes$id(elementId)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'groups', config.fs)
							]),
						A2($elm$core$List$map, groupView, config.cl)),
						A3(
						$elm$html$Html$node,
						'x-d3scription',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + elementId),
								A2(
								$elm$html$Html$Attributes$attribute,
								'content',
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									'',
									$author$project$Dashboards2$Chart$GwiChart$tooltipContent(config),
									model.fV))
							]),
						_List_Nil)
					])));
	});
var $author$project$Dashboards2$Chart$viewWebComponent_ = F7(
	function (config, metric, _v0, widget, globalMaximum, d3Data, _v1) {
		var chartType = _v0.aI;
		var legend = _v1.a1;
		var extraContent = _v1.hM;
		var chartModel = _v1.ad;
		var dimensions = _v1.t;
		var activeLegendItem = _v1.bc;
		var viewData = function (d3Data_) {
			switch (chartModel.$) {
				case 0:
					if (chartType === 2) {
						return $author$project$Dashboards2$Chart$DonutChart$view(
							{
								bc: activeLegendItem,
								fs: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'donut-chart', $author$project$Dashboards2$Chart$moduleClass),
								cl: d3Data_,
								t: dimensions,
								hR: globalMaximum,
								o9: function (scrollTo) {
									return A2(
										$elm$core$Basics$composeR,
										$author$project$Dashboards2$Chart$MouseHoverD3Point(scrollTo),
										config.a);
								},
								pD: config.a($author$project$Dashboards2$Chart$MouseLeaveD3Point),
								dB: metric,
								mM: 'widget-chart-' + $author$project$Data$Id$unwrap(widget.b),
								bO: widget,
								g2: $author$project$Data$Metric$getUnit(metric)
							});
					} else {
						return A3(
							$elm$html$Html$node,
							'x-dashboards-chart-2',
							_List_fromArray(
								[
									A2(
									$elm$html$Html$Attributes$attribute,
									'data',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										A3($author$project$D3Charts$Dashboards2$encodeD3Data, chartType, metric, d3Data_))),
									A2(
									$elm$html$Html$Attributes$attribute,
									'legend-data',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										A3(
											$author$project$D3Charts$Dashboards2$encodeD3Data,
											chartType,
											metric,
											A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$current, legend)))),
									A2(
									$elm$html$Html$Attributes$attribute,
									'metric',
									$author$project$Data$Metric$toString(metric)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'chart-type',
									$author$project$D3Charts$Dashboards$ChartType$toString(chartType)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'size-width',
									$elm$core$String$fromInt(widget.da)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'size-height',
									$elm$core$String$fromInt(widget.cv)),
									A2(
									$elm$html$Html$Attributes$attribute,
									'scale-maxes',
									A2(
										$elm$json$Json$Encode$encode,
										0,
										$author$project$D3Charts$Dashboards2$encodeScaleMaxes(
											A3($author$project$D3Charts$Dashboards2$scaleMaxes, metric, chartType, globalMaximum)))),
									A2(
									$elm$html$Html$Events$on,
									'tracktooltipshown',
									A2(
										$elm$json$Json$Decode$map,
										A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$TrackTooltipShown),
										$author$project$Dashboards2$Chart$showTooltipDecoder))
								]),
							_List_Nil);
					}
				case 1:
					var hbModel = chartModel.a;
					return A2(
						$author$project$Dashboards2$Chart$HorizontalBarChart$view,
						{
							fs: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'horizontal-bar-chart', $author$project$Dashboards2$Chart$moduleClass),
							cl: d3Data_,
							t: dimensions,
							hR: globalMaximum,
							a: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$HorizontalBarChartMsg),
							mM: 'widget-chart-' + $author$project$Data$Id$unwrap(widget.b),
							g2: $author$project$Data$Metric$getUnit(metric)
						},
						hbModel);
				default:
					var vbModel = chartModel.a;
					return A2(
						$author$project$Dashboards2$Chart$VerticalBarChart$view,
						{
							fs: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'vertical-bar-chart', $author$project$Dashboards2$Chart$moduleClass),
							cl: d3Data_,
							t: dimensions,
							hR: globalMaximum,
							a: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$VerticalBarChartMsg),
							mM: 'widget-chart-' + $author$project$Data$Id$unwrap(widget.b),
							g2: $author$project$Data$Metric$getUnit(metric)
						},
						vbModel);
			}
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', $author$project$Dashboards2$Chart$moduleClass),
					$elm$html$Html$Attributes$id(
					$author$project$Dashboards2$Chart$resizeObservedElementId(widget))
				]),
			function () {
				switch (d3Data.$) {
					case 0:
						return _List_fromArray(
							[$author$project$Platform2$Spinner$view]);
					case 1:
						return _List_fromArray(
							[$author$project$Platform2$Spinner$view]);
					case 2:
						var err = d3Data.a;
						return _List_fromArray(
							[
								$author$project$Dashboards2$Chart$viewError(
								$author$project$Dashboards2$Chart$errorText(err))
							]);
					default:
						var d3Data_ = d3Data.a;
						return _List_fromArray(
							[
								viewData(d3Data_),
								extraContent
							]);
				}
			}());
	});
var $author$project$Dashboards2$Chart$viewWebComponentWithWrapper = F6(
	function (innerWrapper, config, store, chartWidget, widget, model) {
		var _v0 = model.h;
		switch (_v0.$) {
			case 0:
				var data = _v0.a.cl;
				var dimensions = _v0.a.t;
				var chartModel = _v0.a.ad;
				var wrappedZipper = A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$second, data);
				var pagesCount = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					0,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$length,
					$elm_community$maybe_extra$Maybe$Extra$join(
						$author$project$RemoteData$Loaded$toMaybe(wrappedZipper)));
				var globalMaximum = A2(
					$elm$core$Maybe$andThen,
					function (zipper) {
						return $author$project$D3Charts$Dashboards2$maximum(
							$elm$core$List$concat(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toList(zipper)));
					},
					$elm_community$maybe_extra$Maybe$Extra$join(
						$author$project$RemoteData$Loaded$toMaybe(wrappedZipper)));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'wrapper', $author$project$Dashboards2$Chart$moduleClass)
						]),
					_List_fromArray(
						[
							innerWrapper(
							A7(
								$author$project$Dashboards2$Chart$viewWebComponent_,
								config,
								model.hr,
								chartWidget,
								widget,
								globalMaximum,
								A3($author$project$Dashboards2$Chart$getDashboardWebDataFromZipper, store, config.bz, data),
								{bc: model.bc, ad: chartModel, t: dimensions, hM: $elm_community$html_extra$Html$Extra$nothing, a1: $elm$core$Maybe$Nothing})),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							pagesCount > 1,
							A2($author$project$Dashboards2$Chart$viewPagination, config, wrappedZipper)),
							A3(
							$author$project$ResizeObserver$view,
							{
								iW: '#' + $author$project$Dashboards2$Chart$resizeObservedElementId(widget),
								iZ: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$WidgetDimensionsChanged)
							},
							_List_Nil,
							_List_Nil)
						]));
			case 1:
				var data = _v0.a.cl;
				var legend = _v0.a.a1;
				var dimensions = _v0.a.t;
				var data_ = A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$second, data);
				var globalMaximum = A2(
					$elm$core$Maybe$andThen,
					$author$project$D3Charts$Dashboards2$maximum,
					$author$project$RemoteData$Loaded$toMaybe(data_));
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'wrapper', $author$project$Dashboards2$Chart$moduleClass)
						]),
					_List_fromArray(
						[
							innerWrapper(
							A7(
								$author$project$Dashboards2$Chart$viewWebComponent_,
								config,
								model.hr,
								chartWidget,
								widget,
								globalMaximum,
								data_,
								{
									bc: model.bc,
									ad: $author$project$Dashboards2$Chart$D3Chart,
									t: dimensions,
									hM: A2(
										$elm_community$html_extra$Html$Extra$viewMaybe,
										$author$project$Dashboards2$Chart$viewAttributeNamesPagination(config),
										legend),
									a1: legend
								}))
						]));
			case 2:
				return $author$project$Dashboards2$Chart$viewError('BUG: StatCardModel inside viewWebComponent');
			default:
				var lineChartModel = _v0.a.f8;
				var nonpaginated = _v0.b;
				var data_ = A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$second, nonpaginated.cl);
				var viewLineChart = function (maybeSuffixCodeAndQuestion) {
					return A2(
						$elm_community$html_extra$Html$Extra$viewMaybe,
						function (_v6) {
							var datapoint = _v6.a;
							var suffixCodes = _v6.b;
							var suffixes = _v6.c;
							var suffixNames = function (names) {
								return $elm$core$List$isEmpty(names) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
									'(' + (A2($elm$core$String$join, ',', names) + ')'));
							}(
								A2(
									$elm$core$List$filterMap,
									function (suffixCode) {
										return A2($author$project$Dashboards2$Chart$AttributeName$getSuffixName, suffixCode, suffixes);
									},
									suffixCodes));
							var attributeLabel = A2($author$project$Dashboards2$Chart$datapointAndSuffixName, datapoint.ld, suffixNames);
							if (data_.$ === 3) {
								var data = data_.a;
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'line-chart-wrapper', $author$project$Dashboards2$Chart$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['line-chart-wrapper', 'labels']),
													$author$project$Dashboards2$Chart$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'metric-label', $author$project$Dashboards2$Chart$moduleClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															$author$project$Data$Metric$getLabel(model.hr))
														])),
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'attribute-label', $author$project$Dashboards2$Chart$moduleClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(attributeLabel)
														]))
												])),
											A2(
											$author$project$Dashboards2$Chart$LineChart$view,
											{
												nw: attributeLabel,
												fs: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'line-chart', $author$project$Dashboards2$Chart$moduleClass),
												cl: data,
												t: nonpaginated.t,
												a: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$LineChartMsg),
												mM: 'widget-chart-' + $author$project$Data$Id$unwrap(widget.b),
												g2: $author$project$Data$Metric$getUnit(model.hr)
											},
											lineChartModel)
										]));
							} else {
								return $author$project$Platform2$Spinner$view;
							}
						},
						A2(
							$elm$core$Maybe$andThen,
							function (_v3) {
								var groupedData = _v3.a;
								var question = _v3.b;
								var validDatapoints = $author$project$Data$Id$setFromList(
									A2($author$project$Data$Platform2$getValidDatapointCodesForWidget, question, chartWidget));
								return A2(
									$elm$core$Maybe$andThen,
									function (_v5) {
										var code = _v5.a;
										var suffixCodes = _v5.b;
										return A2(
											$elm$core$Maybe$map,
											function (dtp) {
												return _Utils_Tuple3(dtp, suffixCodes, question.rI);
											},
											A2(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
												function (dtp) {
													return _Utils_eq(code, dtp.bW);
												},
												question.er));
									},
									A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
										function (_v4) {
											var code = _v4.a;
											return A2($turboMaCk$any_set$Set$Any$member, code, validDatapoints);
										},
										groupedData.er));
							},
							maybeSuffixCodeAndQuestion));
				};
				var viewFirstAvailableAttribute = function (attributes) {
					return viewLineChart(
						A2(
							$elm$core$Maybe$map,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$head,
							A2(
								$elm$core$Maybe$andThen,
								$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap(
									function (groupedData) {
										var questionCode = groupedData.at;
										return A2(
											$elm$core$Maybe$map,
											function (question) {
												return _Utils_Tuple2(
													A2($author$project$Data$Platform2$groupedWidgetDataToExplicitWidgetData, question, groupedData),
													question);
											},
											A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store));
									}),
								attributes)));
				};
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'wrapper', $author$project$Dashboards2$Chart$moduleClass),
							$elm$html$Html$Attributes$id(
							$author$project$Dashboards2$Chart$resizeObservedElementId(widget))
						]),
					_List_fromArray(
						[
							function () {
							var _v1 = chartWidget.cl;
							if (!_v1.$) {
								var oldData = _v1.a;
								return viewFirstAvailableAttribute(
									A2(
										$author$project$Data$Platform2$oldWidgetDataToGroupedWidgetData,
										A2(
											$turboMaCk$any_dict$Dict$Any$filterMap,
											F2(
												function (_v2, v) {
													return $krisajenkins$remotedata$RemoteData$toMaybe(v);
												}),
											store.bt),
										oldData));
							} else {
								var groups = _v1.a;
								return viewFirstAvailableAttribute(
									$elm$core$Maybe$Just(groups));
							}
						}(),
							A3(
							$author$project$ResizeObserver$view,
							{
								iW: '#' + $author$project$Dashboards2$Chart$resizeObservedElementId(widget),
								iZ: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$WidgetDimensionsChanged)
							},
							_List_Nil,
							_List_Nil)
						]));
		}
	});
var $author$project$Dashboards2$Chart$viewWebComponent = $author$project$Dashboards2$Chart$viewWebComponentWithWrapper($elm$core$Basics$identity);
var $author$project$Dashboards2$Chart$prepareViewData = F5(
	function (store, userFilters, widget, chartWidget, model) {
		var chartType = chartWidget.aI;
		var getErrorFromD3Data = function (data) {
			switch (data.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					return $elm$core$Maybe$Nothing;
				case 2:
					var err = data.a;
					return $elm$core$Maybe$Just(
						$author$project$Dashboards2$Chart$errorText(err));
				default:
					return $elm$core$Maybe$Nothing;
			}
		};
		var getErrorFromChartData = function (chartData) {
			switch (chartData.$) {
				case 0:
					var data = chartData.a.cl;
					return getErrorFromD3Data(
						A3($author$project$Dashboards2$Chart$getDashboardWebDataFromZipper, store, userFilters, data));
				case 1:
					var data = chartData.a.cl;
					return getErrorFromD3Data(data);
				case 2:
					return $elm$core$Maybe$Just('BUG: StatCardModel inside viewWebComponent');
				default:
					var data = chartData.b.cl;
					return getErrorFromD3Data(data);
			}
		};
		var errorViewIfAny = F2(
			function (maybeErr, successView) {
				if (!maybeErr.$) {
					var err = maybeErr.a;
					return $author$project$Dashboards2$Chart$ErrorView(
						{$7: err});
				} else {
					return successView;
				}
			});
		var webComponentViewWithErrorCheck = function (_v15) {
			return A2(
				errorViewIfAny,
				getErrorFromChartData(model.h),
				$author$project$Dashboards2$Chart$DataLoaded(
					{
						bT: F2(
							function (config, _v14) {
								return A5($author$project$Dashboards2$Chart$viewWebComponent, config, store, chartWidget, widget, model);
							})
					}));
		};
		switch (chartType) {
			case 0:
				var tableRawView = F4(
					function (config, availableMetrics, width, d3Data) {
						return A3(
							$author$project$Dashboards2$Chart$withResizeHandlerView,
							config,
							widget.b,
							A3(
								$author$project$Dashboards2$Widget$DataTable$view,
								{
									nE: availableMetrics,
									hT: !$elm$core$List$isEmpty(
										$author$project$Dashboards2$UserFilters$activeAudienceIds(userFilters)),
									si: width
								},
								widget,
								d3Data));
					});
				var viewTable = F2(
					function (width, d3Data) {
						return $author$project$Dashboards2$Chart$DataLoaded(
							{
								bT: F2(
									function (config, availableMetrics) {
										return A4(tableRawView, config, availableMetrics, width, d3Data);
									})
							});
					});
				var convertedChartData = function () {
					var _v9 = model.h;
					if (_v9.$ === 1) {
						return A6(
							$author$project$Dashboards2$Chart$updateChartDataPure,
							userFilters,
							store,
							widget,
							chartWidget,
							model.hr,
							A3($author$project$Dashboards2$Chart$toPaginated, widget, chartWidget, model.h));
					} else {
						return model.h;
					}
				}();
				switch (convertedChartData.$) {
					case 1:
						var dimensions = convertedChartData.a.t;
						var data = convertedChartData.a.cl;
						return A2(
							viewTable,
							dimensions.da,
							A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$second, data));
					case 0:
						var dimensions = convertedChartData.a.t;
						var data = convertedChartData.a.cl;
						return A2(
							viewTable,
							dimensions.da,
							A2(
								$author$project$RemoteData$Loaded$andThen,
								function (_v2) {
									var maybeDataZipper = _v2.b;
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$author$project$RemoteData$Loaded$NotAskedL,
										A2(
											$elm$core$Basics$composeR,
											$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toList,
											A2($elm$core$Basics$composeR, $author$project$Gwi$List$fastConcat, $author$project$RemoteData$Loaded$SuccessL)),
										maybeDataZipper);
								},
								data));
					case 2:
						var data = convertedChartData.a;
						switch (data.$) {
							case 0:
								return $author$project$Dashboards2$Chart$DataLoaded(
									{
										bT: F2(
											function (_v4, _v5) {
												return $elm_community$html_extra$Html$Extra$nothing;
											})
									});
							case 1:
								return $author$project$Dashboards2$Chart$LoadingData(
									{
										mi: F2(
											function (_v6, _v7) {
												return $author$project$Platform2$Spinner$view;
											})
									});
							case 3:
								var _v8 = data.a;
								var qresultsDict = _v8.a;
								var statCardData = _v8.b;
								return A2(
									viewTable,
									statCardData.sm,
									A2(
										$author$project$Dashboards2$Chart$sortNonpaginatedData,
										chartWidget,
										A6(
											$author$project$Dashboards2$Chart$buildNonpaginatedData,
											userFilters,
											store,
											model.hr,
											widget,
											chartWidget,
											A3(
												$author$project$Dashboards2$Chart$sortResultsByDefaultDatapointOrder,
												store.bt,
												chartWidget,
												A3(
													$elm_community$maybe_extra$Maybe$Extra$unwrap,
													_List_Nil,
													$elm$core$List$singleton,
													A2($turboMaCk$any_dict$Dict$Any$get, userFilters, qresultsDict))))));
							default:
								var err = data.a;
								return $author$project$Dashboards2$Chart$ErrorView(
									{
										$7: $author$project$Dashboards2$Chart$errorText(err)
									});
						}
					default:
						var dimensions = convertedChartData.b.t;
						var data = convertedChartData.b.cl;
						return A2(
							viewTable,
							dimensions.da,
							A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$second, data));
				}
			case 1:
				return (model.hr === 3) ? webComponentViewWithErrorCheck(0) : $author$project$Dashboards2$Chart$ErrorView(
					{$7: 'ERROR: Diverging Bar Chart only supports the Index metric.'});
			case 2:
				return webComponentViewWithErrorCheck(0);
			case 3:
				return webComponentViewWithErrorCheck(0);
			case 4:
				return A2(
					errorViewIfAny,
					getErrorFromChartData(model.h),
					$author$project$Dashboards2$Chart$DataLoaded(
						{
							bT: F2(
								function (config, _v10) {
									return A6(
										$author$project$Dashboards2$Chart$viewWebComponentWithWrapper,
										$elm$core$Basics$always($elm_community$html_extra$Html$Extra$nothing),
										config,
										store,
										chartWidget,
										widget,
										model);
								})
						}));
			case 5:
				return webComponentViewWithErrorCheck(0);
			case 6:
				return webComponentViewWithErrorCheck(0);
			case 7:
				var widgetDatapoints = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					A2(
						$elm$core$Basics$composeR,
						$turboMaCk$non_empty_list_alias$List$NonEmpty$map(
							function (question) {
								return A2($author$project$Data$Platform2$getValidDatapointCodesForWidget, question, chartWidget);
							}),
						A2($elm$core$Basics$composeR, $turboMaCk$non_empty_list_alias$List$NonEmpty$toList, $elm$core$List$concat)),
					A2($author$project$Dashboards2$Chart$getWidgetQuestions, chartWidget, store));
				return A2(
					$author$project$D3Charts$Dashboards$ChartType$isValidNumberOfDatapoints,
					7,
					$elm$core$List$length(widgetDatapoints)) ? A2(
					errorViewIfAny,
					getErrorFromChartData(model.h),
					$author$project$Dashboards2$Chart$DataLoaded(
						{
							bT: F2(
								function (config, _v11) {
									return A6(
										$author$project$Dashboards2$Chart$viewWebComponentWithWrapper,
										function (c) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'radar-chart-wrapper', $author$project$Dashboards2$Chart$moduleClass)
													]),
												_List_fromArray(
													[c]));
										},
										config,
										store,
										chartWidget,
										widget,
										model);
								})
						})) : $author$project$Dashboards2$Chart$ErrorView(
					{$7: 'ERROR: There is not enough data points for Radar Chart (needs 3 or more).'});
			case 8:
				return webComponentViewWithErrorCheck(0);
			case 9:
				return $author$project$Dashboards2$Chart$DataLoaded(
					{
						bT: F2(
							function (config, _v12) {
								return A3($author$project$Dashboards2$Chart$viewStatCard, config, widget.b, model);
							})
					});
			case 10:
				return $author$project$Dashboards2$Chart$DataLoaded(
					{
						bT: F2(
							function (config, _v13) {
								return A3($author$project$Dashboards2$Chart$viewStatCard, config, widget.b, model);
							})
					});
			default:
				return webComponentViewWithErrorCheck(0);
		}
	});
var $author$project$Dashboards2$Widget$trackWidgetErrorIfAny = F4(
	function (maybeUserFilters, store, widget, model) {
		var trackError = F3(
			function (chartWidget, errorTitle, model_) {
				return model_.ev ? $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model_) : _Utils_Tuple2(
					_Utils_update(
						model_,
						{ev: true}),
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$WidgetError(
							{
								jo: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$Dashboards2$UserFilters$audienceIds, maybeUserFilters),
								oz: errorTitle,
								qE: $author$project$Dashboards2$Widget$widgetQuestionCodes(chartWidget)
							})));
			});
		var checkIfErrorAndTrack = F3(
			function (chartWidget, chartModel, questions) {
				var questionPermissions = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $author$project$Data$Permissions$questionV2, questions);
				var anyNeedUpsell = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$any, $author$project$Data$Permissions$isUpsellNeeded, questionPermissions);
				var allAccessible = A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$all,
					$elm$core$Basics$eq($author$project$Data$Permissions$Accessible),
					questionPermissions);
				return allAccessible ? function () {
					if (maybeUserFilters.$ === 1) {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
					} else {
						var userFilters = maybeUserFilters.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure,
							trackError(chartWidget),
							$author$project$Dashboards2$Chart$getErrorFromViewData(
								A5($author$project$Dashboards2$Chart$prepareViewData, store, userFilters, widget, chartWidget, chartModel)));
					}
				}()(model) : (anyNeedUpsell ? A3(trackError, chartWidget, 'Upsell - Looks like you need more data.', model) : A2(
					$elm$core$Maybe$withDefault,
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
					A2(
						$elm$core$Maybe$map,
						$turboMaCk$non_empty_list_alias$List$NonEmpty$head,
						A2(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
							function (permission) {
								if (permission.$ === 2) {
									var data = permission.a;
									var _v4 = A2($author$project$Data$Permissions$getUnknownTypesCopy, 'widget', data);
									var title = _v4.Y;
									return $elm$core$Maybe$Just(
										A3(trackError, chartWidget, title, model));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							questionPermissions))));
			});
		var _v0 = _Utils_Tuple2(widget.U, model.ad);
		if ((!_v0.a.$) && (_v0.b.$ === 2)) {
			var chartWidget = _v0.a.a;
			var chartModelData = _v0.b.a;
			switch (chartModelData.$) {
				case 0:
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				case 1:
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				case 2:
					var errors = chartModelData.a;
					return (A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$member,
						$elm$http$Http$BadStatus(404),
						errors) || A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$member,
						$elm$http$Http$BadStatus(403),
						errors)) ? A3(trackError, chartWidget, 'You have insufficient permissions to view this question', model) : A3(trackError, chartWidget, 'BUG: failed to fetch data from the /questions/:id API endpoint', model);
				default:
					var questions = chartModelData.a;
					var chartModel = chartModelData.b;
					return A3(checkIfErrorAndTrack, chartWidget, chartModel, questions);
			}
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger = function (msg) {
	return $GlobalWebIndex$cmd_extra$Cmd$Extra$with(
		$GlobalWebIndex$cmd_extra$Cmd$Extra$perform(msg));
};
var $author$project$Dashboards2$Widget$requestDataForWidget_ = F9(
	function (_v0, msg, _v1, maybeUserFilters, flags, store, widget, _v2, model_) {
		var externalCall = _v0.bI;
		var storeActionMany = _v1.l;
		var isEditing = _v2.ez;
		var forceFetch = _v2.oQ;
		var model = externalCall ? _Utils_update(
			model_,
			{d4: false, ev: false}) : model_;
		var _v3 = _Utils_Tuple2(widget.U, model.ad);
		if ((!_v3.a.$) && (_v3.b.$ === 2)) {
			var chartWidget = _v3.a.a;
			var chartModelData = _v3.b.a;
			var widgetWithFilteredDatapoints = function () {
				switch (chartModelData.$) {
					case 0:
						return widget;
					case 1:
						return widget;
					case 2:
						return widget;
					default:
						return A2(
							$elm$core$Maybe$withDefault,
							widget,
							A3($author$project$Dashboards2$Chart$removeDatapointsWithUnknownPermissions, flags, store, widget));
				}
			}();
			return A2(
				$elm$core$Tuple$mapSecond,
				A2(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					A3($author$project$Dashboards2$Widget$trackWidgetErrorIfAny, maybeUserFilters, store, widget)),
				function () {
					var _v4 = _Utils_Tuple3(
						maybeUserFilters,
						A2(
							$elm$core$Maybe$andThen,
							function (userFilters) {
								return A3(
									$author$project$Data$Calc$Platform2$paramsFromWidget,
									store,
									$author$project$Dashboards2$UserFilters$toSimpleFilters(userFilters),
									widgetWithFilteredDatapoints);
							},
							maybeUserFilters),
						$author$project$Dashboards2$Widget$getChartModel(chartModelData));
					if (!_v4.b.$) {
						if ((!_v4.a.$) && (!_v4.c.$)) {
							var userFilters = _v4.a.a;
							var _v5 = _v4.b.a;
							var paramsList = _v5.a;
							var updateStoreFn = _v5.b;
							return $author$project$Dashboards2$Widget$requestActionWithFiltersParametersAndChart(
								{dg: chartWidget, bI: externalCall, oN: flags, oQ: forceFetch, ez: isEditing, k3: maybeUserFilters, k8: model, a: msg, lx: paramsList, rF: store, l: storeActionMany, g$: updateStoreFn, bz: userFilters, bO: widget});
						} else {
							var _v6 = _v4.b.a;
							var updateStoreFn = _v6.b;
							return _Utils_Tuple2(
								_List_Nil,
								A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
									storeActionMany(
										_List_fromArray(
											[
												$author$project$Store$Platform2$UpdateStore(updateStoreFn)
											])),
									model));
						}
					} else {
						return _Utils_Tuple2(
							_List_Nil,
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
					}
				}());
		} else {
			return _Utils_Tuple2(
				_List_Nil,
				$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
		}
	});
var $author$project$Dashboards2$Widget$requestDataForWidgetIfNotLoaded_ = F9(
	function (externalOrNot, msg, storeActionMany, maybeUserFilters, flags, store, widget, params, model) {
		var _v0 = model.ad;
		switch (_v0.$) {
			case 0:
				return _Utils_Tuple2(
					_List_Nil,
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
			case 1:
				return _Utils_Tuple2(
					_List_Nil,
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
			default:
				var chartModelData = _v0.a;
				var fetchIfNotAsked = function (chartModel) {
					return ($author$project$Dashboards2$Chart$isNotAsked(chartModel) && (model.cz || params.oQ)) ? A9($author$project$Dashboards2$Widget$requestDataForWidget_, externalOrNot, msg, storeActionMany, maybeUserFilters, flags, store, widget, params, model) : _Utils_Tuple2(
						_List_Nil,
						$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
				};
				switch (chartModelData.$) {
					case 0:
						var chartModel = chartModelData.a;
						return fetchIfNotAsked(chartModel);
					case 1:
						var chartModel = chartModelData.a;
						return fetchIfNotAsked(chartModel);
					case 2:
						return _Utils_Tuple2(
							_List_Nil,
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
					default:
						var chartModel = chartModelData.b;
						return fetchIfNotAsked(chartModel);
				}
		}
	});
var $author$project$Dashboards2$Widget$requestDataForWidgetIfNotLoaded = $author$project$Dashboards2$Widget$requestDataForWidgetIfNotLoaded_(
	{bI: true});
var $author$project$Dashboards2$requestDataForAllWidgetsIfNotLoaded = $author$project$Dashboards2$requestDataForAllWidgets_($author$project$Dashboards2$Widget$requestDataForWidgetIfNotLoaded);
var $author$project$Dashboards2$setUserFilters = F2(
	function (newUserFilters, model) {
		return _Utils_update(
			model,
			{
				G: A2(
					$author$project$UndoRedo$updateCurrent,
					function (undoRedo) {
						return _Utils_update(
							undoRedo,
							{bz: newUserFilters});
					},
					model.G)
			});
	});
var $author$project$Dashboards2$FiltersChanged = function (a) {
	return {$: 50, a: a};
};
var $author$project$Dashboards2$GotSampleSizeResponse = F2(
	function (a, b) {
		return {$: 49, a: a, b: b};
	});
var $author$project$Dashboards2$userFiltersConfig = {oM: $author$project$Dashboards2$FiltersChanged, o$: $author$project$Dashboards2$GotSampleSizeResponse};
var $author$project$Dashboards2$initUserFilters = F6(
	function (config, flags, dashboard, route, store, model) {
		var dataNeededBasedOnUserPlan = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? _Utils_Tuple3(
			store.d9,
			A2($author$project$Dashboards2$Detail$getWavesForDashboardByDashboardId, store, dashboard),
			A2($author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId, store, dashboard)) : _Utils_Tuple3(
			store.d9,
			A2($author$project$Dashboards2$Detail$getWavesForDashboardByNamespaces, store, dashboard),
			A2($author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces, store, dashboard));
		var _v0 = _Utils_Tuple2(
			dataNeededBasedOnUserPlan,
			A2(
				$elm$core$List$all,
				$krisajenkins$remotedata$RemoteData$isSuccess,
				$turboMaCk$any_dict$Dict$Any$values(store.jq)));
		if ((((_v0.a.a.$ === 3) && (_v0.a.b.$ === 3)) && (_v0.a.c.$ === 3)) && _v0.b) {
			var _v1 = _v0.a;
			var audiences = _v1.a.a;
			var waves = _v1.b.a;
			var locations = _v1.c.a;
			var shortAudiencesDict = A3(
				$elm$core$List$foldl,
				F2(
					function (audience, dict) {
						return A3($turboMaCk$any_dict$Dict$Any$insert, audience.b, audience, dict);
					}),
				$author$project$Data$Id$emptyDict,
				A2(
					$author$project$Gwi$List$fastConcatMap,
					$krisajenkins$remotedata$RemoteData$withDefault(_List_Nil),
					$turboMaCk$any_dict$Dict$Any$values(store.jq)));
			var accessibleWaves = A2(
				$turboMaCk$any_dict$Dict$Any$filter,
				$elm$core$Basics$always(
					function ($) {
						return $.fc;
					}),
				waves);
			var accessibleLocations = A2(
				$turboMaCk$any_dict$Dict$Any$filter,
				$elm$core$Basics$always(
					function ($) {
						return $.fc;
					}),
				locations);
			var _v2 = A7($author$project$Dashboards2$UserFilters$init, $author$project$Dashboards2$userFiltersConfig, flags, dashboard.cl.C, shortAudiencesDict, audiences, accessibleWaves, accessibleLocations);
			var userFilters = _v2.a;
			var userFiltersCmds = _v2.b;
			return A3(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				A5(
					$author$project$Dashboards2$requestDataForAllWidgetsIfNotLoaded,
					config,
					flags,
					route,
					store,
					{bi: false}),
				_Utils_Tuple2(
					A2(
						$author$project$Dashboards2$setUserFilters,
						$author$project$Dashboards2$Editable$initReady(userFilters),
						model),
					A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds)));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Dashboards2$Editable$isNotReady = $elm$core$Basics$eq($author$project$Dashboards2$Editable$NotReady);
var $author$project$Dashboards2$UserFilters$reInitLocations = F3(
	function (storedLoactions, allLocations_, currentLocations) {
		if (!currentLocations.$) {
			return $author$project$Dashboards2$UserFilters$AllAvailableLocations(
				$author$project$Data$Id$keysToSet(allLocations_));
		} else {
			return A2($author$project$Dashboards2$UserFilters$initLocations, storedLoactions, allLocations_);
		}
	});
var $author$project$Dashboards2$UserFilters$reInitWaves = F3(
	function (storedWaves, allWaves_, currentWaves) {
		var lastFourWaves = $author$project$Data$Labels$getFourMostRecentWaveCodes(allWaves_);
		if (!currentWaves.$) {
			return $author$project$Dashboards2$UserFilters$MostRecentWaves(lastFourWaves);
		} else {
			return A2($author$project$Dashboards2$UserFilters$initWaves, storedWaves, allWaves_);
		}
	});
var $author$project$Dashboards2$UserFilters$reInit = F4(
	function (storedFilters, waves_, locations_, _v0) {
		var userFilters = _v0;
		return _Utils_update(
			userFilters,
			{
				cD: A3($author$project$Dashboards2$UserFilters$reInitLocations, storedFilters.cD, locations_, userFilters.cD),
				dX: A3($author$project$Dashboards2$UserFilters$reInitWaves, storedFilters.dX, waves_, userFilters.dX)
			});
	});
var $author$project$Dashboards2$reInitUserFilter = F4(
	function (flags, dashboard, store, userFilters) {
		var dataNeededBasedOnUserPlan = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? _Utils_Tuple2(
			A2($author$project$Dashboards2$Detail$getWavesForDashboardByDashboardId, store, dashboard),
			A2($author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId, store, dashboard)) : _Utils_Tuple2(
			A2($author$project$Dashboards2$Detail$getWavesForDashboardByNamespaces, store, dashboard),
			A2($author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces, store, dashboard));
		if ((dataNeededBasedOnUserPlan.a.$ === 3) && (dataNeededBasedOnUserPlan.b.$ === 3)) {
			var waves = dataNeededBasedOnUserPlan.a.a;
			var locations = dataNeededBasedOnUserPlan.b.a;
			var accessibleWaves = A2(
				$turboMaCk$any_dict$Dict$Any$filter,
				$elm$core$Basics$always(
					function ($) {
						return $.fc;
					}),
				waves);
			var accessibleLocations = A2(
				$turboMaCk$any_dict$Dict$Any$filter,
				$elm$core$Basics$always(
					function ($) {
						return $.fc;
					}),
				locations);
			return A4($author$project$Dashboards2$UserFilters$reInit, dashboard.cl.C, accessibleWaves, accessibleLocations, userFilters);
		} else {
			return userFilters;
		}
	});
var $author$project$Dashboards2$Widget$requestDataForWidget = $author$project$Dashboards2$Widget$requestDataForWidget_(
	{bI: true});
var $author$project$Dashboards2$requestDataForAllWidgets = F4(
	function (config, flags, route, store) {
		return A6(
			$author$project$Dashboards2$requestDataForAllWidgets_,
			$author$project$Dashboards2$Widget$requestDataForWidget,
			config,
			flags,
			route,
			store,
			{bi: false});
	});
var $author$project$Dashboards2$updateCurrentUserFilters = F2(
	function (updateFn, model) {
		return _Utils_update(
			model,
			{
				G: A2(
					$author$project$UndoRedo$updateCurrent,
					function (undoRedo) {
						return _Utils_update(
							undoRedo,
							{
								bz: updateFn(undoRedo.bz)
							});
					},
					model.G)
			});
	});
var $author$project$Dashboards2$Chart$toLineChartData = F3(
	function (widget, chartWidget, chart) {
		switch (chart.$) {
			case 2:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
			case 1:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
			case 0:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
			default:
				return chart;
		}
	});
var $author$project$Dashboards2$Chart$toNonPaginated = F3(
	function (widget, chartWidget, chart) {
		switch (chart.$) {
			case 0:
				var dimensions = chart.a.t;
				var data = chart.a.cl;
				var newData = A2(
					$author$project$RemoteData$Loaded$map,
					function (_v1) {
						var qResult = _v1.a;
						var maybeZipper = _v1.b;
						return _Utils_Tuple2(
							qResult,
							$author$project$Gwi$List$fastConcat(
								A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toList, maybeZipper)));
					},
					data);
				return $author$project$Dashboards2$Chart$Nonpaginated(
					{
						cl: newData,
						t: dimensions,
						a1: A3($author$project$Dashboards2$Chart$createLegendForChart, widget, chartWidget, newData)
					});
			case 3:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
			case 1:
				return chart;
			default:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
		}
	});
var $author$project$Dashboards2$Chart$toStatCardChartData = F3(
	function (widget, chartWidget, chart) {
		switch (chart.$) {
			case 2:
				return chart;
			case 1:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
			case 0:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
			default:
				return A2($author$project$Dashboards2$Chart$initChartData, widget, chartWidget);
		}
	});
var $author$project$Dashboards2$Chart$updateChartData_ = F5(
	function (userFilters, store, widget, chartWidget, model) {
		return A2(
			$author$project$Dashboards2$Chart$setChartData,
			model,
			A6($author$project$Dashboards2$Chart$updateChartDataPure, userFilters, store, widget, chartWidget, model.hr, model.h));
	});
var $author$project$Dashboards2$Chart$updateChartData = F5(
	function (userFilters, store, widget, chartWidget, model) {
		var dimensions = A2(
			$elm$core$Maybe$withDefault,
			A2($author$project$ResizeObserver$Dimensions, 0, 0),
			$author$project$Dashboards2$Chart$getDimensions(model));
		return A5(
			$author$project$Dashboards2$Chart$updateChartData_,
			userFilters,
			store,
			widget,
			chartWidget,
			_Utils_update(
				model,
				{
					h: function () {
						var _v0 = chartWidget.aI;
						switch (_v0) {
							case 9:
								return A3($author$project$Dashboards2$Chart$toStatCardChartData, widget, chartWidget, model.h);
							case 10:
								return A3($author$project$Dashboards2$Chart$toStatCardChartData, widget, chartWidget, model.h);
							case 4:
								return A3($author$project$Dashboards2$Chart$toLineChartData, widget, chartWidget, model.h);
							default:
								return _Utils_eq(
									A3($author$project$Dashboards2$Chart$itemsPerPage, widget, dimensions, _List_Nil),
									$elm$core$Maybe$Nothing) ? A3($author$project$Dashboards2$Chart$toNonPaginated, widget, chartWidget, model.h) : A3($author$project$Dashboards2$Chart$toPaginated, widget, chartWidget, model.h);
						}
					}()
				}));
	});
var $author$project$Dashboards2$Widget$updateWidgetsChartDataWithFilters = F4(
	function (userFilters, store, widget, model) {
		var _v0 = _Utils_Tuple2(widget.U, model.ad);
		if ((!_v0.a.$) && (_v0.b.$ === 2)) {
			var chartWidget = _v0.a.a;
			return _Utils_update(
				model,
				{
					ad: A2(
						$author$project$Dashboards2$Widget$updateChartModel,
						model.ad,
						A2(
							$elm$core$Basics$composeR,
							A4($author$project$Dashboards2$Chart$updateChartData, userFilters, store, widget, chartWidget),
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure)).a
				});
		} else {
			return model;
		}
	});
var $author$project$Dashboards2$Detail$SavedDashboardId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Platform2$findDeepestDataset = F2(
	function (usedDatasets, allDatasets) {
		return $elm$core$List$head(
			A2(
				$author$project$Gwi$List$reverseSortBy,
				function ($) {
					return $.hz;
				},
				A2($author$project$Store$Utils$getByIds, allDatasets, usedDatasets)));
	});
var $krisajenkins$remotedata$RemoteData$andMap = F2(
	function (wrappedValue, wrappedFunction) {
		var _v0 = _Utils_Tuple2(wrappedFunction, wrappedValue);
		_v0$2:
		while (true) {
			_v0$3:
			while (true) {
				_v0$4:
				while (true) {
					_v0$5:
					while (true) {
						switch (_v0.a.$) {
							case 3:
								switch (_v0.b.$) {
									case 3:
										var f = _v0.a.a;
										var value = _v0.b.a;
										return $krisajenkins$remotedata$RemoteData$Success(
											f(value));
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									default:
										var _v4 = _v0.b;
										return $krisajenkins$remotedata$RemoteData$NotAsked;
								}
							case 2:
								var error = _v0.a.a;
								return $krisajenkins$remotedata$RemoteData$Failure(error);
							case 1:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$3;
									case 0:
										break _v0$3;
									default:
										break _v0$3;
								}
							default:
								switch (_v0.b.$) {
									case 2:
										break _v0$2;
									case 1:
										break _v0$4;
									case 0:
										break _v0$5;
									default:
										break _v0$5;
								}
						}
					}
					var _v3 = _v0.a;
					return $krisajenkins$remotedata$RemoteData$NotAsked;
				}
				var _v2 = _v0.b;
				return $krisajenkins$remotedata$RemoteData$Loading;
			}
			var _v1 = _v0.a;
			return $krisajenkins$remotedata$RemoteData$Loading;
		}
		var error = _v0.b.a;
		return $krisajenkins$remotedata$RemoteData$Failure(error);
	});
var $krisajenkins$remotedata$RemoteData$map2 = F3(
	function (f, a, b) {
		return A2(
			$krisajenkins$remotedata$RemoteData$andMap,
			b,
			A2($krisajenkins$remotedata$RemoteData$map, f, a));
	});
var $krisajenkins$remotedata$RemoteData$fromList = A2(
	$elm$core$List$foldr,
	$krisajenkins$remotedata$RemoteData$map2($elm$core$List$cons),
	$krisajenkins$remotedata$RemoteData$Success(_List_Nil));
var $author$project$Dashboards2$Detail$getLocationsForDashboardIdByNamespaces = F2(
	function (store, dashboardId) {
		var _v0 = A2($author$project$Store$Utils$get, store.v, dashboardId);
		if (!_v0.$) {
			var dashboard = _v0.a;
			return A2(
				$krisajenkins$remotedata$RemoteData$andThen,
				$author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces(store),
				$author$project$Data$Platform2$toFullyLoadedDashboard(dashboard));
		} else {
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Dashboards2$Detail$getNamespaceCodes = F2(
	function (store, dashboardOrId) {
		if (dashboardOrId.$ === 1) {
			var dashboardId = dashboardOrId.a;
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Data$Platform2$dashboardNamespaceCodes(store.es),
						$turboMaCk$any_set$Set$Any$toList),
					A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeR, $author$project$Data$Platform2$toFullyLoadedDashboard, $krisajenkins$remotedata$RemoteData$toMaybe),
						A2($author$project$Store$Utils$get, store.v, dashboardId))));
		} else {
			var dashboard = dashboardOrId.a;
			return $turboMaCk$any_set$Set$Any$toList(
				A2($author$project$Data$Platform2$dashboardNamespaceCodes, store.es, dashboard));
		}
	});
var $author$project$Dashboards2$Detail$getWavesForDashboardIdByNamespaces = F2(
	function (store, dashboardId) {
		var _v0 = A2($author$project$Store$Utils$get, store.v, dashboardId);
		if (!_v0.$) {
			var dashboard = _v0.a;
			return A2(
				$krisajenkins$remotedata$RemoteData$andThen,
				$author$project$Dashboards2$Detail$getWavesForDashboardByNamespaces(store),
				$author$project$Data$Platform2$toFullyLoadedDashboard(dashboard));
		} else {
			return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Dashboards2$Detail$storeLoadStatus = F3(
	function (flags, maybeDashboardId, store) {
		var waves = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict),
			$author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? function (dashboardId) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					function (dashboard) {
						return A2($author$project$Store$Platform2$getWavesByDashboardId, dashboard.b, store);
					},
					A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeR, $author$project$Data$Platform2$toFullyLoadedDashboard, $krisajenkins$remotedata$RemoteData$toMaybe),
						A2($author$project$Store$Utils$get, store.v, dashboardId)));
			} : $author$project$Dashboards2$Detail$getWavesForDashboardIdByNamespaces(store),
			maybeDashboardId);
		var namespaceCodes = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Dashboards2$Detail$SavedDashboardId,
				$author$project$Dashboards2$Detail$getNamespaceCodes(store)),
			maybeDashboardId);
		var locations = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict),
			$author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? function (dashboardId) {
				return A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					function (dashboard) {
						return A2($author$project$Store$Platform2$getLocationsByDashboardId, dashboard.b, store);
					},
					A2(
						$elm$core$Maybe$andThen,
						A2($elm$core$Basics$composeR, $author$project$Data$Platform2$toFullyLoadedDashboard, $krisajenkins$remotedata$RemoteData$toMaybe),
						A2($author$project$Store$Utils$get, store.v, dashboardId)));
			} : $author$project$Dashboards2$Detail$getLocationsForDashboardIdByNamespaces(store),
			maybeDashboardId);
		var lineages = function () {
			if ($author$project$Data$User$hasOpenAccessPlan(flags.mQ)) {
				return $krisajenkins$remotedata$RemoteData$Success(0);
			} else {
				var _v2 = A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return $krisajenkins$remotedata$RemoteData$toMaybe(
							A2($author$project$Store$Platform2$getDashboard, id, store.v));
					},
					maybeDashboardId);
				if (_v2.$ === 1) {
					return $krisajenkins$remotedata$RemoteData$Success(0);
				} else {
					var dashboard = _v2.a;
					var _v3 = A2($author$project$Data$Platform2$findDeepestDataset, dashboard.es, store.es);
					if (_v3.$ === 1) {
						return $krisajenkins$remotedata$RemoteData$Success(0);
					} else {
						var baseNamespaceCode = _v3.a.jt;
						var _v4 = A2($turboMaCk$any_dict$Dict$Any$get, baseNamespaceCode, store.cB);
						if (_v4.$ === 1) {
							return $krisajenkins$remotedata$RemoteData$NotAsked;
						} else {
							return $krisajenkins$remotedata$RemoteData$Success(0);
						}
					}
				}
			}
		}();
		var ignoreData = function (data) {
			return A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (_v1) {
					return 0;
				},
				data);
		};
		var mergeStatus = function (results) {
			return ignoreData(
				$krisajenkins$remotedata$RemoteData$fromList(results));
		};
		var splitters = mergeStatus(
			A2(
				$elm$core$List$map,
				function (namespaceCode) {
					return ignoreData(
						A2($author$project$Store$Platform2$getSplitters, namespaceCode, store));
				},
				namespaceCodes));
		var dashboardDetail = function () {
			if (maybeDashboardId.$ === 1) {
				return $krisajenkins$remotedata$RemoteData$Success(0);
			} else {
				var dashboardId = maybeDashboardId.a;
				return ignoreData(
					A2($author$project$Store$Platform2$getDashboardFullyLoaded, dashboardId, store.v));
			}
		}();
		var audienceFolders = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? $krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict) : store.jm;
		return mergeStatus(
			_List_fromArray(
				[
					ignoreData(locations),
					ignoreData(waves),
					ignoreData(store.d9),
					ignoreData(audienceFolders),
					ignoreData(store.v),
					ignoreData(store.es),
					lineages,
					splitters,
					dashboardDetail
				]));
	});
var $author$project$Dashboards2$updateWidgetsPure = F5(
	function (flags, updateWidget, store, route, model) {
		var updateModel = F3(
			function (widget, widgetModel, accModel) {
				var newWidgetModel = A3(updateWidget, store, widget, widgetModel);
				return A2(
					$author$project$Dashboards2$updateWidgets,
					A2($turboMaCk$any_dict$Dict$Any$insert, widget.b, newWidgetModel),
					accModel);
			});
		var dashboardId = $author$project$Dashboards2$Router$getDashboardId(route);
		return $krisajenkins$remotedata$RemoteData$isSuccess(
			A3($author$project$Dashboards2$Detail$storeLoadStatus, flags, dashboardId, store)) ? A2(
			$elm$core$Maybe$withDefault,
			model,
			A2(
				$elm$core$Maybe$map,
				function (dashboard) {
					return A6(
						$author$project$Dashboards2$foldWidgets,
						updateModel,
						model,
						{
							ey: $author$project$Dashboards2$Detail$isEditMode(model.o)
						},
						dashboard,
						store,
						$author$project$Dashboards2$Detail$currentWidgets(model));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return $krisajenkins$remotedata$RemoteData$toMaybe(
							A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
					},
					dashboardId))) : model;
	});
var $author$project$Dashboards2$initUserFiltersIfNeeded = F5(
	function (config, flags, route, store, model) {
		var reloadDataIfFiltersChanged = function (_v3) {
			var model_ = _v3.a;
			var cmds = _v3.b;
			return A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(model_, cmds),
				A3(
					$elm$core$Maybe$map2,
					F2(
						function (oldFilters, newFilters) {
							return ((!_Utils_eq(
								$author$project$Dashboards2$UserFilters$toComparable(oldFilters),
								$author$project$Dashboards2$UserFilters$toComparable(newFilters))) ? A2(
								$turboMaCk$glue$Glue$updateWith,
								$turboMaCk$glue$Glue$id,
								A4($author$project$Dashboards2$requestDataForAllWidgets, config, flags, route, store)) : $elm$core$Basics$identity)(
								_Utils_Tuple2(model_, cmds));
						}),
					$author$project$Dashboards2$getUserFilters(model),
					$author$project$Dashboards2$getUserFilters(model_)));
		};
		var maybeDashboard = function () {
			switch (route.$) {
				case 2:
					return A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							A2($author$project$Dashboards2$getNewEmptyDashboard, flags, store),
							$krisajenkins$remotedata$RemoteData$toMaybe),
						model.dk);
				case 1:
					return A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				case 4:
					return $elm$core$Maybe$Nothing;
				case 3:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		}();
		var aplyNewFiltersToWidgets = A2(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			function (m) {
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						m,
						function (userFilters) {
							return A5(
								$author$project$Dashboards2$updateWidgetsPure,
								flags,
								$author$project$Dashboards2$Widget$updateWidgetsChartDataWithFilters(userFilters),
								store,
								route,
								m);
						},
						$author$project$Dashboards2$getUserFilters(m)));
			});
		if ($author$project$Dashboards2$Editable$isNotReady(
			$author$project$Dashboards2$Detail$currentEditableUserFilters(model))) {
			if (!maybeDashboard.$) {
				var dashboard = maybeDashboard.a;
				return aplyNewFiltersToWidgets(
					A6($author$project$Dashboards2$initUserFilters, config, flags, dashboard, route, store, model));
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		} else {
			return aplyNewFiltersToWidgets(
				reloadDataIfFiltersChanged(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						A2(
							$author$project$Dashboards2$updateCurrentUserFilters,
							function (editableUserFilters) {
								var _v1 = _Utils_Tuple2(
									$author$project$Dashboards2$Editable$get(editableUserFilters),
									maybeDashboard);
								if ((!_v1.a.$) && (!_v1.b.$)) {
									var userFilters = _v1.a.a;
									var dashboard = _v1.b.a;
									return $author$project$Dashboards2$Editable$initReady(
										A4($author$project$Dashboards2$reInitUserFilter, flags, dashboard, store, userFilters));
								} else {
									return editableUserFilters;
								}
							},
							model))));
		}
	});
var $author$project$Dashboards2$init = F4(
	function (config, flags, route, store) {
		return A2(
			$author$project$Dashboards2$checkWidgetVisibility,
			config,
			A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
				$author$project$Gwi$Browser$Dom$debouncedScrollEvent($author$project$Dashboards2$Detail$audiencesPanelScrollableId),
				A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Gwi$Browser$Dom$debouncedScrollEvent($author$project$Dashboards2$Detail$detailScrollContainerId),
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
						A2(
							$elm$core$Task$perform,
							A2($elm$core$Basics$composeR, $author$project$Dashboards2$SetTime, config.a),
							A3($elm$core$Task$map2, $elm$core$Tuple$pair, $elm$time$Time$here, $elm$time$Time$now)),
						A5(
							$author$project$Dashboards2$initUserFiltersIfNeeded,
							config,
							flags,
							route,
							store,
							{
								db: $elm$core$Maybe$Nothing,
								bP: $elm$core$Maybe$Nothing,
								d8: $author$project$Dashboards2$audiencesReorderSystem.k8,
								ec: $elm$core$Maybe$Nothing,
								dh: $turboMaCk$queue$Queue$empty,
								dk: $elm$core$Maybe$Nothing,
								aW: $elm$core$Maybe$Nothing,
								aY: $author$project$Data$Id$emptySet,
								aJ: $author$project$Platform2$Drawers$init,
								o: $author$project$Dashboards2$Detail$NotEditing,
								cC: $author$project$Dashboards2$List$init(flags),
								a2: $elm$core$Maybe$Nothing,
								c: $author$project$Dashboards2$Modal$NoModal,
								cJ: $author$project$Platform2$Notification$Queue$emptyWithLimit(1),
								b4: _List_Nil,
								a6: $elm$core$Maybe$Nothing,
								cV: 2,
								dM: $elm$core$Maybe$Nothing,
								dN: false,
								dS: $elm$core$Maybe$Nothing,
								dT: false,
								G: $author$project$Dashboards2$emptyUndoRedo,
								ba: $elm$core$Maybe$Nothing
							})))));
	});
var $author$project$Data$Platform2$simpleFiltersToComparable = function (filters) {
	return A2(
		$elm$core$String$join,
		'|',
		_List_fromArray(
			[
				'B:' + function () {
				var _v0 = filters.aU;
				if (_v0.$ === 1) {
					return '';
				} else {
					var id = _v0.a.b;
					return $author$project$Data$Id$unwrap(id);
				}
			}(),
				'A:' + A2(
				$elm$core$String$join,
				',',
				$elm$core$List$sort(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.b;
							},
							$author$project$Data$Id$unwrap),
						filters.d9))),
				'W:' + A2(
				$elm$core$String$join,
				',',
				A2($elm$core$List$map, $author$project$Data$Id$unwrap, filters.dX)),
				'L:' + A2(
				$elm$core$String$join,
				',',
				A2($elm$core$List$map, $author$project$Data$Id$unwrap, filters.cD))
			]));
};
var $author$project$Data$Platform2$widgetToComparable = function (widget) {
	var collectionToComparable = F2(
		function (toComparable, c) {
			if (!c.$) {
				return 'implicit';
			} else {
				var nList = c.a;
				return A2(
					$elm$core$String$join,
					'--',
					$elm$core$List$sort(
						A2(
							$elm$core$List$map,
							toComparable,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(nList))));
			}
		});
	var _v0 = widget.U;
	if (!_v0.$) {
		var chartWidget = _v0.a;
		return A2(
			$elm$core$String$join,
			'||',
			_List_fromArray(
				[
					'data:' + function () {
					var _v1 = chartWidget.cl;
					if (!_v1.$) {
						var data = _v1.a;
						return A2(
							$elm$core$String$join,
							'|',
							$elm$core$List$sort(
								_List_fromArray(
									[
										'q:' + $author$project$Data$Id$unwrap(data.at),
										'dtps:' + A2(collectionToComparable, $author$project$Data$Id$unwrap, data.hw),
										's:' + A2(collectionToComparable, $author$project$Data$Id$unwrap, data.eY)
									])));
					} else {
						var data = _v1.a;
						return A2(
							$elm$core$String$join,
							'|',
							$elm$core$List$sort(
								A2(
									$elm$core$List$map,
									function (_v2) {
										var questionCode = _v2.at;
										var datapoints = _v2.er;
										return A2(
											$elm$core$String$join,
											'|',
											_List_fromArray(
												[
													'q:' + $author$project$Data$Id$unwrap(questionCode),
													'dpts:' + A2(
													collectionToComparable,
													function (_v3) {
														var dtpCode = _v3.a;
														var suffixes = _v3.b;
														return A2(
															$elm$core$String$join,
															'|',
															_List_fromArray(
																[
																	'dtp:' + $author$project$Data$Id$unwrap(dtpCode),
																	's:' + A2(
																	$elm$core$String$join,
																	'--',
																	$elm$core$List$sort(
																		A2($elm$core$List$map, $author$project$Data$Id$unwrap, suffixes)))
																]));
													},
													datapoints)
												]));
									},
									$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(data))));
					}
				}(),
					'b:' + function () {
					var _v4 = chartWidget.aU;
					if (!_v4.$) {
						var chartBaseAudience = _v4.a.fp;
						return 'from-d:' + A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							'nope',
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.b;
								},
								$author$project$Data$Id$unwrap),
							chartBaseAudience);
					} else {
						var chartBaseAudience = _v4.a;
						return 'from-c:' + $author$project$Data$Id$unwrap(chartBaseAudience.b);
					}
				}(),
					'ct:' + $author$project$D3Charts$Dashboards$ChartType$toString(chartWidget.aI)
				]));
	} else {
		return $author$project$Data$Id$unwrap(widget.b);
	}
};
var $author$project$Store$Platform2$init = {
	g6: $krisajenkins$remotedata$RemoteData$NotAsked,
	jm: $krisajenkins$remotedata$RemoteData$NotAsked,
	d9: $krisajenkins$remotedata$RemoteData$NotAsked,
	jq: $author$project$Data$Id$emptyDict,
	nD: $krisajenkins$remotedata$RemoteData$NotAsked,
	ac: $krisajenkins$remotedata$RemoteData$NotAsked,
	jE: $krisajenkins$remotedata$RemoteData$NotAsked,
	fr: $krisajenkins$remotedata$RemoteData$NotAsked,
	v: $krisajenkins$remotedata$RemoteData$NotAsked,
	jU: $krisajenkins$remotedata$RemoteData$NotAsked,
	of: $krisajenkins$remotedata$RemoteData$NotAsked,
	es: $krisajenkins$remotedata$RemoteData$NotAsked,
	fC: $krisajenkins$remotedata$RemoteData$NotAsked,
	kF: $krisajenkins$remotedata$RemoteData$NotAsked,
	pk: $author$project$Data$Id$emptyDict,
	cB: $author$project$Data$Id$emptyDict,
	cD: $krisajenkins$remotedata$RemoteData$NotAsked,
	pJ: $author$project$Data$Id$emptyDict,
	pK: $author$project$Data$Id$emptyDict,
	$9: $turboMaCk$any_dict$Dict$Any$empty(
		A2($elm$core$Tuple$mapBoth, $author$project$Data$Platform2$simpleFiltersToComparable, $author$project$Data$Platform2$widgetToComparable)),
	bt: $author$project$Data$Id$emptyDict,
	cP: $author$project$Data$Id$emptyDict,
	gB: $author$project$Data$Id$emptyDict,
	gC: $author$project$Data$Id$emptyDict,
	rm: $author$project$Data$Id$emptyDict,
	cZ: $author$project$Data$Id$emptyDict,
	mx: $krisajenkins$remotedata$RemoteData$NotAsked,
	rT: $krisajenkins$remotedata$RemoteData$NotAsked,
	mK: $krisajenkins$remotedata$RemoteData$NotAsked,
	dX: $krisajenkins$remotedata$RemoteData$NotAsked,
	sd: $author$project$Data$Id$emptyDict,
	se: $author$project$Data$Id$emptyDict
};
var $author$project$Dashboards2Main$init = function (flags) {
	var updateDashboardsFieldIfViewOnly = function (store) {
		return $author$project$Data$User$hasOpenAccessPlan(flags.mQ) ? _Utils_update(
			store,
			{
				v: $krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict)
			}) : store;
	};
	var route = $author$project$Dashboards2$Router$DashboardsList;
	var platform2Store_ = $author$project$Store$Platform2$init;
	var _v0 = A4($author$project$Dashboards2$init, $author$project$Dashboards2Main$dashboardsConfig, flags, route, platform2Store_);
	var d2model = _v0.a;
	var d2msg = _v0.b;
	return _Utils_Tuple2(
		$elm$core$Result$Ok(
			{
				aX: $author$project$Dashboards2Main$dashboardsConfig,
				bD: d2model,
				oN: flags,
				gi: true,
				s: updateDashboardsFieldIfViewOnly(platform2Store_),
				af: route,
				dH: $elm$core$Maybe$Nothing,
				e4: $elm$core$Maybe$Nothing,
				c3: $elm$core$Maybe$Nothing,
				g3: $elm$time$Time$utc
			}),
		$elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					d2msg,
					A2($elm$core$Task$perform, $author$project$Dashboards2Main$UpdateZone, $elm$time$Time$here)
				])));
};
var $author$project$Dashboards2Main$init_ = function (flags_) {
	var _v0 = $author$project$Config$decode(flags_);
	if (!_v0.$) {
		var flags = _v0.a;
		return $author$project$Dashboards2Main$init(flags);
	} else {
		var err = _v0.a;
		return _Utils_Tuple2(
			$elm$core$Result$Err(
				$author$project$Dashboards2Main$InitializationError(err)),
			$elm$core$Platform$Cmd$none);
	}
};
var $author$project$Dashboards2Main$ChangeMountingState = function (a) {
	return {$: 10, a: a};
};
var $author$project$Dashboards2Main$CheckInterruptRouting = function (a) {
	return {$: 32, a: a};
};
var $author$project$Dashboards2Main$RouteChanged = function (a) {
	return {$: 21, a: a};
};
var $author$project$Dashboards2Main$SetNewAccessToken = function (a) {
	return {$: 39, a: a};
};
var $author$project$Dashboards2Main$SetStateFromGlobalSearch = function (a) {
	return {$: 35, a: a};
};
var $author$project$Dashboards2Main$SetStateFromGlobalSearchError = function (a) {
	return {$: 36, a: a};
};
var $author$project$Dashboards2Main$SetStateFromKernel = function (a) {
	return {$: 38, a: a};
};
var $author$project$Dashboards2Main$checkRouteInterruption = _Platform_incomingPort('checkRouteInterruption', $elm$json$Json$Decode$string);
var $author$project$Data$Metric$AudiencePercentage = 0;
var $author$project$Data$Platform2$CreateDashboardFromKernel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Platform2$CreateDashboardFromKernelData = F6(
	function (baseAudience, audiences, widgets, wavesCodes, locationCodes, datasetCodes) {
		return {d9: audiences, aU: baseAudience, fB: datasetCodes, ga: locationCodes, g1: wavesCodes, g: widgets};
	});
var $author$project$Data$Core$DatapointsSort$Default = 3;
var $author$project$Data$Platform2$InheritedFromDashboard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Platform2$RichText = function (a) {
	return {$: 1, a: a};
};
var $author$project$D3Charts$Dashboards$ChartType$DataTable = 0;
var $author$project$D3Charts$Dashboards$ChartType$DivergingBarChart = 1;
var $author$project$D3Charts$Dashboards$ChartType$DonutChart = 2;
var $author$project$D3Charts$Dashboards$ChartType$PieChart = 5;
var $author$project$D3Charts$Dashboards$ChartType$PieRadarChart = 6;
var $author$project$D3Charts$Dashboards$ChartType$RadialBarChart = 8;
var $author$project$D3Charts$Dashboards$ChartType$decoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		switch (string) {
			case 'data_table':
				return $elm$json$Json$Decode$succeed(0);
			case 'donut_chart':
				return $elm$json$Json$Decode$succeed(2);
			case 'donut_chart2':
				return $elm$json$Json$Decode$succeed(2);
			case 'line_chart':
				return $elm$json$Json$Decode$succeed(4);
			case 'pie_chart':
				return $elm$json$Json$Decode$succeed(5);
			case 'stat_card':
				return $elm$json$Json$Decode$succeed(9);
			case 'stat_card_colored':
				return $elm$json$Json$Decode$succeed(10);
			case 'vertical_bar_chart':
				return $elm$json$Json$Decode$succeed(11);
			case 'horizontal_bar_chart':
				return $elm$json$Json$Decode$succeed(3);
			case 'radial_bar_chart':
				return $elm$json$Json$Decode$succeed(8);
			case 'diverging_bar_chart':
				return $elm$json$Json$Decode$succeed(1);
			case 'pie_radar_chart':
				return $elm$json$Json$Decode$succeed(6);
			case 'radar_chart':
				return $elm$json$Json$Decode$succeed(7);
			default:
				return $elm$json$Json$Decode$fail('Invalid Dashboards ChartType: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Metric$DataPointPercentage = 1;
var $author$project$Data$Metric$Responses = 4;
var $author$project$Data$Metric$Universe = 2;
var $author$project$Data$Metric$decoder = function () {
	var decode = function (metric) {
		switch (metric) {
			case 'percentage':
				return $elm$json$Json$Decode$succeed(0);
			case 'horizontal_percentage':
				return $elm$json$Json$Decode$succeed(1);
			case 'weighted_universe_count':
				return $elm$json$Json$Decode$succeed(2);
			case 'index':
				return $elm$json$Json$Decode$succeed(3);
			case 'responses_count':
				return $elm$json$Json$Decode$succeed(4);
			case 'count':
				return $elm$json$Json$Decode$succeed(4);
			default:
				return $elm$json$Json$Decode$fail('Invalid Metric type: ' + metric);
		}
	};
	return A2($elm$json$Json$Decode$andThen, decode, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Platform2$RichTextWidget$RichText = function (paragraphs) {
	return {qt: paragraphs};
};
var $author$project$Data$Platform2$RichTextWidget$Paragraph = F2(
	function (content, style) {
		return {U: content, k: style};
	});
var $author$project$Data$Platform2$RichTextWidget$Style = F4(
	function (size, bold, underline, mainStyle) {
		return {de: bold, ae: mainStyle, cX: size, dU: underline};
	});
var $author$project$Data$Platform2$RichTextWidget$BulletpointList = {$: 1};
var $author$project$Data$Platform2$RichTextWidget$Quote = {$: 2};
var $author$project$Data$Platform2$RichTextWidget$Center = 1;
var $author$project$Data$Platform2$RichTextWidget$Right = 2;
var $author$project$Data$Platform2$RichTextWidget$alignDecoder = function () {
	var decode = function (str) {
		switch (str) {
			case 'Left':
				return $elm$json$Json$Decode$succeed(0);
			case 'Right':
				return $elm$json$Json$Decode$succeed(2);
			case 'Center':
				return $elm$json$Json$Decode$succeed(1);
			default:
				return $elm$json$Json$Decode$fail('Unknonw align type ' + str);
		}
	};
	return A2($elm$json$Json$Decode$andThen, decode, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Platform2$RichTextWidget$mainStyleDecoder = function () {
	var decode = function (str) {
		switch (str) {
			case 'Normal':
				return A2(
					$elm$json$Json$Decode$map,
					function (a) {
						return $author$project$Data$Platform2$RichTextWidget$Normal(
							{fe: a});
					},
					A2($elm$json$Json$Decode$field, 'align', $author$project$Data$Platform2$RichTextWidget$alignDecoder));
			case 'BulletpointList':
				return $elm$json$Json$Decode$succeed($author$project$Data$Platform2$RichTextWidget$BulletpointList);
			case 'Quote':
				return $elm$json$Json$Decode$succeed($author$project$Data$Platform2$RichTextWidget$Quote);
			default:
				return $elm$json$Json$Decode$fail('Unknonw main style type ' + str);
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		decode,
		A2($elm$json$Json$Decode$field, 'style_type', $elm$json$Json$Decode$string));
}();
var $author$project$Data$Platform2$RichTextWidget$Heading1 = 1;
var $author$project$Data$Platform2$RichTextWidget$Heading2 = 2;
var $author$project$Data$Platform2$RichTextWidget$Title = 0;
var $author$project$Data$Platform2$RichTextWidget$sizeDecoder = function () {
	var decode = function (str) {
		switch (str) {
			case 'Title':
				return $elm$json$Json$Decode$succeed(0);
			case 'Heading1':
				return $elm$json$Json$Decode$succeed(1);
			case 'Heading2':
				return $elm$json$Json$Decode$succeed(2);
			case 'Body':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unknonw size ' + str);
		}
	};
	return A2($elm$json$Json$Decode$andThen, decode, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Platform2$RichTextWidget$styleDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'main_style', $author$project$Data$Platform2$RichTextWidget$mainStyleDecoder),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'underline', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'bold', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'size', $author$project$Data$Platform2$RichTextWidget$sizeDecoder),
				$elm$json$Json$Decode$succeed($author$project$Data$Platform2$RichTextWidget$Style)))));
var $author$project$Data$Platform2$RichTextWidget$paragraphDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault($author$project$Data$Platform2$RichTextWidget$defaultStyle),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'style', $author$project$Data$Platform2$RichTextWidget$styleDecoder)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'content', $elm$json$Json$Decode$string),
		$elm$json$Json$Decode$succeed($author$project$Data$Platform2$RichTextWidget$Paragraph)));
var $author$project$Data$Platform2$RichTextWidget$decoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'paragraphs',
		$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($author$project$Data$Platform2$RichTextWidget$paragraphDecoder)),
	$elm$json$Json$Decode$succeed($author$project$Data$Platform2$RichTextWidget$RichText));
var $author$project$Data$Platform2$nullId = $author$project$Data$Id$fromString('encode-this-id-as-null');
var $author$project$Data$Platform2$createDashboardSharedStateDecoder = function () {
	var decodeSharedWidgetData = A2(
		$elm$json$Json$Decode$andThen,
		function (widgetData) {
			if (widgetData.b) {
				var _v3 = widgetData.a;
				var metric = _v3.a;
				var _v4 = $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
					A2($elm$core$List$map, $elm$core$Tuple$second, widgetData));
				if (!_v4.$) {
					var data = _v4.a;
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							metric,
							$author$project$Data$Platform2$GroupedData(data)));
				} else {
					return $elm$json$Json$Decode$fail('Invalid widget data');
				}
			} else {
				return $elm$json$Json$Decode$fail('Invalid widget data');
			}
		},
		$elm$json$Json$Decode$list(
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'metric', $author$project$Data$Metric$decoder),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'question', $author$project$Data$Id$decode),
					$elm$json$Json$Decode$succeed(
						F2(
							function (questionCode, maybeMetric) {
								return _Utils_Tuple2(
									A2($elm$core$Maybe$withDefault, 0, maybeMetric),
									{er: $author$project$Data$Platform2$Implicit, at: questionCode});
							}))))));
	var deocodeSharedWidget = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'rich_content', $author$project$Data$Platform2$RichTextWidget$decoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'data', decodeSharedWidgetData),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'position', $elm$json$Json$Decode$float),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'chart_type', $author$project$D3Charts$Dashboards$ChartType$decoder),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
								$elm$json$Json$Decode$succeed(
									F7(
										function (name, chartType, height, width, position, maybeData, maybeRichContent) {
											var content = function () {
												var _v0 = _Utils_Tuple2(maybeData, maybeRichContent);
												if (!_v0.a.$) {
													var _v1 = _v0.a.a;
													var metric = _v1.a;
													var widgetData = _v1.b;
													return $author$project$Data$Platform2$ChartContent(
														{
															aU: $author$project$Data$Platform2$InheritedFromDashboard(
																{fp: $elm$core$Maybe$Nothing}),
															aI: chartType,
															cl: widgetData,
															dB: metric,
															ld: name,
															b2: '',
															cY: 3
														});
												} else {
													if (!_v0.b.$) {
														var richContent = _v0.b.a;
														return $author$project$Data$Platform2$RichText(richContent);
													} else {
														return $author$project$Data$Platform2$RichText(
															{
																qt: _Utils_Tuple2(
																	{U: '', k: $author$project$Data$Platform2$RichTextWidget$defaultStyle},
																	_List_Nil)
															});
													}
												}
											}();
											return {
												U: content,
												bf: $author$project$Data$Id$fromString('not-defined-yet-pls-fill'),
												cv: height,
												b: $author$project$Data$Platform2$nullId,
												lB: position,
												da: width
											};
										})))))))));
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Platform2$CreateDashboardFromKernel,
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'datasetCodes',
				$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'location_codes',
					$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'wave_codes',
						$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$field,
							'widgets',
							$elm$json$Json$Decode$list(deocodeSharedWidget)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$map,
								$elm_community$maybe_extra$Maybe$Extra$filter(
									A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
									'audiences',
									$elm$json$Json$Decode$list($author$project$Data$Id$decode))),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'base_audience', $author$project$Data$Id$decode),
								$elm$json$Json$Decode$succeed($author$project$Data$Platform2$CreateDashboardFromKernelData))))))));
}();
var $author$project$Data$Platform2$GlobalSearchSharedState = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Platform2$GlobalSearchSharedStateData = F6(
	function (audienceId, attributes, datasetCodes, wavesCodes, locationCodes, chartId) {
		return {d7: attributes, jn: audienceId, nS: chartId, fB: datasetCodes, ga: locationCodes, g1: wavesCodes};
	});
var $author$project$Data$Platform2$AttributeCodes = F3(
	function (datapointCode, questionCode, suffixCode) {
		return {eq: datapointCode, at: questionCode, iT: suffixCode};
	});
var $author$project$Data$Platform2$emptyStringAsNothing = F2(
	function (toExpectedType, s) {
		return $elm$core$String$isEmpty(s) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			toExpectedType(s));
	});
var $author$project$Data$Platform2$attributeCodesDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$andThen(
			$author$project$Data$Platform2$emptyStringAsNothing($author$project$Data$Id$fromString)),
		A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'suffix_code', $elm$json$Json$Decode$string)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'question_code', $author$project$Data$Id$decode),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'datapoint_code', $author$project$Data$Id$decode),
			$elm$json$Json$Decode$succeed($author$project$Data$Platform2$AttributeCodes))));
var $author$project$Data$Platform2$globalSearchSharedStateDecoder = function () {
	var toChartAttribute = F2(
		function (codes, namespace) {
			var combinedCodes = $author$project$Data$Id$fromString(
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					F2(
						function (sCode, dtpCode) {
							return dtpCode + ('_' + $author$project$Data$Id$unwrap(sCode));
						}),
					codes.iT,
					$author$project$Data$Id$unwrap(codes.eq)));
			return {eq: combinedCodes, id: namespace, at: codes.at};
		});
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Data$Platform2$GlobalSearchSharedState,
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'chartId', $author$project$Data$Id$decode),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'locationCodes',
					$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'wavesCodes',
						$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$field,
							'datasetCodes',
							$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'attributes',
								$elm$json$Json$Decode$list(
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'namespace_code', $author$project$Data$Id$decode),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											$author$project$Data$Platform2$attributeCodesDecoder,
											$elm$json$Json$Decode$succeed(toChartAttribute))))),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'audienceId', $author$project$Data$Id$decode),
								$elm$json$Json$Decode$succeed($author$project$Data$Platform2$GlobalSearchSharedStateData))))))));
}();
var $author$project$Dashboards2Main$mountD2 = _Platform_incomingPort(
	'mountD2',
	$elm$json$Json$Decode$null(0));
var $author$project$Dashboards2Main$routeChangedD2 = _Platform_incomingPort('routeChangedD2', $elm$json$Json$Decode$string);
var $author$project$Ports$setNewAccessToken = _Platform_incomingPort('setNewAccessToken', $elm$json$Json$Decode$string);
var $author$project$Dashboards2Main$setSharedStateFromKernel = _Platform_incomingPort('setSharedStateFromKernel', $elm$json$Json$Decode$value);
var $author$project$Dashboards2$CloseDropdown = {$: 66};
var $author$project$Dashboards2$CloseModal = {$: 37};
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Gwi$Browser$Dom$onScrollEnd_ = _Platform_incomingPort(
	'onScrollEnd_',
	A2(
		$elm$json$Json$Decode$andThen,
		function (_v0) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (_v1) {
					return A2(
						$elm$json$Json$Decode$andThen,
						function (_v2) {
							return $elm$json$Json$Decode$succeed(
								_Utils_Tuple3(_v0, _v1, _v2));
						},
						A2($elm$json$Json$Decode$index, 2, $elm$json$Json$Decode$int));
				},
				A2($elm$json$Json$Decode$index, 1, $elm$json$Json$Decode$int));
		},
		A2($elm$json$Json$Decode$index, 0, $elm$json$Json$Decode$string)));
var $author$project$Gwi$Browser$Dom$onScrollStart_ = _Platform_incomingPort('onScrollStart_', $elm$json$Json$Decode$string);
var $author$project$Gwi$Browser$Dom$batchRegister = function (config) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Gwi$Browser$Dom$onScrollEnd_(
				function (_v0) {
					var id = _v0.a;
					var x = _v0.b;
					var y = _v0.c;
					var _v1 = A2($elm$core$Dict$get, id, config.p5);
					if (!_v1.$) {
						var msg = _v1.a;
						return msg(
							_Utils_Tuple2(x, y));
					} else {
						return config.y;
					}
				}),
				$author$project$Gwi$Browser$Dom$onScrollStart_(
				function (id) {
					var _v2 = A2($elm$core$Dict$get, id, config.p6);
					if (!_v2.$) {
						var msg = _v2.a;
						return msg;
					} else {
						return config.y;
					}
				})
			]));
};
var $author$project$Platform2$Dropdown$DropdownMenu$isAnyVisible = function (ddm) {
	if (!ddm.$) {
		return false;
	} else {
		return true;
	}
};
var $elm$core$Platform$Sub$map = _Platform_map;
var $elm$browser$Browser$Events$onClick = A2($elm$browser$Browser$Events$on, 0, 'click');
var $elm$browser$Browser$Events$onKeyUp = A2($elm$browser$Browser$Events$on, 0, 'keyup');
var $author$project$Dashboards2$EnableEditModeWithPermissionsCheck = {$: 76};
var $elm$browser$Browser$Events$onKeyDown = A2($elm$browser$Browser$Events$on, 0, 'keydown');
var $author$project$Dashboards2$subscribeKeyShortcuts = $elm$browser$Browser$Events$onKeyDown(
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
			$elm$json$Json$Decode$succeed(
				F2(
					function (_char, ctrl) {
						var _v0 = _Utils_Tuple2(
							ctrl,
							$elm$core$String$toLower(_char));
						if (_v0.a && (_v0.b === 'e')) {
							return $author$project$Dashboards2$EnableEditModeWithPermissionsCheck;
						} else {
							return $author$project$Dashboards2$NoOp;
						}
					})))));
var $author$project$Dashboards2$List$CloseDropdown = {$: 8};
var $author$project$Dashboards2$List$subscriptions = F2(
	function (config, model) {
		var isDropdownOpened = !_Utils_eq(model.aA.a, $author$project$Dashboards2$List$NoDropdown);
		return isDropdownOpened ? $elm$browser$Browser$Events$onClick(
			$elm$json$Json$Decode$succeed(
				config.a($author$project$Dashboards2$List$CloseDropdown))) : $elm$core$Platform$Sub$none;
	});
var $author$project$Dashboards2$Widget$CloseDropdown = {$: 7};
var $author$project$Dashboards2$Widget$RichTextEditMsg = function (a) {
	return {$: 15, a: a};
};
var $author$project$Dashboards2$Widget$getDropdownElementId = F2(
	function (widget, widgetDropdown) {
		switch (widgetDropdown.$) {
			case 0:
				return $elm$core$Maybe$Nothing;
			case 1:
				return $elm$core$Maybe$Just(
					$author$project$Data$Id$unwrap(widget.b));
			case 2:
				return $elm$core$Maybe$Just(
					'widget-footer-dropdown-chart-type-' + $author$project$Data$Id$unwrap(widget.b));
			case 3:
				return $elm$core$Maybe$Just(
					'widget-footer-dropdown-metrics-' + $author$project$Data$Id$unwrap(widget.b));
			default:
				return $elm$core$Maybe$Just(
					'widget-footer-dropdown-sort-by-' + $author$project$Data$Id$unwrap(widget.b));
		}
	});
var $author$project$Gwi$Html$Events$isOutside = function (dropdownId) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$andThen,
				function (id) {
					return _Utils_eq(dropdownId, id) ? $elm$json$Json$Decode$succeed(false) : $elm$json$Json$Decode$fail('continue');
				},
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$lazy(
				function (_v0) {
					return A2(
						$elm$json$Json$Decode$field,
						'parentNode',
						$author$project$Gwi$Html$Events$isOutside(dropdownId));
				}),
				$elm$json$Json$Decode$succeed(true)
			]));
};
var $elm$browser$Browser$Events$onMouseDown = A2($elm$browser$Browser$Events$on, 0, 'mousedown');
var $author$project$Dashboards2$StatCard$AutoMove = {$: 2};
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {lI: processes, ms: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.lI;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.ms);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Dashboards2$Chart$subscriptions = F2(
	function (config, chartType) {
		return ((chartType === 9) || (chartType === 10)) ? A2(
			$elm$time$Time$every,
			5000,
			$elm$core$Basics$always(
				config.a(
					$author$project$Dashboards2$Chart$StatCardMsg($author$project$Dashboards2$StatCard$AutoMove)))) : $elm$core$Platform$Sub$none;
	});
var $author$project$Dashboards2$Widget$RichText$CloseDropdown = {$: 6};
var $author$project$Dashboards2$Widget$RichText$CloseEditor = {$: 3};
var $author$project$Dashboards2$Widget$RichText$paragraphElementId = F2(
	function (index, _v0) {
		var uniqueId = _v0.mN;
		return 'rich-text-paragraph--' + (uniqueId + ('--' + $elm$core$String$fromInt(index)));
	});
var $author$project$Dashboards2$Widget$RichText$NoOp = {$: 0};
var $author$project$Dashboards2$Widget$RichText$ParagraphMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Dashboards2$Widget$RichText$SetMainStyle = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboards2$Widget$RichText$ToggleBold = {$: 2};
var $author$project$Dashboards2$Widget$RichText$ToggleUnderline = {$: 3};
var $author$project$Dashboards2$Widget$RichText$subscribeKeyShortcuts = function (editingParagraphIndex) {
	return $elm$browser$Browser$Events$onKeyDown(
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'ctrlKey', $elm$json$Json$Decode$bool),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string),
					$elm$json$Json$Decode$succeed(
						F3(
							function (_char, ctrl, shift) {
								if (!editingParagraphIndex.$) {
									var index = editingParagraphIndex.a;
									var _v1 = _Utils_Tuple3(
										ctrl,
										shift,
										$elm$core$String$toLower(_char));
									_v1$4:
									while (true) {
										if (_v1.a) {
											if (!_v1.b) {
												switch (_v1.c) {
													case 'b':
														return A2(
															$author$project$Dashboards2$Widget$RichText$ParagraphMsg,
															{pi: index},
															$author$project$Dashboards2$Widget$RichText$ToggleBold);
													case 'u':
														return A2(
															$author$project$Dashboards2$Widget$RichText$ParagraphMsg,
															{pi: index},
															$author$project$Dashboards2$Widget$RichText$ToggleUnderline);
													default:
														break _v1$4;
												}
											} else {
												switch (_v1.c) {
													case 'l':
														return A2(
															$author$project$Dashboards2$Widget$RichText$ParagraphMsg,
															{pi: index},
															$author$project$Dashboards2$Widget$RichText$SetMainStyle($author$project$Data$Platform2$RichTextWidget$BulletpointList));
													case '8':
														return A2(
															$author$project$Dashboards2$Widget$RichText$ParagraphMsg,
															{pi: index},
															$author$project$Dashboards2$Widget$RichText$SetMainStyle($author$project$Data$Platform2$RichTextWidget$BulletpointList));
													default:
														break _v1$4;
												}
											}
										} else {
											break _v1$4;
										}
									}
									return $author$project$Dashboards2$Widget$RichText$NoOp;
								} else {
									return $author$project$Dashboards2$Widget$RichText$NoOp;
								}
							}))))));
};
var $author$project$Dashboards2$Widget$RichText$subscriptions = function (model) {
	var outsideTarget = function (targetId) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (isOutside) {
				return isOutside ? $elm$json$Json$Decode$succeed($author$project$Dashboards2$Widget$RichText$CloseEditor) : $elm$json$Json$Decode$fail('inside targeted element');
			},
			A2(
				$elm$json$Json$Decode$field,
				'target',
				$author$project$Gwi$Html$Events$isOutside(targetId)));
	};
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				(!(!model.aA)) ? $elm$browser$Browser$Events$onClick(
				$elm$json$Json$Decode$succeed($author$project$Dashboards2$Widget$RichText$CloseDropdown)) : $elm$core$Platform$Sub$none,
				function () {
				var _v0 = model.bH;
				if (!_v0.$) {
					var index = _v0.a;
					return $elm$browser$Browser$Events$onMouseDown(
						outsideTarget(
							A2($author$project$Dashboards2$Widget$RichText$paragraphElementId, index, model)));
				} else {
					return $elm$core$Platform$Sub$none;
				}
			}(),
				$author$project$Dashboards2$Widget$RichText$subscribeKeyShortcuts(model.bH)
			]));
};
var $author$project$Dashboards2$Widget$subscriptions = F3(
	function (config, widget, model) {
		var outsideTarget = function (targetId) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (isOutside) {
					return isOutside ? $elm$json$Json$Decode$succeed(
						config.a($author$project$Dashboards2$Widget$CloseDropdown)) : $elm$json$Json$Decode$fail('inside targeted element');
				},
				A2(
					$elm$json$Json$Decode$field,
					'target',
					$author$project$Gwi$Html$Events$isOutside(targetId)));
		};
		return $elm$core$Platform$Sub$batch(
			_List_fromArray(
				[
					function () {
					var _v0 = widget.U;
					if (!_v0.$) {
						var chartType = _v0.a.aI;
						return A2($author$project$Dashboards2$Chart$subscriptions, config.ef, chartType);
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}(),
					function () {
					var _v1 = A2($author$project$Dashboards2$Widget$getDropdownElementId, widget, model.w);
					if (_v1.$ === 1) {
						return $elm$core$Platform$Sub$none;
					} else {
						var elementId = _v1.a;
						return $elm$browser$Browser$Events$onMouseDown(
							outsideTarget(elementId));
					}
				}(),
					function () {
					var _v2 = model.ad;
					if (_v2.$ === 1) {
						var rtModel = _v2.a;
						return A2(
							$elm$core$Platform$Sub$map,
							A2($elm$core$Basics$composeR, $author$project$Dashboards2$Widget$RichTextEditMsg, config.a),
							$author$project$Dashboards2$Widget$RichText$subscriptions(rtModel));
					} else {
						return $elm$core$Platform$Sub$none;
					}
				}()
				]));
	});
var $author$project$Dashboards2$subscriptions = F5(
	function (flags, config, route, store, model) {
		var widgetsSubscriptions = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A3(
				$elm$core$Maybe$map2,
				F2(
					function (dashboard, userFilters) {
						return A2(
							$elm$core$List$map,
							function (widget) {
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$elm$core$Platform$Sub$none,
									A2(
										$author$project$Dashboards2$Widget$subscriptions,
										A2(config.V.c8, userFilters, widget),
										widget),
									A2(
										$turboMaCk$any_dict$Dict$Any$get,
										widget.b,
										$author$project$Dashboards2$Detail$currentWidgets(model)));
							},
							dashboard.cl.g);
					}),
				A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model),
				$author$project$Dashboards2$getUserFilters(model)));
		var someDropdownOpened = !(A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			true,
			A2($elm$core$Basics$composeR, $author$project$Platform2$Dropdown$DropdownMenu$isAnyVisible, $elm$core$Basics$not),
			model.db) && _Utils_eq(model.bP, $elm$core$Maybe$Nothing));
		var perRouteSubscriptions = function () {
			switch (route.$) {
				case 1:
					return $elm$core$Platform$Sub$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Sub$map,
								config.a,
								$author$project$Dashboards2$audiencesReorderSystem.mq(model.d8)),
								$author$project$Gwi$Browser$Dom$batchRegister(
								{
									y: config.a($author$project$Dashboards2$NoOp),
									p5: $elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												$author$project$Dashboards2$Detail$detailScrollContainerId,
												$elm$core$Basics$always(
													config.a($author$project$Dashboards2$CheckWidgetsVisibility)))
											])),
									p6: $elm$core$Dict$empty
								}),
								A2($elm$core$Platform$Sub$map, config.a, $author$project$Dashboards2$subscribeKeyShortcuts)
							]));
				case 2:
					return $elm$core$Platform$Sub$none;
				case 3:
					return $elm$core$Platform$Sub$none;
				case 4:
					return $elm$core$Platform$Sub$none;
				default:
					return A2($author$project$Dashboards2$List$subscriptions, config.dy, model.cC);
			}
		}();
		var escDecoder = function (msg) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					if (key === 'Escape') {
						return $elm$json$Json$Decode$succeed(msg);
					} else {
						return $elm$json$Json$Decode$fail('Not the key we\'re interested in');
					}
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
		};
		var modalEscClose = $elm_community$maybe_extra$Maybe$Extra$isJust(model.dM) ? $elm$browser$Browser$Events$onKeyUp(
			escDecoder(
				config.a($author$project$Dashboards2$CloseModal))) : (someDropdownOpened ? $elm$browser$Browser$Events$onKeyUp(
			escDecoder(
				config.a($author$project$Dashboards2$CloseDropdown))) : $elm$core$Platform$Sub$none);
		var editSectionSubscriptions = function () {
			var _v0 = model.o;
			if (_v0.$ === 1) {
				var r = _v0.a;
				return config.V.dl.mq(r.fJ);
			} else {
				return $elm$core$Platform$Sub$none;
			}
		}();
		var closeDropdownSub = someDropdownOpened ? $elm$browser$Browser$Events$onClick(
			$elm$json$Json$Decode$succeed(
				config.a($author$project$Dashboards2$CloseDropdown))) : $elm$core$Platform$Sub$none;
		return $elm$core$Platform$Sub$batch(
			A2(
				$elm$core$List$cons,
				closeDropdownSub,
				A2(
					$elm$core$List$cons,
					perRouteSubscriptions,
					A2(
						$elm$core$List$cons,
						editSectionSubscriptions,
						A2($elm$core$List$cons, modalEscClose, widgetsSubscriptions)))));
	});
var $author$project$Dashboards2Main$unmountD2 = _Platform_incomingPort(
	'unmountD2',
	$elm$json$Json$Decode$null(0));
var $author$project$Dashboards2Main$subscriptions = function (model) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Dashboards2Main$unmountD2(
				function (_v0) {
					return $author$project$Dashboards2Main$ChangeMountingState(false);
				}),
				$author$project$Dashboards2Main$mountD2(
				function (_v1) {
					return $author$project$Dashboards2Main$ChangeMountingState(true);
				}),
				$author$project$Dashboards2Main$checkRouteInterruption($author$project$Dashboards2Main$CheckInterruptRouting),
				$author$project$Dashboards2Main$routeChangedD2($author$project$Dashboards2Main$RouteChanged),
				$author$project$Ports$setNewAccessToken($author$project$Dashboards2Main$SetNewAccessToken),
				A2(
				$elm$core$Result$withDefault,
				$elm$core$Platform$Sub$none,
				A2(
					$elm$core$Result$map,
					function (state) {
						return A5($author$project$Dashboards2$subscriptions, state.oN, state.aX, state.af, state.s, state.bD);
					},
					model)),
				$author$project$Dashboards2Main$setSharedStateFromKernel(
				function (value) {
					var _v2 = A2(
						$elm$json$Json$Decode$decodeValue,
						$elm$json$Json$Decode$oneOf(
							_List_fromArray(
								[$author$project$Data$Platform2$globalSearchSharedStateDecoder, $author$project$Data$Platform2$createDashboardSharedStateDecoder])),
						value);
					if (!_v2.$) {
						if (!_v2.a.$) {
							var sharedState = _v2.a.a;
							return $author$project$Dashboards2Main$SetStateFromGlobalSearch(sharedState);
						} else {
							var dataFromKernel = _v2.a.a;
							return $author$project$Dashboards2Main$SetStateFromKernel(dataFromKernel);
						}
					} else {
						var err = _v2.a;
						return $author$project$Dashboards2Main$SetStateFromGlobalSearchError(
							'Unable to decode shared state: ' + $elm$json$Json$Decode$errorToString(err));
					}
				})
			]));
};
var $author$project$Platform2$Router$AudienceBuilderDetail = function (a) {
	return {$: 1, a: a};
};
var $author$project$Platform2$Router$AudienceBuilderNew = {$: 0};
var $author$project$Platform2$Router$ChartBuilderChart = function (a) {
	return {$: 4, a: a};
};
var $author$project$Platform2$Router$ChartBuilderNewChart = {$: 3};
var $author$project$Platform2$Router$ChartBuilderQuestion = function (a) {
	return {$: 2, a: a};
};
var $author$project$Analytics$Place$DashboardChartsBrowser = 6;
var $author$project$Dashboards2$Analytics$DashboardCreated = function (a) {
	return {$: 10, a: a};
};
var $author$project$Dashboards2$Analytics$DashboardFavourite = function (a) {
	return {$: 21, a: a};
};
var $author$project$Dashboards2$Analytics$DashboardQuestionOpened = F5(
	function (a, b, c, d, e) {
		return {$: 1, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Dashboards2$Analytics$DashboardRenamed = function (a) {
	return {$: 26, a: a};
};
var $author$project$Dashboards2$Analytics$DashboardSaved = function (a) {
	return {$: 20, a: a};
};
var $author$project$Dashboards2$Router$ExternalUrl = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2$Analytics$InsightClicked = function (a) {
	return {$: 27, a: a};
};
var $author$project$Platform2$Router$InsightsDetail = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dashboards2$Router$NotFound = {$: 4};
var $author$project$Dashboards2$Analytics$PreviewChart = function (a) {
	return {$: 34, a: a};
};
var $author$project$Dashboards2Main$StoreActionsAndContinue = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Dashboards2$UserFilters$audiences = function (_v0) {
	var r = _v0;
	return A2(
		$elm$core$List$map,
		function ($) {
			return $.fk;
		},
		r.d9);
};
var $author$project$Store$Platform2$clearDatasets = function (store) {
	return _Utils_update(
		store,
		{es: $krisajenkins$remotedata$RemoteData$NotAsked});
};
var $author$project$Dashboards2Main$clearDatasetsForViewOnly = function (route) {
	switch (route.$) {
		case 0:
			return $elm$core$Result$map(
				function (state) {
					return $author$project$Data$User$hasViewOnlyPlan(state.oN.mQ) ? _Utils_update(
						state,
						{
							s: $author$project$Store$Platform2$clearDatasets(state.s)
						}) : state;
				});
		case 1:
			return $elm$core$Basics$identity;
		case 3:
			return $elm$core$Basics$identity;
		case 4:
			return $elm$core$Basics$identity;
		default:
			return $elm$core$Basics$identity;
	}
};
var $author$project$Config$combinePrefixAndFeature = function (_v0) {
	var feature = _v0.hO;
	var pathPrefix = _v0.ip;
	var _v1 = $elm_community$maybe_extra$Maybe$Extra$values(
		_List_fromArray(
			[feature, pathPrefix]));
	if (!_v1.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var values = _v1;
		return $elm$core$Maybe$Just(
			A2($elm$core$String$join, '/', values));
	}
};
var $author$project$Dashboards2Main$convertDashboardToGroupedData = F2(
	function (store, dashboard) {
		var data = dashboard.cl;
		var questions = A2(
			$turboMaCk$any_dict$Dict$Any$filterMap,
			F2(
				function (_v2, v) {
					return $krisajenkins$remotedata$RemoteData$toMaybe(v);
				}),
			store.bt);
		var convertChartWidget = function (chartWidget) {
			var _v1 = chartWidget.cl;
			if (!_v1.$) {
				var oldData = _v1.a;
				var attrs = A2($author$project$Data$Platform2$oldWidgetDataToGroupedWidgetData, questions, oldData);
				return _Utils_update(
					chartWidget,
					{
						cl: A3($elm_community$maybe_extra$Maybe$Extra$unwrap, chartWidget.cl, $author$project$Data$Platform2$GroupedData, attrs)
					});
			} else {
				return chartWidget;
			}
		};
		var convertWidget = function (widget) {
			var _v0 = widget.U;
			if (_v0.$ === 1) {
				return widget;
			} else {
				var chartWidget = _v0.a;
				return _Utils_update(
					widget,
					{
						U: $author$project$Data$Platform2$ChartContent(
							convertChartWidget(chartWidget))
					});
			}
		};
		return _Utils_update(
			dashboard,
			{
				cl: _Utils_update(
					data,
					{
						g: A2($elm$core$List$map, convertWidget, data.g)
					})
			});
	});
var $author$project$Store$Platform2$DashboardCreated = F2(
	function (a, b) {
		return {$: 21, a: a, b: b};
	});
var $author$project$Data$Platform2$DashboardFullyLoaded = function (data) {
	return function (id) {
		return function (name) {
			return function (isFavourite) {
				return function (categories) {
					return function (datasets) {
						return function (userVisits) {
							return function (orgVisits) {
								return function (createdAt) {
									return function (updatedAt) {
										return function (lastVisitedAt) {
											return function (sharing) {
												return function (ownerId) {
													return function (flags) {
														return {ac: categories, bB: createdAt, cl: data, es: datasets, oN: flags, b: id, kN: isFavourite, pC: lastVisitedAt, ld: name, qr: orgVisits, dG: ownerId, ah: sharing, bN: updatedAt, i1: userVisits};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Platform2$InsightCategory = F2(
	function (id, name) {
		return {b: id, ld: name};
	});
var $author$project$Gwi$Json$Decode$nonemptyString = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		return $elm$core$String$isEmpty(string) ? $elm$json$Json$Decode$fail('Encountered empty string') : $elm$json$Json$Decode$succeed(string);
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Id$decodeNonempty = A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $author$project$Gwi$Json$Decode$nonemptyString);
var $author$project$Data$Platform2$insightCategoryDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'name', $author$project$Gwi$Json$Decode$nonemptyString),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'id',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[$author$project$Data$Id$decodeNonempty, $author$project$Data$Id$decodeFromInt]))),
		$elm$json$Json$Decode$succeed($author$project$Data$Platform2$InsightCategory)));
var $author$project$Data$Platform2$categoriesDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (list) {
		if (!list.b) {
			return $elm$json$Json$Decode$succeed(
				_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing));
		} else {
			if (!list.b.b) {
				var cat1 = list.a;
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(
						$elm$core$Maybe$Just(cat1),
						$elm$core$Maybe$Nothing));
			} else {
				if (!list.b.b.b) {
					var cat1 = list.a;
					var _v1 = list.b;
					var cat2 = _v1.a;
					return $elm$json$Json$Decode$succeed(
						_Utils_Tuple2(
							$elm$core$Maybe$Just(cat1),
							$elm$core$Maybe$Just(cat2)));
				} else {
					return $elm$json$Json$Decode$fail('List of dashboard categories too long (more than 2 items)');
				}
			}
		}
	},
	A2(
		$elm$json$Json$Decode$map,
		$elm_community$maybe_extra$Maybe$Extra$values,
		$elm$json$Json$Decode$list(
			$elm$json$Json$Decode$maybe($author$project$Data$Platform2$insightCategoryDecoder))));
var $author$project$Data$Platform2$DashboardData = F4(
	function (widgets, filters, insightLink, description) {
		return {hB: description, C: filters, aP: insightLink, g: widgets};
	});
var $author$project$Data$Platform2$AudienceData = F3(
	function (id, expression, name) {
		return {bY: expression, b: id, ld: name};
	});
var $author$project$Data$Platform2$DashboardStoredFilters = F6(
	function (baseAudience, audiences, audiencesData, audiencesMetadata, waves, locations) {
		return {d9: audiences, nA: audiencesData, nB: audiencesMetadata, aU: baseAudience, cD: locations, dX: waves};
	});
var $author$project$Palette$colorDecoder = function () {
	var decoder = function (str) {
		switch (str) {
			case 'BaseAloneColor':
				return $elm$json$Json$Decode$succeed(0);
			case 'BaseWithAudiencesColor':
				return $elm$json$Json$Decode$succeed(1);
			case 'Color1':
				return $elm$json$Json$Decode$succeed(2);
			case 'Color2':
				return $elm$json$Json$Decode$succeed(3);
			case 'Color3':
				return $elm$json$Json$Decode$succeed(4);
			case 'Color4':
				return $elm$json$Json$Decode$succeed(5);
			case 'Color5':
				return $elm$json$Json$Decode$succeed(6);
			case 'Color6':
				return $elm$json$Json$Decode$succeed(7);
			case 'Color7':
				return $elm$json$Json$Decode$succeed(8);
			default:
				var unknown = str;
				return $elm$json$Json$Decode$fail('colorDecoder: Unknown color ' + unknown);
		}
	};
	return A2($elm$json$Json$Decode$andThen, decoder, $elm$json$Json$Decode$string);
}();
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $author$project$Data$Platform2$dashboardFiltersAudiencesMetadataDecoder = A2(
	$elm$json$Json$Decode$map,
	A2(
		$elm$core$Basics$composeR,
		$elm$core$Dict$toList,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				A2(
					$elm$core$Tuple$mapBoth,
					$author$project$Data$Id$fromString,
					function (c) {
						return {jL: c};
					})),
			$turboMaCk$any_dict$Dict$Any$fromList($author$project$Data$Id$unwrap))),
	$elm$json$Json$Decode$dict(
		A2($elm$json$Json$Decode$field, 'color', $author$project$Palette$colorDecoder)));
var $author$project$Data$Audience$Expression$And = 0;
var $author$project$Data$Audience$Expression$Node = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Data$Audience$Expression$Or = 1;
var $author$project$Data$Audience$Expression$AllRespondents = {$: 0};
var $author$project$Data$Audience$Expression$allRespondentsDecoder = function () {
	var fromPairs = function (xs) {
		if (!xs.b) {
			return $elm$json$Json$Decode$succeed($author$project$Data$Audience$Expression$AllRespondents);
		} else {
			if (!xs.b.b) {
				var _v1 = xs.a;
				return $elm$json$Json$Decode$succeed($author$project$Data$Audience$Expression$AllRespondents);
			} else {
				return $elm$json$Json$Decode$fail('expected {}');
			}
		}
	};
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($author$project$Data$Audience$Expression$AllRespondents),
				A2(
				$elm$json$Json$Decode$andThen,
				fromPairs,
				$elm$json$Json$Decode$keyValuePairs(
					$elm$json$Json$Decode$succeed(0)))
			]));
}();
var $elm_community$json_extra$Json$Decode$Extra$fromMaybe = F2(
	function (error, val) {
		if (!val.$) {
			var v = val.a;
			return $elm$json$Json$Decode$succeed(v);
		} else {
			return $elm$json$Json$Decode$fail(error);
		}
	});
var $author$project$Data$Audience$Expression$Include = 0;
var $author$project$Data$Audience$Expression$Leaf = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Audience$Expression$LeafData = F5(
	function (inclusion, minCount, questionCode, datapointCodes, suffixCodes) {
		return {hw: datapointCodes, kz: inclusion, k6: minCount, at: questionCode, eY: suffixCodes};
	});
var $author$project$Gwi$Json$Decode$stringToInt = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeL,
		$elm_community$json_extra$Json$Decode$Extra$fromMaybe('Couldn\'t parse int'),
		$elm$core$String$toInt),
	$elm$json$Json$Decode$string);
var $author$project$Gwi$Json$Decode$stringOrInt = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$elm$json$Json$Decode$int, $author$project$Gwi$Json$Decode$stringToInt]));
var $author$project$Data$Audience$Expression$leafDecoder = A2(
	$elm$json$Json$Decode$map,
	$author$project$Data$Audience$Expression$Leaf,
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'suffixes',
					$elm$json$Json$Decode$list($author$project$Data$Id$decodeFromStringOrInt)))),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$field,
						'datapoints',
						$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
						A2(
						$elm$json$Json$Decode$field,
						'options',
						$elm$json$Json$Decode$list($author$project$Data$Id$decode))
					])),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'question', $author$project$Data$Id$decode),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(1),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'min_count', $author$project$Gwi$Json$Decode$stringOrInt))),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$map,
							function (bool) {
								return bool ? 1 : 0;
							},
							A2(
								$elm$json$Json$Decode$map,
								$elm$core$Maybe$withDefault(false),
								$elm$json$Json$Decode$maybe(
									A2($elm$json$Json$Decode$field, 'not', $elm$json$Json$Decode$bool)))),
						$elm$json$Json$Decode$succeed($author$project$Data$Audience$Expression$LeafData)))))));
var $author$project$Data$Audience$Expression$decoder_ = function (_v1) {
	var nestedCall = _v1.ig;
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$lazy(
				function (_v2) {
					return $author$project$Data$Audience$Expression$cyclic$nodeDecoder();
				}),
				$author$project$Data$Audience$Expression$leafDecoder,
				nestedCall ? $elm$json$Json$Decode$fail('Invalid nested structure') : $author$project$Data$Audience$Expression$allRespondentsDecoder
			]));
};
function $author$project$Data$Audience$Expression$cyclic$nestedCallDecoder() {
	return $author$project$Data$Audience$Expression$decoder_(
		{ig: true});
}
function $author$project$Data$Audience$Expression$cyclic$nodeDecoder() {
	var logicNodeDecoder = F2(
		function (field, constructor) {
			return A2(
				$elm$json$Json$Decode$map,
				$author$project$Data$Audience$Expression$Node(constructor),
				A2(
					$elm$json$Json$Decode$andThen,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$filterMap($elm$core$Basics$identity),
						A2(
							$elm$core$Basics$composeR,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
							$elm_community$json_extra$Json$Decode$Extra$fromMaybe('Unexpected empty list'))),
					A2(
						$elm$json$Json$Decode$field,
						field,
						$elm$json$Json$Decode$list(
							$elm$json$Json$Decode$lazy(
								function (_v0) {
									return $elm$json$Json$Decode$maybe(
										$author$project$Data$Audience$Expression$cyclic$nestedCallDecoder());
								})))));
		});
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(logicNodeDecoder, 'and', 0),
				A2(logicNodeDecoder, 'or', 1)
			]));
}
var $author$project$Data$Audience$Expression$nestedCallDecoder = $author$project$Data$Audience$Expression$cyclic$nestedCallDecoder();
$author$project$Data$Audience$Expression$cyclic$nestedCallDecoder = function () {
	return $author$project$Data$Audience$Expression$nestedCallDecoder;
};
var $author$project$Data$Audience$Expression$nodeDecoder = $author$project$Data$Audience$Expression$cyclic$nodeDecoder();
$author$project$Data$Audience$Expression$cyclic$nodeDecoder = function () {
	return $author$project$Data$Audience$Expression$nodeDecoder;
};
var $author$project$Data$Audience$Expression$firstLevelDecoder = $author$project$Data$Audience$Expression$decoder_(
	{ig: false});
var $author$project$Data$Audience$Expression$decoder = $author$project$Data$Audience$Expression$firstLevelDecoder;
var $author$project$Data$Id$dictFromList = $turboMaCk$any_dict$Dict$Any$fromList($author$project$Data$Id$unwrap);
var $author$project$Data$Platform2$dashboardFiltersDecoder = function () {
	var nullableIdList = $elm$json$Json$Decode$nullable(
		$elm$json$Json$Decode$list($author$project$Data$Id$decode));
	var audienceDataDecoder = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'expression', $author$project$Data$Audience$Expression$decoder),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
				$elm$json$Json$Decode$succeed($author$project$Data$Platform2$AudienceData))));
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'locations', nullableIdList),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'waves', nullableIdList),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'audiences_metadata', $author$project$Data$Platform2$dashboardFiltersAudiencesMetadataDecoder),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm_community$json_extra$Json$Decode$Extra$optionalNullableField,
						'audiences_data',
						A2(
							$elm$json$Json$Decode$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$map(
									function (a) {
										return _Utils_Tuple2(a.b, a);
									}),
								$author$project$Data$Id$dictFromList),
							$elm$json$Json$Decode$list(audienceDataDecoder))),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'audiences', nullableIdList),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$field,
								'base_audience',
								$elm$json$Json$Decode$nullable($author$project$Data$Id$decode)),
							$elm$json$Json$Decode$succeed($author$project$Data$Platform2$DashboardStoredFilters)))))));
}();
var $author$project$Data$Platform2$InsightLink = F2(
	function (type_, id) {
		return {b: id, mL: type_};
	});
var $author$project$Data$Platform2$COTW = 2;
var $author$project$Data$Platform2$Infographic = 0;
var $author$project$Data$Platform2$Powerpoint = 3;
var $author$project$Data$Platform2$Report = 1;
var $author$project$Data$Platform2$insightTypeDecoder = function () {
	var decode = function (str) {
		switch (str) {
			case 'infographic':
				return $elm$json$Json$Decode$succeed(0);
			case 'report':
				return $elm$json$Json$Decode$succeed(1);
			case 'chart':
				return $elm$json$Json$Decode$succeed(2);
			case 'cotw':
				return $elm$json$Json$Decode$succeed(2);
			case 'powerpoint':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Unknown insight type ' + str);
		}
	};
	return A2($elm$json$Json$Decode$andThen, decode, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Platform2$insightLinkDecoder = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Platform2$InsightLink,
	A2($elm$json$Json$Decode$field, 'type', $author$project$Data$Platform2$insightTypeDecoder),
	A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode));
var $elm$core$String$trim = _String_trim;
var $author$project$Data$Platform2$ChartWidget = F7(
	function (chartType, metric, sortBy, data, baseAudience, name, note) {
		return {aU: baseAudience, aI: chartType, cl: data, dB: metric, ld: name, b2: note, cY: sortBy};
	});
var $author$project$Data$Platform2$Widget = F6(
	function (id, height, width, position, dashboardId, content) {
		return {U: content, bf: dashboardId, cv: height, b: id, lB: position, da: width};
	});
var $author$project$Data$Core$DatapointsSort$Alphabetical = 2;
var $author$project$Data$Core$DatapointsSort$Ascending = 1;
var $author$project$Data$Core$DatapointsSort$Descending = 0;
var $author$project$Data$Core$DatapointsSort$fromString = function (string) {
	switch (string) {
		case 'desc':
			return 0;
		case 'asc':
			return 1;
		case 'alphabetical-real':
			return 2;
		default:
			return 3;
	}
};
var $author$project$Data$Core$DatapointsSort$decoder = A2($elm$json$Json$Decode$map, $author$project$Data$Core$DatapointsSort$fromString, $elm$json$Json$Decode$string);
var $author$project$Data$Platform2$InheritedFromChart = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Platform2$ChartBaseAudience = function (id) {
	return {b: id};
};
var $author$project$Data$Platform2$chartBaseAudienceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
	$elm$json$Json$Decode$succeed($author$project$Data$Platform2$ChartBaseAudience));
var $author$project$Data$Platform2$widgetBaseAudienceDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'base_audience', $author$project$Data$Platform2$chartBaseAudienceDecoder),
			$elm$json$Json$Decode$succeed($author$project$Data$Platform2$InheritedFromChart)),
			A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'chart_base_audience',
				$elm$json$Json$Decode$maybe($author$project$Data$Platform2$chartBaseAudienceDecoder)),
			$elm$json$Json$Decode$succeed(
				function (maybeAudience) {
					return $author$project$Data$Platform2$InheritedFromDashboard(
						{fp: maybeAudience});
				})),
			$elm$json$Json$Decode$succeed(
			$author$project$Data$Platform2$InheritedFromDashboard(
				{fp: $elm$core$Maybe$Nothing}))
		]));
var $author$project$Data$Platform2$GroupedWidgetData = F2(
	function (questionCode, datapoints) {
		return {er: datapoints, at: questionCode};
	});
var $author$project$Data$Platform2$OldData = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Platform2$OldWidgetData = F3(
	function (questionCode, datapointCodes, suffixCodes) {
		return {hw: datapointCodes, at: questionCode, eY: suffixCodes};
	});
var $author$project$Data$Platform2$widgetCodeSelectionDecoder = function (dec) {
	return A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
			A2($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Data$Platform2$Implicit, $author$project$Data$Platform2$Explicit)),
		$elm$json$Json$Decode$list(dec));
};
var $author$project$Data$Platform2$widgetDataDecoder = function () {
	var groupedDatapointDecoder = A3(
		$elm$json$Json$Decode$map2,
		$elm$core$Tuple$pair,
		A2($elm$json$Json$Decode$field, 'datapoint_code', $author$project$Data$Id$decode),
		A2(
			$elm$json$Json$Decode$field,
			'suffix_codes',
			$elm$json$Json$Decode$list($author$project$Data$Id$decode)));
	var groupedWidgetDataDecoder = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'datapoints',
			$author$project$Data$Platform2$widgetCodeSelectionDecoder(groupedDatapointDecoder)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'question_code', $author$project$Data$Id$decode),
			$elm$json$Json$Decode$succeed($author$project$Data$Platform2$GroupedWidgetData)));
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$field,
				'data',
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Data$Platform2$GroupedData,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList(groupedWidgetDataDecoder))),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Data$Platform2$OldData,
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'suffixes',
						$author$project$Data$Platform2$widgetCodeSelectionDecoder($author$project$Data$Id$decode)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$field,
							'datapoints',
							$author$project$Data$Platform2$widgetCodeSelectionDecoder($author$project$Data$Id$decode)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'question_id', $author$project$Data$Id$decode),
							$elm$json$Json$Decode$succeed($author$project$Data$Platform2$OldWidgetData)))))
			]));
}();
var $elm_community$json_extra$Json$Decode$Extra$withDefault = F2(
	function (fallback, decoder) {
		return A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(fallback),
			$elm$json$Json$Decode$maybe(decoder));
	});
var $author$project$Data$Platform2$widgetDecoder = function () {
	var widgetContentDecoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'rich_content', $author$project$Data$Platform2$RichTextWidget$decoder),
				$elm$json$Json$Decode$succeed($author$project$Data$Platform2$RichText)),
				A2(
				$elm$json$Json$Decode$map,
				$author$project$Data$Platform2$ChartContent,
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(''),
						A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'note', $elm$json$Json$Decode$string)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm_community$json_extra$Json$Decode$Extra$withDefault,
							'',
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							$author$project$Data$Platform2$widgetBaseAudienceDecoder,
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								$author$project$Data$Platform2$widgetDataDecoder,
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'sort_by', $author$project$Data$Core$DatapointsSort$decoder),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'metric', $author$project$Data$Metric$decoder),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'chart_type', $author$project$D3Charts$Dashboards$ChartType$decoder),
											$elm$json$Json$Decode$succeed($author$project$Data$Platform2$ChartWidget)))))))))
			]));
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		widgetContentDecoder,
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'dashboard_id', $author$project$Data$Id$decodeFromStringOrInt),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'position', $elm$json$Json$Decode$float),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'width', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'height', $elm$json$Json$Decode$int),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromStringOrInt),
							$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Widget)))))));
}();
var $author$project$Data$Platform2$dashboardDataDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$map,
		function (s) {
			return $elm$core$String$isEmpty(
				$elm$core$String$trim(s)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(s);
		},
		A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'insight_link',
			$elm$json$Json$Decode$maybe($author$project$Data$Platform2$insightLinkDecoder)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'filter', $author$project$Data$Platform2$dashboardFiltersDecoder),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'widgets',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$widgetDecoder)),
				$elm$json$Json$Decode$succeed($author$project$Data$Platform2$DashboardData)))));
var $author$project$Data$Platform2$MigratedFromP1 = 0;
var $author$project$Data$Platform2$dashboardFlagsDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		if (string === 'FromP1') {
			return $elm$json$Json$Decode$succeed(
				$elm$core$Maybe$Just(0));
		} else {
			return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Platform2$GwiShared = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Platform2$LinkShared = {$: 5};
var $author$project$Data$Platform2$NonGwiShared = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Platform2$PublicLinkAndGwiShared = function (a) {
	return {$: 6, a: a};
};
var $author$project$Data$Platform2$PublicLinkAndNonGwiShared = function (a) {
	return {$: 7, a: a};
};
var $author$project$Data$Platform2$PublicLinkAndPublicDashboard = {$: 8};
var $author$project$Data$Platform2$PublicLinkShared = {$: 4};
var $author$project$Data$Platform2$UserEmail = F2(
	function (id, email) {
		return {j: email, b: id};
	});
var $author$project$Data$Platform2$userEmailDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromInt),
		$elm$json$Json$Decode$succeed($author$project$Data$Platform2$UserEmail)));
var $author$project$Data$Platform2$dashboardSharingDecoder = function () {
	var publicLinkSharedDecoder = A2(
		$elm$json$Json$Decode$field,
		'public_link_shared',
		$elm$json$Json$Decode$succeed($author$project$Data$Platform2$PublicLinkShared));
	var publicDecoder = A2(
		$elm$json$Json$Decode$field,
		'public',
		$elm$json$Json$Decode$succeed($author$project$Data$Platform2$PublicDashboard));
	var publicLinkAndPublicDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (_v5, _v6) {
				return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
			}),
		publicLinkSharedDecoder,
		publicDecoder);
	var privateDecoder = A2(
		$elm$json$Json$Decode$field,
		'private',
		$elm$json$Json$Decode$succeed($author$project$Data$Platform2$PrivateDashboard));
	var nonGwiSharedDecoder = function () {
		var usersDecoder = A2(
			$elm$json$Json$Decode$map,
			function (userEmails) {
				return $author$project$Data$Platform2$NonGwiShared(
					_Utils_Tuple2($elm$core$Maybe$Nothing, userEmails));
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['shared_with_users_by_non_gwi_creator', 'users']),
				$elm$json$Json$Decode$list($author$project$Data$Platform2$userEmailDecoder)));
		var orgDecoder = A2(
			$elm$json$Json$Decode$map,
			function (orgId) {
				return $author$project$Data$Platform2$NonGwiShared(
					_Utils_Tuple2(
						$elm$core$Maybe$Just(orgId),
						_List_Nil));
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['nongwi_shared_with_my_org', 'organisation_ids']),
				A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decodeFromInt)));
		var bothFieldsDecoder = A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (orgId, userEmails) {
					return $author$project$Data$Platform2$NonGwiShared(
						_Utils_Tuple2(
							$elm$core$Maybe$Just(orgId),
							userEmails));
				}),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['nongwi_shared_with_my_org', 'organisation_ids']),
				A2($elm$json$Json$Decode$index, 0, $author$project$Data$Id$decodeFromInt)),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['shared_with_users_by_non_gwi_creator', 'users']),
				$elm$json$Json$Decode$list($author$project$Data$Platform2$userEmailDecoder)));
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[bothFieldsDecoder, orgDecoder, usersDecoder]));
	}();
	var publicLinkAndNonGwiSharedDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (_v3, dashboardSharing) {
				if (dashboardSharing.$ === 2) {
					var sharingTuple = dashboardSharing.a;
					return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(sharingTuple);
				} else {
					return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
						_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil));
				}
			}),
		publicLinkSharedDecoder,
		nonGwiSharedDecoder);
	var linkSharedDecoder = A2(
		$elm$json$Json$Decode$andThen,
		function (entries) {
			var _v2 = $elm$core$Dict$size(entries);
			if (!_v2) {
				return $elm$json$Json$Decode$succeed($author$project$Data$Platform2$LinkShared);
			} else {
				return $elm$json$Json$Decode$fail('Expected empty JSON object for LinkShared');
			}
		},
		$elm$json$Json$Decode$dict($elm$json$Json$Decode$int));
	var gwiSharedDecoder = function () {
		var usersDecoder = A2(
			$elm$json$Json$Decode$map,
			function (userEmails) {
				return $author$project$Data$Platform2$GwiShared(
					_Utils_Tuple2(_List_Nil, userEmails));
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['shared_with_users_by_gwi_creator', 'users']),
				$elm$json$Json$Decode$list($author$project$Data$Platform2$userEmailDecoder)));
		var orgsDecoder = A2(
			$elm$json$Json$Decode$map,
			function (orgIds) {
				return $author$project$Data$Platform2$GwiShared(
					_Utils_Tuple2(orgIds, _List_Nil));
			},
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['gwi_shared_with_orgs', 'organisation_ids']),
				$elm$json$Json$Decode$list($author$project$Data$Id$decodeFromInt)));
		var bothFieldsDecoder = A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (organisations, userEmails) {
					return $author$project$Data$Platform2$GwiShared(
						_Utils_Tuple2(organisations, userEmails));
				}),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['gwi_shared_with_orgs', 'organisation_ids']),
				$elm$json$Json$Decode$list($author$project$Data$Id$decodeFromInt)),
			A2(
				$elm$json$Json$Decode$at,
				_List_fromArray(
					['shared_with_users_by_gwi_creator', 'users']),
				$elm$json$Json$Decode$list($author$project$Data$Platform2$userEmailDecoder)));
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[bothFieldsDecoder, orgsDecoder, usersDecoder]));
	}();
	var publicLinkAndGwiSharedDecoder = A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (_v0, dashboardSharing) {
				if (dashboardSharing.$ === 1) {
					var sharingTuple = dashboardSharing.a;
					return $author$project$Data$Platform2$PublicLinkAndGwiShared(sharingTuple);
				} else {
					return $author$project$Data$Platform2$PublicLinkAndGwiShared(
						_Utils_Tuple2(_List_Nil, _List_Nil));
				}
			}),
		publicLinkSharedDecoder,
		gwiSharedDecoder);
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[publicLinkAndPublicDecoder, publicLinkAndGwiSharedDecoder, publicLinkAndNonGwiSharedDecoder, privateDecoder, publicDecoder, publicLinkSharedDecoder, nonGwiSharedDecoder, gwiSharedDecoder, linkSharedDecoder]));
}();
var $elm$parser$Parser$deadEndsToString = function (deadEnds) {
	return 'TODO deadEndsToString';
};
var $elm_community$json_extra$Json$Decode$Extra$fromResult = function (result) {
	if (!result.$) {
		var successValue = result.a;
		return $elm$json$Json$Decode$succeed(successValue);
	} else {
		var errorMessage = result.a;
		return $elm$json$Json$Decode$fail(errorMessage);
	}
};
var $author$project$Gwi$Json$Decode$unixIso8601Decoder = A2(
	$elm$json$Json$Decode$andThen,
	A2(
		$elm$core$Basics$composeR,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toTime,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$mapError($elm$parser$Parser$deadEndsToString),
			$elm_community$json_extra$Json$Decode$Extra$fromResult)),
	$elm$json$Json$Decode$string);
var $author$project$Data$Platform2$dashboardFullyLoadedDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'flags',
		A2(
			$elm$json$Json$Decode$map,
			$elm_community$maybe_extra$Maybe$Extra$values,
			$elm$json$Json$Decode$list($author$project$Data$Platform2$dashboardFlagsDecoder))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'user_id', $author$project$Gwi$Json$Decode$intToString),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'sharings', $author$project$Data$Platform2$dashboardSharingDecoder),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'visited_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'updated_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'created_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'org_visits', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'user_visits', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2(
										$elm$json$Json$Decode$field,
										'datasets',
										$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'categories', $author$project$Data$Platform2$categoriesDecoder),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'favourite', $elm$json$Json$Decode$bool),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromStringOrInt),
													A2(
														$elm_community$json_extra$Json$Decode$Extra$andMap,
														$author$project$Data$Platform2$dashboardDataDecoder,
														$elm$json$Json$Decode$succeed($author$project$Data$Platform2$DashboardFullyLoaded)))))))))))))));
var $author$project$Data$Platform2$encodeInsightCategory = function (category) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Data$Id$encode(category.b)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(category.ld))
			]));
};
var $author$project$Data$Platform2$sanitizeCategory = function (cat) {
	var id = cat.b;
	var name = cat.ld;
	return ($elm$core$String$isEmpty(
		$author$project$Data$Id$unwrap(id)) || $elm$core$String$isEmpty(name)) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(cat);
};
var $author$project$Data$Platform2$sanitizeCategories = function (_v0) {
	var cat1 = _v0.a;
	var cat2 = _v0.b;
	return _Utils_Tuple2(
		A2($elm$core$Maybe$andThen, $author$project$Data$Platform2$sanitizeCategory, cat1),
		A2($elm$core$Maybe$andThen, $author$project$Data$Platform2$sanitizeCategory, cat2));
};
var $author$project$Data$Platform2$encodeCategories = function (categories) {
	var _v0 = $author$project$Data$Platform2$sanitizeCategories(categories);
	var cat1 = _v0.a;
	var cat2 = _v0.b;
	return A2(
		$elm$json$Json$Encode$list,
		$author$project$Data$Platform2$encodeInsightCategory,
		$elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[cat1, cat2])));
};
var $author$project$Palette$colorEncode = function (color) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (color) {
				case 0:
					return 'BaseAloneColor';
				case 1:
					return 'BaseWithAudiencesColor';
				case 2:
					return 'Color1';
				case 3:
					return 'Color2';
				case 4:
					return 'Color3';
				case 5:
					return 'Color4';
				case 6:
					return 'Color5';
				case 7:
					return 'Color6';
				default:
					return 'Color7';
			}
		}());
};
var $author$project$Data$Platform2$dashboardFiltersAudiencesMetadataEncode = function (metadata) {
	return $elm$json$Json$Encode$object(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var id = _v0.a;
				var color = _v0.b.jL;
				return _Utils_Tuple2(
					$author$project$Data$Id$unwrap(id),
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'color',
								$author$project$Palette$colorEncode(color))
							])));
			},
			$turboMaCk$any_dict$Dict$Any$toList(metadata)));
};
var $author$project$Data$Platform2$encodeDashboardFilter = function (filters) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'base_audience',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $author$project$Data$Id$encode, filters.aU)),
				_Utils_Tuple2(
				'audiences',
				A2(
					$elm_community$json_extra$Json$Encode$Extra$maybe,
					$elm$json$Json$Encode$list($author$project$Data$Id$encode),
					filters.d9)),
				_Utils_Tuple2(
				'audiences_metadata',
				$author$project$Data$Platform2$dashboardFiltersAudiencesMetadataEncode(filters.nB)),
				_Utils_Tuple2(
				'waves',
				A2(
					$elm_community$json_extra$Json$Encode$Extra$maybe,
					$elm$json$Json$Encode$list($author$project$Data$Id$encode),
					filters.dX)),
				_Utils_Tuple2(
				'locations',
				A2(
					$elm_community$json_extra$Json$Encode$Extra$maybe,
					$elm$json$Json$Encode$list($author$project$Data$Id$encode),
					filters.cD))
			]));
};
var $author$project$Gwi$Json$Encode$encodeStringAsInt = function (value) {
	return A2(
		$elm_community$json_extra$Json$Encode$Extra$maybe,
		$elm$json$Json$Encode$int,
		$elm$core$String$toInt(value));
};
var $author$project$Data$Id$unsafeEncodeAsInt = A2($elm$core$Basics$composeL, $author$project$Gwi$Json$Encode$encodeStringAsInt, $author$project$Data$Id$unwrap);
var $author$project$Data$Platform2$encodeUserEmail = function (userEmail) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Data$Id$unsafeEncodeAsInt(userEmail.b)),
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$string(userEmail.j))
			]));
};
var $author$project$Data$Platform2$encodeDashboardSharing = function (v2SharingObject) {
	switch (v2SharingObject.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'private',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'organisation_ids',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil)),
									_Utils_Tuple2(
									'users',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil))
								])))
					]));
		case 3:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'public',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'organisation_ids',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil)),
									_Utils_Tuple2(
									'users',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil))
								])))
					]));
		case 2:
			var _v1 = v2SharingObject.a;
			var maybeOrgId = _v1.a;
			var userEmails = _v1.b;
			var usersSharingField = function () {
				if (!userEmails.b) {
					return _List_Nil;
				} else {
					var userEmails_ = userEmails;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'shared_with_users_by_non_gwi_creator',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'users',
										A2($elm$json$Json$Encode$list, $author$project$Data$Platform2$encodeUserEmail, userEmails_))
									])))
						]);
				}
			}();
			var orgSharingField = function () {
				if (!maybeOrgId.$) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'nongwi_shared_with_my_org',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'organisation_ids',
										A2(
											$elm$json$Json$Encode$list,
											$elm$core$Basics$always($elm$json$Json$Encode$null),
											_List_Nil)),
										_Utils_Tuple2(
										'users',
										A2(
											$elm$json$Json$Encode$list,
											$elm$core$Basics$always($elm$json$Json$Encode$null),
											_List_Nil))
									])))
						]);
				} else {
					return _List_Nil;
				}
			}();
			return $elm$json$Json$Encode$object(
				_Utils_ap(orgSharingField, usersSharingField));
		case 1:
			var _v4 = v2SharingObject.a;
			var orgIds = _v4.a;
			var userEmails = _v4.b;
			var usersSharingField = function () {
				if (!userEmails.b) {
					return _List_Nil;
				} else {
					var userEmails_ = userEmails;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'shared_with_users_by_gwi_creator',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'users',
										A2($elm$json$Json$Encode$list, $author$project$Data$Platform2$encodeUserEmail, userEmails_))
									])))
						]);
				}
			}();
			var orgsSharingField = function () {
				if (!orgIds.b) {
					return _List_Nil;
				} else {
					var orgIds_ = orgIds;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'gwi_shared_with_orgs',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'organisation_ids',
										A2($elm$json$Json$Encode$list, $author$project$Data$Id$unsafeEncodeAsInt, orgIds_))
									])))
						]);
				}
			}();
			return $elm$json$Json$Encode$object(
				_Utils_ap(orgsSharingField, usersSharingField));
		case 4:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'public_link_shared',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'organisation_ids',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil)),
									_Utils_Tuple2(
									'users',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil))
								])))
					]));
		case 5:
			return $elm$json$Json$Encode$object(_List_Nil);
		case 6:
			var _v7 = v2SharingObject.a;
			var orgIds = _v7.a;
			var userEmails = _v7.b;
			var usersSharingField = function () {
				if (!userEmails.b) {
					return _List_Nil;
				} else {
					var userEmails_ = userEmails;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'shared_with_users_by_gwi_creator',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'users',
										A2($elm$json$Json$Encode$list, $author$project$Data$Platform2$encodeUserEmail, userEmails_))
									])))
						]);
				}
			}();
			var orgsSharingField = function () {
				if (!orgIds.b) {
					return _List_Nil;
				} else {
					var orgIds_ = orgIds;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'gwi_shared_with_orgs',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'organisation_ids',
										A2($elm$json$Json$Encode$list, $author$project$Data$Id$unsafeEncodeAsInt, orgIds_))
									])))
						]);
				}
			}();
			return $elm$json$Json$Encode$object(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'public_link_shared',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'organisation_ids',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil)),
									_Utils_Tuple2(
									'users',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil))
								]))),
					_Utils_ap(orgsSharingField, usersSharingField)));
		case 7:
			var _v10 = v2SharingObject.a;
			var maybeOrgId = _v10.a;
			var userEmails = _v10.b;
			var usersSharingField = function () {
				if (!userEmails.b) {
					return _List_Nil;
				} else {
					var userEmails_ = userEmails;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'shared_with_users_by_non_gwi_creator',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'users',
										A2($elm$json$Json$Encode$list, $author$project$Data$Platform2$encodeUserEmail, userEmails_))
									])))
						]);
				}
			}();
			var orgSharingField = function () {
				if (!maybeOrgId.$) {
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'nongwi_shared_with_my_org',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'organisation_ids',
										A2(
											$elm$json$Json$Encode$list,
											$elm$core$Basics$always($elm$json$Json$Encode$null),
											_List_Nil)),
										_Utils_Tuple2(
										'users',
										A2(
											$elm$json$Json$Encode$list,
											$elm$core$Basics$always($elm$json$Json$Encode$null),
											_List_Nil))
									])))
						]);
				} else {
					return _List_Nil;
				}
			}();
			return $elm$json$Json$Encode$object(
				A2(
					$elm$core$List$cons,
					_Utils_Tuple2(
						'public_link_shared',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'organisation_ids',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil)),
									_Utils_Tuple2(
									'users',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil))
								]))),
					_Utils_ap(orgSharingField, usersSharingField)));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'public_link_shared',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'organisation_ids',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil)),
									_Utils_Tuple2(
									'users',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil))
								]))),
						_Utils_Tuple2(
						'public',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'organisation_ids',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil)),
									_Utils_Tuple2(
									'users',
									A2(
										$elm$json$Json$Encode$list,
										$elm$core$Basics$always($elm$json$Json$Encode$null),
										_List_Nil))
								])))
					]));
	}
};
var $author$project$Data$Platform2$encodeInsightLink = function (_v0) {
	var type_ = _v0.mL;
	var id = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Data$Id$encode(id)),
				_Utils_Tuple2(
				'type',
				$author$project$Data$Platform2$encodeInsightType(type_))
			]));
};
var $author$project$Data$Core$DatapointsSort$toStringForWidget = function (sort) {
	switch (sort) {
		case 1:
			return 'asc';
		case 0:
			return 'desc';
		case 3:
			return 'default';
		default:
			return 'alphabetical-real';
	}
};
var $author$project$Data$Core$DatapointsSort$encodeForWidget = function (sort) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Core$DatapointsSort$toStringForWidget(sort));
};
var $author$project$Data$Platform2$encodeChartBaseAudience = function (_v0) {
	var id = _v0.b;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Data$Id$encode(id))
			]));
};
var $author$project$Data$Platform2$encodeWidgetBaseAudience = function (baseAudience) {
	if (!baseAudience.$) {
		var chartBaseAudience = baseAudience.a.fp;
		return _List_fromArray(
			[
				_Utils_Tuple2('base_audience', $elm$json$Json$Encode$null),
				_Utils_Tuple2(
				'chart_base_audience',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Platform2$encodeChartBaseAudience, chartBaseAudience))
			]);
	} else {
		var base = baseAudience.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'base_audience',
				$author$project$Data$Platform2$encodeChartBaseAudience(base))
			]);
	}
};
var $author$project$Data$Platform2$encodeWidgetCodeSelection = F2(
	function (fn, sel) {
		if (sel.$ === 1) {
			var list = sel.a;
			return A2($turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList, fn, list);
		} else {
			return A2($elm$json$Json$Encode$list, $elm$core$Basics$identity, _List_Nil);
		}
	});
var $author$project$Data$Platform2$encodeWidgetData = function (widgetData) {
	if (widgetData.$ === 1) {
		var groupedData = widgetData.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'data',
				A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList,
					function (questionGroup) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'question_code',
									$author$project$Data$Id$encode(questionGroup.at)),
									_Utils_Tuple2(
									'datapoints',
									A2(
										$author$project$Data$Platform2$encodeWidgetCodeSelection,
										function (_v1) {
											var dpCode = _v1.a;
											var suffixCodes = _v1.b;
											return $elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'datapoint_code',
														$author$project$Data$Id$encode(dpCode)),
														_Utils_Tuple2(
														'suffix_codes',
														A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, suffixCodes))
													]));
										},
										questionGroup.er))
								]));
					},
					groupedData))
			]);
	} else {
		var oldData = widgetData.a;
		return _List_fromArray(
			[
				_Utils_Tuple2(
				'question_id',
				$author$project$Data$Id$encode(oldData.at)),
				_Utils_Tuple2(
				'datapoints',
				A2($author$project$Data$Platform2$encodeWidgetCodeSelection, $author$project$Data$Id$encode, oldData.hw)),
				_Utils_Tuple2(
				'suffixes',
				A2($author$project$Data$Platform2$encodeWidgetCodeSelection, $author$project$Data$Id$encode, oldData.eY))
			]);
	}
};
var $author$project$Data$Platform2$encodeWidget = function (widget) {
	return $elm$json$Json$Encode$object(
		_Utils_ap(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'id',
					_Utils_eq(widget.b, $author$project$Data$Platform2$nullId) ? $elm$json$Json$Encode$null : $author$project$Data$Id$encode(widget.b)),
					_Utils_Tuple2(
					'width',
					$elm$json$Json$Encode$int(widget.da)),
					_Utils_Tuple2(
					'height',
					$elm$json$Json$Encode$int(widget.cv)),
					_Utils_Tuple2(
					'position',
					$elm$json$Json$Encode$float(widget.lB)),
					_Utils_Tuple2(
					'dashboard_id',
					$author$project$Data$Id$encode(widget.bf))
				]),
			function () {
				var _v0 = widget.U;
				if (_v0.$ === 1) {
					var richText = _v0.a;
					return _List_fromArray(
						[
							_Utils_Tuple2(
							'rich_content',
							$author$project$Data$Platform2$RichTextWidget$encode(richText))
						]);
				} else {
					var chartWidget = _v0.a;
					return _Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'chart_type',
								$author$project$D3Charts$Dashboards$ChartType$encode(chartWidget.aI)),
								_Utils_Tuple2(
								'metric',
								$author$project$Data$Metric$encode(chartWidget.dB)),
								_Utils_Tuple2(
								'sort_by',
								$author$project$Data$Core$DatapointsSort$encodeForWidget(chartWidget.cY)),
								_Utils_Tuple2(
								'name',
								$elm$json$Json$Encode$string(chartWidget.ld)),
								_Utils_Tuple2(
								'note',
								$elm$json$Json$Encode$string(chartWidget.b2))
							]),
						_Utils_ap(
							$author$project$Data$Platform2$encodeWidgetBaseAudience(chartWidget.aU),
							$author$project$Data$Platform2$encodeWidgetData(chartWidget.cl)));
				}
			}()));
};
var $author$project$Data$Platform2$encodeDashboard = function (dashboard) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(dashboard.ld)),
				_Utils_Tuple2(
				'filter',
				$author$project$Data$Platform2$encodeDashboardFilter(dashboard.cl.C)),
				_Utils_Tuple2(
				'categories',
				$author$project$Data$Platform2$encodeCategories(dashboard.ac)),
				_Utils_Tuple2(
				'datasets',
				A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, dashboard.es)),
				_Utils_Tuple2(
				'insight_link',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Data$Platform2$encodeInsightLink, dashboard.cl.aP)),
				_Utils_Tuple2(
				'widgets',
				A2($elm$json$Json$Encode$list, $author$project$Data$Platform2$encodeWidget, dashboard.cl.g)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(
					A2($elm$core$Maybe$withDefault, '', dashboard.cl.hB))),
				_Utils_Tuple2(
				'sharing',
				$author$project$Data$Platform2$encodeDashboardSharing(dashboard.ah))
			]));
};
var $author$project$Gwi$Http$JsonDecoder = function (a) {
	return {$: 0, a: a};
};
var $author$project$Gwi$Http$basicResolveResponse = F2(
	function (successDecoder, response) {
		switch (response.$) {
			case 0:
				var e = response.a;
				return $elm$core$Result$Err(
					$author$project$Gwi$Http$BadUrl(e));
			case 1:
				return $elm$core$Result$Err($author$project$Gwi$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($author$project$Gwi$Http$NetworkError);
			case 3:
				var metadata = response.a;
				var body = response.b;
				return $elm$core$Result$Err(
					A2($author$project$Gwi$Http$BadStatus, metadata, body));
			default:
				var metadata = response.a;
				var body = response.b;
				if (!successDecoder.$) {
					var decoder = successDecoder.a;
					return A2(
						$elm$core$Result$mapError,
						$author$project$Gwi$Http$BadBody(metadata),
						A2($elm$json$Json$Decode$decodeString, decoder, body));
				} else {
					var a = successDecoder.a;
					return $elm$core$Result$Ok(a);
				}
		}
	});
var $author$project$Gwi$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$author$project$Gwi$Http$basicResolveResponse(
				$author$project$Gwi$Http$JsonDecoder(decoder)));
	});
var $author$project$Data$Platform2$fromFullyLoadedDashboard = function (dashboard) {
	return {
		ac: dashboard.ac,
		bB: dashboard.bB,
		cl: $krisajenkins$remotedata$RemoteData$Success(dashboard.cl),
		es: dashboard.es,
		oN: dashboard.oN,
		b: dashboard.b,
		kN: dashboard.kN,
		pC: dashboard.pC,
		ld: dashboard.ld,
		qr: dashboard.qr,
		dG: dashboard.dG,
		ah: dashboard.ah,
		bN: dashboard.bN,
		i1: dashboard.i1
	};
};
var $author$project$Data$Platform2$host = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.j8;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Config$Main$get,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dV;
			},
			function ($) {
				return $.d5;
			})));
var $author$project$Data$Platform2$createDashboard = F2(
	function (dashboard, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeDashboard(dashboard)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Data$Platform2$fromFullyLoadedDashboard,
						A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Platform2$dashboardFullyLoadedDecoder))),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + '/v2/saved/dashboards'
			});
	});
var $elm_community$result_extra$Result$Extra$unpack = F3(
	function (errFunc, okFunc, result) {
		if (!result.$) {
			var ok = result.a;
			return okFunc(ok);
		} else {
			var err = result.a;
			return errFunc(err);
		}
	});
var $author$project$Store$Utils$resourceReq = F9(
	function (toRes, getState, success, fail, requestCmd, model, updateS, flags, store) {
		return _Utils_Tuple2(
			updateS(store),
			function () {
				var _v0 = getState(store);
				if (_v0.$ === 3) {
					var httpResultToMsg = A2(
						$elm_community$result_extra$Result$Extra$unpack,
						fail,
						A2($elm$core$Basics$composeL, success, toRes));
					return A2(
						$elm$core$Platform$Cmd$map,
						httpResultToMsg,
						A2(requestCmd, model, flags));
				} else {
					return $elm$core$Platform$Cmd$none;
				}
			}());
	});
var $author$project$Store$Utils$modify = $author$project$Store$Utils$resourceReq($elm$core$Basics$identity);
var $author$project$Store$Platform2$createDashboard = F3(
	function (isRenamed, dashboardFullyLoaded, config) {
		var dashboard = $author$project$Data$Platform2$fromFullyLoadedDashboard(dashboardFullyLoaded);
		return A6(
			$author$project$Store$Utils$modify,
			function ($) {
				return $.v;
			},
			A2(
				$elm$core$Basics$composeL,
				config.a,
				$author$project$Store$Platform2$DashboardCreated(isRenamed)),
			config.av,
			function (_v0) {
				return $author$project$Data$Platform2$createDashboard(dashboardFullyLoaded);
			},
			dashboard,
			$elm$core$Basics$identity);
	});
var $author$project$Store$Platform2$DashboardAsCopyCreated = function (a) {
	return {$: 22, a: a};
};
var $author$project$Store$Platform2$createDashboardAsCopy = F4(
	function (dashboardFullyLoaded_, config, flags, store) {
		var cleanNotOwnedAudiences = function (dashboard_) {
			var data = dashboard_.cl;
			var filters = data.C;
			var newAudiences = A2(
				$elm$core$Maybe$andThen,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$List$filterMap(
						function (audienceId) {
							return A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.b;
								},
								A2($author$project$Store$Utils$get, store.d9, audienceId));
						}),
					A2(
						$elm$core$Basics$composeR,
						$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
						$elm$core$Maybe$map($turboMaCk$non_empty_list_alias$List$NonEmpty$toList))),
				filters.d9);
			return _Utils_update(
				dashboard_,
				{
					cl: _Utils_update(
						data,
						{
							C: _Utils_update(
								filters,
								{
									d9: newAudiences,
									nB: A2(
										$turboMaCk$any_dict$Dict$Any$filter,
										F2(
											function (audienceId, _v1) {
												return $elm_community$maybe_extra$Maybe$Extra$isJust(
													A2($author$project$Store$Utils$get, store.d9, audienceId));
											}),
										filters.nB),
									aU: A2(
										$elm_community$maybe_extra$Maybe$Extra$filter,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Store$Utils$get(store.d9),
											$elm_community$maybe_extra$Maybe$Extra$isJust),
										filters.aU)
								})
						})
				});
		};
		var dashboardFullyLoaded = cleanNotOwnedAudiences(dashboardFullyLoaded_);
		var dashboard = $author$project$Data$Platform2$fromFullyLoadedDashboard(dashboardFullyLoaded);
		return A8(
			$author$project$Store$Utils$modify,
			function ($) {
				return $.v;
			},
			A2($elm$core$Basics$composeL, config.a, $author$project$Store$Platform2$DashboardAsCopyCreated),
			config.av,
			function (_v0) {
				return $author$project$Data$Platform2$createDashboard(dashboardFullyLoaded);
			},
			dashboard,
			$elm$core$Basics$identity,
			flags,
			store);
	});
var $turboMaCk$glue$Glue$poly = function (rec) {
	return {oS: rec.oS, a: $elm$core$Basics$identity, rg: rec.rg};
};
var $author$project$Dashboards2Main$dashboards = $turboMaCk$glue$Glue$poly(
	{
		oS: A2(
			$elm$core$Basics$composeL,
			$elm$core$Result$toMaybe,
			$elm$core$Result$map(
				function ($) {
					return $.bD;
				})),
		rg: function (s_) {
			if (!s_.$) {
				var s = s_.a;
				return $elm$core$Result$map(
					function (state) {
						return _Utils_update(
							state,
							{bD: s});
					});
			} else {
				return $elm$core$Basics$identity;
			}
		}
	});
var $author$project$Store$Platform2$DashboardDestroyed = function (a) {
	return {$: 19, a: a};
};
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $author$project$Gwi$Http$Whatever = function (a) {
	return {$: 1, a: a};
};
var $author$project$Gwi$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectStringResponse,
		toMsg,
		$author$project$Gwi$Http$basicResolveResponse(
			$author$project$Gwi$Http$Whatever(0)));
};
var $author$project$Data$Platform2$deleteDashboard = F2(
	function (dashboard, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: $author$project$Gwi$Http$expectWhatever($elm$core$Basics$identity),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$),
						A2($elm$http$Http$header, 'content-type', 'application/json')
					]),
				h8: 'DELETE',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + $author$project$Data$Id$unwrap(dashboard.b))
			});
	});
var $author$project$Store$Platform2$destroyDashboard = F4(
	function (_v0, dashboard, flags, store) {
		var msg = _v0.a;
		var simpleErr = _v0.av;
		var httpResultToMsg = A2(
			$elm_community$result_extra$Result$Extra$unpack,
			simpleErr,
			A2(
				$elm$core$Basics$composeL,
				A2($elm$core$Basics$composeL, msg, $author$project$Store$Platform2$DashboardDestroyed),
				$elm$core$Basics$always(dashboard)));
		return _Utils_Tuple2(
			store,
			A2(
				$elm$core$Platform$Cmd$map,
				httpResultToMsg,
				A2($author$project$Data$Platform2$deleteDashboard, dashboard, flags)));
	});
var $author$project$Store$Platform2$WidgetDestroyed = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Data$Platform2$encodeDashboardForWidgetsUpdate = function (newWidgets) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'widgets',
				A2($elm$json$Json$Encode$list, $author$project$Data$Platform2$encodeWidget, newWidgets))
			]));
};
var $author$project$Data$Platform2$deleteWidget = F3(
	function (widgetId, dashboard, flags) {
		var filteredWidgets = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.b;
				},
				$elm$core$Basics$neq(widgetId)),
			dashboard.cl.g);
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeDashboardForWidgetsUpdate(filteredWidgets)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Data$Platform2$fromFullyLoadedDashboard,
						A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Platform2$dashboardFullyLoadedDecoder))),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'PATCH',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + $author$project$Data$Id$unwrap(dashboard.b))
			});
	});
var $author$project$Store$Platform2$destroyWidget = F5(
	function (_v0, widgetId, dashboard, flags, store) {
		var msg = _v0.a;
		var simpleErr = _v0.av;
		var httpResultToMsg = A2(
			$elm_community$result_extra$Result$Extra$unpack,
			simpleErr,
			A2(
				$elm$core$Basics$composeL,
				msg,
				$author$project$Store$Platform2$WidgetDestroyed(widgetId)));
		return _Utils_Tuple2(
			store,
			A2(
				$elm$core$Platform$Cmd$map,
				httpResultToMsg,
				A3($author$project$Data$Platform2$deleteWidget, widgetId, dashboard, flags)));
	});
var $author$project$Data$Id$encodeSet = function (set) {
	return A2($turboMaCk$any_set$Set$Any$encode, $author$project$Data$Id$encode, set);
};
var $author$project$DefaultQueryParams$fromResult = function (result) {
	return A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.oN;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.q_;
					},
					$elm$core$Maybe$map(
						A2(
							$elm$core$Basics$composeR,
							$elm$url$Url$Builder$string('revision'),
							$elm$core$List$singleton)))),
			$elm$core$Result$toMaybe(result)));
};
var $author$project$Dashboards2$UserFilters$getBaseAudienceId = A2(
	$elm$core$Basics$composeR,
	$author$project$Dashboards2$UserFilters$baseAudienceToMaybe,
	$elm$core$Maybe$map(
		function ($) {
			return $.b;
		}));
var $elm$html$Html$br = _VirtualDom_node('br');
var $author$project$Data$Core$Error$errorTitle = function (err) {
	if (err.$ === 3) {
		return 'Permissions insufficient to view data';
	} else {
		return $author$project$Data$Core$Error$errorToString(err);
	}
};
var $author$project$Error$InvalidAudiences = 2;
var $author$project$Error$InvalidNamespacesCombination = 0;
var $author$project$Error$InvalidQuery = 1;
var $author$project$Error$exceptionDecoder = function () {
	var decoder = function (exception) {
		var _v0 = $elm$core$String$toLower(exception);
		switch (_v0) {
			case 'invalidprojectscombination':
				return $elm$json$Json$Decode$succeed(0);
			case 'invalidquery':
				return $elm$json$Json$Decode$succeed(1);
			case 'invalidaudiences':
				return $elm$json$Json$Decode$succeed(2);
			default:
				return $elm$json$Json$Decode$fail('Unknown exception type: ' + exception);
		}
	};
	return A2(
		$elm$json$Json$Decode$field,
		'exception',
		A2($elm$json$Json$Decode$andThen, decoder, $elm$json$Json$Decode$string));
}();
var $author$project$Error$getExceptionType = function (requestBody) {
	return $elm$core$Result$toMaybe(
		A2($elm$json$Json$Decode$decodeString, $author$project$Error$exceptionDecoder, requestBody));
};
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $author$project$Error$messageDecoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[
			A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string),
			A2($elm$json$Json$Decode$field, 'error', $elm$json$Json$Decode$string)
		]));
var $author$project$Gwi$Http$otherErrorTitle = function (otherErr) {
	switch (otherErr.$) {
		case 0:
			return 'Error';
		case 7:
			return 'Error';
		case 1:
			return 'Shared Project Permissions';
		case 2:
			return 'Error';
		case 3:
			return 'Error';
		case 5:
			return 'Error';
		case 4:
			return 'Error';
		case 6:
			return 'Error';
		case 8:
			return 'Error';
		case 9:
			return 'Averages not supported';
		default:
			return 'Averages error';
	}
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Error$viewUuid = function (uuid) {
	return 'Error code: ' + uuid;
};
var $author$project$Error$getDisplay = F2(
	function (customErrorDisplay, error) {
		switch (error.$) {
			case 0:
				return {
					jv: $elm$html$Html$text('Oops, service can\'t be reached.'),
					j$: _List_Nil,
					ka: $elm$core$Maybe$Nothing,
					Y: 'Bad URL'
				};
			case 1:
				return {
					jv: $elm$html$Html$text('A request to our servers took way too long. Please try again later. If the issue persists then please start a live chat with a member of our support team using the button below.'),
					j$: _List_Nil,
					ka: $elm$core$Maybe$Nothing,
					Y: 'Timeout'
				};
			case 2:
				return {
					jv: $elm$html$Html$text('Unfortunately we have detected a connection issue. Please try again later. If the issue persists then please start a live chat with a member of our support team using the button below.'),
					j$: _List_Nil,
					ka: $elm$core$Maybe$Nothing,
					Y: 'Network Error'
				};
			case 3:
				var metadata = error.a;
				var body = error.b;
				var maybeUuid = A2($elm$core$Dict$get, 'x-gateway-uuid', metadata.hU);
				var badStatusMessage = function () {
					var _v1 = $author$project$Error$getExceptionType(body);
					_v1$2:
					while (true) {
						if (!_v1.$) {
							switch (_v1.a) {
								case 0:
									var _v2 = _v1.a;
									return A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('It is not possible to query two independent data sets. Please ensure that data and audiences selected are all from the same data set, or contact '),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$href('mailto:customersuccess@globalwebindex.com'),
														$elm$html$Html$Attributes$target('_blank')
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('customer support')
													])),
												$elm$html$Html$text(' for more information.')
											]));
								case 2:
									var _v3 = _v1.a;
									return A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('You do not have access to specified audience(s).'),
												A2($elm$html$Html$br, _List_Nil, _List_Nil),
												$elm$html$Html$text('This may be due to a change in your permissions, or due to a change in the questions used to create this audience. Please try to recreate the audience in Audience Builder, or contact support for help.')
											]));
								default:
									break _v1$2;
							}
						} else {
							break _v1$2;
						}
					}
					return $elm$html$Html$text(
						A2(
							$elm$core$Result$withDefault,
							'Unexpected error.',
							A2($elm$json$Json$Decode$decodeString, $author$project$Error$messageDecoder, body)));
				}();
				return {
					jv: badStatusMessage,
					j$: A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						A2($elm$core$Basics$composeR, $author$project$Error$viewUuid, $elm$core$List$singleton),
						maybeUuid),
					ka: maybeUuid,
					Y: 'Incompatible Data'
				};
			case 4:
				var decodeError = error.b;
				return {
					jv: $elm$html$Html$text(
						$elm$json$Json$Decode$errorToString(decodeError)),
					j$: _List_Nil,
					ka: $elm$core$Maybe$Nothing,
					Y: 'Bad Body'
				};
			case 5:
				var uuid = error.a;
				var genericError = error.c;
				return {
					jv: $elm$html$Html$text(
						$author$project$Data$Core$Error$errorToString(genericError)),
					j$: _List_fromArray(
						[
							$author$project$Error$viewUuid(uuid)
						]),
					ka: $elm$core$Maybe$Just(uuid),
					Y: $author$project$Data$Core$Error$errorTitle(genericError)
				};
			case 6:
				var uuid = error.a;
				var customError = error.c;
				var _v4 = customErrorDisplay(customError);
				var title = _v4.Y;
				var body = _v4.jv;
				var details = _v4.j$;
				return {
					jv: body,
					j$: A2(
						$elm$core$List$cons,
						$author$project$Error$viewUuid(uuid),
						details),
					ka: $elm$core$Maybe$Just(uuid),
					Y: title
				};
			default:
				var otherError = error.a;
				return {
					jv: $elm$html$Html$text(
						$author$project$Gwi$Http$otherErrorToString(otherError)),
					j$: _List_Nil,
					ka: $elm$core$Maybe$Nothing,
					Y: $author$project$Gwi$Http$otherErrorTitle(otherError)
				};
		}
	});
var $author$project$Dashboards2Main$getSharedStateFromKernel = _Platform_outgoingPort(
	'getSharedStateFromKernel',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Dashboards2Main$LoadExternalUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Error$Analytics$Forbidden = {$: 1};
var $author$project$Error$Analytics$InconsistentToken = {$: 4};
var $author$project$Error$Analytics$InvalidNamespacesCombination = {$: 2};
var $author$project$Error$Analytics$SessionExpired = {$: 3};
var $author$project$Error$Analytics$UnexpectedError = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$ErrorHandling$signOutUrl = F2(
	function (flags, redirectTo) {
		var url = A3(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dV;
			},
			function ($) {
				return $.eW;
			},
			$author$project$Config$Main$get(flags.j8));
		return url(
			{qH: redirectTo});
	});
var $author$project$Error$Analytics$encodeEvent = function (event) {
	switch (event.$) {
		case 0:
			var code = event.a;
			var url = event.b;
			return _Utils_Tuple2(
				'Unexpected Error',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'code',
							$elm$json$Json$Encode$int(code)),
							_Utils_Tuple2(
							'url',
							$elm$json$Json$Encode$string(url))
						])));
		case 2:
			return _Utils_Tuple2(
				'Query Error',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'error',
							$elm$json$Json$Encode$string('It is not possible to query two independent data sets. Please ensure that data and audiences selected are all from the same data set, or contact customer support for more information.')),
							_Utils_Tuple2(
							'exception',
							$elm$json$Json$Encode$string('InvalidQuery'))
						])));
		case 1:
			return _Utils_Tuple2('Forbidden', $elm$json$Json$Encode$null);
		case 3:
			return _Utils_Tuple2('Session Expired', $elm$json$Json$Encode$null);
		default:
			return _Utils_Tuple2('Got Inconsistent Token', $elm$json$Json$Encode$null);
	}
};
var $author$project$Error$Analytics$trackEvent = A2($elm$core$Basics$composeL, $author$project$Analytics$track, $author$project$Error$Analytics$encodeEvent);
var $author$project$ErrorHandling$signOutOn401 = F6(
	function (flags, err, redirectTo, loadUrl, defaultAction, model) {
		var signOutRedirect = function (_v10) {
			return _Utils_Tuple2(
				model,
				A2(
					$elm$core$Task$perform,
					$elm$core$Basics$always(
						loadUrl(
							A2($author$project$ErrorHandling$signOutUrl, flags, redirectTo))),
					$elm$core$Process$sleep(350)));
		};
		var event = function () {
			_v4$4:
			while (true) {
				switch (err.$) {
					case 3:
						var metadata = err.a;
						var body = err.b;
						var _v5 = metadata.rD;
						switch (_v5) {
							case 401:
								return $author$project$Error$Analytics$SessionExpired;
							case 403:
								return $author$project$Error$Analytics$Forbidden;
							default:
								var _v6 = $author$project$Error$getExceptionType(body);
								if ((!_v6.$) && (!_v6.a)) {
									var _v7 = _v6.a;
									return $author$project$Error$Analytics$InvalidNamespacesCombination;
								} else {
									return A2($author$project$Error$Analytics$UnexpectedError, metadata.rD, metadata.c3);
								}
						}
					case 5:
						switch (err.c.$) {
							case 5:
								var _v8 = err.c;
								return $author$project$Error$Analytics$SessionExpired;
							case 6:
								var _v9 = err.c;
								return $author$project$Error$Analytics$InconsistentToken;
							default:
								break _v4$4;
						}
					case 4:
						var metadata = err.a;
						return A2($author$project$Error$Analytics$UnexpectedError, metadata.rD, metadata.c3);
					default:
						break _v4$4;
				}
			}
			return A2($author$project$Error$Analytics$UnexpectedError, 0, 'unknown url');
		}();
		var _v0 = function () {
			_v1$3:
			while (true) {
				switch (err.$) {
					case 3:
						var metadata = err.a;
						return (metadata.rD === 401) ? signOutRedirect(0) : defaultAction(model);
					case 5:
						switch (err.c.$) {
							case 5:
								var _v2 = err.c;
								return signOutRedirect(0);
							case 6:
								var _v3 = err.c;
								return signOutRedirect(0);
							default:
								break _v1$3;
						}
					default:
						break _v1$3;
				}
			}
			return defaultAction(model);
		}();
		var newModel = _v0.a;
		var cmd = _v0.b;
		return _Utils_Tuple2(
			newModel,
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						$author$project$Error$Analytics$trackEvent(event),
						cmd
					])));
	});
var $elm$url$Url$addPort = F2(
	function (maybePort, starter) {
		if (maybePort.$ === 1) {
			return starter;
		} else {
			var port_ = maybePort.a;
			return starter + (':' + $elm$core$String$fromInt(port_));
		}
	});
var $elm$url$Url$addPrefixed = F3(
	function (prefix, maybeSegment, starter) {
		if (maybeSegment.$ === 1) {
			return starter;
		} else {
			var segment = maybeSegment.a;
			return _Utils_ap(
				starter,
				_Utils_ap(prefix, segment));
		}
	});
var $elm$url$Url$toString = function (url) {
	var http = function () {
		var _v0 = url.qB;
		if (!_v0) {
			return 'http://';
		} else {
			return 'https://';
		}
	}();
	return A3(
		$elm$url$Url$addPrefixed,
		'#',
		url.fS,
		A3(
			$elm$url$Url$addPrefixed,
			'?',
			url.gz,
			_Utils_ap(
				A2(
					$elm$url$Url$addPort,
					url.gu,
					_Utils_ap(http, url.fU)),
				url.gt)));
};
var $author$project$Dashboards2Main$handleAjaxError = F3(
	function (showErrorDialog, err, model) {
		if (!model.$) {
			var state = model.a;
			return A6(
				$author$project$ErrorHandling$signOutOn401,
				state.oN,
				err,
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, '', $elm$url$Url$toString, state.c3),
				$author$project$Dashboards2Main$LoadExternalUrl,
				showErrorDialog,
				model);
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Dashboards2$Modal$LinkInsightModal = function (a) {
	return {$: 15, a: a};
};
var $author$project$Dashboards2$Modal$ValidLink = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $author$project$Store$Platform2$getInsight = F2(
	function (insightId, store) {
		return A2(
			$elm$core$Maybe$withDefault,
			$krisajenkins$remotedata$RemoteData$NotAsked,
			A2($turboMaCk$any_dict$Dict$Any$get, insightId, store.pk));
	});
var $turboMaCk$any_set$Set$Any$removeAll = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$removeAll(dict);
};
var $author$project$Dashboards2$handleStoreError = F2(
	function (store, model) {
		var _v0 = model.c;
		if (_v0.$ === 15) {
			var data = _v0.a;
			var _v1 = data.aP;
			switch (_v1.$) {
				case 0:
					return model;
				case 1:
					return model;
				default:
					var v = _v1.a;
					var id = _v1.b;
					return _Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$LinkInsightModal(
								_Utils_update(
									data,
									{
										aP: A3(
											$author$project$Dashboards2$Modal$ValidLink,
											v,
											id,
											A2($author$project$Store$Platform2$getInsight, id, store))
									}))
						});
			}
		} else {
			return _Utils_update(
				model,
				{
					aY: $turboMaCk$any_set$Set$Any$removeAll(model.aY)
				});
		}
	});
var $author$project$Dashboards2$OpenClearFiltersConfirmModal = function (a) {
	return {$: 58, a: a};
};
var $author$project$Dashboards2$OpenUnsavedChangesModal = function (a) {
	return {$: 60, a: a};
};
var $author$project$Dashboards2$Modal$RenameDashboardModal = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $author$project$Gwi$Http$emptyMetadata = {hU: $elm$core$Dict$empty, rD: 0, rE: '', c3: ''};
var $author$project$Gwi$Http$fromHttpError = function (error) {
	switch (error.$) {
		case 0:
			var url = error.a;
			return $author$project$Gwi$Http$BadUrl(url);
		case 1:
			return $author$project$Gwi$Http$Timeout;
		case 2:
			return $author$project$Gwi$Http$NetworkError;
		case 3:
			var status = error.a;
			return A2(
				$author$project$Gwi$Http$BadStatus,
				_Utils_update(
					$author$project$Gwi$Http$emptyMetadata,
					{rD: status}),
				$elm$core$String$fromInt(status));
		default:
			var decodeError = error.a;
			return A2(
				$author$project$Gwi$Http$BadBody,
				$author$project$Gwi$Http$emptyMetadata,
				A2(
					$elm$json$Json$Decode$Failure,
					decodeError,
					$elm$json$Json$Encode$string('<VALUE LOST IN CONVERSION FROM Http.Error>')));
	}
};
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$core$Task$mapError = F2(
	function (convert, task) {
		return A2(
			$elm$core$Task$onError,
			A2($elm$core$Basics$composeL, $elm$core$Task$fail, convert),
			task);
	});
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $author$project$Gwi$Http$resolveErrorAwareJsonWithNever = function (successBodyDecoder) {
	return $elm$http$Http$stringResolver(
		$author$project$Gwi$Http$basicResolveResponse(
			$author$project$Gwi$Http$JsonDecoder(successBodyDecoder)));
};
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{nq: false, jv: r.jv, hK: r.qV, hU: r.hU, h8: r.h8, iY: r.iY, i0: $elm$core$Maybe$Nothing, c3: r.c3});
};
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $author$project$Gwi$Http$genericErrorToHttpError = function (err) {
	var unauthorized = 401;
	var notFound = 404;
	var internalServerError = 500;
	var gatewayTimeout = 504;
	var forbidden = 403;
	var badRequest = 400;
	return $elm$http$Http$BadStatus(
		function () {
			switch (err.$) {
				case 0:
					return badRequest;
				case 1:
					return badRequest;
				case 2:
					return internalServerError;
				case 4:
					return unauthorized;
				case 5:
					return forbidden;
				case 6:
					return forbidden;
				case 7:
					return internalServerError;
				case 8:
					return internalServerError;
				case 9:
					return notFound;
				case 3:
					return forbidden;
				case 10:
					return internalServerError;
				case 11:
					return gatewayTimeout;
				default:
					return internalServerError;
			}
		}());
};
var $author$project$Gwi$Http$toHttpError = F2(
	function (customErrorToHttpError, error) {
		switch (error.$) {
			case 0:
				var url = error.a;
				return $elm$http$Http$BadUrl(url);
			case 1:
				return $elm$http$Http$Timeout;
			case 2:
				return $elm$http$Http$NetworkError;
			case 3:
				var metadata = error.a;
				return $elm$http$Http$BadStatus(metadata.rD);
			case 4:
				var decodeError = error.b;
				return $elm$http$Http$BadBody(
					$elm$json$Json$Decode$errorToString(decodeError));
			case 5:
				var genericError = error.c;
				return $author$project$Gwi$Http$genericErrorToHttpError(genericError);
			case 6:
				var customError = error.c;
				return customErrorToHttpError(customError);
			default:
				var otherError = error.a;
				return $elm$http$Http$BadBody(
					$author$project$Gwi$Http$otherErrorToString(otherError));
		}
	});
var $author$project$Data$Platform2$getDashboardFullyLoadedTask = F2(
	function (dashboardId, flags) {
		return A2(
			$elm$core$Task$mapError,
			$author$project$Gwi$Http$toHttpError($elm$core$Basics$never),
			$elm$http$Http$task(
				{
					jv: $elm$http$Http$emptyBody,
					hU: A2(
						$author$project$Gwi$List$appendMaybe,
						A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
						_List_fromArray(
							[
								$author$project$Data$Auth$header(flags.i$)
							])),
					h8: 'GET',
					qV: $author$project$Gwi$Http$resolveErrorAwareJsonWithNever(
						A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Platform2$dashboardFullyLoadedDecoder)),
					iY: $elm$core$Maybe$Nothing,
					c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + $author$project$Data$Id$unwrap(dashboardId))
				}));
	});
var $author$project$Store$Platform2$getDashboardFullyLoadedTask = F3(
	function (dashboardId, flags, store) {
		var _v0 = A2($author$project$Store$Platform2$getDashboardFullyLoaded, dashboardId, store.v);
		switch (_v0.$) {
			case 0:
				return A2($author$project$Data$Platform2$getDashboardFullyLoadedTask, dashboardId, flags);
			case 1:
				return A2($author$project$Data$Platform2$getDashboardFullyLoadedTask, dashboardId, flags);
			case 3:
				var dashboard = _v0.a;
				return $elm$core$Task$succeed(dashboard);
			default:
				var err = _v0.a;
				return $elm$core$Task$fail(err);
		}
	});
var $author$project$Store$Platform2$LocationsByNamespaceFetched = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Data$Labels$encodeRequestForLocationsForNamespace = function (namespaceCode) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'namespaces',
				A2(
					$elm$json$Json$Encode$list,
					function (code) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$author$project$Data$Id$encode(code))
								]));
					},
					_List_fromArray(
						[namespaceCode]))),
				_Utils_Tuple2(
				'include',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'regions',
							$elm$json$Json$Encode$bool(true))
						])))
			]));
};
var $author$project$Data$Labels$Location = F4(
	function (code, name, region, accessible) {
		return {fc: accessible, bW: code, ld: name, qL: region};
	});
var $author$project$Data$Labels$Americas = 2;
var $author$project$Data$Labels$Apac = 3;
var $author$project$Data$Labels$Euro = 0;
var $author$project$Data$Labels$Mea = 1;
var $author$project$Data$Labels$regionCodeDecoder = function () {
	var typeBuilder = function (code) {
		switch (code) {
			case 'euro':
				return $elm$json$Json$Decode$succeed(0);
			case 'mea':
				return $elm$json$Json$Decode$succeed(1);
			case 'americas':
				return $elm$json$Json$Decode$succeed(2);
			case 'apac':
				return $elm$json$Json$Decode$succeed(3);
			default:
				return $elm$json$Json$Decode$fail('Invalid area code ' + code);
		}
	};
	return A2($elm$json$Json$Decode$andThen, typeBuilder, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Labels$locationV2Decoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['region', 'area']),
			$author$project$Data$Labels$regionCodeDecoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
				$elm$json$Json$Decode$succeed($author$project$Data$Labels$Location)))));
var $author$project$Data$Labels$host = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.j8;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Config$Main$get,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dV;
			},
			function ($) {
				return $.d5;
			})));
var $author$project$Data$Labels$locationsByNamespaceUrl = function (flags) {
	return A3(
		$elm$url$Url$Builder$crossOrigin,
		$author$project$Data$Labels$host(flags),
		_List_fromArray(
			['v2', 'locations', 'filter']),
		_List_Nil);
};
var $author$project$Data$Labels$getOrFetchLocationsTask = F2(
	function (namespaceCode, flags) {
		return A2(
			$elm$core$Task$mapError,
			$author$project$Gwi$Http$toHttpError($elm$core$Basics$never),
			$elm$http$Http$task(
				{
					jv: $elm$http$Http$jsonBody(
						$author$project$Data$Labels$encodeRequestForLocationsForNamespace(namespaceCode)),
					hU: A2(
						$author$project$Gwi$List$appendMaybe,
						A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
						_List_fromArray(
							[
								$author$project$Data$Auth$header(flags.i$)
							])),
					h8: 'POST',
					qV: $author$project$Gwi$Http$resolveErrorAwareJsonWithNever(
						A2(
							$elm$json$Json$Decode$field,
							'locations',
							$elm$json$Json$Decode$list($author$project$Data$Labels$locationV2Decoder))),
					iY: $elm$core$Maybe$Nothing,
					c3: $author$project$Data$Labels$locationsByNamespaceUrl(flags)
				}));
	});
var $author$project$Store$Platform2$getOrFetchLocationsTask = F3(
	function (namespaceCode, flags, store) {
		var task = A2(
			$elm$core$Task$map,
			function (locations) {
				return _Utils_Tuple2(
					$author$project$Data$Id$dictFromList(
						A2(
							$elm$core$List$map,
							function (l) {
								return _Utils_Tuple2(l.bW, l);
							},
							locations)),
					$elm$core$Maybe$Just(
						A2($author$project$Store$Platform2$LocationsByNamespaceFetched, namespaceCode, locations)));
			},
			A2($author$project$Data$Labels$getOrFetchLocationsTask, namespaceCode, flags));
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			task,
			function (locationsByNamespace) {
				switch (locationsByNamespace.$) {
					case 2:
						var e = locationsByNamespace.a;
						return $elm$core$Task$fail(e);
					case 3:
						var s = locationsByNamespace.a;
						return $elm$core$Task$succeed(
							_Utils_Tuple2(s, $elm$core$Maybe$Nothing));
					default:
						return task;
				}
			},
			A2($turboMaCk$any_dict$Dict$Any$get, namespaceCode, store.pK));
	});
var $author$project$Store$Platform2$WavesByNamespaceFetched = F2(
	function (a, b) {
		return {$: 17, a: a, b: b};
	});
var $author$project$Data$Labels$Wave = F6(
	function (code, name, accessible, kind, startDate, endDate) {
		return {fc: accessible, bW: code, j7: endDate, pz: kind, ld: name, mk: startDate};
	});
var $waratuman$time_extra$Time$Extra$epoch = $elm$time$Time$millisToPosix(0);
var $waratuman$time_extra$Time$Extra$intToMonth = function (i) {
	switch (i) {
		case 1:
			return $elm$core$Maybe$Just(0);
		case 2:
			return $elm$core$Maybe$Just(1);
		case 3:
			return $elm$core$Maybe$Just(2);
		case 4:
			return $elm$core$Maybe$Just(3);
		case 5:
			return $elm$core$Maybe$Just(4);
		case 6:
			return $elm$core$Maybe$Just(5);
		case 7:
			return $elm$core$Maybe$Just(6);
		case 8:
			return $elm$core$Maybe$Just(7);
		case 9:
			return $elm$core$Maybe$Just(8);
		case 10:
			return $elm$core$Maybe$Just(9);
		case 11:
			return $elm$core$Maybe$Just(10);
		case 12:
			return $elm$core$Maybe$Just(11);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$Maybe$map3 = F4(
	function (func, ma, mb, mc) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					return $elm$core$Maybe$Just(
						A3(func, a, b, c));
				}
			}
		}
	});
var $waratuman$time_extra$Time$Extra$isleapYear = function (y) {
	return ((!A2($elm$core$Basics$modBy, 4, y)) && (!(!A2($elm$core$Basics$modBy, 100, y)))) || (!A2($elm$core$Basics$modBy, 400, y));
};
var $waratuman$time_extra$Time$Extra$daysInMonth = F2(
	function (y, m) {
		switch (m) {
			case 1:
				return $waratuman$time_extra$Time$Extra$isleapYear(y) ? 29 : 28;
			case 3:
				return 30;
			case 5:
				return 30;
			case 8:
				return 30;
			case 10:
				return 30;
			default:
				return 31;
		}
	});
var $waratuman$time_extra$Time$Extra$msPerDay = 86400000;
var $waratuman$time_extra$Time$Extra$msPerHour = 3600000;
var $waratuman$time_extra$Time$Extra$setDay = F3(
	function (z, d, t) {
		var t_ = $elm$time$Time$posixToMillis(t);
		var origHour = A2($elm$time$Time$toHour, z, t);
		var dim = A2(
			$waratuman$time_extra$Time$Extra$daysInMonth,
			A2($elm$time$Time$toYear, z, t),
			A2($elm$time$Time$toMonth, z, t));
		var cd = A2($elm$time$Time$toDay, z, t);
		var diff_ = ((_Utils_cmp(d, dim) < 1) ? (d - cd) : (dim - cd)) * $waratuman$time_extra$Time$Extra$msPerDay;
		var newHour = A2(
			$elm$time$Time$toHour,
			z,
			$elm$time$Time$millisToPosix(t_ + diff_));
		var diff = _Utils_eq(newHour, origHour) ? diff_ : ((_Utils_cmp(newHour, origHour) > 0) ? (diff_ + $waratuman$time_extra$Time$Extra$msPerHour) : (diff_ - $waratuman$time_extra$Time$Extra$msPerHour));
		return $elm$time$Time$millisToPosix(diff + t_);
	});
var $waratuman$time_extra$Time$Extra$leapYearsBefore = function (y1) {
	var y = y1 - 1;
	return (((y / 4) | 0) - ((y / 100) | 0)) + ((y / 400) | 0);
};
var $waratuman$time_extra$Time$Extra$monthToInt = function (m) {
	switch (m) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $waratuman$time_extra$Time$Extra$months = _List_fromArray(
	[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]);
var $waratuman$time_extra$Time$Extra$msPerYear = 31536000000;
var $waratuman$time_extra$Time$Extra$setMonth = F3(
	function (z, month, t) {
		var y = A2($elm$time$Time$toYear, z, t);
		var yms = ($waratuman$time_extra$Time$Extra$msPerYear * (y - 1970)) + ($waratuman$time_extra$Time$Extra$msPerDay * ($waratuman$time_extra$Time$Extra$leapYearsBefore(y) - $waratuman$time_extra$Time$Extra$leapYearsBefore(1970)));
		var intMonth = $waratuman$time_extra$Time$Extra$monthToInt(month);
		var mms = A3(
			$elm$core$List$foldl,
			F2(
				function (m_, days) {
					return (_Utils_cmp(
						intMonth,
						$waratuman$time_extra$Time$Extra$monthToInt(m_)) > 0) ? (days + A2($waratuman$time_extra$Time$Extra$daysInMonth, y, m_)) : days;
				}),
			0,
			$waratuman$time_extra$Time$Extra$months) * $waratuman$time_extra$Time$Extra$msPerDay;
		var dim = A2($waratuman$time_extra$Time$Extra$daysInMonth, y, month);
		var d_ = A2($elm$time$Time$toDay, z, t);
		var d = (_Utils_cmp(d_, dim) > 0) ? dim : d_;
		var dms = (d - 1) * $waratuman$time_extra$Time$Extra$msPerDay;
		return $elm$time$Time$millisToPosix((yms + mms) + dms);
	});
var $waratuman$time_extra$Time$Extra$setYear = F3(
	function (z, year, t) {
		var yms = ($waratuman$time_extra$Time$Extra$msPerYear * (year - 1970)) + ($waratuman$time_extra$Time$Extra$msPerDay * ($waratuman$time_extra$Time$Extra$leapYearsBefore(year) - $waratuman$time_extra$Time$Extra$leapYearsBefore(1970)));
		var y_ = A2($elm$time$Time$toYear, z, t);
		var yms_ = ($waratuman$time_extra$Time$Extra$msPerYear * (y_ - 1970)) + ($waratuman$time_extra$Time$Extra$msPerDay * ($waratuman$time_extra$Time$Extra$leapYearsBefore(y_) - $waratuman$time_extra$Time$Extra$leapYearsBefore(1970)));
		return $elm$time$Time$millisToPosix(
			($elm$time$Time$posixToMillis(t) - yms_) + yms);
	});
var $waratuman$time_extra$Time$Extra$fromIso8601Date = F2(
	function (z, date) {
		var _v0 = A2($elm$core$String$split, '-', date);
		if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.b.b)) {
			var y_ = _v0.a;
			var _v1 = _v0.b;
			var m_ = _v1.a;
			var _v2 = _v1.b;
			var d_ = _v2.a;
			return A4(
				$elm$core$Maybe$map3,
				F3(
					function (a, b, c) {
						return A3(
							$waratuman$time_extra$Time$Extra$setDay,
							z,
							c,
							A3(
								$waratuman$time_extra$Time$Extra$setMonth,
								z,
								b,
								A3($waratuman$time_extra$Time$Extra$setYear, z, a, $waratuman$time_extra$Time$Extra$epoch)));
					}),
				$elm$core$String$toInt(
					A2($elm$core$String$right, 4, y_)),
				A2(
					$elm$core$Maybe$andThen,
					$waratuman$time_extra$Time$Extra$intToMonth,
					$elm$core$String$toInt(
						A2($elm$core$String$right, 2, m_))),
				$elm$core$String$toInt(
					A2($elm$core$String$right, 2, d_)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Labels$dateDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		return A2(
			$elm_community$json_extra$Json$Decode$Extra$fromMaybe,
			'Invalid date: ' + str,
			A2(
				$waratuman$time_extra$Time$Extra$fromIso8601Date,
				$elm$time$Time$utc,
				$elm$core$String$concat(
					A2(
						$elm$core$List$take,
						1,
						A2($elm$core$String$split, 'T', str)))));
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Labels$Quarter = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Labels$SlidingQuarter = {$: 1};
var $author$project$Data$Labels$Q1 = 0;
var $author$project$Data$Labels$Q2 = 1;
var $author$project$Data$Labels$Q3 = 2;
var $author$project$Data$Labels$Q4 = 3;
var $author$project$Data$Labels$dateToQuarter = function (date) {
	var _v0 = A2($elm$time$Time$toMonth, $elm$time$Time$utc, date);
	switch (_v0) {
		case 0:
			return $elm$core$Maybe$Just(0);
		case 3:
			return $elm$core$Maybe$Just(1);
		case 6:
			return $elm$core$Maybe$Just(2);
		case 9:
			return $elm$core$Maybe$Just(3);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Labels$waveKindDecoder = function () {
	var quarterDecoder = A2(
		$elm$json$Json$Decode$andThen,
		function (date) {
			return A2(
				$elm_community$json_extra$Json$Decode$Extra$fromMaybe,
				'Unsuccessful quarter decoding from date ' + $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(date),
				$author$project$Data$Labels$dateToQuarter(date));
		},
		A2($elm$json$Json$Decode$field, 'date_start', $author$project$Data$Labels$dateDecoder));
	var kindDecoder = function (kind) {
		switch (kind) {
			case 'quarter':
				return A2($elm$json$Json$Decode$map, $author$project$Data$Labels$Quarter, quarterDecoder);
			case 'sliding_quarter':
				return $elm$json$Json$Decode$succeed($author$project$Data$Labels$SlidingQuarter);
			default:
				var unknown = kind;
				return $elm$json$Json$Decode$fail('Unsupported wave kind: ' + unknown);
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		kindDecoder,
		A2($elm$json$Json$Decode$field, 'kind', $elm$json$Json$Decode$string));
}();
var $author$project$Data$Labels$waveDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'date_end', $author$project$Data$Labels$dateDecoder),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'date_start', $author$project$Data$Labels$dateDecoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$author$project$Data$Labels$waveKindDecoder,
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
						$elm$json$Json$Decode$succeed($author$project$Data$Labels$Wave)))))));
var $author$project$Data$Labels$wavesDecoder = $elm$json$Json$Decode$list($author$project$Data$Labels$waveDecoder);
var $author$project$Data$Labels$getOrFetchWavesTask = F2(
	function (namespaceCode, flags) {
		return A2(
			$elm$core$Task$mapError,
			$author$project$Gwi$Http$toHttpError($elm$core$Basics$never),
			$elm$http$Http$task(
				{
					jv: $elm$http$Http$emptyBody,
					hU: A2(
						$author$project$Gwi$List$appendMaybe,
						A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
						_List_fromArray(
							[
								$author$project$Data$Auth$header(flags.i$)
							])),
					h8: 'GET',
					qV: $author$project$Gwi$Http$resolveErrorAwareJsonWithNever(
						A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Labels$wavesDecoder)),
					iY: $elm$core$Maybe$Nothing,
					c3: A3(
						$elm$url$Url$Builder$crossOrigin,
						$author$project$Data$Labels$host(flags),
						_List_fromArray(
							[
								'v1',
								'surveys',
								'waves',
								'by_namespace',
								$author$project$Data$Id$unwrap(namespaceCode)
							]),
						_List_Nil)
				}));
	});
var $author$project$Store$Platform2$getOrFetchWavesTask = F3(
	function (namespaceCode, flags, store) {
		var task = A2(
			$elm$core$Task$map,
			function (waves) {
				return _Utils_Tuple2(
					$author$project$Data$Id$dictFromList(
						A2(
							$elm$core$List$map,
							function (w) {
								return _Utils_Tuple2(w.bW, w);
							},
							waves)),
					$elm$core$Maybe$Just(
						A2($author$project$Store$Platform2$WavesByNamespaceFetched, namespaceCode, waves)));
			},
			A2($author$project$Data$Labels$getOrFetchWavesTask, namespaceCode, flags));
		return A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			task,
			function (wavesByNamespace) {
				switch (wavesByNamespace.$) {
					case 2:
						var e = wavesByNamespace.a;
						return $elm$core$Task$fail(e);
					case 3:
						var s = wavesByNamespace.a;
						return $elm$core$Task$succeed(
							_Utils_Tuple2(s, $elm$core$Maybe$Nothing));
					default:
						return task;
				}
			},
			A2($turboMaCk$any_dict$Dict$Any$get, namespaceCode, store.se));
	});
var $author$project$Dashboards2$Editable$isEdited = function (editable) {
	switch (editable.$) {
		case 0:
			return false;
		case 1:
			return false;
		default:
			return true;
	}
};
var $elm_community$maybe_extra$Maybe$Extra$isNothing = function (m) {
	if (m.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Dashboards2$Detail$isUnsaved = function (model) {
	return $elm_community$maybe_extra$Maybe$Extra$isJust(model.ba) || $author$project$Dashboards2$Editable$isEdited(
		$author$project$Dashboards2$Detail$currentEditableUserFilters(model));
};
var $author$project$Dashboards2$isUnsaved = $author$project$Dashboards2$Detail$isUnsaved;
var $author$project$Dashboards2$namespacesForWidgets = function (widgets) {
	return A2(
		$elm_community$list_extra$List$Extra$uniqueBy,
		$author$project$Data$Id$unwrap,
		A2(
			$author$project$Gwi$List$fastConcatMap,
			function (widgetData) {
				var _v0 = widgetData.cl;
				if (!_v0.$) {
					var questionCode = _v0.a.at;
					return _List_fromArray(
						[
							$author$project$Data$Labels$questionCodeToNamespaceCode(questionCode)
						]);
				} else {
					var groups = _v0.a;
					return A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.at;
							},
							$author$project$Data$Labels$questionCodeToNamespaceCode),
						$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(groups));
				}
			},
			A2($elm$core$List$filterMap, $author$project$Data$Platform2$getChartWidget, widgets)));
};
var $author$project$Dashboards2$interruptRouting = F7(
	function (config, flags, _continue, withStoreMsgs, store, route, model) {
		var unpackResult = A2(
			$elm_community$result_extra$Result$Extra$unpack,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Gwi$Http$fromHttpError,
				config.bQ($elm$core$Basics$identity)),
			$elm$core$Basics$identity);
		var combineTaskResults = A2(
			$elm$core$List$foldr,
			F2(
				function (_v6, _v7) {
					var waves = _v6.a;
					var locations = _v6.b;
					var maybeMsg = _v6.c;
					var wavesSoFar = _v7.a;
					var locationsSoFar = _v7.b;
					var msgs = _v7.c;
					return _Utils_Tuple3(
						A2($turboMaCk$any_dict$Dict$Any$union, waves, wavesSoFar),
						A2($turboMaCk$any_dict$Dict$Any$union, locations, locationsSoFar),
						A4($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$core$Basics$identity, $elm$core$List$cons, maybeMsg, msgs));
				}),
			_Utils_Tuple3($author$project$Data$Id$emptyDict, $author$project$Data$Id$emptyDict, _List_Nil));
		var changeDefaultNameInterruption = function (_v5) {
			return A2(
				$elm$core$Maybe$map,
				function (currentDashboard) {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							model,
							{
								aW: $elm$core$Maybe$Nothing,
								c: A2($author$project$Dashboards2$Modal$RenameDashboardModal, currentDashboard.b, currentDashboard.ld),
								a6: $elm$core$Maybe$Just(route)
							}));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return $krisajenkins$remotedata$RemoteData$toMaybe(
							A2($author$project$Store$Platform2$getDashboard, id, store.v));
					},
					model.aW));
		};
		var showLeaveConfirmIfUnsaved = function (_v4) {
			return $author$project$Dashboards2$isUnsaved(model) ? $elm$core$Maybe$Just(
				A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.a(
						$author$project$Dashboards2$OpenUnsavedChangesModal(route)),
					model)) : changeDefaultNameInterruption(0);
		};
		var allActiveWaves = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			A2($elm$core$Basics$composeR, $author$project$Dashboards2$UserFilters$waves, $turboMaCk$any_set$Set$Any$toList),
			$author$project$Dashboards2$getUserFilters(model));
		var wavesDiffer = function (waves) {
			return A2(
				$elm$core$List$any,
				function (waveCode) {
					return $elm_community$maybe_extra$Maybe$Extra$isNothing(
						A2($turboMaCk$any_dict$Dict$Any$get, waveCode, waves));
				},
				allActiveWaves);
		};
		var allActiveLocations = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			A2($elm$core$Basics$composeR, $author$project$Dashboards2$UserFilters$locations, $turboMaCk$any_set$Set$Any$toList),
			$author$project$Dashboards2$getUserFilters(model));
		var locationsDiffer = function (locations) {
			return A2(
				$elm$core$List$any,
				function (locationCode) {
					return $elm_community$maybe_extra$Maybe$Extra$isNothing(
						A2($turboMaCk$any_dict$Dict$Any$get, locationCode, locations));
				},
				allActiveLocations);
		};
		switch (route.$) {
			case 1:
				var dashboardId = route.a;
				return $elm$core$Maybe$Just(
					_Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							unpackResult,
							A2(
								$elm$core$Task$andThen,
								function (dashboard) {
									var namespaceCodes = $author$project$Dashboards2$namespacesForWidgets(dashboard.cl.g);
									var filtersEdited = $author$project$Dashboards2$Editable$isEdited(
										$author$project$Dashboards2$Detail$currentEditableUserFilters(model));
									var checkIfWavesOrLocationsDiffer = F2(
										function (wavesResults, locationsResults) {
											var _v1 = combineTaskResults(
												_Utils_ap(
													A2(
														$elm$core$List$map,
														function (_v2) {
															var dict = _v2.a;
															var msg = _v2.b;
															return _Utils_Tuple3(dict, $author$project$Data$Id$emptyDict, msg);
														},
														wavesResults),
													A2(
														$elm$core$List$map,
														function (_v3) {
															var dict = _v3.a;
															var msg = _v3.b;
															return _Utils_Tuple3($author$project$Data$Id$emptyDict, dict, msg);
														},
														locationsResults)));
											var waves = _v1.a;
											var locations = _v1.b;
											var msgs = _v1.c;
											return A2(
												withStoreMsgs,
												msgs,
												(wavesDiffer(waves) || locationsDiffer(locations)) ? config.a(
													$author$project$Dashboards2$OpenClearFiltersConfirmModal(route)) : _continue);
										});
									return (filtersEdited && (!$elm$core$List$isEmpty(namespaceCodes))) ? A3(
										$elm$core$Task$map2,
										checkIfWavesOrLocationsDiffer,
										$elm$core$Task$sequence(
											A2(
												$elm$core$List$map,
												function (namespaceCode) {
													return A3($author$project$Store$Platform2$getOrFetchWavesTask, namespaceCode, flags, store);
												},
												namespaceCodes)),
										$elm$core$Task$sequence(
											A2(
												$elm$core$List$map,
												function (namespaceCode) {
													return A3($author$project$Store$Platform2$getOrFetchLocationsTask, namespaceCode, flags, store);
												},
												namespaceCodes))) : $elm$core$Task$succeed(_continue);
								},
								A3($author$project$Store$Platform2$getDashboardFullyLoadedTask, dashboardId, flags, store)))));
			case 2:
				return $elm$core$Maybe$Nothing;
			case 0:
				return showLeaveConfirmIfUnsaved(0);
			case 3:
				return showLeaveConfirmIfUnsaved(0);
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Dashboards2Main$interruptRoutingStatus = _Platform_outgoingPort('interruptRoutingStatus', $elm$json$Json$Encode$bool);
var $author$project$Data$Platform2$isDashboardNewAndUnsaved = function (_v0) {
	var id = _v0.b;
	return _Utils_eq(id, $author$project$Data$Platform2$newUnsavedDashboardId);
};
var $author$project$Permissions$isDashboardsCreator = function (can) {
	return can(23) || can(24);
};
var $elm$browser$Browser$Navigation$load = _Browser_load;
var $author$project$Dashboards2Main$mountedD2 = _Platform_outgoingPort(
	'mountedD2',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Dashboards2Main$navigateToD2 = _Platform_outgoingPort('navigateToD2', $elm$json$Json$Encode$string);
var $author$project$Upsell$Analytics$EnterpriseCTAClicked = F4(
	function (a, b, c, d) {
		return {$: 1, a: a, b: b, c: c, d: d};
	});
var $author$project$Upsell$Analytics$placeAttr = function (place) {
	return _Utils_Tuple2(
		'place',
		$author$project$Analytics$Place$encode(place));
};
var $author$project$Data$Upsell$getId = function (resource) {
	switch (resource.$) {
		case 0:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
		case 1:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
		case 2:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
		case 3:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
		case 4:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
		case 5:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
		case 6:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
		case 7:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
		default:
			var id = resource.a;
			return $author$project$Data$Id$unwrap(id);
	}
};
var $author$project$Upsell$Analytics$upsellResourceAttr = function (resource) {
	return A2(
		$elm$core$Tuple$pair,
		'item_id',
		$elm$json$Json$Encode$string(
			$author$project$Data$Upsell$getId(resource)));
};
var $author$project$Upsell$Analytics$encodeEvent = function (event) {
	if (event.$ === 1) {
		var text = event.a;
		var url = event.b;
		var resource = event.c;
		var place = event.d;
		return _Utils_Tuple2(
			'Enterprise CTA Clicked',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						$author$project$Upsell$Analytics$placeAttr(place),
						$author$project$Upsell$Analytics$upsellResourceAttr(resource),
						_Utils_Tuple2(
						'button_copy',
						$elm$json$Json$Encode$string(text)),
						_Utils_Tuple2(
						'url',
						$elm$json$Json$Encode$string(url))
					])));
	} else {
		var resource = event.a;
		var place = event.b;
		return _Utils_Tuple2(
			'Enterprise Upsell Shown',
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						$author$project$Upsell$Analytics$placeAttr(place),
						$author$project$Upsell$Analytics$upsellResourceAttr(resource)
					])));
	}
};
var $author$project$Upsell$Analytics$trackEvent = A2($elm$core$Basics$composeL, $author$project$Analytics$track, $author$project$Upsell$Analytics$encodeEvent);
var $author$project$Upsell$Dialog$navigateToGetInTouch = F4(
	function (config, btnText, place, resource) {
		var url = 'https://www.globalwebindex.com/enterprise-get-in-touch';
		return $elm$core$Platform$Cmd$batch(
			_List_fromArray(
				[
					$GlobalWebIndex$cmd_extra$Cmd$Extra$perform(
					config.qk(url)),
					A2(
					$elm$core$Platform$Cmd$map,
					config.a,
					$author$project$Upsell$Analytics$trackEvent(
						A4($author$project$Upsell$Analytics$EnterpriseCTAClicked, btnText, url, resource, place)))
				]));
	});
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $author$project$Dashboards2$Router$toUrlString = F2(
	function (prefix, route_) {
		switch (route_.$) {
			case 0:
				return $elm$url$Url$Builder$absolute(
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[prefix])));
			case 1:
				var id = route_.a;
				return $elm$url$Url$Builder$absolute(
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								prefix,
								$elm$core$Maybe$Just(
								$author$project$Data$Id$unwrap(id))
							])));
			case 3:
				var url = route_.a;
				return $elm$core$Basics$always(url);
			case 4:
				return $elm$url$Url$Builder$absolute(
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								prefix,
								$elm$core$Maybe$Just('not-found')
							])));
			default:
				return $elm$url$Url$Builder$absolute(
					$elm_community$maybe_extra$Maybe$Extra$values(
						_List_fromArray(
							[
								prefix,
								$elm$core$Maybe$Just('new')
							])));
		}
	});
var $turboMaCk$glue$Glue$Lazy$patch = function (f) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Maybe$withDefault(
			_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Platform$Cmd$none)),
		$elm$core$Maybe$map(
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Tuple$mapFirst($elm$core$Maybe$Just),
				f)));
};
var $turboMaCk$glue$Glue$Lazy$updateWith = F2(
	function (glue, f) {
		return A2(
			$turboMaCk$glue$Glue$updateWith,
			glue,
			$turboMaCk$glue$Glue$Lazy$patch(f));
	});
var $author$project$Dashboards2Main$navigateToWithCheck = F3(
	function (newRoute, state, model) {
		var updateDashboardsModelIfGoingToDashboard = function (_v2) {
			var m = _v2.a;
			var c = _v2.b;
			if (newRoute.$ === 1) {
				var dashboardId = newRoute.a;
				return _Utils_Tuple2(
					_Utils_update(
						m,
						{
							dS: $elm$core$Maybe$Just(dashboardId)
						}),
					c);
			} else {
				return _Utils_Tuple2(m, c);
			}
		};
		var queryParams = $author$project$DefaultQueryParams$fromResult(model);
		var prefix = A2(
			$elm$core$Maybe$andThen,
			$author$project$Config$combinePrefixAndFeature,
			$elm$core$Result$toMaybe(
				A2(
					$elm$core$Result$map,
					function ($) {
						return $.oN;
					},
					model)));
		var interruptRoute = $author$project$Data$User$hasViewOnlyPlan(state.oN.mQ) ? $elm$core$Maybe$Nothing : A7(
			$author$project$Dashboards2$interruptRouting,
			state.aX,
			state.oN,
			$author$project$Dashboards2Main$ForceNavigateTo(newRoute),
			$author$project$Dashboards2Main$StoreActionsAndContinue,
			state.s,
			newRoute,
			state.bD);
		if (!interruptRoute.$) {
			var newPair = interruptRoute.a;
			var newUpdatedPair = updateDashboardsModelIfGoingToDashboard(newPair);
			return A3(
				$turboMaCk$glue$Glue$Lazy$updateWith,
				$author$project$Dashboards2Main$dashboards,
				$elm$core$Basics$always(newUpdatedPair),
				$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
		} else {
			return _Utils_Tuple2(
				model,
				$author$project$Dashboards2Main$navigateToD2(
					A3($author$project$Dashboards2$Router$toUrlString, prefix, newRoute, queryParams)));
		}
	});
var $author$project$Ports$openChatWithErrorId = _Platform_outgoingPort('openChatWithErrorId', $elm$core$Basics$identity);
var $author$project$Dashboards2$Modal$ErrorModal = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$openErrorModal = F2(
	function (errorDisplay, model) {
		return _Utils_update(
			model,
			{
				aY: $turboMaCk$any_set$Set$Any$removeAll(model.aY),
				c: $author$project$Dashboards2$Modal$ErrorModal(
					{j9: errorDisplay})
			});
	});
var $author$project$Dashboards2Main$openNewWindowD2 = _Platform_outgoingPort('openNewWindowD2', $elm$json$Json$Encode$string);
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {cs: frag, lw: params, ca: unvisited, c5: value, c6: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.ca;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.c5);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.c5);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.gt),
					$elm$url$Url$Parser$prepareQuery(url.gz),
					url.fS,
					$elm$core$Basics$identity)));
	});
var $author$project$Dashboards2$Router$Dashboard = function (a) {
	return {$: 1, a: a};
};
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.c6;
		var unvisited = _v0.ca;
		var params = _v0.lw;
		var frag = _v0.cs;
		var value = _v0.c5;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.c6;
			var unvisited = _v1.ca;
			var params = _v1.lw;
			var frag = _v1.cs;
			var value = _v1.c5;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.c6;
		var unvisited = _v0.ca;
		var params = _v0.lw;
		var frag = _v0.cs;
		var value = _v0.c5;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.c6;
			var unvisited = _v0.ca;
			var params = _v0.lw;
			var frag = _v0.cs;
			var value = _v0.c5;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Dashboards2$Router$route = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Dashboards2$Router$NotFound,
			$elm$url$Url$Parser$s('not-found')),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Dashboards2$Router$NewDashboard,
			$elm$url$Url$Parser$s('new')),
			A2(
			$elm$url$Url$Parser$map,
			A2($elm$core$Basics$composeL, $author$project$Dashboards2$Router$Dashboard, $author$project$Data$Id$fromString),
			$elm$url$Url$Parser$string),
			A2($elm$url$Url$Parser$map, $author$project$Dashboards2$Router$DashboardsList, $elm$url$Url$Parser$top)
		]));
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $author$project$Dashboards2$Router$parseUrl = F2(
	function (flags, url) {
		var namespaceRouter = function (str) {
			return A3(
				$elm$core$List$foldl,
				$elm$core$Basics$composeR,
				$elm$core$Basics$identity,
				A2(
					$elm$core$List$map,
					A2($elm$core$Basics$composeL, $elm$url$Url$Parser$slash, $elm$url$Url$Parser$s),
					A2($elm$core$String$split, '/', str)));
		};
		return function (f) {
			return A2(
				$elm$url$Url$Parser$parse,
				f($author$project$Dashboards2$Router$route),
				url);
		}(
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$elm$core$Basics$identity,
				namespaceRouter,
				$author$project$Config$combinePrefixAndFeature(flags)));
	});
var $author$project$Dashboards2Main$platform2Store = $turboMaCk$glue$Glue$poly(
	{
		oS: A2(
			$elm$core$Basics$composeL,
			$elm$core$Result$toMaybe,
			$elm$core$Result$map(
				function ($) {
					return $.s;
				})),
		rg: F2(
			function (store_, model) {
				if (!store_.$) {
					var s = store_.a;
					return A2(
						$elm$core$Result$map,
						function (state) {
							return _Utils_update(
								state,
								{s: s});
						},
						model);
				} else {
					return model;
				}
			})
	});
var $author$project$Dashboards2Main$AjaxErrorWithoutModal = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Dashboards2Main$NotFoundApiError = function (a) {
	return {$: 40, a: a};
};
var $author$project$Store$Platform2$configure = function (c) {
	return {
		ox: c.ox,
		oy: c.oy,
		a: c.a,
		p3: c.p3,
		av: c.ox($elm$core$Basics$identity)
	};
};
var $author$project$Dashboards2Main$platform2StoreConfig = $author$project$Store$Platform2$configure(
	{ox: $author$project$Dashboards2Main$AjaxError, oy: $author$project$Dashboards2Main$AjaxErrorWithoutModal, a: $author$project$Dashboards2Main$Platform2StoreMsg, p3: $author$project$Dashboards2Main$NotFoundApiError});
var $author$project$Store$Platform2$DashboardRenameResult = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Data$Platform2$encodeDashboardForRename = function (newName) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(newName))
			]));
};
var $author$project$Data$Platform2$renameDashboard = F3(
	function (flags, dashboardId, newName) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeDashboardForRename(newName)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Platform2$dashboardFullyLoadedDecoder)),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'PATCH',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + $author$project$Data$Id$unwrap(dashboardId))
			});
	});
var $author$project$Store$Platform2$renameDashboard = F5(
	function (dashboardId, newName, config, flags, store) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			_Utils_Tuple2(store, $elm$core$Platform$Cmd$none),
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (_v0) {
					var dashboards = _v0.a;
					var oldDashboard = _v0.b;
					return _Utils_Tuple2(
						_Utils_update(
							store,
							{
								v: $krisajenkins$remotedata$RemoteData$Success(
									A3(
										$turboMaCk$any_dict$Dict$Any$insert,
										dashboardId,
										_Utils_update(
											oldDashboard,
											{ld: newName}),
										dashboards))
							}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeL,
								config.a,
								$author$project$Store$Platform2$DashboardRenameResult(
									{lq: oldDashboard})),
							A3($author$project$Data$Platform2$renameDashboard, flags, dashboardId, newName)));
				},
				A3(
					$krisajenkins$remotedata$RemoteData$map2,
					$elm$core$Tuple$pair,
					store.v,
					A2($author$project$Store$Platform2$getDashboard, dashboardId, store.v))));
	});
var $author$project$Dashboards2Main$setDashboardEditedState = _Platform_outgoingPort('setDashboardEditedState', $elm$json$Json$Encode$bool);
var $author$project$Dashboards2$Detail$SavingDashboard = 0;
var $author$project$Dashboards2$setSavingState = F2(
	function (savingState, model) {
		return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
			_Utils_update(
				model,
				{cV: savingState}));
	});
var $author$project$Dashboards2$setDashboardIsSaving = $author$project$Dashboards2$setSavingState(0);
var $author$project$Data$GettableKeyValueHeader$GettableKeyValueHeader = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader = $author$project$Data$GettableKeyValueHeader$GettableKeyValueHeader;
var $author$project$Dashboards2Main$setExtraApiHeaderForViewOnlyAccounts = function () {
	var getDashboard = F2(
		function (route, store) {
			switch (route.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					var id = route.a;
					return $krisajenkins$remotedata$RemoteData$toMaybe(
						A2($author$project$Store$Platform2$getDashboard, id, store.v));
				case 2:
					return $elm$core$Maybe$Nothing;
				case 3:
					return $elm$core$Maybe$Nothing;
				default:
					return $elm$core$Maybe$Nothing;
			}
		});
	var clearExtraApiHeader = function (state) {
		var flags = state.oN;
		return $author$project$Data$User$hasViewOnlyPlan(state.oN.mQ) ? _Utils_update(
			state,
			{
				oN: _Utils_update(
					flags,
					{oG: $elm$core$Maybe$Nothing})
			}) : state;
	};
	return $elm$core$Result$map(
		function (state) {
			var flags = state.oN;
			var _v0 = A2(getDashboard, state.af, state.s);
			if (!_v0.$) {
				var dashboard = _v0.a;
				if ($author$project$Data$User$hasViewOnlyPlan(state.oN.mQ)) {
					var _v1 = dashboard.ah;
					switch (_v1.$) {
						case 2:
							return _Utils_update(
								state,
								{
									oN: _Utils_update(
										flags,
										{
											oG: $elm$core$Maybe$Just(
												_List_fromArray(
													[
														A2($author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader, 'GWI-View-Only-Entity-Type', 'dashboards'),
														A2(
														$author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader,
														'GWI-View-Only-Entity-ID',
														$author$project$Data$Id$unwrap(dashboard.b))
													]))
										})
								});
						case 1:
							return state;
						case 3:
							return state;
						case 0:
							return state;
						case 4:
							return _Utils_update(
								state,
								{
									oN: _Utils_update(
										flags,
										{
											oG: $elm$core$Maybe$Just(
												_List_fromArray(
													[
														A2($author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader, 'GWI-View-Only-Entity-Type', 'dashboards'),
														A2(
														$author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader,
														'GWI-View-Only-Entity-ID',
														$author$project$Data$Id$unwrap(dashboard.b))
													]))
										})
								});
						case 5:
							return state;
						case 7:
							return _Utils_update(
								state,
								{
									oN: _Utils_update(
										flags,
										{
											oG: $elm$core$Maybe$Just(
												_List_fromArray(
													[
														A2($author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader, 'GWI-View-Only-Entity-Type', 'dashboards'),
														A2(
														$author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader,
														'GWI-View-Only-Entity-ID',
														$author$project$Data$Id$unwrap(dashboard.b))
													]))
										})
								});
						case 6:
							return _Utils_update(
								state,
								{
									oN: _Utils_update(
										flags,
										{
											oG: $elm$core$Maybe$Just(
												_List_fromArray(
													[
														A2($author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader, 'GWI-View-Only-Entity-Type', 'dashboards'),
														A2(
														$author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader,
														'GWI-View-Only-Entity-ID',
														$author$project$Data$Id$unwrap(dashboard.b))
													]))
										})
								});
						default:
							return _Utils_update(
								state,
								{
									oN: _Utils_update(
										flags,
										{
											oG: $elm$core$Maybe$Just(
												_List_fromArray(
													[
														A2($author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader, 'GWI-View-Only-Entity-Type', 'dashboards'),
														A2(
														$author$project$Data$GettableKeyValueHeader$gettableKeyValueHeader,
														'GWI-View-Only-Entity-ID',
														$author$project$Data$Id$unwrap(dashboard.b))
													]))
										})
								});
					}
				} else {
					return state;
				}
			} else {
				return clearExtraApiHeader(state);
			}
		});
}();
var $author$project$Store$Platform2$FetchCharts = {$: 24};
var $author$project$Store$Platform2$FetchQuestion = F2(
	function (a, b) {
		return {$: 14, a: a, b: b};
	});
var $author$project$Analytics$Place$GlobalSearch = 13;
var $author$project$Data$Platform2$None = 0;
var $author$project$Data$Labels$addNamespaceToQuestionCode = F2(
	function (namespaceCode, shortQuestionCode) {
		var namespace_ = $author$project$Data$Id$unwrap(namespaceCode);
		return (namespace_ === 'core') ? $author$project$Data$Id$fromString(
			$author$project$Data$Id$unwrap(shortQuestionCode)) : $author$project$Data$Id$fromString(
			namespace_ + ('.' + $author$project$Data$Id$unwrap(shortQuestionCode)));
	});
var $elm_community$list_extra$List$Extra$last = function (items) {
	last:
	while (true) {
		if (!items.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!items.b.b) {
				var x = items.a;
				return $elm$core$Maybe$Just(x);
			} else {
				var rest = items.b;
				var $temp$items = rest;
				items = $temp$items;
				continue last;
			}
		}
	}
};
var $author$project$Data$Platform2$newChartWidget = F3(
	function (widget, dashboardId, position) {
		return {
			U: $author$project$Data$Platform2$ChartContent(widget),
			bf: dashboardId,
			cv: 1,
			b: $author$project$Data$Platform2$nullId,
			lB: position,
			da: 2
		};
	});
var $author$project$Dashboards2$addNewWidgetToDashboard = F2(
	function (chartWidget, savedDashboard) {
		var data = savedDashboard.cl;
		var newPosition = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			0.0,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.lB;
				},
				$elm$core$Basics$add(0.125)),
			$elm_community$list_extra$List$Extra$last(
				A2(
					$elm$core$List$sortBy,
					function ($) {
						return $.lB;
					},
					data.g)));
		var newWidget = A3($author$project$Data$Platform2$newChartWidget, chartWidget, savedDashboard.b, newPosition);
		return _Utils_update(
			savedDashboard,
			{
				cl: _Utils_update(
					data,
					{
						g: A2($elm$core$List$cons, newWidget, data.g)
					})
			});
	});
var $author$project$Dashboards2$clearSharedStateFromKernel = _Platform_outgoingPort(
	'clearSharedStateFromKernel',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Dashboards2$closeModal = function (model) {
	return _Utils_update(
		model,
		{c: $author$project$Dashboards2$Modal$NoModal});
};
var $author$project$Gwi$Browser$Dom$FromTop = function (a) {
	return {$: 0, a: a};
};
var $author$project$Gwi$Browser$Dom$AlwaysToTop = {$: 2};
var $author$project$Gwi$Browser$Dom$correctElementValuesByParent = F2(
	function (element, parentElement) {
		var innerViewport = element.mX;
		var innerScene = element.q7;
		var innerElement = element.j4;
		return _Utils_update(
			element,
			{
				j4: _Utils_update(
					innerElement,
					{m3: innerElement.m3 - parentElement.j4.m3, m4: innerElement.m4 - parentElement.j4.m4}),
				q7: _Utils_update(
					innerScene,
					{cv: element.q7.cv - parentElement.j4.m4, da: element.q7.da - parentElement.j4.m3}),
				mX: _Utils_update(
					innerViewport,
					{cv: element.mX.cv - parentElement.j4.m4, da: element.mX.da - parentElement.j4.m3})
			});
	});
var $author$project$Gwi$Browser$Dom$isVisible = F3(
	function (element_, parentElement, vp) {
		var element = A2($author$project$Gwi$Browser$Dom$correctElementValuesByParent, element_, parentElement);
		return (_Utils_cmp(element.j4.m4, parentElement.j4.m4) > -1) && ((_Utils_cmp(element.j4.m4 + element.j4.cv, vp.mX.cv + parentElement.j4.m4) < 1) && ((_Utils_cmp(element.j4.m3, parentElement.j4.m3) > -1) && (_Utils_cmp(element.j4.m3 + element.j4.da, parentElement.j4.m3 + vp.mX.da) < 1)));
	});
var $elm$core$Task$map3 = F4(
	function (func, taskA, taskB, taskC) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return A2(
							$elm$core$Task$andThen,
							function (c) {
								return $elm$core$Task$succeed(
									A3(func, a, b, c));
							},
							taskC);
					},
					taskB);
			},
			taskA);
	});
var $author$project$Gwi$Browser$Dom$scrollToIfNotVisibleWithOffset = function (_v0) {
	var scrollParentId = _v0.lV;
	var elementId = _v0.j5;
	var scrollOffest = _v0.ra;
	return A2(
		$elm$core$Task$andThen,
		function (_v3) {
			var visible = _v3.mY;
			var scrollToY = _v3.lX;
			var scrollToX = _v3.lW;
			return visible ? $elm$core$Task$succeed(0) : A3($elm$browser$Browser$Dom$setViewportOf, scrollParentId, scrollToX, scrollToY);
		},
		A4(
			$elm$core$Task$map3,
			F3(
				function (element, viewport, parentElement) {
					var _v1 = function () {
						switch (scrollOffest.$) {
							case 1:
								return _Utils_Tuple2((element.mX.cv / 2) - element.mX.cv, (element.mX.da / 2) - element.mX.da);
							case 0:
								var offset = scrollOffest.a;
								return _Utils_Tuple2(offset, (element.mX.da / 2) - element.mX.da);
							default:
								return _Utils_Tuple2(-parentElement.j4.m4, (element.mX.da / 2) - element.mX.da);
						}
					}();
					var yCorrection = _v1.a;
					var xCorrection = _v1.b;
					return {
						lW: (viewport.mX.m3 + element.j4.m3) + xCorrection,
						lX: (viewport.mX.m4 + element.j4.m4) + yCorrection,
						mY: A3($author$project$Gwi$Browser$Dom$isVisible, element, parentElement, viewport) && (!_Utils_eq(scrollOffest, $author$project$Gwi$Browser$Dom$AlwaysToTop))
					};
				}),
			$elm$browser$Browser$Dom$getElement(elementId),
			$elm$browser$Browser$Dom$getViewportOf(scrollParentId),
			$elm$browser$Browser$Dom$getElement(scrollParentId)));
};
var $author$project$Dashboards2$Detail$widgetElementId = function (_v0) {
	var position = _v0.lB;
	return 'widget-item-element-id-on-position-' + $elm$core$String$fromFloat(position);
};
var $author$project$Dashboards2$scrollToWidget = F2(
	function (config, newWidget) {
		var headerHeightInEditMode = 110;
		return $GlobalWebIndex$cmd_extra$Cmd$Extra$add(
			A2(
				$elm$core$Task$attempt,
				$elm$core$Basics$always(
					config.a($author$project$Dashboards2$NoOp)),
				A2(
					$elm$core$Task$andThen,
					function (_v0) {
						return $author$project$Gwi$Browser$Dom$scrollToIfNotVisibleWithOffset(
							{
								j5: $author$project$Dashboards2$Detail$widgetElementId(newWidget),
								ra: $author$project$Gwi$Browser$Dom$FromTop(-headerHeightInEditMode),
								lV: $author$project$Dashboards2$Detail$detailScrollContainerId
							});
					},
					$elm$core$Process$sleep(250))));
	});
var $turboMaCk$glue$Glue$updateModelWith = F3(
	function (_v0, fc, model) {
		var rec = _v0;
		return A2(
			rec.rg,
			fc(
				rec.oS(model)),
			model);
	});
var $author$project$Data$Labels$addQuestionToDatapointCode = F2(
	function (questionCode, dpAndSuffixCode) {
		var questionCode_ = $author$project$Data$Id$unwrap(questionCode);
		var dpAndSuffixCode_ = $author$project$Data$Id$unwrap(dpAndSuffixCode);
		if (questionCode_ === 'waves') {
			return _Utils_Tuple2(
				$author$project$Data$Id$fromString(dpAndSuffixCode_),
				$elm$core$Maybe$Nothing);
		} else {
			var _v1 = A2($elm$core$String$split, '_', dpAndSuffixCode_);
			if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
				var shortDpCode = _v1.a;
				var _v2 = _v1.b;
				var suffixCode = _v2.a;
				return _Utils_Tuple2(
					$author$project$Data$Id$fromString(questionCode_ + ('_' + shortDpCode)),
					$elm$core$Maybe$Just(
						$author$project$Data$Id$fromString(suffixCode)));
			} else {
				return _Utils_Tuple2(
					$author$project$Data$Id$fromString(questionCode_ + ('_' + dpAndSuffixCode_)),
					$elm$core$Maybe$Nothing);
			}
		}
	});
var $author$project$Dashboards2$widgetDataFromChart = function (chart) {
	var convertToMoreIntelligentCodes = $elm$core$List$map(
		function (_v2) {
			var questionCode = _v2.at;
			var datapointCode = _v2.eq;
			var namespaceCode = _v2.id;
			var pair = A2($author$project$Data$Labels$addQuestionToDatapointCode, questionCode, datapointCode);
			var namespaceAndQuestion = A2($author$project$Data$Labels$addNamespaceToQuestionCode, namespaceCode, questionCode);
			return {eq: pair.a, at: namespaceAndQuestion, iT: pair.b};
		});
	var groupByDatapoints = A2(
		$elm$core$Basics$composeR,
		convertToMoreIntelligentCodes,
		A2(
			$elm$core$Basics$composeR,
			$author$project$Gwi$List$groupBy(
				function ($) {
					return $.eq;
				}),
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$map(
					function (grouped) {
						var suffixCodes = A2(
							$elm$core$List$filterMap,
							function ($) {
								return $.iT;
							},
							$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(grouped.f2));
						var item = $turboMaCk$non_empty_list_alias$List$NonEmpty$head(grouped.f2);
						return {
							er: $author$project$Data$Platform2$Explicit(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
									_Utils_Tuple2(item.eq, suffixCodes))),
							at: item.at
						};
					}),
				$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList)));
	var nonGrouping = A2(
		$elm$core$Basics$composeR,
		convertToMoreIntelligentCodes,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$map(
				function (_v1) {
					var questionCode = _v1.at;
					var datapointCode = _v1.eq;
					var suffixCode = _v1.iT;
					return {
						er: $author$project$Data$Platform2$Explicit(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
								_Utils_Tuple2(
									datapointCode,
									A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $elm$core$List$singleton, suffixCode)))),
						at: questionCode
					};
				}),
			$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList));
	var _v0 = chart.kp;
	switch (_v0) {
		case 0:
			return nonGrouping(chart.d7);
		case 1:
			return groupByDatapoints(chart.d7);
		case 2:
			return nonGrouping(chart.d7);
		default:
			return nonGrouping(chart.d7);
	}
};
var $author$project$Dashboards2$setGlobalSearchSharedState = F6(
	function (config, flags, route, store, sharedState, model) {
		var createWidgetFromSharedState = F2(
			function (_v8, savedDashboard) {
				var widgetName = _v8.dZ;
				var createWidgetsFromAttributes = function () {
					if ($elm$core$List$isEmpty(sharedState.d7)) {
						return $elm$core$Basics$identity;
					} else {
						var _v7 = $author$project$Dashboards2$widgetDataFromChart(
							{d7: sharedState.d7, kp: 0});
						if (!_v7.$) {
							var widgetData = _v7.a;
							var chartWidget = {
								aU: $author$project$Data$Platform2$InheritedFromDashboard(
									{fp: $elm$core$Maybe$Nothing}),
								aI: 3,
								cl: $author$project$Data$Platform2$GroupedData(widgetData),
								dB: 0,
								ld: widgetName,
								b2: '',
								cY: 3
							};
							return A2(
								$turboMaCk$glue$Glue$updateModelWith,
								$turboMaCk$glue$Glue$id,
								$author$project$Dashboards2$addNewWidgetToDashboard(chartWidget));
						} else {
							return $elm$core$Basics$identity;
						}
					}
				}();
				var applyDatasetsSelection = function (sDashboard) {
					return $elm$core$List$isEmpty(sharedState.fB) ? sDashboard : _Utils_update(
						sDashboard,
						{es: sharedState.fB});
				};
				var addWavesIfNotEmpty = function (dashboard) {
					var data = dashboard.cl;
					if ($elm$core$List$isEmpty(sharedState.g1)) {
						return dashboard;
					} else {
						var filters = data.C;
						return _Utils_update(
							dashboard,
							{
								cl: _Utils_update(
									data,
									{
										C: _Utils_update(
											filters,
											{
												dX: $elm$core$Maybe$Just(sharedState.g1)
											})
									})
							});
					}
				};
				var addLocationsIfNotEmpty = function (dashboard) {
					var data = dashboard.cl;
					if ($elm$core$List$isEmpty(sharedState.ga)) {
						return dashboard;
					} else {
						var filters = data.C;
						return _Utils_update(
							dashboard,
							{
								cl: _Utils_update(
									data,
									{
										C: _Utils_update(
											filters,
											{
												cD: $elm$core$Maybe$Just(sharedState.ga)
											})
									})
							});
					}
				};
				var addAudiencesIfNotEmpty = function (dashboard) {
					var data = dashboard.cl;
					var _v6 = sharedState.jn;
					if (!_v6.$) {
						var audienceId = _v6.a;
						var filters = data.C;
						return _Utils_update(
							dashboard,
							{
								cl: _Utils_update(
									data,
									{
										C: _Utils_update(
											filters,
											{
												d9: $elm$core$Maybe$Just(
													_List_fromArray(
														[audienceId]))
											})
									})
							});
					} else {
						return dashboard;
					}
				};
				var newDashboard = addLocationsIfNotEmpty(
					addWavesIfNotEmpty(
						addAudiencesIfNotEmpty(
							applyDatasetsSelection(
								createWidgetsFromAttributes(savedDashboard)))));
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$clearSharedStateFromKernel(0),
					A4(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$elm$core$Basics$identity,
						$author$project$Dashboards2$scrollToWidget(config),
						$elm$core$List$head(newDashboard.cl.g),
						A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
							A2(config.ag, newDashboard, 13),
							$author$project$Dashboards2$closeModal(model))));
			});
		switch (route.$) {
			case 1:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.as($author$project$Dashboards2$Router$NewDashboard),
					model);
			case 2:
				var _v1 = _Utils_Tuple2(
					$author$project$Permissions$isDashboardsCreator(flags.nM),
					A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
				if (_v1.a && (!_v1.b.$)) {
					var savedDashboard = _v1.b.a;
					var _v2 = _Utils_Tuple2(sharedState.nS, store.fr);
					if (!_v2.a.$) {
						switch (_v2.b.$) {
							case 0:
								var _v3 = _v2.b;
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
									config.l(
										_List_fromArray(
											[$author$project$Store$Platform2$FetchCharts])),
									model);
							case 3:
								var id = _v2.a.a;
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									A2(
										createWidgetFromSharedState,
										{dZ: 'New chart'},
										savedDashboard),
									function (chart) {
										return A2(
											createWidgetFromSharedState,
											{dZ: chart.ld},
											savedDashboard);
									},
									A2($author$project$Store$Utils$get, store.fr, id));
							default:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
						}
					} else {
						var _v4 = _v2.a;
						return A2(
							$elm$core$Maybe$withDefault,
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
							A2(
								$elm$core$Maybe$map,
								function (attribute) {
									var questionCode = A2($author$project$Data$Labels$addNamespaceToQuestionCode, attribute.id, attribute.at);
									var _v5 = A2($author$project$Store$Platform2$getQuestion, questionCode, store);
									switch (_v5.$) {
										case 0:
											return A2(
												$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
												config.l(
													_List_fromArray(
														[
															A2(
															$author$project$Store$Platform2$FetchQuestion,
															{mf: false},
															questionCode)
														])),
												model);
										case 1:
											return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
										case 2:
											return A2(
												createWidgetFromSharedState,
												{dZ: 'New widget'},
												savedDashboard);
										default:
											var question = _v5.a;
											return A2(
												createWidgetFromSharedState,
												{dZ: question.ld},
												savedDashboard);
									}
								},
								$elm$core$List$head(sharedState.d7)));
					}
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 0:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.as($author$project$Dashboards2$Router$NewDashboard),
					model);
			case 3:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			default:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Analytics$Place$PersonaCards = 36;
var $author$project$Dashboards2$setKernelSharedState = F6(
	function (config, flags, route, store, sharedState, model) {
		var createWidgetFromSharedState = function (savedDashboard) {
			var createWidgetsFromAttributes = function (sd) {
				var data = sd.cl;
				return _Utils_update(
					sd,
					{
						cl: _Utils_update(
							data,
							{
								g: _Utils_ap(sharedState.g, data.g)
							})
					});
			};
			var applyDatasetsSelection = function (sDashboard) {
				return $elm$core$List$isEmpty(sharedState.fB) ? sDashboard : _Utils_update(
					sDashboard,
					{es: sharedState.fB});
			};
			var addWavesIfNotEmpty = function (dashboard) {
				var data = dashboard.cl;
				if ($elm$core$List$isEmpty(sharedState.g1)) {
					return dashboard;
				} else {
					var filters = data.C;
					return _Utils_update(
						dashboard,
						{
							cl: _Utils_update(
								data,
								{
									C: _Utils_update(
										filters,
										{
											dX: $elm$core$Maybe$Just(sharedState.g1)
										})
								})
						});
				}
			};
			var addLocationsIfNotEmpty = function (dashboard) {
				var data = dashboard.cl;
				if ($elm$core$List$isEmpty(sharedState.ga)) {
					return dashboard;
				} else {
					var filters = data.C;
					return _Utils_update(
						dashboard,
						{
							cl: _Utils_update(
								data,
								{
									C: _Utils_update(
										filters,
										{
											cD: $elm$core$Maybe$Just(sharedState.ga)
										})
								})
						});
				}
			};
			var addBaseAudienceIfNotEmpty = function (dashboard) {
				var data = dashboard.cl;
				var _v2 = sharedState.aU;
				if (!_v2.$) {
					var audienceId = _v2.a;
					var filters = data.C;
					return _Utils_update(
						dashboard,
						{
							cl: _Utils_update(
								data,
								{
									C: _Utils_update(
										filters,
										{
											aU: $elm$core$Maybe$Just(audienceId)
										})
								})
						});
				} else {
					return dashboard;
				}
			};
			var addAudiences = function (dashboard) {
				var data = dashboard.cl;
				var filters = data.C;
				return _Utils_update(
					dashboard,
					{
						cl: _Utils_update(
							data,
							{
								C: _Utils_update(
									filters,
									{d9: sharedState.d9})
							})
					});
			};
			var newDashboard = addLocationsIfNotEmpty(
				addWavesIfNotEmpty(
					addAudiences(
						addBaseAudienceIfNotEmpty(
							applyDatasetsSelection(
								createWidgetsFromAttributes(savedDashboard))))));
			return A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
				$author$project$Dashboards2$clearSharedStateFromKernel(0),
				A4(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					$author$project$Dashboards2$scrollToWidget(config),
					$elm$core$List$head(newDashboard.cl.g),
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						A2(config.ag, newDashboard, 36),
						$author$project$Dashboards2$closeModal(model))));
		};
		switch (route.$) {
			case 1:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.as($author$project$Dashboards2$Router$NewDashboard),
					model);
			case 2:
				var _v1 = _Utils_Tuple2(
					$author$project$Permissions$isDashboardsCreator(flags.nM),
					A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
				if (_v1.a && (!_v1.b.$)) {
					var savedDashboard = _v1.b.a;
					return createWidgetFromSharedState(savedDashboard);
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 0:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.as($author$project$Dashboards2$Router$NewDashboard),
					model);
			case 3:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			default:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Dashboards2Main$setSharedStateForChartBuilderAndNavigateTo = _Platform_outgoingPort(
	'setSharedStateForChartBuilderAndNavigateTo',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$core$Basics$identity(a),
					$elm$json$Json$Encode$string(b)
				]));
	});
var $author$project$Store$Platform2$DashboardShared = F2(
	function (a, b) {
		return {$: 33, a: a, b: b};
	});
var $author$project$Data$Platform2$shareDashboard = F2(
	function (dashboard, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeDashboardSharing(dashboard.ah)),
				hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Data$Platform2$dashboardSharingDecoder),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + ($author$project$Data$Id$unwrap(dashboard.b) + '/share'))
			});
	});
var $author$project$Store$Platform2$shareDashboard = F5(
	function (_v0, dashboardFullyLoaded, config, flags, store) {
		var closeShareModal = _v0.bV;
		var dashboard = $author$project$Data$Platform2$fromFullyLoadedDashboard(dashboardFullyLoaded);
		var httpResultToMsg = A2(
			$elm_community$result_extra$Result$Extra$unpack,
			config.av,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					config.a,
					$author$project$Store$Platform2$DashboardShared(
						{bV: closeShareModal})),
				$elm$core$Basics$always(dashboard)));
		return _Utils_Tuple2(
			store,
			A2(
				$elm$core$Platform$Cmd$map,
				httpResultToMsg,
				A2($author$project$Data$Platform2$shareDashboard, dashboardFullyLoaded, flags)));
	});
var $author$project$Store$Platform2$AudienceFoldersFetched = function (a) {
	return {$: 0, a: a};
};
var $author$project$Store$Platform2$AudienceRelatedMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Store$Platform2$AudiencesByDashboardIdFetched = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Store$Platform2$AudiencesFetched = function (a) {
	return {$: 1, a: a};
};
var $author$project$Store$Platform2$AudiencesReloaded = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Store$Platform2$CategoriesFetched = function (a) {
	return {$: 12, a: a};
};
var $author$project$Store$Platform2$ChartFoldersFetched = function (a) {
	return {$: 0, a: a};
};
var $author$project$Store$Platform2$ChartsFetched = function (a) {
	return {$: 1, a: a};
};
var $author$project$Store$Platform2$ChartsRelatedMsg = function (a) {
	return {$: 1, a: a};
};
var $author$project$Store$Platform2$DashboardFetched = function (a) {
	return {$: 3, a: a};
};
var $author$project$Store$Platform2$DashboardsFetched = function (a) {
	return {$: 2, a: a};
};
var $author$project$Store$Platform2$DashboardsUserSettingsFetched = function (a) {
	return {$: 4, a: a};
};
var $author$project$Store$Platform2$DatasetFolderTreesByDashboardIdFetched = function (a) {
	return {$: 28, a: a};
};
var $author$project$Store$Platform2$DatasetFoldersFetched = function (a) {
	return {$: 26, a: a};
};
var $author$project$Store$Platform2$DatasetsFetched = function (a) {
	return {$: 27, a: a};
};
var $author$project$Store$Platform2$InsightCategoriesFetched = function (a) {
	return {$: 25, a: a};
};
var $author$project$Store$Platform2$InsightFetched = function (a) {
	return {$: 29, a: a};
};
var $author$project$Store$Platform2$LineageFetched = F2(
	function (a, b) {
		return {$: 30, a: a, b: b};
	});
var $author$project$Store$Platform2$LocationsByDashboardIdFetched = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Store$Platform2$LocationsFetched = function (a) {
	return {$: 13, a: a};
};
var $author$project$Store$Platform2$QuestionFetchError = F4(
	function (a, b, c, d) {
		return {$: 11, a: a, b: b, c: c, d: d};
	});
var $author$project$Store$Platform2$QuestionFetched = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Store$Platform2$QuestionsForWidgetFetched = F3(
	function (a, b, c) {
		return {$: 10, a: a, b: b, c: c};
	});
var $author$project$Store$Platform2$SplittersFetched = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Store$Platform2$TVChannelsFetched = function (a) {
	return {$: 32, a: a};
};
var $author$project$Store$Platform2$TimezonesFetched = function (a) {
	return {$: 31, a: a};
};
var $author$project$Store$Platform2$WavesByDashboardIdFetched = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Store$Platform2$WavesFetched = function (a) {
	return {$: 16, a: a};
};
var $author$project$Data$Platform2$DashboardsUserSettings = function (doNotShowAgain) {
	return {bF: doNotShowAgain};
};
var $author$project$Data$Platform2$DashboardsDoNotShowAgain = F5(
	function (continueAnalysis, showCreateDashboardOnboarding, showAudiencesReorderingOnboarding, showDotOnChartTypeDropdown, showNewBadgeOnDonutChartItem) {
		return {jN: continueAnalysis, md: showAudiencesReorderingOnboarding, me: showCreateDashboardOnboarding, iO: showDotOnChartTypeDropdown, iP: showNewBadgeOnDonutChartItem};
	});
var $author$project$Data$Platform2$ShowDialog = 0;
var $author$project$Data$Platform2$defaultDashboardsDoNotShowAgain = A5($author$project$Data$Platform2$DashboardsDoNotShowAgain, 0, true, true, true, true);
var $author$project$Data$Platform2$DoNotShowAndContinueWithClearFilters = 1;
var $author$project$Data$Platform2$DoNotShowAndContinueWithCurrentFilters = 2;
var $author$project$Data$Platform2$doNotShowAgainDecoder = function () {
	var decode = function (str) {
		switch (str) {
			case 'ContinueAnalysis_yes':
				return $elm$json$Json$Decode$succeed(
					function (rec) {
						return _Utils_update(
							rec,
							{jN: 2});
					});
			case 'ContinueAnalysis_no':
				return $elm$json$Json$Decode$succeed(
					function (rec) {
						return _Utils_update(
							rec,
							{jN: 1});
					});
			case 'CreateDashboardOnboarding':
				return $elm$json$Json$Decode$succeed(
					function (rec) {
						return _Utils_update(
							rec,
							{me: false});
					});
			case 'AudiencesReorderingOnboarding':
				return $elm$json$Json$Decode$succeed(
					function (rec) {
						return _Utils_update(
							rec,
							{md: false});
					});
			case 'DotOnChartTypeDropdown':
				return $elm$json$Json$Decode$succeed(
					function (rec) {
						return _Utils_update(
							rec,
							{iO: false});
					});
			case 'NewBadgeOnDonutChartItem':
				return $elm$json$Json$Decode$succeed(
					function (rec) {
						return _Utils_update(
							rec,
							{iP: false});
					});
			default:
				return $elm$json$Json$Decode$succeed($elm$core$Basics$identity);
		}
	};
	return A2($elm$json$Json$Decode$andThen, decode, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Platform2$userSettingsDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Maybe$map(
				A2($elm$core$List$foldr, $elm$core$Basics$apL, $author$project$Data$Platform2$defaultDashboardsDoNotShowAgain)),
			$elm$core$Maybe$withDefault($author$project$Data$Platform2$defaultDashboardsDoNotShowAgain)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$optionalField,
			'do_not_show_again',
			$elm$json$Json$Decode$list($author$project$Data$Platform2$doNotShowAgainDecoder))),
	$elm$json$Json$Decode$succeed($author$project$Data$Platform2$DashboardsUserSettings));
var $author$project$Data$Platform2$fetchDashboardsUserSettings = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Data$Platform2$userSettingsDecoder),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: A3(
				$elm$url$Url$Builder$crossOrigin,
				$author$project$Data$Platform2$host(flags),
				_List_fromArray(
					['v2', 'settings', 'dashboards']),
				_List_Nil)
		});
};
var $author$project$Store$Utils$collectionRequest = F7(
	function (customErrorToHttpError, success, fail, requestCmd, setState, flags, store) {
		var httpResultToMsg = A2(
			$elm_community$result_extra$Result$Extra$unpack,
			function (e) {
				return A2(
					fail,
					A2(
						$elm_community$basics_extra$Basics$Extra$flip,
						setState,
						$elm$core$Maybe$Just(
							A2($author$project$Gwi$Http$toHttpError, customErrorToHttpError, e))),
					e);
			},
			success);
		return _Utils_Tuple2(
			A2(setState, store, $elm$core$Maybe$Nothing),
			A2(
				$elm$core$Platform$Cmd$map,
				httpResultToMsg,
				requestCmd(flags)));
	});
var $author$project$Store$Utils$fetch = F8(
	function (customErrorToHttpError, getState, success, fail, requestCmd, setState, flags, store) {
		var _v0 = getState(store);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(store, $elm$core$Platform$Cmd$none);
		} else {
			return A7($author$project$Store$Utils$collectionRequest, customErrorToHttpError, success, fail, requestCmd, setState, flags, store);
		}
	});
var $author$project$Store$Utils$peek = F8(
	function (customErrorToHttpError, getState, success, fail, requestCmd, setState, flags, store) {
		var _v0 = getState(store);
		if (!_v0.$) {
			return A8($author$project$Store$Utils$fetch, customErrorToHttpError, getState, success, fail, requestCmd, setState, flags, store);
		} else {
			return _Utils_Tuple2(store, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Store$Platform2$fetch_ = F4(
	function (r, _v0, flags, store) {
		var msg = _v0.a;
		var err = _v0.ox;
		var errWithoutModal = _v0.oy;
		var errMsg = r.mf ? err : errWithoutModal;
		return A8(
			$author$project$Store$Utils$peek,
			$elm$core$Basics$never,
			r.p,
			A2($elm$core$Basics$composeL, msg, r.gp),
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				errMsg,
				function (onError) {
					return function (s) {
						return A2(onError, r.mf, s);
					};
				},
				r.gn),
			r.gG,
			F2(
				function (store_, result) {
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						A2(r.eT, $krisajenkins$remotedata$RemoteData$Loading, store_),
						function (e) {
							return A2(
								r.eT,
								$krisajenkins$remotedata$RemoteData$Failure(e),
								store_);
						},
						result);
				}),
			flags,
			store);
	});
var $author$project$Data$Platform2$AudienceFolder = F6(
	function (id, name, position, flags, createdAt, updatedAt) {
		return {bB: createdAt, oN: flags, b: id, ld: name, lB: position, bN: updatedAt};
	});
var $author$project$Data$Platform2$AuthoredFolder = 1;
var $author$project$Data$Platform2$CuratedFolder = 0;
var $author$project$Data$Platform2$audienceFolderFlagFromString = function (string) {
	switch (string) {
		case 'curated':
			return $elm$core$Maybe$Just(0);
		case 'authored':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Platform2$audienceFolderFlagDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Data$Platform2$audienceFolderFlagFromString(string);
		if (!_v0.$) {
			var flag = _v0.a;
			return $elm$json$Json$Decode$succeed(flag);
		} else {
			return $elm$json$Json$Decode$fail('Unknown P2 Audience Folder flag: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Platform2$audienceFolderFlagToString = function (flag) {
	if (!flag) {
		return 'curated';
	} else {
		return 'authored';
	}
};
var $author$project$Data$Platform2$audienceFolderDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'updated_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'created_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'flags',
				A2(
					$elm$json$Json$Decode$map,
					$turboMaCk$any_set$Set$Any$fromList($author$project$Data$Platform2$audienceFolderFlagToString),
					$elm$json$Json$Decode$list($author$project$Data$Platform2$audienceFolderFlagDecoder))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'position', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
						$elm$json$Json$Decode$succeed($author$project$Data$Platform2$AudienceFolder)))))));
var $author$project$Data$Platform2$getAudienceFolders = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2(
					$elm$json$Json$Decode$field,
					'data',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$audienceFolderDecoder))),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Platform2$host(flags) + '/v2/audiences/saved/folders'
		});
};
var $author$project$Data$Platform2$Audience = function (id) {
	return function (v1Id) {
		return function (name) {
			return function (expression) {
				return function (folderId) {
					return function (userId) {
						return function (position) {
							return function (flags) {
								return function (createdAt) {
									return function (updatedAt) {
										return {bB: createdAt, bY: expression, oN: flags, oP: folderId, b: id, ld: name, lB: position, bN: updatedAt, mR: userId, r9: v1Id};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Platform2$IsP2Audience = 2;
var $author$project$Data$Platform2$audienceFlagFromString = function (string) {
	switch (string) {
		case 'curated':
			return $elm$core$Maybe$Just(0);
		case 'authored':
			return $elm$core$Maybe$Just(1);
		case 'isP2':
			return $elm$core$Maybe$Just(2);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Data$Platform2$audienceFlagDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (string) {
		var _v0 = $author$project$Data$Platform2$audienceFlagFromString(string);
		if (!_v0.$) {
			var flag = _v0.a;
			return $elm$json$Json$Decode$succeed(flag);
		} else {
			return $elm$json$Json$Decode$fail('Unknown P2 Audience flag: ' + string);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Data$Platform2$audienceFlagToString = function (flag) {
	switch (flag) {
		case 0:
			return 'curated';
		case 1:
			return 'authored';
		default:
			return 'isP2';
	}
};
var $author$project$Data$Platform2$audienceDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'updated_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'created_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$field,
				'flags',
				A2(
					$elm$json$Json$Decode$map,
					$turboMaCk$any_set$Set$Any$fromList($author$project$Data$Platform2$audienceFlagToString),
					$elm$json$Json$Decode$list($author$project$Data$Platform2$audienceFlagDecoder))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'position', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'user_id', $elm$json$Json$Decode$int),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$field,
							'folder_id',
							$elm$json$Json$Decode$nullable($author$project$Data$Id$decode)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'expression', $author$project$Data$Audience$Expression$decoder),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'v1_id', $author$project$Data$Id$decodeFromInt),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
										$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Audience)))))))))));
var $author$project$Data$Platform2$getAudiences = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2(
					$elm$json$Json$Decode$field,
					'data',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$audienceDecoder))),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Platform2$host(flags) + '/v2/audiences/saved'
		});
};
var $author$project$Data$Platform2$audienceByDashboardIdDecoder = function () {
	var shortAudienceDecoder = A4(
		$elm$json$Json$Decode$map3,
		F3(
			function (id, name, sample) {
				return {b: id, ld: name, iD: sample};
			}),
		A2($elm$json$Json$Decode$field, 'audience_id', $author$project$Data$Id$decode),
		A2($elm$json$Json$Decode$field, 'audience_name', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'sample', $author$project$Gwi$Json$Decode$stringOrInt));
	return A3(
		$elm$json$Json$Decode$map2,
		F2(
			function (baseAudience, audiences) {
				return A2($elm$core$List$cons, baseAudience, audiences);
			}),
		A2($elm$json$Json$Decode$field, 'base_audience', shortAudienceDecoder),
		A2(
			$elm$json$Json$Decode$field,
			'audiences',
			$elm$json$Json$Decode$list(shortAudienceDecoder)));
}();
var $author$project$Data$Platform2$encodeAudiencesByDashboardIdRequest = function (dashboardId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboard_id',
				$author$project$Data$Id$encode(dashboardId))
			]));
};
var $author$project$Data$Platform2$getAudiencesByDashboardId = F2(
	function (dashboardId, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeAudiencesByDashboardIdRequest(dashboardId)),
				hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Data$Platform2$audienceByDashboardIdDecoder),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + '/platform/dashboards/audiences'
			});
	});
var $author$project$Data$Platform2$Chart = function (id) {
	return function (name) {
		return function (attributes) {
			return function (baseAudience) {
				return function (datasetCodes) {
					return function (createdAt) {
						return function (updatedAt) {
							return function (groupType) {
								return function (chartSort) {
									return function (isShared) {
										return function (isMine) {
											return function (isPublic) {
												return function (folderId) {
													return function (isValid) {
														return {d7: attributes, aU: baseAudience, nV: chartSort, bB: createdAt, fB: datasetCodes, oP: folderId, kp: groupType, b: id, dv: isMine, f0: isPublic, pw: isShared, kR: isValid, ld: name, bN: updatedAt};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Platform2$ChartAttribute = F3(
	function (questionCode, datapointCode, namespaceCode) {
		return {eq: datapointCode, id: namespaceCode, at: questionCode};
	});
var $author$project$Data$Platform2$chartAttributeDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'namespace_code', $author$project$Data$Id$decode),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$andThen,
			function (dtpCode) {
				return A2(
					$elm$json$Json$Decode$map,
					function (suffix) {
						return $author$project$Data$Id$fromString(
							$elm$core$String$isEmpty(suffix) ? dtpCode : (dtpCode + ('_' + suffix)));
					},
					A2($elm$json$Json$Decode$field, 'suffix_code', $elm$json$Json$Decode$string));
			},
			A2($elm$json$Json$Decode$field, 'datapoint_code', $elm$json$Json$Decode$string)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'question_code', $author$project$Data$Id$decode),
			$elm$json$Json$Decode$succeed($author$project$Data$Platform2$ChartAttribute))));
var $author$project$Data$Platform2$GroupByDatapoint = 1;
var $author$project$Data$Platform2$GroupByOption = 2;
var $author$project$Data$Platform2$GroupByQuestion = 3;
var $author$project$Data$Platform2$chartGroupDecoder = function () {
	var decoder = function (t) {
		switch (t) {
			case 0:
				return $elm$json$Json$Decode$succeed(0);
			case 1:
				return $elm$json$Json$Decode$succeed(1);
			case 2:
				return $elm$json$Json$Decode$succeed(2);
			case 3:
				return $elm$json$Json$Decode$succeed(3);
			default:
				var notSupported = t;
				return $elm$json$Json$Decode$fail(
					'Unsupported query.view_parameters.group_type for chart ' + $elm$core$String$fromInt(notSupported));
		}
	};
	return A2($elm$json$Json$Decode$andThen, decoder, $elm$json$Json$Decode$int);
}();
var $author$project$Data$Platform2$chartSortDecoder = function () {
	var decoder = function (t) {
		switch (t) {
			case 0:
				return $elm$json$Json$Decode$succeed(3);
			case 1:
				return $elm$json$Json$Decode$succeed(1);
			case 2:
				return $elm$json$Json$Decode$succeed(0);
			default:
				var notSupported = t;
				return $elm$json$Json$Decode$fail(
					'Unsupported query.view_parameters.sort_type for chart ' + $elm$core$String$fromInt(notSupported));
		}
	};
	return A2($elm$json$Json$Decode$andThen, decoder, $elm$json$Json$Decode$int);
}();
var $author$project$Gwi$Json$Decode$unixTimestampMilliseconds = A2($elm$json$Json$Decode$map, $elm$time$Time$millisToPosix, $elm$json$Json$Decode$int);
var $author$project$Data$Platform2$chartDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$map,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$List$filter(
				A2($elm$core$Basics$composeR, $elm$core$String$isEmpty, $elm$core$Basics$not)),
			A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
		A2(
			$elm$json$Json$Decode$field,
			'dataset_names',
			$elm$json$Json$Decode$list($elm$json$Json$Decode$string))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'folder_id',
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Data$Platform2$emptyStringAsNothing($author$project$Data$Id$fromString),
				$elm$json$Json$Decode$string)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'is_public', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'is_owner', $elm$json$Json$Decode$bool),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'is_shared', $elm$json$Json$Decode$bool),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'sort_type', $author$project$Data$Platform2$chartSortDecoder),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'group_type', $author$project$Data$Platform2$chartGroupDecoder),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'updated_at', $author$project$Gwi$Json$Decode$unixTimestampMilliseconds),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'created_at', $author$project$Gwi$Json$Decode$unixTimestampMilliseconds),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2(
											$elm$json$Json$Decode$field,
											'dataset_codes',
											$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											$elm$json$Json$Decode$maybe(
												A2($elm$json$Json$Decode$field, 'base_audience', $author$project$Data$Platform2$chartBaseAudienceDecoder)),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2(
													$elm$json$Json$Decode$field,
													'attributes',
													$elm$json$Json$Decode$oneOf(
														_List_fromArray(
															[
																$elm$json$Json$Decode$null(_List_Nil),
																$elm$json$Json$Decode$list($author$project$Data$Platform2$chartAttributeDecoder)
															]))),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
													A2(
														$elm_community$json_extra$Json$Decode$Extra$andMap,
														A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
														$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Chart)))))))))))))));
var $author$project$Data$Platform2$getBrowserCharts = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2(
					$elm$json$Json$Decode$field,
					'charts',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$chartDecoder))),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Platform2$host(flags) + '/platform/charts?includeNested=true'
		});
};
var $author$project$Data$Labels$Category = F7(
	function (id, name, description, parentId, order, accessible, questionCodes) {
		return {fc: accessible, hB: description, b: id, ld: name, gq: order, ly: parentId, qE: questionCodes};
	});
var $author$project$Data$Labels$categoryDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'question_codes',
		$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'parent_id',
					$elm$json$Json$Decode$maybe($author$project$Data$Id$decodeFromInt)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$field,
						'description',
						$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromInt),
							$elm$json$Json$Decode$succeed($author$project$Data$Labels$Category))))))));
var $author$project$Data$SimpleREST$Resource = $elm$core$Basics$identity;
var $author$project$Data$SimpleREST$resource = $elm$core$Basics$identity;
var $author$project$Data$SimpleREST$readOnly = function (_v0) {
	var name = _v0.ld;
	var decoder = _v0.co;
	var getId = _v0.ct;
	return $author$project$Data$SimpleREST$resource(
		{
			co: decoder,
			cr: function (_v1) {
				return $elm$json$Json$Encode$null;
			},
			ct: getId,
			ld: name
		});
};
var $author$project$Data$Labels$category = $author$project$Data$SimpleREST$readOnly(
	{
		co: $author$project$Data$Labels$categoryDecoder,
		ct: A2(
			$elm$core$Basics$composeL,
			$author$project$Data$Id$unwrap,
			function ($) {
				return $.b;
			}),
		ld: 'categories'
	});
var $author$project$Data$SimpleREST$FetchCollection = {$: 1};
var $author$project$Data$SimpleREST$fetchCollection = F2(
	function (_v0, _v1) {
		var resource_ = _v0;
		var m = _v1.a;
		var a = _v1.b;
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					a.fF(resource_.co)),
				hU: a.hU,
				h8: m.fR,
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A2(a.aO, resource_.ld, $author$project$Data$SimpleREST$FetchCollection)
			});
	});
var $author$project$Data$SimpleREST$Adapter = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Data$SimpleREST$defaultMethods = {fw: 'POST', fG: 'DELETE', fQ: 'GET', fR: 'GET', io: 'PATCH', mO: 'PUT'};
var $author$project$Data$SimpleREST$simpleRoutes = F3(
	function (host, name, action) {
		var collection = function (name_) {
			return host + ('/' + name_);
		};
		var single = F2(
			function (name_, id) {
				return collection(name_) + ('/' + id);
			});
		switch (action.$) {
			case 1:
				return collection(name);
			case 0:
				return collection(name);
			case 2:
				var id = action.a;
				return A2(single, name, id);
			case 3:
				var id = action.a;
				return A2(single, name, id);
			default:
				var id = action.a;
				return A2(single, name, id);
		}
	});
var $author$project$Data$SimpleREST$adapter = function (host) {
	return A2(
		$author$project$Data$SimpleREST$Adapter,
		$author$project$Data$SimpleREST$defaultMethods,
		{
			fF: $elm$json$Json$Decode$list,
			bE: $elm$core$Basics$identity,
			aO: $author$project$Data$SimpleREST$simpleRoutes(host),
			hU: _List_Nil
		});
};
var $author$project$Data$Labels$decodeCollection = A2(
	$elm$core$Basics$composeL,
	$elm$json$Json$Decode$field('data'),
	$elm$json$Json$Decode$list);
var $author$project$Data$SimpleREST$decodeCollection = F2(
	function (decoder, _v0) {
		var methods = _v0.a;
		var adapter_ = _v0.b;
		return A2(
			$author$project$Data$SimpleREST$Adapter,
			methods,
			_Utils_update(
				adapter_,
				{fF: decoder}));
	});
var $author$project$Data$SimpleREST$decodeSingle = F2(
	function (decoder, _v0) {
		var methods = _v0.a;
		var adapter_ = _v0.b;
		return A2(
			$author$project$Data$SimpleREST$Adapter,
			methods,
			_Utils_update(
				adapter_,
				{bE: decoder}));
	});
var $author$project$Data$Labels$namespace = '/api';
var $author$project$Data$SimpleREST$setHeaders = F2(
	function (headers, _v0) {
		var methods = _v0.a;
		var adapter_ = _v0.b;
		return A2(
			$author$project$Data$SimpleREST$Adapter,
			methods,
			_Utils_update(
				adapter_,
				{hU: headers}));
	});
var $author$project$Data$Labels$adapter = function (flags) {
	return A2(
		$author$project$Data$SimpleREST$decodeSingle,
		$elm$json$Json$Decode$field('data'),
		A2(
			$author$project$Data$SimpleREST$decodeCollection,
			$author$project$Data$Labels$decodeCollection,
			A2(
				$author$project$Data$SimpleREST$setHeaders,
				_List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				$author$project$Data$SimpleREST$adapter(
					_Utils_ap(
						$author$project$Data$Labels$host(flags),
						$author$project$Data$Labels$namespace)))));
};
var $author$project$Data$Labels$withAdapter = function (fc) {
	return A2($elm$core$Basics$composeL, fc, $author$project$Data$Labels$adapter);
};
var $author$project$Data$Labels$getCategories = $author$project$Data$Labels$withAdapter(
	$author$project$Data$SimpleREST$fetchCollection($author$project$Data$Labels$category));
var $author$project$Data$Platform2$ChartFolder = F5(
	function (id, name, userId, createdAt, updatedAt) {
		return {bB: createdAt, b: id, ld: name, bN: updatedAt, mR: userId};
	});
var $author$project$Gwi$Json$Decode$unixTimestampMillisecondsOrIso8601Decoder = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Gwi$Json$Decode$unixTimestampMilliseconds, $author$project$Gwi$Json$Decode$unixIso8601Decoder]));
var $author$project$Data$Platform2$chartFolderDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'updated_at', $author$project$Gwi$Json$Decode$unixTimestampMillisecondsOrIso8601Decoder),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'created_at', $author$project$Gwi$Json$Decode$unixTimestampMillisecondsOrIso8601Decoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'user_id', $elm$json$Json$Decode$int),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'folder_name', $elm$json$Json$Decode$string),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
					$elm$json$Json$Decode$succeed($author$project$Data$Platform2$ChartFolder))))));
var $author$project$Data$Platform2$getChartFolders = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2(
					$elm$json$Json$Decode$field,
					'folders',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$chartFolderDecoder))),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Platform2$host(flags) + '/platform/folders'
		});
};
var $author$project$Data$Platform2$Dashboard = function (data) {
	return function (id) {
		return function (name) {
			return function (isFavourite) {
				return function (categories) {
					return function (datasets) {
						return function (userVisits) {
							return function (orgVisits) {
								return function (createdAt) {
									return function (updatedAt) {
										return function (lastVisitedAt) {
											return function (sharing) {
												return function (ownerId) {
													return function (flags) {
														return {ac: categories, bB: createdAt, cl: data, es: datasets, oN: flags, b: id, kN: isFavourite, pC: lastVisitedAt, ld: name, qr: orgVisits, dG: ownerId, ah: sharing, bN: updatedAt, i1: userVisits};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Data$Platform2$dashboardDetailDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'flags',
		A2(
			$elm$json$Json$Decode$map,
			$elm_community$maybe_extra$Maybe$Extra$values,
			$elm$json$Json$Decode$list($author$project$Data$Platform2$dashboardFlagsDecoder))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'user_id', $author$project$Gwi$Json$Decode$intToString),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'sharings', $author$project$Data$Platform2$dashboardSharingDecoder),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'visited_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'updated_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'created_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'org_visits', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'user_visits', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2(
										$elm$json$Json$Decode$field,
										'datasets',
										$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'categories', $author$project$Data$Platform2$categoriesDecoder),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'favourite', $elm$json$Json$Decode$bool),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromStringOrInt),
													A2(
														$elm_community$json_extra$Json$Decode$Extra$andMap,
														A2($elm$json$Json$Decode$map, $krisajenkins$remotedata$RemoteData$Success, $author$project$Data$Platform2$dashboardDataDecoder),
														$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Dashboard)))))))))))))));
var $author$project$Data$Platform2$getDashboard = F2(
	function (dashboardId, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Platform2$dashboardDetailDecoder)),
				hU: A2(
					$author$project$Gwi$List$appendMaybe,
					A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
					_List_fromArray(
						[
							$author$project$Data$Auth$header(flags.i$)
						])),
				h8: 'GET',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + $author$project$Data$Id$unwrap(dashboardId))
			});
	});
var $author$project$Data$Platform2$dashboardListDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'flags',
		A2(
			$elm$json$Json$Decode$map,
			$elm_community$maybe_extra$Maybe$Extra$values,
			$elm$json$Json$Decode$list($author$project$Data$Platform2$dashboardFlagsDecoder))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'user_id', $author$project$Gwi$Json$Decode$intToString),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'sharings', $author$project$Data$Platform2$dashboardSharingDecoder),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'visited_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'updated_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'created_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'org_visits', $elm$json$Json$Decode$int),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'user_visits', $elm$json$Json$Decode$int),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2(
										$elm$json$Json$Decode$field,
										'datasets',
										$elm$json$Json$Decode$list($author$project$Data$Id$decode)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2($elm$json$Json$Decode$field, 'categories', $author$project$Data$Platform2$categoriesDecoder),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2($elm$json$Json$Decode$field, 'favourite', $elm$json$Json$Decode$bool),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromStringOrInt),
													$elm$json$Json$Decode$succeed(
														$author$project$Data$Platform2$Dashboard($krisajenkins$remotedata$RemoteData$NotAsked)))))))))))))));
var $author$project$Data$Platform2$getDashboards = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2(
					$elm$json$Json$Decode$field,
					'data',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$dashboardListDecoder))),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Platform2$host(flags) + '/v2/saved/dashboards'
		});
};
var $author$project$Data$Platform2$DatasetFolderTreeDataForOpenAccessDashboards = F6(
	function (id, name, description, order, childFolders, childDatasets) {
		return {n_: childDatasets, n$: childFolders, hB: description, b: id, ld: name, gq: order};
	});
var $author$project$Data$Platform2$DatasetFolderTreeForOpenAccessDashboards = $elm$core$Basics$identity;
var $author$project$Data$Platform2$Dataset = F7(
	function (code, name, description, baseNamespaceCode, categories, depth, order) {
		return {jt: baseNamespaceCode, ac: categories, bW: code, hz: depth, hB: description, ld: name, gq: order};
	});
var $author$project$Data$Platform2$DatasetCategory = F2(
	function (id, name) {
		return {b: id, ld: name};
	});
var $author$project$Data$Platform2$datasetWithoutOrderDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$map,
		$elm$core$Maybe$withDefault(0),
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'depth', $elm$json$Json$Decode$int))),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$map,
			$elm$core$Maybe$withDefault(_List_Nil),
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$field,
					'categories',
					$elm$json$Json$Decode$list(
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
								$elm$json$Json$Decode$succeed($author$project$Data$Platform2$DatasetCategory))))))),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'base_namespace_code', $author$project$Data$Id$decode),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
						$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Dataset)))))));
var $author$project$Data$Platform2$datasetsDecoder = A2(
	$elm$json$Json$Decode$map,
	function (almostDatasets) {
		return A2(
			$elm$core$List$indexedMap,
			F2(
				function (order, toDataset) {
					return toDataset(order);
				}),
			almostDatasets);
	},
	$elm$json$Json$Decode$list($author$project$Data$Platform2$datasetWithoutOrderDecoder));
function $author$project$Data$Platform2$cyclic$datasetFolderTreeForOpenAccessDashboardsDecoder() {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(_List_Nil),
				A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'child_datasets', $author$project$Data$Platform2$datasetsDecoder)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(_List_Nil),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$optionalField,
						'child_folders',
						$elm$json$Json$Decode$list(
							$elm$json$Json$Decode$lazy(
								function (_v0) {
									return $author$project$Data$Platform2$cyclic$datasetFolderTreeForOpenAccessDashboardsDecoder();
								})))),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(0.0),
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float))),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault(''),
							$elm$json$Json$Decode$maybe(
								A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string))),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromStringOrInt),
								$elm$json$Json$Decode$succeed($author$project$Data$Platform2$DatasetFolderTreeDataForOpenAccessDashboards))))))));
}
var $author$project$Data$Platform2$datasetFolderTreeForOpenAccessDashboardsDecoder = $author$project$Data$Platform2$cyclic$datasetFolderTreeForOpenAccessDashboardsDecoder();
$author$project$Data$Platform2$cyclic$datasetFolderTreeForOpenAccessDashboardsDecoder = function () {
	return $author$project$Data$Platform2$datasetFolderTreeForOpenAccessDashboardsDecoder;
};
var $author$project$Data$Platform2$getDatasetFolderTreesByDashboardId = F2(
	function (dashboardId, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'dashboard_id',
								$author$project$Data$Id$encode(dashboardId))
							]))),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$field,
						'folders',
						$elm$json$Json$Decode$list($author$project$Data$Platform2$datasetFolderTreeForOpenAccessDashboardsDecoder))),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + '/platform/dashboards/datasets'
			});
	});
var $author$project$Data$Platform2$DatasetFolder = $elm$core$Basics$identity;
var $author$project$Data$Platform2$DatasetFolderData = F6(
	function (id, name, description, order, datasetCodes, subfolders) {
		return {fB: datasetCodes, hB: description, b: id, ld: name, gq: order, rG: subfolders};
	});
function $author$project$Data$Platform2$cyclic$datasetFolderDecoder() {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Basics$identity,
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$withDefault(_List_Nil),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$optionalField,
					'child_folders',
					$elm$json$Json$Decode$list(
						$elm$json$Json$Decode$lazy(
							function (_v0) {
								return $author$project$Data$Platform2$cyclic$datasetFolderDecoder();
							})))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(_List_Nil),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$optionalField,
						'child_datasets',
						$elm$json$Json$Decode$list(
							A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode)))),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromStringOrInt),
								$elm$json$Json$Decode$succeed($author$project$Data$Platform2$DatasetFolderData))))))));
}
var $author$project$Data$Platform2$datasetFolderDecoder = $author$project$Data$Platform2$cyclic$datasetFolderDecoder();
$author$project$Data$Platform2$cyclic$datasetFolderDecoder = function () {
	return $author$project$Data$Platform2$datasetFolderDecoder;
};
var $author$project$Data$Platform2$getDatasetFolders = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				$elm$json$Json$Decode$list($author$project$Data$Platform2$datasetFolderDecoder)),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Platform2$host(flags) + '/platform/dataset-folders'
		});
};
var $author$project$Data$Platform2$getDatasets = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Data$Platform2$datasetsDecoder),
			hU: A2(
				$author$project$Gwi$List$appendMaybe,
				A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
				_List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					])),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Platform2$host(flags) + '/platform/datasets'
		});
};
var $author$project$Data$Platform2$Insight = F9(
	function (id, name, description, insightType, publishedAt, createdAt, updatedAt, images, categoryIds) {
		return {nP: categoryIds, bB: createdAt, hB: description, b: id, pa: images, kG: insightType, ld: name, qC: publishedAt, bN: updatedAt};
	});
var $author$project$Data$Platform2$InsightImage = F3(
	function (id, thumbPath, isMain) {
		return {b: id, pt: isMain, rO: thumbPath};
	});
var $author$project$Data$Platform2$insightImageDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'is_main', $elm$json$Json$Decode$bool),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'thumb_path', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromInt),
			$elm$json$Json$Decode$succeed($author$project$Data$Platform2$InsightImage))));
var $author$project$Data$Platform2$insightDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2(
		$elm$json$Json$Decode$field,
		'category_ids',
		$elm$json$Json$Decode$list($author$project$Data$Id$decodeFromInt)),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'images',
			$elm$json$Json$Decode$list($author$project$Data$Platform2$insightImageDecoder)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'updated_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'created_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'published_at', $author$project$Gwi$Json$Decode$unixIso8601Decoder),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'type', $author$project$Data$Platform2$insightTypeDecoder),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromInt),
									$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Insight))))))))));
var $author$project$Data$Platform2$getInsight = F2(
	function (insightId, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2($elm$json$Json$Decode$field, 'insight', $author$project$Data$Platform2$insightDecoder)),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'GET',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/insights/insights/' + $author$project$Data$Id$unwrap(insightId))
			});
	});
var $author$project$Data$Platform2$getInsightCategories = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2(
					$elm$json$Json$Decode$field,
					'categories',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$insightCategoryDecoder))),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Data$Platform2$host(flags) + '/v2/insights/categories'
		});
};
var $author$project$Data$Labels$NamespaceLineage = F2(
	function (ancestors, descendants) {
		return {g7: ancestors, j_: descendants};
	});
var $author$project$Data$Labels$lineageDecoder = function () {
	var idsAsObjectKeysDecoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$map(
			A2($elm$core$Basics$composeR, $elm$core$Tuple$first, $author$project$Data$Id$fromString)),
		$elm$json$Json$Decode$keyValuePairs(
			$elm$json$Json$Decode$succeed(0)));
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'descendants', idsAsObjectKeysDecoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'ancestors', idsAsObjectKeysDecoder),
			$elm$json$Json$Decode$succeed($author$project$Data$Labels$NamespaceLineage)));
}();
var $author$project$Data$Labels$getLineage = F2(
	function (namespaceCode, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Data$Labels$lineageDecoder),
				hU: A2(
					$author$project$Gwi$List$appendMaybe,
					A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
					_List_fromArray(
						[
							$author$project$Data$Auth$header(flags.i$)
						])),
				h8: 'GET',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Data$Labels$host(flags),
					_List_fromArray(
						[
							'v1',
							'surveys',
							'lineage',
							'by_namespace',
							$author$project$Data$Id$unwrap(namespaceCode)
						]),
					_List_Nil)
			});
	});
var $author$project$Data$Labels$locationV1Decoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'area', $author$project$Data$Labels$regionCodeDecoder),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
				$elm$json$Json$Decode$succeed($author$project$Data$Labels$Location)))));
var $author$project$Data$Labels$getLocations = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2(
					$elm$json$Json$Decode$field,
					'data',
					$elm$json$Json$Decode$list($author$project$Data$Labels$locationV1Decoder))),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Config$Main$get(flags.j8).dV.d5 + '/v1/surveys/locations'
		});
};
var $author$project$Data$Platform2$LocationsForDashboardIdResponse = F2(
	function (locations, displayAll) {
		return {oi: displayAll, cD: locations};
	});
var $author$project$Data$Platform2$decodeResponseForLocationsForDashboardId = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Data$Platform2$LocationsForDashboardIdResponse,
	A2(
		$elm$json$Json$Decode$field,
		'locations',
		$elm$json$Json$Decode$list($author$project$Data$Labels$locationV2Decoder)),
	A2($elm$json$Json$Decode$field, 'display_all', $elm$json$Json$Decode$bool));
var $author$project$Data$Platform2$encodeRequestForLocationsForDashboardId = function (dashboardId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboard_id',
				$author$project$Data$Id$encode(dashboardId))
			]));
};
var $author$project$Data$Platform2$getLocationsForDashboardId = F2(
	function (dashboardId, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeRequestForLocationsForDashboardId(dashboardId)),
				hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Data$Platform2$decodeResponseForLocationsForDashboardId),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + '/platform/dashboards/locations'
			});
	});
var $author$project$Data$Labels$getLocationsForNamespace = F2(
	function (namespaceCode, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Labels$encodeRequestForLocationsForNamespace(namespaceCode)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$field,
						'locations',
						$elm$json$Json$Decode$list($author$project$Data$Labels$locationV2Decoder))),
				hU: A2(
					$author$project$Gwi$List$appendMaybe,
					A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
					_List_fromArray(
						[
							$author$project$Data$Auth$header(flags.i$)
						])),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Labels$locationsByNamespaceUrl(flags)
			});
	});
var $author$project$Data$Labels$Datapoint = F5(
	function (code, name, accessible, midpoint, order) {
		return {fc: accessible, bW: code, k5: midpoint, ld: name, gq: order};
	});
var $author$project$Data$Labels$AgreementScore = {$: 0};
var $author$project$Data$Labels$OtherUnit = function (a) {
	return {$: 2, a: a};
};
var $author$project$Data$Labels$TimeInHours = {$: 1};
var $author$project$Data$Labels$averagesUnitDecoder = function () {
	var decoder = function (s) {
		switch (s) {
			case 'agreement score':
				return $author$project$Data$Labels$AgreementScore;
			case 'hours':
				return $author$project$Data$Labels$TimeInHours;
			default:
				return $author$project$Data$Labels$OtherUnit(s);
		}
	};
	return A2($elm$json$Json$Decode$map, decoder, $elm$json$Json$Decode$string);
}();
var $author$project$Data$Labels$Suffix = F3(
	function (code, name, midpoint) {
		return {bW: code, k5: midpoint, ld: name};
	});
var $author$project$Data$Labels$suffixDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm_community$json_extra$Json$Decode$Extra$optionalNullableField, 'midpoint', $elm$json$Json$Decode$float),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
						A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromInt)
					])),
			$elm$json$Json$Decode$succeed($author$project$Data$Labels$Suffix))));
var $author$project$Data$Labels$questionV2Decoder = function (wantedQuestionCode) {
	var v2CategoryIdDecoder = A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode);
	var averagesSupportDecoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$member('support_averages'),
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
	var _v0 = $author$project$Data$Labels$splitQuestionCode(wantedQuestionCode);
	var wantedShortQuestionCode = _v0.b;
	var unwrappedShortQuestionCode = $author$project$Data$Id$unwrap(wantedShortQuestionCode);
	var fixDatapointCode = (unwrappedShortQuestionCode === 'waves') ? function (datapointCode) {
		return $author$project$Data$Id$fromString(datapointCode);
	} : function (datapointCode) {
		return $author$project$Data$Id$fromString(unwrappedShortQuestionCode + ('_' + datapointCode));
	};
	var v2DatapointDecoder = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'midpoint', $elm$json$Json$Decode$float)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm_community$json_extra$Json$Decode$Extra$withDefault,
					false,
					A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$field,
							'code',
							A2($elm$json$Json$Decode$map, fixDatapointCode, $elm$json$Json$Decode$string)),
						$elm$json$Json$Decode$succeed($author$project$Data$Labels$Datapoint))))));
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['question', 'datapoints']),
			$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList(v2DatapointDecoder)),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$maybe(
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['question', 'knowledge_base']),
					$elm$json$Json$Decode$string)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				$elm$json$Json$Decode$maybe(
					A2(
						$elm$json$Json$Decode$at,
						_List_fromArray(
							['question', 'warning']),
						$elm$json$Json$Decode$string)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(false),
						$elm$json$Json$Decode$maybe(
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['question', 'flags']),
								averagesSupportDecoder))),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						$elm$json$Json$Decode$maybe(
							A2(
								$elm$json$Json$Decode$at,
								_List_fromArray(
									['question', 'unit']),
								$author$project$Data$Labels$averagesUnitDecoder)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							$elm$json$Json$Decode$maybe(
								A2(
									$elm$json$Json$Decode$at,
									_List_fromArray(
										['question', 'notice']),
									$elm$json$Json$Decode$string)),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm_community$json_extra$Json$Decode$Extra$withDefault,
									false,
									A2(
										$elm$json$Json$Decode$at,
										_List_fromArray(
											['question', 'accessible']),
										$elm$json$Json$Decode$bool)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									$elm$json$Json$Decode$maybe(
										A2(
											$elm$json$Json$Decode$at,
											_List_fromArray(
												['question', 'message']),
											$elm$json$Json$Decode$string)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										$elm$json$Json$Decode$maybe(
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['question', 'suffixes']),
												$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($author$project$Data$Labels$suffixDecoder))),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											A2(
												$elm$json$Json$Decode$at,
												_List_fromArray(
													['question', 'categories']),
												$elm$json$Json$Decode$list(v2CategoryIdDecoder)),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												A2(
													$elm$json$Json$Decode$at,
													_List_fromArray(
														['question', 'description']),
													$elm$json$Json$Decode$string),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2(
														$elm$json$Json$Decode$at,
														_List_fromArray(
															['question', 'name']),
														$elm$json$Json$Decode$string),
													A2(
														$elm_community$json_extra$Json$Decode$Extra$andMap,
														A2(
															$elm$json$Json$Decode$at,
															_List_fromArray(
																['question', 'namespace_code']),
															$author$project$Data$Id$decode),
														A2(
															$elm_community$json_extra$Json$Decode$Extra$andMap,
															A2(
																$elm$json$Json$Decode$at,
																_List_fromArray(
																	['question', 'code']),
																$author$project$Data$Id$decode),
															$elm$json$Json$Decode$succeed(
																function (code) {
																	return function (namespaceCode) {
																		return function (name) {
																			return function (fullName) {
																				return function (categoryIds) {
																					return function (suffixes) {
																						return function (message) {
																							return function (accessible) {
																								return function (notice) {
																									return function (averagesUnit) {
																										return function (averageSupport) {
																											return function (warning) {
																												return function (knowledgeBase) {
																													return function (datapoints) {
																														return {fc: accessible, jr: averageSupport, hc: averagesUnit, nP: categoryIds, bW: code, er: datapoints, oR: fullName, f3: knowledgeBase, k1: wantedQuestionCode, pP: message, ld: name, id: namespaceCode, gl: notice, rI: suffixes, L: warning};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		};
																	};
																})))))))))))))));
};
var $author$project$Data$Labels$getQuestionV2 = F2(
	function (namespaceAndQuestionCode, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					$author$project$Data$Labels$questionV2Decoder(namespaceAndQuestionCode)),
				hU: A2(
					$author$project$Gwi$List$appendMaybe,
					A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
					_List_fromArray(
						[
							$author$project$Data$Auth$header(flags.i$)
						])),
				h8: 'GET',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Data$Labels$host(flags),
					_List_fromArray(
						[
							'v2',
							'questions',
							$author$project$Data$Id$unwrap(namespaceAndQuestionCode)
						]),
					_List_fromArray(
						[
							A2($elm$url$Url$Builder$string, 'include', 'categories,datapoints')
						]))
			});
	});
var $author$project$Data$Platform2$encodeGetQuestionsForWidgetRequest = F2(
	function (dashboardId, widgetId) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'dashboard_id',
					$author$project$Data$Id$encode(dashboardId)),
					_Utils_Tuple2(
					'widget_id',
					$author$project$Data$Id$encode(widgetId))
				]));
	});
var $author$project$Data$Platform2$questionsForWidgetDecoder = function () {
	var v2DatapointDecoder = A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, 'midpoint', $elm$json$Json$Decode$float)),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm_community$json_extra$Json$Decode$Extra$withDefault,
					false,
					A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
						$elm$json$Json$Decode$succeed($author$project$Data$Labels$Datapoint))))));
	var v2CategoryIdDecoder = A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode);
	var averagesSupportDecoder = A2(
		$elm$json$Json$Decode$map,
		$elm$core$List$member('support_averages'),
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string));
	return A2(
		$elm$json$Json$Decode$field,
		'questions',
		$elm$json$Json$Decode$list(
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'datapoints',
					$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList(v2DatapointDecoder)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					$elm$json$Json$Decode$maybe(
						A2($elm$json$Json$Decode$field, 'knowledge_base', $elm$json$Json$Decode$string)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						$elm$json$Json$Decode$maybe(
							A2($elm$json$Json$Decode$field, 'warning', $elm$json$Json$Decode$string)),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$map,
								$elm$core$Maybe$withDefault(false),
								$elm$json$Json$Decode$maybe(
									A2($elm$json$Json$Decode$field, 'flags', averagesSupportDecoder))),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								$elm$json$Json$Decode$maybe(
									A2($elm$json$Json$Decode$field, 'unit', $author$project$Data$Labels$averagesUnitDecoder)),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$andMap,
									$elm$json$Json$Decode$maybe(
										A2($elm$json$Json$Decode$field, 'notice', $elm$json$Json$Decode$string)),
									A2(
										$elm_community$json_extra$Json$Decode$Extra$andMap,
										A2(
											$elm_community$json_extra$Json$Decode$Extra$withDefault,
											false,
											A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool)),
										A2(
											$elm_community$json_extra$Json$Decode$Extra$andMap,
											$elm$json$Json$Decode$maybe(
												A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)),
											A2(
												$elm_community$json_extra$Json$Decode$Extra$andMap,
												$elm$json$Json$Decode$maybe(
													A2(
														$elm$json$Json$Decode$field,
														'suffixes',
														$turboMaCk$non_empty_list_alias$List$NonEmpty$decodeList($author$project$Data$Labels$suffixDecoder))),
												A2(
													$elm_community$json_extra$Json$Decode$Extra$andMap,
													A2(
														$elm$json$Json$Decode$field,
														'categories',
														$elm$json$Json$Decode$list(v2CategoryIdDecoder)),
													A2(
														$elm_community$json_extra$Json$Decode$Extra$andMap,
														A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
														A2(
															$elm_community$json_extra$Json$Decode$Extra$andMap,
															A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
															A2(
																$elm_community$json_extra$Json$Decode$Extra$andMap,
																A2($elm$json$Json$Decode$field, 'namespace_code', $author$project$Data$Id$decode),
																A2(
																	$elm_community$json_extra$Json$Decode$Extra$andMap,
																	A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
																	$elm$json$Json$Decode$succeed(
																		function (code) {
																			return function (namespaceCode) {
																				return function (name) {
																					return function (fullName) {
																						return function (categoryIds) {
																							return function (suffixes) {
																								return function (message) {
																									return function (accessible) {
																										return function (notice) {
																											return function (averagesUnit) {
																												return function (averageSupport) {
																													return function (warning) {
																														return function (knowledgeBase) {
																															return function (datapoints) {
																																var wantedQuestionCode = ($author$project$Data$Id$unwrap(namespaceCode) !== 'core') ? $author$project$Data$Id$fromString(
																																	$author$project$Data$Id$unwrap(namespaceCode) + ('.' + $author$project$Data$Id$unwrap(code))) : $author$project$Data$Id$fromString(
																																	$author$project$Data$Id$unwrap(code));
																																return {fc: accessible, jr: averageSupport, hc: averagesUnit, nP: categoryIds, bW: code, er: datapoints, oR: fullName, f3: knowledgeBase, k1: wantedQuestionCode, pP: message, ld: name, id: namespaceCode, gl: notice, rI: suffixes, L: warning};
																															};
																														};
																													};
																												};
																											};
																										};
																									};
																								};
																							};
																						};
																					};
																				};
																			};
																		})))))))))))))))));
}();
var $author$project$Data$Platform2$getQuestionsForWidget = F3(
	function (dashboardId, widgetId, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					A2($author$project$Data$Platform2$encodeGetQuestionsForWidgetRequest, dashboardId, widgetId)),
				hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Data$Platform2$questionsForWidgetDecoder),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Data$Platform2$host(flags),
					_List_fromArray(
						['platform', 'dashboards', 'metadata']),
					_List_Nil)
			});
	});
var $elm_community$json_extra$Json$Decode$Extra$combine = A2(
	$elm$core$List$foldr,
	$elm$json$Json$Decode$map2($elm$core$List$cons),
	$elm$json$Json$Decode$succeed(_List_Nil));
var $elm_community$json_extra$Json$Decode$Extra$sequence = function (decoders) {
	return $elm_community$json_extra$Json$Decode$Extra$combine(
		A2(
			$elm$core$List$indexedMap,
			F2(
				function (idx, dec) {
					return A2($elm$json$Json$Decode$index, idx, dec);
				}),
			decoders));
};
var $elm_community$json_extra$Json$Decode$Extra$indexedList = function (indexedDecoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (values) {
			return $elm_community$json_extra$Json$Decode$Extra$sequence(
				A2(
					$elm$core$List$map,
					indexedDecoder,
					A2(
						$elm$core$List$range,
						0,
						$elm$core$List$length(values) - 1)));
		},
		$elm$json$Json$Decode$list($elm$json$Json$Decode$value));
};
var $author$project$Data$Platform2$Splitter = F5(
	function (code, name, segments, accessible, position) {
		return {fc: accessible, bW: code, ld: name, lB: position, l5: segments};
	});
var $author$project$Data$Platform2$Segment = F3(
	function (id, name, accessible) {
		return {fc: accessible, b: id, ld: name};
	});
var $author$project$Data$Platform2$segmentDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
			$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Segment))));
var $author$project$Data$Platform2$splitterDecoder = function (position) {
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(position),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'accessible', $elm$json$Json$Decode$bool),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$field,
					'segments',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$segmentDecoder)),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
						$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Splitter))))));
};
var $author$project$Data$Platform2$getSplitters = F2(
	function (namespaceCode, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm_community$json_extra$Json$Decode$Extra$indexedList($author$project$Data$Platform2$splitterDecoder))),
				hU: A2(
					$author$project$Gwi$List$appendMaybe,
					A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
					_List_fromArray(
						[
							$author$project$Data$Auth$header(flags.i$)
						])),
				h8: 'GET',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Data$Platform2$host(flags),
					_List_fromArray(
						[
							'v1',
							'splitters',
							'by_namespace',
							$author$project$Data$Id$unwrap(namespaceCode)
						]),
					_List_Nil)
			});
	});
var $elm$core$String$indices = _String_indexes;
var $author$project$Data$Platform2$parseTVChannelLabel = function (label) {
	var startOfMeta = A2(
		$elm$core$Maybe$withDefault,
		-1,
		$elm$core$List$head(
			A2($elm$core$String$indices, '(', label)));
	var endOfMeta = $elm$core$String$length(label);
	var channelName = A3($elm$core$String$slice, 0, startOfMeta, label);
	var channelMeta = A3($elm$core$String$slice, startOfMeta, endOfMeta, label);
	return {
		gf: $elm$core$String$isEmpty(channelMeta) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(channelMeta),
		ld: $elm$core$String$trim(channelName)
	};
};
var $author$project$Data$Platform2$tvChannelDecoder = A2(
	$elm$json$Json$Decode$map,
	function (_v0) {
		var code = _v0.a;
		var label = _v0.b;
		var _v1 = $author$project$Data$Platform2$parseTVChannelLabel(label);
		var name = _v1.ld;
		var metadata = _v1.gf;
		return {bW: code, gf: metadata, ld: name};
	},
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
			$elm$json$Json$Decode$succeed($elm$core$Tuple$pair))));
var $author$project$Data$Platform2$getTVChannels = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2(
					$elm$json$Json$Decode$field,
					'datapoints',
					$elm$json$Json$Decode$list($author$project$Data$Platform2$tvChannelDecoder))),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: A3(
				$elm$url$Url$Builder$crossOrigin,
				$author$project$Data$Platform2$host(flags),
				_List_fromArray(
					['v1', 'tvrf', 'query', 'datapoints']),
				_List_Nil)
		});
};
var $author$project$Data$Platform2$unsafeDatapointCodeToTimezoneCode = function (_v0) {
	var id = _v0;
	return id;
};
var $author$project$Data$Platform2$timezoneFromDatapoint = F2(
	function (position, datapoint) {
		return {
			bW: $author$project$Data$Platform2$unsafeDatapointCodeToTimezoneCode(datapoint.bW),
			ld: datapoint.ld,
			lB: position
		};
	});
var $author$project$Data$Platform2$timezonesQuestionCode = $author$project$Data$Id$fromString('gwi-ext.q418999');
var $author$project$Data$Platform2$getTimezones = function (flags) {
	return A2(
		$elm$core$Platform$Cmd$map,
		$elm$core$Result$map(
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.er;
				},
				A2(
					$elm$core$Basics$composeR,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$List$sortBy(
							function ($) {
								return $.gq;
							}),
						$elm$core$List$indexedMap($author$project$Data$Platform2$timezoneFromDatapoint))))),
		A2($author$project$Data$Labels$getQuestionV2, $author$project$Data$Platform2$timezonesQuestionCode, flags));
};
var $author$project$Data$Labels$getWaves = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Labels$wavesDecoder)),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: $author$project$Config$Main$get(flags.j8).dV.d5 + '/v1/surveys/waves'
		});
};
var $author$project$Data$Platform2$encodeRequestForWavesForDashboardId = function (dashboardId) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'dashboard_id',
				$author$project$Data$Id$encode(dashboardId))
			]));
};
var $author$project$Data$Platform2$getWavesForDashboardId = F2(
	function (dashboardId, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeRequestForWavesForDashboardId(dashboardId)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2($elm$json$Json$Decode$field, 'waves', $author$project$Data$Labels$wavesDecoder)),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + '/platform/dashboards/waves'
			});
	});
var $author$project$Data$Labels$getWavesForNamespace = F2(
	function (namespaceCode, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Labels$wavesDecoder)),
				hU: A2(
					$author$project$Gwi$List$appendMaybe,
					A2($elm$core$Maybe$map, $author$project$Data$GettableKeyValueHeader$toHttpHeaderList, flags.oG),
					_List_fromArray(
						[
							$author$project$Data$Auth$header(flags.i$)
						])),
				h8: 'GET',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Data$Labels$host(flags),
					_List_fromArray(
						[
							'v1',
							'surveys',
							'waves',
							'by_namespace',
							$author$project$Data$Id$unwrap(namespaceCode)
						]),
					_List_Nil)
			});
	});
var $author$project$Store$Platform2$DashboardsUserSettingsUpdated = function (a) {
	return {$: 5, a: a};
};
var $author$project$Data$Platform2$encodeDoNotShowAgain = function (settings) {
	return A2(
		$elm$json$Json$Encode$list,
		$elm$json$Json$Encode$string,
		A3(
			$author$project$Gwi$List$addIf,
			!settings.iP,
			'NewBadgeOnDonutChartItem',
			A3(
				$author$project$Gwi$List$addIf,
				!settings.iO,
				'DotOnChartTypeDropdown',
				A3(
					$author$project$Gwi$List$addIf,
					!settings.md,
					'AudiencesReorderingOnboarding',
					A3(
						$author$project$Gwi$List$addIf,
						!settings.me,
						'CreateDashboardOnboarding',
						function () {
							var _v0 = settings.jN;
							switch (_v0) {
								case 0:
									return _List_Nil;
								case 1:
									return _List_fromArray(
										['ContinueAnalysis_no']);
								default:
									return _List_fromArray(
										['ContinueAnalysis_yes']);
							}
						}())))));
};
var $author$project$Data$Platform2$userSettingsEncode = function (_v0) {
	var doNotShowAgain = _v0.bF;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'do_not_show_again',
				$author$project$Data$Platform2$encodeDoNotShowAgain(doNotShowAgain))
			]));
};
var $author$project$Data$Platform2$updateDashboardsUserSettings = F2(
	function (settings, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$userSettingsEncode(settings)),
				hK: $author$project$Gwi$Http$expectWhatever($elm$core$Basics$identity),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'PUT',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Data$Platform2$host(flags),
					_List_fromArray(
						['v2', 'settings', 'dashboards']),
					_List_Nil)
			});
	});
var $author$project$Store$Platform2$saveDashboardsUserSettings = F2(
	function (userSettings, config) {
		return A5(
			$author$project$Store$Utils$collectionRequest,
			$elm$core$Basics$never,
			$elm$core$Basics$always(
				config.a(
					$author$project$Store$Platform2$DashboardsUserSettingsUpdated(userSettings))),
			$elm$core$Basics$always(config.av),
			$author$project$Data$Platform2$updateDashboardsUserSettings(userSettings),
			F2(
				function (store, err) {
					return _Utils_update(
						store,
						{
							jU: A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$krisajenkins$remotedata$RemoteData$Success(userSettings),
								$krisajenkins$remotedata$RemoteData$Failure,
								err)
						});
				}));
	});
var $author$project$Store$Utils$taggedCollectionLoadedWith = function (toKey) {
	return A2(
		$elm$core$Basics$composeL,
		A2($elm$core$Basics$composeL, $krisajenkins$remotedata$RemoteData$Success, $author$project$Data$Id$dictFromList),
		$elm$core$List$map(
			function (c) {
				return _Utils_Tuple2(
					toKey(c),
					c);
			}));
};
var $turboMaCk$any_dict$Dict$Any$update = F3(
	function (k, f, _v0) {
		var inner = _v0;
		var updateDict = A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$core$Maybe$map(
					function (b) {
						return _Utils_Tuple2(k, b);
					}),
				f),
			$elm$core$Maybe$map($elm$core$Tuple$second));
		return _Utils_update(
			inner,
			{
				i: A3(
					$elm$core$Dict$update,
					inner.aT(k),
					updateDict,
					inner.i)
			});
	});
var $author$project$Store$Platform2$fetch = function (action) {
	var fetchWithoutCustomError = function (r) {
		return $author$project$Store$Platform2$fetch_(
			{p: r.p, gn: $elm$core$Maybe$Nothing, gp: r.gp, gG: r.gG, eT: r.eT, mf: r.mf});
	};
	switch (action.$) {
		case 0:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.jm;
					},
					gp: A2($elm$core$Basics$composeL, $author$project$Store$Platform2$AudienceRelatedMsg, $author$project$Store$Platform2$AudienceFoldersFetched),
					gG: $author$project$Data$Platform2$getAudienceFolders,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{jm: val});
						}),
					mf: true
				});
		case 23:
			return fetchWithoutCustomError(
				{
					p: $elm$core$Basics$always($krisajenkins$remotedata$RemoteData$NotAsked),
					gp: A2($elm$core$Basics$composeL, $author$project$Store$Platform2$ChartsRelatedMsg, $author$project$Store$Platform2$ChartFoldersFetched),
					gG: $author$project$Data$Platform2$getChartFolders,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{jE: val});
						}),
					mf: true
				});
		case 24:
			return fetchWithoutCustomError(
				{
					p: $elm$core$Basics$always($krisajenkins$remotedata$RemoteData$NotAsked),
					gp: A2($elm$core$Basics$composeL, $author$project$Store$Platform2$ChartsRelatedMsg, $author$project$Store$Platform2$ChartsFetched),
					gG: $author$project$Data$Platform2$getBrowserCharts,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{fr: val});
						}),
					mf: true
				});
		case 1:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.d9;
					},
					gp: A2($elm$core$Basics$composeL, $author$project$Store$Platform2$AudienceRelatedMsg, $author$project$Store$Platform2$AudiencesFetched),
					gG: $author$project$Data$Platform2$getAudiences,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{d9: val});
						}),
					mf: true
				});
		case 2:
			var dashboardId = action.a;
			return fetchWithoutCustomError(
				{
					p: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.jq;
						},
						A2(
							$elm$core$Basics$composeR,
							$turboMaCk$any_dict$Dict$Any$get(dashboardId),
							$elm$core$Maybe$withDefault($krisajenkins$remotedata$RemoteData$NotAsked))),
					gp: A2(
						$elm$core$Basics$composeL,
						$author$project$Store$Platform2$AudienceRelatedMsg,
						$author$project$Store$Platform2$AudiencesByDashboardIdFetched(dashboardId)),
					gG: $author$project$Data$Platform2$getAudiencesByDashboardId(dashboardId),
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{
									jq: A3($turboMaCk$any_dict$Dict$Any$insert, dashboardId, val, store_.jq)
								});
						}),
					mf: true
				});
		case 3:
			return F3(
				function (config, flags, store) {
					return A4(
						fetchWithoutCustomError,
						{
							p: $elm$core$Basics$always($krisajenkins$remotedata$RemoteData$NotAsked),
							gp: A2(
								$elm$core$Basics$composeL,
								$author$project$Store$Platform2$AudienceRelatedMsg,
								$author$project$Store$Platform2$AudiencesReloaded(store.d9)),
							gG: $author$project$Data$Platform2$getAudiences,
							eT: F2(
								function (val, store_) {
									return _Utils_update(
										store_,
										{d9: val});
								}),
							mf: true
						},
						config,
						flags,
						store);
				});
		case 4:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.v;
					},
					gp: $author$project$Store$Platform2$DashboardsFetched,
					gG: $author$project$Data$Platform2$getDashboards,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{v: val});
						}),
					mf: true
				});
		case 16:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.jU;
					},
					gp: $author$project$Store$Platform2$DashboardsUserSettingsFetched,
					gG: $author$project$Data$Platform2$fetchDashboardsUserSettings,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{jU: val});
						}),
					mf: true
				});
		case 17:
			var userSettings = action.a;
			return $author$project$Store$Platform2$saveDashboardsUserSettings(userSettings);
		case 5:
			var dashboardId = action.a;
			return function (config) {
				return A2(
					$author$project$Store$Platform2$fetch_,
					{
						p: A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.v;
							},
							A2(
								$elm$core$Basics$composeR,
								$author$project$Store$Platform2$getDashboard(dashboardId),
								$krisajenkins$remotedata$RemoteData$andThen(
									function (dashboard) {
										return A2(
											$krisajenkins$remotedata$RemoteData$map,
											$elm$core$Basics$always(dashboard),
											dashboard.cl);
									}))),
						gn: $elm$core$Maybe$Just(
							F3(
								function (_v1, storeUpdate, err) {
									if (err.$ === 3) {
										var metadata = err.a;
										return (metadata.rD === 404) ? config.p3(storeUpdate) : A2(config.ox, storeUpdate, err);
									} else {
										return A2(config.ox, storeUpdate, err);
									}
								})),
						gp: $author$project$Store$Platform2$DashboardFetched,
						gG: $author$project$Data$Platform2$getDashboard(dashboardId),
						eT: F2(
							function (val, store_) {
								return _Utils_update(
									store_,
									{
										v: A2(
											$krisajenkins$remotedata$RemoteData$map,
											A2(
												$turboMaCk$any_dict$Dict$Any$update,
												dashboardId,
												$elm$core$Maybe$map(
													function (dashboard) {
														return _Utils_update(
															dashboard,
															{
																cl: A2(
																	$krisajenkins$remotedata$RemoteData$andThen,
																	function ($) {
																		return $.cl;
																	},
																	val)
															});
													})),
											store_.v)
									});
							}),
						mf: true
					},
					config);
			};
		case 6:
			var namespaceCode = action.a;
			return fetchWithoutCustomError(
				{
					p: $author$project$Store$Platform2$getSplitters(namespaceCode),
					gp: $author$project$Store$Platform2$SplittersFetched(namespaceCode),
					gG: $author$project$Data$Platform2$getSplitters(namespaceCode),
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{
									cZ: A3($turboMaCk$any_dict$Dict$Any$insert, namespaceCode, val, store_.cZ)
								});
						}),
					mf: true
				});
		case 14:
			var showErrorModal = action.a.mf;
			var questionCode = action.b;
			return function (config) {
				return A2(
					$author$project$Store$Platform2$fetch_,
					{
						p: $author$project$Store$Platform2$getQuestion(questionCode),
						gn: $elm$core$Maybe$Just(
							F2(
								function (b, us) {
									return A2(
										$elm$core$Basics$composeL,
										config.a,
										A3($author$project$Store$Platform2$QuestionFetchError, questionCode, b, us));
								})),
						gp: $author$project$Store$Platform2$QuestionFetched(questionCode),
						gG: $author$project$Data$Labels$getQuestionV2(questionCode),
						eT: F2(
							function (val, store_) {
								return _Utils_update(
									store_,
									{
										bt: A3($turboMaCk$any_dict$Dict$Any$insert, questionCode, val, store_.bt)
									});
							}),
						mf: showErrorModal
					},
					config);
			};
		case 15:
			var dashboardId = action.a;
			var widgetId = action.b;
			var dashboardAndWidgetId = $author$project$Data$Id$fromString(
				_Utils_ap(
					$author$project$Data$Id$unwrap(dashboardId),
					$author$project$Data$Id$unwrap(widgetId)));
			var checkQuestionsLoaded = function (store) {
				return A2(
					$elm$core$Maybe$withDefault,
					$krisajenkins$remotedata$RemoteData$NotAsked,
					A2($turboMaCk$any_dict$Dict$Any$get, dashboardAndWidgetId, store.cP));
			};
			return fetchWithoutCustomError(
				{
					p: checkQuestionsLoaded,
					gp: A2($author$project$Store$Platform2$QuestionsForWidgetFetched, dashboardId, widgetId),
					gG: A2($author$project$Data$Platform2$getQuestionsForWidget, dashboardId, widgetId),
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{
									cP: A3($turboMaCk$any_dict$Dict$Any$insert, dashboardAndWidgetId, val, store_.cP)
								});
						}),
					mf: false
				});
		case 7:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.ac;
					},
					gp: $author$project$Store$Platform2$CategoriesFetched,
					gG: $author$project$Data$Labels$getCategories,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{ac: val});
						}),
					mf: true
				});
		case 8:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.cD;
					},
					gp: $author$project$Store$Platform2$LocationsFetched,
					gG: $author$project$Data$Labels$getLocations,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{cD: val});
						}),
					mf: true
				});
		case 9:
			var namespaceCode = action.a;
			return fetchWithoutCustomError(
				{
					p: $author$project$Store$Platform2$getLocations(namespaceCode),
					gp: $author$project$Store$Platform2$LocationsByNamespaceFetched(namespaceCode),
					gG: $author$project$Data$Labels$getLocationsForNamespace(namespaceCode),
					eT: F2(
						function (val, store_) {
							var valueToInsert = function () {
								if (((val.$ === 2) && (val.a.$ === 3)) && (val.a.a === 403)) {
									return $krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict);
								} else {
									return val;
								}
							}();
							return _Utils_update(
								store_,
								{
									pK: A3($turboMaCk$any_dict$Dict$Any$insert, namespaceCode, valueToInsert, store_.pK)
								});
						}),
					mf: false
				});
		case 10:
			var dashboardId = action.a;
			return fetchWithoutCustomError(
				{
					p: $author$project$Store$Platform2$getLocationsByDashboardId(dashboardId),
					gp: $author$project$Store$Platform2$LocationsByDashboardIdFetched(dashboardId),
					gG: $author$project$Data$Platform2$getLocationsForDashboardId(dashboardId),
					eT: F2(
						function (val, store_) {
							var valueToInsert = function () {
								if (((val.$ === 2) && (val.a.$ === 3)) && (val.a.a === 403)) {
									return $krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict);
								} else {
									return val;
								}
							}();
							return _Utils_update(
								store_,
								{
									pJ: A3($turboMaCk$any_dict$Dict$Any$insert, dashboardId, valueToInsert, store_.pJ)
								});
						}),
					mf: false
				});
		case 11:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.dX;
					},
					gp: $author$project$Store$Platform2$WavesFetched,
					gG: $author$project$Data$Labels$getWaves,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{dX: val});
						}),
					mf: true
				});
		case 12:
			var namespaceCode = action.a;
			return fetchWithoutCustomError(
				{
					p: $author$project$Store$Platform2$getWaves(namespaceCode),
					gp: $author$project$Store$Platform2$WavesByNamespaceFetched(namespaceCode),
					gG: $author$project$Data$Labels$getWavesForNamespace(namespaceCode),
					eT: F2(
						function (val, store_) {
							var valueToInsert = function () {
								if (((val.$ === 2) && (val.a.$ === 3)) && (val.a.a === 403)) {
									return $krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict);
								} else {
									return val;
								}
							}();
							return _Utils_update(
								store_,
								{
									se: A3($turboMaCk$any_dict$Dict$Any$insert, namespaceCode, valueToInsert, store_.se)
								});
						}),
					mf: false
				});
		case 13:
			var dashboardId = action.a;
			return fetchWithoutCustomError(
				{
					p: $author$project$Store$Platform2$getWavesByDashboardId(dashboardId),
					gp: $author$project$Store$Platform2$WavesByDashboardIdFetched(dashboardId),
					gG: $author$project$Data$Platform2$getWavesForDashboardId(dashboardId),
					eT: F2(
						function (val, store_) {
							var valueToInsert = function () {
								if (((val.$ === 2) && (val.a.$ === 3)) && (val.a.a === 403)) {
									return $krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict);
								} else {
									return val;
								}
							}();
							return _Utils_update(
								store_,
								{
									sd: A3($turboMaCk$any_dict$Dict$Any$insert, dashboardId, valueToInsert, store_.sd)
								});
						}),
					mf: false
				});
		case 18:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.kF;
					},
					gp: $author$project$Store$Platform2$InsightCategoriesFetched,
					gG: $author$project$Data$Platform2$getInsightCategories,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{kF: val});
						}),
					mf: true
				});
		case 19:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.of;
					},
					gp: $author$project$Store$Platform2$DatasetFoldersFetched,
					gG: $author$project$Data$Platform2$getDatasetFolders,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{of: val});
						}),
					mf: true
				});
		case 20:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.es;
					},
					gp: $author$project$Store$Platform2$DatasetsFetched,
					gG: $author$project$Data$Platform2$getDatasets,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{es: val});
						}),
					mf: true
				});
		case 21:
			var dashboardId = action.a;
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.es;
					},
					gp: $author$project$Store$Platform2$DatasetFolderTreesByDashboardIdFetched,
					gG: $author$project$Data$Platform2$getDatasetFolderTreesByDashboardId(dashboardId),
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{es: val});
						}),
					mf: true
				});
		case 22:
			var insightId = action.a;
			return fetchWithoutCustomError(
				{
					p: $author$project$Store$Platform2$getInsight(insightId),
					gp: $author$project$Store$Platform2$InsightFetched,
					gG: $author$project$Data$Platform2$getInsight(insightId),
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{
									pk: A3($turboMaCk$any_dict$Dict$Any$insert, insightId, val, store_.pk)
								});
						}),
					mf: false
				});
		case 25:
			var namespaceCode = action.a;
			return fetchWithoutCustomError(
				{
					p: A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.cB;
						},
						A2(
							$elm$core$Basics$composeR,
							$turboMaCk$any_dict$Dict$Any$get(namespaceCode),
							$elm$core$Maybe$withDefault($krisajenkins$remotedata$RemoteData$NotAsked))),
					gp: $author$project$Store$Platform2$LineageFetched(namespaceCode),
					gG: $author$project$Data$Labels$getLineage(namespaceCode),
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{
									cB: A3($turboMaCk$any_dict$Dict$Any$insert, namespaceCode, val, store_.cB)
								});
						}),
					mf: false
				});
		case 26:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.rT;
					},
					gp: $author$project$Store$Platform2$TimezonesFetched,
					gG: $author$project$Data$Platform2$getTimezones,
					eT: F2(
						function (list, store_) {
							return _Utils_update(
								store_,
								{
									mx: A2(
										$krisajenkins$remotedata$RemoteData$andThen,
										$author$project$Store$Utils$taggedCollectionLoadedWith(
											function ($) {
												return $.bW;
											}),
										list),
									rT: list
								});
						}),
					mf: true
				});
		case 27:
			return fetchWithoutCustomError(
				{
					p: function ($) {
						return $.mK;
					},
					gp: $author$project$Store$Platform2$TVChannelsFetched,
					gG: $author$project$Data$Platform2$getTVChannels,
					eT: F2(
						function (val, store_) {
							return _Utils_update(
								store_,
								{mK: val});
						}),
					mf: true
				});
		default:
			var fn = action.a;
			return F3(
				function (_v7, _v8, store) {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						fn(store));
				});
	}
};
var $author$project$Store$Platform2$storeActionMany = F4(
	function (actions, config, flags, store) {
		return A2(
			$elm$core$Tuple$mapSecond,
			$elm$core$Platform$Cmd$batch,
			A3(
				$elm$core$List$foldl,
				F2(
					function (action, _v0) {
						var store_ = _v0.a;
						var cmds = _v0.b;
						var _v1 = A4($author$project$Store$Platform2$fetch, action, config, flags, store_);
						var newStore = _v1.a;
						var newCmd = _v1.b;
						return _Utils_Tuple2(
							newStore,
							A2($elm$core$List$cons, newCmd, cmds));
					}),
				_Utils_Tuple2(store, _List_Nil),
				actions));
	});
var $author$project$Data$Metric$toP2CompatibleString = function (metric) {
	switch (metric) {
		case 0:
			return 'audience_percentage';
		case 1:
			return 'datapoint_percentage';
		case 2:
			return 'positive_size';
		case 3:
			return 'audience_index';
		default:
			return 'positive_sample';
	}
};
var $author$project$Platform2$Router$toUrlString = F2(
	function (flags, route) {
		var path = '/' + function () {
			switch (route.$) {
				case 0:
					return 'audiences/new';
				case 1:
					var audienceId = route.a;
					return 'audiences/' + $author$project$Data$Id$unwrap(audienceId);
				case 2:
					var questionCode = route.a;
					return 'chart-builder/questions/' + $author$project$Data$Id$unwrap(questionCode);
				case 3:
					return 'chart-builder/chart';
				case 4:
					var chartId = route.a;
					return 'chart-builder/chart/' + $author$project$Data$Id$unwrap(chartId);
				case 5:
					var insightId = route.a;
					return 'insights/' + $author$project$Data$Id$unwrap(insightId);
				default:
					return 'insights';
			}
		}();
		var host = flags.lA;
		var cleanFeature = $elm$core$Maybe$andThen(
			function (feature) {
				var _v0 = A2($elm$core$String$split, '/', feature);
				if (_v0.b) {
					if (!_v0.b.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var cleanPart = _v0.a;
						return $elm$core$Maybe$Just(cleanPart);
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			});
		return _Utils_ap(
			host,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				path,
				A2(
					$elm$core$Basics$composeL,
					A2($elm_community$basics_extra$Basics$Extra$flip, $elm$core$Basics$append, path),
					$elm$core$Basics$append('/')),
				cleanFeature(flags.hO)));
	});
var $author$project$Store$Platform2$DashboardFavouriteToggleResult = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Data$Platform2$setDashboardFavourite = F3(
	function (dashboardId, isFavourite, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'favourite',
								$elm$json$Json$Encode$bool(isFavourite))
							]))),
				hK: $author$project$Gwi$Http$expectWhatever($elm$core$Basics$identity),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'PUT',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + ($author$project$Data$Id$unwrap(dashboardId) + '/favourite'))
			});
	});
var $author$project$Store$Platform2$toggleDashboardFavourite = F4(
	function (dashboardId, config, flags, store) {
		var _v0 = store.v;
		if (_v0.$ === 3) {
			var dashboards = _v0.a;
			var _v1 = A2($turboMaCk$any_dict$Dict$Any$get, dashboardId, dashboards);
			if (!_v1.$) {
				var dashboard = _v1.a;
				var newIsFavourite = !dashboard.kN;
				var newDashboard = _Utils_update(
					dashboard,
					{kN: newIsFavourite});
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: $krisajenkins$remotedata$RemoteData$Success(
								A3($turboMaCk$any_dict$Dict$Any$insert, dashboardId, newDashboard, dashboards))
						}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2(
							$elm$core$Basics$composeL,
							config.a,
							$author$project$Store$Platform2$DashboardFavouriteToggleResult(dashboardId)),
						A3($author$project$Data$Platform2$setDashboardFavourite, dashboardId, newIsFavourite, flags)));
			} else {
				return _Utils_Tuple2(store, $elm$core$Platform$Cmd$none);
			}
		} else {
			return _Utils_Tuple2(store, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Dashboards2Main$unmountedD2 = _Platform_outgoingPort(
	'unmountedD2',
	function ($) {
		return $elm$json$Json$Encode$null;
	});
var $author$project$Store$Platform2$DashboardUnshared = F2(
	function (a, b) {
		return {$: 34, a: a, b: b};
	});
var $author$project$Data$Platform2$unshareDashboard = F2(
	function (dashboard, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: $author$project$Gwi$Http$expectWhatever($elm$core$Basics$identity),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'DELETE',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + ($author$project$Data$Id$unwrap(dashboard.b) + '/share'))
			});
	});
var $author$project$Store$Platform2$unshareDashboard = F5(
	function (_v0, dashboardFullyLoaded, config, flags, store) {
		var closeShareModal = _v0.bV;
		var dashboard = $author$project$Data$Platform2$fromFullyLoadedDashboard(dashboardFullyLoaded);
		var httpResultToMsg = A2(
			$elm_community$result_extra$Result$Extra$unpack,
			config.av,
			A2(
				$elm$core$Basics$composeL,
				A2(
					$elm$core$Basics$composeL,
					config.a,
					$author$project$Store$Platform2$DashboardUnshared(
						{bV: closeShareModal})),
				$elm$core$Basics$always(dashboard)));
		return _Utils_Tuple2(
			store,
			A2(
				$elm$core$Platform$Cmd$map,
				httpResultToMsg,
				A2($author$project$Data$Platform2$unshareDashboard, dashboardFullyLoaded, flags)));
	});
var $author$project$Dashboards2$Modal$AddDescriptionModal = function (a) {
	return {$: 17, a: a};
};
var $author$project$Dashboards2$ApplyDatasetsSelection = function (a) {
	return {$: 22, a: a};
};
var $author$project$Dashboards2$ApplyLocationsSelection = F2(
	function (a, b) {
		return {$: 20, a: a, b: b};
	});
var $author$project$Dashboards2$ApplyWavesSelection = function (a) {
	return {$: 21, a: a};
};
var $author$project$Dashboards2$Modal$AudienceBrowser = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2$Analytics$AudienceBrowserOpened = function (a) {
	return {$: 42, a: a};
};
var $author$project$Dashboards2$Modal$AudienceExpression = function (a) {
	return {$: 14, a: a};
};
var $author$project$Dashboards2$Analytics$AudienceRearanged = function (a) {
	return {$: 30, a: a};
};
var $author$project$Dashboards2$Modal$BaseAudienceBrowser = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dashboards2$BulkOrgAddIdsValidated = F2(
	function (a, b) {
		return {$: 109, a: a, b: b};
	});
var $author$project$Dashboards2$ByNewSharedWith = {$: 1};
var $author$project$Analytics$Place$ChangeChartTypeDropdown = 32;
var $author$project$Dashboards2$Modal$ChartBrowserModal = function (a) {
	return {$: 18, a: a};
};
var $author$project$Dashboards2$Analytics$ChartMetadata = function (a) {
	return {$: 37, a: a};
};
var $author$project$Dashboards2$Analytics$ChartWidgetDeleted = function (a) {
	return {$: 23, a: a};
};
var $author$project$Dashboards2$Analytics$ChartWidgetsSaved = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dashboards2$CheckWidgetVisibility = F2(
	function (a, b) {
		return {$: 119, a: a, b: b};
	});
var $author$project$Dashboards2$Modal$ClickedDisabledAudience = 1;
var $author$project$Dashboards2$Modal$ConfirmDeleteDashboard = function (a) {
	return {$: 6, a: a};
};
var $author$project$Dashboards2$Modal$ConfirmDeleteMultipleDashboards = function (a) {
	return {$: 7, a: a};
};
var $author$project$Dashboards2$Modal$ConfirmDeleteWidget = function (a) {
	return {$: 8, a: a};
};
var $author$project$Dashboards2$Modal$ConfirmModal = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Analytics$ContinueAnalysis = function (a) {
	return {$: 31, a: a};
};
var $author$project$Dashboards2$CreateNotification = F2(
	function (a, b) {
		return {$: 48, a: a, b: b};
	});
var $author$project$Analytics$Place$DashboardBuilder = 5;
var $author$project$Dashboards2$Analytics$DashboardDeleted = function (a) {
	return {$: 16, a: a};
};
var $author$project$Dashboards2$Analytics$DashboardEditModeOpened = function (a) {
	return {$: 13, a: a};
};
var $author$project$Dashboards2$Analytics$DashboardExported = function (a) {
	return {$: 14, a: a};
};
var $author$project$Dashboards2$DeleteDashboard = function (a) {
	return {$: 51, a: a};
};
var $author$project$Dashboards2$DrawersMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboards2$Modal$DuplicateDashboardModal = function (a) {
	return {$: 12, a: a};
};
var $author$project$Dashboards2$Analytics$DuplicateTextWidget = function (a) {
	return {$: 38, a: a};
};
var $author$project$Dashboards2$Modal$EditWidgetName = function (a) {
	return {$: 19, a: a};
};
var $author$project$Dashboards2$Modal$EmptyLink = {$: 0};
var $author$project$Store$Platform2$FetchInsight = function (a) {
	return {$: 22, a: a};
};
var $author$project$Store$Platform2$FetchLineage = function (a) {
	return {$: 25, a: a};
};
var $author$project$Dashboards2$FetchMany = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2$Modal$HelpMeChooseChartType = function (a) {
	return {$: 9, a: a};
};
var $author$project$Dashboards2$Modal$HelpMeChooseMetric = function (a) {
	return {$: 10, a: a};
};
var $author$project$Analytics$Place$HelpMeChooseModal = 31;
var $author$project$Dashboards2$Analytics$IntentionToShare = function (a) {
	return {$: 43, a: a};
};
var $author$project$Dashboards2$Modal$MetricInfo = {$: 11};
var $author$project$Dashboards2$Modal$NoWarning = 0;
var $author$project$Dashboards2$NotificationQueueMsg = function (a) {
	return {$: 47, a: a};
};
var $author$project$Dashboards2$OpenShareModal = function (a) {
	return {$: 88, a: a};
};
var $author$project$Dashboards2$OrgAutocompleteInputMsg = function (a) {
	return {$: 86, a: a};
};
var $author$project$Data$Platform2$Organisation = F2(
	function (id, name) {
		return {b: id, ld: name};
	});
var $author$project$Dashboards2$Analytics$RedoApplied = function (a) {
	return {$: 29, a: a};
};
var $author$project$Store$Platform2$ReloadAudiences = {$: 3};
var $author$project$Dashboards2$Replace = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Modal$ReplaceAudienceBrowser = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboards2$Widget$SetMetric = function (a) {
	return {$: 8, a: a};
};
var $author$project$Dashboards2$SetStickyHeaderVisibility = function (a) {
	return {$: 116, a: a};
};
var $author$project$Dashboards2$SetWidgetPosition = F2(
	function (a, b) {
		return {$: 106, a: a, b: b};
	});
var $author$project$Dashboards2$ShareDashboard = function (a) {
	return {$: 107, a: a};
};
var $author$project$Dashboards2$Modal$ShareDashboardModal = function (a) {
	return {$: 16, a: a};
};
var $author$project$Dashboards2$Modal$ShareDashboardModalLoading = {$: 0};
var $author$project$Dashboards2$Modal$ShareDashboardModalReady = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Analytics$TextWidgetDeleted = function (a) {
	return {$: 22, a: a};
};
var $author$project$Dashboards2$TrackAndDeleteDashboard = F2(
	function (a, b) {
		return {$: 53, a: a, b: b};
	});
var $author$project$Dashboards2$TrackAndDuplicateDashboard = F2(
	function (a, b) {
		return {$: 54, a: a, b: b};
	});
var $author$project$Dashboards2$Analytics$UndoApplied = function (a) {
	return {$: 28, a: a};
};
var $author$project$Dashboards2$UserAutocompleteInputMsg = function (a) {
	return {$: 87, a: a};
};
var $author$project$Dashboards2$Modal$Visible = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Analytics$WidgetAddButtonClicked = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$Analytics$WidgetMoved = function (a) {
	return {$: 40, a: a};
};
var $author$project$Dashboards2$Analytics$AudienceAdded = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Dashboards2$UserFilters$OtherChange = 1;
var $author$project$Analytics$batch = _Platform_outgoingPort(
	'batch',
	$elm$json$Json$Encode$list(
		function ($) {
			var a = $.a;
			var b = $.b;
			return A2(
				$elm$json$Json$Encode$list,
				$elm$core$Basics$identity,
				_List_fromArray(
					[
						$elm$json$Json$Encode$string(a),
						$elm$core$Basics$identity(b)
					]));
		}));
var $author$project$Analytics$batch_ = F2(
	function (encodeEvent, events) {
		if (!events.b) {
			return $elm$core$Platform$Cmd$none;
		} else {
			if (!events.b.b) {
				var event = events.a;
				return $author$project$Analytics$track(
					encodeEvent(event));
			} else {
				return $author$project$Analytics$batch(
					A2($elm$core$List$map, encodeEvent, events));
			}
		}
	});
var $author$project$Dashboards2$Analytics$trackEvents = function (events) {
	return A2($author$project$Analytics$batch_, $author$project$Dashboards2$Analytics$encodeEvent, events);
};
var $author$project$Dashboards2$UserFilters$addAudiences = F6(
	function (config, flags, audiences_, audienceIds_, _v0, _v1) {
		var r = _v0;
		var isEditing = _v1.ez;
		var fullDataAudiences = A2(
			$elm$core$List$filterMap,
			function (audienceId) {
				return A2($turboMaCk$any_dict$Dict$Any$get, audienceId, audiences_);
			},
			audienceIds_);
		var states = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.oN;
				},
				$author$project$Data$Platform2$encodeAudienceStatesForAnalytics),
			fullDataAudiences);
		var analytics = $author$project$Dashboards2$Analytics$trackEvents(
			_List_fromArray(
				[
					A2(
					$author$project$Dashboards2$Analytics$AudienceAdded,
					isEditing ? 5 : 4,
					{be: 'Dashboards', hb: 'audience_browser', d9: fullDataAudiences, rC: states})
				]));
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
			analytics,
			A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
				config.oM(1),
				A3(
					$author$project$Dashboards2$UserFilters$fetchSampleSize,
					config,
					flags,
					_Utils_update(
						r,
						{
							d9: _Utils_ap(
								r.d9,
								A3(
									$author$project$Dashboards2$UserFilters$audiencesToColored,
									r.d9,
									$elm$core$Basics$always($elm$core$Maybe$Nothing),
									A2(
										$elm$core$List$filterMap,
										function (id) {
											return A2(
												$elm$core$Maybe$map,
												function (_v2) {
													var expression = _v2.bY;
													var name = _v2.ld;
													return {bY: expression, b: id, pr: false, ld: name, eQ: $krisajenkins$remotedata$RemoteData$NotAsked};
												},
												A2($turboMaCk$any_dict$Dict$Any$get, id, audiences_));
										},
										audienceIds_)))
						}))));
	});
var $author$project$Dashboards2$UserFilters$addBaseAudience = F6(
	function (config, flags, audiences_, baseAudienceId, _v0, isEditing) {
		var r = _v0;
		var fullDataBaseAudience = A2(
			$elm$core$List$filterMap,
			function (audienceId) {
				return A2($turboMaCk$any_dict$Dict$Any$get, audienceId, audiences_);
			},
			A2($elm_community$maybe_extra$Maybe$Extra$cons, baseAudienceId, _List_Nil));
		var states = A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.oN;
				},
				$author$project$Data$Platform2$encodeAudienceStatesForAnalytics),
			fullDataBaseAudience);
		var analytics = $author$project$Dashboards2$Analytics$trackEvents(
			_List_fromArray(
				[
					A2(
					$author$project$Dashboards2$Analytics$AudienceAdded,
					isEditing ? 5 : 4,
					{be: 'Dashboards', hb: 'base_audience_browser', d9: fullDataBaseAudience, rC: states})
				]));
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
			analytics,
			A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
				config.oM(1),
				A3(
					$author$project$Dashboards2$UserFilters$fetchSampleSize,
					config,
					flags,
					_Utils_update(
						r,
						{
							d9: A2(
								$elm$core$List$map,
								function (colored) {
									var audience = colored.fk;
									return _Utils_update(
										colored,
										{
											fk: _Utils_update(
												audience,
												{eQ: $krisajenkins$remotedata$RemoteData$NotAsked})
										});
								},
								r.d9),
							aU: function () {
								if (baseAudienceId.$ === 1) {
									return $author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$NotAsked);
								} else {
									var id = baseAudienceId.a;
									var _v2 = A2($turboMaCk$any_dict$Dict$Any$get, id, audiences_);
									if (!_v2.$) {
										var expression = _v2.a.bY;
										var name = _v2.a.ld;
										return $author$project$Dashboards2$UserFilters$Base(
											{bY: expression, b: id, pr: false, ld: name, eQ: $krisajenkins$remotedata$RemoteData$NotAsked});
									} else {
										return $author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$NotAsked);
									}
								}
							}()
						}))));
	});
var $author$project$Dashboards2$addChartNameLimit = 64;
var $author$project$Dashboards2$addChartNoteLimit = 130;
var $author$project$Platform2$AutocompleteInput$addItems = F2(
	function (items, model) {
		return _Utils_update(
			model,
			{
				u: _Utils_ap(model.u, items)
			});
	});
var $GlobalWebIndex$cmd_extra$Cmd$Extra$addMaybe = F3(
	function (valueToCmd, maybeValue, _v0) {
		var model = _v0.a;
		var prevCmd = _v0.b;
		return _Utils_Tuple2(
			model,
			A2(
				$elm$core$Maybe$withDefault,
				prevCmd,
				A2(
					$elm$core$Maybe$map,
					function (v) {
						return $elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									valueToCmd(v),
									prevCmd
								]));
					},
					maybeValue)));
	});
var $author$project$Dashboards2$allowedWidgetDimensionRanges = {
	cv: {gc: 2, gg: 1},
	da: {gc: 4, gg: 1}
};
var $author$project$Palette$InactiveColor = {$: 0};
var $author$project$Palette$removeShade = function (filtersColor) {
	if (!filtersColor.$) {
		return filtersColor;
	} else {
		var color = filtersColor.b;
		return $author$project$Palette$DefaultColor(color);
	}
};
var $author$project$Dashboards2$UserFilters$lightenIfNeeded = function (audience) {
	return audience.fk.pr ? _Utils_update(
		audience,
		{
			jL: A2($author$project$Palette$p2Shade, audience.jL, $author$project$Palette$InactiveColor)
		}) : _Utils_update(
		audience,
		{
			jL: $author$project$Palette$removeShade(audience.jL)
		});
};
var $author$project$Dashboards2$UserFilters$audiencesWithColor = function (_v0) {
	var r = _v0;
	return A2($elm$core$List$map, $author$project$Dashboards2$UserFilters$lightenIfNeeded, r.d9);
};
var $author$project$Dashboards2$UserFilters$locationsForSaving = function (_v0) {
	var r = _v0;
	var _v1 = r.cD;
	if (!_v1.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var locations_ = _v1.a;
		return $elm$core$Maybe$Just(
			$turboMaCk$any_set$Set$Any$toList(locations_));
	}
};
var $author$project$Data$Platform2$setAudenceColorToMetadata = F2(
	function (audienceId, filtersColor) {
		return A2(
			$turboMaCk$any_dict$Dict$Any$insert,
			audienceId,
			{
				jL: $author$project$Palette$basicColor(filtersColor)
			});
	});
var $author$project$Dashboards2$UserFilters$wavesForSaving = function (_v0) {
	var r = _v0;
	var _v1 = r.dX;
	if (!_v1.$) {
		return $elm$core$Maybe$Nothing;
	} else {
		var waves_ = _v1.a;
		return $elm$core$Maybe$Just(
			$turboMaCk$any_set$Set$Any$toList(waves_));
	}
};
var $author$project$Dashboards2$Detail$applyEdits = F3(
	function (maybeEdits, maybeUf, saved) {
		var maybeWaves = A2($elm$core$Maybe$andThen, $author$project$Dashboards2$UserFilters$wavesForSaving, maybeUf);
		var maybeLocations = A2($elm$core$Maybe$andThen, $author$project$Dashboards2$UserFilters$locationsForSaving, maybeUf);
		var maybeBaseAudienceId = A2($elm$core$Maybe$andThen, $author$project$Dashboards2$UserFilters$getBaseAudienceId, maybeUf);
		var maybeAudiences = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Dashboards2$UserFilters$audiences,
				$elm$core$List$map(
					function ($) {
						return $.b;
					})),
			maybeUf);
		var audiencesMetadata = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Platform2$emptyDashboardFiltersAudiencesMetadata,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Dashboards2$UserFilters$audiencesWithColor,
					A2(
						$elm$core$List$foldr,
						function (_v1) {
							var audience = _v1.fk;
							var color = _v1.jL;
							return A2($author$project$Data$Platform2$setAudenceColorToMetadata, audience.b, color);
						},
						$author$project$Data$Platform2$emptyDashboardFiltersAudiencesMetadata)),
				maybeUf));
		var newFilters = F4(
			function (newLocations, newWaves, baseAudienceId, newAudiences) {
				return {d9: newAudiences, nA: $elm$core$Maybe$Nothing, nB: audiencesMetadata, aU: baseAudienceId, cD: newLocations, dX: newWaves};
			});
		var setNewDashboardData = function (oldData) {
			return _Utils_update(
				oldData,
				{
					C: A4(newFilters, maybeLocations, maybeWaves, maybeBaseAudienceId, maybeAudiences)
				});
		};
		var addName = function (dashboard) {
			if (!maybeEdits.$) {
				var edits = maybeEdits.a;
				return _Utils_update(
					dashboard,
					{ld: edits.ld});
			} else {
				return dashboard;
			}
		};
		var addData = function (dashboard) {
			return _Utils_update(
				dashboard,
				{
					cl: setNewDashboardData(dashboard.cl)
				});
		};
		return addData(
			addName(saved));
	});
var $author$project$Dashboards2$Detail$UnsavedDashboard = function (a) {
	return {$: 0, a: a};
};
var $author$project$Platform2$Drawers$close = $author$project$Platform2$Drawers$Closed;
var $author$project$Dashboards2$UserFilters$setAudiencesAsNotAsked = function (_v0) {
	var userFilters = _v0;
	return _Utils_update(
		userFilters,
		{
			d9: A2(
				$elm$core$List$map,
				function (coloredAudience) {
					var audience = coloredAudience.fk;
					return _Utils_update(
						coloredAudience,
						{
							fk: _Utils_update(
								audience,
								{eQ: $krisajenkins$remotedata$RemoteData$NotAsked})
						});
				},
				userFilters.d9),
			aU: function () {
				var _v1 = userFilters.aU;
				if (!_v1.$) {
					return $author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$NotAsked);
				} else {
					var audience = _v1.a;
					return $author$project$Dashboards2$UserFilters$Base(
						_Utils_update(
							audience,
							{eQ: $krisajenkins$remotedata$RemoteData$NotAsked}));
				}
			}()
		});
};
var $author$project$Dashboards2$UserFilters$setLocations = F4(
	function (config, flags, _v0, _v1) {
		var allLocations = _v0.nn;
		var selectedLocations = _v0.l8;
		var userFilters = _v1;
		var newLocations = A2(
			$author$project$Dashboards2$UserFilters$initLocations,
			$elm$core$Maybe$Just(
				$turboMaCk$any_set$Set$Any$toList(selectedLocations)),
			allLocations);
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.oM(1),
			A3(
				$author$project$Dashboards2$UserFilters$fetchSampleSize,
				config,
				flags,
				$author$project$Dashboards2$UserFilters$setAudiencesAsNotAsked(
					_Utils_update(
						userFilters,
						{cD: newLocations}))));
	});
var $author$project$UndoRedo$addWithLimit = F3(
	function (maxHistoryLength, state, list) {
		if (!list.b) {
			return _List_fromArray(
				[state]);
		} else {
			var firstAdded = list.a;
			var rest = list.b;
			return (_Utils_cmp(
				$elm$core$List$length(list),
				maxHistoryLength) > -1) ? _Utils_ap(
				rest,
				_List_fromArray(
					[state])) : A2(
				$elm$core$List$cons,
				firstAdded,
				_Utils_ap(
					rest,
					_List_fromArray(
						[state])));
		}
	});
var $author$project$UndoRedo$moveCurrentToPrevious = function (data) {
	return _Utils_update(
		data,
		{
			a4: A3($author$project$UndoRedo$addWithLimit, data.gd, data.aq, data.a4)
		});
};
var $author$project$UndoRedo$commit = F3(
	function (tag, updateState, _v0) {
		var undoRedo = _v0;
		return function (d) {
			return _Utils_update(
				d,
				{
					aq: _Utils_Tuple2(
						$elm$core$Maybe$Just(tag),
						updateState(d.aq.b)),
					bj: _List_Nil
				});
		}(
			$author$project$UndoRedo$moveCurrentToPrevious(undoRedo));
	});
var $author$project$Dashboards2$Editable$Edited = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$Editable$set = $author$project$Dashboards2$Editable$Edited;
var $author$project$Dashboards2$undoRedoCommitIfNotEditMode = F2(
	function (newUserFilters, model) {
		return $author$project$Dashboards2$isEditMode(model.o) ? A2(
			$author$project$Dashboards2$setUserFilters,
			$author$project$Dashboards2$Editable$set(newUserFilters),
			model) : _Utils_update(
			model,
			{
				G: A3(
					$author$project$UndoRedo$commit,
					0,
					function (undoRedo) {
						return _Utils_update(
							undoRedo,
							{
								bz: $author$project$Dashboards2$Editable$set(newUserFilters)
							});
					},
					model.G)
			});
	});
var $author$project$Dashboards2$applyLocationsSelection = F6(
	function (config, flags, route, store, selectedLocationCodes, model) {
		var allAvailableLocations = function () {
			var getLocationsBasedOnPlan = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Data$Id$emptyDict,
				function (dashboard) {
					return A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						$author$project$Data$Id$emptyDict,
						A2($author$project$Store$Platform2$getLocationsByDashboardId, dashboard.b, store));
				}) : A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen(
					A2(
						$elm$core$Basics$composeR,
						$author$project$Dashboards2$Detail$UnsavedDashboard,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Dashboards2$Detail$getNamespaceCodes(store),
							$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList))),
				A2(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$author$project$Data$Id$emptyDict,
					function (ns) {
						return A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							$author$project$Data$Id$emptyDict,
							A2($author$project$Store$Platform2$getLocationsForNamespaces, ns, store));
					}));
			return getLocationsBasedOnPlan(
				A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$map,
				function (userFilters) {
					var _v0 = A4(
						$author$project$Dashboards2$UserFilters$setLocations,
						$author$project$Dashboards2$userFiltersConfig,
						flags,
						{nn: allAvailableLocations, l8: selectedLocationCodes},
						userFilters);
					var updatedUserFilters = _v0.a;
					var userFiltersCmds = _v0.b;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
						A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds),
						A2(
							$author$project$Dashboards2$undoRedoCommitIfNotEditMode,
							updatedUserFilters,
							_Utils_update(
								model,
								{aJ: $author$project$Platform2$Drawers$close})));
				},
				$author$project$Dashboards2$getUserFilters(model)));
	});
var $author$project$Dashboards2$UserFilters$setWaves = F4(
	function (config, flags, _v0, _v1) {
		var selectedWaves = _v0.l9;
		var allWaves = _v0.np;
		var userFilters = _v1;
		var newWaves = A2(
			$author$project$Dashboards2$UserFilters$initWaves,
			$elm$core$Maybe$Just(
				$turboMaCk$any_set$Set$Any$toList(selectedWaves)),
			allWaves);
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.oM(1),
			A3(
				$author$project$Dashboards2$UserFilters$fetchSampleSize,
				config,
				flags,
				$author$project$Dashboards2$UserFilters$setAudiencesAsNotAsked(
					_Utils_update(
						userFilters,
						{dX: newWaves}))));
	});
var $author$project$Dashboards2$applyWavesSelection = F6(
	function (config, flags, route, store, selectedWaveCodes, model) {
		var allAvailableWaves = function () {
			var getWavesBasedOnPlan = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$author$project$Data$Id$emptyDict,
				function (dashboard) {
					return A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						$author$project$Data$Id$emptyDict,
						A2($author$project$Store$Platform2$getWavesByDashboardId, dashboard.b, store));
				}) : A2(
				$elm$core$Basics$composeR,
				$elm$core$Maybe$andThen(
					A2(
						$elm$core$Basics$composeR,
						$author$project$Dashboards2$Detail$UnsavedDashboard,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Dashboards2$Detail$getNamespaceCodes(store),
							$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList))),
				A2(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$author$project$Data$Id$emptyDict,
					function (ns) {
						return A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							$author$project$Data$Id$emptyDict,
							A2($author$project$Store$Platform2$getWavesForNamespaces, ns, store));
					}));
			return getWavesBasedOnPlan(
				A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
		}();
		return A2(
			$elm$core$Maybe$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Maybe$map,
				function (userFilters) {
					var _v0 = A4(
						$author$project$Dashboards2$UserFilters$setWaves,
						$author$project$Dashboards2$userFiltersConfig,
						flags,
						{np: allAvailableWaves, l9: selectedWaveCodes},
						userFilters);
					var updatedUserFilters = _v0.a;
					var userFiltersCmds = _v0.b;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
						A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds),
						A2(
							$author$project$Dashboards2$undoRedoCommitIfNotEditMode,
							updatedUserFilters,
							_Utils_update(
								model,
								{aJ: $author$project$Platform2$Drawers$close})));
				},
				$author$project$Dashboards2$getUserFilters(model)));
	});
var $author$project$Dashboards2$Permissions$canEditContentAndShare = F4(
	function (user, can, sharing, dashboardOwnerId) {
		switch (sharing.$) {
			case 3:
				return can(23);
			case 1:
				return can(23);
			case 2:
				return can(24) && _Utils_eq(user.b, dashboardOwnerId);
			case 0:
				return $author$project$Permissions$isDashboardsCreator(can);
			case 4:
				return can(23) || _Utils_eq(user.b, dashboardOwnerId);
			case 5:
				return false;
			case 6:
				return can(23) || _Utils_eq(user.b, dashboardOwnerId);
			case 7:
				return can(24) && _Utils_eq(user.b, dashboardOwnerId);
			default:
				return can(23);
		}
	});
var $author$project$Dashboards2$Permissions$canRenameOrDelete = F4(
	function (user, can, sharing, dashboardOwnerId) {
		switch (sharing.$) {
			case 3:
				return can(23);
			case 1:
				return can(23);
			case 2:
				return can(24) && _Utils_eq(user.b, dashboardOwnerId);
			case 0:
				return true;
			case 4:
				return can(23) || _Utils_eq(user.b, dashboardOwnerId);
			case 5:
				return false;
			case 6:
				return can(23) || _Utils_eq(user.b, dashboardOwnerId);
			case 7:
				return can(24) && _Utils_eq(user.b, dashboardOwnerId);
			default:
				return can(24);
		}
	});
var $author$project$Dashboards2$ClearFiltersAndNavigateTo = function (a) {
	return {$: 59, a: a};
};
var $author$project$Dashboards2$Modal$Hidden = {$: 0};
var $author$project$Dashboards2$clearFiltersConfirmDialog = F2(
	function (route, model) {
		return _Utils_update(
			model,
			{
				c: $author$project$Dashboards2$Modal$ConfirmModal(
					{
						aH: _List_fromArray(
							[
								{cd: $author$project$Dashboards2$CloseModal, cy: false, Y: 'Cancel'},
								{
								cd: $author$project$Dashboards2$ClearFiltersAndNavigateTo(route),
								cy: true,
								Y: 'Clear and continue'
							}
							]),
						ft: $elm$core$Maybe$Nothing,
						U: A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('You have selected a dashboard with a different set of Waves available.')
										])),
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Please click continue to reset your filters or cancel to return to your current dashboard.')
										]))
								])),
						bF: $author$project$Dashboards2$Modal$Hidden,
						Y: 'Incompatible filters'
					})
			});
	});
var $turboMaCk$queue$Queue$filter = F2(
	function (fc, _v0) {
		var fl = _v0.a;
		var rl = _v0.b;
		var f = $elm$core$List$filter(fc);
		return A2(
			$turboMaCk$queue$Queue$queue,
			f(fl),
			f(rl));
	});
var $author$project$Platform2$Notification$Queue$filter = F2(
	function (fn, _v0) {
		var queue = _v0;
		var notifications = queue.bn;
		return _Utils_update(
			queue,
			{
				bn: A2($turboMaCk$queue$Queue$filter, fn, notifications)
			});
	});
var $author$project$Platform2$Notification$isPersistent = function (_v0) {
	var shouldPersist = _v0.dL;
	return shouldPersist;
};
var $author$project$Platform2$Notification$Queue$clearNonpersistent = $author$project$Platform2$Notification$Queue$filter(
	A2(
		$elm$core$Basics$composeR,
		function ($) {
			return $.cI;
		},
		$author$project$Platform2$Notification$isPersistent));
var $author$project$Dashboards2$clearUndoRedoHistory = function (model) {
	return _Utils_update(
		model,
		{
			G: A2(
				$author$project$UndoRedo$init,
				$author$project$Dashboards2$maxHistoryLimit,
				$author$project$UndoRedo$current(model.G))
		});
};
var $author$project$Dashboards2$closeDropdown = function (model) {
	return _Utils_update(
		model,
		{db: $elm$core$Maybe$Nothing, bP: $elm$core$Maybe$Nothing});
};
var $elm$core$Dict$map = F2(
	function (func, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				A2(func, key, value),
				A2($elm$core$Dict$map, func, left),
				A2($elm$core$Dict$map, func, right));
		}
	});
var $turboMaCk$any_dict$Dict$Any$map = F2(
	function (f, _v0) {
		var dict = _v0.i;
		var toKey = _v0.aT;
		return {
			i: A2(
				$elm$core$Dict$map,
				F2(
					function (_v1, _v2) {
						var k = _v2.a;
						var v = _v2.b;
						return _Utils_Tuple2(
							k,
							A2(f, k, v));
					}),
				dict),
			aT: toKey
		};
	});
var $author$project$Dashboards2$Widget$closeWidgetsDropdown = $turboMaCk$any_dict$Dict$Any$map(
	F2(
		function (_v0, model) {
			return _Utils_update(
				model,
				{w: $author$project$Dashboards2$Widget$NoDropdown});
		}));
var $author$project$Gwi$Http$cmdMap = function (f) {
	return $elm$core$Platform$Cmd$map(
		$elm$core$Result$map(f));
};
var $author$project$Dashboards2$Widget$containerElementId = function (widget) {
	return 'dashboards2-grid-item-widget-id-' + $author$project$Data$Id$unwrap(widget.b);
};
var $author$project$Clipboard$addHostAndCopyToClipboard = _Platform_outgoingPort('addHostAndCopyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Icons$Platform2$duplicate = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M23.996 9.337A1.44 1.44 0 0 0 22.57 8h-8.502l-.112.004c-.738.058-1.318.683-1.318 1.446v4.036H9.43A1.44 1.44 0 0 0 8 14.936v7.614A1.44 1.44 0 0 0 9.43 24h7.729a1.44 1.44 0 0 0 1.43-1.45v-3.029h3.981l.112-.004c.737-.058 1.318-.683 1.318-1.446V9.45zm-6.72 9.528v-3.929c0-.065-.052-.118-.116-.118H9.43c-.064 0-.116.052-.116.118v7.614c0 .065.052.118.116.118h7.73c.064 0 .116-.053.116-.118zm1.314-.677h3.981c.051 0 .095-.034.11-.08l.006-.037V9.45c0-.052-.033-.096-.079-.112l-.037-.006h-8.503c-.051 0-.095.034-.11.08l-.006.037v4.036h3.208a1.44 1.44 0 0 1 1.43 1.45v3.252zm-4.643-1.768a.66.66 0 0 0-.652-.583.66.66 0 0 0-.657.666v1.685h-1.662l-.082.005c-.324.041-.575.321-.575.661a.66.66 0 0 0 .657.666h1.662v1.685l.005.084a.66.66 0 0 0 .652.583.66.66 0 0 0 .657-.666v-1.685h1.662l.082-.005c.324-.041.575-.321.575-.661a.66.66 0 0 0-.657-.666h-1.662v-1.685z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$copyDashboardLink = F4(
	function (config, flags, dashboardId, model) {
		var prefix = $author$project$Config$combinePrefixAndFeature(flags);
		var url = A3(
			$author$project$Dashboards2$Router$toUrlString,
			prefix,
			$author$project$Dashboards2$Router$Dashboard(dashboardId),
			_List_Nil);
		var notificationMsg = config.a(
			A2(
				$author$project$Dashboards2$CreateNotification,
				$author$project$Icons$Platform2$duplicate,
				$elm$html$Html$text('Copied to clipboard')));
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			notificationMsg,
			A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
				$author$project$Clipboard$addHostAndCopyToClipboard(url),
				model));
	});
var $author$project$Clipboard$copyToClipboard = _Platform_outgoingPort('copyToClipboard', $elm$json$Json$Encode$string);
var $author$project$Dashboards2$copyOadLink = F4(
	function (config, flags, dashboardId, model) {
		var prefix = $author$project$Config$combinePrefixAndFeature(flags);
		var notificationMsg = config.a(
			A2(
				$author$project$Dashboards2$CreateNotification,
				$author$project$Icons$Platform2$duplicate,
				$elm$html$Html$text('Open access link copied to clipboard')));
		var host = function () {
			var _v0 = flags.j8;
			switch (_v0) {
				case 2:
					return 'https://dashboards-testing.gwi.com';
				case 3:
					return 'https://dashboards-staging.gwi.com';
				default:
					return 'https://dashboards.gwi.com';
			}
		}();
		var url = A3(
			$author$project$Dashboards2$Router$toUrlString,
			prefix,
			$author$project$Dashboards2$Router$ExternalUrl(
				A3(
					$elm$url$Url$Builder$crossOrigin,
					host,
					_List_fromArray(
						[
							'dashboards',
							$author$project$Data$Id$unwrap(dashboardId)
						]),
					_List_Nil)),
			_List_Nil);
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			notificationMsg,
			A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
				$author$project$Clipboard$copyToClipboard(url),
				model));
	});
var $author$project$Platform2$Notification$Visible = 0;
var $author$project$Platform2$Notification$create = F3(
	function (button, content, iconData) {
		return {df: button, cg: $elm$core$Maybe$Nothing, U: content, dq: iconData, dL: false, rA: 0};
	});
var $author$project$Dashboards2$dashboardsList = $turboMaCk$glue$Glue$poly(
	{
		oS: function ($) {
			return $.cC;
		},
		rg: F2(
			function (newSubModel, model) {
				return _Utils_update(
					model,
					{cC: newSubModel});
			})
	});
var $erlandsona$assoc_set$AssocSet$Set = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$D = $elm$core$Basics$identity;
var $pzp1997$assoc_list$AssocList$empty = _List_Nil;
var $erlandsona$assoc_set$AssocSet$empty = $pzp1997$assoc_list$AssocList$empty;
var $pzp1997$assoc_list$AssocList$get = F2(
	function (targetKey, _v0) {
		get:
		while (true) {
			var alist = _v0;
			if (!alist.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var _v2 = alist.a;
				var key = _v2.a;
				var value = _v2.b;
				var rest = alist.b;
				if (_Utils_eq(key, targetKey)) {
					return $elm$core$Maybe$Just(value);
				} else {
					var $temp$targetKey = targetKey,
						$temp$_v0 = rest;
					targetKey = $temp$targetKey;
					_v0 = $temp$_v0;
					continue get;
				}
			}
		}
	});
var $Janiczek$elm_bidict$BiDict$Assoc$getReverse = F2(
	function (to, _v0) {
		var d = _v0;
		return A2(
			$elm$core$Maybe$withDefault,
			$erlandsona$assoc_set$AssocSet$empty,
			A2($pzp1997$assoc_list$AssocList$get, to, d.aQ));
	});
var $turboMaCk$any_dict$Dict$Any$isEmpty = function (_v0) {
	var dict = _v0.i;
	return $elm$core$Dict$isEmpty(dict);
};
var $turboMaCk$any_set$Set$Any$isEmpty = function (_v0) {
	var dict = _v0;
	return $turboMaCk$any_dict$Dict$Any$isEmpty(dict);
};
var $pzp1997$assoc_list$AssocList$keys = function (_v0) {
	var alist = _v0;
	return A2($elm$core$List$map, $elm$core$Tuple$first, alist);
};
var $erlandsona$assoc_set$AssocSet$toList = function (_v0) {
	var dict = _v0;
	return $pzp1997$assoc_list$AssocList$keys(dict);
};
var $author$project$Data$Platform2$datasetsForNamespace = F3(
	function (datasetsToNamespaces, lineages, namespaceCode) {
		var simple = function (nsCode) {
			return $author$project$Data$Id$setFromList(
				$erlandsona$assoc_set$AssocSet$toList(
					A2($Janiczek$elm_bidict$BiDict$Assoc$getReverse, nsCode, datasetsToNamespaces)));
		};
		var recursive = F2(
			function (ancestors_, nsCode) {
				recursive:
				while (true) {
					var simple_ = simple(nsCode);
					if ($turboMaCk$any_set$Set$Any$isEmpty(simple_)) {
						if (ancestors_.b) {
							var closestAncestor = ancestors_.a;
							var restOfAncestors = ancestors_.b;
							var $temp$ancestors_ = restOfAncestors,
								$temp$nsCode = closestAncestor;
							ancestors_ = $temp$ancestors_;
							nsCode = $temp$nsCode;
							continue recursive;
						} else {
							return $krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptySet);
						}
					} else {
						return $krisajenkins$remotedata$RemoteData$Success(simple_);
					}
				}
			});
		var ancestors = A2(
			$krisajenkins$remotedata$RemoteData$map,
			function ($) {
				return $.g7;
			},
			A2(
				$elm$core$Maybe$withDefault,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A2($turboMaCk$any_dict$Dict$Any$get, namespaceCode, lineages)));
		return A2(
			$krisajenkins$remotedata$RemoteData$andThen,
			function (ancestors_) {
				return A2(recursive, ancestors_, namespaceCode);
			},
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				$elm$core$List$cons(namespaceCode),
				ancestors));
	});
var $Janiczek$elm_bidict$BiDict$Assoc$BiDict = $elm$core$Basics$identity;
var $Janiczek$elm_bidict$BiDict$Assoc$empty = {r: $pzp1997$assoc_list$AssocList$empty, aQ: $pzp1997$assoc_list$AssocList$empty};
var $author$project$Gwi$List$remoteDataValues = function (list) {
	return A2(
		$elm$core$List$filterMap,
		function (remoteData) {
			if (remoteData.$ === 3) {
				var val = remoteData.a;
				return $elm$core$Maybe$Just(val);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		},
		list);
};
var $author$project$Dashboards2$datasetsFromDashboard = F4(
	function (flags, route, store, model) {
		var maybeDashboard_ = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
		var datasetsToNamespaces_ = A2($krisajenkins$remotedata$RemoteData$withDefault, $Janiczek$elm_bidict$BiDict$Assoc$empty, store.fC);
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$orElse,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.es;
					},
					maybeDashboard_),
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								A2($author$project$Data$Platform2$datasetsForNamespace, datasetsToNamespaces_, store.cB)),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Gwi$List$remoteDataValues,
								A2(
									$elm$core$Basics$composeR,
									A2($elm$core$List$foldl, $turboMaCk$any_set$Set$Any$union, $author$project$Data$Id$emptySet),
									A2($elm$core$Basics$composeR, $turboMaCk$any_set$Set$Any$toList, $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList)))),
						A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Data$Platform2$dashboardNamespaceCodes(store.es),
								$turboMaCk$any_set$Set$Any$toList),
							maybeDashboard_)))));
	});
var $turboMaCk$queue$Queue$dequeue = function (_v0) {
	var fl = _v0.a;
	var rl = _v0.b;
	if (!fl.b) {
		return _Utils_Tuple2(
			$elm$core$Maybe$Nothing,
			A2($turboMaCk$queue$Queue$Queue, _List_Nil, _List_Nil));
	} else {
		var head = fl.a;
		var tail = fl.b;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(head),
			A2($turboMaCk$queue$Queue$queue, tail, rl));
	}
};
var $author$project$Dashboards2$descriptionLimit = 120;
var $author$project$Platform2$NameForCopy$copyNumberRegex = function () {
	var regexString = '(.*)' + ('\\s' + ('\\(' + ('(' + ('\\d+' + (')' + ('\\)' + ('\\s{0,}' + '$')))))));
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$regex$Regex$never,
		$elm$regex$Regex$fromString(regexString));
}();
var $author$project$Platform2$NameForCopy$parseNameWithCounter = function (string) {
	var _v0 = A2(
		$elm$core$Maybe$withDefault,
		_List_Nil,
		A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.mo;
			},
			$elm$core$List$head(
				A2($elm$regex$Regex$find, $author$project$Platform2$NameForCopy$copyNumberRegex, string))));
	if ((((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) && (!_v0.b.b.b)) {
		var originalName = _v0.a.a;
		var _v1 = _v0.b;
		var copyNumber = _v1.a.a;
		return A2(
			$elm$core$Maybe$map,
			function (number) {
				return {fv: number, gr: originalName};
			},
			$elm$core$String$toInt(copyNumber));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Platform2$NameForCopy$getNameWithSuffix = F3(
	function (maxLength, allCurrentNames, currentName) {
		var minimalSuffixLength = 4;
		var analysedName = $author$project$Platform2$NameForCopy$parseNameWithCounter(currentName);
		var initialCopyNumber = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			1,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fv;
				},
				$elm$core$Basics$add(1)),
			analysedName);
		var originalName = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			currentName,
			function ($) {
				return $.gr;
			},
			analysedName);
		var checkShortenedVersion = function (name) {
			if (_Utils_cmp(
				$elm$core$String$length(currentName) + minimalSuffixLength,
				maxLength) > 0) {
				var regex = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString('^(' + (name + ')')));
				return $elm_community$maybe_extra$Maybe$Extra$isJust(
					$elm$core$List$head(
						A2($elm$regex$Regex$find, regex, originalName)));
			} else {
				return false;
			}
		};
		var copyNumberString = $elm$core$String$fromInt(
			A3(
				$elm$core$List$foldr,
				F2(
					function (name, numberSoFar) {
						var _v0 = $author$project$Platform2$NameForCopy$parseNameWithCounter(name);
						if (!_v0.$) {
							var result = _v0.a;
							return ((_Utils_eq(result.gr, originalName) || checkShortenedVersion(result.gr)) && (_Utils_cmp(result.fv, numberSoFar) > -1)) ? (result.fv + 1) : numberSoFar;
						} else {
							return numberSoFar;
						}
					}),
				initialCopyNumber,
				allCurrentNames));
		return _Utils_Tuple2(originalName, ' (' + (copyNumberString + ')'));
	});
var $author$project$Platform2$NameForCopy$getWithLimit = F3(
	function (allCurrentNames, maxLength, originalName) {
		var _v0 = A3($author$project$Platform2$NameForCopy$getNameWithSuffix, maxLength, allCurrentNames, originalName);
		var name = _v0.a;
		var suffix = _v0.b;
		var nameLength = $elm$core$String$length(
			_Utils_ap(name, suffix));
		return (_Utils_cmp(nameLength, maxLength) > 0) ? (A3($elm$core$String$slice, 0, (maxLength - nameLength) - 3, name) + ('...' + suffix)) : _Utils_ap(name, suffix);
	});
var $author$project$Dashboards2$maxUserDefinedNameLength = 64;
var $krisajenkins$remotedata$RemoteData$unwrap = F3(
	function (_default, _function, remoteData) {
		if (remoteData.$ === 3) {
			var data = remoteData.a;
			return _function(data);
		} else {
			return _default;
		}
	});
var $author$project$Dashboards2$duplicateDashboard = F4(
	function (flags, route, store, model) {
		var allDashboardNames = A2(
			$elm$core$List$map,
			function ($) {
				return $.ld;
			},
			A3($krisajenkins$remotedata$RemoteData$unwrap, _List_Nil, $turboMaCk$any_dict$Dict$Any$values, store.v));
		var _v0 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
		if (!_v0.$) {
			var savedDashboard = _v0.a;
			var editedDashboard = A3(
				$author$project$Dashboards2$Detail$applyEdits,
				model.ba,
				$author$project$Dashboards2$getUserFilters(model),
				savedDashboard);
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
				$author$project$Dashboards2$closeDropdown(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$DuplicateDashboardModal(
								{
									ht: $author$project$Data$Platform2$fromFullyLoadedDashboard(editedDashboard),
									fK: false,
									ld: A3($author$project$Platform2$NameForCopy$getWithLimit, allDashboardNames, $author$project$Dashboards2$maxUserDefinedNameLength, editedDashboard.ld),
									iC: $elm$core$Maybe$Nothing
								})
						})));
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Data$Platform2$duplicateWidget = F3(
	function (_v0, dashboardId, position) {
		var content = _v0.U;
		var width = _v0.da;
		var height = _v0.cv;
		return {U: content, bf: dashboardId, cv: height, b: $author$project$Data$Platform2$nullId, lB: position, da: width};
	});
var $author$project$Platform2$Notification$Queue$Generic = function (a) {
	return {$: 0, a: a};
};
var $author$project$Platform2$Notification$Queue$StartHiding = function (a) {
	return {$: 0, a: a};
};
var $author$project$Platform2$Notification$Queue$incrementId = function (_v0) {
	var queue = _v0;
	return _Utils_update(
		queue,
		{gj: queue.gj + 1});
};
var $turboMaCk$queue$Queue$map = F2(
	function (fc, _v0) {
		var fl = _v0.a;
		var rl = _v0.b;
		var map_ = $elm$core$List$map(fc);
		return A2(
			$turboMaCk$queue$Queue$queue,
			map_(fl),
			map_(rl));
	});
var $author$project$Platform2$Notification$Queue$mapQueue = F2(
	function (fn, _v0) {
		var queue = _v0;
		var notifications = queue.bn;
		return _Utils_update(
			queue,
			{
				bn: fn(notifications)
			});
	});
var $author$project$Platform2$Notification$Queue$performAfterDelay = F2(
	function (delay, msg) {
		return A2(
			$elm$core$Task$perform,
			function (_v0) {
				return msg;
			},
			$elm$core$Process$sleep(delay));
	});
var $turboMaCk$queue$Queue$size = function (_v0) {
	var fl = _v0.a;
	var rl = _v0.b;
	return $elm$core$List$length(fl) + $elm$core$List$length(rl);
};
var $turboMaCk$queue$Queue$toList = function (_v0) {
	var fl = _v0.a;
	var rl = _v0.b;
	return _Utils_ap(
		fl,
		$elm$core$List$reverse(rl));
};
var $author$project$Platform2$Notification$Queue$toList = function (_v0) {
	var notifications = _v0.bn;
	return $turboMaCk$queue$Queue$toList(notifications);
};
var $author$project$Platform2$Notification$Queue$visibleTimeout = 5000;
var $author$project$Platform2$Notification$Queue$enqueueWithId_ = F3(
	function (id, notification, queue) {
		var notificationWithId = {b: id, cI: notification};
		var updateNotification = $turboMaCk$queue$Queue$map(
			function (notification_) {
				return _Utils_eq(notification_.b, id) ? notificationWithId : notification_;
			});
		var dequeueIfOverLimit = function (queue_) {
			var data = queue_;
			var _v0 = data.lL;
			if (!_v0.$) {
				return queue_;
			} else {
				var capSize = _v0.a;
				return (_Utils_cmp(
					$turboMaCk$queue$Queue$size(data.bn),
					capSize) > 0) ? A2(
					$author$project$Platform2$Notification$Queue$mapQueue,
					A2($elm$core$Basics$composeR, $turboMaCk$queue$Queue$dequeue, $elm$core$Tuple$second),
					queue_) : queue_;
			}
		};
		var upsertQueue = dequeueIfOverLimit(
			function (notifications) {
				return A2($elm$core$List$member, id, notifications) ? A2(
					$author$project$Platform2$Notification$Queue$mapQueue,
					updateNotification,
					$author$project$Platform2$Notification$Queue$incrementId(queue)) : A2(
					$author$project$Platform2$Notification$Queue$mapQueue,
					$turboMaCk$queue$Queue$enqueue(notificationWithId),
					$author$project$Platform2$Notification$Queue$incrementId(queue));
			}(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.b;
					},
					$author$project$Platform2$Notification$Queue$toList(queue))));
		var cmd = notification.dL ? $elm$core$Platform$Cmd$none : A2(
			$author$project$Platform2$Notification$Queue$performAfterDelay,
			$author$project$Platform2$Notification$Queue$visibleTimeout,
			$author$project$Platform2$Notification$Queue$StartHiding(notificationWithId.b));
		return _Utils_Tuple2(upsertQueue, cmd);
	});
var $author$project$Platform2$Notification$Queue$getNextId = function (_v0) {
	var nextId = _v0.gj;
	return nextId;
};
var $author$project$Platform2$Notification$Queue$enqueue = F2(
	function (notification, queue) {
		var id = $author$project$Platform2$Notification$Queue$getNextId(queue);
		return A3(
			$author$project$Platform2$Notification$Queue$enqueueWithId_,
			$author$project$Platform2$Notification$Queue$Generic(id),
			notification,
			queue);
	});
var $author$project$Dashboards2$ExportAjaxError = function (a) {
	return {$: 2, a: a};
};
var $author$project$Icons$Platform2$pathFill = F2(
	function (fill, d) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(d),
					$elm$svg$Svg$Attributes$fill(fill)
				]),
			_List_Nil);
	});
var $author$project$Icons$Platform2$export = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(8 8)')
			]),
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M8.62331 0.529134C8.57436 0.229042 8.31393 0 8 0C7.65119 0 7.36842 0.282768 7.36842 0.631579V12.0936L7.37669 12.196C7.42563 12.4961 7.68607 12.7251 8 12.7251C8.34881 12.7251 8.63158 12.4424 8.63158 12.0936V0.631579L8.62331 0.529134Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M5.35673 6.36257C5.35673 6.01376 5.07396 5.73099 4.72515 5.73099H2.26901L2.10702 5.73669C0.929879 5.81982 0 6.80179 0 8V13.731L0.00569961 13.893C0.0888237 15.0701 1.0708 16 2.26901 16H13.731L13.8931 15.9943C15.0707 15.9112 16 14.9294 16 13.731V8L15.9943 7.83798C15.9112 6.66066 14.9298 5.73099 13.731 5.73099H11.2749L11.1724 5.73926C10.8723 5.78821 10.6433 6.04864 10.6433 6.36257C10.6433 6.71138 10.926 6.99415 11.2749 6.99415H13.731L13.8483 7.00092C14.3486 7.05904 14.7368 7.48429 14.7368 8V13.731L14.7301 13.8483C14.672 14.3484 14.2468 14.7368 13.731 14.7368H2.26901L2.15179 14.7301C1.65186 14.6719 1.26316 14.2464 1.26316 13.731V8L1.26993 7.88278C1.32809 7.38285 1.7536 6.99415 2.26901 6.99415H4.72515L4.82759 6.98588C5.12768 6.93694 5.35673 6.6765 5.35673 6.36257Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M5.0977 9.19084C5.31695 8.97159 5.65727 8.94724 5.90342 9.11776L5.99089 9.19084L8.00019 11.2L10.01 9.19084C10.2292 8.97159 10.5696 8.94724 10.8157 9.11776L10.9032 9.19084C11.1224 9.41008 11.1468 9.7504 10.9763 9.99655L10.9032 10.084L8.44703 12.5402C8.22779 12.7594 7.88747 12.7838 7.64132 12.6132L7.55385 12.5402L5.0977 10.084C4.85106 9.83738 4.85106 9.43748 5.0977 9.19084Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Export$DirectDownload = function (a) {
	return {$: 1, a: a};
};
var $author$project$Export$Mail = function (a) {
	return {$: 0, a: a};
};
var $author$project$Data$Platform2$Export$decodeExportsResponse = function (flags) {
	return flags.nM(8) ? A2(
		$elm$json$Json$Decode$map,
		function (message) {
			return $author$project$Export$Mail(
				{pP: message});
		},
		A2($elm$json$Json$Decode$field, 'message', $elm$json$Json$Decode$string)) : A2(
		$elm$json$Json$Decode$map,
		function (downloadUrl) {
			return $author$project$Export$DirectDownload(
				{on: downloadUrl});
		},
		A2($elm$json$Json$Decode$field, 'download_url', $elm$json$Json$Decode$string));
};
var $author$project$Data$Platform2$Export$defaultAudience = $elm$json$Json$Encode$object(
	_List_fromArray(
		[
			_Utils_Tuple2(
			'id',
			$elm$json$Json$Encode$string('')),
			_Utils_Tuple2(
			'name',
			$elm$json$Json$Encode$string($author$project$Data$Platform2$defaultAudienceName)),
			_Utils_Tuple2(
			'color',
			$elm$json$Json$Encode$string('#ced9eb'))
		]));
var $author$project$Data$Platform2$Export$encodeColoredAudience = function (_v0) {
	var audience = _v0.fk;
	var color = _v0.jL;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Data$Id$encode(audience.b)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(audience.ld)),
				_Utils_Tuple2(
				'color',
				$elm$json$Json$Encode$string(color))
			]));
};
var $author$project$Data$Labels$getShortQuestionCode = function (code) {
	var _v0 = A2(
		$elm$core$String$split,
		'.',
		$author$project$Data$Id$unwrap(code));
	if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
		var _v1 = _v0.b;
		var c = _v1.a;
		return $author$project$Data$Id$fromString(c);
	} else {
		return $author$project$Data$Id$fromString(
			$author$project$Data$Id$unwrap(code));
	}
};
var $author$project$Data$Platform2$Export$encodeExportMetadata = function (metadata) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(metadata.ld)),
				_Utils_Tuple2(
				'file_name',
				$elm$json$Json$Encode$string(metadata.oJ)),
				_Utils_Tuple2(
				'export_time',
				$elm$json$Json$Encode$string(metadata.hL)),
				_Utils_Tuple2(
				'attribute_data',
				A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList,
					function (attr) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'label',
									$elm$json$Json$Encode$string(attr.h4)),
									_Utils_Tuple2(
									'question_code',
									$author$project$Data$Id$encode(
										$author$project$Data$Labels$getShortQuestionCode(attr.at))),
									_Utils_Tuple2(
									'namespace',
									$author$project$Data$Id$encode(
										$author$project$Data$Labels$parseNamespaceCode(attr.at))),
									_Utils_Tuple2(
									'datapoint_code',
									$author$project$Data$Id$encode(attr.eq))
								]));
					},
					metadata.d7)),
				_Utils_Tuple2(
				'question_data',
				A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList,
					function (q) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'namespace',
									$author$project$Data$Id$encode(q.id)),
									_Utils_Tuple2(
									'code',
									$author$project$Data$Id$encode(q.bW)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(q.ld)),
									_Utils_Tuple2(
									'description',
									$elm$json$Json$Encode$string(q.oR))
								]));
					},
					metadata.bt)),
				_Utils_Tuple2(
				'base_audience',
				A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $author$project$Data$Platform2$Export$defaultAudience, $author$project$Data$Platform2$Export$encodeColoredAudience, metadata.aU)),
				_Utils_Tuple2(
				'audience_data',
				A2($elm$json$Json$Encode$list, $author$project$Data$Platform2$Export$encodeColoredAudience, metadata.d9)),
				_Utils_Tuple2(
				'segment_data',
				A2(
					$elm$json$Json$Encode$list,
					function (segment) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'code',
									$author$project$Data$Id$encode(segment.b)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(segment.ld))
								]));
					},
					metadata.l5)),
				_Utils_Tuple2(
				'wave_names',
				A2(
					$elm$json$Json$Encode$list,
					A2(
						$elm$core$Basics$composeL,
						$elm$json$Json$Encode$string,
						function ($) {
							return $.ld;
						}),
					metadata.dX)),
				_Utils_Tuple2(
				'location_names',
				A2(
					$elm$json$Json$Encode$list,
					A2(
						$elm$core$Basics$composeL,
						$elm$json$Json$Encode$string,
						function ($) {
							return $.ld;
						}),
					metadata.hp))
			]));
};
var $author$project$Data$Core$DatapointsSort$encodeForExport = function (sort) {
	switch (sort) {
		case 3:
			return $elm$json$Json$Encode$null;
		case 1:
			return $elm$json$Json$Encode$string('asc');
		case 0:
			return $elm$json$Json$Encode$string('desc');
		default:
			return $elm$json$Json$Encode$string('alphabetical');
	}
};
var $author$project$Data$Platform2$Export$encodeExportSettings = function (settings) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'email',
				$elm$json$Json$Encode$bool(settings.j)),
				_Utils_Tuple2(
				'order_type',
				$author$project$Data$Core$DatapointsSort$encodeForExport(settings.ls)),
				_Utils_Tuple2(
				'active_metrics',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, settings.g5)),
				_Utils_Tuple2(
				'metric',
				$elm$json$Json$Encode$string(settings.h9)),
				_Utils_Tuple2(
				'scale_maxes',
				$elm$json$Json$Encode$int(
					$elm$core$Basics$round(settings.iE)))
			]));
};
var $author$project$Data$Metrics$encode = function (metrics) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'positive_sample',
				$elm$json$Json$Encode$int(metrics.qW)),
				_Utils_Tuple2(
				'positive_size',
				$elm$json$Json$Encode$int(metrics.sg)),
				_Utils_Tuple2(
				'audience_percentage',
				$elm$json$Json$Encode$float(metrics.ny)),
				_Utils_Tuple2(
				'datapoint_percentage',
				$elm$json$Json$Encode$float(metrics.oe)),
				_Utils_Tuple2(
				'audience_index',
				$elm$json$Json$Encode$float(metrics.pi))
			]));
};
var $author$project$Data$Platform2$Export$encodeQResult = function (result) {
	var questionCode = function () {
		switch (result.$) {
			case 0:
				var d = result.a;
				return d.at;
			case 1:
				var d = result.a;
				return d.at;
			case 2:
				var d = result.a;
				return d.at;
			default:
				var d = result.a;
				return d.at;
		}
	}();
	var encodeItem = F2(
		function (extra, item) {
			return $elm$json$Json$Encode$object(
				_Utils_ap(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'datapoint',
							$author$project$Data$Id$encode(item.eq)),
							_Utils_Tuple2(
							'metrics',
							$author$project$Data$Metrics$encode(item.dC)),
							_Utils_Tuple2(
							'suffixes',
							A2($elm$json$Json$Encode$list, $author$project$Data$Id$unsafeEncodeAsInt, item.eY))
						]),
					extra));
		});
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'meta',
				$elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'question',
							$author$project$Data$Id$encode(questionCode))
						]))),
				_Utils_Tuple2(
				'data',
				function () {
					switch (result.$) {
						case 0:
							var list = result.b;
							return A2(
								$elm$json$Json$Encode$list,
								encodeItem(_List_Nil),
								list);
						case 1:
							var list = result.b;
							return A2(
								$elm$json$Json$Encode$list,
								function (item) {
									return A2(
										encodeItem,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'audience',
												$author$project$Data$Id$encode(item.jn))
											]),
										item);
								},
								list);
						case 2:
							var list = result.b;
							return A2(
								$elm$json$Json$Encode$list,
								function (item) {
									return A2(
										encodeItem,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'segment',
												$author$project$Data$Id$encode(item.l3))
											]),
										item);
								},
								list);
						default:
							var list = result.b;
							return A2(
								$elm$json$Json$Encode$list,
								function (item) {
									return A2(
										encodeItem,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'audience',
												$author$project$Data$Id$encode(item.jn)),
												_Utils_Tuple2(
												'segment',
												$author$project$Data$Id$encode(item.l3))
											]),
										item);
								},
								list);
					}
				}())
			]));
};
var $author$project$Data$Platform2$Export$encodeQResults = function (results) {
	if (!results.$) {
		var qResults = results.a;
		return A2($turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList, $author$project$Data$Platform2$Export$encodeQResult, qResults);
	} else {
		return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, _List_Nil);
	}
};
var $author$project$Data$Platform2$Export$encodeExportItem = function (exportItem) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'queries',
				A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$encodeList,
					A2($elm$core$Basics$composeL, $elm$json$Json$Encode$object, $author$project$Data$Calc$Platform2$params),
					exportItem.lw)),
				_Utils_Tuple2(
				'settings',
				$author$project$Data$Platform2$Export$encodeExportSettings(exportItem.mc)),
				_Utils_Tuple2(
				'metadata',
				$author$project$Data$Platform2$Export$encodeExportMetadata(exportItem.gf)),
				_Utils_Tuple2(
				'query_results',
				$author$project$Data$Platform2$Export$encodeQResults(exportItem.lJ))
			]));
};
var $author$project$Data$Platform2$Export$encodeMultiple = function (exportItems) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'widgets',
				A2($elm$json$Json$Encode$list, $author$project$Data$Platform2$Export$encodeExportItem, exportItems))
			]));
};
var $author$project$Export$AuthTokenParseError = {$: 0};
var $author$project$Export$CurrentUserQueryError = {$: 3};
var $author$project$Export$EmailSendError = {$: 4};
var $author$project$Export$ProcessingError = {$: 2};
var $author$project$Export$QueryingDataError = {$: 1};
var $author$project$Export$ResultsMissing = {$: 5};
var $author$project$Export$exportErrorDecoder = A2(
	$elm$json$Json$Decode$andThen,
	function (errorType) {
		switch (errorType) {
			case 'auth_token_parse_error':
				return $elm$json$Json$Decode$succeed($author$project$Export$AuthTokenParseError);
			case 'quering_data_error':
				return $elm$json$Json$Decode$succeed($author$project$Export$QueryingDataError);
			case 'processing_error':
				return $elm$json$Json$Decode$succeed($author$project$Export$ProcessingError);
			case 'current_user_query_error':
				return $elm$json$Json$Decode$succeed($author$project$Export$CurrentUserQueryError);
			case 'email_send_error':
				return $elm$json$Json$Decode$succeed($author$project$Export$EmailSendError);
			case 'results_missing_error':
				return $elm$json$Json$Decode$succeed($author$project$Export$ResultsMissing);
			default:
				return $elm$json$Json$Decode$fail('Failed to determine ExportError from error_type: ' + errorType);
		}
	},
	$author$project$Data$Core$Error$typeDecoder);
var $author$project$Data$Platform2$Export$host = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.j8;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Config$Main$get,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dV;
			},
			function ($) {
				return $.d5;
			})));
var $author$project$Data$Platform2$Export$namespace = '/v3/exports';
var $author$project$Data$Platform2$Export$exportDashboard = F4(
	function (flags, exportResponse, ajaxError, exportItems) {
		return A2(
			$elm$core$Platform$Cmd$map,
			A2($elm_community$result_extra$Result$Extra$unpack, ajaxError, exportResponse),
			$elm$http$Http$request(
				{
					jv: $elm$http$Http$jsonBody(
						$author$project$Data$Platform2$Export$encodeMultiple(exportItems)),
					hK: A2(
						$author$project$Gwi$Http$expectErrorAwareJson,
						$author$project$Export$exportErrorDecoder,
						$author$project$Data$Platform2$Export$decodeExportsResponse(flags)),
					hU: _List_fromArray(
						[
							$author$project$Data$Auth$header(flags.i$)
						]),
					h8: 'POST',
					iY: $elm$core$Maybe$Nothing,
					i0: $elm$core$Maybe$Nothing,
					c3: _Utils_ap(
						$author$project$Data$Platform2$Export$host(flags),
						_Utils_ap(
							$author$project$Data$Platform2$Export$namespace,
							A2(
								$elm$url$Url$Builder$absolute,
								_List_fromArray(
									['dashboard.xlsx']),
								_List_Nil)))
				}));
	});
var $author$project$Dashboards2$ExportFinished = function (a) {
	return {$: 12, a: a};
};
var $author$project$Export$handleExportResponse = F2(
	function (_v0, response) {
		var createNotification = _v0.oa;
		var download = _v0.ol;
		if (!response.$) {
			var message = response.a.pP;
			return createNotification(message);
		} else {
			var downloadUrl = response.a.on;
			return download(downloadUrl);
		}
	});
var $author$project$Dashboards2$handleExportResponse = F2(
	function (config, response) {
		return A2(
			$author$project$Export$handleExportResponse,
			{
				oa: A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						config.a,
						$author$project$Dashboards2$CreateNotification($author$project$Icons$Platform2$export)),
					$elm$html$Html$text),
				ol: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ExportFinished)
			},
			response);
	});
var $author$project$Data$Platform2$Export$ExportItem = F4(
	function (queryResults, settings, metadata, params) {
		return {gf: metadata, lw: params, lJ: queryResults, mc: settings};
	});
var $author$project$Data$Metric$toComparable = function (metric) {
	switch (metric) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		case 3:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Data$Metric$allMetrics = A2(
	$elm$core$List$sortBy,
	$author$project$Data$Metric$toComparable,
	_List_fromArray(
		[0, 1, 2, 3, 4]));
var $elm_community$maybe_extra$Maybe$Extra$andThen2 = F3(
	function (func, ma, mb) {
		if (!ma.$) {
			var a = ma.a;
			if (!mb.$) {
				var b = mb.a;
				return A2(func, a, b);
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Data$Platform2$deepestDatasetNamespaceCode = F2(
	function (usedDatasets, allDatasets) {
		return A2(
			$elm$core$Maybe$map,
			function ($) {
				return $.jt;
			},
			A2($author$project$Data$Platform2$findDeepestDataset, usedDatasets, allDatasets));
	});
var $author$project$Data$Platform2$deepestNamespaceCode = F4(
	function (datasets, datasetsToNamespaces, lineages, namespaceCode) {
		var namespaceDatasets = A2(
			$krisajenkins$remotedata$RemoteData$map,
			$turboMaCk$any_set$Set$Any$toList,
			A2(
				$krisajenkins$remotedata$RemoteData$andThen,
				function (datasetsToNamespaces_) {
					return A3($author$project$Data$Platform2$datasetsForNamespace, datasetsToNamespaces_, lineages, namespaceCode);
				},
				datasetsToNamespaces));
		return A2(
			$elm$core$Maybe$andThen,
			function (usedDatasets) {
				return A2($author$project$Data$Platform2$deepestDatasetNamespaceCode, usedDatasets, datasets);
			},
			$krisajenkins$remotedata$RemoteData$toMaybe(namespaceDatasets));
	});
var $author$project$Data$Calc$Platform2$activeLocationsByNamespaceCode = F3(
	function (store, namespaceCode, activeLocations) {
		var namespaceCodeToUse = A2(
			$elm$core$Maybe$withDefault,
			namespaceCode,
			A4($author$project$Data$Platform2$deepestNamespaceCode, store.es, store.fC, store.cB, namespaceCode));
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var code = _v0.bW;
				return A2($elm$core$List$member, code, activeLocations);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$any_dict$Dict$Any$values,
					A2(
						$elm$core$Maybe$andThen,
						$krisajenkins$remotedata$RemoteData$toMaybe,
						A2($turboMaCk$any_dict$Dict$Any$get, namespaceCodeToUse, store.pK)))));
	});
var $author$project$Data$Calc$Platform2$activeWavesByNamespaceCode = F3(
	function (store, namespaceCode, activeWaves) {
		var namespaceCodeToUse = A2(
			$elm$core$Maybe$withDefault,
			namespaceCode,
			A4($author$project$Data$Platform2$deepestNamespaceCode, store.es, store.fC, store.cB, namespaceCode));
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var code = _v0.bW;
				return A2($elm$core$List$member, code, activeWaves);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$any_dict$Dict$Any$values,
					A2(
						$elm$core$Maybe$andThen,
						$krisajenkins$remotedata$RemoteData$toMaybe,
						A2($turboMaCk$any_dict$Dict$Any$get, namespaceCodeToUse, store.se)))));
	});
var $author$project$Data$Labels$addSuffixToDatapointCode = F3(
	function (shortQuestionCode, maybeSuffixCode, questionAndDatapointCode) {
		var questionAndDatapointCode_ = $author$project$Data$Id$unwrap(questionAndDatapointCode);
		var _v0 = $author$project$Data$Id$unwrap(shortQuestionCode);
		if (_v0 === 'waves') {
			return $author$project$Data$Id$fromString(questionAndDatapointCode_);
		} else {
			var _v1 = A2($elm$core$String$split, '_', questionAndDatapointCode_);
			if ((_v1.b && _v1.b.b) && (!_v1.b.b.b)) {
				var _v2 = _v1.b;
				var shortDatapointCode = _v2.a;
				if (maybeSuffixCode.$ === 1) {
					return $author$project$Data$Id$fromString(shortDatapointCode);
				} else {
					var suffixCode = maybeSuffixCode.a;
					return $author$project$Data$Id$fromString(
						shortDatapointCode + ('_' + $author$project$Data$Id$unwrap(suffixCode)));
				}
			} else {
				return $author$project$Data$Id$fromString(questionAndDatapointCode_);
			}
		}
	});
var $waratuman$time_extra$Time$Extra$toIso8601Date = F2(
	function (z, dt) {
		return A3(
			$elm$core$String$padLeft,
			4,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toYear, z, dt))) + ('-' + (A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				$waratuman$time_extra$Time$Extra$monthToInt(
					A2($elm$time$Time$toMonth, z, dt)))) + ('-' + A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(
				A2($elm$time$Time$toDay, z, dt))))));
	});
var $waratuman$time_extra$Time$Extra$toIso8601Time = F2(
	function (z, dt) {
		var s = A2($elm$time$Time$toSecond, z, dt);
		var ms = A2($elm$time$Time$toMillis, z, dt);
		var m = A2($elm$time$Time$toMinute, z, dt);
		var h = A2($elm$time$Time$toHour, z, dt);
		return A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(h)) + (':' + (A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(m)) + (((!s) && (!ms)) ? '' : (':' + (A3(
			$elm$core$String$padLeft,
			2,
			'0',
			$elm$core$String$fromInt(s)) + ((!ms) ? '' : ('.' + A3(
			$elm$core$String$padLeft,
			3,
			'0',
			$elm$core$String$fromInt(ms)))))))));
	});
var $waratuman$time_extra$Time$Extra$toIso8601DateTimeUTC = function (dt) {
	return A2($waratuman$time_extra$Time$Extra$toIso8601Date, $elm$time$Time$utc, dt) + ('T' + (A2($waratuman$time_extra$Time$Extra$toIso8601Time, $elm$time$Time$utc, dt) + 'Z'));
};
var $author$project$Data$Platform2$Export$exportMetadata = function (params) {
	var store = params.rF;
	var widgetName = params.dZ;
	var fileName = params.oJ;
	var simpleFilters = params.rn;
	var getAudienceColor = params.oT;
	var segments = params.l5;
	var time = params.rR;
	var questions = A2(
		$elm$core$Maybe$andThen,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
		A2(
			$elm_community$maybe_extra$Maybe$Extra$traverse,
			function (_v3) {
				var questionCode = _v3.at;
				return A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store);
			},
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(params.sh)));
	var namespaceCodes = $elm_community$list_extra$List$Extra$unique(
		A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
					$elm$core$List$map(
						function ($) {
							return $.id;
						})),
				questions)));
	var baseAudience = A2(
		$elm$core$Maybe$andThen,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.b;
			},
			$author$project$Store$Utils$get(store.d9)),
		simpleFilters.aU);
	var audiences = A2(
		$elm$core$List$filterMap,
		function (_v2) {
			var id = _v2.b;
			return A2(
				$elm$core$Maybe$map,
				function (audience) {
					return {
						fk: audience,
						jL: getAudienceColor(id)
					};
				},
				A2($author$project$Store$Utils$get, store.d9, id));
		},
		simpleFilters.d9);
	var attributes = A2(
		$elm$core$Maybe$andThen,
		$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
		A2(
			$elm$core$Maybe$map,
			$author$project$Gwi$List$fastConcat,
			A2(
				$elm_community$maybe_extra$Maybe$Extra$traverse,
				function (_v0) {
					var questionCode = _v0.at;
					var datapoints = _v0.er;
					return A2(
						$elm$core$Maybe$map,
						function (q) {
							return A2(
								$elm$core$List$filterMap,
								function (_v1) {
									var dtpCode = _v1.a;
									var suffixes = _v1.b;
									return A2(
										$elm$core$Maybe$map,
										function (datapoint) {
											var sorroundIfNotEmpty = F3(
												function (l, r, s) {
													return $elm$core$String$isEmpty(s) ? s : _Utils_ap(
														l,
														_Utils_ap(s, r));
												});
											var suffixNames = A3(
												sorroundIfNotEmpty,
												' (',
												')',
												A2(
													$elm$core$String$join,
													', ',
													A2(
														$elm$core$Maybe$withDefault,
														_List_Nil,
														A2(
															$elm$core$Maybe$map,
															A2(
																$elm$core$Basics$composeR,
																$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
																$elm$core$List$filterMap(
																	function (suffix) {
																		return A2($elm$core$List$member, suffix.bW, suffixes) ? $elm$core$Maybe$Just(suffix.ld) : $elm$core$Maybe$Nothing;
																	})),
															q.rI))));
											var megaJoin = $author$project$Data$Id$fromString(
												A2(
													$elm$core$String$join,
													'_',
													A2(
														$elm$core$List$cons,
														$author$project$Data$Id$unwrap(
															A3($author$project$Data$Labels$addSuffixToDatapointCode, q.bW, $elm$core$Maybe$Nothing, datapoint.bW)),
														A2($elm$core$List$map, $author$project$Data$Id$unwrap, suffixes))));
											return {
												eq: megaJoin,
												h4: _Utils_ap(datapoint.ld, suffixNames),
												at: questionCode
											};
										},
										A2(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.bW;
												},
												$elm$core$Basics$eq(dtpCode)),
											q.er));
								},
								$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(datapoints));
						},
						A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store));
				},
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(params.sh))));
	var activeWaves = $elm_community$list_extra$List$Extra$unique(
		$author$project$Gwi$List$fastConcat(
			A2(
				$elm$core$List$map,
				function (namepsaceCode) {
					return A3($author$project$Data$Calc$Platform2$activeWavesByNamespaceCode, store, namepsaceCode, simpleFilters.dX);
				},
				namespaceCodes)));
	var activeWavesWithDefault = $elm$core$List$isEmpty(activeWaves) ? A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		_List_Nil,
		A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$values, store.dX)) : activeWaves;
	var waves = $author$project$Data$Labels$sortWavesMostRecentFirst(activeWavesWithDefault);
	var activeCountries = $elm_community$list_extra$List$Extra$unique(
		$author$project$Gwi$List$fastConcat(
			A2(
				$elm$core$List$map,
				function (namepsaceCode) {
					return A3($author$project$Data$Calc$Platform2$activeLocationsByNamespaceCode, store, namepsaceCode, simpleFilters.cD);
				},
				namespaceCodes)));
	var activeCountriesWithDefault = $elm$core$List$isEmpty(activeCountries) ? A2(
		$krisajenkins$remotedata$RemoteData$withDefault,
		_List_Nil,
		A2($krisajenkins$remotedata$RemoteData$map, $turboMaCk$any_dict$Dict$Any$values, store.cD)) : activeCountries;
	var countries = A2(
		$elm$core$List$sortBy,
		function ($) {
			return $.ld;
		},
		activeCountriesWithDefault);
	return A3(
		$elm$core$Maybe$map2,
		F2(
			function (questions_, attributes_) {
				return {
					d7: attributes_,
					d9: audiences,
					aU: A2(
						$elm$core$Maybe$map,
						function (base) {
							return {fk: base, jL: '#ced9eb'};
						},
						baseAudience),
					hp: countries,
					hL: $waratuman$time_extra$Time$Extra$toIso8601DateTimeUTC(time),
					oJ: fileName,
					ld: widgetName,
					bt: questions_,
					l5: segments,
					dX: waves
				};
			}),
		questions,
		attributes);
};
var $author$project$Data$Calc$Platform2$activeLocationsByDashboardId = F3(
	function (store, dashboardId, activeLocations) {
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var code = _v0.bW;
				return A2($elm$core$List$member, code, activeLocations);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$any_dict$Dict$Any$values,
					A2(
						$elm$core$Maybe$andThen,
						$krisajenkins$remotedata$RemoteData$toMaybe,
						A2($turboMaCk$any_dict$Dict$Any$get, dashboardId, store.pJ)))));
	});
var $author$project$Data$Calc$Platform2$activeWavesByDashboardId = F3(
	function (store, dashboardId, activeWaves) {
		return A2(
			$elm$core$List$filter,
			function (_v0) {
				var code = _v0.bW;
				return A2($elm$core$List$member, code, activeWaves);
			},
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$any_dict$Dict$Any$values,
					A2(
						$elm$core$Maybe$andThen,
						$krisajenkins$remotedata$RemoteData$toMaybe,
						A2($turboMaCk$any_dict$Dict$Any$get, dashboardId, store.sd)))));
	});
var $author$project$Data$Calc$Platform2$exportParamsFromWidget = F4(
	function (store, simpleFilters, widget, data) {
		return $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
			$author$project$Gwi$List$fastConcat(
				A2(
					$elm$core$List$filterMap,
					function (_v0) {
						var questionCode = _v0.at;
						var datapoints = _v0.er;
						var namespaceCode = $author$project$Data$Labels$questionCodeToNamespaceCode(questionCode);
						var splitters = A2($author$project$Store$Platform2$getSplitters, namespaceCode, store);
						var waves = A2(
							$elm_community$list_extra$List$Extra$uniqueBy,
							function ($) {
								return $.bW;
							},
							_Utils_ap(
								A3($author$project$Data$Calc$Platform2$activeWavesByNamespaceCode, store, namespaceCode, simpleFilters.dX),
								A3($author$project$Data$Calc$Platform2$activeWavesByDashboardId, store, widget.bf, simpleFilters.dX)));
						var maybeSplitter = A2($author$project$Data$Calc$Platform2$getWidgetSplitter, widget, splitters);
						var locations = A2(
							$elm_community$list_extra$List$Extra$uniqueBy,
							function ($) {
								return $.bW;
							},
							_Utils_ap(
								A3($author$project$Data$Calc$Platform2$activeLocationsByNamespaceCode, store, namespaceCode, simpleFilters.cD),
								A3($author$project$Data$Calc$Platform2$activeLocationsByDashboardId, store, widget.bf, simpleFilters.cD)));
						var getAllSuffixes = F2(
							function (suffixCodes_, question) {
								return A2(
									$elm$core$Maybe$andThen,
									function (questionSuffixes) {
										return A2(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$filter,
											function (questionSuffix) {
												return A2($elm$core$List$member, questionSuffix.bW, suffixCodes_);
											},
											questionSuffixes);
									},
									question.rI);
							});
						var audiences = simpleFilters.d9;
						return A2(
							$elm$core$Maybe$map,
							function (question) {
								var getDatapoint = function (code) {
									return A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$find,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.bW;
											},
											$elm$core$Basics$eq(code)),
										question.er);
								};
								return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
									A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
										function (_v1) {
											var datapointCode = _v1.a;
											var suffixCodes = _v1.b;
											var suffixOrder = A2(
												$turboMaCk$any_dict$Dict$Any$fromList,
												$author$project$Data$Id$unwrap,
												A2(
													$elm$core$List$indexedMap,
													F2(
														function (index, suffix) {
															return _Utils_Tuple2(suffix, index);
														}),
													suffixCodes));
											var sortSuffixesByOriginalOrder = $elm$core$List$sortBy(
												function (_v2) {
													var code = _v2.bW;
													return A2(
														$elm$core$Maybe$withDefault,
														0,
														A2($turboMaCk$any_dict$Dict$Any$get, code, suffixOrder));
												});
											return {
												nh: A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.l5;
													},
													maybeSplitter),
												nx: $turboMaCk$any_set$Set$Any$toList(
													$author$project$Data$Calc$Platform2$audienceDatapoints(audiences)),
												nz: $turboMaCk$any_set$Set$Any$toList(
													$author$project$Data$Calc$Platform2$audienceQuestions(audiences)),
												d9: audiences,
												aU: simpleFilters.aU,
												er: A2(
													$elm$core$List$filterMap,
													getDatapoint,
													_List_fromArray(
														[datapointCode])),
												cD: locations,
												gA: question,
												qF: false,
												ry: maybeSplitter,
												rI: sortSuffixesByOriginalOrder(
													A3(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														_List_Nil,
														$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
														A2(getAllSuffixes, suffixCodes, question))),
												dX: waves
											};
										},
										datapoints));
							},
							A2(
								$elm$core$Maybe$andThen,
								$krisajenkins$remotedata$RemoteData$toMaybe,
								A2($turboMaCk$any_dict$Dict$Any$get, questionCode, store.bt)));
					},
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(data))));
	});
var $author$project$Data$Platform2$Export$exportSettings = F5(
	function (flags, datapointsSort, metricsShown, ordinate, scaleMaxes) {
		return {
			g5: A2($elm$core$List$map, $author$project$Data$Metric$toP2CompatibleString, metricsShown),
			j: flags.nM(8),
			ko: 'segment',
			h9: $author$project$Data$Metric$toP2CompatibleString(ordinate),
			ls: datapointsSort,
			iE: scaleMaxes
		};
	});
var $author$project$Data$Platform2$getOldWidgetDataSuffixCodes = F2(
	function (question, oldData) {
		var _v0 = oldData.eY;
		if (!_v0.$) {
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				A2(
					$elm$core$Basics$composeR,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$map(
						function ($) {
							return $.bW;
						}),
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList),
				question.rI);
		} else {
			var xs = _v0.a;
			return $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(xs);
		}
	});
var $author$project$RemoteData$Loaded$isDone = function (data) {
	switch (data.$) {
		case 3:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $author$project$Dashboards2$Chart$isFinished = function (_v0) {
	var chartData = _v0.h;
	switch (chartData.$) {
		case 0:
			var data = chartData.a.cl;
			return $author$project$RemoteData$Loaded$isDone(data);
		case 1:
			var data = chartData.a.cl;
			return $author$project$RemoteData$Loaded$isDone(data);
		case 2:
			var webdataStatCardModel = chartData.a;
			return $author$project$RemoteData$Loaded$isDone(webdataStatCardModel);
		default:
			var data = chartData.b.cl;
			return $author$project$RemoteData$Loaded$isDone(data);
	}
};
var $author$project$Dashboards2$Chart$getQueryResults = F2(
	function (userFilters, model) {
		var toNonemptyListResults = F2(
			function (webData, convert) {
				return A2(
					$elm$core$Maybe$andThen,
					convert,
					$author$project$RemoteData$Loaded$toMaybe(webData));
			});
		if ($author$project$Dashboards2$Chart$isFinished(model)) {
			var _v0 = model.h;
			switch (_v0.$) {
				case 0:
					var data = _v0.a.cl;
					return A2(
						toNonemptyListResults,
						data,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							A2(
								$elm$core$Basics$composeR,
								$turboMaCk$any_dict$Dict$Any$get(userFilters),
								$elm$core$Maybe$andThen(
									A2($elm$core$Basics$composeR, $turboMaCk$any_set$Set$Any$toList, $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList)))));
				case 1:
					var data = _v0.a.cl;
					return A2(
						toNonemptyListResults,
						data,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							A2(
								$elm$core$Basics$composeR,
								$turboMaCk$any_dict$Dict$Any$get(userFilters),
								$elm$core$Maybe$andThen(
									A2($elm$core$Basics$composeR, $turboMaCk$any_set$Set$Any$toList, $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList)))));
				case 2:
					var data = _v0.a;
					return A2(
						toNonemptyListResults,
						data,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							A2(
								$elm$core$Basics$composeR,
								$turboMaCk$any_dict$Dict$Any$get(userFilters),
								$elm$core$Maybe$map($turboMaCk$non_empty_list_alias$List$NonEmpty$singleton))));
				default:
					var data = _v0.b.cl;
					return A2(
						toNonemptyListResults,
						data,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Tuple$first,
							A2(
								$elm$core$Basics$composeR,
								$turboMaCk$any_dict$Dict$Any$get(userFilters),
								$elm$core$Maybe$andThen(
									A2($elm$core$Basics$composeR, $turboMaCk$any_set$Set$Any$toList, $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList)))));
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Dashboards2$Widget$getQueryResults = F2(
	function (userFilters, model) {
		var _v0 = model.ad;
		switch (_v0.$) {
			case 2:
				var chartModelData = _v0.a;
				return A2(
					$elm$core$Maybe$andThen,
					$author$project$Dashboards2$Chart$getQueryResults(userFilters),
					$author$project$Dashboards2$Widget$getChartModel(chartModelData));
			case 0:
				return $elm$core$Maybe$Nothing;
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Dashboards2$Detail$isWidgetExportable = F2(
	function (questions, widgetData) {
		var isQuestionExportable = function (group) {
			var questionCode = group.at;
			var _v1 = A2($turboMaCk$any_dict$Dict$Any$get, questionCode, questions);
			if (!_v1.$) {
				var question = _v1.a;
				var explicitGroup = A2($author$project$Data$Platform2$groupedWidgetDataToExplicitWidgetData, question, group);
				var datapointCodes = A2($turboMaCk$non_empty_list_alias$List$NonEmpty$map, $elm$core$Tuple$first, explicitGroup.er);
				var widgetDatapoints = A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$filter,
					function (dp) {
						return A2($turboMaCk$non_empty_list_alias$List$NonEmpty$member, dp.bW, datapointCodes);
					},
					question.er);
				var allDatapointsAreKnown = _Utils_eq(
					A3($elm_community$maybe_extra$Maybe$Extra$unwrap, 0, $turboMaCk$non_empty_list_alias$List$NonEmpty$length, widgetDatapoints),
					$turboMaCk$non_empty_list_alias$List$NonEmpty$length(datapointCodes));
				return _Utils_eq(
					$author$project$Data$Permissions$questionV2(question),
					$author$project$Data$Permissions$Accessible) && (A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$all(
						function ($) {
							return $.fc;
						}),
					widgetDatapoints) && allDatapointsAreKnown);
			} else {
				return false;
			}
		};
		if (!widgetData.$) {
			var oldData = widgetData.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				false,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$all(isQuestionExportable),
				A2($author$project$Data$Platform2$oldWidgetDataToGroupedWidgetData, questions, oldData));
		} else {
			var groups = widgetData.a;
			return A2($turboMaCk$non_empty_list_alias$List$NonEmpty$all, isQuestionExportable, groups);
		}
	});
var $elm$core$Maybe$map4 = F5(
	function (func, ma, mb, mc, md) {
		if (ma.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var a = ma.a;
			if (mb.$ === 1) {
				return $elm$core$Maybe$Nothing;
			} else {
				var b = mb.a;
				if (mc.$ === 1) {
					return $elm$core$Maybe$Nothing;
				} else {
					var c = mc.a;
					if (md.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var d = md.a;
						return $elm$core$Maybe$Just(
							A4(func, a, b, c, d));
					}
				}
			}
		}
	});
var $author$project$Dashboards2$widgetToExportItem = F7(
	function (flags, store, currentTime, maybeUserFilters, savedDashboard, model, widget) {
		var results = A3(
			$elm_community$maybe_extra$Maybe$Extra$andThen2,
			$author$project$Dashboards2$Widget$getQueryResults,
			maybeUserFilters,
			A2(
				$turboMaCk$any_dict$Dict$Any$get,
				widget.b,
				$author$project$Dashboards2$Detail$currentWidgets(model)));
		var questions = A2(
			$turboMaCk$any_dict$Dict$Any$filterMap,
			F2(
				function (_v2, v) {
					return $krisajenkins$remotedata$RemoteData$toMaybe(v);
				}),
			store.bt);
		var maybeDataForWidget = A2(
			$elm$core$Maybe$andThen,
			function (_v0) {
				var data = _v0.cl;
				if (!data.$) {
					var oldData = data.a;
					return A2(
						$elm$core$Maybe$map,
						function (question) {
							var suffixes = A2($author$project$Data$Platform2$getOldWidgetDataSuffixCodes, question, oldData);
							return $turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(
								{
									er: A2(
										$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
										function (dtp) {
											return _Utils_Tuple2(dtp, suffixes);
										},
										A2($author$project$Data$Platform2$getOldWidgetDataDatapointCodes, question, oldData)),
									at: oldData.at
								});
						},
						A2(
							$elm$core$Maybe$andThen,
							$krisajenkins$remotedata$RemoteData$toMaybe,
							A2($turboMaCk$any_dict$Dict$Any$get, oldData.at, store.bt)));
				} else {
					var groups = data.a;
					return A2(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap,
						function (group) {
							return A2(
								$elm$core$Maybe$map,
								function (question) {
									return A2($author$project$Data$Platform2$groupedWidgetDataToExplicitWidgetData, question, group);
								},
								A2(
									$elm$core$Maybe$andThen,
									$krisajenkins$remotedata$RemoteData$toMaybe,
									A2($turboMaCk$any_dict$Dict$Any$get, group.at, store.bt)));
						},
						groups);
				}
			},
			A2(
				$elm_community$maybe_extra$Maybe$Extra$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.cl;
					},
					$author$project$Dashboards2$Detail$isWidgetExportable(questions)),
				$author$project$Data$Platform2$getChartWidget(widget)));
		var maybeParams = A2(
			$elm$core$Maybe$andThen,
			function (userFilters) {
				return A2(
					$elm$core$Maybe$andThen,
					A3(
						$author$project$Data$Calc$Platform2$exportParamsFromWidget,
						store,
						$author$project$Dashboards2$UserFilters$toSimpleFilters(userFilters),
						widget),
					maybeDataForWidget);
			},
			maybeUserFilters);
		var splitters = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList,
			A2(
				$elm$core$Maybe$andThen,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$filterMap(
					function ($) {
						return $.ry;
					}),
				maybeParams));
		var segments = A2(
			$author$project$Gwi$List$fastConcatMap,
			function ($) {
				return $.l5;
			},
			splitters);
		var maybeMetadata = A2(
			$elm$core$Maybe$withDefault,
			$elm$core$Maybe$Nothing,
			A5(
				$elm$core$Maybe$map4,
				F4(
					function (userFilters, dashboard, chartWidget, dataForWidget) {
						return $author$project$Data$Platform2$Export$exportMetadata(
							{
								oJ: dashboard.ld,
								oT: function (id) {
									return $author$project$Palette$filtersColorToHex(
										A2($author$project$Dashboards2$UserFilters$audienceColor, id, userFilters));
								},
								l5: segments,
								rn: $author$project$Dashboards2$UserFilters$toSimpleFilters(userFilters),
								rF: store,
								rR: currentTime,
								sh: dataForWidget,
								dZ: chartWidget.ld
							});
					}),
				maybeUserFilters,
				savedDashboard,
				$author$project$Data$Platform2$getChartWidget(widget),
				maybeDataForWidget));
		var exportSettings = A2(
			$elm$core$Maybe$map,
			function (chartWidget) {
				return A5($author$project$Data$Platform2$Export$exportSettings, flags, chartWidget.cY, $author$project$Data$Metric$allMetrics, 0, 0);
			},
			$author$project$Data$Platform2$getChartWidget(widget));
		return A4(
			$elm$core$Maybe$map3,
			$author$project$Data$Platform2$Export$ExportItem(results),
			exportSettings,
			maybeMetadata,
			maybeParams);
	});
var $author$project$Dashboards2$export = F6(
	function (config, flags, currentTime, route, store, model) {
		var savedDashboard = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
		var maybeWidgets = A2(
			$elm$core$Maybe$map,
			$elm$core$List$sortBy(
				function ($) {
					return $.lB;
				}),
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.cl;
					},
					function ($) {
						return $.g;
					}),
				savedDashboard));
		var maybeUserFilters = $author$project$Dashboards2$getUserFilters(model);
		var exportCmd = A2(
			$elm$core$Maybe$map,
			function (exportItems) {
				return A4(
					$author$project$Data$Platform2$Export$exportDashboard,
					flags,
					$author$project$Dashboards2$handleExportResponse(config),
					A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ExportAjaxError),
					exportItems);
			},
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$filterMap(
					A6($author$project$Dashboards2$widgetToExportItem, flags, store, currentTime, maybeUserFilters, savedDashboard, model)),
				maybeWidgets));
		var notification = $elm_community$maybe_extra$Maybe$Extra$isJust(exportCmd) ? $elm$html$Html$text('Data for export is downloading.') : $elm$html$Html$text('There is nothing to export.');
		var notificationCmd = $GlobalWebIndex$cmd_extra$Cmd$Extra$perform(
			config.a(
				A2($author$project$Dashboards2$CreateNotification, $author$project$Icons$Platform2$export, notification)));
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{a2: $elm$core$Maybe$Nothing}),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Maybe$withDefault, $elm$core$Platform$Cmd$none, exportCmd),
						notificationCmd
					])));
	});
var $author$project$Export$exportErrorDisplay = function (err) {
	switch (err.$) {
		case 0:
			return {
				jv: $elm$html$Html$text('There was an error parsing your auth token'),
				j$: _List_Nil,
				ka: $elm$core$Maybe$Nothing,
				Y: 'Auth token parsing error'
			};
		case 1:
			return {
				jv: $elm$html$Html$text('There was an error querying the data'),
				j$: _List_Nil,
				ka: $elm$core$Maybe$Nothing,
				Y: 'Querying data error'
			};
		case 2:
			return {
				jv: $elm$html$Html$text('There was a processing error'),
				j$: _List_Nil,
				ka: $elm$core$Maybe$Nothing,
				Y: 'Processing error'
			};
		case 3:
			return {
				jv: $elm$html$Html$text('There was an error querying current_user'),
				j$: _List_Nil,
				ka: $elm$core$Maybe$Nothing,
				Y: 'Current user query error'
			};
		case 4:
			return {
				jv: $elm$html$Html$text('There was an error sending email'),
				j$: _List_Nil,
				ka: $elm$core$Maybe$Nothing,
				Y: 'Email send error'
			};
		case 5:
			return {
				jv: $elm$html$Html$text('The results for the query are missing'),
				j$: _List_Nil,
				ka: $elm$core$Maybe$Nothing,
				Y: 'Results missing'
			};
		case 6:
			var ids = err.a;
			var questionIds = A2(
				$elm$core$List$map,
				$author$project$Data$Id$unwrap,
				A2($elm$core$List$map, $elm$core$Tuple$second, ids));
			var count = $elm$core$List$length(ids);
			var bookmarkIds = A2(
				$elm$core$List$map,
				$author$project$Data$Id$unwrap,
				A2($elm$core$List$map, $elm$core$Tuple$first, ids));
			return {
				jv: $elm$html$Html$text(
					A2($author$project$Plural$fromInt, count, 'Question') + (' ' + (A2($author$project$Plural$fromInt, count, 'be') + ' missing when exporting bookmarks'))),
				j$: _List_fromArray(
					[
						A2($author$project$Plural$fromInt, count, 'bookmark id') + (': ' + A2($elm$core$String$join, ', ', bookmarkIds)),
						A2($author$project$Plural$fromInt, count, 'question id') + (': ' + A2($elm$core$String$join, ', ', questionIds))
					]),
				ka: $elm$core$Maybe$Nothing,
				Y: 'Export failed'
			};
		default:
			var ids = err.a;
			var questionIds = A2(
				$elm$core$List$map,
				$author$project$Data$Id$unwrap,
				A2($elm$core$List$map, $elm$core$Tuple$second, ids));
			var queryIds = A2(
				$elm$core$List$map,
				$author$project$Data$Id$unwrap,
				A2($elm$core$List$map, $elm$core$Tuple$first, ids));
			var count = $elm$core$List$length(ids);
			return {
				jv: $elm$html$Html$text(
					A2($author$project$Plural$fromInt, count, 'Question') + (' ' + (A2($author$project$Plural$fromInt, count, 'be') + ' missing when exporting queries'))),
				j$: _List_fromArray(
					[
						A2($author$project$Plural$fromInt, count, 'query id') + (': ' + A2($elm$core$String$join, ', ', queryIds)),
						A2($author$project$Plural$fromInt, count, 'question id') + (': ' + A2($elm$core$String$join, ', ', questionIds))
					]),
				ka: $elm$core$Maybe$Nothing,
				Y: 'Export failed'
			};
	}
};
var $author$project$Icons$Platform2$eyeCrossed = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M21.179 13.307c.254-.217.636-.187.853.067.592.694 1.11 1.441 1.526 2.212.224.414.224.915 0 1.329-1.747 3.23-4.795 5.586-7.695 5.586-.741 0-1.492-.152-2.238-.442-.312-.12-.466-.47-.345-.782.12-.312.471-.466.782-.345.612.237 1.216.359 1.8.359h.01c2.387-.005 5.069-2.08 6.622-4.951.03-.055.03-.124 0-.179-.376-.694-.844-1.371-1.382-2.001-.217-.254-.187-.636.067-.853zM15.863 10c1.344 0 2.717.494 4.006 1.387l1.211-1.21c.237-.236.62-.236.856 0 .236.237.236.62 0 .856l-11.29 11.29c-.237.237-.62.237-.856 0-.236-.236-.236-.619 0-.855l1.107-1.108c-1.078-.947-2.027-2.147-2.73-3.445-.223-.414-.223-.916 0-1.33C9.915 12.357 12.963 10 15.864 10zm0 1.21c-2.39 0-5.077 2.076-6.631 4.951-.03.055-.03.124 0 .179.648 1.198 1.53 2.304 2.523 3.164l1.497-1.499c-.824-1.223-.695-2.897.387-3.979 1.082-1.082 2.757-1.21 3.98-.386l1.379-1.38c-1.042-.683-2.117-1.05-3.135-1.05zm.872 3.311c-.726-.366-1.635-.246-2.24.36-.607.607-.727 1.515-.36 2.241z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$transform('translate(-1044 -270) translate(267 262) translate(777 8)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Data$Platform2$FullUserEmail = F4(
	function (id, email, firstName, lastName) {
		return {j: email, ke: firstName, b: id, pA: lastName};
	});
var $author$project$Data$Platform2$fullUserEmailsDecoder = A2(
	$elm$json$Json$Decode$map,
	$elm$core$Maybe$withDefault(_List_Nil),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$optionalField,
		'users',
		$elm$json$Json$Decode$list(
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'last_name', $elm$json$Json$Decode$string),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'first_name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decodeFromInt),
							$elm$json$Json$Decode$succeed($author$project$Data$Platform2$FullUserEmail))))))));
var $author$project$Data$Platform2$fetchFullUserEmails = F2(
	function (term, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'hint',
								$elm$json$Json$Encode$string(term)),
								_Utils_Tuple2(
								'limit',
								$elm$json$Json$Encode$int(3))
							]))),
				hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Data$Platform2$fullUserEmailsDecoder),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Data$Platform2$host(flags),
					_List_fromArray(
						['v2', 'users', 'suggest']),
					_List_Nil)
			});
	});
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $author$project$Dashboards2$focusElement = F2(
	function (elementId, config) {
		return A2(
			$elm$core$Task$attempt,
			function (_v0) {
				return config.y;
			},
			$elm$browser$Browser$Dom$focus(elementId));
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$foldl = F2(
	function (f, acc) {
		return A2(
			$elm$core$Basics$composeL,
			A2($elm$core$List$foldl, f, acc),
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList);
	});
var $author$project$Dashboards2$Analytics$DashboardShared = function (a) {
	return {$: 15, a: a};
};
var $author$project$Data$Platform2$getCategoryNames = function (categories) {
	if (categories.a.$ === 1) {
		if (categories.b.$ === 1) {
			var _v1 = categories.a;
			var _v2 = categories.b;
			return _List_Nil;
		} else {
			var _v3 = categories.a;
			var name = categories.b.a.ld;
			return _List_fromArray(
				[name]);
		}
	} else {
		if (categories.b.$ === 1) {
			var name = categories.a.a.ld;
			var _v4 = categories.b;
			return _List_fromArray(
				[name]);
		} else {
			var c1 = categories.a.a;
			var c2 = categories.b.a;
			return _List_fromArray(
				[c1.ld, c2.ld]);
		}
	}
};
var $author$project$Dashboards2$generateDashboardSharedAnalyticsCmd = F7(
	function (flags, store, model, categories, sharedWith, dashboard, sharingMethod) {
		var sharedWithOwnOrg = function () {
			switch (sharedWith.$) {
				case 1:
					var _v7 = sharedWith.a;
					var orgIds = _v7.a;
					return $elm_community$maybe_extra$Maybe$Extra$isJust(
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (orgId) {
								return _Utils_eq(
									$elm$core$Maybe$Just(orgId),
									A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m));
							},
							orgIds));
				case 2:
					if (!sharedWith.a.a.$) {
						var _v8 = sharedWith.a;
						var orgId = _v8.a.a;
						return _Utils_eq(
							A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m),
							$elm$core$Maybe$Just(orgId));
					} else {
						return false;
					}
				case 3:
					return false;
				case 0:
					return false;
				case 4:
					return false;
				case 6:
					var _v9 = sharedWith.a;
					var orgIds = _v9.a;
					return $elm_community$maybe_extra$Maybe$Extra$isJust(
						A2(
							$elm_community$list_extra$List$Extra$find,
							function (orgId) {
								return _Utils_eq(
									$elm$core$Maybe$Just(orgId),
									A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m));
							},
							orgIds));
				case 7:
					if (!sharedWith.a.a.$) {
						var _v10 = sharedWith.a;
						var orgId = _v10.a.a;
						return _Utils_eq(
							A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m),
							$elm$core$Maybe$Just(orgId));
					} else {
						return false;
					}
				case 8:
					return false;
				default:
					return false;
			}
		}();
		var selectedWaves = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				function (userFilters) {
					return $turboMaCk$any_set$Set$Any$toList(
						$author$project$Dashboards2$UserFilters$waves(userFilters));
				},
				$author$project$Dashboards2$getUserFilters(model)));
		var selectedLocations = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				function (userFilters) {
					return $turboMaCk$any_set$Set$Any$toList(
						$author$project$Dashboards2$UserFilters$locations(userFilters));
				},
				$author$project$Dashboards2$getUserFilters(model)));
		var questions = $turboMaCk$any_dict$Dict$Any$values(
			A2(
				$turboMaCk$any_dict$Dict$Any$filterMap,
				F2(
					function (_v5, v) {
						return $krisajenkins$remotedata$RemoteData$toMaybe(v);
					}),
				store.bt));
		var newSharingMethod = function () {
			if (!sharingMethod.$) {
				var method = sharingMethod.a;
				return method;
			} else {
				switch (sharedWith.$) {
					case 0:
						return 'n/a';
					case 3:
						return 'shared_with_others';
					case 1:
						return 'shared_with_others';
					case 2:
						return 'shared_with_others';
					case 4:
						return 'open_access_link';
					case 5:
						return 'public_link';
					case 6:
						return 'shared_with_others';
					case 7:
						return 'shared_with_others';
					default:
						return 'n/a';
				}
			}
		}();
		var filteredWaves = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			$elm$core$List$map($elm$core$Tuple$second),
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$filter(
					function (_v2) {
						var k = _v2.a;
						return A2($elm$core$List$member, k, selectedWaves);
					}),
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$any_dict$Dict$Any$toList,
					$krisajenkins$remotedata$RemoteData$toMaybe(
						A2($author$project$Dashboards2$Detail$getWavesForDashboardByNamespaces, store, dashboard)))));
		var filteredLocations = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			$elm$core$List$map($elm$core$Tuple$second),
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$filter(
					function (_v0) {
						var k = _v0.a;
						return A2($elm$core$List$member, k, selectedLocations);
					}),
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$any_dict$Dict$Any$toList,
					$krisajenkins$remotedata$RemoteData$toMaybe(
						A2($author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId, store, dashboard))))) : A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			$elm$core$List$map($elm$core$Tuple$second),
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$filter(
					function (_v1) {
						var k = _v1.a;
						return A2($elm$core$List$member, k, selectedLocations);
					}),
				A2(
					$elm$core$Maybe$map,
					$turboMaCk$any_dict$Dict$Any$toList,
					$krisajenkins$remotedata$RemoteData$toMaybe(
						A2($author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces, store, dashboard)))));
		var audiences = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			_List_Nil,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Maybe$map,
				function (userFilters) {
					return A2(
						$author$project$Store$Utils$getByIds,
						store.d9,
						$author$project$Dashboards2$UserFilters$audienceIds(userFilters));
				},
				$author$project$Dashboards2$getUserFilters(model)));
		return $author$project$Dashboards2$Analytics$trackEvent(
			$author$project$Dashboards2$Analytics$DashboardShared(
				{
					be: 'Dashboards',
					g9: $elm$core$List$sum(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.er;
								},
								$turboMaCk$non_empty_list_alias$List$NonEmpty$length),
							questions)),
					d9: A2(
						$elm$core$List$map,
						function (audience) {
							return {b: audience.b, ld: audience.ld};
						},
						audiences),
					ac: $author$project$Data$Platform2$getCategoryNames(categories),
					ep: dashboard,
					a0: flags.nM(23),
					h2: _Utils_eq(flags.mQ.b, dashboard.dG),
					cD: A2(
						$elm$core$List$map,
						function (location) {
							return {bW: location.bW, ld: location.ld};
						},
						filteredLocations),
					bt: A2(
						$elm$core$List$map,
						function (question) {
							return {bW: question.bW, ld: question.ld};
						},
						questions),
					rk: sharedWithOwnOrg,
					ah: sharedWith,
					dK: newSharingMethod,
					dX: A2(
						$elm$core$List$map,
						function ($) {
							return $.bW;
						},
						filteredWaves),
					i4: $elm$core$List$length(dashboard.cl.g)
				}));
	});
var $author$project$Dashboards2$SearchForCategoryInModal = function (a) {
	return {$: 123, a: a};
};
var $author$project$Data$Platform2$getCategories = function (categories) {
	if (categories.a.$ === 1) {
		if (categories.b.$ === 1) {
			var _v1 = categories.a;
			var _v2 = categories.b;
			return _List_Nil;
		} else {
			var _v3 = categories.a;
			var c = categories.b.a;
			return _List_fromArray(
				[c]);
		}
	} else {
		if (categories.b.$ === 1) {
			var c = categories.a.a;
			var _v4 = categories.b;
			return _List_fromArray(
				[c]);
		} else {
			var c1 = categories.a.a;
			var c2 = categories.b.a;
			return _List_fromArray(
				[c1, c2]);
		}
	}
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $author$project$Dashboards2$getAddCategoryViewConfig = F3(
	function (store, searchTerm, dashboard) {
		var dashboardCategoriesLimit = 2;
		var dashboardCategories = $author$project$Data$Platform2$getCategories(dashboard.ac);
		var selectionInfo = A2(
			$elm$html$Html$strong,
			_List_Nil,
			$elm$core$List$singleton(
				$elm$html$Html$text(
					$elm$core$String$fromInt(
						$elm$core$List$length(dashboardCategories)) + (' of ' + ($elm$core$String$fromInt(dashboardCategoriesLimit) + ' selected')))));
		var toItem = function (category) {
			var isSelected = A2($elm$core$List$member, category, dashboardCategories);
			return {
				fI: (!isSelected) && (_Utils_cmp(
					$elm$core$List$length(dashboardCategories),
					dashboardCategoriesLimit) > -1),
				pv: isSelected,
				kS: category,
				h4: category.ld
			};
		};
		return {
			n2: $author$project$Dashboards2$ToggleAddCategory,
			f2: A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				A2(
					$elm$core$Basics$composeR,
					$turboMaCk$any_dict$Dict$Any$values,
					$elm$core$List$map(toItem)),
				$krisajenkins$remotedata$RemoteData$toMaybe(store.kF)),
			y: $author$project$Dashboards2$NoOp,
			go: $author$project$Dashboards2$SearchForCategoryInModal,
			cO: 'Search categories',
			cW: searchTerm,
			re: selectionInfo,
			r6: $author$project$Dashboards2$ToggleDashboardCategory(dashboard)
		};
	});
var $elm_community$list_extra$List$Extra$getAt = F2(
	function (idx, xs) {
		return (idx < 0) ? $elm$core$Maybe$Nothing : $elm$core$List$head(
			A2($elm$core$List$drop, idx, xs));
	});
var $author$project$Dashboards2$UserFilters$getBaseAudience = function (_v0) {
	var baseAudience = _v0.aU;
	return baseAudience;
};
var $author$project$Dashboards2$GotBasesPanelViewport = function (a) {
	return {$: 127, a: a};
};
var $author$project$Dashboards2$getBasesPanelViewport = function (config) {
	return A2(
		$elm$core$Task$attempt,
		function (result) {
			if (!result.$) {
				var info = result.a;
				return config.a(
					$author$project$Dashboards2$GotBasesPanelViewport(info));
			} else {
				return config.a($author$project$Dashboards2$NoOp);
			}
		},
		$elm$browser$Browser$Dom$getViewportOf($author$project$Dashboards2$Detail$audiencesPanelScrollableId));
};
var $author$project$Data$Platform2$organisationDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'id', $author$project$Data$Id$decode),
		$elm$json$Json$Decode$succeed($author$project$Data$Platform2$Organisation)));
var $elm$http$Http$stringBody = _Http_pair;
var $author$project$Data$Platform2$getOrganisationsSuggestion = F2(
	function (searchTerm, flags) {
		var body = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'input',
					$elm$json$Json$Encode$string(searchTerm))
				]));
		return $elm$http$Http$request(
			{
				jv: A2(
					$elm$http$Http$stringBody,
					'application/vnd.api+json',
					A2($elm$json$Json$Encode$encode, 0, body)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$field,
						'data',
						$elm$json$Json$Decode$list(
							A2($elm$json$Json$Decode$field, 'attributes', $author$project$Data$Platform2$organisationDecoder)))),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + '/v2/app/dashboards/organisations/suggest'
			});
	});
var $author$project$Data$Platform2$getOrganisationsTask = F2(
	function (orgIds, flags) {
		var validOrganisationsDecoder = A2(
			$elm$json$Json$Decode$map,
			$elm$core$List$filterMap($elm$core$Basics$identity),
			$elm$json$Json$Decode$list(
				A2(
					$elm$json$Json$Decode$field,
					'attributes',
					A2(
						$elm_community$json_extra$Json$Decode$Extra$withDefault,
						$elm$core$Maybe$Nothing,
						A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, $author$project$Data$Platform2$organisationDecoder)))));
		var body = A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, orgIds);
		return A2(
			$elm$core$Task$mapError,
			$author$project$Gwi$Http$toHttpError($elm$core$Basics$never),
			$elm$http$Http$task(
				{
					jv: A2(
						$elm$http$Http$stringBody,
						'application/vnd.api+json',
						A2($elm$json$Json$Encode$encode, 0, body)),
					hU: _List_fromArray(
						[
							$author$project$Data$Auth$header(flags.i$)
						]),
					h8: 'POST',
					qV: $author$project$Gwi$Http$resolveErrorAwareJsonWithNever(
						A2($elm$json$Json$Decode$field, 'data', validOrganisationsDecoder)),
					iY: $elm$core$Maybe$Nothing,
					c3: $author$project$Data$Platform2$host(flags) + '/v2/app/dashboards/organisations/validate/bulk'
				}));
	});
var $author$project$DragAndDrop$Move$getOverDropItem = function (msg) {
	if ((msg.$ === 4) && (msg.a.$ === 1)) {
		var _v1 = msg.a;
		var listId = _v1.a;
		return $elm$core$Maybe$Just(listId);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Dashboards2$getRememberMyChoice = function (modal) {
	if (modal.$ === 1) {
		var data = modal.a;
		var _v1 = data.bF;
		if (!_v1.$) {
			return false;
		} else {
			var showAgain = _v1.a;
			return showAgain;
		}
	} else {
		return false;
	}
};
var $author$project$DragAndDrop$Move$getTickTime = function (msg) {
	if ((msg.$ === 4) && (msg.a.$ === 6)) {
		var time = msg.a.a;
		return $elm$core$Maybe$Just(time);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Dashboards2$getWidgetModel = F2(
	function (id, model) {
		return A2(
			$turboMaCk$any_dict$Dict$Any$get,
			id,
			$author$project$Dashboards2$Detail$currentWidgets(model));
	});
var $author$project$Icons$Platform2$globe = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('translate(7.5 8)'),
						$elm$svg$Svg$Attributes$d('M0.500326 7.97738C0.500109 7.98468 0.5 7.992 0.5 7.99935C0.5 8.00669 0.500109 8.01401 0.500325 8.0213C0.511952 12.4108 4.0354 15.9543 8.41717 15.9986C8.47265 16.0005 8.52818 16.0005 8.58366 15.9986C12.9724 15.954 16.5 12.3989 16.5 7.9995C16.5 3.57231 12.9276 8.05213e-05 8.50022 0C4.08019 8.13149e-05 0.512204 3.56041 0.500326 7.97738ZM1.99446 7.27214C2.2594 4.85886 3.82787 2.84709 5.98402 1.95263C5.13397 3.61305 4.65942 5.43328 4.56038 7.27214H1.99446ZM1.99443 8.72656H4.56028C4.65906 10.5653 5.13329 12.3855 5.98299 14.0459C3.82728 13.1512 2.25923 11.1396 1.99443 8.72656ZM6.01713 8.72656C6.12906 10.5853 6.67117 12.4196 7.64344 14.0428C7.83445 14.3618 8.14102 14.5291 8.45308 14.5444L8.50007 14.5446L8.54766 14.5444C8.55714 14.5439 8.56661 14.5433 8.57607 14.5426C8.8782 14.5188 9.17197 14.3522 9.35717 14.0429C10.3294 12.4197 10.8716 10.5853 10.9835 8.72656H8.54574H8.50014H6.01713ZM8.50016 7.27214H8.53815H10.9834C10.8712 5.41409 10.3292 3.58041 9.35724 1.95779C9.15772 1.62512 8.83319 1.45764 8.50781 1.45505C8.50528 1.45503 8.50274 1.45502 8.50021 1.45502L8.50016 7.27214ZM12.4404 8.72656C12.3416 10.5652 11.8674 12.3854 11.0178 14.0457C13.1733 13.1509 14.7411 11.1394 15.0059 8.72656H12.4404ZM15.0058 7.27214H12.4403C12.3413 5.43336 11.8667 3.6132 11.0168 1.95283C13.1727 2.84739 14.7409 4.85904 15.0058 7.27214ZM8.50016 7.27214H6.01725C6.12943 5.41409 6.67149 3.58041 7.64344 1.95779C7.84401 1.62281 8.17215 1.45505 8.50021 1.45502L8.50016 7.27214Z')
					]),
				_List_Nil)
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$FullScreenLoader$setLoadedCount = F2(
	function (newLoadedCount, counts) {
		return _Utils_update(
			counts,
			{h6: newLoadedCount});
	});
var $author$project$Dashboards2$incrementLoaderCounts = $elm$core$Maybe$map(
	function (counts) {
		return A2($author$project$FullScreenLoader$setLoadedCount, counts.h6 + 1, counts);
	});
var $author$project$Dashboards2$ChartBrowser$CurrentTime = function (a) {
	return {$: 3, a: a};
};
var $author$project$Store$Platform2$FetchChartFolders = {$: 23};
var $author$project$Dashboards2$ChartBrowser$MyCharts = 0;
var $author$project$Store$AttributesTaxonomy$taxonomyFolderIdToComparable = function (categoryId) {
	if (!categoryId.$) {
		var id = categoryId.a;
		return 'category-id--' + id;
	} else {
		var id = categoryId.a;
		return 'dataset-folder-id--' + id;
	}
};
var $author$project$Store$AttributesTaxonomy$init = {
	ac: $turboMaCk$any_dict$Dict$Any$empty(
		A2($elm_community$maybe_extra$Maybe$Extra$unwrap, '0', $author$project$Store$AttributesTaxonomy$taxonomyFolderIdToComparable))
};
var $author$project$Dashboards2$ChartBrowser$init = F2(
	function (config, validDatasets) {
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
			A2(
				$elm$core$Task$perform,
				A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ChartBrowser$CurrentTime),
				$elm$time$Time$now),
			A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
				config.l(
					_List_fromArray(
						[$author$project$Store$Platform2$FetchChartFolders, $author$project$Store$Platform2$FetchCharts])),
				{
					cf: _List_Nil,
					di: $elm$core$Maybe$Nothing,
					dj: $elm$core$Maybe$Nothing,
					eo: 0,
					dk: $elm$time$Time$millisToPosix(0),
					aR: $author$project$Platform2$SearchInput$initialModel,
					aE: _List_Nil,
					eZ: $elm$core$Maybe$Nothing,
					c_: $author$project$Store$AttributesTaxonomy$init,
					g0: validDatasets
				}));
	});
var $Gizra$elm_debouncer$Debouncer$Internal$Config = $elm$core$Basics$identity;
var $Gizra$elm_debouncer$Debouncer$Internal$lastInput = F2(
	function (i, o) {
		return $elm$core$Maybe$Just(i);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$manual = {cc: $Gizra$elm_debouncer$Debouncer$Internal$lastInput, bg: $elm$core$Maybe$Nothing, bh: $elm$core$Maybe$Nothing, bu: $elm$core$Maybe$Nothing};
var $Gizra$elm_debouncer$Debouncer$Basic$manual = $Gizra$elm_debouncer$Debouncer$Internal$manual;
var $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor = F2(
	function (time, _v0) {
		var config = _v0;
		return _Utils_update(
			config,
			{bu: time});
	});
var $Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor = $Gizra$elm_debouncer$Debouncer$Internal$settleWhenQuietFor;
var $Gizra$elm_debouncer$Debouncer$Basic$debounce = function (interval) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Basic$settleWhenQuietFor,
		$elm$core$Maybe$Just(interval),
		$Gizra$elm_debouncer$Debouncer$Basic$manual);
};
var $Gizra$elm_debouncer$Debouncer$Internal$fromSeconds = function (s) {
	return $elm$core$Basics$round(s * 1000);
};
var $Gizra$elm_debouncer$Debouncer$Basic$fromSeconds = $Gizra$elm_debouncer$Debouncer$Internal$fromSeconds;
var $Gizra$elm_debouncer$Debouncer$Internal$Debouncer = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$Settled = {$: 0};
var $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative = $elm$core$Maybe$andThen(
	function (num) {
		return (num < 0) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(num);
	});
var $Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig = function (_v0) {
	var config = _v0;
	return {
		cc: config.cc,
		bg: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.bg),
		bh: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.bh),
		bu: $Gizra$elm_debouncer$Debouncer$Internal$nothingIfNegative(config.bu)
	};
};
var $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer = function (config) {
	return A2(
		$Gizra$elm_debouncer$Debouncer$Internal$Debouncer,
		$Gizra$elm_debouncer$Debouncer$Internal$sanitizeConfig(config),
		$Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer = $Gizra$elm_debouncer$Debouncer$Internal$toDebouncer;
var $author$project$Platform2$AutocompleteInput$init = function (config) {
	return {
		dr: $Gizra$elm_debouncer$Debouncer$Basic$toDebouncer(
			$Gizra$elm_debouncer$Debouncer$Basic$debounce(
				$Gizra$elm_debouncer$Debouncer$Basic$fromSeconds(config.jX))),
		cW: '',
		u: config.u,
		dI: 0,
		by: $elm$core$Maybe$Nothing
	};
};
var $author$project$Dashboards2$Detail$EditGrid = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$initEditGrid = F2(
	function (config, editSection) {
		var placeholderDimensions = function () {
			if (editSection.$ === 1) {
				var data = editSection.a;
				return data.ir;
			} else {
				return A2($author$project$ResizeObserver$Dimensions, 0, 0);
			}
		}();
		return $author$project$Dashboards2$Detail$EditGrid(
			{fJ: config.V.dl.k8, eD: $elm$core$Maybe$Nothing, b1: $elm$core$Maybe$Nothing, ir: placeholderDimensions});
	});
var $turboMaCk$any_set$Set$Any$insert = F2(
	function (a, _v0) {
		var dict = _v0;
		return A3($turboMaCk$any_dict$Dict$Any$insert, a, 0, dict);
	});
var $author$project$Gwi$Browser$Dom$BottomRight = 3;
var $author$project$Gwi$Browser$Dom$Point = F2(
	function (x, y) {
		return {m3: x, m4: y};
	});
var $author$project$Gwi$Browser$Dom$TopLeft = 0;
var $author$project$Gwi$Browser$Dom$BottomLeft = 2;
var $author$project$Gwi$Browser$Dom$TopRight = 1;
var $author$project$Gwi$List$joinIf = F3(
	function (cond, listToJoin, sourceList) {
		return cond ? _Utils_ap(sourceList, listToJoin) : sourceList;
	});
var $author$project$Gwi$Browser$Dom$pointsPositionRelation = function (_v0) {
	var mainPoint = _v0.h7;
	var pointToGetPosition = _v0.is;
	return A3(
		$author$project$Gwi$List$joinIf,
		(_Utils_cmp(mainPoint.m3, pointToGetPosition.m3) < 0) && _Utils_eq(mainPoint.m4, pointToGetPosition.m4),
		_List_fromArray(
			[1, 3]),
		A3(
			$author$project$Gwi$List$joinIf,
			(_Utils_cmp(mainPoint.m3, pointToGetPosition.m3) > 0) && _Utils_eq(mainPoint.m4, pointToGetPosition.m4),
			_List_fromArray(
				[0, 2]),
			A3(
				$author$project$Gwi$List$joinIf,
				_Utils_eq(mainPoint.m3, pointToGetPosition.m3) && (_Utils_cmp(mainPoint.m4, pointToGetPosition.m4) < 0),
				_List_fromArray(
					[2, 3]),
				A3(
					$author$project$Gwi$List$joinIf,
					_Utils_eq(mainPoint.m3, pointToGetPosition.m3) && (_Utils_cmp(mainPoint.m4, pointToGetPosition.m4) > 0),
					_List_fromArray(
						[0, 1]),
					A3(
						$author$project$Gwi$List$addIf,
						(_Utils_cmp(mainPoint.m3, pointToGetPosition.m3) < 0) && (_Utils_cmp(mainPoint.m4, pointToGetPosition.m4) < 0),
						3,
						A3(
							$author$project$Gwi$List$addIf,
							(_Utils_cmp(mainPoint.m3, pointToGetPosition.m3) > 0) && (_Utils_cmp(mainPoint.m4, pointToGetPosition.m4) < 0),
							2,
							A3(
								$author$project$Gwi$List$addIf,
								(_Utils_cmp(mainPoint.m3, pointToGetPosition.m3) < 0) && (_Utils_cmp(mainPoint.m4, pointToGetPosition.m4) > 0),
								1,
								A3(
									$author$project$Gwi$List$addIf,
									(_Utils_cmp(mainPoint.m3, pointToGetPosition.m3) > 0) && (_Utils_cmp(mainPoint.m4, pointToGetPosition.m4) > 0),
									0,
									_List_Nil))))))));
};
var $author$project$Gwi$Browser$Dom$isVisibleWithOffset = F3(
	function (offset, _v0, _v1) {
		var element = _v0.j4;
		var viewport = _v1.mX;
		var _v2 = _Utils_Tuple2(
			A2($author$project$Gwi$Browser$Dom$Point, -offset, -offset),
			A2($author$project$Gwi$Browser$Dom$Point, viewport.da + offset, viewport.cv + offset));
		var sceneTopLeft = _v2.a;
		var sceneBottomRight = _v2.b;
		var isPointVisibleInScene = function (point) {
			return A2(
				$elm$core$List$member,
				3,
				$author$project$Gwi$Browser$Dom$pointsPositionRelation(
					{h7: sceneTopLeft, is: point})) && A2(
				$elm$core$List$member,
				0,
				$author$project$Gwi$Browser$Dom$pointsPositionRelation(
					{h7: sceneBottomRight, is: point}));
		};
		var _v3 = _Utils_Tuple2(
			A2($author$project$Gwi$Browser$Dom$Point, element.m3, element.m4),
			A2($author$project$Gwi$Browser$Dom$Point, element.m3 + element.da, element.m4 + element.cv));
		var elementTopLeft = _v3.a;
		var elementBottomRight = _v3.b;
		return isPointVisibleInScene(elementTopLeft) || isPointVisibleInScene(elementBottomRight);
	});
var $author$project$Gwi$Browser$Dom$isElementVisible = function (_v0) {
	var scrollParentId = _v0.lV;
	var elementId = _v0.j5;
	var offset = _v0.lm;
	return A3(
		$elm$core$Task$map2,
		$author$project$Gwi$Browser$Dom$isVisibleWithOffset(offset),
		$elm$browser$Browser$Dom$getElement(elementId),
		$elm$browser$Browser$Dom$getViewportOf(scrollParentId));
};
var $author$project$Dashboards2$Widget$isWidgetVisible = function ($) {
	return $.cz;
};
var $author$project$Dashboards2$mapEditGridState = F2(
	function (fn, model) {
		var _v0 = model.o;
		if (_v0.$ === 1) {
			var r = _v0.a;
			var _v1 = fn(r);
			var newEditGridData = _v1.a;
			var cmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						o: $author$project$Dashboards2$Detail$EditGrid(newEditGridData)
					}),
				cmds);
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Dashboards2$UserFilters$maxNumberOfAudiences = 4;
var $GlobalWebIndex$cmd_extra$Cmd$Extra$maybe = function (maybeMsg) {
	return A2(
		$elm$core$Maybe$withDefault,
		$elm$core$Platform$Cmd$none,
		A2($elm$core$Maybe$map, $GlobalWebIndex$cmd_extra$Cmd$Extra$perform, maybeMsg));
};
var $author$project$Data$Audience$Expression$namespaceCodes = function (expr) {
	return A2(
		$elm$core$List$map,
		$author$project$Data$Labels$questionCodeToNamespaceCode,
		$author$project$Data$Audience$Expression$questionCodes(expr));
};
var $author$project$Data$Platform2$newRichTextWidget = F3(
	function (content, dashboardId, position) {
		return {
			U: $author$project$Data$Platform2$RichText(content),
			bf: dashboardId,
			cv: 1,
			b: $author$project$Data$Platform2$nullId,
			lB: position,
			da: 2
		};
	});
var $elm_community$list_extra$List$Extra$notMember = function (x) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$not,
		$elm$core$List$member(x));
};
var $author$project$Platform2$Drawers$Datasets = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Platform2$Drawers$NoWarning = {$: 0};
var $author$project$Gwi$List$combineRemoteData = function (list) {
	return A3(
		$elm$core$List$foldl,
		$krisajenkins$remotedata$RemoteData$map2($elm$core$List$cons),
		$krisajenkins$remotedata$RemoteData$Success(_List_Nil),
		list);
};
var $author$project$Data$Labels$mergeLineage = F2(
	function (currentNamespace, _v0) {
		var ancestors = _v0.g7;
		var descendants = _v0.j_;
		return A2(
			$elm$core$List$cons,
			currentNamespace,
			_Utils_ap(ancestors, descendants));
	});
var $author$project$Data$Labels$compatibleNamespaces = F2(
	function (lineages, namespaceCode) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Data$Labels$mergeLineage(namespaceCode),
				$author$project$Data$Id$setFromList),
			A2(
				$elm$core$Maybe$withDefault,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A2($turboMaCk$any_dict$Dict$Any$get, namespaceCode, lineages)));
	});
var $elm$core$Dict$intersect = F2(
	function (t1, t2) {
		return A2(
			$elm$core$Dict$filter,
			F2(
				function (k, _v0) {
					return A2($elm$core$Dict$member, k, t2);
				}),
			t1);
	});
var $turboMaCk$any_dict$Dict$Any$intersect = F2(
	function (_v0, _v1) {
		var inner = _v0;
		var dict = _v1.i;
		return _Utils_update(
			inner,
			{
				i: A2($elm$core$Dict$intersect, inner.i, dict)
			});
	});
var $turboMaCk$any_set$Set$Any$intersect = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return A2($turboMaCk$any_dict$Dict$Any$intersect, d1, d2);
	});
var $author$project$Data$Labels$compatibleNamespacesWithAll = F2(
	function (lineages, namespaceCodes) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			function (compatibles) {
				var all = A3($elm$core$List$foldl, $turboMaCk$any_set$Set$Any$union, $author$project$Data$Id$emptySet, compatibles);
				return A3($elm$core$List$foldl, $turboMaCk$any_set$Set$Any$intersect, all, compatibles);
			},
			$author$project$Gwi$List$combineRemoteData(
				A2(
					$elm$core$List$map,
					$author$project$Data$Labels$compatibleNamespaces(lineages),
					namespaceCodes)));
	});
var $Janiczek$elm_bidict$BiDict$Assoc$get = F2(
	function (from, _v0) {
		var d = _v0;
		return A2($pzp1997$assoc_list$AssocList$get, from, d.r);
	});
var $author$project$Data$Platform2$isNamespaceCodeCompatibleWithDatasets = F4(
	function (datasets, datasetsToNamespaces, lineages, namespaceCode) {
		var selectedNamespaceCodes = A2(
			$elm$core$List$filterMap,
			function (code) {
				return A2($Janiczek$elm_bidict$BiDict$Assoc$get, code, datasetsToNamespaces);
			},
			datasets);
		var compatibleNamespaces = A2(
			$turboMaCk$any_set$Set$Any$union,
			A2($turboMaCk$any_set$Set$Any$fromList, $author$project$Data$Id$unwrap, selectedNamespaceCodes),
			A2(
				$krisajenkins$remotedata$RemoteData$withDefault,
				$author$project$Data$Id$emptySet,
				A2($author$project$Data$Labels$compatibleNamespacesWithAll, lineages, selectedNamespaceCodes)));
		return $elm$core$List$isEmpty(datasets) || A2($turboMaCk$any_set$Set$Any$member, namespaceCode, compatibleNamespaces);
	});
var $author$project$Platform2$Drawers$computeDatasetCompatibilities = F2(
	function (store, data) {
		return A2(
			$krisajenkins$remotedata$RemoteData$withDefault,
			data,
			A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (datasetsToNamespaces) {
					return _Utils_update(
						data,
						{
							f$: A3(
								$author$project$Data$Platform2$isNamespaceCodeCompatibleWithDatasets,
								$turboMaCk$any_set$Set$Any$toList(data.l7),
								datasetsToNamespaces,
								store.cB)
						});
				},
				store.fC));
	});
var $author$project$Platform2$Drawers$openDatasets = F3(
	function (config, _v0, store) {
		var selectedDatasets = _v0.l7;
		var computeIncompatibilities = _v0.n5;
		return A2(
			$author$project$Platform2$Drawers$Datasets,
			config,
			A2(
				$author$project$Platform2$Drawers$computeDatasetCompatibilities,
				store,
				{
					n5: computeIncompatibilities,
					ci: $author$project$Platform2$Drawers$NoWarning,
					el: false,
					f$: $elm$core$Basics$always(true),
					eK: $author$project$Data$Id$emptySet,
					eO: selectedDatasets,
					cW: '',
					l7: selectedDatasets,
					bv: false
				}));
	});
var $author$project$Platform2$Drawers$Locations = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Platform2$Drawers$LocationsRoot = {$: 0};
var $author$project$Data$Labels$comparableRegionCode = function (code) {
	switch (code) {
		case 0:
			return 1;
		case 2:
			return 2;
		case 1:
			return 3;
		default:
			return 4;
	}
};
var $author$project$Platform2$Drawers$openLocations = F2(
	function (config, _v0) {
		var selectedLocations = _v0.l8;
		var segmenting = _v0.rc;
		var getLocations = _v0.oV;
		var footerWarning = _v0.kg;
		return A2(
			$author$project$Platform2$Drawers$Locations,
			config,
			{
				kg: footerWarning,
				oV: getLocations,
				fY: segmenting,
				fZ: selectedLocations,
				dF: $author$project$Platform2$Drawers$LocationsRoot,
				eM: $turboMaCk$any_set$Set$Any$empty($author$project$Data$Labels$comparableRegionCode),
				rc: segmenting,
				l8: selectedLocations
			});
	});
var $author$project$Platform2$Drawers$Waves = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $author$project$Platform2$Drawers$openWaves = F2(
	function (config, _v0) {
		var selectedWaves = _v0.l9;
		var getWaves = _v0.oX;
		var footerWarning = _v0.kg;
		return A2(
			$author$project$Platform2$Drawers$Waves,
			config,
			{kg: footerWarning, oX: getWaves, f_: selectedWaves, eN: $elm$core$Set$empty, l9: selectedWaves});
	});
var $elm$core$String$fromList = _String_fromList;
var $elm$core$String$words = _String_words;
var $author$project$Dashboards2$parseBulkAddOrganisationIds = function (input) {
	return A2(
		$elm$core$List$map,
		$author$project$Data$Id$fromString,
		$elm$core$String$words(
			$elm$core$String$fromList(
				A2(
					$elm$core$List$map,
					function (c) {
						return $elm$core$Char$isDigit(c) ? c : ' ';
					},
					$elm$core$String$toList(input)))));
};
var $author$project$UndoRedo$redo = function (_v0) {
	var data = _v0;
	var _v1 = $elm$core$List$reverse(data.bj);
	if (!_v1.b) {
		return data;
	} else {
		var lastAdded = _v1.a;
		var restOfFuture = _v1.b;
		return _Utils_update(
			data,
			{
				aq: lastAdded,
				bj: $elm$core$List$reverse(restOfFuture),
				a4: A3($author$project$UndoRedo$addWithLimit, data.gd, data.aq, data.a4)
			});
	}
};
var $author$project$Data$Platform2$IncompatibilitiesResult = F3(
	function (cleansedDashboard, removedWidgets, removedAudiences) {
		return {jH: cleansedDashboard, gE: removedAudiences, gF: removedWidgets};
	});
var $elm$core$Dict$diff = F2(
	function (t1, t2) {
		return A3(
			$elm$core$Dict$foldl,
			F3(
				function (k, v, t) {
					return A2($elm$core$Dict$remove, k, t);
				}),
			t1,
			t2);
	});
var $turboMaCk$any_dict$Dict$Any$diff = F2(
	function (_v0, _v1) {
		var inner = _v0;
		var dict = _v1.i;
		return _Utils_update(
			inner,
			{
				i: A2($elm$core$Dict$diff, inner.i, dict)
			});
	});
var $turboMaCk$any_set$Set$Any$diff = F2(
	function (_v0, _v1) {
		var d1 = _v0;
		var d2 = _v1;
		return A2($turboMaCk$any_dict$Dict$Any$diff, d1, d2);
	});
var $author$project$Data$Platform2$removeAllIncompatibilitiesFromDashboard = F4(
	function (allAudiences, datasetsToNamespaces, lineages, dashboard) {
		var data = dashboard.cl;
		var getDescendants = function (namespaceCode) {
			return A2(
				$krisajenkins$remotedata$RemoteData$withDefault,
				_List_Nil,
				A2(
					$krisajenkins$remotedata$RemoteData$map,
					function ($) {
						return $.j_;
					},
					A2(
						$elm$core$Maybe$withDefault,
						$krisajenkins$remotedata$RemoteData$NotAsked,
						A2($turboMaCk$any_dict$Dict$Any$get, namespaceCode, lineages))));
		};
		var filters = data.C;
		var dashboardNamespaces = $author$project$Data$Id$setFromList(
			A2(
				$author$project$Gwi$List$fastConcatMap,
				function (code) {
					return A2(
						$elm$core$List$cons,
						code,
						getDescendants(code));
				},
				A2(
					$elm$core$List$filterMap,
					function (code) {
						return A2($Janiczek$elm_bidict$BiDict$Assoc$get, code, datasetsToNamespaces);
					},
					dashboard.es)));
		var checkAudienceId = function (audienceId) {
			return A2(
				$elm$core$Maybe$andThen,
				function (audience) {
					return $turboMaCk$any_set$Set$Any$isEmpty(
						function (codes) {
							return A2($turboMaCk$any_set$Set$Any$diff, codes, dashboardNamespaces);
						}(
							$author$project$Data$Id$setFromList(
								$author$project$Data$Audience$Expression$namespaceCodes(audience.bY)))) ? $elm$core$Maybe$Just(audience.b) : $elm$core$Maybe$Nothing;
				},
				A2($turboMaCk$any_dict$Dict$Any$get, audienceId, allAudiences));
		};
		var newAudiences = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$elm$core$List$filterMap(checkAudienceId),
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Maybe$Just,
					$elm_community$maybe_extra$Maybe$Extra$filter(
						A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)))),
			filters.d9);
		var cleansedAudiences = $turboMaCk$any_set$Set$Any$toList(
			A2(
				$turboMaCk$any_set$Set$Any$diff,
				A2(
					$turboMaCk$any_set$Set$Any$fromList,
					$author$project$Data$Id$unwrap,
					A2($elm$core$Maybe$withDefault, _List_Nil, filters.d9)),
				A2(
					$turboMaCk$any_set$Set$Any$fromList,
					$author$project$Data$Id$unwrap,
					A2($elm$core$Maybe$withDefault, _List_Nil, newAudiences))));
		var sanitizedFilters = _Utils_update(
			filters,
			{
				d9: newAudiences,
				aU: A2($elm$core$Maybe$andThen, checkAudienceId, filters.aU)
			});
		var _v0 = A2(
			$elm$core$List$partition,
			function (widget) {
				var _v1 = widget.U;
				if (!_v1.$) {
					var chartWidget = _v1.a;
					var namespacesForWidget = $author$project$Data$Id$setFromList(
						$author$project$Data$Platform2$namespacesForChartWidget(chartWidget));
					return $turboMaCk$any_set$Set$Any$isEmpty(
						A2($turboMaCk$any_set$Set$Any$diff, namespacesForWidget, dashboardNamespaces));
				} else {
					return true;
				}
			},
			data.g);
		var goodWidgets = _v0.a;
		var cleansedWidgets = _v0.b;
		return A3(
			$author$project$Data$Platform2$IncompatibilitiesResult,
			_Utils_update(
				dashboard,
				{
					cl: _Utils_update(
						data,
						{C: sanitizedFilters, g: goodWidgets})
				}),
			cleansedWidgets,
			cleansedAudiences);
	});
var $elm_community$list_extra$List$Extra$removeAt = F2(
	function (index, l) {
		if (index < 0) {
			return l;
		} else {
			var _v0 = A2($elm$core$List$drop, index, l);
			if (!_v0.b) {
				return l;
			} else {
				var rest = _v0.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, l),
					rest);
			}
		}
	});
var $author$project$Dashboards2$UserFilters$removeAudienceAtIndex = F3(
	function (config, index, _v0) {
		var uf = _v0;
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
			config.oM(1),
			_Utils_update(
				uf,
				{
					d9: A2($elm_community$list_extra$List$Extra$removeAt, index, uf.d9)
				}));
	});
var $author$project$Dashboards2$UserFilters$removeIncompatibleAudiences = F4(
	function (config, flags, namespaceCodes, _v0) {
		var userFilters = _v0;
		var isCompatibleAudience = function (audience) {
			return A2(
				$elm$core$List$all,
				function (namespaceCode) {
					return A2($elm$core$List$member, namespaceCode, namespaceCodes);
				},
				A2(
					$elm$core$List$map,
					$author$project$Data$Labels$questionCodeToNamespaceCode,
					$author$project$Data$Audience$Expression$questionCodes(audience.bY)));
		};
		var newData = _Utils_update(
			userFilters,
			{
				d9: A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fk;
						},
						isCompatibleAudience),
					userFilters.d9),
				aU: function () {
					var _v1 = userFilters.aU;
					if (!_v1.$) {
						return userFilters.aU;
					} else {
						var audience = _v1.a;
						return isCompatibleAudience(audience) ? userFilters.aU : $author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$NotAsked);
					}
				}()
			});
		var hasChanged = (!_Utils_eq(newData.aU, userFilters.aU)) || (!_Utils_eq(newData.d9, userFilters.d9));
		var cmdsIfChanged = hasChanged ? A2(
			$elm$core$Basics$composeR,
			A2($author$project$Dashboards2$UserFilters$fetchSampleSize, config, flags),
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
				config.oM(1))) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
		return cmdsIfChanged(newData);
	});
var $author$project$Dashboards2$Editable$update = F2(
	function (a, editable) {
		switch (editable.$) {
			case 0:
				return $author$project$Dashboards2$Editable$NotEdited(a);
			case 2:
				return $author$project$Dashboards2$Editable$Edited(a);
			default:
				return $author$project$Dashboards2$Editable$NotEdited(a);
		}
	});
var $author$project$Dashboards2$removeIncompatibleAudiences = F4(
	function (config, flags, namespaceCodes, model) {
		var _v0 = _Utils_Tuple2(
			$author$project$Dashboards2$Editable$isEdited(
				$author$project$Dashboards2$Detail$currentEditableUserFilters(model)),
			$author$project$Dashboards2$getUserFilters(model));
		if (_v0.a && (!_v0.b.$)) {
			var userFilters = _v0.b.a;
			var _v1 = A4($author$project$Dashboards2$UserFilters$removeIncompatibleAudiences, $author$project$Dashboards2$userFiltersConfig, flags, namespaceCodes, userFilters);
			var newUserFilters = _v1.a;
			var userFiltersCmds = _v1.b;
			return A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
				A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds),
				A2(
					$author$project$Dashboards2$updateCurrentUserFilters,
					$author$project$Dashboards2$Editable$update(newUserFilters),
					model));
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $elm_community$list_extra$List$Extra$updateAt = F3(
	function (index, fn, list) {
		if (index < 0) {
			return list;
		} else {
			var tail = A2($elm$core$List$drop, index, list);
			if (tail.b) {
				var x = tail.a;
				var xs = tail.b;
				return _Utils_ap(
					A2($elm$core$List$take, index, list),
					A2(
						$elm$core$List$cons,
						fn(x),
						xs));
			} else {
				return list;
			}
		}
	});
var $elm_community$list_extra$List$Extra$setAt = F2(
	function (index, value) {
		return A2(
			$elm_community$list_extra$List$Extra$updateAt,
			index,
			$elm$core$Basics$always(value));
	});
var $author$project$Dashboards2$UserFilters$replaceAudienceAtIndex = F5(
	function (config, flags, index, audience_, _v0) {
		var uf = _v0;
		var _v1 = A2($elm_community$list_extra$List$Extra$getAt, index, uf.d9);
		if (!_v1.$) {
			var colored = _v1.a;
			var newColored = _Utils_update(
				colored,
				{
					fk: {bY: audience_.bY, b: audience_.b, pr: false, ld: audience_.ld, eQ: $krisajenkins$remotedata$RemoteData$NotAsked}
				});
			return A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
				config.oM(1),
				A3(
					$author$project$Dashboards2$UserFilters$fetchSampleSize,
					config,
					flags,
					_Utils_update(
						uf,
						{
							d9: A3($elm_community$list_extra$List$Extra$setAt, index, newColored, uf.d9)
						})));
		} else {
			return _Utils_Tuple2(uf, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Dashboards2$UserFilters$resetBaseAudience = F3(
	function (config, flags, _v0) {
		var r = _v0;
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.oM(1),
			A3(
				$author$project$Dashboards2$UserFilters$fetchSampleSize,
				config,
				flags,
				_Utils_update(
					r,
					{
						d9: A2(
							$elm$core$List$map,
							function (colored) {
								var audience = colored.fk;
								return _Utils_update(
									colored,
									{
										fk: _Utils_update(
											audience,
											{eQ: $krisajenkins$remotedata$RemoteData$NotAsked})
									});
							},
							r.d9),
						aU: $author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$NotAsked)
					})));
	});
var $author$project$Store$Platform2$SaveDashboardsUserSettings = function (a) {
	return {$: 17, a: a};
};
var $author$project$Data$Platform2$mapDashboardsDoNotShowAgain = F2(
	function (update, userSettings) {
		return _Utils_update(
			userSettings,
			{
				bF: update(userSettings.bF)
			});
	});
var $author$project$Dashboards2$saveContinueAnalysisUserSettingsIfRequired = F4(
	function (config, userChoice, store, modal) {
		if (modal.$ === 1) {
			var data = modal.a;
			var _v1 = data.bF;
			if (!_v1.$) {
				return $elm$core$Basics$identity;
			} else {
				var cond = _v1.a;
				return cond ? A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Data$Platform2$mapDashboardsDoNotShowAgain(
							function (settings) {
								return _Utils_update(
									settings,
									{jN: userChoice});
							}),
						A2(
							$elm$core$Basics$composeR,
							$author$project$Store$Platform2$SaveDashboardsUserSettings,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$List$singleton,
								A2($elm$core$Basics$composeR, config.l, $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger)))),
					$krisajenkins$remotedata$RemoteData$toMaybe(store.jU)) : $elm$core$Basics$identity;
			}
		} else {
			return $elm$core$Basics$identity;
		}
	});
var $author$project$Dashboards2$Permissions$canSaveFilters = F3(
	function (user, can, dashboard) {
		var _v0 = dashboard.ah;
		switch (_v0.$) {
			case 3:
				return false;
			case 1:
				return can(23);
			case 2:
				return can(24) && _Utils_eq(user.b, dashboard.dG);
			case 0:
				return _Utils_eq(user.b, dashboard.dG);
			case 4:
				return can(23) || _Utils_eq(user.b, dashboard.dG);
			case 5:
				return false;
			case 6:
				return can(23) || _Utils_eq(user.b, dashboard.dG);
			case 7:
				return can(24) && _Utils_eq(user.b, dashboard.dG);
			default:
				return can(23);
		}
	});
var $author$project$Dashboards2$Detail$canOnlyDuplicate = F3(
	function (flags, currentDashboard, model) {
		var isSharedWithSomeone = !_Utils_eq(currentDashboard.ah, $author$project$Data$Platform2$PrivateDashboard);
		var isNotEditMode = !$author$project$Dashboards2$Detail$isEditMode(model.o);
		var isGwiCreator = flags.nM(23);
		var canSaveFilters = A3($author$project$Dashboards2$Permissions$canSaveFilters, flags.mQ, flags.nM, currentDashboard);
		return (isGwiCreator && (isNotEditMode && isSharedWithSomeone)) || ((!isGwiCreator) && (!canSaveFilters));
	});
var $author$project$Dashboards2$canOnlyDuplicate = $author$project$Dashboards2$Detail$canOnlyDuplicate;
var $author$project$Dashboards2$Editable$setReadyIfEdited = function (editable) {
	switch (editable.$) {
		case 0:
			return editable;
		case 2:
			var a = editable.a;
			return $author$project$Dashboards2$Editable$NotEdited(a);
		default:
			return editable;
	}
};
var $author$project$Dashboards2$setNotEdited = function (model) {
	return _Utils_update(
		model,
		{
			G: A2(
				$author$project$UndoRedo$updateCurrent,
				function (undoRedo) {
					return _Utils_update(
						undoRedo,
						{
							bz: $author$project$Dashboards2$Editable$setReadyIfEdited(undoRedo.bz)
						});
				},
				model.G),
			ba: $elm$core$Maybe$Nothing
		});
};
var $author$project$Dashboards2$saveDashboard = F6(
	function (flags, config, route, newRoute, store, model) {
		var _v0 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
		if (!_v0.$) {
			var savedDashboard = _v0.a;
			if ($author$project$Dashboards2$isUnsaved(model)) {
				return A3($author$project$Dashboards2$canOnlyDuplicate, flags, savedDashboard, model) ? A4($author$project$Dashboards2$duplicateDashboard, flags, route, store, model) : A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.cS(
						A3(
							$author$project$Dashboards2$Detail$applyEdits,
							model.ba,
							$author$project$Dashboards2$getUserFilters(model),
							savedDashboard)),
					$author$project$Dashboards2$setNotEdited(
						_Utils_update(
							model,
							{a6: newRoute})));
			} else {
				var withForceNavigateTo = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					A2($elm$core$Basics$composeL, $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger, config.aM),
					newRoute);
				return A2(
					$elm$core$Maybe$withDefault,
					withForceNavigateTo(
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)),
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$mapFirst($author$project$Dashboards2$setNotEdited),
						A2(
							$elm$core$Maybe$map,
							function (edits) {
								return _Utils_eq(savedDashboard.ld, edits.ld) ? withForceNavigateTo(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
										_Utils_update(
											model,
											{ba: $elm$core$Maybe$Nothing}))) : A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
									config.cS(
										A3(
											$author$project$Dashboards2$Detail$applyEdits,
											$elm$core$Maybe$Just(edits),
											$author$project$Dashboards2$getUserFilters(model),
											savedDashboard)),
									_Utils_update(
										model,
										{a6: newRoute}));
							},
							model.ba)));
			}
		} else {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Dashboards2$Analytics$ChartWidgetSaved = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboards2$Analytics$TextWidgetSaved = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2$saveWidget = F6(
	function (config, flags, route, store, updatedWidget, model) {
		var _v0 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
		if (!_v0.$) {
			var savedDashboard = _v0.a;
			var data = savedDashboard.cl;
			var widgetChangedProp = F2(
				function (prop, widgets) {
					return A2(
						$elm$core$List$any,
						function (w) {
							if (_Utils_eq(w.b, updatedWidget.b)) {
								var _v3 = _Utils_Tuple2(
									$author$project$Data$Platform2$getChartWidget(w),
									$author$project$Data$Platform2$getChartWidget(updatedWidget));
								if ((!_v3.a.$) && (!_v3.b.$)) {
									var oldChartWidget = _v3.a.a;
									var updatedChartWidget = _v3.b.a;
									return !_Utils_eq(
										prop(oldChartWidget),
										prop(updatedChartWidget));
								} else {
									return false;
								}
							} else {
								return false;
							}
						},
						widgets);
				});
			var newWidgets = A2(
				$elm$core$List$map,
				function (w) {
					return _Utils_eq(w.b, updatedWidget.b) ? updatedWidget : w;
				},
				data.g);
			return A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
				$author$project$Dashboards2$Analytics$trackEvent(
					function () {
						var _v1 = updatedWidget.U;
						if (_v1.$ === 1) {
							var richText = _v1.a;
							return $author$project$Dashboards2$Analytics$TextWidgetSaved(
								{bO: richText});
						} else {
							var c = _v1.a;
							return $author$project$Dashboards2$Analytics$ChartWidgetSaved(
								{
									hh: c.ld,
									aI: c.aI,
									nW: A2(
										widgetChangedProp,
										function ($) {
											return $.aI;
										},
										data.g),
									bf: savedDashboard.b,
									bC: savedDashboard.ld,
									ov: true,
									fX: c.b2,
									kC: function () {
										var _v2 = c.aU;
										if (_v2.$ === 1) {
											return true;
										} else {
											return false;
										}
									}(),
									a0: flags.nM(23),
									kP: A2(
										widgetChangedProp,
										function ($) {
											return $.ld;
										},
										data.g),
									dB: c.dB,
									cY: c.cY
								});
						}
					}()),
				A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					A2(
						config.ag,
						_Utils_update(
							savedDashboard,
							{
								cl: _Utils_update(
									data,
									{g: newWidgets})
							}),
						4),
					_Utils_update(
						model,
						{
							o: A2($author$project$Dashboards2$initEditGrid, config, model.o)
						})));
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Dashboards2$UserFilters$setAudiencesOrder = F2(
	function (newAudiencesOrder, _v0) {
		var r = _v0;
		var audienceWithOrder = A2(
			$turboMaCk$any_dict$Dict$Any$fromList,
			$author$project$Data$Id$unwrap,
			A2(
				$elm$core$List$indexedMap,
				F2(
					function (order, id) {
						return _Utils_Tuple2(id, order);
					}),
				newAudiencesOrder));
		var getOrder = function (audience) {
			return A2(
				$elm$core$Maybe$withDefault,
				-1,
				A2($turboMaCk$any_dict$Dict$Any$get, audience.b, audienceWithOrder));
		};
		return _Utils_update(
			r,
			{
				d9: A2(
					$elm$core$List$sortBy,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.fk;
						},
						getOrder),
					r.d9)
			});
	});
var $author$project$Dashboards2$Chart$NoOp = {$: 0};
var $author$project$Dashboards2$Widget$SetChartTypeAndSave = F2(
	function (a, b) {
		return {$: 11, a: a, b: b};
	});
var $author$project$Dashboards2$Analytics$ChartsSortingChanged = function (a) {
	return {$: 32, a: a};
};
var $author$project$Dashboards2$Analytics$ChartsTypeChanged = function (a) {
	return {$: 33, a: a};
};
var $author$project$Dashboards2$Analytics$DashboardDataTableShown = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Widget$DataTableTab = 1;
var $author$project$Dashboards2$Widget$EditDropdown = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Widget$HideMetadataTooltip = {$: 19};
var $author$project$Dashboards2$Widget$Hiding = 1;
var $author$project$Data$Upsell$QuestionResource = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Widget$StoreActionMany = function (a) {
	return {$: 20, a: a};
};
var $author$project$Dashboards2$Widget$Visible = 2;
var $GlobalWebIndex$cmd_extra$Cmd$Extra$addTriggerMaybe = F2(
	function (maybeMsg, _v0) {
		var model = _v0.a;
		var cmd = _v0.b;
		if (!maybeMsg.$) {
			var msg = maybeMsg.a;
			return A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
				msg,
				_Utils_Tuple2(model, cmd));
		} else {
			return _Utils_Tuple2(model, cmd);
		}
	});
var $author$project$Dashboards2$Widget$isEditDropdown = function (model) {
	var _v0 = model.w;
	switch (_v0.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		case 3:
			return false;
		default:
			return false;
	}
};
var $turboMaCk$any_set$Set$Any$filter = F2(
	function (f, _v0) {
		var dict = _v0;
		return A2(
			$turboMaCk$any_dict$Dict$Any$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$always, f),
			dict);
	});
var $author$project$RemoteData$Loaded$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $author$project$RemoteData$Loaded$FailureL(e);
	} else {
		var a = result.a;
		return $author$project$RemoteData$Loaded$SuccessL(a);
	}
};
var $author$project$Dashboards2$Chart$getWidgetDimensions = function (widget) {
	return A2(
		$elm$core$Task$attempt,
		A2(
			$elm$core$Basics$composeR,
			$elm$core$Result$map(
				function (_v0) {
					var viewport = _v0.mX;
					return $author$project$Dashboards2$Chart$WidgetDimensionsChanged(
						A2($author$project$ResizeObserver$Dimensions, viewport.da, viewport.cv));
				}),
			$elm$core$Result$withDefault($author$project$Dashboards2$Chart$NoOp)),
		$elm$browser$Browser$Dom$getViewportOf(
			$author$project$Dashboards2$Chart$resizeObservedElementId(widget)));
};
var $author$project$Dashboards2$StatCard$init = F3(
	function (width, height, widgetId) {
		return {d9: _List_Nil, ai: 0, ax: 0, eb: true, fA: '', cv: height, du: false, dB: 2, sj: widgetId, da: width, sm: 1};
	});
var $author$project$Data$Calc$Platform2$qResultToComparable = function (qResult) {
	var go = F2(
		function (_v2, groupedDatapoints) {
			var questionCode = _v2.at;
			return A2(
				$elm$core$String$join,
				',',
				A2(
					$elm$core$List$cons,
					$author$project$Data$Id$unwrap(questionCode),
					A2(
						$author$project$Gwi$List$fastConcatMap,
						function (_v1) {
							var datapointCode = _v1.eq;
							var suffixCodes = _v1.eY;
							var datapointCode_ = $author$project$Data$Id$unwrap(datapointCode);
							return $elm$core$List$isEmpty(suffixCodes) ? _List_fromArray(
								[datapointCode_]) : A2(
								$elm$core$List$map,
								function (suffixCode) {
									return datapointCode_ + ('_' + $author$project$Data$Id$unwrap(suffixCode));
								},
								suffixCodes);
						},
						groupedDatapoints)));
		});
	switch (qResult.$) {
		case 0:
			var r1 = qResult.a;
			var r2 = qResult.b;
			return A2(go, r1, r2);
		case 1:
			var r1 = qResult.a;
			var r2 = qResult.b;
			return A2(go, r1, r2);
		case 2:
			var r1 = qResult.a;
			var r2 = qResult.b;
			return A2(go, r1, r2);
		default:
			var r1 = qResult.a;
			var r2 = qResult.b;
			return A2(go, r1, r2);
	}
};
var $turboMaCk$any_dict$Dict$Any$singleton = F3(
	function (k, v, f) {
		return A3(
			$turboMaCk$any_dict$Dict$Any$insert,
			k,
			v,
			$turboMaCk$any_dict$Dict$Any$empty(f));
	});
var $turboMaCk$any_set$Set$Any$singleton = function (a) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$Basics$identity,
		A2($turboMaCk$any_dict$Dict$Any$singleton, a, 0));
};
var $author$project$Dashboards2$Chart$onDataReceived = F7(
	function (flags, userFilters, store, result, widget, chartWidget, model) {
		var widgetWithFilteredDatapoints = A2(
			$elm$core$Maybe$withDefault,
			widget,
			A3($author$project$Dashboards2$Chart$removeDatapointsWithUnknownPermissions, flags, store, widget));
		var currentAudienceIds = $author$project$Dashboards2$UserFilters$audienceIds(userFilters);
		var containsOnlyValidAudiences = $elm$core$List$all(
			function (_v8) {
				var audienceId = _v8.jn;
				return A2($elm$core$List$member, audienceId, currentAudienceIds);
			});
		var clearInvalidAudiences = $turboMaCk$any_set$Set$Any$filter(
			function (r) {
				switch (r.$) {
					case 0:
						return $elm$core$List$isEmpty(currentAudienceIds);
					case 1:
						var list = r.b;
						return containsOnlyValidAudiences(list);
					case 2:
						return $elm$core$List$isEmpty(currentAudienceIds);
					default:
						var list = r.b;
						return containsOnlyValidAudiences(list);
				}
			});
		var allLoadedCheck = F2(
			function (userFiltersForResult, data) {
				var paramsListForWidget = A2(
					$elm$core$Maybe$map,
					$elm$core$Tuple$first,
					A3(
						$author$project$Data$Calc$Platform2$paramsFromWidget,
						store,
						$author$project$Dashboards2$UserFilters$toSimpleFilters(userFiltersForResult),
						widgetWithFilteredDatapoints));
				var isAllLoaded = function () {
					var _v6 = _Utils_Tuple2(
						paramsListForWidget,
						A2(
							$elm$core$Maybe$map,
							$turboMaCk$any_set$Set$Any$size,
							A2($turboMaCk$any_dict$Dict$Any$get, userFiltersForResult, data.a)));
					if ((!_v6.a.$) && (!_v6.b.$)) {
						var list = _v6.a.a;
						var count = _v6.b.a;
						return _Utils_eq(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$length(list),
							count);
					} else {
						return false;
					}
				}();
				return isAllLoaded ? $author$project$RemoteData$Loaded$SuccessL(data) : $author$project$RemoteData$Loaded$LoadingL(
					$elm$core$Maybe$Just(data));
			});
		var prepareNonpaginatedData = function (nonpaginated) {
			return _Utils_update(
				nonpaginated,
				{
					cl: A2(
						$author$project$RemoteData$Loaded$andThen,
						function (_v4) {
							var userFiltersForResult = _v4.a;
							var newResult = _v4.b;
							var dictSoFar = A2(
								$author$project$RemoteData$Loaded$withDefault,
								$turboMaCk$any_dict$Dict$Any$empty($author$project$Dashboards2$UserFilters$toComparable),
								A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$first, nonpaginated.cl));
							var newSet = clearInvalidAudiences(
								function () {
									var _v5 = A2($turboMaCk$any_dict$Dict$Any$get, userFiltersForResult, dictSoFar);
									if (_v5.$ === 1) {
										return A2($turboMaCk$any_set$Set$Any$singleton, newResult, $author$project$Data$Calc$Platform2$qResultToComparable);
									} else {
										var set = _v5.a;
										return A2($turboMaCk$any_set$Set$Any$insert, newResult, set);
									}
								}());
							var newDict = A3($turboMaCk$any_dict$Dict$Any$insert, userFiltersForResult, newSet, dictSoFar);
							return A2(
								allLoadedCheck,
								userFiltersForResult,
								_Utils_Tuple2(newDict, _List_Nil));
						},
						$author$project$RemoteData$Loaded$fromResult(result))
				});
		};
		var newChartData = function () {
			var _v0 = model.h;
			switch (_v0.$) {
				case 0:
					var paginated = _v0.a;
					return $author$project$Dashboards2$Chart$Paginated(
						_Utils_update(
							paginated,
							{
								cl: A2(
									$author$project$RemoteData$Loaded$andThen,
									function (_v1) {
										var userFiltersForResult = _v1.a;
										var qResult = _v1.b;
										return A2(
											allLoadedCheck,
											userFiltersForResult,
											A2(
												$elm$core$Tuple$mapFirst,
												A2(
													$turboMaCk$any_dict$Dict$Any$update,
													userFiltersForResult,
													function (maybeSet) {
														if (!maybeSet.$) {
															var set = maybeSet.a;
															return $elm$core$Maybe$Just(
																clearInvalidAudiences(
																	A2($turboMaCk$any_set$Set$Any$insert, qResult, set)));
														} else {
															return $elm$core$Maybe$Just(
																clearInvalidAudiences(
																	A2($turboMaCk$any_set$Set$Any$singleton, qResult, $author$project$Data$Calc$Platform2$qResultToComparable)));
														}
													}),
												A2(
													$author$project$RemoteData$Loaded$withDefault,
													_Utils_Tuple2(
														$turboMaCk$any_dict$Dict$Any$empty($author$project$Dashboards2$UserFilters$toComparable),
														$elm$core$Maybe$Nothing),
													paginated.cl)));
									},
									$author$project$RemoteData$Loaded$fromResult(result))
							}));
				case 1:
					var nonpaginated = _v0.a;
					return $author$project$Dashboards2$Chart$Nonpaginated(
						prepareNonpaginatedData(nonpaginated));
				case 2:
					var statCard = _v0.a;
					return $author$project$Dashboards2$Chart$StatCardModel(
						A2(
							$author$project$RemoteData$Loaded$andThen,
							function (_v3) {
								var userFiltersForResult = _v3.a;
								var qresult = _v3.b;
								var statCardModel = A2(
									$author$project$RemoteData$Loaded$withDefault,
									A3($author$project$Dashboards2$StatCard$init, widget.da, widget.cv, widget.b),
									A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$second, statCard));
								var newDict = A3($turboMaCk$any_dict$Dict$Any$singleton, userFiltersForResult, qresult, $author$project$Dashboards2$UserFilters$toComparable);
								return A2(
									$author$project$RemoteData$Loaded$map,
									$elm$core$Tuple$pair(newDict),
									A6(
										$author$project$Dashboards2$Chart$buildStatCardData,
										userFiltersForResult,
										store,
										model.hr,
										chartWidget,
										$author$project$RemoteData$Loaded$SuccessL(qresult),
										$author$project$RemoteData$Loaded$SuccessL(statCardModel)));
							},
							$author$project$RemoteData$Loaded$fromResult(result)));
				default:
					var lcModel = _v0.a;
					var nonpaginated = _v0.b;
					return A2(
						$author$project$Dashboards2$Chart$LineChartModel,
						lcModel,
						prepareNonpaginatedData(nonpaginated));
			}
		}();
		return _Utils_Tuple2(
			A5(
				$author$project$Dashboards2$Chart$updateChartData,
				userFilters,
				store,
				widget,
				chartWidget,
				A2($author$project$Dashboards2$Chart$setChartData, model, newChartData)),
			$author$project$Dashboards2$Chart$getWidgetDimensions(widget));
	});
var $GlobalWebIndex$cmd_extra$Cmd$Extra$addIf = F3(
	function (predicate, newCmd, _v0) {
		var model = _v0.a;
		var prevCmd = _v0.b;
		return _Utils_Tuple2(
			model,
			predicate ? $elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[newCmd, prevCmd])) : prevCmd);
	});
var $author$project$Dashboards2$Widget$processRequests = F2(
	function (config, _v0) {
		var cmds = _v0.a;
		var modelCmdsPair = _v0.b;
		return A3(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addIf,
			!$elm$core$List$isEmpty(cmds),
			$GlobalWebIndex$cmd_extra$Cmd$Extra$perform(
				config.qy(cmds)),
			A2($turboMaCk$glue$Glue$map, config.a, modelCmdsPair));
	});
var $author$project$Dashboards2$Widget$requestDataForWidgetInternal = $author$project$Dashboards2$Widget$requestDataForWidget_(
	{bI: false});
var $author$project$Dashboards2$Analytics$WidgetMetricChanged = function (a) {
	return {$: 18, a: a};
};
var $author$project$Dashboards2$Chart$setMetric = F8(
	function (userFilters, store, dashboard, widget, chartWidget, newMetric, place, model) {
		return _Utils_Tuple2(
			A5(
				$author$project$Dashboards2$Chart$updateChartData,
				userFilters,
				store,
				widget,
				chartWidget,
				_Utils_update(
					model,
					{hr: newMetric})),
			A2(
				$elm$core$Maybe$withDefault,
				$elm$core$Platform$Cmd$none,
				A2(
					$elm$core$Maybe$map,
					function (questions) {
						return $author$project$Dashboards2$Analytics$trackEvent(
							$author$project$Dashboards2$Analytics$WidgetMetricChanged(
								{ep: dashboard, dB: newMetric, iq: place, bt: questions, bO: widget}));
					},
					A2($author$project$Dashboards2$Chart$getWidgetQuestions, chartWidget, store))));
	});
var $author$project$Dashboards2$Widget$setMetricWithChartType = F2(
	function (defaultMetric, chartType) {
		return (chartType === 1) ? 3 : defaultMetric;
	});
var $author$project$Dashboards2$Widget$shouldRetry = function (err) {
	_v0$6:
	while (true) {
		switch (err.$) {
			case 1:
				return true;
			case 2:
				return true;
			case 3:
				var statusCode = err.a.rD;
				return statusCode === 429;
			case 5:
				switch (err.c.$) {
					case 11:
						var _v1 = err.c;
						return true;
					case 2:
						var _v2 = err.c;
						return true;
					case 12:
						return true;
					default:
						break _v0$6;
				}
			default:
				break _v0$6;
		}
	}
	return false;
};
var $author$project$Dashboards2$Analytics$DashboardDatapointHighlighted = F4(
	function (a, b, c, d) {
		return {$: 8, a: a, b: b, c: c, d: d};
	});
var $author$project$Dashboards2$Analytics$DashboardPageFlipped = function (a) {
	return {$: 7, a: a};
};
var $author$project$Dashboards2$Analytics$DashboardWaveHighlighted = function (a) {
	return {$: 9, a: a};
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$tail = function (_v0) {
	var t = _v0.b;
	return t;
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$concat = function (_v0) {
	var h = _v0.a;
	var t = _v0.b;
	var tx = _Utils_ap(
		$turboMaCk$non_empty_list_alias$List$NonEmpty$tail(h),
		$elm$core$List$concat(
			A2($elm$core$List$map, $turboMaCk$non_empty_list_alias$List$NonEmpty$toList, t)));
	var hx = $turboMaCk$non_empty_list_alias$List$NonEmpty$head(h);
	return _Utils_Tuple2(hx, tx);
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$nTimes = F3(
	function (n, fn, value) {
		nTimes:
		while (true) {
			if (n <= 0) {
				return value;
			} else {
				var $temp$n = n - 1,
					$temp$fn = fn,
					$temp$value = A2($elm$core$Maybe$andThen, fn, value);
				n = $temp$n;
				fn = $temp$fn;
				value = $temp$value;
				continue nTimes;
			}
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$next = function (_v0) {
	var p = _v0.a;
	var f = _v0.b;
	var n = _v0.c;
	if (!n.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var h = n.a;
		var t = n.b;
		return $elm$core$Maybe$Just(
			A3(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper,
				A2($elm$core$List$cons, f, p),
				h,
				t));
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$prev = function (_v0) {
	var p = _v0.a;
	var f = _v0.b;
	var n = _v0.c;
	if (!p.b) {
		return $elm$core$Maybe$Nothing;
	} else {
		var h = p.a;
		var t = p.b;
		return $elm$core$Maybe$Just(
			A3(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$Zipper,
				t,
				h,
				A2($elm$core$List$cons, f, n)));
	}
};
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toEndHelper = F2(
	function (f, acc) {
		toEndHelper:
		while (true) {
			var _v0 = f(acc);
			if (!_v0.$) {
				var val = _v0.a;
				var $temp$f = f,
					$temp$acc = val;
				f = $temp$f;
				acc = $temp$acc;
				continue toEndHelper;
			} else {
				return acc;
			}
		}
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$start = $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$toEndHelper($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$prev);
var $turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$goToIndex = F2(
	function (index, zipper) {
		return A3(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$nTimes,
			index,
			$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$next,
			$elm$core$Maybe$Just(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$start(zipper)));
	});
var $author$project$Dashboards2$Chart$GwiChart$update = F2(
	function (msg, model) {
		if (!msg.$) {
			var group = msg.a;
			return _Utils_update(
				model,
				{
					fV: $elm$core$Maybe$Just(group)
				});
		} else {
			return _Utils_update(
				model,
				{fV: $elm$core$Maybe$Nothing});
		}
	});
var $author$project$Dashboards2$Chart$HorizontalBarChart$update = $author$project$Dashboards2$Chart$GwiChart$update;
var $author$project$Dashboards2$Chart$LineChart$update = F2(
	function (msg, model) {
		var hovering = msg;
		return _Utils_update(
			model,
			{fV: hovering});
	});
var $author$project$Dashboards2$Chart$VerticalBarChart$update = $author$project$Dashboards2$Chart$GwiChart$update;
var $author$project$Dashboards2$StatCard$move = F2(
	function (model, direction) {
		var step = function () {
			if (direction === 1) {
				return 1;
			} else {
				return -1;
			}
		}();
		var audiencesCount = $elm$core$List$length(model.d9);
		return A2($elm$core$Basics$modBy, (audiencesCount - model.ax) + 1, model.ai + step);
	});
var $author$project$Dashboards2$StatCard$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var index = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ai: A2($author$project$Dashboards2$StatCard$calculatePageOffset, model, index),
							eb: false
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var direction = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ai: A2($author$project$Dashboards2$StatCard$move, model, direction),
							eb: false
						}),
					$elm$core$Platform$Cmd$none);
			default:
				return _Utils_Tuple2(
					model.eb ? _Utils_update(
						model,
						{
							ai: A2($author$project$Dashboards2$StatCard$move, model, 1)
						}) : model,
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Dashboards2$Chart$update = F7(
	function (userFilters, store, dashboard, widget, chartWidget, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var statCardMsg = msg.a;
				var _v1 = model.h;
				if (_v1.$ === 2) {
					var data = _v1.a;
					return A2(
						$author$project$RemoteData$Loaded$withDefault,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						A2(
							$author$project$RemoteData$Loaded$map,
							function (_v2) {
								var statCardModel = _v2.b;
								var _v3 = A2($author$project$Dashboards2$StatCard$update, statCardMsg, statCardModel);
								var newStatCardModel = _v3.a;
								var statCardCmd = _v3.b;
								return _Utils_Tuple2(
									_Utils_update(
										model,
										{
											h: $author$project$Dashboards2$Chart$StatCardModel(
												A2(
													$author$project$RemoteData$Loaded$map,
													$elm$core$Tuple$mapSecond(
														$elm$core$Basics$always(newStatCardModel)),
													data))
										}),
									A2($elm$core$Platform$Cmd$map, $author$project$Dashboards2$Chart$StatCardMsg, statCardCmd));
							},
							data));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 3:
				var dimensions = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A5(
						$author$project$Dashboards2$Chart$updateChartData,
						userFilters,
						store,
						widget,
						chartWidget,
						A2($author$project$Dashboards2$Chart$setDimensions, dimensions, model)));
			case 1:
				var pageIndex = msg.a;
				var _v4 = model.h;
				switch (_v4.$) {
					case 0:
						var paginated = _v4.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Dashboards2$Chart$setChartData,
								model,
								$author$project$Dashboards2$Chart$Paginated(
									_Utils_update(
										paginated,
										{
											cl: A2(
												$author$project$RemoteData$Loaded$map,
												function (_v5) {
													var qresult = _v5.a;
													var maybeZipper = _v5.b;
													return _Utils_Tuple2(
														qresult,
														A2(
															$elm$core$Maybe$map,
															function (zipper) {
																return A2(
																	$elm$core$Maybe$withDefault,
																	zipper,
																	A2($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$goToIndex, pageIndex, zipper));
															},
															maybeZipper));
												},
												paginated.cl)
										}))),
							A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									function (questions) {
										return $author$project$Dashboards2$Analytics$trackEvent(
											$author$project$Dashboards2$Analytics$DashboardPageFlipped(
												{dg: chartWidget, ep: dashboard, qs: pageIndex, bt: questions, bO: widget}));
									},
									A2($author$project$Dashboards2$Chart$getWidgetQuestions, chartWidget, store))));
					case 1:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 2:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 5:
				var index = msg.a;
				var _v6 = model.h;
				switch (_v6.$) {
					case 0:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 1:
						var data = _v6.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Dashboards2$Chart$setChartData,
								model,
								$author$project$Dashboards2$Chart$Nonpaginated(
									_Utils_update(
										data,
										{
											a1: A2(
												$elm$core$Maybe$map,
												function (zipper) {
													return A2(
														$elm$core$Maybe$withDefault,
														zipper,
														A2($turboMaCk$non_empty_list_alias$List$NonEmpty$Zipper$goToIndex, index, zipper));
												},
												data.a1)
										}))),
							$elm$core$Platform$Cmd$none);
					case 2:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 4:
				var datapointName = msg.a;
				var datapointFromName = $turboMaCk$non_empty_list_alias$List$NonEmpty$find(
					function (datapoint) {
						return _Utils_eq(datapoint.ld, datapointName);
					});
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						function () {
							var _v7 = chartWidget.aI;
							if (_v7 === 4) {
								return A2(
									$elm$core$Maybe$map,
									function (questions) {
										return $author$project$Dashboards2$Analytics$trackEvent(
											$author$project$Dashboards2$Analytics$DashboardWaveHighlighted(
												{aI: chartWidget.aI, ep: dashboard, bt: questions, sc: datapointName}));
									},
									A2($author$project$Dashboards2$Chart$getWidgetQuestions, chartWidget, store));
							} else {
								return A2(
									$elm$core$Maybe$andThen,
									function (questions) {
										var datapoints = $turboMaCk$non_empty_list_alias$List$NonEmpty$concat(
											A2(
												$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
												function ($) {
													return $.er;
												},
												questions));
										return A2(
											$elm$core$Maybe$map,
											function (datapoint) {
												return $author$project$Dashboards2$Analytics$trackEvent(
													A4($author$project$Dashboards2$Analytics$DashboardDatapointHighlighted, dashboard, chartWidget.aI, questions, datapoint));
											},
											datapointFromName(datapoints));
									},
									A2($author$project$Dashboards2$Chart$getWidgetQuestions, chartWidget, store));
							}
						}()));
			case 6:
				var lsMsg = msg.a;
				var _v8 = model.h;
				switch (_v8.$) {
					case 0:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 1:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 2:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						var lineChartData = _v8.a;
						var nonpaginated = _v8.b;
						return _Utils_Tuple2(
							A2(
								$author$project$Dashboards2$Chart$setChartData,
								model,
								A2(
									$author$project$Dashboards2$Chart$LineChartModel,
									_Utils_update(
										lineChartData,
										{
											f8: A2($author$project$Dashboards2$Chart$LineChart$update, lsMsg, lineChartData.f8)
										}),
									nonpaginated)),
							$elm$core$Platform$Cmd$none);
				}
			case 7:
				var hbcMsg = msg.a;
				var _v9 = model.h;
				switch (_v9.$) {
					case 0:
						var data = _v9.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Dashboards2$Chart$setChartData,
								model,
								$author$project$Dashboards2$Chart$Paginated(
									_Utils_update(
										data,
										{
											ad: function () {
												var _v10 = data.ad;
												switch (_v10.$) {
													case 0:
														return data.ad;
													case 2:
														return data.ad;
													default:
														var horizontalBarChartModel = _v10.a;
														return $author$project$Dashboards2$Chart$HorizontalBC(
															A2($author$project$Dashboards2$Chart$HorizontalBarChart$update, hbcMsg, horizontalBarChartModel));
												}
											}()
										}))),
							$elm$core$Platform$Cmd$none);
					case 1:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 2:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				var hbcMsg = msg.a;
				var _v11 = model.h;
				switch (_v11.$) {
					case 0:
						var data = _v11.a;
						return _Utils_Tuple2(
							A2(
								$author$project$Dashboards2$Chart$setChartData,
								model,
								$author$project$Dashboards2$Chart$Paginated(
									_Utils_update(
										data,
										{
											ad: function () {
												var _v12 = data.ad;
												switch (_v12.$) {
													case 0:
														return data.ad;
													case 1:
														return data.ad;
													default:
														var verticalBarChartModel = _v12.a;
														return $author$project$Dashboards2$Chart$VerticalBC(
															A2($author$project$Dashboards2$Chart$VerticalBarChart$update, hbcMsg, verticalBarChartModel));
												}
											}()
										}))),
							$elm$core$Platform$Cmd$none);
					case 1:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 2:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 9:
				var scrollTo = msg.a;
				var d3PointName = msg.b;
				return function () {
					if (!scrollTo.$) {
						var elementId = scrollTo.a.j5;
						var scrollParentId = scrollTo.a.lV;
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$with(
							A2(
								$elm$core$Task$attempt,
								$elm$core$Basics$always($author$project$Dashboards2$Chart$NoOp),
								$author$project$Gwi$Browser$Dom$scrollToIfNotVisibleWithOffset(
									{j5: elementId, ra: $author$project$Gwi$Browser$Dom$AlwaysToTop, lV: scrollParentId})));
					} else {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
					}
				}()(
					_Utils_update(
						model,
						{
							bc: $elm$core$Maybe$Just(d3PointName)
						}));
			default:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{bc: $elm$core$Maybe$Nothing}));
		}
	});
var $author$project$Dashboards2$Analytics$EditTextWidgetButtonClicked = function (a) {
	return {$: 19, a: a};
};
var $author$project$Dashboards2$Widget$RichText$SetTextareaCursorPosition = function (a) {
	return {$: 7, a: a};
};
var $author$project$Dashboards2$Widget$RichText$contentScrollElementId = function (_v0) {
	var uniqueId = _v0.mN;
	return 'rich-text-scroll-container--' + uniqueId;
};
var $author$project$Dashboards2$Widget$RichText$textareaElementId = F2(
	function (index, _v0) {
		var uniqueId = _v0.mN;
		return 'rich-text-textarea--' + (uniqueId + ('--' + $elm$core$String$fromInt(index)));
	});
var $author$project$Dashboards2$Widget$RichText$scrollToMakeItVisible = F4(
	function (msg, index, afterScrollAction, model) {
		return A2(
			$elm$core$Task$attempt,
			$elm$core$Basics$always(
				msg(
					A2($elm$core$Maybe$withDefault, $author$project$Dashboards2$Widget$RichText$NoOp, afterScrollAction))),
			A2(
				$elm$core$Task$andThen,
				function (_v0) {
					return A2(
						$elm$core$Task$andThen,
						function (_v1) {
							return $author$project$Gwi$Browser$Dom$scrollToIfNotVisibleWithOffset(
								{
									j5: A2($author$project$Dashboards2$Widget$RichText$paragraphElementId, index, model),
									ra: $author$project$Gwi$Browser$Dom$AlwaysToTop,
									lV: $author$project$Dashboards2$Widget$RichText$contentScrollElementId(model)
								});
						},
						$elm$browser$Browser$Dom$focus(
							A2($author$project$Dashboards2$Widget$RichText$textareaElementId, index, model)));
				},
				$elm$core$Process$sleep(100)));
	});
var $author$project$Dashboards2$Widget$RichText$setTextareaCursorPosition = _Platform_outgoingPort(
	'setTextareaCursorPosition',
	function ($) {
		var a = $.a;
		var b = $.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					$elm$json$Json$Encode$string(a),
					$elm$json$Json$Encode$int(b)
				]));
	});
var $author$project$Dashboards2$Widget$RichText$updateParagraphs = F3(
	function (msg, _v0, paragraphs) {
		var index = _v0.pi;
		switch (msg.$) {
			case 0:
				var str = msg.a;
				return _Utils_Tuple2(
					A3(
						$elm_community$list_extra$List$Extra$updateAt,
						index,
						function (paragraph) {
							return _Utils_update(
								paragraph,
								{U: str});
						},
						paragraphs),
					false);
			case 2:
				return _Utils_Tuple2(
					A3(
						$elm_community$list_extra$List$Extra$updateAt,
						index,
						function (paragraph) {
							var style = paragraph.k;
							return _Utils_update(
								paragraph,
								{
									k: _Utils_update(
										style,
										{de: !style.de})
								});
						},
						paragraphs),
					true);
			case 3:
				return _Utils_Tuple2(
					A3(
						$elm_community$list_extra$List$Extra$updateAt,
						index,
						function (paragraph) {
							var style = paragraph.k;
							return _Utils_update(
								paragraph,
								{
									k: _Utils_update(
										style,
										{dU: !style.dU})
								});
						},
						paragraphs),
					true);
			case 4:
				var newMainStyle = msg.a;
				return _Utils_Tuple2(
					A3(
						$elm_community$list_extra$List$Extra$updateAt,
						index,
						function (paragraph) {
							var style = paragraph.k;
							var newMainStyle_ = function () {
								var _v2 = style.ae;
								switch (_v2.$) {
									case 0:
										return newMainStyle;
									case 1:
										return _Utils_eq(newMainStyle, $author$project$Data$Platform2$RichTextWidget$BulletpointList) ? $author$project$Data$Platform2$RichTextWidget$defaultStyle.ae : newMainStyle;
									default:
										return _Utils_eq(newMainStyle, $author$project$Data$Platform2$RichTextWidget$Quote) ? $author$project$Data$Platform2$RichTextWidget$defaultStyle.ae : newMainStyle;
								}
							}();
							return _Utils_update(
								paragraph,
								{
									k: _Utils_update(
										style,
										{ae: newMainStyle_})
								});
						},
						paragraphs),
					true);
			case 1:
				return _Utils_Tuple2(
					A2($elm_community$list_extra$List$Extra$removeAt, index, paragraphs),
					true);
			default:
				var size = msg.a;
				return _Utils_Tuple2(
					A3(
						$elm_community$list_extra$List$Extra$updateAt,
						index,
						function (paragraph) {
							var style = paragraph.k;
							return _Utils_update(
								paragraph,
								{
									k: _Utils_update(
										style,
										{cX: size})
								});
						},
						paragraphs),
					true);
		}
	});
var $author$project$Dashboards2$Widget$RichText$update = F3(
	function (config, msg, model) {
		var richText = model.bM;
		switch (msg.$) {
			case 0:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			case 1:
				var index = msg.a;
				var action = msg.b;
				var _v1 = A3(
					$author$project$Dashboards2$Widget$RichText$updateParagraphs,
					action,
					index,
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(richText.qt));
				var newParagraps = _v1.a;
				var triggerUpdate = _v1.b;
				var newRichText = function () {
					var _v2 = $turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(newParagraps);
					if (!_v2.$) {
						var ps = _v2.a;
						return _Utils_update(
							richText,
							{qt: ps});
					} else {
						return richText;
					}
				}();
				var newModel = _Utils_update(
					model,
					{aA: 0, bM: newRichText});
				return triggerUpdate ? A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.sk(newRichText),
					newModel) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(newModel);
			case 7:
				var args = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Dashboards2$Widget$RichText$setTextareaCursorPosition(args));
			case 2:
				var index = msg.a;
				var contentLength = msg.b;
				var afterScrollAction = $elm$core$Maybe$Just(
					$author$project$Dashboards2$Widget$RichText$SetTextareaCursorPosition(
						_Utils_Tuple2(
							A2($author$project$Dashboards2$Widget$RichText$textareaElementId, index, model),
							contentLength)));
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$EditTextWidgetButtonClicked(
							{mL: 'text'})),
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								bH: $elm$core$Maybe$Just(index)
							}),
						A4($author$project$Dashboards2$Widget$RichText$scrollToMakeItVisible, config.a, index, afterScrollAction, model)));
			case 3:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.sk(model.bM),
					_Utils_update(
						model,
						{bH: $elm$core$Maybe$Nothing}));
			case 4:
				var newParagrapIndex = $turboMaCk$non_empty_list_alias$List$NonEmpty$length(richText.qt);
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$EditTextWidgetButtonClicked(
							{mL: 'text'})),
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								bH: $elm$core$Maybe$Just(newParagrapIndex),
								bM: _Utils_update(
									richText,
									{
										qt: A2(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$append,
											richText.qt,
											$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton($author$project$Dashboards2$Widget$RichText$initParagraph))
									})
							}),
						A4($author$project$Dashboards2$Widget$RichText$scrollToMakeItVisible, config.a, newParagrapIndex, $elm$core$Maybe$Nothing, model)));
			case 5:
				var dropdown = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							aA: _Utils_eq(dropdown, model.aA) ? 0 : dropdown
						}));
			default:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{aA: 0}));
		}
	});
var $author$project$Dashboards2$Chart$updateModelOnOneViewOnlyDatapoint = function (_v0) {
	var userFilters = _v0.bz;
	var store = _v0.rF;
	var result = _v0.iA;
	var widget = _v0.bO;
	var chartWidget = _v0.dg;
	var model = _v0.k8;
	var currentAudiences = $author$project$Dashboards2$UserFilters$audienceIds(userFilters);
	var containsOnlyValidAudiences = $elm$core$List$all(
		function (_v8) {
			var audienceId = _v8.jn;
			return A2($elm$core$List$member, audienceId, currentAudiences);
		});
	var clearInvalidAudiences = $turboMaCk$any_set$Set$Any$filter(
		function (r) {
			switch (r.$) {
				case 0:
					return $elm$core$List$isEmpty(currentAudiences);
				case 1:
					var list = r.b;
					return containsOnlyValidAudiences(list);
				case 2:
					return $elm$core$List$isEmpty(currentAudiences);
				default:
					var list = r.b;
					return containsOnlyValidAudiences(list);
			}
		});
	var prepareNonpaginatedData = function (nonpaginated) {
		return _Utils_update(
			nonpaginated,
			{
				cl: A2(
					$author$project$RemoteData$Loaded$map,
					function (_v5) {
						var userFiltersForResult = _v5.a;
						var newResult = _v5.b;
						var dictSoFar = A2(
							$author$project$RemoteData$Loaded$withDefault,
							$turboMaCk$any_dict$Dict$Any$empty($author$project$Dashboards2$UserFilters$toComparable),
							A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$first, nonpaginated.cl));
						var newSet = clearInvalidAudiences(
							function () {
								var _v6 = A2($turboMaCk$any_dict$Dict$Any$get, userFiltersForResult, dictSoFar);
								if (_v6.$ === 1) {
									return A2($turboMaCk$any_set$Set$Any$singleton, newResult, $author$project$Data$Calc$Platform2$qResultToComparable);
								} else {
									var set = _v6.a;
									return A2($turboMaCk$any_set$Set$Any$insert, newResult, set);
								}
							}());
						var newDict = A3($turboMaCk$any_dict$Dict$Any$insert, userFiltersForResult, newSet, dictSoFar);
						return _Utils_Tuple2(newDict, _List_Nil);
					},
					$author$project$RemoteData$Loaded$fromResult(result))
			});
	};
	var newChartData = function () {
		var _v1 = model.h;
		switch (_v1.$) {
			case 0:
				var paginated = _v1.a;
				return $author$project$Dashboards2$Chart$Paginated(
					_Utils_update(
						paginated,
						{
							cl: A2(
								$author$project$RemoteData$Loaded$map,
								function (_v2) {
									var userFiltersForResult = _v2.a;
									var qResult = _v2.b;
									return A2(
										$elm$core$Tuple$mapFirst,
										A2(
											$turboMaCk$any_dict$Dict$Any$update,
											userFiltersForResult,
											function (maybeSet) {
												if (!maybeSet.$) {
													var set = maybeSet.a;
													return $elm$core$Maybe$Just(
														clearInvalidAudiences(
															A2($turboMaCk$any_set$Set$Any$insert, qResult, set)));
												} else {
													return $elm$core$Maybe$Just(
														clearInvalidAudiences(
															A2($turboMaCk$any_set$Set$Any$singleton, qResult, $author$project$Data$Calc$Platform2$qResultToComparable)));
												}
											}),
										A2(
											$author$project$RemoteData$Loaded$withDefault,
											_Utils_Tuple2(
												$turboMaCk$any_dict$Dict$Any$empty($author$project$Dashboards2$UserFilters$toComparable),
												$elm$core$Maybe$Nothing),
											paginated.cl));
								},
								$author$project$RemoteData$Loaded$fromResult(result))
						}));
			case 1:
				var nonpaginated = _v1.a;
				return $author$project$Dashboards2$Chart$Nonpaginated(
					prepareNonpaginatedData(nonpaginated));
			case 2:
				var statCard = _v1.a;
				return $author$project$Dashboards2$Chart$StatCardModel(
					A2(
						$author$project$RemoteData$Loaded$andThen,
						function (_v4) {
							var userFiltersForResult = _v4.a;
							var qresult = _v4.b;
							var statCardModel = A2(
								$author$project$RemoteData$Loaded$withDefault,
								A3($author$project$Dashboards2$StatCard$init, widget.da, widget.cv, widget.b),
								A2($author$project$RemoteData$Loaded$map, $elm$core$Tuple$second, statCard));
							var newDict = A3($turboMaCk$any_dict$Dict$Any$singleton, userFiltersForResult, qresult, $author$project$Dashboards2$UserFilters$toComparable);
							return A2(
								$author$project$RemoteData$Loaded$map,
								$elm$core$Tuple$pair(newDict),
								A6(
									$author$project$Dashboards2$Chart$buildStatCardData,
									userFiltersForResult,
									store,
									model.hr,
									chartWidget,
									$author$project$RemoteData$Loaded$SuccessL(qresult),
									$author$project$RemoteData$Loaded$SuccessL(statCardModel)));
						},
						$author$project$RemoteData$Loaded$fromResult(result)));
			default:
				var lcModel = _v1.a;
				var nonpaginated = _v1.b;
				return A2(
					$author$project$Dashboards2$Chart$LineChartModel,
					lcModel,
					prepareNonpaginatedData(nonpaginated));
		}
	}();
	return A5(
		$author$project$Dashboards2$Chart$updateChartData,
		userFilters,
		store,
		widget,
		chartWidget,
		A2($author$project$Dashboards2$Chart$setChartData, model, newChartData));
};
var $author$project$Dashboards2$Chart$onDataReceivedViewOnlySuccess = function (_v0) {
	onDataReceivedViewOnlySuccess:
	while (true) {
		var flags = _v0.oN;
		var userFilters = _v0.bz;
		var store = _v0.rF;
		var qResults = _v0.iv;
		var specificUserFilters = _v0.iQ;
		var widget = _v0.bO;
		var chartWidget = _v0.dg;
		var model = _v0.k8;
		if (!qResults.b) {
			return _Utils_Tuple2(
				model,
				$author$project$Dashboards2$Chart$getWidgetDimensions(widget));
		} else {
			var head = qResults.a;
			var tail = qResults.b;
			var $temp$_v0 = {
				dg: chartWidget,
				oN: flags,
				k8: $author$project$Dashboards2$Chart$updateModelOnOneViewOnlyDatapoint(
					{
						dg: chartWidget,
						k8: model,
						iA: $elm$core$Result$Ok(
							_Utils_Tuple2(specificUserFilters, head)),
						rF: store,
						bz: userFilters,
						bO: widget
					}),
				iv: tail,
				iQ: specificUserFilters,
				rF: store,
				bz: userFilters,
				bO: widget
			};
			_v0 = $temp$_v0;
			continue onDataReceivedViewOnlySuccess;
		}
	}
};
var $author$project$Dashboards2$Chart$onDataReceivedViewOnly = function (_v0) {
	var flags = _v0.oN;
	var userFilters = _v0.bz;
	var store = _v0.rF;
	var result = _v0.iA;
	var widget = _v0.bO;
	var chartWidget = _v0.dg;
	var model = _v0.k8;
	if (result.$ === 1) {
		var err = result.a;
		return A7(
			$author$project$Dashboards2$Chart$onDataReceived,
			flags,
			userFilters,
			store,
			$elm$core$Result$Err(err),
			widget,
			chartWidget,
			model);
	} else {
		var _v2 = result.a;
		var specificUserFilters = _v2.a;
		var qResults = _v2.b;
		return $author$project$Dashboards2$Chart$onDataReceivedViewOnlySuccess(
			{dg: chartWidget, oN: flags, k8: model, iv: qResults, iQ: specificUserFilters, rF: store, bz: userFilters, bO: widget});
	}
};
var $author$project$Dashboards2$Widget$updateWithParamsOnViewOnlyDataReceived = function (_v0) {
	var config = _v0.fu;
	var model = _v0.k8;
	var chartWidget = _v0.dg;
	var widget = _v0.bO;
	var widgetWhenRequested = _v0.c9;
	var userFiltersWhenRequested = _v0.c4;
	var httpResponse = _v0.cx;
	var store = _v0.rF;
	var flags = _v0.oN;
	var updateStoreFn = _v0.g$;
	var _v1 = A2(
		$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
		config.l(
			_List_fromArray(
				[
					$author$project$Store$Platform2$UpdateStore(updateStoreFn)
				])),
		model);
	var model_ = _v1.a;
	var cmds = _v1.b;
	if (_Utils_eq(widgetWhenRequested, widget)) {
		var _v2 = A2(
			$author$project$Dashboards2$Widget$updateChartModel,
			model.ad,
			function (chartModel) {
				return $author$project$Dashboards2$Chart$onDataReceivedViewOnly(
					{
						dg: chartWidget,
						oN: flags,
						k8: chartModel,
						iA: A2(
							$elm$core$Result$map,
							$elm$core$Tuple$pair(userFiltersWhenRequested),
							httpResponse),
						rF: store,
						bz: config.bz,
						bO: widget
					});
			});
		var newChartModel = _v2.a;
		var newChartCmd = _v2.b;
		return A3(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			A3(
				$author$project$Dashboards2$Widget$trackWidgetErrorIfAny,
				$elm$core$Maybe$Just(config.bz),
				store,
				widget),
			A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, $author$project$Dashboards2$Widget$ChartMsg, config.a),
					newChartCmd),
				_Utils_Tuple2(
					_Utils_update(
						model_,
						{ad: newChartModel}),
					cmds)));
	} else {
		var widgetsInfo = A2(
			$elm$core$String$join,
			', ',
			_List_fromArray(
				[
					$author$project$Data$Id$unwrap(widgetWhenRequested.b),
					A2(
					$elm$core$Maybe$withDefault,
					'',
					A2(
						$elm$core$Maybe$map,
						function ($) {
							return $.ld;
						},
						$author$project$Data$Platform2$getChartWidget(widgetWhenRequested))),
					$author$project$Data$Id$unwrap(widget.b),
					chartWidget.ld
				]));
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
			$author$project$Dashboards2$Analytics$trackEvent(
				$author$project$Dashboards2$Analytics$WidgetError(
					{
						jo: $author$project$Dashboards2$UserFilters$audienceIds(config.bz),
						oz: 'Data received for different widget : ' + widgetsInfo,
						qE: $author$project$Dashboards2$Widget$widgetQuestionCodes(chartWidget)
					})),
			_Utils_Tuple2(model_, cmds));
	}
};
var $author$project$Dashboards2$Widget$updateOnDataForWidgetReceivedViewOnly = function (_v0) {
	var chartWidget = _v0.dg;
	var widget = _v0.bO;
	var userFiltersWhenRequested = _v0.c4;
	var config = _v0.fu;
	var flags = _v0.oN;
	var retryLimit = _v0.b5;
	var httpResponse = _v0.cx;
	var model = _v0.k8;
	var widgetWhenRequested = _v0.c9;
	var store = _v0.rF;
	var paramsFromWidget = A3(
		$author$project$Data$Calc$Platform2$paramsFromWidget,
		store,
		$author$project$Dashboards2$UserFilters$toSimpleFilters(config.bz),
		widget);
	var innerMsg = function (newHttpResponse) {
		return $author$project$Dashboards2$Widget$DataForWidgetReceivedViewOnly(
			{cx: newHttpResponse, b5: retryLimit - 1, c4: userFiltersWhenRequested, c9: widget});
	};
	var retryIfFail = function (updateResult) {
		if (httpResponse.$ === 1) {
			var err = httpResponse.a;
			return ($author$project$Dashboards2$Widget$shouldRetry(err) && (retryLimit > 0)) ? A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
				A2(
					$elm$core$Platform$Cmd$map,
					A2($elm$core$Basics$composeR, innerMsg, config.a),
					$author$project$Data$Calc$Platform2$sendFromDashboardsViewOnly(
						{bf: widget.bf, oN: flags, sj: widget.b})),
				updateResult) : updateResult;
		} else {
			return updateResult;
		}
	};
	return retryIfFail(
		function () {
			if (!paramsFromWidget.$) {
				var _v2 = paramsFromWidget.a;
				var updateStoreFn = _v2.b;
				return $author$project$Dashboards2$Widget$updateWithParamsOnViewOnlyDataReceived(
					{dg: chartWidget, fu: config, oN: flags, cx: httpResponse, k8: model, rF: store, g$: updateStoreFn, c4: userFiltersWhenRequested, bO: widget, c9: widgetWhenRequested});
			} else {
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			}
		}());
};
var $author$project$Dashboards2$Widget$update = F9(
	function (flags, config, store, dashboard, widget, _v0, msg, place, model) {
		var isEditing = _v0.ez;
		var withChartWidget = function (fn) {
			var _v17 = _Utils_Tuple2(widget.U, model.ad);
			if ((!_v17.a.$) && (_v17.b.$ === 2)) {
				var chartWidget = _v17.a.a;
				var chartModelData = _v17.b.a;
				var _v18 = $author$project$Dashboards2$Widget$getChartModel(chartModelData);
				if (!_v18.$) {
					return fn(chartWidget);
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			} else {
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			}
		};
		switch (msg.$) {
			case 1:
				var chartMsg = msg.a;
				return withChartWidget(
					function (chartWidget) {
						var _v2 = A2(
							$author$project$Dashboards2$Widget$updateChartModel,
							model.ad,
							A6($author$project$Dashboards2$Chart$update, config.bz, store, dashboard, widget, chartWidget, chartMsg));
						var newChartModel = _v2.a;
						var newChartCmd = _v2.b;
						return A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
							A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Widget$ChartMsg),
								newChartCmd),
							_Utils_update(
								model,
								{ad: newChartModel}));
					});
			case 3:
				var retryLimit = msg.a.b5;
				var userFiltersWhenRequested = msg.a.c4;
				var widgetWhenRequested = msg.a.c9;
				var httpResponse = msg.a.cx;
				return withChartWidget(
					function (chartWidget) {
						return $author$project$Dashboards2$Widget$updateOnDataForWidgetReceivedViewOnly(
							{dg: chartWidget, fu: config, oN: flags, cx: httpResponse, k8: model, b5: retryLimit, rF: store, c4: userFiltersWhenRequested, bO: widget, c9: widgetWhenRequested});
					});
			case 2:
				var retryLimit = msg.a.b5;
				var widgetWhenRequested = msg.b;
				var userFiltersWhenRequested = msg.c;
				var qParams = msg.d;
				var qResult = msg.e;
				return withChartWidget(
					function (chartWidget) {
						var retryIfFail = function () {
							if (qResult.$ === 1) {
								var err = qResult.a;
								return ($author$project$Dashboards2$Widget$shouldRetry(err) && (retryLimit > 0)) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$add(
									A2(
										$elm$core$Platform$Cmd$map,
										A2(
											$elm$core$Basics$composeR,
											A4(
												$author$project$Dashboards2$Widget$DataForWidgetReceived,
												{b5: retryLimit - 1},
												widget,
												userFiltersWhenRequested,
												qParams),
											config.a),
										A2($author$project$Data$Calc$Platform2$sendFromDashboards, flags, qParams))) : $elm$core$Basics$identity;
							} else {
								return $elm$core$Basics$identity;
							}
						}();
						return retryIfFail(
							A2(
								$elm$core$Maybe$withDefault,
								$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
								A2(
									$elm$core$Maybe$map,
									function (_v3) {
										var allParams = _v3.a;
										var updateStoreFn = _v3.b;
										return A3(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$foldr,
											F2(
												function (params, _v4) {
													var model_ = _v4.a;
													var cmds = _v4.b;
													if (_Utils_eq(params, qParams) && _Utils_eq(widgetWhenRequested, widget)) {
														var _v5 = A2(
															$author$project$Dashboards2$Widget$updateChartModel,
															model.ad,
															A6(
																$author$project$Dashboards2$Chart$onDataReceived,
																flags,
																config.bz,
																store,
																A2(
																	$elm$core$Result$map,
																	$elm$core$Tuple$pair(userFiltersWhenRequested),
																	qResult),
																widget,
																chartWidget));
														var newChartModel = _v5.a;
														var newChartCmd = _v5.b;
														return A3(
															$turboMaCk$glue$Glue$updateWith,
															$turboMaCk$glue$Glue$id,
															A3(
																$author$project$Dashboards2$Widget$trackWidgetErrorIfAny,
																$elm$core$Maybe$Just(config.bz),
																store,
																widget),
															A2(
																$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
																A2(
																	$elm$core$Platform$Cmd$map,
																	A2($elm$core$Basics$composeR, $author$project$Dashboards2$Widget$ChartMsg, config.a),
																	newChartCmd),
																_Utils_Tuple2(
																	_Utils_update(
																		model_,
																		{ad: newChartModel}),
																	cmds)));
													} else {
														if (!_Utils_eq(widgetWhenRequested, widget)) {
															var widgetsInfo = A2(
																$elm$core$String$join,
																', ',
																_List_fromArray(
																	[
																		$author$project$Data$Id$unwrap(widgetWhenRequested.b),
																		A2(
																		$elm$core$Maybe$withDefault,
																		'',
																		A2(
																			$elm$core$Maybe$map,
																			function ($) {
																				return $.ld;
																			},
																			$author$project$Data$Platform2$getChartWidget(widgetWhenRequested))),
																		$author$project$Data$Id$unwrap(widget.b),
																		chartWidget.ld
																	]));
															return A2(
																$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
																$author$project$Dashboards2$Analytics$trackEvent(
																	$author$project$Dashboards2$Analytics$WidgetError(
																		{
																			jo: $author$project$Dashboards2$UserFilters$audienceIds(config.bz),
																			oz: 'Data received for different widget : ' + widgetsInfo,
																			qE: $author$project$Dashboards2$Widget$widgetQuestionCodes(chartWidget)
																		})),
																_Utils_Tuple2(model_, cmds));
														} else {
															return _Utils_Tuple2(model_, cmds);
														}
													}
												}),
											A2(
												$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
												config.l(
													_List_fromArray(
														[
															$author$project$Store$Platform2$UpdateStore(updateStoreFn)
														])),
												model),
											allParams);
									},
									A3(
										$author$project$Data$Calc$Platform2$paramsFromWidget,
										store,
										$author$project$Dashboards2$UserFilters$toSimpleFilters(config.bz),
										widget))));
					});
			case 0:
				var dataTableShownCmd = $author$project$Dashboards2$Analytics$trackEvent(
					$author$project$Dashboards2$Analytics$DashboardDataTableShown(widget));
				var _v7 = function () {
					var _v8 = model.eo;
					if (!_v8) {
						return _Utils_Tuple2(1, dataTableShownCmd);
					} else {
						return _Utils_Tuple2(0, $elm$core$Platform$Cmd$none);
					}
				}();
				var newTab = _v7.a;
				var analyticsCmd = _v7.b;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
					analyticsCmd,
					_Utils_update(
						model,
						{eo: newTab}));
			case 4:
				var qCode = msg.a;
				var btnText = msg.b;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					A3(
						config.b0,
						btnText,
						4,
						$author$project$Data$Upsell$QuestionResource(qCode)),
					model);
			case 6:
				var widgetDropdown = msg.a;
				var notificationDotIsShown = function () {
					var _v9 = A2(
						$krisajenkins$remotedata$RemoteData$map,
						function ($) {
							return $.bF;
						},
						store.jU);
					if (_v9.$ === 3) {
						var showDotOnChartTypeDropdown = _v9.a.iO;
						return showDotOnChartTypeDropdown;
					} else {
						return false;
					}
				}();
				var maybeHideDotOnDropdown = A2(
					$elm_community$maybe_extra$Maybe$Extra$filter,
					$elm$core$Basics$always(notificationDotIsShown),
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Data$Platform2$mapDashboardsDoNotShowAgain(
								function (settings) {
									return _Utils_update(
										settings,
										{iO: false});
								}),
							A2(
								$elm$core$Basics$composeR,
								$author$project$Store$Platform2$SaveDashboardsUserSettings,
								A2($elm$core$Basics$composeR, $elm$core$List$singleton, config.l))),
						$krisajenkins$remotedata$RemoteData$toMaybe(store.jU)));
				return _Utils_eq(widgetDropdown, model.w) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{w: $author$project$Dashboards2$Widget$NoDropdown})) : A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$addTriggerMaybe,
					maybeHideDotOnDropdown,
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							model,
							{w: widgetDropdown})));
			case 5:
				var menuData = msg.a;
				return $author$project$Dashboards2$Widget$isEditDropdown(model) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{w: $author$project$Dashboards2$Widget$NoDropdown})) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							w: $author$project$Dashboards2$Widget$EditDropdown(menuData)
						}));
			case 7:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{w: $author$project$Dashboards2$Widget$NoDropdown}));
			case 8:
				var newMetric = msg.a;
				return withChartWidget(
					function (chartWidget) {
						var saveWidgetIfEditMode = isEditing ? $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
							config.q5(
								_Utils_update(
									widget,
									{
										U: $author$project$Data$Platform2$ChartContent(
											_Utils_update(
												chartWidget,
												{dB: newMetric}))
									}))) : $elm$core$Basics$identity;
						var _v10 = A2(
							$author$project$Dashboards2$Widget$updateChartModel,
							model.ad,
							A7($author$project$Dashboards2$Chart$setMetric, config.bz, store, dashboard, widget, chartWidget, newMetric, place));
						var newChartModel = _v10.a;
						var newChartCmd = _v10.b;
						return saveWidgetIfEditMode(
							A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
								A2(
									$elm$core$Platform$Cmd$map,
									A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Widget$ChartMsg),
									newChartCmd),
								_Utils_update(
									model,
									{ad: newChartModel, w: $author$project$Dashboards2$Widget$NoDropdown})));
					});
			case 9:
				var newChartWidget = msg.a;
				return withChartWidget(
					function (chartWidget) {
						var numAttributes = $elm$core$List$length(
							A2($author$project$Data$Platform2$getAllDatapointCodesForWidgetInOriginalOrder, store.bt, newChartWidget.cl));
						var newWidget = _Utils_update(
							widget,
							{
								U: $author$project$Data$Platform2$ChartContent(newChartWidget)
							});
						var analytics = $author$project$Dashboards2$Analytics$trackEvent(
							$author$project$Dashboards2$Analytics$ChartsSortingChanged(
								{hh: newChartWidget.ld, aI: newChartWidget.aI, lk: numAttributes, rv: chartWidget.cY, rw: newChartWidget.cY}));
						return A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
							analytics,
							A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								config.q5(newWidget),
								_Utils_update(
									model,
									{w: $author$project$Dashboards2$Widget$NoDropdown})));
					});
			case 16:
				var widgetToDuplicate = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.os(widgetToDuplicate),
					_Utils_update(
						model,
						{w: $author$project$Dashboards2$Widget$NoDropdown}));
			case 10:
				var inheritedFromChart = msg.a.hZ;
				var newWidget = _Utils_update(
					widget,
					{
						U: function () {
							var _v11 = widget.U;
							if (!_v11.$) {
								var chartWidget = _v11.a;
								return $author$project$Data$Platform2$ChartContent(
									_Utils_update(
										chartWidget,
										{
											aU: function () {
												var _v12 = chartWidget.aU;
												if (!_v12.$) {
													var chartBaseAudience = _v12.a.fp;
													return inheritedFromChart ? A3($elm_community$maybe_extra$Maybe$Extra$unwrap, chartWidget.aU, $author$project$Data$Platform2$InheritedFromChart, chartBaseAudience) : chartWidget.aU;
												} else {
													var b = _v12.a;
													return inheritedFromChart ? chartWidget.aU : $author$project$Data$Platform2$InheritedFromDashboard(
														{
															fp: $elm$core$Maybe$Just(b)
														});
												}
											}()
										}));
							} else {
								return widget.U;
							}
						}()
					});
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
					config.q5(newWidget),
					A2(
						$author$project$Dashboards2$Widget$processRequests,
						config,
						A8(
							$author$project$Dashboards2$Widget$requestDataForWidgetInternal,
							$elm$core$Basics$identity,
							{l: $author$project$Dashboards2$Widget$StoreActionMany},
							$elm$core$Maybe$Just(config.bz),
							flags,
							store,
							newWidget,
							{oQ: false, ez: isEditing},
							_Utils_update(
								model,
								{w: $author$project$Dashboards2$Widget$NoDropdown}))));
			case 11:
				var chartType = msg.a;
				var chartName = msg.b;
				return withChartWidget(
					function (chartWidget) {
						var newChartWidget = _Utils_update(
							chartWidget,
							{
								aI: chartType,
								dB: A2($author$project$Dashboards2$Widget$setMetricWithChartType, chartWidget.dB, chartType)
							});
						var newWidget = _Utils_update(
							widget,
							{
								U: $author$project$Data$Platform2$ChartContent(newChartWidget)
							});
						var numAttributes = $elm$core$List$length(
							A2($author$project$Data$Platform2$getAllDatapointCodesForWidgetInOriginalOrder, store.bt, newChartWidget.cl));
						var newBadgeIsShown = function () {
							var _v14 = A2(
								$krisajenkins$remotedata$RemoteData$map,
								function ($) {
									return $.bF;
								},
								store.jU);
							if (_v14.$ === 3) {
								var showNewBadgeOnDonutChartItem = _v14.a.iP;
								return showNewBadgeOnDonutChartItem;
							} else {
								return false;
							}
						}();
						var maybeHideNewBadgeOnItem = A2(
							$elm_community$maybe_extra$Maybe$Extra$filter,
							$elm$core$Basics$always(newBadgeIsShown && (chartType === 2)),
							A2(
								$elm$core$Maybe$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Data$Platform2$mapDashboardsDoNotShowAgain(
										function (settings) {
											return _Utils_update(
												settings,
												{iP: false});
										}),
									A2(
										$elm$core$Basics$composeR,
										$author$project$Store$Platform2$SaveDashboardsUserSettings,
										A2($elm$core$Basics$composeR, $elm$core$List$singleton, config.l))),
								$krisajenkins$remotedata$RemoteData$toMaybe(store.jU)));
						var analytics = $author$project$Dashboards2$Analytics$trackEvent(
							$author$project$Dashboards2$Analytics$ChartsTypeChanged(
								{hh: chartName, nX: chartWidget.aI, nY: chartType, lk: numAttributes, iq: place}));
						var _v13 = (!_Utils_eq(chartWidget.dB, newChartWidget.dB)) ? A2(
							$author$project$Dashboards2$Widget$updateChartModel,
							model.ad,
							A7($author$project$Dashboards2$Chart$setMetric, config.bz, store, dashboard, newWidget, newChartWidget, newChartWidget.dB, place)) : A2(
							$author$project$Dashboards2$Widget$updateChartModel,
							model.ad,
							A2(
								$elm$core$Basics$composeR,
								A4($author$project$Dashboards2$Chart$updateChartData, config.bz, store, newWidget, newChartWidget),
								$GlobalWebIndex$cmd_extra$Cmd$Extra$pure));
						var newChartModel = _v13.a;
						var newChartCmd = _v13.b;
						return A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$addTriggerMaybe,
							maybeHideNewBadgeOnItem,
							A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
								analytics,
								A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
									config.q5(newWidget),
									A2(
										$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
										A2(
											$elm$core$Platform$Cmd$map,
											A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Widget$ChartMsg),
											newChartCmd),
										_Utils_update(
											model,
											{ad: newChartModel, w: $author$project$Dashboards2$Widget$NoDropdown})))));
					});
			case 12:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.o3,
					_Utils_update(
						model,
						{w: $author$project$Dashboards2$Widget$NoDropdown}));
			case 13:
				var currentMetric = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.o4(currentMetric),
					_Utils_update(
						model,
						{w: $author$project$Dashboards2$Widget$NoDropdown}));
			case 14:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.pQ,
					_Utils_update(
						model,
						{w: $author$project$Dashboards2$Widget$NoDropdown}));
			case 15:
				var rtMsg = msg.a;
				var _v15 = model.ad;
				if (_v15.$ === 1) {
					var rtModel = _v15.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (newRtModel) {
							return _Utils_update(
								model,
								{
									ad: $author$project$Dashboards2$Widget$EditModeRichTextWidget(newRtModel)
								});
						},
						A3(
							$author$project$Dashboards2$Widget$RichText$update,
							{
								a: A2($elm$core$Basics$composeR, $author$project$Dashboards2$Widget$RichTextEditMsg, config.a),
								sk: function (newRichText) {
									return config.q5(
										_Utils_update(
											widget,
											{
												U: $author$project$Data$Platform2$RichText(newRichText)
											}));
								}
							},
							rtMsg,
							rtModel));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 17:
				var isHovered = msg.a.eB;
				return isHovered ? _Utils_Tuple2(
					_Utils_update(
						model,
						{b$: 2}),
					$elm$core$Platform$Cmd$none) : A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
					A2(
						$elm$core$Task$attempt,
						function (_v16) {
							return config.a($author$project$Dashboards2$Widget$HideMetadataTooltip);
						},
						$elm$core$Process$sleep(200)),
					_Utils_update(
						model,
						{b$: 1}));
			case 18:
				var chartWidget = msg.a;
				var questions = msg.b;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					A2(config.ql, chartWidget, questions),
					_Utils_update(
						model,
						{b$: 0}));
			case 19:
				return (model.b$ === 1) ? _Utils_Tuple2(
					_Utils_update(
						model,
						{b$: 0}),
					$elm$core$Platform$Cmd$none) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			default:
				var actions = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.l(actions),
					model);
		}
	});
var $author$project$Dashboards2$Widget$setChartType = F7(
	function (flags, config, store, dashboard, widget, isEditing, newChartType) {
		var msg = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Dashboards2$Widget$ChartMsg($author$project$Dashboards2$Chart$NoOp),
			A2(
				$elm$core$Maybe$map,
				function (_v0) {
					var name = _v0.ld;
					return A2($author$project$Dashboards2$Widget$SetChartTypeAndSave, newChartType, name);
				},
				$author$project$Data$Platform2$getChartWidget(widget)));
		return A8($author$project$Dashboards2$Widget$update, flags, config, store, dashboard, widget, isEditing, msg, 31);
	});
var $author$project$Dashboards2$Widget$setEditMode = F3(
	function (_v0, widget, model) {
		var isEditMode = _v0.ey;
		var _v1 = _Utils_Tuple3(widget.U, model.ad, isEditMode);
		_v1$2:
		while (true) {
			if (_v1.a.$ === 1) {
				if (_v1.c) {
					if (!_v1.b.$) {
						var richText = _v1.a.a;
						var _v2 = _v1.b;
						return _Utils_update(
							model,
							{
								ad: $author$project$Dashboards2$Widget$EditModeRichTextWidget(
									A2(
										$author$project$Dashboards2$Widget$RichText$init,
										{
											mN: $author$project$Data$Id$unwrap(widget.b)
										},
										$elm$core$Maybe$Just(richText)))
							});
					} else {
						break _v1$2;
					}
				} else {
					if (_v1.b.$ === 1) {
						return _Utils_update(
							model,
							{ad: $author$project$Dashboards2$Widget$OnlyViewForTextWidget});
					} else {
						break _v1$2;
					}
				}
			} else {
				break _v1$2;
			}
		}
		return model;
	});
var $author$project$Dashboards2$setEditMode = F6(
	function (shouldBeEditing, flags, config, route, store, model) {
		var setEditModeInWidgets = function (model_) {
			return A5(
				$author$project$Dashboards2$updateWidgetsPure,
				flags,
				F2(
					function (_v1, widget) {
						return A2(
							$author$project$Dashboards2$Widget$setEditMode,
							{
								ey: $author$project$Dashboards2$isEditMode(model_.o)
							},
							widget);
					}),
				store,
				route,
				model_);
		};
		var resetSavingStateWhenLeavingEditMode = A2(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			shouldBeEditing ? $GlobalWebIndex$cmd_extra$Cmd$Extra$pure : $author$project$Dashboards2$setSavingState(2));
		var currentFilters = $author$project$Dashboards2$Detail$currentEditableUserFilters(model);
		var reloadWidgetsIfNeeded = (shouldBeEditing && $author$project$Dashboards2$Editable$isEdited(currentFilters)) ? A2(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			A4($author$project$Dashboards2$requestDataForAllWidgets, config, flags, route, store)) : $elm$core$Basics$identity;
		var _v0 = shouldBeEditing ? _Utils_Tuple2(
			A2($author$project$Dashboards2$initEditGrid, config, model.o),
			(!$author$project$Dashboards2$Editable$isEdited(currentFilters)) ? currentFilters : $author$project$Dashboards2$Editable$initNotReady) : _Utils_Tuple2($author$project$Dashboards2$Detail$NotEditing, currentFilters);
		var editSection = _v0.a;
		var userFilters = _v0.b;
		return A3(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			A2($elm$core$Basics$composeR, setEditModeInWidgets, $GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
			reloadWidgetsIfNeeded(
				resetSavingStateWhenLeavingEditMode(
					A5(
						$author$project$Dashboards2$initUserFiltersIfNeeded,
						config,
						flags,
						route,
						store,
						A2(
							$author$project$Dashboards2$setUserFilters,
							userFilters,
							_Utils_update(
								model,
								{o: editSection, dN: false}))))));
	});
var $author$project$Dashboards2$UserFilters$setSampleSize = F3(
	function (audienceToUpdate, sampleSizeResult, uf) {
		var userFilters = uf;
		switch (audienceToUpdate.$) {
			case 0:
				var _v1 = userFilters.aU;
				if (!_v1.$) {
					return _Utils_update(
						userFilters,
						{
							aU: $author$project$Dashboards2$UserFilters$Default(sampleSizeResult)
						});
				} else {
					return uf;
				}
			case 1:
				var _v2 = userFilters.aU;
				if (_v2.$ === 1) {
					var audience = _v2.a;
					return _Utils_update(
						userFilters,
						{
							aU: $author$project$Dashboards2$UserFilters$Base(
								_Utils_update(
									audience,
									{eQ: sampleSizeResult}))
						});
				} else {
					return uf;
				}
			default:
				var id = audienceToUpdate.a;
				return function (newAudiences) {
					return _Utils_update(
						userFilters,
						{d9: newAudiences});
				}(
					A2(
						$elm$core$List$map,
						function (colored) {
							var audience = colored.fk;
							return _Utils_eq(audience.b, id) ? _Utils_update(
								colored,
								{
									fk: _Utils_update(
										audience,
										{eQ: sampleSizeResult})
								}) : colored;
						},
						userFilters.d9));
		}
	});
var $author$project$Dashboards2$Widget$setVisibility = F2(
	function (isVisible, model) {
		return _Utils_update(
			model,
			{cz: isVisible});
	});
var $author$project$Icons$Platform2$sharing = {
	mr: $author$project$Icons$Platform2$path('M14.536 14.91c1.212 0 2.42.24 3.462.689l.037.018c.506-.212 1.056-.33 1.628-.329C22.06 15.291 24 17.24 24 19.644c0 2.337-1.833 4.244-4.136 4.351L19.66 24l-.204-.005c-1.536-.071-2.864-.944-3.577-2.21H9.412c-.744 0-1.338-.593-1.406-1.331L8 20.314v-.788c0-2.715 3.035-4.617 6.536-4.617zm5.126 1.744c-1.603-.001-2.981 1.381-2.981 2.99 0 .407.08.794.226 1.147.013.02.023.043.032.067.439.996 1.407 1.705 2.546 1.771l.175.004.175-.004c1.506-.087 2.712-1.297 2.799-2.81l.005-.175c0-1.65-1.332-2.988-2.977-2.99zm2.106 1.692c.239.24.263.614.071.88l-.072.086-2.033 2.04c-.24.24-.612.263-.878.071l-.084-.072-1.22-1.224c-.265-.267-.265-.7 0-.966.24-.24.613-.264.879-.072l.084.072.737.74 1.553-1.555c.266-.267.697-.267.963 0zm-7.232-2.071c-2.763 0-5.041 1.378-5.17 3.098l-.005.153v.788c0 .05.02.084.036.098l.015.007h5.976c-.045-.252-.068-.51-.068-.774 0-1.192.505-2.289 1.307-3.084-.66-.187-1.374-.286-2.091-.286zm0-8.275c1.788 0 3.237 1.454 3.237 3.248 0 1.794-1.449 3.248-3.237 3.248-1.787 0-3.236-1.454-3.236-3.248C11.3 9.454 12.75 8 14.536 8zm0 1.366c-1.035 0-1.875.843-1.875 1.882 0 1.04.84 1.882 1.875 1.882 1.036 0 1.876-.842 1.876-1.882s-.84-1.882-1.876-1.882z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Detail$stickyHeaderElementId = 'd2-detail-sticky-header-element-id';
var $elm_community$list_extra$List$Extra$reverseAppend = F2(
	function (list1, list2) {
		return A3($elm$core$List$foldl, $elm$core$List$cons, list2, list1);
	});
var $elm_community$list_extra$List$Extra$removeHelp = F4(
	function (list, x, xs, previousElements) {
		removeHelp:
		while (true) {
			if (!xs.b) {
				return list;
			} else {
				var y = xs.a;
				var ys = xs.b;
				if (_Utils_eq(x, y)) {
					return A2($elm_community$list_extra$List$Extra$reverseAppend, previousElements, ys);
				} else {
					var $temp$list = list,
						$temp$x = x,
						$temp$xs = ys,
						$temp$previousElements = A2($elm$core$List$cons, y, previousElements);
					list = $temp$list;
					x = $temp$x;
					xs = $temp$xs;
					previousElements = $temp$previousElements;
					continue removeHelp;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$remove = F2(
	function (x, xs) {
		return A4($elm_community$list_extra$List$Extra$removeHelp, xs, x, xs, _List_Nil);
	});
var $author$project$Gwi$List$toggle = F2(
	function (item, list) {
		return A2($elm$core$List$member, item, list) ? A2($elm_community$list_extra$List$Extra$remove, item, list) : _Utils_ap(
			list,
			_List_fromArray(
				[item]));
	});
var $author$project$Platform2$Dropdown$DropdownMenu$Closed = {$: 0};
var $author$project$Platform2$Dropdown$DropdownMenu$toggle = F2(
	function (_new, current) {
		var _v0 = _Utils_Tuple2(_new, current);
		if ((_v0.a.$ === 1) && (_v0.b.$ === 1)) {
			var newData = _v0.a.a;
			var currentData = _v0.b.a;
			return _Utils_eq(newData.b, currentData.b) ? $author$project$Platform2$Dropdown$DropdownMenu$Closed : _new;
		} else {
			return _new;
		}
	});
var $author$project$Dashboards2$UserFilters$ToggleAudience = 0;
var $author$project$Dashboards2$UserFilters$toggleAudienceVisibility = F3(
	function (_v0, id, _v1) {
		var filtersChanged = _v0.oM;
		var data = _v1;
		var newAudiences = A2(
			$elm$core$List$map,
			function (colored) {
				var audience = colored.fk;
				return _Utils_eq(audience.b, id) ? _Utils_update(
					colored,
					{
						fk: _Utils_update(
							audience,
							{pr: !audience.pr})
					}) : colored;
			},
			data.d9);
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
			filtersChanged(0),
			_Utils_update(
				data,
				{d9: newAudiences}));
	});
var $author$project$UndoRedo$undo = function (_v0) {
	var data = _v0;
	var _v1 = $elm$core$List$reverse(data.a4);
	if (!_v1.b) {
		return data;
	} else {
		var lastAdded = _v1.a;
		var restOfPrevious = _v1.b;
		return _Utils_update(
			data,
			{
				aq: lastAdded,
				bj: A3($author$project$UndoRedo$addWithLimit, data.gd, data.aq, data.bj),
				a4: $elm$core$List$reverse(restOfPrevious)
			});
	}
};
var $author$project$Dashboards2$UserFilters$fetchMissingData = F3(
	function (config, flags, _v0) {
		var uf = _v0;
		return A3(
			$author$project$Dashboards2$UserFilters$fetchSampleSize,
			config,
			flags,
			_Utils_update(
				uf,
				{
					d9: A2(
						$elm$core$List$map,
						function (colored) {
							var audience = colored.fk;
							return $krisajenkins$remotedata$RemoteData$isSuccess(audience.eQ) ? colored : _Utils_update(
								colored,
								{
									fk: _Utils_update(
										audience,
										{eQ: $krisajenkins$remotedata$RemoteData$NotAsked})
								});
						},
						uf.d9),
					aU: function () {
						var _v1 = uf.aU;
						if (!_v1.$) {
							var sampleSize_ = _v1.a;
							return $krisajenkins$remotedata$RemoteData$isSuccess(sampleSize_) ? uf.aU : $author$project$Dashboards2$UserFilters$Default($krisajenkins$remotedata$RemoteData$NotAsked);
						} else {
							var audience = _v1.a;
							return $krisajenkins$remotedata$RemoteData$isSuccess(audience.eQ) ? uf.aU : $author$project$Dashboards2$UserFilters$Base(
								_Utils_update(
									audience,
									{eQ: $krisajenkins$remotedata$RemoteData$NotAsked}));
						}
					}()
				}));
	});
var $author$project$Dashboards2$undoRedoAction = F7(
	function (config, flags, route, store, undoOrRedo, createAnalytics, model) {
		var analyticsCmd = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$elm$core$Platform$Cmd$none,
			function (dashboardFullyLoaded) {
				return $author$project$Dashboards2$Analytics$trackEvent(
					createAnalytics(
						{nM: flags.nM, ep: dashboardFullyLoaded}));
			},
			A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
		return A3(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			A5(
				$author$project$Dashboards2$requestDataForAllWidgetsIfNotLoaded,
				config,
				flags,
				route,
				store,
				{bi: false}),
			A3(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				function (m) {
					var _v0 = $author$project$Dashboards2$getUserFilters(m);
					if (!_v0.$) {
						var userFilters = _v0.a;
						var _v1 = A3($author$project$Dashboards2$UserFilters$fetchMissingData, $author$project$Dashboards2$userFiltersConfig, flags, userFilters);
						var newFilters = _v1.a;
						var filtersCmds = _v1.b;
						return A2(
							$turboMaCk$glue$Glue$map,
							config.a,
							A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
								filtersCmds,
								A2(
									$author$project$Dashboards2$updateCurrentUserFilters,
									$author$project$Dashboards2$Editable$update(newFilters),
									m)));
					} else {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(m);
					}
				},
				A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
					analyticsCmd,
					$author$project$Dashboards2$closeDropdown(
						_Utils_update(
							model,
							{
								G: undoOrRedo(model.G)
							})))));
	});
var $author$project$Dashboards2$DiscardChangesAndForceNavigateTo = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$SaveDashboardAndNavigateTo = function (a) {
	return {$: 61, a: a};
};
var $author$project$Dashboards2$unsavedChangesConfirmDialog = F2(
	function (route, model) {
		return _Utils_update(
			model,
			{
				c: $author$project$Dashboards2$Modal$ConfirmModal(
					{
						aH: _List_fromArray(
							[
								{
								cd: $author$project$Dashboards2$DiscardChangesAndForceNavigateTo(route),
								cy: false,
								Y: 'Discard changes'
							},
								{
								cd: $author$project$Dashboards2$SaveDashboardAndNavigateTo(route),
								cy: true,
								Y: 'Save changes'
							}
							]),
						ft: $elm$core$Maybe$Just($author$project$Dashboards2$CloseModal),
						U: A2(
							$elm$html$Html$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$p,
									_List_Nil,
									_List_fromArray(
										[
											$elm$html$Html$text('Changes that you have made will not be saved. Are you sure you want to continue?')
										]))
								])),
						bF: $author$project$Dashboards2$Modal$Hidden,
						Y: 'You have unsaved changes'
					})
			});
	});
var $author$project$Dashboards2$Analytics$ChartSelected = function (a) {
	return {$: 36, a: a};
};
var $author$project$Dashboards2$Analytics$CreateChart = function (a) {
	return {$: 35, a: a};
};
var $author$project$Store$AttributesTaxonomy$FetchCategory = $elm$core$Basics$identity;
var $author$project$Platform2$SortingHeader$Off = 2;
var $author$project$Dashboards2$ChartBrowser$QuestionCharts = 2;
var $author$project$Dashboards2$ChartBrowser$SearchInputMsg = function (a) {
	return {$: 7, a: a};
};
var $elm_community$list_extra$List$Extra$dropWhileRight = function (p) {
	return A2(
		$elm$core$List$foldr,
		F2(
			function (x, xs) {
				return (p(x) && $elm$core$List$isEmpty(xs)) ? _List_Nil : A2($elm$core$List$cons, x, xs);
			}),
		_List_Nil);
};
var $author$project$Store$AttributesTaxonomy$CategoryFetchError = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $author$project$Store$AttributesTaxonomy$CategoryFetched = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Store$AttributesTaxonomy$TopLevelCategoryFetched = function (a) {
	return {$: 1, a: a};
};
var $author$project$Store$AttributesTaxonomy$host = A2(
	$elm$core$Basics$composeR,
	function ($) {
		return $.j8;
	},
	A2(
		$elm$core$Basics$composeR,
		$author$project$Config$Main$get,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.dV;
			},
			function ($) {
				return $.d5;
			})));
var $author$project$Store$AttributesTaxonomy$taxonomyFolderIdUnwrap = function (categoryId) {
	if (!categoryId.$) {
		var id = categoryId.a;
		return id;
	} else {
		var id = categoryId.a;
		return id;
	}
};
var $author$project$Store$AttributesTaxonomy$CategoryFolderId = function (a) {
	return {$: 0, a: a};
};
var $author$project$Store$AttributesTaxonomy$CategoryInfo = F5(
	function (id, name, order, description, datasets) {
		return {es: datasets, hB: description, b: id, ld: name, gq: order};
	});
var $author$project$Store$AttributesTaxonomy$CategoryLevel = function (a) {
	return {$: 0, a: a};
};
var $author$project$Store$AttributesTaxonomy$QuestionLevel = function (a) {
	return {$: 1, a: a};
};
var $author$project$Store$AttributesTaxonomy$TaxonomyLevel = F2(
	function (children, currentCategory) {
		return {eg: children, di: currentCategory};
	});
var $author$project$Store$AttributesTaxonomy$TaxonomyLevelChildrenList = function (a) {
	return {$: 0, a: a};
};
var $author$project$Store$AttributesTaxonomy$DatasetInfo = F4(
	function (code, baseNamespaceCode, description, name) {
		return {jt: baseNamespaceCode, bW: code, hB: description, ld: name};
	});
var $author$project$Gwi$Json$Decode$emptyStringAsNull = A2(
	$elm$json$Json$Decode$map,
	$elm_community$maybe_extra$Maybe$Extra$filter(
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty)),
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Store$AttributesTaxonomy$datasetInfoDecoder = A2(
	$elm_community$json_extra$Json$Decode$Extra$andMap,
	A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
	A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2($elm$json$Json$Decode$field, 'description', $author$project$Gwi$Json$Decode$emptyStringAsNull),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'base_namespace_code', $author$project$Data$Id$decode),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
				$elm$json$Json$Decode$succeed($author$project$Store$AttributesTaxonomy$DatasetInfo)))));
var $author$project$Store$AttributesTaxonomy$QuestionInfo = F5(
	function (questionCode, namespaceCode, description, name, order) {
		return {hB: description, ld: name, id: namespaceCode, gq: order, at: questionCode};
	});
var $author$project$Store$AttributesTaxonomy$questionInfoDecoder = function (order) {
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$succeed(order),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'question_label', $elm$json$Json$Decode$string),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'question_description', $author$project$Gwi$Json$Decode$emptyStringAsNull),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'namespace_code', $author$project$Data$Id$decode),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'question_code', $author$project$Data$Id$decode),
						$elm$json$Json$Decode$succeed($author$project$Store$AttributesTaxonomy$QuestionInfo))))));
};
var $author$project$Store$AttributesTaxonomy$taxonomyLevelDecoder = function () {
	var datasetsFromTaxonomyPathsDecoder = A2(
		$elm$json$Json$Decode$field,
		'taxonomy_paths',
		$elm$json$Json$Decode$list(
			A2($elm$json$Json$Decode$field, 'dataset', $author$project$Store$AttributesTaxonomy$datasetInfoDecoder)));
	var categoryDecoder = function (datasets) {
		return A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			$elm$json$Json$Decode$succeed(datasets),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(0),
						A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'order', $elm$json$Json$Decode$float)),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Store$AttributesTaxonomy$CategoryFolderId,
								A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
							$elm$json$Json$Decode$succeed($author$project$Store$AttributesTaxonomy$CategoryInfo))))));
	};
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$map,
					$author$project$Store$AttributesTaxonomy$CategoryFolderId,
					A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
				$elm$json$Json$Decode$succeed(
					F2(
						function (id, name) {
							return A5($author$project$Store$AttributesTaxonomy$CategoryInfo, id, name, 0, $elm$core$Maybe$Nothing, _List_Nil);
						})))),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$map,
				A2($elm$core$Basics$composeR, $author$project$Store$AttributesTaxonomy$TaxonomyLevelChildrenList, $elm$core$List$singleton),
				A3(
					$elm$json$Json$Decode$map2,
					$elm$core$Basics$append,
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(_List_Nil),
						A2(
							$elm$json$Json$Decode$andThen,
							function (datasets) {
								return A2(
									$elm_community$json_extra$Json$Decode$Extra$optionalField,
									'category_children',
									$elm$json$Json$Decode$list(
										A2(
											$elm$json$Json$Decode$map,
											$author$project$Store$AttributesTaxonomy$CategoryLevel,
											categoryDecoder(datasets))));
							},
							datasetsFromTaxonomyPathsDecoder)),
					A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$withDefault(_List_Nil),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$optionalField,
							'question_children',
							$elm_community$json_extra$Json$Decode$Extra$indexedList(
								A2(
									$elm$core$Basics$composeL,
									A2(
										$elm$core$Basics$composeL,
										$elm$json$Json$Decode$map($author$project$Store$AttributesTaxonomy$QuestionLevel),
										$author$project$Store$AttributesTaxonomy$questionInfoDecoder),
									$elm$core$Basics$toFloat)))))),
			$elm$json$Json$Decode$succeed($author$project$Store$AttributesTaxonomy$TaxonomyLevel)));
}();
var $author$project$Store$AttributesTaxonomy$fetchCategory = F2(
	function (categoryId, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'category_id',
								$elm$json$Json$Encode$string(
									$author$project$Store$AttributesTaxonomy$taxonomyFolderIdUnwrap(categoryId)))
							]))),
				hK: A2($author$project$Gwi$Http$expectJson, $elm$core$Basics$identity, $author$project$Store$AttributesTaxonomy$taxonomyLevelDecoder),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'POST',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: A3(
					$elm$url$Url$Builder$crossOrigin,
					$author$project$Store$AttributesTaxonomy$host(flags),
					_List_fromArray(
						['platform', 'category']),
					_List_Nil)
			});
	});
var $author$project$Store$AttributesTaxonomy$DatasetFolderId = function (a) {
	return {$: 1, a: a};
};
var $author$project$Store$AttributesTaxonomy$TaxonomyLevelChildrenForParent = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Store$AttributesTaxonomy$taxonomyTopLevelDecoder = function (order) {
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'categories',
			$elm$json$Json$Decode$list(
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2(
								$elm$json$Json$Decode$map,
								$author$project$Store$AttributesTaxonomy$CategoryFolderId,
								A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
							$elm$json$Json$Decode$succeed(
								F3(
									function (id, name, order_) {
										return _Utils_Tuple3(id, name, order_);
									}))))))),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'description', $author$project$Gwi$Json$Decode$emptyStringAsNull),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'base_namespace_code', $author$project$Data$Id$decode),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'code', $author$project$Data$Id$decode),
						$elm$json$Json$Decode$succeed(
							F5(
								function (code, name, namespaceCode, description, categories) {
									var datasets = _List_fromArray(
										[
											{jt: namespaceCode, bW: code, hB: description, ld: name}
										]);
									if (categories.b && (!categories.b.b)) {
										var _v1 = categories.a;
										var id = _v1.a;
										var order_ = _v1.c;
										return {
											eg: _List_Nil,
											di: {
												es: datasets,
												hB: description,
												b: id,
												ld: name,
												gq: A2($elm$core$Maybe$withDefault, order_, order)
											}
										};
									} else {
										var moreOrEmpty = categories;
										var parentId = $author$project$Store$AttributesTaxonomy$DatasetFolderId(
											$author$project$Data$Id$unwrap(code));
										return {
											eg: $elm$core$List$singleton(
												A2(
													$author$project$Store$AttributesTaxonomy$TaxonomyLevelChildrenForParent,
													parentId,
													A2(
														$elm$core$List$map,
														function (_v2) {
															var categoryId = _v2.a;
															var categoryName = _v2.b;
															var order_ = _v2.c;
															return $author$project$Store$AttributesTaxonomy$CategoryLevel(
																{
																	es: datasets,
																	hB: $elm$core$Maybe$Nothing,
																	b: categoryId,
																	ld: categoryName,
																	gq: A2($elm$core$Maybe$withDefault, order_, order)
																});
														},
														moreOrEmpty))),
											di: {
												es: datasets,
												hB: description,
												b: parentId,
												ld: name,
												gq: A2($elm$core$Maybe$withDefault, 0, order)
											}
										};
									}
								})))))));
};
var $author$project$Store$AttributesTaxonomy$datasetFoldersDecoder = function (_v0) {
	var rootFolderId = _v0.lR;
	var toOrder = F3(
		function (order, multiplier, i) {
			return $elm$core$Maybe$Just((multiplier * (i + 1)) + order);
		});
	var nonSyndicatedDecoder = F2(
		function (doRecursion, maybeOrder) {
			return A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					doRecursion ? A2(
						$elm$json$Json$Decode$andThen,
						function (order) {
							return A2(
								$elm$json$Json$Decode$map,
								A2($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$Gwi$List$fastConcat),
								A2(
									$elm_community$json_extra$Json$Decode$Extra$optionalField,
									'child_folders',
									$elm$json$Json$Decode$list(
										A2(
											nonSyndicatedDecoder,
											false,
											$elm$core$Maybe$Just(order)))));
						},
						A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float)) : $elm$json$Json$Decode$succeed(_List_Nil),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2(
							$elm$json$Json$Decode$map,
							$elm$core$Maybe$withDefault(_List_Nil),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$optionalField,
								'child_datasets',
								$elm_community$json_extra$Json$Decode$Extra$indexedList(
									function (i) {
										return $author$project$Store$AttributesTaxonomy$taxonomyTopLevelDecoder(
											A2(
												$elm$core$Maybe$andThen,
												function (order) {
													return A3(toOrder, order, 0.001, i);
												},
												maybeOrder));
									}))),
						$elm$json$Json$Decode$succeed($elm$core$Basics$append))),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm$json$Json$Decode$field, 'description', $author$project$Gwi$Json$Decode$emptyStringAsNull),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm$json$Json$Decode$field, 'name', $elm$json$Json$Decode$string),
							A2(
								$elm_community$json_extra$Json$Decode$Extra$andMap,
								A2(
									$elm$json$Json$Decode$map,
									$author$project$Store$AttributesTaxonomy$DatasetFolderId,
									A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
								$elm$json$Json$Decode$succeed(
									F5(
										function (id, name, description, order, childDatasets) {
											return _List_fromArray(
												[
													{
													eg: A2(
														$author$project$Gwi$List$fastConcatMap,
														function (_v1) {
															var currentCategory = _v1.di;
															var children = _v1.eg;
															return _Utils_ap(
																_List_fromArray(
																	[
																		A2(
																		$author$project$Store$AttributesTaxonomy$TaxonomyLevelChildrenForParent,
																		id,
																		_List_fromArray(
																			[
																				$author$project$Store$AttributesTaxonomy$CategoryLevel(currentCategory)
																			]))
																	]),
																A2(
																	$elm$core$List$map,
																	function (children_) {
																		_v2$2:
																		while (true) {
																			if (!children_.$) {
																				if (!children_.a.b) {
																					return A2(
																						$author$project$Store$AttributesTaxonomy$TaxonomyLevelChildrenForParent,
																						id,
																						_List_fromArray(
																							[
																								$author$project$Store$AttributesTaxonomy$CategoryLevel(currentCategory)
																							]));
																				} else {
																					break _v2$2;
																				}
																			} else {
																				if (!children_.b.b) {
																					var parent = children_.a;
																					return A2(
																						$author$project$Store$AttributesTaxonomy$TaxonomyLevelChildrenForParent,
																						parent,
																						_List_fromArray(
																							[
																								$author$project$Store$AttributesTaxonomy$CategoryLevel(currentCategory)
																							]));
																				} else {
																					break _v2$2;
																				}
																			}
																		}
																		var nonEmpty = children_;
																		return nonEmpty;
																	},
																	children));
														},
														childDatasets),
													di: {
														es: _List_Nil,
														hB: description,
														b: id,
														ld: name,
														gq: A2($elm$core$Maybe$withDefault, order, maybeOrder)
													}
												}
												]);
										})))))));
		});
	var syndicatedDecoder = function (order) {
		return A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2(
				$elm$json$Json$Decode$map,
				A2($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $author$project$Gwi$List$fastConcat),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$optionalField,
					'child_folders',
					$elm_community$json_extra$Json$Decode$Extra$indexedList(
						function (i) {
							return A2(
								nonSyndicatedDecoder,
								true,
								A3(toOrder, order, 0.01, i));
						}))),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2(
					$elm$json$Json$Decode$map,
					$elm$core$Maybe$withDefault(_List_Nil),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$optionalField,
						'child_datasets',
						$elm_community$json_extra$Json$Decode$Extra$indexedList(
							function (i) {
								return $author$project$Store$AttributesTaxonomy$taxonomyTopLevelDecoder(
									A3(toOrder, order, 0.001, i));
							}))),
				$elm$json$Json$Decode$succeed($elm$core$Basics$append)));
	};
	var decoder = A2(
		$elm$json$Json$Decode$andThen,
		function (_v3) {
			var id = _v3.a;
			var order = _v3.b;
			return _Utils_eq(id, rootFolderId) ? syndicatedDecoder(order) : A2(nonSyndicatedDecoder, true, $elm$core$Maybe$Nothing);
		},
		A3(
			$elm$json$Json$Decode$map2,
			$elm$core$Tuple$pair,
			A2(
				$elm$json$Json$Decode$map,
				$author$project$Store$AttributesTaxonomy$DatasetFolderId,
				A2($elm$json$Json$Decode$field, 'id', $elm$json$Json$Decode$string)),
			A2($elm$json$Json$Decode$field, 'order', $elm$json$Json$Decode$float)));
	return A2(
		$elm$json$Json$Decode$map,
		$author$project$Gwi$List$fastConcat,
		$elm$json$Json$Decode$list(decoder));
};
var $author$project$Store$AttributesTaxonomy$gwiSyndicatedFolder = function (flags) {
	return $author$project$Store$AttributesTaxonomy$DatasetFolderId(
		function () {
			var _v0 = flags.j8;
			switch (_v0) {
				case 0:
					return '105';
				case 1:
					return '105';
				case 2:
					return '105';
				case 3:
					return '446';
				default:
					return '446';
			}
		}());
};
var $author$project$Store$AttributesTaxonomy$fetchFolders = function (flags) {
	return $elm$http$Http$request(
		{
			jv: $elm$http$Http$emptyBody,
			hK: A2(
				$author$project$Gwi$Http$expectJson,
				$elm$core$Basics$identity,
				$author$project$Store$AttributesTaxonomy$datasetFoldersDecoder(
					{
						lR: $author$project$Store$AttributesTaxonomy$gwiSyndicatedFolder(flags)
					})),
			hU: _List_fromArray(
				[
					$author$project$Data$Auth$header(flags.i$)
				]),
			h8: 'GET',
			iY: $elm$core$Maybe$Nothing,
			i0: $elm$core$Maybe$Nothing,
			c3: A3(
				$elm$url$Url$Builder$crossOrigin,
				$author$project$Store$AttributesTaxonomy$host(flags),
				_List_fromArray(
					['platform', 'dataset-folders']),
				_List_Nil)
		});
};
var $author$project$Store$AttributesTaxonomy$fetch_ = F4(
	function (r, _v0, flags, store) {
		var msg = _v0.a;
		return _Utils_eq(
			r.oS(store),
			$krisajenkins$remotedata$RemoteData$NotAsked) ? A8(
			$author$project$Store$Utils$fetch,
			$elm$core$Basics$never,
			r.oS,
			A2($elm$core$Basics$composeL, msg, r.gp),
			function (s) {
				return A2(
					$elm$core$Basics$composeR,
					r.gn(s),
					msg);
			},
			r.gG,
			F2(
				function (store_, result) {
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						A2(r.eT, $krisajenkins$remotedata$RemoteData$Loading, store_),
						function (e) {
							return A2(
								r.eT,
								$krisajenkins$remotedata$RemoteData$Failure(e),
								store_);
						},
						result);
				}),
			flags,
			store) : _Utils_Tuple2(store, $elm$core$Platform$Cmd$none);
	});
var $author$project$Store$AttributesTaxonomy$sortByOrder = $elm$core$List$sortBy(
	function (item) {
		if (!item.$) {
			var category = item.a;
			return category.gq;
		} else {
			var question = item.a;
			return question.gq;
		}
	});
var $author$project$Store$AttributesTaxonomy$getCategory = F2(
	function (categoryId, store) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$author$project$Store$AttributesTaxonomy$sortByOrder,
			A2(
				$elm$core$Maybe$withDefault,
				$krisajenkins$remotedata$RemoteData$NotAsked,
				A2($turboMaCk$any_dict$Dict$Any$get, categoryId, store.ac)));
	});
var $author$project$Store$AttributesTaxonomy$fetch = function (action) {
	var maybeCategoryId = action;
	if (!maybeCategoryId.$) {
		var categoryId = maybeCategoryId.a;
		return $author$project$Store$AttributesTaxonomy$fetch_(
			{
				oS: $author$project$Store$AttributesTaxonomy$getCategory(maybeCategoryId),
				gn: $author$project$Store$AttributesTaxonomy$CategoryFetchError,
				gp: $author$project$Store$AttributesTaxonomy$CategoryFetched(maybeCategoryId),
				gG: $author$project$Store$AttributesTaxonomy$fetchCategory(categoryId),
				eT: F2(
					function (val, store_) {
						return _Utils_update(
							store_,
							{
								ac: A3($turboMaCk$any_dict$Dict$Any$insert, maybeCategoryId, val, store_.ac)
							});
					})
			});
	} else {
		return $author$project$Store$AttributesTaxonomy$fetch_(
			{
				oS: $author$project$Store$AttributesTaxonomy$getCategory(maybeCategoryId),
				gn: $author$project$Store$AttributesTaxonomy$CategoryFetchError,
				gp: $author$project$Store$AttributesTaxonomy$TopLevelCategoryFetched,
				gG: $author$project$Store$AttributesTaxonomy$fetchFolders,
				eT: F2(
					function (val, store_) {
						return _Utils_update(
							store_,
							{
								ac: A3($turboMaCk$any_dict$Dict$Any$insert, $elm$core$Maybe$Nothing, val, store_.ac)
							});
					})
			});
	}
};
var $author$project$Platform2$SearchInput$NoOp = {$: 2};
var $author$project$Platform2$SearchInput$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 2:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var newSearchTerm = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cW: newSearchTerm}),
					$elm$core$Platform$Cmd$none);
			default:
				var elementId = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Platform2$SearchInput$NoOp),
						$elm$browser$Browser$Dom$focus(elementId)));
		}
	});
var $author$project$Store$AttributesTaxonomy$update = F3(
	function (config, msg, store) {
		var sort = $elm$core$List$sortBy(
			function (item) {
				if (!item.$) {
					var order = item.a.gq;
					return _Utils_Tuple2(0, order);
				} else {
					var order = item.a.gq;
					return _Utils_Tuple2(1, order);
				}
			});
		var taxonomyChildrenInserter = F3(
			function (parentId, children, acc) {
				var combineLists = F2(
					function (list, webdata) {
						if (webdata.$ === 3) {
							var listSoFar = webdata.a;
							return _Utils_ap(listSoFar, list);
						} else {
							return list;
						}
					});
				var updateDictHelper = F2(
					function (children_, currentValue) {
						return $elm$core$Maybe$Just(
							function () {
								if (!currentValue.$) {
									var value = currentValue.a;
									return $krisajenkins$remotedata$RemoteData$Success(
										sort(
											A2(combineLists, children_, value)));
								} else {
									return $krisajenkins$remotedata$RemoteData$Success(
										sort(children_));
								}
							}());
					});
				return A3(
					$elm$core$List$foldr,
					function (oneLevel) {
						if (!oneLevel.$) {
							var children_ = oneLevel.a;
							return A2(
								$turboMaCk$any_dict$Dict$Any$update,
								parentId,
								updateDictHelper(children_));
						} else {
							var parent = oneLevel.a;
							var children_ = oneLevel.b;
							return A2(
								$turboMaCk$any_dict$Dict$Any$update,
								$elm$core$Maybe$Just(parent),
								updateDictHelper(children_));
						}
					},
					acc,
					children);
			});
		var processTaxonomyLevel = F3(
			function (maybeCategoryId, _v2, store_) {
				var children = _v2.eg;
				var currentCategory = _v2.di;
				var insertChildrenIfAny = $elm$core$List$isEmpty(children) ? $elm$core$Basics$identity : A2(
					taxonomyChildrenInserter,
					$elm$core$Maybe$Just(currentCategory.b),
					children);
				return _Utils_update(
					store_,
					{
						ac: insertChildrenIfAny(
							A3(
								$turboMaCk$any_dict$Dict$Any$update,
								maybeCategoryId,
								$elm$core$Maybe$map(
									function (soFar) {
										switch (soFar.$) {
											case 3:
												var list = soFar.a;
												return $krisajenkins$remotedata$RemoteData$Success(
													sort(
														A2(
															$elm$core$List$cons,
															$author$project$Store$AttributesTaxonomy$CategoryLevel(currentCategory),
															list)));
											case 2:
												return soFar;
											default:
												return $krisajenkins$remotedata$RemoteData$Success(
													_List_fromArray(
														[
															$author$project$Store$AttributesTaxonomy$CategoryLevel(currentCategory)
														]));
										}
									}),
								store_.ac))
					});
			});
		switch (msg.$) {
			case 0:
				var maybeCategoryId = msg.a;
				var children = msg.b.eg;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							ac: A3(taxonomyChildrenInserter, maybeCategoryId, children, store.ac)
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var taxonomyLevels = msg.a;
				return _Utils_Tuple2(
					A3(
						$elm$core$List$foldr,
						processTaxonomyLevel($elm$core$Maybe$Nothing),
						store,
						taxonomyLevels),
					$elm$core$Platform$Cmd$none);
			default:
				var updateStoreFn = msg.a;
				var err = msg.b;
				return _Utils_Tuple2(
					updateStoreFn(store),
					$GlobalWebIndex$cmd_extra$Cmd$Extra$perform(
						config.ox(err)));
		}
	});
var $author$project$Dashboards2$ChartBrowser$update = F4(
	function (config, flags, msg, model) {
		var fetchLineages = function (maybeCategory) {
			if (!maybeCategory.$) {
				var categoryInfo = maybeCategory.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
					config.l(
						A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.jt;
								},
								$author$project$Store$Platform2$FetchLineage),
							categoryInfo.es)));
			} else {
				return $elm$core$Basics$identity;
			}
		};
		var fetchCategory = F2(
			function (maybeCategory, model_) {
				return A2(
					$elm$core$Tuple$mapFirst,
					function (newTaxonomyStore) {
						return _Utils_update(
							model_,
							{c_: newTaxonomyStore});
					},
					A4(
						$author$project$Store$AttributesTaxonomy$fetch,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.b;
							},
							maybeCategory),
						config.gU,
						flags,
						model_.c_));
			});
		switch (msg.$) {
			case 0:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			case 3:
				var time = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{dk: time}));
			case 7:
				var subMsg = msg.a;
				return function (_v1) {
					var subm_ = _v1.a;
					var subcmd = _v1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aR: subm_}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ChartBrowser$SearchInputMsg),
							subcmd));
				}(
					A2($author$project$Platform2$SearchInput$update, subMsg, model.aR));
			case 8:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{aR: $author$project$Platform2$SearchInput$initialModel}));
			case 1:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{aE: _List_Nil}));
			case 2:
				var sortBy = msg.a;
				var direction = msg.b;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							eZ: (direction === 2) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								{fH: direction, cY: sortBy})
						}));
			case 4:
				var maybeFolderId = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{dj: maybeFolderId}));
			case 5:
				var item = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aE: A2($author$project$Gwi$List$toggle, item, model.aE)
						}),
					function () {
						if (!item.$) {
							var name = item.a.ld;
							return $author$project$Dashboards2$Analytics$trackEvent(
								$author$project$Dashboards2$Analytics$ChartSelected(
									{
										hh: name,
										nU: !A2($elm$core$List$member, item, model.aE)
									}));
						} else {
							var qInfo = item.a;
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$perform(
								config.l(
									_List_fromArray(
										[
											A2(
											$author$project$Store$Platform2$FetchQuestion,
											{mf: false},
											A2($author$project$Data$Labels$addNamespaceToQuestionCode, qInfo.id, qInfo.at))
										])));
						}
					}());
			case 6:
				var chart = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.eH(chart),
					model);
			case 9:
				var nonEmptyCharts = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.ob(nonEmptyCharts),
					model);
			case 10:
				var newTab = msg.a;
				var fetchCategoryIfNeeded = (newTab === 2) ? fetchCategory(model.di) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
				return fetchCategoryIfNeeded(
					_Utils_update(
						model,
						{eo: newTab}));
			case 11:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
					config.o_,
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
						$author$project$Dashboards2$Analytics$trackEvent(
							$author$project$Dashboards2$Analytics$CreateChart(
								{iq: 6})),
						model));
			case 12:
				var atMsg = msg.a;
				var _v3 = A3($author$project$Store$AttributesTaxonomy$update, config.gU, atMsg, model.c_);
				var newTaxonomyStore = _v3.a;
				var cmds = _v3.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c_: newTaxonomyStore}),
					cmds);
			case 14:
				var maybeCategory = msg.a;
				return A2(
					fetchLineages,
					maybeCategory,
					A2(
						fetchCategory,
						maybeCategory,
						_Utils_update(
							model,
							{
								cf: function () {
									if (!maybeCategory.$) {
										var category = maybeCategory.a;
										return A2($elm$core$List$member, category, model.cf) ? A2(
											$elm_community$list_extra$List$Extra$dropWhileRight,
											$elm$core$Basics$neq(category),
											model.cf) : _Utils_ap(
											model.cf,
											_List_fromArray(
												[category]));
									} else {
										return _List_Nil;
									}
								}(),
								di: maybeCategory
							})));
			default:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Dashboards2$List$FilterDropdown = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Analytics$ManagementFilter = function (a) {
	return {$: 39, a: a};
};
var $author$project$Dashboards2$List$SearchInputMsg = function (a) {
	return {$: 21, a: a};
};
var $author$project$DropDownMenu$Closed = {$: 0};
var $author$project$DropDownMenu$applyOpenClosed = F3(
	function (fcOpen, _const, m) {
		if (m.$ === 1) {
			var config = m.a;
			return fcOpen(config);
		} else {
			return _const;
		}
	});
var $author$project$DropDownMenu$attemptState = F2(
	function (currentState, newState) {
		var getNewState = F2(
			function (state1, state2) {
				return _Utils_eq(state1.b, state2.b) ? $author$project$DropDownMenu$Closed : newState;
			});
		var openCurrent = function (state) {
			return A3(
				$author$project$DropDownMenu$applyOpenClosed,
				getNewState(state),
				newState,
				newState);
		};
		return A3($author$project$DropDownMenu$applyOpenClosed, openCurrent, newState, currentState);
	});
var $author$project$Dashboards2$List$closeDropdown = function (model) {
	return _Utils_update(
		model,
		{
			aA: _Utils_Tuple2($author$project$Dashboards2$List$NoDropdown, $elm$core$Maybe$Nothing)
		});
};
var $author$project$Dashboards2$List$dashboardTypeLabel = F2(
	function (user, type_) {
		switch (type_) {
			case 2:
				return 'GWI';
			case 1:
				return A2($elm$core$Maybe$withDefault, 'My Organisation', user.bL);
			default:
				return 'Me';
		}
	});
var $author$project$DropDownMenu$init = $author$project$DropDownMenu$Closed;
var $author$project$Dashboards2$List$isDropdownSelected = F2(
	function (dd, _v0) {
		var dropdown = _v0.aA;
		return _Utils_eq(dd, dropdown.a);
	});
var $elm_community$list_extra$List$Extra$indexedFoldr = F3(
	function (func, acc, list) {
		var step = F2(
			function (x, _v0) {
				var i = _v0.a;
				var thisAcc = _v0.b;
				return _Utils_Tuple2(
					i - 1,
					A3(func, i, x, thisAcc));
			});
		return A3(
			$elm$core$List$foldr,
			step,
			_Utils_Tuple2(
				$elm$core$List$length(list) - 1,
				acc),
			list).b;
	});
var $author$project$Gwi$List$selectRange = F2(
	function (_v0, allItems) {
		var isSelected = _v0.pv;
		var itemToSelect = _v0.py;
		var selectedAround = A3(
			$elm_community$list_extra$List$Extra$indexedFoldl,
			F3(
				function (index, item, acc) {
					return isSelected(item) ? (($elm_community$maybe_extra$Maybe$Extra$isJust(acc.dw) && _Utils_eq(acc.gk, $elm$core$Maybe$Nothing)) ? _Utils_update(
						acc,
						{
							gk: $elm$core$Maybe$Just(index)
						}) : (_Utils_eq(acc.dw, $elm$core$Maybe$Nothing) ? _Utils_update(
						acc,
						{
							gx: $elm$core$Maybe$Just(index)
						}) : acc)) : (itemToSelect(item) ? _Utils_update(
						acc,
						{
							dw: $elm$core$Maybe$Just(index)
						}) : acc);
				}),
			{dw: $elm$core$Maybe$Nothing, gk: $elm$core$Maybe$Nothing, gx: $elm$core$Maybe$Nothing},
			allItems);
		var fromPreviousToKey = function () {
			var _v4 = _Utils_Tuple2(selectedAround.gx, selectedAround.dw);
			_v4$2:
			while (true) {
				if (!_v4.a.$) {
					if (!_v4.b.$) {
						var previousSelected = _v4.a.a;
						var keyIndex = _v4.b.a;
						return _Utils_Tuple2(previousSelected, keyIndex);
					} else {
						break _v4$2;
					}
				} else {
					if (!_v4.b.$) {
						var _v5 = _v4.a;
						var keyIndex = _v4.b.a;
						return _Utils_Tuple2(keyIndex, keyIndex);
					} else {
						break _v4$2;
					}
				}
			}
			return _Utils_Tuple2(-1, -1);
		}();
		var fromKeyToNext = function () {
			var _v2 = _Utils_Tuple2(selectedAround.gk, selectedAround.dw);
			_v2$2:
			while (true) {
				if (!_v2.a.$) {
					if (!_v2.b.$) {
						var nextSelected = _v2.a.a;
						var keyIndex = _v2.b.a;
						return _Utils_Tuple2(keyIndex, nextSelected);
					} else {
						break _v2$2;
					}
				} else {
					if (!_v2.b.$) {
						var _v3 = _v2.a;
						var keyIndex = _v2.b.a;
						return _Utils_Tuple2(keyIndex, keyIndex);
					} else {
						break _v2$2;
					}
				}
			}
			return _Utils_Tuple2(-1, -1);
		}();
		var _v1 = $elm_community$maybe_extra$Maybe$Extra$isJust(selectedAround.gx) ? fromPreviousToKey : fromKeyToNext;
		var from = _v1.a;
		var to = _v1.b;
		return A3(
			$elm_community$list_extra$List$Extra$indexedFoldr,
			F2(
				function (index, currentItem) {
					return ((_Utils_cmp(from, index) < 1) && ((_Utils_cmp(index, to) < 1) && (!isSelected(currentItem)))) ? $elm$core$List$cons(currentItem) : $elm$core$Basics$identity;
				}),
			_List_Nil,
			allItems);
	});
var $author$project$Dashboards2$List$sortTypeLabel = function (sortType) {
	switch (sortType) {
		case 0:
			return 'Recently visited';
		case 1:
			return 'Popular';
		case 2:
			return 'Popular';
		case 3:
			return 'A–Z';
		case 4:
			return 'Z–A';
		default:
			return 'Promoted';
	}
};
var $turboMaCk$any_dict$Dict$Any$remove = F2(
	function (k, _v0) {
		var inner = _v0;
		return _Utils_update(
			inner,
			{
				i: A2(
					$elm$core$Dict$remove,
					inner.aT(k),
					inner.i)
			});
	});
var $turboMaCk$any_set$Set$Any$remove = F2(
	function (a, _v0) {
		var dict = _v0;
		return A2($turboMaCk$any_dict$Dict$Any$remove, a, dict);
	});
var $turboMaCk$any_set$Set$Any$toggle = F2(
	function (a, set) {
		return A2($turboMaCk$any_set$Set$Any$member, a, set) ? A2($turboMaCk$any_set$Set$Any$remove, a, set) : A2($turboMaCk$any_set$Set$Any$insert, a, set);
	});
var $author$project$Dashboards2$Analytics$trackEventIf = F2(
	function (cond, event) {
		return cond ? $author$project$Analytics$track(
			$author$project$Dashboards2$Analytics$encodeEvent(event)) : $elm$core$Platform$Cmd$none;
	});
var $author$project$Dashboards2$List$update = F4(
	function (config, user, msg, model) {
		switch (msg.$) {
			case 0:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			case 1:
				var allListedDashboarsd = msg.a;
				var dashboardId = msg.b;
				var shiftPressed = msg.c.rl;
				var dashboardIdsToSelect = (shiftPressed && (!A2($turboMaCk$any_set$Set$Any$member, dashboardId, model.J))) ? A2(
					$elm$core$List$map,
					function ($) {
						return $.b;
					},
					A2(
						$author$project$Gwi$List$selectRange,
						{
							pv: function (d) {
								return A2($turboMaCk$any_set$Set$Any$member, d.b, model.J);
							},
							py: A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.b;
								},
								$elm$core$Basics$eq(dashboardId))
						},
						allListedDashboarsd)) : _List_fromArray(
					[dashboardId]);
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							J: A3($elm$core$List$foldr, $turboMaCk$any_set$Set$Any$toggle, model.J, dashboardIdsToSelect)
						}));
			case 2:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							J: $turboMaCk$any_set$Set$Any$removeAll(model.J)
						}));
			case 3:
				var dashboards = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							J: A3($elm$core$List$foldr, $turboMaCk$any_set$Set$Any$insert, model.J, dashboards)
						}));
			case 4:
				var dashboards = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.qg(dashboards),
					model);
			case 5:
				var dashboardId = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.b9(dashboardId),
					$author$project$Dashboards2$List$closeDropdown(model));
			case 6:
				var route = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
					config.qU,
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						config.as(route),
						$author$project$Dashboards2$List$closeDropdown(model)));
			case 21:
				var subMsg = msg.a;
				return function (_v1) {
					var subm_ = _v1.a;
					var subcmd = _v1.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{aR: subm_}),
						A2(
							$elm$core$Platform$Cmd$map,
							A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$List$SearchInputMsg),
							subcmd));
				}(
					A2($author$project$Platform2$SearchInput$update, subMsg, model.aR));
			case 7:
				var tab = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							J: $turboMaCk$any_set$Set$Any$removeAll(model.J),
							a9: tab
						}));
			case 9:
				var newState = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							aA: _Utils_Tuple2(
								$author$project$Dashboards2$List$FilterDropdown(
									A2($author$project$DropDownMenu$attemptState, $author$project$DropDownMenu$init, newState)),
								$elm$core$Maybe$Nothing)
						}));
			case 8:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							aA: A2($elm$core$Tuple$pair, $author$project$Dashboards2$List$NoDropdown, $elm$core$Maybe$Nothing)
						}));
			case 10:
				var newDropdown = msg.a;
				var menuData = msg.b;
				return A2($author$project$Dashboards2$List$isDropdownSelected, newDropdown, model) ? _Utils_Tuple2(
					$author$project$Dashboards2$List$closeDropdown(model),
					$elm$core$Platform$Cmd$none) : _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: _Utils_Tuple2(
								newDropdown,
								$elm$core$Maybe$Just(menuData))
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var sortType = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{d$: sortType}),
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$ManagementFilter(
							{
								oL: 'sort',
								rd: $author$project$Dashboards2$List$sortTypeLabel(sortType)
							})));
			case 12:
				var type_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aV: A2($turboMaCk$any_set$Set$Any$toggle, type_, model.aV)
						}),
					A2(
						$author$project$Dashboards2$Analytics$trackEventIf,
						!A2($turboMaCk$any_set$Set$Any$member, type_, model.aV),
						$author$project$Dashboards2$Analytics$ManagementFilter(
							{oL: 'category', rd: type_.ld})));
			case 13:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aV: $turboMaCk$any_set$Set$Any$removeAll(model.aV)
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var dataset = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: A2($turboMaCk$any_set$Set$Any$toggle, dataset.bW, model.aZ)
						}),
					A2(
						$author$project$Dashboards2$Analytics$trackEventIf,
						!A2($turboMaCk$any_set$Set$Any$member, dataset.bW, model.aZ),
						$author$project$Dashboards2$Analytics$ManagementFilter(
							{oL: 'dataset', rd: dataset.ld})));
			case 15:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aZ: $turboMaCk$any_set$Set$Any$removeAll(model.aZ)
						}),
					$elm$core$Platform$Cmd$none);
			case 16:
				var type_ = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							az: A2($turboMaCk$any_set$Set$Any$toggle, type_, model.az)
						}),
					A2(
						$author$project$Dashboards2$Analytics$trackEventIf,
						!A2($turboMaCk$any_set$Set$Any$member, type_, model.az),
						$author$project$Dashboards2$Analytics$ManagementFilter(
							{
								oL: 'owner',
								rd: A2($author$project$Dashboards2$List$dashboardTypeLabel, user, type_)
							})));
			case 17:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							az: $turboMaCk$any_set$Set$Any$removeAll(model.az)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var dashboard = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.qf(dashboard),
					$author$project$Dashboards2$List$closeDropdown(model));
			case 19:
				var dashboard = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.qn(dashboard),
					$author$project$Dashboards2$List$closeDropdown(model));
			case 20:
				var dashboard = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.qh(dashboard),
					$author$project$Dashboards2$List$closeDropdown(model));
			default:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							a9: $author$project$Dashboards2$List$defaultTab(!model.K),
							K: !model.K
						}));
		}
	});
var $turboMaCk$glue$Glue$update = F4(
	function (_v0, fc, msg, _v1) {
		var rec = _v0;
		var model = _v1.a;
		var cmd = _v1.b;
		var _v2 = A2(
			fc,
			msg,
			rec.oS(model));
		var subModel = _v2.a;
		var subCmd = _v2.b;
		return _Utils_Tuple2(
			A2(rec.rg, subModel, model),
			$elm$core$Platform$Cmd$batch(
				_List_fromArray(
					[
						A2($elm$core$Platform$Cmd$map, rec.a, subCmd),
						cmd
					])));
	});
var $author$project$Platform2$AutocompleteInput$CloseSuggestions = {$: 9};
var $author$project$Platform2$AutocompleteInput$FetchSuggestions = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Platform2$AutocompleteInput$InputDebouncerMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Platform2$AutocompleteInput$NoOp = {$: 0};
var $author$project$Platform2$AutocompleteInput$SelectSuggestion = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Platform2$AutocompleteInput$SuggestionsLoaded = F4(
	function (a, b, c, d) {
		return {$: 4, a: a, b: b, c: c, d: d};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$cancel = function (_v0) {
	var config = _v0.a;
	var state = _v0.b;
	return A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, config, $Gizra$elm_debouncer$Debouncer$Internal$Settled);
};
var $Gizra$elm_debouncer$Debouncer$Basic$cancel = $Gizra$elm_debouncer$Debouncer$Internal$cancel;
var $author$project$Platform2$AutocompleteInput$inputElementId = 'autocomplete-input-module-input-element-id';
var $author$project$Platform2$AutocompleteInput$getSuggestionItemElementId = function (id) {
	return $author$project$Platform2$AutocompleteInput$inputElementId + ('-' + $elm$core$String$fromInt(id));
};
var $author$project$Platform2$AutocompleteInput$processSuggestionResult = F2(
	function (result, model) {
		if (!result.$) {
			var items = result.a;
			return _Utils_update(
				model,
				{
					by: $elm$core$Maybe$Just(items)
				});
		} else {
			return model;
		}
	});
var $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput = function (a) {
	return {$: 0, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Basic$provideInput = $Gizra$elm_debouncer$Debouncer$Basic$ProvideInput;
var $author$project$Gwi$Browser$Dom$Centered = {$: 1};
var $author$project$Gwi$Browser$Dom$scrollToIfNotVisible = function (_v0) {
	var scrollParentId = _v0.lV;
	var elementId = _v0.j5;
	return $author$project$Gwi$Browser$Dom$scrollToIfNotVisibleWithOffset(
		{j5: elementId, ra: $author$project$Gwi$Browser$Dom$Centered, lV: scrollParentId});
};
var $author$project$Platform2$AutocompleteInput$suggestionsElementId = 'autocomplete-input-suggestions';
var $Gizra$elm_debouncer$Debouncer$Internal$Check = function (a) {
	return {$: 4, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt = function (a) {
	return {$: 3, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal = function (a) {
	return {$: 2, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$Unsettled = function (a) {
	return {$: 1, a: a};
};
var $Gizra$elm_debouncer$Debouncer$Internal$update = F2(
	function (msg, debouncer) {
		var wrappedConfig = debouncer.a;
		var config = wrappedConfig;
		var state = debouncer.b;
		switch (msg.$) {
			case 0:
				var input = msg.a;
				var time = msg.b;
				var newState = function () {
					if (!state.$) {
						return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							{
								dx: $elm$core$Maybe$Nothing,
								f4: time,
								a3: A2(config.cc, input, $elm$core$Maybe$Nothing),
								gZ: time
							});
					} else {
						var unsettled = state.a;
						return $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							_Utils_update(
								unsettled,
								{
									f4: time,
									a3: A2(config.cc, input, unsettled.a3)
								}));
					}
				}();
				var newDebouncer = A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState);
				var checks = function () {
					if (!state.$) {
						return $elm_community$list_extra$List$Extra$unique(
							A2(
								$elm$core$List$filterMap,
								$elm$core$Basics$identity,
								_List_fromArray(
									[config.bg, config.bh, config.bu])));
					} else {
						return A2(
							$elm$core$List$filterMap,
							$elm$core$Basics$identity,
							_List_fromArray(
								[config.bu]));
					}
				}();
				var _v1 = A2(
					$elm$core$Tuple$mapFirst,
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$List$isEmpty),
					A2(
						$elm$core$List$partition,
						function (interval) {
							return interval <= 0;
						},
						checks));
				var checkNow = _v1.a;
				var checkLater = _v1.b;
				var _v2 = checkNow ? A2(
					$Gizra$elm_debouncer$Debouncer$Internal$update,
					$Gizra$elm_debouncer$Debouncer$Internal$Check(time),
					newDebouncer) : _Utils_Tuple3(newDebouncer, _List_Nil, $elm$core$Maybe$Nothing);
				var checkedDebouncer = _v2.a;
				var checkedIntervals = _v2.b;
				var emit = _v2.c;
				return _Utils_Tuple3(
					checkedDebouncer,
					_Utils_ap(checkedIntervals, checkLater),
					emit);
			case 1:
				return _Utils_Tuple3(
					$Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer),
					_List_Nil,
					$elm$core$Maybe$Nothing);
			case 2:
				var emit = function () {
					if (!state.$) {
						return $elm$core$Maybe$Nothing;
					} else {
						var unsettled = state.a;
						return unsettled.a3;
					}
				}();
				return _Utils_Tuple3(
					$Gizra$elm_debouncer$Debouncer$Internal$cancel(debouncer),
					_List_Nil,
					emit);
			case 3:
				var time = msg.a;
				if (!state.$) {
					return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
				} else {
					var unsettled = state.a;
					var _v7 = unsettled.a3;
					if (!_v7.$) {
						var newState = $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
							_Utils_update(
								unsettled,
								{
									dx: $elm$core$Maybe$Just(time),
									a3: $elm$core$Maybe$Nothing
								}));
						var intervals = function () {
							var _v8 = config.bg;
							if (!_v8.$) {
								var emit = _v8.a;
								return _List_fromArray(
									[emit]);
							} else {
								return _List_Nil;
							}
						}();
						return _Utils_Tuple3(
							A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState),
							intervals,
							unsettled.a3);
					} else {
						return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
					}
				}
			default:
				var time = msg.a;
				if (!state.$) {
					return _Utils_Tuple3(debouncer, _List_Nil, $elm$core$Maybe$Nothing);
				} else {
					var unsettled = state.a;
					var shouldSettle = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (interval) {
								return _Utils_cmp(unsettled.f4 + interval, time) < 1;
							},
							config.bu));
					var becauseEmitWhileUnsettled = function () {
						var _v13 = config.bh;
						if (!_v13.$) {
							var interval = _v13.a;
							var _v14 = unsettled.dx;
							if (!_v14.$) {
								var lastEmittedAt = _v14.a;
								return _Utils_cmp(lastEmittedAt + interval, time) < 1;
							} else {
								return _Utils_cmp(unsettled.gZ + interval, time) < 1;
							}
						} else {
							return false;
						}
					}();
					var becauseEmitWhenUnsettled = function () {
						var _v11 = config.bg;
						if (!_v11.$) {
							var interval = _v11.a;
							var _v12 = unsettled.dx;
							if (!_v12.$) {
								return false;
							} else {
								return _Utils_cmp(unsettled.gZ + interval, time) < 1;
							}
						} else {
							return false;
						}
					}();
					var shouldEmit = (!_Utils_eq(unsettled.a3, $elm$core$Maybe$Nothing)) && (shouldSettle || (becauseEmitWhenUnsettled || becauseEmitWhileUnsettled));
					var emit = shouldEmit ? unsettled.a3 : $elm$core$Maybe$Nothing;
					var intervals = function () {
						if (shouldEmit && (!shouldSettle)) {
							var _v10 = config.bh;
							if (!_v10.$) {
								var interval = _v10.a;
								return _List_fromArray(
									[interval]);
							} else {
								return _List_Nil;
							}
						} else {
							return _List_Nil;
						}
					}();
					var newState = shouldSettle ? $Gizra$elm_debouncer$Debouncer$Internal$Settled : (shouldEmit ? $Gizra$elm_debouncer$Debouncer$Internal$Unsettled(
						_Utils_update(
							unsettled,
							{
								dx: $elm$core$Maybe$Just(time),
								a3: $elm$core$Maybe$Nothing
							})) : state);
					return _Utils_Tuple3(
						A2($Gizra$elm_debouncer$Debouncer$Internal$Debouncer, wrappedConfig, newState),
						intervals,
						emit);
				}
		}
	});
var $Gizra$elm_debouncer$Debouncer$Basic$update = F2(
	function (msg, debouncer) {
		switch (msg.$) {
			case 0:
				var input = msg.a;
				return _Utils_Tuple3(
					debouncer,
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2(
								$elm$core$Basics$composeL,
								$Gizra$elm_debouncer$Debouncer$Basic$MsgInternal,
								$Gizra$elm_debouncer$Debouncer$Internal$InputProvidedAt(input)),
							$elm$time$Time$posixToMillis),
						$elm$time$Time$now),
					$elm$core$Maybe$Nothing);
			case 1:
				return _Utils_Tuple3(
					debouncer,
					A2(
						$elm$core$Task$perform,
						A2(
							$elm$core$Basics$composeL,
							A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$ManualEmitAt),
							$elm$time$Time$posixToMillis),
						$elm$time$Time$now),
					$elm$core$Maybe$Nothing);
			default:
				var subMsg = msg.a;
				var _v1 = A2($Gizra$elm_debouncer$Debouncer$Internal$update, subMsg, debouncer);
				var updatedDebouncer = _v1.a;
				var intervals = _v1.b;
				var output = _v1.c;
				var cmds = $elm$core$Platform$Cmd$batch(
					A2(
						$elm$core$List$map,
						function (interval) {
							return A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeL,
									A2($elm$core$Basics$composeL, $Gizra$elm_debouncer$Debouncer$Basic$MsgInternal, $Gizra$elm_debouncer$Debouncer$Internal$Check),
									$elm$time$Time$posixToMillis),
								A2(
									$elm$core$Task$andThen,
									$elm$core$Basics$always($elm$time$Time$now),
									$elm$core$Process$sleep(interval)));
						},
						intervals));
				return _Utils_Tuple3(updatedDebouncer, cmds, output);
		}
	});
var $author$project$Platform2$AutocompleteInput$update = F3(
	function (config, msg, model) {
		var getSuggestionsMatch = F2(
			function (requestedString, suggestions) {
				return A2(
					$elm_community$list_extra$List$Extra$find,
					A2(
						$elm$core$Basics$composeR,
						config.mA,
						$elm$core$Basics$eq(requestedString)),
					A2($elm$core$Maybe$withDefault, _List_Nil, suggestions));
			});
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				var elementId = msg.a;
				var string = msg.b;
				return (!_Utils_eq(model.cW, string)) ? A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					$author$project$Platform2$AutocompleteInput$InputDebouncerMsg(
						$Gizra$elm_debouncer$Debouncer$Basic$provideInput(
							A3(
								$author$project$Platform2$AutocompleteInput$FetchSuggestions,
								{fi: false},
								elementId,
								string))),
					_Utils_update(
						model,
						{cW: string})) : ($elm$core$String$isEmpty(string) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{cW: string, by: $elm$core$Maybe$Nothing})) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
			case 2:
				var elementId = msg.a;
				var _v1 = A2(getSuggestionsMatch, model.cW, model.by);
				if (!_v1.$) {
					var item = _v1.a;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						A2($author$project$Platform2$AutocompleteInput$SelectSuggestion, elementId.j5, item),
						model);
				} else {
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
						A2(
							$elm$core$Platform$Cmd$map,
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Result$map(
									A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm_community$maybe_extra$Maybe$Extra$values)),
								A3(
									$author$project$Platform2$AutocompleteInput$SuggestionsLoaded,
									{fi: true},
									elementId,
									model.cW)),
							config.mV(model.cW)),
						model);
				}
			case 3:
				var applyIfMatch = msg.a;
				var elementId = msg.b;
				var string = msg.c;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
					A2(
						$elm$core$Platform$Cmd$map,
						A3($author$project$Platform2$AutocompleteInput$SuggestionsLoaded, applyIfMatch, elementId, string),
						config.kd(string)),
					model);
			case 4:
				var applyIfMatch = msg.a.fi;
				var elementId = msg.b.j5;
				var requestedString = msg.c;
				var result = msg.d;
				var selectItemIfMatch = function (m) {
					return applyIfMatch ? A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(m),
						function (item) {
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								A2($author$project$Platform2$AutocompleteInput$SelectSuggestion, elementId, item),
								m);
						},
						A2(getSuggestionsMatch, requestedString, m.by)) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(m);
				};
				return selectItemIfMatch(
					A2($author$project$Platform2$AutocompleteInput$processSuggestionResult, result, model));
			case 5:
				var subMsg = msg.a;
				var _v2 = A2($Gizra$elm_debouncer$Debouncer$Basic$update, subMsg, model.dr);
				var newDebouncer = _v2.a;
				var debouncerCmd = _v2.b;
				var emittedMsg = _v2.c;
				var command = A2($elm$core$Platform$Cmd$map, $author$project$Platform2$AutocompleteInput$InputDebouncerMsg, debouncerCmd);
				var newModel = _Utils_update(
					model,
					{dr: newDebouncer});
				if (!emittedMsg.$) {
					var emitted = emittedMsg.a;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
						command,
						A3($author$project$Platform2$AutocompleteInput$update, config, emitted, newModel));
				} else {
					return _Utils_Tuple2(newModel, command);
				}
			case 6:
				var elementId = msg.a;
				var suggestion = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							cW: '',
							u: $elm_community$list_extra$List$Extra$unique(
								_Utils_ap(
									model.u,
									_List_fromArray(
										[suggestion]))),
							by: $elm$core$Maybe$Nothing
						}),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Platform2$AutocompleteInput$NoOp),
						$elm$browser$Browser$Dom$focus(elementId)));
			case 7:
				var elementId = msg.a;
				var item = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							u: A2(
								$elm$core$List$filter,
								$elm$core$Basics$neq(item),
								model.u)
						}),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Platform2$AutocompleteInput$NoOp),
						$elm$browser$Browser$Dom$focus(elementId)));
			case 8:
				var elementId = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Platform2$AutocompleteInput$NoOp),
						$elm$browser$Browser$Dom$focus(elementId)));
			case 10:
				var elementId = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								$elm$core$Basics$always($author$project$Platform2$AutocompleteInput$CloseSuggestions),
								$elm$core$Process$sleep(500)),
								A2(
								$elm$core$Platform$Cmd$map,
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Result$map(
										A2($elm$core$Basics$composeR, $elm$core$List$singleton, $elm_community$maybe_extra$Maybe$Extra$values)),
									A3(
										$author$project$Platform2$AutocompleteInput$SuggestionsLoaded,
										{fi: true},
										{j5: elementId},
										model.cW)),
								config.mV(model.cW))
							])));
			case 9:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							dr: $Gizra$elm_debouncer$Debouncer$Basic$cancel(model.dr),
							dI: 0,
							by: $elm$core$Maybe$Nothing
						}));
			default:
				var newIndex = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{dI: newIndex}),
					A2(
						$elm$core$Task$attempt,
						$elm$core$Basics$always($author$project$Platform2$AutocompleteInput$NoOp),
						$author$project$Gwi$Browser$Dom$scrollToIfNotVisible(
							{
								j5: $author$project$Platform2$AutocompleteInput$getSuggestionItemElementId(newIndex),
								lV: $author$project$Platform2$AutocompleteInput$suggestionsElementId
							})));
		}
	});
var $author$project$Platform2$Drawers$FinalConfirmation = {$: 2};
var $author$project$Platform2$Drawers$Search = function (a) {
	return {$: 1, a: a};
};
var $author$project$Platform2$Drawers$fetchLineagesForDataset = F3(
	function (config, store, data) {
		var _v0 = store.fC;
		if (_v0.$ === 3) {
			var datasetsToNamespaces = _v0.a;
			return A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
				config.oI(
					A2(
						$elm$core$List$filterMap,
						function (code) {
							return A2($Janiczek$elm_bidict$BiDict$Assoc$get, code, datasetsToNamespaces);
						},
						$turboMaCk$any_set$Set$Any$toList(data.l7))),
				data);
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(data);
		}
	});
var $author$project$Platform2$Drawers$mapDatasetsDrawer = F2(
	function (fn, drawer) {
		if (drawer.$ === 5) {
			var config = drawer.a;
			var locationsDrawer = drawer.b;
			return A2(
				$elm$core$Tuple$mapFirst,
				$author$project$Platform2$Drawers$Datasets(config),
				A2(fn, config, locationsDrawer));
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(drawer);
		}
	});
var $author$project$Platform2$Drawers$mapLocationsDrawer = F2(
	function (fn, drawer) {
		if (drawer.$ === 3) {
			var config = drawer.a;
			var locationsDrawer = drawer.b;
			return A2(
				$author$project$Platform2$Drawers$Locations,
				config,
				fn(locationsDrawer));
		} else {
			return drawer;
		}
	});
var $author$project$Platform2$Drawers$TVChannels = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Platform2$Drawers$mapTVChannelsDrawer = F2(
	function (fn, drawer) {
		if (drawer.$ === 6) {
			var config = drawer.a;
			var tvChannelsDrawer = drawer.b;
			return A2(
				$author$project$Platform2$Drawers$TVChannels,
				config,
				fn(tvChannelsDrawer));
		} else {
			return drawer;
		}
	});
var $author$project$Platform2$Drawers$Timezones = F2(
	function (a, b) {
		return {$: 8, a: a, b: b};
	});
var $author$project$Platform2$Drawers$mapTimezonesDrawer = F2(
	function (fn, drawer) {
		if (drawer.$ === 8) {
			var config = drawer.a;
			var timezonesDrawer = drawer.b;
			return A2(
				$author$project$Platform2$Drawers$Timezones,
				config,
				fn(timezonesDrawer));
		} else {
			return drawer;
		}
	});
var $author$project$Platform2$Drawers$mapWavesDrawer = F2(
	function (fn, drawer) {
		if (drawer.$ === 1) {
			var config = drawer.a;
			var wavesDrawer = drawer.b;
			return A2(
				$author$project$Platform2$Drawers$Waves,
				config,
				fn(wavesDrawer));
		} else {
			return drawer;
		}
	});
var $author$project$Platform2$Drawers$FirstWarning = function (a) {
	return {$: 1, a: a};
};
var $author$project$Platform2$Drawers$showContentRemoveWarningIfNeeded = function (datasetsDrawer) {
	var incompatibilities = datasetsDrawer.n5(datasetsDrawer.l7);
	return ((!_Utils_eq(datasetsDrawer.l7, datasetsDrawer.eO)) && ((!datasetsDrawer.el) && incompatibilities.mg)) ? _Utils_update(
		datasetsDrawer,
		{
			ci: $author$project$Platform2$Drawers$FirstWarning(datasetsDrawer.eO),
			el: true
		}) : datasetsDrawer;
};
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$Set$remove = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$remove, key, dict);
	});
var $author$project$Gwi$Set$toggle = F2(
	function (x, xs) {
		return A2($elm$core$Set$member, x, xs) ? A2($elm$core$Set$remove, x, xs) : A2($elm$core$Set$insert, x, xs);
	});
var $author$project$Platform2$Drawers$update = F3(
	function (store, msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2($author$project$Platform2$Drawers$Closed, $elm$core$Platform$Cmd$none);
			case 1:
				var year = msg.a;
				var updatedDrawer = function (wavesDrawer) {
					return _Utils_update(
						wavesDrawer,
						{
							eN: A2($author$project$Gwi$Set$toggle, year, wavesDrawer.eN)
						});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapWavesDrawer, updatedDrawer, model));
			case 2:
				var region = msg.a;
				var updatedDrawer = function (locationsDrawer) {
					return _Utils_update(
						locationsDrawer,
						{
							eM: A2($turboMaCk$any_set$Set$Any$toggle, region, locationsDrawer.eM)
						});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapLocationsDrawer, updatedDrawer, model));
			case 3:
				var searchTerm = msg.a;
				var updatedDrawer = function (locationsDrawer) {
					return $elm$core$String$isEmpty(searchTerm) ? _Utils_update(
						locationsDrawer,
						{dF: $author$project$Platform2$Drawers$LocationsRoot}) : _Utils_update(
						locationsDrawer,
						{
							dF: $author$project$Platform2$Drawers$Search(searchTerm)
						});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapLocationsDrawer, updatedDrawer, model));
			case 16:
				var searchTerm = msg.a;
				var setSearchTerm = function (channelsDrawer) {
					return _Utils_update(
						channelsDrawer,
						{cW: searchTerm});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapTVChannelsDrawer, setSearchTerm, model));
			case 17:
				var clearSearchTerm = function (channelsDrawer) {
					return _Utils_update(
						channelsDrawer,
						{cW: ''});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapTVChannelsDrawer, clearSearchTerm, model));
			case 18:
				var tvChannelCode = msg.a;
				var toggleChannel = function (channelsDrawer) {
					return _Utils_update(
						channelsDrawer,
						{
							a7: A2($turboMaCk$any_set$Set$Any$toggle, tvChannelCode, channelsDrawer.a7)
						});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapTVChannelsDrawer, toggleChannel, model));
			case 4:
				var updatedDrawer = function (locationsDrawer) {
					return _Utils_update(
						locationsDrawer,
						{dF: $author$project$Platform2$Drawers$LocationsRoot});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapLocationsDrawer, updatedDrawer, model));
			case 5:
				var wave = msg.a;
				var updatedDrawer = function (wavesDrawer) {
					return _Utils_update(
						wavesDrawer,
						{
							l9: A2($turboMaCk$any_set$Set$Any$toggle, wave.bW, wavesDrawer.l9)
						});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapWavesDrawer, updatedDrawer, model));
			case 6:
				var location = msg.a;
				var updatedDrawer = function (locationDrawer) {
					return _Utils_update(
						locationDrawer,
						{
							l8: A2($turboMaCk$any_set$Set$Any$toggle, location.bW, locationDrawer.l8)
						});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapLocationsDrawer, updatedDrawer, model));
			case 7:
				var locationCodesList = msg.a;
				var updatedDrawer = function (locationDrawer) {
					return A2(
						$elm$core$List$all,
						function (code) {
							return A2($turboMaCk$any_set$Set$Any$member, code, locationDrawer.l8);
						},
						locationCodesList) ? _Utils_update(
						locationDrawer,
						{
							l8: A2(
								$turboMaCk$any_set$Set$Any$diff,
								locationDrawer.l8,
								$author$project$Data$Id$setFromList(locationCodesList))
						}) : _Utils_update(
						locationDrawer,
						{
							l8: A2(
								$turboMaCk$any_set$Set$Any$union,
								locationDrawer.l8,
								$author$project$Data$Id$setFromList(locationCodesList))
						});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapLocationsDrawer, updatedDrawer, model));
			case 8:
				var waveCodesList = msg.a;
				var updatedDrawer = function (drawer) {
					return A2(
						$elm$core$List$all,
						function (code) {
							return A2($turboMaCk$any_set$Set$Any$member, code, drawer.l9);
						},
						waveCodesList) ? _Utils_update(
						drawer,
						{
							l9: A2(
								$turboMaCk$any_set$Set$Any$diff,
								drawer.l9,
								$author$project$Data$Id$setFromList(waveCodesList))
						}) : _Utils_update(
						drawer,
						{
							l9: A2(
								$turboMaCk$any_set$Set$Any$union,
								drawer.l9,
								$author$project$Data$Id$setFromList(waveCodesList))
						});
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapWavesDrawer, updatedDrawer, model));
			case 9:
				var toggleSegmenting = function (locationDrawer) {
					var _v1 = locationDrawer.rc;
					if (!_v1.$) {
						var v = _v1.a;
						return _Utils_update(
							locationDrawer,
							{
								rc: $elm$core$Maybe$Just(!v)
							});
					} else {
						return locationDrawer;
					}
				};
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Platform2$Drawers$mapLocationsDrawer, toggleSegmenting, model));
			case 10:
				var folderId = msg.a;
				var toggleFolder = F2(
					function (_v2, datasetsDrawer) {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
							_Utils_update(
								datasetsDrawer,
								{
									eK: A2($turboMaCk$any_set$Set$Any$toggle, folderId, datasetsDrawer.eK),
									bv: false
								}));
					});
				return A2($author$project$Platform2$Drawers$mapDatasetsDrawer, toggleFolder, model);
			case 11:
				var datasets = msg.a;
				var codes = $author$project$Data$Id$setFromList(
					A2(
						$elm$core$List$map,
						function ($) {
							return $.bW;
						},
						datasets));
				var toggleDatasets = F2(
					function (config, datasetsDrawer) {
						var intersect = A2($turboMaCk$any_set$Set$Any$intersect, datasetsDrawer.l7, codes);
						return A3(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A2($elm$core$Basics$composeR, $author$project$Platform2$Drawers$showContentRemoveWarningIfNeeded, $GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
							A3(
								$author$project$Platform2$Drawers$fetchLineagesForDataset,
								config,
								store,
								A2(
									$author$project$Platform2$Drawers$computeDatasetCompatibilities,
									store,
									_Utils_update(
										datasetsDrawer,
										{
											l7: _Utils_eq(
												$turboMaCk$any_set$Set$Any$size(intersect),
												$turboMaCk$any_set$Set$Any$size(codes)) ? A2($turboMaCk$any_set$Set$Any$diff, datasetsDrawer.l7, codes) : A2($turboMaCk$any_set$Set$Any$union, codes, datasetsDrawer.l7),
											bv: false
										}))));
					});
				return A2($author$project$Platform2$Drawers$mapDatasetsDrawer, toggleDatasets, model);
			case 12:
				var clearDatasetsSelection = F2(
					function (config, datasetsDrawer) {
						return A3(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A2($elm$core$Basics$composeR, $author$project$Platform2$Drawers$showContentRemoveWarningIfNeeded, $GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
							A3(
								$author$project$Platform2$Drawers$fetchLineagesForDataset,
								config,
								store,
								A2(
									$author$project$Platform2$Drawers$computeDatasetCompatibilities,
									store,
									_Utils_update(
										datasetsDrawer,
										{l7: $author$project$Data$Id$emptySet, bv: false}))));
					});
				return A2($author$project$Platform2$Drawers$mapDatasetsDrawer, clearDatasetsSelection, model);
			case 13:
				var datasetCode = msg.a;
				var toggleDataset = F2(
					function (config, datasetsDrawer) {
						return A3(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A2($elm$core$Basics$composeR, $author$project$Platform2$Drawers$showContentRemoveWarningIfNeeded, $GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
							A3(
								$author$project$Platform2$Drawers$fetchLineagesForDataset,
								config,
								store,
								A2(
									$author$project$Platform2$Drawers$computeDatasetCompatibilities,
									store,
									_Utils_update(
										datasetsDrawer,
										{
											l7: A2($turboMaCk$any_set$Set$Any$toggle, datasetCode, datasetsDrawer.l7),
											bv: false
										}))));
					});
				return A2($author$project$Platform2$Drawers$mapDatasetsDrawer, toggleDataset, model);
			case 23:
				var codes = msg.a;
				var setDatasets = F2(
					function (_v3, datasetsDrawer) {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
							A2(
								$author$project$Platform2$Drawers$computeDatasetCompatibilities,
								store,
								_Utils_update(
									datasetsDrawer,
									{ci: $author$project$Platform2$Drawers$NoWarning, el: false, l7: codes, bv: false})));
					});
				return A2($author$project$Platform2$Drawers$mapDatasetsDrawer, setDatasets, model);
			case 21:
				return A2(
					$author$project$Platform2$Drawers$mapDatasetsDrawer,
					F2(
						function (_v4, datasetsDrawer) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									datasetsDrawer,
									{ci: $author$project$Platform2$Drawers$NoWarning}));
						}),
					model);
			case 22:
				var widgets = msg.a;
				return A2(
					$author$project$Platform2$Drawers$mapDatasetsDrawer,
					F2(
						function (_v5, datasetsDrawer) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									datasetsDrawer,
									{
										ci: $elm$core$List$isEmpty(widgets) ? $author$project$Platform2$Drawers$NoWarning : $author$project$Platform2$Drawers$FinalConfirmation
									}));
						}),
					model);
			case 14:
				var searchTerm = msg.a;
				var setSearchTerm = F2(
					function (_v6, datasetsDrawer) {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
							_Utils_update(
								datasetsDrawer,
								{cW: searchTerm, bv: false}));
					});
				return A2($author$project$Platform2$Drawers$mapDatasetsDrawer, setSearchTerm, model);
			case 15:
				return A2(
					$author$project$Platform2$Drawers$mapDatasetsDrawer,
					F2(
						function (_v7, datasetsDrawer) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									datasetsDrawer,
									{bv: true}));
						}),
					model);
			case 19:
				var targetTimezone = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2(
						$author$project$Platform2$Drawers$mapTimezonesDrawer,
						function (timezoneDrawer) {
							return _Utils_update(
								timezoneDrawer,
								{b6: targetTimezone});
						},
						model));
			default:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2(
						$author$project$Platform2$Drawers$mapTimezonesDrawer,
						function (timezoneDrawer) {
							return _Utils_update(
								timezoneDrawer,
								{eA: !timezoneDrawer.eA});
						},
						model));
		}
	});
var $author$project$Platform2$Notification$Queue$RemoveHiding = {$: 1};
var $author$project$Platform2$Notification$hidingTimeout = 1000;
var $author$project$Platform2$Notification$Hiding = 1;
var $author$project$Platform2$Notification$isHiding = function (_v0) {
	var state = _v0.rA;
	return state === 1;
};
var $author$project$Platform2$Notification$Queue$map = F2(
	function (fn, _v0) {
		var queue = _v0;
		var notifications = queue.bn;
		return _Utils_update(
			queue,
			{
				bn: A2($turboMaCk$queue$Queue$map, fn, notifications)
			});
	});
var $author$project$Platform2$Notification$setHiding = function (notification) {
	return _Utils_update(
		notification,
		{rA: 1});
};
var $author$project$Platform2$Notification$Queue$update = F2(
	function (msg, queue) {
		switch (msg.$) {
			case 0:
				var id = msg.a;
				return _Utils_Tuple3(
					A2(
						$author$project$Platform2$Notification$Queue$map,
						function (data) {
							return _Utils_eq(data.b, id) ? _Utils_update(
								data,
								{
									cI: $author$project$Platform2$Notification$setHiding(data.cI)
								}) : data;
						},
						queue),
					A2($author$project$Platform2$Notification$Queue$performAfterDelay, $author$project$Platform2$Notification$hidingTimeout, $author$project$Platform2$Notification$Queue$RemoveHiding),
					$elm$core$Maybe$Nothing);
			case 1:
				var newQueue = A2(
					$author$project$Platform2$Notification$Queue$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.cI;
						},
						A2($elm$core$Basics$composeR, $author$project$Platform2$Notification$isHiding, $elm$core$Basics$not)),
					queue);
				return _Utils_Tuple3(newQueue, $elm$core$Platform$Cmd$none, $elm$core$Maybe$Nothing);
			default:
				var msg_ = msg.a;
				return _Utils_Tuple3(
					queue,
					$elm$core$Platform$Cmd$none,
					$elm$core$Maybe$Just(msg_));
		}
	});
var $author$project$Dashboards2$updateEditSection = F2(
	function (msg, editSection) {
		var dimensions = msg;
		if (editSection.$ === 1) {
			var editGridState = editSection.a;
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
				$author$project$Dashboards2$Detail$EditGrid(
					_Utils_update(
						editGridState,
						{ir: dimensions})));
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(editSection);
		}
	});
var $author$project$Dashboards2$Detail$DashboardJustSaved = 1;
var $author$project$Store$Platform2$FetchAudienceFolders = {$: 0};
var $author$project$Store$Platform2$FetchAudiences = {$: 1};
var $author$project$Store$Platform2$FetchDashboards = {$: 4};
var $author$project$Store$Platform2$FetchDashboardsUserSettings = {$: 16};
var $author$project$Store$Platform2$FetchDatasetFolders = {$: 19};
var $author$project$Store$Platform2$FetchDatasets = {$: 20};
var $author$project$Store$Platform2$FetchInsightCategories = {$: 18};
var $author$project$Dashboards2$checkWidgetsVisibilityOnDetail = F2(
	function (config, route) {
		switch (route.$) {
			case 3:
				return $elm$core$Basics$identity;
			case 4:
				return $elm$core$Basics$identity;
			case 0:
				return $elm$core$Basics$identity;
			case 1:
				return $author$project$Dashboards2$checkWidgetVisibility(config);
			default:
				return $elm$core$Basics$identity;
		}
	});
var $author$project$Store$Platform2$clearParamsForWidget = function (store) {
	return _Utils_update(
		store,
		{
			$9: $turboMaCk$any_dict$Dict$Any$removeAll(store.$9)
		});
};
var $author$project$Dashboards2$Analytics$DashboardOpened = function (a) {
	return {$: 12, a: a};
};
var $author$project$Data$Platform2$isDashboardPublic = function (sharing) {
	switch (sharing.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return false;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return false;
		case 6:
			return true;
		case 7:
			return true;
		default:
			return true;
	}
};
var $author$project$Data$Platform2$isDashboardShared = function (sharing) {
	switch (sharing.$) {
		case 0:
			return false;
		case 1:
			return true;
		case 2:
			return true;
		case 3:
			return true;
		case 4:
			return true;
		case 5:
			return false;
		case 6:
			return true;
		case 7:
			return true;
		default:
			return true;
	}
};
var $author$project$Data$Platform2$isSharedByMyOrganisation = F2(
	function (user, sharing) {
		switch (sharing.$) {
			case 1:
				return false;
			case 2:
				var _v1 = sharing.a;
				var maybeOrgId = _v1.a;
				return _Utils_eq(
					maybeOrgId,
					A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, user.m));
			case 3:
				return false;
			case 0:
				return false;
			case 4:
				return false;
			case 5:
				return false;
			case 6:
				return false;
			case 7:
				var _v2 = sharing.a;
				var maybeOrgId = _v2.a;
				return _Utils_eq(
					maybeOrgId,
					A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, user.m));
			default:
				return false;
		}
	});
var $author$project$Dashboards2$dashboardOpenedAnalytics = F4(
	function (flags, store, dashboardId, model) {
		var userFiltersReady = $elm_community$maybe_extra$Maybe$Extra$isJust(
			$author$project$Dashboards2$getUserFilters(model));
		var isDashboardTracked = _Utils_eq(
			model.dS,
			$elm$core$Maybe$Just(dashboardId));
		var fetchedDashboard = A2($author$project$Store$Platform2$getDashboardFullyLoaded, dashboardId, store.v);
		var _v0 = _Utils_Tuple3(fetchedDashboard, userFiltersReady, isDashboardTracked);
		if (((_v0.a.$ === 3) && _v0.b) && _v0.c) {
			var dashboard = _v0.a.a;
			var waveIds = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
				$elm$core$List$map,
				function (w) {
					return w.bW;
				},
				A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					_List_Nil,
					$turboMaCk$any_dict$Dict$Any$values,
					A2($author$project$Dashboards2$Detail$getWavesForDashboardByDashboardId, store, dashboard))) : A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				A2($elm$core$Basics$composeR, $author$project$Dashboards2$UserFilters$waves, $turboMaCk$any_set$Set$Any$toList),
				$author$project$Dashboards2$getUserFilters(model));
			var locationIds = A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				A2($elm$core$Basics$composeR, $author$project$Dashboards2$UserFilters$locations, $turboMaCk$any_set$Set$Any$toList),
				$author$project$Dashboards2$getUserFilters(model));
			var locations = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
				$elm$core$List$filter,
				function (l) {
					return A2($elm$core$List$member, l.bW, locationIds);
				},
				A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					_List_Nil,
					$turboMaCk$any_dict$Dict$Any$values,
					A2($author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId, store, dashboard))) : A2(
				$elm$core$List$filter,
				function (l) {
					return A2($elm$core$List$member, l.bW, locationIds);
				},
				A3(
					$krisajenkins$remotedata$RemoteData$unwrap,
					_List_Nil,
					$turboMaCk$any_dict$Dict$Any$values,
					A2($author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces, store, dashboard)));
			var getQuestionCodes = function (chartWidget) {
				var widgetQuestions = $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
					$author$project$Dashboards2$Widget$widgetQuestionCodes(chartWidget));
				var maybeBaseAudience = function () {
					var _v3 = chartWidget.aU;
					if (!_v3.$) {
						var chartBaseAudience = _v3.a.fp;
						return A2(
							$elm$core$Maybe$andThen,
							$author$project$Store$Utils$get(store.d9),
							A2(
								$elm$core$Maybe$map,
								function ($) {
									return $.b;
								},
								chartBaseAudience));
					} else {
						var id = _v3.a.b;
						return A2($author$project$Store$Utils$get, store.d9, id);
					}
				}();
				var baseAudienceQuestionCodes = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					A2(
						$elm$core$Maybe$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bY;
							},
							$author$project$Data$Audience$Expression$questionCodes),
						maybeBaseAudience));
				return A2(
					$elm_community$list_extra$List$Extra$uniqueBy,
					$author$project$Data$Id$unwrap,
					_Utils_ap(widgetQuestions, baseAudienceQuestionCodes));
			};
			var questionCodes = A2(
				$author$project$Gwi$List$fastConcatMap,
				getQuestionCodes,
				A2($elm$core$List$filterMap, $author$project$Data$Platform2$getChartWidget, dashboard.cl.g));
			var questions = A2(
				$elm$core$List$filter,
				function (q) {
					return A2($elm$core$List$member, q.k1, questionCodes);
				},
				$turboMaCk$any_dict$Dict$Any$values(
					A2(
						$turboMaCk$any_dict$Dict$Any$filterMap,
						F2(
							function (_v2, v) {
								return $krisajenkins$remotedata$RemoteData$toMaybe(v);
							}),
						store.bt)));
			var questionsAreFetched = function () {
				var fetchedQuestionCodes = A2(
					$elm$core$List$map,
					function ($) {
						return $.k1;
					},
					questions);
				return A2(
					$elm$core$List$all,
					function (qc) {
						return A2($elm$core$List$member, qc, fetchedQuestionCodes);
					},
					questionCodes);
			}();
			var questionsAreReady = (questionsAreFetched && ($elm$core$List$length(questionCodes) > 0)) || (!$elm$core$List$length(questionCodes));
			var audienceIds = function () {
				var _v1 = dashboard.cl.C.d9;
				if (!_v1.$) {
					var ids = _v1.a;
					return ids;
				} else {
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						$author$project$Dashboards2$UserFilters$audienceIds,
						$author$project$Dashboards2$getUserFilters(model));
				}
			}();
			var audiences = A2(
				$elm$core$List$filter,
				function (a) {
					return A2($elm$core$List$member, a.b, audienceIds);
				},
				A3($krisajenkins$remotedata$RemoteData$unwrap, _List_Nil, $turboMaCk$any_dict$Dict$Any$values, store.d9));
			return questionsAreReady ? A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
				$author$project$Dashboards2$Analytics$trackEvent(
					$author$project$Dashboards2$Analytics$DashboardOpened(
						{
							be: 'Dashboards',
							d9: audiences,
							bf: dashboardId,
							bC: dashboard.ld,
							es: A2($author$project$Store$Utils$getByIds, store.es, dashboard.es),
							pp: $author$project$Data$Platform2$isDashboardPublic(dashboard.ah),
							h2: _Utils_eq(dashboard.dG, flags.mQ.b) || ($author$project$Data$Platform2$isDashboardPublic(dashboard.ah) && (flags.nM(23) && (!A2($author$project$Data$Platform2$isSharedByMyOrganisation, flags.mQ, dashboard.ah)))),
							pw: $author$project$Data$Platform2$isDashboardShared(dashboard.ah),
							cD: locations,
							pW: model.cV === 1,
							bt: questions,
							dX: waveIds
						})),
				_Utils_update(
					model,
					{dS: $elm$core$Maybe$Nothing})) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Store$Platform2$FetchAudiencesByDashboardId = function (a) {
	return {$: 2, a: a};
};
var $author$project$Store$Platform2$FetchDatasetFolderTreesByDashboardId = function (a) {
	return {$: 21, a: a};
};
var $elm_community$list_extra$List$Extra$dropWhile = F2(
	function (predicate, list) {
		dropWhile:
		while (true) {
			if (!list.b) {
				return _List_Nil;
			} else {
				var x = list.a;
				var xs = list.b;
				if (predicate(x)) {
					var $temp$predicate = predicate,
						$temp$list = xs;
					predicate = $temp$predicate;
					list = $temp$list;
					continue dropWhile;
				} else {
					return list;
				}
			}
		}
	});
var $elm_community$list_extra$List$Extra$takeWhile = function (predicate) {
	var takeWhileMemo = F2(
		function (memo, list) {
			takeWhileMemo:
			while (true) {
				if (!list.b) {
					return $elm$core$List$reverse(memo);
				} else {
					var x = list.a;
					var xs = list.b;
					if (predicate(x)) {
						var $temp$memo = A2($elm$core$List$cons, x, memo),
							$temp$list = xs;
						memo = $temp$memo;
						list = $temp$list;
						continue takeWhileMemo;
					} else {
						return $elm$core$List$reverse(memo);
					}
				}
			}
		});
	return takeWhileMemo(_List_Nil);
};
var $elm_community$list_extra$List$Extra$span = F2(
	function (p, xs) {
		return _Utils_Tuple2(
			A2($elm_community$list_extra$List$Extra$takeWhile, p, xs),
			A2($elm_community$list_extra$List$Extra$dropWhile, p, xs));
	});
var $elm_community$list_extra$List$Extra$break = function (p) {
	return $elm_community$list_extra$List$Extra$span(
		A2($elm$core$Basics$composeL, $elm$core$Basics$not, p));
};
var $author$project$Store$Platform2$FetchDashboard = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dashboards2$fetchDashboard = F3(
	function (config, route, model) {
		var _v0 = $author$project$Dashboards2$Router$getDashboardId(route);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var dashboardId = _v0.a;
			return A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
				config.l(
					_List_fromArray(
						[
							$author$project$Store$Platform2$FetchDashboard(dashboardId)
						])),
				_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
		}
	});
var $author$project$Store$Platform2$FetchLocationsByNamespace = function (a) {
	return {$: 9, a: a};
};
var $author$project$Dashboards2$fetchLocations = F3(
	function (config, namespaceCodes, model) {
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(
				A2($elm$core$List$map, $author$project$Store$Platform2$FetchLocationsByNamespace, namespaceCodes)),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$Store$Platform2$FetchLocationsByDashboardId = function (a) {
	return {$: 10, a: a};
};
var $author$project$Dashboards2$fetchLocationsForDashboardId = F3(
	function (config, dashboardId, model) {
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(
				_List_fromArray(
					[
						$author$project$Store$Platform2$FetchLocationsByDashboardId(dashboardId)
					])),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$Dashboards2$fetchNamespaceLineages = F3(
	function (config, namespaces, model) {
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(
				A2($elm$core$List$map, $author$project$Store$Platform2$FetchLineage, namespaces)),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$Store$Platform2$FetchQuestionsForWidget = F2(
	function (a, b) {
		return {$: 15, a: a, b: b};
	});
var $author$project$Dashboards2$Widget$isChartWidget = function (widget) {
	var _v0 = widget.U;
	if (!_v0.$) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Dashboards2$fetchQuestions = F5(
	function (config, flags, store, dashboard, model) {
		var viewOnlyActions = A2(
			$elm$core$List$map,
			function (widget) {
				return A2($author$project$Store$Platform2$FetchQuestionsForWidget, dashboard.b, widget.b);
			},
			A2($elm$core$List$filter, $author$project$Dashboards2$Widget$isChartWidget, dashboard.cl.g));
		var getQuestionCodes = function (chartWidget) {
			var widgetQuestions = $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
				$author$project$Dashboards2$Widget$widgetQuestionCodes(chartWidget));
			var maybeBaseAudience = function () {
				var _v0 = chartWidget.aU;
				if (!_v0.$) {
					var chartBaseAudience = _v0.a.fp;
					return A2(
						$elm$core$Maybe$andThen,
						$author$project$Store$Utils$get(store.d9),
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.b;
							},
							chartBaseAudience));
				} else {
					var id = _v0.a.b;
					return A2($author$project$Store$Utils$get, store.d9, id);
				}
			}();
			var baseAudienceQuestionCodes = A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bY;
						},
						$author$project$Data$Audience$Expression$questionCodes),
					maybeBaseAudience));
			return A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				$author$project$Data$Id$unwrap,
				_Utils_ap(widgetQuestions, baseAudienceQuestionCodes));
		};
		var actions = A2(
			$elm$core$List$map,
			$author$project$Store$Platform2$FetchQuestion(
				{mf: false}),
			A2(
				$author$project$Gwi$List$fastConcatMap,
				getQuestionCodes,
				A2($elm$core$List$filterMap, $author$project$Data$Platform2$getChartWidget, dashboard.cl.g)));
		return $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? ($elm$core$List$isEmpty(viewOnlyActions) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(viewOnlyActions),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none))) : ($elm$core$List$isEmpty(actions) ? _Utils_Tuple2(model, $elm$core$Platform$Cmd$none) : A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(actions),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
	});
var $author$project$Store$Platform2$FetchSplitters = function (a) {
	return {$: 6, a: a};
};
var $author$project$Dashboards2$fetchSplitters = F3(
	function (config, namespaceCodes, model) {
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(
				A2($elm$core$List$map, $author$project$Store$Platform2$FetchSplitters, namespaceCodes)),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$Store$Platform2$FetchWavesByNamespace = function (a) {
	return {$: 12, a: a};
};
var $author$project$Dashboards2$fetchWaves = F3(
	function (config, namespaceCodes, model) {
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(
				A2($elm$core$List$map, $author$project$Store$Platform2$FetchWavesByNamespace, namespaceCodes)),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$Store$Platform2$FetchWavesByDashboardId = function (a) {
	return {$: 13, a: a};
};
var $author$project$Dashboards2$fetchWavesForDashboardId = F3(
	function (config, dashboardId, model) {
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(
				_List_fromArray(
					[
						$author$project$Store$Platform2$FetchWavesByDashboardId(dashboardId)
					])),
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
	});
var $author$project$Data$Labels$regionName = function (code) {
	switch (code) {
		case 0:
			return 'Europe';
		case 2:
			return 'Americas';
		case 1:
			return 'Middle East & Africa';
		default:
			return 'Asia Pacific';
	}
};
var $author$project$Data$Labels$allRegions = $elm$core$Dict$fromList(
	A2(
		$elm$core$List$map,
		function (code) {
			return _Utils_Tuple2(
				$author$project$Data$Labels$comparableRegionCode(code),
				{
					cD: $author$project$Data$Id$emptyDict,
					ld: $author$project$Data$Labels$regionName(code)
				});
		},
		_List_fromArray(
			[2, 3, 0, 1])));
var $author$project$Data$Labels$addLocation = F2(
	function (location_, regions) {
		var insertLocation = function (region) {
			return _Utils_update(
				region,
				{
					cD: A3($turboMaCk$any_dict$Dict$Any$insert, location_.bW, location_, region.cD)
				});
		};
		var updater = function (maybeRegion) {
			if (!maybeRegion.$) {
				var region = maybeRegion.a;
				return $elm$core$Maybe$Just(
					insertLocation(region));
			} else {
				return A2(
					$elm$core$Maybe$map,
					insertLocation,
					A2(
						$elm$core$Dict$get,
						$author$project$Data$Labels$comparableRegionCode(location_.qL),
						$author$project$Data$Labels$allRegions));
			}
		};
		return A3(
			$elm$core$Dict$update,
			$author$project$Data$Labels$comparableRegionCode(location_.qL),
			updater,
			regions);
	});
var $author$project$Data$Labels$groupToRegion = function (locations) {
	return A3($elm$core$List$foldr, $author$project$Data$Labels$addLocation, $elm$core$Dict$empty, locations);
};
var $author$project$Store$Platform2$setLocationsForNamespace = F3(
	function (namespaceCode, locations, store) {
		return _Utils_update(
			store,
			{
				pK: A3(
					$turboMaCk$any_dict$Dict$Any$insert,
					namespaceCode,
					A2(
						$author$project$Store$Utils$taggedCollectionLoadedWith,
						function ($) {
							return $.bW;
						},
						locations),
					store.pK),
				gC: A3(
					$turboMaCk$any_dict$Dict$Any$insert,
					namespaceCode,
					$krisajenkins$remotedata$RemoteData$Success(
						$author$project$Data$Labels$groupToRegion(locations)),
					store.gC)
			});
	});
var $author$project$Store$Platform2$setSplittersForNamespace = F3(
	function (namespaceCode, splitters, store) {
		return _Utils_update(
			store,
			{
				cZ: A3(
					$turboMaCk$any_dict$Dict$Any$insert,
					namespaceCode,
					A2(
						$author$project$Store$Utils$taggedCollectionLoadedWith,
						function ($) {
							return $.bW;
						},
						splitters),
					store.cZ)
			});
	});
var $author$project$Store$Platform2$setWavesForNamespace = F3(
	function (namespaceCode, waves, store) {
		return _Utils_update(
			store,
			{
				se: A3(
					$turboMaCk$any_dict$Dict$Any$insert,
					namespaceCode,
					A2(
						$author$project$Store$Utils$taggedCollectionLoadedWith,
						function ($) {
							return $.bW;
						},
						waves),
					store.se)
			});
	});
var $author$project$Dashboards2$fetchDashboardAndItsData = F6(
	function (config, flags, store, route, maybeDashboard, model) {
		var mainUserDataset = $author$project$Store$Platform2$getMainDataset(store);
		var fetchLocationsAndWavesForMainDataset = function (availableNamespacesForDashboard) {
			var namespaceCodesToFetch = A2(
				$elm_community$list_extra$List$Extra$uniqueBy,
				$author$project$Data$Id$unwrap,
				_Utils_ap(
					A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						_List_Nil,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.jt;
							},
							$elm$core$List$singleton),
						mainUserDataset),
					availableNamespacesForDashboard));
			var fetchWavesCmdBasedOnPlan = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$GlobalWebIndex$cmd_extra$Cmd$Extra$add($elm$core$Platform$Cmd$none),
				function (dashboard) {
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A2($author$project$Dashboards2$fetchWavesForDashboardId, config, dashboard.b));
				},
				A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model)) : A2(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				A2($author$project$Dashboards2$fetchWaves, config, namespaceCodesToFetch));
			var fetchNamespaceLineagesCmdBasedOnPlan = $author$project$Data$User$hasOpenAccessPlan(flags.mQ) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$add($elm$core$Platform$Cmd$none) : A2(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				A2($author$project$Dashboards2$fetchNamespaceLineages, config, namespaceCodesToFetch));
			var fetchLocationsCmdBasedOnPlan = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$GlobalWebIndex$cmd_extra$Cmd$Extra$add($elm$core$Platform$Cmd$none),
				function (dashboard) {
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A2($author$project$Dashboards2$fetchLocationsForDashboardId, config, dashboard.b));
				},
				A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model)) : A2(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				A2($author$project$Dashboards2$fetchLocations, config, namespaceCodesToFetch));
			return A2(
				$elm$core$Basics$composeR,
				fetchWavesCmdBasedOnPlan,
				A2(
					$elm$core$Basics$composeR,
					fetchLocationsCmdBasedOnPlan,
					A2(
						$elm$core$Basics$composeR,
						fetchNamespaceLineagesCmdBasedOnPlan,
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A2($author$project$Dashboards2$fetchSplitters, config, namespaceCodesToFetch)))));
		};
		var fetchIfNotViewOnly = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? $elm$core$Basics$identity : fetchLocationsAndWavesForMainDataset(_List_Nil);
		var fetchDatasetsIfViewOnly = function (dashboardId) {
			return $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger(
					config.l(
						_List_fromArray(
							[
								$author$project$Store$Platform2$FetchDatasetFolderTreesByDashboardId(dashboardId)
							])))) : $elm$core$Basics$identity;
		};
		var fetchAudiencesIfViewOnly = function (dashboardId) {
			return $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger(
					config.l(
						_List_fromArray(
							[
								$author$project$Store$Platform2$FetchAudiencesByDashboardId(dashboardId)
							])))) : $elm$core$Basics$identity;
		};
		if (maybeDashboard.$ === 1) {
			return fetchIfNotViewOnly(
				A3(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					A2($author$project$Dashboards2$fetchDashboard, config, route),
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
		} else {
			var dashboard = maybeDashboard.a;
			var fetchDataBasedOnAccessibleDatasets = function (datasets) {
				var _v1 = function () {
					var namespaceCodes = $turboMaCk$any_set$Set$Any$toList(
						A2($author$project$Data$Platform2$dashboardNamespaceCodes, store.es, dashboard));
					var availableNamespacesCodes = A2(
						$elm$core$List$map,
						function ($) {
							return $.jt;
						},
						datasets);
					return $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? _Utils_Tuple2(_List_Nil, namespaceCodes) : A2(
						$elm_community$list_extra$List$Extra$break,
						function (code) {
							return A2($elm$core$List$member, code, availableNamespacesCodes);
						},
						namespaceCodes);
				}();
				var notAvailableNamespaceCodesForDashboard = _v1.a;
				var availableNamespacesForDashboard = _v1.b;
				var setEmptyDataForNotAccessibleNamepsaces = $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
					config.c1(
						function (p2Store) {
							return A3(
								$elm$core$List$foldr,
								function (namespaceCode) {
									return A2(
										$elm$core$Basics$composeR,
										A2($author$project$Store$Platform2$setLocationsForNamespace, namespaceCode, _List_Nil),
										A2(
											$elm$core$Basics$composeR,
											A2($author$project$Store$Platform2$setWavesForNamespace, namespaceCode, _List_Nil),
											A2($author$project$Store$Platform2$setSplittersForNamespace, namespaceCode, _List_Nil)));
								},
								p2Store,
								notAvailableNamespaceCodesForDashboard);
						}));
				return A2(
					$elm$core$Basics$composeR,
					fetchLocationsAndWavesForMainDataset(availableNamespacesForDashboard),
					setEmptyDataForNotAccessibleNamepsaces);
			};
			return A3(
				$elm$core$Basics$apR,
				$krisajenkins$remotedata$RemoteData$toMaybe(store.es),
				A2(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					$elm$core$Basics$identity,
					A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$values, fetchDataBasedOnAccessibleDatasets)),
				A2(
					fetchAudiencesIfViewOnly,
					dashboard.b,
					A2(
						fetchDatasetsIfViewOnly,
						dashboard.b,
						A3(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A4($author$project$Dashboards2$fetchQuestions, config, flags, store, dashboard),
							_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)))));
		}
	});
var $author$project$Dashboards2$ContinueAnalysisWithClearFilters = {$: 70};
var $author$project$Dashboards2$ContinueAnalysisWithCurrentFilters = {$: 69};
var $author$project$Dashboards2$continueAnalysisConfirmDialog = function (model) {
	return _Utils_update(
		model,
		{
			c: $author$project$Dashboards2$Modal$ConfirmModal(
				{
					aH: _List_fromArray(
						[
							{cd: $author$project$Dashboards2$ContinueAnalysisWithClearFilters, cy: false, Y: 'No'},
							{cd: $author$project$Dashboards2$ContinueAnalysisWithCurrentFilters, cy: true, Y: 'Yes'}
						]),
					ft: $elm$core$Maybe$Nothing,
					U: A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$elm$html$Html$p,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Continue using audiences, waves and locations from your previous analysis? Audiences may be removed due incompatibilty with this dashboard.')
									]))
							])),
					bF: $author$project$Dashboards2$Modal$Visible(false),
					Y: 'Continue analysis?'
				})
		});
};
var $author$project$Dashboards2$showContinueAnalysisModalOrDoAction = F5(
	function (flags, config, route, store, _v0) {
		var model = _v0.a;
		var cmds = _v0.b;
		var isDashboardFullyLoaded = $elm_community$maybe_extra$Maybe$Extra$isJust(
			A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
		if (isDashboardFullyLoaded) {
			var _v1 = A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.bF;
				},
				store.jU);
			switch (_v1.$) {
				case 3:
					var continueAnalysis = _v1.a.jN;
					return function () {
						switch (continueAnalysis) {
							case 0:
								return A2(
									$turboMaCk$glue$Glue$updateWith,
									$turboMaCk$glue$Glue$id,
									A2($elm$core$Basics$composeR, $author$project$Dashboards2$continueAnalysisConfirmDialog, $GlobalWebIndex$cmd_extra$Cmd$Extra$pure));
							case 1:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
									config.a($author$project$Dashboards2$ContinueAnalysisWithClearFilters));
							default:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
									config.a($author$project$Dashboards2$ContinueAnalysisWithCurrentFilters));
						}
					}()(
						_Utils_Tuple2(model, cmds));
				case 0:
					return _Utils_Tuple2(model, cmds);
				case 1:
					return _Utils_Tuple2(model, cmds);
				default:
					return _Utils_Tuple2(model, cmds);
			}
		} else {
			return _Utils_Tuple2(model, cmds);
		}
	});
var $author$project$Dashboards2$Widget$requestDataForWidgetIfNotLoadedInternal = $author$project$Dashboards2$Widget$requestDataForWidgetIfNotLoaded_(
	{bI: false});
var $author$project$Dashboards2$Widget$updateForRoute = F8(
	function (getConfig, maybeUserFilters, flags, store, route, widget, isEditing, model) {
		switch (route.$) {
			case 0:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			case 3:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			case 4:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			case 1:
				var dashboardId = route.a;
				if (_Utils_eq(widget.bf, dashboardId)) {
					var _v1 = A2(
						$elm$core$Maybe$map,
						function (uf) {
							return A2(getConfig, uf, widget);
						},
						maybeUserFilters);
					if (!_v1.$) {
						var config = _v1.a;
						return A2(
							$author$project$Dashboards2$Widget$processRequests,
							config,
							A8(
								$author$project$Dashboards2$Widget$requestDataForWidgetIfNotLoadedInternal,
								$elm$core$Basics$identity,
								{l: $author$project$Dashboards2$Widget$StoreActionMany},
								maybeUserFilters,
								flags,
								store,
								widget,
								{oQ: false, ez: isEditing},
								model));
					} else {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
					}
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			default:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Dashboards2$updateWidgetsWith = F5(
	function (updateWidgetFn, flags, store, route, model) {
		var updateModel = F3(
			function (widget, wModel, _v0) {
				var accModel = _v0.a;
				var accCmds = _v0.b;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					accCmds,
					A2(
						$elm$core$Tuple$mapFirst,
						function (newWModel) {
							return A2(
								$author$project$Dashboards2$updateWidgets,
								A2($turboMaCk$any_dict$Dict$Any$insert, widget.b, newWModel),
								accModel);
						},
						A4(updateWidgetFn, flags, store, widget, wModel)));
			});
		var dashboardId = $author$project$Dashboards2$Router$getDashboardId(route);
		return A2(
			$elm$core$Maybe$withDefault,
			$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
			A2(
				$elm$core$Maybe$map,
				function (dashboard) {
					return A6(
						$author$project$Dashboards2$foldWidgets,
						updateModel,
						_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
						{
							ey: $author$project$Dashboards2$Detail$isEditMode(model.o)
						},
						dashboard,
						store,
						$author$project$Dashboards2$Detail$currentWidgets(model));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (id) {
						return $krisajenkins$remotedata$RemoteData$toMaybe(
							A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
					},
					dashboardId)));
	});
var $author$project$Data$Platform2$visitDashboard = F2(
	function (flags, dashboardId) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$emptyBody,
				hK: $author$project$Gwi$Http$expectWhatever($elm$core$Basics$identity),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$),
						A2($elm$http$Http$header, 'content-type', 'application/json')
					]),
				h8: 'PUT',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + ($author$project$Data$Id$unwrap(dashboardId) + '/visit'))
			});
	});
var $author$project$Dashboards2$visitDashboardCmd = F3(
	function (config, flags, dashboardId) {
		return A2(
			$elm$core$Platform$Cmd$map,
			$elm$core$Basics$always(config.y),
			A2($author$project$Data$Platform2$visitDashboard, flags, dashboardId));
	});
var $author$project$Dashboards2$updateForRoute = F5(
	function (config, flags, store, route, model) {
		var visitDashboardCmdBasedOnPlan = $author$project$Data$User$hasOpenAccessPlan(flags.mQ) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$add($elm$core$Platform$Cmd$none) : A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addMaybe,
			A2($author$project$Dashboards2$visitDashboardCmd, config, flags),
			$author$project$Dashboards2$Router$getDashboardId(route));
		var trackDashboardOpened = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$GlobalWebIndex$cmd_extra$Cmd$Extra$pure,
			A2($author$project$Dashboards2$dashboardOpenedAnalytics, flags, store),
			$author$project$Dashboards2$Router$getDashboardId(route));
		var storeActions = A3(
			$author$project$Gwi$List$addIf,
			$author$project$Permissions$isDashboardsCreator(flags.nM),
			$author$project$Store$Platform2$FetchInsightCategories,
			A3(
				$author$project$Gwi$List$joinIf,
				!$author$project$Data$User$hasViewOnlyPlan(flags.mQ),
				_List_fromArray(
					[$author$project$Store$Platform2$FetchDatasetFolders, $author$project$Store$Platform2$FetchDatasets, $author$project$Store$Platform2$FetchAudiences, $author$project$Store$Platform2$FetchAudienceFolders]),
				A3(
					$author$project$Gwi$List$addIf,
					!$author$project$Data$User$hasOpenAccessPlan(flags.mQ),
					$author$project$Store$Platform2$FetchDashboards,
					A3(
						$author$project$Gwi$List$addIf,
						!$author$project$Data$User$hasOpenAccessPlan(flags.mQ),
						$author$project$Store$Platform2$FetchDashboardsUserSettings,
						_List_Nil))));
		var setEditModeIfNewDashboard = function () {
			switch (route.$) {
				case 3:
					return $elm$core$Basics$identity;
				case 4:
					return $elm$core$Basics$identity;
				case 0:
					return $elm$core$Basics$identity;
				case 1:
					return $elm$core$Basics$identity;
				default:
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A5($author$project$Dashboards2$setEditMode, true, flags, config, route, store));
			}
		}();
		var reinitChartBrowserIfNeeded = function (model_) {
			var _v4 = model.c;
			if (_v4.$ === 18) {
				return A2(
					$elm$core$Tuple$mapFirst,
					function (newCBModel) {
						return _Utils_update(
							model_,
							{
								c: $author$project$Dashboards2$Modal$ChartBrowserModal(newCBModel)
							});
					},
					A2(
						$author$project$Dashboards2$ChartBrowser$init,
						config.V.fq,
						A4($author$project$Dashboards2$datasetsFromDashboard, flags, route, store, model_)));
			} else {
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model_);
			}
		};
		var maybeDashboard = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
		var clearDashboardIfOnList = function () {
			switch (route.$) {
				case 3:
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						function (m) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									m,
									{G: $author$project$Dashboards2$emptyUndoRedo}));
						});
				case 4:
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						function (m) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									m,
									{G: $author$project$Dashboards2$emptyUndoRedo}));
						});
				case 0:
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						function (m) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									m,
									{G: $author$project$Dashboards2$emptyUndoRedo}));
						});
				case 1:
					return $elm$core$Basics$identity;
				default:
					return $elm$core$Basics$identity;
			}
		}();
		var checkUserFilters = function () {
			var _v2 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
			if (!_v2.$) {
				var dashboard = _v2.a;
				return ($author$project$Dashboards2$Editable$isEdited(
					$author$project$Dashboards2$Detail$currentEditableUserFilters(model)) && (!_Utils_eq(dashboard.ah, $author$project$Data$Platform2$PrivateDashboard))) ? A4($author$project$Dashboards2$showContinueAnalysisModalOrDoAction, flags, config, route, store) : A2(
					$elm$core$Basics$composeR,
					A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A2(
							$elm$core$Basics$composeL,
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure,
							$author$project$Dashboards2$setUserFilters($author$project$Dashboards2$Editable$initNotReady))),
					A2(
						$elm$core$Basics$composeR,
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A4($author$project$Dashboards2$initUserFiltersIfNeeded, config, flags, route, store)),
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A4($author$project$Dashboards2$requestDataForAllWidgets, config, flags, route, store))));
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var checkNotRenamedInfo = function () {
			switch (route.$) {
				case 3:
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						function (m) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									m,
									{aW: $elm$core$Maybe$Nothing}));
						});
				case 4:
					return $elm$core$Basics$identity;
				case 0:
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						function (m) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								$author$project$Dashboards2$closeModal(
									_Utils_update(
										m,
										{aW: $elm$core$Maybe$Nothing})));
						});
				case 1:
					var id = route.a;
					return A2(
						$elm$core$Basics$composeR,
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							function (m) {
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
									$author$project$Dashboards2$clearUndoRedoHistory(
										_Utils_update(
											m,
											{
												aW: A2(
													$elm_community$maybe_extra$Maybe$Extra$filter,
													$elm$core$Basics$eq(id),
													m.aW)
											})));
							}),
						A2($turboMaCk$glue$Glue$updateWith, $turboMaCk$glue$Glue$id, reinitChartBrowserIfNeeded));
				default:
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						function (m) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									m,
									{aW: $elm$core$Maybe$Nothing}));
						});
			}
		}();
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
			config.l(
				_List_fromArray(
					[
						$author$project$Store$Platform2$UpdateStore($author$project$Store$Platform2$clearParamsForWidget)
					])),
			A3(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				trackDashboardOpened,
				A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					A2(
						$elm$core$Task$perform,
						A2($elm$core$Basics$composeR, $author$project$Dashboards2$SetTime, config.a),
						A3($elm$core$Task$map2, $elm$core$Tuple$pair, $elm$time$Time$here, $elm$time$Time$now)),
					setEditModeIfNewDashboard(
						A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
							config.a($author$project$Dashboards2$CheckStickyHeaderVisibility),
							A3(
								$author$project$Dashboards2$checkWidgetsVisibilityOnDetail,
								config,
								route,
								clearDashboardIfOnList(
									checkNotRenamedInfo(
										checkUserFilters(
											visitDashboardCmdBasedOnPlan(
												A3(
													$turboMaCk$glue$Glue$updateWith,
													$turboMaCk$glue$Glue$id,
													A5($author$project$Dashboards2$fetchDashboardAndItsData, config, flags, store, route, maybeDashboard),
													A2(
														$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
														config.l(storeActions),
														A5(
															$author$project$Dashboards2$updateWidgetsWith,
															F3(
																function (flags_, store_, widget) {
																	return A7(
																		$author$project$Dashboards2$Widget$updateForRoute,
																		config.V.c8,
																		$author$project$Dashboards2$getUserFilters(model),
																		flags_,
																		store_,
																		route,
																		widget,
																		$author$project$Dashboards2$Detail$isEditMode(model.o));
																}),
															flags,
															store,
															route,
															_Utils_update(
																model,
																{
																	b4: _List_Nil,
																	cV: function () {
																		var _v0 = model.cV;
																		if (_v0 === 3) {
																			return 1;
																		} else {
																			return 2;
																		}
																	}(),
																	dN: false,
																	ba: $elm$core$Maybe$Nothing
																}))))))))))))));
	});
var $author$project$Dashboards2$Modal$InvalidLink = function (a) {
	return {$: 1, a: a};
};
var $author$project$Platform2$Router$parseInsightUrl = function (url) {
	var _v0 = $elm$core$List$reverse(
		A2($elm$core$String$split, '/', url));
	if ((_v0.b && _v0.b.b) && (_v0.b.a === 'insights')) {
		var id = _v0.a;
		var _v1 = _v0.b;
		return $elm$core$Maybe$Just(
			$author$project$Data$Id$fromString(id));
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Dashboards2$updateInsightLink = F4(
	function (config, link, store, model) {
		var updateModal = F2(
			function (insightLink, modal) {
				if (modal.$ === 15) {
					var data = modal.a;
					return $author$project$Dashboards2$Modal$LinkInsightModal(
						_Utils_update(
							data,
							{ak: true, aP: insightLink}));
				} else {
					return model.c;
				}
			});
		if ($elm$core$String$isEmpty(link)) {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
				_Utils_update(
					model,
					{
						c: A2(updateModal, $author$project$Dashboards2$Modal$EmptyLink, model.c)
					}));
		} else {
			var _v0 = $author$project$Platform2$Router$parseInsightUrl(link);
			if (!_v0.$) {
				var insightId = _v0.a;
				var insight = function () {
					var _v1 = A2($author$project$Store$Platform2$getInsight, insightId, store);
					if (!_v1.$) {
						return $krisajenkins$remotedata$RemoteData$Loading;
					} else {
						var other = _v1;
						return other;
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: A2(
								updateModal,
								A3($author$project$Dashboards2$Modal$ValidLink, link, insightId, insight),
								model.c)
						}),
					$krisajenkins$remotedata$RemoteData$isSuccess(insight) ? $elm$core$Platform$Cmd$none : $GlobalWebIndex$cmd_extra$Cmd$Extra$perform(
						config.l(
							_List_fromArray(
								[
									$author$project$Store$Platform2$FetchInsight(insightId)
								]))));
			} else {
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							c: A2(
								updateModal,
								$author$project$Dashboards2$Modal$InvalidLink(link),
								model.c)
						}));
			}
		}
	});
var $author$project$Dashboards2$updateShareModal = F2(
	function (fn, model) {
		var _v0 = model.c;
		if ((_v0.$ === 16) && (_v0.a.$ === 1)) {
			var data = _v0.a.a;
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
				_Utils_update(
					model,
					{
						c: $author$project$Dashboards2$Modal$ShareDashboardModal(
							$author$project$Dashboards2$Modal$ShareDashboardModalReady(
								fn(data)))
					}));
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $elm$file$File$Download$url = function (href) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$never,
		_File_downloadUrl(href));
};
var $author$project$Export$urlDownload = function (url) {
	return $elm$file$File$Download$url(url);
};
var $author$project$Dashboards2$Analytics$FiltersChanged = function (a) {
	return {$: 41, a: a};
};
var $author$project$Dashboards2$userFiltersChangedAnalytics = F4(
	function (flags, route, store, model) {
		var maybeDashboard = A2(
			$elm$core$Maybe$andThen,
			function (id) {
				return $krisajenkins$remotedata$RemoteData$toMaybe(
					A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
			},
			$author$project$Dashboards2$Router$getDashboardId(route));
		var factors = _Utils_Tuple3(
			model.dT,
			$author$project$Dashboards2$getUserFilters(model),
			maybeDashboard);
		if ((factors.a && (!factors.b.$)) && (!factors.c.$)) {
			var userFilters = factors.b.a;
			var dashboard = factors.c.a;
			var waves = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				$turboMaCk$any_dict$Dict$Any$keys,
				$krisajenkins$remotedata$RemoteData$toMaybe(
					A2($author$project$Dashboards2$Detail$getWavesForDashboardByDashboardId, store, dashboard))) : $turboMaCk$any_set$Set$Any$toList(
				$author$project$Dashboards2$UserFilters$waves(userFilters));
			var locationIds = $turboMaCk$any_set$Set$Any$toList(
				$author$project$Dashboards2$UserFilters$locations(userFilters));
			var locationLabels = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
				$elm$core$List$map,
				function ($) {
					return $.ld;
				},
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					$elm$core$List$map($elm$core$Tuple$second),
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$filter(
							function (_v1) {
								var k = _v1.a;
								return A2($elm$core$List$member, k, locationIds);
							}),
						A2(
							$elm$core$Maybe$map,
							$turboMaCk$any_dict$Dict$Any$toList,
							$krisajenkins$remotedata$RemoteData$toMaybe(
								A2($author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId, store, dashboard)))))) : A2(
				$elm$core$List$map,
				function ($) {
					return $.ld;
				},
				A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					_List_Nil,
					$elm$core$List$map($elm$core$Tuple$second),
					A2(
						$elm$core$Maybe$map,
						$elm$core$List$filter(
							function (_v2) {
								var k = _v2.a;
								return A2($elm$core$List$member, k, locationIds);
							}),
						A2(
							$elm$core$Maybe$map,
							$turboMaCk$any_dict$Dict$Any$toList,
							$krisajenkins$remotedata$RemoteData$toMaybe(
								A2($author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces, store, dashboard))))));
			var datasets = A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				_List_Nil,
				function ($) {
					return $.es;
				},
				A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
			return A2(
				$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
				$author$project$Dashboards2$Analytics$trackEvent(
					$author$project$Dashboards2$Analytics$FiltersChanged(
						{es: datasets, cD: locationLabels, dX: waves})),
				_Utils_update(
					model,
					{dT: false}));
		} else {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
		}
	});
var $author$project$Icons$Platform2$warningTriangleIcon = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M13.853 10.182c.9-1.576 3.172-1.576 4.072 0l5.54 9.695c.894 1.563-.234 3.509-2.035 3.509H10.349c-1.8 0-2.93-1.946-2.037-3.51zm2.035 8.34l-.105.007c-.413.052-.732.405-.73.833 0 .457.375.83.836.83.461 0 .835-.373.835-.834 0-.427-.319-.778-.73-.83l-.106-.006zm.001-4.882c-.361 0-.654.293-.654.654v2.713l.006.088c.043.32.317.566.648.566.362 0 .655-.293.655-.654v-2.713l-.006-.089c-.044-.32-.318-.565-.649-.565z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$transform('translate(-723 -413) translate(0 246) translate(723 168)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Chart$dashboardUpdated = function (widget) {
	return $author$project$Dashboards2$Chart$getWidgetDimensions(widget);
};
var $author$project$Dashboards2$Widget$widgetResized = F2(
	function (msg, widget) {
		return A2(
			$elm$core$Platform$Cmd$map,
			A2($elm$core$Basics$composeR, $author$project$Dashboards2$Widget$ChartMsg, msg),
			$author$project$Dashboards2$Chart$dashboardUpdated(widget));
	});
var $author$project$Dashboards2$widgetsVisibilityFenceOffset = 200;
var $author$project$Dashboards2$update = F6(
	function (config, flags, route, store, msg, model) {
		switch (msg.$) {
			case 0:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
			case 133:
				var dashboardId = msg.a;
				var dashboardSharedAnalyticsMsg = function () {
					var _v1 = model.c;
					if ((_v1.$ === 16) && (_v1.a.$ === 1)) {
						var data = _v1.a.a;
						return A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$addMaybe,
							function (dashboard) {
								return A7(
									$author$project$Dashboards2$generateDashboardSharedAnalyticsCmd,
									flags,
									store,
									model,
									data.ac,
									data.d,
									dashboard,
									$author$project$Dashboards2$Replace('public_link'));
							},
							A2(
								$elm$core$Maybe$andThen,
								function (id) {
									return $krisajenkins$remotedata$RemoteData$toMaybe(
										A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
								},
								$author$project$Dashboards2$Router$getDashboardId(route)));
					} else {
						var _v2 = A2(
							$elm$core$Maybe$andThen,
							function (id) {
								return $krisajenkins$remotedata$RemoteData$toMaybe(
									A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
							},
							$author$project$Dashboards2$Router$getDashboardId(route));
						if (!_v2.$) {
							var dashboard = _v2.a;
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$add(
								A7(
									$author$project$Dashboards2$generateDashboardSharedAnalyticsCmd,
									flags,
									store,
									model,
									dashboard.ac,
									dashboard.ah,
									dashboard,
									$author$project$Dashboards2$Replace('public_link')));
						} else {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
								config.a($author$project$Dashboards2$NoOp));
						}
					}
				}();
				return dashboardSharedAnalyticsMsg(
					A4($author$project$Dashboards2$copyDashboardLink, config, flags, dashboardId, model));
			case 134:
				var shareDashboardMsg = function (msg_) {
					var _v6 = model.c;
					if ((_v6.$ === 16) && (_v6.a.$ === 1)) {
						var data = _v6.a.a;
						var _v7 = data.d;
						switch (_v7.$) {
							case 4:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
									config.a($author$project$Dashboards2$NoOp));
							case 6:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
									config.a($author$project$Dashboards2$NoOp));
							case 7:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
									config.a($author$project$Dashboards2$NoOp));
							case 8:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
									config.a($author$project$Dashboards2$NoOp));
							default:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(msg_);
						}
					} else {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
							config.a($author$project$Dashboards2$NoOp));
					}
				};
				var dashboardSharedAnalyticsMsg = function () {
					var _v4 = model.c;
					if ((_v4.$ === 16) && (_v4.a.$ === 1)) {
						var data = _v4.a.a;
						var _v5 = data.d;
						switch (_v5.$) {
							case 4:
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$addMaybe,
									function (dashboard) {
										return A7(
											$author$project$Dashboards2$generateDashboardSharedAnalyticsCmd,
											flags,
											store,
											model,
											data.ac,
											data.d,
											dashboard,
											$author$project$Dashboards2$Replace('open_access_link'));
									},
									A2(
										$elm$core$Maybe$andThen,
										function (id) {
											return $krisajenkins$remotedata$RemoteData$toMaybe(
												A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
										},
										$author$project$Dashboards2$Router$getDashboardId(route)));
							case 6:
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$addMaybe,
									function (dashboard) {
										return A7(
											$author$project$Dashboards2$generateDashboardSharedAnalyticsCmd,
											flags,
											store,
											model,
											data.ac,
											data.d,
											dashboard,
											$author$project$Dashboards2$Replace('open_access_link'));
									},
									A2(
										$elm$core$Maybe$andThen,
										function (id) {
											return $krisajenkins$remotedata$RemoteData$toMaybe(
												A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
										},
										$author$project$Dashboards2$Router$getDashboardId(route)));
							case 7:
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$addMaybe,
									function (dashboard) {
										return A7(
											$author$project$Dashboards2$generateDashboardSharedAnalyticsCmd,
											flags,
											store,
											model,
											data.ac,
											data.d,
											dashboard,
											$author$project$Dashboards2$Replace('open_access_link'));
									},
									A2(
										$elm$core$Maybe$andThen,
										function (id) {
											return $krisajenkins$remotedata$RemoteData$toMaybe(
												A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
										},
										$author$project$Dashboards2$Router$getDashboardId(route)));
							case 8:
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$addMaybe,
									function (dashboard) {
										return A7(
											$author$project$Dashboards2$generateDashboardSharedAnalyticsCmd,
											flags,
											store,
											model,
											data.ac,
											data.d,
											dashboard,
											$author$project$Dashboards2$Replace('open_access_link'));
									},
									A2(
										$elm$core$Maybe$andThen,
										function (id) {
											return $krisajenkins$remotedata$RemoteData$toMaybe(
												A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
										},
										$author$project$Dashboards2$Router$getDashboardId(route)));
							default:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
									config.a($author$project$Dashboards2$NoOp));
						}
					} else {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
							config.a($author$project$Dashboards2$NoOp));
					}
				}();
				var copyOadLinkMsg = A2(
					$elm$core$Maybe$map,
					function (id) {
						return A4($author$project$Dashboards2$copyOadLink, config, flags, id, model);
					},
					$author$project$Dashboards2$Router$getDashboardId(route));
				return dashboardSharedAnalyticsMsg(
					A3(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$addMaybe,
						$elm$core$Tuple$second,
						copyOadLinkMsg,
						A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
							config.a(
								A2(
									$author$project$Dashboards2$CreateNotification,
									$author$project$Icons$Platform2$duplicate,
									$elm$html$Html$text('Open access link copied to clipboard'))),
							A2(
								shareDashboardMsg,
								config.a(
									$author$project$Dashboards2$ShareDashboard(
										{
											bV: false,
											dK: $author$project$Dashboards2$Replace('open_access_link')
										})),
								A2(
									$author$project$Dashboards2$updateShareModal,
									function (data) {
										var newSharingType = function (sharingType) {
											switch (sharingType.$) {
												case 0:
													return $author$project$Data$Platform2$PublicLinkShared;
												case 3:
													return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
												case 2:
													var sharingTuple = sharingType.a;
													return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(sharingTuple);
												case 1:
													var sharingTuple = sharingType.a;
													return $author$project$Data$Platform2$PublicLinkAndGwiShared(sharingTuple);
												case 4:
													return $author$project$Data$Platform2$PublicLinkShared;
												case 5:
													return $author$project$Data$Platform2$LinkShared;
												case 8:
													return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
												case 7:
													var sharingTuple = sharingType.a;
													return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(sharingTuple);
												default:
													var sharingTuple = sharingType.a;
													return $author$project$Data$Platform2$PublicLinkAndGwiShared(sharingTuple);
											}
										};
										return _Utils_update(
											data,
											{
												d: newSharingType(data.d),
												bq: newSharingType(data.bq)
											});
									},
									model)))));
			case 1:
				var newRoute = msg.a;
				var initFiltersIfPossible = function () {
					var _v8 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
					if (!_v8.$) {
						var dashboard = _v8.a;
						return A5($author$project$Dashboards2$initUserFilters, config, flags, dashboard, route, store);
					} else {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
					}
				}();
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
					config.aM(newRoute),
					initFiltersIfPossible(
						$author$project$Dashboards2$clearUndoRedoHistory(
							A2(
								$author$project$Dashboards2$setUserFilters,
								$author$project$Dashboards2$Editable$initNotReady,
								$author$project$Dashboards2$setNotEdited(
									$author$project$Dashboards2$closeModal(model))))));
			case 2:
				var error = msg.a;
				var errorDisplay = A2($author$project$Error$getDisplay, $author$project$Export$exportErrorDisplay, error);
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Dashboards2$openErrorModal, errorDisplay, model));
			case 3:
				var list = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.l(list),
					model);
			case 71:
				var index = msg.a;
				var _v9 = $author$project$Dashboards2$getUserFilters(model);
				if (!_v9.$) {
					var userFilters = _v9.a;
					var _v10 = A3($author$project$Dashboards2$UserFilters$removeAudienceAtIndex, $author$project$Dashboards2$userFiltersConfig, index, userFilters);
					var newUserFilters = _v10.a;
					var cmd = _v10.b;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
						A2($elm$core$Platform$Cmd$map, config.a, cmd),
						A2(
							$author$project$Dashboards2$undoRedoCommitIfNotEditMode,
							newUserFilters,
							$author$project$Dashboards2$closeDropdown(model)));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 72:
				var expression = msg.a.bY;
				var name = msg.a.ld;
				return _Utils_Tuple2(
					$author$project$Dashboards2$closeDropdown(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$AudienceExpression(
									{bY: expression, ld: name})
							})),
					$elm$core$Platform$Cmd$none);
			case 73:
				var audienceId = msg.a;
				return _Utils_Tuple2(
					$author$project$Dashboards2$closeDropdown(
						_Utils_update(
							model,
							{
								dM: $elm$core$Maybe$Just(audienceId)
							})),
					$elm$core$Platform$Cmd$none);
			case 67:
				var _v11 = $author$project$Dashboards2$getUserFilters(model);
				if (!_v11.$) {
					var userFilters = _v11.a;
					var _v12 = A3($author$project$Dashboards2$UserFilters$resetBaseAudience, $author$project$Dashboards2$userFiltersConfig, flags, userFilters);
					var newUserFilters = _v12.a;
					var userFiltersCmds = _v12.b;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
						A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds),
						A2(
							$author$project$Dashboards2$undoRedoCommitIfNotEditMode,
							newUserFilters,
							$author$project$Dashboards2$closeDropdown(
								_Utils_update(
									model,
									{c: $author$project$Dashboards2$Modal$NoModal}))));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 66:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					$author$project$Dashboards2$closeDropdown(model));
			case 13:
				var lMsg = msg.a;
				return A4(
					$turboMaCk$glue$Glue$update,
					$author$project$Dashboards2$dashboardsList,
					A2($author$project$Dashboards2$List$update, config.dy, flags.mQ),
					lMsg,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
			case 4:
				var dmsg = msg.a;
				var _v13 = A2(
					$turboMaCk$glue$Glue$map,
					config.a,
					A3($author$project$Platform2$Drawers$update, store, dmsg, model.aJ));
				var drawerModel = _v13.a;
				var drawerMsg = _v13.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{aJ: drawerModel}),
					drawerMsg);
			case 5:
				var widgetId = msg.a;
				var subMsg = msg.b;
				var maybeDashboard = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				var maybeWidget = A2(
					$elm$core$Maybe$andThen,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.cl;
						},
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.g;
							},
							$elm_community$list_extra$List$Extra$find(
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.b;
									},
									$elm$core$Basics$eq(widgetId))))),
					maybeDashboard);
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A5(
						$elm$core$Maybe$map4,
						F4(
							function (widgetModel, dashboard, widget, userFilters) {
								var _v14 = A9(
									$author$project$Dashboards2$Widget$update,
									flags,
									A2(config.V.c8, userFilters, widget),
									store,
									dashboard,
									widget,
									{
										ez: $author$project$Dashboards2$isEditMode(model.o)
									},
									subMsg,
									32,
									widgetModel);
								var newWidgetModel = _v14.a;
								var cmd = _v14.b;
								return function (_v15) {
									var subModel = _v15.a;
									var subCmd = _v15.b;
									if (subMsg.$ === 2) {
										var _v17 = $turboMaCk$queue$Queue$dequeue(model.dh);
										if (!_v17.a.$) {
											var msg_ = _v17.a.a;
											var newQueue = _v17.b;
											return A2(
												$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
												A2($elm$core$Platform$Cmd$map, config.a, msg_),
												_Utils_Tuple2(
													_Utils_update(
														subModel,
														{
															dh: newQueue,
															a2: $author$project$Dashboards2$incrementLoaderCounts(subModel.a2)
														}),
													subCmd));
										} else {
											var _v18 = _v17.a;
											var _v19 = subModel.a2;
											if (!_v19.$) {
												var totalCellsCount = _v19.a.mI;
												var loadedCellsCount = _v19.a.h6;
												return _Utils_eq(totalCellsCount, loadedCellsCount + 1) ? A2(
													$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
													subCmd,
													_Utils_Tuple2(
														subModel,
														A2(
															$elm$core$Task$perform,
															config.a,
															A2($elm$core$Task$map, $author$project$Dashboards2$Export, $elm$time$Time$now)))) : _Utils_Tuple2(
													_Utils_update(
														subModel,
														{
															a2: $author$project$Dashboards2$incrementLoaderCounts(subModel.a2)
														}),
													subCmd);
											} else {
												return _Utils_Tuple2(subModel, subCmd);
											}
										}
									} else {
										return _Utils_Tuple2(subModel, subCmd);
									}
								}(
									_Utils_Tuple2(
										A2(
											$author$project$Dashboards2$updateWidgets,
											A2($turboMaCk$any_dict$Dict$Any$insert, widgetId, newWidgetModel),
											model),
										cmd));
							}),
						A2(
							$turboMaCk$any_dict$Dict$Any$get,
							widgetId,
							$author$project$Dashboards2$Detail$currentWidgets(model)),
						maybeDashboard,
						maybeWidget,
						$author$project$Dashboards2$getUserFilters(model)));
			case 6:
				var place = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$DashboardCreated(
							{
								a0: flags.nM(23),
								iq: place
							})),
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						config.as($author$project$Dashboards2$Router$NewDashboard),
						model));
			case 62:
				var newName = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					function () {
						var _v20 = model.c;
						if (_v20.$ === 12) {
							var data = _v20.a;
							return (_Utils_cmp(
								$elm$core$String$length(newName),
								$author$project$Dashboards2$maxUserDefinedNameLength) > 0) ? model : _Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$DuplicateDashboardModal(
										_Utils_update(
											data,
											{ld: newName}))
								});
						} else {
							return model;
						}
					}());
			case 7:
				return A6($author$project$Dashboards2$saveDashboard, flags, config, route, $elm$core$Maybe$Nothing, store, model);
			case 8:
				return A4($author$project$Dashboards2$duplicateDashboard, flags, route, store, model);
			case 9:
				var dashboard = msg.a;
				var maybeUserFilters = $author$project$Dashboards2$getUserFilters(model);
				var _v21 = function () {
					var _v22 = model.c;
					if (_v22.$ === 12) {
						var data = _v22.a;
						return _Utils_Tuple3(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$DuplicateDashboardModal(
										_Utils_update(
											data,
											{fK: true}))
								}),
							data.ld,
							data.iC);
					} else {
						return _Utils_Tuple3(model, '', $elm$core$Maybe$Nothing);
					}
				}();
				var newModel = _v21.a;
				var newName = _v21.b;
				var routeAfterSave = _v21.c;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeL,
							config.a,
							$author$project$Dashboards2$TrackAndDuplicateDashboard(newName)),
						A2(
							$elm$core$Task$map,
							$elm_community$maybe_extra$Maybe$Extra$isJust(maybeUserFilters) ? A2($author$project$Dashboards2$Detail$applyEdits, model.ba, maybeUserFilters) : $elm$core$Basics$identity,
							A3($author$project$Store$Platform2$getDashboardFullyLoadedTask, dashboard.b, flags, store))),
					$author$project$Dashboards2$setNotEdited(
						_Utils_update(
							newModel,
							{a6: routeAfterSave})));
			case 10:
				return A6(
					$author$project$Dashboards2$requestDataForAllWidgetsIfNotLoaded,
					config,
					flags,
					route,
					store,
					{bi: true},
					$author$project$Dashboards2$closeDropdown(model));
			case 11:
				var currentTime = msg.a;
				return A6($author$project$Dashboards2$export, config, flags, currentTime, route, store, model);
			case 12:
				var url = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (userFilters) {
							var selectedLocations = $turboMaCk$any_set$Set$Any$toList(
								$author$project$Dashboards2$UserFilters$locations(userFilters));
							var questions = $turboMaCk$any_dict$Dict$Any$values(
								A2(
									$turboMaCk$any_dict$Dict$Any$filterMap,
									F2(
										function (_v25, v) {
											return $krisajenkins$remotedata$RemoteData$toMaybe(v);
										}),
									store.bt));
							var getFilteredLocations = function (dashboard) {
								return $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									_List_Nil,
									$elm$core$List$map($elm$core$Tuple$second),
									A2(
										$elm$core$Maybe$map,
										$elm$core$List$filter(
											function (_v23) {
												var k = _v23.a;
												return A2($elm$core$List$member, k, selectedLocations);
											}),
										A2(
											$elm$core$Maybe$map,
											$turboMaCk$any_dict$Dict$Any$toList,
											$krisajenkins$remotedata$RemoteData$toMaybe(
												A2($author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId, store, dashboard))))) : A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									_List_Nil,
									$elm$core$List$map($elm$core$Tuple$second),
									A2(
										$elm$core$Maybe$map,
										$elm$core$List$filter(
											function (_v24) {
												var k = _v24.a;
												return A2($elm$core$List$member, k, selectedLocations);
											}),
										A2(
											$elm$core$Maybe$map,
											$turboMaCk$any_dict$Dict$Any$toList,
											$krisajenkins$remotedata$RemoteData$toMaybe(
												A2($author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces, store, dashboard)))));
							};
							var baseAudience = A2(
								$elm$core$Maybe$andThen,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.b;
									},
									$author$project$Store$Utils$get(store.d9)),
								$author$project$Dashboards2$UserFilters$baseAudienceToMaybe(userFilters));
							var audiences = A2(
								$author$project$Store$Utils$getByIds,
								store.d9,
								$author$project$Dashboards2$UserFilters$audienceIds(userFilters));
							var analyticsCmd = A2(
								$elm$core$Maybe$withDefault,
								$elm$core$Platform$Cmd$none,
								A2(
									$elm$core$Maybe$map,
									function (dashboard) {
										return $author$project$Dashboards2$Analytics$trackEvent(
											$author$project$Dashboards2$Analytics$DashboardExported(
												{
													be: 'Dashboards',
													d9: audiences,
													aU: baseAudience,
													ep: dashboard,
													oE: flags.mQ.b,
													cD: getFilteredLocations(dashboard),
													bt: questions
												}));
									},
									A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model)));
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{a2: $elm$core$Maybe$Nothing}),
								$elm$core$Platform$Cmd$batch(
									_List_fromArray(
										[
											$author$project$Export$urlDownload(url),
											analyticsCmd
										])));
						},
						$author$project$Dashboards2$getUserFilters(model)));
			case 131:
				var organisation = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
					config.a(
						A2(
							$author$project$Dashboards2$CreateNotification,
							$author$project$Icons$Platform2$sharing,
							$elm$html$Html$text('Dashboard unshared with ' + organisation.ld))),
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
						config.a(
							$author$project$Dashboards2$ShareDashboard(
								{bV: false, dK: $author$project$Dashboards2$ByNewSharedWith})),
						A2(
							$author$project$Dashboards2$updateShareModal,
							function (data) {
								var newSharingType = function (sharingType) {
									switch (sharingType.$) {
										case 0:
											return $author$project$Data$Platform2$PrivateDashboard;
										case 3:
											return $author$project$Data$Platform2$PublicDashboard;
										case 2:
											var _v27 = sharingType.a;
											var userIds = _v27.b;
											return $elm$core$List$isEmpty(userIds) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$NonGwiShared(
												_Utils_Tuple2($elm$core$Maybe$Nothing, userIds));
										case 1:
											var _v28 = sharingType.a;
											var orgIds = _v28.a;
											var userIds = _v28.b;
											var listWithOriginalOrgRemoved = A2(
												$elm$core$List$filter,
												$elm$core$Basics$neq(organisation.b),
												orgIds);
											return ($elm$core$List$isEmpty(listWithOriginalOrgRemoved) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
												_Utils_Tuple2(listWithOriginalOrgRemoved, userIds));
										case 4:
											return $author$project$Data$Platform2$PublicLinkShared;
										case 5:
											return $author$project$Data$Platform2$LinkShared;
										case 8:
											return $author$project$Data$Platform2$PublicDashboard;
										case 7:
											var _v29 = sharingType.a;
											var userIds = _v29.b;
											return $elm$core$List$isEmpty(userIds) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
												_Utils_Tuple2($elm$core$Maybe$Nothing, userIds));
										default:
											var _v30 = sharingType.a;
											var orgIds = _v30.a;
											var userIds = _v30.b;
											var listWithOriginalOrgRemoved = A2(
												$elm$core$List$filter,
												$elm$core$Basics$neq(organisation.b),
												orgIds);
											return ($elm$core$List$isEmpty(listWithOriginalOrgRemoved) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
												_Utils_Tuple2(listWithOriginalOrgRemoved, userIds));
									}
								};
								return _Utils_update(
									data,
									{
										d: newSharingType(data.d),
										aa: A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.b;
												},
												$elm$core$Basics$neq(organisation.b)),
											data.aa),
										bq: newSharingType(data.bq)
									});
							},
							model)));
			case 132:
				var user = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
					config.a(
						A2(
							$author$project$Dashboards2$CreateNotification,
							$author$project$Icons$Platform2$sharing,
							$elm$html$Html$text('Dashboard unshared with ' + user.j))),
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
						config.a(
							$author$project$Dashboards2$ShareDashboard(
								{bV: false, dK: $author$project$Dashboards2$ByNewSharedWith})),
						A2(
							$author$project$Dashboards2$updateShareModal,
							function (data) {
								var newSharingType = function (sharingType) {
									switch (sharingType.$) {
										case 0:
											return $author$project$Data$Platform2$PrivateDashboard;
										case 3:
											return $author$project$Data$Platform2$PublicDashboard;
										case 2:
											var _v32 = sharingType.a;
											var maybeOrgId = _v32.a;
											var userEmails = _v32.b;
											var listWithOriginalUserRemoved = A2(
												$elm$core$List$filter,
												$elm$core$Basics$neq(
													{j: user.j, b: user.b}),
												userEmails);
											return ($elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOrgId) && $elm$core$List$isEmpty(listWithOriginalUserRemoved)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$NonGwiShared(
												_Utils_Tuple2($elm$core$Maybe$Nothing, listWithOriginalUserRemoved));
										case 1:
											var _v33 = sharingType.a;
											var orgIds = _v33.a;
											var userEmails = _v33.b;
											var listWithOriginalUserRemoved = A2(
												$elm$core$List$filter,
												$elm$core$Basics$neq(
													{j: user.j, b: user.b}),
												userEmails);
											return ($elm$core$List$isEmpty(orgIds) && $elm$core$List$isEmpty(listWithOriginalUserRemoved)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
												_Utils_Tuple2(orgIds, listWithOriginalUserRemoved));
										case 4:
											return $author$project$Data$Platform2$PublicLinkShared;
										case 5:
											return $author$project$Data$Platform2$LinkShared;
										case 8:
											return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
										case 7:
											var _v34 = sharingType.a;
											var maybeOrgId = _v34.a;
											var userEmails = _v34.b;
											var listWithOriginalUserRemoved = A2(
												$elm$core$List$filter,
												$elm$core$Basics$neq(
													{j: user.j, b: user.b}),
												userEmails);
											return ($elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOrgId) && $elm$core$List$isEmpty(listWithOriginalUserRemoved)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
												_Utils_Tuple2($elm$core$Maybe$Nothing, listWithOriginalUserRemoved));
										default:
											var _v35 = sharingType.a;
											var orgIds = _v35.a;
											var userEmails = _v35.b;
											var listWithOriginalUserRemoved = A2(
												$elm$core$List$filter,
												$elm$core$Basics$neq(
													{j: user.j, b: user.b}),
												userEmails);
											return ($elm$core$List$isEmpty(orgIds) && $elm$core$List$isEmpty(listWithOriginalUserRemoved)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
												_Utils_Tuple2(orgIds, listWithOriginalUserRemoved));
									}
								};
								return _Utils_update(
									data,
									{
										d: newSharingType(data.d),
										bq: newSharingType(data.bq),
										W: A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.b;
												},
												$elm$core$Basics$neq(user.b)),
											data.W)
									});
							},
							model)));
			case 14:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (userFilters) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									model,
									{
										aJ: A2(
											$author$project$Platform2$Drawers$openLocations,
											{ns: $author$project$Dashboards2$ApplyLocationsSelection, a: $author$project$Dashboards2$DrawersMsg},
											{
												kg: $elm$core$Maybe$Nothing,
												oV: function (store_) {
													return A3(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														$krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict),
														$author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? $author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId(store_) : $author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces(store_),
														A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
												},
												rc: $elm$core$Maybe$Nothing,
												l8: $author$project$Dashboards2$UserFilters$locations(userFilters)
											})
									}));
						},
						$author$project$Dashboards2$getUserFilters(model)));
			case 15:
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (userFilters) {
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								_Utils_update(
									model,
									{
										aJ: A2(
											$author$project$Platform2$Drawers$openWaves,
											{nt: $author$project$Dashboards2$ApplyWavesSelection, a: $author$project$Dashboards2$DrawersMsg},
											{
												kg: $elm$core$Maybe$Nothing,
												oX: function (store_) {
													return A3(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														$krisajenkins$remotedata$RemoteData$Success($author$project$Data$Id$emptyDict),
														$author$project$Dashboards2$Detail$getWavesForDashboardByNamespaces(store_),
														A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
												},
												l9: $author$project$Dashboards2$UserFilters$waves(userFilters)
											})
									}));
						},
						$author$project$Dashboards2$getUserFilters(model)));
			case 16:
				var dashboard = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$ConfirmDeleteDashboard(dashboard)
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var dashboardIds = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$ConfirmDeleteMultipleDashboards(dashboardIds)
						}),
					$elm$core$Platform$Cmd$none);
			case 18:
				var dashboard = msg.a;
				if (A4($author$project$Dashboards2$Permissions$canRenameOrDelete, flags.mQ, flags.nM, dashboard.ah, dashboard.dG)) {
					switch (route.$) {
						case 0:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: A2($author$project$Dashboards2$Modal$RenameDashboardModal, dashboard.b, dashboard.ld)
									}),
								$elm$core$Platform$Cmd$none);
						case 1:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: A2($author$project$Dashboards2$Modal$RenameDashboardModal, dashboard.b, dashboard.ld)
									}),
								$elm$core$Platform$Cmd$none);
						case 3:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						case 4:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						default:
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: A2($author$project$Dashboards2$Modal$RenameDashboardModal, dashboard.b, dashboard.ld)
									}),
								$elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 19:
				var dashboard = msg.a;
				var allDashboardNames = A2(
					$elm$core$List$map,
					function ($) {
						return $.ld;
					},
					A3($krisajenkins$remotedata$RemoteData$unwrap, _List_Nil, $turboMaCk$any_dict$Dict$Any$values, store.v));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$DuplicateDashboardModal(
								{
									ht: dashboard,
									fK: false,
									ld: A3($author$project$Platform2$NameForCopy$getWithLimit, allDashboardNames, $author$project$Dashboards2$maxUserDefinedNameLength, dashboard.ld),
									iC: $elm$core$Maybe$Just($author$project$Dashboards2$Router$DashboardsList)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 49:
				var id = msg.a;
				var data = msg.b;
				var result = function () {
					if (!data.$) {
						var size = data.a;
						return $krisajenkins$remotedata$RemoteData$Success(size);
					} else {
						var error = data.a;
						return $krisajenkins$remotedata$RemoteData$Failure(
							A2(
								$author$project$Gwi$Http$toHttpError,
								function (err) {
									switch (err.$) {
										case 0:
											var e = err.a;
											return $elm$http$Http$BadBody(e);
										case 1:
											return $elm$http$Http$BadBody('Empty audience expression');
										default:
											return $elm$http$Http$BadBody('Universe zero');
									}
								},
								error));
					}
				}();
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (userFilters) {
							return _Utils_Tuple2(
								A2(
									$author$project$Dashboards2$updateCurrentUserFilters,
									$author$project$Dashboards2$Editable$update(
										A3($author$project$Dashboards2$UserFilters$setSampleSize, id, result, userFilters)),
									model),
								$elm$core$Platform$Cmd$none);
						},
						$author$project$Dashboards2$getUserFilters(model)));
			case 50:
				var change = msg.a;
				var isEditing = !_Utils_eq(model.o, $author$project$Dashboards2$Detail$NotEditing);
				var saveIfEditing = (isEditing && $author$project$Dashboards2$Editable$isEdited(
					$author$project$Dashboards2$Detail$currentEditableUserFilters(model))) ? A2(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					A5($author$project$Dashboards2$saveDashboard, flags, config, route, $elm$core$Maybe$Nothing, store)) : $elm$core$Basics$identity;
				var setUnsavedIfNotEdition = isEditing ? $elm$core$Basics$identity : A2(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					$author$project$Dashboards2$setSavingState(2));
				return A3(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					A3($author$project$Dashboards2$userFiltersChangedAnalytics, flags, route, store),
					A3(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						$author$project$Dashboards2$setSavingState(2),
						A3(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							function (m) {
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
									_Utils_update(
										m,
										{dT: true}));
							},
							saveIfEditing(
								function () {
									if (!change) {
										return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
											A2(
												$elm$core$Maybe$withDefault,
												model,
												A2(
													$elm$core$Maybe$map,
													function (userFilters) {
														return A5(
															$author$project$Dashboards2$updateWidgetsPure,
															flags,
															$author$project$Dashboards2$Widget$updateWidgetsChartDataWithFilters(userFilters),
															store,
															route,
															model);
													},
													$author$project$Dashboards2$getUserFilters(model))));
									} else {
										return setUnsavedIfNotEdition(
											A5($author$project$Dashboards2$requestDataForAllWidgets, config, flags, route, store, model));
									}
								}()))));
			case 57:
				var id = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
					A2(
						$elm$core$Maybe$map,
						function (userFilters) {
							var _v40 = A3($author$project$Dashboards2$UserFilters$toggleAudienceVisibility, $author$project$Dashboards2$userFiltersConfig, id, userFilters);
							var updatedFilters = _v40.a;
							var cmds = _v40.b;
							return _Utils_Tuple2(
								A2(
									$author$project$Dashboards2$updateCurrentUserFilters,
									$author$project$Dashboards2$Editable$update(updatedFilters),
									$author$project$Dashboards2$closeDropdown(model)),
								A2($elm$core$Platform$Cmd$map, config.a, cmds));
						},
						$author$project$Dashboards2$getUserFilters(model)));
			case 20:
				var selectedLocationCodes = msg.a;
				return A6($author$project$Dashboards2$applyLocationsSelection, config, flags, route, store, selectedLocationCodes, model);
			case 21:
				var selectedWaveCodes = msg.a;
				return A6($author$project$Dashboards2$applyWavesSelection, config, flags, route, store, selectedWaveCodes, model);
			case 23:
				var widget = msg.a;
				var questions = msg.b;
				var analytics = $author$project$Dashboards2$Analytics$trackEvent(
					$author$project$Dashboards2$Analytics$ChartMetadata(
						{hh: widget.ld, aI: widget.aI}));
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					analytics,
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								b4: $turboMaCk$non_empty_list_alias$List$NonEmpty$toList(questions)
							}),
						$elm$core$Platform$Cmd$none));
			case 24:
				var isBase = msg.a.dt;
				var isNotDefault = function (baseAudience) {
					if (!baseAudience.$) {
						return false;
					} else {
						return true;
					}
				};
				var hasBaseAudience = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						isNotDefault,
						A2(
							$elm$core$Maybe$map,
							$author$project$Dashboards2$UserFilters$getBaseAudience,
							$author$project$Dashboards2$getUserFilters(model))));
				var hasAudiences = 0 < $elm$core$List$length(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$Dashboards2$UserFilters$audiences,
							$author$project$Dashboards2$getUserFilters(model))));
				var dashboardId = function () {
					if (route.$ === 1) {
						var id = route.a;
						return $author$project$Data$Id$unwrap(id);
					} else {
						return 'N/A';
					}
				}();
				var audienceOrBase = isBase ? 'audience_browser' : 'audience_browser';
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$AudienceBrowser(
								{Z: $elm$core$Maybe$Nothing, dt: isBase, aS: _List_Nil, L: 0})
						}),
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$AudienceBrowserOpened(
							{
								be: 'Dashboards',
								hb: audienceOrBase,
								hs: _List_fromArray(
									[dashboardId]),
								hT: hasBaseAudience || hasAudiences
							})));
			case 25:
				var colored = msg.a;
				var index = msg.b;
				var dashboardId = function () {
					if (route.$ === 1) {
						var id = route.a;
						return $author$project$Data$Id$unwrap(id);
					} else {
						return 'N/A';
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$ReplaceAudienceBrowser(
								{
									Z: $elm$core$Maybe$Nothing,
									pi: index,
									lv: colored.fk.b,
									lE: A2(
										$elm$core$Maybe$withDefault,
										$turboMaCk$any_set$Set$Any$empty(
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.b;
												},
												$author$project$Data$Id$unwrap)),
										A2(
											$elm$core$Maybe$map,
											function (userFilters) {
												return A2(
													$turboMaCk$any_set$Set$Any$fromList,
													A2(
														$elm$core$Basics$composeR,
														function ($) {
															return $.b;
														},
														$author$project$Data$Id$unwrap),
													A2(
														$elm$core$List$filter,
														function (storeAudience) {
															return !_Utils_eq(storeAudience.b, colored.fk.b);
														},
														A2(
															$elm$core$List$filterMap,
															A2(
																$elm$core$Basics$composeR,
																function ($) {
																	return $.b;
																},
																$author$project$Store$Utils$get(store.d9)),
															$author$project$Dashboards2$UserFilters$audiences(userFilters))));
											},
											$author$project$Dashboards2$getUserFilters(model))),
									bw: colored.fk.b,
									L: 0
								})
						}),
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$AudienceBrowserOpened(
							{
								be: 'Dashboards',
								hb: 'audience_browser',
								hs: _List_fromArray(
									[dashboardId]),
								hT: true
							})));
			case 26:
				var isNotDefault = function (baseAudience) {
					if (!baseAudience.$) {
						return false;
					} else {
						return true;
					}
				};
				var hasBaseAudience = A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						isNotDefault,
						A2(
							$elm$core$Maybe$map,
							$author$project$Dashboards2$UserFilters$getBaseAudience,
							$author$project$Dashboards2$getUserFilters(model))));
				var hasAudiences = 0 < $elm$core$List$length(
					A2(
						$elm$core$Maybe$withDefault,
						_List_Nil,
						A2(
							$elm$core$Maybe$map,
							$author$project$Dashboards2$UserFilters$audiences,
							$author$project$Dashboards2$getUserFilters(model))));
				var dashboardId = function () {
					if (route.$ === 1) {
						var id = route.a;
						return $author$project$Data$Id$unwrap(id);
					} else {
						return 'N/A';
					}
				}();
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$BaseAudienceBrowser(
								{Z: $elm$core$Maybe$Nothing, bw: $elm$core$Maybe$Nothing, L: 0})
						}),
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$AudienceBrowserOpened(
							{
								be: 'Dashboards',
								hb: 'base_audience_browser',
								hs: _List_fromArray(
									[dashboardId]),
								hT: hasBaseAudience || hasAudiences
							})));
			case 27:
				var description = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2(
						$author$project$Dashboards2$openErrorModal,
						{jv: $elm_community$html_extra$Html$Extra$nothing, j$: description, ka: $elm$core$Maybe$Nothing, Y: ''},
						model));
			case 28:
				var widget = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$ConfirmDeleteWidget(widget)
						}));
			case 29:
				var widget = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$HelpMeChooseChartType(
								{aI: $elm$core$Maybe$Nothing, bO: widget})
						}));
			case 30:
				var widget = msg.a;
				var currentMetric = msg.b;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$HelpMeChooseMetric(
								{hr: currentMetric, bO: widget})
						}));
			case 31:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{c: $author$project$Dashboards2$Modal$MetricInfo}));
			case 32:
				var widget = msg.a;
				var _v46 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v46.$) {
					var savedDashboard = _v46.a;
					var data = savedDashboard.cl;
					var newPosition = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						0.0,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.lB;
							},
							$elm$core$Basics$add(0.125)),
						$elm_community$list_extra$List$Extra$last(
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.lB;
								},
								data.g)));
					var newWidget = A3($author$project$Data$Platform2$duplicateWidget, widget, savedDashboard.b, newPosition);
					return A3(
						$author$project$Dashboards2$scrollToWidget,
						config,
						newWidget,
						A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
							$author$project$Dashboards2$Analytics$trackEvent(
								$author$project$Dashboards2$Analytics$DuplicateTextWidget(
									{bO: newWidget})),
							A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								A2(
									config.ag,
									_Utils_update(
										savedDashboard,
										{
											cl: _Utils_update(
												data,
												{
													g: A2($elm$core$List$cons, newWidget, data.g)
												})
										}),
									5),
								_Utils_update(
									model,
									{
										o: A2($author$project$Dashboards2$initEditGrid, config, model.o)
									}))));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 33:
				var chartType = msg.a;
				var _v47 = model.c;
				if (_v47.$ === 9) {
					var data = _v47.a;
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$HelpMeChooseChartType(
									_Utils_update(
										data,
										{
											aI: $elm$core$Maybe$Just(chartType)
										}))
							}));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 34:
				var metric = msg.a;
				var _v48 = model.c;
				if (_v48.$ === 10) {
					var data = _v48.a;
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$HelpMeChooseMetric(
									_Utils_update(
										data,
										{hr: metric}))
							}));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 35:
				var widget = msg.a;
				var chartType = msg.b;
				var maybeDashboard = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				return A2(
					$elm$core$Maybe$withDefault,
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (dashboard, userFilters) {
								return A5(
									$author$project$Dashboards2$updateWidgetsWith,
									F3(
										function (_v49, store_, widget_) {
											return _Utils_eq(widget_.b, widget.b) ? A7(
												$author$project$Dashboards2$Widget$setChartType,
												flags,
												A2(config.V.c8, userFilters, widget),
												store_,
												dashboard,
												widget,
												{
													ez: $author$project$Dashboards2$isEditMode(model.o)
												},
												chartType) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
										}),
									flags,
									store,
									route,
									$author$project$Dashboards2$closeModal(model));
							}),
						maybeDashboard,
						$author$project$Dashboards2$getUserFilters(model)));
			case 36:
				var widget = msg.a;
				var metric = msg.b;
				return A2(
					$elm$core$Maybe$withDefault,
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
					A3(
						$elm$core$Maybe$map2,
						F2(
							function (dashboard, userFilters) {
								return A5(
									$author$project$Dashboards2$updateWidgetsWith,
									F3(
										function (_v50, store_, widget_) {
											return _Utils_eq(widget_.b, widget.b) ? A8(
												$author$project$Dashboards2$Widget$update,
												flags,
												A2(config.V.c8, userFilters, widget),
												store_,
												dashboard,
												widget,
												{
													ez: $author$project$Dashboards2$isEditMode(model.o)
												},
												$author$project$Dashboards2$Widget$SetMetric(metric),
												31) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
										}),
									flags,
									store,
									route,
									$author$project$Dashboards2$closeModal(model));
							}),
						A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model),
						$author$project$Dashboards2$getUserFilters(model)));
			case 37:
				return _Utils_Tuple2(
					A2(
						$author$project$Dashboards2$updateWidgets,
						$author$project$Dashboards2$Widget$closeWidgetsDropdown,
						$author$project$Dashboards2$closeModal(model)),
					$elm$core$Platform$Cmd$none);
			case 39:
				return A3(
					$elm$core$Basics$apR,
					model.a6,
					A2(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$GlobalWebIndex$cmd_extra$Cmd$Extra$pure,
						A2($elm$core$Basics$composeR, config.aM, $GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger)),
					$author$project$Dashboards2$closeModal(
						_Utils_update(
							model,
							{a6: $elm$core$Maybe$Nothing})));
			case 38:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.l(
						_List_fromArray(
							[$author$project$Store$Platform2$ReloadAudiences])),
					_Utils_update(
						model,
						{dM: $elm$core$Maybe$Nothing, dN: false}));
			case 44:
				var _v51 = model.c;
				switch (_v51.$) {
					case 5:
						var data = _v51.a;
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$BaseAudienceBrowser(
										_Utils_update(
											data,
											{L: 0}))
								}));
					case 4:
						var data = _v51.a;
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$ReplaceAudienceBrowser(
										_Utils_update(
											data,
											{L: 0}))
								}));
					default:
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 45:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{b4: _List_Nil}),
					$elm$core$Platform$Cmd$none);
			case 46:
				var _v52 = _Utils_Tuple2(
					$author$project$Dashboards2$getUserFilters(model),
					store.d9);
				if ((!_v52.a.$) && (_v52.b.$ === 3)) {
					var userFilters = _v52.a.a;
					var audiences = _v52.b.a;
					var _v53 = model.c;
					switch (_v53.$) {
						case 3:
							var stagedAudiences = _v53.a.aS;
							var newStagedAudiences = A2(
								$elm$core$List$map,
								function ($) {
									return $.b;
								},
								stagedAudiences);
							var isEditing = !_Utils_eq(model.o, $author$project$Dashboards2$Detail$NotEditing);
							var _v54 = A6(
								$author$project$Dashboards2$UserFilters$addAudiences,
								$author$project$Dashboards2$userFiltersConfig,
								flags,
								audiences,
								newStagedAudiences,
								userFilters,
								{ez: isEditing});
							var newUserFilters = _v54.a;
							var userFiltersCmds = _v54.b;
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
								A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds),
								A2(
									$author$project$Dashboards2$undoRedoCommitIfNotEditMode,
									newUserFilters,
									_Utils_update(
										model,
										{c: $author$project$Dashboards2$Modal$NoModal})));
						case 5:
							var stagedAudience = _v53.a.bw;
							var isEditing = !_Utils_eq(model.o, $author$project$Dashboards2$Detail$NotEditing);
							var _v55 = A6(
								$author$project$Dashboards2$UserFilters$addBaseAudience,
								$author$project$Dashboards2$userFiltersConfig,
								flags,
								audiences,
								A2(
									$elm$core$Maybe$map,
									function ($) {
										return $.b;
									},
									stagedAudience),
								userFilters,
								isEditing);
							var newUserFilters = _v55.a;
							var userFiltersCmds = _v55.b;
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
								A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds),
								A2(
									$author$project$Dashboards2$undoRedoCommitIfNotEditMode,
									newUserFilters,
									_Utils_update(
										model,
										{c: $author$project$Dashboards2$Modal$NoModal})));
						case 4:
							var stagedAudience = _v53.a.bw;
							var index = _v53.a.pi;
							var _v56 = function () {
								var _v57 = A2($author$project$Store$Utils$get, store.d9, stagedAudience);
								if (!_v57.$) {
									var audience = _v57.a;
									return A5($author$project$Dashboards2$UserFilters$replaceAudienceAtIndex, $author$project$Dashboards2$userFiltersConfig, flags, index, audience, userFilters);
								} else {
									return _Utils_Tuple2(userFilters, $elm$core$Platform$Cmd$none);
								}
							}();
							var newUserFilters = _v56.a;
							var userFiltersCmds = _v56.b;
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
								A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds),
								A2(
									$author$project$Dashboards2$undoRedoCommitIfNotEditMode,
									newUserFilters,
									_Utils_update(
										model,
										{c: $author$project$Dashboards2$Modal$NoModal})));
						default:
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 40:
				var audience = msg.a;
				var _v58 = model.c;
				switch (_v58.$) {
					case 4:
						var data = _v58.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$ReplaceAudienceBrowser(
										_Utils_update(
											data,
											{Z: $elm$core$Maybe$Nothing, bw: audience.b, L: 0}))
								}),
							$elm$core$Platform$Cmd$none);
					case 3:
						var data = _v58.a;
						var wouldAdd = !A2(
							$elm$core$List$member,
							audience.b,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.b;
								},
								data.aS));
						var stagedCount = $elm$core$List$length(data.aS);
						var preexistingCount = A2(
							$elm$core$Maybe$withDefault,
							0,
							A2(
								$elm$core$Maybe$map,
								A2($elm$core$Basics$composeR, $author$project$Dashboards2$UserFilters$audienceIds, $elm$core$List$length),
								$author$project$Dashboards2$getUserFilters(model)));
						var isAtFullCapacity = _Utils_cmp(stagedCount + preexistingCount, $author$project$Dashboards2$UserFilters$maxNumberOfAudiences) > -1;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$AudienceBrowser(
										_Utils_update(
											data,
											{
												Z: $elm$core$Maybe$Nothing,
												aS: (wouldAdd && isAtFullCapacity) ? data.aS : A2($author$project$Gwi$List$toggle, audience, data.aS),
												L: 0
											}))
								}),
							$elm$core$Platform$Cmd$none);
					case 5:
						var data = _v58.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$BaseAudienceBrowser(
										_Utils_update(
											data,
											{
												Z: $elm$core$Maybe$Nothing,
												bw: _Utils_eq(
													$elm$core$Maybe$Just(audience),
													data.bw) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(audience),
												L: 0
											}))
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 41:
				var _v59 = model.c;
				switch (_v59.$) {
					case 3:
						var data = _v59.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$AudienceBrowser(
										_Utils_update(
											data,
											{L: 1}))
								}),
							$elm$core$Platform$Cmd$none);
					case 5:
						var data = _v59.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$BaseAudienceBrowser(
										_Utils_update(
											data,
											{L: 1}))
								}),
							$elm$core$Platform$Cmd$none);
					case 4:
						var data = _v59.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$ReplaceAudienceBrowser(
										_Utils_update(
											data,
											{L: 1}))
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 42:
				var err = msg.a;
				var _v60 = model.c;
				switch (_v60.$) {
					case 3:
						var data = _v60.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$AudienceBrowser(
										_Utils_update(
											data,
											{
												Z: $elm$core$Maybe$Just(err)
											}))
								}),
							$elm$core$Platform$Cmd$none);
					case 5:
						var data = _v60.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$BaseAudienceBrowser(
										_Utils_update(
											data,
											{
												Z: $elm$core$Maybe$Just(err)
											}))
								}),
							$elm$core$Platform$Cmd$none);
					case 4:
						var data = _v60.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$ReplaceAudienceBrowser(
										_Utils_update(
											data,
											{
												Z: $elm$core$Maybe$Just(err)
											}))
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 43:
				var _v61 = model.c;
				switch (_v61.$) {
					case 3:
						var data = _v61.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$AudienceBrowser(
										_Utils_update(
											data,
											{Z: $elm$core$Maybe$Nothing, aS: _List_Nil, L: 0}))
								}),
							$elm$core$Platform$Cmd$none);
					case 5:
						var data = _v61.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$BaseAudienceBrowser(
										_Utils_update(
											data,
											{Z: $elm$core$Maybe$Nothing, bw: $elm$core$Maybe$Nothing, L: 0}))
								}),
							$elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 47:
				var innerMsg = msg.a;
				var _v62 = A2($author$project$Platform2$Notification$Queue$update, innerMsg, model.cJ);
				var notificationQueue = _v62.a;
				var cmd = _v62.b;
				var maybeMsg = _v62.c;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cJ: notificationQueue}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Platform$Cmd$map,
								A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$NotificationQueueMsg),
								cmd),
								A2(
								$elm$core$Platform$Cmd$map,
								config.a,
								$GlobalWebIndex$cmd_extra$Cmd$Extra$maybe(maybeMsg))
							])));
			case 48:
				var iconData = msg.a;
				var body = msg.b;
				var _v63 = A2(
					$author$project$Platform2$Notification$Queue$enqueue,
					A3($author$project$Platform2$Notification$create, $elm$core$Maybe$Nothing, body, iconData),
					$author$project$Platform2$Notification$Queue$clearNonpersistent(model.cJ));
				var newQueue = _v63.a;
				var cmd = _v63.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{cJ: newQueue}),
					A2(
						$elm$core$Platform$Cmd$map,
						A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$NotificationQueueMsg),
						cmd));
			case 51:
				var dashboard = msg.a;
				return function () {
					var _v64 = $author$project$Data$Platform2$toFullyLoadedDashboard(dashboard);
					if (_v64.$ === 3) {
						var dashboardFullyLoaded = _v64.a;
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger(
							config.a(
								A2(
									$author$project$Dashboards2$TrackAndDeleteDashboard,
									dashboard,
									$elm$core$Result$Ok(dashboardFullyLoaded))));
					} else {
						return $GlobalWebIndex$cmd_extra$Cmd$Extra$with(
							A2(
								$elm$core$Task$attempt,
								A2(
									$elm$core$Basics$composeL,
									config.a,
									$author$project$Dashboards2$TrackAndDeleteDashboard(dashboard)),
								A2($author$project$Data$Platform2$getDashboardFullyLoadedTask, dashboard.b, flags)));
					}
				}()(model);
			case 52:
				var dashboards = msg.a;
				return A3(
					$elm$core$List$foldr,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger, config.a),
						$author$project$Dashboards2$DeleteDashboard),
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							model,
							{
								aY: A3(
									$elm$core$List$foldr,
									function (d) {
										return $turboMaCk$any_set$Set$Any$insert(d.b);
									},
									model.aY,
									dashboards)
							})),
					dashboards);
			case 53:
				var dashboard = msg.a;
				var dashboardFullyLoadedResult = msg.b;
				var widgetsCount = function () {
					if (dashboardFullyLoadedResult.$ === 1) {
						return A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.g;
								},
								$elm$core$List$length),
							$krisajenkins$remotedata$RemoteData$toMaybe(dashboard.cl));
					} else {
						var dashboardFullyLoaded = dashboardFullyLoadedResult.a;
						return $elm$core$Maybe$Just(
							$elm$core$List$length(dashboardFullyLoaded.cl.g));
					}
				}();
				var audienceIds = function () {
					if (dashboardFullyLoadedResult.$ === 1) {
						return A2(
							$elm$core$Maybe$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.C;
								},
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.d9;
									},
									$elm$core$Maybe$withDefault(_List_Nil))),
							$krisajenkins$remotedata$RemoteData$toMaybe(dashboard.cl));
					} else {
						var dashboardFullyLoaded = dashboardFullyLoadedResult.a;
						return $elm$core$Maybe$Just(
							A2($elm$core$Maybe$withDefault, _List_Nil, dashboardFullyLoaded.cl.C.d9));
					}
				}();
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$DashboardDeleted(
							{
								jl: A2($elm$core$Maybe$map, $elm$core$List$length, audienceIds),
								jo: audienceIds,
								bf: dashboard.b,
								bC: dashboard.ld,
								a0: flags.nM(23),
								i4: widgetsCount
							})),
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						config.cp(dashboard),
						_Utils_update(
							model,
							{c: $author$project$Dashboards2$Modal$NoModal})));
			case 54:
				var newDashboardName = msg.a;
				var dashboard = msg.b;
				if (!dashboard.$) {
					var dashboardFullyLoaded = dashboard.a;
					var duplicatedDashboard = _Utils_update(
						dashboardFullyLoaded,
						{ld: newDashboardName, ah: $author$project$Data$Platform2$PrivateDashboard});
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
						$author$project$Dashboards2$Analytics$trackEvent(
							$author$project$Dashboards2$Analytics$DashboardSaved(
								{nM: flags.nM, ep: duplicatedDashboard, ot: true, q6: true})),
						A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
							config.cj(duplicatedDashboard),
							_Utils_update(
								model,
								{c: $author$project$Dashboards2$Modal$NoModal})));
				} else {
					var err = dashboard.a;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						A3(
							$elm$core$Basics$composeR,
							$author$project$Gwi$Http$fromHttpError,
							config.bQ($elm$core$Basics$identity),
							err),
						model);
				}
			case 55:
				var widget = msg.a;
				var dashboard = msg.b;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(
						function () {
							var _v68 = widget.U;
							if (_v68.$ === 1) {
								return $author$project$Dashboards2$Analytics$TextWidgetDeleted(
									{
										bf: dashboard.b,
										bC: dashboard.ld,
										a0: flags.nM(23)
									});
							} else {
								var c = _v68.a;
								return $author$project$Dashboards2$Analytics$ChartWidgetDeleted(
									{
										hh: c.ld,
										aI: c.aI,
										bf: dashboard.b,
										bC: dashboard.ld,
										fX: c.b2,
										kC: function () {
											var _v69 = c.aU;
											if (_v69.$ === 1) {
												return true;
											} else {
												return false;
											}
										}(),
										a0: flags.nM(23),
										dB: c.dB,
										cY: c.cY
									});
							}
						}()),
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						A2(config.cq, widget.b, dashboard),
						_Utils_update(
							model,
							{c: $author$project$Dashboards2$Modal$NoModal})));
			case 56:
				var _v70 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v70.$) {
					var dashboard = _v70.a;
					return A3(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A4($author$project$Dashboards2$requestDataForAllWidgets, config, flags, route, store),
						A6(
							$author$project$Dashboards2$initUserFilters,
							config,
							flags,
							dashboard,
							route,
							store,
							$author$project$Dashboards2$clearUndoRedoHistory(
								A2(
									$author$project$Dashboards2$setUserFilters,
									$author$project$Dashboards2$Editable$initNotReady,
									$author$project$Dashboards2$closeDropdown(
										_Utils_update(
											model,
											{cV: 2, ba: $elm$core$Maybe$Nothing}))))));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 58:
				var newRoute = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Dashboards2$clearFiltersConfirmDialog, newRoute, model));
			case 59:
				var newRoute = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.aM(newRoute),
					A2(
						$author$project$Dashboards2$setUserFilters,
						$author$project$Dashboards2$Editable$initNotReady,
						_Utils_update(
							model,
							{c: $author$project$Dashboards2$Modal$NoModal})));
			case 60:
				var newRoute = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					A2($author$project$Dashboards2$unsavedChangesConfirmDialog, newRoute, model));
			case 61:
				var newRoute = msg.a;
				return A6(
					$author$project$Dashboards2$saveDashboard,
					flags,
					config,
					route,
					$elm$core$Maybe$Just(newRoute),
					store,
					$author$project$Dashboards2$clearUndoRedoHistory(
						$author$project$Dashboards2$closeModal(model)));
			case 63:
				var id = msg.a;
				var newName = msg.b;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					A2(config.cR, id, newName),
					_Utils_update(
						model,
						{c: $author$project$Dashboards2$Modal$NoModal}));
			case 64:
				var newName = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					function () {
						var _v71 = model.c;
						if (_v71.$ === 13) {
							var dashboardId = _v71.a;
							return (_Utils_cmp(
								$elm$core$String$length(newName),
								$author$project$Dashboards2$maxUserDefinedNameLength) > 0) ? model : _Utils_update(
								model,
								{
									c: A2($author$project$Dashboards2$Modal$RenameDashboardModal, dashboardId, newName)
								});
						} else {
							return model;
						}
					}());
			case 68:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					function () {
						var _v72 = model.c;
						if (_v72.$ === 1) {
							var data = _v72.a;
							return _Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$ConfirmModal(
										_Utils_update(
											data,
											{
												bF: function () {
													var _v73 = data.bF;
													if (!_v73.$) {
														return $author$project$Dashboards2$Modal$Visible(true);
													} else {
														var current = _v73.a;
														return $author$project$Dashboards2$Modal$Visible(!current);
													}
												}()
											}))
								});
						} else {
							return model;
						}
					}());
			case 128:
				return _Utils_Tuple2(
					model,
					$author$project$Dashboards2$getBasesPanelViewport(config));
			case 127:
				var viewport = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							ec: $elm$core$Maybe$Just(viewport)
						}),
					$elm$core$Platform$Cmd$none);
			case 126:
				var jumpLeft = function (id) {
					return A2(
						$elm$core$Task$attempt,
						function (_v74) {
							return config.a($author$project$Dashboards2$NoOp);
						},
						A2(
							$elm$core$Task$andThen,
							function (info) {
								return A3($elm$browser$Browser$Dom$setViewportOf, id, info.mX.m3 - 40, 0);
							},
							$elm$browser$Browser$Dom$getViewportOf(id)));
				};
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								jumpLeft($author$project$Dashboards2$Detail$audiencesPanelScrollableId),
								$author$project$Dashboards2$getBasesPanelViewport(config)
							])));
			case 125:
				var jumpRight = function (id) {
					return A2(
						$elm$core$Task$attempt,
						function (_v75) {
							return config.a($author$project$Dashboards2$NoOp);
						},
						A2(
							$elm$core$Task$andThen,
							function (info) {
								return A3($elm$browser$Browser$Dom$setViewportOf, id, info.mX.m3 + 40, 0);
							},
							$elm$browser$Browser$Dom$getViewportOf(id)));
				};
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								jumpRight($author$project$Dashboards2$Detail$audiencesPanelScrollableId),
								$author$project$Dashboards2$getBasesPanelViewport(config)
							])));
			case 70:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$ContinueAnalysis(
							{
								jf: false,
								lM: $author$project$Dashboards2$getRememberMyChoice(model.c)
							})),
					A5(
						$author$project$Dashboards2$saveContinueAnalysisUserSettingsIfRequired,
						config,
						1,
						store,
						model.c,
						A3(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A4($author$project$Dashboards2$updateForRoute, config, flags, store, route),
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
								A2(
									$author$project$Dashboards2$setUserFilters,
									$author$project$Dashboards2$Editable$initNotReady,
									_Utils_update(
										model,
										{c: $author$project$Dashboards2$Modal$NoModal}))))));
			case 69:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$ContinueAnalysis(
							{
								jf: true,
								lM: $author$project$Dashboards2$getRememberMyChoice(model.c)
							})),
					A5(
						$author$project$Dashboards2$saveContinueAnalysisUserSettingsIfRequired,
						config,
						2,
						store,
						model.c,
						A4(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Dashboards2$Detail$SavedDashboardId,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Dashboards2$Detail$getNamespaceCodes(store),
									A2($author$project$Dashboards2$removeIncompatibleAudiences, config, flags))),
							$author$project$Dashboards2$Router$getDashboardId(route),
							$author$project$Dashboards2$closeModal(model))));
			case 74:
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					A2(
						$elm$core$Maybe$withDefault,
						$elm$core$Platform$Cmd$none,
						A2(
							$elm$core$Maybe$map,
							function (dashboard) {
								var audienceIds = A2($elm$core$Maybe$withDefault, _List_Nil, dashboard.cl.C.d9);
								return $author$project$Dashboards2$Analytics$trackEvent(
									$author$project$Dashboards2$Analytics$DashboardEditModeOpened(
										{
											jl: $elm$core$List$length(audienceIds),
											jo: audienceIds,
											bf: dashboard.b,
											bC: dashboard.ld,
											a0: flags.nM(23),
											i4: $elm$core$List$length(dashboard.cl.g)
										}));
							},
							A2(
								$elm$core$Maybe$andThen,
								function (id) {
									return $krisajenkins$remotedata$RemoteData$toMaybe(
										A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
								},
								$author$project$Dashboards2$Router$getDashboardId(route)))),
					A6(
						$author$project$Dashboards2$setEditMode,
						true,
						flags,
						config,
						route,
						store,
						$author$project$Dashboards2$closeDropdown(model)));
			case 75:
				var shouldBeEditing = msg.a;
				return A6($author$project$Dashboards2$setEditMode, shouldBeEditing, flags, config, route, store, model);
			case 76:
				var canEditContentAndShare = function (currentDashboard) {
					return A4($author$project$Dashboards2$Permissions$canEditContentAndShare, flags.mQ, flags.nM, currentDashboard.ah, currentDashboard.dG);
				};
				var _v76 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v76.$) {
					var dashboard = _v76.a;
					return canEditContentAndShare(dashboard) ? A6($author$project$Dashboards2$setEditMode, true, flags, config, route, store, model) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 77:
				var getNamespacesFromDashboardAudiences = function (dashboard) {
					return A3(
						$elm$core$List$foldr,
						function (_v80) {
							var expression = _v80.bY;
							return $turboMaCk$any_set$Set$Any$union(
								$author$project$Data$Id$setFromList(
									$author$project$Data$Audience$Expression$namespaceCodes(expression)));
						},
						$author$project$Data$Id$emptySet,
						A2(
							$author$project$Store$Utils$getByIds,
							store.d9,
							A4(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Basics$identity,
								$elm$core$List$cons,
								dashboard.cl.C.aU,
								A2($elm$core$Maybe$withDefault, _List_Nil, dashboard.cl.C.d9))));
				};
				var getDashboardWidgetNamespaces = function (dashboard) {
					return A3(
						$elm$core$List$foldr,
						F2(
							function (w, acc) {
								var _v79 = w.U;
								if (!_v79.$) {
									var chartWidget = _v79.a;
									return A2(
										$turboMaCk$any_set$Set$Any$union,
										acc,
										$author$project$Data$Id$setFromList(
											$author$project$Data$Platform2$namespacesForChartWidget(chartWidget)));
								} else {
									return acc;
								}
							}),
						$author$project$Data$Id$emptySet,
						dashboard.cl.g);
				};
				var _v77 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v77.$) {
					var dashboard = _v77.a;
					var namespacesFromDashboard = $turboMaCk$any_set$Set$Any$toList(
						A2(
							$turboMaCk$any_set$Set$Any$union,
							getDashboardWidgetNamespaces(dashboard),
							getNamespacesFromDashboardAudiences(dashboard)));
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						config.a(
							$author$project$Dashboards2$FetchMany(
								A2($elm$core$List$map, $author$project$Store$Platform2$FetchLineage, namespacesFromDashboard))),
						_Utils_update(
							model,
							{
								aJ: A3(
									$author$project$Platform2$Drawers$openDatasets,
									{
										nr: $author$project$Dashboards2$ApplyDatasetsSelection,
										oI: A2(
											$elm$core$Basics$composeR,
											$elm$core$List$map($author$project$Store$Platform2$FetchLineage),
											$author$project$Dashboards2$FetchMany),
										a: $author$project$Dashboards2$DrawersMsg
									},
									{
										n5: function (selectedDatasets) {
											var updatedDashboard = _Utils_update(
												dashboard,
												{
													es: $turboMaCk$any_set$Set$Any$toList(selectedDatasets)
												});
											return A3(
												$krisajenkins$remotedata$RemoteData$unwrap,
												{gE: _List_Nil, gF: _List_Nil, mg: false},
												function (_v78) {
													var removedWidgets = _v78.gF;
													var removedAudiences = _v78.gE;
													return {
														gE: removedAudiences,
														gF: removedWidgets,
														mg: (!$elm$core$List$isEmpty(removedWidgets)) || (!$elm$core$List$isEmpty(removedAudiences))
													};
												},
												A3(
													$krisajenkins$remotedata$RemoteData$map2,
													F2(
														function (datasetsToNamespaces, allAudiences) {
															return A4($author$project$Data$Platform2$removeAllIncompatibilitiesFromDashboard, allAudiences, datasetsToNamespaces, store.cB, updatedDashboard);
														}),
													store.fC,
													store.d9));
										},
										l7: $author$project$Data$Id$setFromList(dashboard.es)
									},
									store)
							}));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 22:
				var datasets = msg.a;
				var _v81 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v81.$) {
					var savedDashboard = _v81.a;
					var newDashboard = _Utils_update(
						savedDashboard,
						{
							es: $turboMaCk$any_set$Set$Any$toList(datasets)
						});
					var modelWithoutUserFiltersReady = A2($author$project$Dashboards2$setUserFilters, $author$project$Dashboards2$Editable$initNotReady, model);
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						function (d) {
							return A2(config.ag, d, 4);
						}(
							A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								{jH: newDashboard, gE: _List_Nil, gF: _List_Nil},
								A3(
									$krisajenkins$remotedata$RemoteData$map2,
									F2(
										function (audiences, datasetsToNamespaces) {
											return A4($author$project$Data$Platform2$removeAllIncompatibilitiesFromDashboard, audiences, datasetsToNamespaces, store.cB, newDashboard);
										}),
									store.d9,
									store.fC)).jH),
						_Utils_update(
							modelWithoutUserFiltersReady,
							{aJ: $author$project$Platform2$Drawers$close, dT: true}));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 78:
				var _v82 = function () {
					var _v83 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
					if (!_v83.$) {
						var data = _v83.a.cl;
						var _v84 = data.aP;
						if (!_v84.$) {
							var id = _v84.a.b;
							var insight = A2(
								$elm$core$Maybe$withDefault,
								$krisajenkins$remotedata$RemoteData$NotAsked,
								A2($turboMaCk$any_dict$Dict$Any$get, id, store.pk));
							var cmd = $krisajenkins$remotedata$RemoteData$isSuccess(insight) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$pure : $GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger(
								config.l(
									_List_fromArray(
										[
											$author$project$Store$Platform2$FetchInsight(id)
										])));
							return _Utils_Tuple2(
								{
									ak: false,
									aP: A3($author$project$Dashboards2$Modal$ValidLink, '', id, insight),
									eC: true
								},
								cmd);
						} else {
							return _Utils_Tuple2(
								{ak: false, aP: $author$project$Dashboards2$Modal$EmptyLink, eC: false},
								$GlobalWebIndex$cmd_extra$Cmd$Extra$pure);
						}
					} else {
						return _Utils_Tuple2(
							{ak: false, aP: $author$project$Dashboards2$Modal$EmptyLink, eC: false},
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure);
					}
				}();
				var currentLink = _v82.a;
				var withCmd = _v82.b;
				return withCmd(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$LinkInsightModal(currentLink)
						}));
			case 79:
				var _v85 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v85.$) {
					var data = _v85.a.cl;
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$AddDescriptionModal(
									{fx: data.hB, ak: false})
							}));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 80:
				var text = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							c: function () {
								var _v86 = model.c;
								if (_v86.$ === 17) {
									var data = _v86.a;
									var description = $elm$core$String$isEmpty(text) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
										A2($elm$core$String$left, $author$project$Dashboards2$descriptionLimit, text));
									return $author$project$Dashboards2$Modal$AddDescriptionModal(
										_Utils_update(
											data,
											{fx: description, ak: true}));
								} else {
									return model.c;
								}
							}()
						}));
			case 81:
				var widget = msg.a;
				var chartWidget = msg.b;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							c: $author$project$Dashboards2$Modal$EditWidgetName(
								{dg: chartWidget, ak: false, bO: widget})
						}));
			case 82:
				var text = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							c: function () {
								var _v87 = model.c;
								if (_v87.$ === 19) {
									var data = _v87.a;
									var chartWidget = data.dg;
									var newChartWidget = _Utils_update(
										chartWidget,
										{
											ld: A2($elm$core$String$left, $author$project$Dashboards2$addChartNameLimit, text)
										});
									return $author$project$Dashboards2$Modal$EditWidgetName(
										_Utils_update(
											data,
											{dg: newChartWidget, ak: true}));
								} else {
									return model.c;
								}
							}()
						}));
			case 83:
				var text = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							c: function () {
								var _v88 = model.c;
								if (_v88.$ === 19) {
									var data = _v88.a;
									var chartWidget = data.dg;
									var newChartWidget = _Utils_update(
										chartWidget,
										{
											b2: A2($elm$core$String$left, $author$project$Dashboards2$addChartNoteLimit, text)
										});
									return $author$project$Dashboards2$Modal$EditWidgetName(
										_Utils_update(
											data,
											{dg: newChartWidget, ak: true}));
								} else {
									return model.c;
								}
							}()
						}));
			case 84:
				var id = msg.a.b;
				var name = msg.a.ld;
				var place = msg.b;
				var selectedDataset = A4($author$project$Dashboards2$datasetsFromDashboard, flags, route, store, model);
				var _v89 = A2($author$project$Dashboards2$ChartBrowser$init, config.V.fq, selectedDataset);
				var chartBrowserModel = _v89.a;
				var cmds = _v89.b;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$WidgetAddButtonClicked(
							{
								bf: id,
								bC: name,
								a0: flags.nM(23),
								iq: place,
								mL: 'chart'
							})),
					_Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$ChartBrowserModal(chartBrowserModel)
							}),
						cmds));
			case 85:
				var cbMsg = msg.a;
				var _v90 = model.c;
				if (_v90.$ === 18) {
					var chartBrowserModel = _v90.a;
					return A2(
						$elm$core$Tuple$mapFirst,
						function (newCBModel) {
							return _Utils_update(
								model,
								{
									c: $author$project$Dashboards2$Modal$ChartBrowserModal(newCBModel)
								});
						},
						A4($author$project$Dashboards2$ChartBrowser$update, config.V.fq, flags, cbMsg, chartBrowserModel));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 86:
				var subMsg = msg.a;
				var _v91 = model.c;
				if ((_v91.$ === 16) && (_v91.a.$ === 1)) {
					var data = _v91.a.a;
					return A2(
						$turboMaCk$glue$Glue$map,
						A2($elm$core$Basics$composeR, $author$project$Dashboards2$OrgAutocompleteInputMsg, config.a),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newOrgAutocompleteModel) {
								var newSharedWith = function () {
									var _v95 = data.d;
									switch (_v95.$) {
										case 0:
											var orgIds = A2(
												$elm$core$List$map,
												function ($) {
													return $.b;
												},
												newOrgAutocompleteModel.u);
											var _v96 = _Utils_Tuple2(
												flags.nM(23),
												orgIds);
											if (_v96.a) {
												if (!_v96.b.b) {
													return $author$project$Data$Platform2$PrivateDashboard;
												} else {
													var orgIds_ = _v96.b;
													return $author$project$Data$Platform2$GwiShared(
														_Utils_Tuple2(orgIds_, _List_Nil));
												}
											} else {
												return $author$project$Data$Platform2$PrivateDashboard;
											}
										case 3:
											return $author$project$Data$Platform2$PublicDashboard;
										case 2:
											var sharingTuple = _v95.a;
											return $author$project$Data$Platform2$NonGwiShared(sharingTuple);
										case 1:
											var _v97 = _v95.a;
											var userIds = _v97.b;
											var originalAndSelectedOrgIds = A2(
												$elm$core$List$map,
												function ($) {
													return $.b;
												},
												_Utils_ap(data.aa, newOrgAutocompleteModel.u));
											return ($elm$core$List$isEmpty(originalAndSelectedOrgIds) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
												_Utils_Tuple2(originalAndSelectedOrgIds, userIds));
										case 4:
											var originalAndSelectedOrgIds = A2(
												$elm$core$List$map,
												function ($) {
													return $.b;
												},
												_Utils_ap(data.aa, newOrgAutocompleteModel.u));
											return $elm$core$List$isEmpty(originalAndSelectedOrgIds) ? $author$project$Data$Platform2$PublicLinkShared : (flags.nM(23) ? $author$project$Data$Platform2$PublicLinkAndGwiShared(
												_Utils_Tuple2(originalAndSelectedOrgIds, _List_Nil)) : $author$project$Data$Platform2$PublicLinkShared);
										case 8:
											return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
										case 7:
											var sharingTuple = _v95.a;
											return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(sharingTuple);
										case 6:
											var _v98 = _v95.a;
											var userIds = _v98.b;
											var originalAndSelectedOrgIds = A2(
												$elm$core$List$map,
												function ($) {
													return $.b;
												},
												_Utils_ap(data.aa, newOrgAutocompleteModel.u));
											return ($elm$core$List$isEmpty(originalAndSelectedOrgIds) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
												_Utils_Tuple2(originalAndSelectedOrgIds, userIds));
										default:
											return $author$project$Data$Platform2$LinkShared;
									}
								}();
								return _Utils_update(
									model,
									{
										c: $author$project$Dashboards2$Modal$ShareDashboardModal(
											$author$project$Dashboards2$Modal$ShareDashboardModalReady(
												_Utils_update(
													data,
													{d: newSharedWith, F: newOrgAutocompleteModel})))
									});
							},
							A3(
								$author$project$Platform2$AutocompleteInput$update,
								{
									kd: function (term) {
										var removeExistingOrgsFromSuggestions = function () {
											var _v92 = data.d;
											if (_v92.$ === 1) {
												var _v93 = _v92.a;
												var orgIds = _v93.a;
												return $elm$core$List$filter(
													function (fetchedOrg) {
														return !A2($elm$core$List$member, fetchedOrg.b, orgIds);
													});
											} else {
												return $elm$core$Basics$identity;
											}
										}();
										return A2(
											$author$project$Gwi$Http$cmdMap,
											removeExistingOrgsFromSuggestions,
											A2($author$project$Data$Platform2$getOrganisationsSuggestion, term, flags));
									},
									mA: function ($) {
										return $.ld;
									},
									mV: function (_v94) {
										return $elm$core$Platform$Cmd$none;
									}
								},
								subMsg,
								data.F)));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 87:
				var subMsg = msg.a;
				var _v99 = model.c;
				if ((_v99.$ === 16) && (_v99.a.$ === 1)) {
					var data = _v99.a.a;
					return A2(
						$turboMaCk$glue$Glue$map,
						A2($elm$core$Basics$composeR, $author$project$Dashboards2$UserAutocompleteInputMsg, config.a),
						A2(
							$elm$core$Tuple$mapFirst,
							function (newUserAutocompleteModel) {
								var newSharedWith = function () {
									var _v105 = data.d;
									switch (_v105.$) {
										case 0:
											var userEmails = A2(
												$elm$core$List$map,
												function (fullUserEmail) {
													return {j: fullUserEmail.j, b: fullUserEmail.b};
												},
												newUserAutocompleteModel.u);
											var _v106 = _Utils_Tuple2(
												flags.nM(23),
												userEmails);
											if (_v106.a) {
												if (!_v106.b.b) {
													return $author$project$Data$Platform2$PrivateDashboard;
												} else {
													var userEmails_ = _v106.b;
													return $author$project$Data$Platform2$GwiShared(
														_Utils_Tuple2(_List_Nil, userEmails_));
												}
											} else {
												if (!_v106.b.b) {
													return $author$project$Data$Platform2$PrivateDashboard;
												} else {
													var userEmails_ = _v106.b;
													return $author$project$Data$Platform2$NonGwiShared(
														_Utils_Tuple2($elm$core$Maybe$Nothing, userEmails_));
												}
											}
										case 3:
											return $author$project$Data$Platform2$PublicDashboard;
										case 1:
											var _v107 = _v105.a;
											var orgIds = _v107.a;
											var originalAndSelectedUserEmails = _Utils_ap(
												data.W,
												A2(
													$elm$core$List$map,
													function (fullUserEmail) {
														return {j: fullUserEmail.j, b: fullUserEmail.b};
													},
													newUserAutocompleteModel.u));
											return ($elm$core$List$isEmpty(orgIds) && $elm$core$List$isEmpty(originalAndSelectedUserEmails)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
												_Utils_Tuple2(orgIds, originalAndSelectedUserEmails));
										case 2:
											var _v108 = _v105.a;
											var maybeOrgId = _v108.a;
											var originalAndSelectedUserEmails = _Utils_ap(
												data.W,
												A2(
													$elm$core$List$map,
													function (fullUserEmail) {
														return {j: fullUserEmail.j, b: fullUserEmail.b};
													},
													newUserAutocompleteModel.u));
											return ($elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOrgId) && $elm$core$List$isEmpty(originalAndSelectedUserEmails)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$NonGwiShared(
												_Utils_Tuple2(maybeOrgId, originalAndSelectedUserEmails));
										case 4:
											var userEmails = A2(
												$elm$core$List$map,
												function (fullUserEmail) {
													return {j: fullUserEmail.j, b: fullUserEmail.b};
												},
												newUserAutocompleteModel.u);
											var _v109 = _Utils_Tuple2(
												flags.nM(23),
												userEmails);
											if (_v109.a) {
												if (!_v109.b.b) {
													return $author$project$Data$Platform2$PublicLinkShared;
												} else {
													var userEmails_ = _v109.b;
													return $author$project$Data$Platform2$PublicLinkAndGwiShared(
														_Utils_Tuple2(_List_Nil, userEmails_));
												}
											} else {
												if (!_v109.b.b) {
													return $author$project$Data$Platform2$PublicLinkShared;
												} else {
													var userEmails_ = _v109.b;
													return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
														_Utils_Tuple2($elm$core$Maybe$Nothing, userEmails_));
												}
											}
										case 8:
											return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
										case 6:
											var _v110 = _v105.a;
											var orgIds = _v110.a;
											var originalAndSelectedUserEmails = _Utils_ap(
												data.W,
												A2(
													$elm$core$List$map,
													function (fullUserEmail) {
														return {j: fullUserEmail.j, b: fullUserEmail.b};
													},
													newUserAutocompleteModel.u));
											return ($elm$core$List$isEmpty(orgIds) && $elm$core$List$isEmpty(originalAndSelectedUserEmails)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
												_Utils_Tuple2(orgIds, originalAndSelectedUserEmails));
										case 7:
											var _v111 = _v105.a;
											var maybeOrgId = _v111.a;
											var originalAndSelectedUserEmails = _Utils_ap(
												data.W,
												A2(
													$elm$core$List$map,
													function (fullUserEmail) {
														return {j: fullUserEmail.j, b: fullUserEmail.b};
													},
													newUserAutocompleteModel.u));
											return ($elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOrgId) && $elm$core$List$isEmpty(originalAndSelectedUserEmails)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
												_Utils_Tuple2(maybeOrgId, originalAndSelectedUserEmails));
										default:
											return $author$project$Data$Platform2$LinkShared;
									}
								}();
								return _Utils_update(
									model,
									{
										c: $author$project$Dashboards2$Modal$ShareDashboardModal(
											$author$project$Dashboards2$Modal$ShareDashboardModalReady(
												_Utils_update(
													data,
													{d: newSharedWith, cb: newUserAutocompleteModel})))
									});
							},
							A3(
								$author$project$Platform2$AutocompleteInput$update,
								{
									kd: function (term) {
										var removeExistingUsersFromSuggestions = A2(
											$elm$core$Basics$composeR,
											function () {
												var _v100 = data.d;
												switch (_v100.$) {
													case 1:
														var _v101 = _v100.a;
														var userEmails = _v101.b;
														return $elm$core$List$filter(
															function (fetchedUser) {
																return !A2(
																	$elm$core$List$member,
																	{j: fetchedUser.j, b: fetchedUser.b},
																	userEmails);
															});
													case 2:
														var _v102 = _v100.a;
														var userEmails = _v102.b;
														return $elm$core$List$filter(
															function (fetchedUser) {
																return !A2(
																	$elm$core$List$member,
																	{j: fetchedUser.j, b: fetchedUser.b},
																	userEmails);
															});
													default:
														return $elm$core$Basics$identity;
												}
											}(),
											$elm$core$List$filter(
												function (_v103) {
													var email = _v103.j;
													return !_Utils_eq(email, flags.mQ.j);
												}));
										return ($elm$core$String$length(term) >= 3) ? A2(
											$author$project$Gwi$Http$cmdMap,
											removeExistingUsersFromSuggestions,
											A2($author$project$Data$Platform2$fetchFullUserEmails, term, flags)) : $elm$core$Platform$Cmd$none;
									},
									mA: function ($) {
										return $.j;
									},
									mV: function (_v104) {
										return $elm$core$Platform$Cmd$none;
									}
								},
								subMsg,
								data.cb)));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 89:
				var unpackResult = A2(
					$elm_community$result_extra$Result$Extra$unpack,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Gwi$Http$fromHttpError,
						config.bQ($elm$core$Basics$identity)),
					$elm$core$Basics$identity);
				var _v112 = A2(
					$elm$core$Maybe$andThen,
					$author$project$Store$Utils$get(store.v),
					$author$project$Dashboards2$Router$getDashboardId(route));
				if (!_v112.$) {
					var dashboard = _v112.a;
					var _v113 = dashboard.ah;
					switch (_v113.$) {
						case 1:
							var _v114 = _v113.a;
							var orgIds = _v114.a;
							var userEmails = _v114.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: $author$project$Dashboards2$Modal$ShareDashboardModal($author$project$Dashboards2$Modal$ShareDashboardModalLoading)
									}),
								A2(
									$elm$core$Task$attempt,
									unpackResult,
									A2(
										$elm$core$Task$map,
										function (organisations) {
											return config.a(
												$author$project$Dashboards2$OpenShareModal(
													{aa: organisations, W: userEmails}));
										},
										A2($author$project$Data$Platform2$getOrganisationsTask, orgIds, flags))));
						case 2:
							var _v115 = _v113.a;
							var maybeOrgId = _v115.a;
							var userEmails = _v115.b;
							var maybeOrgIdFromSharedAndCurrent = _Utils_eq(
								maybeOrgId,
								A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m)) ? maybeOrgId : $elm$core$Maybe$Nothing;
							var userOrgSingleton = A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A3(
									$elm$core$Maybe$map2,
									F2(
										function (orgId, orgName) {
											return _List_fromArray(
												[
													{b: orgId, ld: orgName}
												]);
										}),
									maybeOrgIdFromSharedAndCurrent,
									flags.mQ.bL));
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								config.a(
									$author$project$Dashboards2$OpenShareModal(
										{aa: userOrgSingleton, W: userEmails})),
								model);
						case 0:
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								config.a(
									$author$project$Dashboards2$OpenShareModal(
										{aa: _List_Nil, W: _List_Nil})),
								model);
						case 3:
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								config.a(
									$author$project$Dashboards2$OpenShareModal(
										{aa: _List_Nil, W: _List_Nil})),
								model);
						case 8:
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								config.a(
									$author$project$Dashboards2$OpenShareModal(
										{aa: _List_Nil, W: _List_Nil})),
								model);
						case 4:
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								config.a(
									$author$project$Dashboards2$OpenShareModal(
										{aa: _List_Nil, W: _List_Nil})),
								model);
						case 6:
							var _v116 = _v113.a;
							var orgIds = _v116.a;
							var userEmails = _v116.b;
							return _Utils_Tuple2(
								_Utils_update(
									model,
									{
										c: $author$project$Dashboards2$Modal$ShareDashboardModal($author$project$Dashboards2$Modal$ShareDashboardModalLoading)
									}),
								A2(
									$elm$core$Task$attempt,
									unpackResult,
									A2(
										$elm$core$Task$map,
										function (organisations) {
											return config.a(
												$author$project$Dashboards2$OpenShareModal(
													{aa: organisations, W: userEmails}));
										},
										A2($author$project$Data$Platform2$getOrganisationsTask, orgIds, flags))));
						case 7:
							var _v117 = _v113.a;
							var maybeOrgId = _v117.a;
							var userEmails = _v117.b;
							var maybeOrgIdFromSharedAndCurrent = _Utils_eq(
								maybeOrgId,
								A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m)) ? maybeOrgId : $elm$core$Maybe$Nothing;
							var userOrgSingleton = A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A3(
									$elm$core$Maybe$map2,
									F2(
										function (orgId, orgName) {
											return _List_fromArray(
												[
													{b: orgId, ld: orgName}
												]);
										}),
									maybeOrgIdFromSharedAndCurrent,
									flags.mQ.bL));
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								config.a(
									$author$project$Dashboards2$OpenShareModal(
										{aa: userOrgSingleton, W: userEmails})),
								model);
						default:
							return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
					}
				} else {
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						config.a(
							A2(
								$author$project$Dashboards2$CreateNotification,
								$author$project$Icons$Platform2$warningTriangleIcon,
								$elm$html$Html$text('Dashboard was not loaded, please refresh your browser and try again.'))),
						model);
				}
			case 88:
				var originalOrgs = msg.a.aa;
				var originalUsers = msg.a.W;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
					$author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$IntentionToShare(
							{
								h2: A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									false,
									$elm$core$Basics$eq(flags.mQ.b),
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.dG;
										},
										A2(
											$elm$core$Maybe$andThen,
											$author$project$Store$Utils$get(store.v),
											$author$project$Dashboards2$Router$getDashboardId(route)))),
								mQ: flags.mQ
							})),
					$author$project$Dashboards2$closeDropdown(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$ShareDashboardModal(
									$author$project$Dashboards2$Modal$ShareDashboardModalReady(
										{
											ac: A2(
												$elm$core$Maybe$withDefault,
												_Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing),
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.ac;
													},
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Store$Utils$get(store.v),
														$author$project$Dashboards2$Router$getDashboardId(route)))),
											kQ: A2(
												$elm$core$Maybe$withDefault,
												false,
												A2(
													$elm$core$Maybe$andThen,
													function (dashboard) {
														var _v118 = dashboard.ah;
														switch (_v118.$) {
															case 2:
																var _v119 = _v118.a;
																var maybeOrgId = _v119.a;
																var _v120 = _Utils_Tuple2(
																	maybeOrgId,
																	A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m));
																if (_v120.a.$ === 1) {
																	var _v121 = _v120.a;
																	return $elm$core$Maybe$Just(false);
																} else {
																	var maybePreviousOrgId = _v120.a;
																	var maybeCurrentOrgId = _v120.b;
																	return $elm$core$Maybe$Just(
																		!_Utils_eq(maybePreviousOrgId, maybeCurrentOrgId));
																}
															case 1:
																return $elm$core$Maybe$Just(false);
															case 0:
																return $elm$core$Maybe$Just(false);
															case 3:
																return $elm$core$Maybe$Just(false);
															case 4:
																return $elm$core$Maybe$Just(false);
															case 5:
																return $elm$core$Maybe$Just(false);
															case 7:
																var _v122 = _v118.a;
																var maybeOrgId = _v122.a;
																var _v123 = _Utils_Tuple2(
																	maybeOrgId,
																	A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m));
																if (_v123.a.$ === 1) {
																	var _v124 = _v123.a;
																	return $elm$core$Maybe$Just(false);
																} else {
																	var maybePreviousOrgId = _v123.a;
																	var maybeCurrentOrgId = _v123.b;
																	return $elm$core$Maybe$Just(
																		!_Utils_eq(maybePreviousOrgId, maybeCurrentOrgId));
																}
															case 6:
																return $elm$core$Maybe$Just(false);
															default:
																return $elm$core$Maybe$Just(false);
														}
													},
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Store$Utils$get(store.v),
														$author$project$Dashboards2$Router$getDashboardId(route)))),
											f9: false,
											d: A2(
												$elm$core$Maybe$withDefault,
												$author$project$Data$Platform2$PrivateDashboard,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.ah;
													},
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Store$Utils$get(store.v),
														$author$project$Dashboards2$Router$getDashboardId(route)))),
											F: $author$project$Platform2$AutocompleteInput$init(
												{jX: 0.5, u: _List_Nil}),
											aa: originalOrgs,
											bq: A2(
												$elm$core$Maybe$withDefault,
												$author$project$Data$Platform2$PrivateDashboard,
												A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.ah;
													},
													A2(
														$elm$core$Maybe$andThen,
														$author$project$Store$Utils$get(store.v),
														$author$project$Dashboards2$Router$getDashboardId(route)))),
											W: originalUsers,
											cb: $author$project$Platform2$AutocompleteInput$init(
												{jX: 0.5, u: _List_Nil})
										}))
							})));
			case 90:
				var dndMsg = msg.a;
				return A2(
					$author$project$Dashboards2$mapEditGridState,
					function (r) {
						var dndModel = r.fJ;
						var tickTime = $author$project$DragAndDrop$Move$getTickTime(dndMsg);
						var previousOverItem = A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.j3;
							},
							config.V.dl.fX(dndModel.k_));
						var positionCheck = F2(
							function (item, position) {
								return {
									kK: _Utils_cmp(
										A2($elm$core$Maybe$withDefault, item.lB, position),
										item.lB) > 0,
									kL: _Utils_cmp(
										A2($elm$core$Maybe$withDefault, item.lB, position),
										item.lB) < 0
								};
							});
						var overDropItemFromMsg = $author$project$DragAndDrop$Move$getOverDropItem(dndMsg);
						var newPosition = F3(
							function (dragItem, item, lastDnDTickTime) {
								var position = A2(
									positionCheck,
									item,
									A2(
										$elm$core$Maybe$map,
										function ($) {
											return $.lB;
										},
										r.b1));
								var computedNewPosition = (((_Utils_cmp(dragItem.lB, item.lB) < 0) || position.kL) && (!position.kK)) ? (item.lB + 0.1) : (item.lB - 0.1);
								return {lB: computedNewPosition, mw: lastDnDTickTime};
							});
						var _v125 = A2(config.V.dl.mO, dndMsg, dndModel);
						var dndReturn = _v125.a;
						var newDndModel = _v125.b;
						var dndCmd = _v125.c;
						var dndInfo = config.V.dl.fX(newDndModel.k_);
						var newDraggedPossition = function () {
							if ($elm_community$maybe_extra$Maybe$Extra$isJust(overDropItemFromMsg) && (!_Utils_eq(previousOverItem, overDropItemFromMsg))) {
								var changeDebounceTimeMs = 100;
								var lastChangeDiff = A2(
									$elm$core$Maybe$withDefault,
									changeDebounceTimeMs + 1,
									A3(
										$elm$core$Maybe$map2,
										F2(
											function (lastDnDTickTime, _v128) {
												var timeOfChange = _v128.mw;
												return lastDnDTickTime - timeOfChange;
											}),
										r.eD,
										r.b1));
								return (_Utils_cmp(lastChangeDiff, changeDebounceTimeMs) < 0) ? r.b1 : A2(
									$elm_community$maybe_extra$Maybe$Extra$orElse,
									r.b1,
									A3(
										$elm$core$Maybe$map2,
										function (_v127) {
											var dragItem = _v127.op;
											var dropListId = _v127.j3;
											return A2(newPosition, dragItem, dropListId);
										},
										dndInfo,
										r.eD));
							} else {
								return r.b1;
							}
						}();
						var _default = _Utils_Tuple2(
							_Utils_update(
								r,
								{
									fJ: newDndModel,
									eD: $elm_community$maybe_extra$Maybe$Extra$isJust(tickTime) ? tickTime : r.eD,
									b1: newDraggedPossition
								}),
							dndCmd);
						var _v126 = _Utils_Tuple2(dndReturn, newDraggedPossition);
						if ((!_v126.a.$) && (!_v126.b.$)) {
							var dragListId = _v126.a.a.oq;
							var position = _v126.b.a.lB;
							return A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
								$author$project$Dashboards2$Analytics$trackEvent(
									$author$project$Dashboards2$Analytics$WidgetMoved(
										{bO: dragListId})),
								A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
									config.a(
										A2($author$project$Dashboards2$SetWidgetPosition, dragListId, position)),
									_default));
						} else {
							return _default;
						}
					},
					model);
			case 92:
				var reorderMsg = msg.a;
				var _v129 = $author$project$Dashboards2$getUserFilters(model);
				if (_v129.$ === 1) {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				} else {
					var userFilters = _v129.a;
					var audienceSoFar = $author$project$Dashboards2$UserFilters$audienceIds(userFilters);
					var _v130 = A3($author$project$Dashboards2$audiencesReorderSystem.mO, reorderMsg, audienceSoFar, model.d8);
					var audiences = _v130.a;
					var reorderModel = _v130.b;
					var reorderCmds = _v130.c;
					var newUserFilters = A2($author$project$Dashboards2$UserFilters$setAudiencesOrder, audiences, userFilters);
					return _Utils_Tuple2(
						A2(
							$author$project$Dashboards2$setUserFilters,
							$author$project$Dashboards2$Editable$set(newUserFilters),
							_Utils_update(
								model,
								{d8: reorderModel})),
						A2($elm$core$Platform$Cmd$map, config.a, reorderCmds));
				}
			case 91:
				var audienceIds = msg.a;
				var index = msg.b;
				var isEditing = !_Utils_eq(model.o, $author$project$Dashboards2$Detail$NotEditing);
				var isEditedUserFilters = $author$project$Dashboards2$Editable$isEdited(
					$author$project$Dashboards2$Detail$currentEditableUserFilters(model));
				var saveIfEditing = (isEditing && isEditedUserFilters) ? A2(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					A5($author$project$Dashboards2$saveDashboard, flags, config, route, $elm$core$Maybe$Nothing, store)) : $elm$core$Basics$identity;
				var analyticsCmd = A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Platform$Cmd$none,
					A2(
						$elm$core$Maybe$andThen,
						function (savedDashboard) {
							var maybeUserFilters = $author$project$Dashboards2$getUserFilters(model);
							var getAudience = $author$project$Store$Utils$get(store.d9);
							var dashboardFullyLoaded = A3($author$project$Dashboards2$Detail$applyEdits, model.ba, maybeUserFilters, savedDashboard);
							return A2(
								$elm$core$Maybe$map,
								function (audience) {
									return $author$project$Dashboards2$Analytics$trackEvent(
										$author$project$Dashboards2$Analytics$AudienceRearanged(
											{fk: audience, nM: flags.nM, ep: dashboardFullyLoaded}));
								},
								A2(
									$elm$core$Maybe$andThen,
									getAudience,
									A2($elm_community$list_extra$List$Extra$getAt, index, audienceIds)));
						},
						A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model)));
				return saveIfEditing(
					A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
						analyticsCmd,
						A2(
							$elm$core$Maybe$withDefault,
							model,
							A2(
								$elm$core$Maybe$map,
								function (userFilters) {
									return A5(
										$author$project$Dashboards2$updateWidgetsPure,
										flags,
										$author$project$Dashboards2$Widget$updateWidgetsChartDataWithFilters(userFilters),
										store,
										route,
										model);
								},
								$author$project$Dashboards2$getUserFilters(model)))));
			case 93:
				var editSectionMsg = msg.a;
				var _v131 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v131.$) {
					return A2(
						$elm$core$Tuple$mapFirst,
						function (editSection) {
							return _Utils_update(
								model,
								{o: editSection});
						},
						A2($author$project$Dashboards2$updateEditSection, editSectionMsg, model.o));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 94:
				var widgetId = msg.a;
				var whatChange = msg.b;
				var _v132 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v132.$) {
					var savedDashboard = _v132.a;
					var data = savedDashboard.cl;
					var clampDimensions = function (getAllowedDimensions) {
						var _v136 = getAllowedDimensions($author$project$Dashboards2$allowedWidgetDimensionRanges);
						var min = _v136.gg;
						var max = _v136.gc;
						return A2($elm$core$Basics$clamp, min, max);
					};
					var updateWidgetDimension = function (w) {
						if (_Utils_eq(w.b, widgetId)) {
							switch (whatChange) {
								case 0:
									return _Utils_update(
										w,
										{
											da: A2(
												clampDimensions,
												function ($) {
													return $.da;
												},
												w.da + 1)
										});
								case 1:
									return _Utils_update(
										w,
										{
											da: A2(
												clampDimensions,
												function ($) {
													return $.da;
												},
												w.da - 1)
										});
								case 2:
									return _Utils_update(
										w,
										{
											cv: A2(
												clampDimensions,
												function ($) {
													return $.cv;
												},
												w.cv + 1)
										});
								default:
									return _Utils_update(
										w,
										{
											cv: A2(
												clampDimensions,
												function ($) {
													return $.cv;
												},
												w.cv - 1)
										});
							}
						} else {
							return w;
						}
					};
					var newDashboard = _Utils_update(
						savedDashboard,
						{
							cl: _Utils_update(
								data,
								{
									g: A2($elm$core$List$map, updateWidgetDimension, data.g)
								})
						});
					return A3(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A4(
							$author$project$Dashboards2$updateWidgetsWith,
							F3(
								function (_v133, _v134, widget) {
									return _Utils_eq(widget.b, widgetId) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$with(
										A2(
											$author$project$Dashboards2$Widget$widgetResized,
											A2(
												$elm$core$Basics$composeL,
												config.a,
												$author$project$Dashboards2$WidgetMsg(widget.b)),
											widget)) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
								}),
							flags,
							store,
							route),
						A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
							config.cT(newDashboard),
							model));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 95:
				var text = msg.a;
				var _v137 = model.c;
				if (_v137.$ === 15) {
					return A4($author$project$Dashboards2$updateInsightLink, config, text, store, model);
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 96:
				var _v138 = model.c;
				if (_v138.$ === 15) {
					var data = _v138.a;
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$LinkInsightModal(
									_Utils_update(
										data,
										{ak: data.eC, aP: $author$project$Dashboards2$Modal$EmptyLink}))
							}));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 97:
				var insight = msg.a;
				var _v139 = _Utils_Tuple2(
					flags.nM(23),
					A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
				if (_v139.a && (!_v139.b.$)) {
					var savedDashboard = _v139.b.a;
					var data = savedDashboard.cl;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						A2(
							config.ag,
							_Utils_update(
								savedDashboard,
								{
									cl: _Utils_update(
										data,
										{aP: insight})
								}),
							4),
						$author$project$Dashboards2$closeModal(model));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 98:
				var description = msg.a;
				var _v140 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v140.$) {
					var savedDashboard = _v140.a;
					var data = savedDashboard.cl;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						A2(
							config.ag,
							_Utils_update(
								savedDashboard,
								{
									cl: _Utils_update(
										data,
										{hB: description})
								}),
							4),
						$author$project$Dashboards2$closeModal(model));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 99:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{o: $author$project$Dashboards2$Detail$NotEditing}));
			case 100:
				var sharedWith = msg.a;
				return A2(
					$author$project$Dashboards2$updateShareModal,
					function (data) {
						var newAutocompleteModel = function () {
							var orgAutocompleteModel = data.F;
							return _Utils_update(
								orgAutocompleteModel,
								{
									u: function () {
										var userOrganisationId = A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$Data$Id$fromString(''),
											$author$project$Data$Id$fromString,
											flags.mQ.m);
										var userOrganisationIsPresent = A2(
											$elm$core$List$member,
											userOrganisationId,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.b;
												},
												orgAutocompleteModel.u));
										return userOrganisationIsPresent ? A2(
											$elm$core$List$filter,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.b;
												},
												$elm$core$Basics$neq(userOrganisationId)),
											orgAutocompleteModel.u) : _Utils_ap(
											orgAutocompleteModel.u,
											_List_fromArray(
												[
													A2(
													$author$project$Data$Platform2$Organisation,
													userOrganisationId,
													A2($elm$core$Maybe$withDefault, '', flags.mQ.bL))
												]));
									}()
								});
						}();
						return _Utils_update(
							data,
							{d: sharedWith, F: newAutocompleteModel});
					},
					model);
			case 101:
				var _v141 = model.c;
				if ((_v141.$ === 16) && (_v141.a.$ === 1)) {
					var modalData = _v141.a.a;
					var newSharedWith = function () {
						var _v142 = modalData.d;
						switch (_v142.$) {
							case 0:
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$Data$Platform2$PrivateDashboard,
									function (orgId) {
										return $author$project$Data$Platform2$NonGwiShared(
											_Utils_Tuple2(
												$elm$core$Maybe$Just(
													$author$project$Data$Id$fromString(orgId)),
												_List_Nil));
									},
									flags.mQ.m);
							case 3:
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$Data$Platform2$PrivateDashboard,
									function (orgId) {
										return $author$project$Data$Platform2$NonGwiShared(
											_Utils_Tuple2(
												$elm$core$Maybe$Just(
													$author$project$Data$Id$fromString(orgId)),
												_List_Nil));
									},
									flags.mQ.m);
							case 1:
								var sharingTuple = _v142.a;
								return $author$project$Data$Platform2$GwiShared(sharingTuple);
							case 2:
								var _v143 = _v142.a;
								var maybeOrgId = _v143.a;
								var userEmails = _v143.b;
								var newMaybeOrgId = function () {
									if (!maybeOrgId.$) {
										return $elm$core$Maybe$Nothing;
									} else {
										return A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m);
									}
								}();
								return ($elm_community$maybe_extra$Maybe$Extra$isNothing(newMaybeOrgId) && $elm$core$List$isEmpty(userEmails)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$NonGwiShared(
									_Utils_Tuple2(newMaybeOrgId, userEmails));
							case 4:
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$Data$Platform2$PublicLinkShared,
									function (orgId) {
										return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
											_Utils_Tuple2(
												$elm$core$Maybe$Just(
													$author$project$Data$Id$fromString(orgId)),
												_List_Nil));
									},
									flags.mQ.m);
							case 5:
								return $author$project$Data$Platform2$LinkShared;
							case 6:
								var sharingTuple = _v142.a;
								return $author$project$Data$Platform2$PublicLinkAndGwiShared(sharingTuple);
							case 7:
								var _v145 = _v142.a;
								var maybeOrgId = _v145.a;
								var userEmails = _v145.b;
								var newMaybeOrgId = function () {
									if (!maybeOrgId.$) {
										return $elm$core$Maybe$Nothing;
									} else {
										return A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, flags.mQ.m);
									}
								}();
								return ($elm_community$maybe_extra$Maybe$Extra$isNothing(newMaybeOrgId) && $elm$core$List$isEmpty(userEmails)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
									_Utils_Tuple2(newMaybeOrgId, userEmails));
							default:
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$author$project$Data$Platform2$PublicLinkShared,
									function (orgId) {
										return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
											_Utils_Tuple2(
												$elm$core$Maybe$Just(
													$author$project$Data$Id$fromString(orgId)),
												_List_Nil));
									},
									flags.mQ.m);
						}
					}();
					var newModalData = $author$project$Dashboards2$Modal$ShareDashboardModal(
						$author$project$Dashboards2$Modal$ShareDashboardModalReady(
							_Utils_update(
								modalData,
								{d: newSharedWith})));
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							model,
							{c: newModalData}));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 102:
				return A2(
					$author$project$Dashboards2$updateShareModal,
					function (data) {
						var originalAndSelectedUserEmails = _Utils_ap(
							data.W,
							A2(
								$elm$core$List$map,
								function (fullUserEmail) {
									return {j: fullUserEmail.j, b: fullUserEmail.b};
								},
								data.cb.u));
						var originalAndSelectedOrgIds = A2(
							$elm$core$List$map,
							function ($) {
								return $.b;
							},
							_Utils_ap(data.aa, data.F.u));
						var newSharedWith = function () {
							var _v147 = data.d;
							switch (_v147.$) {
								case 0:
									return $author$project$Data$Platform2$PublicDashboard;
								case 1:
									return $author$project$Data$Platform2$PublicDashboard;
								case 2:
									return $author$project$Data$Platform2$PublicDashboard;
								case 3:
									return ($elm$core$List$isEmpty(originalAndSelectedOrgIds) && $elm$core$List$isEmpty(originalAndSelectedUserEmails)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
										_Utils_Tuple2(originalAndSelectedOrgIds, originalAndSelectedUserEmails));
								case 4:
									return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
								case 5:
									return $author$project$Data$Platform2$LinkShared;
								case 6:
									return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
								case 7:
									return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
								default:
									return ($elm$core$List$isEmpty(originalAndSelectedOrgIds) && $elm$core$List$isEmpty(originalAndSelectedUserEmails)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
										_Utils_Tuple2(originalAndSelectedOrgIds, originalAndSelectedUserEmails));
							}
						}();
						return _Utils_update(
							data,
							{d: newSharedWith});
					},
					model);
			case 103:
				var richText = msg.a;
				var place = msg.b;
				var _v148 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v148.$) {
					var savedDashboard = _v148.a;
					var data = savedDashboard.cl;
					var newPosition = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						0.0,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.lB;
							},
							$elm$core$Basics$add(0.125)),
						$elm_community$list_extra$List$Extra$last(
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.lB;
								},
								data.g)));
					var newWidget = A3($author$project$Data$Platform2$newRichTextWidget, richText, savedDashboard.b, newPosition);
					return A3(
						$author$project$Dashboards2$scrollToWidget,
						config,
						newWidget,
						A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
							$author$project$Dashboards2$Analytics$trackEvent(
								$author$project$Dashboards2$Analytics$WidgetAddButtonClicked(
									{
										bf: savedDashboard.b,
										bC: savedDashboard.ld,
										a0: flags.nM(23),
										iq: place,
										mL: 'text'
									})),
							A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
								A2(
									config.ag,
									_Utils_update(
										savedDashboard,
										{
											cl: _Utils_update(
												data,
												{
													g: A2($elm$core$List$cons, newWidget, data.g)
												})
										}),
									4),
								_Utils_update(
									model,
									{
										o: A2($author$project$Dashboards2$initEditGrid, config, model.o)
									}))));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 104:
				var charts = msg.a;
				var _v149 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v149.$) {
					var savedDashboard = _v149.a;
					var newDashboard = A3(
						$turboMaCk$non_empty_list_alias$List$NonEmpty$foldl,
						F2(
							function (item, dashboardSoFar) {
								var _v150 = $author$project$Dashboards2$widgetDataFromChart(item);
								if (!_v150.$) {
									var widgetData = _v150.a;
									var namespaceCodesSoFar = A2($author$project$Data$Platform2$dashboardNamespaceCodes, store.es, dashboardSoFar);
									var datasetsToNamespaces_ = A2($krisajenkins$remotedata$RemoteData$withDefault, $Janiczek$elm_bidict$BiDict$Assoc$empty, store.fC);
									var datasetsForNewWidget = $turboMaCk$any_set$Set$Any$toList(
										A3(
											$elm$core$List$foldl,
											$turboMaCk$any_set$Set$Any$union,
											$author$project$Data$Id$emptySet,
											$author$project$Gwi$List$remoteDataValues(
												A2(
													$elm$core$List$map,
													A2($author$project$Data$Platform2$datasetsForNamespace, datasetsToNamespaces_, store.cB),
													A2(
														$elm_community$list_extra$List$Extra$uniqueBy,
														$author$project$Data$Id$unwrap,
														A2(
															$elm$core$List$filter,
															function (nc) {
																return !A2($turboMaCk$any_set$Set$Any$member, nc, namespaceCodesSoFar);
															},
															A2(
																$elm$core$List$map,
																function ($) {
																	return $.id;
																},
																item.d7)))))));
									var chartWidget = {
										aU: $author$project$Data$Platform2$InheritedFromDashboard(
											{fp: item.aU}),
										aI: 3,
										cl: $author$project$Data$Platform2$GroupedData(widgetData),
										dB: 0,
										ld: item.ld,
										b2: '',
										cY: item.nV
									};
									return A3(
										$turboMaCk$glue$Glue$updateModelWith,
										$turboMaCk$glue$Glue$id,
										$author$project$Dashboards2$addNewWidgetToDashboard(chartWidget),
										_Utils_update(
											dashboardSoFar,
											{
												es: A2(
													$elm_community$list_extra$List$Extra$uniqueBy,
													$author$project$Data$Id$unwrap,
													_Utils_ap(dashboardSoFar.es, datasetsForNewWidget))
											}));
								} else {
									return dashboardSoFar;
								}
							}),
						savedDashboard,
						charts);
					var analyticsCmd = $author$project$Dashboards2$Analytics$trackEvent(
						$author$project$Dashboards2$Analytics$ChartWidgetsSaved(
							{
								nT: A2(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
									function ($) {
										return $.ld;
									},
									charts),
								bf: newDashboard.b,
								bC: newDashboard.ld,
								a0: flags.nM(23)
							}));
					return A2(
						$author$project$Dashboards2$checkWidgetVisibility,
						config,
						A4(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$elm$core$Basics$identity,
							$author$project$Dashboards2$scrollToWidget(config),
							$elm$core$List$head(newDashboard.cl.g),
							A2(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
								analyticsCmd,
								A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
									A2(config.ag, newDashboard, 4),
									$author$project$Dashboards2$closeModal(model)))));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 105:
				var updatedWidget = msg.a;
				return A6($author$project$Dashboards2$saveWidget, config, flags, route, store, updatedWidget, model);
			case 106:
				var widget = msg.a;
				var newPosition = msg.b;
				var _v151 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v151.$) {
					var savedDashboard = _v151.a;
					var data = savedDashboard.cl;
					var updateWidgetsPositons = A2(
						$elm$core$Basics$composeR,
						$elm$core$List$map(
							function (w) {
								return _Utils_eq(w.b, widget.b) ? _Utils_update(
									w,
									{lB: newPosition}) : w;
							}),
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$sortBy(
								function ($) {
									return $.lB;
								}),
							$elm$core$List$indexedMap(
								F2(
									function (p, w) {
										return _Utils_update(
											w,
											{lB: p});
									}))));
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
						A2(
							config.ag,
							_Utils_update(
								savedDashboard,
								{
									cl: _Utils_update(
										data,
										{
											g: updateWidgetsPositons(data.g)
										})
								}),
							4),
						A2(
							$author$project$Dashboards2$mapEditGridState,
							function (r) {
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
									_Utils_update(
										r,
										{b1: $elm$core$Maybe$Nothing}));
							},
							model));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 107:
				var closeShareModal = msg.a.bV;
				var sharingMethod = msg.a.dK;
				var _v152 = model.c;
				if ((_v152.$ === 16) && (_v152.a.$ === 1)) {
					var modalData = _v152.a.a;
					if (route.$ === 1) {
						var id = route.a;
						var _v154 = $krisajenkins$remotedata$RemoteData$toMaybe(
							A2($author$project$Store$Platform2$getDashboardFullyLoaded, id, store.v));
						if (_v154.$ === 1) {
							return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
						} else {
							var savedDashboard = _v154.a;
							if ($author$project$Permissions$isDashboardsCreator(flags.nM)) {
								var notificationMsg = function () {
									var _v155 = modalData.d;
									_v155$3:
									while (true) {
										_v155$14:
										while (true) {
											switch (_v155.$) {
												case 3:
													return config.a(
														A2(
															$author$project$Dashboards2$CreateNotification,
															$author$project$Icons$Platform2$globe,
															$elm$html$Html$text('Dashboard is now public')));
												case 0:
													return config.a(
														A2(
															$author$project$Dashboards2$CreateNotification,
															$author$project$Icons$Platform2$eyeCrossed,
															$elm$html$Html$text('Dashboard is now private')));
												case 1:
													if (_v155.a.a.b) {
														if (!_v155.a.b.b) {
															if (!_v155.a.a.b.b) {
																var _v156 = _v155.a;
																var _v157 = _v156.a;
																var orgId = _v157.a;
																if (closeShareModal) {
																	var orgName = function () {
																		var _v158 = A2(
																			$elm$core$List$filter,
																			function (org) {
																				return _Utils_eq(org.b, orgId);
																			},
																			modalData.F.u);
																		if (_v158.b && (!_v158.b.b)) {
																			var singleOrg = _v158.a;
																			return singleOrg.ld;
																		} else {
																			return $author$project$Data$Id$unwrap(orgId);
																		}
																	}();
																	return config.a(
																		A2(
																			$author$project$Dashboards2$CreateNotification,
																			$author$project$Icons$Platform2$sharing,
																			$elm$html$Html$text('Dashboard shared with ' + orgName)));
																} else {
																	return config.a($author$project$Dashboards2$NoOp);
																}
															} else {
																break _v155$3;
															}
														} else {
															var _v163 = _v155.a;
															var orgIds = _v163.a;
															var userEmails = _v163.b;
															return closeShareModal ? config.a(
																A2(
																	$author$project$Dashboards2$CreateNotification,
																	$author$project$Icons$Platform2$sharing,
																	$elm$html$Html$text(
																		'Dashboard shared with ' + ($elm$core$String$fromInt(
																			$elm$core$List$length(orgIds)) + (' organisations, and ' + ($elm$core$String$fromInt(
																			$elm$core$List$length(userEmails)) + ' individuals')))))) : config.a($author$project$Dashboards2$NoOp);
														}
													} else {
														if (!_v155.a.b.b) {
															break _v155$3;
														} else {
															if (!_v155.a.b.b.b) {
																var _v160 = _v155.a;
																var _v161 = _v160.b;
																var userEmail = _v161.a;
																return closeShareModal ? config.a(
																	A2(
																		$author$project$Dashboards2$CreateNotification,
																		$author$project$Icons$Platform2$sharing,
																		$elm$html$Html$text('Dashboard shared with ' + userEmail.j))) : config.a($author$project$Dashboards2$NoOp);
															} else {
																var _v162 = _v155.a;
																var userEmails = _v162.b;
																return closeShareModal ? config.a(
																	A2(
																		$author$project$Dashboards2$CreateNotification,
																		$author$project$Icons$Platform2$sharing,
																		$elm$html$Html$text(
																			'Dashboard shared with ' + ($elm$core$String$fromInt(
																				$elm$core$List$length(userEmails)) + ' individuals')))) : config.a($author$project$Dashboards2$NoOp);
															}
														}
													}
												case 2:
													if (!_v155.a.a.$) {
														if (!_v155.a.b.b) {
															var _v164 = _v155.a;
															var orgId = _v164.a.a;
															if (closeShareModal) {
																var orgName = A2(
																	$elm$core$Maybe$withDefault,
																	$author$project$Data$Id$unwrap(orgId),
																	flags.mQ.bL);
																return config.a(
																	A2(
																		$author$project$Dashboards2$CreateNotification,
																		$author$project$Icons$Platform2$sharing,
																		$elm$html$Html$text('Dashboard shared with everyone at ' + orgName)));
															} else {
																return config.a($author$project$Dashboards2$NoOp);
															}
														} else {
															var _v170 = _v155.a;
															var userEmails = _v170.b;
															return closeShareModal ? config.a(
																A2(
																	$author$project$Dashboards2$CreateNotification,
																	$author$project$Icons$Platform2$sharing,
																	$elm$html$Html$text(
																		'Dashboard shared with everyone at ' + (A2($elm$core$Maybe$withDefault, 'your organisation', flags.mQ.bL) + (', and ' + ($elm$core$String$fromInt(
																			$elm$core$List$length(userEmails)) + ' individuals')))))) : config.a($author$project$Dashboards2$NoOp);
														}
													} else {
														if (_v155.a.b.b && (!_v155.a.b.b.b)) {
															var _v165 = _v155.a;
															var _v166 = _v165.a;
															var _v167 = _v165.b;
															var userEmail = _v167.a;
															return closeShareModal ? config.a(
																A2(
																	$author$project$Dashboards2$CreateNotification,
																	$author$project$Icons$Platform2$sharing,
																	$elm$html$Html$text('Dashboard shared with ' + userEmail.j))) : config.a($author$project$Dashboards2$NoOp);
														} else {
															var _v168 = _v155.a;
															var _v169 = _v168.a;
															var userEmails = _v168.b;
															return closeShareModal ? config.a(
																A2(
																	$author$project$Dashboards2$CreateNotification,
																	$author$project$Icons$Platform2$sharing,
																	$elm$html$Html$text(
																		'Dashboard shared with ' + ($elm$core$String$fromInt(
																			$elm$core$List$length(userEmails)) + ' individuals')))) : config.a($author$project$Dashboards2$NoOp);
														}
													}
												case 4:
													return config.a($author$project$Dashboards2$NoOp);
												case 8:
													return config.a(
														A2(
															$author$project$Dashboards2$CreateNotification,
															$author$project$Icons$Platform2$globe,
															$elm$html$Html$text('Dashboard is now public')));
												case 6:
													if (_v155.a.a.b) {
														if (!_v155.a.b.b) {
															if (!_v155.a.a.b.b) {
																var _v171 = _v155.a;
																var _v172 = _v171.a;
																var orgId = _v172.a;
																if (closeShareModal) {
																	var orgName = function () {
																		var _v173 = A2(
																			$elm$core$List$filter,
																			function (org) {
																				return _Utils_eq(org.b, orgId);
																			},
																			modalData.F.u);
																		if (_v173.b && (!_v173.b.b)) {
																			var singleOrg = _v173.a;
																			return singleOrg.ld;
																		} else {
																			return $author$project$Data$Id$unwrap(orgId);
																		}
																	}();
																	return config.a(
																		A2(
																			$author$project$Dashboards2$CreateNotification,
																			$author$project$Icons$Platform2$sharing,
																			$elm$html$Html$text('Dashboard shared with ' + orgName)));
																} else {
																	return config.a($author$project$Dashboards2$NoOp);
																}
															} else {
																break _v155$14;
															}
														} else {
															var _v178 = _v155.a;
															var orgIds = _v178.a;
															var userEmails = _v178.b;
															return closeShareModal ? config.a(
																A2(
																	$author$project$Dashboards2$CreateNotification,
																	$author$project$Icons$Platform2$sharing,
																	$elm$html$Html$text(
																		'Dashboard shared with ' + ($elm$core$String$fromInt(
																			$elm$core$List$length(orgIds)) + (' organisations, and ' + ($elm$core$String$fromInt(
																			$elm$core$List$length(userEmails)) + ' individuals')))))) : config.a($author$project$Dashboards2$NoOp);
														}
													} else {
														if (!_v155.a.b.b) {
															break _v155$14;
														} else {
															if (!_v155.a.b.b.b) {
																var _v175 = _v155.a;
																var _v176 = _v175.b;
																var userEmail = _v176.a;
																return closeShareModal ? config.a(
																	A2(
																		$author$project$Dashboards2$CreateNotification,
																		$author$project$Icons$Platform2$sharing,
																		$elm$html$Html$text('Dashboard shared with ' + userEmail.j))) : config.a($author$project$Dashboards2$NoOp);
															} else {
																var _v177 = _v155.a;
																var userEmails = _v177.b;
																return closeShareModal ? config.a(
																	A2(
																		$author$project$Dashboards2$CreateNotification,
																		$author$project$Icons$Platform2$sharing,
																		$elm$html$Html$text(
																			'Dashboard shared with ' + ($elm$core$String$fromInt(
																				$elm$core$List$length(userEmails)) + ' individuals')))) : config.a($author$project$Dashboards2$NoOp);
															}
														}
													}
												case 7:
													if (!_v155.a.a.$) {
														if (!_v155.a.b.b) {
															var _v179 = _v155.a;
															var orgId = _v179.a.a;
															if (closeShareModal) {
																var orgName = A2(
																	$elm$core$Maybe$withDefault,
																	$author$project$Data$Id$unwrap(orgId),
																	flags.mQ.bL);
																return config.a(
																	A2(
																		$author$project$Dashboards2$CreateNotification,
																		$author$project$Icons$Platform2$sharing,
																		$elm$html$Html$text('Dashboard shared with everyone at ' + orgName)));
															} else {
																return config.a($author$project$Dashboards2$NoOp);
															}
														} else {
															var _v185 = _v155.a;
															var userEmails = _v185.b;
															return closeShareModal ? config.a(
																A2(
																	$author$project$Dashboards2$CreateNotification,
																	$author$project$Icons$Platform2$sharing,
																	$elm$html$Html$text(
																		'Dashboard shared with everyone at ' + (A2($elm$core$Maybe$withDefault, 'your organisation', flags.mQ.bL) + (', and ' + ($elm$core$String$fromInt(
																			$elm$core$List$length(userEmails)) + ' individuals')))))) : config.a($author$project$Dashboards2$NoOp);
														}
													} else {
														if (_v155.a.b.b && (!_v155.a.b.b.b)) {
															var _v180 = _v155.a;
															var _v181 = _v180.a;
															var _v182 = _v180.b;
															var userEmail = _v182.a;
															return closeShareModal ? config.a(
																A2(
																	$author$project$Dashboards2$CreateNotification,
																	$author$project$Icons$Platform2$sharing,
																	$elm$html$Html$text('Dashboard shared with ' + userEmail.j))) : config.a($author$project$Dashboards2$NoOp);
														} else {
															var _v183 = _v155.a;
															var _v184 = _v183.a;
															var userEmails = _v183.b;
															return closeShareModal ? config.a(
																A2(
																	$author$project$Dashboards2$CreateNotification,
																	$author$project$Icons$Platform2$sharing,
																	$elm$html$Html$text(
																		'Dashboard shared with ' + ($elm$core$String$fromInt(
																			$elm$core$List$length(userEmails)) + ' individuals')))) : config.a($author$project$Dashboards2$NoOp);
														}
													}
												default:
													return config.a($author$project$Dashboards2$NoOp);
											}
										}
										var _v174 = _v155.a;
										var orgIds = _v174.a;
										return closeShareModal ? config.a(
											A2(
												$author$project$Dashboards2$CreateNotification,
												$author$project$Icons$Platform2$sharing,
												$elm$html$Html$text(
													'Dashboard shared with ' + ($elm$core$String$fromInt(
														$elm$core$List$length(orgIds)) + ' organisations')))) : config.a($author$project$Dashboards2$NoOp);
									}
									var _v159 = _v155.a;
									var orgIds = _v159.a;
									return closeShareModal ? config.a(
										A2(
											$author$project$Dashboards2$CreateNotification,
											$author$project$Icons$Platform2$sharing,
											$elm$html$Html$text(
												'Dashboard shared with ' + ($elm$core$String$fromInt(
													$elm$core$List$length(orgIds)) + ' organisations')))) : config.a($author$project$Dashboards2$NoOp);
								}();
								var newDashboard = _Utils_update(
									savedDashboard,
									{ac: modalData.ac, ah: modalData.d});
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
									A7($author$project$Dashboards2$generateDashboardSharedAnalyticsCmd, flags, store, model, modalData.ac, modalData.d, newDashboard, sharingMethod),
									A2(
										$GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger,
										notificationMsg,
										A2(
											$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
											A2(
												config.eU,
												{bV: closeShareModal},
												newDashboard),
											model)));
							} else {
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							}
						}
					} else {
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					}
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 108:
				var bulkOrgIdsInput = msg.a;
				var textInputId = msg.b;
				var _v186 = model.c;
				if ((_v186.$ === 16) && (_v186.a.$ === 1)) {
					var modalData = _v186.a.a;
					var orgAutocompleteModel = modalData.F;
					var unpackResult = A2(
						$elm_community$result_extra$Result$Extra$unpack,
						A2(
							$elm$core$Basics$composeR,
							$author$project$Gwi$Http$fromHttpError,
							config.bQ($elm$core$Basics$identity)),
						$elm$core$Basics$identity);
					var orgIds = $author$project$Dashboards2$parseBulkAddOrganisationIds(bulkOrgIdsInput);
					return $elm$core$List$isEmpty(orgIds) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model) : _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$ShareDashboardModal(
									$author$project$Dashboards2$Modal$ShareDashboardModalReady(
										_Utils_update(
											modalData,
											{
												f9: true,
												F: _Utils_update(
													orgAutocompleteModel,
													{cW: ''})
											})))
							}),
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									unpackResult,
									A2(
										$elm$core$Task$map,
										A2(
											$elm$core$Basics$composeL,
											config.a,
											$author$project$Dashboards2$BulkOrgAddIdsValidated(textInputId)),
										A2($author$project$Data$Platform2$getOrganisationsTask, orgIds, flags))),
									A2($author$project$Dashboards2$focusElement, textInputId, config)
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 109:
				var textInputId = msg.a;
				var parsedOrgs = msg.b;
				var _v187 = model.c;
				if ((_v187.$ === 16) && (_v187.a.$ === 1)) {
					var modalData = _v187.a.a;
					var removeDuplicatesAndExistingOrgs = function () {
						var _v191 = modalData.d;
						switch (_v191.$) {
							case 1:
								var _v192 = _v191.a;
								var orgIds = _v192.a;
								return A2(
									$elm$core$Basics$composeR,
									$elm_community$list_extra$List$Extra$unique,
									$elm$core$List$filter(
										function (org) {
											return A2($elm_community$list_extra$List$Extra$notMember, org.b, orgIds);
										}));
							case 2:
								return $elm$core$Basics$identity;
							case 0:
								return $elm$core$Basics$identity;
							case 3:
								return $elm$core$Basics$identity;
							case 4:
								return $elm$core$Basics$identity;
							case 6:
								var _v193 = _v191.a;
								var orgIds = _v193.a;
								return A2(
									$elm$core$Basics$composeR,
									$elm_community$list_extra$List$Extra$unique,
									$elm$core$List$filter(
										function (org) {
											return A2($elm_community$list_extra$List$Extra$notMember, org.b, orgIds);
										}));
							case 7:
								return $elm$core$Basics$identity;
							case 8:
								return $elm$core$Basics$identity;
							default:
								return $elm$core$Basics$identity;
						}
					}();
					var orgsToAdd = removeDuplicatesAndExistingOrgs(parsedOrgs);
					var newSharedWith = function () {
						var _v188 = modalData.d;
						switch (_v188.$) {
							case 0:
								return $author$project$Data$Platform2$GwiShared(
									_Utils_Tuple2(
										A2(
											$elm$core$List$map,
											function ($) {
												return $.b;
											},
											orgsToAdd),
										_List_Nil));
							case 3:
								return $author$project$Data$Platform2$GwiShared(
									_Utils_Tuple2(
										A2(
											$elm$core$List$map,
											function ($) {
												return $.b;
											},
											orgsToAdd),
										_List_Nil));
							case 1:
								var _v189 = _v188.a;
								var orgIds = _v189.a;
								var userIds = _v189.b;
								return $author$project$Data$Platform2$GwiShared(
									_Utils_Tuple2(
										_Utils_ap(
											orgIds,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.b;
												},
												orgsToAdd)),
										userIds));
							case 2:
								var sharingTuple = _v188.a;
								return $author$project$Data$Platform2$NonGwiShared(sharingTuple);
							case 4:
								return $author$project$Data$Platform2$PublicLinkAndGwiShared(
									_Utils_Tuple2(
										A2(
											$elm$core$List$map,
											function ($) {
												return $.b;
											},
											orgsToAdd),
										_List_Nil));
							case 5:
								return $author$project$Data$Platform2$LinkShared;
							case 8:
								return $author$project$Data$Platform2$PublicLinkAndGwiShared(
									_Utils_Tuple2(
										A2(
											$elm$core$List$map,
											function ($) {
												return $.b;
											},
											orgsToAdd),
										_List_Nil));
							case 6:
								var _v190 = _v188.a;
								var orgIds = _v190.a;
								var userIds = _v190.b;
								return $author$project$Data$Platform2$PublicLinkAndGwiShared(
									_Utils_Tuple2(
										_Utils_ap(
											orgIds,
											A2(
												$elm$core$List$map,
												function ($) {
													return $.b;
												},
												orgsToAdd)),
										userIds));
							default:
								var sharingTuple = _v188.a;
								return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(sharingTuple);
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$ShareDashboardModal(
									$author$project$Dashboards2$Modal$ShareDashboardModalReady(
										_Utils_update(
											modalData,
											{
												f9: false,
												d: newSharedWith,
												F: A2($author$project$Platform2$AutocompleteInput$addItems, orgsToAdd, modalData.F)
											})))
							}),
						A2($author$project$Dashboards2$focusElement, textInputId, config));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 110:
				var _v194 = model.c;
				if ((_v194.$ === 16) && (_v194.a.$ === 1)) {
					var modalData = _v194.a.a;
					var orgAutocompleteModel = modalData.F;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$ShareDashboardModal(
									$author$project$Dashboards2$Modal$ShareDashboardModalReady(
										_Utils_update(
											modalData,
											{
												d: function () {
													var _v195 = modalData.d;
													switch (_v195.$) {
														case 0:
															return $author$project$Data$Platform2$PrivateDashboard;
														case 3:
															return $author$project$Data$Platform2$PublicDashboard;
														case 2:
															var sharingTuple = _v195.a;
															return $author$project$Data$Platform2$NonGwiShared(sharingTuple);
														case 1:
															var _v196 = _v195.a;
															var orgIds = _v196.a;
															var userIds = _v196.b;
															var previousSelectedOrgIds = A2(
																$elm$core$List$map,
																function ($) {
																	return $.b;
																},
																orgAutocompleteModel.u);
															var orgIdsWithoutPreviousSelected = A2(
																$elm$core$List$filter,
																function (orgId) {
																	return A2($elm_community$list_extra$List$Extra$notMember, orgId, previousSelectedOrgIds);
																},
																orgIds);
															return ($elm$core$List$isEmpty(orgIdsWithoutPreviousSelected) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
																_Utils_Tuple2(orgIdsWithoutPreviousSelected, userIds));
														case 4:
															return $author$project$Data$Platform2$PublicLinkShared;
														case 5:
															return $author$project$Data$Platform2$LinkShared;
														case 8:
															return $author$project$Data$Platform2$PublicDashboard;
														case 7:
															var sharingTuple = _v195.a;
															return $author$project$Data$Platform2$NonGwiShared(sharingTuple);
														default:
															var _v197 = _v195.a;
															var orgIds = _v197.a;
															var userIds = _v197.b;
															var previousSelectedOrgIds = A2(
																$elm$core$List$map,
																function ($) {
																	return $.b;
																},
																orgAutocompleteModel.u);
															var orgIdsWithoutPreviousSelected = A2(
																$elm$core$List$filter,
																function (orgId) {
																	return A2($elm_community$list_extra$List$Extra$notMember, orgId, previousSelectedOrgIds);
																},
																orgIds);
															return ($elm$core$List$isEmpty(orgIdsWithoutPreviousSelected) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
																_Utils_Tuple2(orgIdsWithoutPreviousSelected, userIds));
													}
												}(),
												F: _Utils_update(
													orgAutocompleteModel,
													{cW: '', u: _List_Nil})
											})))
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 111:
				var textInputId = msg.a;
				var _v198 = model.c;
				if ((_v198.$ === 16) && (_v198.a.$ === 1)) {
					var modalData = _v198.a.a;
					var orgAutocompleteModel = modalData.F;
					var newSharedWith = function () {
						var _v199 = modalData.d;
						switch (_v199.$) {
							case 0:
								return $author$project$Data$Platform2$PrivateDashboard;
							case 3:
								return $author$project$Data$Platform2$PublicDashboard;
							case 2:
								var sharingTuple = _v199.a;
								return $author$project$Data$Platform2$NonGwiShared(sharingTuple);
							case 1:
								var _v200 = _v199.a;
								var orgIds = _v200.a;
								var userIds = _v200.b;
								var orgIdsWithLastRemoved = $elm$core$List$reverse(
									A2(
										$elm$core$List$drop,
										1,
										$elm$core$List$reverse(orgIds)));
								return ($elm$core$List$isEmpty(orgIdsWithLastRemoved) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
									_Utils_Tuple2(orgIdsWithLastRemoved, userIds));
							case 4:
								return $author$project$Data$Platform2$PublicLinkShared;
							case 5:
								return $author$project$Data$Platform2$LinkShared;
							case 8:
								return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
							case 7:
								var sharingTuple = _v199.a;
								return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(sharingTuple);
							default:
								var _v201 = _v199.a;
								var orgIds = _v201.a;
								var userIds = _v201.b;
								var orgIdsWithLastRemoved = $elm$core$List$reverse(
									A2(
										$elm$core$List$drop,
										1,
										$elm$core$List$reverse(orgIds)));
								return ($elm$core$List$isEmpty(orgIdsWithLastRemoved) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
									_Utils_Tuple2(orgIdsWithLastRemoved, userIds));
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$ShareDashboardModal(
									$author$project$Dashboards2$Modal$ShareDashboardModalReady(
										_Utils_update(
											modalData,
											{
												d: newSharedWith,
												F: _Utils_update(
													orgAutocompleteModel,
													{
														u: $elm$core$List$reverse(
															A2(
																$elm$core$List$drop,
																1,
																$elm$core$List$reverse(orgAutocompleteModel.u)))
													})
											})))
							}),
						A2($author$project$Dashboards2$focusElement, textInputId, config));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 112:
				var textInputId = msg.a;
				var _v202 = model.c;
				if ((_v202.$ === 16) && (_v202.a.$ === 1)) {
					var modalData = _v202.a.a;
					var userAutocompleteModel = modalData.cb;
					var newSharedWith = function () {
						var _v203 = modalData.d;
						switch (_v203.$) {
							case 0:
								return $author$project$Data$Platform2$PrivateDashboard;
							case 3:
								return $author$project$Data$Platform2$PublicDashboard;
							case 2:
								var _v204 = _v203.a;
								var maybeOrgId = _v204.a;
								var userIds = _v204.b;
								var userIdsWithLastRemoved = $elm$core$List$reverse(
									A2(
										$elm$core$List$drop,
										1,
										$elm$core$List$reverse(userIds)));
								return ($elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOrgId) && $elm$core$List$isEmpty(userIdsWithLastRemoved)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$NonGwiShared(
									_Utils_Tuple2(maybeOrgId, userIdsWithLastRemoved));
							case 1:
								var _v205 = _v203.a;
								var orgIds = _v205.a;
								var userIds = _v205.b;
								var userIdsWithLastRemoved = $elm$core$List$reverse(
									A2(
										$elm$core$List$drop,
										1,
										$elm$core$List$reverse(userIds)));
								return ($elm$core$List$isEmpty(orgIds) && $elm$core$List$isEmpty(userIdsWithLastRemoved)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
									_Utils_Tuple2(orgIds, userIdsWithLastRemoved));
							case 4:
								return $author$project$Data$Platform2$PublicLinkShared;
							case 5:
								return $author$project$Data$Platform2$LinkShared;
							case 8:
								return $author$project$Data$Platform2$PublicLinkAndPublicDashboard;
							case 7:
								var _v206 = _v203.a;
								var maybeOrgId = _v206.a;
								var userIds = _v206.b;
								var userIdsWithLastRemoved = $elm$core$List$reverse(
									A2(
										$elm$core$List$drop,
										1,
										$elm$core$List$reverse(userIds)));
								return ($elm_community$maybe_extra$Maybe$Extra$isNothing(maybeOrgId) && $elm$core$List$isEmpty(userIdsWithLastRemoved)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
									_Utils_Tuple2(maybeOrgId, userIdsWithLastRemoved));
							default:
								var _v207 = _v203.a;
								var orgIds = _v207.a;
								var userIds = _v207.b;
								var userIdsWithLastRemoved = $elm$core$List$reverse(
									A2(
										$elm$core$List$drop,
										1,
										$elm$core$List$reverse(userIds)));
								return ($elm$core$List$isEmpty(orgIds) && $elm$core$List$isEmpty(userIdsWithLastRemoved)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
									_Utils_Tuple2(orgIds, userIdsWithLastRemoved));
						}
					}();
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c: $author$project$Dashboards2$Modal$ShareDashboardModal(
									$author$project$Dashboards2$Modal$ShareDashboardModalReady(
										_Utils_update(
											modalData,
											{
												d: newSharedWith,
												cb: _Utils_update(
													userAutocompleteModel,
													{
														u: $elm$core$List$reverse(
															A2(
																$elm$core$List$drop,
																1,
																$elm$core$List$reverse(userAutocompleteModel.u)))
													})
											})))
							}),
						A2($author$project$Dashboards2$focusElement, textInputId, config));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 113:
				return A7($author$project$Dashboards2$undoRedoAction, config, flags, route, store, $author$project$UndoRedo$undo, $author$project$Dashboards2$Analytics$UndoApplied, model);
			case 114:
				return A7($author$project$Dashboards2$undoRedoAction, config, flags, route, store, $author$project$UndoRedo$redo, $author$project$Dashboards2$Analytics$RedoApplied, model);
			case 115:
				return _Utils_Tuple2(
					$author$project$Dashboards2$closeDropdown(model),
					A2(
						$elm$core$Task$attempt,
						A2(
							$elm$core$Basics$composeR,
							$elm$core$Result$map(
								function (_v208) {
									var element = _v208.a.j4;
									var scrollContainer = _v208.b;
									return $author$project$Dashboards2$SetStickyHeaderVisibility(
										_Utils_cmp(element.m4, scrollContainer.j4.m4) < 1);
								}),
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Result$withDefault($author$project$Dashboards2$NoOp),
								config.a)),
						A3(
							$elm$core$Task$map2,
							$elm$core$Tuple$pair,
							$elm$browser$Browser$Dom$getElement($author$project$Dashboards2$Detail$stickyHeaderElementId),
							$elm$browser$Browser$Dom$getElement($author$project$Dashboards2$Detail$detailScrollContainerId))));
			case 116:
				var showStickyHeader = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{dN: showStickyHeader}));
			case 117:
				var time = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							dk: $elm$core$Maybe$Just(time)
						}),
					$elm$core$Platform$Cmd$none);
			case 118:
				var _v209 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
				if (!_v209.$) {
					var dashboard = _v209.a;
					var cmds = $elm$core$Platform$Cmd$batch(
						A2(
							$elm$core$List$filterMap,
							function (widget) {
								var _v210 = widget.U;
								if (!_v210.$) {
									return $elm$core$Maybe$Just(
										A2(
											$elm$core$Task$attempt,
											A2(
												$elm$core$Basics$composeR,
												$elm$core$Result$map(
													A2(
														$elm$core$Basics$composeR,
														$author$project$Dashboards2$CheckWidgetVisibility(widget.b),
														config.a)),
												$elm$core$Result$withDefault(
													config.a($author$project$Dashboards2$NoOp))),
											$author$project$Gwi$Browser$Dom$isElementVisible(
												{
													j5: $author$project$Dashboards2$Widget$containerElementId(widget),
													lm: $author$project$Dashboards2$widgetsVisibilityFenceOffset,
													lV: $author$project$Dashboards2$Detail$detailScrollContainerId
												})));
								} else {
									return $elm$core$Maybe$Nothing;
								}
							},
							dashboard.cl.g));
					return _Utils_Tuple2(model, cmds);
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 120:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{a2: $elm$core$Maybe$Nothing}));
			case 119:
				var id = msg.a;
				var isVisible = msg.b;
				var _v211 = A2(
					$elm$core$Maybe$map,
					$author$project$Dashboards2$Widget$isWidgetVisible,
					A2($author$project$Dashboards2$getWidgetModel, id, model));
				if (!_v211.$) {
					var oldVisibleState = _v211.a;
					return (oldVisibleState && isVisible) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model) : A3(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A5(
							$author$project$Dashboards2$requestDataForAllWidgetsIfNotLoaded,
							config,
							flags,
							route,
							store,
							{bi: false}),
						A5(
							$author$project$Dashboards2$updateWidgetsWith,
							F3(
								function (_v212, _v213, widget) {
									return _Utils_eq(widget.b, id) ? A2(
										$elm$core$Basics$composeR,
										$author$project$Dashboards2$Widget$setVisibility(isVisible),
										$GlobalWebIndex$cmd_extra$Cmd$Extra$pure) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
								}),
							flags,
							store,
							route,
							model));
				} else {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
				}
			case 121:
				var cmds = msg.a;
				return A2(
					$elm$core$Maybe$withDefault,
					$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
					A2(
						$elm$core$Maybe$map,
						function (dashboard) {
							return A6(
								$author$project$Dashboards2$processWidgetsRequests,
								config,
								flags,
								store,
								dashboard,
								{bi: false},
								_Utils_Tuple2(
									cmds,
									$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model)));
						},
						A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model)));
			case 122:
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							bP: $elm_community$maybe_extra$Maybe$Extra$isJust(model.bP) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
								A2($author$project$Dashboards2$getAddCategoryViewConfig, store, $elm$core$Maybe$Nothing))
						}));
			case 123:
				var term = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							bP: A2(
								$elm$core$Maybe$map,
								$elm$core$Basics$always(
									A2(
										$author$project$Dashboards2$getAddCategoryViewConfig,
										store,
										$elm$core$String$isEmpty(term) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(term))),
								model.bP)
						}));
			case 124:
				var dashboard = msg.a;
				var insightCategory = msg.b;
				var updatedDashboard = _Utils_update(
					dashboard,
					{
						ac: function () {
							var _v214 = dashboard.ac;
							if (!_v214.a.$) {
								if (!_v214.b.$) {
									var category1 = _v214.a.a;
									var category2 = _v214.b.a;
									return _Utils_eq(category1, insightCategory) ? _Utils_Tuple2(
										$elm$core$Maybe$Nothing,
										$elm$core$Maybe$Just(category2)) : (_Utils_eq(category2, insightCategory) ? _Utils_Tuple2(
										$elm$core$Maybe$Just(category1),
										$elm$core$Maybe$Nothing) : dashboard.ac);
								} else {
									var category1 = _v214.a.a;
									var _v215 = _v214.b;
									return _Utils_eq(category1, insightCategory) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
										$elm$core$Maybe$Just(category1),
										$elm$core$Maybe$Just(insightCategory));
								}
							} else {
								if (!_v214.b.$) {
									var _v216 = _v214.a;
									var category2 = _v214.b.a;
									return _Utils_eq(category2, insightCategory) ? _Utils_Tuple2($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing) : _Utils_Tuple2(
										$elm$core$Maybe$Just(insightCategory),
										$elm$core$Maybe$Just(category2));
								} else {
									var _v217 = _v214.a;
									var _v218 = _v214.b;
									return _Utils_Tuple2(
										$elm$core$Maybe$Just(insightCategory),
										$elm$core$Maybe$Nothing);
								}
							}
						}()
					});
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					A2(config.eR, updatedDashboard, 5),
					model);
			case 65:
				var dropDownMenu = msg.a;
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						model,
						{
							db: $elm$core$Maybe$Just(
								A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									dropDownMenu,
									$author$project$Platform2$Dropdown$DropdownMenu$toggle(dropDownMenu),
									model.db))
						}));
			case 129:
				var link = msg.a;
				var dashboard = msg.b;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					A2(config.dE, link, dashboard),
					model);
			default:
				var actions = msg.a;
				return A2(
					$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
					config.l(actions),
					model);
		}
	});
var $turboMaCk$glue$Glue$Lazy$update = F2(
	function (glue, f) {
		return A2(
			$turboMaCk$glue$Glue$update,
			glue,
			function (a) {
				return $turboMaCk$glue$Glue$Lazy$patch(
					f(a));
			});
	});
var $pzp1997$assoc_list$AssocList$foldl = F3(
	function (func, initialResult, _v0) {
		var alist = _v0;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v1, result) {
					var key = _v1.a;
					var value = _v1.b;
					return A3(func, key, value, result);
				}),
			initialResult,
			alist);
	});
var $pzp1997$assoc_list$AssocList$remove = F2(
	function (targetKey, _v0) {
		var alist = _v0;
		return A2(
			$elm$core$List$filter,
			function (_v1) {
				var key = _v1.a;
				return !_Utils_eq(key, targetKey);
			},
			alist);
	});
var $pzp1997$assoc_list$AssocList$insert = F3(
	function (key, value, dict) {
		var _v0 = A2($pzp1997$assoc_list$AssocList$remove, key, dict);
		var alteredAlist = _v0;
		return A2(
			$elm$core$List$cons,
			_Utils_Tuple2(key, value),
			alteredAlist);
	});
var $erlandsona$assoc_set$AssocSet$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($pzp1997$assoc_list$AssocList$insert, key, 0, dict);
	});
var $pzp1997$assoc_list$AssocList$singleton = F2(
	function (key, value) {
		return _List_fromArray(
			[
				_Utils_Tuple2(key, value)
			]);
	});
var $erlandsona$assoc_set$AssocSet$singleton = function (key) {
	return A2($pzp1997$assoc_list$AssocList$singleton, key, 0);
};
var $pzp1997$assoc_list$AssocList$update = F3(
	function (targetKey, alter, dict) {
		var alist = dict;
		var maybeValue = A2($pzp1997$assoc_list$AssocList$get, targetKey, dict);
		if (!maybeValue.$) {
			var _v1 = alter(maybeValue);
			if (!_v1.$) {
				var alteredValue = _v1.a;
				return A2(
					$elm$core$List$map,
					function (entry) {
						var key = entry.a;
						return _Utils_eq(key, targetKey) ? _Utils_Tuple2(targetKey, alteredValue) : entry;
					},
					alist);
			} else {
				return A2($pzp1997$assoc_list$AssocList$remove, targetKey, dict);
			}
		} else {
			var _v2 = alter($elm$core$Maybe$Nothing);
			if (!_v2.$) {
				var alteredValue = _v2.a;
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(targetKey, alteredValue),
					alist);
			} else {
				return dict;
			}
		}
	});
var $Janiczek$elm_bidict$BiDict$Assoc$fromDict = function (forward) {
	return {
		r: forward,
		aQ: A3(
			$pzp1997$assoc_list$AssocList$foldl,
			F3(
				function (key, value, acc) {
					return A3(
						$pzp1997$assoc_list$AssocList$update,
						value,
						function (maybeKeys) {
							return $elm$core$Maybe$Just(
								function () {
									if (maybeKeys.$ === 1) {
										return $erlandsona$assoc_set$AssocSet$singleton(key);
									} else {
										var keys_ = maybeKeys.a;
										return A2($erlandsona$assoc_set$AssocSet$insert, key, keys_);
									}
								}());
						},
						acc);
				}),
			$pzp1997$assoc_list$AssocList$empty,
			forward)
	};
};
var $pzp1997$assoc_list$AssocList$fromList = function (alist) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, result) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($pzp1997$assoc_list$AssocList$insert, key, value, result);
			}),
		_List_Nil,
		alist);
};
var $Janiczek$elm_bidict$BiDict$Assoc$fromList = function (list) {
	return $Janiczek$elm_bidict$BiDict$Assoc$fromDict(
		$pzp1997$assoc_list$AssocList$fromList(list));
};
var $author$project$Store$Utils$insertResource = F2(
	function (state, model) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			A2($turboMaCk$any_dict$Dict$Any$insert, model.b, model),
			state);
	});
var $author$project$Store$Utils$removeResource = F2(
	function (state, id) {
		return A2(
			$krisajenkins$remotedata$RemoteData$map,
			$turboMaCk$any_dict$Dict$Any$remove(id),
			state);
	});
var $author$project$Store$Platform2$saveDashboard = F2(
	function (dashboard, store) {
		return _Utils_update(
			store,
			{
				v: A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2(
						$turboMaCk$any_dict$Dict$Any$update,
						dashboard.b,
						$elm$core$Maybe$map(
							$elm$core$Basics$always(dashboard))),
					store.v)
			});
	});
var $author$project$Store$Platform2$saveDashboardFullyLoaded = F2(
	function (dashboard, store) {
		return _Utils_update(
			store,
			{
				v: A2(
					$krisajenkins$remotedata$RemoteData$map,
					A2(
						$turboMaCk$any_dict$Dict$Any$update,
						dashboard.b,
						$elm$core$Maybe$map(
							function (_v0) {
								return $author$project$Data$Platform2$fromFullyLoadedDashboard(dashboard);
							})),
					store.v)
			});
	});
var $author$project$Store$Platform2$orderWidgets = function (dashboard) {
	return _Utils_update(
		dashboard,
		{
			cl: A2(
				$krisajenkins$remotedata$RemoteData$map,
				function (data) {
					return _Utils_update(
						data,
						{
							g: A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.lB;
								},
								data.g)
						});
				},
				dashboard.cl)
		});
};
var $author$project$Store$Utils$taggedCollectionLoaded = $author$project$Store$Utils$taggedCollectionLoadedWith(
	function ($) {
		return $.b;
	});
var $author$project$Store$Platform2$setDashboards = F2(
	function (dashboards, store) {
		return _Utils_update(
			store,
			{
				v: $author$project$Store$Utils$taggedCollectionLoaded(
					A2($elm$core$List$map, $author$project$Store$Platform2$orderWidgets, dashboards))
			});
	});
var $author$project$Store$Platform2$setLocationsForDashboardId = F3(
	function (dashboardId, _v0, store) {
		var locations = _v0.cD;
		var displayAll = _v0.oi;
		return _Utils_update(
			store,
			{
				pJ: A3(
					$turboMaCk$any_dict$Dict$Any$insert,
					dashboardId,
					A2(
						$author$project$Store$Utils$taggedCollectionLoadedWith,
						function ($) {
							return $.bW;
						},
						locations),
					store.pJ),
				gB: A3(
					$turboMaCk$any_dict$Dict$Any$insert,
					dashboardId,
					$krisajenkins$remotedata$RemoteData$Success(
						$author$project$Data$Labels$groupToRegion(locations)),
					store.gB),
				rm: A3($turboMaCk$any_dict$Dict$Any$insert, dashboardId, displayAll, store.rm)
			});
	});
var $author$project$Store$Platform2$setWavesForDashboardId = F3(
	function (dashboardId, waves, store) {
		return _Utils_update(
			store,
			{
				sd: A3(
					$turboMaCk$any_dict$Dict$Any$insert,
					dashboardId,
					A2(
						$author$project$Store$Utils$taggedCollectionLoadedWith,
						function ($) {
							return $.bW;
						},
						waves),
					store.sd)
			});
	});
var $author$project$Store$Platform2$update = F3(
	function (config, msg, store) {
		switch (msg.$) {
			case 1:
				if (!msg.a.$) {
					var folders = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							store,
							{
								jE: $author$project$Store$Utils$taggedCollectionLoaded(folders)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var charts = msg.a.a;
					return _Utils_Tuple2(
						_Utils_update(
							store,
							{
								fr: $author$project$Store$Utils$taggedCollectionLoaded(charts)
							}),
						$elm$core$Platform$Cmd$none);
				}
			case 0:
				switch (msg.a.$) {
					case 0:
						var folders = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								store,
								{
									jm: $author$project$Store$Utils$taggedCollectionLoaded(folders)
								}),
							$elm$core$Platform$Cmd$none);
					case 1:
						var audiences = msg.a.a;
						return _Utils_Tuple2(
							_Utils_update(
								store,
								{
									d9: $author$project$Store$Utils$taggedCollectionLoaded(audiences),
									nD: $krisajenkins$remotedata$RemoteData$Success(
										$author$project$Data$Id$dictFromList(
											A2(
												$elm$core$List$map,
												function (a) {
													return _Utils_Tuple2(a.r9, a.b);
												},
												audiences)))
								}),
							$elm$core$Platform$Cmd$none);
					case 4:
						var _v1 = msg.a;
						var dashboardId = _v1.a;
						var audiences = _v1.b;
						var longAudiences = A2(
							$elm$core$List$map,
							function (shortAudience) {
								return {
									bB: $elm$time$Time$millisToPosix(1),
									bY: $author$project$Data$Audience$Expression$AllRespondents,
									oN: A2(
										$turboMaCk$any_set$Set$Any$fromList,
										$elm$core$Basics$always('isP2'),
										_List_fromArray(
											[2])),
									oP: $elm$core$Maybe$Nothing,
									b: shortAudience.b,
									ld: shortAudience.ld,
									lB: 1,
									bN: $elm$time$Time$millisToPosix(2),
									mR: 0,
									r9: shortAudience.b
								};
							},
							audiences);
						return _Utils_Tuple2(
							_Utils_update(
								store,
								{
									d9: $author$project$Store$Utils$taggedCollectionLoaded(longAudiences),
									jq: A3(
										$turboMaCk$any_dict$Dict$Any$insert,
										dashboardId,
										$krisajenkins$remotedata$RemoteData$Success(audiences),
										store.jq),
									nD: $krisajenkins$remotedata$RemoteData$Success(
										$author$project$Data$Id$dictFromList(
											A2(
												$elm$core$List$map,
												function (a) {
													return _Utils_Tuple2(a.b, a.b);
												},
												audiences)))
								}),
							$elm$core$Platform$Cmd$none);
					case 2:
						var _v2 = msg.a;
						var audiences = _v2.b;
						return _Utils_Tuple2(
							_Utils_update(
								store,
								{
									d9: $author$project$Store$Utils$taggedCollectionLoaded(audiences),
									nD: $krisajenkins$remotedata$RemoteData$Success(
										$author$project$Data$Id$dictFromList(
											A2(
												$elm$core$List$map,
												function (a) {
													return _Utils_Tuple2(a.r9, a.b);
												},
												audiences)))
								}),
							$elm$core$Platform$Cmd$none);
					default:
						var _v3 = msg.a;
						var audiences = _v3.a;
						var audience = _v3.b;
						return _Utils_Tuple2(
							_Utils_update(
								store,
								{
									d9: A2($author$project$Store$Utils$insertResource, audiences, audience)
								}),
							$elm$core$Platform$Cmd$none);
				}
			case 2:
				var dashboards = msg.a;
				return _Utils_Tuple2(
					A2($author$project$Store$Platform2$setDashboards, dashboards, store),
					$elm$core$Platform$Cmd$none);
			case 3:
				var dashboard = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2(
								$krisajenkins$remotedata$RemoteData$map,
								A2($turboMaCk$any_dict$Dict$Any$insert, dashboard.b, dashboard),
								store.v)
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var userSettings = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							jU: $krisajenkins$remotedata$RemoteData$Success(userSettings)
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var userSettings = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							jU: $krisajenkins$remotedata$RemoteData$Success(userSettings)
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var dashboardId = msg.a;
				var result = msg.b;
				if (!result.$) {
					return _Utils_Tuple2(store, $elm$core$Platform$Cmd$none);
				} else {
					var err = result.a;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						config.av(err),
						_Utils_update(
							store,
							{
								v: A2(
									$krisajenkins$remotedata$RemoteData$map,
									A2(
										$turboMaCk$any_dict$Dict$Any$update,
										dashboardId,
										$elm$core$Maybe$map(
											function (dashboard) {
												return _Utils_update(
													dashboard,
													{kN: !dashboard.kN});
											})),
									store.v)
							}));
				}
			case 7:
				var old = msg.a.lq;
				var result = msg.b;
				if (!result.$) {
					var _new = result.a;
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						A2($author$project$Store$Platform2$saveDashboardFullyLoaded, _new, store));
				} else {
					var err = result.a;
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
						config.av(err),
						A2($author$project$Store$Platform2$saveDashboard, old, store));
				}
			case 8:
				var namespaceCode = msg.a;
				var splitters = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Store$Platform2$setSplittersForNamespace, namespaceCode, splitters, store),
					$elm$core$Platform$Cmd$none);
			case 9:
				var questionCode = msg.a;
				var question = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							bt: A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								questionCode,
								$krisajenkins$remotedata$RemoteData$Success(question),
								store.bt)
						}),
					$elm$core$Platform$Cmd$none);
			case 10:
				var dashboardId = msg.a;
				var widgetId = msg.b;
				var questions = msg.c;
				var mergeQuestionDatapointsIfPresent = F2(
					function (questionsDict, question) {
						var _v6 = A2($turboMaCk$any_dict$Dict$Any$get, question.k1, questionsDict);
						if ((!_v6.$) && (_v6.a.$ === 3)) {
							var questionAlreadyFetched = _v6.a.a;
							return _Utils_update(
								question,
								{
									er: A2($turboMaCk$non_empty_list_alias$List$NonEmpty$append, question.er, questionAlreadyFetched.er)
								});
						} else {
							return question;
						}
					});
				var questions_ = A3(
					$elm$core$List$foldl,
					F2(
						function (question, dict) {
							var questionToInsert = A2(mergeQuestionDatapointsIfPresent, dict, question);
							return A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								questionToInsert.k1,
								$krisajenkins$remotedata$RemoteData$Success(questionToInsert),
								dict);
						}),
					store.bt,
					questions);
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							bt: questions_,
							cP: A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								$author$project$Data$Id$fromString(
									_Utils_ap(
										$author$project$Data$Id$unwrap(dashboardId),
										$author$project$Data$Id$unwrap(widgetId))),
								$krisajenkins$remotedata$RemoteData$Success(_List_Nil),
								store.cP)
						}),
					$elm$core$Platform$Cmd$none);
			case 11:
				var showErrorModal = msg.b;
				var updateStoreFn = msg.c;
				var err = msg.d;
				return _Utils_Tuple2(
					store,
					$GlobalWebIndex$cmd_extra$Cmd$Extra$perform(
						showErrorModal ? A2(config.ox, updateStoreFn, err) : A2(config.oy, updateStoreFn, err)));
			case 12:
				var categories = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							ac: $author$project$Store$Utils$taggedCollectionLoaded(categories)
						}),
					$elm$core$Platform$Cmd$none);
			case 13:
				var locations = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							g6: $krisajenkins$remotedata$RemoteData$Success(
								$author$project$Data$Labels$groupToRegion(locations)),
							cD: A2(
								$author$project$Store$Utils$taggedCollectionLoadedWith,
								function ($) {
									return $.bW;
								},
								locations)
						}),
					$elm$core$Platform$Cmd$none);
			case 14:
				var namespaceCode = msg.a;
				var locations = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Store$Platform2$setLocationsForNamespace, namespaceCode, locations, store),
					$elm$core$Platform$Cmd$none);
			case 15:
				var dashboardId = msg.a;
				var locationsAndDisplayAll = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Store$Platform2$setLocationsForDashboardId, dashboardId, locationsAndDisplayAll, store),
					$elm$core$Platform$Cmd$none);
			case 16:
				var waves = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							dX: A2(
								$author$project$Store$Utils$taggedCollectionLoadedWith,
								function ($) {
									return $.bW;
								},
								waves)
						}),
					$elm$core$Platform$Cmd$none);
			case 17:
				var namespaceCode = msg.a;
				var waves = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Store$Platform2$setWavesForNamespace, namespaceCode, waves, store),
					$elm$core$Platform$Cmd$none);
			case 18:
				var dashboardId = msg.a;
				var waves = msg.b;
				return _Utils_Tuple2(
					A3($author$project$Store$Platform2$setWavesForDashboardId, dashboardId, waves, store),
					$elm$core$Platform$Cmd$none);
			case 19:
				var d = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2($author$project$Store$Utils$removeResource, store.v, d.b)
						}),
					$elm$core$Platform$Cmd$none);
			case 20:
				var newDashboard = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2(
								$krisajenkins$remotedata$RemoteData$map,
								A2($turboMaCk$any_dict$Dict$Any$insert, newDashboard.b, newDashboard),
								store.v)
						}),
					$elm$core$Platform$Cmd$none);
			case 21:
				var dashboard = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
						}),
					$elm$core$Platform$Cmd$none);
			case 22:
				var dashboard = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
						}),
					$elm$core$Platform$Cmd$none);
			case 23:
				var dashboard = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
						}),
					$elm$core$Platform$Cmd$none);
			case 24:
				var dashboard = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
						}),
					$elm$core$Platform$Cmd$none);
			case 33:
				var dashboard = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
						}),
					$elm$core$Platform$Cmd$none);
			case 34:
				var dashboard = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
						}),
					$elm$core$Platform$Cmd$none);
			case 25:
				var insightCategories = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							kF: $author$project$Store$Utils$taggedCollectionLoaded(insightCategories)
						}),
					$elm$core$Platform$Cmd$none);
			case 26:
				var datasetFolders = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							of: $krisajenkins$remotedata$RemoteData$Success(datasetFolders)
						}),
					$elm$core$Platform$Cmd$none);
			case 27:
				var datasets = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							es: A2(
								$author$project$Store$Utils$taggedCollectionLoadedWith,
								function ($) {
									return $.bW;
								},
								datasets),
							fC: $krisajenkins$remotedata$RemoteData$Success(
								$Janiczek$elm_bidict$BiDict$Assoc$fromList(
									A2(
										$elm$core$List$map,
										function (ds) {
											return _Utils_Tuple2(ds.bW, ds.jt);
										},
										datasets)))
						}),
					$elm$core$Platform$Cmd$none);
			case 28:
				var datasetFolderTrees = msg.a;
				var getDatasetsRecursively = function (_v7) {
					var datasetFolderTreeData = _v7;
					return _Utils_ap(
						datasetFolderTreeData.n_,
						A2($author$project$Gwi$List$fastConcatMap, getDatasetsRecursively, datasetFolderTreeData.n$));
				};
				var datasetsFromFolderTree = A2($author$project$Gwi$List$fastConcatMap, getDatasetsRecursively, datasetFolderTrees);
				var datasetFoldersFromFolderTree = function () {
					var datasetFoldersFromFolderTree_ = function (_v8) {
						var datasetFolderTreeData = _v8;
						return {
							fB: A2(
								$elm$core$List$map,
								function ($) {
									return $.bW;
								},
								datasetFolderTreeData.n_),
							hB: datasetFolderTreeData.hB,
							b: datasetFolderTreeData.b,
							ld: datasetFolderTreeData.ld,
							gq: datasetFolderTreeData.gq,
							rG: A2($elm$core$List$map, datasetFoldersFromFolderTree_, datasetFolderTreeData.n$)
						};
					};
					return A2($elm$core$List$map, datasetFoldersFromFolderTree_, datasetFolderTrees);
				}();
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							of: $krisajenkins$remotedata$RemoteData$Success(datasetFoldersFromFolderTree),
							es: A2(
								$author$project$Store$Utils$taggedCollectionLoadedWith,
								function ($) {
									return $.bW;
								},
								datasetsFromFolderTree),
							fC: $krisajenkins$remotedata$RemoteData$Success(
								$Janiczek$elm_bidict$BiDict$Assoc$fromList(
									A2(
										$elm$core$List$map,
										function (ds) {
											return _Utils_Tuple2(ds.bW, ds.jt);
										},
										datasetsFromFolderTree)))
						}),
					$elm$core$Platform$Cmd$none);
			case 29:
				var insight = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							pk: A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								insight.b,
								$krisajenkins$remotedata$RemoteData$Success(insight),
								store.pk)
						}),
					$elm$core$Platform$Cmd$none);
			case 30:
				var namespaceCode = msg.a;
				var lineage = msg.b;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							cB: A3(
								$turboMaCk$any_dict$Dict$Any$insert,
								namespaceCode,
								$krisajenkins$remotedata$RemoteData$Success(lineage),
								store.cB)
						}),
					$elm$core$Platform$Cmd$none);
			case 31:
				var list = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							mx: A2(
								$author$project$Store$Utils$taggedCollectionLoadedWith,
								function ($) {
									return $.bW;
								},
								list),
							rT: $krisajenkins$remotedata$RemoteData$Success(list)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var channels = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						store,
						{
							mK: A2(
								$author$project$Store$Utils$taggedCollectionLoadedWith,
								function ($) {
									return $.bW;
								},
								channels)
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Upsell$Dialog$update = F3(
	function (config, msg, model) {
		var btnText = msg;
		return A2(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
			A4($author$project$Upsell$Dialog$navigateToGetInTouch, config, btnText, model.iq, model.iz),
			model);
	});
var $author$project$Store$Platform2$DashboardUpdatedAsCreator = F2(
	function (a, b) {
		return {$: 24, a: a, b: b};
	});
var $author$project$Data$Platform2$updateDashboardAsCreator = F2(
	function (dashboard, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeDashboard(dashboard)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Data$Platform2$fromFullyLoadedDashboard,
						A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Platform2$dashboardFullyLoadedDecoder))),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'PATCH',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + $author$project$Data$Id$unwrap(dashboard.b))
			});
	});
var $author$project$Store$Platform2$updateDashboardAsCreator = F3(
	function (reloadWidgets, dashboardFullyLoaded, config) {
		var dashboard = $author$project$Data$Platform2$fromFullyLoadedDashboard(dashboardFullyLoaded);
		return A6(
			$author$project$Store$Utils$modify,
			function ($) {
				return $.v;
			},
			A2(
				$elm$core$Basics$composeL,
				config.a,
				$author$project$Store$Platform2$DashboardUpdatedAsCreator(reloadWidgets)),
			config.av,
			function (_v0) {
				return $author$project$Data$Platform2$updateDashboardAsCreator(dashboardFullyLoaded);
			},
			dashboard,
			function (store) {
				return _Utils_update(
					store,
					{
						v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
					});
			});
	});
var $author$project$Store$Platform2$DashboardUpdated = function (a) {
	return {$: 23, a: a};
};
var $author$project$Data$Platform2$encodeDashboardForUserUpdate = function (dashboard) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(dashboard.ld)),
				_Utils_Tuple2(
				'filter',
				$author$project$Data$Platform2$encodeDashboardFilter(dashboard.cl.C))
			]));
};
var $author$project$Data$Platform2$updateDashboardAsUser = F2(
	function (dashboard, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeDashboardForUserUpdate(dashboard)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Data$Platform2$fromFullyLoadedDashboard,
						A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Platform2$dashboardFullyLoadedDecoder))),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'PATCH',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + $author$project$Data$Id$unwrap(dashboard.b))
			});
	});
var $author$project$Store$Platform2$updateDashboardAsUser = F2(
	function (dashboardFullyLoaded, config) {
		var dashboard = $author$project$Data$Platform2$fromFullyLoadedDashboard(dashboardFullyLoaded);
		return A6(
			$author$project$Store$Utils$modify,
			function ($) {
				return $.v;
			},
			A2($elm$core$Basics$composeL, config.a, $author$project$Store$Platform2$DashboardUpdated),
			config.av,
			function (_v0) {
				return $author$project$Data$Platform2$updateDashboardAsUser(dashboardFullyLoaded);
			},
			dashboard,
			function (store) {
				return _Utils_update(
					store,
					{
						v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
					});
			});
	});
var $author$project$Data$Platform2$updateDashboardWidgets = F2(
	function (dashboard, flags) {
		return $elm$http$Http$request(
			{
				jv: $elm$http$Http$jsonBody(
					$author$project$Data$Platform2$encodeDashboardForWidgetsUpdate(dashboard.cl.g)),
				hK: A2(
					$author$project$Gwi$Http$expectJson,
					$elm$core$Basics$identity,
					A2(
						$elm$json$Json$Decode$map,
						$author$project$Data$Platform2$fromFullyLoadedDashboard,
						A2($elm$json$Json$Decode$field, 'data', $author$project$Data$Platform2$dashboardFullyLoadedDecoder))),
				hU: _List_fromArray(
					[
						$author$project$Data$Auth$header(flags.i$)
					]),
				h8: 'PATCH',
				iY: $elm$core$Maybe$Nothing,
				i0: $elm$core$Maybe$Nothing,
				c3: $author$project$Data$Platform2$host(flags) + ('/v2/saved/dashboards/' + $author$project$Data$Id$unwrap(dashboard.b))
			});
	});
var $author$project$Store$Platform2$updateDashboardWidgets = F2(
	function (dashboardFullyLoaded, config) {
		var dashboard = $author$project$Data$Platform2$fromFullyLoadedDashboard(dashboardFullyLoaded);
		return A6(
			$author$project$Store$Utils$modify,
			function ($) {
				return $.v;
			},
			A2($elm$core$Basics$composeL, config.a, $author$project$Store$Platform2$DashboardUpdated),
			config.av,
			function (_v0) {
				return $author$project$Data$Platform2$updateDashboardWidgets(dashboardFullyLoaded);
			},
			dashboard,
			function (store) {
				return _Utils_update(
					store,
					{
						v: A2($author$project$Store$Utils$insertResource, store.v, dashboard)
					});
			});
	});
var $author$project$Dashboards2$Detail$DashboardDuplicated = 3;
var $author$project$Dashboards2$Analytics$DashboardFirstChange = function (a) {
	return {$: 11, a: a};
};
var $author$project$Dashboards2$List$removeDashboardSelection = F2(
	function (dashboardId, model) {
		return _Utils_update(
			model,
			{
				J: A2($turboMaCk$any_set$Set$Any$remove, dashboardId, model.J)
			});
	});
var $author$project$Dashboards2$Editable$setEdited = function (editable) {
	switch (editable.$) {
		case 0:
			return $author$project$Dashboards2$Editable$NotReady;
		case 1:
			var a = editable.a;
			return $author$project$Dashboards2$Editable$Edited(a);
		default:
			return editable;
	}
};
var $author$project$UndoRedo$updateAllExceptCurrent = F2(
	function (updateState, _v0) {
		var undoRedo = _v0;
		return _Utils_update(
			undoRedo,
			{
				bj: A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(updateState),
					undoRedo.bj),
				a4: A2(
					$elm$core$List$map,
					$elm$core$Tuple$mapSecond(updateState),
					undoRedo.a4)
			});
	});
var $author$project$Dashboards2$Widget$RichText$isEmpty = function (_v0) {
	var richText = _v0.bM;
	return _Utils_eq(richText, $author$project$Dashboards2$Widget$RichText$empty);
};
var $author$project$Dashboards2$Chart$isSuccessfulyLoaded = function (_v0) {
	var chartData = _v0.h;
	switch (chartData.$) {
		case 0:
			var data = chartData.a.cl;
			return $elm_community$maybe_extra$Maybe$Extra$isJust(
				$author$project$RemoteData$Loaded$toMaybe(data));
		case 1:
			var data = chartData.a.cl;
			return $elm_community$maybe_extra$Maybe$Extra$isJust(
				$author$project$RemoteData$Loaded$toMaybe(data));
		case 2:
			var webdataStatCardModel = chartData.a;
			return $elm_community$maybe_extra$Maybe$Extra$isJust(
				$author$project$RemoteData$Loaded$toMaybe(webdataStatCardModel));
		default:
			var data = chartData.b.cl;
			return $elm_community$maybe_extra$Maybe$Extra$isJust(
				$author$project$RemoteData$Loaded$toMaybe(data));
	}
};
var $author$project$Dashboards2$Widget$RichText$setEditModeAndFocusFirstParagraphIfNew = F2(
	function (msg, model) {
		return ($author$project$Dashboards2$Widget$RichText$isEmpty(model) && model.bZ) ? _Utils_Tuple2(
			_Utils_update(
				model,
				{
					bH: $elm$core$Maybe$Just(0),
					bZ: false
				}),
			A4(
				$author$project$Dashboards2$Widget$RichText$scrollToMakeItVisible,
				msg,
				0,
				$elm$core$Maybe$Just(
					$author$project$Dashboards2$Widget$RichText$SetTextareaCursorPosition(
						_Utils_Tuple2(
							A2($author$project$Dashboards2$Widget$RichText$textareaElementId, 0, model),
							0))),
				model)) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
	});
var $author$project$Dashboards2$Widget$updateForStore = F9(
	function (msg, getConfig, maybeUserFilters, storeMsg, flags, store, widget, isEditing, model) {
		var updateChartModelData = function (handleChartModelData) {
			return A2(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				function (m) {
					var _v18 = function () {
						var _v19 = m.ad;
						switch (_v19.$) {
							case 0:
								return _Utils_Tuple2(m.ad, false);
							case 1:
								return _Utils_Tuple2(m.ad, false);
							default:
								var chartModelData = _v19.a;
								return A2(
									$elm$core$Tuple$mapFirst,
									$author$project$Dashboards2$Widget$ChartModel,
									handleChartModelData(chartModelData));
						}
					}();
					var newChartModel = _v18.a;
					var trackError = _v18.b;
					return (trackError ? A3($author$project$Dashboards2$Widget$trackWidgetErrorIfAny, maybeUserFilters, store, widget) : $GlobalWebIndex$cmd_extra$Cmd$Extra$pure)(
						_Utils_update(
							m,
							{ad: newChartModel}));
				});
		};
		var updateWidgetsForFetchedQuestion = function (code) {
			var _v12 = widget.U;
			if (!_v12.$) {
				var chartWidget = _v12.a;
				var widgetContainsThisQuestion = function () {
					var _v17 = chartWidget.cl;
					if (!_v17.$) {
						var questionCode = _v17.a.at;
						return _Utils_eq(questionCode, code);
					} else {
						var groups = _v17.a;
						return A2(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.at;
								},
								$elm$core$Basics$eq(code)),
							groups);
					}
				}();
				var maybeQuestions = function () {
					var _v15 = chartWidget.cl;
					if (!_v15.$) {
						var questionCode = _v15.a.at;
						return A2(
							$elm$core$Maybe$map,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton,
							A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store));
					} else {
						var groups = _v15.a;
						return A2(
							$elm$core$Maybe$map,
							$author$project$Gwi$NonEmpty$uniqueBy(
								function ($) {
									return $.k1;
								}),
							A2(
								$turboMaCk$non_empty_list_alias$Maybe$NonEmpty$traverseNe,
								function (_v16) {
									var questionCode = _v16.at;
									return A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store);
								},
								groups));
					}
				}();
				var _v13 = _Utils_Tuple2(widgetContainsThisQuestion, maybeQuestions);
				if (_v13.a && (!_v13.b.$)) {
					var questions = _v13.b.a;
					return updateChartModelData(
						function (chartModelData) {
							switch (chartModelData.$) {
								case 0:
									var chartModel = chartModelData.a;
									return _Utils_Tuple2(
										A2($author$project$Dashboards2$Widget$WidgetDataCollected, questions, chartModel),
										$author$project$Dashboards2$Chart$isSuccessfulyLoaded(chartModel));
								case 1:
									var chartModel = chartModelData.a;
									return _Utils_Tuple2(
										A2($author$project$Dashboards2$Widget$WidgetDataCollected, questions, chartModel),
										$author$project$Dashboards2$Chart$isSuccessfulyLoaded(chartModel));
								case 2:
									return _Utils_Tuple2(chartModelData, false);
								default:
									return _Utils_Tuple2(chartModelData, false);
							}
						});
				} else {
					return $elm$core$Basics$identity;
				}
			} else {
				return $elm$core$Basics$identity;
			}
		};
		var updateWidgetsForFetchedQuestions = F2(
			function (modelCmd, codes) {
				var _v6 = widget.U;
				if (!_v6.$) {
					var chartWidget = _v6.a;
					var widgetContainsThisQuestion = function () {
						var _v11 = chartWidget.cl;
						if (!_v11.$) {
							var questionCode = _v11.a.at;
							return A2($turboMaCk$any_set$Set$Any$member, questionCode, codes);
						} else {
							var groups = _v11.a;
							return A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$any,
								function (group) {
									return A2($turboMaCk$any_set$Set$Any$member, group.at, codes);
								},
								groups);
						}
					}();
					var maybeQuestions = function () {
						var _v9 = chartWidget.cl;
						if (!_v9.$) {
							var questionCode = _v9.a.at;
							return A2(
								$elm$core$Maybe$map,
								$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton,
								A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store));
						} else {
							var groups = _v9.a;
							return A2(
								$elm$core$Maybe$map,
								$turboMaCk$non_empty_list_alias$List$NonEmpty$unique,
								A2(
									$turboMaCk$non_empty_list_alias$Maybe$NonEmpty$traverseNe,
									function (_v10) {
										var questionCode = _v10.at;
										return A2($author$project$Store$Platform2$getQuestionMaybe, questionCode, store);
									},
									groups));
						}
					}();
					var _v7 = _Utils_Tuple2(widgetContainsThisQuestion, maybeQuestions);
					if (_v7.a && (!_v7.b.$)) {
						var questions = _v7.b.a;
						return A2(
							updateChartModelData,
							function (chartModelData) {
								switch (chartModelData.$) {
									case 0:
										var chartModel = chartModelData.a;
										return _Utils_Tuple2(
											A2($author$project$Dashboards2$Widget$WidgetDataCollected, questions, chartModel),
											$author$project$Dashboards2$Chart$isSuccessfulyLoaded(chartModel));
									case 1:
										var chartModel = chartModelData.a;
										return _Utils_Tuple2(
											A2($author$project$Dashboards2$Widget$WidgetDataCollected, questions, chartModel),
											$author$project$Dashboards2$Chart$isSuccessfulyLoaded(chartModel));
									case 2:
										return _Utils_Tuple2(chartModelData, false);
									default:
										return _Utils_Tuple2(chartModelData, false);
								}
							},
							modelCmd);
					} else {
						return modelCmd;
					}
				} else {
					return modelCmd;
				}
			});
		var updateWidgetsForQuestionError = F2(
			function (code, questionError) {
				var _v3 = widget.U;
				if (!_v3.$) {
					var chartWidget = _v3.a;
					var widgetContainsThisQuestion = function () {
						var _v5 = chartWidget.cl;
						if (!_v5.$) {
							var questionCode = _v5.a.at;
							return _Utils_eq(questionCode, code);
						} else {
							var groups = _v5.a;
							return A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$any,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.at;
									},
									$elm$core$Basics$eq(code)),
								groups);
						}
					}();
					return widgetContainsThisQuestion ? updateChartModelData(
						function (chartModelData) {
							var error = A2($author$project$Gwi$Http$toHttpError, $elm$core$Basics$never, questionError);
							switch (chartModelData.$) {
								case 0:
									return _Utils_Tuple2(
										$author$project$Dashboards2$Widget$QuestionErrorView(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(error)),
										true);
								case 1:
									return _Utils_Tuple2(
										$author$project$Dashboards2$Widget$QuestionErrorView(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(error)),
										true);
								case 2:
									var errorsSoFar = chartModelData.a;
									return _Utils_Tuple2(
										$author$project$Dashboards2$Widget$QuestionErrorView(
											A2($turboMaCk$non_empty_list_alias$List$NonEmpty$cons, error, errorsSoFar)),
										false);
								default:
									return _Utils_Tuple2(
										$author$project$Dashboards2$Widget$QuestionErrorView(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$singleton(error)),
										true);
							}
						}) : $elm$core$Basics$identity;
				} else {
					return $elm$core$Basics$identity;
				}
			});
		var updateChartDataWithWithFilters = A2(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				$GlobalWebIndex$cmd_extra$Cmd$Extra$pure,
				function (userFilters) {
					return A2(
						$elm$core$Basics$composeR,
						A3($author$project$Dashboards2$Widget$updateWidgetsChartDataWithFilters, userFilters, store, widget),
						$GlobalWebIndex$cmd_extra$Cmd$Extra$pure);
				},
				maybeUserFilters));
		var setFocusToNewlyCreatedTextWidgetIfEditing = function () {
			if (isEditing) {
				var _v2 = model.ad;
				switch (_v2.$) {
					case 1:
						var richTextModel = _v2.a;
						return $author$project$Dashboards2$Widget$RichText$isEmpty(richTextModel) ? A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							function (model_) {
								return A2(
									$elm$core$Tuple$mapFirst,
									function (newRichTextModel) {
										return _Utils_update(
											model_,
											{
												ad: $author$project$Dashboards2$Widget$EditModeRichTextWidget(newRichTextModel)
											});
									},
									A2(
										$author$project$Dashboards2$Widget$RichText$setEditModeAndFocusFirstParagraphIfNew,
										A2($elm$core$Basics$composeL, msg, $author$project$Dashboards2$Widget$RichTextEditMsg),
										richTextModel));
							}) : $elm$core$Basics$identity;
					case 0:
						return $elm$core$Basics$identity;
					default:
						return $elm$core$Basics$identity;
				}
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var reloadWidgetData = function () {
			var _v1 = A2(
				$elm$core$Maybe$map,
				function (uf) {
					return A2(getConfig, uf, widget);
				},
				maybeUserFilters);
			if (!_v1.$) {
				var config = _v1.a;
				return A2(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					A2(
						$elm$core$Basics$composeL,
						$author$project$Dashboards2$Widget$processRequests(config),
						A7(
							$author$project$Dashboards2$Widget$requestDataForWidgetIfNotLoadedInternal,
							$elm$core$Basics$identity,
							{l: $author$project$Dashboards2$Widget$StoreActionMany},
							maybeUserFilters,
							flags,
							store,
							widget,
							{oQ: false, ez: isEditing})));
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var updateModelIfNeeded = function () {
			switch (storeMsg.$) {
				case 2:
					return reloadWidgetData;
				case 3:
					var dashboard = storeMsg.a;
					return _Utils_eq(dashboard.b, widget.bf) ? reloadWidgetData : $elm$core$Basics$identity;
				case 6:
					return $elm$core$Basics$identity;
				case 4:
					return $elm$core$Basics$identity;
				case 5:
					return $elm$core$Basics$identity;
				case 7:
					return $elm$core$Basics$identity;
				case 20:
					return $elm$core$Basics$identity;
				case 9:
					var code = storeMsg.a;
					return A2(
						$elm$core$Basics$composeR,
						updateWidgetsForFetchedQuestion(code),
						reloadWidgetData);
				case 10:
					var questions = storeMsg.c;
					return function (modelCmd) {
						return reloadWidgetData(
							A2(
								updateWidgetsForFetchedQuestions,
								modelCmd,
								A2(
									$turboMaCk$any_set$Set$Any$fromList,
									$author$project$Data$Id$unwrap,
									A2(
										$elm$core$List$map,
										function ($) {
											return $.k1;
										},
										questions))));
					};
				case 11:
					var code = storeMsg.a;
					var questionError = storeMsg.d;
					return A2(updateWidgetsForQuestionError, code, questionError);
				case 13:
					return $elm$core$Basics$identity;
				case 14:
					return reloadWidgetData;
				case 15:
					return reloadWidgetData;
				case 8:
					return reloadWidgetData;
				case 17:
					return reloadWidgetData;
				case 18:
					return reloadWidgetData;
				case 0:
					if (storeMsg.a.$ === 1) {
						return reloadWidgetData;
					} else {
						return $elm$core$Basics$identity;
					}
				case 16:
					return $elm$core$Basics$identity;
				case 12:
					return $elm$core$Basics$identity;
				case 21:
					return $elm$core$Basics$identity;
				case 22:
					return $elm$core$Basics$identity;
				case 23:
					return A2($elm$core$Basics$composeR, updateChartDataWithWithFilters, reloadWidgetData);
				case 24:
					var reloadWidgets = storeMsg.a.qM;
					return A2(
						$elm$core$Basics$composeR,
						updateChartDataWithWithFilters,
						A2(
							$elm$core$Basics$composeR,
							reloadWidgets ? reloadWidgetData : $elm$core$Basics$identity,
							setFocusToNewlyCreatedTextWidgetIfEditing));
				case 33:
					return $elm$core$Basics$identity;
				case 34:
					return $elm$core$Basics$identity;
				case 19:
					var dashboard = storeMsg.a;
					return _Utils_eq(dashboard.b, widget.bf) ? reloadWidgetData : $elm$core$Basics$identity;
				case 25:
					return $elm$core$Basics$identity;
				case 26:
					return $elm$core$Basics$identity;
				case 27:
					return $elm$core$Basics$identity;
				case 28:
					return $elm$core$Basics$identity;
				case 29:
					return $elm$core$Basics$identity;
				case 1:
					return $elm$core$Basics$identity;
				case 30:
					return $elm$core$Basics$identity;
				case 31:
					return $elm$core$Basics$identity;
				default:
					return $elm$core$Basics$identity;
			}
		}();
		return updateModelIfNeeded(
			$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model));
	});
var $author$project$Platform2$Drawers$updateForStore = F2(
	function (store, model) {
		return A2(
			$author$project$Platform2$Drawers$mapDatasetsDrawer,
			F2(
				function (_v0, data) {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						$author$project$Platform2$Drawers$showContentRemoveWarningIfNeeded(
							A2($author$project$Platform2$Drawers$computeDatasetCompatibilities, store, data)));
				}),
			model).a;
	});
var $author$project$Dashboards2$updateForStore = F6(
	function (config, flags, route, store, storeMsg, model) {
		var updateDrawer = function (model_) {
			return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
				_Utils_update(
					model_,
					{
						aJ: A2($author$project$Platform2$Drawers$updateForStore, store, model_.aJ)
					}));
		};
		var trackDashboardOpened = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$GlobalWebIndex$cmd_extra$Cmd$Extra$pure,
			A2($author$project$Dashboards2$dashboardOpenedAnalytics, flags, store),
			$author$project$Dashboards2$Router$getDashboardId(route));
		var setSavedState = A2(
			$elm$core$Basics$composeR,
			A2(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				$author$project$Dashboards2$setSavingState(1)),
			A2(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				function (m) {
					return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
						_Utils_update(
							m,
							{
								G: A2(
									$author$project$UndoRedo$updateAllExceptCurrent,
									function (undoRedo) {
										return _Utils_update(
											undoRedo,
											{
												bz: $author$project$Dashboards2$Editable$setEdited(undoRedo.bz)
											});
									},
									m.G)
							}));
				}));
		var setInsightToModalIfNeeded = F2(
			function (insight, model_) {
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					function () {
						var _v9 = model_.c;
						if (_v9.$ === 15) {
							var data = _v9.a;
							var _v10 = data.aP;
							switch (_v10.$) {
								case 0:
									return model_;
								case 1:
									return model_;
								default:
									var v = _v10.a;
									var id = _v10.b;
									return _Utils_eq(insight.b, id) ? _Utils_update(
										model_,
										{
											c: $author$project$Dashboards2$Modal$LinkInsightModal(
												_Utils_update(
													data,
													{
														aP: A3(
															$author$project$Dashboards2$Modal$ValidLink,
															v,
															id,
															$krisajenkins$remotedata$RemoteData$Success(insight))
													}))
										}) : model_;
							}
						} else {
							return model_;
						}
					}());
			});
		var redirectToAfterCreatedOrUpdateDashboard = F2(
			function (goToEditMode, maybeId) {
				return A2(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Dashboards2$setNotEdited,
						function (currentModel) {
							var setEditModeIfCanAccess = goToEditMode ? $GlobalWebIndex$cmd_extra$Cmd$Extra$addTrigger(
								config.a(
									$author$project$Dashboards2$SetEditMode(true))) : $elm$core$Basics$identity;
							var navigateTo = function () {
								if (!maybeId.$) {
									var id = maybeId.a;
									var navigateToCmd = config.aM(
										A2(
											$elm$core$Maybe$withDefault,
											$author$project$Dashboards2$Router$Dashboard(id),
											currentModel.a6));
									return A2(
										$elm$core$Basics$composeR,
										$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger(navigateToCmd),
										setEditModeIfCanAccess);
								} else {
									return A3(
										$elm_community$maybe_extra$Maybe$Extra$unwrap,
										$GlobalWebIndex$cmd_extra$Cmd$Extra$pure,
										A2($elm$core$Basics$composeR, config.aM, $GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger),
										currentModel.a6);
								}
							}();
							return function () {
								switch (route.$) {
									case 3:
										return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
									case 4:
										return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure;
									case 0:
										return navigateTo;
									case 1:
										return navigateTo;
									default:
										return navigateTo;
								}
							}()(
								_Utils_update(
									currentModel,
									{a6: $elm$core$Maybe$Nothing}));
						}));
			});
		var maybeDashboard = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
		var closeAnyModal = A2(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			function (m) {
				return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
					_Utils_update(
						m,
						{c: $author$project$Dashboards2$Modal$NoModal}));
			});
		var handleStoreMsg = function () {
			switch (storeMsg.$) {
				case 21:
					var isRenamed = storeMsg.a.kP;
					var id = storeMsg.b.b;
					return A2(
						$elm$core$Basics$composeR,
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							function (m) {
								return _Utils_Tuple2(
									_Utils_update(
										m,
										{
											aW: isRenamed ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(id)
										}),
									$author$project$Dashboards2$Analytics$trackEvent(
										$author$project$Dashboards2$Analytics$DashboardFirstChange(
											{
												bf: id,
												a0: flags.nM(23)
											})));
							}),
						A2(
							$elm$core$Basics$composeR,
							A2(
								redirectToAfterCreatedOrUpdateDashboard,
								true,
								$elm$core$Maybe$Just(id)),
							closeAnyModal));
				case 22:
					var id = storeMsg.a.b;
					return A2(
						$elm$core$Basics$composeR,
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							function (m) {
								return _Utils_Tuple2(
									_Utils_update(
										m,
										{
											dS: $elm$core$Maybe$Just(id)
										}),
									$elm$core$Platform$Cmd$none);
							}),
						A2(
							$elm$core$Basics$composeR,
							A2(
								$turboMaCk$glue$Glue$updateWith,
								$turboMaCk$glue$Glue$id,
								$author$project$Dashboards2$setSavingState(3)),
							A2(
								$elm$core$Basics$composeR,
								A2(
									redirectToAfterCreatedOrUpdateDashboard,
									false,
									$elm$core$Maybe$Just(id)),
								closeAnyModal)));
				case 23:
					return A2(
						$elm$core$Basics$composeR,
						A2(redirectToAfterCreatedOrUpdateDashboard, false, $elm$core$Maybe$Nothing),
						setSavedState);
				case 24:
					return A2(
						$elm$core$Basics$composeR,
						A2(redirectToAfterCreatedOrUpdateDashboard, false, $elm$core$Maybe$Nothing),
						A2($elm$core$Basics$composeR, setSavedState, closeAnyModal));
				case 33:
					var closeShareModal = storeMsg.a.bV;
					return A2(
						$elm$core$Basics$composeR,
						A2(redirectToAfterCreatedOrUpdateDashboard, false, $elm$core$Maybe$Nothing),
						A2(
							$elm$core$Basics$composeR,
							setSavedState,
							closeShareModal ? closeAnyModal : $elm$core$Basics$identity));
				case 34:
					var closeShareModal = storeMsg.a.bV;
					return A2(
						$elm$core$Basics$composeR,
						A2(redirectToAfterCreatedOrUpdateDashboard, false, $elm$core$Maybe$Nothing),
						A2(
							$elm$core$Basics$composeR,
							setSavedState,
							closeShareModal ? closeAnyModal : $elm$core$Basics$identity));
				case 3:
					var id = storeMsg.a.b;
					return A2(
						$elm$core$Basics$composeR,
						function () {
							if ($author$project$Dashboards2$Editable$isEdited(
								$author$project$Dashboards2$Detail$currentEditableUserFilters(model))) {
								var _v1 = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
								if (!_v1.$) {
									var dashboard = _v1.a;
									return ((!_Utils_eq(dashboard.ah, $author$project$Data$Platform2$PrivateDashboard)) && _Utils_eq(id, dashboard.b)) ? A4($author$project$Dashboards2$showContinueAnalysisModalOrDoAction, flags, config, route, store) : $elm$core$Basics$identity;
								} else {
									return $elm$core$Basics$identity;
								}
							} else {
								return $elm$core$Basics$identity;
							}
						}(),
						A2(
							$elm$core$Basics$composeR,
							A2(
								$turboMaCk$glue$Glue$updateWith,
								$turboMaCk$glue$Glue$id,
								function (m) {
									return _Utils_Tuple2(
										_Utils_update(
											m,
											{
												dS: $elm$core$Maybe$Just(id)
											}),
										$elm$core$Platform$Cmd$none);
								}),
							A2(
								$turboMaCk$glue$Glue$updateWith,
								$turboMaCk$glue$Glue$id,
								A3($author$project$Dashboards2$dashboardOpenedAnalytics, flags, store, id))));
				case 0:
					if (storeMsg.a.$ === 2) {
						var _v2 = storeMsg.a;
						var oldAudiences = _v2.a;
						var _v3 = $author$project$Dashboards2$getUserFilters(model);
						if (!_v3.$) {
							var userFilters = _v3.a;
							var _v4 = A3(
								$elm_community$list_extra$List$Extra$indexedFoldl,
								F2(
									function (index, _v5) {
										var id = _v5.b;
										var _v6 = A2($author$project$Store$Utils$get, store.d9, id);
										if (!_v6.$) {
											var newAudience = _v6.a;
											var audienceChanged = A2(
												$elm$core$Maybe$withDefault,
												true,
												A2(
													$elm$core$Maybe$map,
													function (oldAudinece) {
														return !_Utils_eq(newAudience.bY, oldAudinece.bY);
													},
													A2($author$project$Store$Utils$get, oldAudiences, id)));
											return audienceChanged ? A2(
												$turboMaCk$glue$Glue$updateWith,
												$turboMaCk$glue$Glue$id,
												A4($author$project$Dashboards2$UserFilters$replaceAudienceAtIndex, $author$project$Dashboards2$userFiltersConfig, flags, index, newAudience)) : $elm$core$Basics$identity;
										} else {
											return $elm$core$Basics$identity;
										}
									}),
								$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(userFilters),
								$author$project$Dashboards2$UserFilters$audiences(userFilters));
							var newUserFilters = _v4.a;
							var userFiltersCmds = _v4.b;
							return A2(
								$turboMaCk$glue$Glue$updateWith,
								$turboMaCk$glue$Glue$id,
								function (m) {
									return A2(
										$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
										A2($elm$core$Platform$Cmd$map, config.a, userFiltersCmds),
										A2(
											$author$project$Dashboards2$setUserFilters,
											$author$project$Dashboards2$Editable$set(newUserFilters),
											m));
								});
						} else {
							return $elm$core$Basics$identity;
						}
					} else {
						return $elm$core$Basics$identity;
					}
				case 2:
					return $elm$core$Basics$identity;
				case 4:
					return $elm$core$Basics$identity;
				case 5:
					return $elm$core$Basics$identity;
				case 6:
					return $elm$core$Basics$identity;
				case 7:
					return A2(
						$elm$core$Basics$composeR,
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							function (m) {
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
									_Utils_update(
										m,
										{aW: $elm$core$Maybe$Nothing}));
							}),
						A2(
							$elm$core$Basics$composeR,
							A2(redirectToAfterCreatedOrUpdateDashboard, false, $elm$core$Maybe$Nothing),
							A2($elm$core$Basics$composeR, setSavedState, closeAnyModal)));
				case 8:
					return $elm$core$Basics$identity;
				case 9:
					return A2($author$project$Dashboards2$checkWidgetsVisibilityOnDetail, config, route);
				case 10:
					return A2($author$project$Dashboards2$checkWidgetsVisibilityOnDetail, config, route);
				case 11:
					return $elm$core$Basics$identity;
				case 12:
					return $elm$core$Basics$identity;
				case 13:
					return $elm$core$Basics$identity;
				case 14:
					return $elm$core$Basics$identity;
				case 15:
					return $elm$core$Basics$identity;
				case 16:
					return $elm$core$Basics$identity;
				case 17:
					return $elm$core$Basics$identity;
				case 18:
					return $elm$core$Basics$identity;
				case 19:
					var dashboard = storeMsg.a;
					return A2(
						$elm$core$Basics$composeR,
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							function (m) {
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
									_Utils_update(
										m,
										{
											aY: A2($turboMaCk$any_set$Set$Any$remove, dashboard.b, m.aY)
										}));
							}),
						A2(
							$turboMaCk$glue$Glue$updateWith,
							$author$project$Dashboards2$dashboardsList,
							A2(
								$elm$core$Basics$composeR,
								$author$project$Dashboards2$List$removeDashboardSelection(dashboard.b),
								$GlobalWebIndex$cmd_extra$Cmd$Extra$pure)));
				case 25:
					return $elm$core$Basics$identity;
				case 26:
					return $elm$core$Basics$identity;
				case 27:
					return A2($turboMaCk$glue$Glue$updateWith, $turboMaCk$glue$Glue$id, updateDrawer);
				case 28:
					return A2($turboMaCk$glue$Glue$updateWith, $turboMaCk$glue$Glue$id, updateDrawer);
				case 20:
					return setSavedState;
				case 29:
					var insight = storeMsg.a;
					return A2(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						setInsightToModalIfNeeded(insight));
				case 1:
					return $elm$core$Basics$identity;
				case 30:
					return A2($turboMaCk$glue$Glue$updateWith, $turboMaCk$glue$Glue$id, updateDrawer);
				case 31:
					return $elm$core$Basics$identity;
				default:
					return $elm$core$Basics$identity;
			}
		}();
		return A3(
			$turboMaCk$glue$Glue$updateWith,
			$turboMaCk$glue$Glue$id,
			trackDashboardOpened,
			A3(
				$turboMaCk$glue$Glue$updateWith,
				$turboMaCk$glue$Glue$id,
				A3($author$project$Dashboards2$userFiltersChangedAnalytics, flags, route, store),
				A3(
					$turboMaCk$glue$Glue$updateWith,
					$turboMaCk$glue$Glue$id,
					A4(
						$author$project$Dashboards2$updateWidgetsWith,
						F3(
							function (flags_, store_, widget) {
								return A8(
									$author$project$Dashboards2$Widget$updateForStore,
									A2(
										$elm$core$Basics$composeL,
										config.a,
										$author$project$Dashboards2$WidgetMsg(widget.b)),
									config.V.c8,
									$author$project$Dashboards2$getUserFilters(model),
									storeMsg,
									flags_,
									store_,
									widget,
									$author$project$Dashboards2$Detail$isEditMode(model.o));
							}),
						flags,
						store,
						route),
					A3(
						$turboMaCk$glue$Glue$updateWith,
						$turboMaCk$glue$Glue$id,
						A5($author$project$Dashboards2$fetchDashboardAndItsData, config, flags, store, route, maybeDashboard),
						A3(
							$turboMaCk$glue$Glue$updateWith,
							$turboMaCk$glue$Glue$id,
							A4($author$project$Dashboards2$initUserFiltersIfNeeded, config, flags, route, store),
							handleStoreMsg(
								$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model)))))));
	});
var $author$project$Dashboards2Main$updateForStore = F2(
	function (msg, model) {
		return A2(
			$elm$core$Result$withDefault,
			$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
			A2(
				$elm$core$Result$map,
				function (state) {
					return A2(
						$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
						$author$project$Dashboards2Main$getSharedStateFromKernel(0),
						A3(
							$turboMaCk$glue$Glue$Lazy$updateWith,
							$author$project$Dashboards2Main$dashboards,
							A5($author$project$Dashboards2$updateForStore, state.aX, state.oN, state.af, state.s, msg),
							$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model)));
				},
				model));
	});
var $turboMaCk$glue$Glue$Lazy$updateModelWith = F2(
	function (glue, f) {
		return A2(
			$turboMaCk$glue$Glue$updateModelWith,
			glue,
			$elm$core$Maybe$map(f));
	});
var $author$project$Dashboards2Main$upsell = $turboMaCk$glue$Glue$poly(
	{
		oS: A2(
			$elm$core$Basics$composeL,
			$elm$core$Maybe$andThen(
				function ($) {
					return $.e4;
				}),
			$elm$core$Result$toMaybe),
		rg: F2(
			function (subModel, model) {
				return A2(
					$elm$core$Result$map,
					function (state) {
						return _Utils_update(
							state,
							{e4: subModel});
					},
					model);
			})
	});
var $author$project$Dashboards2Main$CloseUpsell = {$: 29};
var $author$project$Dashboards2Main$OpenNewWindow = function (a) {
	return {$: 31, a: a};
};
var $author$project$Dashboards2Main$UpsellMsg = function (a) {
	return {$: 28, a: a};
};
var $author$project$Dashboards2Main$upsellConfig = {n2: $author$project$Dashboards2Main$CloseUpsell, a: $author$project$Dashboards2Main$UpsellMsg, qk: $author$project$Dashboards2Main$OpenNewWindow};
var $author$project$Dashboards2Main$update = F2(
	function (msg, model) {
		return A2(
			$elm$core$Result$withDefault,
			_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
			A2(
				$elm$core$Result$map,
				A2(
					$turboMaCk$glue$Glue$Lazy$updateWith,
					$author$project$Dashboards2Main$dashboards,
					function (dModel) {
						return A2(
							$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
							$author$project$Dashboards2Main$setDashboardEditedState(
								$author$project$Dashboards2$isUnsaved(dModel)),
							dModel);
					}),
				A2(
					$elm$core$Result$map,
					function (state) {
						switch (msg.$) {
							case 9:
								var newToken = msg.a;
								var newFlags = function (flags_) {
									return _Utils_update(
										flags_,
										{i$: newToken});
								};
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
									$elm$core$Result$Ok(
										_Utils_update(
											state,
											{
												oN: newFlags(state.oN)
											})));
							case 0:
								return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
							case 1:
								var url = msg.a;
								return _Utils_Tuple2(
									model,
									$elm$browser$Browser$Navigation$load(url));
							case 3:
								var setFailure = msg.a;
								var err = msg.b;
								var newStore = setFailure(state.s);
								return A3(
									$author$project$Dashboards2Main$handleAjaxError,
									A2(
										$elm$core$Basics$composeR,
										A2(
											$turboMaCk$glue$Glue$Lazy$updateModelWith,
											$author$project$Dashboards2Main$dashboards,
											$author$project$Dashboards2$handleStoreError(newStore)),
										$GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
									err,
									$elm$core$Result$Ok(
										_Utils_update(
											state,
											{s: newStore})));
							case 2:
								var setFailure = msg.a;
								var err = msg.b;
								var errorDisplay = A2($author$project$Error$getDisplay, $elm$core$Basics$never, err);
								return A3(
									$author$project$Dashboards2Main$handleAjaxError,
									A2(
										$elm$core$Basics$composeR,
										A2(
											$turboMaCk$glue$Glue$Lazy$updateModelWith,
											$author$project$Dashboards2Main$dashboards,
											$author$project$Dashboards2$openErrorModal(errorDisplay)),
										$GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
									err,
									$elm$core$Result$Ok(
										_Utils_update(
											state,
											{
												s: setFailure(state.s)
											})));
							case 40:
								var setFailure = msg.a;
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$withTrigger,
									$author$project$Dashboards2Main$NavigateTo($author$project$Dashboards2$Router$NotFound),
									$elm$core$Result$Ok(
										_Utils_update(
											state,
											{
												s: setFailure(state.s)
											})));
							case 10:
								var bool = msg.a;
								var clearAudiencesFromStore = function (s) {
									return (!bool) ? _Utils_update(
										s,
										{jm: $krisajenkins$remotedata$RemoteData$NotAsked, d9: $krisajenkins$remotedata$RemoteData$NotAsked, nD: $krisajenkins$remotedata$RemoteData$NotAsked}) : s;
								};
								return _Utils_Tuple2(
									$elm$core$Result$Ok(
										_Utils_update(
											state,
											{
												gi: bool,
												s: clearAudiencesFromStore(state.s)
											})),
									bool ? $author$project$Dashboards2Main$mountedD2(0) : $author$project$Dashboards2Main$unmountedD2(0));
							case 32:
								var string = msg.a;
								var maybeUrl = $elm$url$Url$fromString(string);
								var newRoute = A2(
									$elm$core$Maybe$withDefault,
									$author$project$Dashboards2$Router$ExternalUrl(string),
									A2(
										$elm$core$Maybe$andThen,
										$author$project$Dashboards2$Router$parseUrl(state.oN),
										maybeUrl));
								var interruptRoute = A7(
									$author$project$Dashboards2$interruptRouting,
									state.aX,
									state.oN,
									$author$project$Dashboards2Main$ForceNavigateTo(newRoute),
									$author$project$Dashboards2Main$StoreActionsAndContinue,
									state.s,
									newRoute,
									state.bD);
								if (!interruptRoute.$) {
									var newPair = interruptRoute.a;
									return A2(
										$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
										$author$project$Dashboards2Main$interruptRoutingStatus(true),
										A3(
											$turboMaCk$glue$Glue$Lazy$updateWith,
											$author$project$Dashboards2Main$dashboards,
											$elm$core$Basics$always(newPair),
											$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model)));
								} else {
									return _Utils_Tuple2(
										model,
										$author$project$Dashboards2Main$interruptRoutingStatus(false));
								}
							case 11:
								var list = msg.a;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$platform2Store,
									A3($author$project$Store$Platform2$storeActionMany, list, $author$project$Dashboards2Main$platform2StoreConfig, state.oN),
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 12:
								var platform2Msg = msg.a;
								return A3(
									$turboMaCk$glue$Glue$updateWith,
									$turboMaCk$glue$Glue$id,
									$author$project$Dashboards2Main$updateForStore(platform2Msg),
									A3(
										$turboMaCk$glue$Glue$updateWith,
										$turboMaCk$glue$Glue$id,
										A2($elm$core$Basics$composeR, $author$project$Dashboards2Main$setExtraApiHeaderForViewOnlyAccounts, $GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
										A4(
											$turboMaCk$glue$Glue$Lazy$update,
											$author$project$Dashboards2Main$platform2Store,
											$author$project$Store$Platform2$update($author$project$Dashboards2Main$platform2StoreConfig),
											platform2Msg,
											_Utils_Tuple2(model, $elm$core$Platform$Cmd$none))));
							case 13:
								var updateWith = msg.a;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$platform2Store,
									A2($elm$core$Basics$composeR, updateWith, $GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 24:
								var storeMsgs = msg.a;
								var appMsg = msg.b;
								return A3(
									$turboMaCk$glue$Glue$updateWith,
									$turboMaCk$glue$Glue$id,
									$author$project$Dashboards2Main$update(appMsg),
									A3(
										$elm$core$List$foldl,
										A2(
											$elm$core$Basics$composeL,
											$turboMaCk$glue$Glue$Lazy$updateWith($author$project$Dashboards2Main$platform2Store),
											$author$project$Store$Platform2$update($author$project$Dashboards2Main$platform2StoreConfig)),
										$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
										storeMsgs));
							case 21:
								var string = msg.a;
								var queryParams = $author$project$DefaultQueryParams$fromResult(model);
								var prefix = $author$project$Config$combinePrefixAndFeature(state.oN);
								var maybeUrl = $elm$url$Url$fromString(string);
								var newRoute = A2(
									$elm$core$Maybe$withDefault,
									state.af,
									A2(
										$elm$core$Maybe$andThen,
										$author$project$Dashboards2$Router$parseUrl(state.oN),
										maybeUrl));
								var newStateAndCmd = function () {
									var _v3 = state.dH;
									if (!_v3.$) {
										var routeToRestoreWhenComingToList = _v3.a;
										switch (newRoute.$) {
											case 0:
												var newState = _Utils_update(
													state,
													{
														af: routeToRestoreWhenComingToList,
														dH: $elm$core$Maybe$Nothing,
														c3: $elm$url$Url$fromString(
															A3($author$project$Dashboards2$Router$toUrlString, prefix, routeToRestoreWhenComingToList, queryParams))
													});
												return A2(
													$elm$core$Tuple$mapFirst,
													$elm$core$Result$withDefault(newState),
													A3(
														$turboMaCk$glue$Glue$updateWith,
														$turboMaCk$glue$Glue$id,
														function (model_) {
															return A2(
																$elm$core$Result$withDefault,
																$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model_),
																A2(
																	$elm$core$Result$map,
																	function (state_) {
																		return A3($author$project$Dashboards2Main$navigateToWithCheck, routeToRestoreWhenComingToList, state_, model_);
																	},
																	model_));
														},
														$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
															$author$project$Dashboards2Main$setExtraApiHeaderForViewOnlyAccounts(
																$elm$core$Result$Ok(newState)))));
											case 1:
												return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
													_Utils_update(
														state,
														{af: newRoute, dH: $elm$core$Maybe$Nothing, c3: maybeUrl}));
											default:
												return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
													_Utils_update(
														state,
														{af: newRoute, c3: maybeUrl}));
										}
									} else {
										return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
											_Utils_update(
												state,
												{af: newRoute, c3: maybeUrl}));
									}
								}();
								var checkSharedStateIfNewDashboard = _Utils_eq(newRoute, $author$project$Dashboards2$Router$NewDashboard) ? $GlobalWebIndex$cmd_extra$Cmd$Extra$add(
									$author$project$Dashboards2Main$getSharedStateFromKernel(0)) : $elm$core$Basics$identity;
								return function (_v2) {
									var model_ = _v2.a;
									var cmds = _v2.b;
									return A3(
										$elm$core$Basics$apR,
										A2(
											$elm$core$Result$map,
											function (state_) {
												return A2(
													$turboMaCk$glue$Glue$Lazy$updateWith,
													$author$project$Dashboards2Main$dashboards,
													A4($author$project$Dashboards2$updateForRoute, state_.aX, state_.oN, state_.s, newStateAndCmd.a.af));
											},
											model_),
										$elm$core$Result$withDefault($elm$core$Basics$identity),
										_Utils_Tuple2(model_, cmds));
								}(
									A3(
										$turboMaCk$glue$Glue$updateWith,
										$turboMaCk$glue$Glue$id,
										A2(
											$elm$core$Basics$composeR,
											$author$project$Dashboards2Main$clearDatasetsForViewOnly(newRoute),
											$GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
										A3(
											$turboMaCk$glue$Glue$updateWith,
											$turboMaCk$glue$Glue$id,
											A2($elm$core$Basics$composeR, $author$project$Dashboards2Main$setExtraApiHeaderForViewOnlyAccounts, $GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
											A2(
												$elm$core$Tuple$mapFirst,
												$elm$core$Result$Ok,
												checkSharedStateIfNewDashboard(newStateAndCmd)))));
							case 22:
								var route = msg.a;
								var queryParams = $author$project$DefaultQueryParams$fromResult(model);
								var prefix = A2(
									$elm$core$Maybe$andThen,
									$author$project$Config$combinePrefixAndFeature,
									$elm$core$Result$toMaybe(
										A2(
											$elm$core$Result$map,
											function ($) {
												return $.oN;
											},
											model)));
								return _Utils_Tuple2(
									model,
									$author$project$Dashboards2Main$navigateToD2(
										A3($author$project$Dashboards2$Router$toUrlString, prefix, route, queryParams)));
							case 23:
								var newRoute = msg.a;
								return A3($author$project$Dashboards2Main$navigateToWithCheck, newRoute, state, model);
							case 25:
								var zone = msg.a;
								return _Utils_Tuple2(
									$elm$core$Result$Ok(
										_Utils_update(
											state,
											{g3: zone})),
									$elm$core$Platform$Cmd$none);
							case 4:
								var dashboardsMsg = msg.a;
								return A4(
									$turboMaCk$glue$Glue$Lazy$update,
									$author$project$Dashboards2Main$dashboards,
									A4($author$project$Dashboards2$update, state.aX, state.oN, state.af, state.s),
									dashboardsMsg,
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 5:
								var widget = msg.a;
								var dashboardId = widget.bf;
								var chartWidget = msg.b;
								var metric = msg.c;
								var questionCodes = $author$project$Data$Platform2$widgetDataQuestionCodes(chartWidget.cl);
								var questionCode = ($turboMaCk$non_empty_list_alias$List$NonEmpty$length(questionCodes) === 1) ? $elm$core$Maybe$Just(
									$turboMaCk$non_empty_list_alias$List$NonEmpty$head(questionCodes)) : $elm$core$Maybe$Nothing;
								var analyticsCmd = A2(
									$elm$core$Maybe$withDefault,
									$elm$core$Platform$Cmd$none,
									$elm_community$maybe_extra$Maybe$Extra$join(
										A3(
											$elm$core$Maybe$map2,
											F2(
												function (model_, questionCode_) {
													return A3(
														$elm$core$Maybe$map2,
														F2(
															function (dashboard, question) {
																return $author$project$Dashboards2$Analytics$trackEvent(
																	A5(
																		$author$project$Dashboards2$Analytics$DashboardQuestionOpened,
																		dashboard,
																		widget,
																		chartWidget,
																		question,
																		$author$project$Dashboards2$isEditMode(model_.bD.o)));
															}),
														$krisajenkins$remotedata$RemoteData$toMaybe(
															A2($author$project$Store$Platform2$getDashboardFullyLoaded, dashboardId, model_.s.v)),
														A2($author$project$Store$Platform2$getQuestionMaybe, questionCode_, model_.s));
												}),
											$elm$core$Result$toMaybe(model),
											questionCode)));
								return A3(
									$elm_community$maybe_extra$Maybe$Extra$unwrap,
									$GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model),
									function (_v5) {
										var questionCode_ = _v5.a;
										var _v6 = _v5.b;
										var userFilters = _v6.a;
										var dashboard = _v6.b;
										var sharedFilters = $elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'questionCode',
													$author$project$Data$Id$encode(questionCode_)),
													_Utils_Tuple2(
													'datasetCodes',
													A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, dashboard.es)),
													_Utils_Tuple2(
													'wavesCodes',
													$author$project$Data$Id$encodeSet(
														$author$project$Dashboards2$UserFilters$waves(userFilters))),
													_Utils_Tuple2(
													'locationCodes',
													$author$project$Data$Id$encodeSet(
														$author$project$Dashboards2$UserFilters$locations(userFilters))),
													_Utils_Tuple2(
													'audienceIds',
													A2(
														$elm$json$Json$Encode$list,
														A2(
															$elm$core$Basics$composeR,
															function ($) {
																return $.b;
															},
															$author$project$Data$Id$encode),
														$author$project$Dashboards2$UserFilters$audiences(userFilters))),
													_Utils_Tuple2(
													'baseAudienceId',
													A3(
														$elm_community$maybe_extra$Maybe$Extra$unwrap,
														$elm$json$Json$Encode$null,
														$author$project$Data$Id$encode,
														$author$project$Dashboards2$UserFilters$getBaseAudienceId(userFilters))),
													_Utils_Tuple2(
													'selectedMetric',
													$elm$json$Json$Encode$string(
														$author$project$Data$Metric$toP2CompatibleString(metric)))
												]));
										var cbUrl = A2(
											$author$project$Platform2$Router$toUrlString,
											state.oN,
											$author$project$Platform2$Router$ChartBuilderQuestion(questionCode_));
										return A2(
											$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
											$elm$core$Platform$Cmd$batch(
												_List_fromArray(
													[
														$author$project$Dashboards2Main$setSharedStateForChartBuilderAndNavigateTo(
														_Utils_Tuple2(sharedFilters, cbUrl)),
														analyticsCmd
													])),
											model);
									},
									A3(
										$elm$core$Maybe$map2,
										$elm$core$Tuple$pair,
										questionCode,
										A2(
											$elm$core$Maybe$andThen,
											function (model_) {
												return A3(
													$elm$core$Maybe$map2,
													$elm$core$Tuple$pair,
													$author$project$Dashboards2$getUserFilters(model_.bD),
													$krisajenkins$remotedata$RemoteData$toMaybe(
														A2($author$project$Store$Platform2$getDashboardFullyLoaded, dashboardId, model_.s.v)));
											},
											$elm$core$Result$toMaybe(model))));
							case 6:
								var chart = msg.a;
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
									$author$project$Dashboards2$Analytics$trackEvent(
										$author$project$Dashboards2$Analytics$PreviewChart(
											{hh: chart.ld, iq: 6})),
									A2(
										$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
										$author$project$Dashboards2Main$navigateToD2(
											A2(
												$author$project$Platform2$Router$toUrlString,
												state.oN,
												$author$project$Platform2$Router$ChartBuilderChart(chart.b))),
										model));
							case 7:
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
									$author$project$Dashboards2Main$navigateToD2(
										A2($author$project$Platform2$Router$toUrlString, state.oN, $author$project$Platform2$Router$ChartBuilderNewChart)),
									$elm$core$Result$Ok(
										_Utils_update(
											state,
											{
												dH: $elm$core$Maybe$Just(state.af)
											})));
							case 8:
								var insightLink = msg.a;
								var dashboard = msg.b;
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
									$author$project$Dashboards2$Analytics$trackEvent(
										$author$project$Dashboards2$Analytics$InsightClicked(
											{
												ep: dashboard,
												aP: insightLink,
												a0: state.oN.nM(23)
											})),
									A2(
										$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
										A3(
											$elm$core$Basics$composeL,
											$author$project$Dashboards2Main$navigateToD2,
											$author$project$Platform2$Router$toUrlString(state.oN),
											$author$project$Platform2$Router$InsightsDetail(insightLink.b)),
										model));
							case 14:
								var dashboardId = msg.a;
								return A2(
									$elm$core$Maybe$withDefault,
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none),
									A2(
										$elm$core$Maybe$map,
										function (dashboard) {
											return A3(
												$turboMaCk$glue$Glue$Lazy$updateWith,
												$author$project$Dashboards2Main$platform2Store,
												A3($author$project$Store$Platform2$toggleDashboardFavourite, dashboardId, $author$project$Dashboards2Main$platform2StoreConfig, state.oN),
												_Utils_Tuple2(
													model,
													$author$project$Dashboards2$Analytics$trackEvent(
														$author$project$Dashboards2$Analytics$DashboardFavourite(
															{bf: dashboard.b, bC: dashboard.ld, pV: !dashboard.kN}))));
										},
										$krisajenkins$remotedata$RemoteData$toMaybe(
											A2($author$project$Store$Platform2$getDashboard, dashboardId, state.s.v))));
							case 20:
								var dashboardId = msg.a;
								var newName = msg.b;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$dashboards,
									$author$project$Dashboards2$setDashboardIsSaving,
									A3(
										$turboMaCk$glue$Glue$Lazy$updateWith,
										$author$project$Dashboards2Main$platform2Store,
										A4($author$project$Store$Platform2$renameDashboard, dashboardId, newName, $author$project$Dashboards2Main$platform2StoreConfig, state.oN),
										_Utils_Tuple2(
											model,
											$author$project$Dashboards2$Analytics$trackEvent(
												$author$project$Dashboards2$Analytics$DashboardRenamed(
													{
														bf: dashboardId,
														bC: newName,
														pq: false,
														a0: state.oN.nM(23)
													})))));
							case 26:
								var dashboard = msg.a;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$platform2Store,
									A3($author$project$Store$Platform2$destroyDashboard, $author$project$Dashboards2Main$platform2StoreConfig, dashboard, state.oN),
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 27:
								var widgetId = msg.a;
								var dashboard = msg.b;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$dashboards,
									$author$project$Dashboards2$setDashboardIsSaving,
									A3(
										$turboMaCk$glue$Glue$Lazy$updateWith,
										$author$project$Dashboards2Main$platform2Store,
										A4($author$project$Store$Platform2$destroyWidget, $author$project$Dashboards2Main$platform2StoreConfig, widgetId, dashboard, state.oN),
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
							case 17:
								var dashboard = msg.a;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$platform2Store,
									A3($author$project$Store$Platform2$createDashboardAsCopy, dashboard, $author$project$Dashboards2Main$platform2StoreConfig, state.oN),
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 15:
								var dashboard = msg.a;
								return $author$project$Data$Platform2$isDashboardNewAndUnsaved(dashboard) ? A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$platform2Store,
									A4(
										$author$project$Store$Platform2$createDashboard,
										{kP: false},
										dashboard,
										$author$project$Dashboards2Main$platform2StoreConfig,
										state.oN),
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)) : A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$dashboards,
									$author$project$Dashboards2$setDashboardIsSaving,
									A3(
										$turboMaCk$glue$Glue$Lazy$updateWith,
										$author$project$Dashboards2Main$platform2Store,
										A3($author$project$Store$Platform2$updateDashboardAsUser, dashboard, $author$project$Dashboards2Main$platform2StoreConfig, state.oN),
										_Utils_Tuple2(
											model,
											$author$project$Dashboards2$Analytics$trackEvent(
												$author$project$Dashboards2$Analytics$DashboardSaved(
													{nM: state.oN.nM, ep: dashboard, ot: false, q6: false})))));
							case 18:
								var isRenamed = msg.a.kP;
								var reloadWidgets = msg.a.qM;
								var dashboard = msg.b;
								var place = msg.c;
								if ($author$project$Permissions$isDashboardsCreator(state.oN.nM)) {
									var dashboardWithConvertedWidgets = A2($author$project$Dashboards2Main$convertDashboardToGroupedData, state.s, dashboard);
									return $author$project$Data$Platform2$isDashboardNewAndUnsaved(dashboard) ? A2(
										$GlobalWebIndex$cmd_extra$Cmd$Extra$add,
										$author$project$Dashboards2$Analytics$trackEvent(
											$author$project$Dashboards2$Analytics$DashboardCreated(
												{
													a0: state.oN.nM(23),
													iq: place
												})),
										A3(
											$turboMaCk$glue$Glue$Lazy$updateWith,
											$author$project$Dashboards2Main$platform2Store,
											A4(
												$author$project$Store$Platform2$createDashboard,
												{kP: isRenamed},
												dashboard,
												$author$project$Dashboards2Main$platform2StoreConfig,
												state.oN),
											_Utils_Tuple2(model, $elm$core$Platform$Cmd$none))) : A3(
										$turboMaCk$glue$Glue$Lazy$updateWith,
										$author$project$Dashboards2Main$dashboards,
										$author$project$Dashboards2$setDashboardIsSaving,
										A3(
											$turboMaCk$glue$Glue$Lazy$updateWith,
											$author$project$Dashboards2Main$platform2Store,
											A4(
												$author$project$Store$Platform2$updateDashboardAsCreator,
												{qM: reloadWidgets},
												dashboardWithConvertedWidgets,
												$author$project$Dashboards2Main$platform2StoreConfig,
												state.oN),
											_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
								} else {
									return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
								}
							case 16:
								var closeShareModal = msg.a.bV;
								var dashboard = msg.b;
								var sharingRequest = function () {
									var _v7 = dashboard.ah;
									if (!_v7.$) {
										return $author$project$Store$Platform2$unshareDashboard(
											{bV: closeShareModal});
									} else {
										return $author$project$Store$Platform2$shareDashboard(
											{bV: closeShareModal});
									}
								}();
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$dashboards,
									$author$project$Dashboards2$setDashboardIsSaving,
									A3(
										$turboMaCk$glue$Glue$Lazy$updateWith,
										$author$project$Dashboards2Main$platform2Store,
										A3(sharingRequest, dashboard, $author$project$Dashboards2Main$platform2StoreConfig, state.oN),
										_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
							case 19:
								var dashboard = msg.a;
								if ($author$project$Permissions$isDashboardsCreator(state.oN.nM)) {
									var dashboardWithConvertedWidgets = A2($author$project$Dashboards2Main$convertDashboardToGroupedData, state.s, dashboard);
									return A3(
										$turboMaCk$glue$Glue$Lazy$updateWith,
										$author$project$Dashboards2Main$dashboards,
										$author$project$Dashboards2$setDashboardIsSaving,
										A3(
											$turboMaCk$glue$Glue$Lazy$updateWith,
											$author$project$Dashboards2Main$platform2Store,
											A3($author$project$Store$Platform2$updateDashboardWidgets, dashboardWithConvertedWidgets, $author$project$Dashboards2Main$platform2StoreConfig, state.oN),
											_Utils_Tuple2(model, $elm$core$Platform$Cmd$none)));
								} else {
									return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(model);
								}
							case 28:
								var uMsg = msg.a;
								return A4(
									$turboMaCk$glue$Glue$Lazy$update,
									$author$project$Dashboards2Main$upsell,
									$author$project$Upsell$Dialog$update($author$project$Dashboards2Main$upsellConfig),
									uMsg,
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 29:
								return $GlobalWebIndex$cmd_extra$Cmd$Extra$pure(
									A2(
										$elm$core$Result$map,
										function (m) {
											return _Utils_update(
												m,
												{e4: $elm$core$Maybe$Nothing});
										},
										model));
							case 30:
								var btnText = msg.a;
								var place = msg.b;
								var resource = msg.c;
								return A2(
									$GlobalWebIndex$cmd_extra$Cmd$Extra$with,
									A4($author$project$Upsell$Dialog$navigateToGetInTouch, $author$project$Dashboards2Main$upsellConfig, btnText, place, resource),
									model);
							case 31:
								var url = msg.a;
								return _Utils_Tuple2(
									model,
									$author$project$Dashboards2Main$openNewWindowD2(url));
							case 33:
								return _Utils_Tuple2(
									model,
									$author$project$Dashboards2Main$navigateToD2(
										A2($author$project$Platform2$Router$toUrlString, state.oN, $author$project$Platform2$Router$AudienceBuilderNew)));
							case 34:
								var audienceId = msg.a;
								return _Utils_Tuple2(
									model,
									$author$project$Dashboards2Main$navigateToD2(
										A2(
											$author$project$Platform2$Router$toUrlString,
											state.oN,
											$author$project$Platform2$Router$AudienceBuilderDetail(audienceId))));
							case 35:
								var sharedState = msg.a;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$dashboards,
									A5($author$project$Dashboards2$setGlobalSearchSharedState, state.aX, state.oN, state.af, state.s, sharedState),
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 38:
								var data = msg.a;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$dashboards,
									A5($author$project$Dashboards2$setKernelSharedState, state.aX, state.oN, state.af, state.s, data),
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 36:
								var errorDescription = msg.a;
								return A3(
									$turboMaCk$glue$Glue$Lazy$updateWith,
									$author$project$Dashboards2Main$dashboards,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Dashboards2$openErrorModal(
											{
												jv: $elm$html$Html$text(errorDescription),
												j$: _List_Nil,
												ka: $elm$core$Maybe$Nothing,
												Y: ''
											}),
										$GlobalWebIndex$cmd_extra$Cmd$Extra$pure),
									_Utils_Tuple2(model, $elm$core$Platform$Cmd$none));
							case 37:
								var errorId = msg.a;
								return _Utils_Tuple2(
									model,
									$author$project$Ports$openChatWithErrorId(
										A3($elm_community$maybe_extra$Maybe$Extra$unwrap, $elm$json$Json$Encode$null, $elm$json$Json$Encode$string, errorId)));
							default:
								var token = msg.a;
								var flags = state.oN;
								return _Utils_Tuple2(
									$elm$core$Result$Ok(
										_Utils_update(
											state,
											{
												oN: _Utils_update(
													flags,
													{i$: token})
											})),
									$elm$core$Platform$Cmd$none);
						}
					},
					model)));
	});
var $author$project$Dashboards2Main$NotMounted = {$: 0};
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $author$project$Dashboards2Main$errorView = function (error) {
	if (!error.$) {
		return $elm$html$Html$text('App is not mounted!');
	} else {
		var err = error.a;
		return $elm$html$Html$text(
			'Initialization error ' + $elm$json$Json$Decode$errorToString(err));
	}
};
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $author$project$Dashboards2Main$handleMounting = function (model) {
	if (!model.$) {
		var s = model.a;
		return s.gi ? model : $elm$core$Result$Err($author$project$Dashboards2Main$NotMounted);
	} else {
		return model;
	}
};
var $elm_community$result_extra$Result$Extra$merge = function (r) {
	if (!r.$) {
		var rr = r.a;
		return rr;
	} else {
		var rr = r.a;
		return rr;
	}
};
var $author$project$Dashboards2$CloseABAndReloadAudiences = {$: 38};
var $author$project$Data$Platform2$encodeDatasetForWebcomponent = function (dataset) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'code',
				$author$project$Data$Id$encode(dataset.bW)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(dataset.ld)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(dataset.hB)),
				_Utils_Tuple2(
				'base_namespace_code',
				$author$project$Data$Id$encode(dataset.jt)),
				_Utils_Tuple2(
				'categories',
				A2(
					$elm$json$Json$Encode$list,
					function (category) {
						return $elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'id',
									$author$project$Data$Id$encode(category.b)),
									_Utils_Tuple2(
									'name',
									$elm$json$Json$Encode$string(category.ld))
								]));
					},
					dataset.ac)),
				_Utils_Tuple2(
				'depth',
				$elm$json$Json$Encode$int(dataset.hz)),
				_Utils_Tuple2(
				'order',
				$elm$json$Json$Encode$int(dataset.gq))
			]));
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$html$Html$Keyed$node = $elm$virtual_dom$VirtualDom$keyedNode;
var $author$project$Config$Main$stageToString = function (env) {
	switch (env) {
		case 0:
			return 'development';
		case 1:
			return 'testsuite';
		case 2:
			return 'testing';
		case 3:
			return 'staging';
		default:
			return 'production';
	}
};
var $author$project$Data$Labels$waveYear = function (_v0) {
	var startDate = _v0.mk;
	return A2($elm$time$Time$toYear, $elm$time$Time$utc, startDate);
};
var $author$project$Platform2$AudienceBuilder$view = F2(
	function (flags, config) {
		var userEncoded = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string(flags.i$)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(flags.mQ.j))
				]));
		var uri = $author$project$Config$Main$get(flags.j8).dV;
		var encodedWaves = A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				function (wave) {
					return A2(
						$elm$json$Json$Encode$list,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$author$project$Data$Id$encode(wave.bW),
								$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(wave.ld)),
										_Utils_Tuple2(
										'code',
										$author$project$Data$Id$encode(wave.bW)),
										_Utils_Tuple2(
										'year',
										$elm$json$Json$Encode$int(
											$author$project$Data$Labels$waveYear(wave)))
									]))
							]));
				},
				$turboMaCk$any_dict$Dict$Any$values(config.dX)));
		var encodedSelectedDatasets = A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				function (dataset) {
					return $author$project$Data$Platform2$encodeDatasetForWebcomponent(dataset);
				},
				config.l7));
		var encodedLocations = A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				function (location) {
					return A2(
						$elm$json$Json$Encode$list,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$author$project$Data$Id$encode(location.bW),
								$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'name',
										$elm$json$Json$Encode$string(location.ld)),
										_Utils_Tuple2(
										'code',
										$author$project$Data$Id$encode(location.bW)),
										_Utils_Tuple2(
										'region',
										$elm$json$Json$Encode$object(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'code',
													$elm$json$Json$Encode$string(
														$elm$core$String$fromInt(
															$author$project$Data$Labels$comparableRegionCode(location.qL)))),
													_Utils_Tuple2(
													'name',
													$elm$json$Json$Encode$string(
														$author$project$Data$Labels$regionName(location.qL)))
												])))
									]))
							]));
				},
				$turboMaCk$any_dict$Dict$Any$values(config.cD)));
		var apiEncoded = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'SERVICE_LAYER_HOST',
					$elm$json$Json$Encode$string(uri.eS)),
					_Utils_Tuple2(
					'COLLECTIONS_HOST',
					$elm$json$Json$Encode$string(uri.ei)),
					_Utils_Tuple2(
					'AUDIENCES_CORE_HOST',
					$elm$json$Json$Encode$string(uri.ea)),
					_Utils_Tuple2(
					'GWI_DEFAULT_HOST',
					$elm$json$Json$Encode$string(uri.d5)),
					_Utils_Tuple2(
					'ANALYTICS_HOST',
					$elm$json$Json$Encode$string(uri.d3)),
					_Utils_Tuple2(
					'SURVEYS_HOST',
					$elm$json$Json$Encode$string(
						A3(
							$elm$url$Url$Builder$crossOrigin,
							uri.d5,
							_List_fromArray(
								['v1', 'surveys']),
							_List_Nil))),
					_Utils_Tuple2(
					'LOCATIONS_HOST',
					$elm$json$Json$Encode$string(
						A3(
							$elm$url$Url$Builder$crossOrigin,
							uri.d5,
							_List_fromArray(
								['v2', 'locations']),
							_List_Nil))),
					_Utils_Tuple2(
					'SEGMENTS_HOST',
					$elm$json$Json$Encode$string(
						A3(
							$elm$url$Url$Builder$crossOrigin,
							uri.d5,
							_List_fromArray(
								['v1', 'splitters', 'by_namespace']),
							_List_Nil)))
				]));
		var encodedConfig = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'environment',
						$elm$json$Json$Encode$string(
							$author$project$Config$Main$stageToString(flags.j8))),
						_Utils_Tuple2('api', apiEncoded),
						_Utils_Tuple2(
						'appName',
						$elm$json$Json$Encode$string(config.be)),
						_Utils_Tuple2('user', userEncoded),
						_Utils_Tuple2(
						'email',
						$elm$json$Json$Encode$string(flags.mQ.j)),
						_Utils_Tuple2(
						'token',
						$elm$json$Json$Encode$string(flags.i$))
					])));
		return A3(
			$elm$html$Html$Keyed$node,
			'x-et-audience-builder',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'x-env-values', encodedConfig),
					A2($elm$html$Html$Attributes$attribute, 'type', 'editApplied'),
					A2(
					$elm$html$Html$Attributes$attribute,
					'audience-id',
					$author$project$Data$Id$unwrap(config.jn)),
					A2($elm$html$Html$Attributes$attribute, 'all-waves', encodedWaves),
					A2($elm$html$Html$Attributes$attribute, 'all-areas', encodedLocations),
					A2($elm$html$Html$Attributes$attribute, 'selected-datasets', encodedSelectedDatasets),
					A2(
					$elm$html$Html$Attributes$attribute,
					'selected-wave-codes',
					A2(
						$elm$json$Json$Encode$encode,
						0,
						$author$project$Data$Id$encodeSet(config.nj))),
					A2(
					$elm$html$Html$Attributes$attribute,
					'selected-location-ids',
					A2(
						$elm$json$Json$Encode$encode,
						0,
						$author$project$Data$Id$encodeSet(config.ng))),
					A2(
					$elm$html$Html$Events$on,
					'audienceBuilderClosed',
					A2(
						$elm$json$Json$Decode$andThen,
						function (_v0) {
							return $elm$json$Json$Decode$succeed(config.n3);
						},
						$elm$json$Json$Decode$value))
				]),
			_List_Nil);
	});
var $author$project$Dashboards2$audienceBuilderView = F6(
	function (config, flags, audienceId, store, route, model) {
		var toSet = A2($elm$core$Basics$composeR, $turboMaCk$any_dict$Dict$Any$keys, $author$project$Data$Id$setFromList);
		var maybeDashboard = A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model);
		var namespaceCodes = A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Dashboards2$Detail$UnsavedDashboard,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Dashboards2$Detail$getNamespaceCodes(store),
					$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList)),
			maybeDashboard);
		var selectedLocations = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Data$Id$emptySet,
			toSet,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
					$elm$core$Basics$composeR,
					$author$project$Dashboards2$Detail$getLocationsForDashboardByDashboardId(store),
					$krisajenkins$remotedata$RemoteData$toMaybe) : A2(
					$elm$core$Basics$composeR,
					$author$project$Dashboards2$Detail$getLocationsForDashboardByNamespaces(store),
					$krisajenkins$remotedata$RemoteData$toMaybe),
				maybeDashboard));
		var selectedWaves = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Data$Id$emptySet,
			toSet,
			A2(
				$elm$core$Maybe$andThen,
				$author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
					$elm$core$Basics$composeR,
					$author$project$Dashboards2$Detail$getWavesForDashboardByDashboardId(store),
					$krisajenkins$remotedata$RemoteData$toMaybe) : A2(
					$elm$core$Basics$composeR,
					$author$project$Dashboards2$Detail$getWavesForDashboardByNamespaces(store),
					$krisajenkins$remotedata$RemoteData$toMaybe),
				maybeDashboard));
		var waves = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Data$Id$emptyDict,
			function (dashboard) {
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$author$project$Data$Id$emptyDict,
					A2($author$project$Store$Platform2$getWavesByDashboardId, dashboard.b, store));
			},
			maybeDashboard) : A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Data$Id$emptyDict,
			function (ns) {
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$author$project$Data$Id$emptyDict,
					A2($author$project$Store$Platform2$getWavesForNamespaces, ns, store));
			},
			namespaceCodes);
		var locations = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Data$Id$emptyDict,
			function (dashboard) {
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$author$project$Data$Id$emptyDict,
					A2($author$project$Store$Platform2$getLocationsByDashboardId, dashboard.b, store));
			},
			maybeDashboard) : A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			$author$project$Data$Id$emptyDict,
			function (ns) {
				return A2(
					$krisajenkins$remotedata$RemoteData$withDefault,
					$author$project$Data$Id$emptyDict,
					A2($author$project$Store$Platform2$getLocationsForNamespaces, ns, store));
			},
			namespaceCodes);
		var datasets = A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Data$Id$emptyDict, store.es);
		var selectedDataset = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.es;
					},
					$elm$core$List$filterMap(
						function (code) {
							return A2($turboMaCk$any_dict$Dict$Any$get, code, datasets);
						})),
				A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model)));
		return A2(
			$author$project$Platform2$AudienceBuilder$view,
			flags,
			{
				ng: selectedLocations,
				nj: selectedWaves,
				fg: datasets,
				be: 'Dashboards',
				jn: audienceId,
				n3: config.a($author$project$Dashboards2$CloseABAndReloadAudiences),
				cD: locations,
				l7: selectedDataset,
				dX: waves
			});
	});
var $author$project$Analytics$Place$NewWidgetTile = 35;
var $author$project$CoolTip$Bottom = 5;
var $author$project$Platform2$Dropdown$DropdownMenu$BottomLeft = 1;
var $author$project$CoolTip$Normal = {$: 0};
var $author$project$Icons$Platform2$arrowLeft = {
	mr: $author$project$Icons$Platform2$path('M14.786 11.103l-4.62 4.566a.7237.7237 0 00-.136.144l-.073.123c-.148.305-.09.662.149.897l4.68 4.627.074.064c.318.24.76.212 1.038-.064l.065-.073.065-.098c.17-.304.122-.683-.13-.932l-3.349-3.311 9.79.001.09-.005c.399-.05.696-.38.696-.774l-.007-.106c-.052-.38-.382-.673-.78-.673l-9.762-.001 3.322-3.282.065-.073c.243-.316.215-.754-.065-1.03-.307-.304-.804-.304-1.112 0z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$pathFillTransform = F3(
	function (fill, transform, d) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(d),
					$elm$svg$Svg$Attributes$fill(fill),
					$elm$svg$Svg$Attributes$transform(transform)
				]),
			_List_Nil);
	});
var $author$project$Icons$Platform2$changes = {
	mr: A3($author$project$Icons$Platform2$pathFillTransform, 'currentColor', 'translate(8, 8)', 'M2.47368 0H11.6842C11.8761 0 12.0575 0.0872146 12.1774 0.237035L15.8616 4.8423C15.9512 4.95429 16 5.09343 16 5.23684V13.5263C16 14.892 14.892 16 13.5263 16H2.47368C1.10738 16 0 14.8922 0 13.5263V2.47368C0 1.10776 1.10738 0 2.47368 0ZM10.5993 1.26308V3.98106H4.94193V1.26314L10.5993 1.26308ZM11.8625 1.8647L14.736 5.45675L14.7368 13.5263C14.7368 14.1943 14.1943 14.7368 13.5263 14.7368H2.47368C1.80509 14.7368 1.26315 14.1947 1.26315 13.5263V2.47369C1.26315 1.80529 1.80509 1.26316 2.47368 1.26316L3.67878 1.26315V4.60454L3.68704 4.70699C3.73599 5.00708 3.99642 5.23612 4.31036 5.23612C4.32021 5.23612 4.33001 5.2359 4.33975 5.23545C4.37406 5.24122 4.40931 5.24422 4.44525 5.24422H11.2306L11.3331 5.23595C11.6273 5.18796 11.8532 4.93667 11.862 4.63099C11.8623 4.62222 11.8625 4.6134 11.8625 4.60454V1.8647ZM9.94676 8.05719C8.7832 7.04006 7.01358 7.08629 5.9042 8.19566C4.74756 9.35231 4.74756 11.2286 5.9042 12.3853C7.06181 13.5429 8.93833 13.5429 10.095 12.3851L10.2335 12.2369C11.2494 11.0735 11.2032 9.30411 10.0928 8.19359L9.94676 8.05719ZM6.79736 9.08885C7.42252 8.46368 8.41277 8.42691 9.08014 8.97833L9.20154 9.08885L9.31172 9.21003C9.8626 9.87742 9.82587 10.8678 9.20154 11.4921C8.53798 12.1563 7.4616 12.1563 6.79736 11.4921C6.13401 10.8288 6.13401 9.7522 6.79736 9.08885Z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$circleArrows = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(9, 10.5)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M11.954 2.05c-2.735-2.733-7.17-2.733-9.906 0C.746 3.351.028 5.08 0 6.886c-.006.376.294.685.67.691.376.006.686-.293.692-.67.023-1.455.6-2.846 1.65-3.894C5.214.81 8.786.81 10.99 3.013c.092.091.18.186.265.284h-1.13l-.093.006c-.332.045-.588.33-.588.675 0 .376.305.68.68.68h2.796l.092-.006c.332-.045.589-.33.589-.674V1.185l-.007-.092c-.045-.332-.33-.588-.674-.588l-.093.006c-.332.045-.588.33-.588.674v1.168c-.093-.104-.188-.205-.287-.303zm2.045 4.978c.002-.376-.302-.682-.678-.684-.376-.001-.682.302-.684.678-.005 1.484-.581 2.901-1.646 3.965-2.204 2.202-5.776 2.202-7.98 0-.092-.092-.18-.187-.266-.285h1.131l.093-.006c.332-.045.588-.33.588-.674 0-.376-.304-.68-.68-.68H1.081l-.092.006c-.333.045-.589.33-.589.674v2.793l.006.092c.045.332.33.588.675.588l.093-.006c.332-.045.588-.33.588-.675v-1.166c.092.103.187.204.285.302 2.735 2.733 7.17 2.733 9.905 0 1.323-1.321 2.04-3.084 2.046-4.922z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$Item$Attribute = $elm$core$Basics$identity;
var $author$project$Platform2$Dropdown$Item$class = function (class_) {
	return function (config) {
		return _Utils_update(
			config,
			{fs: class_});
	};
};
var $author$project$Platform2$Dropdown$Item$disabled = function (disabled_) {
	return function (config) {
		return _Utils_update(
			config,
			{fI: disabled_});
	};
};
var $author$project$Icons$Platform2$edit = {
	mr: $author$project$Icons$Platform2$path('M8.78 22.444a.78.78 0 01.779.778.78.78 0 01-1.559 0 .78.78 0 01.78-.778zm3.562 0a.78.78 0 01.779.778.78.78 0 01-1.559 0 .78.78 0 01.78-.778zm3.562 0c.43 0 .78.35.78.778a.78.78 0 01-1.56 0 .78.78 0 01.78-.778zm3.562-.027c.43 0 .78.35.78.779a.78.78 0 01-1.559 0 .78.78 0 01.78-.779zm3.563 0a.78.78 0 01.779.779.78.78 0 01-1.559 0 .78.78 0 01.78-.779zm-14.25-3.53c.43 0 .78.349.78.778a.78.78 0 01-1.559 0 .78.78 0 01.78-.778zm14.25-.027a.78.78 0 01.779.778.78.78 0 01-1.559 0 .78.78 0 01.78-.778zM20.333 8.046l1.594-1.59a1.56 1.56 0 012.204 0l1.412 1.41c.61.607.61 1.593 0 2.201l-8.906 8.893a1.558 1.558 0 01-1.102.456h-2.303a.667.667 0 01-.668-.667v-2.3c0-.413.165-.81.457-1.1l7.305-7.295.007-.008zm.469 1.419l-6.838 6.829a.22.22 0 00-.064.155v1.633h1.635c.04 0 .078-.01.111-.03l.047-.035 6.836-6.827-1.727-1.725zM8.779 15.329c.43 0 .78.35.78.779a.78.78 0 01-1.559 0c0-.43.35-.779.78-.779zm14.25-.026a.78.78 0 01.779.778.78.78 0 01-1.559 0 .78.78 0 01.78-.778zm-14.25-3.53c.43 0 .78.349.78.777a.78.78 0 01-1.559 0 .78.78 0 01.78-.778zm14.407-4.374a.223.223 0 00-.315 0l-1.124 1.123 1.727 1.724 1.125-1.122a.223.223 0 00.036-.267l-.036-.047zm-10.844.771a.78.78 0 01.779.778.78.78 0 01-1.559 0 .78.78 0 01.78-.778zm-3.563 0c.43 0 .78.35.78.778a.78.78 0 01-1.559 0 .78.78 0 01.78-.778zm7.125 0c.43 0 .78.35.78.778a.78.78 0 01-1.56 0 .78.78 0 01.78-.778z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$ellipsisVertical = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(4 4)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M12.177 16.118a1.618 1.618 0 11-.001 3.235 1.618 1.618 0 01.001-3.235zm0-5.66a1.619 1.619 0 010 3.235 1.618 1.618 0 010-3.234zm0-5.658a1.618 1.618 0 11-.001 3.235 1.618 1.618 0 01.001-3.235z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$CoolTip$Platform2$viewIf = F2(
	function (cond, _v0) {
		var targetHtml = _v0.mu;
		var tooltipText = _v0.mG;
		var type_ = _v0.mL;
		var position = _v0.lB;
		var wrapperAttributes = _v0.m2;
		return cond ? $author$project$CoolTip$Platform2$view(
			{
				lm: $elm$core$Maybe$Nothing,
				lB: position,
				mt: _List_Nil,
				mu: _List_fromArray(
					[targetHtml]),
				mE: _List_Nil,
				mF: $elm$html$Html$text(tooltipText),
				mL: type_,
				m2: wrapperAttributes
			}) : targetHtml;
	});
var $author$project$Dashboards2$Detail$exportButtonView = F5(
	function (config, flags, questions, _class, dashboard) {
		var isExportEnabled = flags.nM(15);
		var isDashboardExportable = ($elm$core$List$length(dashboard.cl.g) > 0) && A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.cl;
				},
				$author$project$Dashboards2$Detail$isWidgetExportable(questions)),
			A2($elm$core$List$filterMap, $author$project$Data$Platform2$getChartWidget, dashboard.cl.g));
		return A2(
			$author$project$CoolTip$Platform2$viewIf,
			(!isExportEnabled) || (!isDashboardExportable),
			{
				lB: 5,
				mu: A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn', _class),
							$elm$html$Html$Events$onClick(
							config.a(config.bi)),
							$elm$html$Html$Attributes$disabled(!(isExportEnabled && isDashboardExportable))
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$export),
							$elm$html$Html$text('Export')
						])),
				mG: (!isExportEnabled) ? 'Your exports are currently disabled, please get in touch with us if you wish to enable them.' : 'Please add at least one chart widget to your dashboard to enable exports.',
				mL: $author$project$CoolTip$Normal,
				m2: _List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn-tooltip', _class)
					])
			});
	});
var $author$project$Icons$Platform2$favourite = {
	mr: $author$project$Icons$Platform2$path('M13.274 12.877l-4.692.722-.094.021a.686.686 0 00-.292 1.136l3.414 3.497-.807 4.95-.009.092a.686.686 0 001.018.618L16 21.596l4.188 2.317.084.04a.687.687 0 00.925-.75l-.808-4.95 3.415-3.497.063-.073a.686.686 0 00-.45-1.084l-4.692-.722-2.104-4.483a.687.687 0 00-1.242 0l-2.105 4.483zM16 10.297l1.64 3.494.047.085a.689.689 0 00.47.302l3.734.573-2.725 2.792-.06.07a.686.686 0 00-.126.52l.635 3.896-3.283-1.815-.091-.042a.686.686 0 00-.573.042l-3.284 1.815.636-3.897.009-.092a.687.687 0 00-.195-.497l-2.726-2.792 3.736-.573a.684.684 0 00.516-.387L16 10.297z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$favouriteFilled = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('translate(-443 -198) translate(0 162) translate(443 36)'),
						$elm$svg$Svg$Attributes$d('M13.274 12.877l-4.692.722-.094.021c-.482.142-.659.76-.292 1.136l3.414 3.497-.807 4.95-.009.092c-.016.517.545.88 1.018.618L16 21.596l4.188 2.317.084.04c.481.19 1.012-.217.925-.75l-.808-4.95 3.415-3.497.063-.073c.3-.403.07-1.004-.45-1.084l-4.692-.722-2.104-4.483c-.247-.525-.995-.525-1.242 0l-2.105 4.483z')
					]),
				_List_Nil)
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $author$project$UndoRedo$hasFuture = function (_v0) {
	var undoRedo = _v0;
	return !$elm$core$List$isEmpty(undoRedo.bj);
};
var $author$project$UndoRedo$hasPast = function (_v0) {
	var undoRedo = _v0;
	return !$elm$core$List$isEmpty(undoRedo.a4);
};
var $author$project$Dashboards2$Detail$moduleClass = $GlobalWebIndex$class_namespaces$WeakCss$namespace('dashboards-2');
var $author$project$Dashboards2$Detail$headerClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'header', $author$project$Dashboards2$Detail$moduleClass);
var $author$project$Icons$Height = function (a) {
	return {$: 1, a: a};
};
var $author$project$Icons$height = $author$project$Icons$Height;
var $author$project$Icons$Platform2$insights = {
	mr: $author$project$Icons$Platform2$path('M20.759 9c1.145 0 2.074.911 2.074 2.034v7.094c0 1.123-.929 2.034-2.074 2.034h-.821v.804c0 1.123-.929 2.034-2.074 2.034h-5.79C10.93 23 10 22.089 10 20.966v-7.094c0-1.123.93-2.034 2.075-2.034l.819-.001v-.803c0-1.072.847-1.95 1.92-2.028L14.97 9zm-2.895 4.068h-5.79c-.452 0-.82.36-.82.804v7.094c0 .444.368.804.82.804h5.79c.453 0 .82-.36.82-.804v-7.094a.812.812 0 00-.82-.804zm-1.447 5.155c.346 0 .627.275.627.615a.62.62 0 01-.627.615h-2.895a.622.622 0 01-.627-.615c0-.34.28-.615.627-.615zm4.342-7.993h-5.79c-.452 0-.82.36-.82.804v.803h3.715c1.145 0 2.075.912 2.075 2.035l-.001 5.06h.82a.816.816 0 00.815-.703l.006-.1v-7.095a.813.813 0 00-.82-.804zm-4.342 5.155c.346 0 .627.275.627.615a.62.62 0 01-.627.615h-2.895a.621.621 0 01-.627-.615c0-.34.28-.615.627-.615z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$DropdownMenu$isVisible = F2(
	function (idForCheck, ddm) {
		if (!ddm.$) {
			return false;
		} else {
			var id = ddm.a.b;
			return _Utils_eq(idForCheck, id);
		}
	});
var $author$project$Platform2$Dropdown$Item$label = function (label_) {
	return function (config) {
		return _Utils_update(
			config,
			{h4: label_});
	};
};
var $elm$virtual_dom$VirtualDom$lazy = _VirtualDom_lazy;
var $elm$html$Html$Lazy$lazy = $elm$virtual_dom$VirtualDom$lazy;
var $author$project$Platform2$Dropdown$Item$leftIcon = function (leftIcon_) {
	return function (config) {
		return _Utils_update(
			config,
			{
				f5: $elm$core$Maybe$Just(leftIcon_)
			});
	};
};
var $author$project$Icons$Platform2$link = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M7.60662 1.30773C8.51034 0.379323 9.84375 0.0086228 11.0972 0.337715C12.3526 0.667317 13.333 1.64774 13.6626 2.90314C13.9917 4.1566 13.621 5.49002 12.6926 6.39374L11.5431 7.54328C11.2502 7.83617 10.7753 7.83618 10.4824 7.54328C10.1895 7.25039 10.1895 6.77552 10.4824 6.48262L11.6438 5.32126C12.1868 4.7944 12.4039 4.01588 12.2118 3.28405C12.0197 2.55222 11.4481 1.98068 10.7163 1.78854C9.98446 1.5964 9.20588 1.81347 8.67902 2.35653L8.67111 2.36468L6.20439 4.83128C5.81112 5.22428 5.58997 5.75764 5.58997 6.31362C5.58997 6.86959 5.81093 7.40277 6.2042 7.79577C6.22792 7.81947 6.24988 7.84459 6.27002 7.87094C6.41982 8.00339 6.58825 8.11344 6.7701 8.19751C7.14608 8.37132 7.30998 8.81701 7.13617 9.19299C6.96236 9.56898 6.51666 9.73287 6.14068 9.55906C5.77057 9.38797 5.4326 9.15456 5.14152 8.86902C5.1062 8.83438 5.07466 8.7966 5.04719 8.75632C4.43299 8.09303 4.08997 7.22102 4.08997 6.31362C4.08997 5.35972 4.46904 4.44493 5.14373 3.77062C5.14379 3.77056 5.14366 3.77068 5.14373 3.77062L7.60662 1.30773Z'),
				$author$project$Icons$Platform2$path('M6.8568 4.81395C7.03085 4.43808 7.47664 4.27446 7.85252 4.44851C8.22261 4.61988 8.56053 4.85353 8.85153 5.13929L8.85621 5.14388C9.53102 5.81821 9.91014 6.7331 9.91014 7.68709C9.91014 8.64098 9.53107 9.55577 8.85638 10.2301C8.85632 10.2301 8.85644 10.23 8.85638 10.2301L6.38168 12.7048C4.97123 14.0732 2.72353 14.0561 1.33396 12.6665C-0.0556165 11.2769 -0.0726295 9.02929 1.29575 7.61885L1.30366 7.6107L2.45705 6.45742C2.74994 6.16453 3.22482 6.16453 3.51771 6.45742C3.8106 6.75032 3.8106 7.22519 3.51771 7.51808L2.36869 8.6671C1.57468 9.48955 1.58581 10.797 2.39462 11.6058C3.20343 12.4147 4.51092 12.4258 5.33336 11.6318L7.79572 9.16942C8.18899 8.77643 8.41014 8.24306 8.41014 7.68709C8.41014 7.1322 8.19004 6.60002 7.79821 6.20725C7.63029 6.04287 7.43549 5.90841 7.22225 5.80967C6.84637 5.63562 6.68276 5.18983 6.8568 4.81395Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$migrated = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M11.854 4.509a.61.61 0 0 0-.14-.222c-.06-.06-.13-.105-.204-.134s-.143-.042-.221-.042H8.822a.6.6 0 0 0 0 1.2H9.84l-3.909 3.91a.6.6 0 0 0 .849.848l3.909-3.91v1.019a.6.6 0 0 0 1.2 0V4.71l-.002-.052-.033-.15z')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$fillRule('evenodd'),
						$elm$svg$Svg$Attributes$d('M4.111 2.244C4.111 1.004 5.116 0 6.356 0h7.4C14.996 0 16 1.005 16 2.244v9.045c0 1.24-1.005 2.244-2.244 2.244h-1.867v.223c0 1.24-1.005 2.244-2.245 2.244h-7.4C1.004 16 0 14.995 0 13.756v-7.4C0 5.116 1.005 4.11 2.244 4.11h1.867V2.244zm1.2 1.867h1.045a.6.6 0 0 1 0 1.2H2.244c-.577 0-1.044.467-1.044 1.045v7.4c0 .577.467 1.044 1.044 1.044h7.4c.578 0 1.045-.467 1.045-1.044V9.644a.6.6 0 0 1 1.2 0v2.69h1.867c.577 0 1.044-.468 1.044-1.045V2.244c0-.577-.467-1.044-1.044-1.044h-7.4c-.578 0-1.045.467-1.045 1.044v1.867z')
					]),
				_List_Nil)
			])),
	e5: 16,
	mT: 0,
	mU: 0,
	e6: 16
};
var $author$project$Platform2$Dropdown$Item$onClick = function (onClick_) {
	return function (config) {
		return _Utils_update(
			config,
			{
				cL: $elm$core$Maybe$Just(onClick_)
			});
	};
};
var $author$project$Icons$Platform2$plusSign = {
	mr: $author$project$Icons$Platform2$path('M15.64 9.351l.11-.008c.377 0 .688.278.742.64l.008.11V15h4.907c.376 0 .688.278.742.64l.008.11c0 .377-.278.688-.64.742l-.11.008H16.5v4.907c0 .376-.278.688-.64.742l-.11.008c-.377 0-.688-.278-.742-.64l-.008-.11V16.5h-4.907c-.376 0-.688-.278-.742-.64l-.008-.11c0-.377.278-.688.64-.742l.11-.008H15v-4.907c0-.376.278-.688.64-.742l.11-.008-.11.008z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$redo = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M23.029 16.418c.136.238.26.482.372.731l.283-1.035c.109-.4.522-.634.921-.525.366.1.594.455.546.822l-.02.1-.748 2.726c-.1.367-.455.595-.821.546l-.1-.02-2.728-.747c-.4-.11-.635-.522-.525-.922.1-.366.455-.594.821-.545l.1.02.928.253c-.099-.225-.21-.446-.332-.661-1.983-3.478-6.41-4.69-9.89-2.708-1.656.944-2.842 2.473-3.366 4.27-.115.398-.532.627-.93.511-.397-.116-.626-.532-.51-.93.631-2.168 2.065-4.015 4.064-5.155 4.199-2.392 9.541-.928 11.935 3.269z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$transform('translate(-1087 -65) translate(1087 65)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$refresh = {
	mr: $author$project$Icons$Platform2$path('M19.711 13.992l-.109-.008c-.654-.098-.654-1.086 0-1.184l.11-.008h1.377a5.901 5.901 0 00-10.49 3.708c0 3.258 2.643 5.9 5.9 5.9 3.26 0 5.9-2.641 5.9-5.9a.601.601 0 011.2 0 7.1 7.1 0 11-1.614-4.509v-1.472a.6.6 0 01.502-.592l.097-.008a.6.6 0 01.592.503l.008.097v2.873a.6.6 0 01-.502.592l-.098.008h-2.873z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$rename = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M19.1494 8.54399L8.54372 19.1497C8.19584 19.4957 8 19.969 8 20.4619V23.2046C8 23.6439 8.35612 24 8.79543 24H11.5381C12.0303 24 12.5019 23.8047 12.8503 23.4563L21.5407 14.7659C21.5453 14.7615 21.5498 14.7571 21.5543 14.7526C21.5589 14.748 21.5633 14.7435 21.5677 14.7389L23.456 12.8506C24.1814 12.1252 24.1814 10.9496 23.4553 10.2253L21.7739 8.54399C21.0486 7.81867 19.8747 7.81867 19.1494 8.54399ZM20.9916 13.0649L22.3311 11.7254C22.435 11.6215 22.435 11.4544 22.3311 11.3507L20.6491 9.66865C20.545 9.5646 20.3784 9.5646 20.2743 9.66865L18.9348 11.0081L20.9916 13.0649ZM17.8099 12.133L9.66714 20.2758C9.61864 20.324 9.59087 20.3912 9.59087 20.4617L9.59076 22.4088L11.5381 22.4089C11.585 22.4089 11.6304 22.3966 11.6703 22.3735L11.7254 22.3311L19.8667 14.1898L17.8099 12.133Z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$saveAsNew = {
	mr: A3($author$project$Icons$Platform2$pathFillTransform, 'currentColor', 'translate(8, 8)', 'M5.54092 0C5.88497 0 6.16387 0.278905 6.16387 0.622951C6.16387 0.932592 5.93796 1.18947 5.64197 1.23775L5.54092 1.2459H4.72125C4.63091 1.2459 4.55452 1.30723 4.53157 1.39041L4.52453 1.44262V2.2623C4.52453 2.60634 4.24563 2.88525 3.90158 2.88525C3.59194 2.88525 3.33506 2.65933 3.28678 2.36334L3.27863 2.2623V1.44262C3.27863 0.692971 3.85097 0.0765342 4.58235 0.0066062L4.72125 0H5.54092ZM15.9934 1.30373C15.9235 0.572339 15.307 0 14.5574 0H13.7377L13.6367 0.00815337C13.3407 0.0564323 13.1148 0.313309 13.1148 0.622951C13.1148 0.966997 13.3937 1.2459 13.7377 1.2459H14.5574L14.6096 1.25294C14.6928 1.2759 14.7541 1.35228 14.7541 1.44262V2.2623L14.7623 2.36334C14.8105 2.65933 15.0674 2.88525 15.3771 2.88525C15.7211 2.88525 16 2.60634 16 2.2623V1.44262L15.9934 1.30373ZM15.9919 10.358C15.9436 10.062 15.6867 9.83607 15.3771 9.83607C15.033 9.83607 14.7541 10.115 14.7541 10.459V11.2787L14.7471 11.3309C14.7241 11.4141 14.6477 11.4754 14.5574 11.4754H13.7377L13.6367 11.4836C13.3407 11.5318 13.1148 11.7887 13.1148 12.0984C13.1148 12.4424 13.3937 12.7213 13.7377 12.7213H14.5574L14.6963 12.7147C15.4277 12.6448 16 12.0283 16 11.2787V10.459L15.9919 10.358ZM11.082 0.622951C11.082 0.278905 10.8031 0 10.4591 0H8.81971L8.71867 0.00815338C8.42267 0.0564323 8.19676 0.313309 8.19676 0.622951C8.19676 0.966997 8.47567 1.2459 8.81971 1.2459H10.4591L10.5601 1.23775C10.8561 1.18947 11.082 0.932593 11.082 0.622951ZM2.2623 4.09836H9.63934C10.8883 4.09836 11.9016 5.11169 11.9016 6.36065V13.7377C11.9016 14.9872 10.8885 16 9.63934 16H2.2623C1.0131 16 0 14.9872 0 13.7377V6.36065C0 5.11169 1.01333 4.09836 2.2623 4.09836ZM9.63929 5.34425H2.26224C1.70137 5.34425 1.24585 5.79978 1.24585 6.36065V13.7377C1.24585 14.2991 1.70104 14.7541 2.26224 14.7541H9.63929C10.2005 14.7541 10.6557 14.2991 10.6557 13.7377V6.36065C10.6557 5.79978 10.2002 5.34425 9.63929 5.34425ZM6.56563 7.89895C6.51735 7.60296 6.26047 7.37705 5.95083 7.37705C5.60679 7.37705 5.32788 7.65595 5.32788 8V9.42623H3.90158L3.80053 9.43438C3.50454 9.48266 3.27863 9.73954 3.27863 10.0492C3.27863 10.3932 3.55753 10.6721 3.90158 10.6721H5.32788V12.0984L5.33604 12.1994C5.38431 12.4954 5.64119 12.7213 5.95083 12.7213C6.29488 12.7213 6.57378 12.4424 6.57378 12.0984V10.6721H7.99994L8.10099 10.664C8.39698 10.6157 8.62289 10.3588 8.62289 10.0492C8.62289 9.70514 8.34399 9.42623 7.99994 9.42623H6.57378V8L6.56563 7.89895ZM15.3431 4.47549C15.0117 4.47549 14.7431 4.74412 14.7431 5.07549V7.1979C14.7431 7.52927 15.0117 7.7979 15.3431 7.7979H15.389C15.7204 7.7979 15.989 7.52927 15.989 7.1979V5.07549C15.989 4.74412 15.7204 4.47549 15.389 4.47549H15.3431Z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$Item$separator = function (class_) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'separator', class_)
			]),
		_List_Nil);
};
var $author$project$Icons$Platform2$share = {
	mr: A3($author$project$Icons$Platform2$pathFillTransform, 'currentColor', 'translate(8 8)', 'M9.64167 3.17908C9.64167 1.42319 11.0641 0 12.8198 0C14.5757 0 15.9989 1.42327 15.9989 3.17908C15.9989 4.93489 14.5757 6.35817 12.8198 6.35817C11.853 6.35817 10.9873 5.92663 10.4045 5.24562L6.28158 7.30742C6.33113 7.53041 6.35726 7.76222 6.35726 8.00014C6.35726 8.23796 6.33115 8.46969 6.28163 8.69261L10.4045 10.7544C10.9873 10.0734 11.853 9.64183 12.8198 9.64183C14.5757 9.64183 15.9989 11.0651 15.9989 12.8209C15.9989 14.5767 14.5757 16 12.8198 16C11.0641 16 9.64167 14.5768 9.64167 12.8209C9.64167 12.5832 9.66774 12.3516 9.71718 12.1288L5.59396 10.0668C5.0109 10.7477 4.14495 11.1792 3.17818 11.1792C1.42245 11.1792 0 9.75603 0 8.00014C0 6.24424 1.42245 4.82105 3.17818 4.82105C4.14486 4.82105 5.01073 5.25247 5.59379 5.93327L9.71718 3.87123C9.66774 3.64842 9.64167 3.4168 9.64167 3.17908ZM4.69097 8.64092C4.67185 8.66906 4.65436 8.6988 4.63873 8.73007C4.62317 8.76118 4.60992 8.79285 4.59891 8.82487C4.31445 9.31386 3.78475 9.64256 3.17824 9.64256C2.27136 9.64256 1.53672 8.90753 1.53672 8.00014C1.53672 7.09274 2.27136 6.35771 3.17824 6.35771C3.78491 6.35771 4.31473 6.68659 4.59914 7.1758C4.6101 7.20759 4.62328 7.23904 4.63873 7.26993C4.65428 7.30104 4.67166 7.33063 4.69067 7.35863C4.77436 7.55571 4.82066 7.77251 4.82066 8.00014C4.82066 8.22748 4.77447 8.44403 4.69097 8.64092ZM11.3082 12.1794C11.2246 12.3765 11.1783 12.5933 11.1783 12.8209C11.1783 13.7283 11.913 14.4633 12.8198 14.4633C13.727 14.4633 14.4623 13.7281 14.4623 12.8209C14.4623 11.9138 13.727 11.1785 12.8198 11.1785C12.2132 11.1785 11.6836 11.5074 11.3994 11.9968C11.3885 12.0287 11.3753 12.0602 11.3598 12.0912C11.3443 12.1221 11.3271 12.1515 11.3082 12.1794ZM12.8198 4.8215C12.2132 4.8215 11.6836 4.49257 11.3994 4.00314C11.3885 3.97128 11.3753 3.93979 11.3598 3.90883C11.3443 3.8779 11.3271 3.84847 11.3082 3.82061C11.2246 3.62354 11.1783 3.40674 11.1783 3.17908C11.1783 2.27169 11.913 1.53666 12.8198 1.53666C13.727 1.53666 14.4623 2.27195 14.4623 3.17908C14.4623 4.08622 13.727 4.8215 12.8198 4.8215Z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$tick = {
	mr: $author$project$Icons$Platform2$path('M21.527 11.247c.344-.337.894-.328 1.228.02.306.318.324.81.06 1.15l-.079.088-8.43 8.248c-.31.302-.785.327-1.122.075l-.088-.075-3.832-3.749c-.344-.337-.353-.892-.019-1.24.306-.318.794-.351 1.138-.095l.09.077 3.227 3.156 7.827-7.655z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$undo = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M23.029 16.418c.136.238.26.482.372.731l.283-1.035c.109-.4.522-.634.921-.525.366.1.594.455.546.822l-.02.1-.748 2.726c-.1.367-.455.595-.821.546l-.1-.02-2.728-.747c-.4-.11-.635-.522-.525-.922.1-.366.455-.594.821-.545l.1.02.928.253c-.099-.225-.21-.446-.332-.661-1.983-3.478-6.41-4.69-9.89-2.708-1.656.944-2.842 2.473-3.366 4.27-.115.398-.532.627-.93.511-.397-.116-.626-.532-.51-.93.631-2.168 2.065-4.015 4.064-5.155 4.199-2.392 9.541-.928 11.935 3.269z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$transform('translate(-1010 -65) translate(1010 65) matrix(-1 0 0 1 32.157 0)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$Item$defaultConfig = {
	eg: _List_Nil,
	fs: $GlobalWebIndex$class_namespaces$WeakCss$namespace('dropdown'),
	fI: false,
	fL: false,
	f1: $elm$core$Basics$identity,
	h4: 'Option',
	f5: $elm$core$Maybe$Nothing,
	cL: $elm$core$Maybe$Nothing,
	gJ: $elm$core$Maybe$Nothing,
	aE: false,
	gR: $elm$core$Maybe$Nothing,
	mM: 'Option'
};
var $author$project$Icons$Width = function (a) {
	return {$: 0, a: a};
};
var $author$project$Icons$width = $author$project$Icons$Width;
var $author$project$Platform2$Dropdown$Item$leftIconView = F2(
	function (config, maybeIcon) {
		if (config.aE) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['item', 'left-icon']),
						config.fs)
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$tick)
					]));
		} else {
			if (!maybeIcon.$) {
				var icon = maybeIcon.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['item', 'left-icon']),
							config.fs)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Icons$icon,
							_List_fromArray(
								[
									$author$project$Icons$width(32),
									$author$project$Icons$height(32)
								]),
							icon)
						]));
			} else {
				return $elm_community$html_extra$Html$Extra$nothing;
			}
		}
	});
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $elm$html$Html$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$elm$virtual_dom$VirtualDom$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $elm_community$html_extra$Html$Events$Extra$onClickStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Platform2$Dropdown$Item$itemView = function (config) {
	return A3(
		$elm$html$Html$Keyed$node,
		'div',
		_List_fromArray(
			[
				A2(
				$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
				_List_fromArray(
					['item', 'wrapper']),
				config.fs)
			]),
		_List_fromArray(
			[
				_Utils_Tuple2(
				config.mM,
				config.f1(
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('selected', config.aE),
										_Utils_Tuple2('disabled', config.fI)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'item', config.fs)),
								A2($elm_community$html_extra$Html$Attributes$Extra$attributeMaybe, $elm_community$html_extra$Html$Events$Extra$onClickStopPropagation, config.cL)
							]),
						_List_fromArray(
							[
								A2($author$project$Platform2$Dropdown$Item$leftIconView, config, config.f5),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['item', 'label']),
										config.fs),
										A2($elm$html$Html$Attributes$attribute, 'label', config.h4)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(config.h4)
									])),
								A2(
								$elm_community$html_extra$Html$Extra$viewMaybe,
								function (sublabelText) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item', 'sub-label']),
												config.fs)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(sublabelText)
											]));
								},
								config.gR),
								A2(
								$elm_community$html_extra$Html$Extra$viewMaybe,
								function (rightIcon_) {
									return A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item', 'right-icon']),
												config.fs)
											]),
										_List_fromArray(
											[
												A2($author$project$Icons$icon, _List_Nil, rightIcon_)
											]));
								},
								config.gJ)
							]))))
			]));
};
var $author$project$Platform2$Dropdown$Item$render = function (config) {
	return $elm$core$List$isEmpty(config.eg) ? $author$project$Platform2$Dropdown$Item$itemView(config) : A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2(
				$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
				_List_fromArray(
					['nested']),
				A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'item', config.fs))
			]),
		_List_fromArray(
			[
				$author$project$Platform2$Dropdown$Item$itemView(config),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
						_List_fromArray(
							['children-wrap']),
						A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'item', config.fs))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('children', true),
										_Utils_Tuple2('v-edge', config.fL)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'item', config.fs))
							]),
						A2($elm$core$List$map, $author$project$Platform2$Dropdown$Item$view, config.eg))
					]))
			]));
};
var $author$project$Platform2$Dropdown$Item$view = function (attributes) {
	return $author$project$Platform2$Dropdown$Item$render(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, config) {
					var attribute = _v0;
					return attribute(config);
				}),
			$author$project$Platform2$Dropdown$Item$defaultConfig,
			attributes));
};
var $author$project$Platform2$Dropdown$DropdownMenu$BottomRight = 0;
var $author$project$Platform2$Dropdown$DropdownMenu$LeftBottom = 6;
var $author$project$Platform2$Dropdown$DropdownMenu$LeftTop = 5;
var $author$project$Platform2$Dropdown$DropdownMenu$Opened = function (a) {
	return {$: 1, a: a};
};
var $author$project$Platform2$Dropdown$DropdownMenu$RightBottom = 4;
var $author$project$Platform2$Dropdown$DropdownMenu$RightCenter = 3;
var $author$project$Platform2$Dropdown$DropdownMenu$RightTop = 2;
var $author$project$Gwi$Html$Events$Dimensions = F2(
	function (width, height) {
		return {cv: height, da: width};
	});
var $author$project$Gwi$Html$Events$Position = F2(
	function (x, y) {
		return {m3: x, m4: y};
	});
var $author$project$Gwi$Html$Events$OffsetElement = $elm$core$Basics$identity;
function $author$project$Gwi$Html$Events$cyclic$offsetParentDecoder() {
	var pDecoder = $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$json$Json$Decode$map,
				$elm$core$Maybe$Just,
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Gwi$Html$Events$cyclic$offsetParentDecoder();
					})),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$field, 'offsetParent', pDecoder),
					A2($elm$json$Json$Decode$field, 'parentNode', pDecoder)
				])),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'nodeName', $elm$json$Json$Decode$string),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'scrollLeft', $elm$json$Json$Decode$float),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'scrollTop', $elm$json$Json$Decode$float),
					A2(
						$elm_community$json_extra$Json$Decode$Extra$andMap,
						A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'offsetTop', $elm$json$Json$Decode$float),
						A2(
							$elm_community$json_extra$Json$Decode$Extra$andMap,
							A2($elm_community$json_extra$Json$Decode$Extra$optionalField, 'offsetLeft', $elm$json$Json$Decode$float),
							$elm$json$Json$Decode$succeed(
								F6(
									function (offsetLeft, offsetTop, scrollTop, scrollLeft, nodeName, parent) {
										return {
											ii: nodeName,
											lo: A2($elm$core$Maybe$withDefault, 0, offsetLeft),
											lp: A2($elm$core$Maybe$withDefault, 0, offsetTop),
											gs: parent,
											lU: A2($elm$core$Maybe$withDefault, 0, scrollLeft),
											lY: A2($elm$core$Maybe$withDefault, 0, scrollTop)
										};
									}))))))));
}
var $author$project$Gwi$Html$Events$offsetParentDecoder = $author$project$Gwi$Html$Events$cyclic$offsetParentDecoder();
$author$project$Gwi$Html$Events$cyclic$offsetParentDecoder = function () {
	return $author$project$Gwi$Html$Events$offsetParentDecoder;
};
var $author$project$Gwi$Html$Events$Element = $elm$core$Basics$identity;
function $author$project$Gwi$Html$Events$cyclic$parentDecoder() {
	return A2(
		$elm_community$json_extra$Json$Decode$Extra$andMap,
		A2(
			$elm$json$Json$Decode$field,
			'parentElement',
			$elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						A2(
						$elm$json$Json$Decode$map,
						$elm$core$Maybe$Just,
						$elm$json$Json$Decode$lazy(
							function (_v0) {
								return $author$project$Gwi$Html$Events$cyclic$parentDecoder();
							})),
						$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
					]))),
		A2(
			$elm_community$json_extra$Json$Decode$Extra$andMap,
			A2($elm$json$Json$Decode$field, 'nodeName', $elm$json$Json$Decode$string),
			A2(
				$elm_community$json_extra$Json$Decode$Extra$andMap,
				A2($elm$json$Json$Decode$field, 'clientHeight', $elm$json$Json$Decode$int),
				A2(
					$elm_community$json_extra$Json$Decode$Extra$andMap,
					A2($elm$json$Json$Decode$field, 'clientWidth', $elm$json$Json$Decode$int),
					$elm$json$Json$Decode$succeed(
						F4(
							function (clientWidth, clientHeight, nodeName, parent) {
								return {jI: clientHeight, jJ: clientWidth, ii: nodeName, gs: parent};
							}))))));
}
var $author$project$Gwi$Html$Events$parentDecoder = $author$project$Gwi$Html$Events$cyclic$parentDecoder();
$author$project$Gwi$Html$Events$cyclic$parentDecoder = function () {
	return $author$project$Gwi$Html$Events$parentDecoder;
};
var $author$project$Gwi$Html$Events$onClickWithBodyDimensions = function (toMsg) {
	var decoder = A2(
		$elm$json$Json$Decode$map,
		function (result) {
			var getElementOffsetOnPage = F2(
				function (offsetSoFar, _v0) {
					var element = _v0;
					var accOffset = A3(
						$elm$core$Tuple$mapBoth,
						$elm$core$Basics$add(element.lp - element.lY),
						$elm$core$Basics$add(element.lo - element.lU),
						offsetSoFar);
					return A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						accOffset,
						getElementOffsetOnPage(accOffset),
						element.gs);
				});
			var getBodyDimensions_ = F2(
				function (dimensionsSoFar, _v1) {
					var element = _v1;
					return ($elm$core$String$toUpper(element.ii) === 'BODY') ? $elm$core$Maybe$Just(
						_Utils_Tuple2(element.jJ, element.jI)) : (_Utils_eq(dimensionsSoFar, $elm$core$Maybe$Nothing) ? A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						dimensionsSoFar,
						getBodyDimensions_(dimensionsSoFar),
						element.gs) : dimensionsSoFar);
				});
			var _v2 = A2(
				getElementOffsetOnPage,
				_Utils_Tuple2(0, 0),
				result.ln);
			var y = _v2.a;
			var x = _v2.b;
			var _v3 = A2(
				$elm$core$Maybe$withDefault,
				_Utils_Tuple2(0, 0),
				A2(getBodyDimensions_, $elm$core$Maybe$Nothing, result.e$));
			var bodyWidth = _v3.a;
			var bodyHeight = _v3.b;
			return {
				jw: A2($author$project$Gwi$Html$Events$Dimensions, bodyWidth, bodyHeight),
				lB: A2($author$project$Gwi$Html$Events$Position, x, y),
				e$: result.e$
			};
		},
		A3(
			$elm$json$Json$Decode$map2,
			F2(
				function (target, offsetElement) {
					return {ln: offsetElement, e$: target};
				}),
			A2($elm$json$Json$Decode$field, 'target', $author$project$Gwi$Html$Events$parentDecoder),
			A2($elm$json$Json$Decode$field, 'target', $author$project$Gwi$Html$Events$offsetParentDecoder)));
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		A2(
			$elm$json$Json$Decode$map,
			function (position) {
				return _Utils_Tuple2(
					toMsg(position),
					true);
			},
			decoder));
};
var $author$project$Platform2$Dropdown$DropdownMenu$with = F2(
	function (toMsg, _v0) {
		var id = _v0.b;
		var orientation = _v0.im;
		var content = _v0.U;
		var screenBottomEdgeMinOffset = _v0.iF;
		var screenSideEdgeMinOffset = _v0.iG;
		var controlElementAttrs = _v0.hn;
		var controlElementContent = _v0.ho;
		var openMsg = function (_v1) {
			var position = _v1.lB;
			var bodyDimensions = _v1.jw;
			var bodyWidth = bodyDimensions.da;
			var bodyHeight = bodyDimensions.cv;
			var orientation_ = ((_Utils_cmp(position.m4 + screenBottomEdgeMinOffset, bodyHeight) > 0) && ((orientation === 2) || (orientation === 3))) ? ((_Utils_cmp(position.m3 + screenSideEdgeMinOffset, bodyWidth) > 0) ? 6 : 4) : (((_Utils_cmp(position.m4 + screenBottomEdgeMinOffset, bodyHeight) > 0) && (orientation === 5)) ? 6 : (((_Utils_cmp(position.m3, screenSideEdgeMinOffset) < 0) && (!orientation)) ? 1 : (((_Utils_cmp(position.m3 + screenSideEdgeMinOffset, bodyWidth) > 0) && (orientation === 1)) ? 0 : (((_Utils_cmp(position.m3 + screenSideEdgeMinOffset, bodyWidth) > 0) && (orientation === 2)) ? 5 : orientation))));
			return toMsg(
				$author$project$Platform2$Dropdown$DropdownMenu$Opened(
					{U: content, b: id, im: orientation_, lB: position}));
		};
		var attributes = A2(
			$elm$core$List$cons,
			$author$project$Gwi$Html$Events$onClickWithBodyDimensions(openMsg),
			controlElementAttrs);
		return A2($elm$html$Html$button, attributes, controlElementContent);
	});
var $author$project$Dashboards2$Detail$actionBarView = F4(
	function (config, _v0, _v1, model) {
		var inStickyHeader = _v0.ar;
		var dashboardId = _v0.bf;
		var flags = _v1.oN;
		var hasUnsavedChanges = _v1.fT;
		var resetButtonEnabled = _v1.gH;
		var currentDashboard = _v1.em;
		var questions = _v1.bt;
		var editSection = _v1.o;
		var saveBtnIsVisible = !A3($author$project$Dashboards2$Detail$canOnlyDuplicate, flags, currentDashboard, model);
		var isViewOnlyMode = $author$project$Data$User$hasViewOnlyPlan(flags.mQ);
		var isDashboardNewAndUnsaved = $author$project$Data$Platform2$isDashboardNewAndUnsaved(currentDashboard);
		var inEditMode = $author$project$Dashboards2$Detail$isEditMode(model.o);
		var favouriteIcon = currentDashboard.kN ? $author$project$Icons$Platform2$favouriteFilled : $author$project$Icons$Platform2$favourite;
		var canSaveFilters = A3($author$project$Dashboards2$Permissions$canSaveFilters, flags.mQ, flags.nM, currentDashboard);
		var canRenameOrDelete = A4($author$project$Dashboards2$Permissions$canRenameOrDelete, flags.mQ, flags.nM, currentDashboard.ah, currentDashboard.dG);
		var canEditContentAndShare = A4($author$project$Dashboards2$Permissions$canEditContentAndShare, flags.mQ, flags.nM, currentDashboard.ah, currentDashboard.dG);
		var actionBarClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'action-bar', $author$project$Dashboards2$Detail$headerClass);
		var actionSubheaderClass = A2(
			$GlobalWebIndex$class_namespaces$WeakCss$addMany,
			_List_fromArray(
				['info', 'subheader']),
			actionBarClass);
		var saveInfoView_ = F3(
			function (_v8, icon, copy) {
				var animateIcon = _v8.fh;
				return A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('animate', animateIcon)
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'saving-info', actionSubheaderClass))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['saving-info', 'icon']),
									actionSubheaderClass)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, icon)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['saving-info', 'copy']),
									actionSubheaderClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(copy)
								]))
						]));
			});
		var saveInfoView = function () {
			var _v7 = model.cV;
			switch (_v7) {
				case 0:
					return A3(
						saveInfoView_,
						{fh: true},
						$author$project$Icons$Platform2$circleArrows,
						'Saving…');
				case 1:
					return A3(
						saveInfoView_,
						{fh: false},
						$author$project$Icons$Platform2$tick,
						'Saved');
				case 3:
					return A3(
						saveInfoView_,
						{fh: false},
						$author$project$Icons$Platform2$tick,
						'Saved');
				default:
					return hasUnsavedChanges ? A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'unsaved', actionSubheaderClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Unsaved')
							])) : $elm_community$html_extra$Html$Extra$nothing;
			}
		}();
		var actionsClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'actions', actionBarClass);
		var addDescriptionBtn = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn', actionsClass),
					$elm$html$Html$Events$onClick(config.nl)
				]),
			_List_fromArray(
				[
					A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$plusSign),
					$elm$html$Html$text('Add description')
				]));
		var closeBtn = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn', actionsClass),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
					!isDashboardNewAndUnsaved,
					$elm$html$Html$Events$onClick(
						config.ri(false))),
					$elm$html$Html$Attributes$disabled(isDashboardNewAndUnsaved)
				]),
			_List_fromArray(
				[
					A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$edit),
					$elm$html$Html$text('Close')
				]));
		var editBtn = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn', actionsClass),
					$elm$html$Html$Events$onClick(
					config.a(config.qi))
				]),
			_List_fromArray(
				[
					A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$edit),
					$elm$html$Html$text('Edit')
				]));
		var exportBtn = A2(
			$elm$html$Html$Lazy$lazy,
			A4($author$project$Dashboards2$Detail$exportButtonView, config, flags, questions, actionsClass),
			currentDashboard);
		var linkInsightBtn = A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			flags.nM(23),
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn', actionsClass),
						$elm$html$Html$Events$onClick(config.pG)
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$insights),
						$elm$html$Html$text('Link insight')
					])));
		var resetBtn = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn', actionsClass),
					$elm$html$Html$Attributes$disabled(!resetButtonEnabled),
					$elm$html$Html$Events$onClick(
					config.a(config.qT))
				]),
			_List_fromArray(
				[
					A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$refresh),
					$elm$html$Html$text('Reset dashboard')
				]));
		var saveAsNewBtn = function (_v6) {
			var primaryBtn = _v6.gy;
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nest,
						primaryBtn ? 'save-btn' : 'btn',
						actionsClass),
						$elm$html$Html$Events$onClick(
						config.a(config.or))
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$saveAsNew),
						$elm$html$Html$text('Save as new')
					]));
		};
		var saveBtn = A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			saveBtnIsVisible,
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'save-btn', actionsClass),
						$elm$html$Html$Attributes$disabled(!hasUnsavedChanges),
						$elm$html$Html$Events$onClick(config.cS)
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$changes),
						$elm$html$Html$text('Save')
					])));
		var shareBtn = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'share-buttons', actionsClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn', actionsClass),
							A2(
							$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
							!isDashboardNewAndUnsaved,
							$elm$html$Html$Events$onClick(
								config.a(config.rj))),
							$elm$html$Html$Attributes$disabled(isDashboardNewAndUnsaved)
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$share),
							$elm$html$Html$text('Share')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['share-buttons', 'separator']),
							actionsClass)
						]),
					_List_Nil),
					A2(
					$author$project$CoolTip$Platform2$viewIf,
					!isDashboardNewAndUnsaved,
					{
						lB: 0,
						mu: A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
									!isDashboardNewAndUnsaved,
									$elm$html$Html$Events$onClick(
										config.a(
											config.n8(dashboardId)))),
									$elm$html$Html$Attributes$disabled(isDashboardNewAndUnsaved),
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'link', actionsClass)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$link)
								])),
						mG: 'Copy link',
						mL: $author$project$CoolTip$Normal,
						m2: _List_Nil
					})
				]));
		var undoRedoButtonsView = function () {
			var undoDisabled = !$author$project$UndoRedo$hasPast(model.G);
			var redoDisabled = !$author$project$UndoRedo$hasFuture(model.G);
			return A2(
				$elm_community$html_extra$Html$Extra$viewIf,
				!inEditMode,
				A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'undo-redo', actionsClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('disabled', undoDisabled)
										]),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'btn', actionsClass)),
									$elm$html$Html$Events$onClick(
									config.a(config.r7)),
									$elm$html$Html$Attributes$title('CTRL / ⌘ Z'),
									$elm$html$Html$Attributes$disabled(undoDisabled)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									$author$project$Icons$Platform2$undo)
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('disabled', redoDisabled)
										]),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'btn', actionsClass)),
									$elm$html$Html$Events$onClick(
									config.a(config.qI)),
									$elm$html$Html$Attributes$title('CTRL Y / Shift ⌘ Z'),
									$elm$html$Html$Attributes$disabled(redoDisabled)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									$author$project$Icons$Platform2$redo)
								]))
						])));
		}();
		var _v2 = function () {
			var _v3 = currentDashboard.cl.aP;
			if (_v3.$ === 1) {
				return _Utils_Tuple3(false, 'Go to insight', config.pX);
			} else {
				var insightLink = _v3.a;
				var type_ = insightLink.mL;
				return _Utils_Tuple3(
					true,
					function () {
						switch (type_) {
							case 1:
								return 'Go to report';
							case 0:
								return 'Go to infographic';
							case 2:
								return 'Go to COTW';
							default:
								return 'Go to powerpoint';
						}
					}(),
					A2(config.dE, insightLink, currentDashboard));
			}
		}();
		var isInsightLinkVisible = _v2.a;
		var insightLinkLabel = _v2.b;
		var insightLinkOnClick = _v2.c;
		var goToInsightBtn = A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			isInsightLinkVisible,
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'btn', actionsClass),
						$elm$html$Html$Events$onClick(
						config.a(insightLinkOnClick))
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$insights),
						$elm$html$Html$text(insightLinkLabel)
					])));
		var stickyDropdownView = function (_v5) {
			var toOption = F4(
				function (icon, label, action, disabled) {
					return $author$project$Platform2$Dropdown$Item$view(
						A3(
							$author$project$Gwi$List$addIf,
							disabled,
							$author$project$Platform2$Dropdown$Item$onClick(config.pX),
							A3(
								$author$project$Gwi$List$addIf,
								!disabled,
								$author$project$Platform2$Dropdown$Item$onClick(action),
								_List_fromArray(
									[
										$author$project$Platform2$Dropdown$Item$class(
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['dropdown', 'options']),
											actionsClass)),
										$author$project$Platform2$Dropdown$Item$label(label),
										$author$project$Platform2$Dropdown$Item$leftIcon(icon),
										$author$project$Platform2$Dropdown$Item$disabled(disabled)
									]))));
				});
			var ddMenuId = 'sticky-header-dropdown-menu-id';
			var isDDOpen = A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				false,
				$author$project$Platform2$Dropdown$DropdownMenu$isVisible(ddMenuId),
				model.db);
			var canExport = flags.nM(15) && (($elm$core$List$length(currentDashboard.cl.g) > 0) && A2(
				$elm$core$List$any,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.cl;
					},
					$author$project$Dashboards2$Detail$isWidgetExportable(questions)),
				A2($elm$core$List$filterMap, $author$project$Data$Platform2$getChartWidget, currentDashboard.cl.g)));
			var options = $elm$core$List$reverse(
				A2(
					$elm$core$List$cons,
					A4(
						toOption,
						$author$project$Icons$Platform2$redo,
						'Redo',
						config.qI,
						!$author$project$UndoRedo$hasFuture(model.G)),
					A2(
						$elm$core$List$cons,
						A4(
							toOption,
							$author$project$Icons$Platform2$undo,
							'Undo',
							config.r7,
							!$author$project$UndoRedo$hasPast(model.G)),
						A2(
							$elm$core$List$cons,
							$author$project$Platform2$Dropdown$Item$separator(
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['dropdown', 'options']),
									actionsClass)),
							A2(
								$elm$core$List$cons,
								A4(toOption, $author$project$Icons$Platform2$refresh, 'Reset dashboard', config.qT, !resetButtonEnabled),
								A3(
									$author$project$Gwi$List$addIf,
									isInsightLinkVisible,
									A4(toOption, $author$project$Icons$Platform2$insights, insightLinkLabel, insightLinkOnClick, false),
									A2(
										$elm$core$List$cons,
										A4(toOption, $author$project$Icons$Platform2$export, 'Export', config.bi, !canExport),
										A3(
											$author$project$Gwi$List$addIf,
											canEditContentAndShare,
											A4(toOption, $author$project$Icons$Platform2$share, 'Share', config.rj, false),
											A3(
												$author$project$Gwi$List$addIf,
												canEditContentAndShare,
												A4(toOption, $author$project$Icons$Platform2$edit, 'Edit', config.qi, false),
												_List_fromArray(
													[
														A4(toOption, $author$project$Icons$Platform2$saveAsNew, 'Save as new', config.or, false)
													]))))))))));
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['dropdown', 'pill', 'trigger-button']),
						actionsClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$map,
						config.a,
						A2(
							$author$project$Platform2$Dropdown$DropdownMenu$with,
							config.nR,
							{
								U: A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
											_List_fromArray(
												['dynamic']),
											A2(
												$GlobalWebIndex$class_namespaces$WeakCss$addMany,
												_List_fromArray(
													['dropdown', 'options']),
												actionsClass))
										]),
									options),
								hn: _List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('active', isDDOpen)
											]),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['dropdown', 'pill', 'trigger-button', 'right-icon']),
											actionsClass))
									]),
								ho: _List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$ellipsisVertical)
									]),
								b: ddMenuId,
								im: 1,
								iF: 80,
								iG: 200
							}))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'is-edit-mode',
							$author$project$Dashboards2$Detail$isEditMode(editSection)),
							_Utils_Tuple2('in-sticky-header', inStickyHeader)
						]),
					actionBarClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'top', actionBarClass)
						]),
					_List_fromArray(
						[
							$author$project$Data$User$hasOpenAccessPlan(flags.mQ) ? A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['margin-for-oad-header']),
									$author$project$Dashboards2$Detail$moduleClass)
								]),
							_List_Nil) : A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									config.as($author$project$Dashboards2$Router$DashboardsList)),
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'back-btn', actionBarClass)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$arrowLeft)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('in-sticky', inStickyHeader)
										]),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'info', actionBarClass))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h1,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['info', 'header']),
											actionBarClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['info', 'header', 'name']),
													actionBarClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['info', 'header', 'name', 'hidden']),
															actionBarClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(currentDashboard.ld)
														])),
													A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['info', 'header', 'name', 'content']),
															actionBarClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(currentDashboard.ld)
														]))
												])),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											canRenameOrDelete && (!isViewOnlyMode),
											A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['info', 'header', 'rename-btn']),
														actionBarClass),
														$elm$html$Html$Events$onClick(
														config.qm(
															$author$project$Data$Platform2$fromFullyLoadedDashboard(currentDashboard)))
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$rename)
													]))),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!isViewOnlyMode,
											A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$withStates,
														_List_fromArray(
															[
																_Utils_Tuple2('is-favourite', currentDashboard.kN),
																_Utils_Tuple2('disabled', isDashboardNewAndUnsaved)
															]),
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['info', 'header', 'favourite-icon']),
															actionBarClass)),
														A2(
														$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
														!isDashboardNewAndUnsaved,
														$elm$html$Html$Events$onClick(
															config.b9(currentDashboard.b)))
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, favouriteIcon)
													]))),
											saveInfoView,
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											flags.nM(23) && A2($elm$core$List$member, 0, currentDashboard.oN),
											A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['info', 'header', 'copy-icon-wrapper']),
														actionBarClass)
													]),
												_List_fromArray(
													[
														$author$project$CoolTip$Platform2$view(
														{
															lm: $elm$core$Maybe$Nothing,
															lB: 5,
															mt: _List_Nil,
															mu: _List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			A2(
																			$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																			_List_fromArray(
																				['info', 'header', 'copy-icon']),
																			actionBarClass)
																		]),
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Icons$icon,
																			_List_fromArray(
																				[
																					$author$project$Icons$width(16),
																					$author$project$Icons$height(16)
																				]),
																			$author$project$Icons$Platform2$migrated)
																		]))
																]),
															mE: _List_Nil,
															mF: $elm$html$Html$text('Changes will not carry over to the old platform'),
															mL: $author$project$CoolTip$Normal,
															m2: _List_Nil
														})
													]))),
											A2($elm_community$html_extra$Html$Extra$viewIfLazy, inStickyHeader && ((!inEditMode) && (!isViewOnlyMode)), stickyDropdownView)
										]))
								])),
							A2(
							$elm_community$html_extra$Html$Extra$viewIfLazy,
							!inStickyHeader,
							$elm$core$Basics$always(
								A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											$GlobalWebIndex$class_namespaces$WeakCss$toClass(actionsClass)
										]),
									inEditMode ? _List_fromArray(
										[closeBtn, shareBtn, addDescriptionBtn, linkInsightBtn]) : (isViewOnlyMode ? _List_fromArray(
										[goToInsightBtn]) : (canEditContentAndShare ? _List_fromArray(
										[
											saveBtn,
											saveAsNewBtn(
											{gy: !saveBtnIsVisible}),
											editBtn,
											shareBtn,
											exportBtn,
											goToInsightBtn,
											resetBtn,
											undoRedoButtonsView
										]) : (canSaveFilters ? _List_fromArray(
										[
											saveBtn,
											saveAsNewBtn(
											{gy: !saveBtnIsVisible}),
											exportBtn,
											goToInsightBtn,
											resetBtn,
											undoRedoButtonsView
										]) : _List_fromArray(
										[
											saveAsNewBtn(
											{gy: true}),
											exportBtn,
											goToInsightBtn,
											resetBtn,
											undoRedoButtonsView
										])))))))
						]))
				]));
	});
var $author$project$Analytics$Place$DashboardBulkBar = 34;
var $author$project$Icons$Platform2$charts = {
	mr: $author$project$Icons$Platform2$path('M14.156 22.2l-.012-.001-3.544.001a.6.6 0 01-.6-.6v-5.333a.6.6 0 01.6-.6l2.956-.001V9.6a.6.6 0 01.6-.6h3.555a.6.6 0 01.6.6v2.733h2.956a.6.6 0 01.6.6V21.6a.6.6 0 01-.6.6h-7.111zm2.955-12h-2.355V21h2.355V10.2zm3.556 3.333H18.31V21h2.356v-7.467zm-7.112 3.334H11.2V21h2.355v-4.133z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$text = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M5.39597 2.61111C5.39597 2.2736 5.70297 2 6.08168 2H15.3143C15.693 2 16 2.2736 16 2.61111C16 2.94862 15.693 3.22222 15.3143 3.22222H6.08168C5.70297 3.22222 5.39597 2.94862 5.39597 2.61111Z'),
				$author$project$Icons$Platform2$path('M10.6659 2C11.0446 2 11.3517 2.2736 11.3517 2.61111V12.3889C11.3517 12.7264 11.0446 13 10.6659 13C10.2872 13 9.98022 12.7264 9.98022 12.3889V2.61111C9.98022 2.2736 10.2872 2 10.6659 2Z'),
				$author$project$Icons$Platform2$path('M3.40758 6.07397C3.78629 6.07397 4.09329 6.34758 4.09329 6.68509V12.3888C4.09329 12.7263 3.78629 12.9999 3.40758 12.9999C3.02887 12.9999 2.72186 12.7263 2.72186 12.3888V6.68509C2.72186 6.34758 3.02887 6.07397 3.40758 6.07397Z'),
				$author$project$Icons$Platform2$path('M0 6.68509C0 6.34758 0.307005 6.07397 0.685714 6.07397H6.12948C6.50819 6.07397 6.81519 6.34758 6.81519 6.68509C6.81519 7.02259 6.50819 7.2962 6.12948 7.2962H0.685714C0.307005 7.2962 0 7.02259 0 6.68509Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Detail$addWidgetBarView = F3(
	function (config, dashboard, _v0) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['edit-mode', 'add-widget-bar']),
					$author$project$Dashboards2$Detail$moduleClass)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Add to your dashboard:'),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['edit-mode', 'add-widget-bar', 'add-button', 'wrapper']),
							$author$project$Dashboards2$Detail$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['edit-mode', 'add-widget-bar', 'add-button']),
									$author$project$Dashboards2$Detail$moduleClass),
									$elm$html$Html$Events$onClick(
									A2(config.qc, dashboard, 34))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Chart'),
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$charts)
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['edit-mode', 'add-widget-bar', 'add-button', 'wrapper']),
							$author$project$Dashboards2$Detail$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['edit-mode', 'add-widget-bar', 'add-button']),
									$author$project$Dashboards2$Detail$moduleClass),
									$elm$html$Html$Events$onClick(
									A2(config.nm, $author$project$Dashboards2$Widget$RichText$empty, 34))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Text'),
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$text)
								]))
						]))
				]));
	});
var $author$project$Dashboards2$Detail$dashboardNotFoundView = function (id) {
	return $elm$html$Html$text(
		'Dashboard ' + ($author$project$Data$Id$unwrap(id) + ' not found!'));
};
var $author$project$Dashboards2$Widget$moduleClass = $GlobalWebIndex$class_namespaces$WeakCss$namespace('dashboard-widget-2');
var $elm_community$basics_extra$Basics$Extra$uncurry = F2(
	function (f, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		return A2(f, a, b);
	});
var $author$project$Dashboards2$Widget$DuplicateWidget = function (a) {
	return {$: 16, a: a};
};
var $author$project$Dashboards2$Widget$SaveBaseInheritance = function (a) {
	return {$: 10, a: a};
};
var $author$project$Platform2$Dropdown$ToBottomLeft = 1;
var $author$project$Dashboards2$Widget$ToggleEditDropdown = function (a) {
	return {$: 5, a: a};
};
var $author$project$CoolTip$TopRight = 1;
var $author$project$Icons$Platform2$blank = {
	mr: A2($elm$svg$Svg$path, _List_Nil, _List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$dropdownItemView = F2(
	function (_class, _v0) {
		var icon = _v0.a;
		var label = _v0.b;
		var action = _v0.c;
		return $author$project$Platform2$Dropdown$Item$view(
			_List_fromArray(
				[
					$author$project$Platform2$Dropdown$Item$class(_class),
					$author$project$Platform2$Dropdown$Item$onClick(action),
					$author$project$Platform2$Dropdown$Item$label(label),
					$author$project$Platform2$Dropdown$Item$leftIcon(icon)
				]));
	});
var $author$project$Dashboards2$Widget$getCurrentMetric = function (model) {
	var _v0 = model.ad;
	switch (_v0.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		default:
			var chartModelData = _v0.a;
			return A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.hr;
				},
				$author$project$Dashboards2$Widget$getChartModel(chartModelData));
	}
};
var $author$project$Platform2$Dropdown$Item$selected = function (selected_) {
	return function (config) {
		return _Utils_update(
			config,
			{aE: selected_});
	};
};
var $author$project$Icons$Platform2$trash = {
	mr: $author$project$Icons$Platform2$path('M11.778 10.602l.496-1.547a1.519 1.519 0 011.314-1.05L13.72 8h4.008c.616 0 1.165.371 1.4.932l.045.123.495 1.547h2.128a.65.65 0 01.089 1.296l-.089.006-.217-.001v9.534a2.563 2.563 0 01-2.401 2.558l-.163.005h-6.583a2.562 2.562 0 01-2.563-2.563l-.001-9.534h-.216a.65.65 0 01-.089-1.295l.089-.006h2.127zm8.5 1.302h-9.11l.001 9.533c0 .656.5 1.195 1.14 1.256l.122.006h6.583c.698 0 1.264-.565 1.264-1.262v-9.533zm-4.555 1.108a.65.65 0 01.645.562l.006.089v7.18a.651.651 0 01-1.296.089l-.006-.088v-7.181a.65.65 0 01.65-.651zm-2.602 1.012a.65.65 0 01.644.562l.006.089v5.253a.65.65 0 01-1.295.088l-.006-.088v-5.253a.65.65 0 01.65-.651zm5.204 0a.65.65 0 01.645.562l.006.089v5.253a.65.65 0 01-1.295.088l-.006-.088v-5.253a.65.65 0 01.65-.651zm-.598-4.723h-4.008a.22.22 0 00-.183.1l-.023.05-.369 1.151h5.157l-.368-1.15a.216.216 0 00-.151-.144l-.055-.007z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$ToBottomRight = 0;
var $author$project$Platform2$Dropdown$ToTopLeft = 2;
var $author$project$Platform2$Dropdown$ToTopRight = 3;
var $author$project$Platform2$Dropdown$Trigger$defaultConfig = {
	fs: $GlobalWebIndex$class_namespaces$WeakCss$namespace('dropdown'),
	jL: $elm$core$Maybe$Nothing,
	fI: false,
	h4: $elm_community$html_extra$Html$Extra$nothing,
	f5: $elm$core$Maybe$Nothing,
	gR: $elm$core$Maybe$Nothing
};
var $author$project$Platform2$Dropdown$Trigger$renderButton = F2(
	function (required, config) {
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2('open', required.p9),
							_Utils_Tuple2('disabled', config.fI)
						]),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'trigger-button', config.fs)),
					$elm$html$Html$Attributes$disabled(config.fI),
					$author$project$Gwi$Html$Events$onClickWithBodyDimensions(required.cL),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeMaybe,
					$elm$html$Html$Attributes$style('background-color'),
					config.jL)
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (leftIcon_) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['trigger-button', 'left-icon']),
									config.fs)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, leftIcon_)
								]));
					},
					config.f5),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['trigger-button', 'label']),
							config.fs)
						]),
					_List_fromArray(
						[config.h4])),
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (sublabel_) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['trigger-button', 'sublabel']),
									config.fs)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(sublabel_)
								]));
					},
					config.gR),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['trigger-button', 'right-icon']),
							config.fs),
							A2(
							$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
							required.p9,
							$elm$html$Html$Attributes$class(
								A2($elm$core$Maybe$withDefault, '', required.nf)))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Icons$icon,
							_List_Nil,
							required.p9 ? required.qq : required.n4)
						]))
				]));
	});
var $author$project$Platform2$Dropdown$Trigger$buttonWithBodyFenceView = F2(
	function (required, attributes) {
		return A2(
			$author$project$Platform2$Dropdown$Trigger$renderButton,
			required,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, config) {
						var attribute = _v0;
						return attribute(config);
					}),
				$author$project$Platform2$Dropdown$Trigger$defaultConfig,
				attributes));
	});
var $author$project$Platform2$Dropdown$Trigger$Attribute = $elm$core$Basics$identity;
var $author$project$Platform2$Dropdown$Trigger$class = function (class_) {
	return function (config) {
		return _Utils_update(
			config,
			{fs: class_});
	};
};
var $author$project$Platform2$Dropdown$expandToToString = function (expandTo) {
	switch (expandTo) {
		case 0:
			return 'bottom-right';
		case 1:
			return 'bottom-left';
		case 3:
			return 'top-right';
		default:
			return 'top-left';
	}
};
var $author$project$Platform2$Dropdown$Trigger$label = function (label_) {
	return function (config) {
		return _Utils_update(
			config,
			{h4: label_});
	};
};
var $author$project$Platform2$Dropdown$viewWithOrientationCustomOptions = F2(
	function (_v0, _v1) {
		var toggleMsg = _v0.mD;
		var label = _v0.h4;
		var _class = _v0.fs;
		var options = _v0.lr;
		var isSelected = _v0.pv;
		var screenBottomEdgeMinOffset = _v0.iF;
		var screenSideEdgeMinOffset = _v0.iG;
		var expandTo = _v1.oB;
		var openMsg = function (_v4) {
			var position = _v4.lB;
			var bodyDimensions = _v4.jw;
			var target = _v4.e$;
			var yTopSwaps = A2(
				$turboMaCk$any_dict$Dict$Any$fromList,
				$author$project$Platform2$Dropdown$expandToToString,
				_List_fromArray(
					[
						_Utils_Tuple2(2, 1),
						_Utils_Tuple2(3, 0)
					]));
			var yBottomSwaps = A2(
				$turboMaCk$any_dict$Dict$Any$fromList,
				$author$project$Platform2$Dropdown$expandToToString,
				_List_fromArray(
					[
						_Utils_Tuple2(1, 2),
						_Utils_Tuple2(0, 3)
					]));
			var xRightSwaps = A2(
				$turboMaCk$any_dict$Dict$Any$fromList,
				$author$project$Platform2$Dropdown$expandToToString,
				_List_fromArray(
					[
						_Utils_Tuple2(0, 1),
						_Utils_Tuple2(3, 2)
					]));
			var xLeftSwaps = A2(
				$turboMaCk$any_dict$Dict$Any$fromList,
				$author$project$Platform2$Dropdown$expandToToString,
				_List_fromArray(
					[
						_Utils_Tuple2(1, 0),
						_Utils_Tuple2(2, 3)
					]));
			var targetElement = function () {
				var element = target;
				return element;
			}();
			var swapIf = F3(
				function (condition, swapRules, current) {
					return condition ? A2(
						$elm$core$Maybe$withDefault,
						current,
						A2($turboMaCk$any_dict$Dict$Any$get, current, swapRules)) : current;
				});
			var expandTo_ = A3(
				swapIf,
				_Utils_cmp(position.m3, screenSideEdgeMinOffset) < 0,
				xLeftSwaps,
				A3(
					swapIf,
					_Utils_cmp((position.m3 + screenSideEdgeMinOffset) + targetElement.jJ, bodyDimensions.da) > 0,
					xRightSwaps,
					A3(
						swapIf,
						_Utils_cmp(position.m4, screenBottomEdgeMinOffset) < 0,
						yTopSwaps,
						A3(
							swapIf,
							_Utils_cmp((position.m4 + screenBottomEdgeMinOffset) + targetElement.jI, bodyDimensions.cv) > 0,
							yBottomSwaps,
							expandTo))));
			return toggleMsg(
				{oB: expandTo_});
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass(_class)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Platform2$Dropdown$Trigger$buttonWithBodyFenceView,
					{
						nf: $elm$core$Maybe$Just('active'),
						n4: $author$project$Icons$Platform2$ellipsisVertical,
						cL: openMsg,
						p9: isSelected,
						qq: $author$project$Icons$Platform2$ellipsisVertical
					},
					_List_fromArray(
						[
							$author$project$Platform2$Dropdown$Trigger$class(
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'pill', _class)),
							$author$project$Platform2$Dropdown$Trigger$label(label)
						])),
					A2(
					$elm_community$html_extra$Html$Extra$viewIfLazy,
					isSelected,
					function (_v2) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
									_List_fromArray(
										[
											$author$project$Platform2$Dropdown$expandToToString(expandTo)
										]),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'options', _class))
								]),
							options);
					})
				]));
	});
var $author$project$Dashboards2$Widget$viewEditButtons = F5(
	function (config, _v0, widget, maybeChartWidget, model) {
		var canAccessChartBuilder = _v0.jz;
		var hasSingleQuestion = function () {
			if (!maybeChartWidget.$) {
				var chartWidget = maybeChartWidget.a;
				return 1 === $turboMaCk$non_empty_list_alias$List$NonEmpty$length(
					$author$project$Data$Platform2$widgetDataQuestionCodes(chartWidget.cl));
			} else {
				return true;
			}
		}();
		var defaultMenuData = {oB: 1};
		var menuData = function () {
			var _v4 = model.w;
			switch (_v4.$) {
				case 0:
					return defaultMenuData;
				case 1:
					var data = _v4.a;
					return data;
				case 2:
					return defaultMenuData;
				case 3:
					return defaultMenuData;
				default:
					return defaultMenuData;
			}
		}();
		var ddMenuClass = A2(
			$GlobalWebIndex$class_namespaces$WeakCss$addMany,
			_List_fromArray(
				['header', 'buttons', 'dropdown']),
			$author$project$Dashboards2$Widget$moduleClass);
		var toDdItem = A2(
			$elm$core$Basics$composeR,
			$author$project$Platform2$Dropdown$dropdownItemView(
				A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'options', ddMenuClass)),
			$elm$core$Maybe$Just);
		var editTitleDescOption = A2(
			$elm$core$Maybe$andThen,
			function (chartWidget) {
				return toDdItem(
					_Utils_Tuple3(
						$author$project$Icons$Platform2$rename,
						'Edit title/description',
						config.qO(chartWidget)));
			},
			maybeChartWidget);
		var baseInheritanceButtons = function () {
			if (!maybeChartWidget.$) {
				var chartWidget = maybeChartWidget.a;
				var _v2 = function () {
					var _v3 = chartWidget.aU;
					if (_v3.$ === 1) {
						return _Utils_Tuple2(true, true);
					} else {
						var d = _v3.a;
						return _Utils_Tuple2(
							false,
							$elm_community$maybe_extra$Maybe$Extra$isJust(d.fp));
					}
				}();
				var baseInheritedFromChart = _v2.a;
				var canInheritFromChart = _v2.b;
				return _List_fromArray(
					[
						$author$project$Platform2$Dropdown$Item$separator(
						A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'options', ddMenuClass)),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'inactive-label', ddMenuClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$strong,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Base audience')
									]))
							])),
						$author$project$Platform2$Dropdown$Item$view(
						A3(
							$author$project$Gwi$List$addIf,
							baseInheritedFromChart,
							$author$project$Platform2$Dropdown$Item$onClick(
								config.a(
									$author$project$Dashboards2$Widget$SaveBaseInheritance(
										{hZ: false}))),
							_List_fromArray(
								[
									$author$project$Platform2$Dropdown$Item$class(
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'options', ddMenuClass)),
									$author$project$Platform2$Dropdown$Item$label('Inherited from dashboard'),
									$author$project$Platform2$Dropdown$Item$selected(!baseInheritedFromChart),
									$author$project$Platform2$Dropdown$Item$leftIcon($author$project$Icons$Platform2$blank)
								]))),
						canInheritFromChart ? $author$project$Platform2$Dropdown$Item$view(
						A3(
							$author$project$Gwi$List$addIf,
							!baseInheritedFromChart,
							$author$project$Platform2$Dropdown$Item$onClick(
								config.a(
									$author$project$Dashboards2$Widget$SaveBaseInheritance(
										{hZ: true}))),
							_List_fromArray(
								[
									$author$project$Platform2$Dropdown$Item$class(
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'options', ddMenuClass)),
									$author$project$Platform2$Dropdown$Item$label('Inherited  from chart '),
									$author$project$Platform2$Dropdown$Item$selected(baseInheritedFromChart),
									$author$project$Platform2$Dropdown$Item$leftIcon($author$project$Icons$Platform2$blank),
									$author$project$Platform2$Dropdown$Item$disabled(false)
								]))) : $author$project$CoolTip$Platform2$view(
						{
							lm: $elm$core$Maybe$Nothing,
							lB: 1,
							mt: _List_Nil,
							mu: _List_fromArray(
								[
									$author$project$Platform2$Dropdown$Item$view(
									_List_fromArray(
										[
											$author$project$Platform2$Dropdown$Item$class(
											A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'options', ddMenuClass)),
											$author$project$Platform2$Dropdown$Item$label('Inherited  from chart '),
											$author$project$Platform2$Dropdown$Item$leftIcon($author$project$Icons$Platform2$blank),
											$author$project$Platform2$Dropdown$Item$disabled(true)
										]))
								]),
							mE: _List_Nil,
							mF: $elm$html$Html$text('The selected chart doesn\'t contain a base audience'),
							mL: $author$project$CoolTip$Normal,
							m2: _List_Nil
						})
					]);
			} else {
				return _List_Nil;
			}
		}();
		var ddMenuOptions = _Utils_ap(
			$elm_community$maybe_extra$Maybe$Extra$values(
				_List_fromArray(
					[
						editTitleDescOption,
						A2(
						$elm$core$Maybe$andThen,
						function (currentMetric) {
							return ($elm_community$maybe_extra$Maybe$Extra$isJust(maybeChartWidget) && (canAccessChartBuilder && hasSingleQuestion)) ? toDdItem(
								_Utils_Tuple3(
									$author$project$Icons$Platform2$charts,
									'Preview in charts',
									config.eI(currentMetric))) : $elm$core$Maybe$Nothing;
						},
						$author$project$Dashboards2$Widget$getCurrentMetric(model)),
						toDdItem(
						_Utils_Tuple3(
							$author$project$Icons$Platform2$duplicate,
							'Duplicate',
							config.a(
								$author$project$Dashboards2$Widget$DuplicateWidget(widget)))),
						toDdItem(
						_Utils_Tuple3(
							$author$project$Icons$Platform2$trash,
							'Remove',
							config.qd(widget)))
					])),
			baseInheritanceButtons);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['header', 'buttons']),
					$author$project$Dashboards2$Widget$moduleClass),
					$elm$html$Html$Attributes$id(
					$author$project$Data$Id$unwrap(widget.b))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Platform2$Dropdown$viewWithOrientationCustomOptions,
					{
						fs: ddMenuClass,
						pv: $author$project$Dashboards2$Widget$isEditDropdown(model),
						h4: $elm_community$html_extra$Html$Extra$nothing,
						lr: ddMenuOptions,
						iF: $elm$core$List$length(ddMenuOptions) * 40,
						iG: 200,
						mD: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Widget$ToggleEditDropdown)
					},
					menuData)
				]));
	});
var $author$project$Dashboards2$Widget$viewButtons = F5(
	function (config, permissions, widget, chartWidget, model) {
		return permissions.kO ? A5(
			$author$project$Dashboards2$Widget$viewEditButtons,
			config,
			permissions,
			widget,
			$elm$core$Maybe$Just(chartWidget),
			model) : $elm_community$html_extra$Html$Extra$nothing;
	});
var $author$project$Dashboards2$Widget$developerBugView = F6(
	function (config, widget, maybeChartWidget, permissions, error, maybeModel) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						['error']),
					$author$project$Dashboards2$Widget$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', $author$project$Dashboards2$Widget$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'info-group']),
									$author$project$Dashboards2$Widget$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'question-name']),
											$author$project$Dashboards2$Widget$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm_community$html_extra$Html$Extra$viewMaybe,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.ld;
												},
												$elm$html$Html$text),
											maybeChartWidget)
										]))
								])),
							A2(
							$elm_community$html_extra$Html$Extra$viewMaybe,
							$elm_community$basics_extra$Basics$Extra$uncurry(
								A3($author$project$Dashboards2$Widget$viewButtons, config, permissions, widget)),
							A3($elm$core$Maybe$map2, $elm$core$Tuple$pair, maybeChartWidget, maybeModel))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							_List_fromArray(
								['error']),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'content', $author$project$Dashboards2$Widget$moduleClass))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(error)
						]))
				]));
	});
var $author$project$Dashboards2$Detail$gridItemWrapper = F3(
	function (_v0, widget, content) {
		var extraStates = _v0.hN;
		return A3(
			$elm$html$Html$Keyed$node,
			'div',
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_Utils_ap(
						_List_fromArray(
							[
								_Utils_Tuple2('height-2', widget.cv === 2),
								_Utils_Tuple2('height-1', widget.cv === 1),
								_Utils_Tuple2('width-1', widget.da === 1),
								_Utils_Tuple2('width-2', widget.da === 2),
								_Utils_Tuple2('width-3', widget.da === 3),
								_Utils_Tuple2('width-4', widget.da === 4)
							]),
						extraStates),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'grid-item', $author$project$Dashboards2$Detail$moduleClass)),
					$elm$html$Html$Attributes$id(
					$author$project$Dashboards2$Detail$widgetElementId(widget))
				]),
			content);
	});
var $author$project$Dashboards2$Detail$developerBugView = F4(
	function (config, widget, permissions, error) {
		var maybeChartWidget = $author$project$Data$Platform2$getChartWidget(widget);
		return A3(
			$author$project$Dashboards2$Detail$gridItemWrapper,
			{hN: _List_Nil},
			widget,
			_List_fromArray(
				[
					_Utils_Tuple2(
					$author$project$Data$Id$unwrap(widget.b),
					A6($author$project$Dashboards2$Widget$developerBugView, config, widget, maybeChartWidget, permissions, error, $elm$core$Maybe$Nothing))
				]));
	});
var $author$project$Dashboards2$Detail$dropElementId = function (id) {
	return 'dashboards2-dnd-drop-last-element-id-' + $author$project$Data$Id$unwrap(id);
};
var $author$project$Icons$Platform2$eye = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M16 9.25c3.224 0 6.609 2.523 8.551 5.985.265.476.265 1.054-.001 1.532-1.94 3.46-5.326 5.983-8.55 5.983-3.224 0-6.609-2.523-8.55-5.983-.267-.477-.267-1.057 0-1.535C9.392 11.773 12.778 9.25 16 9.25zm0 1.5c-2.607 0-5.542 2.188-7.24 5.215-.013.022-.013.047-.001.069 1.699 3.029 4.634 5.216 7.24 5.216 2.608 0 5.544-2.187 7.241-5.214.013-.023.013-.05.002-.07-1.7-3.028-4.635-5.216-7.242-5.216zm0 1.964c1.862 0 3.381 1.465 3.381 3.286 0 1.82-1.52 3.286-3.381 3.286-1.862 0-3.381-1.465-3.381-3.286 0-1.82 1.52-3.286 3.381-3.286zm0 1.43c-1.084 0-1.952.836-1.952 1.856s.868 1.857 1.952 1.857 1.952-.837 1.952-1.857-.868-1.857-1.952-1.857z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$transform('translate(-1132 -340) translate(1132 340)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Detail$getAudiencesReorderSystem = function (config) {
	return A2(
		$author$project$DragAndDrop$Reorder$create,
		config.qR,
		A2(
			$author$project$DragAndDrop$Reorder$hookCommandsOnReorderFinished,
			config.nC,
			$author$project$DragAndDrop$Reorder$freeMovement($author$project$DragAndDrop$Reorder$config)));
};
var $author$project$Dashboards2$Detail$getEditGridState = function (editSection) {
	if (editSection.$ === 1) {
		var r = editSection.a;
		return $elm$core$Maybe$Just(r);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Dashboards2$Detail$getDndInfo = F2(
	function (config, _v0) {
		var editSection = _v0.o;
		return A2(
			$elm$core$Maybe$andThen,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.fJ;
				},
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.k_;
					},
					config.dl.fX)),
			$author$project$Dashboards2$Detail$getEditGridState(editSection));
	});
var $author$project$Platform2$Drawers$SelectionPanel$All = 0;
var $author$project$CoolTip$BottomRight = 7;
var $author$project$Dashboards2$Detail$ChevronLeft = 0;
var $author$project$Dashboards2$Detail$ChevronRight = 1;
var $author$project$Platform2$Drawers$SelectionPanel$DatasetsDrawer = function (a) {
	return {$: 2, a: a};
};
var $author$project$Platform2$Drawers$SelectionPanel$LocationsDrawer = function (a) {
	return {$: 0, a: a};
};
var $author$project$Platform2$Drawers$SelectionPanel$LocationsList = 1;
var $author$project$Platform2$Drawers$SelectionPanel$NotTVEdit = 1;
var $author$project$Platform2$Drawers$SelectionPanel$ShowByComparison = 2;
var $author$project$Platform2$Drawers$SelectionPanel$WavesDrawer = function (a) {
	return {$: 1, a: a};
};
var $author$project$Gwi$List$appendIf = F3(
	function (cond, x, xs) {
		return cond ? _Utils_ap(
			xs,
			_List_fromArray(
				[x])) : xs;
	});
var $author$project$Dashboards2$UserFilters$baseAudienceInfo = function (userFilters) {
	var uf = userFilters;
	var sampleSize = function () {
		var _v0 = uf.aU;
		if (!_v0.$) {
			var sampleSize_ = _v0.a;
			return sampleSize_;
		} else {
			var audience = _v0.a;
			return audience.eQ;
		}
	}();
	return {
		jL: $author$project$Palette$filtersColorToHex(
			$author$project$Dashboards2$UserFilters$baseColor(userFilters)),
		ld: $author$project$Dashboards2$UserFilters$baseAudienceName(userFilters),
		eQ: sampleSize
	};
};
var $author$project$Icons$Platform2$category = {
	mr: $author$project$Icons$Platform2$path('M14.563 9c.5 0 .93.294 1.13.718h5.338c1.04 0 1.892.808 1.964 1.829l.005.14v9.344c0 1.04-.807 1.892-1.828 1.964l-.14.005H10.968c-1.04 0-1.892-.806-1.964-1.828L9 21.032v-9.344c0-1.04.807-1.892 1.828-1.964l.14-.005 1.026-.001c.2-.424.631-.718 1.131-.718zm-2.689 1.781h-.905c-.464 0-.848.35-.9.801l-.006.106v9.343c0 .465.35.848.8.9l.106.006H21.03c.465 0 .848-.35.9-.8l.006-.106v-9.343c0-.465-.35-.848-.8-.9l-.106-.007h-5.219v3.063c0 .364-.354.611-.686.508l-.082-.033-1.2-.6-1.2.6c-.328.164-.71-.046-.763-.393l-.006-.082-.001-3.063zm7.72 8.281c.293 0 .531.238.531.532 0 .264-.193.483-.445.524l-.086.007h-7.188c-.293 0-.531-.238-.531-.531 0-.264.193-.484.445-.525l.086-.007h7.188zm0-2.875c.293 0 .531.238.531.532 0 .264-.193.483-.445.524l-.086.007h-7.188c-.293 0-.531-.238-.531-.531 0-.264.193-.483.445-.525l.086-.007h7.188zm0-2.875c.293 0 .531.238.531.532 0 .264-.193.483-.445.524l-.086.007h-1.438c-.293 0-.531-.238-.531-.531 0-.264.193-.483.445-.525l.086-.007h1.438zm-5.031-3.25h-1.438c-.103 0-.187.085-.187.188l-.001 2.734.67-.334c.119-.06.255-.072.382-.036l.092.036.669.334V10.25c0-.086-.058-.159-.138-.18l-.05-.007z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$crossLarge = {
	mr: A3($author$project$Icons$Platform2$pathFillTransform, 'currentColor', 'translate(8 8)', 'M14.1993 0.308964C14.6112 -0.10296 15.2791 -0.10296 15.691 0.308964C16.0652 0.683152 16.0997 1.26922 15.7936 1.68183L15.681 1.8107L9.49339 8L15.691 14.1993C16.103 14.6112 16.103 15.2791 15.691 15.691C15.3168 16.0652 14.7308 16.0997 14.3182 15.7936L14.1893 15.681L8 9.49339L1.80068 15.691C1.38875 16.103 0.720889 16.103 0.308964 15.691C-0.0652243 15.3168 -0.0996513 14.7308 0.206365 14.3182L0.318987 14.1893L6.50661 8L0.308964 1.80068C-0.10296 1.38875 -0.10296 0.720889 0.308964 0.308964C0.683152 -0.0652233 1.26922 -0.0996511 1.68183 0.206362L1.8107 0.318988L8 6.50661L14.1993 0.308964Z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$fileSearch = {
	mr: $author$project$Icons$Platform2$path('M17.546 9c.475 0 .934.168 1.296.471l.13.12 2.013 2.013c.337.336.542.78.584 1.25l.008.177v2.257a.595.595 0 01-1.183.088l-.007-.088v-1.54h-2.252a1.306 1.306 0 01-1.3-1.18l-.006-.126-.001-2.253h-5.81a.829.829 0 00-.823.732l-.005.097v9.964c0 .425.32.775.731.823l.097.005H16a.596.596 0 01.088 1.184L16 23h-4.982a2.017 2.017 0 01-2.013-1.874L9 20.982v-9.964c0-1.066.826-1.94 1.874-2.013L11.018 9h6.528zm3.943 8.629a2.726 2.726 0 01.374 3.393l.963.963a.594.594 0 01-.768.904l-.073-.063-.963-.963-.075.05a2.732 2.732 0 11.541-4.285zm-3.02.84a1.542 1.542 0 001.959 2.363 1.577 1.577 0 00.219-.185l.012-.011a1.54 1.54 0 00.084-2.062l-.096-.105a1.54 1.54 0 00-2.178 0zm-.45-8.13v2.103c0 .051.033.095.08.11l.036.006h2.103l-.022-.03-.072-.083-2.012-2.013a.924.924 0 00-.113-.094z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Gwi$FormatNumber$formatD2SampleSize = A2(
	$elm$core$Basics$composeR,
	$elm$core$Basics$toFloat,
	$cuducos$elm_format_number$FormatNumber$format(
		_Utils_update(
			$author$project$Gwi$FormatNumber$defaultLocale,
			{
				jY: $cuducos$elm_format_number$FormatNumber$Locales$Exact(0),
				rN: ','
			})));
var $author$project$Icons$Platform2$group = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M16.822 8c1.24 0 2.245 1.005 2.245 2.245v2.687h2.688c1.188 0 2.16.924 2.24 2.092l.005.154v6.577C24 22.995 22.994 24 21.755 24h-6.577c-1.24 0-2.245-1.005-2.245-2.245l-.001-2.688h-2.687c-1.188 0-2.16-.923-2.24-2.091L8 16.822v-6.577C8 9.005 9.006 8 10.245 8zm4.933 6.135l-2.688-.001v2.688c0 1.189-.923 2.161-2.091 2.24l-.154.005h-2.688v2.688c0 .537.408.98.93 1.037l.114.006h6.577c.576 0 1.043-.467 1.043-1.043v-6.577c0-.576-.467-1.043-1.043-1.043zm-4.933-4.933h-6.577c-.576 0-1.043.467-1.043 1.043v6.577c0 .576.467 1.043 1.043 1.043h2.687v-2.687c0-1.189.924-2.161 2.092-2.24l.154-.005 2.687-.001v-2.687c0-.537-.407-.98-.93-1.037l-.113-.006zm1.043 4.932h-2.687c-.576 0-1.043.468-1.043 1.044l-.001 2.687h2.688c.538 0 .98-.407 1.037-.93l.006-.113v-2.688z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$transform('translate(-233 -740) translate(16 728) translate(217 12)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $elm$html$Html$header = _VirtualDom_node('header');
var $author$project$Icons$Platform2$info = {
	mr: $author$project$Icons$Platform2$path('M12 5.25a6.75 6.75 0 01.19 13.497l-.19.003a6.75 6.75 0 110-13.5zm0 1.165A5.584 5.584 0 006.415 12c0 3.084 2.5 5.585 5.577 5.585l.173-.002A5.586 5.586 0 0012 6.415zm0 5.003c.297 0 .542.222.578.509l.004.073v3.426a.582.582 0 01-1.16.073l-.004-.073v-2.844h-.103a.582.582 0 01-.578-.509L10.732 12c0-.297.222-.542.51-.578l.073-.004H12zm-.172-2.742l.082.005a.753.753 0 11-.165 0l.083-.005z'),
	e5: 24,
	mT: 0,
	mU: 0,
	e6: 24
};
var $author$project$Icons$Platform2$random = {
	mr: $author$project$Icons$Platform2$path('M17.67 17.204l.068.08 1.052 1.448c.108.148.27.246.448.274l.108.008 1.09-.005-.229-.23c-.228-.228-.251-.585-.068-.839l.068-.08c.229-.229.585-.252.839-.069l.08.069 1.334 1.333.008.008c.017.018.033.036.048.055l-.056-.063c.028.028.053.058.074.09.015.02.028.04.04.063l.01.02c.042.086.066.182.066.284 0 .077-.013.152-.037.22l-.031.074-.026.045c-.008.015-.018.029-.028.043l-.068.08-1.334 1.334c-.253.254-.665.254-.919 0-.228-.229-.251-.585-.068-.839l.068-.08.217-.218-1.072.005c-.579.002-1.128-.249-1.505-.682l-.108-.135-1.053-1.449c-.21-.29-.146-.696.144-.907.262-.19.617-.157.84.063zm3.376-6.732l.08.068 1.334 1.333c.129.13.192.3.19.468v.01c0 .219-.11.413-.278.53l-1.246 1.245c-.253.254-.665.254-.919 0-.228-.228-.251-.585-.068-.839l.068-.08.217-.217-1.078-.004c-.183 0-.357.072-.485.2l-.07.082-4.53 6.229c-.341.469-.868.763-1.44.81l-.172.007-2.652-.011c-.359-.002-.648-.294-.647-.653.002-.326.243-.596.557-.64l.096-.007 2.651.011c.183 0 .357-.072.484-.199l.071-.083 4.53-6.229c.34-.469.868-.763 1.44-.81l.173-.007 1.087.005-.232-.232c-.228-.228-.251-.584-.068-.838l.068-.08c.229-.23.585-.252.839-.07zm-8.398 1.214c.579-.002 1.128.249 1.504.681l.108.136 1.054 1.448c.21.29.147.697-.144.908-.261.19-.616.157-.839-.063l-.069-.08-1.053-1.448c-.108-.148-.27-.246-.447-.273l-.108-.009-2.652.011c-.358.002-.65-.288-.652-.647-.001-.327.238-.598.551-.645l.096-.008 2.651-.01z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $author$project$Dashboards2$Detail$rearrangeAudiencesOnboardingView = F3(
	function (config, store, isViewOnly) {
		var showOnboarding = function () {
			var _v1 = A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.bF;
				},
				store.jU);
			if (_v1.$ === 3) {
				var showAudiencesReorderingOnboarding = _v1.a.md;
				return showAudiencesReorderingOnboarding && (!isViewOnly);
			} else {
				return false;
			}
		}();
		var maybeCloseMsg = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Data$Platform2$mapDashboardsDoNotShowAgain(
					function (settings) {
						return _Utils_update(
							settings,
							{md: false});
					}),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Store$Platform2$SaveDashboardsUserSettings,
					A2($elm$core$Basics$composeR, $elm$core$List$singleton, config.l))),
			$krisajenkins$remotedata$RemoteData$toMaybe(store.jU));
		return A2(
			$elm_community$html_extra$Html$Extra$viewIfLazy,
			showOnboarding,
			function (_v0) {
				return A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (closeMsg) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'audiences-bar', 'controls', 'audiences-list', 'onboarding']),
									$author$project$Dashboards2$Detail$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'audiences-bar', 'controls', 'audiences-list', 'onboarding', 'animation']),
											$author$project$Dashboards2$Detail$moduleClass)
										]),
									_List_Nil),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'audiences-bar', 'controls', 'audiences-list', 'onboarding', 'new-badge']),
											$author$project$Dashboards2$Detail$moduleClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('New')
										])),
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'audiences-bar', 'controls', 'audiences-list', 'onboarding', 'title']),
											$author$project$Dashboards2$Detail$moduleClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('You can now rearrange your audiences 🎉')
										])),
									$elm$html$Html$text('Simply drag and drop the audience you wish to move; this will change the order of your audiences in the charts.'),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'audiences-bar', 'controls', 'audiences-list', 'onboarding', 'got-it']),
											$author$project$Dashboards2$Detail$moduleClass),
											$elm$html$Html$Events$onClick(closeMsg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Got it')
										]))
								]));
					},
					maybeCloseMsg);
			});
	});
var $author$project$Dashboards2$Detail$shouldBeChevronVisible = F2(
	function (chevronType, maybeViewport) {
		var isAtTheEnd = function (info) {
			if (chevronType === 1) {
				return _Utils_cmp(info.mX.m3 + info.mX.da, info.q7.da - 32) > -1;
			} else {
				return info.mX.m3 <= 0;
			}
		};
		if (!maybeViewport.$) {
			var viewport = maybeViewport.a;
			return !isAtTheEnd(viewport);
		} else {
			return false;
		}
	});
var $author$project$Dashboards2$Detail$showChevron = F5(
	function (className, display, chevronType, states, basesPanelScrolled) {
		var _v0 = (!chevronType) ? _Utils_Tuple2(
			$author$project$Icons$Platform2$chevronLeft,
			A2(
				$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
				_List_fromArray(
					['audiences-list', 'wrapper', 'chevron', 'left']),
				className)) : _Utils_Tuple2(
			$author$project$Icons$Platform2$chevronRight,
			A2(
				$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
				_List_fromArray(
					['audiences-list', 'wrapper', 'chevron', 'right']),
				className));
		var chevron = _v0.a;
		var chevronSpecificStyle = _v0.b;
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			display,
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(basesPanelScrolled),
						chevronSpecificStyle,
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						states,
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['audiences-list', 'wrapper', 'chevron']),
							className))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Icons$icon,
						_List_fromArray(
							[
								$author$project$Icons$height(32),
								$author$project$Icons$width(32)
							]),
						chevron)
					])));
	});
var $zwilias$elm_html_string$Html$String$strong = $zwilias$elm_html_string$Html$String$node('strong');
var $author$project$Icons$Platform2$sync = {
	mr: $author$project$Icons$Platform2$path('M21.742 15.072c.36.002.65.294.65.654-.008 1.76-.693 3.447-1.958 4.711-2.616 2.616-6.858 2.616-9.475 0-.094-.095-.186-.192-.274-.291l.002 1.119c0 .33-.245.602-.563.645l-.089.006c-.33 0-.602-.245-.645-.563l-.006-.088v-2.673c0-.33.245-.602.563-.645l.088-.006h2.673c.36 0 .652.291.652.651 0 .33-.245.602-.563.645l-.089.006h-1.08c.08.094.165.185.253.273 2.107 2.107 5.524 2.107 7.632 0 1.02-1.019 1.57-2.375 1.575-3.795.002-.36.295-.65.654-.649zm-1.308-4.11c.094.094.186.192.274.292v-1.12c0-.33.244-.602.562-.645l.089-.006c.33 0 .602.245.645.563l.006.088v2.673c0 .33-.245.602-.563.645l-.088.006h-2.674c-.36 0-.651-.291-.651-.651 0-.33.245-.602.563-.645l.088-.006 1.08-.003c-.081-.093-.165-.182-.252-.27-2.108-2.107-5.525-2.107-7.632 0-1.004 1.004-1.556 2.335-1.578 3.728-.006.36-.302.647-.662.641-.36-.005-.647-.302-.64-.661.027-1.728.713-3.383 1.958-4.629 2.617-2.616 6.859-2.616 9.475 0z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$dataSurvey = {
	mr: $author$project$Icons$Platform2$path('M9.56 14.848a.453.453 0 01.668.037.526.526 0 01-.035.71l-1.766 1.692a.453.453 0 01-.633 0l-.877-.841a.525.525 0 01-.035-.71.454.454 0 01.668-.037l.56.537zm7.217 1c.261 0 .473.225.473.502 0 .278-.212.503-.473.503H11.47c-.261 0-.473-.225-.473-.503 0-.277.212-.502.473-.502zm-8.493-5.081c.847 0 1.535.73 1.535 1.632 0 .9-.688 1.631-1.535 1.631S6.75 13.3 6.75 12.4s.687-1.632 1.534-1.632zm0 1.005c-.325 0-.589.281-.589.627 0 .345.264.626.59.626.324 0 .588-.28.588-.626s-.264-.627-.589-.627zm8.493.124c.261 0 .473.225.473.503 0 .277-.212.502-.473.502H11.47c-.261 0-.473-.225-.473-.502 0-.278.212-.503.473-.503zM8.284 6.815c.847 0 1.535.73 1.535 1.632 0 .9-.688 1.632-1.535 1.632S6.75 9.348 6.75 8.447c0-.901.687-1.632 1.534-1.632zm0 1.005c-.325 0-.589.281-.589.627 0 .345.264.626.59.626.324 0 .588-.28.588-.626s-.264-.627-.589-.627zm8.493.124c.261 0 .473.225.473.503 0 .277-.212.503-.473.503H11.47c-.261 0-.473-.226-.473-.503 0-.278.212-.503.473-.503z'),
	e5: 25,
	mT: 0,
	mU: 0,
	e6: 24
};
var $author$project$Icons$Platform2$locations = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M16 9c2.685 0 4.865 2.151 4.865 4.808 0 .288-.03.581-.09.879-.212 1.076-.784 2.183-1.622 3.296 2.3.484 3.847 1.483 3.847 2.809 0 1.875-3.16 3.123-7 3.123s-7-1.248-7-3.123c0-1.326 1.546-2.325 3.847-2.81-.838-1.112-1.41-2.219-1.623-3.295-.059-.298-.09-.59-.09-.879C11.135 11.151 13.316 9 16 9zm2.287 10.033l-.066.077c-.374.413-.76.803-1.148 1.165-.18.17-.35.32-.5.45l-.199.168c-.218.177-.53.177-.749 0l-.197-.167c-.152-.131-.32-.282-.501-.45-.517-.483-1.033-1.016-1.516-1.587l.3.345c-2.133.338-3.521 1.118-3.521 1.758 0 .916 2.575 1.933 5.81 1.933 3.234 0 5.81-1.017 5.81-1.933 0-.64-1.389-1.42-3.523-1.759zM16 10.19c-2.032 0-3.676 1.622-3.676 3.618 0 .209.023.425.067.648.21 1.066.902 2.254 1.928 3.464.45.533.935 1.033 1.42 1.486l.26.24.262-.24c.485-.453.97-.953 1.42-1.486l-.068.078.017-.018.051-.06c1.025-1.21 1.717-2.398 1.928-3.464.044-.223.066-.44.066-.648 0-1.996-1.644-3.618-3.675-3.618zm0 1.7c1.116 0 2.018.915 2.018 2.04 0 1.123-.902 2.039-2.018 2.039-1.116 0-2.018-.916-2.018-2.04s.901-2.04 2.018-2.04zm0 1.19c-.456 0-.829.378-.829.85 0 .47.374.85.829.85.455 0 .828-.38.828-.85 0-.472-.373-.85-.828-.85z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$transform('translate(-725 -130) translate(725 130)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$lock = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M12.292 3.699C12.173 1.639 10.297 0 8 0 5.627 0 3.702 1.75 3.702 3.906v1.825h-.206C2.118 5.731 1 6.747 1 8v5.731C1 14.984 2.118 16 3.496 16h9.008C13.883 16 15 14.984 15 13.731V8c0-1.253-1.117-2.269-2.496-2.269h-.206V3.906l-.006-.207zM11.6 6.994h.904c.61 0 1.106.45 1.106 1.006v5.731c0 .555-.495 1.006-1.106 1.006H3.496c-.61 0-1.106-.451-1.106-1.006V8c0-.555.496-1.006 1.106-1.006H11.6zm-.692-1.263V3.906c0-1.46-1.302-2.643-2.908-2.643-1.542 0-2.803 1.09-2.902 2.47l-.006.173v1.825h5.816z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Drawers$SelectionPanel$TVEdit = 0;
var $author$project$Platform2$Bubble$view = F2(
	function (cls, text) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass(cls)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(text)
				]));
	});
var $author$project$Platform2$Drawers$SelectionPanel$selectionInfoView = F4(
	function (cls, activeItemsNames, lockIcon, activeItemsCount) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'selection-info', cls)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['selection-info', 'items']),
							cls)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$String$join, ', ', activeItemsNames))
						])),
					function () {
					if (!lockIcon.$) {
						var lockIconHtml = lockIcon.a;
						return lockIconHtml;
					} else {
						return A2(
							$elm_community$html_extra$Html$Extra$viewMaybe,
							function (count) {
								return A2(
									$author$project$Platform2$Bubble$view,
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['selection-info', 'counter']),
										cls),
									$elm$core$String$fromInt(count));
							},
							activeItemsCount);
					}
				}()
				]));
	});
var $author$project$Platform2$Drawers$SelectionPanel$selectionInfoLocationsView = F5(
	function (cls, _v0, place, activeLocations, setOfAllLocationCodes) {
		var canEdit = _v0.he;
		var locationsShowingMode = _v0.pL;
		var newActiveLocations = function () {
			if ((!place) && $elm$core$List$isEmpty(activeLocations)) {
				return _List_fromArray(
					['Please select your location(s)']);
			} else {
				switch (locationsShowingMode) {
					case 0:
						return _List_fromArray(
							['All']);
					case 1:
						return A2(
							$elm$core$List$map,
							function ($) {
								return $.ld;
							},
							activeLocations);
					default:
						return A2(
							$turboMaCk$any_set$Set$Any$equal,
							$author$project$Data$Id$setFromList(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.bW;
									},
									activeLocations)),
							setOfAllLocationCodes) ? _List_fromArray(
							['All']) : A2(
							$elm$core$List$map,
							function ($) {
								return $.ld;
							},
							activeLocations);
				}
			}
		}();
		var lockIcon = canEdit ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$CoolTip$Platform2$view(
				{
					lm: $elm$core$Maybe$Nothing,
					lB: 5,
					mt: _List_Nil,
					mu: _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['selection-info', 'locked']),
									cls)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									$author$project$Icons$Platform2$lock)
								]))
						]),
					mE: _List_Nil,
					mF: $elm$html$Html$text('Locations can’t be changed'),
					mL: $author$project$CoolTip$Normal,
					m2: _List_Nil
				}));
		return A4(
			$author$project$Platform2$Drawers$SelectionPanel$selectionInfoView,
			cls,
			newActiveLocations,
			lockIcon,
			$elm$core$Maybe$Just(
				$elm$core$List$length(activeLocations)));
	});
var $author$project$Platform2$Drawers$SelectionPanel$selectionInfoTVChannelsView = F3(
	function (cls, place, activeChannels) {
		var names = ((!place) && $elm$core$List$isEmpty(activeChannels)) ? _List_fromArray(
			['Please select your channel(s)']) : A2(
			$elm$core$List$map,
			function ($) {
				return $.ld;
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.ld;
				},
				activeChannels));
		return A4(
			$author$project$Platform2$Drawers$SelectionPanel$selectionInfoView,
			cls,
			names,
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Just(
				$elm$core$List$length(activeChannels)));
	});
var $author$project$Gwi$String$fromHttpError = function (err) {
	switch (err.$) {
		case 0:
			var url = err.a;
			return 'Bad URL: ' + url;
		case 1:
			return 'Timeout';
		case 2:
			return 'Network error';
		case 3:
			var code = err.a;
			return 'Bad status code: ' + $elm$core$String$fromInt(code);
		default:
			var decodeError = err.a;
			return 'Bad payload (JSON decoding error): ' + decodeError;
	}
};
var $krisajenkins$remotedata$RemoteData$fromMaybe = F2(
	function (error, maybe) {
		if (maybe.$ === 1) {
			return $krisajenkins$remotedata$RemoteData$Failure(error);
		} else {
			var x = maybe.a;
			return $krisajenkins$remotedata$RemoteData$Success(x);
		}
	});
var $krisajenkins$remotedata$RemoteData$mapError = F2(
	function (f, data) {
		switch (data.$) {
			case 3:
				var x = data.a;
				return $krisajenkins$remotedata$RemoteData$Success(x);
			case 2:
				var e = data.a;
				return $krisajenkins$remotedata$RemoteData$Failure(
					f(e));
			case 1:
				return $krisajenkins$remotedata$RemoteData$Loading;
			default:
				return $krisajenkins$remotedata$RemoteData$NotAsked;
		}
	});
var $author$project$Data$Platform2$targetTimezoneLabel = F3(
	function (labels, timezones, targetTimezone) {
		if (!targetTimezone.$) {
			return labels.k$;
		} else {
			var timezoneCode = targetTimezone.a;
			var timezoneName = A2(
				$krisajenkins$remotedata$RemoteData$andThen,
				A2(
					$elm$core$Basics$composeR,
					$turboMaCk$any_dict$Dict$Any$get(timezoneCode),
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Maybe$map(
							function ($) {
								return $.ld;
							}),
						$krisajenkins$remotedata$RemoteData$fromMaybe('timezone name not found for the code'))),
				A2($krisajenkins$remotedata$RemoteData$mapError, $author$project$Gwi$String$fromHttpError, timezones));
			switch (timezoneName.$) {
				case 0:
					return $author$project$Data$Id$unwrap(timezoneCode) + ' - error getting timezone name';
				case 1:
					return $author$project$Data$Id$unwrap(timezoneCode) + ' - loading timezone name';
				case 2:
					var err = timezoneName.a;
					return $author$project$Data$Id$unwrap(timezoneCode) + (' - error getting timezone name: ' + err);
				default:
					var name = timezoneName.a;
					return labels.mj(name);
			}
		}
	});
var $author$project$Platform2$Drawers$SelectionPanel$selectionInfoTimezoneView = F3(
	function (cls, allTimezones, activeTimezone) {
		var activeTimezoneName = A3(
			$author$project$Data$Platform2$targetTimezoneLabel,
			{k$: 'Local time zone', mj: $elm$core$Basics$identity},
			allTimezones,
			activeTimezone);
		return A4(
			$author$project$Platform2$Drawers$SelectionPanel$selectionInfoView,
			cls,
			_List_fromArray(
				[activeTimezoneName]),
			$elm$core$Maybe$Nothing,
			$elm$core$Maybe$Nothing);
	});
var $author$project$Platform2$Drawers$SelectionPanel$selectionInfoWavesView = F3(
	function (cls, _v0, activeWaves) {
		var canEdit = _v0.he;
		var names = A2(
			$elm$core$List$map,
			function ($) {
				return $.ld;
			},
			A2(
				$elm$core$List$sortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.mk;
					},
					$elm$time$Time$posixToMillis),
				activeWaves));
		var lockIcon = canEdit ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
			$author$project$CoolTip$Platform2$view(
				{
					lm: $elm$core$Maybe$Nothing,
					lB: 5,
					mt: _List_Nil,
					mu: _List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['selection-info', 'locked']),
									cls)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									$author$project$Icons$Platform2$lock)
								]))
						]),
					mE: _List_Nil,
					mF: $elm$html$Html$text('Waves can’t be changed'),
					mL: $author$project$CoolTip$Normal,
					m2: _List_Nil
				}));
		return A4(
			$author$project$Platform2$Drawers$SelectionPanel$selectionInfoView,
			cls,
			names,
			lockIcon,
			$elm$core$Maybe$Just(
				$elm$core$List$length(names)));
	});
var $author$project$Icons$Platform2$time = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M16 8a8 8 0 1 1 0 16 8 8 0 1 1 0-16zm0 1.23a6.77 6.77 0 1 0 0 13.54 6.77 6.77 0 1 0 0-13.54zm-.23 1.835c.31 0 .568.232.609.532l.005.084v4.842l3.739 2.23c.267.16.37.49.251.77l-.038.074c-.16.268-.49.37-.769.252l-.075-.038-4.038-2.41c-.16-.095-.266-.256-.293-.436l-.007-.092v-5.192c0-.34.275-.616.615-.616z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$tv = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M20.737 21.87a.6.6 0 0 1 .373.762.6.6 0 0 1-.763.372c-2.56-.88-6.778-.88-9.337 0a.6.6 0 0 1-.763-.372.6.6 0 0 1 .373-.762c2.812-.968 7.304-.968 10.117 0zM20.97 9.4c1.097 0 1.986.89 1.986 1.987v6.775a1.99 1.99 0 0 1-1.986 1.987H10.387A1.99 1.99 0 0 1 8.4 18.162v-6.775c0-1.098.89-1.987 1.987-1.987zm0 1.2H10.387c-.435 0-.787.352-.787.787v6.775a.79.79 0 0 0 .787.787H20.97c.434 0 .786-.353.786-.787v-6.775c0-.435-.352-.787-.786-.787z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$waves = {
	mr: $author$project$Icons$Platform2$path('M15.829 9c.34 0 .615.275.615.615v5.599h5.599c.34 0 .615.275.615.615 0 3.771-3.057 6.829-6.83 6.829-3.77 0-6.828-3.058-6.828-6.83C9 12.059 12.057 9 15.829 9zm5.566 7.444h-4.951v4.95l.204-.025c2.504-.368 4.47-2.393 4.747-4.925zm-6.181-6.18c-2.803.305-4.984 2.68-4.984 5.565 0 2.884 2.181 5.26 4.984 5.566zm3.65 1.643c.488 0 .885.396.887.887 0 .489-.395.886-.884.888l-.1-.005a.8877.8877 0 01-.791-.883c0-.49.397-.887.887-.887zm2.903.014c.483-.003.875.388.877.87l-.005.099a.8734.8734 0 01-.868.778.8736.8736 0 01-.874-.874c0-.482.39-.873.87-.873zm-2.904-2.907c.483 0 .874.39.874.87.002.484-.39.877-.873.877l-.096-.005a.8737.8737 0 01-.779-.869c0-.482.392-.873.874-.873z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Drawers$SelectionPanel$view = F3(
	function (moduleClass, place, drawers) {
		var iconView = function (iconData) {
			return A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'icon', moduleClass)
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Icons$icon,
						_List_fromArray(
							[
								$author$project$Icons$width(32)
							]),
						iconData)
					]));
		};
		var containerView = F3(
			function (_v1, lockedTooltip, openDrawer) {
				var locked = _v1.dA;
				return $elm$html$Html$button(
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('locked', locked)
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'container', moduleClass)),
							A2(
							$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
							locked,
							A2(
								$elm_community$html_extra$Html$Attributes$Extra$attributeMaybe,
								$elm$html$Html$Attributes$attribute('data-title'),
								lockedTooltip)),
							A2(
							$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
							!locked,
							$elm$html$Html$Events$onClick(openDrawer)),
							$elm$html$Html$Attributes$disabled(locked)
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass(moduleClass)
				]),
			A2(
				$elm$core$List$map,
				function (drawer) {
					switch (drawer.$) {
						case 0:
							var openDrawer = drawer.a.ik;
							var canEdit = drawer.a.he;
							var disabledTooltip = drawer.a.j0;
							var activeLocations = drawer.a.ng;
							var allLocations = drawer.a.nn;
							var locationsShowingMode = drawer.a.pL;
							return A4(
								containerView,
								{dA: !canEdit},
								disabledTooltip,
								openDrawer,
								_List_fromArray(
									[
										iconView($author$project$Icons$Platform2$locations),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'label', moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Locations')
											])),
										A5(
										$author$project$Platform2$Drawers$SelectionPanel$selectionInfoLocationsView,
										moduleClass,
										{he: canEdit, pL: locationsShowingMode},
										place,
										activeLocations,
										allLocations)
									]));
						case 1:
							var openDrawer = drawer.a.ik;
							var canEdit = drawer.a.he;
							var disabledTooltip = drawer.a.j0;
							var activeWaves = drawer.a.nj;
							return A4(
								containerView,
								{dA: !canEdit},
								disabledTooltip,
								openDrawer,
								_List_fromArray(
									[
										iconView($author$project$Icons$Platform2$waves),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'label', moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Waves')
											])),
										A3(
										$author$project$Platform2$Drawers$SelectionPanel$selectionInfoWavesView,
										moduleClass,
										{he: canEdit},
										activeWaves)
									]));
						case 3:
							var openDrawer = drawer.a.ik;
							var activeChannels = drawer.a.nd;
							return A4(
								containerView,
								{dA: false},
								$elm$core$Maybe$Nothing,
								openDrawer,
								_List_fromArray(
									[
										iconView($author$project$Icons$Platform2$tv),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'label', moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Channels')
											])),
										A3($author$project$Platform2$Drawers$SelectionPanel$selectionInfoTVChannelsView, moduleClass, place, activeChannels)
									]));
						case 4:
							var openDrawer = drawer.a.ik;
							var allTimezones = drawer.a.no;
							var activeTimezone = drawer.a.ni;
							return A4(
								containerView,
								{dA: false},
								$elm$core$Maybe$Nothing,
								openDrawer,
								_List_fromArray(
									[
										iconView($author$project$Icons$Platform2$time),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'label', moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Time zone')
											])),
										A3($author$project$Platform2$Drawers$SelectionPanel$selectionInfoTimezoneView, moduleClass, allTimezones, activeTimezone)
									]));
						default:
							var openDrawer = drawer.a.ik;
							var canEdit = drawer.a.he;
							var selectedDatasets = drawer.a.l7;
							return A4(
								containerView,
								{dA: !canEdit},
								$elm$core$Maybe$Nothing,
								openDrawer,
								_List_fromArray(
									[
										iconView($author$project$Icons$Platform2$dataSurvey),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'label', moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Datasets')
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'selection-info', moduleClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['selection-info', 'items']),
														moduleClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														A2($elm$core$String$join, ', ', selectedDatasets))
													])),
												canEdit ? A2(
												$author$project$Platform2$Bubble$view,
												A2(
													$GlobalWebIndex$class_namespaces$WeakCss$addMany,
													_List_fromArray(
														['selection-info', 'counter']),
													moduleClass),
												$elm$core$String$fromInt(
													$elm$core$List$length(selectedDatasets))) : $author$project$CoolTip$Platform2$view(
												{
													lm: $elm$core$Maybe$Nothing,
													lB: 5,
													mt: _List_Nil,
													mu: _List_fromArray(
														[
															A2(
															$elm$html$Html$span,
															_List_fromArray(
																[
																	A2(
																	$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																	_List_fromArray(
																		['selection-info', 'locked']),
																	moduleClass)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Icons$icon,
																	_List_fromArray(
																		[
																			$author$project$Icons$width(32)
																		]),
																	$author$project$Icons$Platform2$lock)
																]))
														]),
													mE: _List_Nil,
													mF: $elm$html$Html$text('Dataset can’t be changed'),
													mL: $author$project$CoolTip$Normal,
													m2: _List_Nil
												})
											]))
									]));
					}
				},
				$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(drawers)));
	});
var $author$project$Icons$Platform2$checkboxCrossed = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A3($author$project$Icons$Platform2$pathFillTransform, 'currentColor', 'translate(-16 -430) translate(0 422) translate(16 8) translate(8 8)', 'M14.519 2.758c.085.231.131.481.131.742v9c0 1.187-.962 2.15-2.15 2.15h-9c-.261 0-.511-.047-.743-.132l1.168-1.168H12.5c.433 0 .79-.324.843-.743l.007-.107V3.926zM12.5 1.35c.322 0 .628.071.903.198L12.3 2.65H3.5c-.433 0-.79.325-.843.743L2.65 3.5v8.8l-1.102 1.103c-.107-.23-.174-.484-.193-.75L1.35 12.5v-9c0-1.187.963-2.15 2.15-2.15z'),
				A3($author$project$Icons$Platform2$pathFillTransform, 'currentColor', 'translate(-16 -430) translate(0 422) translate(16 8) translate(8 8)', 'M1.239 14.787L14.787 1.24c.284-.283.284-.743 0-1.026-.283-.284-.743-.284-1.026 0L.213 13.76c-.284.283-.284.743 0 1.026.283.284.743.284 1.026 0z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$checkboxFilled = {
	mr: $author$project$Icons$Platform2$path('M21 9c1.105 0 2 .895 2 2v10c0 1.105-.895 2-2 2H11c-1.105 0-2-.895-2-2V11c0-1.105.895-2 2-2h10zm-1.248 4.793c-.252-.26-.667-.266-.928-.014L14.77 17.71l-1.593-1.546-.075-.062a.655.655 0 00-.853.077c-.253.26-.246.675.014.927l2.05 1.99.081.066c.254.177.604.155.833-.067l4.512-4.375.065-.072c.194-.254.179-.62-.05-.856z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$checkboxUnfilled = {
	mr: $author$project$Icons$Platform2$path('M20.5 9.35h-9c-1.187 0-2.15.963-2.15 2.15v9c0 1.187.963 2.15 2.15 2.15h9c1.188 0 2.15-.963 2.15-2.15v-9c0-1.187-.962-2.15-2.15-2.15zm-9 1.3h9c.47 0 .85.38.85.85v9c0 .47-.38.85-.85.85h-9c-.469 0-.85-.381-.85-.85v-9c0-.469.381-.85.85-.85z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Search$checkEmpty = F2(
	function (needle, fc) {
		return $elm$core$String$isEmpty(needle) ? $elm$core$Basics$identity : fc;
	});
var $author$project$Search$sanitizedMatch = function (needle) {
	return A2(
		$elm$core$Basics$composeL,
		$elm$core$String$contains(
			$elm$core$String$toLower(needle)),
		$elm$core$String$toLower);
};
var $author$project$Search$match_ = F2(
	function (getter, needle) {
		return A2(
			$elm$core$Basics$composeL,
			$author$project$Search$sanitizedMatch(needle),
			getter);
	});
var $author$project$Search$filter = F2(
	function (getter, needle) {
		return A2(
			$author$project$Search$checkEmpty,
			needle,
			$elm$core$List$filter(
				A2($author$project$Search$match_, getter, needle)));
	});
var $elm$html$Html$footer = _VirtualDom_node('footer');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$html$Html$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $elm$html$Html$Events$onInput = function (tagger) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $elm$html$Html$Events$targetValue)));
};
var $elm$html$Html$Attributes$placeholder = $elm$html$Html$Attributes$stringProperty('placeholder');
var $author$project$Icons$Platform2$search = {
	mr: $author$project$Icons$Platform2$path('M23.8935 23.5003C24.0801 23.1481 24.0258 22.7024 23.7291 22.4041L19.1869 17.8405L19.2746 17.726C20.0157 16.6941 20.4223 15.4568 20.4223 14.1585C20.4223 10.7566 17.6414 8 14.2112 8C10.7809 8 8 10.7566 8 14.1585C8 17.5599 10.7813 20.317 14.2112 20.317L14.5548 20.3077L14.9325 20.2758C15.9334 20.1609 16.8806 19.8082 17.7049 19.251L17.8392 19.1531L22.3849 23.723L22.5009 23.8215L22.6333 23.8998C22.9962 24.0783 23.4297 24.0158 23.7198 23.7322L23.8122 23.6275L23.8935 23.5003ZM9.88966 14.1585C9.88966 11.7937 11.8238 9.87653 14.2112 9.87653C16.5985 9.87653 18.5327 11.7937 18.5327 14.1585C18.5327 16.5227 16.5981 18.4404 14.2112 18.4404C11.8242 18.4404 9.88966 16.5227 9.88966 14.1585Z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $elm$html$Html$Attributes$value = $elm$html$Html$Attributes$stringProperty('value');
var $author$project$Platform2$SelectableList$view = F2(
	function (className, config) {
		var itemsToShow = function () {
			var _v0 = config.cW;
			if (!_v0.$) {
				var term = _v0.a;
				return A3(
					$author$project$Search$filter,
					function ($) {
						return $.h4;
					},
					term,
					config.f2);
			} else {
				return config.f2;
			}
		}();
		var itemView = function (item) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2('selected', item.pv),
								_Utils_Tuple2('disabled', item.fI)
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['selectable-list', 'items', 'item']),
							className)),
						$elm$html$Html$Attributes$disabled(item.fI),
						$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
						config.r6(item.kS))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['selectable-list', 'items', 'item', 'checkbox']),
								className)
							]),
						_List_fromArray(
							[
								item.pv ? A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$checkboxFilled) : (item.fI ? A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$checkboxCrossed) : A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$checkboxUnfilled))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['selectable-list', 'items', 'item', 'label']),
								className)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(item.h4)
							]))
					]));
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'selectable-list', className),
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(config.y)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['selectable-list', 'search']),
							className)
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$search),
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['selectable-list', 'search', 'input']),
									className),
									$elm$html$Html$Events$onInput(config.go),
									A2($elm_community$html_extra$Html$Attributes$Extra$attributeMaybe, $elm$html$Html$Attributes$value, config.cW),
									$elm$html$Html$Attributes$placeholder(config.cO)
								]),
							_List_Nil)
						])),
					$elm$core$List$isEmpty(itemsToShow) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['selectable-list', 'items']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['selectable-list', 'items', 'empty']),
									className)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Nothing found')
								]))
						])) : A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['selectable-list', 'items']),
							className)
						]),
					A2($elm$core$List$map, itemView, itemsToShow)),
					A2(
					$elm$html$Html$footer,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['selectable-list', 'footer']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['selectable-list', 'footer', 'selection-info']),
									className)
								]),
							_List_fromArray(
								[config.re])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['selectable-list', 'footer', 'button']),
									className),
									$elm$html$Html$Events$onClick(config.n2)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Close')
								]))
						]))
				]));
	});
var $author$project$Dashboards2$Detail$headerView = F5(
	function (config, flags, headerViewConfig, store, model) {
		var userFilters = headerViewConfig.bz;
		var allDatasets = headerViewConfig.fg;
		var allLocations = headerViewConfig.nn;
		var allWaves = headerViewConfig.np;
		var currentDashboard = headerViewConfig.em;
		var editSection = headerViewConfig.o;
		var userFiltersAudiences = $author$project$Dashboards2$UserFilters$audiences(userFilters);
		var shouldShowFullAddAudienceButton = $elm$core$List$isEmpty(userFiltersAudiences);
		var selectedWaves = $turboMaCk$any_dict$Dict$Any$values(
			A2(
				$turboMaCk$any_dict$Dict$Any$filter,
				F2(
					function (k, _v28) {
						return A2(
							$turboMaCk$any_set$Set$Any$member,
							k,
							$author$project$Dashboards2$UserFilters$waves(userFilters));
					}),
				allWaves));
		var selectedLocations = $turboMaCk$any_dict$Dict$Any$values(
			A2(
				$turboMaCk$any_dict$Dict$Any$filter,
				F2(
					function (k, _v27) {
						return A2(
							$turboMaCk$any_set$Set$Any$member,
							k,
							$author$project$Dashboards2$UserFilters$locations(userFilters));
					}),
				allLocations));
		var selectedDatasetNames = A2(
			$elm$core$List$map,
			function ($) {
				return $.ld;
			},
			A2(
				$elm$core$List$filterMap,
				function (code) {
					return A2($turboMaCk$any_dict$Dict$Any$get, code, allDatasets);
				},
				currentDashboard.es));
		var isViewOnlyMode = $author$project$Data$User$hasViewOnlyPlan(flags.mQ);
		var locationsShowingMode = function () {
			var shouldShowAll = A2(
				$elm$core$Maybe$withDefault,
				false,
				A2($turboMaCk$any_dict$Dict$Any$get, currentDashboard.b, store.rm));
			return isViewOnlyMode ? (shouldShowAll ? 0 : 1) : 2;
		}();
		var isEditing = !_Utils_eq(editSection, $author$project$Dashboards2$Detail$NotEditing);
		var inEditMode = $author$project$Dashboards2$Detail$isEditMode(editSection);
		var drawersPanelData = _Utils_Tuple2(
			$author$project$Platform2$Drawers$SelectionPanel$DatasetsDrawer(
				{he: (!isViewOnlyMode) && isEditing, ik: config.qe, l7: selectedDatasetNames}),
			_List_fromArray(
				[
					$author$project$Platform2$Drawers$SelectionPanel$WavesDrawer(
					{nj: selectedWaves, he: !isViewOnlyMode, j0: $elm$core$Maybe$Nothing, ik: config.qp}),
					$author$project$Platform2$Drawers$SelectionPanel$LocationsDrawer(
					{
						ng: selectedLocations,
						nn: $author$project$Data$Id$keysToSet(allLocations),
						he: !isViewOnlyMode,
						j0: $elm$core$Maybe$Nothing,
						pL: locationsShowingMode,
						ik: config.qj
					})
				]));
		var coloredAudiences = $author$project$Dashboards2$UserFilters$audiencesWithColor(userFilters);
		var showAudiencesContainer = !(isViewOnlyMode && $elm$core$List$isEmpty(coloredAudiences));
		var categoriesView = function (_v26) {
			var categories = $author$project$Data$Platform2$getCategories(currentDashboard.ac);
			return A2(
				$elm_community$html_extra$Html$Extra$viewIfLazy,
				!$elm$core$List$isEmpty(categories),
				function (_v25) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'bottom', $author$project$Dashboards2$Detail$headerClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
										_List_fromArray(
											['ready-only-mode']),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['bottom', 'added-categories']),
											$author$project$Dashboards2$Detail$headerClass))
									]),
								A2(
									$elm$core$List$map,
									function (category) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
													_List_fromArray(
														['ready-only-mode']),
													A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['bottom', 'added-categories', 'pill']),
														$author$project$Dashboards2$Detail$headerClass))
												]),
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$category),
													$elm$html$Html$text(category.ld)
												]));
									},
									categories))
							]));
				});
		};
		var baseName = $author$project$Dashboards2$UserFilters$baseAudienceName(userFilters);
		var baseAudienceInfo = $author$project$Dashboards2$UserFilters$baseAudienceInfo(userFilters);
		var audiencesReorderSystem = $author$project$Dashboards2$Detail$getAudiencesReorderSystem(config);
		var audiencesCount = $elm$core$List$length(userFiltersAudiences);
		var canShowSmallAddAudienceButton = (!isViewOnlyMode) && (_Utils_cmp(audiencesCount, $author$project$Dashboards2$UserFilters$maxNumberOfAudiences) < 0);
		var audiencesBarClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'audiences-bar', $author$project$Dashboards2$Detail$headerClass);
		var audiencesClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'audiences', audiencesBarClass);
		var audiencesControlsClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'controls', audiencesBarClass);
		var dropdownMenuClass = A2(
			$GlobalWebIndex$class_namespaces$WeakCss$addMany,
			_List_fromArray(
				['dropdown', 'options']),
			audiencesControlsClass);
		var smallAddAudienceButtonView = function (_v24) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'add-audience-small-btn', audiencesControlsClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['add-audience-small-btn', 'button']),
								audiencesControlsClass),
								$elm$html$Html$Events$onClick(
								config.qa(
									{dt: false}))
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$plusSign)
							]))
					]));
		};
		var audienceVisibilityItem = F2(
			function (id, isHidden) {
				var _v23 = isHidden ? _Utils_Tuple2($author$project$Icons$Platform2$eye, 'Show') : _Utils_Tuple2($author$project$Icons$Platform2$eyeCrossed, 'Hide');
				var icon = _v23.a;
				var label = _v23.b;
				return $author$project$Platform2$Dropdown$Item$view(
					_List_fromArray(
						[
							$author$project$Platform2$Dropdown$Item$class(dropdownMenuClass),
							$author$project$Platform2$Dropdown$Item$label(label),
							$author$project$Platform2$Dropdown$Item$onClick(
							config.r4(id)),
							$author$project$Platform2$Dropdown$Item$leftIcon(icon)
						]));
			});
		var viewPill = F3(
			function (_v22, index, colored) {
				var inStickyHeader = _v22.ar;
				var htmlId = 'dashboard-audience-pill-id-' + $author$project$Data$Id$unwrap(colored.fk.b);
				var color = $author$project$Palette$filtersColorToHex(colored.jL);
				var _v18 = function () {
					var _v19 = audiencesReorderSystem.fX(headerViewConfig.d8);
					if (!_v19.$) {
						var dragIndex = _v19.a.j2;
						return _Utils_Tuple2(
							(!_Utils_eq(dragIndex, index)) ? A2(
								$elm$core$List$cons,
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
									_List_fromArray(
										['reordering']),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'audience-pill-wrapper', audiencesControlsClass)),
								A2(
									$elm$core$List$cons,
									A2($elm$html$Html$Attributes$style, 'background-color', color),
									A2(
										$elm$core$List$map,
										$elm$html$Html$Attributes$map(config.a),
										A2(audiencesReorderSystem.hJ, index, htmlId)))) : _List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
									_List_fromArray(
										['dragged']),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'audience-pill-wrapper', audiencesControlsClass))
								]),
							_List_Nil);
					} else {
						return _Utils_Tuple2(
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('view-only', isViewOnlyMode)
										]),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'audience-pill-wrapper', audiencesControlsClass)),
									A2($elm$html$Html$Attributes$style, 'background-color', color),
									A2(
									$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
									!isViewOnlyMode,
									A2($elm$html$Html$Attributes$attribute, 'data-title', colored.fk.ld))
								]),
							A2(
								$elm$core$List$map,
								$elm$html$Html$Attributes$map(config.a),
								A2(audiencesReorderSystem.oo, index, htmlId)));
					}
				}();
				var itemAttributes = _v18.a;
				var dndEvents = _v18.b;
				return A2(
					$elm$html$Html$div,
					A2(
						$elm$core$List$cons,
						$elm$html$Html$Attributes$id(htmlId),
						itemAttributes),
					_List_fromArray(
						[
							function () {
							var sampleSize = A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								'0',
								$author$project$Gwi$FormatNumber$formatD2SampleSize,
								$krisajenkins$remotedata$RemoteData$toMaybe(colored.fk.eQ));
							var labelHtmlId = 'label--' + htmlId;
							var dndAttributes = isViewOnlyMode ? _List_Nil : dndEvents;
							var ddMenuId = 'audience-pill--' + htmlId;
							var isDDOpen = A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								false,
								$author$project$Platform2$Dropdown$DropdownMenu$isVisible(ddMenuId),
								model.db);
							var audienceNameView = A2(
								$elm$html$Html$div,
								_Utils_ap(
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['audience', 'label', 'text']),
											audiencesControlsClass),
											$elm$html$Html$Attributes$id(labelHtmlId)
										]),
									dndAttributes),
								_List_fromArray(
									[
										$elm$html$Html$text(colored.fk.ld)
									]));
							var additionalAttributes = isViewOnlyMode ? _List_fromArray(
								[
									$elm$html$Html$Events$onClick(
									config.a(
										config.qx(colored.fk))),
									$elm$html$Html$Attributes$title('Preview audience')
								]) : _List_Nil;
							return A2(
								$elm$html$Html$div,
								A2(
									$elm$core$List$cons,
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('open', isDDOpen),
												_Utils_Tuple2('in-sticky-header', inStickyHeader),
												_Utils_Tuple2('view-only', isViewOnlyMode)
											]),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['pill']),
											audiencesControlsClass)),
									additionalAttributes),
								_List_fromArray(
									[
										(inStickyHeader || ($elm$core$String$length(colored.fk.ld) < 20)) ? audienceNameView : $author$project$CoolTip$Platform2$view(
										{
											lm: $elm$core$Maybe$Nothing,
											lB: 0,
											mt: _List_Nil,
											mu: _List_fromArray(
												[audienceNameView]),
											mE: _List_Nil,
											mF: $elm$html$Html$text(colored.fk.ld),
											mL: $author$project$CoolTip$NormalShownWhenEllipsis('#' + labelHtmlId),
											m2: _List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nest,
													'tooltip',
													A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['audience', 'label', 'text']),
														audiencesControlsClass))
												])
										}),
										A2(
										$elm_community$html_extra$Html$Extra$viewIfLazy,
										!inStickyHeader,
										function (_v20) {
											return A2(
												$elm$html$Html$span,
												_Utils_ap(
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['audience', 'label', 'size']),
															audiencesControlsClass)
														]),
													dndAttributes),
												_List_fromArray(
													[
														$elm$html$Html$text('(' + (sampleSize + ')'))
													]));
										}),
										A2(
										$elm_community$html_extra$Html$Extra$viewIf,
										!isViewOnlyMode,
										A2(
											$elm$html$Html$map,
											config.a,
											A2(
												$author$project$Platform2$Dropdown$DropdownMenu$with,
												config.nR,
												{
													U: A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
																_List_fromArray(
																	['dynamic']),
																dropdownMenuClass)
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		A2(
																		$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																		_List_fromArray(
																			['dropdown', 'menu']),
																		$author$project$Dashboards2$Detail$moduleClass)
																	]),
																A3(
																	$author$project$Gwi$List$appendIf,
																	true,
																	$author$project$Platform2$Dropdown$Item$view(
																		_List_fromArray(
																			[
																				$author$project$Platform2$Dropdown$Item$class(dropdownMenuClass),
																				$author$project$Platform2$Dropdown$Item$label('Remove'),
																				$author$project$Platform2$Dropdown$Item$onClick(
																				config.qN(index)),
																				$author$project$Platform2$Dropdown$Item$leftIcon($author$project$Icons$Platform2$trash)
																			])),
																	A3(
																		$author$project$Gwi$List$appendIf,
																		flags.nM(25) && $elm_community$maybe_extra$Maybe$Extra$isJust(
																			A2($author$project$Store$Utils$get, store.d9, colored.fk.b)),
																		$author$project$Platform2$Dropdown$Item$view(
																			_List_fromArray(
																				[
																					$author$project$Platform2$Dropdown$Item$class(dropdownMenuClass),
																					$author$project$Platform2$Dropdown$Item$label('Edit'),
																					$author$project$Platform2$Dropdown$Item$onClick(
																					config.fM(colored.fk.b)),
																					$author$project$Platform2$Dropdown$Item$leftIcon($author$project$Icons$Platform2$group)
																				])),
																		_List_fromArray(
																			[
																				A2(audienceVisibilityItem, colored.fk.b, colored.fk.pr),
																				$author$project$Platform2$Dropdown$Item$view(
																				_List_fromArray(
																					[
																						$author$project$Platform2$Dropdown$Item$class(dropdownMenuClass),
																						$author$project$Platform2$Dropdown$Item$label('Replace'),
																						$author$project$Platform2$Dropdown$Item$onClick(
																						A2(config.qo, colored, index)),
																						$author$project$Platform2$Dropdown$Item$leftIcon($author$project$Icons$Platform2$random)
																					])),
																				$author$project$Platform2$Dropdown$Item$view(
																				_List_fromArray(
																					[
																						$author$project$Platform2$Dropdown$Item$class(dropdownMenuClass),
																						$author$project$Platform2$Dropdown$Item$label('Preview'),
																						$author$project$Platform2$Dropdown$Item$onClick(
																						config.qx(colored.fk)),
																						$author$project$Platform2$Dropdown$Item$leftIcon($author$project$Icons$Platform2$eye)
																					]))
																			]))))
															])),
													hn: _List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$withStates,
															_List_fromArray(
																[
																	_Utils_Tuple2('active', isDDOpen)
																]),
															A2(
																$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																_List_fromArray(
																	['dropdown', 'pill', 'trigger-button', 'right-icon']),
																audiencesControlsClass))
														]),
													ho: _List_fromArray(
														[
															A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$ellipsisVertical)
														]),
													b: ddMenuId,
													im: 1,
													iF: 200,
													iG: 150
												}))),
										A2(
										$elm_community$html_extra$Html$Extra$viewIfLazy,
										isViewOnlyMode,
										function (_v21) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['audience-view-only', 'icon']),
														audiencesControlsClass)
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$eye)
													]));
										})
									]));
						}()
						]));
			});
		var audienceNum = A3(
			$elm_community$maybe_extra$Maybe$Extra$unwrap,
			'0',
			$author$project$Gwi$FormatNumber$formatD2SampleSize,
			$krisajenkins$remotedata$RemoteData$toMaybe(baseAudienceInfo.eQ));
		var baseAudienceDropdownView = function (_v17) {
			var inStickyHeader = _v17.ar;
			var baseNameView = A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['audience', 'replace-state', 'label', 'text']),
						audiencesControlsClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(baseName)
					]));
			var viewBasePill = function (icon) {
				return A2(
					$elm$html$Html$button,
					A3(
						$author$project$Gwi$List$addIf,
						!$author$project$Data$User$hasViewOnlyPlan(flags.mQ),
						$elm$html$Html$Events$onClick(
							config.a(config.qb)),
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('in-sticky-header', inStickyHeader),
										_Utils_Tuple2('view-only', isViewOnlyMode)
									]),
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['audience', 'replace-state']),
									audiencesControlsClass))
							])),
					_List_fromArray(
						[
							inStickyHeader ? baseNameView : $author$project$CoolTip$Platform2$view(
							{
								lm: $elm$core$Maybe$Nothing,
								lB: 0,
								mt: _List_Nil,
								mu: _List_fromArray(
									[baseNameView]),
								mE: _List_Nil,
								mF: $elm$html$Html$text(baseName),
								mL: $author$project$CoolTip$NormalShownWhenEllipsis(
									'.' + $GlobalWebIndex$class_namespaces$WeakCss$toString(
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['audience', 'replace-state', 'label', 'text']),
											audiencesControlsClass))),
								m2: _List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nest,
										'tooltip',
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['audience', 'replace-state', 'label', 'text']),
											audiencesControlsClass))
									])
							}),
							A2(
							$elm_community$html_extra$Html$Extra$viewIfLazy,
							!inStickyHeader,
							function (_v16) {
								return A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['audience', 'replace-state', 'label', 'size']),
											audiencesControlsClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('(' + (audienceNum + ')'))
										]));
							}),
							A2($elm_community$html_extra$Html$Extra$viewIf, !isViewOnlyMode, icon)
						]));
			};
			var _v14 = $author$project$Dashboards2$UserFilters$getBaseAudience(userFilters);
			if (!_v14.$) {
				return viewBasePill(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['audience', 'replace-state', 'replace']),
								audiencesControlsClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['audience', 'replace-state', 'replace', 'icon']),
										audiencesControlsClass)
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$random)
									]))
							])));
			} else {
				var audience = _v14.a;
				var toDDMenuItem = function (_v15) {
					var icon = _v15.a;
					var label = _v15.b;
					var msg = _v15.c;
					return $author$project$Platform2$Dropdown$Item$view(
						_List_fromArray(
							[
								$author$project$Platform2$Dropdown$Item$class(dropdownMenuClass),
								$author$project$Platform2$Dropdown$Item$label(label),
								$author$project$Platform2$Dropdown$Item$onClick(msg),
								$author$project$Platform2$Dropdown$Item$leftIcon(icon)
							]));
				};
				var ddMenuId = 'base-audience-pill--' + $author$project$Data$Id$unwrap(audience.b);
				var isDDOpen = A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					false,
					$author$project$Platform2$Dropdown$DropdownMenu$isVisible(ddMenuId),
					model.db);
				return viewBasePill(
					A2(
						$elm$html$Html$map,
						config.a,
						A2(
							$author$project$Platform2$Dropdown$DropdownMenu$with,
							config.nR,
							{
								U: A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
											_List_fromArray(
												['dynamic']),
											dropdownMenuClass)
										]),
									A2(
										$elm$core$List$map,
										toDDMenuItem,
										_List_fromArray(
											[
												_Utils_Tuple3($author$project$Icons$Platform2$random, 'Replace', config.qb),
												_Utils_Tuple3($author$project$Icons$Platform2$sync, 'Reset', config.qS),
												_Utils_Tuple3(
												$author$project$Icons$Platform2$fileSearch,
												'Preview',
												config.qx(audience))
											]))),
								hn: _List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('active', isDDOpen)
											]),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['dropdown', 'pill', 'trigger-button', 'right-icon']),
											audiencesControlsClass))
									]),
								ho: _List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$ellipsisVertical)
									]),
								b: ddMenuId,
								im: 1,
								iF: 80,
								iG: 200
							})));
			}
		};
		var viewBaseAudiencePill = function (inStickyHeader) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'notalone',
								$author$project$Dashboards2$UserFilters$baseIsNotAlone(userFilters)),
								_Utils_Tuple2('view-only', isViewOnlyMode),
								_Utils_Tuple2('base-audience', true),
								_Utils_Tuple2('in-sticky-header', inStickyHeader.ar)
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['audience']),
							audiencesControlsClass)),
						$author$project$Gwi$Html$Attributes$cssVars(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'--audience-color',
								$author$project$Palette$filtersColorToHex(
									$author$project$Dashboards2$UserFilters$baseColor(userFilters)))
							]))
					]),
				_List_fromArray(
					[
						baseAudienceDropdownView(inStickyHeader)
					]));
		};
		var audienceMaybeGhostView = function (_v13) {
			var inStickyHeader = _v13.ar;
			return A2(
				$elm_community$html_extra$Html$Extra$viewMaybe,
				function (colored) {
					var sampleSize = A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						'0',
						$author$project$Gwi$FormatNumber$formatD2SampleSize,
						$krisajenkins$remotedata$RemoteData$toMaybe(colored.fk.eQ));
					return A2(
						$elm$html$Html$div,
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
									_List_fromArray(
										['ghost']),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'audience-pill-wrapper', audiencesControlsClass)),
									A2(
									$elm$html$Html$Attributes$style,
									'background-color',
									$author$project$Palette$filtersColorToHex(colored.jL))
								]),
							A2(
								$elm$core$List$map,
								$elm$html$Html$Attributes$map(config.a),
								audiencesReorderSystem.oY(headerViewConfig.d8))),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('in-sticky-header', inStickyHeader),
												_Utils_Tuple2('view-only', isViewOnlyMode)
											]),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['pill']),
											audiencesControlsClass))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['audience', 'label', 'text']),
												audiencesControlsClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(colored.fk.ld)
											])),
										A2(
										$elm_community$html_extra$Html$Extra$viewIfLazy,
										!inStickyHeader,
										function (_v12) {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['audience', 'label', 'size']),
														audiencesControlsClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('(' + (sampleSize + ')'))
													]));
										})
									]))
							]));
				},
				A2(
					$elm$core$Maybe$andThen,
					function (_v11) {
						var dragIndex = _v11.j2;
						return $elm$core$List$head(
							A2($elm$core$List$drop, dragIndex, coloredAudiences));
					},
					audiencesReorderSystem.fX(headerViewConfig.d8)));
		};
		var stickyHeaderView = A2(
			$elm_community$html_extra$Html$Extra$viewIfLazy,
			!inEditMode,
			function (_v6) {
				var tooltipSampleSizeContent = F3(
					function (name, sampleSize, color) {
						return A2(
							$zwilias$elm_html_string$Html$String$toString,
							0,
							A2(
								$zwilias$elm_html_string$Html$String$div,
								_List_fromArray(
									[
										$zwilias$elm_html_string$Html$String$Attributes$class(
										$GlobalWebIndex$class_namespaces$WeakCss$toString(
											A2(
												$GlobalWebIndex$class_namespaces$WeakCss$addMany,
												_List_fromArray(
													['sticky', 'sample-size']),
												$author$project$Dashboards2$Detail$headerClass))),
										A2($zwilias$elm_html_string$Html$String$Attributes$attribute, 'style', '--audience-color: ' + color)
									]),
								_List_fromArray(
									[
										A2(
										$zwilias$elm_html_string$Html$String$div,
										_List_fromArray(
											[
												$zwilias$elm_html_string$Html$String$Attributes$class(
												$GlobalWebIndex$class_namespaces$WeakCss$toString(
													A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['sticky', 'sample-size', 'name']),
														$author$project$Dashboards2$Detail$headerClass)))
											]),
										_List_fromArray(
											[
												$zwilias$elm_html_string$Html$String$text(name)
											])),
										A2(
										$zwilias$elm_html_string$Html$String$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$zwilias$elm_html_string$Html$String$strong,
												_List_Nil,
												_List_fromArray(
													[
														$zwilias$elm_html_string$Html$String$text('Sample size: ')
													])),
												function () {
												switch (sampleSize.$) {
													case 3:
														var sampleSizeInt = sampleSize.a;
														return $zwilias$elm_html_string$Html$String$text(
															$author$project$Gwi$FormatNumber$formatD2SampleSize(sampleSizeInt));
													case 0:
														return $zwilias$elm_html_string$Html$String$text('FAIL: not asked');
													case 2:
														return $zwilias$elm_html_string$Html$String$text('Error fetching');
													default:
														return A2(
															$zwilias$elm_html_string$Html$String$span,
															_List_fromArray(
																[
																	$zwilias$elm_html_string$Html$String$Attributes$class(
																	' animated' + $GlobalWebIndex$class_namespaces$WeakCss$toString(
																		A2(
																			$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																			_List_fromArray(
																				['audience', 'sample-size', 'loader-bar']),
																			audiencesClass)))
																]),
															_List_Nil);
												}
											}()
											]))
									])));
					});
				var isReorderingAudiences = $elm_community$maybe_extra$Maybe$Extra$isJust(
					audiencesReorderSystem.fX(headerViewConfig.d8));
				var withInfoTooltip = F3(
					function (_v9, attributes, c) {
						var elementId = _v9.j5;
						var infoTooltip = _v9.kB;
						return ((!A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Platform2$Dropdown$DropdownMenu$isAnyVisible, model.db)) && (!isReorderingAudiences)) ? A3(
							$elm$html$Html$node,
							'x-d3scription',
							_Utils_ap(
								_List_fromArray(
									[
										A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + elementId),
										$elm$html$Html$Attributes$id(elementId),
										A2($elm$html$Html$Attributes$attribute, 'content', infoTooltip),
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['audience', 'wrapper']),
										audiencesControlsClass)
									]),
								attributes),
							_List_fromArray(
								[c])) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['audience', 'wrapper']),
									audiencesControlsClass)
								]),
							_List_fromArray(
								[c]));
					});
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('visible', model.dN),
									_Utils_Tuple2('is-sticky', true)
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'sticky', $author$project$Dashboards2$Detail$headerClass)),
							$elm$html$Html$Attributes$id($author$project$Dashboards2$Detail$stickyHeaderElementId)
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Extra$viewIfLazy,
							model.dN,
							function (_v7) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['sticky', 'inner']),
											$author$project$Dashboards2$Detail$headerClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['sticky', 'inner', 'left-part']),
													$author$project$Dashboards2$Detail$headerClass)
												]),
											_List_fromArray(
												[
													A4(
													$author$project$Dashboards2$Detail$actionBarView,
													config,
													{bf: currentDashboard.b, ar: true},
													headerViewConfig,
													model)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['sticky', 'inner', 'audiences']),
													$author$project$Dashboards2$Detail$headerClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['audiences-list', 'wrapper']),
															audiencesControlsClass)
														]),
													_List_fromArray(
														[
															A3(
															$author$project$ResizeObserver$view,
															{
																iW: '#' + $author$project$Dashboards2$Detail$audiencesPanelScrollableId,
																iZ: function (_v8) {
																	return config.rL;
																}
															},
															_List_Nil,
															_List_fromArray(
																[
																	A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			A2(
																			$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																			_List_fromArray(
																				['audiences-list', 'wrapper', 'scrollable']),
																			audiencesControlsClass),
																			$elm$html$Html$Attributes$id($author$project$Dashboards2$Detail$audiencesPanelScrollableId),
																			A2(
																			$elm$html$Html$Events$on,
																			'scroll',
																			$elm$json$Json$Decode$succeed(config.rL))
																		]),
																	_List_fromArray(
																		[
																			A5(
																			$author$project$Dashboards2$Detail$showChevron,
																			audiencesControlsClass,
																			A2(
																				$author$project$Dashboards2$Detail$shouldBeChevronVisible,
																				0,
																				config.ec(model)),
																			0,
																			_List_Nil,
																			config.q8),
																			A2(
																			$elm$html$Html$div,
																			_List_fromArray(
																				[
																					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'audiences-list', audiencesControlsClass)
																				]),
																			A2(
																				$elm$core$List$cons,
																				A3(
																					withInfoTooltip,
																					{
																						j5: 'd2-sticky-header-base-audience-pill',
																						kB: A3(tooltipSampleSizeContent, baseAudienceInfo.ld, baseAudienceInfo.eQ, baseAudienceInfo.jL)
																					},
																					_List_fromArray(
																						[
																							A2(
																							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																							_List_fromArray(
																								['sticky', 'inner', 'audiences', 'base-tooltip']),
																							$author$project$Dashboards2$Detail$headerClass)
																						]),
																					viewBaseAudiencePill(
																						{ar: true})),
																				_Utils_ap(
																					_List_fromArray(
																						[
																							audienceMaybeGhostView(
																							{ar: true})
																						]),
																					A2(
																						$elm$core$List$indexedMap,
																						F2(
																							function (i, colored) {
																								return A3(
																									withInfoTooltip,
																									{
																										j5: 'd2-sticky-header-audience-pill--' + $author$project$Data$Id$unwrap(colored.fk.b),
																										kB: A3(
																											tooltipSampleSizeContent,
																											colored.fk.ld,
																											colored.fk.eQ,
																											$author$project$Palette$filtersColorToHex(colored.jL))
																									},
																									_List_Nil,
																									A3(
																										viewPill,
																										{ar: true},
																										i,
																										colored));
																							}),
																						coloredAudiences)))),
																			A5(
																			$author$project$Dashboards2$Detail$showChevron,
																			audiencesControlsClass,
																			A2(
																				$author$project$Dashboards2$Detail$shouldBeChevronVisible,
																				1,
																				config.ec(model)),
																			1,
																			_List_fromArray(
																				[
																					_Utils_Tuple2('add-button-visible', canShowSmallAddAudienceButton)
																				]),
																			config.q9),
																			A2($elm_community$html_extra$Html$Extra$viewIfLazy, canShowSmallAddAudienceButton, smallAddAudienceButtonView)
																		]))
																]))
														])),
													A2(
													$elm_community$html_extra$Html$Extra$viewIf,
													$elm$core$List$length(coloredAudiences) > 1,
													A3($author$project$Dashboards2$Detail$rearrangeAudiencesOnboardingView, config, store, isViewOnlyMode))
												]))
										]));
							})
						]));
			});
		var addCategoryView = function (_v5) {
			var categories = $author$project$Data$Platform2$getCategories(currentDashboard.ac);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'bottom', $author$project$Dashboards2$Detail$headerClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						!$elm$core$List$isEmpty(categories),
						A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['bottom', 'added-categories']),
									$author$project$Dashboards2$Detail$headerClass),
									$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(config.r3)
								]),
							A2(
								$elm$core$List$map,
								function (category) {
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['bottom', 'added-categories', 'pill']),
												$author$project$Dashboards2$Detail$headerClass)
											]),
										_List_fromArray(
											[
												A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$category),
												$elm$html$Html$text(category.ld),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['bottom', 'added-categories', 'pill', 'remove']),
														$author$project$Dashboards2$Detail$headerClass),
														$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
														A2(config.r5, currentDashboard, category))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Icons$icon,
														_List_fromArray(
															[
																$author$project$Icons$width(24)
															]),
														$author$project$Icons$Platform2$crossLarge)
													]))
											]));
								},
								categories))),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						$elm$core$List$length(categories) < 2,
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['bottom', 'add-category']),
									$author$project$Dashboards2$Detail$headerClass),
									$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(config.r3)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$plusSign),
									$elm$html$Html$text('Add category')
								]))),
						function () {
						var _v4 = model.bP;
						if (!_v4.$) {
							var addCategoryListConfig = _v4.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'add-category-modal', $author$project$Dashboards2$Detail$headerClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										config.a,
										A2(
											$author$project$Platform2$SelectableList$view,
											$author$project$Dashboards2$Detail$headerClass,
											addCategoryListConfig(currentDashboard)))
									]));
						} else {
							return $elm_community$html_extra$Html$Extra$nothing;
						}
					}()
					]));
		};
		var addAudienceButtonView = function (_v3) {
			return A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'add-audience-full-btn', audiencesControlsClass),
						$elm$html$Html$Events$onClick(
						config.qa(
							{dt: false}))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Add an audience'),
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$plusSign)
					]));
		};
		return _List_fromArray(
			[
				A2(
				$elm$html$Html$header,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2('is-edit-mode', inEditMode)
							]),
						$author$project$Dashboards2$Detail$headerClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm_community$html_extra$Html$Extra$viewIfLazy,
						!inEditMode,
						function (_v0) {
							return A4(
								$author$project$Dashboards2$Detail$actionBarView,
								config,
								{bf: currentDashboard.b, ar: false},
								headerViewConfig,
								model);
						}),
						A2(
						$elm_community$html_extra$Html$Extra$viewMaybe,
						function (description) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'description', $author$project$Dashboards2$Detail$headerClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(description)
									]));
						},
						currentDashboard.cl.hB),
						A2($elm_community$html_extra$Html$Extra$viewIfLazy, inEditMode, addCategoryView),
						A2($elm_community$html_extra$Html$Extra$viewIfLazy, !inEditMode, categoriesView),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'selection-bar', $author$project$Dashboards2$Detail$headerClass)
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Platform2$Drawers$SelectionPanel$view,
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'drawer-selection-panel', $author$project$Dashboards2$Detail$moduleClass),
								1,
								drawersPanelData)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('sticky-header-visible', model.dN)
									]),
								audiencesBarClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$GlobalWebIndex$class_namespaces$WeakCss$toClass(audiencesControlsClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'wrapper', audiencesControlsClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Base audience'),
												viewBaseAudiencePill(
												{ar: false})
											])),
										A2(
										$elm_community$html_extra$Html$Extra$viewIfLazy,
										(!model.dN) && showAudiencesContainer,
										function (_v1) {
											return A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'wrapper', audiencesControlsClass)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['wrapper', 'icon']),
																audiencesControlsClass)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Audience (sample size)'),
																$author$project$CoolTip$Platform2$view(
																{
																	lm: $elm$core$Maybe$Nothing,
																	lB: 7,
																	mt: _List_Nil,
																	mu: _List_fromArray(
																		[
																			A2(
																			$author$project$Icons$icon,
																			_List_fromArray(
																				[
																					$author$project$Icons$width(26)
																				]),
																			$author$project$Icons$Platform2$info)
																		]),
																	mE: _List_Nil,
																	mF: $elm$html$Html$text('The number of respondents that match the waves and locations selected in this dashboard.'),
																	mL: $author$project$CoolTip$Normal,
																	m2: _List_Nil
																})
															])),
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'audiences-row', audiencesControlsClass)
															]),
														_List_fromArray(
															[
																A2(
																$elm_community$html_extra$Html$Extra$viewIf,
																!shouldShowFullAddAudienceButton,
																A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			A2(
																			$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																			_List_fromArray(
																				['audiences-list', 'wrapper']),
																			audiencesControlsClass)
																		]),
																	_List_fromArray(
																		[
																			A3(
																			$author$project$ResizeObserver$view,
																			{
																				iW: '#' + $author$project$Dashboards2$Detail$audiencesPanelScrollableId,
																				iZ: function (_v2) {
																					return config.rL;
																				}
																			},
																			_List_Nil,
																			_List_fromArray(
																				[
																					A2(
																					$elm$html$Html$div,
																					_List_fromArray(
																						[
																							A2(
																							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																							_List_fromArray(
																								['audiences-list', 'wrapper', 'scrollable']),
																							audiencesControlsClass),
																							$elm$html$Html$Attributes$id($author$project$Dashboards2$Detail$audiencesPanelScrollableId),
																							A2(
																							$elm$html$Html$Events$on,
																							'scroll',
																							$elm$json$Json$Decode$succeed(config.rL))
																						]),
																					_List_fromArray(
																						[
																							A5(
																							$author$project$Dashboards2$Detail$showChevron,
																							audiencesControlsClass,
																							A2(
																								$author$project$Dashboards2$Detail$shouldBeChevronVisible,
																								0,
																								config.ec(model)),
																							0,
																							_List_Nil,
																							config.q8),
																							A2(
																							$elm$html$Html$div,
																							_List_fromArray(
																								[
																									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'audiences-list', audiencesControlsClass)
																								]),
																							_Utils_ap(
																								_List_fromArray(
																									[
																										audienceMaybeGhostView(
																										{ar: false})
																									]),
																								A2(
																									$elm$core$List$indexedMap,
																									viewPill(
																										{ar: false}),
																									coloredAudiences))),
																							A5(
																							$author$project$Dashboards2$Detail$showChevron,
																							audiencesControlsClass,
																							A2(
																								$author$project$Dashboards2$Detail$shouldBeChevronVisible,
																								1,
																								config.ec(model)),
																							1,
																							_List_fromArray(
																								[
																									_Utils_Tuple2('add-button-visible', canShowSmallAddAudienceButton)
																								]),
																							config.q9),
																							A2($elm_community$html_extra$Html$Extra$viewIfLazy, (!shouldShowFullAddAudienceButton) && canShowSmallAddAudienceButton, smallAddAudienceButtonView)
																						]))
																				])),
																			A2(
																			$elm_community$html_extra$Html$Extra$viewIf,
																			$elm$core$List$length(coloredAudiences) > 1,
																			A3($author$project$Dashboards2$Detail$rearrangeAudiencesOnboardingView, config, store, isViewOnlyMode))
																		]))),
																A2($elm_community$html_extra$Html$Extra$viewIfLazy, (!isViewOnlyMode) && shouldShowFullAddAudienceButton, addAudienceButtonView)
															]))
													]));
										})
									]))
							]))
					])),
				stickyHeaderView
			]);
	});
var $elm_explorations$markdown$Markdown$defaultOptions = {
	jZ: $elm$core$Maybe$Nothing,
	oZ: $elm$core$Maybe$Just(
		{nK: false, rK: false}),
	q4: true,
	ro: false
};
var $elm_explorations$markdown$Markdown$toHtmlWith = _Markdown_toHtml;
var $elm_explorations$markdown$Markdown$toHtml = $elm_explorations$markdown$Markdown$toHtmlWith($elm_explorations$markdown$Markdown$defaultOptions);
var $author$project$Dashboards2$Detail$remoteDataView = F4(
	function (config, flags, fn, webData) {
		switch (webData.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					[$author$project$Platform2$Spinner$view]);
			case 2:
				var err = webData.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'error', $author$project$Dashboards2$Detail$moduleClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$h1,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('Something went wrong')
									])),
								A2(
								$elm_explorations$markdown$Markdown$toHtml,
								_List_Nil,
								$author$project$Gwi$String$fromHttpError(err)),
								$author$project$Data$User$hasOpenAccessPlan(flags.mQ) ? A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['margin-for-oad-header']),
										$author$project$Dashboards2$Detail$moduleClass)
									]),
								_List_Nil) : A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['error', 'back-btn']),
										$author$project$Dashboards2$Detail$moduleClass),
										$elm$html$Html$Events$onClick(
										config.as($author$project$Dashboards2$Router$DashboardsList))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Back to management page')
									]))
							]))
					]);
			default:
				var data = webData.a;
				return fn(data);
		}
	});
var $author$project$FullScreenLoader$view = F2(
	function (config, counts) {
		var progressValue = A2($elm$core$Basics$min, 100, (100 / counts.mI) * counts.h6);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass(config.pH),
					$elm$html$Html$Events$onClick(config.nO)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'modal', config.pH)
						]),
					_List_fromArray(
						[
							A2(
							$elm$svg$Svg$svg,
							_List_fromArray(
								[
									$elm$svg$Svg$Attributes$class(
									$GlobalWebIndex$class_namespaces$WeakCss$toString(
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['modal', 'progress-bar']),
											config.pH))),
									$author$project$Gwi$Html$Attributes$cssVars(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'--data-percentage-progress',
											$elm$core$String$fromFloat(progressValue))
										])),
									$elm$svg$Svg$Attributes$viewBox('0 0 36 36')
								]),
							_List_fromArray(
								[
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class(
											$GlobalWebIndex$class_namespaces$WeakCss$toString(
												A2(
													$GlobalWebIndex$class_namespaces$WeakCss$addMany,
													_List_fromArray(
														['modal', 'progress-bar', 'circle']),
													config.pH))),
											$elm$svg$Svg$Attributes$d('M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831')
										]),
									_List_Nil),
									A2(
									$elm$svg$Svg$path,
									_List_fromArray(
										[
											$elm$svg$Svg$Attributes$class(
											$GlobalWebIndex$class_namespaces$WeakCss$toString(
												A2(
													$GlobalWebIndex$class_namespaces$WeakCss$addMany,
													_List_fromArray(
														['modal', 'progress-bar', 'arc']),
													config.pH))),
											$elm$svg$Svg$Attributes$d('M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831')
										]),
									_List_Nil)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['modal', 'progress-label']),
									config.pH)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(
										$elm$core$Basics$round(progressValue)) + '%')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['modal', 'title']),
									config.pH)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(config.pI)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['modal', 'cancel']),
									config.pH)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$a,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['modal', 'cancel', 'btn']),
											config.pH),
											$elm$html$Html$Events$onClick(config.nO)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Cancel')
										]))
								]))
						]))
				]));
	});
var $author$project$Platform2$Drawers$CloseDrawer = {$: 0};
var $author$project$Platform2$Drawers$ApplyChangesConfirmation = function (a) {
	return {$: 22, a: a};
};
var $author$project$Platform2$Drawers$CancelDatasetSelection = function (a) {
	return {$: 23, a: a};
};
var $author$project$Platform2$Drawers$ClearDatasetsSelection = {$: 12};
var $author$project$Platform2$Drawers$CloseRemoveContentWarning = {$: 21};
var $author$project$Platform2$Drawers$DatasetsDrawerInputChanged = function (a) {
	return {$: 14, a: a};
};
var $author$project$Platform2$Drawers$ShowDatasetsIncompatibilityWarning = {$: 15};
var $author$project$Platform2$Drawers$ToggleDatasetFolder = function (a) {
	return {$: 10, a: a};
};
var $author$project$Platform2$Drawers$ToggleDatasetSelection = function (a) {
	return {$: 13, a: a};
};
var $author$project$Platform2$Drawers$ToggleDatasetsSelection = function (a) {
	return {$: 11, a: a};
};
var $author$project$Icons$Platform2$caretDown = {
	mr: $author$project$Icons$Platform2$path('M19.952 14.42c-.098-.254-.328-.42-.584-.42h-6.736c-.256 0-.486.166-.584.42-.098.255-.044.55.137.744l3.369 3.636c.123.134.284.2.446.2.162 0 .323-.066.446-.2l3.369-3.636c.18-.195.235-.489.137-.743'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$caretUp = {
	mr: $author$project$Icons$Platform2$path('M19.952 18.58c-.098.254-.328.42-.584.42h-6.736c-.256 0-.486-.166-.584-.42-.098-.255-.044-.55.137-.744l3.369-3.636c.123-.134.284-.2.446-.2.162 0 .323.066.446.2l3.369 3.636c.18.195.235.489.137.743'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$checkboxHalfFilled = {
	mr: $author$project$Icons$Platform2$path('M20.15 9c1.19 0 2.15.96 2.15 2.15v9c0 1.19-.96 2.15-2.15 2.15h-9A2.15 2.15 0 019 20.15v-9C9 9.96 9.96 9 11.15 9zm0 1.3h-9a.85.85 0 00-.85.85v9c0 .47.38.85.85.85h9c.47 0 .85-.38.85-.85v-9a.85.85 0 00-.85-.85zm-.5 4.35a1 1 0 010 2h-8a1 1 0 010-2h8z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Drawers$collectAllNestedDatasetsForFolder = F2(
	function (datasets, _v0) {
		var folder = _v0;
		var datasetsForFolder = function (folder_) {
			return A2(
				$elm$core$List$filter,
				function (_v1) {
					var code = _v1.bW;
					return A2($elm$core$List$member, code, folder_.fB);
				},
				$turboMaCk$any_dict$Dict$Any$values(datasets));
		};
		return _Utils_ap(
			datasetsForFolder(folder),
			A2(
				$author$project$Gwi$List$fastConcatMap,
				$author$project$Platform2$Drawers$collectAllNestedDatasetsForFolder(datasets),
				folder.rG));
	});
var $author$project$Icons$Platform2$cross = {
	mr: $author$project$Icons$Platform2$path('M20.743 11.257c.314.313.34.806.079 1.15l-.079.089L17.24 16l3.503 3.504a.876.876 0 01-1.15 1.318l-.089-.079L16 17.24l-3.504 3.503a.876.876 0 01-1.318-1.15l.079-.089L14.76 16l-3.503-3.504a.876.876 0 011.15-1.318l.089.079L16 14.76l3.504-3.503a.876.876 0 011.24 0z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Drawers$drawerContentClass = $GlobalWebIndex$class_namespaces$WeakCss$add('content');
var $author$project$Icons$Platform2$folderFilled = {
	mr: $author$project$Icons$Platform2$path('m14.283 10.012h-3.137c-1.143 0-2.088 0.882-2.088 1.994v7.86c0 1.112 0.945 1.994 2.088 1.994h9.824c1.143 0 2.088-0.882 2.088-1.994v-5.934c0-1.112-0.945-1.994-2.088-1.994h-4.54l-0.029-6e-3 -0.984-1.352c-0.264-0.36-0.686-0.568-1.134-0.568z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$li = _VirtualDom_node('li');
var $author$project$Platform2$Drawers$remoteDataView = F4(
	function (label, moduleClass, data, successView) {
		var errorView = function (string) {
			return _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nest,
							'error',
							$author$project$Platform2$Drawers$drawerContentClass(moduleClass))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(string)
						]))
				]);
		};
		switch (data.$) {
			case 3:
				var successData = data.a;
				return successView(successData);
			case 2:
				return errorView('Error loading ' + label);
			case 1:
				return _List_fromArray(
					[$author$project$Platform2$Spinner$view]);
			default:
				return errorView('Bug: didn\'t start loading ' + label);
		}
	});
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $author$project$Platform2$Drawers$datasetsDrawerContent = F4(
	function (config, moduleClass, store, data) {
		var openFolders = data.eK;
		var searchTerm = data.cW;
		var computeIncompatibilities = data.n5;
		var showIncompatibilityWarning = data.bv;
		var contentRemoveWarning = data.ci;
		var isNamespaceCodeAllowed = data.f$;
		return A4(
			$author$project$Platform2$Drawers$remoteDataView,
			'Dataset related data',
			moduleClass,
			A3($krisajenkins$remotedata$RemoteData$map2, $elm$core$Tuple$pair, store.of, store.es),
			function (_v0) {
				var folders = _v0.a;
				var datasets = _v0.b;
				var sortFolders = $elm$core$List$sortBy(
					function (_v10) {
						var folder = _v10;
						return folder.gq;
					});
				var selectedDatasets = A2(
					$turboMaCk$any_set$Set$Any$filter,
					function (code) {
						return $elm_community$maybe_extra$Maybe$Extra$isJust(
							A2($turboMaCk$any_dict$Dict$Any$get, code, datasets));
					},
					data.l7);
				var selectedCount = function (items) {
					return $turboMaCk$any_set$Set$Any$size(
						A2(
							$turboMaCk$any_set$Set$Any$intersect,
							selectedDatasets,
							$author$project$Data$Id$setFromList(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.bW;
									},
									items))));
				};
				var itemIcon = F2(
					function (isAllowed, items) {
						return (!isAllowed) ? $author$project$Icons$Platform2$checkboxCrossed : ((!selectedCount(items)) ? $author$project$Icons$Platform2$checkboxUnfilled : ((_Utils_cmp(
							selectedCount(items),
							$elm$core$List$length(items)) < 0) ? $author$project$Icons$Platform2$checkboxHalfFilled : $author$project$Icons$Platform2$checkboxFilled));
					});
				var getDatasetsForFolder = function (_v9) {
					var folder = _v9;
					return A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.gq;
						},
						A2(
							$elm$core$List$filter,
							function (_v8) {
								var code = _v8.bW;
								return A2($elm$core$List$member, code, folder.fB);
							},
							$turboMaCk$any_dict$Dict$Any$values(datasets)));
				};
				var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
				var headerView = A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', contentClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'close-button']),
									contentClass),
									$elm$html$Html$Events$onClick(
									config.a($author$project$Platform2$Drawers$CloseDrawer))
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
								])),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'title']),
									contentClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Select data set to filter by...')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'search-row']),
									contentClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'search-row', 'search']),
											contentClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['header', 'search-row', 'search', 'left-icon']),
													contentClass)
												]),
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$search)
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['header', 'search-row', 'search', 'input']),
													contentClass),
													$elm$html$Html$Attributes$placeholder('Filter data sets'),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, config.a, $author$project$Platform2$Drawers$DatasetsDrawerInputChanged)),
													$elm$html$Html$Attributes$value(searchTerm)
												]),
											_List_Nil),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											searchTerm !== '',
											A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['header', 'search-row', 'search', 'clear-btn']),
														contentClass),
														$elm$html$Html$Events$onClick(
														config.a(
															$author$project$Platform2$Drawers$DatasetsDrawerInputChanged('')))
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
													])))
										])),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'search-row', 'select-all-button']),
											contentClass),
											$elm$html$Html$Events$onClick(
											config.a($author$project$Platform2$Drawers$ClearDatasetsSelection)),
											$elm$html$Html$Attributes$disabled(
											$turboMaCk$any_set$Set$Any$isEmpty(selectedDatasets))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Clear all')
										]))
								]))
						]));
				var incompatibilityWarningView = function (_v7) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['footer', 'warning']),
								contentClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$warningTriangleIcon)
									])),
								A2(
								$elm$html$Html$span,
								_List_Nil,
								_List_fromArray(
									[
										$elm$html$Html$text('This data set is not compatible with the ones you have already selected.')
									]))
							]));
				};
				var itemView = F2(
					function (_v6, dataset) {
						var topLevel = _v6.c$;
						var isSelected = A2($turboMaCk$any_set$Set$Any$member, dataset.bW, selectedDatasets);
						var isAllowed = isNamespaceCodeAllowed(dataset.jt);
						return A2(
							$elm$html$Html$li,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('selected', isSelected),
											_Utils_Tuple2('not-allowed', !isAllowed),
											_Utils_Tuple2('top-level', topLevel)
										]),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['list-item']),
										contentClass)),
									A2(
									$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
									isAllowed,
									$elm$html$Html$Events$onClick(
										config.a(
											$author$project$Platform2$Drawers$ToggleDatasetSelection(dataset.bW)))),
									A2(
									$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
									!isAllowed,
									$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
										config.a($author$project$Platform2$Drawers$ShowDatasetsIncompatibilityWarning)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['list-item', 'checkbox']),
											contentClass)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Icons$icon,
											_List_Nil,
											(!isAllowed) ? $author$project$Icons$Platform2$checkboxCrossed : (isSelected ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled))
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['list-item', 'inner']),
											contentClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['list-item', 'inner', 'name']),
													contentClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(dataset.ld)
												])),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!$elm$core$String$isEmpty(dataset.hB),
											A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['list-item', 'inner', 'description']),
														contentClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(dataset.hB)
													])))
										]))
								]));
					});
				var folderView = function (dFolder) {
					var folder = dFolder;
					var isOpen = A2($turboMaCk$any_set$Set$Any$member, folder.b, openFolders);
					var isFolderAllowed = function (df) {
						var f = df;
						return A2(
							$elm$core$List$any,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.jt;
								},
								isNamespaceCodeAllowed),
							getDatasetsForFolder(df)) || A2($elm$core$List$any, isFolderAllowed, f.rG);
					};
					var datasetsForFolder = getDatasetsForFolder(dFolder);
					var allNestedDatasetsForFolder = A2($author$project$Platform2$Drawers$collectAllNestedDatasetsForFolder, datasets, dFolder);
					var isSelected = selectedCount(allNestedDatasetsForFolder) > 0;
					var isAllowed = isSelected || isFolderAllowed(dFolder);
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-wrapper', contentClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('selected', isSelected),
												_Utils_Tuple2('not-allowed', !isAllowed)
											]),
										A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'item-with-description', contentClass))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item-with-description', 'name-and-icons']),
												contentClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['item-with-description', 'checkbox']),
														contentClass),
														A2(
														$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
														isAllowed,
														$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
															config.a(
																$author$project$Platform2$Drawers$ToggleDatasetsSelection(allNestedDatasetsForFolder)))),
														A2(
														$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
														!isAllowed,
														$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
															config.a($author$project$Platform2$Drawers$ShowDatasetsIncompatibilityWarning)))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Icons$icon,
														_List_Nil,
														A2(itemIcon, isAllowed, allNestedDatasetsForFolder))
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['item-with-description', 'inner']),
														contentClass),
														A2(
														$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
														isAllowed,
														$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
															config.a(
																$author$project$Platform2$Drawers$ToggleDatasetFolder(folder.b))))
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['item-with-description', 'inner', 'right-icon']),
																contentClass)
															]),
														_List_fromArray(
															[
																A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$folderFilled)
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['item-with-description', 'inner', 'content']),
																contentClass)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(folder.ld)
															])),
														A2(
														$elm$html$Html$span,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['item-with-description', 'inner', 'right-icon']),
																contentClass)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Icons$icon,
																_List_Nil,
																isOpen ? $author$project$Icons$Platform2$caretUp : $author$project$Icons$Platform2$caretDown)
															]))
													]))
											])),
										A2(
										$elm_community$html_extra$Html$Extra$viewIf,
										!$elm$core$String$isEmpty(folder.hB),
										A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['item-with-description', 'description']),
													contentClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(folder.hB)
												])))
									])),
								A2(
								$elm_community$html_extra$Html$Extra$viewIfLazy,
								isOpen,
								function (_v1) {
									return A2(
										$elm$html$Html$div,
										_List_Nil,
										A2(
											$elm$core$List$map,
											itemView(
												{c$: false}),
											datasetsForFolder));
								}),
								A2(
								$elm_community$html_extra$Html$Extra$viewIfLazy,
								isOpen,
								function (_v2) {
									return A2(
										$elm$html$Html$ul,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'sub-items', contentClass)
											]),
										A2(
											$elm$core$List$map,
											folderView,
											sortFolders(folder.rG)));
								})
							]));
				};
				var rootView = function (_v5) {
					var datasetsInRoot = A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.gq;
						},
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.hz;
								},
								$elm$core$Basics$eq(0)),
							$turboMaCk$any_dict$Dict$Any$values(datasets)));
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'items', contentClass)
							]),
						_Utils_ap(
							A2(
								$elm$core$List$map,
								itemView(
									{c$: true}),
								datasetsInRoot),
							A2(
								$elm$core$List$map,
								folderView,
								sortFolders(folders))));
				};
				var searchResultView = function (_v4) {
					var filteredItems = A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.gq;
						},
						A2(
							$elm$core$List$filter,
							function (dataset) {
								return A2(
									$elm$core$String$contains,
									$elm$core$String$toLower(searchTerm),
									$elm$core$String$toLower(dataset.ld));
							},
							$turboMaCk$any_dict$Dict$Any$values(datasets)));
					return $elm$core$List$isEmpty(filteredItems) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'no-results', contentClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No results found')
							])) : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'search-items', contentClass)
							]),
						A2(
							$elm$core$List$map,
							itemView(
								{c$: true}),
							filteredItems));
				};
				var computedIncompatibilities = computeIncompatibilities(selectedDatasets);
				var footerView = function () {
					var selectedDatasetNames = A2(
						$elm$core$List$map,
						function (code) {
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$author$project$Data$Id$unwrap(code),
								function ($) {
									return $.ld;
								},
								A2($turboMaCk$any_dict$Dict$Any$get, code, datasets));
						},
						$turboMaCk$any_set$Set$Any$toList(selectedDatasets));
					var codesCount = $turboMaCk$any_set$Set$Any$size(selectedDatasets);
					return A2(
						$elm$html$Html$footer,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'footer', contentClass)
							]),
						_List_fromArray(
							[
								A2($elm_community$html_extra$Html$Extra$viewIfLazy, showIncompatibilityWarning, incompatibilityWarningView),
								A2(
								$elm_community$html_extra$Html$Extra$viewIf,
								!$elm$core$List$isEmpty(selectedDatasetNames),
								A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['footer', 'selected']),
											contentClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['footer', 'selected', 'label']),
													contentClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Selected: ')
												])),
											$elm$html$Html$text(
											A2($elm$core$String$join, ', ', selectedDatasetNames))
										]))),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['footer', 'apply-button']),
										contentClass),
										$elm$html$Html$Events$onClick(
										$elm$core$List$isEmpty(computedIncompatibilities.gF) ? config.nr(selectedDatasets) : config.a(
											$author$project$Platform2$Drawers$ApplyChangesConfirmation(computedIncompatibilities.gF))),
										$elm$html$Html$Attributes$disabled(
										$turboMaCk$any_set$Set$Any$isEmpty(selectedDatasets))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Apply ' + ($elm$core$String$fromInt(codesCount) + A2($author$project$Plural$fromInt, codesCount, ' dataset')))
									]))
							]));
				}();
				var widgetNames = A2(
					$elm$core$List$map,
					function ($) {
						return $.ld;
					},
					A2(
						$elm$core$List$filterMap,
						$author$project$Data$Platform2$getChartWidget,
						A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.lB;
							},
							computedIncompatibilities.gF)));
				var audienceNames = A2(
					$elm$core$List$map,
					function ($) {
						return $.ld;
					},
					A2($author$project$Store$Utils$getByIds, store.d9, computedIncompatibilities.gE));
				var removeContentWarningView = function (currentWarning) {
					switch (currentWarning.$) {
						case 0:
							return $elm_community$html_extra$Html$Extra$nothing;
						case 1:
							var selectionToRestore = currentWarning.a;
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['modal', 'warning']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['modal', 'warning', 'content']),
												contentClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['modal', 'warning', 'content', 'title']),
														contentClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Changes required...')
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['modal', 'warning', 'content', 'paragraph']),
														contentClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Before you can change your data set, you\'ll need to remove your audiences and attributes selected in your current chart.')
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['modal', 'warning', 'content', 'paragraph']),
														contentClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Would you like to clear them now?')
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['modal', 'warning', 'content', 'buttons']),
														contentClass)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['modal', 'warning', 'content', 'btn-cancel']),
																contentClass),
																$elm$html$Html$Events$onClick(
																config.a(
																	$author$project$Platform2$Drawers$CancelDatasetSelection(selectionToRestore)))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Cancel')
															])),
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['modal', 'warning', 'content', 'btn-confirm']),
																contentClass),
																$elm$html$Html$Events$onClick(
																config.a($author$project$Platform2$Drawers$CloseRemoveContentWarning))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Yes, please')
															]))
													]))
											]))
									]));
						default:
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['modal', 'warning']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['modal', 'warning', 'content']),
												contentClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$h3,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['modal', 'warning', 'content', 'title']),
														contentClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Are you sure?')
													])),
												$elm$html$Html$text(
												'This will clear your \'' + (A2(
													$elm$core$String$join,
													'\' and your \' ',
													_Utils_ap(widgetNames, audienceNames)) + '\'.')),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['modal', 'warning', 'content', 'buttons']),
														contentClass)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['modal', 'warning', 'content', 'btn-cancel']),
																contentClass),
																$elm$html$Html$Events$onClick(
																config.a($author$project$Platform2$Drawers$CloseRemoveContentWarning))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Cancel')
															])),
														A2(
														$elm$html$Html$button,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['modal', 'warning', 'content', 'btn-confirm']),
																contentClass),
																$elm$html$Html$Events$onClick(
																config.nr(selectedDatasets))
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('Yes, please')
															]))
													]))
											]))
									]));
					}
				};
				return _List_fromArray(
					[
						headerView,
						removeContentWarningView(contentRemoveWarning),
						$elm$core$String$isEmpty(searchTerm) ? rootView(0) : searchResultView(0),
						footerView
					]);
			});
	});
var $author$project$Platform2$Drawers$LocationsDrawerClearInput = {$: 4};
var $author$project$Platform2$Drawers$LocationsDrawerInputChanged = function (a) {
	return {$: 3, a: a};
};
var $author$project$Platform2$Drawers$SelectLocations = function (a) {
	return {$: 7, a: a};
};
var $author$project$Platform2$Drawers$ToggleSegmenting = {$: 9};
var $author$project$Platform2$Drawers$closingMsgCheckSegmenting = F3(
	function (_v0, applyMsgDefault, applyMsgPrev) {
		var segmenting = _v0.rc;
		var segmentingOnOpen = _v0.l4;
		return (!_Utils_eq(applyMsgPrev, $elm$core$Maybe$Nothing)) ? applyMsgPrev : ((!_Utils_eq(segmenting, segmentingOnOpen)) ? $elm$core$Maybe$Just(applyMsgDefault) : $elm$core$Maybe$Nothing);
	});
var $author$project$Platform2$Drawers$closingMsgCheckSets = function (_v0) {
	var selected = _v0.aE;
	var selectedOnOpen = _v0.iI;
	var applyMsg = _v0.g8;
	return $turboMaCk$any_set$Set$Any$isEmpty(selected) ? $elm$core$Maybe$Nothing : (_Utils_eq(selected, selectedOnOpen) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(applyMsg));
};
var $author$project$Data$Labels$locationsByRegions = function (locations) {
	var groupLocationsByRegion = function (locations_) {
		return A2(
			$turboMaCk$any_dict$Dict$Any$fromList,
			$author$project$Data$Labels$comparableRegionCode,
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					$elm$core$Tuple$second,
					A2($elm$core$Basics$composeR, $elm$core$List$isEmpty, $elm$core$Basics$not)),
				A2(
					$elm$core$List$map,
					function (code) {
						return _Utils_Tuple2(
							code,
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.ld;
								},
								A2(
									$elm$core$List$filter,
									A2(
										$elm$core$Basics$composeL,
										$elm$core$Basics$eq(code),
										function ($) {
											return $.qL;
										}),
									locations_)));
					},
					_List_fromArray(
						[0, 2, 1, 3]))));
	};
	return groupLocationsByRegion(
		$turboMaCk$any_dict$Dict$Any$values(
			A2(
				$turboMaCk$any_dict$Dict$Any$filter,
				$elm$core$Basics$always(
					function ($) {
						return $.fc;
					}),
				locations)));
};
var $author$project$Platform2$Drawers$ToggleLocationsSublist = function (a) {
	return {$: 2, a: a};
};
var $author$project$Platform2$Drawers$ToggleLocationInDrawer = function (a) {
	return {$: 6, a: a};
};
var $author$project$Platform2$Drawers$locationsDrawerRegionItems = F4(
	function (config, moduleClass, selectedLocations, regionItems) {
		var isItemSelected = function (location) {
			return A2($turboMaCk$any_set$Set$Any$member, location.bW, selectedLocations);
		};
		var locationIcon = function (location) {
			return isItemSelected(location) ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled;
		};
		var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
		var item = function (location) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'selected',
								isItemSelected(location))
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['list-item']),
							contentClass)),
						$elm$html$Html$Events$onClick(
						config.a(
							$author$project$Platform2$Drawers$ToggleLocationInDrawer(location)))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['list-item', 'checkbox']),
								contentClass)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Icons$icon,
								_List_Nil,
								locationIcon(location))
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['list-item', 'inner']),
								contentClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(location.ld)
							]))
					]));
		};
		return A2($elm$core$List$map, item, regionItems);
	});
var $author$project$Platform2$Drawers$locationsDrawerRegions = F5(
	function (config, moduleClass, selectedLocations, openedRegions, locationsByRegions) {
		var selectedLocationsCount = function (locations) {
			return $turboMaCk$any_set$Set$Any$size(
				A2(
					$turboMaCk$any_set$Set$Any$intersect,
					selectedLocations,
					$author$project$Data$Id$setFromList(
						A2(
							$elm$core$List$map,
							function ($) {
								return $.bW;
							},
							locations))));
		};
		var locationsIcon = function (locations) {
			return (!selectedLocationsCount(locations)) ? $author$project$Icons$Platform2$checkboxUnfilled : ((_Utils_cmp(
				selectedLocationsCount(locations),
				$elm$core$List$length(locations)) < 0) ? $author$project$Icons$Platform2$checkboxHalfFilled : $author$project$Icons$Platform2$checkboxFilled);
		};
		var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
		var regionItem = function (_v1) {
			var regionCode = _v1.a;
			var locations = _v1.b;
			var isOpen = A2($turboMaCk$any_set$Set$Any$member, regionCode, openedRegions);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-wrapper', contentClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'selected',
										selectedLocationsCount(locations) > 0)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'item', contentClass))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['item', 'checkbox']),
										contentClass),
										$elm$html$Html$Events$onClick(
										config.a(
											$author$project$Platform2$Drawers$SelectLocations(
												A2(
													$elm$core$List$map,
													function ($) {
														return $.bW;
													},
													locations))))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Icons$icon,
										_List_Nil,
										locationsIcon(locations))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['item', 'inner']),
										contentClass),
										$elm$html$Html$Events$onClick(
										config.a(
											$author$project$Platform2$Drawers$ToggleLocationsSublist(regionCode)))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item', 'inner', 'right-icon']),
												contentClass)
											]),
										_List_fromArray(
											[
												A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$folderFilled)
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item', 'inner', 'content']),
												contentClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Data$Labels$regionName(regionCode))
											])),
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item', 'inner', 'right-icon']),
												contentClass)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Icons$icon,
												_List_Nil,
												isOpen ? $author$project$Icons$Platform2$caretUp : $author$project$Icons$Platform2$caretDown)
											]))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('open', isOpen)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'list-items', contentClass))
							]),
						_List_fromArray(
							[
								A2(
								$elm_community$html_extra$Html$Extra$viewIf,
								isOpen,
								A2(
									$elm$html$Html$div,
									_List_Nil,
									A4($author$project$Platform2$Drawers$locationsDrawerRegionItems, config, moduleClass, selectedLocations, locations)))
							]))
					]));
		};
		return A2(
			$elm$core$List$map,
			regionItem,
			A2(
				$elm$core$List$sortBy,
				function (_v0) {
					var regionCode = _v0.a;
					return $author$project$Data$Labels$regionName(regionCode);
				},
				$turboMaCk$any_dict$Dict$Any$toList(locationsByRegions)));
	});
var $author$project$Platform2$Drawers$locationsDrawerSearchItems = F4(
	function (config, moduleClass, selectedLocations, filteredItems) {
		var isItemSelected = function (location) {
			return A2($turboMaCk$any_set$Set$Any$member, location.bW, selectedLocations);
		};
		var locationIcon = function (location) {
			return isItemSelected(location) ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled;
		};
		var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
		var item = function (location) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2(
								'selected',
								isItemSelected(location))
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['search-list-item']),
							contentClass)),
						$elm$html$Html$Events$onClick(
						config.a(
							$author$project$Platform2$Drawers$ToggleLocationInDrawer(location)))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Icons$icon,
						_List_Nil,
						locationIcon(location)),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['search-list-item', 'content']),
								contentClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(location.ld)
							]))
					]));
		};
		return $elm$core$List$isEmpty(filteredItems) ? _List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'no-results', contentClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('No results found')
					]))
			]) : A2($elm$core$List$map, item, filteredItems);
	});
var $elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation = function (msg) {
	return A2(
		$elm$html$Html$Events$custom,
		'click',
		$elm$json$Json$Decode$succeed(
			{pP: msg, lF: true, ml: true}));
};
var $author$project$Platform2$Drawers$segmentingToBool = function (s) {
	if (!s.$) {
		var v = s.a;
		return v;
	} else {
		return false;
	}
};
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$label = _VirtualDom_node('label');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $author$project$Platform2$Drawers$switchWithOnOffLabels = F4(
	function (className, isSegmented, text, msg) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'segmenting', className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['segmenting', 'label']),
							className)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(text)
						])),
					A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['segmenting', 'switch']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['segmenting', 'switch', 'input']),
									className),
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(isSegmented),
									$elm$html$Html$Events$onClick(msg)
								]),
							_List_Nil),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('active', isSegmented)
										]),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['segmenting', 'switch', 'slider']),
										className))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['segmenting', 'switch', 'slider', 'dot']),
											className)
										]),
									_List_Nil)
								]))
						]))
				]));
	});
var $author$project$Platform2$Drawers$locationsDrawerContent = F4(
	function (config, moduleClass, store, data) {
		var navigation = data.dF;
		var initialSelectedLocations = data.fZ;
		var segmenting = data.rc;
		var initialSegmenting = data.fY;
		var getLocations = data.oV;
		var footerWarning = data.kg;
		return A4(
			$author$project$Platform2$Drawers$remoteDataView,
			'locations',
			moduleClass,
			getLocations(store),
			function (locations) {
				var selectedLocations = A2(
					$turboMaCk$any_set$Set$Any$filter,
					function (code) {
						return $elm_community$maybe_extra$Maybe$Extra$isJust(
							A2($turboMaCk$any_dict$Dict$Any$get, code, locations));
					},
					data.l8);
				var selectedCount = $turboMaCk$any_set$Set$Any$size(selectedLocations);
				var selectAllLabel = function (displayedCodes) {
					return A2(
						$elm$core$List$all,
						function (code) {
							return A2($turboMaCk$any_set$Set$Any$member, code, selectedLocations);
						},
						displayedCodes) ? 'Deselect all' : 'Select all';
				};
				var searchValue = function () {
					if (!navigation.$) {
						return '';
					} else {
						var searchTerm = navigation.a;
						return searchTerm;
					}
				}();
				var locationsByRegions = $author$project$Data$Labels$locationsByRegions(locations);
				var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
				var header = function (allLocationCodes) {
					return A2(
						$elm$html$Html$header,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', contentClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'close-button']),
										contentClass),
										$elm$html$Html$Events$onClick(
										config.a($author$project$Platform2$Drawers$CloseDrawer))
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
									])),
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'title']),
										contentClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Select locations to filter by...')
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'search-row']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['header', 'search-row', 'search']),
												contentClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['header', 'search-row', 'search', 'input']),
														contentClass),
														$elm$html$Html$Attributes$placeholder('Filter locations'),
														$elm$html$Html$Events$onInput(
														A2($elm$core$Basics$composeL, config.a, $author$project$Platform2$Drawers$LocationsDrawerInputChanged)),
														$elm$html$Html$Attributes$value(searchValue)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['header', 'search-row', 'search', 'left-icon']),
														contentClass)
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$search)
													])),
												A2(
												$elm_community$html_extra$Html$Extra$viewIf,
												searchValue !== '',
												A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['header', 'search-row', 'search', 'clear-btn']),
															contentClass),
															$elm$html$Html$Events$onClick(
															config.a($author$project$Platform2$Drawers$LocationsDrawerClearInput))
														]),
													_List_fromArray(
														[
															A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
														])))
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['header', 'search-row', 'select-all-button']),
												contentClass),
												$elm$html$Html$Events$onClick(
												config.a(
													$author$project$Platform2$Drawers$SelectLocations(allLocationCodes)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												selectAllLabel(allLocationCodes))
											]))
									]))
							]));
				};
				var segmenting_ = function () {
					if (!segmenting.$) {
						var isSegmented = segmenting.a;
						return A4(
							$author$project$Platform2$Drawers$switchWithOnOffLabels,
							contentClass,
							isSegmented,
							'Segment output by location',
							config.a($author$project$Platform2$Drawers$ToggleSegmenting));
					} else {
						return $elm_community$html_extra$Html$Extra$nothing;
					}
				}();
				var applyMsg = A2(
					$elm$core$Maybe$withDefault,
					config.a($author$project$Platform2$Drawers$CloseDrawer),
					function (msg) {
						return A3(
							$author$project$Platform2$Drawers$closingMsgCheckSegmenting,
							{rc: segmenting, l4: initialSegmenting},
							msg,
							$author$project$Platform2$Drawers$closingMsgCheckSets(
								{g8: msg, aE: selectedLocations, iI: initialSelectedLocations}));
					}(
						A2(
							config.ns,
							selectedLocations,
							$author$project$Platform2$Drawers$segmentingToBool(segmenting))));
				var footer = A2(
					$elm$html$Html$footer,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['footer']),
							contentClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Extra$viewMaybe,
							function (copy) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['footer', 'warning']),
											contentClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$warningTriangleIcon)
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(copy)
												]))
										]));
							},
							footerWarning),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['footer', 'apply-button']),
									contentClass),
									$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(applyMsg),
									$elm$html$Html$Attributes$disabled(
									$turboMaCk$any_set$Set$Any$isEmpty(selectedLocations))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Apply ' + ($elm$core$String$fromInt(selectedCount) + A2($author$project$Plural$fromInt, selectedCount, ' location')))
								]))
						]));
				if (!navigation.$) {
					var allLocationCodes = $turboMaCk$any_dict$Dict$Any$keys(locations);
					return _List_fromArray(
						[
							header(allLocationCodes),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'items', contentClass)
								]),
							A5($author$project$Platform2$Drawers$locationsDrawerRegions, config, moduleClass, selectedLocations, data.eM, locationsByRegions)),
							segmenting_,
							footer
						]);
				} else {
					var searchTerm = navigation.a;
					var filteredItems = A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.ld;
						},
						A2(
							$elm$core$List$filter,
							function (location) {
								return A2(
									$elm$core$String$contains,
									$elm$core$String$toLower(searchTerm),
									$elm$core$String$toLower(location.ld));
							},
							$author$project$Gwi$List$fastConcat(
								$turboMaCk$any_dict$Dict$Any$values(locationsByRegions))));
					return _List_fromArray(
						[
							header(
							A2(
								$elm$core$List$map,
								function ($) {
									return $.bW;
								},
								filteredItems)),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'items', contentClass)
								]),
							A4($author$project$Platform2$Drawers$locationsDrawerSearchItems, config, moduleClass, selectedLocations, filteredItems)),
							segmenting_,
							footer
						]);
				}
			});
	});
var $author$project$Platform2$Drawers$readonlyDrawerContent = F6(
	function (moduleClass, config, selectedItems, icon, itemLabel, getItemsData) {
		var pluralItemLabel = A2($author$project$Plural$fromInt, 2, itemLabel);
		var numberOfSelectedItems = $elm$core$List$length(selectedItems);
		var itemsData = getItemsData(selectedItems);
		return A4(
			$author$project$Platform2$Drawers$remoteDataView,
			pluralItemLabel,
			moduleClass,
			itemsData,
			function (itemsData_) {
				var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
				var headerView = A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', contentClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'close-button']),
									contentClass),
									$elm$html$Html$Events$onClick(
									config.a($author$project$Platform2$Drawers$CloseDrawer))
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
								])),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'title']),
									contentClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(numberOfSelectedItems) + (' selected ' + A2($author$project$Plural$fromInt, numberOfSelectedItems, itemLabel)))
								]))
						]));
				var itemView = function (itemName) {
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
								_List_fromArray(
									['readonly']),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'item', contentClass))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['item', 'icon']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, icon)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['item', 'inner']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item', 'inner', 'name']),
												contentClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(itemName)
											]))
									]))
							]));
				};
				var itemsView = A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'items', contentClass)
						]),
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.ld;
							},
							itemView),
						A2(
							$elm$core$List$sortBy,
							function ($) {
								return $.gq;
							},
							itemsData_)));
				return _List_fromArray(
					[headerView, itemsView]);
			});
	});
var $author$project$Data$Platform2$Local = {$: 0};
var $author$project$Platform2$Drawers$SelectTimezone = function (a) {
	return {$: 19, a: a};
};
var $author$project$Data$Platform2$Standardized = function (a) {
	return {$: 1, a: a};
};
var $author$project$Platform2$Drawers$ToggleTimezoneFolder = {$: 20};
var $author$project$Icons$Platform2$radioButtonFilled = {
	mr: $author$project$Icons$Platform2$path('M16.5 8a8 8 0 110 16 8 8 0 010-16zm0 2a6 6 0 100 12 6 6 0 000-12zm0 2.5a3.5 3.5 0 110 7 3.5 3.5 0 010-7z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$radioButtonUnfilled = {
	mr: $author$project$Icons$Platform2$path('M16.5 9a8 8 0 110 16 8 8 0 010-16zm0 1.7a6.3 6.3 0 100 12.6 6.3 6.3 0 000-12.6z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Drawers$timezonesDrawerContent = F4(
	function (config, moduleClass, store, _v0) {
		var selectedTimezone = _v0.b6;
		var isFolderOpen = _v0.eA;
		var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
		var footerView = A2(
			$elm$html$Html$footer,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'footer', contentClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['footer', 'apply-button']),
							contentClass),
							$elm$html$Html$Events$onClick(
							config.jh(selectedTimezone))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Apply time zone')
						]))
				]));
		var headerView = A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', contentClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['header', 'close-button']),
							contentClass),
							$elm$html$Html$Events$onClick(
							config.a($author$project$Platform2$Drawers$CloseDrawer))
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
						])),
					A2(
					$elm$html$Html$h2,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['header', 'title']),
							contentClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Select a time zone to filter by...')
						]))
				]));
		var itemView = F2(
			function (_v2, targetTimezone) {
				var topLevel = _v2.c$;
				var isSelected = _Utils_eq(targetTimezone, selectedTimezone);
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('selected', isSelected),
									_Utils_Tuple2('top-level', topLevel),
									_Utils_Tuple2('timezones', true)
								]),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['list-item']),
								contentClass)),
							$elm$html$Html$Events$onClick(
							config.a(
								$author$project$Platform2$Drawers$SelectTimezone(targetTimezone)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['list-item', 'checkbox']),
									contentClass)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_Nil,
									isSelected ? $author$project$Icons$Platform2$radioButtonFilled : $author$project$Icons$Platform2$radioButtonUnfilled)
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['list-item', 'inner']),
									contentClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['list-item', 'inner', 'name']),
											contentClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											A3(
												$author$project$Data$Platform2$targetTimezoneLabel,
												{k$: 'Use local time zone', mj: $elm$core$Basics$identity},
												store.mx,
												targetTimezone))
										]))
								]))
						]));
			});
		var folderView = function (timezoneList) {
			var isFolderContentSelected = A2(
				$elm$core$List$any,
				$elm$core$Basics$eq(selectedTimezone),
				timezoneList);
			return A2(
				$elm$html$Html$li,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-wrapper', contentClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-with-description', contentClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['item-with-description', 'name-and-icons']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item-with-description', 'checkbox']),
												contentClass),
												$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
												config.a($author$project$Platform2$Drawers$ToggleTimezoneFolder))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Icons$icon,
												_List_Nil,
												isFolderOpen ? (isFolderContentSelected ? $author$project$Icons$Platform2$radioButtonFilled : $author$project$Icons$Platform2$radioButtonUnfilled) : $author$project$Icons$Platform2$folderFilled)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item-with-description', 'inner']),
												contentClass),
												$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
												config.a($author$project$Platform2$Drawers$ToggleTimezoneFolder))
											]),
										_List_fromArray(
											[
												A2(
												$elm_community$html_extra$Html$Extra$viewIf,
												isFolderOpen,
												A2(
													$elm$html$Html$span,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['item-with-description', 'inner', 'right-icon']),
															contentClass)
														]),
													_List_fromArray(
														[
															A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$folderFilled)
														]))),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['item-with-description', 'inner', 'content']),
														contentClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Use standardized time zone')
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['item-with-description', 'inner', 'right-icon']),
														contentClass)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Icons$icon,
														_List_Nil,
														isFolderOpen ? $author$project$Icons$Platform2$caretUp : $author$project$Icons$Platform2$caretDown)
													]))
											]))
									]))
							])),
						A2(
						$elm_community$html_extra$Html$Extra$viewIfLazy,
						isFolderOpen,
						function (_v1) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'list-items', contentClass)
									]),
								A2(
									$elm$core$List$map,
									itemView(
										{c$: false}),
									timezoneList));
						})
					]));
		};
		var rootView = A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'items', contentClass)
				]),
			_List_fromArray(
				[
					A2(
					itemView,
					{c$: true},
					$author$project$Data$Platform2$Local),
					folderView(
					A2(
						$elm$core$List$map,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.bW;
							},
							$author$project$Data$Platform2$Standardized),
						A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, store.rT)))
				]));
		return _List_fromArray(
			[headerView, rootView, footerView]);
	});
var $author$project$Platform2$Drawers$TVChannelsDrawerClearInput = {$: 17};
var $author$project$Platform2$Drawers$TVChannelsDrawerInputChanged = function (a) {
	return {$: 16, a: a};
};
var $author$project$Platform2$Drawers$ToggleTVChannel = function (a) {
	return {$: 18, a: a};
};
var $author$project$Platform2$Drawers$tvChannelsDrawerContent = F4(
	function (config, moduleClass, store, data) {
		var searchTerm = data.cW;
		return A4(
			$author$project$Platform2$Drawers$remoteDataView,
			'TV channels',
			moduleClass,
			store.mK,
			function (allChannels) {
				var selectedChannels = A2(
					$turboMaCk$any_set$Set$Any$filter,
					function (code) {
						return $elm_community$maybe_extra$Maybe$Extra$isJust(
							A2($turboMaCk$any_dict$Dict$Any$get, code, allChannels));
					},
					data.a7);
				var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
				var footerView = function () {
					var codesCount = $turboMaCk$any_set$Set$Any$size(selectedChannels);
					return A2(
						$elm$html$Html$footer,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'footer', contentClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['footer', 'apply-button']),
										contentClass),
										$elm$html$Html$Events$onClick(
										config.jg(selectedChannels)),
										$elm$html$Html$Attributes$disabled(!codesCount)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Apply ' + ($elm$core$String$fromInt(codesCount) + A2($author$project$Plural$fromInt, codesCount, ' channel')))
									]))
							]));
				}();
				var headerView = A2(
					$elm$html$Html$header,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', contentClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'close-button']),
									contentClass),
									$elm$html$Html$Events$onClick(
									config.a($author$project$Platform2$Drawers$CloseDrawer))
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
								])),
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'title']),
									contentClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Select your channel(s) to filter by...')
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'search-row']),
									contentClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'search-row', 'search']),
											contentClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['header', 'search-row', 'search', 'left-icon']),
													contentClass)
												]),
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$search)
												])),
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['header', 'search-row', 'search', 'input']),
													contentClass),
													$elm$html$Html$Attributes$placeholder('Search TV channels'),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, config.a, $author$project$Platform2$Drawers$TVChannelsDrawerInputChanged)),
													$elm$html$Html$Attributes$value(searchTerm)
												]),
											_List_Nil),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											searchTerm !== '',
											A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['header', 'search-row', 'search', 'clear-btn']),
														contentClass),
														$elm$html$Html$Events$onClick(
														config.a($author$project$Platform2$Drawers$TVChannelsDrawerClearInput))
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
													])))
										]))
								]))
						]));
				var itemView = function (tvChannel) {
					var isSelected = A2($turboMaCk$any_set$Set$Any$member, tvChannel.bW, selectedChannels);
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('selected', isSelected),
										_Utils_Tuple2('top-level', true),
										_Utils_Tuple2('checkbox-at-top', true)
									]),
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['list-item']),
									contentClass)),
								$elm$html$Html$Events$onClick(
								config.a(
									$author$project$Platform2$Drawers$ToggleTVChannel(tvChannel.bW)))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['list-item', 'checkbox']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Icons$icon,
										_List_Nil,
										isSelected ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['list-item', 'inner']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['list-item', 'inner', 'name']),
												contentClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(tvChannel.ld)
											])),
										A2(
										$elm_community$html_extra$Html$Extra$viewMaybe,
										function (metadata_) {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['list-item', 'inner', 'description']),
														contentClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(metadata_)
													]));
										},
										tvChannel.gf)
									]))
							]));
				};
				var rootView = function (_v1) {
					return A2(
						$elm$html$Html$ul,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'items', contentClass)
							]),
						A2(
							$elm$core$List$map,
							itemView,
							A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.ld;
								},
								$turboMaCk$any_dict$Dict$Any$values(allChannels))));
				};
				var searchResultView = function (_v0) {
					var filteredItems = A2(
						$elm$core$List$sortBy,
						function ($) {
							return $.ld;
						},
						A2(
							$elm$core$List$filter,
							function (tvChannel) {
								return A2(
									$elm$core$String$contains,
									$elm$core$String$toLower(searchTerm),
									$elm$core$String$toLower(tvChannel.ld));
							},
							$turboMaCk$any_dict$Dict$Any$values(allChannels)));
					return $elm$core$List$isEmpty(filteredItems) ? A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'no-results', contentClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No results found')
							])) : A2(
						$elm$html$Html$div,
						_List_Nil,
						A2($elm$core$List$map, itemView, filteredItems));
				};
				return _List_fromArray(
					[
						headerView,
						$elm$core$String$isEmpty(searchTerm) ? rootView(0) : searchResultView(0),
						footerView
					]);
			});
	});
var $author$project$Platform2$Drawers$SelectWaves = function (a) {
	return {$: 8, a: a};
};
var $author$project$Platform2$Drawers$ToggleWaveInDrawer = function (a) {
	return {$: 5, a: a};
};
var $author$project$Platform2$Drawers$ToggleWaveSublist = function (a) {
	return {$: 1, a: a};
};
var $author$project$Data$Labels$getWavesSortedLeastRecentFirst = function (dict) {
	return A2(
		$elm$core$List$sortBy,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.mk;
			},
			$elm$time$Time$posixToMillis),
		$turboMaCk$any_dict$Dict$Any$values(dict));
};
var $author$project$Data$Labels$wavesByYears = function (waves) {
	return $elm$core$Dict$fromList(
		A2(
			$elm$core$List$map,
			function (_v0) {
				var first = _v0.a;
				var restList = _v0.b;
				var wavesInsideYear = A2(
					$author$project$Gwi$List$reverseSortBy,
					function (wave) {
						return _Utils_Tuple2(
							$elm$time$Time$posixToMillis(wave.mk),
							$elm$time$Time$posixToMillis(wave.j7));
					},
					A2($elm$core$List$cons, first, restList));
				return _Utils_Tuple2(
					$author$project$Data$Labels$waveYear(first),
					wavesInsideYear);
			},
			A2(
				$elm_community$list_extra$List$Extra$gatherWith,
				F2(
					function (a, b) {
						return _Utils_eq(
							$author$project$Data$Labels$waveYear(a),
							$author$project$Data$Labels$waveYear(b));
					}),
				$author$project$Data$Labels$getWavesSortedLeastRecentFirst(
					A2(
						$turboMaCk$any_dict$Dict$Any$filter,
						$elm$core$Basics$always(
							function ($) {
								return $.fc;
							}),
						waves)))));
};
var $author$project$Platform2$Drawers$wavesDrawerContent = F4(
	function (config, moduleClass, store, data) {
		var initialSelectedWaves = data.f_;
		var getWaves = data.oX;
		var footerWarning = data.kg;
		return A4(
			$author$project$Platform2$Drawers$remoteDataView,
			'Waves',
			moduleClass,
			getWaves(store),
			function (waves) {
				var wavesByYears = $author$project$Data$Labels$wavesByYears(waves);
				var wavesList = $elm$core$List$reverse(
					$elm$core$Dict$toList(wavesByYears));
				var selectedWaves = A2(
					$turboMaCk$any_set$Set$Any$filter,
					function (code) {
						return $elm_community$maybe_extra$Maybe$Extra$isJust(
							A2($turboMaCk$any_dict$Dict$Any$get, code, waves));
					},
					data.l9);
				var selectedWavesCount = function (waves_) {
					return $turboMaCk$any_set$Set$Any$size(
						A2(
							$turboMaCk$any_set$Set$Any$intersect,
							selectedWaves,
							$author$project$Data$Id$setFromList(
								A2(
									$elm$core$List$map,
									function ($) {
										return $.bW;
									},
									waves_))));
				};
				var wavesIcon = function (waves_) {
					return (!selectedWavesCount(waves_)) ? $author$project$Icons$Platform2$checkboxUnfilled : ((_Utils_cmp(
						selectedWavesCount(waves_),
						$elm$core$List$length(waves_)) < 0) ? $author$project$Icons$Platform2$checkboxHalfFilled : $author$project$Icons$Platform2$checkboxFilled);
				};
				var selectedCount = $turboMaCk$any_set$Set$Any$size(selectedWaves);
				var selectAllLabel = function (waveCodes) {
					return A2(
						$elm$core$List$all,
						function (code) {
							return A2($turboMaCk$any_set$Set$Any$member, code, selectedWaves);
						},
						waveCodes) ? 'Deselect all' : 'Select all';
				};
				var contentClass = $author$project$Platform2$Drawers$drawerContentClass(moduleClass);
				var drawerListItem = function (wave) {
					var isItemSelected = A2($turboMaCk$any_set$Set$Any$member, wave.bW, selectedWaves);
					var drawerItemIcon = isItemSelected ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('selected', isItemSelected)
									]),
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['list-item']),
									contentClass)),
								$elm$html$Html$Events$onClick(
								config.a(
									$author$project$Platform2$Drawers$ToggleWaveInDrawer(wave)))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['list-item', 'checkbox']),
										contentClass)
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, drawerItemIcon)
									])),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['list-item', 'inner']),
										contentClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(wave.ld)
									]))
							]));
				};
				var drawerRootItem = function (_v0) {
					var waveYear = _v0.a;
					var waves_ = _v0.b;
					var isOpen = A2($elm$core$Set$member, waveYear, data.eN);
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-wrapper', contentClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'selected',
												selectedWavesCount(waves_) > 0)
											]),
										A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'item', contentClass))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item', 'checkbox']),
												contentClass),
												$elm$html$Html$Events$onClick(
												config.a(
													$author$project$Platform2$Drawers$SelectWaves(
														A2(
															$elm$core$List$map,
															function ($) {
																return $.bW;
															},
															waves_))))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Icons$icon,
												_List_Nil,
												wavesIcon(waves_))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['item', 'inner']),
												contentClass),
												$elm$html$Html$Events$onClick(
												config.a(
													$author$project$Platform2$Drawers$ToggleWaveSublist(waveYear)))
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['item', 'inner', 'right-icon']),
														contentClass)
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$folderFilled)
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['item', 'inner', 'content']),
														contentClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(
														$elm$core$String$fromInt(waveYear))
													])),
												A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['item', 'inner', 'right-icon']),
														contentClass)
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Icons$icon,
														_List_Nil,
														isOpen ? $author$project$Icons$Platform2$caretUp : $author$project$Icons$Platform2$caretDown)
													]))
											]))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('open', isOpen)
											]),
										A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'list-items', contentClass))
									]),
								_List_fromArray(
									[
										A2(
										$elm_community$html_extra$Html$Extra$viewIf,
										isOpen,
										A2(
											$elm$html$Html$div,
											_List_Nil,
											A2($elm$core$List$map, drawerListItem, waves_)))
									]))
							]));
				};
				var applyMsg = A2(
					$elm$core$Maybe$withDefault,
					config.a($author$project$Platform2$Drawers$CloseDrawer),
					function (msg) {
						return $author$project$Platform2$Drawers$closingMsgCheckSets(
							{g8: msg, aE: selectedWaves, iI: initialSelectedWaves});
					}(
						config.nt(selectedWaves)));
				var footer = A2(
					$elm$html$Html$footer,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['footer']),
							contentClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Extra$viewMaybe,
							function (copy) {
								return A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['footer', 'warning']),
											contentClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$warningTriangleIcon)
												])),
											A2(
											$elm$html$Html$span,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(copy)
												]))
										]));
							},
							footerWarning),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['footer', 'apply-button']),
									contentClass),
									$elm$html$Html$Events$onClick(applyMsg),
									$elm$html$Html$Attributes$disabled(
									$turboMaCk$any_set$Set$Any$isEmpty(selectedWaves))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									'Apply ' + ($elm$core$String$fromInt(selectedCount) + A2($author$project$Plural$fromInt, selectedCount, ' wave')))
								]))
						]));
				var allWaveCodes = A2(
					$author$project$Gwi$List$fastConcatMap,
					$elm$core$List$map(
						function ($) {
							return $.bW;
						}),
					$elm$core$Dict$values(wavesByYears));
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$header,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', contentClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'close-button']),
										contentClass),
										$elm$html$Html$Events$onClick(
										config.a($author$project$Platform2$Drawers$CloseDrawer))
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
									])),
								A2(
								$elm$html$Html$h2,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'title']),
										contentClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Select waves to filter by...')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'select-all-button']),
										contentClass),
										$elm$html$Html$Events$onClick(
										config.a(
											$author$project$Platform2$Drawers$SelectWaves(allWaveCodes)))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										selectAllLabel(
											A2(
												$elm$core$List$map,
												function ($) {
													return $.bW;
												},
												$elm$core$List$concat(
													$elm$core$Dict$values(wavesByYears)))))
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'items', contentClass)
							]),
						A2($elm$core$List$map, drawerRootItem, wavesList)),
						footer
					]);
			});
	});
var $author$project$Platform2$Drawers$view = F3(
	function (moduleClass, store, drawer) {
		var readonlyDrawerContent_ = $author$project$Platform2$Drawers$readonlyDrawerContent(moduleClass);
		var getItemsDataWaves = F2(
			function (data, ids) {
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$map,
							function (wave) {
								return {
									ld: wave.ld,
									gq: -$elm$time$Time$posixToMillis(wave.mk)
								};
							},
							A2($author$project$Store$Utils$getByIds, data, ids))),
					data);
			});
		var getItemsData = F2(
			function (data, ids) {
				return A2(
					$krisajenkins$remotedata$RemoteData$map,
					$elm$core$Basics$always(
						A2(
							$elm$core$List$map,
							function (item) {
								return {ld: item.ld, gq: item.ld};
							},
							A2($author$project$Store$Utils$getByIds, data, ids))),
					data);
			});
		var drawerOpen = !_Utils_eq(drawer, $author$project$Platform2$Drawers$Closed);
		var content = function () {
			switch (drawer.$) {
				case 0:
					return _List_Nil;
				case 1:
					var config = drawer.a;
					var wavesData = drawer.b;
					return A4($author$project$Platform2$Drawers$wavesDrawerContent, config, moduleClass, store, wavesData);
				case 3:
					var config = drawer.a;
					var locationsData = drawer.b;
					return A4($author$project$Platform2$Drawers$locationsDrawerContent, config, moduleClass, store, locationsData);
				case 5:
					var config = drawer.a;
					var datasetsData = drawer.b;
					return A4($author$project$Platform2$Drawers$datasetsDrawerContent, config, moduleClass, store, datasetsData);
				case 6:
					var config = drawer.a;
					var tvChannelsData = drawer.b;
					return A4($author$project$Platform2$Drawers$tvChannelsDrawerContent, config, moduleClass, store, tvChannelsData);
				case 8:
					var config = drawer.a;
					var timezonesData = drawer.b;
					return A4($author$project$Platform2$Drawers$timezonesDrawerContent, config, moduleClass, store, timezonesData);
				case 2:
					var config = drawer.a;
					var wavesData = drawer.b;
					return A5(
						readonlyDrawerContent_,
						config,
						$turboMaCk$any_set$Set$Any$toList(wavesData.l9),
						$author$project$Icons$Platform2$waves,
						'wave',
						getItemsDataWaves(
							wavesData.oX(store)));
				case 4:
					var config = drawer.a;
					var locationsData = drawer.b;
					return A5(
						readonlyDrawerContent_,
						config,
						$turboMaCk$any_set$Set$Any$toList(locationsData.l8),
						$author$project$Icons$Platform2$locations,
						'location',
						getItemsData(
							locationsData.oV(store)));
				case 7:
					var config = drawer.a;
					var channelsData = drawer.b;
					return A5(
						readonlyDrawerContent_,
						config,
						$turboMaCk$any_set$Set$Any$toList(channelsData.a7),
						$author$project$Icons$Platform2$tv,
						'channel',
						getItemsData(store.mK));
				default:
					var config = drawer.a;
					var timezonesData = drawer.b;
					return A5(
						readonlyDrawerContent_,
						config,
						_List_fromArray(
							[timezonesData.b6]),
						$author$project$Icons$Platform2$time,
						'timezone',
						A2(
							$elm$core$Basics$composeR,
							$elm$core$List$map(
								function (timezone) {
									var name = A3(
										$author$project$Data$Platform2$targetTimezoneLabel,
										{k$: 'Local time zone', mj: $elm$core$Basics$identity},
										store.mx,
										timezone);
									return {ld: name, gq: name};
								}),
							$krisajenkins$remotedata$RemoteData$Success));
			}
		}();
		var closingMsg = function () {
			switch (drawer.$) {
				case 0:
					return $elm$core$Maybe$Nothing;
				case 1:
					var config = drawer.a;
					var wavesData = drawer.b;
					return $elm$core$Maybe$Just(
						$turboMaCk$any_set$Set$Any$isEmpty(wavesData.l9) ? config.a($author$project$Platform2$Drawers$CloseDrawer) : (_Utils_eq(wavesData.l9, wavesData.f_) ? config.a($author$project$Platform2$Drawers$CloseDrawer) : config.nt(wavesData.l9)));
				case 3:
					var config = drawer.a;
					var locationsData = drawer.b;
					return $elm$core$Maybe$Just(
						$turboMaCk$any_set$Set$Any$isEmpty(locationsData.l8) ? config.a($author$project$Platform2$Drawers$CloseDrawer) : ((_Utils_eq(locationsData.l8, locationsData.fZ) && _Utils_eq(locationsData.rc, locationsData.fY)) ? config.a($author$project$Platform2$Drawers$CloseDrawer) : A2(
							config.ns,
							locationsData.l8,
							$author$project$Platform2$Drawers$segmentingToBool(locationsData.rc))));
				case 5:
					var config = drawer.a;
					var datasetsData = drawer.b;
					return $elm$core$Maybe$Just(
						((!$turboMaCk$any_set$Set$Any$isEmpty(datasetsData.l7)) && (!_Utils_eq(datasetsData.l7, datasetsData.eO))) ? config.nr(datasetsData.l7) : config.a($author$project$Platform2$Drawers$CloseDrawer));
				case 6:
					var config = drawer.a;
					var tvChannelsData = drawer.b;
					return $elm$core$Maybe$Just(
						$turboMaCk$any_set$Set$Any$isEmpty(tvChannelsData.a7) ? config.a($author$project$Platform2$Drawers$CloseDrawer) : (_Utils_eq(tvChannelsData.a7, tvChannelsData.h_) ? config.a($author$project$Platform2$Drawers$CloseDrawer) : config.jg(tvChannelsData.a7)));
				case 8:
					var config = drawer.a;
					var timezonesData = drawer.b;
					return $elm$core$Maybe$Just(
						config.jh(timezonesData.b6));
				case 2:
					var config = drawer.a;
					return $elm$core$Maybe$Just(
						config.a($author$project$Platform2$Drawers$CloseDrawer));
				case 4:
					var config = drawer.a;
					return $elm$core$Maybe$Just(
						config.a($author$project$Platform2$Drawers$CloseDrawer));
				case 7:
					var config = drawer.a;
					return $elm$core$Maybe$Just(
						config.a($author$project$Platform2$Drawers$CloseDrawer));
				default:
					var config = drawer.a;
					return $elm$core$Maybe$Just(
						config.a($author$project$Platform2$Drawers$CloseDrawer));
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2('open', drawerOpen)
						]),
					moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('open', drawerOpen)
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'overlay', moduleClass)),
							A2($elm_community$html_extra$Html$Attributes$Extra$attributeMaybe, $elm$html$Html$Events$onClick, closingMsg)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('open', drawerOpen)
								]),
							$author$project$Platform2$Drawers$drawerContentClass(moduleClass))
						]),
					content)
				]));
	});
var $author$project$Platform2$Dropdown$DropdownMenu$moduleClass = A2(
	$GlobalWebIndex$class_namespaces$WeakCss$add,
	'dynamic-dropdown-menu',
	$GlobalWebIndex$class_namespaces$WeakCss$namespace('p2-et'));
var $author$project$Platform2$Dropdown$DropdownMenu$orientationToActiveState = function (orientation) {
	switch (orientation) {
		case 0:
			return 'bottom-right';
		case 1:
			return 'bottom-left';
		case 2:
			return 'right-top';
		case 3:
			return 'right-center';
		case 4:
			return 'right-bottom';
		case 5:
			return 'left-top';
		case 6:
			return 'left-bottom';
		default:
			return 'left';
	}
};
var $author$project$Platform2$Dropdown$DropdownMenu$show = function (_v0) {
	var orientation = _v0.im;
	var position = _v0.lB;
	var content = _v0.U;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2(
				$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
				_List_fromArray(
					[
						$author$project$Platform2$Dropdown$DropdownMenu$orientationToActiveState(orientation)
					]),
				$author$project$Platform2$Dropdown$DropdownMenu$moduleClass),
				A2(
				$elm$html$Html$Attributes$style,
				'top',
				$elm$core$String$fromFloat(position.m4) + 'px'),
				A2(
				$elm$html$Html$Attributes$style,
				'left',
				$elm$core$String$fromFloat(position.m3) + 'px'),
				A2($elm$html$Html$Attributes$style, 'position', 'fixed')
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'inner', $author$project$Platform2$Dropdown$DropdownMenu$moduleClass)
					]),
				_List_fromArray(
					[content]))
			]));
};
var $author$project$Platform2$Dropdown$DropdownMenu$view = function (ddm) {
	if (ddm.$ === 1) {
		var data = ddm.a;
		return $author$project$Platform2$Dropdown$DropdownMenu$show(data);
	} else {
		return $elm_community$html_extra$Html$Extra$nothing;
	}
};
var $author$project$Dashboards2$Detail$DecreaseHeight = 3;
var $author$project$Dashboards2$Detail$DecreaseWidth = 1;
var $author$project$Dashboards2$Detail$IncreaseHeight = 2;
var $author$project$Dashboards2$Detail$IncreaseWidth = 0;
var $author$project$Dashboards2$Detail$allMetrics = _List_fromArray(
	[0, 2, 3, 4, 1]);
var $author$project$Dashboards2$Widget$isDropdownOpened = function (model) {
	return !_Utils_eq(model.w, $author$project$Dashboards2$Widget$NoDropdown);
};
var $author$project$Dashboards2$Detail$isEditGrid = function (editSection) {
	if (editSection.$ === 1) {
		return true;
	} else {
		return false;
	}
};
var $author$project$Icons$Platform2$minusSign = {
	mr: $author$project$Icons$Platform2$path('M10 15  h 11.3 c.376 0 .688.278.742.64l.008.11 c0 .377-.278.688-.64.742l-.11.008 h -11  c-.376 0-.688-.278-.742-.64l-.008-.11 c0-.377.278-.688.64-.742l.11-.008 z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Widget$spinnerShellView = F2(
	function (widget, chartWidget) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						['loading']),
					$author$project$Dashboards2$Widget$moduleClass),
					$elm$html$Html$Attributes$id(
					$author$project$Dashboards2$Widget$containerElementId(widget))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', $author$project$Dashboards2$Widget$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'info-group']),
									$author$project$Dashboards2$Widget$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'metadata-info']),
											$author$project$Dashboards2$Widget$moduleClass),
											$elm$html$Html$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$info)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'question-name']),
											$author$project$Dashboards2$Widget$moduleClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(chartWidget.ld)
										]))
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', $author$project$Dashboards2$Widget$moduleClass)
						]),
					_List_fromArray(
						[$author$project$Platform2$Spinner$view]))
				]));
	});
var $author$project$Dashboards2$Widget$NavigateToGetInTouch = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $author$project$Dashboards2$Widget$upsellView = F6(
	function (config, qCode, permissions, widget, chartWidget, model) {
		var isCreator = permissions.kM;
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						['error']),
					$author$project$Dashboards2$Widget$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', $author$project$Dashboards2$Widget$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'info-group']),
									$author$project$Dashboards2$Widget$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'metadata-info']),
											$author$project$Dashboards2$Widget$moduleClass),
											$elm$html$Html$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$info)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'question-name']),
											$author$project$Dashboards2$Widget$moduleClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(chartWidget.ld)
										]))
								])),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							isCreator,
							A2(
								$elm$html$Html$div,
								_List_Nil,
								_List_fromArray(
									[
										A5($author$project$Dashboards2$Widget$viewButtons, config, permissions, widget, chartWidget, model)
									])))
						])),
					A2(
					$elm$html$Html$map,
					config.a,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', $author$project$Dashboards2$Widget$moduleClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'upsell', $author$project$Dashboards2$Widget$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$i,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['upsell', 'icon']),
												$author$project$Dashboards2$Widget$moduleClass)
											]),
										_List_Nil),
										A2(
										$elm$html$Html$p,
										_List_Nil,
										_List_fromArray(
											[
												$elm$html$Html$text('Looks like you need more data.')
											])),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['upsell', 'button']),
												$author$project$Dashboards2$Widget$moduleClass),
												$elm$html$Html$Events$onClick(
												A2($author$project$Dashboards2$Widget$NavigateToGetInTouch, qCode, 'Get in Touch'))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Get in Touch')
											]))
									]))
							])))
				]));
	});
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $author$project$Dashboards2$Widget$userErrorView = F8(
	function (config, currentTab, widget, chartWidget, permissions, title, model, error) {
		var errorContent = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', $author$project$Dashboards2$Widget$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['content', 'header']),
							$author$project$Dashboards2$Widget$moduleClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(title)
						])),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[error]))
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						['error']),
					$author$project$Dashboards2$Widget$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', $author$project$Dashboards2$Widget$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['header', 'info-group']),
									$author$project$Dashboards2$Widget$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'metadata-info']),
											$author$project$Dashboards2$Widget$moduleClass),
											$elm$html$Html$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$info)
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['header', 'question-name']),
											$author$project$Dashboards2$Widget$moduleClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(chartWidget.ld)
										]))
								])),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							permissions.kO,
							A5(
								$author$project$Dashboards2$Widget$viewEditButtons,
								config,
								permissions,
								widget,
								$elm$core$Maybe$Just(chartWidget),
								model))
						])),
					function () {
					if (!currentTab) {
						return errorContent;
					} else {
						return errorContent;
					}
				}()
				]));
	});
var $author$project$Dashboards2$Widget$RichText$alignToString = function (align) {
	switch (align) {
		case 0:
			return 'left';
		case 1:
			return 'center';
		default:
			return 'right';
	}
};
var $elm$core$String$lines = _String_lines;
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $author$project$Dashboards2$Widget$RichText$sizeToString = function (size) {
	switch (size) {
		case 0:
			return 'size-title';
		case 1:
			return 'size-heading1';
		case 2:
			return 'size-heading2';
		default:
			return 'size-body';
	}
};
var $author$project$Dashboards2$Widget$RichText$viewParagraph = F2(
	function (className, paragraph) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2('bold', paragraph.k.de),
							_Utils_Tuple2(
							'underline',
							paragraph.k.dU && (!_Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$Quote))),
							_Utils_Tuple2(
							$author$project$Dashboards2$Widget$RichText$sizeToString(paragraph.k.cX),
							true)
						]),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'paragraph', className))
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = paragraph.k.ae;
					switch (_v0.$) {
						case 0:
							var align = _v0.a.fe;
							return A2(
								$elm$html$Html$pre,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
										_List_fromArray(
											[
												$author$project$Dashboards2$Widget$RichText$alignToString(align)
											]),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['paragraph', 'content']),
											className))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(paragraph.U)
									]));
						case 1:
							return A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['paragraph', 'list']),
										className)
									]),
								A2(
									$elm$core$List$map,
									function (line) {
										return A2(
											$elm$html$Html$li,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['paragraph', 'list', 'item']),
													className)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(line)
												]));
									},
									$elm$core$String$lines(paragraph.U)));
						default:
							return A2(
								$elm$html$Html$pre,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('underline', paragraph.k.dU)
											]),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['paragraph', 'quote']),
											className))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['paragraph', 'quote', 'text']),
												className)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(paragraph.U)
											]))
									]));
					}
				}()
				]));
	});
var $author$project$Dashboards2$Widget$RichText$view = F2(
	function (className, richText) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'rich-text', className)
				]),
			$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
				A2(
					$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
					$author$project$Dashboards2$Widget$RichText$viewParagraph(
						A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'rich-text', className)),
					richText.qt)));
	});
var $author$project$Dashboards2$Widget$RichText$AddParagraph = {$: 4};
var $author$project$Dashboards2$Widget$RichText$Remove = {$: 1};
var $author$project$Dashboards2$Widget$RichText$StartEdit = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $turboMaCk$non_empty_list_alias$List$NonEmpty$indexedMap = F2(
	function (f, _v0) {
		var h = _v0.a;
		var t = _v0.b;
		return _Utils_Tuple2(
			A2(f, 0, h),
			A2(
				$elm$core$List$indexedMap,
				function (i) {
					return f(i + 1);
				},
				t));
	});
var $author$project$Dashboards2$Widget$RichText$AlignDropdown = 2;
var $author$project$Dashboards2$Widget$RichText$SetContent = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Widget$RichText$SetSize = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dashboards2$Widget$RichText$SizeDropdown = 1;
var $author$project$Dashboards2$Widget$RichText$ToggleDropdown = function (a) {
	return {$: 5, a: a};
};
var $author$project$Icons$Platform2$alignLeft = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M0 0.906641C0 0.57527 0.268629 0.306641 0.6 0.306641H15.4C15.7314 0.306641 16 0.57527 16 0.906641C16 1.23801 15.7314 1.50664 15.4 1.50664H0.6C0.268629 1.50664 0 1.23801 0 0.906641Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M0 4.96914C0 4.63777 0.268629 4.36914 0.6 4.36914H12.15C12.4814 4.36914 12.75 4.63777 12.75 4.96914C12.75 5.30051 12.4814 5.56914 12.15 5.56914H0.6C0.268629 5.56914 0 5.30051 0 4.96914Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M0 9.03138C0 8.70001 0.268629 8.43138 0.6 8.43138H15.4C15.7314 8.43138 16 8.70001 16 9.03138C16 9.36275 15.7314 9.63138 15.4 9.63138H0.6C0.268629 9.63138 0 9.36275 0 9.03138Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M0 13.0941C0 12.7628 0.268629 12.4941 0.6 12.4941H8.9C9.23137 12.4941 9.5 12.7628 9.5 13.0941C9.5 13.4255 9.23137 13.6941 8.9 13.6941H0.6C0.268629 13.6941 0 13.4255 0 13.0941Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$alignCenter = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M0 0.940443C0 0.590404 0.283763 0.306641 0.633803 0.306641H15.3662C15.7162 0.306641 16 0.590404 16 0.940443C16 1.29048 15.7162 1.57425 15.3662 1.57425H0.633803C0.283763 1.57425 0 1.29048 0 0.940443Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M1.71655 5.23182C1.71655 4.88178 2.00031 4.59801 2.35035 4.59801H13.6496C13.9997 4.59801 14.2835 4.88178 14.2835 5.23182C14.2835 5.58186 13.9997 5.86562 13.6496 5.86562H2.35035C2.00031 5.86562 1.71655 5.58186 1.71655 5.23182Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M0 9.52291C0 9.17287 0.283763 8.88911 0.633803 8.88911H15.3662C15.7162 8.88911 16 9.17287 16 9.52291C16 9.87295 15.7162 10.1567 15.3662 10.1567H0.633803C0.283763 10.1567 0 9.87295 0 9.52291Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M3.43303 13.8146C3.43303 13.4645 3.71679 13.1808 4.06683 13.1808H11.933C12.2831 13.1808 12.5668 13.4645 12.5668 13.8146C12.5668 14.1646 12.2831 14.4484 11.933 14.4484H4.06683C3.71679 14.4484 3.43303 14.1646 3.43303 13.8146Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$alignRight = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M0 0.940443C0 0.590404 0.283763 0.306641 0.633803 0.306641H15.3662C15.7162 0.306641 16 0.590404 16 0.940443C16 1.29048 15.7162 1.57425 15.3662 1.57425H0.633803C0.283763 1.57425 0 1.29048 0 0.940443Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M3.43303 5.23182C3.43303 4.88178 3.71679 4.59801 4.06683 4.59801H15.3661C15.7162 4.59801 15.9999 4.88178 15.9999 5.23182C15.9999 5.58186 15.7162 5.86562 15.3661 5.86562H4.06683C3.71679 5.86562 3.43303 5.58186 3.43303 5.23182Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M0 9.52291C0 9.17287 0.283763 8.88911 0.633803 8.88911H15.3662C15.7162 8.88911 16 9.17287 16 9.52291C16 9.87295 15.7162 10.1567 15.3662 10.1567H0.633803C0.283763 10.1567 0 9.87295 0 9.52291Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M6.8662 13.8146C6.8662 13.4645 7.14996 13.1808 7.5 13.1808H15.3662C15.7162 13.1808 16 13.4645 16 13.8146C16 14.1646 15.7162 14.4484 15.3662 14.4484H7.5C7.14996 14.4484 6.8662 14.1646 6.8662 13.8146Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Widget$RichText$alignToIcon = function (align) {
	switch (align) {
		case 0:
			return $author$project$Icons$Platform2$alignLeft;
		case 1:
			return $author$project$Icons$Platform2$alignCenter;
		default:
			return $author$project$Icons$Platform2$alignRight;
	}
};
var $author$project$Dashboards2$Widget$RichText$alignToLabel = function (align) {
	switch (align) {
		case 0:
			return 'Align left';
		case 1:
			return 'Align center';
		default:
			return 'Align right';
	}
};
var $author$project$Icons$Platform2$bold = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, 'transparent', 'M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V30C32 31.1046 31.1046 32 30 32H2C0.895431 32 0 31.1046 0 30V2Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M10.8887 10.6667C10.8887 10.2985 11.1871 10 11.5553 10H16.7776C18.6185 10 20.1109 11.4924 20.1109 13.3333C20.1109 14.2297 19.7571 15.0435 19.1815 15.6425C20.3209 16.1724 21.1109 17.3273 21.1109 18.6667C21.1109 20.5076 19.6185 22 17.7776 22H11.5553C11.1871 22 10.8887 21.7015 10.8887 21.3333V10.6667ZM12.222 16.6667V20.6667H17.7776C18.8821 20.6667 19.7776 19.7712 19.7776 18.6667C19.7776 17.5621 18.8821 16.6667 17.7776 16.6667H12.222ZM12.222 15.3333H16.7776C17.8821 15.3333 18.7776 14.4379 18.7776 13.3333C18.7776 12.2288 17.8821 11.3333 16.7776 11.3333H12.222V15.3333Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$bulletList = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M8 10.9156C8 10.2845 8.51156 9.77295 9.1426 9.77295C9.77364 9.77295 10.2852 10.2845 10.2852 10.9156C10.2852 11.5466 9.77364 12.0582 9.1426 12.0582C8.51156 12.0582 8 11.5466 8 10.9156Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M12.5717 10.969C12.5717 10.5905 12.8786 10.2836 13.2571 10.2836H23.3146C23.6931 10.2836 24 10.5905 24 10.969C24 11.3476 23.6931 11.6545 23.3146 11.6545H13.2571C12.8786 11.6545 12.5717 11.3476 12.5717 10.969Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M8 16C8 15.369 8.51156 14.8574 9.1426 14.8574C9.77364 14.8574 10.2852 15.369 10.2852 16C10.2852 16.6311 9.77364 17.1426 9.1426 17.1426C8.51156 17.1426 8 16.6311 8 16Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M12.5717 16.0537C12.5717 15.6751 12.8786 15.3682 13.2571 15.3682H23.3146C23.6931 15.3682 24 15.6751 24 16.0537C24 16.4322 23.6931 16.7391 23.3146 16.7391H13.2571C12.8786 16.7391 12.5717 16.4322 12.5717 16.0537Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M8 21.0845C8 20.4535 8.51156 19.9419 9.1426 19.9419C9.77364 19.9419 10.2852 20.4535 10.2852 21.0845C10.2852 21.7156 9.77364 22.2271 9.1426 22.2271C8.51156 22.2271 8 21.7156 8 21.0845Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M12.5716 21.0845C12.5716 20.7059 12.8784 20.3991 13.257 20.3991H23.3144C23.693 20.3991 23.9999 20.7059 23.9999 21.0845C23.9999 21.4631 23.693 21.77 23.3144 21.77H13.257C12.8784 21.77 12.5716 21.4631 12.5716 21.0845Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$Item$itemWrapp = function (wrapp) {
	return function (config) {
		return _Utils_update(
			config,
			{f1: wrapp});
	};
};
var $author$project$Icons$Platform2$quote = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M11.8991 1.16727C12.0829 1.44299 12.0084 1.81551 11.7327 1.99932C10.6285 2.73543 10.0244 3.20946 9.64488 3.96842C9.29168 4.67482 9.10426 5.69019 9.0717 7.50009H12.1332C12.8694 7.50009 13.4666 8.09725 13.4666 8.83342V11.7668C13.4666 12.5029 12.8694 13.1001 12.1332 13.1001H9.19989C8.46372 13.1001 7.86656 12.5029 7.86656 11.7668V8.10009C7.86656 5.89228 8.04537 4.48415 8.57157 3.43176C9.10876 2.35738 9.97124 1.73141 11.0671 1.00086C11.3428 0.817047 11.7153 0.891551 11.8991 1.16727ZM9.06656 8.70009V11.7668C9.06656 11.8402 9.12646 11.9001 9.19989 11.9001H12.1332C12.2067 11.9001 12.2666 11.8402 12.2666 11.7668V8.83342C12.2666 8.75999 12.2067 8.70009 12.1332 8.70009H9.06656Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M4.56577 1.16727C4.74958 1.44299 4.67507 1.81551 4.39936 1.99932C3.29519 2.73543 2.691 3.20946 2.31153 3.96842C1.95832 4.67482 1.77091 5.69019 1.73835 7.50009H4.79987C5.53604 7.50009 6.1332 8.09725 6.1332 8.83342V11.7668C6.1332 12.5029 5.53604 13.1001 4.79987 13.1001H1.86654C1.13037 13.1001 0.533203 12.5029 0.533203 11.7668V8.10009C0.533203 5.89228 0.712017 4.48415 1.23821 3.43176C1.7754 2.35738 2.63788 1.73141 3.73372 1.00086C4.00943 0.817047 4.38195 0.891551 4.56577 1.16727ZM1.7332 8.70009V11.7668C1.7332 11.8402 1.79311 11.9001 1.86654 11.9001H4.79987C4.8733 11.9001 4.9332 11.8402 4.9332 11.7668V8.83342C4.9332 8.75999 4.8733 8.70009 4.79987 8.70009H1.7332Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$Item$rightIcon = function (rightIcon_) {
	return function (config) {
		return _Utils_update(
			config,
			{
				gJ: $elm$core$Maybe$Just(rightIcon_)
			});
	};
};
var $author$project$Dashboards2$Widget$RichText$sizeTitle = function (size) {
	switch (size) {
		case 0:
			return 'Title';
		case 1:
			return 'Heading 1';
		case 2:
			return 'Heading 2';
		default:
			return 'Normal';
	}
};
var $elm$html$Html$textarea = _VirtualDom_node('textarea');
var $author$project$Icons$Platform2$underline = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, 'transparent', 'M0 2C0 0.895431 0.895431 0 2 0H30C31.1046 0 32 0.895431 32 2V30C32 31.1046 31.1046 32 30 32H2C0.895431 32 0 31.1046 0 30V2Z'),
				A2($author$project$Icons$Platform2$pathFill, 'currentColor', 'M12.4137 9.5C12.7851 9.5 13.0861 9.80105 13.0861 10.1724V15.5517C13.0861 17.161 14.3907 18.4655 15.9999 18.4655C17.6091 18.4655 18.9137 17.161 18.9137 15.5517V10.1724C18.9137 9.80105 19.2147 9.5 19.5861 9.5C19.9575 9.5 20.2585 9.80105 20.2585 10.1724V15.5517C20.2585 17.9037 18.3519 19.8103 15.9999 19.8103C13.6479 19.8103 11.7413 17.9037 11.7413 15.5517V10.1724C11.7413 9.80105 12.0423 9.5 12.4137 9.5ZM10.8447 21.8276C10.8447 21.4562 11.1458 21.1552 11.5171 21.1552H20.4827C20.854 21.1552 21.1551 21.4562 21.1551 21.8276C21.1551 22.1989 20.854 22.5 20.4827 22.5H11.5171C11.1458 22.5 10.8447 22.1989 10.8447 21.8276Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Gwi$Html$Attributes$withDisabledGrammarly = $elm$core$Basics$append(
	_List_fromArray(
		[
			A2($elm$html$Html$Attributes$attribute, 'data-gramm_editor', 'false'),
			A2($elm$html$Html$Attributes$attribute, 'data-enable-grammarly', 'false')
		]));
var $author$project$Dashboards2$Widget$RichText$viewEditParagraph = F5(
	function (className, _v0, index, paragraph, model) {
		var canRemove = _v0.fn;
		var compactView = _v0.jM;
		var withAlign = function () {
			var _v5 = paragraph.k.ae;
			switch (_v5.$) {
				case 2:
					return $elm$core$Basics$identity;
				case 1:
					return $elm$core$Basics$identity;
				default:
					var align = _v5.a.fe;
					return $elm$core$List$cons(
						_Utils_Tuple2(
							$author$project$Dashboards2$Widget$RichText$alignToString(align),
							true));
			}
		}();
		var toAction = function (action) {
			return A2(
				$author$project$Dashboards2$Widget$RichText$ParagraphMsg,
				{pi: index},
				action);
		};
		var surroundIfQuote = function (content) {
			return _Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$Quote) ? A2(
				$elm$html$Html$pre,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
						_List_fromArray(
							['edit-mode']),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['paragraph', 'quote']),
							className))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['paragraph', 'quote', 'text-edit-mode']),
								className)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(paragraph.U),
								content
							]))
					])) : content;
		};
		var sizeDropdown = function () {
			var sdClassName = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'size-dropdown', className);
			var isActive = model.aA === 1;
			var dropdownItemView = function (item) {
				return $author$project$Platform2$Dropdown$Item$view(
					A3(
						$author$project$Gwi$List$addIf,
						_Utils_eq(paragraph.k.cX, item),
						$author$project$Platform2$Dropdown$Item$leftIcon($author$project$Icons$Platform2$tick),
						_List_fromArray(
							[
								$author$project$Platform2$Dropdown$Item$class(
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['dropdown', 'options']),
									sdClassName)),
								$author$project$Platform2$Dropdown$Item$label(
								$author$project$Dashboards2$Widget$RichText$sizeTitle(item)),
								$author$project$Platform2$Dropdown$Item$onClick(
								toAction(
									$author$project$Dashboards2$Widget$RichText$SetSize(item))),
								$author$project$Platform2$Dropdown$Item$selected(
								_Utils_eq(paragraph.k.cX, item))
							])));
			};
			var dropdownView = function (_v4) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							_List_fromArray(
								['top-right']),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['dropdown', 'options']),
								sdClassName))
						]),
					A2(
						$elm$core$List$map,
						dropdownItemView,
						_List_fromArray(
							[0, 1, 2, 3])));
			};
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$GlobalWebIndex$class_namespaces$WeakCss$toClass(sdClassName)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('active', isActive),
										_Utils_Tuple2('compact-view', compactView)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'toggle-button', sdClassName)),
								$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
								$author$project$Dashboards2$Widget$RichText$ToggleDropdown(1))
							]),
						_List_fromArray(
							[
								compactView ? A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$text) : $elm$html$Html$text(
								$author$project$Dashboards2$Widget$RichText$sizeTitle(paragraph.k.cX)),
								isActive ? A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretUp) : A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretDown)
							])),
						A2($elm_community$html_extra$Html$Extra$viewIfLazy, isActive, dropdownView)
					]));
		}();
		var removeBtn = A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['paragraph', 'remove-btn']),
					className),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
					canRemove,
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
						toAction($author$project$Dashboards2$Widget$RichText$Remove))),
					$elm$html$Html$Attributes$disabled(!canRemove)
				]),
			_List_fromArray(
				[
					A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$trash)
				]));
		var controlPanelButton = F4(
			function (tooltip, active, action, icon) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('active', active)
								]),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['paragraph', 'control-panel', 'button']),
								className)),
							$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
							toAction(action))
						]),
					_List_fromArray(
						[
							$author$project$CoolTip$Platform2$view(
							{
								lm: $elm$core$Maybe$Nothing,
								lB: 0,
								mt: _List_Nil,
								mu: _List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, icon)
									]),
								mE: _List_Nil,
								mF: $elm$html$Html$text(tooltip),
								mL: $author$project$CoolTip$Normal,
								m2: _List_Nil
							})
						]));
			});
		var bulletListButton = A4(
			controlPanelButton,
			'Bulleted list',
			_Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$BulletpointList),
			$author$project$Dashboards2$Widget$RichText$SetMainStyle($author$project$Data$Platform2$RichTextWidget$BulletpointList),
			$author$project$Icons$Platform2$bulletList);
		var alignDropdown = function () {
			var isActive = model.aA === 2;
			var toggleContent = function (align) {
				return compactView ? _List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$ellipsisVertical)
					]) : _List_fromArray(
					[
						A2(
						$author$project$Icons$icon,
						_List_Nil,
						$author$project$Dashboards2$Widget$RichText$alignToIcon(align)),
						isActive ? A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretUp) : A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretDown)
					]);
			};
			var cooltipWrapp = F2(
				function (tooltip, content) {
					return $author$project$CoolTip$Platform2$view(
						{
							lm: $elm$core$Maybe$Nothing,
							lB: 0,
							mt: _List_Nil,
							mu: _List_fromArray(
								[content]),
							mE: _List_Nil,
							mF: $elm$html$Html$text(tooltip),
							mL: $author$project$CoolTip$Normal,
							m2: _List_Nil
						});
				});
			var adClassName = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'align-dropdown', className);
			var addExtraItemsIfCompactView = function (items) {
				return compactView ? _Utils_ap(
					items,
					_List_fromArray(
						[
							$author$project$Platform2$Dropdown$Item$separator(
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['dropdown', 'options']),
								adClassName)),
							$author$project$Platform2$Dropdown$Item$view(
							_List_fromArray(
								[
									$author$project$Platform2$Dropdown$Item$class(
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['dropdown', 'options']),
										adClassName)),
									$author$project$Platform2$Dropdown$Item$label(''),
									$author$project$Platform2$Dropdown$Item$onClick(
									toAction(
										$author$project$Dashboards2$Widget$RichText$SetMainStyle($author$project$Data$Platform2$RichTextWidget$BulletpointList))),
									$author$project$Platform2$Dropdown$Item$rightIcon($author$project$Icons$Platform2$bulletList),
									$author$project$Platform2$Dropdown$Item$itemWrapp(
									cooltipWrapp('Bulleted list'))
								]))
						])) : items;
			};
			var dropdownItemView = F3(
				function (disabled, currentAlign, item) {
					return $author$project$Platform2$Dropdown$Item$view(
						A3(
							$author$project$Gwi$List$addIf,
							!disabled,
							$author$project$Platform2$Dropdown$Item$onClick(
								toAction(
									$author$project$Dashboards2$Widget$RichText$SetMainStyle(
										$author$project$Data$Platform2$RichTextWidget$Normal(
											{fe: item})))),
							_List_fromArray(
								[
									$author$project$Platform2$Dropdown$Item$class(
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['dropdown', 'options']),
										adClassName)),
									$author$project$Platform2$Dropdown$Item$disabled(disabled),
									$author$project$Platform2$Dropdown$Item$label(''),
									$author$project$Platform2$Dropdown$Item$selected(
									_Utils_eq(currentAlign, item)),
									$author$project$Platform2$Dropdown$Item$rightIcon(
									$author$project$Dashboards2$Widget$RichText$alignToIcon(item)),
									$author$project$Platform2$Dropdown$Item$itemWrapp(
									cooltipWrapp(
										$author$project$Dashboards2$Widget$RichText$alignToLabel(item)))
								])));
				});
			var dropdownView = F3(
				function (_v2, align, _v3) {
					var disableAlignItems = _v2.hF;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
								_List_fromArray(
									['top-right']),
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['dropdown', 'options']),
									adClassName))
							]),
						addExtraItemsIfCompactView(
							A2(
								$elm$core$List$map,
								A2(dropdownItemView, disableAlignItems, align),
								_List_fromArray(
									[0, 1, 2]))));
				});
			var _v1 = paragraph.k.ae;
			switch (_v1.$) {
				case 2:
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$GlobalWebIndex$class_namespaces$WeakCss$toClass(adClassName)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('disabled', !compactView),
												_Utils_Tuple2('active', isActive),
												_Utils_Tuple2('compact', compactView)
											]),
										A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'toggle-button', adClassName)),
										A2(
										$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
										compactView,
										$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
											$author$project$Dashboards2$Widget$RichText$ToggleDropdown(2)))
									]),
								toggleContent(0)),
								A2(
								$elm_community$html_extra$Html$Extra$viewIfLazy,
								isActive,
								A2(
									dropdownView,
									{hF: true},
									0))
							]));
				case 0:
					var align = _v1.a.fe;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$GlobalWebIndex$class_namespaces$WeakCss$toClass(adClassName)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2('active', isActive),
												_Utils_Tuple2('compact', compactView)
											]),
										A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'toggle-button', adClassName)),
										$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
										$author$project$Dashboards2$Widget$RichText$ToggleDropdown(2))
									]),
								toggleContent(align)),
								A2(
								$elm_community$html_extra$Html$Extra$viewIfLazy,
								isActive,
								A2(
									dropdownView,
									{hF: false},
									align))
							]));
				default:
					return compactView ? bulletListButton : A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$GlobalWebIndex$class_namespaces$WeakCss$toClass(adClassName)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
										_List_fromArray(
											['disabled']),
										A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'toggle-button', adClassName))
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$alignLeft),
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretDown)
									]))
							]));
			}
		}();
		var controlPanel = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['paragraph', 'control-panel']),
					className)
				]),
			_List_fromArray(
				[
					sizeDropdown,
					A4(controlPanelButton, 'Bold', paragraph.k.de, $author$project$Dashboards2$Widget$RichText$ToggleBold, $author$project$Icons$Platform2$bold),
					A4(controlPanelButton, 'Underline', paragraph.k.dU, $author$project$Dashboards2$Widget$RichText$ToggleUnderline, $author$project$Icons$Platform2$underline),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['paragraph', 'control-panel', 'separator']),
							className)
						]),
					_List_Nil),
					A4(
					controlPanelButton,
					'Quote',
					_Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$Quote),
					$author$project$Dashboards2$Widget$RichText$SetMainStyle($author$project$Data$Platform2$RichTextWidget$Quote),
					$author$project$Icons$Platform2$quote),
					A2($elm_community$html_extra$Html$Extra$viewIf, !compactView, bulletListButton),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					!compactView,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['paragraph', 'control-panel', 'separator']),
								className)
							]),
						_List_Nil)),
					alignDropdown
				]));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						[
							'edit-mode',
							$author$project$Dashboards2$Widget$RichText$sizeToString(paragraph.k.cX)
						]),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'paragraph', className)),
					$elm$html$Html$Attributes$id(
					A2($author$project$Dashboards2$Widget$RichText$paragraphElementId, index, model))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['paragraph', 'textarea-cont']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'quote',
											_Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$Quote)),
											_Utils_Tuple2('bold', paragraph.k.de)
										]),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['paragraph', 'textarea-cont', 'inner']),
										className))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$withStates,
											_List_fromArray(
												[
													_Utils_Tuple2(
													'bulletpoint-list',
													_Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$BulletpointList)),
													_Utils_Tuple2(
													'quote',
													_Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$Quote))
												]),
											A2(
												$GlobalWebIndex$class_namespaces$WeakCss$addMany,
												_List_fromArray(
													['paragraph', 'hidden']),
												className))
										]),
									_List_fromArray(
										[
											A2($author$project$Dashboards2$Widget$RichText$viewParagraph, className, paragraph)
										])),
									surroundIfQuote(
									A2(
										$elm$html$Html$textarea,
										$author$project$Gwi$Html$Attributes$withDisabledGrammarly(
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$withStates,
													withAlign(
														_List_fromArray(
															[
																_Utils_Tuple2('bold', paragraph.k.de),
																_Utils_Tuple2('underline', paragraph.k.dU),
																_Utils_Tuple2(
																$author$project$Dashboards2$Widget$RichText$sizeToString(paragraph.k.cX),
																true),
																_Utils_Tuple2(
																'bulletpoint-list',
																_Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$BulletpointList)),
																_Utils_Tuple2(
																'quote',
																_Utils_eq(paragraph.k.ae, $author$project$Data$Platform2$RichTextWidget$Quote))
															])),
													A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['paragraph', 'textarea']),
														className)),
													$elm$html$Html$Attributes$id(
													A2($author$project$Dashboards2$Widget$RichText$textareaElementId, index, model)),
													$elm$html$Html$Events$onInput(
													A2($elm$core$Basics$composeL, toAction, $author$project$Dashboards2$Widget$RichText$SetContent)),
													$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation($author$project$Dashboards2$Widget$RichText$NoOp)
												])),
										_List_fromArray(
											[
												$elm$html$Html$text(paragraph.U)
											])))
								]))
						])),
					removeBtn,
					controlPanel
				]));
	});
var $author$project$Dashboards2$Widget$RichText$viewEdit = F3(
	function (_v0, className, model) {
		var widgetWidth = _v0.sl;
		var rtClassName = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'rich-text', className);
		var args = {
			fn: $turboMaCk$non_empty_list_alias$List$NonEmpty$length(model.bM.qt) > 1,
			jM: widgetWidth < 2
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'left-row', rtClassName)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							_List_fromArray(
								['edit-mode']),
							rtClassName),
							$elm$html$Html$Attributes$id(
							$author$project$Dashboards2$Widget$RichText$contentScrollElementId(model))
						]),
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
						A2(
							$turboMaCk$non_empty_list_alias$List$NonEmpty$indexedMap,
							F2(
								function (index, paragraph) {
									return _Utils_eq(
										model.bH,
										$elm$core$Maybe$Just(index)) ? A5($author$project$Dashboards2$Widget$RichText$viewEditParagraph, rtClassName, args, index, paragraph, model) : A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'edit-mode', rtClassName),
												$elm$html$Html$Attributes$id(
												A2($author$project$Dashboards2$Widget$RichText$paragraphElementId, index, model)),
												$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
												A2(
													$author$project$Dashboards2$Widget$RichText$StartEdit,
													index,
													$elm$core$String$length(paragraph.U)))
											]),
										_List_fromArray(
											[
												$elm$core$String$isEmpty(paragraph.U) ? A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['edit-mode', 'placeholder']),
														rtClassName)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Click to add text')
													])) : A2($author$project$Dashboards2$Widget$RichText$viewParagraph, rtClassName, paragraph),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['edit-mode', 'remove-btn']),
														rtClassName),
														A2(
														$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
														args.fn,
														$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
															A2(
																$author$project$Dashboards2$Widget$RichText$ParagraphMsg,
																{pi: index},
																$author$project$Dashboards2$Widget$RichText$Remove))),
														$elm$html$Html$Attributes$disabled(!args.fn)
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$trash)
													]))
											]));
								}),
							model.bM.qt))),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'add-paragraph-btn', rtClassName),
							$elm$html$Html$Events$onClick($author$project$Dashboards2$Widget$RichText$AddParagraph)
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$plusSign),
							$elm$html$Html$text('Add new paragraph')
						]))
				]));
	});
var $author$project$Dashboards2$Widget$MetadataIcon = function (a) {
	return {$: 17, a: a};
};
var $author$project$Dashboards2$Widget$ViewAllQuestions = F2(
	function (a, b) {
		return {$: 18, a: a, b: b};
	});
var $author$project$Data$Platform2$baseAudienceName = F2(
	function (audiences, id) {
		return A2(
			$elm$core$Maybe$withDefault,
			$author$project$Data$Id$unwrap(id),
			A2(
				$elm$core$Maybe$map,
				function ($) {
					return $.ld;
				},
				A2($author$project$Store$Utils$get, audiences, id)));
	});
var $author$project$Dashboards2$Widget$showMedatadaTooltip = function (state) {
	switch (state) {
		case 0:
			return false;
		case 1:
			return true;
		default:
			return true;
	}
};
var $author$project$Dashboards2$StatCard$ActivateAudience = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Widget$Pagination$horizontalView = $author$project$Dashboards2$Widget$Pagination$view_(
	{hW: true, iL: true, iM: false});
var $author$project$Dashboards2$StatCard$tooltipAudiences = $elm$core$List$map(
	function (audience) {
		return {jL: audience.jL, h4: audience.ld, c5: audience.c5};
	});
var $author$project$Dashboards2$StatCard$paginationView = function (model) {
	var tooltipContent = A2(
		$zwilias$elm_html_string$Html$String$toString,
		0,
		A3(
			$author$project$D3Charts$Dashboards2$viewTooltip,
			2,
			model.fA,
			$author$project$Dashboards2$StatCard$tooltipAudiences(model.d9)));
	var length = $elm$core$Basics$ceiling(
		$elm$core$List$length(model.d9) / model.ax);
	var elementId = 'statCard' + $author$project$Data$Id$unwrap(model.sj);
	var currentIndex = (_Utils_cmp(model.ai, length) > -1) ? (length - 1) : model.ai;
	var goToAction = function (index) {
		if (!_Utils_eq(
			length,
			$elm$core$List$length(model.d9))) {
			if (model.ax === 2) {
				return $author$project$Dashboards2$StatCard$ActivateAudience(model.ax * index);
			} else {
				var direction = (_Utils_cmp(index, currentIndex) > 0) ? 1 : 0;
				return $author$project$Dashboards2$StatCard$Move(direction);
			}
		} else {
			return $author$project$Dashboards2$StatCard$ActivateAudience(index);
		}
	};
	return A3(
		$elm$html$Html$node,
		'x-d3scription',
		_List_fromArray(
			[
				A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + elementId),
				A2($elm$html$Html$Attributes$attribute, 'content', tooltipContent)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(elementId)
					]),
				_List_fromArray(
					[
						$author$project$Dashboards2$Widget$Pagination$horizontalView(
						{
							hi: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'pagination', $author$project$Dashboards2$StatCard$moduleClass),
							jS: currentIndex,
							kn: goToAction,
							kZ: length
						})
					]))
			]));
};
var $author$project$Dashboards2$Chart$view = F6(
	function (config, availableMetrics, store, widget, chartWidget, model) {
		var userFilters = config.bz;
		var chartType = chartWidget.aI;
		var viewData = A5($author$project$Dashboards2$Chart$prepareViewData, store, userFilters, widget, chartWidget, model);
		var showMetric = !A2(
			$elm$core$List$member,
			chartType,
			_List_fromArray(
				[0, 4, 1]));
		var paginationView = A2(
			$elm$html$Html$map,
			A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$Chart$StatCardMsg),
			function () {
				var _v1 = model.h;
				if (_v1.$ === 2) {
					var data = _v1.a;
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'footer', $author$project$Dashboards2$Chart$moduleClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['footer', 'pagination']),
										$author$project$Dashboards2$Chart$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$RemoteData$Loaded$withDefault,
										$elm_community$html_extra$Html$Extra$nothing,
										A2(
											$author$project$RemoteData$Loaded$map,
											function (_v2) {
												var statCardModel = _v2.b;
												return $author$project$Dashboards2$StatCard$paginationView(statCardModel);
											},
											data))
									]))
							]));
				} else {
					return $elm_community$html_extra$Html$Extra$nothing;
				}
			}());
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass($author$project$Dashboards2$Chart$moduleClass)
				]),
			_List_fromArray(
				[
					function () {
					switch (viewData.$) {
						case 0:
							var spinnerView = viewData.a.mi;
							return A2(spinnerView, config, availableMetrics);
						case 1:
							var chartView = viewData.a.bT;
							return A2(chartView, config, availableMetrics);
						default:
							var error = viewData.a.$7;
							return $author$project$Dashboards2$Chart$viewError(error);
					}
				}(),
					A2($elm_community$html_extra$Html$Extra$viewIf, showMetric, paginationView)
				]));
	});
var $author$project$Dashboards2$Widget$ChartTypeDropdown = {$: 2};
var $author$project$Dashboards2$Widget$FooterDDItem = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$Widget$FooterDDSeparator = {$: 2};
var $author$project$Dashboards2$Widget$FooterResetItem = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$Widget$MetricsDropdown = {$: 3};
var $author$project$Dashboards2$Widget$OpenHelpMeChooseModal = {$: 12};
var $author$project$Dashboards2$Widget$OpenShowMetricInfoModal = {$: 14};
var $author$project$Dashboards2$Widget$SaveChartWidgetAndCloseDropdown = function (a) {
	return {$: 9, a: a};
};
var $author$project$Dashboards2$Widget$SortByDropdown = {$: 4};
var $author$project$Dashboards2$Widget$ToggleDropdown = function (a) {
	return {$: 6, a: a};
};
var $author$project$Icons$Platform2$alphabet = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(8 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M1.23077 3.89744C1.23077 2.42479 2.42479 1.23077 3.89744 1.23077H12.1026C13.5752 1.23077 14.7692 2.42479 14.7692 3.89744V12.1026C14.7692 13.5752 13.5752 14.7692 12.1026 14.7692H3.89744C2.42479 14.7692 1.23077 13.5752 1.23077 12.1026V3.89744ZM3.89744 0C1.74506 0 0 1.74506 0 3.89744V12.1026C0 14.2549 1.74506 16 3.89744 16H12.1026C14.2549 16 16 14.2549 16 12.1026V3.89744C16 1.74506 14.2549 0 12.1026 0H3.89744ZM9.65756 7.65793C9.9158 6.95529 10.4323 6.56699 11.1237 6.56699C12.2566 6.56699 12.9231 7.51 12.9231 8.93377C12.9231 10.339 12.2317 11.2821 11.0654 11.2821C10.399 11.2821 9.9158 10.903 9.65756 10.2189V11.1896H8.59959V4.71795H9.65756V7.65793ZM9.6159 8.93377C9.6159 9.82131 9.95745 10.2189 10.7488 10.2189C11.5236 10.2189 11.8568 9.82131 11.8568 8.93377C11.8568 8.02774 11.5236 7.63019 10.7488 7.63019C9.95745 7.63019 9.6159 8.02774 9.6159 8.93377ZM6.35077 7.67642V6.65944H7.40874V11.1896H6.35077V10.2004C6.10086 10.8938 5.60937 11.2821 4.9346 11.2821C3.76835 11.2821 3.07692 10.339 3.07692 8.93377C3.07692 7.51 3.74336 6.56699 4.88462 6.56699C5.58438 6.56699 6.09253 6.96454 6.35077 7.67642ZM4.14322 8.93377C4.14322 9.82131 4.48476 10.2189 5.25116 10.2189C6.04255 10.2189 6.3841 9.82131 6.3841 8.93377C6.3841 8.02774 6.04255 7.63019 5.25116 7.63019C4.48476 7.63019 4.14322 8.02774 4.14322 8.93377Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$D3Charts$Dashboards$ChartType$availableForNonGwiCreator = _List_fromArray(
	[0, 1, 2, 3, 9, 10, 11]);
var $author$project$Dashboards2$Widget$chartsButtonView = F6(
	function (config, _v0, flags, _v1, chartWidget, model) {
		var _short = _v0.a8;
		var canAccessChartBuilder = _v1.jz;
		var isViewOnlyMode = $author$project$Data$User$hasViewOnlyPlan(flags.mQ);
		var hasSingleQuestion = 1 === $turboMaCk$non_empty_list_alias$List$NonEmpty$length(
			$author$project$Data$Platform2$widgetDataQuestionCodes(chartWidget.cl));
		var canEditAudiencesAndCharts = flags.nM(25);
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			canAccessChartBuilder && (canEditAudiencesAndCharts && (!isViewOnlyMode)),
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2(
						$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
						hasSingleQuestion,
						A2(
							$elm_community$html_extra$Html$Attributes$Extra$attributeMaybe,
							A2($elm$core$Basics$composeL, $elm$html$Html$Events$onClick, config.eI),
							$author$project$Dashboards2$Widget$getCurrentMetric(model))),
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2('short', _short)
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['footer', 'button']),
							$author$project$Dashboards2$Widget$moduleClass)),
						$elm$html$Html$Attributes$disabled(!hasSingleQuestion)
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$charts),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						!_short,
						$elm$html$Html$text('View in Charts'))
					])));
	});
var $author$project$Icons$Platform2$dataMetrics = {
	mr: $author$project$Icons$Platform2$path('M19.3 10.23a6.42 6.42 0 01.44 8.59l3.4 3.4a.65.65 0 01-.84.99l-.08-.07-3.4-3.4a6.42 6.42 0 11.48-9.51zm-8.15.92a5.12 5.12 0 107.4.18l-.17-.18-.18-.17a5.12 5.12 0 00-7.05.17zm.89 3.29c.32 0 .6.24.64.55v.87a.65.65 0 01-1.29.1v-.87c0-.36.29-.65.65-.65zm2.56-.77c.32 0 .6.24.64.55V15.86a.65.65 0 01-1.29.1V14.32c0-.36.29-.65.65-.65zm2.56-.77c.33 0 .6.24.64.55l.01.1v2.31a.65.65 0 01-1.3.1v-2.41c0-.36.29-.65.65-.65z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Widget$ToggleDataTable = {$: 0};
var $author$project$Dashboards2$Widget$DataTable$invalidTypesForDataTable = _List_fromArray(
	[4]);
var $author$project$Dashboards2$Widget$DataTable$canBeDataTable = function (widget) {
	var _v0 = widget.U;
	if (!_v0.$) {
		var chartType = _v0.a.aI;
		return A2($elm_community$list_extra$List$Extra$notMember, chartType, $author$project$Dashboards2$Widget$DataTable$invalidTypesForDataTable);
	} else {
		return false;
	}
};
var $author$project$Icons$Platform2$dataGrid = {
	mr: $author$project$Icons$Platform2$path('M 20.5 9 l -10.2 0 a 1.7 1.7 90 0 0 -1.7 1.7 l 0 10.2 a 1.7 1.7 90 0 0 1.7 1.7 l 10.2 0 a 1.7 1.7 90 0 0 1.7 -1.7 l 0 -10.2 a 1.7 1.7 90 0 0 -1.7 -1.7 z m 0.68 9.435 l 0 2.465 a 0.85 0.85 90 0 1 -0.68 0.68 l -2.465 0 l 0 -3.145 z m -4.165 0 l 0 3.145 l -3.23 0 l 0 -3.145 z m -4.25 0 l 0 3.145 l -2.465 0 a 0.85 0.85 90 0 1 -0.68 -0.68 l 0 -2.465 z m 8.415 -4.25 l 0 3.23 l -3.145 0 l 0 -3.23 z m -4.165 0 l 0 3.23 l -3.23 0 l 0 -3.23 z m -4.25 0 l 0 3.23 l -3.145 0 l 0 -3.23 z m 8.415 -3.485 l 0 2.465 l -3.145 0 l 0 -3.145 l 2.465 0 a 0.85 0.85 90 0 1 0.68 0.68 z m -4.165 -0.68 l 0 3.145 l -3.23 0 l 0 -3.145 z m -4.25 0 l 0 3.145 l -3.145 0 l 0 -2.465 a 0.85 0.85 90 0 1 0.68 -0.68 z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Widget$dataTableButtonView = F6(
	function (config, _v0, flags, widget, chartWidget, model) {
		var _short = _v0.a8;
		var isViewOnlyMode = $author$project$Data$User$hasViewOnlyPlan(flags.mQ);
		var canShowDataTable = $author$project$Dashboards2$Widget$DataTable$canBeDataTable(widget) && (!(!chartWidget.aI));
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			canShowDataTable && (!isViewOnlyMode),
			A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						$elm$html$Html$Events$onClick(
						config.a($author$project$Dashboards2$Widget$ToggleDataTable)),
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2('short', _short),
								_Utils_Tuple2('pressed', model.eo === 1)
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['footer', 'button']),
							$author$project$Dashboards2$Widget$moduleClass))
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$dataGrid),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						!_short,
						$elm$html$Html$text('Data table'))
					])));
	});
var $author$project$Icons$Platform2$datapointSortAscending = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M0.727273 0H6.08646C6.48813 0 6.81374 0.325611 6.81374 0.727273V3.9596C6.81374 4.36126 6.48813 4.68687 6.08646 4.68687H0.727273C0.325611 4.68687 0 4.36126 0 3.9596V0.727273C0 0.325611 0.325611 0 0.727273 0ZM5.35838 3.23133V1.45455H1.4546V3.23133H5.35838ZM10.6788 5.65657H0.727273C0.325611 5.65657 0 5.98218 0 6.38384V9.61616C0 10.0178 0.325611 10.3434 0.727273 10.3434H10.6788C11.0804 10.3434 11.4061 10.0178 11.4061 9.61616V6.38384C11.4061 5.98218 11.0804 5.65657 10.6788 5.65657ZM9.95138 7.11049V8.88839H1.4546V7.11049H9.95138ZM15.2727 11.3131H0.727273C0.325611 11.3131 0 11.6387 0 12.0404V15.2727C0 15.6744 0.325611 16 0.727273 16H15.2727C15.6744 16 16 15.6744 16 15.2727V12.0404C16 11.6387 15.6744 11.3131 15.2727 11.3131ZM14.5455 12.7676V14.5455H1.4546V12.7676H14.5455Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$datapointSortDescending = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M0.727273 16H6.08646C6.48813 16 6.81374 15.6744 6.81374 15.2727V12.0404C6.81374 11.6387 6.48813 11.3131 6.08646 11.3131H0.727273C0.325611 11.3131 0 11.6387 0 12.0404V15.2727C0 15.6744 0.325611 16 0.727273 16ZM5.35838 12.7687V14.5455H1.4546V12.7687H5.35838ZM10.6788 10.3434H0.727273C0.325611 10.3434 0 10.0178 0 9.61616V6.38384C0 5.98218 0.325611 5.65657 0.727273 5.65657H10.6788C11.0804 5.65657 11.4061 5.98218 11.4061 6.38384V9.61616C11.4061 10.0178 11.0804 10.3434 10.6788 10.3434ZM9.95138 8.88951V7.11161H1.4546V8.88951H9.95138ZM15.2727 4.68687H0.727273C0.325611 4.68687 0 4.36126 0 3.9596V0.727274C0 0.325612 0.325611 9.53674e-07 0.727273 9.53674e-07H15.2727C15.6744 9.53674e-07 16 0.325612 16 0.727274V3.9596C16 4.36126 15.6744 4.68687 15.2727 4.68687ZM14.5455 3.23245V1.45455H1.4546V3.23245H14.5455Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$circle = {
	mr: A2(
		$elm$svg$Svg$circle,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$cx('6'),
				$elm$svg$Svg$Attributes$cy('6'),
				$elm$svg$Svg$Attributes$r('3'),
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_Nil),
	e5: 12,
	mT: 0,
	mU: 0,
	e6: 12
};
var $author$project$Platform2$Dropdown$Item$sublabel = function (label_) {
	return function (config) {
		return _Utils_update(
			config,
			{gR: label_});
	};
};
var $author$project$Dashboards2$Widget$footerDropdownView = F2(
	function (config, store) {
		var _v0 = A3(
			$elm$core$List$foldl,
			F2(
				function (item, acc) {
					switch (item.$) {
						case 0:
							var itm = item.a;
							return (itm.pv && _Utils_eq(acc, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
								{
									dq: itm.dq,
									h4: $elm$core$Maybe$Just(itm.h4)
								}) : acc;
						case 1:
							var itm = item.a;
							return (itm.pv && _Utils_eq(acc, $elm$core$Maybe$Nothing)) ? $elm$core$Maybe$Just(
								{dq: itm.kx, h4: $elm$core$Maybe$Nothing}) : acc;
						default:
							return acc;
					}
				}),
			$elm$core$Maybe$Nothing,
			config.f2);
		if (!_v0.$) {
			var firstSelectedItem = _v0.a;
			var showDot = function () {
				var _v5 = A2(
					$krisajenkins$remotedata$RemoteData$map,
					function ($) {
						return $.bF;
					},
					store.jU);
				if (_v5.$ === 3) {
					var showDotOnChartTypeDropdown = _v5.a.iO;
					return showDotOnChartTypeDropdown;
				} else {
					return false;
				}
			}();
			var newCircle = A2(
				$elm$html$Html$span,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nest,
						'new-circle',
						A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'toggle-button', config.fs))
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$circle)
					]));
			var labelView = function () {
				var _v4 = config.ed;
				if (!_v4.$) {
					var prefix = _v4.a;
					return A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(prefix),
								A2(
								$elm_community$html_extra$Html$Extra$viewMaybe,
								function (label) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['toggle-button', 'label-suffix']),
												config.fs)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(label)
											]));
								},
								firstSelectedItem.h4)
							]));
				} else {
					return A2($elm_community$html_extra$Html$Extra$viewMaybe, $elm$html$Html$text, firstSelectedItem.h4);
				}
			}();
			var dropdownItemView = function (item_) {
				switch (item_.$) {
					case 1:
						var item = item_.a;
						return $author$project$Platform2$Dropdown$Item$view(
							_List_fromArray(
								[
									$author$project$Platform2$Dropdown$Item$class(
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['dropdown', 'options']),
										config.fs)),
									$author$project$Platform2$Dropdown$Item$label(item.h4),
									$author$project$Platform2$Dropdown$Item$leftIcon(item.dq),
									$author$project$Platform2$Dropdown$Item$onClick(item.cd)
								]));
					case 0:
						var item = item_.a;
						return $author$project$Platform2$Dropdown$Item$view(
							function (attrs) {
								return item.bJ ? attrs : A2(
									$elm$core$List$cons,
									$author$project$Platform2$Dropdown$Item$onClick(item.cd),
									attrs);
							}(
								A3(
									$author$project$Gwi$List$addIf,
									item.bZ,
									$author$project$Platform2$Dropdown$Item$sublabel(
										$elm$core$Maybe$Just('New')),
									_List_fromArray(
										[
											$author$project$Platform2$Dropdown$Item$class(
											A2(
												$GlobalWebIndex$class_namespaces$WeakCss$addMany,
												_List_fromArray(
													['dropdown', 'options']),
												config.fs)),
											$author$project$Platform2$Dropdown$Item$selected(item.pv),
											$author$project$Platform2$Dropdown$Item$disabled(item.bJ),
											$author$project$Platform2$Dropdown$Item$label(item.h4),
											$author$project$Platform2$Dropdown$Item$leftIcon(item.dq)
										]))));
					default:
						return $author$project$Platform2$Dropdown$Item$separator(
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['dropdown', 'options']),
								config.fs));
				}
			};
			var dropdownView = function (_v2) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('top-right', true),
									_Utils_Tuple2('limit-height', config.f7)
								]),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['dropdown', 'options']),
								config.fs))
						]),
					A2($elm$core$List$map, dropdownItemView, config.f2));
			};
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$GlobalWebIndex$class_namespaces$WeakCss$toClass(config.fs),
						A2($elm_community$html_extra$Html$Attributes$Extra$attributeMaybe, $elm$html$Html$Attributes$id, config.j5)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('active', config.h$),
										_Utils_Tuple2('short', config.a8)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'toggle-button', config.fs)),
								$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(config.gW)
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, firstSelectedItem.dq),
								A2(
								$elm_community$html_extra$Html$Extra$viewIf,
								showDot && _Utils_eq(config.ed, $elm$core$Maybe$Nothing),
								newCircle),
								A2($elm_community$html_extra$Html$Extra$viewIf, !config.a8, labelView),
								config.h$ ? A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretUp) : A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretDown)
							])),
						A2($elm_community$html_extra$Html$Extra$viewIfLazy, config.h$, dropdownView)
					]));
		} else {
			return $elm_community$html_extra$Html$Extra$nothing;
		}
	});
var $author$project$Icons$Platform2$help = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('M10.036 12.29c.32.161.45.552.29.873-.442.88-.676 1.843-.676 2.837 0 3.507 2.843 6.35 6.35 6.35 1.513 0 2.942-.532 4.077-1.488.274-.231.684-.196.916.078.23.275.196.685-.079.916-1.366 1.152-3.091 1.794-4.914 1.794-4.225 0-7.65-3.425-7.65-7.65 0-1.198.282-2.36.813-3.42.161-.321.552-.45.873-.29zm5.963 6.107l.107.008c.385.052.68.38.68.778 0 .434-.351.786-.786.786-.435 0-.785-.352-.785-.772-.009-.407.294-.744.685-.793l.1-.007zM16 8.35c4.226 0 7.65 3.424 7.65 7.65 0 1.197-.281 2.359-.812 3.419-.161.32-.552.45-.873.29-.32-.161-.45-.552-.29-.873.442-.88.676-1.844.676-2.836 0-3.508-2.843-6.35-6.35-6.35-1.513 0-2.942.532-4.077 1.488-.275.23-.685.196-.916-.079a.65.65 0 01.079-.916C12.453 8.993 14.177 8.35 16 8.35zm.002 3.88c1.186 0 2.148.96 2.148 2.148 0 .712-.313 1.188-.882 1.61l-.148.103c-.31.208-.44.36-.465.574l-.004.084v.187a.65.65 0 01-.65.65.649.649 0 01-.643-.554l-.007-.096v-.187c0-.724.318-1.208.894-1.631l.15-.105c.34-.23.455-.385.455-.635 0-.469-.38-.848-.848-.848-.433 0-.79.323-.843.74l-.006.107a.65.65 0 01-.65.65c-.36 0-.65-.291-.65-.65 0-1.186.963-2.147 2.149-2.147z')
					]),
				_List_Nil)
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$Widget$OpenHelpMeChooseMetricModal = function (a) {
	return {$: 13, a: a};
};
var $author$project$Data$Metric$getTooltipText = function (metric) {
	switch (metric) {
		case 0:
			return 'Show how many people in your audience match with the attribute.';
		case 1:
			return 'Shows the contribution that your selected audience makes to the total audience that matches an attribute.';
		case 2:
			return 'Shows GWI\'s estimate of how many real-world people are represented by the Audience %.';
		case 3:
			return 'Compares your Audience to the base audience you have applied, showing how much more or less likely they are to match with an attribute.';
		default:
			return 'Shows the number of people from our panel who match the attribute.';
	}
};
var $author$project$Dashboards2$Widget$metricsDropdownView = F5(
	function (config, _v0, widget, model, currentMetric) {
		var _short = _v0.a8;
		var metricDropdownOpened = _Utils_eq(model.w, $author$project$Dashboards2$Widget$MetricsDropdown);
		var metricDropdownItem = function (metric) {
			return $author$project$CoolTip$Platform2$view(
				{
					lm: $elm$core$Maybe$Nothing,
					lB: 1,
					mt: _List_Nil,
					mu: _List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'active',
											_Utils_eq(metric, currentMetric))
										]),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['footer', 'metrics-dropdown', 'metric']),
										$author$project$Dashboards2$Widget$moduleClass)),
									$elm$html$Html$Events$onClick(
									config.a(
										$author$project$Dashboards2$Widget$SetMetric(metric)))
								]),
							_List_fromArray(
								[
									A2(
									$elm_community$html_extra$Html$Extra$viewIf,
									_Utils_eq(metric, currentMetric),
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$tick)),
									$elm$html$Html$text(
									$author$project$Data$Metric$getLabel(metric))
								]))
						]),
					mE: _List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['footer', 'metrics-dropdown', 'tooltip']),
							$author$project$Dashboards2$Widget$moduleClass)
						]),
					mF: $elm$html$Html$text(
						$author$project$Data$Metric$getTooltipText(metric)),
					mL: $author$project$CoolTip$Normal,
					m2: _List_Nil
				});
		};
		var metricDropdown = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['footer', 'metrics-dropdown']),
					$author$project$Dashboards2$Widget$moduleClass)
				]),
			_Utils_ap(
				A2($elm$core$List$map, metricDropdownItem, $author$project$Data$Metric$allMetrics),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['footer', 'metrics-dropdown', 'separator']),
								$author$project$Dashboards2$Widget$moduleClass)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['footer', 'metrics-dropdown', 'help-me-choose']),
								$author$project$Dashboards2$Widget$moduleClass),
								$elm$html$Html$Events$onClick(
								config.a(
									$author$project$Dashboards2$Widget$OpenHelpMeChooseMetricModal(currentMetric)))
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$help),
								$elm$html$Html$text('Help me choose')
							]))
					])));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['footer', 'metrics-dropdown-wrapper']),
					$author$project$Dashboards2$Widget$moduleClass),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeMaybe,
					$elm$html$Html$Attributes$id,
					A2($author$project$Dashboards2$Widget$getDropdownElementId, widget, $author$project$Dashboards2$Widget$MetricsDropdown))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('active', metricDropdownOpened),
									_Utils_Tuple2('short', _short)
								]),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['footer', 'metrics']),
								$author$project$Dashboards2$Widget$moduleClass)),
							$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
							config.a(
								$author$project$Dashboards2$Widget$ToggleDropdown($author$project$Dashboards2$Widget$MetricsDropdown)))
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$dataMetrics),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							!_short,
							$elm$html$Html$text(
								$author$project$Data$Metric$getLabel(currentMetric))),
							metricDropdownOpened ? A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretUp) : A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$caretDown)
						])),
					A2($elm_community$html_extra$Html$Extra$viewIf, metricDropdownOpened, metricDropdown)
				]));
	});
var $author$project$D3Charts$Dashboards$ChartType$p2All = _List_fromArray(
	[3, 11, 1, 6, 5, 2, 0, 9, 10, 4, 8, 7]);
var $author$project$D3Charts$Dashboards$ChartType$p2Label = function (chartType) {
	switch (chartType) {
		case 0:
			return 'Data table';
		case 1:
			return 'Diverging bar chart';
		case 2:
			return 'Donut chart';
		case 3:
			return 'Horizontal bar chart';
		case 4:
			return 'Line chart (time series)';
		case 5:
			return 'Pie chart';
		case 6:
			return 'Pie - Radar chart';
		case 7:
			return 'Radar chart';
		case 8:
			return 'Radial chart';
		case 9:
			return 'Stat card - white';
		case 10:
			return 'Stat card - colour';
		default:
			return 'Vertical bar chart';
	}
};
var $author$project$Icons$Platform2$sort = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M19.97 9.81l.088-.02c.067-.01.135-.01.202.001l-.103-.008c.055 0 .107.007.158.02l.043.012c.02.006.038.013.057.021l.038.018c.016.008.032.017.047.027l.037.024c.034.026.063.05.089.078l3.024 3.024c.254.254.254.665 0 .92-.228.228-.584.25-.838.068l-.08-.069-1.925-1.924V22.23c0 .359-.29.65-.65.65-.326 0-.596-.241-.643-.554l-.007-.096V12.002l-1.923 1.924c-.229.229-.585.252-.839.069l-.08-.069c-.229-.228-.252-.584-.069-.838l.069-.081 3.033-3.033.013-.013c.015-.015.031-.028.048-.041l-.061.054c.029-.03.06-.055.092-.077.016-.011.033-.021.05-.03l.035-.02c.025-.012.051-.022.078-.031l.007-.002.01-.003z'),
				$author$project$Icons$Platform2$path('M11.731 9.783c.327 0 .597.24.643.554l.007.096V20.66l1.924-1.922c.229-.229.585-.252.839-.069l.08.069c.23.228.252.584.07.838l-.07.08-3.033 3.034-.014.014-.044.038.058-.052c-.029.03-.06.055-.093.077-.016.011-.032.021-.049.03l-.035.02-.052.022-.038.013c-.031.01-.063.017-.096.021l-.096.007c-.035 0-.069-.002-.103-.008l.102.009c-.063 0-.125-.01-.184-.027l-.014-.005c-.027-.008-.053-.018-.078-.03l-.016-.008c-.02-.01-.04-.022-.06-.034l-.026-.018c-.035-.026-.064-.05-.09-.078l-3.024-3.024c-.254-.254-.254-.666 0-.92.228-.228.584-.25.838-.068l.08.069 1.924 1.922V10.433c0-.359.291-.65.65-.65z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$path = function (d) {
	return A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d(d)
			]),
		_List_Nil);
};
var $author$project$Icons$ChartTypes$dataTable = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M 13.85 0.8 l -11.22 0 a 1.87 1.87 90 0 0 -1.87 1.87 l 0 11.22 a 1.87 1.87 90 0 0 1.87 1.87 l 11.22 0 a 1.87 1.87 90 0 0 1.87 -1.87 l 0 -11.22 a 1.87 1.87 90 0 0 -1.87 -1.87 z m 0.748 10.3785 l 0 2.7115 a 0.935 0.935 90 0 1 -0.748 0.748 l -2.7115 0 l 0 -3.4595 z m -4.5815 0 l 0 3.4595 l -3.553 0 l 0 -3.4595 z m -4.675 0 l 0 3.4595 l -2.7115 0 a 0.935 0.935 90 0 1 -0.748 -0.748 l 0 -2.7115 z m 9.2565 -4.675 l 0 3.553 l -3.4595 0 l 0 -3.553 z m -4.5815 0 l 0 3.553 l -3.553 0 l 0 -3.553 z m -4.675 0 l 0 3.553 l -3.4595 0 l 0 -3.553 z m 9.2565 -3.8335 l 0 2.7115 l -3.4595 0 l 0 -3.4595 l 2.7115 0 a 0.935 0.935 90 0 1 0.748 0.748 z m -4.5815 -0.748 l 0 3.4595 l -3.553 0 l 0 -3.4595 z m -4.675 0 l 0 3.4595 l -3.4595 0 l 0 -2.7115 a 0.935 0.935 90 0 1 0.748 -0.748 z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $elm$svg$Svg$mask = $elm$svg$Svg$trustedNode('mask');
var $elm$svg$Svg$Attributes$mask = _VirtualDom_attribute('mask');
var $author$project$Icons$ChartTypes$diverginBarChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$svg,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$width('16'),
						$elm$svg$Svg$Attributes$height('16'),
						$elm$svg$Svg$Attributes$viewBox('0 0 16 16'),
						$elm$svg$Svg$Attributes$fill('none')
					]),
				_List_fromArray(
					[
						A2(
						$elm$svg$Svg$mask,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('path-1-inside-1_797_2458'),
								$elm$svg$Svg$Attributes$fill('white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M8 0H12.5C12.7761 0 13 0.223858 13 0.5V3.5C13 3.77614 12.7761 4 12.5 4H8V0Z')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M8 0H12.5C12.7761 0 13 0.223858 13 0.5V3.5C13 3.77614 12.7761 4 12.5 4H8V0Z'),
								$elm$svg$Svg$Attributes$stroke('#191530'),
								$elm$svg$Svg$Attributes$strokeWidth('2.4'),
								$elm$svg$Svg$Attributes$mask('url(#path-1-inside-1_797_2458)')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$mask,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('path-2-inside-2_797_2458'),
								$elm$svg$Svg$Attributes$fill('white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M3 0.5C3 0.223858 3.22386 0 3.5 0H8V4H3.5C3.22386 4 3 3.77614 3 3.5V0.5Z')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M3 0.5C3 0.223858 3.22386 0 3.5 0H8V4H3.5C3.22386 4 3 3.77614 3 3.5V0.5Z'),
								$elm$svg$Svg$Attributes$stroke('#191530'),
								$elm$svg$Svg$Attributes$strokeWidth('2.4'),
								$elm$svg$Svg$Attributes$mask('url(#path-2-inside-2_797_2458)')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$mask,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('path-3-inside-3_797_2458'),
								$elm$svg$Svg$Attributes$fill('white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M8 6H13.5C13.7761 6 14 6.22386 14 6.5V9.5C14 9.77614 13.7761 10 13.5 10H8V6Z')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M8 6H13.5C13.7761 6 14 6.22386 14 6.5V9.5C14 9.77614 13.7761 10 13.5 10H8V6Z'),
								$elm$svg$Svg$Attributes$stroke('#191530'),
								$elm$svg$Svg$Attributes$strokeWidth('2.4'),
								$elm$svg$Svg$Attributes$mask('url(#path-3-inside-3_797_2458)')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$mask,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('path-4-inside-4_797_2458'),
								$elm$svg$Svg$Attributes$fill('white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M2 6.5C2 6.22386 2.22386 6 2.5 6H8V10H2.5C2.22386 10 2 9.77614 2 9.5V6.5Z')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M2 6.5C2 6.22386 2.22386 6 2.5 6H8V10H2.5C2.22386 10 2 9.77614 2 9.5V6.5Z'),
								$elm$svg$Svg$Attributes$stroke('#191530'),
								$elm$svg$Svg$Attributes$strokeWidth('2.4'),
								$elm$svg$Svg$Attributes$mask('url(#path-4-inside-4_797_2458)')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$mask,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('path-5-inside-5_797_2458'),
								$elm$svg$Svg$Attributes$fill('white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M8 12H15.5C15.7761 12 16 12.2239 16 12.5V15.5C16 15.7761 15.7761 16 15.5 16H8V12Z')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M8 12H15.5C15.7761 12 16 12.2239 16 12.5V15.5C16 15.7761 15.7761 16 15.5 16H8V12Z'),
								$elm$svg$Svg$Attributes$stroke('#191530'),
								$elm$svg$Svg$Attributes$strokeWidth('2.4'),
								$elm$svg$Svg$Attributes$mask('url(#path-5-inside-5_797_2458)')
							]),
						_List_Nil),
						A2(
						$elm$svg$Svg$mask,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$id('path-6-inside-6_797_2458'),
								$elm$svg$Svg$Attributes$fill('white')
							]),
						_List_fromArray(
							[
								A2(
								$elm$svg$Svg$path,
								_List_fromArray(
									[
										$elm$svg$Svg$Attributes$d('M0 12.5C0 12.2239 0.223858 12 0.5 12H8V16H0.5C0.223858 16 0 15.7761 0 15.5V12.5Z')
									]),
								_List_Nil)
							])),
						A2(
						$elm$svg$Svg$path,
						_List_fromArray(
							[
								$elm$svg$Svg$Attributes$d('M0 12.5C0 12.2239 0.223858 12 0.5 12H8V16H0.5C0.223858 16 0 15.7761 0 15.5V12.5Z'),
								$elm$svg$Svg$Attributes$stroke('#191530'),
								$elm$svg$Svg$Attributes$strokeWidth('2.4'),
								$elm$svg$Svg$Attributes$mask('url(#path-6-inside-6_797_2458)')
							]),
						_List_Nil)
					]))
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$donutChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M12.7866 3.21343C11.8788 2.30569 10.7774 1.70965 9.61535 1.42531C9.28588 1.34469 8.95153 1.28913 8.61535 1.25863V4.04704C10.5323 4.34303 12 6.00012 12 8C12 10.2091 10.2091 12 7.99998 12C7.09293 12 6.25639 11.6981 5.58537 11.1893L3.65838 13.1941C3.92014 13.4134 4.19458 13.6098 4.47906 13.7833C7.08491 15.3727 10.5327 15.0404 12.7866 12.7866C15.43 10.1431 15.4298 5.85701 12.7866 3.21343ZM5.81643 10.1095L6.18959 10.3924C6.6928 10.774 7.31857 11 7.99998 11C9.65684 11 11 9.65685 11 8C11 6.50101 9.89963 5.25719 8.46275 5.03533L7.99998 4.96387L7.53718 5.03534C6.73387 5.15939 6.03312 5.60368 5.57198 6.23747L5.29634 6.61632L5.15029 7.05886C5.05303 7.35359 4.99998 7.6696 4.99998 8C4.99998 8.64458 5.20213 9.23896 5.54657 9.72706L5.81643 10.1095ZM2.8005 3.66486C2.93012 3.50977 3.06776 3.35911 3.21343 3.21344C4.12116 2.30571 5.22253 1.70968 6.38457 1.42533C6.71404 1.34471 7.04839 1.28914 7.38457 1.25863V4.04705C6.30974 4.21302 5.37618 4.80688 4.76337 5.64914L2.20746 4.49425C2.3818 4.2067 2.57948 3.92933 2.8005 3.66486ZM4.20067 6.74546C4.07045 7.14004 3.99998 7.56179 3.99998 8C3.99998 8.8577 4.26994 9.65235 4.72951 10.3036L2.78952 12.322C2.56959 12.0575 2.37294 11.7801 2.19956 11.4927C1.29785 9.9978 1.02559 8.22952 1.3828 6.56955C1.45338 6.24156 1.54854 5.91779 1.66827 5.60119L4.20067 6.74546ZM2.35095 13.6646C5.47576 16.781 10.5353 16.7784 13.6568 13.6569C16.7811 10.5327 16.781 5.46735 13.6569 2.34315C10.5327 -0.78105 5.46735 -0.781049 2.34315 2.34315C-0.77832 5.4646 -0.781047 10.5238 2.33496 13.6487C2.34017 13.6541 2.34551 13.6594 2.35095 13.6646Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$horizontalBarChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M7.19168 6.57263C7.59334 6.57263 7.91895 6.24702 7.91895 5.84536L7.91895 1.53587C7.91895 1.1342 7.59334 0.808594 7.19168 0.808594L0.727138 0.808593C0.325482 0.808593 -0.000123992 1.1342 -0.000124009 1.53587L-0.000124198 5.84536C-0.000124215 6.24702 0.325482 6.57263 0.727137 6.57263L7.19168 6.57263ZM6.4644 2.26308L6.4644 5.11803L1.4543 5.11803L1.4543 2.26308L6.4644 2.26308Z'),
				$author$project$Icons$ChartTypes$path('M15.2727 10.8829C15.6744 10.8829 16 10.5573 16 10.1557L16 5.84617C16 5.44451 15.6744 5.1189 15.2727 5.1189L0.727509 5.1189C0.325853 5.1189 0.000247941 5.44451 0.000247924 5.84617L0.000247735 10.1557C0.000247718 10.5573 0.325853 10.8829 0.727509 10.8829L15.2727 10.8829ZM14.5455 6.57342L14.5455 9.42837L1.45475 9.42837L1.45475 6.57342L14.5455 6.57342Z'),
				$author$project$Icons$ChartTypes$path('M11.2327 15.1924C11.6344 15.1924 11.96 14.8668 11.96 14.4651L11.96 10.1556C11.96 9.75396 11.6344 9.42834 11.2327 9.42834L0.72781 9.42834C0.326155 9.42834 0.000548348 9.75396 0.000548331 10.1556L0.000548143 14.4651C0.000548125 14.8668 0.326154 15.1924 0.72781 15.1924L11.2327 15.1924ZM10.5054 10.8829L10.5054 13.7378L1.45505 13.7378L1.45505 10.8829L10.5054 10.8829Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$lineChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M1.23077 0.615384C1.23077 0.275517 0.955251 0 0.615384 0C0.275517 0 0 0.275517 0 0.615384V13.7436C0 14.9901 1.00987 16 2.25641 16H15.3846C15.7245 16 16 15.7245 16 15.3846C16 15.0447 15.7245 14.7692 15.3846 14.7692H2.25641C1.68961 14.7692 1.23077 14.3104 1.23077 13.7436V0.615384ZM15.8574 3.47088C16.0749 3.20977 16.0396 2.82174 15.7785 2.60417C15.5174 2.3866 15.1294 2.42189 14.9118 2.68299L11.1391 7.21057C11.0885 7.27112 11.0083 7.29732 10.9312 7.27818L8.64895 6.7072C8.11471 6.57364 7.55047 6.75762 7.19739 7.18103L3.42468 11.7086C3.20711 11.9697 3.2424 12.3578 3.5035 12.5753C3.7646 12.7929 4.15264 12.7576 4.37021 12.4965L8.14278 7.96909C8.19336 7.90843 8.27425 7.88221 8.35044 7.90122L10.6335 8.47239C11.1683 8.60574 11.7316 8.42184 12.0847 7.99846L15.8574 3.47088Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$pieChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M8.61535 1.25863C10.1373 1.39673 11.6215 2.04833 12.7866 3.21343L12.7868 3.21372C15.4301 5.85729 15.43 10.1431 12.7866 12.7866C10.2867 15.2865 6.3179 15.4223 3.65838 13.1941L8.44363 8.21558C8.54313 8.11206 8.60296 7.97739 8.61362 7.83515C8.61524 7.81456 8.6158 7.79398 8.61535 7.77351V1.25863ZM7.38457 1.25863C5.86264 1.39675 4.37852 2.04835 3.21344 3.21344L3.21343 3.21344C2.81937 3.6075 2.48404 4.03806 2.20746 4.49425L7.38457 6.83353V1.25863ZM1.66827 5.60119C0.826068 7.82814 1.19982 10.41 2.78952 12.322L6.95383 7.98948L1.66827 5.60119ZM2.33496 13.6487C-0.781047 10.5238 -0.77832 5.4646 2.34315 2.34315C5.46735 -0.781049 10.5327 -0.781051 13.6569 2.34315C16.781 5.46735 16.7811 10.5327 13.6568 13.6569C10.5353 16.7784 5.47576 16.781 2.35095 13.6646C2.34551 13.6594 2.34018 13.6541 2.33496 13.6487Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$pieRadarChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M-2.80616e-07 9.58025L-3.06519e-07 8.98766C-4.1698e-07 7.80738 0.232472 6.63866 0.684144 5.54823C1.13582 4.4578 1.79784 3.467 2.63242 2.63242C3.467 1.79784 4.45779 1.13582 5.54823 0.684145C6.63866 0.232473 7.80738 -3.41271e-07 8.98765 -3.92863e-07L9.58025 -4.18766e-07L9.58025 3.98559C10.3008 4.07096 10.9969 4.31132 11.6195 4.69287C12.4116 5.17825 13.054 5.87319 13.4757 6.70089C13.8974 7.52858 14.082 8.45678 14.0092 9.38286C13.9519 10.1109 13.7372 10.8153 13.3827 11.4484L15.0091 12.63L14.6608 13.1094C13.7903 14.3074 12.563 15.1992 11.1546 15.6568C9.74621 16.1144 8.22911 16.1144 6.82072 15.6568C5.41234 15.1992 4.18498 14.3075 3.31455 13.1094C2.56072 12.0719 2.10812 10.8507 2.00039 9.58025L-2.80616e-07 9.58025ZM8.39506 8.39506L8.39506 1.20772C7.57335 1.27031 6.76545 1.46279 6.00178 1.77911C5.05514 2.17122 4.195 2.74595 3.47047 3.47048C2.74595 4.195 2.17122 5.05514 1.77911 6.00178C1.46279 6.76545 1.27031 7.57335 1.20772 8.39506L8.39506 8.39506ZM8.79511 9.58025L3.1907 9.58025C3.29493 10.5999 3.6668 11.5779 4.27338 12.4128C4.9967 13.4083 6.01662 14.1493 7.18696 14.5296C8.35731 14.9099 9.618 14.9099 10.7883 14.5296C11.7698 14.2107 12.6455 13.6381 13.3292 12.8744L8.79511 9.58025ZM12.4151 10.7453C12.6466 10.294 12.7875 9.79947 12.8276 9.28987C12.8834 8.58169 12.7422 7.87189 12.4197 7.23895C12.0972 6.60601 11.6059 6.07458 11.0002 5.70341C10.5644 5.43632 10.0815 5.2597 9.58025 5.18166L9.58025 8.68571L12.4151 10.7453Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$radarChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M8 0C7.08023 0 6.20014 0.156012 5.37889 0.430821C5.05137 0.540416 4.87631 0.890059 4.98788 1.21177C5.09945 1.53348 5.45541 1.70544 5.78293 1.59585C6.48196 1.36194 7.22574 1.23077 8 1.23077C8.77429 1.23077 9.51801 1.36195 10.216 1.59578C10.5435 1.70548 10.8995 1.53364 11.0112 1.21197C11.1229 0.890291 10.948 0.54059 10.6205 0.430888C9.79989 0.156002 8.91974 0 8 0ZM0.505235 8.83215C0.844681 8.7663 1.1742 8.98322 1.24123 9.31665C1.5409 10.8072 2.34166 12.1198 3.46379 13.0864C3.72393 13.3105 3.74987 13.6993 3.52174 13.9549C3.29361 14.2104 2.89778 14.2359 2.63764 14.0118C1.31561 12.873 0.367215 11.322 0.0119893 9.5551C-0.0550449 9.22167 0.165789 8.89799 0.505235 8.83215ZM11.0112 14.7881C11.1229 15.1097 10.948 15.4594 10.6205 15.5691C9.79989 15.844 8.91974 16 8 16C7.08023 16 6.20014 15.844 5.37889 15.5692C5.05137 15.4596 4.87631 15.11 4.98788 14.7883C5.09945 14.4665 5.45541 14.2946 5.78293 14.4042C6.48196 14.6381 7.22574 14.7693 8 14.7693C8.77429 14.7693 9.51801 14.6381 10.216 14.4042C10.5435 14.2945 10.8995 14.4664 11.0112 14.7881ZM15.4948 8.83246C15.8342 8.8983 16.055 9.22198 15.988 9.55541C15.6328 11.3223 14.6844 12.8733 13.3624 14.0121C13.1022 14.2362 12.7064 14.2107 12.4783 13.9552C12.2501 13.6996 12.2761 13.3108 12.5362 13.0867C13.6583 12.1201 14.4591 10.8075 14.7588 9.31696C14.8258 8.98353 15.1553 8.76661 15.4948 8.83246ZM13.1103 2.40286C12.8498 2.17912 12.454 2.20514 12.2263 2.46097C11.9985 2.71681 12.025 3.10558 12.2854 3.32932C13.4497 4.32951 14.2066 5.66701 14.4978 7.10487C14.5653 7.43821 14.8951 7.65468 15.2345 7.58838C15.5738 7.52208 15.7942 7.19811 15.7267 6.86477C15.3837 5.17074 14.4905 3.58848 13.1103 2.40286ZM3.52172 2.04504C3.74987 2.30056 3.72394 2.68937 3.46381 2.91347C2.34069 3.88103 1.54012 5.19281 1.24129 6.68298C1.17442 7.01644 0.845011 7.23351 0.505533 7.16783C0.166054 7.10215 -0.054939 6.77857 0.0119306 6.44512C0.366326 4.67784 1.31491 3.12767 2.63762 1.98816C2.89775 1.76406 3.29357 1.78953 3.52172 2.04504ZM3.96788 6.96795L7.72683 2.04487L13.1564 5.73718L11.9034 11.891H3.55022L3.96788 6.96795Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$radialChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M14.7692 8C14.7692 11.7388 11.7388 14.7692 8 14.7692C4.26115 14.7692 1.23076 11.7388 1.23076 8C1.23076 7.66013 0.955246 7.38462 0.615381 7.38462C0.275516 7.38462 -5.65653e-07 7.66013 0 8C1.60491e-07 12.4186 3.58142 16 8 16C12.4186 16 16 12.4186 16 8C16 3.58142 12.4186 -1.16164e-07 8 0C7.66013 -1.23437e-08 7.38462 0.275515 7.38462 0.615381C7.38462 0.955246 7.66013 1.23076 8 1.23076C11.7388 1.23076 14.7692 4.26115 14.7692 8ZM7.99962 11.8965C10.1522 11.8965 11.8969 10.1518 11.8969 7.9992C11.8969 5.84658 10.1522 4.10189 7.99962 4.10189C7.65975 4.10189 7.38424 3.82637 7.38424 3.48651C7.38424 3.14664 7.65975 2.87112 7.99962 2.87112C10.832 2.87112 13.1277 5.16685 13.1277 7.9992C13.1277 10.8315 10.832 13.1273 7.99962 13.1273C5.16727 13.1273 2.87154 10.8315 2.87154 7.9992C2.87154 7.65933 3.14706 7.38382 3.48692 7.38382C3.82679 7.38382 4.1023 7.65933 4.1023 7.9992C4.1023 10.1518 5.847 11.8965 7.99962 11.8965ZM7.99986 9.21685C8.67184 9.21685 9.21671 8.67198 9.21671 8C9.21671 7.32802 8.67184 6.78315 7.99986 6.78315C7.66 6.78315 7.38448 6.50764 7.38448 6.16777C7.38448 5.8279 7.66 5.55239 7.99986 5.55239C9.35157 5.55239 10.4475 6.64829 10.4475 8C10.4475 9.35171 9.35157 10.4476 7.99986 10.4476C6.64815 10.4476 5.55225 9.35171 5.55225 8C5.55225 7.66013 5.82777 7.38462 6.16763 7.38462C6.5075 7.38462 6.78301 7.66013 6.78301 8C6.78301 8.67198 7.32788 9.21685 7.99986 9.21685Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$pathFill = F2(
	function (fill, d) {
		return A2(
			$elm$svg$Svg$path,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$d(d),
					$elm$svg$Svg$Attributes$fill(fill)
				]),
			_List_Nil);
	});
var $author$project$Icons$ChartTypes$statCardColor = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M0 4.71613C0 2.11148 2.11149 0 4.71613 0H11.2839C13.8885 0 16 2.11149 16 4.71613V11.2839C16 13.8885 13.8885 16 11.2839 16H4.71613C2.11148 16 0 13.8885 0 11.2839V4.71613Z'),
				A2($author$project$Icons$ChartTypes$pathFill, '#ffffff', 'M5.64144 5C4.06023 5 3 6.03663 3 7.87068C3 9.70473 4.06023 10.7414 5.64144 10.7414C7.23178 10.7414 8.30115 9.70473 8.30115 7.87068C8.30115 6.03663 7.23178 5 5.64144 5ZM5.64144 9.62499C4.70002 9.62499 4.46239 9.27412 4.46239 7.87068C4.46239 6.46724 4.70002 6.11638 5.64144 6.11638C6.60113 6.11638 6.83876 6.46724 6.83876 7.87068C6.83876 9.27412 6.60113 9.62499 5.64144 9.62499Z'),
				A2($author$project$Icons$ChartTypes$pathFill, '#ffffff', 'M10.6695 5.07974L8.549 6.04461L9.30761 7.16896L10.5872 5.94892V10.6616H12.0222V5.07974H10.6695Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$statCardWhite = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M4.71613 0C2.11148 0 0 2.11148 0 4.71612V11.2838C0 13.8885 2.11148 15.9999 4.71613 15.9999H11.2839C13.8885 15.9999 16 13.8885 16 11.2838V4.71612C16 2.11148 13.8885 0 11.2839 0H4.71613ZM1.2303 4.71612C1.2303 2.79095 2.79096 1.23029 4.71613 1.23029H11.2839C13.209 1.23029 14.7697 2.79095 14.7697 4.71612V11.2838C14.7697 13.209 13.209 14.7697 11.2839 14.7697H4.71613C2.79096 14.7697 1.2303 13.209 1.2303 11.2838V4.71612ZM3.28079 7.79185C3.28079 5.9578 4.34102 4.92117 5.92223 4.92117C7.51257 4.92117 8.58194 5.9578 8.58194 7.79185C8.58194 9.62589 7.51257 10.6625 5.92223 10.6625C4.34102 10.6625 3.28079 9.62589 3.28079 7.79185ZM4.74318 7.79185C4.74318 9.19529 4.98082 9.54615 5.92223 9.54615C6.88192 9.54615 7.11956 9.19529 7.11956 7.79185C7.11956 6.3884 6.88192 6.03754 5.92223 6.03754C4.98082 6.03754 4.74318 6.3884 4.74318 7.79185ZM8.82979 5.96578L10.9503 5.00091H12.303V10.5828H10.868V5.87009L9.5884 7.09013L8.82979 5.96578Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$ChartTypes$verticalBarChart = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$ChartTypes$path('M6.76404 8.80819C6.76404 8.40654 6.43843 8.08093 6.03677 8.08093H1.72727C1.32561 8.08093 1 8.40654 1 8.80819V15.2727C1 15.6744 1.32561 16 1.72727 16H6.03677C6.43843 16 6.76404 15.6744 6.76404 15.2727V8.80819ZM2.45449 9.53548H5.30944V14.5456H2.45449V9.53548Z'),
				$author$project$Icons$ChartTypes$path('M11.0746 0.727261C11.0746 0.325606 10.749 0 10.3473 0H6.03782C5.63616 0 5.31055 0.325606 5.31055 0.727261V15.2725C5.31055 15.6741 5.63616 15.9998 6.03782 15.9998H10.3473C10.749 15.9998 11.0746 15.6741 11.0746 15.2725V0.727261ZM6.76507 1.45454H9.62002V14.5452H6.76507V1.45454Z'),
				$author$project$Icons$ChartTypes$path('M15.3837 4.7673C15.3837 4.36565 15.0581 4.04004 14.6564 4.04004H10.3469C9.94524 4.04004 9.61963 4.36565 9.61963 4.7673V15.2722C9.61963 15.6738 9.94524 15.9995 10.3469 15.9995H14.6564C15.0581 15.9995 15.3837 15.6738 15.3837 15.2722V4.7673ZM11.0742 5.49458H13.9291V14.5449H11.0742V5.49458Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$D3Charts$Dashboards$ChartType$toIcon = function (chartType) {
	switch (chartType) {
		case 0:
			return $author$project$Icons$ChartTypes$dataTable;
		case 1:
			return $author$project$Icons$ChartTypes$diverginBarChart;
		case 2:
			return $author$project$Icons$ChartTypes$donutChart;
		case 3:
			return $author$project$Icons$ChartTypes$horizontalBarChart;
		case 4:
			return $author$project$Icons$ChartTypes$lineChart;
		case 5:
			return $author$project$Icons$ChartTypes$pieChart;
		case 6:
			return $author$project$Icons$ChartTypes$pieRadarChart;
		case 7:
			return $author$project$Icons$ChartTypes$radarChart;
		case 8:
			return $author$project$Icons$ChartTypes$radialChart;
		case 9:
			return $author$project$Icons$ChartTypes$statCardWhite;
		case 10:
			return $author$project$Icons$ChartTypes$statCardColor;
		default:
			return $author$project$Icons$ChartTypes$verticalBarChart;
	}
};
var $author$project$Dashboards2$Widget$widgetFooterView = F7(
	function (config, flags, store, permissions, widget, chartWidget, model) {
		var can = flags.nM;
		var user = flags.mQ;
		var widgetIsShort = widget.da === 1;
		var showShortDDButtons = widget.da === 1;
		var showNewBadge = function () {
			var _v6 = A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.bF;
				},
				store.jU);
			if (_v6.$ === 3) {
				var showNewBadgeOnDonutChartItem = _v6.a.iP;
				return showNewBadgeOnDonutChartItem;
			} else {
				return false;
			}
		}();
		var prepareSortOption = function (sortType) {
			switch (sortType) {
				case 3:
					return $author$project$Dashboards2$Widget$FooterResetItem(
						{
							cd: config.a(
								$author$project$Dashboards2$Widget$SaveChartWidgetAndCloseDropdown(
									_Utils_update(
										chartWidget,
										{cY: sortType}))),
							dq: $author$project$Icons$Platform2$refresh,
							kx: $author$project$Icons$Platform2$sort,
							bJ: false,
							bZ: false,
							pv: _Utils_eq(sortType, chartWidget.cY),
							h4: 'Reset'
						});
				case 1:
					return $author$project$Dashboards2$Widget$FooterDDItem(
						{
							cd: config.a(
								$author$project$Dashboards2$Widget$SaveChartWidgetAndCloseDropdown(
									_Utils_update(
										chartWidget,
										{cY: sortType}))),
							dq: $author$project$Icons$Platform2$datapointSortAscending,
							bJ: false,
							bZ: false,
							pv: _Utils_eq(sortType, chartWidget.cY),
							h4: 'Ascending'
						});
				case 0:
					return $author$project$Dashboards2$Widget$FooterDDItem(
						{
							cd: config.a(
								$author$project$Dashboards2$Widget$SaveChartWidgetAndCloseDropdown(
									_Utils_update(
										chartWidget,
										{cY: sortType}))),
							dq: $author$project$Icons$Platform2$datapointSortDescending,
							bJ: false,
							bZ: false,
							pv: _Utils_eq(sortType, chartWidget.cY),
							h4: 'Descending'
						});
				default:
					return $author$project$Dashboards2$Widget$FooterDDItem(
						{
							cd: config.a(
								$author$project$Dashboards2$Widget$SaveChartWidgetAndCloseDropdown(
									_Utils_update(
										chartWidget,
										{cY: sortType}))),
							dq: $author$project$Icons$Platform2$alphabet,
							bJ: false,
							bZ: false,
							pv: _Utils_eq(sortType, chartWidget.cY),
							h4: 'Alphabetical'
						});
			}
		};
		var sortingDropdownView = function (_v4) {
			return A2(
				$author$project$CoolTip$Platform2$viewIf,
				!_Utils_eq(model.w, $author$project$Dashboards2$Widget$SortByDropdown),
				{
					lB: 0,
					mu: A2(
						$author$project$Dashboards2$Widget$footerDropdownView,
						{
							ed: $elm$core$Maybe$Just(
								'Sort by' + ((chartWidget.cY === 3) ? '' : ': ')),
							fs: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'footer-dropdown', $author$project$Dashboards2$Widget$moduleClass),
							j5: A2($author$project$Dashboards2$Widget$getDropdownElementId, widget, $author$project$Dashboards2$Widget$SortByDropdown),
							h$: _Utils_eq(model.w, $author$project$Dashboards2$Widget$SortByDropdown),
							f2: A2(
								$elm$core$List$map,
								prepareSortOption,
								_List_fromArray(
									[2, 1, 0, 3])),
							f7: false,
							a8: showShortDDButtons,
							gW: config.a(
								$author$project$Dashboards2$Widget$ToggleDropdown($author$project$Dashboards2$Widget$SortByDropdown))
						},
						store),
					mG: 'Sort by',
					mL: $author$project$CoolTip$Normal,
					m2: _List_Nil
				});
		};
		var isViewOnlyMode = $author$project$Data$User$hasViewOnlyPlan(user);
		var labelOnlyMetricView = F2(
			function (_short, metric) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['footer', 'metrics-dropdown-wrapper']),
							$author$project$Dashboards2$Widget$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('short', _short)
										]),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['footer', 'metrics']),
										$author$project$Dashboards2$Widget$moduleClass)),
									isViewOnlyMode ? $elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
									config.a($author$project$Dashboards2$Widget$OpenShowMetricInfoModal)) : $elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
									config.a(
										$author$project$Dashboards2$Widget$ToggleDropdown($author$project$Dashboards2$Widget$MetricsDropdown)))
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$dataMetrics),
									A2(
									$elm_community$html_extra$Html$Extra$viewIf,
									!widgetIsShort,
									$elm$html$Html$text(
										$author$project$Data$Metric$getLabel(metric)))
								]))
						]));
			});
		var metricsDropdown = function (metric) {
			return A2(
				$author$project$CoolTip$Platform2$viewIf,
				!_Utils_eq(model.w, $author$project$Dashboards2$Widget$MetricsDropdown),
				{
					lB: isViewOnlyMode ? 5 : 0,
					mu: isViewOnlyMode ? A2(labelOnlyMetricView, widgetIsShort, metric) : A5(
						$author$project$Dashboards2$Widget$metricsDropdownView,
						config,
						{a8: widgetIsShort},
						widget,
						model,
						metric),
					mG: isViewOnlyMode ? 'Metric info' : 'Default metric',
					mL: $author$project$CoolTip$Normal,
					m2: _List_Nil
				});
		};
		var hasSingleQuestion = 1 === $turboMaCk$non_empty_list_alias$List$NonEmpty$length(
			$author$project$Data$Platform2$widgetDataQuestionCodes(chartWidget.cl));
		var viewInChartsButton = function (_v3) {
			return A2(
				$author$project$CoolTip$Platform2$viewIf,
				widgetIsShort || (!hasSingleQuestion),
				{
					lB: isViewOnlyMode ? 5 : 0,
					mu: A6(
						$author$project$Dashboards2$Widget$chartsButtonView,
						config,
						{a8: widgetIsShort},
						flags,
						permissions,
						chartWidget,
						model),
					mG: hasSingleQuestion ? 'View in Charts' : 'You cannot go to Charts from multi-question widgets',
					mL: $author$project$CoolTip$Normal,
					m2: _List_Nil
				});
		};
		var hasAccessToChart = function (type_) {
			return can(23) || A2($elm$core$List$member, type_, $author$project$D3Charts$Dashboards$ChartType$availableForNonGwiCreator);
		};
		var dataTableButton = function (_v2) {
			return A2(
				$author$project$CoolTip$Platform2$viewIf,
				widgetIsShort,
				{
					lB: isViewOnlyMode ? 5 : 0,
					mu: A6(
						$author$project$Dashboards2$Widget$dataTableButtonView,
						config,
						{a8: widgetIsShort},
						flags,
						widget,
						chartWidget,
						model),
					mG: 'Data table',
					mL: $author$project$CoolTip$Normal,
					m2: _List_Nil
				});
		};
		var currentMetric = $author$project$Dashboards2$Widget$getCurrentMetric(model);
		var availableChartTypes = can(23) ? $author$project$D3Charts$Dashboards$ChartType$p2All : $author$project$D3Charts$Dashboards$ChartType$availableForNonGwiCreator;
		var attributesCount = $elm$core$List$length(
			A2($author$project$Data$Platform2$getAllDatapointCodesForWidgetInOriginalOrder, store.bt, chartWidget.cl));
		var isDisabled = function (type_) {
			return (!A2($author$project$D3Charts$Dashboards$ChartType$isValidNumberOfDatapoints, type_, attributesCount)) || (!hasAccessToChart(type_));
		};
		var isSelected = function (type_) {
			return _Utils_eq(type_, chartWidget.aI) && (!isDisabled(type_));
		};
		var prepareChartOption = F2(
			function (_v1, type_) {
				var name = _v1.ld;
				return $author$project$Dashboards2$Widget$FooterDDItem(
					{
						cd: config.a(
							A2($author$project$Dashboards2$Widget$SetChartTypeAndSave, type_, name)),
						dq: $author$project$D3Charts$Dashboards$ChartType$toIcon(type_),
						bJ: isDisabled(type_),
						bZ: showNewBadge && (type_ === 2),
						pv: isSelected(type_),
						h4: $author$project$D3Charts$Dashboards$ChartType$p2Label(type_)
					});
			});
		var chartTypeDropdown = function (_v0) {
			return A2(
				$author$project$CoolTip$Platform2$viewIf,
				!_Utils_eq(model.w, $author$project$Dashboards2$Widget$ChartTypeDropdown),
				{
					lB: 0,
					mu: A2(
						$author$project$Dashboards2$Widget$footerDropdownView,
						{
							ed: $elm$core$Maybe$Nothing,
							fs: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'footer-dropdown', $author$project$Dashboards2$Widget$moduleClass),
							j5: A2($author$project$Dashboards2$Widget$getDropdownElementId, widget, $author$project$Dashboards2$Widget$ChartTypeDropdown),
							h$: _Utils_eq(model.w, $author$project$Dashboards2$Widget$ChartTypeDropdown),
							f2: _Utils_ap(
								A2(
									$elm$core$List$map,
									prepareChartOption(chartWidget),
									availableChartTypes),
								_List_fromArray(
									[
										$author$project$Dashboards2$Widget$FooterDDSeparator,
										$author$project$Dashboards2$Widget$FooterDDItem(
										{
											cd: config.a($author$project$Dashboards2$Widget$OpenHelpMeChooseModal),
											dq: $author$project$Icons$Platform2$help,
											bJ: false,
											bZ: false,
											pv: false,
											h4: 'Help me choose'
										})
									])),
							f7: true,
							a8: showShortDDButtons,
							gW: config.a(
								$author$project$Dashboards2$Widget$ToggleDropdown($author$project$Dashboards2$Widget$ChartTypeDropdown))
						},
						store),
					mG: 'Chart types',
					mL: $author$project$CoolTip$Normal,
					m2: _List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Attributes$Extra$attributeMaybe,
							$elm$html$Html$Attributes$id,
							A2($author$project$Dashboards2$Widget$getDropdownElementId, widget, $author$project$Dashboards2$Widget$ChartTypeDropdown))
						])
				});
		};
		return _List_fromArray(
			[
				A2($elm_community$html_extra$Html$Extra$viewMaybe, metricsDropdown, currentMetric),
				A2($elm_community$html_extra$Html$Extra$viewIfLazy, !permissions.kO, dataTableButton),
				A2($elm_community$html_extra$Html$Extra$viewIfLazy, !permissions.kO, viewInChartsButton),
				A2($elm_community$html_extra$Html$Extra$viewIfLazy, permissions.kO, chartTypeDropdown),
				A2($elm_community$html_extra$Html$Extra$viewIfLazy, permissions.kO, sortingDropdownView)
			]);
	});
var $author$project$Dashboards2$Widget$chartContentView = F8(
	function (toConfig, flags, store, userFilters, availableMetrics, isEditing, model, widget) {
		var permissions = {
			jz: flags.nM(2),
			kM: $author$project$Permissions$isDashboardsCreator(flags.nM),
			kO: isEditing
		};
		var config = A2(toConfig, userFilters, widget);
		var metadataTooltip = F3(
			function (chartWidget, questions, _v5) {
				var question = $turboMaCk$non_empty_list_alias$List$NonEmpty$head(questions);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['header', 'metadata-info', 'tooltip']),
							$author$project$Dashboards2$Widget$moduleClass),
							$elm$html$Html$Events$onMouseEnter(
							config.a(
								$author$project$Dashboards2$Widget$MetadataIcon(
									{eB: true}))),
							$elm$html$Html$Events$onMouseLeave(
							config.a(
								$author$project$Dashboards2$Widget$MetadataIcon(
									{eB: false})))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$strong,
							_List_Nil,
							_List_fromArray(
								[
									$elm$html$Html$text(question.oR)
								])),
							A2(
							$elm$html$Html$p,
							_List_Nil,
							_List_fromArray(
								[
									A2($elm_community$html_extra$Html$Extra$viewMaybe, $elm$html$Html$text, question.pP)
								])),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							$turboMaCk$non_empty_list_alias$List$NonEmpty$length(questions) > 1,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'metadata-info', 'tooltip', 'summary']),
										$author$project$Dashboards2$Widget$moduleClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										'Question 1 of ' + $elm$core$String$fromInt(
											$turboMaCk$non_empty_list_alias$List$NonEmpty$length(questions))),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['header', 'metadata-info', 'tooltip', 'button']),
												$author$project$Dashboards2$Widget$moduleClass),
												$elm$html$Html$Events$onClick(
												config.a(
													A2($author$project$Dashboards2$Widget$ViewAllQuestions, chartWidget, questions)))
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('View all questions')
											]))
									])))
						]));
			});
		var _v0 = _Utils_Tuple2(widget.U, model.ad);
		if (((!_v0.a.$) && (_v0.b.$ === 2)) && (_v0.b.a.$ === 3)) {
			var chartWidget = _v0.a.a;
			var _v1 = _v0.b.a;
			var questions = _v1.a;
			var chartModel = _v1.b;
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'container', $author$project$Dashboards2$Widget$moduleClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', $author$project$Dashboards2$Widget$moduleClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'info-group']),
										$author$project$Dashboards2$Widget$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['header', 'metadata-info']),
												$author$project$Dashboards2$Widget$moduleClass),
												$elm$html$Html$Events$onMouseEnter(
												config.a(
													$author$project$Dashboards2$Widget$MetadataIcon(
														{eB: true}))),
												$elm$html$Html$Events$onMouseLeave(
												config.a(
													$author$project$Dashboards2$Widget$MetadataIcon(
														{eB: false})))
											]),
										_List_fromArray(
											[
												A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$info)
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$withStates,
												_List_fromArray(
													[
														_Utils_Tuple2('edit-mode', permissions.kO)
													]),
												A2(
													$GlobalWebIndex$class_namespaces$WeakCss$addMany,
													_List_fromArray(
														['header', 'question-name']),
													$author$project$Dashboards2$Widget$moduleClass)),
												A2(
												$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
												permissions.kO,
												$elm$html$Html$Events$onClick(
													config.qO(chartWidget)))
											]),
										_List_fromArray(
											[
												$author$project$CoolTip$Platform2$view(
												{
													lm: $elm$core$Maybe$Nothing,
													lB: 1,
													mt: _List_Nil,
													mu: _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	A2(
																	$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																	_List_fromArray(
																		['header', 'question-name', 'chart-label']),
																	$author$project$Dashboards2$Widget$moduleClass),
																	A2(
																	$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
																	permissions.kO,
																	$elm$html$Html$Events$onClick(
																		config.qO(chartWidget)))
																]),
															_List_fromArray(
																[
																	$elm$html$Html$text(chartWidget.ld)
																]))
														]),
													mE: _List_Nil,
													mF: $elm$html$Html$text(chartWidget.ld),
													mL: $author$project$CoolTip$NormalShownWhenEllipsis(
														'.' + $GlobalWebIndex$class_namespaces$WeakCss$toString(
															A2(
																$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																_List_fromArray(
																	['header', 'question-name', 'chart-label']),
																$author$project$Dashboards2$Widget$moduleClass))),
													m2: _List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['header', 'question-name', 'tooltip']),
															$author$project$Dashboards2$Widget$moduleClass)
														])
												}),
												A2(
												$elm_community$html_extra$Html$Extra$viewIf,
												permissions.kO,
												A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['header', 'question-name', 'edit-btn']),
															$author$project$Dashboards2$Widget$moduleClass),
															$elm$html$Html$Attributes$title('Edit title/description')
														]),
													_List_fromArray(
														[
															A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$rename)
														])))
											]))
									])),
								A5($author$project$Dashboards2$Widget$viewButtons, config, permissions, widget, chartWidget, model)
							])),
						A2(
						$elm_community$html_extra$Html$Extra$viewIfLazy,
						$author$project$Dashboards2$Widget$showMedatadaTooltip(model.b$),
						A2(metadataTooltip, chartWidget, questions)),
						function () {
						var _v2 = chartWidget.aU;
						if (_v2.$ === 1) {
							var id = _v2.a.b;
							var baseAudienceNameBasedOnPlan = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$author$project$Data$Id$unwrap(id),
								function ($) {
									return $.ld;
								},
								A2(
									$elm$core$Maybe$andThen,
									$turboMaCk$any_dict$Dict$Any$get(id),
									A2(
										$elm$core$Maybe$andThen,
										A2(
											$elm$core$Basics$composeR,
											function ($) {
												return $.C;
											},
											function ($) {
												return $.nA;
											}),
										A2(
											$elm$core$Maybe$andThen,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.cl;
												},
												$krisajenkins$remotedata$RemoteData$toMaybe),
											A3(
												$krisajenkins$remotedata$RemoteData$unwrap,
												$elm$core$Maybe$Nothing,
												function (dashboards) {
													return A2($turboMaCk$any_dict$Dict$Any$get, widget.bf, dashboards);
												},
												store.v))))) : A2($author$project$Data$Platform2$baseAudienceName, store.d9, id);
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'base-name', $author$project$Dashboards2$Widget$moduleClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Base audience: ' + baseAudienceNameBasedOnPlan)
									]));
						} else {
							return $elm_community$html_extra$Html$Extra$nothing;
						}
					}(),
						A2(
						$elm_community$html_extra$Html$Extra$viewIfLazy,
						!$elm$core$String$isEmpty(chartWidget.b2),
						function (_v3) {
							return $author$project$CoolTip$Platform2$view(
								{
									lm: $elm$core$Maybe$Nothing,
									lB: 1,
									mt: _List_Nil,
									mu: _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$withStates,
													_List_fromArray(
														[
															_Utils_Tuple2('edit-mode', permissions.kO)
														]),
													A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'note', $author$project$Dashboards2$Widget$moduleClass)),
													A2(
													$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
													permissions.kO,
													$elm$html$Html$Events$onClick(
														config.qO(chartWidget)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(chartWidget.b2)
												]))
										]),
									mE: _List_Nil,
									mF: $elm$html$Html$text(chartWidget.b2),
									mL: $author$project$CoolTip$NormalShownWhenEllipsis(
										'.' + $GlobalWebIndex$class_namespaces$WeakCss$toString(
											A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'note', $author$project$Dashboards2$Widget$moduleClass))),
									m2: _List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nest,
											'tooltip',
											A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'note', $author$project$Dashboards2$Widget$moduleClass))
										])
								});
						}),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('donut-chart', chartWidget.aI === 2)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'content', $author$project$Dashboards2$Widget$moduleClass))
							]),
						_List_fromArray(
							[
								function () {
								var _v4 = model.eo;
								if (!_v4) {
									return A6($author$project$Dashboards2$Chart$view, config.ef, availableMetrics, store, widget, chartWidget, chartModel);
								} else {
									return A6(
										$author$project$Dashboards2$Chart$view,
										config.ef,
										availableMetrics,
										store,
										widget,
										_Utils_update(
											chartWidget,
											{aI: 0}),
										chartModel);
								}
							}()
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'footer', $author$project$Dashboards2$Widget$moduleClass)
							]),
						A7($author$project$Dashboards2$Widget$widgetFooterView, config, flags, store, permissions, widget, chartWidget, model))
					]));
		} else {
			return $elm_community$html_extra$Html$Extra$nothing;
		}
	});
var $elm$virtual_dom$VirtualDom$lazy8 = _VirtualDom_lazy8;
var $elm$html$Html$Lazy$lazy8 = $elm$virtual_dom$VirtualDom$lazy8;
var $elm_community$string_extra$String$Extra$ellipsisWith = F3(
	function (howLong, append, string) {
		return (_Utils_cmp(
			$elm$core$String$length(string),
			howLong) < 1) ? string : _Utils_ap(
			A2(
				$elm$core$String$left,
				howLong - $elm$core$String$length(append),
				string),
			append);
	});
var $elm_community$string_extra$String$Extra$ellipsis = F2(
	function (howLong, string) {
		return A3($elm_community$string_extra$String$Extra$ellipsisWith, howLong, '...', string);
	});
var $author$project$Dashboards2$Widget$RichText$getContent = function (_v0) {
	var paragraphs = _v0.qt;
	return A2(
		$elm$core$String$join,
		'\n',
		$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(
			A2(
				$turboMaCk$non_empty_list_alias$List$NonEmpty$map,
				function ($) {
					return $.U;
				},
				paragraphs)));
};
var $author$project$Dashboards2$Widget$widgetContainerView = F4(
	function (_v0, extraStates, widget, content) {
		var isEditing = _v0.ez;
		var maybeDnd = _v0.ge;
		var htmlId = $author$project$Dashboards2$Widget$containerElementId(widget);
		var withDndAttrs = function () {
			if (!maybeDnd.$) {
				var dnd = maybeDnd.a;
				return $elm$core$Basics$append(
					A4(dnd.dl.oo, widget, widget, 0, htmlId));
			} else {
				return $elm$core$Basics$identity;
			}
		}();
		var ghostView = function () {
			var _v4 = widget.U;
			if (_v4.$ === 1) {
				var richText = _v4.a;
				return $elm$html$Html$text(
					A2(
						$elm_community$string_extra$String$Extra$ellipsis,
						100,
						$author$project$Dashboards2$Widget$RichText$getContent(richText)));
			} else {
				var chartWidget = _v4.a;
				return $elm$html$Html$text(chartWidget.ld);
			}
		}();
		var _v1 = function () {
			if (!maybeDnd.$) {
				var dnd = maybeDnd.a;
				var _v3 = dnd.dl.fX(dnd.fJ.k_);
				if (!_v3.$) {
					var dragItem = _v3.a.op;
					return _Utils_eq(dragItem.b, widget.b) ? _Utils_Tuple2(
						$elm$core$Basics$append(
							dnd.dl.oY(dnd.fJ)),
						true) : _Utils_Tuple2($elm$core$Basics$identity, false);
				} else {
					return _Utils_Tuple2($elm$core$Basics$identity, false);
				}
			} else {
				return _Utils_Tuple2($elm$core$Basics$identity, false);
			}
		}();
		var withGhostAttrs = _v1.a;
		var isDragged = _v1.b;
		return A2(
			$elm$html$Html$div,
			withGhostAttrs(
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						A2(
							$elm$core$List$cons,
							_Utils_Tuple2('being-dragged', isDragged),
							extraStates),
						$author$project$Dashboards2$Widget$moduleClass),
						$elm$html$Html$Attributes$id(htmlId)
					])),
			isDragged ? _List_fromArray(
				[ghostView]) : A2(
				$elm$core$List$cons,
				A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					isEditing,
					A2(
						$elm$html$Html$div,
						withDndAttrs(
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'drag-n-drop-handle', $author$project$Dashboards2$Widget$moduleClass)
								])),
						_List_Nil)),
				content));
	});
var $author$project$Dashboards2$Widget$view_ = function (toConfig) {
	return function (flags) {
		return function (store) {
			return function (userFilters) {
				return function (availableMetrics) {
					return function (isEditing) {
						return function (dnd) {
							return function (model) {
								return function (chartModel) {
									return function (widget) {
										return function (chartWidget) {
											var currentTab = model.eo;
											var permissions = {
												jz: flags.nM(2),
												kM: $author$project$Permissions$isDashboardsCreator(flags.nM),
												kO: isEditing
											};
											var noActiveAudiences = (!$elm$core$List$isEmpty(
												$author$project$Dashboards2$UserFilters$audienceIds(userFilters))) && $elm$core$List$isEmpty(
												$author$project$Dashboards2$UserFilters$activeAudienceIds(userFilters));
											var isLoaded = $author$project$Dashboards2$Chart$isSuccessfulyLoaded(chartModel);
											var config = A2(toConfig, userFilters, widget);
											return noActiveAudiences ? A8(
												$author$project$Dashboards2$Widget$userErrorView,
												config,
												currentTab,
												widget,
												chartWidget,
												permissions,
												'There are no active audiences',
												model,
												$elm$html$Html$text('To see the chart, please activate at least one audience or remove all of them.')) : A4(
												$author$project$Dashboards2$Widget$widgetContainerView,
												{ez: permissions.kO, ge: dnd},
												_List_fromArray(
													[
														_Utils_Tuple2('colored', (!currentTab) && ((chartWidget.aI === 10) && isLoaded)),
														_Utils_Tuple2(
														'stat-card',
														(!currentTab) && A2(
															$elm$core$List$member,
															chartWidget.aI,
															_List_fromArray(
																[9, 10]))),
														_Utils_Tuple2('chart-widget', true),
														_Utils_Tuple2('is-visible', model.cz)
													]),
												widget,
												_List_fromArray(
													[
														A9($elm$html$Html$Lazy$lazy8, $author$project$Dashboards2$Widget$chartContentView, toConfig, flags, store, userFilters, availableMetrics, isEditing, model, widget)
													]));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Dashboards2$Widget$view = F9(
	function (toConfig, flags, userFilters, store, availableMetrics, isEditing, dnd, model, widget) {
		var user = flags.mQ;
		var permissions = {
			jz: flags.nM(2),
			kM: $author$project$Permissions$isDashboardsCreator(flags.nM),
			kO: isEditing
		};
		var config = A2(toConfig, userFilters, widget);
		var userErrorView_ = F2(
			function (chartWidget, title) {
				return A7($author$project$Dashboards2$Widget$userErrorView, config, model.eo, widget, chartWidget, permissions, title, model);
			});
		var missingPermissions = F2(
			function (problematicData, chartWidget) {
				var inaccessibleEntities = $author$project$Data$Permissions$getProblematicTypes(problematicData);
				return A3(
					userErrorView_,
					chartWidget,
					'Missing Permissions',
					A2(
						$elm$html$Html$div,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('You have insufficient permissions to view this data:'),
								A2(
								$elm$html$Html$ul,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'problematic-data', $author$project$Dashboards2$Widget$moduleClass)
									]),
								A2(
									$elm$core$List$map,
									function (_v10) {
										var entityName = _v10.a;
										var codes = _v10.b;
										return A2(
											$elm$html$Html$li,
											_List_Nil,
											_List_fromArray(
												[
													$elm$html$Html$text(
													entityName + (': ' + A2($elm$core$String$join, ', ', codes)))
												]));
									},
									inaccessibleEntities)),
								$elm$html$Html$text('Please contact your Account Manager or email '),
								A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										$elm$html$Html$Attributes$href('mailto:customersuccess@globalwebindex.com'),
										$elm$html$Html$Attributes$target('_blank')
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('customersuccess@globalwebindex.com')
									])),
								$elm$html$Html$text('.')
							])));
			});
		var missingPermissionsWithoutCodes = function (chartWidget) {
			return A3(
				userErrorView_,
				chartWidget,
				'Missing Permissions',
				A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[
							$elm$html$Html$text('You have insufficient permissions to view this data.'),
							$elm$html$Html$text('Please contact your Account Manager or email '),
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href('mailto:customersuccess@globalwebindex.com'),
									$elm$html$Html$Attributes$target('_blank')
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('customersuccess@globalwebindex.com')
								])),
							$elm$html$Html$text('.')
						])));
		};
		var _v0 = _Utils_Tuple2(widget.U, model.ad);
		_v0$3:
		while (true) {
			if (!_v0.a.$) {
				if (_v0.b.$ === 2) {
					var chartWidget = _v0.a.a;
					var chartModelData = _v0.b.a;
					switch (chartModelData.$) {
						case 0:
							return A2($author$project$Dashboards2$Widget$spinnerShellView, widget, chartWidget);
						case 1:
							return A2($author$project$Dashboards2$Widget$spinnerShellView, widget, chartWidget);
						case 2:
							var errors = chartModelData.a;
							return (A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$member,
								$elm$http$Http$BadStatus(404),
								errors) || A2(
								$turboMaCk$non_empty_list_alias$List$NonEmpty$member,
								$elm$http$Http$BadStatus(403),
								errors)) ? missingPermissionsWithoutCodes(chartWidget) : A6(
								$author$project$Dashboards2$Widget$developerBugView,
								config,
								widget,
								$elm$core$Maybe$Just(chartWidget),
								permissions,
								'BUG: failed to fetch data from the /questions/:id API endpoint',
								$elm$core$Maybe$Just(model));
						default:
							var chartModel = chartModelData.b;
							var _v2 = A4($author$project$Data$Permissions$p2Widget, user.qw, store.bt, store.d9, widget);
							switch (_v2.$) {
								case 0:
									return $author$project$Dashboards2$Widget$view_(toConfig)(flags)(store)(userFilters)(availableMetrics)(isEditing)(dnd)(model)(chartModel)(widget)(chartWidget);
								case 1:
									var inaccessibleData = _v2.a;
									var _v3 = inaccessibleData.bt;
									if (!_v3.$) {
										var _v4 = _v3.a;
										var firstInaccessibleQuestionCode = _v4.a;
										return A6($author$project$Dashboards2$Widget$upsellView, config, firstInaccessibleQuestionCode, permissions, widget, chartWidget, model);
									} else {
										return A2(missingPermissions, inaccessibleData, chartWidget);
									}
								default:
									var unknownData = _v2.a;
									var widgetWithFilteredDatapoints = A3($author$project$Dashboards2$Chart$removeDatapointsWithUnknownPermissions, flags, store, widget);
									var _v5 = A2($author$project$Data$Permissions$getUnknownTypesCopy, 'widget', unknownData);
									var title = _v5.Y;
									var message = _v5.pP;
									if (!widgetWithFilteredDatapoints.$) {
										var widget_ = widgetWithFilteredDatapoints.a;
										return $author$project$Dashboards2$Widget$view_(toConfig)(flags)(store)(userFilters)(availableMetrics)(isEditing)(dnd)(model)(chartModel)(widget_)(chartWidget);
									} else {
										return A3(
											userErrorView_,
											chartWidget,
											title,
											$elm$html$Html$text(message));
									}
							}
					}
				} else {
					break _v0$3;
				}
			} else {
				switch (_v0.b.$) {
					case 0:
						var richText = _v0.a.a;
						var _v7 = _v0.b;
						var textWidgetButtonsView = function (_v8) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header-text-widget', $author$project$Dashboards2$Widget$moduleClass)
									]),
								_List_fromArray(
									[
										A5($author$project$Dashboards2$Widget$viewEditButtons, config, permissions, widget, $elm$core$Maybe$Nothing, model)
									]));
						};
						return A4(
							$author$project$Dashboards2$Widget$widgetContainerView,
							{ez: isEditing, ge: dnd},
							_List_fromArray(
								[
									_Utils_Tuple2('text-widget', true)
								]),
							widget,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', $author$project$Dashboards2$Widget$moduleClass)
										]),
									_List_fromArray(
										[
											A2($elm_community$html_extra$Html$Extra$viewIfLazy, permissions.kO, textWidgetButtonsView),
											A2($author$project$Dashboards2$Widget$RichText$view, $author$project$Dashboards2$Widget$moduleClass, richText)
										]))
								]));
					case 1:
						var richTextModel = _v0.b.a;
						var textWidgetButtonsView = function (_v9) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header-text-widget-edit', $author$project$Dashboards2$Widget$moduleClass)
									]),
								_List_fromArray(
									[
										A5($author$project$Dashboards2$Widget$viewEditButtons, config, permissions, widget, $elm$core$Maybe$Nothing, model)
									]));
						};
						return A4(
							$author$project$Dashboards2$Widget$widgetContainerView,
							{ez: isEditing, ge: dnd},
							_List_fromArray(
								[
									_Utils_Tuple2('text-widget', true)
								]),
							widget,
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
											_List_fromArray(
												['flex-row']),
											A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'content', $author$project$Dashboards2$Widget$moduleClass))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$map,
											A2($elm$core$Basics$composeR, $author$project$Dashboards2$Widget$RichTextEditMsg, config.a),
											A3(
												$author$project$Dashboards2$Widget$RichText$viewEdit,
												{sl: widget.da},
												$author$project$Dashboards2$Widget$moduleClass,
												richTextModel)),
											A2($elm_community$html_extra$Html$Extra$viewIfLazy, permissions.kO, textWidgetButtonsView)
										]))
								]));
					default:
						break _v0$3;
				}
			}
		}
		return $elm$html$Html$text('Invalid widget and chart model combination, this should never happen :)');
	});
var $author$project$Dashboards2$Detail$widgetView = F6(
	function (config, flags, store, userFilters, widget, model) {
		var editSection = model.o;
		var widgetModel = A2(
			$turboMaCk$any_dict$Dict$Any$get,
			widget.b,
			$author$project$Dashboards2$Detail$currentWidgets(model));
		var staticId = $author$project$Dashboards2$Detail$dropElementId(widget.b);
		var isWidgetDDOpened = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, false, $author$project$Dashboards2$Widget$isDropdownOpened, widgetModel);
		var _v0 = function () {
			if (!editSection.$) {
				return _Utils_Tuple2($elm$core$Maybe$Nothing, false);
			} else {
				var data = editSection.a;
				var dndInfo = config.dl.fX(data.fJ.k_);
				return _Utils_Tuple2(
					$elm$core$Maybe$Just(
						{fJ: data.fJ, dl: config.dl}),
					$author$project$Dashboards2$Detail$isEditGrid(editSection) && (A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						true,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.op;
							},
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.b;
								},
								A2(
									$elm$core$Basics$composeR,
									$elm$core$Basics$eq(widget.b),
									$elm$core$Basics$not))),
						dndInfo) && (!isWidgetDDOpened)));
			}
		}();
		var dnd = _v0.a;
		var showEditControls = _v0.b;
		var dropPlaceView = function () {
			if (!dnd.$) {
				var d = dnd.a;
				var _v7 = d.dl.fX(d.fJ.k_);
				if (!_v7.$) {
					var dragItem = _v7.a.op;
					var width = $elm$core$String$fromInt(
						A3($elm$core$Basics$clamp, 25, 100, ((100 / widget.da) | 0) * dragItem.da));
					var height = $elm$core$String$fromInt(
						A3($elm$core$Basics$clamp, 50, 100, ((100 / widget.cv) | 0) * dragItem.cv));
					return A2(
						$elm$html$Html$div,
						A2(
							$elm$core$List$cons,
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2(
										'hidden',
										_Utils_eq(dragItem.b, widget.b))
									]),
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['grid-item', 'drop-place']),
									$author$project$Dashboards2$Detail$moduleClass)),
							A2(
								$elm$core$List$cons,
								A2($elm$html$Html$Attributes$attribute, 'style', ('--drop-place-width: ' + (width + '%;')) + ('--drop-place-height: ' + (height + '%'))),
								A3(d.dl.hJ, widget, 0, staticId))),
						_List_Nil);
				} else {
					return $elm_community$html_extra$Html$Extra$nothing;
				}
			} else {
				return $elm_community$html_extra$Html$Extra$nothing;
			}
		}();
		var positionChanged = function () {
			if (!dnd.$) {
				var d = dnd.a;
				var _v5 = d.dl.fX(d.fJ.k_);
				if (!_v5.$) {
					var dragItem = _v5.a.op;
					var dropListId = _v5.a.j3;
					return _Utils_eq(dragItem.b, widget.b) ? (!_Utils_eq(dropListId.lB, dragItem.lB)) : false;
				} else {
					return false;
				}
			} else {
				return false;
			}
		}();
		return A3(
			$author$project$Dashboards2$Detail$gridItemWrapper,
			{
				hN: _List_fromArray(
					[
						_Utils_Tuple2('position-changed', positionChanged)
					])
			},
			widget,
			_List_fromArray(
				[
					_Utils_Tuple2(
					'header-' + $author$project$Data$Id$unwrap(widget.b),
					A2(
						$elm_community$html_extra$Html$Extra$viewIfLazy,
						showEditControls,
						function (_v2) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'edit-widget-controls', $author$project$Dashboards2$Detail$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['edit-widget-controls', 'change-width']),
												$author$project$Dashboards2$Detail$moduleClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['edit-widget-controls', 'change-width', 'btn']),
														$author$project$Dashboards2$Detail$moduleClass),
														$elm$html$Html$Attributes$disabled(widget.da === 1),
														$elm$html$Html$Events$onClick(
														A2(config.ou, widget.b, 1))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Icons$icon,
														_List_fromArray(
															[
																$author$project$Icons$width(26)
															]),
														$author$project$Icons$Platform2$minusSign)
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['edit-widget-controls', 'change-width', 'btn']),
														$author$project$Dashboards2$Detail$moduleClass),
														$elm$html$Html$Attributes$disabled(widget.da === 4),
														$elm$html$Html$Events$onClick(
														A2(config.ou, widget.b, 0))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Icons$icon,
														_List_fromArray(
															[
																$author$project$Icons$width(26)
															]),
														$author$project$Icons$Platform2$plusSign)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['edit-widget-controls', 'change-height']),
												$author$project$Dashboards2$Detail$moduleClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['edit-widget-controls', 'change-height', 'btn']),
														$author$project$Dashboards2$Detail$moduleClass),
														$elm$html$Html$Attributes$disabled(widget.cv === 1),
														$elm$html$Html$Events$onClick(
														A2(config.ou, widget.b, 3))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Icons$icon,
														_List_fromArray(
															[
																$author$project$Icons$width(26)
															]),
														$author$project$Icons$Platform2$minusSign)
													])),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['edit-widget-controls', 'change-height', 'btn']),
														$author$project$Dashboards2$Detail$moduleClass),
														$elm$html$Html$Attributes$disabled(widget.cv === 2),
														$elm$html$Html$Events$onClick(
														A2(config.ou, widget.b, 2))
													]),
												_List_fromArray(
													[
														A2(
														$author$project$Icons$icon,
														_List_fromArray(
															[
																$author$project$Icons$width(26)
															]),
														$author$project$Icons$Platform2$plusSign)
													]))
											]))
									]));
						})),
					_Utils_Tuple2(
					'drop-place-' + $author$project$Data$Id$unwrap(widget.b),
					dropPlaceView),
					function () {
					if (!widgetModel.$) {
						var widgetModel_ = widgetModel.a;
						return _Utils_Tuple2(
							$author$project$Data$Id$unwrap(widget.b),
							A9(
								$author$project$Dashboards2$Widget$view,
								config.c8,
								flags,
								userFilters,
								store,
								$author$project$Dashboards2$Detail$allMetrics,
								!_Utils_eq(editSection, $author$project$Dashboards2$Detail$NotEditing),
								dnd,
								widgetModel_,
								widget));
					} else {
						return _Utils_Tuple2(
							'spinner-' + $author$project$Data$Id$unwrap(widget.b),
							$author$project$Platform2$Spinner$view);
					}
				}()
				]));
	});
var $author$project$Dashboards2$Detail$view = F5(
	function (flags, config, dashboardOrId, store, model) {
		var viewOnlyInfoBannerView = function (_v20) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'info-banner', $author$project$Dashboards2$Detail$moduleClass)
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$eye),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['info-banner', 'text']),
								$author$project$Dashboards2$Detail$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('You have view-only access and cannot edit.')
							]))
					]));
		};
		var isViewOnlyMode = $author$project$Data$User$hasViewOnlyPlan(flags.mQ);
		var headerViewConfig = F2(
			function (currentDashboard, userFilters) {
				var isUnsaved_ = $author$project$Dashboards2$Detail$isUnsaved(model);
				return {
					fg: A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Data$Id$emptyDict, store.es),
					nn: isViewOnlyMode ? A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						$author$project$Data$Id$emptyDict,
						A2($author$project$Store$Platform2$getLocationsByDashboardId, currentDashboard.b, store)) : A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$Data$Id$emptyDict,
						function (ns) {
							return A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								$author$project$Data$Id$emptyDict,
								A2($author$project$Store$Platform2$getLocationsForNamespaces, ns, store));
						},
						$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
							A2($author$project$Dashboards2$Detail$getNamespaceCodes, store, dashboardOrId))),
					np: isViewOnlyMode ? A2(
						$krisajenkins$remotedata$RemoteData$withDefault,
						$author$project$Data$Id$emptyDict,
						A2($author$project$Store$Platform2$getWavesByDashboardId, currentDashboard.b, store)) : A3(
						$elm_community$maybe_extra$Maybe$Extra$unwrap,
						$author$project$Data$Id$emptyDict,
						function (ns) {
							return A2(
								$krisajenkins$remotedata$RemoteData$withDefault,
								$author$project$Data$Id$emptyDict,
								A2($author$project$Store$Platform2$getWavesForNamespaces, ns, store));
						},
						$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
							A2($author$project$Dashboards2$Detail$getNamespaceCodes, store, dashboardOrId))),
					d8: model.d8,
					d9: store.d9,
					em: currentDashboard,
					o: model.o,
					oN: flags,
					fT: isUnsaved_,
					bt: A2(
						$turboMaCk$any_dict$Dict$Any$filterMap,
						F2(
							function (_v19, v) {
								return $krisajenkins$remotedata$RemoteData$toMaybe(v);
							}),
						store.bt),
					gH: isUnsaved_,
					bz: userFilters
				};
			});
		var editModeInfoBannerView = function (_v18) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'info-banner', $author$project$Dashboards2$Detail$moduleClass)
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$edit),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['info-banner', 'text']),
								$author$project$Dashboards2$Detail$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('You’re in Edit mode. All changes will be saved and visible to the people you’ve invited.')
							]))
					]));
		};
		var currentDashboardView = F2(
			function (notFoundView, foundView) {
				if (dashboardOrId.$ === 1) {
					var dashboardId = dashboardOrId.a;
					return A4(
						$author$project$Dashboards2$Detail$remoteDataView,
						config,
						flags,
						function (_v14) {
							var _v15 = $krisajenkins$remotedata$RemoteData$toMaybe(
								A2($author$project$Store$Platform2$getDashboardFullyLoaded, dashboardId, store.v));
							if (_v15.$ === 1) {
								return _List_fromArray(
									[
										notFoundView(dashboardId)
									]);
							} else {
								var savedDashboard = _v15.a;
								var _v16 = $author$project$Dashboards2$Detail$getUserFilters(model);
								if (_v16.$ === 1) {
									return _List_fromArray(
										[
											notFoundView(dashboardId)
										]);
								} else {
									var userFilters = _v16.a;
									return A2(
										foundView,
										userFilters,
										A3(
											$author$project$Dashboards2$Detail$applyEdits,
											model.ba,
											$elm$core$Maybe$Just(userFilters),
											savedDashboard));
								}
							}
						},
						A3(
							$author$project$Dashboards2$Detail$storeLoadStatus,
							flags,
							$elm$core$Maybe$Just(dashboardId),
							store));
				} else {
					var dashboard = dashboardOrId.a;
					var _v17 = $author$project$Dashboards2$Detail$getUserFilters(model);
					if (_v17.$ === 1) {
						return _List_fromArray(
							[$author$project$Platform2$Spinner$view]);
					} else {
						var userFilters = _v17.a;
						return A2(
							foundView,
							userFilters,
							A3(
								$author$project$Dashboards2$Detail$applyEdits,
								model.ba,
								$elm$core$Maybe$Just(userFilters),
								dashboard));
					}
				}
			});
		var detailInnerView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'detail', $author$project$Dashboards2$Detail$moduleClass),
					$elm$html$Html$Attributes$id($author$project$Dashboards2$Detail$detailScrollContainerId),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
					!$author$project$Dashboards2$Detail$isEditMode(model.o),
					A2(
						$elm$html$Html$Events$on,
						'scroll',
						$elm$json$Json$Decode$succeed(config.nZ))),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
					!$author$project$Dashboards2$Detail$isEditMode(model.o),
					A2(
						$elm$html$Html$Events$on,
						'touchmove',
						$elm$json$Json$Decode$succeed(config.nZ)))
				]),
			A2(
				currentDashboardView,
				$author$project$Dashboards2$Detail$dashboardNotFoundView,
				F2(
					function (userFilters, currentDashboard) {
						var widgetWidthString = function (editGridState) {
							return $elm$core$String$fromFloat(editGridState.ir.da);
						};
						var widgetHeightString = function (editGridState) {
							return $elm$core$String$fromFloat(editGridState.ir.cv);
						};
						var waves = isViewOnlyMode ? A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							$author$project$Data$Id$emptyDict,
							A2($author$project$Store$Platform2$getWavesByDashboardId, currentDashboard.b, store)) : A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Id$emptyDict,
							function (ns) {
								return A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$author$project$Data$Id$emptyDict,
									A2($author$project$Store$Platform2$getWavesForNamespaces, ns, store));
							},
							$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
								A2($author$project$Dashboards2$Detail$getNamespaceCodes, store, dashboardOrId)));
						var questions = A2(
							$turboMaCk$any_dict$Dict$Any$filterMap,
							F2(
								function (_v12, v) {
									return $krisajenkins$remotedata$RemoteData$toMaybe(v);
								}),
							store.bt);
						var locations = isViewOnlyMode ? A2(
							$krisajenkins$remotedata$RemoteData$withDefault,
							$author$project$Data$Id$emptyDict,
							A2($author$project$Store$Platform2$getLocationsByDashboardId, currentDashboard.b, store)) : A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Id$emptyDict,
							function (ns) {
								return A2(
									$krisajenkins$remotedata$RemoteData$withDefault,
									$author$project$Data$Id$emptyDict,
									A2($author$project$Store$Platform2$getLocationsForNamespaces, ns, store));
							},
							$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList(
								A2($author$project$Dashboards2$Detail$getNamespaceCodes, store, dashboardOrId)));
						var isUnsaved_ = $author$project$Dashboards2$Detail$isUnsaved(model);
						var isNotDragging = (!$author$project$Dashboards2$Detail$isEditMode(model.o)) || (!$elm_community$maybe_extra$Maybe$Extra$isJust(
							A2(
								$elm$core$Maybe$andThen,
								function (_v11) {
									var dndModel = _v11.fJ;
									return config.dl.fX(dndModel.k_);
								},
								$author$project$Dashboards2$Detail$getEditGridState(model.o))));
						var gridView = function (_v10) {
							return A2(
								$elm$core$List$map,
								function (widget) {
									var _v8 = A2(
										$turboMaCk$any_dict$Dict$Any$get,
										widget.b,
										$author$project$Dashboards2$Detail$currentWidgets(model));
									if (!_v8.$) {
										return A6($author$project$Dashboards2$Detail$widgetView, config, flags, store, userFilters, widget, model);
									} else {
										var nameOrId = function () {
											var _v9 = A2(
												$elm$core$Maybe$map,
												function ($) {
													return $.ld;
												},
												$author$project$Data$Platform2$getChartWidget(widget));
											if (_v9.$ === 1) {
												return '#' + $author$project$Data$Id$unwrap(widget.b);
											} else {
												var name = _v9.a;
												return '\'' + (name + ('\' (ID #' + ($author$project$Data$Id$unwrap(widget.b) + ')')));
											}
										}();
										return A4(
											$author$project$Dashboards2$Detail$developerBugView,
											A2(config.c8, userFilters, widget),
											widget,
											{
												jz: flags.nM(2),
												kM: $author$project$Permissions$isDashboardsCreator(flags.nM),
												kO: !_Utils_eq(model.o, $author$project$Dashboards2$Detail$NotEditing)
											},
											'FAIL: widget model for widget ' + (nameOrId + ' not found (should have been initialized)'));
									}
								},
								A2(
									$elm$core$List$sortBy,
									function ($) {
										return $.lB;
									},
									currentDashboard.cl.g));
						};
						var dndUpdateWidgetPosition = function (widgets) {
							var _v6 = model.o;
							if (!_v6.$) {
								return widgets;
							} else {
								var editGridState = _v6.a;
								var _v7 = _Utils_Tuple2(
									config.dl.fX(editGridState.fJ.k_),
									editGridState.b1);
								if ((!_v7.a.$) && (!_v7.b.$)) {
									var dragItem = _v7.a.a.op;
									var position = _v7.b.a.lB;
									return A2(
										$elm$core$List$map,
										function (w) {
											return _Utils_eq(w.b, dragItem.b) ? _Utils_update(
												w,
												{lB: position}) : w;
										},
										widgets);
								} else {
									return widgets;
								}
							}
						};
						var editModeGridView = function (_v5) {
							var sortedWidgets = A2(
								$elm$core$List$sortBy,
								function ($) {
									return $.lB;
								},
								dndUpdateWidgetPosition(currentDashboard.cl.g));
							var widgetsView = A2(
								$elm$core$List$map,
								function (widget) {
									var _v3 = A2(
										$turboMaCk$any_dict$Dict$Any$get,
										widget.b,
										$author$project$Dashboards2$Detail$currentWidgets(model));
									if (!_v3.$) {
										return A6($author$project$Dashboards2$Detail$widgetView, config, flags, store, userFilters, widget, model);
									} else {
										if (_Utils_eq(widget.b, $author$project$Data$Platform2$nullId)) {
											return A6($author$project$Dashboards2$Detail$widgetView, config, flags, store, userFilters, widget, model);
										} else {
											var nameOrId = function () {
												var _v4 = A2(
													$elm$core$Maybe$map,
													function ($) {
														return $.ld;
													},
													$author$project$Data$Platform2$getChartWidget(widget));
												if (_v4.$ === 1) {
													return '#' + $author$project$Data$Id$unwrap(widget.b);
												} else {
													var name = _v4.a;
													return '\'' + (name + ('\' (ID #' + ($author$project$Data$Id$unwrap(widget.b) + ')')));
												}
											}();
											return A4(
												$author$project$Dashboards2$Detail$developerBugView,
												A2(config.c8, userFilters, widget),
												widget,
												{
													jz: flags.nM(2),
													kM: $author$project$Permissions$isDashboardsCreator(flags.nM),
													kO: !_Utils_eq(model.o, $author$project$Dashboards2$Detail$NotEditing)
												},
												'FAIL: widget model for widget ' + (nameOrId + ' not found (should have been initialized)'));
										}
									}
								},
								sortedWidgets);
							var placeholdersCount = 8;
							var placeholdersView = function () {
								var placeholderId = 'd2-edit-grid-view-first-placeholder-element';
								return A2(
									$elm$core$List$map,
									function (index) {
										return A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$withStates,
													_List_fromArray(
														[
															_Utils_Tuple2('is-first', index === 1)
														]),
													A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['grid', 'placeholder']),
														$author$project$Dashboards2$Detail$moduleClass))
												]),
											_List_fromArray(
												[
													(index === 1) ? A3(
													$author$project$ResizeObserver$view,
													{iW: '#' + placeholderId, iZ: config.qu},
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	A2(
																	$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																	_List_fromArray(
																		['grid', 'placeholder', 'inner']),
																	$author$project$Dashboards2$Detail$moduleClass),
																	$elm$html$Html$Attributes$id(placeholderId)
																]),
															_List_Nil)
														])) : $elm_community$html_extra$Html$Extra$nothing
												]));
									},
									A2($elm$core$List$range, 1, placeholdersCount));
							}();
							var lastWidget = $elm_community$list_extra$List$Extra$last(sortedWidgets);
							var extraLastPlaceholderView = function (widget) {
								var staticId = $author$project$Dashboards2$Detail$dropElementId(widget.b);
								return A2(
									$elm_community$html_extra$Html$Extra$viewIf,
									$elm_community$maybe_extra$Maybe$Extra$isJust(
										A2($author$project$Dashboards2$Detail$getDndInfo, config, model)),
									A2(
										$elm$html$Html$div,
										A2(
											$elm$core$List$cons,
											A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['grid', 'drop-placeholder']),
												$author$project$Dashboards2$Detail$moduleClass),
											A2(
												$elm$core$List$cons,
												$elm$html$Html$Attributes$id(staticId),
												A3(
													config.dl.hJ,
													_Utils_update(
														widget,
														{lB: widget.lB + 1}),
													0,
													staticId))),
										_List_Nil));
							};
							var addWidgetView = _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['edit-mode', 'add-widget-buttons']),
											$author$project$Dashboards2$Detail$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['edit-mode', 'add-widget-buttons', 'title']),
													$author$project$Dashboards2$Detail$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Add to your dashboard:')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['edit-mode', 'add-widget-buttons', 'add-button']),
													$author$project$Dashboards2$Detail$moduleClass),
													$elm$html$Html$Events$onClick(
													A2(config.qc, currentDashboard, 35))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Chart'),
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$charts)
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['edit-mode', 'add-widget-buttons', 'add-button']),
													$author$project$Dashboards2$Detail$moduleClass),
													$elm$html$Html$Events$onClick(
													A2(config.nm, $author$project$Dashboards2$Widget$RichText$empty, 35))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Text'),
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$text)
												]))
										]))
								]);
							return $elm$core$List$concat(
								_List_fromArray(
									[
										widgetsView,
										addWidgetView,
										$elm$core$List$singleton(
										A2($elm_community$html_extra$Html$Extra$viewMaybe, extraLastPlaceholderView, lastWidget)),
										placeholdersView
									]));
						};
						var datasets = A2($krisajenkins$remotedata$RemoteData$withDefault, $author$project$Data$Id$emptyDict, store.es);
						var canShowAddWidgetBarView = function () {
							var _v2 = model.o;
							if (!_v2.$) {
								return false;
							} else {
								var data = _v2.a;
								return _Utils_eq(
									config.dl.fX(data.fJ.k_),
									$elm$core$Maybe$Nothing);
							}
						}();
						return _Utils_ap(
							A5(
								$author$project$Dashboards2$Detail$headerView,
								config,
								flags,
								{fg: datasets, nn: locations, np: waves, d8: model.d8, d9: store.d9, em: currentDashboard, o: model.o, oN: flags, fT: isUnsaved_, bt: questions, gH: isUnsaved_, bz: userFilters},
								store,
								model),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$withStates,
											_List_fromArray(
												[
													_Utils_Tuple2(
													'edit-mode',
													$author$project$Dashboards2$Detail$isEditMode(model.o))
												]),
											A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'grid-cont', $author$project$Dashboards2$Detail$moduleClass))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											function () {
												var _v0 = model.o;
												if (!_v0.$) {
													return $elm$core$Basics$identity;
												} else {
													var editGridState = _v0.a;
													return $elm$core$List$cons(
														$author$project$Gwi$Html$Attributes$cssVars(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'--widget-width',
																	widgetWidthString(editGridState) + 'px'),
																	_Utils_Tuple2(
																	'--widget-height',
																	widgetHeightString(editGridState) + 'px')
																])));
												}
											}()(
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$withStates,
														_List_fromArray(
															[
																_Utils_Tuple2(
																'edit-mode',
																$author$project$Dashboards2$Detail$isEditMode(model.o)),
																_Utils_Tuple2(
																'edit-mode-empty',
																$author$project$Dashboards2$Detail$isEditMode(model.o) && $elm$core$List$isEmpty(currentDashboard.cl.g)),
																_Utils_Tuple2('is-not-dragging', isNotDragging)
															]),
														A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'grid', $author$project$Dashboards2$Detail$moduleClass))
													])),
											function () {
												var _v1 = model.o;
												if (!_v1.$) {
													return gridView(0);
												} else {
													return editModeGridView(0);
												}
											}())
										])),
									A2(
									$elm$html$Html$map,
									config.a,
									A3(
										$author$project$Platform2$Drawers$view,
										A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'drawers', $author$project$Dashboards2$Detail$moduleClass),
										store,
										model.aJ)),
									A2(
									$elm_community$html_extra$Html$Extra$viewMaybe,
									$author$project$FullScreenLoader$view(
										{
											nO: config.nN,
											pH: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'full-table-loading', $author$project$Dashboards2$Detail$moduleClass),
											pI: 'Exporting dashboard…'
										}),
									model.a2),
									A2(
									$elm_community$html_extra$Html$Extra$viewIfLazy,
									canShowAddWidgetBarView,
									A2($author$project$Dashboards2$Detail$addWidgetBarView, config, currentDashboard)),
									A2(
									$elm$html$Html$map,
									config.a,
									A2($elm_community$html_extra$Html$Extra$viewMaybe, $author$project$Platform2$Dropdown$DropdownMenu$view, model.db))
								]));
					})));
		var audiencesReorderSystem = $author$project$Dashboards2$Detail$getAudiencesReorderSystem(config);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'is-edit-mode',
							$author$project$Dashboards2$Detail$isEditMode(model.o)),
							_Utils_Tuple2(
							'grabbing',
							$elm_community$maybe_extra$Maybe$Extra$isJust(
								audiencesReorderSystem.fX(model.d8)))
						]),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'detail-wrapper', $author$project$Dashboards2$Detail$moduleClass))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['detail-wrapper', 'header']),
							$author$project$Dashboards2$Detail$moduleClass)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm_community$html_extra$Html$Extra$viewIfLazy,
							$author$project$Dashboards2$Detail$isEditMode(model.o),
							editModeInfoBannerView),
						_Utils_ap(
							$author$project$Dashboards2$Detail$isEditMode(model.o) ? A2(
								currentDashboardView,
								$elm$core$Basics$always($elm_community$html_extra$Html$Extra$nothing),
								F2(
									function (userFilters, currentDashboard) {
										return $elm$core$List$singleton(
											A4(
												$author$project$Dashboards2$Detail$actionBarView,
												config,
												{bf: currentDashboard.b, ar: false},
												A2(headerViewConfig, currentDashboard, userFilters),
												model));
									})) : _List_Nil,
							_List_fromArray(
								[
									A2($elm_community$html_extra$Html$Extra$viewIfLazy, isViewOnlyMode, viewOnlyInfoBannerView)
								])))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['detail-wrapper', 'body']),
							$author$project$Dashboards2$Detail$moduleClass)
						]),
					_List_fromArray(
						[detailInnerView]))
				]));
	});
var $author$project$Dashboards2$detailView = F5(
	function (flags, config, dashboardOrId, store, model) {
		return A5($author$project$Dashboards2$Detail$view, flags, config.V, dashboardOrId, store, model);
	});
var $author$project$Dashboards2$Detail$isDragging = F2(
	function (config, model) {
		return A2(
			$elm$core$Maybe$withDefault,
			false,
			A2(
				$elm$core$Maybe$map,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.fJ;
					},
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.k_;
						},
						A2($elm$core$Basics$composeR, config.dl.fX, $elm_community$maybe_extra$Maybe$Extra$isJust))),
				$author$project$Dashboards2$Detail$getEditGridState(model.o)));
	});
var $author$project$Dashboards2$moduleClass = $GlobalWebIndex$class_namespaces$WeakCss$namespace('dashboards-2');
var $author$project$Dashboards2$List$ClearDashboardSelection = {$: 2};
var $author$project$Dashboards2$List$OpenConfirmDeleteDashboardsModal = function (a) {
	return {$: 4, a: a};
};
var $author$project$CoolTip$RelativeAncestor = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$List$SelectDashboards = function (a) {
	return {$: 3, a: a};
};
var $author$project$Dashboards2$List$availableCategories = F2(
	function (insightCategories, dashboards) {
		return A2(
			$turboMaCk$any_set$Set$Any$fromList,
			$author$project$Data$Platform2$insightCategoryToComparable,
			A2(
				$author$project$Gwi$List$fastConcatMap,
				function (_v0) {
					var categories = _v0.ac;
					var _v1 = categories;
					var cat1 = _v1.a;
					var cat2 = _v1.b;
					return A2(
						$elm$core$List$map,
						function (category) {
							return A2(
								$elm$core$Maybe$withDefault,
								category,
								A2($author$project$Store$Utils$get, insightCategories, category.b));
						},
						$elm_community$maybe_extra$Maybe$Extra$values(
							_List_fromArray(
								[cat1, cat2])));
				},
				dashboards));
	});
var $author$project$Dashboards2$List$isCategoryFilterActive = F3(
	function (p2Store, dashboards, filter) {
		return (!$turboMaCk$any_set$Set$Any$isEmpty(filter)) && (!A2(
			$turboMaCk$any_set$Set$Any$equal,
			filter,
			A2($author$project$Dashboards2$List$availableCategories, p2Store.kF, dashboards)));
	});
var $author$project$Dashboards2$List$filterByCategory = F3(
	function (p2Store, _v0, dashboardsToFilter) {
		var allDashboards = _v0.ff;
		var allowedCategories = _v0.jd;
		return A3($author$project$Dashboards2$List$isCategoryFilterActive, p2Store, allDashboards, allowedCategories) ? A2(
			$elm$core$List$filter,
			function (_v1) {
				var categories = _v1.ac;
				if (categories.a.$ === 1) {
					if (categories.b.$ === 1) {
						var _v3 = categories.a;
						var _v4 = categories.b;
						return false;
					} else {
						var _v5 = categories.a;
						var category = categories.b.a;
						return A2($turboMaCk$any_set$Set$Any$member, category, allowedCategories);
					}
				} else {
					if (categories.b.$ === 1) {
						var category = categories.a.a;
						var _v6 = categories.b;
						return A2($turboMaCk$any_set$Set$Any$member, category, allowedCategories);
					} else {
						var cat1 = categories.a.a;
						var cat2 = categories.b.a;
						return A2($turboMaCk$any_set$Set$Any$member, cat1, allowedCategories) || A2($turboMaCk$any_set$Set$Any$member, cat2, allowedCategories);
					}
				}
			},
			dashboardsToFilter) : dashboardsToFilter;
	});
var $author$project$Data$Platform2$MeDashboards = 0;
var $author$project$Data$Platform2$PublicDashboards = 2;
var $author$project$Data$Platform2$SharedByMyOrg = 1;
var $author$project$Dashboards2$List$dashboardsSharingToDashboardsTab = F2(
	function (user, sharing) {
		switch (sharing.$) {
			case 0:
				return 0;
			case 3:
				return 2;
			case 1:
				return 2;
			case 2:
				var _v1 = sharing.a;
				var maybeOrgId = _v1.a;
				return _Utils_eq(
					maybeOrgId,
					A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, user.m)) ? 1 : 0;
			case 4:
				return 2;
			case 5:
				return 2;
			case 6:
				return 2;
			case 7:
				var _v2 = sharing.a;
				var maybeOrgId = _v2.a;
				return _Utils_eq(
					maybeOrgId,
					A2($elm$core$Maybe$map, $author$project$Data$Id$fromString, user.m)) ? 1 : 0;
			default:
				return 2;
		}
	});
var $author$project$Data$Platform2$allDashboardTypes = _List_fromArray(
	[0, 2, 1]);
var $author$project$Dashboards2$List$isDashboardTypeFilterActive = function (filter) {
	return (!$turboMaCk$any_set$Set$Any$isEmpty(filter)) && (!_Utils_eq(
		$turboMaCk$any_set$Set$Any$size(filter),
		$elm$core$List$length($author$project$Data$Platform2$allDashboardTypes)));
};
var $author$project$Dashboards2$List$filterByDashboardType = F3(
	function (user, allowedTypes, dashboards) {
		return $author$project$Dashboards2$List$isDashboardTypeFilterActive(allowedTypes) ? A2(
			$elm$core$List$filter,
			function (_v0) {
				var sharing = _v0.ah;
				return A2(
					$turboMaCk$any_set$Set$Any$member,
					A2($author$project$Dashboards2$List$dashboardsSharingToDashboardsTab, user, sharing),
					allowedTypes);
			},
			dashboards) : dashboards;
	});
var $author$project$Dashboards2$List$availableDatasets = function (dashboards) {
	return $author$project$Data$Id$setFromList(
		A2(
			$author$project$Gwi$List$fastConcatMap,
			function ($) {
				return $.es;
			},
			dashboards));
};
var $author$project$Dashboards2$List$isDatasetFilterActive = F2(
	function (dashboards, filter) {
		return (!$turboMaCk$any_set$Set$Any$isEmpty(filter)) && (!A2(
			$turboMaCk$any_set$Set$Any$equal,
			filter,
			$author$project$Dashboards2$List$availableDatasets(dashboards)));
	});
var $author$project$Dashboards2$List$filterByDataset = F2(
	function (_v0, dashboardsToFilter) {
		var allDashboards = _v0.ff;
		var allowedDatasets = _v0.je;
		return A2($author$project$Dashboards2$List$isDatasetFilterActive, allDashboards, allowedDatasets) ? A2(
			$elm$core$List$filter,
			function (_v1) {
				var datasets = _v1.es;
				return A2(
					$elm$core$List$any,
					function (dataset) {
						return A2($turboMaCk$any_set$Set$Any$member, dataset, allowedDatasets);
					},
					datasets);
			},
			dashboardsToFilter) : dashboardsToFilter;
	});
var $author$project$Dashboards2$List$filterBySearch = F2(
	function (searchTerm, dashboards) {
		return $elm$core$String$isEmpty(searchTerm) ? dashboards : A3(
			$author$project$Search$filter,
			function ($) {
				return $.ld;
			},
			searchTerm,
			dashboards);
	});
var $author$project$Dashboards2$List$filterByTab = F3(
	function (user, tab, dashboards) {
		switch (tab) {
			case 0:
				return dashboards;
			case 1:
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ah;
						},
						$author$project$Data$Platform2$isSharedByMyOrganisation(user)),
					dashboards);
			case 2:
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.dG;
						},
						$elm$core$Basics$eq(user.b)),
					dashboards);
			case 3:
				return A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.ah;
						},
						A2(
							$elm$core$Basics$composeR,
							$author$project$Dashboards2$List$dashboardsSharingToDashboardsTab(user),
							$elm$core$Basics$eq(2))),
					dashboards);
			default:
				return A2(
					$elm$core$List$filter,
					function ($) {
						return $.kN;
					},
					dashboards);
		}
	});
var $author$project$Dashboards2$List$specialPromotedDashboards = $author$project$Data$Id$dictFromList(
	A2(
		$elm$core$List$indexedMap,
		F2(
			function (index, id) {
				return _Utils_Tuple2(
					$author$project$Data$Id$fromString(id),
					index);
			}),
		_List_fromArray(
			['9c9775da-3b2b-481f-9cf2-af7233bd2752', '62aeea60-f52b-4daa-9af1-f60566a14288', '1745eba3-58c8-44fd-b337-d8b9039de1bc', 'd189e283-40f4-43b4-a69b-bc95fe116db3', '86254b0b-5b32-4bff-9b68-691c3819352e', 'aa2e1406-b5ea-4b6a-95bc-900954a67bd7', '293154af-b854-4f18-bbf4-6990df9c07c0'])));
var $author$project$Dashboards2$List$todoTemporaryHackPromotedDashboardsATC2752Order = function (dashboard) {
	var _v0 = A2($turboMaCk$any_dict$Dict$Any$get, dashboard.b, $author$project$Dashboards2$List$specialPromotedDashboards);
	if (!_v0.$) {
		var index = _v0.a;
		return _Utils_Tuple2(index, dashboard.ld);
	} else {
		return A2($elm$core$String$startsWith, 'GWI Zeitgeist', dashboard.ld) ? _Utils_Tuple2(
			$turboMaCk$any_dict$Dict$Any$size($author$project$Dashboards2$List$specialPromotedDashboards),
			dashboard.ld) : _Utils_Tuple2(99999, dashboard.ld);
	}
};
var $author$project$Dashboards2$List$sortBy = function (sortType) {
	switch (sortType) {
		case 0:
			return $author$project$Gwi$List$reverseSortBy(
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.pC;
					},
					$elm$time$Time$posixToMillis));
		case 1:
			return $author$project$Gwi$List$reverseSortBy(
				function ($) {
					return $.qr;
				});
		case 2:
			return $author$project$Gwi$List$reverseSortBy(
				function ($) {
					return $.i1;
				});
		case 3:
			return $elm$core$List$sortBy(
				function ($) {
					return $.ld;
				});
		case 4:
			return $author$project$Gwi$List$reverseSortBy(
				function ($) {
					return $.ld;
				});
		default:
			return $elm$core$List$sortBy($author$project$Dashboards2$List$todoTemporaryHackPromotedDashboardsATC2752Order);
	}
};
var $author$project$Dashboards2$List$getFilteredAndSortedDashboardsList = F4(
	function (user, p2Store, dashboardsList, model) {
		return A2(
			$author$project$Dashboards2$List$sortBy,
			model.d$,
			A3(
				$author$project$Dashboards2$List$filterByDashboardType,
				user,
				model.az,
				A2(
					$author$project$Dashboards2$List$filterByDataset,
					{ff: dashboardsList, je: model.aZ},
					A3(
						$author$project$Dashboards2$List$filterByCategory,
						p2Store,
						{ff: dashboardsList, jd: model.aV},
						A2(
							$author$project$Dashboards2$List$filterBySearch,
							model.aR.cW,
							A3($author$project$Dashboards2$List$filterByTab, user, model.a9, dashboardsList))))));
	});
var $author$project$Dashboards2$List$moduleClass = $GlobalWebIndex$class_namespaces$WeakCss$namespace('dashboards-list');
var $author$project$Dashboards2$List$selectionPanelView = F5(
	function (user, can, p2Store, dashboardsDict, model) {
		var selectedCount = $turboMaCk$any_set$Set$Any$size(model.J);
		var panelClass = A2(
			$GlobalWebIndex$class_namespaces$WeakCss$addMany,
			_List_fromArray(
				['list', 'selection-panel']),
			$author$project$Dashboards2$List$moduleClass);
		var dashboards = A4(
			$author$project$Dashboards2$List$getFilteredAndSortedDashboardsList,
			user,
			p2Store,
			$turboMaCk$any_dict$Dict$Any$values(dashboardsDict),
			model);
		var buttonView = F6(
			function (disabledMsg_, disabled, title, maybeIcon, buttonClass, onClick) {
				var buttonView_ = A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('disabled', disabled)
								]),
							buttonClass),
							$elm$html$Html$Attributes$disabled(disabled),
							$elm$html$Html$Events$onClick(onClick)
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Extra$viewMaybe,
							function (icon) {
								return A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'icon', buttonClass)
										]),
									_List_fromArray(
										[
											A2($author$project$Icons$icon, _List_Nil, icon)
										]));
							},
							maybeIcon),
							$elm$html$Html$text(title)
						]));
				return A2(
					$author$project$CoolTip$Platform2$viewIf,
					disabled,
					{
						lB: 0,
						mu: buttonView_,
						mG: disabledMsg_,
						mL: $author$project$CoolTip$RelativeAncestor(
							'.' + $GlobalWebIndex$class_namespaces$WeakCss$toString(panelClass)),
						m2: _List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'tooltip', buttonClass)
							])
					});
			});
		var btnClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'control-btn', panelClass);
		var areAllSelected = _Utils_eq(
			$elm$core$List$length(dashboards),
			$turboMaCk$any_set$Set$Any$size(model.J));
		var allSelected = A2(
			$elm$core$List$filter,
			function (d) {
				return A2($turboMaCk$any_set$Set$Any$member, d.b, model.J);
			},
			dashboards);
		var canDeleteAllSelected = A2(
			$elm$core$List$all,
			function (dashboard) {
				return A4($author$project$Dashboards2$Permissions$canRenameOrDelete, user, can, dashboard.ah, dashboard.dG);
			},
			allSelected);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2('opened', selectedCount > 0)
						]),
					panelClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'counter', panelClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['counter', 'checkbox']),
									panelClass)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$checkboxFilled)
								])),
							$elm$html$Html$text(
							$elm$core$String$fromInt(selectedCount)),
							$elm$html$Html$text(' Selected')
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'control-buttons', panelClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'control-buttons', panelClass)
								]),
							_List_fromArray(
								[
									areAllSelected ? A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$GlobalWebIndex$class_namespaces$WeakCss$toClass(btnClass),
											$elm$html$Html$Events$onClick($author$project$Dashboards2$List$ClearDashboardSelection)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Deselect all')
										])) : A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											$GlobalWebIndex$class_namespaces$WeakCss$toClass(btnClass),
											$elm$html$Html$Events$onClick(
											$author$project$Dashboards2$List$SelectDashboards(
												A2(
													$elm$core$List$map,
													function ($) {
														return $.b;
													},
													dashboards)))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Select all')
										])),
									A6(
									buttonView,
									'One or more projects are shared with your whole organisation and cannot be deleted',
									!canDeleteAllSelected,
									'Delete',
									$elm$core$Maybe$Just($author$project$Icons$Platform2$trash),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'delete', btnClass),
									$author$project$Dashboards2$List$OpenConfirmDeleteDashboardsModal(allSelected))
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'close', btnClass),
									$elm$html$Html$Events$onClick($author$project$Dashboards2$List$ClearDashboardSelection)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
								]))
						]))
				]));
	});
var $author$project$Dashboards2$List$ToggleViewOnlyMode = {$: 22};
var $author$project$Dashboards2$List$createDashboardOnboardingView = F2(
	function (config, store) {
		var showOnboarding = function () {
			var _v1 = A2(
				$krisajenkins$remotedata$RemoteData$map,
				function ($) {
					return $.bF;
				},
				store.jU);
			if (_v1.$ === 3) {
				var showCreateDashboardOnboarding = _v1.a.me;
				return showCreateDashboardOnboarding;
			} else {
				return false;
			}
		}();
		var maybeCloseMsg = A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Data$Platform2$mapDashboardsDoNotShowAgain(
					function (settings) {
						return _Utils_update(
							settings,
							{me: false});
					}),
				A2(
					$elm$core$Basics$composeR,
					$author$project$Store$Platform2$SaveDashboardsUserSettings,
					A2($elm$core$Basics$composeR, $elm$core$List$singleton, config.l))),
			$krisajenkins$remotedata$RemoteData$toMaybe(store.jU));
		return A2(
			$elm_community$html_extra$Html$Extra$viewIfLazy,
			showOnboarding,
			function (_v0) {
				return A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (closeMsg) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['create-btn', 'onboarding']),
									$author$project$Dashboards2$List$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h3,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['create-btn', 'onboarding', 'title']),
											$author$project$Dashboards2$List$moduleClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Create a dashboard')
										])),
									$elm$html$Html$text('Dashboards make it quick and easy to visualise all of your insights in one place and build your own story.'),
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['create-btn', 'onboarding', 'got-it']),
											$author$project$Dashboards2$List$moduleClass),
											$elm$html$Html$Events$onClick(closeMsg)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Got it')
										]))
								]));
					},
					maybeCloseMsg);
			});
	});
var $author$project$Dashboards2$List$dashboardTabHeader = function (tab) {
	switch (tab) {
		case 0:
			return 'Dashboards';
		case 1:
			return 'Dashboards shared with you';
		case 2:
			return 'Dashboards';
		case 3:
			return 'Dashboards';
		default:
			return 'Dashboards';
	}
};
var $author$project$Dashboards2$List$Favourites = 4;
var $author$project$Dashboards2$List$ListProjectDropdown = function (a) {
	return {$: 2, a: a};
};
var $author$project$Dashboards2$List$MyDashboards = 2;
var $author$project$Dashboards2$List$NavigateTo = function (a) {
	return {$: 6, a: a};
};
var $author$project$Dashboards2$List$NoOp = {$: 0};
var $author$project$Dashboards2$List$ToggleDashboardSelection = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $author$project$Dashboards2$List$ToggleProjectDropdown = F2(
	function (a, b) {
		return {$: 10, a: a, b: b};
	});
var $author$project$Icons$Platform2$calendar = {
	mr: $author$project$Icons$Platform2$path('M18.863 9c.277 0 .508.193.551.445l.007.086v.83h1.589c1.046 0 1.905.77 1.984 1.746l.006.148v8.852C23 22.152 22.109 23 21.01 23H10.99C9.891 23 9 22.152 9 21.107v-8.852c0-1.045.891-1.893 1.99-1.893l1.588-.001v-.83c0-.293.25-.531.56-.531.277 0 .507.193.55.445l.008.086-.001.83h4.609v-.83c0-.293.25-.531.559-.531zm3.019 5.829H10.117v6.278c0 .423.333.773.763.824l.11.006h10.02c.482 0 .873-.372.873-.83l-.001-6.278zm-9.451 4.2l.1.006c.36.047.637.34.637.696 0 .387-.33.701-.737.701s-.738-.314-.738-.701c0-.355.278-.649.638-.696l.1-.006zm3.578 0l.1.006c.361.047.638.34.638.696 0 .387-.33.701-.738.701-.406 0-.737-.314-.737-.701 0-.355.277-.649.637-.696l.1-.006zm0-2.724l.1.007c.361.046.638.34.638.695 0 .387-.33.702-.738.702-.406 0-.737-.315-.737-.702 0-.354.277-.649.637-.695l.1-.007zm3.579 0l.1.007c.36.046.637.34.637.695 0 .387-.329.702-.737.702-.406 0-.737-.315-.737-.702 0-.354.277-.649.637-.695l.1-.007zm-7.01-4.881H10.99c-.482 0-.873.373-.873.831v1.511h11.765l.001-1.511c0-.423-.333-.773-.764-.824l-.109-.006-1.589-.001v.831c0 .293-.25.531-.558.531-.278 0-.508-.192-.551-.445l-.008-.086v-.831h-4.609v.831c0 .293-.25.531-.558.531-.277 0-.508-.192-.551-.445l-.007-.086-.001-.831z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$dashboards = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('translate(-619 -122) translate(553 114) translate(66) translate(0 8)'),
						$elm$svg$Svg$Attributes$d('M13.73 18.797c1.07 0 1.94.868 1.94 1.939v.325c0 1.07-.87 1.939-1.94 1.939H11.94C10.869 23 10 22.132 10 21.061v-.325c0-1.07.868-1.939 1.939-1.939h1.792zm7.331-2.932c1.07 0 1.939.868 1.939 1.938v3.258c0 1.07-.868 1.939-1.939 1.939H19.27c-1.07 0-1.938-.868-1.938-1.939v-3.258c0-1.07.868-1.938 1.938-1.938h1.792zm-7.33 4.203h-1.792c-.369 0-.668.3-.668.668v.325c0 .369.3.668.668.668h1.792c.368 0 .667-.3.667-.668v-.325c0-.369-.299-.668-.667-.668zm7.33-2.933H19.27c-.368 0-.667.3-.667.668v3.258c0 .369.299.668.667.668h1.792c.369 0 .668-.3.668-.668v-3.258c0-.368-.3-.668-.668-.668zM13.731 10c1.07 0 1.938.868 1.938 1.939v3.258c0 1.07-.868 1.938-1.938 1.938h-1.792c-1.07 0-1.939-.868-1.939-1.938v-3.258c0-1.07.868-1.939 1.939-1.939h1.792zm0 1.27h-1.792c-.369 0-.668.3-.668.669v3.258c0 .368.3.668.668.668h1.792c.368 0 .667-.3.667-.668v-3.258c0-.369-.299-.668-.667-.668zM21.06 10c1.07 0 1.939.868 1.939 1.939v.325c0 1.07-.868 1.939-1.939 1.939H19.27c-1.07 0-1.938-.868-1.938-1.939v-.325c0-1.07.868-1.939 1.938-1.939h1.792zm0 1.27H19.27c-.368 0-.667.3-.667.669v.325c0 .369.299.668.667.668h1.792c.369 0 .668-.3.668-.668v-.325c0-.369-.3-.668-.668-.668z')
					]),
				_List_Nil)
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$List$emptyDashboardsListView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'empty-dashboards-list', $author$project$Dashboards2$List$moduleClass)
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['empty-dashboards-list', 'container']),
					$author$project$Dashboards2$List$moduleClass)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Oh no! There are no such dashboards'),
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['empty-dashboards-list', 'main-copy']),
							$author$project$Dashboards2$List$moduleClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('No dashboards satisfy your filters. Please try to change some of them.')
						]))
				]))
		]));
var $author$project$Dashboards2$List$emptyFavouritesView = A2(
	$elm$html$Html$div,
	_List_fromArray(
		[
			A2(
			$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
			_List_fromArray(
				['favourites']),
			A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'empty-dashboards-list', $author$project$Dashboards2$List$moduleClass))
		]),
	_List_fromArray(
		[
			A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['empty-dashboards-list', 'container']),
					$author$project$Dashboards2$List$moduleClass)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('No favorite dashboards yet…'),
					A2(
					$elm$html$Html$h4,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['empty-dashboards-list', 'main-copy']),
							$author$project$Dashboards2$List$moduleClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Click the '),
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$favourite),
							$elm$html$Html$text(' to favorite a dashboard')
						]))
				]))
		]));
var $author$project$Dashboards2$List$SelectTab = function (a) {
	return {$: 7, a: a};
};
var $author$project$Dashboards2$List$emptyMyDashboardsView = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2(
				$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
				_List_fromArray(
					['my-dashboards']),
				A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'empty-dashboards-list', $author$project$Dashboards2$List$moduleClass))
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['empty-dashboards-list', 'container']),
						$author$project$Dashboards2$List$moduleClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['empty-dashboards-list', 'main-copy']),
								$author$project$Dashboards2$List$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('You haven\'t saved any dashboard queries yet')
							])),
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['empty-dashboards-list', 'primary-btn']),
								$author$project$Dashboards2$List$moduleClass),
								$elm$html$Html$Events$onClick(
								config.a(
									$author$project$Dashboards2$List$SelectTab(0)))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Discover a dashboard')
							]))
					]))
			]));
};
var $author$project$Dashboards2$List$emptySearchResultsView = function (searchTerm) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'empty-search-results', $author$project$Dashboards2$List$moduleClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['empty-search-results', 'container']),
						$author$project$Dashboards2$List$moduleClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Oh no! There are no search results'),
						A2(
						$elm$html$Html$h4,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['empty-search-results', 'main-copy']),
								$author$project$Dashboards2$List$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('We couldn’t find any search results for ‘'),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['empty-search-results', 'term']),
										$author$project$Dashboards2$List$moduleClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(searchTerm)
									])),
								$elm$html$Html$text('’, please try again')
							]))
					]))
			]));
};
var $author$project$Platform2$Router$Insights = {$: 6};
var $author$project$Dashboards2$List$emptyViewOnlyDashboardsView = function (flags) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'empty-viewonly-dashboards-list', $author$project$Dashboards2$List$moduleClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['empty-viewonly-dashboards-list', 'container']),
						$author$project$Dashboards2$List$moduleClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$pre,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['empty-viewonly-dashboards-list', 'main-copy']),
								$author$project$Dashboards2$List$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No dashboards have\nbeen shared with you yet 👀')
							])),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['empty-viewonly-dashboards-list', 'content']),
								$author$project$Dashboards2$List$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Once a dashboard has been shared with you, they will populate here for you to look through. Until then, feel free to look through some of our insights:')
							])),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['empty-viewonly-dashboards-list', 'primary-btn']),
								$author$project$Dashboards2$List$moduleClass),
								$elm$html$Html$Attributes$href(
								A2($author$project$Platform2$Router$toUrlString, flags, $author$project$Platform2$Router$Insights))
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$insights),
								$elm$html$Html$text('Explore insights')
							]))
					]))
			]));
};
var $author$project$Dashboards2$List$ToggleFavourite = function (a) {
	return {$: 5, a: a};
};
var $author$project$Dashboards2$List$favouriteView = F3(
	function (config, className, dashboard) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2('active', dashboard.kN)
						]),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'favourite', className)),
					$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
					config.a(
						$author$project$Dashboards2$List$ToggleFavourite(dashboard.b)))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Icons$icon,
					_List_Nil,
					dashboard.kN ? $author$project$Icons$Platform2$favouriteFilled : $author$project$Icons$Platform2$favourite)
				]));
	});
var $author$project$Time$Format$format_D_MMM_YYYY = _List_fromArray(
	[
		$ryannhg$date_format$DateFormat$dayOfMonthNumber,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$monthNameAbbreviated,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$yearNumber
	]);
var $author$project$Dashboards2$List$getDDMenuData = F2(
	function (dd, model) {
		var defaultMenuData = {oB: 1};
		return A2($author$project$Dashboards2$List$isDropdownSelected, dd, model) ? A2($elm$core$Maybe$withDefault, defaultMenuData, model.aA.b) : defaultMenuData;
	});
var $author$project$Dashboards2$List$DeleteDashboard = function (a) {
	return {$: 18, a: a};
};
var $author$project$Dashboards2$List$OpenDuplicateDashboardModal = function (a) {
	return {$: 20, a: a};
};
var $author$project$Dashboards2$List$OpenRenameDashboardModal = function (a) {
	return {$: 19, a: a};
};
var $author$project$Dashboards2$List$getDropdownOptions = F3(
	function (canRenameOrDelete, config, dashboard) {
		return A3(
			$author$project$Gwi$List$appendIf,
			canRenameOrDelete,
			_Utils_Tuple3(
				$author$project$Icons$Platform2$trash,
				'Delete',
				config.a(
					$author$project$Dashboards2$List$DeleteDashboard(dashboard))),
			A3(
				$author$project$Gwi$List$appendIf,
				canRenameOrDelete,
				_Utils_Tuple3(
					$author$project$Icons$Platform2$rename,
					'Rename',
					config.a(
						$author$project$Dashboards2$List$OpenRenameDashboardModal(dashboard))),
				_List_fromArray(
					[
						_Utils_Tuple3(
						$author$project$Icons$Platform2$duplicate,
						'Duplicate',
						config.a(
							$author$project$Dashboards2$List$OpenDuplicateDashboardModal(dashboard))),
						_Utils_Tuple3(
						$author$project$Icons$Platform2$edit,
						'Edit',
						config.a(
							$author$project$Dashboards2$List$NavigateTo(
								$author$project$Dashboards2$Router$Dashboard(dashboard.b))))
					])));
	});
var $author$project$Gwi$Html$Events$onClickStopPropagationWithShiftCheck = function (action) {
	return A2(
		$elm$html$Html$Events$stopPropagationOn,
		'click',
		A2(
			$elm$json$Json$Decode$map,
			function (shiftPressed) {
				return _Utils_Tuple2(
					action(
						{rl: shiftPressed}),
					true);
			},
			A2($elm$json$Json$Decode$field, 'shiftKey', $elm$json$Json$Decode$bool)));
};
var $author$project$Icons$Platform2$shared = {
	mr: $author$project$Icons$Platform2$path('M19.915 18.015c2.2 0 3.985 1.784 3.985 3.985a.65.65 0 0 1-1.3 0c0-1.426-1.112-2.592-2.515-2.68l-.17-.005h-3.83c-1.483 0-2.685 1.202-2.685 2.685a.65.65 0 1 1-1.3 0c0-2.134 1.678-3.877 3.786-3.98l.2-.005h3.83zm-8.324-4.01l.083.07 1.5 1.5c.024.024.047.05.066.078l-.066-.078c.027.027.05.056.072.087.017.025.033.052.046.08l.01.025c.01.02.017.042.023.065l.01.035.01.063.003.04V16v.028l-.004.04.004-.068c0 .046-.005.1-.015.133-.002.01-.005.023-.01.034-.005.02-.012.038-.02.057l-.015.033c-.01.025-.024.048-.04.07l-.01.014-.01.013-.06.07-1.5 1.5a.6.6 0 0 1-.918-.765l.07-.083.475-.476H9a.6.6 0 0 1-.097-1.192L9 15.4h2.3l-.475-.476a.6.6 0 0 1-.07-.765l.07-.083a.6.6 0 0 1 .765-.07zM18 9.492a3.8 3.8 0 0 1 3.8 3.799 3.8 3.8 0 1 1-7.6 0 3.8 3.8 0 0 1 3.8-3.8zm0 1.3a2.5 2.5 0 0 0-2.5 2.499 2.5 2.5 0 1 0 5 0 2.5 2.5 0 0 0-2.5-2.5z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Dropdown$viewWithOrientation = function (config) {
	return $author$project$Platform2$Dropdown$viewWithOrientationCustomOptions(
		{
			fs: config.fs,
			pv: config.pv,
			h4: config.h4,
			lr: config.pv ? A2(
				$elm$core$List$map,
				$author$project$Platform2$Dropdown$dropdownItemView(
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'options', config.fs)),
				config.lr) : _List_Nil,
			iF: config.iF,
			iG: config.iG,
			mD: config.mD
		});
};
var $author$project$Dashboards2$List$dashboardsListView = F6(
	function (config, flags, zone, p2Store, dashboardsList, model) {
		var tooltipClass = function (lastClass) {
			return A2(
				$GlobalWebIndex$class_namespaces$WeakCss$addMany,
				_List_fromArray(
					['list', 'item', 'link', lastClass]),
				$author$project$Dashboards2$List$moduleClass);
		};
		var isAnySelected = !$turboMaCk$any_set$Set$Any$isEmpty(model.J);
		var filteredSortedDashboardsList = A4($author$project$Dashboards2$List$getFilteredAndSortedDashboardsList, flags.mQ, p2Store, dashboardsList, model);
		var ellipsisElementClass = function (name) {
			return A2(
				$GlobalWebIndex$class_namespaces$WeakCss$addMany,
				_List_fromArray(
					['list', 'item', 'link', name, 'text']),
				$author$project$Dashboards2$List$moduleClass);
		};
		var withTooltip = F3(
			function (tooltipText, lastClass, content) {
				var ellipsisElementSelector = (lastClass === 'name') ? ('.' + $GlobalWebIndex$class_namespaces$WeakCss$toString(
					A2(
						$GlobalWebIndex$class_namespaces$WeakCss$addMany,
						_List_fromArray(
							['list', 'item', 'link', lastClass]),
						$author$project$Dashboards2$List$moduleClass))) : ('.' + $GlobalWebIndex$class_namespaces$WeakCss$toString(
					ellipsisElementClass(lastClass)));
				return $author$project$CoolTip$Platform2$view(
					{
						lm: $elm$core$Maybe$Nothing,
						lB: 1,
						mt: _List_Nil,
						mu: _List_fromArray(
							[content]),
						mE: _List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['list', 'item', 'link', 'tooltip-content']),
								$author$project$Dashboards2$List$moduleClass)
							]),
						mF: $elm$html$Html$text(tooltipText),
						mL: $author$project$CoolTip$NormalShownWhenEllipsis(ellipsisElementSelector),
						m2: _List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nest,
								'tooltip',
								tooltipClass(lastClass))
							])
					});
			});
		var itemPartView_ = F3(
			function (maybeIcon, name, str) {
				return A3(
					withTooltip,
					str,
					name,
					A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['list', 'item', 'link', name]),
								$author$project$Dashboards2$List$moduleClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm_community$html_extra$Html$Extra$viewIf,
								!$elm$core$String$isEmpty(str),
								A2(
									$elm_community$html_extra$Html$Extra$viewMaybe,
									A2(
										$elm$core$Basics$composeL,
										A2(
											$elm$core$Basics$composeL,
											$elm$html$Html$span(
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['list', 'item', 'link', name, 'icon']),
														$author$project$Dashboards2$List$moduleClass)
													])),
											$elm$core$List$singleton),
										$author$project$Icons$icon(
											_List_fromArray(
												[
													$author$project$Icons$width(24)
												]))),
									maybeIcon)),
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										$GlobalWebIndex$class_namespaces$WeakCss$toClass(
										ellipsisElementClass(name))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(str)
									]))
							])));
			});
		var itemPartView = itemPartView_($elm$core$Maybe$Nothing);
		var itemPartViewWithIcon = function (icon) {
			return itemPartView_(
				$elm$core$Maybe$Just(icon));
		};
		var checkboxView = F2(
			function (isSelected, dashboard) {
				return A2(
					$elm$html$Html$label,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['list', 'item', 'select']),
							$author$project$Dashboards2$List$moduleClass),
							$author$project$Gwi$Html$Events$onClickStopPropagationWithShiftCheck(
							A2(
								$elm$core$Basics$composeL,
								config.a,
								A2($author$project$Dashboards2$List$ToggleDashboardSelection, filteredSortedDashboardsList, dashboard.b)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$input,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['list', 'item', 'select', 'input']),
									$author$project$Dashboards2$List$moduleClass),
									$elm$html$Html$Attributes$type_('checkbox'),
									$elm$html$Html$Attributes$checked(isSelected),
									$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
									config.a($author$project$Dashboards2$List$NoOp))
								]),
							_List_Nil),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('selected', isSelected)
										]),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['list', 'item', 'select', 'indicator']),
										$author$project$Dashboards2$List$moduleClass))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$i,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['list', 'item', 'select', 'indicator', 'icon']),
											$author$project$Dashboards2$List$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Icons$icon,
											_List_Nil,
											isSelected ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled)
										]))
								]))
						]));
			});
		var itemView = F2(
			function (index, dashboard) {
				var itemAction = isAnySelected ? A2(
					$elm$core$Basics$composeL,
					config.a,
					A2($author$project$Dashboards2$List$ToggleDashboardSelection, filteredSortedDashboardsList, dashboard.b)) : $elm$core$Basics$always(
					config.a(
						$author$project$Dashboards2$List$NavigateTo(
							$author$project$Dashboards2$Router$Dashboard(dashboard.b))));
				var isSelected = A2($turboMaCk$any_set$Set$Any$member, dashboard.b, model.J);
				var dashboardSharing = A2($author$project$Dashboards2$List$dashboardsSharingToDashboardsTab, flags.mQ, dashboard.ah);
				var canRenameOrDelete = A4($author$project$Dashboards2$Permissions$canRenameOrDelete, flags.mQ, flags.nM, dashboard.ah, dashboard.dG);
				var ddMenuOptions = A3($author$project$Dashboards2$List$getDropdownOptions, canRenameOrDelete, config, dashboard);
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['list', 'item']),
							$author$project$Dashboards2$List$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2('selected', isSelected)
										]),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['list', 'item', 'link']),
										$author$project$Dashboards2$List$moduleClass)),
									$author$project$Gwi$Html$Events$onClickStopPropagationWithShiftCheck(itemAction)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['list', 'item', 'link', 'left-icons']),
											$author$project$Dashboards2$List$moduleClass)
										]),
									_List_fromArray(
										[
											A2(checkboxView, isSelected, dashboard),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['list', 'item', 'link', 'left-icons', 'dashboard-type']),
													$author$project$Dashboards2$List$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Icons$icon,
													_List_Nil,
													function () {
														switch (dashboardSharing) {
															case 0:
																return $author$project$Icons$Platform2$dashboards;
															case 1:
																return $author$project$Icons$Platform2$shared;
															default:
																return $author$project$Icons$Platform2$globe;
														}
													}())
												]))
										])),
									A2(itemPartView, 'name', dashboard.ld),
									A3(
									itemPartViewWithIcon,
									$author$project$Icons$Platform2$category,
									'categories',
									A2(
										$elm$core$String$join,
										', ',
										$author$project$Data$Platform2$getCategoryNames(dashboard.ac))),
									A3(
									itemPartViewWithIcon,
									$author$project$Icons$Platform2$dataSurvey,
									'data-set',
									A2(
										$elm$core$String$join,
										', ',
										A2(
											$elm$core$List$map,
											function ($) {
												return $.ld;
											},
											A2($author$project$Store$Utils$getByIds, p2Store.es, dashboard.es)))),
									A2(
									itemPartView,
									'owner',
									A2($author$project$Dashboards2$List$dashboardTypeLabel, flags.mQ, dashboardSharing)),
									A3(
									itemPartViewWithIcon,
									$author$project$Icons$Platform2$calendar,
									'created-at',
									A3(
										$elm$core$Basics$composeR,
										A2($ryannhg$date_format$DateFormat$format, $author$project$Time$Format$format_D_MMM_YYYY, zone),
										$elm$core$Basics$append('Created '),
										dashboard.bB)),
									A2(
									$elm_community$html_extra$Html$Extra$viewIf,
									!model.K,
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['list', 'item', 'link', 'right-icons']),
												$author$project$Dashboards2$List$moduleClass)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Platform2$Dropdown$viewWithOrientation,
												{
													fs: A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['list', 'item', 'link', 'dropdown']),
														$author$project$Dashboards2$List$moduleClass),
													pv: A2(
														$author$project$Dashboards2$List$isDropdownSelected,
														$author$project$Dashboards2$List$ListProjectDropdown(index),
														model),
													h4: $elm_community$html_extra$Html$Extra$nothing,
													lr: ddMenuOptions,
													iF: $elm$core$List$length(ddMenuOptions) * 40,
													iG: 200,
													mD: A2(
														$elm$core$Basics$composeL,
														config.a,
														$author$project$Dashboards2$List$ToggleProjectDropdown(
															$author$project$Dashboards2$List$ListProjectDropdown(index)))
												},
												A2(
													$author$project$Dashboards2$List$getDDMenuData,
													$author$project$Dashboards2$List$ListProjectDropdown(index),
													model)),
												A2(
												$elm_community$html_extra$Html$Extra$viewIf,
												!model.K,
												A3(
													$author$project$Dashboards2$List$favouriteView,
													config,
													A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['list', 'item', 'link']),
														$author$project$Dashboards2$List$moduleClass),
													dashboard))
											])))
								]))
						]));
			});
		return ((model.a9 === 4) && (!A2(
			$elm$core$List$any,
			function ($) {
				return $.kN;
			},
			dashboardsList))) ? $author$project$Dashboards2$List$emptyFavouritesView : (($elm$core$List$isEmpty(dashboardsList) && $author$project$Data$User$hasViewOnlyPlan(flags.mQ)) ? $author$project$Dashboards2$List$emptyViewOnlyDashboardsView(flags) : ($elm$core$List$isEmpty(filteredSortedDashboardsList) ? (($elm$core$String$isEmpty(model.aR.cW) && (model.a9 === 2)) ? $author$project$Dashboards2$List$emptyMyDashboardsView(config) : ($elm$core$String$isEmpty(model.aR.cW) ? $author$project$Dashboards2$List$emptyDashboardsListView : $author$project$Dashboards2$List$emptySearchResultsView(model.aR.cW))) : A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['list', 'container']),
					$author$project$Dashboards2$List$moduleClass)
				]),
			$elm$core$List$singleton(
				A2(
					$elm$html$Html$ul,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'any-selected',
									!$turboMaCk$any_set$Set$Any$isEmpty(model.J))
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'list', $author$project$Dashboards2$List$moduleClass))
						]),
					A2($elm$core$List$indexedMap, itemView, filteredSortedDashboardsList))))));
	});
var $author$project$DropDownMenu$BottomLeft = 0;
var $author$project$Dashboards2$List$ClearCategoryFilter = {$: 13};
var $author$project$Dashboards2$List$OpenFilterDropdown = function (a) {
	return {$: 9, a: a};
};
var $author$project$Dashboards2$List$ToggleCategoryFilter = function (a) {
	return {$: 12, a: a};
};
var $elm$html$Html$Attributes$for = $elm$html$Html$Attributes$stringProperty('htmlFor');
var $author$project$Dashboards2$List$checkboxItemView = F3(
	function (className, index, _v0) {
		var label = _v0.h4;
		var isChecked = _v0.bl;
		var onCheck = _v0.cK;
		var id = 'checkbox-' + $elm$core$String$fromInt(index);
		return A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2('checked', isChecked)
						]),
					A2(
						$GlobalWebIndex$class_namespaces$WeakCss$addMany,
						_List_fromArray(
							['menu', 'items', 'item']),
						className)),
					$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(onCheck),
					$elm$html$Html$Attributes$for(id)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$id(id),
							$elm$html$Html$Attributes$type_('checkbox'),
							$elm$html$Html$Attributes$checked(isChecked),
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['menu', 'items', 'item', 'checkbox']),
							className)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['menu', 'items', 'item', 'checkmark']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Icons$icon,
							_List_Nil,
							isChecked ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled)
						])),
					$elm$html$Html$text(label)
				]));
	});
var $author$project$DropDownMenu$isOpen = F2(
	function (config, model) {
		if (!model.$) {
			return false;
		} else {
			var openedConfig = model.a;
			return _Utils_eq(config.b, openedConfig.b);
		}
	});
var $author$project$DropDownMenu$Open = function (a) {
	return {$: 1, a: a};
};
var $author$project$DropDownMenu$open = F2(
	function (message, config) {
		return $elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
			message(
				$author$project$DropDownMenu$Open(config)));
	});
var $author$project$DropDownMenu$arrowPositionState = function (arrow) {
	switch (arrow) {
		case 0:
			return 'left';
		case 1:
			return 'right';
		case 2:
			return 'top-left';
		default:
			return 'no-arrow';
	}
};
var $author$project$DropDownMenu$open_ = F3(
	function (_v0, listContent, c) {
		var id = _v0.b;
		var className = _v0.hi;
		var arrow = _v0.fj;
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			_Utils_eq(c.b, id),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
						_List_fromArray(
							[
								$author$project$DropDownMenu$arrowPositionState(arrow)
							]),
						className)
					]),
				_List_fromArray(
					[listContent])));
	});
var $author$project$DropDownMenu$customView = F2(
	function (listContent, config) {
		return A2(
			$author$project$DropDownMenu$applyOpenClosed,
			A2($author$project$DropDownMenu$open_, config, listContent),
			$elm_community$html_extra$Html$Extra$nothing);
	});
var $author$project$DropDownMenu$view = function (config) {
	var content = config.U;
	var className = config.hi;
	var listContent = A2(
		$elm$html$Html$ul,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'list', className)
			]),
		content);
	return A2($author$project$DropDownMenu$customView, listContent, config);
};
var $author$project$Dashboards2$List$categoryMenuView = F4(
	function (className, p2Store, dashboards, model) {
		var itemsList = A2(
			$elm$core$List$map,
			function (category) {
				return {
					bl: A2($turboMaCk$any_set$Set$Any$member, category, model.aV),
					h4: category.ld,
					cK: $author$project$Dashboards2$List$ToggleCategoryFilter(category)
				};
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.ld;
				},
				$turboMaCk$any_set$Set$Any$toList(
					A2($author$project$Dashboards2$List$availableCategories, p2Store.kF, dashboards))));
		var selectedItemsCount = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.bl;
				},
				itemsList));
		var menuConfig = {
			fj: 0,
			hi: A2(
				$GlobalWebIndex$class_namespaces$WeakCss$addMany,
				_List_fromArray(
					['category', 'menu']),
				className),
			U: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['category', 'menu', 'header']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['category', 'menu', 'selected-count']),
									className)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(selectedItemsCount) + ' Selected')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Dashboards2$List$ClearCategoryFilter),
									$elm$html$Html$Attributes$disabled(!selectedItemsCount),
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['category', 'menu', 'clear-btn']),
									className)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clear')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['category', 'menu', 'items']),
							className)
						]),
					A2(
						$elm$core$List$indexedMap,
						$author$project$Dashboards2$List$checkboxItemView(
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'category', className)),
						itemsList))
				]),
			b: 'd2-list-category-filter'
		};
		var filterDropdown = function () {
			var _v0 = model.aA.a;
			if (!_v0.$) {
				var dropdown = _v0.a;
				return dropdown;
			} else {
				return $author$project$DropDownMenu$Closed;
			}
		}();
		var isOpen = A2($author$project$DropDownMenu$isOpen, menuConfig, filterDropdown);
		var toggleMenu = isOpen ? $elm$html$Html$Events$onClick($author$project$Dashboards2$List$CloseDropdown) : A2($author$project$DropDownMenu$open, $author$project$Dashboards2$List$OpenFilterDropdown, menuConfig);
		var categoriesString = A3($author$project$Dashboards2$List$isCategoryFilterActive, p2Store, dashboards, model.aV) ? A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.ld;
				},
				$turboMaCk$any_set$Set$Any$toList(model.aV))) : 'All';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'filter', className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							toggleMenu,
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('open', isOpen)
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'category', className))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['category', 'icon']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									$author$project$Icons$Platform2$category)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['category', 'label']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['category', 'label', 'label-text']),
											className)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Category:')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['category', 'label', 'value']),
											className)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(categoriesString)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['category', 'icon']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									isOpen ? $author$project$Icons$Platform2$caretUp : $author$project$Icons$Platform2$caretDown)
								]))
						])),
					A2($author$project$DropDownMenu$view, menuConfig, filterDropdown)
				]));
	});
var $author$project$Dashboards2$List$ClearDashboardTypeFilter = {$: 17};
var $author$project$Dashboards2$List$ToggleDashboardTypeFilter = function (a) {
	return {$: 16, a: a};
};
var $author$project$Icons$Platform2$segments = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('translate(-750 -378) translate(750 378)'),
						$elm$svg$Svg$Attributes$d('M22.486 17.623c1.33 0 2.427 1.004 2.509 2.283l.005.155v.804c0 .335-.271.606-.606.606-.305 0-.557-.224-.6-.516l-.006-.09v-.804c0-.631-.512-1.16-1.176-1.22l-.126-.006h-.611c-.335 0-.606-.271-.606-.606 0-.304.224-.556.516-.6l.09-.006h.611zm-12.36 0c.334 0 .605.271.605.606 0 .305-.224.557-.516.6l-.09.006h-.611c-.682 0-1.233.492-1.296 1.11l-.006.116v.804c0 .335-.271.606-.606.606-.304 0-.556-.224-.6-.516L7 20.865v-.804c0-1.3 1.046-2.354 2.355-2.433l.159-.005h.611zm7.278-1.103c1.744 0 3.178 1.322 3.272 2.997l.005.174v1.174c0 .335-.272.606-.607.606-.304 0-.556-.224-.6-.516l-.006-.09v-1.174c0-1.029-.84-1.881-1.916-1.953l-.148-.005h-2.808c-1.095 0-1.984.807-2.06 1.819l-.004.14v1.173c0 .335-.272.606-.606.606-.305 0-.557-.224-.6-.516l-.007-.09v-1.174c0-1.698 1.376-3.076 3.098-3.166l.18-.005h2.807zm4.214-3.639c1.182 0 2.15.93 2.15 2.088 0 1.16-.968 2.088-2.15 2.088s-2.15-.929-2.15-2.088.968-2.088 2.15-2.088zm-11.236 0c1.182 0 2.15.93 2.15 2.088 0 1.159-.968 2.088-2.15 2.088s-2.149-.929-2.149-2.088.967-2.088 2.15-2.088zm11.236 1.213c-.523 0-.938.397-.938.875s.415.876.938.876c.523 0 .937-.398.937-.876s-.414-.875-.937-.875zm-11.236 0c-.523 0-.937.397-.937.875s.414.876.937.876c.523 0 .938-.398.938-.876s-.415-.875-.938-.875zM16 10c1.642 0 2.983 1.287 2.983 2.888S17.642 15.777 16 15.777c-1.642 0-2.983-1.287-2.983-2.889 0-1.6 1.34-2.888 2.983-2.888zm0 1.212c-.983 0-1.77.756-1.77 1.676 0 .92.787 1.677 1.77 1.677s1.77-.756 1.77-1.677c0-.92-.787-1.676-1.77-1.676z')
					]),
				_List_Nil)
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$List$dashboardTypeFilterMenuView = F3(
	function (user, className, model) {
		var itemsList = $elm_community$maybe_extra$Maybe$Extra$values(
			_List_fromArray(
				[
					$elm$core$Maybe$Just(
					{
						bl: A2($turboMaCk$any_set$Set$Any$member, 2, model.az),
						h4: A2($author$project$Dashboards2$List$dashboardTypeLabel, user, 2),
						cK: $author$project$Dashboards2$List$ToggleDashboardTypeFilter(2)
					}),
					A2(
					$elm$core$Maybe$map,
					function (_v1) {
						return {
							bl: A2($turboMaCk$any_set$Set$Any$member, 1, model.az),
							h4: A2($author$project$Dashboards2$List$dashboardTypeLabel, user, 1),
							cK: $author$project$Dashboards2$List$ToggleDashboardTypeFilter(1)
						};
					},
					user.bL),
					$elm$core$Maybe$Just(
					{
						bl: A2($turboMaCk$any_set$Set$Any$member, 0, model.az),
						h4: A2($author$project$Dashboards2$List$dashboardTypeLabel, user, 0),
						cK: $author$project$Dashboards2$List$ToggleDashboardTypeFilter(0)
					})
				]));
		var selectedItemsCount = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.bl;
				},
				itemsList));
		var menuConfig = {
			fj: 0,
			hi: A2(
				$GlobalWebIndex$class_namespaces$WeakCss$addMany,
				_List_fromArray(
					['dashboard-type', 'menu']),
				className),
			U: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['dashboard-type', 'menu', 'header']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dashboard-type', 'menu', 'selected-count']),
									className)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(selectedItemsCount) + ' Selected')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Dashboards2$List$ClearDashboardTypeFilter),
									$elm$html$Html$Attributes$disabled(!selectedItemsCount),
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dashboard-type', 'menu', 'clear-btn']),
									className)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clear')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['dashboard-type', 'menu', 'items']),
							className)
						]),
					A2(
						$elm$core$List$indexedMap,
						$author$project$Dashboards2$List$checkboxItemView(
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'dashboard-type', className)),
						itemsList))
				]),
			b: 'd2-list-dashboard-type-filter'
		};
		var filterDropdown = function () {
			var _v0 = model.aA.a;
			if (!_v0.$) {
				var dropdown = _v0.a;
				return dropdown;
			} else {
				return $author$project$DropDownMenu$Closed;
			}
		}();
		var isOpen = A2($author$project$DropDownMenu$isOpen, menuConfig, filterDropdown);
		var toggleMenu = isOpen ? $elm$html$Html$Events$onClick($author$project$Dashboards2$List$CloseDropdown) : A2($author$project$DropDownMenu$open, $author$project$Dashboards2$List$OpenFilterDropdown, menuConfig);
		var dashboardTypesString = $author$project$Dashboards2$List$isDashboardTypeFilterActive(model.az) ? A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$author$project$Dashboards2$List$dashboardTypeLabel(user),
				$turboMaCk$any_set$Set$Any$toList(model.az))) : 'All';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'filter', className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2($elm_community$html_extra$Html$Attributes$Extra$attributeIf, !model.K, toggleMenu),
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('open', isOpen),
									_Utils_Tuple2('disabled', model.K)
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'dashboard-type', className))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dashboard-type', 'icon']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									$author$project$Icons$Platform2$segments)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dashboard-type', 'label']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['dashboard-type', 'label', 'label-text']),
											className)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Owner:')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['dashboard-type', 'label', 'value']),
											className)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(dashboardTypesString)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dashboard-type', 'icon']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_Nil,
									isOpen ? $author$project$Icons$Platform2$caretUp : $author$project$Icons$Platform2$caretDown)
								]))
						])),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					!model.K,
					A2($author$project$DropDownMenu$view, menuConfig, filterDropdown))
				]));
	});
var $author$project$Dashboards2$List$ClearDatasetFilter = {$: 15};
var $author$project$Dashboards2$List$ToggleDatasetFilter = function (a) {
	return {$: 14, a: a};
};
var $author$project$Dashboards2$List$datasetMenuView = F4(
	function (className, p2Store, dashboards, model) {
		var itemsList = A2(
			$elm$core$List$map,
			function (dataset) {
				return {
					bl: A2($turboMaCk$any_set$Set$Any$member, dataset.bW, model.aZ),
					h4: dataset.ld,
					cK: $author$project$Dashboards2$List$ToggleDatasetFilter(dataset)
				};
			},
			A2(
				$elm$core$List$sortBy,
				function ($) {
					return $.gq;
				},
				A2(
					$author$project$Store$Utils$getByIds,
					p2Store.es,
					$turboMaCk$any_set$Set$Any$toList(
						$author$project$Dashboards2$List$availableDatasets(dashboards)))));
		var selectedItemsCount = $elm$core$List$length(
			A2(
				$elm$core$List$filter,
				function ($) {
					return $.bl;
				},
				itemsList));
		var menuConfig = {
			fj: 0,
			hi: A2(
				$GlobalWebIndex$class_namespaces$WeakCss$addMany,
				_List_fromArray(
					['dataset', 'menu']),
				className),
			U: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['dataset', 'menu', 'header']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dataset', 'menu', 'selected-count']),
									className)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$fromInt(selectedItemsCount) + ' Selected')
								])),
							A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm$html$Html$Events$onClick($author$project$Dashboards2$List$ClearDatasetFilter),
									$elm$html$Html$Attributes$disabled(!selectedItemsCount),
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dataset', 'menu', 'clear-btn']),
									className)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Clear')
								]))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['dataset', 'menu', 'items']),
							className)
						]),
					A2(
						$elm$core$List$indexedMap,
						$author$project$Dashboards2$List$checkboxItemView(
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'dataset', className)),
						itemsList))
				]),
			b: 'd2-list-dataset-filter'
		};
		var filterDropdown = function () {
			var _v0 = model.aA.a;
			if (!_v0.$) {
				var dropdown = _v0.a;
				return dropdown;
			} else {
				return $author$project$DropDownMenu$Closed;
			}
		}();
		var isOpen = A2($author$project$DropDownMenu$isOpen, menuConfig, filterDropdown);
		var toggleMenu = isOpen ? $elm$html$Html$Events$onClick($author$project$Dashboards2$List$CloseDropdown) : A2($author$project$DropDownMenu$open, $author$project$Dashboards2$List$OpenFilterDropdown, menuConfig);
		var datasetsString = A2($author$project$Dashboards2$List$isDatasetFilterActive, dashboards, model.aZ) ? A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				function ($) {
					return $.ld;
				},
				A2(
					$author$project$Store$Utils$getByIds,
					p2Store.es,
					$turboMaCk$any_set$Set$Any$toList(model.aZ)))) : 'All';
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'filter', className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
							!$elm$core$List$isEmpty(itemsList),
							toggleMenu),
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('open', isOpen),
									_Utils_Tuple2(
									'disabled',
									$elm$core$List$isEmpty(itemsList))
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'dataset', className))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dataset', 'icon']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									$author$project$Icons$Platform2$dataSurvey)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dataset', 'label']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['dataset', 'label', 'label-text']),
											className)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Dataset:')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['dataset', 'label', 'value']),
											className)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(datasetsString)
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['dataset', 'icon']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_Nil,
									isOpen ? $author$project$Icons$Platform2$caretUp : $author$project$Icons$Platform2$caretDown)
								]))
						])),
					A2($author$project$DropDownMenu$view, menuConfig, filterDropdown)
				]));
	});
var $author$project$Dashboards2$List$SelectSort = function (a) {
	return {$: 11, a: a};
};
var $author$project$Dashboards2$List$MostPopularByMe = 2;
var $author$project$Dashboards2$List$MostPopularByOrg = 1;
var $author$project$Dashboards2$List$MostRecentlyVisited = 0;
var $author$project$Dashboards2$List$NameDesc = 4;
var $author$project$Dashboards2$List$sortTypesForTab = function (tab) {
	switch (tab) {
		case 0:
			return _List_fromArray(
				[0, 1, 3, 4]);
		case 1:
			return _List_fromArray(
				[0, 1, 3, 4]);
		case 2:
			return _List_fromArray(
				[0, 2, 3, 4]);
		case 3:
			return _List_fromArray(
				[0, 2, 3, 4]);
		default:
			return _List_fromArray(
				[0, 2, 3, 4]);
	}
};
var $author$project$Dashboards2$List$sortMenuView = F2(
	function (className, model) {
		var menuConfig = {
			fj: 0,
			hi: A2(
				$GlobalWebIndex$class_namespaces$WeakCss$addMany,
				_List_fromArray(
					['sort', 'menu']),
				className),
			U: _List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['sort', 'menu', 'items']),
							className)
						]),
					A2(
						$elm$core$List$map,
						function (sortType) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['sort', 'menu', 'items', 'item']),
										className),
										$elm$html$Html$Events$onClick(
										$author$project$Dashboards2$List$SelectSort(sortType))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										$author$project$Dashboards2$List$sortTypeLabel(sortType))
									]));
						},
						$author$project$Dashboards2$List$sortTypesForTab(model.a9)))
				]),
			b: 'd2-list-sort-filter'
		};
		var filterDropdown = function () {
			var _v0 = model.aA.a;
			if (!_v0.$) {
				var dropdown = _v0.a;
				return dropdown;
			} else {
				return $author$project$DropDownMenu$Closed;
			}
		}();
		var isOpen = A2($author$project$DropDownMenu$isOpen, menuConfig, filterDropdown);
		var toggleMenu = isOpen ? $elm$html$Html$Events$onClick($author$project$Dashboards2$List$CloseDropdown) : A2($author$project$DropDownMenu$open, $author$project$Dashboards2$List$OpenFilterDropdown, menuConfig);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'filter', className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							toggleMenu,
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2('open', isOpen)
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'sort', className))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['sort', 'icon']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_fromArray(
										[
											$author$project$Icons$width(32)
										]),
									$author$project$Icons$Platform2$sort)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['sort', 'label']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['sort', 'label', 'label-text']),
											className)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Sort by')
										])),
									A2(
									$elm$html$Html$span,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['sort', 'label', 'value']),
											className)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(
											$author$project$Dashboards2$List$sortTypeLabel(model.d$))
										]))
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['sort', 'icon']),
									className)
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Icons$icon,
									_List_Nil,
									isOpen ? $author$project$Icons$Platform2$caretUp : $author$project$Icons$Platform2$caretDown)
								]))
						])),
					A2($author$project$DropDownMenu$view, menuConfig, filterDropdown)
				]));
	});
var $author$project$Dashboards2$List$filtersPanelView = F5(
	function (config, user, p2Store, dashboards, model) {
		var className = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'filters-panel', $author$project$Dashboards2$List$moduleClass);
		return A2(
			$elm$html$Html$map,
			config.a,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$GlobalWebIndex$class_namespaces$WeakCss$toClass(className)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'container', className)
							]),
						_List_fromArray(
							[
								A4($author$project$Dashboards2$List$categoryMenuView, className, p2Store, dashboards, model),
								A4($author$project$Dashboards2$List$datasetMenuView, className, p2Store, dashboards, model),
								A3($author$project$Dashboards2$List$dashboardTypeFilterMenuView, user, className, model),
								A2($author$project$Dashboards2$List$sortMenuView, className, model)
							]))
					])));
	});
var $author$project$Dashboards2$List$HighlightedProjectDropdown = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$List$findHighlightedDashboards = F2(
	function (user, dashboardsList) {
		var userDashboards = A2(
			$elm$core$List$filter,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.dG;
				},
				$elm$core$Basics$eq(user.b)),
			dashboardsList);
		var mostVisited = $elm$core$List$head(
			A2(
				$author$project$Gwi$List$reverseSortBy,
				function ($) {
					return $.i1;
				},
				A2(
					$elm$core$List$filter,
					function (dashboard) {
						return !(!dashboard.i1);
					},
					dashboardsList)));
		var lastUpdated = $elm$core$List$head(
			A2(
				$author$project$Gwi$List$reverseSortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bN;
					},
					$elm$time$Time$posixToMillis),
				userDashboards));
		var lastCreated = $elm$core$List$head(
			A2(
				$author$project$Gwi$List$reverseSortBy,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bB;
					},
					$elm$time$Time$posixToMillis),
				userDashboards));
		return {hf: mostVisited, h5: lastCreated, iB: lastUpdated};
	});
var $author$project$Dashboards2$List$highlightedDashboardsView = F7(
	function (config, flags, zone, p2Store, dashboardsList, model, _v0) {
		var itemInfoView = F3(
			function (name, icon, str) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['highlighted', 'item', name]),
							$author$project$Dashboards2$List$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							!$elm$core$String$isEmpty(str),
							A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['highlighted', 'item', name, 'icon']),
										$author$project$Dashboards2$List$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Icons$icon,
										_List_fromArray(
											[
												$author$project$Icons$width(24)
											]),
										icon)
									]))),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['highlighted', 'item', name, 'text']),
									$author$project$Dashboards2$List$moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(str)
								]))
						]));
			});
		var highlightedItemView = F3(
			function (index, label, dashboard) {
				var datasets = A2(
					$elm$core$List$filterMap,
					$author$project$Store$Utils$get(p2Store.es),
					dashboard.es);
				var canRenameOrDelete = A4($author$project$Dashboards2$Permissions$canRenameOrDelete, flags.mQ, flags.nM, dashboard.ah, dashboard.dG);
				var ddMenuOptions = A3($author$project$Dashboards2$List$getDropdownOptions, canRenameOrDelete, config, dashboard);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['highlighted', 'item-with-label']),
							$author$project$Dashboards2$List$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['highlighted', 'label']),
									$author$project$Dashboards2$List$moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(label)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['highlighted', 'item']),
									$author$project$Dashboards2$List$moduleClass),
									$elm$html$Html$Events$onClick(
									config.a(
										$author$project$Dashboards2$List$NavigateTo(
											$author$project$Dashboards2$Router$Dashboard(dashboard.b))))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['highlighted', 'item', 'top']),
											$author$project$Dashboards2$List$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['highlighted', 'item', 'top', 'names']),
													$author$project$Dashboards2$List$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['highlighted', 'item', 'top', 'names', 'data-set']),
															$author$project$Dashboards2$List$moduleClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(
															A2(
																$author$project$Dashboards2$List$dashboardTypeLabel,
																flags.mQ,
																A2($author$project$Dashboards2$List$dashboardsSharingToDashboardsTab, flags.mQ, dashboard.ah)))
														])),
													A2(
													$elm$html$Html$h3,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['highlighted', 'item', 'top', 'names', 'name']),
															$author$project$Dashboards2$List$moduleClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(dashboard.ld)
														]))
												])),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!model.K,
											A3(
												$author$project$Dashboards2$List$favouriteView,
												config,
												A2(
													$GlobalWebIndex$class_namespaces$WeakCss$addMany,
													_List_fromArray(
														['highlighted', 'item', 'top']),
													$author$project$Dashboards2$List$moduleClass),
												dashboard)),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!model.K,
											A2(
												$author$project$Platform2$Dropdown$viewWithOrientation,
												{
													fs: A2(
														$GlobalWebIndex$class_namespaces$WeakCss$addMany,
														_List_fromArray(
															['highlighted', 'item', 'top', 'dropdown']),
														$author$project$Dashboards2$List$moduleClass),
													pv: A2(
														$author$project$Dashboards2$List$isDropdownSelected,
														$author$project$Dashboards2$List$HighlightedProjectDropdown(index),
														model),
													h4: $elm_community$html_extra$Html$Extra$nothing,
													lr: ddMenuOptions,
													iF: $elm$core$List$length(ddMenuOptions) * 40,
													iG: 200,
													mD: A2(
														$elm$core$Basics$composeL,
														config.a,
														$author$project$Dashboards2$List$ToggleProjectDropdown(
															$author$project$Dashboards2$List$HighlightedProjectDropdown(index)))
												},
												A2(
													$author$project$Dashboards2$List$getDDMenuData,
													$author$project$Dashboards2$List$HighlightedProjectDropdown(index),
													model)))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['highlighted', 'item', 'bottom']),
											$author$project$Dashboards2$List$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!$elm$core$List$isEmpty(datasets),
											A3(
												itemInfoView,
												'project',
												$author$project$Icons$Platform2$dataSurvey,
												A2(
													$elm$core$String$join,
													', ',
													A2(
														$elm$core$List$map,
														function ($) {
															return $.ld;
														},
														datasets)))),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['highlighted', 'item', 'group']),
													$author$project$Dashboards2$List$moduleClass)
												]),
											_List_fromArray(
												[
													A3(
													itemInfoView,
													'categories',
													$author$project$Icons$Platform2$category,
													A2(
														$elm$core$String$join,
														', ',
														$author$project$Data$Platform2$getCategoryNames(dashboard.ac))),
													A3(
													itemInfoView,
													'created-at',
													$author$project$Icons$Platform2$calendar,
													function (date) {
														return 'Created ' + date;
													}(
														A3($ryannhg$date_format$DateFormat$format, $author$project$Time$Format$format_D_MMM_YYYY, zone, dashboard.bB)))
												]))
										]))
								]))
						]));
			});
		var highlightedDashboards = A2($author$project$Dashboards2$List$findHighlightedDashboards, flags.mQ, dashboardsList);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['highlighted', 'wrapper']),
					$author$project$Dashboards2$List$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'highlighted', $author$project$Dashboards2$List$moduleClass)
						]),
					A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, _v1) {
								var maybeDashboard = _v1.a;
								var label = _v1.b;
								return A2(
									$elm_community$html_extra$Html$Extra$viewMaybe,
									A2(highlightedItemView, i, label),
									maybeDashboard);
							}),
						_List_fromArray(
							[
								_Utils_Tuple2(highlightedDashboards.h5, 'Last created by me'),
								_Utils_Tuple2(highlightedDashboards.hf, 'Most visited by me'),
								_Utils_Tuple2(highlightedDashboards.iB, 'Last updated by me')
							])))
				]));
	});
var $author$project$Dashboards2$List$searchInputId = 'search-dashboard-input';
var $author$project$Dashboards2$List$GWIDashboards = 3;
var $author$project$Icons$Platform2$list = {
	mr: $author$project$Icons$Platform2$path('M10.519 20.51c.406 0 .735.334.735.745 0 .377-.276.689-.635.738l-.1.007h-.783C9.329 22 9 21.667 9 21.255c0-.377.277-.688.636-.737l.1-.007h.783zm11.745 0c.407 0 .736.334.736.745 0 .377-.277.689-.636.738l-.1.007h-9.396c-.406 0-.736-.333-.736-.745 0-.377.277-.688.636-.737l.1-.007h9.396zM10.52 15.756c.406 0 .735.334.735.745 0 .377-.276.688-.635.738l-.1.007h-.783c-.407 0-.736-.334-.736-.745 0-.377.277-.688.636-.738l.1-.007h.783zm11.745 0c.407 0 .736.334.736.745 0 .377-.277.688-.636.738l-.1.007h-9.396c-.406 0-.736-.334-.736-.745 0-.377.277-.688.636-.738l.1-.007h9.396zM10.52 11c.406 0 .735.333.735.745 0 .377-.276.688-.635.737l-.1.007h-.783c-.407 0-.736-.333-.736-.744 0-.377.277-.689.636-.738l.1-.007h.783zm11.745 0c.407 0 .736.333.736.745 0 .377-.277.688-.636.737l-.1.007h-9.396c-.406 0-.736-.333-.736-.744 0-.377.277-.689.636-.738l.1-.007h9.396z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$List$tabsView = F4(
	function (user, config, _v0, model) {
		var hasAnyMyOrgDashboards = _v0.ks;
		var tabView = F2(
			function (tab, icon) {
				return A2(
					$elm$html$Html$li,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'active',
									_Utils_eq(model.a9, tab))
								]),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['tabs', 'items', 'item']),
								$author$project$Dashboards2$List$moduleClass))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['tabs', 'items', 'item', 'link']),
									$author$project$Dashboards2$List$moduleClass),
									$elm$html$Html$Events$onClick(
									config.a(
										$author$project$Dashboards2$List$SelectTab(tab)))
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, icon),
									$elm$html$Html$text(
									function () {
										switch (tab) {
											case 0:
												return 'All';
											case 1:
												return A2($elm$core$Maybe$withDefault, 'My organisation', user.bL);
											case 2:
												return 'My dashboards';
											case 3:
												return 'GWI';
											default:
												return 'Favorites';
										}
									}())
								]))
						]));
			});
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'navigation-wrapper', $author$project$Dashboards2$List$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'navigation', $author$project$Dashboards2$List$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'tabs', $author$project$Dashboards2$List$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$ul,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['tabs', 'items']),
											$author$project$Dashboards2$List$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!model.K,
											A2(tabView, 0, $author$project$Icons$Platform2$list)),
											A2(
											$elm_community$html_extra$Html$Extra$viewIfLazy,
											hasAnyMyOrgDashboards,
											function (_v1) {
												return A2(tabView, 1, $author$project$Icons$Platform2$dashboards);
											}),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!model.K,
											A2(tabView, 2, $author$project$Icons$Platform2$dashboards)),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!model.K,
											A2(tabView, 3, $author$project$Icons$Platform2$globe)),
											A2(
											$elm_community$html_extra$Html$Extra$viewIf,
											!model.K,
											A2(tabView, 4, $author$project$Icons$Platform2$favourite))
										]))
								]))
						]))
				]));
	});
var $author$project$Platform2$SearchInput$Focus = function (a) {
	return {$: 1, a: a};
};
var $author$project$Platform2$SearchInput$UpdateSearchField = function (a) {
	return {$: 0, a: a};
};
var $elm$html$Html$Attributes$autocomplete = function (bool) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'autocomplete',
		bool ? 'on' : 'off');
};
var $author$project$Platform2$SearchInput$resetSearchField = $author$project$Platform2$SearchInput$UpdateSearchField('');
var $author$project$Platform2$SearchInput$view = F2(
	function (config, model) {
		var searchClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'search', config.js);
		var searchIcon = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'search-icon', searchClass)
				]),
			_List_fromArray(
				[
					A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$search)
				]));
		var isEmpty = !$elm$core$String$length(model.cW);
		var input = A2(
			$elm$html$Html$input,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'input', searchClass),
					$elm$html$Html$Attributes$placeholder(config.cO),
					$elm$html$Html$Attributes$value(model.cW),
					$elm$html$Html$Attributes$id(config.rb),
					$elm$html$Html$Attributes$autocomplete(false),
					$elm$html$Html$Events$onClick(
					config.a(
						$author$project$Platform2$SearchInput$Focus(config.rb))),
					$elm$html$Html$Events$onInput(
					A2($elm$core$Basics$composeL, config.a, $author$project$Platform2$SearchInput$UpdateSearchField))
				]),
			_List_Nil);
		var crossIcon = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'cross-icon', searchClass),
					$elm$html$Html$Events$onClick(
					config.a($author$project$Platform2$SearchInput$resetSearchField))
				]),
			_List_fromArray(
				[
					A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
				]));
		var searchContent = $elm$core$String$isEmpty(model.cW) ? _List_fromArray(
			[searchIcon, input]) : _List_fromArray(
			[searchIcon, input, crossIcon]);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2('is-nonempty', !isEmpty)
						]),
					searchClass)
				]),
			searchContent);
	});
var $author$project$Dashboards2$List$view = F6(
	function (flags, config, zone, p2Store, dashboardsDict, model) {
		var dashboards = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) ? A2(
			$elm$core$List$filter,
			function (d) {
				return A2($author$project$Data$Platform2$isSharedByMyOrganisation, flags.mQ, d.ah) || _Utils_eq(d.dG, flags.mQ.b);
			},
			$turboMaCk$any_dict$Dict$Any$values(dashboardsDict)) : $turboMaCk$any_dict$Dict$Any$values(dashboardsDict);
		var hasAnyMyOrgDashboards = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.ah;
				},
				$author$project$Data$Platform2$isSharedByMyOrganisation(flags.mQ)),
			dashboards);
		var isEmptyViewOnly = $author$project$Data$User$hasViewOnlyPlan(flags.mQ) && $elm$core$List$isEmpty(dashboards);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass($author$project$Dashboards2$List$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					flags.nM(23),
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'info-banner', $author$project$Dashboards2$List$moduleClass)
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$migrated),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['info-banner', 'text']),
										$author$project$Dashboards2$List$moduleClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Changes will not carry over to the old platform')
									]))
							]))),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					!isEmptyViewOnly,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', $author$project$Dashboards2$List$moduleClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header', 'inner']),
										$author$project$Dashboards2$List$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Platform2$SearchInput$view,
										{
											js: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'navigation', $author$project$Dashboards2$List$moduleClass),
											a: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$List$SearchInputMsg),
											cO: 'Search dashboards',
											rb: $author$project$Dashboards2$List$searchInputId
										},
										model.aR),
										A2(
										$elm_community$html_extra$Html$Extra$viewIfLazy,
										flags.nM(18),
										function (_v0) {
											return A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														config.a($author$project$Dashboards2$List$ToggleViewOnlyMode)),
														$elm$html$Html$Attributes$title('This is visible only for GWI users with FF debug_buttons')
													]),
												_List_fromArray(
													[
														model.K ? A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$checkboxFilled) : A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$checkboxUnfilled)
													]));
										}),
										A2(
										$elm$html$Html$h1,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['header', 'inner', 'title']),
												$author$project$Dashboards2$List$moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												$author$project$Dashboards2$List$dashboardTabHeader(model.a9))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$withStates,
												_List_fromArray(
													[
														_Utils_Tuple2(
														'hide',
														!$author$project$Permissions$isDashboardsCreator(flags.nM))
													]),
												A2(
													$GlobalWebIndex$class_namespaces$WeakCss$addMany,
													_List_fromArray(
														['create-btn', 'wrapper']),
													$author$project$Dashboards2$List$moduleClass))
											]),
										model.K ? _List_Nil : _List_fromArray(
											[
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														$elm$html$Html$Events$onClick(
														config.n9(4)),
														A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'create-btn', $author$project$Dashboards2$List$moduleClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text('Create a dashboard'),
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$plusSign)
													])),
												A2($author$project$Dashboards2$List$createDashboardOnboardingView, config, p2Store)
											]))
									]))
							]))),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					!isEmptyViewOnly,
					A4(
						$author$project$Dashboards2$List$tabsView,
						flags.mQ,
						config,
						{ks: hasAnyMyOrgDashboards},
						model)),
					A2(
					$elm_community$html_extra$Html$Extra$viewIfLazy,
					_Utils_eq(
						model.a9,
						$author$project$Dashboards2$List$defaultTab(model.K)) && (!model.K),
					A6($author$project$Dashboards2$List$highlightedDashboardsView, config, flags, zone, p2Store, dashboards, model)),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					!isEmptyViewOnly,
					A5($author$project$Dashboards2$List$filtersPanelView, config, flags.mQ, p2Store, dashboards, model)),
					A6($author$project$Dashboards2$List$dashboardsListView, config, flags, zone, p2Store, dashboards, model)
				]));
	});
var $author$project$Dashboards2$listView = F5(
	function (flags, config, zone, store, model) {
		var _v0 = store.v;
		switch (_v0.$) {
			case 0:
				return _List_fromArray(
					[$elm_community$html_extra$Html$Extra$nothing]);
			case 1:
				return _List_fromArray(
					[$author$project$Platform2$Spinner$view]);
			case 2:
				return _List_fromArray(
					[
						$elm$html$Html$text('Error loading dashboards')
					]);
			default:
				var dashboards = _v0.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'list-scroll-container', $author$project$Dashboards2$moduleClass)
							]),
						_List_fromArray(
							[
								A6($author$project$Dashboards2$List$view, flags, config.dy, zone, store, dashboards, model.cC)
							])),
						A2(
						$elm$html$Html$map,
						config.dy.a,
						A5($author$project$Dashboards2$List$selectionPanelView, flags.mQ, flags.nM, store, dashboards, model.cC))
					]);
		}
	});
var $author$project$Dashboards2$CloseMetadataView = {$: 45};
var $author$project$Dashboards2$metadataView = F2(
	function (config, model) {
		var questionMetadata = function (_v1) {
			var fullName = _v1.oR;
			var message = _v1.pP;
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$strong,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text(fullName)
							])),
						A2(
						$elm$html$Html$p,
						_List_Nil,
						_List_fromArray(
							[
								A2($elm_community$html_extra$Html$Extra$viewMaybe, $elm$html$Html$text, message)
							]))
					]));
		};
		var count = $elm$core$List$length(model.b4);
		var headerCopy = _Utils_ap(
			$elm$core$String$fromInt(count),
			A2($author$project$Plural$fromInt, count, ' question'));
		return A2(
			$elm_community$html_extra$Html$Extra$viewIfLazy,
			!$elm$core$List$isEmpty(model.b4),
			function (_v0) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'main-content', $author$project$Dashboards2$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['main-content', 'question-metadata']),
									$author$project$Dashboards2$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['main-content', 'question-metadata', 'heading']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['main-content', 'question-metadata', 'heading', 'title']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(headerCopy)
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['main-content', 'question-metadata', 'heading', 'close']),
													$author$project$Dashboards2$moduleClass),
													$elm$html$Html$Events$onClick(
													config.a($author$project$Dashboards2$CloseMetadataView))
												]),
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$crossLarge)
												]))
										])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['main-content', 'question-metadata', 'content']),
											$author$project$Dashboards2$moduleClass)
										]),
									A2($elm$core$List$map, questionMetadata, model.b4))
								]))
						]));
			});
	});
var $author$project$Dashboards2$AddAudiencesFromAudienceBrowser = {$: 46};
var $author$project$Dashboards2$AddDescriptionOnInput = function (a) {
	return {$: 80, a: a};
};
var $author$project$Dashboards2$ApplyDashboardDescription = function (a) {
	return {$: 98, a: a};
};
var $author$project$Dashboards2$ApplyInsightLink = function (a) {
	return {$: 97, a: a};
};
var $author$project$Platform2$GroupingPanel$AudienceDefault = 2;
var $author$project$Platform2$GroupingPanel$AudienceMy = 1;
var $author$project$Platform2$GroupingPanel$Bold = 1;
var $author$project$Platform2$RadioButton$Checked = 0;
var $author$project$Dashboards2$ClearAllAudiencesInAB = {$: 43};
var $author$project$Dashboards2$CloseModalAndRedirectIfNeeded = {$: 39};
var $author$project$Dashboards2$ConfirmSaveDashboardAsCopy = function (a) {
	return {$: 9, a: a};
};
var $author$project$Dashboards2$DeleteDashboards = function (a) {
	return {$: 52, a: a};
};
var $author$project$Dashboards2$DeleteWidget = F2(
	function (a, b) {
		return {$: 55, a: a, b: b};
	});
var $author$project$Dashboards2$EditWidgetDescriptionOnInput = function (a) {
	return {$: 83, a: a};
};
var $author$project$Dashboards2$EditWidgetNameOnInput = function (a) {
	return {$: 82, a: a};
};
var $author$project$CoolTip$Global = {$: 2};
var $author$project$Dashboards2$InsightModalRemoveLink = {$: 96};
var $author$project$Dashboards2$Modal$Large = 4;
var $author$project$Dashboards2$Modal$Medium = 1;
var $author$project$Dashboards2$Modal$MediumFlexible = 2;
var $author$project$Dashboards2$Modal$MediumFlexibleHeight = 3;
var $author$project$Dashboards2$OnInputInsightModal = function (a) {
	return {$: 95, a: a};
};
var $author$project$Platform2$GroupingPanel$Plain = 0;
var $author$project$Dashboards2$RenameDashboard = F2(
	function (a, b) {
		return {$: 63, a: a, b: b};
	});
var $author$project$Dashboards2$SelectWidgetChartTypeInHelpMeChooseModal = function (a) {
	return {$: 33, a: a};
};
var $author$project$Dashboards2$SelectWidgetMetricInHelpMeChooseModal = function (a) {
	return {$: 34, a: a};
};
var $author$project$Dashboards2$SetDashboardNameForSaving = function (a) {
	return {$: 62, a: a};
};
var $author$project$Dashboards2$SetDecodingErrorInAB = function (a) {
	return {$: 42, a: a};
};
var $author$project$Dashboards2$SetRenameInput = function (a) {
	return {$: 64, a: a};
};
var $author$project$Dashboards2$SetWidgetChartType = F2(
	function (a, b) {
		return {$: 35, a: a, b: b};
	});
var $author$project$Dashboards2$SetWidgetMetric = F2(
	function (a, b) {
		return {$: 36, a: a, b: b};
	});
var $author$project$Dashboards2$ShowDisabledWarningInAB = {$: 41};
var $author$project$Dashboards2$Modal$Small = 0;
var $author$project$Platform2$Grouping$Split = 0;
var $author$project$Dashboards2$ToggleAudienceInAB = function (a) {
	return {$: 40, a: a};
};
var $author$project$Dashboards2$ToggleDoNotShowAgainInModal = {$: 68};
var $author$project$Platform2$RadioButton$Unchecked = 1;
var $author$project$Dashboards2$attributesCountFromWidgetData = F2(
	function (questions, data) {
		var countFromGroupedData = A2(
			$turboMaCk$non_empty_list_alias$List$NonEmpty$foldr,
			F2(
				function (group, acc) {
					var _v1 = A2($turboMaCk$any_dict$Dict$Any$get, group.at, questions);
					if (!_v1.$) {
						var question = _v1.a;
						return acc + $turboMaCk$non_empty_list_alias$List$NonEmpty$length(
							A2($author$project$Data$Platform2$groupedWidgetDataToExplicitWidgetData, question, group).er);
					} else {
						return acc;
					}
				}),
			0);
		if (!data.$) {
			var oldData = data.a;
			return A3(
				$elm_community$maybe_extra$Maybe$Extra$unwrap,
				0,
				countFromGroupedData,
				A2($author$project$Data$Platform2$oldWidgetDataToGroupedWidgetData, questions, oldData));
		} else {
			var groups = data.a;
			return countFromGroupedData(groups);
		}
	});
var $author$project$Icons$Platform2$audiences = {
	mr: $author$project$Icons$Platform2$path('M14.745 17.62a3.7 3.7 0 0 1 3.698 3.698.65.65 0 0 1-1.3 0c0-1.27-.986-2.308-2.234-2.392l-.164-.006h-3.047A2.4 2.4 0 0 0 9.3 21.317a.65.65 0 1 1-1.3 0 3.7 3.7 0 0 1 3.501-3.693l.197-.005h3.047zm6.857-.762c1.622 0 2.936 1.314 2.936 2.936a.65.65 0 0 1-1.3 0c0-.856-.657-1.558-1.494-1.63l-.142-.006h-2.285a.65.65 0 0 1-.096-1.293l.096-.007h2.285zM13.222 10c1.83 0 3.316 1.484 3.316 3.317s-1.485 3.316-3.317 3.316-3.316-1.485-3.316-3.316S11.39 10 13.22 10zm7.238.762c1.4 0 2.554 1.144 2.554 2.555S21.87 15.87 20.46 15.87s-2.555-1.143-2.555-2.554 1.143-2.555 2.555-2.555zm-7.24.538c-1.114 0-2.016.902-2.016 2.017s.903 2.016 2.016 2.016 2.017-.903 2.017-2.016-.903-2.017-2.017-2.017zm7.24.762c-.694 0-1.255.56-1.255 1.255s.56 1.254 1.255 1.254 1.254-.56 1.254-1.254-.562-1.255-1.254-1.255z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$CoolTip$Center = 8;
var $author$project$D3Charts$Dashboards$ChartType$p2Class = function (chartType) {
	switch (chartType) {
		case 0:
			return 'data-table';
		case 1:
			return 'diverging-bar-chart';
		case 2:
			return 'donut-chart';
		case 3:
			return 'horizontal-bar-chart';
		case 4:
			return 'line-chart';
		case 5:
			return 'pie-chart';
		case 6:
			return 'pie-radar-chart';
		case 7:
			return 'radar-chart';
		case 8:
			return 'radial-bar-chart';
		case 9:
			return 'stat-card';
		case 10:
			return 'stat-card-colored';
		default:
			return 'vertical-bar-chart';
	}
};
var $author$project$D3Charts$Dashboards$ChartType$p2Description = function (chartType) {
	switch (chartType) {
		case 0:
			return 'A data table chart is a means of arranging data in rows and columns';
		case 1:
			return 'A diverging bar chart is used to compare attributes from a vertical baseline';
		case 2:
			return 'A donut chart is a kind of pie chart where the center has been removed';
		case 3:
			return 'A horizontal bar chart is used to compare data across different categories';
		case 4:
			return 'A line chart displays information as a series of data points';
		case 5:
			return 'A pie chart is divided into sectors, illustrating numerical proportion';
		case 6:
			return 'A pie radar chart is where sectors are equal angles and differ';
		case 7:
			return 'A radar chart displays multivariate data two-dimensionally, on axes';
		case 8:
			return 'A radial chart is used to show comparisons on a polar coordinate system';
		case 9:
			return 'A stat card is best for displaying a key raw value';
		case 10:
			return 'A stat card is best for displaying a key raw value';
		default:
			return 'A vertical bar chart is used to compare data across different categories';
	}
};
var $author$project$Dashboards2$chartTypeView = F3(
	function (config, _v0, type_) {
		var className = _v0.hi;
		var attributesCount = _v0.g9;
		var selectedChartType = _v0.l6;
		var onClick = _v0.cL;
		var isDisabled = !A2($author$project$D3Charts$Dashboards$ChartType$isValidNumberOfDatapoints, type_, attributesCount);
		var isSelected = function () {
			if (!selectedChartType.$) {
				var selectedType = selectedChartType.a;
				return _Utils_eq(type_, selectedType) && (!isDisabled);
			} else {
				return false;
			}
		}();
		var onClickMsg = isDisabled ? config.y : onClick(type_);
		var states = _List_fromArray(
			[
				_Utils_Tuple2(
				$author$project$D3Charts$Dashboards$ChartType$p2Class(type_),
				true),
				_Utils_Tuple2('selected', isSelected),
				_Utils_Tuple2('disabled', isDisabled)
			]);
		var chartClass = A2(
			$GlobalWebIndex$class_namespaces$WeakCss$addMany,
			_List_fromArray(
				['add-chart', 'chart']),
			className);
		var addTooltip = F2(
			function (tooltipText, content) {
				return A2($author$project$D3Charts$Dashboards$ChartType$isValidNumberOfDatapoints, type_, attributesCount) ? content : $author$project$CoolTip$Platform2$view(
					{
						lm: $elm$core$Maybe$Nothing,
						lB: 8,
						mt: _List_Nil,
						mu: _List_fromArray(
							[content]),
						mE: _List_Nil,
						mF: $elm$html$Html$text(tooltipText),
						mL: $author$project$CoolTip$Normal,
						m2: _List_Nil
					});
			});
		var withTooltip = function (content) {
			var _v1 = $author$project$D3Charts$Dashboards$ChartType$datapointCountRequirement(type_);
			switch (_v1) {
				case 0:
					return A2(addTooltip, 'This chart type only supports 1 attribute', content);
				case 1:
					return A2(addTooltip, 'This chart type requires 3+ attributes', content);
				default:
					return content;
			}
		};
		return withTooltip(
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$withStates, states, chartClass),
						$elm$html$Html$Events$onClick(onClickMsg)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'image', chartClass)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'title', chartClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$D3Charts$Dashboards$ChartType$p2Label(type_))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'description', chartClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(
								$author$project$D3Charts$Dashboards$ChartType$p2Description(type_))
							]))
					])));
	});
var $author$project$Platform2$Input$Text$Attribute = $elm$core$Basics$identity;
var $author$project$Platform2$Input$Text$class = function (class_) {
	return function (config) {
		return _Utils_update(
			config,
			{fs: class_});
	};
};
var $author$project$Platform2$AudienceBrowser$compatibleNamespaces = F3(
	function (usedDatasets, datasets, lineages) {
		return A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$andThen,
				function (namespaceCode) {
					return A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							$krisajenkins$remotedata$RemoteData$toMaybe,
							$elm$core$Maybe$map(
								$author$project$Data$Labels$mergeLineage(namespaceCode))),
						A2($turboMaCk$any_dict$Dict$Any$get, namespaceCode, lineages));
				},
				A2($author$project$Data$Platform2$deepestDatasetNamespaceCode, usedDatasets, datasets)));
	});
var $elm$html$Html$form = _VirtualDom_node('form');
var $elm$html$Html$main_ = _VirtualDom_node('main');
var $elm$html$Html$Events$onMouseDown = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'mousedown',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Dashboards2$modalSkeletonView = F4(
	function (config, maybeCrossClose, modalSize, content) {
		var closeCrossView = A2(
			$elm_community$html_extra$Html$Extra$viewMaybe,
			function (close) {
				return A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['modal', 'cross-close']),
							$author$project$Dashboards2$moduleClass),
							$elm$html$Html$Events$onClick(
							config.a(close))
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
						]));
			},
			maybeCrossClose);
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						[
							function () {
							switch (modalSize) {
								case 0:
									return 'small';
								case 3:
									return 'medium-flexible-height';
								case 2:
									return 'medium-flexible';
								case 1:
									return 'medium';
								default:
									return 'large';
							}
						}()
						]),
					A2(
						$GlobalWebIndex$class_namespaces$WeakCss$addMany,
						_List_fromArray(
							['modal', 'overlay']),
						$author$project$Dashboards2$moduleClass)),
					$elm$html$Html$Events$onMouseDown(
					config.a($author$project$Dashboards2$CloseModal))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['modal', 'container']),
							$author$project$Dashboards2$moduleClass),
							A2(
							$elm$html$Html$Events$stopPropagationOn,
							'mousedown',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2(config.y, true)))
						]),
					_Utils_ap(
						content,
						_List_fromArray(
							[closeCrossView])))
				]));
	});
var $elm_community$html_extra$Html$Events$Extra$onClickPreventDefault = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'click',
		$elm$json$Json$Decode$succeed(
			_Utils_Tuple2(msg, true)));
};
var $author$project$Dashboards2$shareScrollContainerId = 'd2-sharing-scroll-container-id';
var $author$project$Dashboards2$genericModalView = F2(
	function (config, data) {
		return A4(
			$author$project$Dashboards2$modalSkeletonView,
			config,
			$elm$core$Maybe$Nothing,
			data.cG,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							data.cF,
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['generic-modal', 'header']),
								$author$project$Dashboards2$moduleClass))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['generic-modal', 'headline']),
									$author$project$Dashboards2$moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(data.cu)
								]))
						])),
					A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							data.ch,
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['generic-modal', 'content']),
								$author$project$Dashboards2$moduleClass)),
							$elm$html$Html$Attributes$id($author$project$Dashboards2$shareScrollContainerId)
						]),
					_List_fromArray(
						[data.U])),
					A2(
					$elm$html$Html$footer,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['generic-modal', 'footer']),
							$author$project$Dashboards2$moduleClass)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(
									config.a($author$project$Dashboards2$CloseModal)),
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['generic-modal', 'action-link']),
									$author$project$Dashboards2$moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
						data.aH))
				]));
	});
var $author$project$Dashboards2$genericModalWithContentAfterFooterView = F2(
	function (config, data) {
		return A4(
			$author$project$Dashboards2$modalSkeletonView,
			config,
			$elm$core$Maybe$Nothing,
			data.cG,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							data.cF,
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['generic-modal', 'header']),
								$author$project$Dashboards2$moduleClass))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$h2,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['generic-modal', 'headline']),
									$author$project$Dashboards2$moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(data.cu)
								]))
						])),
					A2(
					$elm$html$Html$main_,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							data.ch,
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['generic-modal', 'content']),
								$author$project$Dashboards2$moduleClass)),
							$elm$html$Html$Attributes$id($author$project$Dashboards2$shareScrollContainerId)
						]),
					_List_fromArray(
						[data.U])),
					A2(
					$elm$html$Html$footer,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['generic-modal', 'footer']),
							$author$project$Dashboards2$moduleClass)
						]),
					A2(
						$elm$core$List$cons,
						A2(
							$elm$html$Html$button,
							_List_fromArray(
								[
									$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(
									config.a($author$project$Dashboards2$CloseModal)),
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['generic-modal', 'action-link']),
									$author$project$Dashboards2$moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('Cancel')
								])),
						data.aH)),
					A2(
					$elm$html$Html$div,
					_List_Nil,
					_List_fromArray(
						[data.jb]))
				]));
	});
var $author$project$Icons$Platform2$groupingPanelPlaceholderDashboards = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(-20.388,-26.041)'),
				$elm$svg$Svg$Attributes$fillRule('evenodd')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m26.265 32.384c3.637 0 6.586 2.949 6.586 6.586 0 0.64-0.518 1.158-1.157 1.158-0.64 0-1.158-0.518-1.158-1.158 0-2.26-1.757-4.11-3.979-4.26l-0.292-0.01h-5.429c-2.358 0-4.27 1.912-4.27 4.27 0 0.64-0.519 1.158-1.158 1.158-0.64 0-1.158-0.518-1.158-1.158 0-3.52 2.762-6.395 6.237-6.577l0.35-0.01h5.428zm12.214-1.357c2.888 0 5.23 2.34 5.23 5.229 0 0.64-0.519 1.158-1.158 1.158-0.64 0-1.158-0.519-1.158-1.158 0-1.525-1.17-2.775-2.662-2.903l-0.252-0.01h-4.071c-0.64 0-1.158-0.519-1.158-1.158 0-0.582 0.428-1.063 0.987-1.146l0.17-0.012zm-14.928-12.215c3.263 0 5.907 2.645 5.907 5.908s-2.645 5.908-5.907 5.908c-3.263 0-5.908-2.645-5.908-5.908s2.644-5.907 5.908-5.907zm12.893 1.358c2.512 0 4.55 2.037 4.55 4.55 0 2.514-2.038 4.551-4.55 4.551-2.514 0-4.551-2.037-4.551-4.55 0-2.514 2.037-4.551 4.55-4.551zm-12.893 0.958c-1.985 0-3.593 1.608-3.593 3.592s1.609 3.593 3.593 3.593 3.592-1.609 3.592-3.593-1.608-3.592-3.592-3.592zm12.893 1.357c-1.235 0-2.236 1-2.236 2.235s1 2.235 2.236 2.235c1.233 0 2.235-1 2.235-2.235 0-1.234-1.002-2.235-2.235-2.235z'),
						$elm$svg$Svg$Attributes$fill('#DE1B76'),
						$elm$svg$Svg$Attributes$transform('rotate(12,-276.72,100.06)')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m25.458 33.482c1.906 0 3.453 1.547 3.453 3.453v0.58c0 1.907-1.547 3.454-3.453 3.454h-3.192c-1.907 0-3.453-1.547-3.453-3.453v-0.58c0-1.907 1.546-3.454 3.453-3.454zm13.058-5.223c1.906 0 3.453 1.547 3.453 3.453v5.804c0 1.906-1.547 3.453-3.453 3.453h-3.192c-1.907 0-3.453-1.547-3.453-3.453v-5.804c0-1.906 1.546-3.453 3.453-3.453zm-13.058 7.487h-3.192c-0.657 0-1.19 0.533-1.19 1.19v0.58c0 0.656 0.533 1.19 1.19 1.19h3.192c0.656 0 1.19-0.534 1.19-1.19v-0.58c0-0.657-0.534-1.19-1.19-1.19zm13.058-5.224h-3.192c-0.657 0-1.19 0.534-1.19 1.19v5.804c0 0.656 0.533 1.19 1.19 1.19h3.192c0.656 0 1.19-0.534 1.19-1.19v-5.804c0-0.656-0.534-1.19-1.19-1.19zm-13.058-12.71c1.906 0 3.453 1.547 3.453 3.454v5.803c0 1.907-1.547 3.453-3.453 3.453h-3.192c-1.907 0-3.453-1.546-3.453-3.453v-5.803c0-1.907 1.546-3.453 3.453-3.453h3.192zm0 2.264h-3.192c-0.657 0-1.19 0.533-1.19 1.19v5.803c0 0.657 0.533 1.19 1.19 1.19h3.192c0.656 0 1.19-0.533 1.19-1.19v-5.803c0-0.657-0.534-1.19-1.19-1.19zm13.058-2.264c1.906 0 3.453 1.547 3.453 3.454v0.58c0 1.906-1.547 3.453-3.453 3.453h-3.192c-1.907 0-3.453-1.547-3.453-3.453v-0.58c0-1.907 1.546-3.453 3.453-3.453h3.192zm0 2.264h-3.192c-0.657 0-1.19 0.533-1.19 1.19v0.58c0 0.656 0.533 1.19 1.19 1.19h3.192c0.656 0 1.19-0.534 1.19-1.19v-0.58c0-0.657-0.534-1.19-1.19-1.19z'),
						$elm$svg$Svg$Attributes$fill('#F690C4'),
						$elm$svg$Svg$Attributes$transform('rotate(-29,126.4,-35.134)')
					]),
				_List_Nil),
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$d('m20.881 40.544c-0.59 0-1.069-0.479-1.069-1.069v-9.5c0-0.59 0.479-1.069 1.07-1.069h5.264v-10.806c0-0.59 0.48-1.069 1.07-1.069h6.332c0.59 0 1.07 0.479 1.07 1.069l-2e-3 4.868h5.265c0.59 0 1.069 0.48 1.069 1.07v15.437c0 0.59-0.478 1.069-1.069 1.069zm11.599-21.375h-4.196v19.237h4.196v-19.236zm6.333 5.937h-4.196v13.3h4.196zm-12.668 5.938h-4.195v7.362h4.195z'),
						$elm$svg$Svg$Attributes$fill('#A40F58'),
						$elm$svg$Svg$Attributes$transform('rotate(115,30.996,37.548)')
					]),
				_List_Nil)
			])),
	e5: 80,
	mT: 0,
	mU: 0,
	e6: 68
};
var $author$project$Platform2$Modal$showTabs = F2(
	function (_class, headerTabs) {
		return A2(
			$elm$html$Html$ul,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['header-with-tabs', 'tabs']),
					_class)
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var title = _v0.Y;
					var active = _v0.fd;
					var icon = _v0.dq;
					var onClick = _v0.cL;
					return A2(
						$elm$html$Html$li,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('active', active),
										_Utils_Tuple2(
										'clickable',
										!_Utils_eq(onClick, $elm$core$Maybe$Nothing))
									]),
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['header-with-tabs', 'tabs', 'tab']),
									_class)),
								A2($elm_community$html_extra$Html$Attributes$Extra$attributeMaybe, $elm$html$Html$Events$onClick, onClick)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$i,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['header-with-tabs', 'tabs', 'tab', 'icon']),
										_class)
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, icon)
									])),
								$elm$html$Html$text(title)
							]));
				},
				headerTabs));
	});
var $author$project$Platform2$Modal$headerWithTabsView = F3(
	function (closeModal, _class, headerTabs) {
		return A2(
			$elm$html$Html$header,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['header-with-tabs']),
					_class)
				]),
			_List_fromArray(
				[
					A2($author$project$Platform2$Modal$showTabs, _class, headerTabs),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(closeModal),
							$elm$html$Html$Attributes$type_('button'),
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['header-with-tabs', 'close']),
							_class)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Icons$icon,
							_List_fromArray(
								[
									$author$project$Icons$width(32)
								]),
							$author$project$Icons$Platform2$cross)
						]))
				]));
	});
var $author$project$Platform2$Input$Text$id = function (id_) {
	return function (config) {
		return _Utils_update(
			config,
			{b: id_});
	};
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $krisajenkins$remotedata$RemoteData$isFailure = function (data) {
	if (data.$ === 2) {
		var x = data.a;
		return true;
	} else {
		return false;
	}
};
var $author$project$Platform2$Input$Text$limit = function (limit_) {
	return function (config) {
		return _Utils_update(
			config,
			{
				f6: $elm$core$Maybe$Just(limit_)
			});
	};
};
var $author$project$Platform2$Input$Text$onEnter = function (onEnter_) {
	return function (config) {
		return _Utils_update(
			config,
			{
				gm: $elm$core$Maybe$Just(onEnter_)
			});
	};
};
var $elm$html$Html$Events$alwaysPreventDefault = function (msg) {
	return _Utils_Tuple2(msg, true);
};
var $elm$html$Html$Events$onSubmit = function (msg) {
	return A2(
		$elm$html$Html$Events$preventDefaultOn,
		'submit',
		A2(
			$elm$json$Json$Decode$map,
			$elm$html$Html$Events$alwaysPreventDefault,
			$elm$json$Json$Decode$succeed(msg)));
};
var $author$project$Dashboards2$remoteDataView = F2(
	function (fn, webData) {
		switch (webData.$) {
			case 0:
				return _List_Nil;
			case 1:
				return _List_fromArray(
					[$author$project$Platform2$Spinner$view]);
			case 2:
				var err = webData.a;
				return _List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'error', $author$project$Dashboards2$moduleClass)
							]),
						_List_fromArray(
							[
								A2(
								$elm_explorations$markdown$Markdown$toHtml,
								_List_Nil,
								$author$project$Gwi$String$fromHttpError(err))
							]))
					]);
			default:
				var data = webData.a;
				return fn(data);
		}
	});
var $author$project$Dashboards2$CloseAudienceModalWarning = {$: 44};
var $author$project$Data$Platform2$encodeAudienceFolderFlag = function (flag) {
	return $elm$json$Json$Encode$string(
		$author$project$Data$Platform2$audienceFolderFlagToString(flag));
};
var $author$project$Data$Platform2$encodeAudienceFolder = function (folder) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$author$project$Data$Id$encode(folder.b)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(folder.ld)),
				_Utils_Tuple2(
				'position',
				$elm$json$Json$Encode$int(folder.lB)),
				_Utils_Tuple2(
				'flags',
				A2(
					$elm$json$Json$Encode$list,
					$author$project$Data$Platform2$encodeAudienceFolderFlag,
					$turboMaCk$any_set$Set$Any$toList(folder.oN))),
				_Utils_Tuple2(
				'created_at',
				$elm$json$Json$Encode$string(
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(folder.bB))),
				_Utils_Tuple2(
				'updated_at',
				$elm$json$Json$Encode$string(
					$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(folder.bN)))
			]));
};
var $author$project$Platform2$AudienceBrowser$view = F3(
	function (flags, config, audienceFolders) {
		var userEncoded = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string(flags.i$)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(flags.mQ.j)),
					_Utils_Tuple2(
					'customer_features',
					A2($turboMaCk$any_set$Set$Any$encode, $author$project$Data$User$encodeFeature, flags.mQ.jT))
				]));
		var uri = $author$project$Config$Main$get(flags.j8).dV;
		var toggleDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['detail', 'payload']),
			$author$project$Data$Platform2$audienceDecoder);
		var event = function (eventName) {
			return config.be + ('-' + eventName);
		};
		var encodedStagedAudiences = A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.b;
					},
					$author$project$Data$Id$encode),
				config.aS));
		var encodedSelectedAudiences = A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.b;
					},
					$author$project$Data$Id$encode),
				config.it));
		var encodedModalType = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$string(
				config.dt ? 'base' : 'regular'));
		var encodedHideMyAudiencesTab = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$bool(config.hV));
		var encodedFolders = A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				$author$project$Data$Platform2$encodeAudienceFolder,
				$turboMaCk$any_dict$Dict$Any$values(audienceFolders)));
		var encodedCompatibleNamespaces = A2(
			$elm$json$Json$Encode$encode,
			0,
			A2($elm$json$Json$Encode$list, $author$project$Data$Id$encode, config.hj));
		var encodedAllDatasets = A2(
			$elm$json$Json$Encode$encode,
			0,
			A2(
				$elm$json$Json$Encode$list,
				function (dataset) {
					return A2(
						$elm$json$Json$Encode$list,
						$elm$core$Basics$identity,
						_List_fromArray(
							[
								$author$project$Data$Id$encode(dataset.bW),
								$author$project$Data$Platform2$encodeDatasetForWebcomponent(dataset)
							]));
				},
				config.fg));
		var editDecoder = A2(
			$elm$json$Json$Decode$at,
			_List_fromArray(
				['detail', 'audienceId']),
			$author$project$Data$Id$decode);
		var apiEncoded = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'AUDIENCES_CORE_HOST',
					$elm$json$Json$Encode$string(uri.ea)),
					_Utils_Tuple2(
					'SERVICE_LAYER_HOST',
					$elm$json$Json$Encode$string(uri.eS)),
					_Utils_Tuple2(
					'ANALYTICS_HOST',
					$elm$json$Json$Encode$string(uri.d3)),
					_Utils_Tuple2(
					'COLLECTIONS_HOST',
					$elm$json$Json$Encode$string(uri.ei + '/'))
				]));
		var encodedConfig = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'appName',
						$elm$json$Json$Encode$string(config.be)),
						_Utils_Tuple2(
						'environment',
						$elm$json$Json$Encode$string(
							$author$project$Config$Main$stageToString(flags.j8))),
						_Utils_Tuple2('api', apiEncoded),
						_Utils_Tuple2('user', userEncoded)
					])));
		return A3(
			$elm$html$Html$node,
			'x-et-audience-browser',
			_List_fromArray(
				[
					A2($elm$html$Html$Attributes$attribute, 'x-env-values', encodedConfig),
					A2($elm$html$Html$Attributes$attribute, 'modal-type', encodedModalType),
					A2($elm$html$Html$Attributes$attribute, 'staged-audiences', encodedStagedAudiences),
					A2($elm$html$Html$Attributes$attribute, 'selected-audiences', encodedSelectedAudiences),
					A2($elm$html$Html$Attributes$attribute, 'folders', encodedFolders),
					A2($elm$html$Html$Attributes$attribute, 'all-datasets', encodedAllDatasets),
					A2($elm$html$Html$Attributes$attribute, 'compatible-namespaces', encodedCompatibleNamespaces),
					A2($elm$html$Html$Attributes$attribute, 'hide-my-audiences-tab', encodedHideMyAudiencesTab),
					A2(
					$elm$html$Html$Events$on,
					event('audienceBrowserLeftAudienceBuilderEditClicked'),
					A2(
						$elm$json$Json$Decode$map,
						function (event_) {
							var _v0 = A2($elm$json$Json$Decode$decodeValue, editDecoder, event_);
							if (!_v0.$) {
								var decodedAudienceId = _v0.a;
								return config.fM(decodedAudienceId);
							} else {
								var err = _v0.a;
								return config.iJ(
									$elm$json$Json$Decode$errorToString(err));
							}
						},
						$elm$json$Json$Decode$value)),
					A2(
					$elm$html$Html$Events$on,
					event('audienceBrowserLeftToggledEvent'),
					A2(
						$elm$json$Json$Decode$map,
						function (event_) {
							var _v1 = A2($elm$json$Json$Decode$decodeValue, toggleDecoder, event_);
							if (!_v1.$) {
								var decodedAudience = _v1.a;
								return config.i_(decodedAudience);
							} else {
								var err = _v1.a;
								return config.iJ(
									$elm$json$Json$Decode$errorToString(err));
							}
						},
						$elm$json$Json$Decode$value)),
					A2(
					$elm$html$Html$Events$on,
					event('audienceBrowserLeftDisabledAudienceClicked'),
					$elm$json$Json$Decode$succeed(config.iN)),
					A2(
					$elm$html$Html$Events$on,
					event('audienceBrowserLeftAudienceBuilderCreateClicked'),
					$elm$json$Json$Decode$succeed(config.hq))
				]),
			_List_Nil);
	});
var $author$project$Platform2$AudienceBrowser$clickedDisabledAudienceText = function (entity) {
	return $elm$html$Html$text('Audience is not compatible with the data\u00A0set you have already selected in your ' + entity);
};
var $author$project$Dashboards2$warningToString = function (warning) {
	if (!warning) {
		return $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Just(
			$author$project$Platform2$AudienceBrowser$clickedDisabledAudienceText('dashboard'));
	}
};
var $author$project$Dashboards2$replaceAudienceModalView = F4(
	function (config, flags, store, _v0) {
		var audienceBrowserConfig = _v0.ha;
		var confirmBtnTitle = _v0.hm;
		var confirmBtnDisabled = _v0.hl;
		var decodingError = _v0.Z;
		var warning = _v0.L;
		var confirm = _v0.hk;
		var cls = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'replace-audience-modal', $author$project$Dashboards2$moduleClass);
		var warningView = function (warningContent) {
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['content', 'top-part', 'warning-cont']),
						cls)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['content', 'top-part', 'warning']),
								cls)
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$span,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['content', 'top-part', 'warning', 'icon']),
										cls)
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$warningTriangleIcon)
									])),
								warningContent,
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['content', 'top-part', 'warning', 'close']),
										cls),
										$elm$html$Html$Events$onClick(
										config.a($author$project$Dashboards2$CloseAudienceModalWarning))
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
									]))
							]))
					]));
		};
		var browserView = function (folders) {
			return A3($author$project$Platform2$AudienceBrowser$view, flags, audienceBrowserConfig, folders);
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						['large-capped']),
					A2(
						$GlobalWebIndex$class_namespaces$WeakCss$addMany,
						_List_fromArray(
							['modal', 'overlay']),
						$author$project$Dashboards2$moduleClass)),
					$elm$html$Html$Events$onMouseDown(
					config.a($author$project$Dashboards2$CloseModal))
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['modal', 'container']),
							$author$project$Dashboards2$moduleClass),
							A2(
							$elm$html$Html$Events$stopPropagationOn,
							'mousedown',
							$elm$json$Json$Decode$succeed(
								_Utils_Tuple2(config.y, true)))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Platform2$Modal$headerWithTabsView,
							config.a($author$project$Dashboards2$CloseModal),
							cls,
							_List_fromArray(
								[
									{fd: true, dq: $author$project$Icons$Platform2$audiences, cL: $elm$core$Maybe$Nothing, Y: 'Audiences'}
								])),
							A2(
							$elm$html$Html$main_,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', cls)
								]),
							A2(
								$author$project$Dashboards2$remoteDataView,
								function (folders) {
									return _List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['content', 'top-part']),
													cls)
												]),
											_List_fromArray(
												[
													browserView(folders),
													A2(
													$elm_community$html_extra$Html$Extra$viewMaybe,
													warningView,
													$author$project$Dashboards2$warningToString(warning))
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['content', 'bottom-part']),
													cls)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['content', 'bottom-part', 'button']),
															cls),
															$elm$html$Html$Events$onClick(confirm),
															$elm$html$Html$Attributes$disabled(confirmBtnDisabled)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(confirmBtnTitle)
														]))
												])),
											A2(
											$elm_community$html_extra$Html$Extra$viewMaybe,
											function (err) {
												return A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['content', 'error-view']),
															cls)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(err)
														]));
											},
											decodingError)
										]);
								},
								store.jm))
						]))
				]));
	});
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $author$project$Platform2$Input$Text$value = function (value_) {
	return function (config) {
		return _Utils_update(
			config,
			{c5: value_});
	};
};
var $author$project$Dashboards2$ChartBrowser$ChangeCurrentTab = function (a) {
	return {$: 10, a: a};
};
var $author$project$Platform2$GroupingPanel$Chart = 4;
var $author$project$Dashboards2$ChartBrowser$ChartRow = function (a) {
	return {$: 1, a: a};
};
var $author$project$Dashboards2$ChartBrowser$ClearAll = {$: 1};
var $author$project$Dashboards2$ChartBrowser$ClearSearch = {$: 8};
var $author$project$Dashboards2$ChartBrowser$CreateWidgets = function (a) {
	return {$: 9, a: a};
};
var $author$project$Platform2$SortingHeader$Desc = 1;
var $author$project$Dashboards2$ChartBrowser$FolderRow = {$: 0};
var $author$project$Dashboards2$ChartBrowser$GoToChartBuilder = {$: 11};
var $author$project$Dashboards2$ChartBrowser$NoOp = {$: 0};
var $author$project$Dashboards2$ChartBrowser$OpenChartFolder = function (a) {
	return {$: 4, a: a};
};
var $author$project$Dashboards2$ChartBrowser$SelectedChart = function (a) {
	return {$: 0, a: a};
};
var $author$project$Dashboards2$ChartBrowser$Shared = 1;
var $author$project$Dashboards2$ChartBrowser$ToggleSelection = function (a) {
	return {$: 5, a: a};
};
var $author$project$Icons$Platform2$emptyChartsSearchReuslts = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, '#7BCCF1', 'M26.5999 38.4C39.7199 38.4 45.7999 32.32 45.7999 19.2C45.7999 6.08 39.7199 0 26.5999 0C13.4799 0 7.3999 6.08 7.3999 19.2C7.3999 32.32 13.4799 38.4 26.5999 38.4Z'),
				A2($author$project$Icons$Platform2$pathFill, '#191530', 'M4.19995 32C4.19995 31.1164 4.9163 30.4 5.79995 30.4H15.4C16.2836 30.4 17 31.1164 17 32V54.4C17 55.2837 16.2836 56 15.4 56H5.79995C4.9163 56 4.19995 55.2837 4.19995 54.4V32ZM7.39995 33.6V52.8H13.8V33.6H7.39995Z'),
				A2($author$project$Icons$Platform2$pathFill, '#191530', 'M36.2 38.4C36.2 37.5163 36.9163 36.8 37.8 36.8H47.4C48.2836 36.8 49 37.5163 49 38.4V54.4C49 55.2836 48.2836 56 47.4 56H37.8C36.9163 56 36.2 55.2836 36.2 54.4V38.4ZM39.4 40V52.8H45.8V40H39.4Z'),
				A2($author$project$Icons$Platform2$pathFill, '#191530', 'M20.2 19.2C20.2 18.3164 20.9163 17.6 21.8 17.6H31.4C32.2836 17.6 33 18.3164 33 19.2V54.4C33 55.2837 32.2836 56 31.4 56H21.8C20.9163 56 20.2 55.2837 20.2 54.4V19.2ZM23.4 20.8V52.8H29.8V20.8H23.4Z')
			])),
	e5: 56,
	mT: 0,
	mU: 0,
	e6: 56
};
var $author$project$Dashboards2$ChartBrowser$moduleClass = A2(
	$GlobalWebIndex$class_namespaces$WeakCss$add,
	'chart-browser',
	$GlobalWebIndex$class_namespaces$WeakCss$namespace('dashboards-2'));
var $author$project$Dashboards2$ChartBrowser$emptySearchResultsView = function (term) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'empty-search-results', $author$project$Dashboards2$ChartBrowser$moduleClass)
			]),
		_List_fromArray(
			[
				A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$emptyChartsSearchReuslts),
				$elm$html$Html$text('Oh no! There are no search results'),
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['empty-search-results', 'headline']),
						$author$project$Dashboards2$ChartBrowser$moduleClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('We couldn’t find any search results for ‘'),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['empty-search-results', 'term']),
								$author$project$Dashboards2$ChartBrowser$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(term)
							])),
						$elm$html$Html$text('’, please try again')
					]))
			]));
};
var $author$project$Dashboards2$ChartBrowser$emptyTableView = function (_v0) {
	var mine = _v0.eG;
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'empty', $author$project$Dashboards2$ChartBrowser$moduleClass)
			]),
		_List_fromArray(
			[
				A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$emptyChartsSearchReuslts),
				A2(
				$elm$html$Html$h3,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['empty', 'headline']),
						$author$project$Dashboards2$ChartBrowser$moduleClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Oh no! There are no charts')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['empty', 'paragraph']),
						$author$project$Dashboards2$ChartBrowser$moduleClass)
					]),
				mine ? _List_fromArray(
					[
						$elm$html$Html$text('You need to create a chart before building a dashboard.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Create a new one from scratch using Charts')
					]) : _List_fromArray(
					[
						$elm$html$Html$text('Charts shared by others will appear on this page')
					])),
				A2(
				$elm_community$html_extra$Html$Extra$viewIf,
				mine,
				A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['empty', 'create-chart']),
							$author$project$Dashboards2$ChartBrowser$moduleClass),
							$elm$html$Html$Events$onClick($author$project$Dashboards2$ChartBrowser$GoToChartBuilder)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Create a chart'),
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$plusSign)
						])))
			]));
};
var $author$project$Data$Platform2$getChartDatapoints = function (chart) {
	return A3(
		$elm$core$List$foldr,
		A2(
			$elm$core$Basics$composeR,
			function ($) {
				return $.eq;
			},
			$elm$core$List$cons),
		_List_Nil,
		chart.d7);
};
var $author$project$Data$Platform2$getChartQuestions = function (chart) {
	return A3(
		$elm$core$List$foldr,
		F2(
			function (_v0, acc) {
				var questionCode = _v0.at;
				return A2($elm$core$List$member, questionCode, acc) ? acc : A2($elm$core$List$cons, questionCode, acc);
			}),
		_List_Nil,
		chart.d7);
};
var $author$project$Icons$Platform2$groupingPanelPlaceholderCharts = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_Nil,
		_List_fromArray(
			[
				A2($author$project$Icons$Platform2$pathFill, '#DE1B76', 'M9.66902 54.1663C12.2432 54.7134 13.8869 57.2444 13.3397 59.8186C13.2434 60.2716 12.7988 60.5603 12.3466 60.4642C11.8936 60.3679 11.6049 59.9233 11.7012 59.4703C12.0412 57.8707 11.0759 56.297 9.52576 55.8565L9.32059 55.8055L5.47801 54.9887C3.80905 54.634 2.1681 55.6996 1.81335 57.3686C1.71707 57.8216 1.2718 58.1101 0.819521 58.014C0.366536 57.9177 0.0778324 57.4732 0.174117 57.0202C0.703684 54.5288 3.09112 52.9094 5.57807 53.3034L5.8273 53.349L9.66917 54.1656L9.66902 54.1663ZM18.5181 55.0433C20.5622 55.4778 21.8678 57.4864 21.4331 59.5312C21.3369 59.9842 20.8916 60.2727 20.4393 60.1766C19.9863 60.0803 19.6978 59.635 19.7939 59.1828C20.0233 58.1034 19.3833 57.0426 18.3465 56.7276L18.1697 56.6826L15.2883 56.0701C14.8353 55.9738 14.5467 55.5286 14.6429 55.0763C14.7304 54.6644 15.1057 54.3883 15.5139 54.4136L15.636 54.4307L18.5181 55.0433ZM9.78992 44.1519C12.0994 44.6428 13.5729 46.9126 13.082 49.2222C12.5911 51.5317 10.3211 53.0058 8.01227 52.5151C5.70275 52.0242 4.22858 49.7542 4.71948 47.4447C5.21038 45.1351 7.47955 43.6615 9.78977 44.1526L9.78992 44.1519ZM18.7111 47.0527C20.4891 47.4306 21.6251 49.179 21.247 50.9577C20.8688 52.7371 19.1199 53.8722 17.3419 53.4943C15.5626 53.1161 14.4272 51.3679 14.8053 49.5892C15.1835 47.8098 16.9317 46.6745 18.7104 47.0526L18.7111 47.0527ZM9.44149 45.7911C8.03653 45.4925 6.6565 46.3887 6.35801 47.7929C6.05953 49.1972 6.95629 50.5781 8.36055 50.8766C9.7648 51.175 11.145 50.2781 11.4435 48.8739C11.742 47.4696 10.8457 46.0896 9.44149 45.7911ZM18.3628 48.6913C17.4887 48.5055 16.6298 49.0627 16.444 49.9368C16.2582 50.8109 16.8155 51.6691 17.6904 51.8551C18.5631 52.0406 19.4227 51.4835 19.6085 50.6094C19.7942 49.736 19.2356 48.8768 18.3628 48.6913Z'),
				A2($author$project$Icons$Platform2$pathFill, '#F690C4', 'M36.9241 37.495C38.1303 36.8263 39.6521 37.2627 40.3207 38.4689L40.5242 38.836C41.1932 40.0429 40.7568 41.5646 39.5506 42.2333L37.5304 43.3531C36.3235 44.0221 34.8024 43.5854 34.1338 42.3791L33.9303 42.012C33.2613 40.8051 33.697 39.2837 34.9039 38.6147L36.9241 37.495ZM43.3559 29.6086C44.5621 28.94 46.0839 29.3763 46.7525 30.5826L48.7886 34.2558C49.4573 35.462 49.0209 36.9838 47.8146 37.6524L45.7945 38.7722C44.5876 39.4412 43.0665 39.0045 42.3978 37.7982L40.3618 34.125C39.6931 32.9188 40.1288 31.3974 41.3357 30.7284L43.3559 29.6086ZM37.7183 38.9278L35.6982 40.0476C35.2824 40.278 35.132 40.8023 35.3625 41.2181L35.566 41.5852C35.7961 42.0004 36.3207 42.1514 36.7365 41.9209L38.7567 40.8011C39.1718 40.571 39.3225 40.0457 39.0923 39.6305L38.8889 39.2634C38.6584 38.8476 38.1335 38.6977 37.7183 38.9278ZM44.1497 31.0408L42.1296 32.1606C41.7138 32.391 41.5638 32.916 41.794 33.3312L43.83 37.0044C44.0602 37.4195 44.5848 37.5705 45.0006 37.34L47.0208 36.2202C47.4359 35.9901 47.5866 35.4648 47.3564 35.0497L45.3203 31.3764C45.0902 30.9613 44.5649 30.8107 44.1497 31.0408ZM31.4269 27.5778C32.6332 26.9092 34.1549 27.3455 34.8239 28.5524L36.8596 32.225C37.5286 33.4319 37.0919 34.953 35.8857 35.6216L33.8655 36.7414C32.6586 37.4104 31.1379 36.9743 30.4689 35.7674L28.4331 32.0949C27.7641 30.888 28.2002 29.3672 29.4071 28.6982L31.4272 27.5784L31.4269 27.5778ZM32.2211 29.0106L30.201 30.1304C29.7852 30.3609 29.6348 30.8852 29.8653 31.301L31.9011 34.9736C32.1315 35.3894 32.6559 35.5397 33.0716 35.3092L35.0918 34.1894C35.507 33.9593 35.6579 33.4347 35.4274 33.0189L33.3917 29.3463C33.1612 28.9305 32.6363 28.7805 32.2211 29.0106ZM39.691 22.9969C40.8972 22.3283 42.419 22.7647 43.088 23.9716L43.2915 24.3386C43.9601 25.5449 43.5237 27.0666 42.3175 27.7353L40.2973 28.8551C39.0904 29.5241 37.5693 29.0873 36.9007 27.8811L36.6972 27.514C36.0282 26.3071 36.4643 24.7863 37.6712 24.1174L39.6913 22.9976L39.691 22.9969ZM40.4852 24.4298L38.4651 25.5496C38.0493 25.78 37.8989 26.3043 38.1294 26.7201L38.3329 27.0872C38.563 27.5024 39.0877 27.6533 39.5035 27.4229L41.5236 26.3031C41.9388 26.073 42.0894 25.5477 41.8593 25.1325L41.6558 24.7654C41.4253 24.3496 40.9004 24.1996 40.4852 24.4298Z'),
				A2($author$project$Icons$Platform2$pathFill, '#A40F58', 'M8.83055 3.70099C9.01098 3.31406 9.47159 3.14641 9.85851 3.32684L16.0887 6.232C16.4756 6.41243 16.6432 6.87304 16.4625 7.26062L14.8527 10.7128L21.9394 14.0173C22.3263 14.1977 22.4936 14.659 22.3132 15.0459L20.3768 19.1985C20.1964 19.5854 19.7355 19.7537 19.3486 19.5733L16.1567 18.0833L14.5466 21.5361C14.3662 21.9231 13.905 22.0904 13.518 21.91L3.39437 17.1892C3.00745 17.0088 2.83949 16.5489 3.02022 16.1613L8.83055 3.70099ZM19.3013 17.8443L20.5845 15.0925L7.96877 9.20972L6.68561 11.9615L19.3007 17.844L19.3013 17.8443ZM13.4711 20.1819L14.7543 17.4302L6.0321 13.3629L4.74894 16.1147L13.4711 20.1819ZM13.4509 10.0583L14.7338 7.30721L9.90575 5.05586L8.62289 7.80696L13.4509 10.0583Z')
			])),
	e5: 65,
	mT: 0,
	mU: 0,
	e6: 50
};
var $author$project$Dashboards2$ChartBrowser$OpenCategory = function (a) {
	return {$: 14, a: a};
};
var $author$project$Dashboards2$ChartBrowser$SelectedQuestion = function (a) {
	return {$: 1, a: a};
};
var $author$project$Gwi$List$dropLast = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A2(
				$elm$core$List$drop,
				n,
				$elm$core$List$reverse(list)));
	});
var $author$project$Icons$Platform2$folder = {
	mr: $author$project$Icons$Platform2$path('M14.225 10h-3.137C9.945 10 9 10.882 9 11.994v7.86c0 1.112.945 1.994 2.088 1.994h9.824c1.143 0 2.088-.882 2.088-1.994V13.92c0-1.112-.945-1.994-2.088-1.994h-4.54l-.029-.006-.984-1.352A1.402 1.402 0 0014.225 10zm-3.137 1.368h3.137c.017 0 .028.006.029.007l.984 1.351c.262.36.685.568 1.133.568h4.541c.407 0 .72.292.72.626v5.934c0 .334-.313.626-.72.626h-9.824c-.407 0-.72-.292-.72-.626v-7.86c0-.334.312-.626.72-.626z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$folderCrossed = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$transform('translate(8, 8)')
			]),
		_List_fromArray(
			[
				$author$project$Icons$Platform2$path('M15.9938 5.64323L16 5.81157V13.2454C16 14.4345 15.0791 15.4095 13.9119 15.4956L13.7436 15.5018L2.73486 15.5017L3.96571 14.2709L13.7436 14.2711C14.266 14.2711 14.6979 13.8794 14.7612 13.374L14.7692 13.2454V5.81157C14.7692 5.28913 14.3776 4.85728 13.8722 4.79393L13.7436 4.78593L13.4514 4.78514L14.5395 3.69968C15.3427 4.00274 15.9279 4.75104 15.9938 5.64323ZM5.92492 1.14286C6.34674 1.14286 6.74404 1.32825 7.01639 1.64576L7.11247 1.77092L8.26319 3.46422C8.28928 3.50231 8.32638 3.53003 8.36831 3.54428L8.43405 3.55516L12.4926 3.55428L11.2617 4.78514L8.43405 4.78593C8.01223 4.78593 7.61493 4.60054 7.34259 4.28303L7.24651 4.15787L6.09579 2.46457C6.05665 2.40744 5.99274 2.37363 5.92492 2.37363H2.25641C1.73366 2.37363 1.30207 2.76487 1.23876 3.27061L1.23077 3.39927V13.2454C1.23077 13.6701 1.4896 14.035 1.85796 14.1906L0.957356 15.0903C0.421353 14.7121 0.0573232 14.1063 0.0061918 13.4138L0 13.2454V3.39927C0 2.20962 0.920688 1.23517 2.08804 1.14904L2.25641 1.14286H5.92492Z'),
				$author$project$Icons$Platform2$path('M1.32163 15.7732L15.7732 1.32163C16.0756 1.01929 16.0756 0.529097 15.7732 0.226756C15.4709 -0.0755854 14.9807 -0.0755854 14.6784 0.226756L0.226756 14.6784C-0.0755854 14.9807 -0.0755854 15.4709 0.226756 15.7732C0.529097 16.0756 1.01929 16.0756 1.32163 15.7732Z')
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Dashboards2$ChartBrowser$remoteDataView = F2(
	function (fn, webData) {
		switch (webData.$) {
			case 3:
				var data = webData.a;
				return fn(data);
			case 0:
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'error', $author$project$Dashboards2$ChartBrowser$moduleClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Data has to be asked. Check your code.')
						]));
			case 1:
				return $author$project$Platform2$Spinner$view;
			default:
				var err = webData.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'error', $author$project$Dashboards2$ChartBrowser$moduleClass)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Something went wrong'),
							$elm$html$Html$text(
							$author$project$Gwi$String$fromHttpError(err))
						]));
		}
	});
var $author$project$Dashboards2$ChartBrowser$questionChartsView = F2(
	function (store, model) {
		var taxonomyQuestionView = function (question) {
			var isSelected = A2(
				$elm$core$List$member,
				$author$project$Dashboards2$ChartBrowser$SelectedQuestion(question),
				model.aE);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2('selected', isSelected)
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['question-charts', 'item']),
							$author$project$Dashboards2$ChartBrowser$moduleClass)),
						$elm$html$Html$Events$onClick(
						$author$project$Dashboards2$ChartBrowser$ToggleSelection(
							$author$project$Dashboards2$ChartBrowser$SelectedQuestion(question)))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['question-charts', 'item', 'icon']),
								$author$project$Dashboards2$ChartBrowser$moduleClass)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Icons$icon,
								_List_Nil,
								isSelected ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['question-charts', 'item', 'label']),
								$author$project$Dashboards2$ChartBrowser$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(question.ld),
								A2(
								$elm_community$html_extra$Html$Extra$viewMaybe,
								function (description) {
									return A2(
										$elm$html$Html$span,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['question-charts', 'item', 'description']),
												$author$project$Dashboards2$ChartBrowser$moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(description)
											]));
								},
								question.hB)
							]))
					]));
		};
		var taxonomyBreadcrumbsView = F2(
			function (paths, currentCategory) {
				return ($elm$core$List$length(paths) > 0) ? A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'breadcrumbs', $author$project$Dashboards2$ChartBrowser$moduleClass)
						]),
					A2(
						$elm$core$List$intersperse,
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$chevronRight),
						A2(
							$elm$core$List$cons,
							A2(
								$elm$html$Html$a,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['breadcrumbs', 'link']),
										$author$project$Dashboards2$ChartBrowser$moduleClass),
										$elm$html$Html$Events$onClick(
										$author$project$Dashboards2$ChartBrowser$OpenCategory($elm$core$Maybe$Nothing))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Question Charts')
									])),
							_Utils_ap(
								A2(
									$elm$core$List$map,
									function (item) {
										return A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['breadcrumbs', 'link']),
													$author$project$Dashboards2$ChartBrowser$moduleClass),
													$elm$html$Html$Events$onClick(
													$author$project$Dashboards2$ChartBrowser$OpenCategory(
														$elm$core$Maybe$Just(item)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(item.ld)
												]));
									},
									A2($author$project$Gwi$List$dropLast, 1, paths)),
								_List_fromArray(
									[
										A2(
										$elm_community$html_extra$Html$Extra$viewMaybe,
										function (category) {
											return A2(
												$elm$html$Html$span,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['breadcrumbs', 'current-item']),
														$author$project$Dashboards2$ChartBrowser$moduleClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(category.ld)
													]));
										},
										currentCategory)
									]))))) : $elm_community$html_extra$Html$Extra$nothing;
			});
		var isSearching = !$elm$core$String$isEmpty(model.aR.cW);
		var isCategoryCompatible = function (category) {
			var datasetsToNamespaces = A2($krisajenkins$remotedata$RemoteData$withDefault, $Janiczek$elm_bidict$BiDict$Assoc$empty, store.fC);
			return A2(
				$elm$core$List$all,
				function (_v2) {
					var baseNamespaceCode = _v2.jt;
					return A4($author$project$Data$Platform2$isNamespaceCodeCompatibleWithDatasets, model.g0, datasetsToNamespaces, store.cB, baseNamespaceCode);
				},
				category.es);
		};
		var taxonomyCategoryView = function (category) {
			if (isCategoryCompatible(category)) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['question-charts', 'folder']),
							$author$project$Dashboards2$ChartBrowser$moduleClass),
							$elm$html$Html$Events$onClick(
							$author$project$Dashboards2$ChartBrowser$OpenCategory(
								$elm$core$Maybe$Just(category)))
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$folder),
							$elm$html$Html$text(category.ld)
						]));
			} else {
				var elementId = 'd2-chart-browser-incompatible-folder-' + $author$project$Store$AttributesTaxonomy$taxonomyFolderIdToComparable(category.b);
				return A3(
					$elm$html$Html$node,
					'x-d3scription',
					_List_fromArray(
						[
							A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + elementId),
							A2($elm$html$Html$Attributes$attribute, 'content', 'You are unable to mix different studies in one dashboard'),
							A2($elm$html$Html$Attributes$attribute, 'dark-mode', 'true'),
							$elm$html$Html$Attributes$id(elementId)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
									_List_fromArray(
										['incompatible']),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['question-charts', 'folder']),
										$author$project$Dashboards2$ChartBrowser$moduleClass))
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$folderCrossed),
									$elm$html$Html$text(category.ld),
									A2(
									$elm_community$html_extra$Html$Extra$viewMaybe,
									function (description) {
										return A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['question-charts', 'item', 'description']),
													$author$project$Dashboards2$ChartBrowser$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(description)
												]));
									},
									category.hB)
								]))
						]));
			}
		};
		var filterBySearch = function (items) {
			return isSearching ? A3(
				$author$project$Search$filter,
				function (categoryOrQuestion) {
					if (!categoryOrQuestion.$) {
						var category = categoryOrQuestion.a;
						return category.ld;
					} else {
						var question = categoryOrQuestion.a;
						return _Utils_ap(
							question.ld,
							A2($elm$core$Maybe$withDefault, '', question.hB));
					}
				},
				model.aR.cW,
				items) : items;
		};
		return A2(
			$author$project$Dashboards2$ChartBrowser$remoteDataView,
			function (categoriesAndQuestions) {
				var filteredItems = filterBySearch(categoriesAndQuestions);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'question-charts-wrapper', $author$project$Dashboards2$ChartBrowser$moduleClass)
						]),
					_List_fromArray(
						[
							A2(taxonomyBreadcrumbsView, model.cf, model.di),
							(isSearching && $elm$core$List$isEmpty(filteredItems)) ? $author$project$Dashboards2$ChartBrowser$emptySearchResultsView(model.aR.cW) : A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'question-charts', $author$project$Dashboards2$ChartBrowser$moduleClass)
								]),
							A2(
								$elm$core$List$map,
								function (categoryOrQuestion) {
									if (!categoryOrQuestion.$) {
										var category = categoryOrQuestion.a;
										return taxonomyCategoryView(category);
									} else {
										var question = categoryOrQuestion.a;
										return taxonomyQuestionView(question);
									}
								},
								filteredItems))
						]));
			},
			A2(
				$author$project$Store$AttributesTaxonomy$getCategory,
				A2(
					$elm$core$Maybe$map,
					function ($) {
						return $.b;
					},
					model.di),
				model.c_));
	});
var $author$project$Dashboards2$ChartBrowser$sortData = F3(
	function (sortBy, a, b) {
		switch (sortBy) {
			case 1:
				return A2(
					$elm$core$Basics$compare,
					$elm$time$Time$posixToMillis(a.bB),
					$elm$time$Time$posixToMillis(b.bB));
			case 2:
				return A2(
					$elm$core$Basics$compare,
					$elm$time$Time$posixToMillis(a.bN),
					$elm$time$Time$posixToMillis(b.bN));
			default:
				return A2($mcordova47$elm_natural_ordering$NaturalOrdering$compare, a.ld, b.ld);
		}
	});
var $author$project$Icons$Platform2$question = {
	mr: $author$project$Icons$Platform2$path('M12.021 5.513c3.503 0 6.378 2.535 6.504 5.741l.005.22c0 3.309-2.927 5.961-6.509 5.961-.394 0-.786-.033-1.175-.099L8.715 18.39a.51.51 0 01-.251.092h-.011l-.032.002h-.02a.491.491 0 01-.405-.227c-.003-.01-.008-.017-.013-.025-.005-.006-.008-.013-.011-.02l-.012-.026a.237.237 0 01-.013-.034l.025.06a.52.52 0 01-.04-.11l-.006-.034-.005-.054v-1.918c-1.509-1.12-2.409-2.796-2.409-4.622.001-3.309 2.927-5.962 6.508-5.962zm0 .975c-3.063 0-5.533 2.238-5.533 4.986l-.002.007.008.228c.076 1.464.86 2.802 2.135 3.697a.48.48 0 01.285.367l.006.072v1.353l1.635-.807.01-.006a.578.578 0 01.065-.025l-.075.03a.45.45 0 01.152-.046l.045-.004h.036c.014 0 .029.002.043.004a6.107 6.107 0 001.19.116c3.064 0 5.534-2.238 5.534-4.986 0-2.748-2.47-4.987-5.534-4.987zm1.441 6.645c.27 0 .488.224.488.5 0 .25-.18.459-.416.494l-.072.006H10.58a.494.494 0 01-.487-.5c0-.251.18-.46.415-.495l.072-.005h2.882zm1.235-2.174c.27 0 .488.223.488.5 0 .25-.18.458-.416.494l-.072.006H9.345a.494.494 0 01-.487-.5c0-.251.18-.46.415-.495l.072-.005h5.352zm-1.235-2.175c.27 0 .488.224.488.5 0 .251-.18.46-.416.495l-.072.005H10.58a.494.494 0 01-.487-.5c0-.25.18-.459.415-.494l.072-.006h2.882z'),
	e5: 24,
	mT: 0,
	mU: 0,
	e6: 24
};
var $author$project$Dashboards2$ChartBrowser$tabToIcon = function (tab) {
	switch (tab) {
		case 0:
			return $author$project$Icons$Platform2$charts;
		case 1:
			return $author$project$Icons$Platform2$shared;
		default:
			return $author$project$Icons$Platform2$question;
	}
};
var $author$project$Dashboards2$ChartBrowser$tabToString = function (tab) {
	switch (tab) {
		case 0:
			return 'My Charts';
		case 1:
			return 'Shared';
		default:
			return 'Question Charts';
	}
};
var $author$project$Dashboards2$ChartBrowser$DateCreated = 1;
var $author$project$Dashboards2$ChartBrowser$LastModified = 2;
var $author$project$Dashboards2$ChartBrowser$Name = 0;
var $author$project$Dashboards2$ChartBrowser$OpenChartInChartBrowser = function (a) {
	return {$: 6, a: a};
};
var $author$project$Dashboards2$ChartBrowser$SortByClicked = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $ryannhg$date_format$DateFormat$DayOfMonthFixed = {$: 7};
var $ryannhg$date_format$DateFormat$dayOfMonthFixed = $ryannhg$date_format$DateFormat$DayOfMonthFixed;
var $author$project$Time$Format$format_D_MMM_YYYY_hh_mm = _List_fromArray(
	[
		$ryannhg$date_format$DateFormat$dayOfMonthNumber,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$monthNameAbbreviated,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$yearNumber,
		$ryannhg$date_format$DateFormat$text(' '),
		$ryannhg$date_format$DateFormat$hourMilitaryFixed,
		$ryannhg$date_format$DateFormat$text(':'),
		$ryannhg$date_format$DateFormat$minuteFixed
	]);
var $author$project$Dashboards2$ChartBrowser$getLabelName = function (label) {
	switch (label) {
		case 0:
			return 'Name';
		case 1:
			return 'Date created';
		default:
			return 'Last modified';
	}
};
var $ryannhg$date_format$DateFormat$MonthNameFull = {$: 4};
var $ryannhg$date_format$DateFormat$monthNameFull = $ryannhg$date_format$DateFormat$MonthNameFull;
var $author$project$Dashboards2$ChartBrowser$tableLabelToString = function (label) {
	switch (label) {
		case 0:
			return 'name';
		case 1:
			return 'date-created';
		default:
			return 'last-modified';
	}
};
var $author$project$Platform2$SortingHeader$Asc = 0;
var $author$project$Icons$Platform2$chevronDown = {
	mr: $author$project$Icons$Platform2$path('m 1.4638763,0.25712628 c -0.334,-0.342 -0.87700008,-0.343 -1.21199998,-0.002 -0.3350001,0.342 -0.336,0.89600002 -0.002,1.23800002 L 5.3778767,6.7431262 c 0.3340004,0.342 0.8770003,0.343 1.2120003,0.002 l 5.158,-5.2479999 c 0.335,-0.341 0.336,-0.89500002 0.002,-1.23700002 -0.334,-0.343 -0.877,-0.344 -1.212,-0.002 L 5.986877,4.8881263 1.4638763,0.25812628 Z'),
	e5: 7,
	mT: 0,
	mU: 0,
	e6: 12
};
var $author$project$Icons$Platform2$chevronUp = {
	mr: $author$project$Icons$Platform2$path('m 10.535877,6.7431262 c 0.334,0.342 0.877,0.343 1.212,0.002 0.335,-0.342 0.336,-0.896 0.002,-1.238 L 6.6218765,0.25712624 c -0.3340003,-0.342 -0.8770003,-0.343 -1.2120003,-0.002 L 0.25187626,5.5031262 c -0.335,0.341 -0.336,0.895 -0.002,1.237 0.334,0.343 0.87699994,0.344 1.21199994,0.002 l 4.551,-4.63 4.5230008,4.63 z'),
	e5: 7,
	mT: 0,
	mU: 0,
	e6: 12
};
var $author$project$Platform2$SortingHeader$cycleDirection = function (direction) {
	switch (direction) {
		case 0:
			return 1;
		case 1:
			return 2;
		default:
			return 0;
	}
};
var $author$project$Platform2$SortingHeader$view = function (_v0) {
	var baseClass = _v0.js;
	var stateClasses = _v0.rB;
	var label = _v0.h4;
	var setDirection = _v0.rh;
	var direction = _v0.fH;
	var arrowsClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'arrows', baseClass);
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$withActiveStates, stateClasses, baseClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'label', baseClass),
						$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
						setDirection(
							$author$project$Platform2$SortingHeader$cycleDirection(direction)))
					]),
				_List_fromArray(
					[
						$elm$html$Html$text(label)
					])),
				A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$GlobalWebIndex$class_namespaces$WeakCss$toClass(arrowsClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
								setDirection(0)),
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('active', !direction)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'up', arrowsClass))
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$chevronUp)
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
								setDirection(1)),
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('active', direction === 1)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'down', arrowsClass))
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$chevronDown)
							]))
					]))
			]));
};
var $ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions = F6(
	function (seconds, minutes, hours, days, months, years) {
		return {jW: days, kw: hours, k7: minutes, lb: months, lZ: seconds, m6: years};
	});
var $ryannhg$date_format$DateFormat$Relative$relativeTimeWithFunctions = F3(
	function (zone, millis, functions) {
		var seconds = (millis / 1000) | 0;
		var posix = $elm$time$Time$millisToPosix(millis);
		var minutes = (seconds / 60) | 0;
		var hours = (minutes / 60) | 0;
		var days = (hours / 24) | 0;
		return (minutes < 1) ? functions.lZ(
			A2($elm$time$Time$toSecond, zone, posix)) : ((hours < 1) ? functions.k7(
			A2($elm$time$Time$toMinute, zone, posix)) : ((hours < 24) ? functions.kw(
			A2($elm$time$Time$toHour, zone, posix)) : ((days < 30) ? functions.jW(days) : ((days < 365) ? functions.lb((days / 30) | 0) : functions.m6((days / 365) | 0)))));
	});
var $ryannhg$date_format$DateFormat$Relative$toMilliseconds = $elm$time$Time$posixToMillis;
var $ryannhg$date_format$DateFormat$Relative$relativeTimeWithOptions = F3(
	function (options, start, end) {
		var differenceInMilliseconds = $ryannhg$date_format$DateFormat$Relative$toMilliseconds(end) - $ryannhg$date_format$DateFormat$Relative$toMilliseconds(start);
		return (!differenceInMilliseconds) ? options.q1 : A3(
			$ryannhg$date_format$DateFormat$Relative$relativeTimeWithFunctions,
			$elm$time$Time$utc,
			$elm$core$Basics$abs(differenceInMilliseconds),
			(differenceInMilliseconds < 0) ? A6($ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions, options.rt, options.rr, options.rq, options.rp, options.rs, options.ru) : A6($ryannhg$date_format$DateFormat$Relative$RelativeTimeFunctions, options.pg, options.pe, options.pd, options.pc, options.pf, options.ph));
	});
var $author$project$Time$Format$xbRelativeTimeOptions = {
	pc: function (ds) {
		return (ds === 1) ? 'in a day' : ((ds < 26) ? ('in ' + ($elm$core$String$fromInt(ds) + ' days')) : 'in a month');
	},
	pd: function (hs) {
		return (hs === 1) ? 'in an hour' : ((hs < 22) ? ('in ' + ($elm$core$String$fromInt(hs) + ' hours')) : 'in a day');
	},
	pe: function (mins) {
		return (mins === 1) ? 'in a minute' : ((mins < 45) ? ('in ' + ($elm$core$String$fromInt(mins) + ' minutes')) : 'in an hour');
	},
	pf: function (ms) {
		return (ms === 1) ? 'in a month' : ((ms < 11) ? ('in ' + ($elm$core$String$fromInt(ms) + ' months')) : 'in a year');
	},
	pg: function (secs) {
		return (!secs) ? 'just now' : ((secs === 1) ? 'in a second' : ((secs < 45) ? ('in ' + ($elm$core$String$fromInt(secs) + ' seconds')) : 'in a minute'));
	},
	ph: function (ys) {
		return (ys === 1) ? 'in a year' : ('in ' + ($elm$core$String$fromInt(ys) + ' years'));
	},
	q1: 'just now',
	rp: function (ds) {
		return (ds === 1) ? '1 day ago' : ((ds < 26) ? ($elm$core$String$fromInt(ds) + ' days ago') : '1 month ago');
	},
	rq: function (hs) {
		return (hs === 1) ? '1 hour ago' : ((hs < 22) ? ($elm$core$String$fromInt(hs) + ' hours ago') : '1 day ago');
	},
	rr: function (mins) {
		return (mins === 1) ? '1 minute ago' : ((mins < 45) ? ($elm$core$String$fromInt(mins) + ' minutes ago') : '1 hour ago');
	},
	rs: function (ms) {
		return (ms === 1) ? '1 month ago' : ((ms < 11) ? ($elm$core$String$fromInt(ms) + ' months ago') : '1 year ago');
	},
	rt: function (secs) {
		return (secs < 45) ? 'just now' : '1 minute ago';
	},
	ru: function (ys) {
		return $elm$core$String$fromInt(ys) + ' years ago';
	}
};
var $author$project$Time$Format$xbRelativeTime = F2(
	function (current, saved) {
		return A3($ryannhg$date_format$DateFormat$Relative$relativeTimeWithOptions, $author$project$Time$Format$xbRelativeTimeOptions, current, saved);
	});
var $author$project$Dashboards2$ChartBrowser$tableView = F4(
	function (flags, config, zone, model) {
		var timeFormat = A2($ryannhg$date_format$DateFormat$format, $author$project$Time$Format$format_D_MMM_YYYY_hh_mm, zone);
		var tableClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'table', $author$project$Dashboards2$ChartBrowser$moduleClass);
		var itemView = F2(
			function (index, item) {
				var incompatibleTooltip = function () {
					var _v3 = item.cA;
					if (!_v3.$) {
						return '';
					} else {
						var d = _v3.a;
						return d.hY ? 'You are unable to mix different studies in one dashboard' : ((!d.fo.kR) ? 'This chart contains invalid, or missing data. Please create a new one, or contact the GWI team for further support.' : '');
					}
				}();
				var incompatible = function () {
					var _v2 = item.cA;
					if (!_v2.$) {
						return false;
					} else {
						var d = _v2.a;
						return d.hY || (!d.fo.kR);
					}
				}();
				var elementId = 'chart-browser-table-row-item--' + $elm$core$String$fromInt(index);
				var forbiddenIncompatibleTooltipElementId = elementId + '-do-not-show-incompatible-here';
				var withInfoTooltip = F2(
					function (infoTooltip, c) {
						return A3(
							$elm$html$Html$node,
							'x-d3scription',
							_List_fromArray(
								[
									A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + elementId),
									A2($elm$html$Html$Attributes$attribute, 'content', infoTooltip)
								]),
							_List_fromArray(
								[c]));
					});
				var withTooltip = function (c) {
					return incompatible ? A3(
						$elm$html$Html$node,
						'x-d3scription',
						_List_fromArray(
							[
								A2($elm$html$Html$Attributes$attribute, 'target-selector', '#' + (elementId + '-incompatible')),
								A2($elm$html$Html$Attributes$attribute, 'forbidden-selector', '#' + forbiddenIncompatibleTooltipElementId),
								A2($elm$html$Html$Attributes$attribute, 'content', incompatibleTooltip),
								A2($elm$html$Html$Attributes$attribute, 'dark-mode', 'true'),
								$elm$html$Html$Attributes$id(elementId + '-incompatible')
							]),
						_List_fromArray(
							[c])) : c;
				};
				return withTooltip(
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('active', item.pv),
										_Utils_Tuple2('incompatible', incompatible)
									]),
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['rows', 'row']),
									tableClass)),
								A2(
								$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
								!incompatible,
								$elm$html$Html$Events$onClick(item.cd))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['rows', 'row', 'checkbox-icon']),
										tableClass)
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Icons$icon,
										_List_Nil,
										function () {
											var _v0 = item.cA;
											if (!_v0.$) {
												return $author$project$Icons$Platform2$folderFilled;
											} else {
												return item.pv ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled;
											}
										}())
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['rows', 'row', 'chart-icon']),
										tableClass)
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$charts)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['rows', 'row', 'name']),
										tableClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(item.ld)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['rows', 'row', 'date-created']),
										tableClass),
										$elm$html$Html$Attributes$title(
										timeFormat(item.bB))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A3(
											$ryannhg$date_format$DateFormat$format,
											_List_fromArray(
												[
													$ryannhg$date_format$DateFormat$dayOfMonthFixed,
													$ryannhg$date_format$DateFormat$text(' '),
													$ryannhg$date_format$DateFormat$monthNameFull,
													$ryannhg$date_format$DateFormat$text(' '),
													$ryannhg$date_format$DateFormat$yearNumber
												]),
											zone,
											item.bB))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['rows', 'row', 'last-modified']),
										tableClass),
										$elm$html$Html$Attributes$title(
										timeFormat(item.bN))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										A2($author$project$Time$Format$xbRelativeTime, model.dk, item.bN))
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['rows', 'row', 'icons']),
										tableClass),
										$elm$html$Html$Attributes$id(forbiddenIncompatibleTooltipElementId)
									]),
								function () {
									var _v1 = item.cA;
									if (!_v1.$) {
										return _List_Nil;
									} else {
										var infoTooltip = _v1.a.kB;
										var chart = _v1.a.fo;
										return _List_fromArray(
											[
												A2(
												withInfoTooltip,
												infoTooltip,
												A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															$elm$html$Html$Attributes$id(elementId),
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['rows', 'row', 'icons', 'info']),
															tableClass)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Icons$icon,
															_List_fromArray(
																[
																	$author$project$Icons$width(30)
																]),
															$author$project$Icons$Platform2$info)
														]))),
												A2(
												$elm$html$Html$a,
												_List_fromArray(
													[
														$elm$html$Html$Attributes$id(elementId),
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['rows', 'row', 'icons', 'preview']),
														tableClass),
														$elm$html$Html$Attributes$href(
														A2(
															$author$project$Platform2$Router$toUrlString,
															flags,
															$author$project$Platform2$Router$ChartBuilderChart(chart.b))),
														$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(
														$author$project$Dashboards2$ChartBrowser$OpenChartInChartBrowser(chart))
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$eye)
													]))
											]);
									}
								}())
							])));
			});
		var headerItemView = function (label) {
			return $author$project$Platform2$SortingHeader$view(
				{
					js: A2(
						$GlobalWebIndex$class_namespaces$WeakCss$addMany,
						_List_fromArray(
							['header', 'label']),
						tableClass),
					fH: A2(
						$elm$core$Maybe$withDefault,
						2,
						A2(
							$elm$core$Maybe$map,
							function ($) {
								return $.fH;
							},
							A2(
								$elm_community$maybe_extra$Maybe$Extra$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.cY;
									},
									$elm$core$Basics$eq(label)),
								model.eZ))),
					h4: $author$project$Dashboards2$ChartBrowser$getLabelName(label),
					rh: $author$project$Dashboards2$ChartBrowser$SortByClicked(label),
					rB: _List_fromArray(
						[
							$author$project$Dashboards2$ChartBrowser$tableLabelToString(label)
						])
				});
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass(tableClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', tableClass)
						]),
					A2(
						$elm$core$List$map,
						headerItemView,
						_List_fromArray(
							[0, 1, 2]))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'rows', tableClass)
						]),
					A2($elm$core$List$indexedMap, itemView, config.f2))
				]));
	});
var $author$project$Icons$Platform2$attribute = {
	mr: A2(
		$elm$svg$Svg$path,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$d('M20.188 16.547c1.892 0 3.426 1.534 3.426 3.427 0 1.688-1.228 3.11-2.879 3.38l-.185.026-.188.015-.174.005c-1.893 0-3.427-1.534-3.427-3.426 0-1.893 1.534-3.427 3.427-3.427zm-5.896.393c.298 0 .556.196.644.477l.023.097.007.101v4.717c0 .299-.195.556-.476.644l-.097.023-.101.008H9.575c-.299 0-.557-.196-.644-.477l-.023-.097-.008-.101v-4.717c0-.299.195-.556.477-.644l.097-.023.1-.008h4.718zm5.896.957c-1.147 0-2.077.93-2.077 2.077 0 1.037.765 1.908 1.76 2.055l.15.016.148.006.137-.004c1.097-.061 1.958-.972 1.958-2.073 0-1.147-.93-2.077-2.076-2.077zm-6.572.392h-3.367v3.367h3.367v-3.367zm1.676-10.072c.222-.355.701-.417 1.005-.16l.078.077.061.083 3.44 5.503c.24.386.036.883-.384 1.006l-.094.02-.095.007h-6.878c-.456 0-.768-.437-.65-.859l.033-.09.044-.084 3.44-5.503zm.571 1.631l-2.222 3.554h4.443l-2.221-3.554z'),
				$elm$svg$Svg$Attributes$fill('currentColor'),
				$elm$svg$Svg$Attributes$fillRule('evenodd'),
				$elm$svg$Svg$Attributes$transform('translate(-267 -220) translate(235 212) translate(32) translate(0 8)')
			]),
		_List_Nil),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$GroupingPanel$buttonView = F2(
	function (moduleClass, _v0) {
		var label = _v0.h4;
		var onClick = _v0.cL;
		var disabled = _v0.fI;
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'button', moduleClass),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
					!disabled,
					$elm$html$Html$Events$onClick(onClick)),
					$elm$html$Html$Attributes$disabled(disabled)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(label)
				]));
	});
var $author$project$Platform2$GroupingPanel$Average = 3;
var $author$project$Platform2$Grouping$toString = function (grouping) {
	switch (grouping) {
		case 0:
			return 'Split';
		case 1:
			return 'And';
		default:
			return 'Or';
	}
};
var $author$project$Platform2$GroupingPanel$groupingView = F3(
	function (moduleClass, config, _v0) {
		var grouping = _v0.kq;
		var disabled = _v0.fI;
		var onClick = _v0.cL;
		var isActive = _Utils_eq(config.ne, grouping);
		var containsAverage = A2(
			$elm$core$List$any,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.mL;
				},
				$elm$core$Basics$eq(3)),
			config.f2);
		return A2(
			$elm$html$Html$button,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2('active', isActive)
						]),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'grouping', moduleClass)),
					$elm$html$Html$Attributes$disabled(disabled),
					$elm$html$Html$Events$onClick(onClick),
					A2(
					$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
					containsAverage && disabled,
					A2($elm$html$Html$Attributes$attribute, 'tooltip-content', 'Averages and attributes cannot be combined'))
				]),
			_List_fromArray(
				[
					$elm$html$Html$text(
					$author$project$Platform2$Grouping$toString(grouping))
				]));
	});
var $author$project$Icons$Platform2$audienceDefault = {
	mr: $author$project$Icons$Platform2$path('M21.704 8.4c1.047 0 1.896.85 1.896 1.897v9.073c0 1.048-.85 1.897-1.896 1.897h-.438v.437c0 .997-.77 1.815-1.748 1.9l-.148.006h-9.073c-.998 0-1.816-.77-1.89-1.748l-.006-.148V12.63c0-.998.77-1.815 1.748-1.9l.15-.007h.436v-.436c0-.998.77-1.816 1.748-1.89l.15-.006zm-10.97 3.533h-.436c-.353 0-.645.262-.7.602l-.007.095v9.074c0 .352.262.644.602.7l.095.006h9.073c.353 0 .644-.262.7-.602l.007-.094-.001-.438H12.63c-.998 0-1.815-.77-1.9-1.748l-.006-.148-.001-7.437zM21.703 9.6H12.63c-.385 0-.696.31-.696.697v9.073c0 .385.3.697.696.697h9.074c.384 0 .696-.312.696-.697v-9.073c0-.385-.312-.697-.696-.697zm-2.754 7.305c.618 0 1.2.233 1.664.653.268.248.477.553.61.892a.6.6 0 0 1-.336.78.6.6 0 0 1-.779-.337 1.25 1.25 0 0 0-1.026-.781l-.134-.007h-3.565c-.314 0-.615.118-.847.333a1.23 1.23 0 0 0-.254.329l-.06.126a.6.6 0 0 1-.779.336.6.6 0 0 1-.336-.779c.135-.34.344-.644.612-.893.404-.373.916-.598 1.458-.644l.205-.008h3.565zm.017-5.09c.994.994.994 2.606 0 3.6s-2.605.993-3.598 0-.994-2.605 0-3.6 2.604-.993 3.598 0zm-2.75.85c-.525.525-.525 1.376 0 1.9s1.376.525 1.9 0c.5-.5.523-1.264.098-1.792l-.098-.1-.11-.097c-.528-.425-1.302-.392-1.792.098z'),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Icons$Platform2$average = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('translate(-245 -369) translate(245 361) translate(0 8)'),
						$elm$svg$Svg$Attributes$d('M23.111 15.35c.327 0 .597.24.643.554l.007.096v7c0 .359-.29.65-.65.65-.326 0-.596-.24-.643-.554L22.461 23v-7c0-.36.291-.65.65-.65zm-4.709 2.333c.326 0 .597.241.643.554l.007.096V23c0 .359-.291.65-.65.65-.326 0-.596-.24-.643-.554L17.752 23v-4.667c0-.359.291-.65.65-.65zm-9.513 2.042c.326 0 .597.24.643.554l.007.096V23c0 .359-.29.65-.65.65-.326 0-.596-.24-.643-.554L8.24 23v-2.625c0-.36.291-.65.65-.65zm4.71-2.975c.326 0 .597.24.643.554l.007.096V23c0 .359-.29.65-.65.65-.326 0-.596-.24-.643-.554L12.95 23v-5.6c0-.36.291-.65.65-.65zm9.975-8.206c.227.23.247.587.062.84l-.069.08L19.06 13.9c-.563.553-1.45.587-2.052.103l-.116-.104-.727-.715.02-.014c-.364.262-.812.417-1.296.417-.517 0-.993-.177-1.37-.472l.009.007-4.183 4.118c-.256.252-.668.249-.92-.007-.226-.23-.246-.587-.061-.84l.069-.08 4.344-4.276-.008-.027c-.056-.192-.086-.395-.086-.605 0-1.207.99-2.181 2.206-2.181 1.215 0 2.205.975 2.205 2.181 0 .21-.03.413-.085.605l-.045.137.84.826c.078.077.2.09.293.038l.051-.038 4.507-4.437c.256-.252.667-.249.92.007zm-8.685 1.981c-.503 0-.906.397-.906.881 0 .485.403.881.906.881.502 0 .905-.396.905-.88 0-.485-.403-.882-.905-.882z')
					]),
				_List_Nil)
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Platform2$Grouping$groupingPanelItemLabel = function (grouping) {
	switch (grouping) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Just('And');
		default:
			return $elm$core$Maybe$Just('Or');
	}
};
var $author$project$Platform2$GroupingPanel$itemView = F6(
	function (moduleClass, activeGrouping, clearItem, isClearable, index, _v0) {
		var item = _v0.kS;
		var title = _v0.Y;
		var subtitle = _v0.rH;
		var type_ = _v0.mL;
		var icon = function () {
			switch (type_) {
				case 0:
					return $author$project$Icons$Platform2$attribute;
				case 1:
					return $author$project$Icons$Platform2$audiences;
				case 2:
					return $author$project$Icons$Platform2$audienceDefault;
				case 3:
					return $author$project$Icons$Platform2$average;
				case 4:
					return $author$project$Icons$Platform2$charts;
				default:
					return $author$project$Icons$Platform2$attribute;
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-row', moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (groupingLabel) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-operator', moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(groupingLabel)
								]));
					},
					A2(
						$elm_community$maybe_extra$Maybe$Extra$filter,
						function (_v1) {
							return !(!index);
						},
						$author$project$Platform2$Grouping$groupingPanelItemLabel(activeGrouping))),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item', moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-icon', moduleClass)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, icon)
								])),
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'names', moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm_community$html_extra$Html$Extra$viewIf,
									!_Utils_eq(subtitle, $elm$core$Maybe$Nothing),
									A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['names', 'subtitle']),
												moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(
												A2($elm$core$Maybe$withDefault, '', subtitle))
											]))),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$withStates,
											_List_fromArray(
												[
													_Utils_Tuple2(
													'subtitle-only',
													_Utils_eq(subtitle, $elm$core$Maybe$Nothing))
												]),
											A2(
												$GlobalWebIndex$class_namespaces$WeakCss$addMany,
												_List_fromArray(
													['names', 'title']),
												moduleClass))
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(title)
										]))
								])),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							isClearable,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'item-close-btn', moduleClass),
										$elm$html$Html$Events$onClick(
										clearItem(item))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Icons$icon,
										_List_fromArray(
											[
												$author$project$Icons$width(32),
												$author$project$Icons$height(32)
											]),
										$author$project$Icons$Platform2$cross)
									])))
						]))
				]));
	});
var $author$project$Platform2$GroupingPanel$placeholderMessageView = F2(
	function (moduleClass, content) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'placeholder-message', moduleClass)
				]),
			A2(
				$elm$core$List$map,
				function (_v0) {
					var format = _v0.a;
					var string = _v0.b;
					return A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('bold', format === 1)
									]),
								A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'placeholder-text', moduleClass))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(string)
							]));
				},
				content));
	});
var $author$project$Platform2$GroupingPanel$warningView = F2(
	function (moduleClass, warning) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'warning', moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$span,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['warning', 'icon']),
							moduleClass)
						]),
					_List_fromArray(
						[
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$warningTriangleIcon)
						])),
					warning
				]));
	});
var $author$project$Platform2$GroupingPanel$view = F2(
	function (moduleClass, config) {
		var loadingStateView = function (_v1) {
			return A2(
				$elm$html$Html$div,
				_List_Nil,
				_List_fromArray(
					[
						A2(
						$elm$html$Html$i,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'loading-bar', moduleClass)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'loading-state', moduleClass)
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$attribute),
								$elm$html$Html$text('Attributes loading…')
							]))
					]));
		};
		var itemsCount = $elm$core$List$length(config.f2);
		var maybePlaceholder = config.cO(itemsCount);
		var itemsView = (_Utils_eq(maybePlaceholder, $elm$core$Maybe$Nothing) ? A2(
			$elm$core$Basics$composeL,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$div(
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'full-height',
									_Utils_eq(maybePlaceholder, $elm$core$Maybe$Nothing))
								]),
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'items', moduleClass))
						])),
				$elm$core$List$singleton),
			$elm$html$Html$div(
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['items', 'content-scroll']),
						moduleClass)
					]))) : $elm$html$Html$div(
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
					_List_fromArray(
						['native-scroll']),
					A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'items', moduleClass))
				])))(
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_Nil,
					A2(
						$elm$core$List$indexedMap,
						A4($author$project$Platform2$GroupingPanel$itemView, moduleClass, config.ne, config.n1, config.po),
						config.f2))
				]));
		var placeholderView = function () {
			if (!maybePlaceholder.$) {
				var placeholders = maybePlaceholder.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'placeholder', moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'placeholder-icon', moduleClass)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, config.qv)
								])),
							A2($author$project$Platform2$GroupingPanel$placeholderMessageView, moduleClass, placeholders)
						]));
			} else {
				return A2($elm$html$Html$div, _List_Nil, _List_Nil);
			}
		}();
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass(moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'title', moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(config.Y)
								])),
							A2(
							$elm_community$html_extra$Html$Extra$viewIf,
							config.po,
							A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'clear-all-btn', moduleClass),
										$elm$html$Html$Events$onClick(config.n0),
										$elm$html$Html$Attributes$disabled(itemsCount <= 0)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Clear all')
									])))
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'groupings', moduleClass)
						]),
					A2(
						$elm$core$List$map,
						A2($author$project$Platform2$GroupingPanel$groupingView, moduleClass, config),
						config.o2)),
					A2($elm_community$html_extra$Html$Extra$viewIf, itemsCount > 0, itemsView),
					placeholderView,
					A2($elm_community$html_extra$Html$Extra$viewIfLazy, config.ps, loadingStateView),
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					$author$project$Platform2$GroupingPanel$warningView(moduleClass),
					config.L),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'buttons', moduleClass)
						]),
					A2(
						$elm$core$List$map,
						$author$project$Platform2$GroupingPanel$buttonView(moduleClass),
						config.aH))
				]));
	});
var $author$project$Dashboards2$ChartBrowser$view = F4(
	function (flags, store, zone, model) {
		var tabsPanelview = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'tabs-panel', $author$project$Dashboards2$ChartBrowser$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['tabs-panel', 'tabs']),
							$author$project$Dashboards2$ChartBrowser$moduleClass)
						]),
					A2(
						$elm$core$List$map,
						function (tab) {
							return A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'active',
												_Utils_eq(model.eo, tab))
											]),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['tabs-panel', 'tabs', 'tab']),
											$author$project$Dashboards2$ChartBrowser$moduleClass)),
										$elm$html$Html$Events$onClick(
										$author$project$Dashboards2$ChartBrowser$ChangeCurrentTab(tab))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Icons$icon,
										_List_Nil,
										$author$project$Dashboards2$ChartBrowser$tabToIcon(tab)),
										$elm$html$Html$text(
										$author$project$Dashboards2$ChartBrowser$tabToString(tab))
									]));
						},
						_List_fromArray(
							[0, 1, 2])))
				]));
		var selectedItemsCount = $elm$core$List$length(model.aE);
		var questionToChartAttributes = function (_v9) {
			var code = _v9.bW;
			var namespaceCode = _v9.id;
			var datapoints = _v9.er;
			var suffixes = _v9.rI;
			var toAttribute = F2(
				function (maybeSuffix, dtpCode) {
					return {
						eq: A3($author$project$Data$Labels$addSuffixToDatapointCode, code, maybeSuffix, dtpCode),
						id: namespaceCode,
						at: code
					};
				});
			if (!suffixes.$) {
				var suffixes_ = suffixes.a;
				return A2(
					$author$project$Gwi$List$fastConcatMap,
					function (suffix) {
						return A2(
							$elm$core$List$map,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.bW;
								},
								toAttribute(
									$elm$core$Maybe$Just(suffix.bW))),
							$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(datapoints));
					},
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(suffixes_));
			} else {
				return A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bW;
						},
						toAttribute($elm$core$Maybe$Nothing)),
					$turboMaCk$non_empty_list_alias$List$NonEmpty$toList(datapoints));
			}
		};
		var isSearching = !$elm$core$String$isEmpty(model.aR.cW);
		var searchBarView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'search-bar', $author$project$Dashboards2$ChartBrowser$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					isSearching,
					A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								$elm$html$Html$Events$onClick($author$project$Dashboards2$ChartBrowser$ClearSearch)
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$arrowLeft)
							]))),
					A2(
					$author$project$Platform2$SearchInput$view,
					{
						js: A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'search-bar', $author$project$Dashboards2$ChartBrowser$moduleClass),
						a: $author$project$Dashboards2$ChartBrowser$SearchInputMsg,
						cO: 'Search for a chart',
						rb: ''
					},
					model.aR)
				]));
		var goToChartBuilderButtonView = $author$project$CoolTip$Platform2$view(
			{
				lm: $elm$core$Maybe$Nothing,
				lB: 0,
				mt: _List_Nil,
				mu: _List_fromArray(
					[
						A2(
						$elm$html$Html$button,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'create-chart', $author$project$Dashboards2$ChartBrowser$moduleClass),
								$elm$html$Html$Events$onClick($author$project$Dashboards2$ChartBrowser$GoToChartBuilder)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Create a chart'),
								A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$plusSign)
							]))
					]),
				mE: _List_Nil,
				mF: $elm$html$Html$text('You will be redirected to the Chart tool'),
				mL: $author$project$CoolTip$Global,
				m2: _List_Nil
			});
		var getQuestion = function (questinInfo) {
			return A2(
				$author$project$Store$Platform2$getQuestionMaybe,
				A2($author$project$Data$Labels$addNamespaceToQuestionCode, questinInfo.id, questinInfo.at),
				store);
		};
		var filterBySearch = function (items) {
			return isSearching ? A3(
				$author$project$Search$filter,
				function ($) {
					return $.ld;
				},
				model.aR.cW,
				items) : items;
		};
		var prepareTableItems = F2(
			function (_v6, _v7) {
				var mine = _v6.eG;
				var folders = _v7.a;
				var charts = _v7.b;
				var sortIfNeeded = function () {
					var _v5 = model.eZ;
					if (!_v5.$) {
						var sortBy = _v5.a.cY;
						var direction = _v5.a.fH;
						return A2(
							$elm$core$Basics$composeR,
							$elm$core$List$sortWith(
								$author$project$Dashboards2$ChartBrowser$sortData(sortBy)),
							(direction === 1) ? $elm$core$List$reverse : $elm$core$Basics$identity);
					} else {
						return $elm$core$Basics$identity;
					}
				}();
				var isCompatible = function (chart) {
					var datasetsToNamespaces = A2($krisajenkins$remotedata$RemoteData$withDefault, $Janiczek$elm_bidict$BiDict$Assoc$empty, store.fC);
					var chartNamespaceCodes = A2(
						$elm$core$List$filterMap,
						function (code) {
							return A2($Janiczek$elm_bidict$BiDict$Assoc$get, code, datasetsToNamespaces);
						},
						chart.fB);
					return A2(
						$elm$core$List$all,
						function (namespaceCode) {
							return A4($author$project$Data$Platform2$isNamespaceCodeCompatibleWithDatasets, model.g0, datasetsToNamespaces, store.cB, namespaceCode);
						},
						chartNamespaceCodes);
				};
				var getInfoTooltip = function (chart) {
					return A2(
						$zwilias$elm_html_string$Html$String$toString,
						0,
						A2(
							$zwilias$elm_html_string$Html$String$div,
							_List_fromArray(
								[
									$zwilias$elm_html_string$Html$String$Attributes$class(
									$GlobalWebIndex$class_namespaces$WeakCss$toString(
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['table', 'rows', 'row', 'info-tooltip']),
											$author$project$Dashboards2$ChartBrowser$moduleClass)))
								]),
							A2(
								$elm$core$List$map,
								function (_v4) {
									var label = _v4.a;
									var value = _v4.b;
									return A2(
										$zwilias$elm_html_string$Html$String$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$zwilias$elm_html_string$Html$String$strong,
												_List_Nil,
												_List_fromArray(
													[
														$zwilias$elm_html_string$Html$String$text(label),
														$zwilias$elm_html_string$Html$String$text(': ')
													])),
												$zwilias$elm_html_string$Html$String$text(value)
											]));
								},
								_List_fromArray(
									[
										_Utils_Tuple2('Chart name', chart.ld),
										_Utils_Tuple2(
										'Base audience',
										A3(
											$elm_community$maybe_extra$Maybe$Extra$unwrap,
											$author$project$Data$Platform2$defaultAudienceName,
											A2(
												$elm$core$Basics$composeR,
												function ($) {
													return $.b;
												},
												$author$project$Data$Id$unwrap),
											chart.aU)),
										_Utils_Tuple2(
										'Questions',
										$elm$core$String$fromInt(
											$elm$core$List$length(
												$author$project$Data$Platform2$getChartQuestions(chart)))),
										_Utils_Tuple2(
										'Datapoints',
										$elm$core$String$fromInt(
											$elm$core$List$length(
												$author$project$Data$Platform2$getChartDatapoints(chart))))
									]))));
				};
				var folderItems = _Utils_eq(model.dj, $elm$core$Maybe$Nothing) ? sortIfNeeded(
					filterBySearch(
						A2(
							$elm$core$List$map,
							function (folder) {
								return {
									cd: $author$project$Dashboards2$ChartBrowser$OpenChartFolder(
										$elm$core$Maybe$Just(folder.b)),
									bB: folder.bB,
									h$: false,
									dv: true,
									pv: false,
									pw: false,
									cA: $author$project$Dashboards2$ChartBrowser$FolderRow,
									ld: folder.ld,
									bN: folder.bN
								};
							},
							$turboMaCk$any_dict$Dict$Any$values(folders)))) : _List_Nil;
				return _Utils_ap(
					folderItems,
					sortIfNeeded(
						filterBySearch(
							A2(
								$elm$core$List$filterMap,
								function (chart) {
									return (_Utils_eq(chart.oP, model.dj) || (isSearching || (!mine))) ? $elm$core$Maybe$Just(
										{
											cd: $author$project$Dashboards2$ChartBrowser$ToggleSelection(
												$author$project$Dashboards2$ChartBrowser$SelectedChart(chart)),
											bB: chart.bB,
											h$: false,
											dv: chart.dv,
											pv: A2(
												$elm$core$List$member,
												$author$project$Dashboards2$ChartBrowser$SelectedChart(chart),
												model.aE),
											pw: chart.pw,
											cA: $author$project$Dashboards2$ChartBrowser$ChartRow(
												{
													fo: chart,
													hY: !isCompatible(chart),
													kB: getInfoTooltip(chart)
												}),
											ld: chart.ld,
											bN: chart.bN
										}) : $elm$core$Maybe$Nothing;
								},
								$turboMaCk$any_dict$Dict$Any$values(charts)))));
			});
		var chartsListView = function (arg) {
			var mine = arg.eG;
			return A2(
				$author$project$Dashboards2$ChartBrowser$remoteDataView,
				function (data) {
					var items = mine ? A2(
						$elm$core$List$filter,
						function ($) {
							return $.dv;
						},
						A2(prepareTableItems, arg, data)) : A2(
						$elm$core$List$filter,
						function (i) {
							return i.pw && (!i.dv);
						},
						A2(prepareTableItems, arg, data));
					return (!$elm$core$List$isEmpty(items)) ? A4(
						$author$project$Dashboards2$ChartBrowser$tableView,
						flags,
						{f2: items},
						zone,
						model) : (isSearching ? $author$project$Dashboards2$ChartBrowser$emptySearchResultsView(model.aR.cW) : $author$project$Dashboards2$ChartBrowser$emptyTableView(arg));
				},
				A3($krisajenkins$remotedata$RemoteData$map2, $elm$core$Tuple$pair, store.jE, store.fr));
		};
		var breadcrumbsView = A2(
			$elm_community$html_extra$Html$Extra$viewMaybe,
			function (folder) {
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'breadcrumbs', $author$project$Dashboards2$ChartBrowser$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['breadcrumbs', 'link']),
									$author$project$Dashboards2$ChartBrowser$moduleClass),
									$elm$html$Html$Events$onClick(
									$author$project$Dashboards2$ChartBrowser$OpenChartFolder($elm$core$Maybe$Nothing))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text('All charts')
								])),
							A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$chevronRight),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['breadcrumbs', 'current-item']),
									$author$project$Dashboards2$ChartBrowser$moduleClass)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(folder.ld)
								]))
						]));
			},
			A2(
				$elm$core$Maybe$andThen,
				function (folderId) {
					return A2(
						$elm$core$Maybe$andThen,
						$turboMaCk$any_dict$Dict$Any$get(folderId),
						$krisajenkins$remotedata$RemoteData$toMaybe(store.jE));
				},
				model.dj));
		var addWidgetAction = A2(
			$elm$core$Maybe$map,
			$author$project$Dashboards2$ChartBrowser$CreateWidgets,
			A2(
				$elm$core$Maybe$andThen,
				$turboMaCk$non_empty_list_alias$List$NonEmpty$fromList,
				A3(
					$elm$core$List$foldr,
					function (selected) {
						if (!selected.$) {
							var chart = selected.a;
							return $elm$core$Maybe$map(
								$elm$core$List$cons(
									{d7: chart.d7, aU: chart.aU, nV: chart.nV, kp: chart.kp, ld: chart.ld}));
						} else {
							var qInfo = selected.a;
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$elm$core$Basics$always($elm$core$Maybe$Nothing),
								function (questionV2) {
									return $elm$core$Maybe$map(
										$elm$core$List$cons(
											{
												d7: questionToChartAttributes(questionV2),
												aU: $elm$core$Maybe$Nothing,
												nV: 3,
												kp: 0,
												ld: questionV2.ld
											}));
								},
								getQuestion(qInfo));
						}
					},
					$elm$core$Maybe$Just(_List_Nil),
					model.aE)));
		var groupingPanelConfig = {
			ne: 0,
			aH: _List_fromArray(
				[
					function () {
					if (!addWidgetAction.$) {
						var action = addWidgetAction.a;
						return {
							fI: $elm$core$List$isEmpty(model.aE),
							h4: 'Add ' + ($elm$core$String$fromInt(selectedItemsCount) + A2($author$project$Plural$fromInt, selectedItemsCount, ' chart')),
							cL: action
						};
					} else {
						return {
							fI: $elm$core$List$isEmpty(model.aE),
							h4: 'Add charts',
							cL: $author$project$Dashboards2$ChartBrowser$NoOp
						};
					}
				}()
				]),
			n0: $author$project$Dashboards2$ChartBrowser$ClearAll,
			n1: $author$project$Dashboards2$ChartBrowser$ToggleSelection,
			o2: _List_Nil,
			po: true,
			ps: false,
			f2: A2(
				$elm$core$List$map,
				function (item) {
					if (!item.$) {
						var chart = item.a;
						return {kS: item, rH: $elm$core$Maybe$Nothing, Y: chart.ld, mL: 4};
					} else {
						var q = item.a;
						return {kS: item, rH: q.hB, Y: q.ld, mL: 4};
					}
				},
				model.aE),
			cO: function (num) {
				return (!num) ? $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(0, 'Add one or more '),
							_Utils_Tuple2(1, 'charts'),
							_Utils_Tuple2(0, ' to start building your'),
							_Utils_Tuple2(0, ' dashboard')
						])) : ((num < 4) ? $elm$core$Maybe$Just(
					_List_fromArray(
						[
							_Utils_Tuple2(0, 'Continue adding '),
							_Utils_Tuple2(1, 'charts'),
							_Utils_Tuple2(0, ' to start building your'),
							_Utils_Tuple2(0, ' dashboard')
						])) : $elm$core$Maybe$Nothing);
			},
			qv: $author$project$Icons$Platform2$groupingPanelPlaceholderCharts,
			Y: 'Add to your dashboard',
			L: $elm$core$Maybe$Nothing
		};
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					$GlobalWebIndex$class_namespaces$WeakCss$toClass($author$project$Dashboards2$ChartBrowser$moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'left', $author$project$Dashboards2$ChartBrowser$moduleClass)
						]),
					_List_fromArray(
						[
							searchBarView,
							tabsPanelview,
							goToChartBuilderButtonView,
							breadcrumbsView,
							function () {
							var _v0 = model.eo;
							switch (_v0) {
								case 0:
									return chartsListView(
										{eG: true});
								case 1:
									return chartsListView(
										{eG: false});
								default:
									return A2($author$project$Dashboards2$ChartBrowser$questionChartsView, store, model);
							}
						}()
						])),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'right', $author$project$Dashboards2$ChartBrowser$moduleClass)
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Platform2$GroupingPanel$view,
							A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'grouping-panel', $author$project$Dashboards2$ChartBrowser$moduleClass),
							groupingPanelConfig)
						]))
				]));
	});
var $author$project$Data$GettableKeyValueHeader$unwrap = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return _Utils_Tuple2(key, value);
};
var $author$project$Platform2$AudienceExpressionViewer$view = F3(
	function (flags, moduleClass, expression) {
		var userEncoded = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'token',
					$elm$json$Json$Encode$string(flags.i$)),
					_Utils_Tuple2(
					'email',
					$elm$json$Json$Encode$string(flags.mQ.j))
				]));
		var uri = $author$project$Config$Main$get(flags.j8).dV;
		var encodedViewOnlyHeaders = function () {
			var unwrappedHeaders = A2(
				$elm$core$List$map,
				$author$project$Data$GettableKeyValueHeader$unwrap,
				A2($elm$core$Maybe$withDefault, _List_Nil, flags.oG));
			var headerValues = _Utils_ap(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq('GWI-View-Only-Entity-Type')),
					unwrappedHeaders),
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						$elm$core$Tuple$first,
						$elm$core$Basics$eq('GWI-View-Only-Entity-ID')),
					unwrappedHeaders));
			var _v0 = A2($elm$core$List$map, $elm$core$Tuple$second, headerValues);
			if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
				var entityType = _v0.a;
				var _v1 = _v0.b;
				var entityId = _v1.a;
				return A2(
					$elm$json$Json$Encode$encode,
					0,
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'entityType',
								$elm$json$Json$Encode$string(entityType)),
								_Utils_Tuple2(
								'entityId',
								$elm$json$Json$Encode$string(entityId))
							])));
			} else {
				return '';
			}
		}();
		var encodedExpression = A2(
			$elm$json$Json$Encode$encode,
			0,
			$author$project$Data$Audience$Expression$encodeV2(expression));
		var apiEncoded = $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'SERVICE_LAYER_HOST',
					$elm$json$Json$Encode$string(uri.eS))
				]));
		var encodedConfig = A2(
			$elm$json$Json$Encode$encode,
			0,
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'environment',
						$elm$json$Json$Encode$string(
							$author$project$Config$Main$stageToString(flags.j8))),
						_Utils_Tuple2('api', apiEncoded),
						_Utils_Tuple2('user', userEncoded)
					])));
		return A3(
			$elm$html$Html$Keyed$node,
			'x-et-audience-expression-viewer',
			A3(
				$author$project$Gwi$List$appendIf,
				encodedViewOnlyHeaders !== '',
				A2($elm$html$Html$Attributes$attribute, 'view-only-headers', encodedViewOnlyHeaders),
				_List_fromArray(
					[
						A2($elm$html$Html$Attributes$attribute, 'x-env-values', encodedConfig),
						A2($elm$html$Html$Attributes$attribute, 'expression', encodedExpression),
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'expression-viewer', moduleClass)
					])),
			_List_Nil);
	});
var $author$project$Platform2$Input$Text$defaultConfig = {
	fs: $GlobalWebIndex$class_namespaces$WeakCss$namespace('form-control'),
	dq: $elm$core$Maybe$Nothing,
	b: '',
	f6: $elm$core$Maybe$Nothing,
	gm: $elm$core$Maybe$Nothing,
	cO: '',
	c5: ''
};
var $elm$html$Html$Attributes$autofocus = $elm$html$Html$Attributes$boolProperty('autofocus');
var $elm$html$Html$Events$keyCode = A2($elm$json$Json$Decode$field, 'keyCode', $elm$json$Json$Decode$int);
var $elm_community$html_extra$Html$Events$Extra$onEnter = function (onEnterAction) {
	return A2(
		$elm$html$Html$Events$on,
		'keyup',
		A2(
			$elm$json$Json$Decode$andThen,
			function (keyCode) {
				return (keyCode === 13) ? $elm$json$Json$Decode$succeed(onEnterAction) : $elm$json$Json$Decode$fail(
					$elm$core$String$fromInt(keyCode));
			},
			$elm$html$Html$Events$keyCode));
};
var $author$project$Platform2$Input$Text$render = F2(
	function (required, config) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'control', config.fs)
				]),
			_List_fromArray(
				[
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (icon_) {
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'icon', config.fs)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, icon_)
								]));
					},
					config.dq),
					A2(
					$elm$html$Html$input,
					_List_fromArray(
						[
							A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'input', config.fs),
							$elm$html$Html$Events$onInput(required.go),
							$elm$html$Html$Attributes$placeholder(required.cO),
							$elm$html$Html$Attributes$value(config.c5),
							$elm$html$Html$Attributes$id(config.b),
							$elm$html$Html$Attributes$autocomplete(false),
							$elm$html$Html$Attributes$autofocus(true),
							A2($elm_community$html_extra$Html$Attributes$Extra$attributeMaybe, $elm_community$html_extra$Html$Events$Extra$onEnter, config.gm)
						]),
					_List_Nil),
					A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (limit_) {
						return A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withStates,
									_List_fromArray(
										[
											_Utils_Tuple2(
											'reached',
											_Utils_cmp(
												$elm$core$String$length(config.c5),
												limit_ - 10) > -1)
										]),
									A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'char-limit', config.fs))
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									$elm$core$String$concat(
										_List_fromArray(
											[
												$elm$core$String$fromInt(
												$elm$core$String$length(config.c5)),
												'/',
												$elm$core$String$fromInt(limit_)
											])))
								]));
					},
					config.f6)
				]));
	});
var $author$project$Platform2$Input$Text$view = F2(
	function (required, attributes) {
		return A2(
			$author$project$Platform2$Input$Text$render,
			required,
			A3(
				$elm$core$List$foldl,
				F2(
					function (_v0, config) {
						var attribute = _v0;
						return attribute(config);
					}),
				$author$project$Platform2$Input$Text$defaultConfig,
				attributes));
	});
var $elm$html$Html$Attributes$name = $elm$html$Html$Attributes$stringProperty('name');
var $elm_community$html_extra$Html$Events$Extra$onChange = function (onChangeAction) {
	return A2(
		$elm$html$Html$Events$on,
		'change',
		A2($elm$json$Json$Decode$map, onChangeAction, $elm$html$Html$Events$targetValue));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlJson(value));
	});
var $elm$html$Html$Attributes$property = $elm$virtual_dom$VirtualDom$property;
var $author$project$Platform2$RadioButton$view = function (_v0) {
	var className = _v0.hi;
	var groupName = _v0.o0;
	var value = _v0.c5;
	var label = _v0.h4;
	var msg = _v0.a;
	var state = _v0.rA;
	var getInfo = _v0.oU;
	var id = groupName + ('_' + value);
	var checkedOrDisabled = function () {
		if (!state) {
			return A2(
				$elm$html$Html$Attributes$property,
				'checked',
				$elm$json$Json$Encode$bool(true));
		} else {
			return $elm_community$html_extra$Html$Attributes$Extra$empty;
		}
	}();
	return A2(
		$elm$html$Html$span,
		_List_fromArray(
			[
				$GlobalWebIndex$class_namespaces$WeakCss$toClass(className)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$input,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$id(id),
						$elm$html$Html$Attributes$name(groupName),
						$elm$html$Html$Attributes$type_('radio'),
						$elm$html$Html$Attributes$value(value),
						checkedOrDisabled,
						$elm_community$html_extra$Html$Events$Extra$onChange(msg)
					]),
				_List_Nil),
				A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$for(id)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'label-text', className),
								A2($elm$html$Html$Attributes$attribute, 'data-text', label)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(label)
							]))
					])),
				A2(
				$elm_community$html_extra$Html$Extra$viewMaybe,
				A2(
					$elm$core$Basics$composeL,
					A2(
						$elm$core$Basics$composeL,
						$elm$html$Html$div(
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['label-text', 'info']),
									className)
								])),
						$elm$core$List$singleton),
					$elm$html$Html$text),
				getInfo)
			]));
};
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $author$project$Dashboards2$viewShareModalAfterFooterContent = F3(
	function (config, maybeDashboardId, className) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['share-modal', 'after-footer']),
					className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$hr,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['share-modal', 'hr']),
							className)
						]),
					_List_Nil),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['share-modal', 'after-footer', 'copy-link-container']),
							className)
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$button,
							A2(
								$elm$core$List$cons,
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['share-modal', 'after-footer', 'copy-link-container', 'button']),
									$author$project$Dashboards2$moduleClass),
								function () {
									if (!maybeDashboardId.$) {
										var dashboardId = maybeDashboardId.a;
										return _List_fromArray(
											[
												$elm$html$Html$Events$onClick(
												config.a(
													$author$project$Dashboards2$CopyDashboardLink(dashboardId)))
											]);
									} else {
										return _List_Nil;
									}
								}()),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$link),
									$elm$html$Html$text('Copy link')
								])),
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['share-modal', 'after-footer', 'copy-link-container', 'copy']),
									className)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$info),
									$elm$html$Html$text('Anyone with the link can view and duplicate your dashboard,' + ' depending on their data plan')
								]))
						]))
				]));
	});
var $author$project$Dashboards2$ClearBulkOrgAdd = {$: 110};
var $author$project$Dashboards2$GenerateOadLink = {$: 134};
var $author$project$Dashboards2$RemoveLastBulkAddOrganisation = function (a) {
	return {$: 111, a: a};
};
var $author$project$Dashboards2$RemoveLastBulkAddUser = function (a) {
	return {$: 112, a: a};
};
var $author$project$Dashboards2$RemoveOriginalSharedOrg = function (a) {
	return {$: 131, a: a};
};
var $author$project$Dashboards2$RemoveOriginalSharedUser = function (a) {
	return {$: 132, a: a};
};
var $author$project$Dashboards2$SelectShared = function (a) {
	return {$: 100, a: a};
};
var $author$project$Dashboards2$ToggleOwnOrgSharing = {$: 101};
var $author$project$Dashboards2$TogglePublicSharing = {$: 102};
var $author$project$Dashboards2$ValidateBulkOrgAddIds = F2(
	function (a, b) {
		return {$: 108, a: a, b: b};
	});
var $author$project$Icons$Platform2$crossSmall = {
	mr: $author$project$Icons$Platform2$path('M9.743.257c.314.313.34.806.079 1.15l-.079.089L6.24 5l3.503 3.504c.343.342.343.897 0 1.24-.313.313-.806.34-1.15.078l-.089-.079L5 6.24 1.496 9.743c-.342.343-.897.343-1.24 0-.313-.313-.34-.806-.078-1.15l.079-.089L3.76 5 .257 1.496c-.343-.342-.343-.897 0-1.24.313-.313.806-.34 1.15-.078l.089.079L5 3.76 8.504.257c.342-.343.897-.343 1.24 0z'),
	e5: 10,
	mT: 0,
	mU: 0,
	e6: 10
};
var $author$project$Icons$Platform2$earth = {
	mr: A2(
		$elm$svg$Svg$g,
		_List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('currentColor')
			]),
		_List_fromArray(
			[
				A2(
				$elm$svg$Svg$path,
				_List_fromArray(
					[
						$elm$svg$Svg$Attributes$transform('translate(4 4)'),
						$elm$svg$Svg$Attributes$d('M9.9 19.4303V16.7515L11.5203 15.1312L8.60296 13.4642L7.6 12.2105V13L6.4382 13.2107L5.3943 10.4269C5.20272 11.0847 5.1 11.7804 5.1 12.5C5.1 15.672 7.09572 18.3778 9.9 19.4303ZM15.6 5.77866V11.4485L13.7515 9.6H11.3L10.2922 10.9437L10.7485 11.4H12.6V12.8183L13.3211 13.9H15.7172L18.7651 16.4399C19.484 15.2991 19.9 13.9481 19.9 12.5C19.9 9.52001 18.1385 6.95143 15.6 5.77866ZM15.6 4.47567C18.8178 5.71962 21.1 8.84329 21.1 12.5C21.1 17.2497 17.2496 21.1 12.5 21.1C7.75035 21.1 3.9 17.2497 3.9 12.5C3.9 7.75035 7.75035 3.9 12.5 3.9C13.5164 3.9 14.4915 4.07631 15.3966 4.4H15.6V4.47567Z')
					]),
				_List_Nil)
			])),
	e5: 32,
	mT: 0,
	mU: 0,
	e6: 32
};
var $author$project$Palette$avatarsPalette = $elm$core$Array$fromList(
	_List_fromArray(
		['#963CBD', '#008851', '#007CB6', '#DE1B76']));
var $author$project$Palette$p2AvatarColorFromIndex = function (index) {
	return A2(
		$elm$core$Result$withDefault,
		'#fff',
		A2($author$project$Palette$cycledColor, $author$project$Palette$avatarsPalette, index));
};
var $elm$svg$Svg$Attributes$textAnchor = _VirtualDom_attribute('text-anchor');
var $author$project$Platform2$AutocompleteInput$ChangedIndex = function (a) {
	return {$: 11, a: a};
};
var $author$project$Platform2$AutocompleteInput$FocusInput = function (a) {
	return {$: 8, a: a};
};
var $author$project$Platform2$AutocompleteInput$InputBlur = function (a) {
	return {$: 10, a: a};
};
var $author$project$Platform2$AutocompleteInput$OnEnter = function (a) {
	return {$: 2, a: a};
};
var $author$project$Platform2$AutocompleteInput$OnInput = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Platform2$AutocompleteInput$RemoveItemFromSelected = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $ohanhi$keyboard$Keyboard$Backspace = {$: 26};
var $robinheghan$keyboard_events$Keyboard$Events$Keydown = 0;
var $robinheghan$keyboard_events$Keyboard$Events$eventToString = function (event) {
	switch (event) {
		case 0:
			return 'keydown';
		case 1:
			return 'keyup';
		default:
			return 'keypress';
	}
};
var $ohanhi$keyboard$Keyboard$Clear = {$: 27};
var $ohanhi$keyboard$Keyboard$Copy = {$: 28};
var $ohanhi$keyboard$Keyboard$CrSel = {$: 29};
var $ohanhi$keyboard$Keyboard$Cut = {$: 30};
var $ohanhi$keyboard$Keyboard$Delete = {$: 31};
var $ohanhi$keyboard$Keyboard$EraseEof = {$: 32};
var $ohanhi$keyboard$Keyboard$ExSel = {$: 33};
var $ohanhi$keyboard$Keyboard$Insert = {$: 34};
var $ohanhi$keyboard$Keyboard$Paste = {$: 35};
var $ohanhi$keyboard$Keyboard$Redo = {$: 36};
var $ohanhi$keyboard$Keyboard$Undo = {$: 37};
var $ohanhi$keyboard$Keyboard$editingKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'Backspace':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Backspace);
		case 'Clear':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Clear);
		case 'Copy':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Copy);
		case 'CrSel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CrSel);
		case 'Cut':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Cut);
		case 'Delete':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Delete);
		case 'EraseEof':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$EraseEof);
		case 'ExSel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ExSel);
		case 'Insert':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Insert);
		case 'Paste':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Paste);
		case 'Redo':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Redo);
		case 'Undo':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Undo);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$F1 = {$: 38};
var $ohanhi$keyboard$Keyboard$F10 = {$: 47};
var $ohanhi$keyboard$Keyboard$F11 = {$: 48};
var $ohanhi$keyboard$Keyboard$F12 = {$: 49};
var $ohanhi$keyboard$Keyboard$F13 = {$: 50};
var $ohanhi$keyboard$Keyboard$F14 = {$: 51};
var $ohanhi$keyboard$Keyboard$F15 = {$: 52};
var $ohanhi$keyboard$Keyboard$F16 = {$: 53};
var $ohanhi$keyboard$Keyboard$F17 = {$: 54};
var $ohanhi$keyboard$Keyboard$F18 = {$: 55};
var $ohanhi$keyboard$Keyboard$F19 = {$: 56};
var $ohanhi$keyboard$Keyboard$F2 = {$: 39};
var $ohanhi$keyboard$Keyboard$F20 = {$: 57};
var $ohanhi$keyboard$Keyboard$F3 = {$: 40};
var $ohanhi$keyboard$Keyboard$F4 = {$: 41};
var $ohanhi$keyboard$Keyboard$F5 = {$: 42};
var $ohanhi$keyboard$Keyboard$F6 = {$: 43};
var $ohanhi$keyboard$Keyboard$F7 = {$: 44};
var $ohanhi$keyboard$Keyboard$F8 = {$: 45};
var $ohanhi$keyboard$Keyboard$F9 = {$: 46};
var $ohanhi$keyboard$Keyboard$functionKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'F1':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F1);
		case 'F2':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F2);
		case 'F3':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F3);
		case 'F4':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F4);
		case 'F5':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F5);
		case 'F6':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F6);
		case 'F7':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F7);
		case 'F8':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F8);
		case 'F9':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F9);
		case 'F10':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F10);
		case 'F11':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F11);
		case 'F12':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F12);
		case 'F13':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F13);
		case 'F14':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F14);
		case 'F15':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F15);
		case 'F16':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F16);
		case 'F17':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F17);
		case 'F18':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F18);
		case 'F19':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F19);
		case 'F20':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$F20);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$ChannelDown = {$: 85};
var $ohanhi$keyboard$Keyboard$ChannelUp = {$: 86};
var $ohanhi$keyboard$Keyboard$MediaFastForward = {$: 87};
var $ohanhi$keyboard$Keyboard$MediaPause = {$: 88};
var $ohanhi$keyboard$Keyboard$MediaPlay = {$: 89};
var $ohanhi$keyboard$Keyboard$MediaPlayPause = {$: 90};
var $ohanhi$keyboard$Keyboard$MediaRecord = {$: 91};
var $ohanhi$keyboard$Keyboard$MediaRewind = {$: 92};
var $ohanhi$keyboard$Keyboard$MediaStop = {$: 93};
var $ohanhi$keyboard$Keyboard$MediaTrackNext = {$: 94};
var $ohanhi$keyboard$Keyboard$MediaTrackPrevious = {$: 95};
var $ohanhi$keyboard$Keyboard$mediaKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'ChannelDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ChannelDown);
		case 'ChannelUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ChannelUp);
		case 'MediaFastForward':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaFastForward);
		case 'MediaPause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPause);
		case 'MediaPlay':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPlay);
		case 'MediaPlayPause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaPlayPause);
		case 'MediaRecord':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaRecord);
		case 'MediaRewind':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaRewind);
		case 'MediaStop':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaStop);
		case 'MediaTrackNext':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaTrackNext);
		case 'MediaTrackPrevious':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MediaTrackPrevious);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Alt = {$: 1};
var $ohanhi$keyboard$Keyboard$AltGraph = {$: 2};
var $ohanhi$keyboard$Keyboard$CapsLock = {$: 3};
var $ohanhi$keyboard$Keyboard$Control = {$: 4};
var $ohanhi$keyboard$Keyboard$Fn = {$: 5};
var $ohanhi$keyboard$Keyboard$FnLock = {$: 6};
var $ohanhi$keyboard$Keyboard$Hyper = {$: 7};
var $ohanhi$keyboard$Keyboard$Meta = {$: 8};
var $ohanhi$keyboard$Keyboard$NumLock = {$: 9};
var $ohanhi$keyboard$Keyboard$ScrollLock = {$: 10};
var $ohanhi$keyboard$Keyboard$Shift = {$: 11};
var $ohanhi$keyboard$Keyboard$Super = {$: 12};
var $ohanhi$keyboard$Keyboard$Symbol = {$: 13};
var $ohanhi$keyboard$Keyboard$SymbolLock = {$: 14};
var $ohanhi$keyboard$Keyboard$modifierKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'Alt':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Alt);
		case 'AltGraph':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$AltGraph);
		case 'CapsLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CapsLock);
		case 'Control':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Control);
		case 'Fn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Fn);
		case 'FnLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$FnLock);
		case 'Hyper':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Hyper);
		case 'Meta':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Meta);
		case 'NumLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$NumLock);
		case 'ScrollLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ScrollLock);
		case 'Shift':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Shift);
		case 'Super':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Super);
		case 'OS':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Super);
		case 'Symbol':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Symbol);
		case 'SymbolLock':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$SymbolLock);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$ArrowDown = {$: 18};
var $ohanhi$keyboard$Keyboard$ArrowLeft = {$: 19};
var $ohanhi$keyboard$Keyboard$ArrowRight = {$: 20};
var $ohanhi$keyboard$Keyboard$ArrowUp = {$: 21};
var $ohanhi$keyboard$Keyboard$End = {$: 22};
var $ohanhi$keyboard$Keyboard$Home = {$: 23};
var $ohanhi$keyboard$Keyboard$PageDown = {$: 24};
var $ohanhi$keyboard$Keyboard$PageUp = {$: 25};
var $ohanhi$keyboard$Keyboard$navigationKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'ArrowDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowDown);
		case 'ArrowLeft':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft);
		case 'ArrowRight':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight);
		case 'ArrowUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowUp);
		case 'Down':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowDown);
		case 'Left':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowLeft);
		case 'Right':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowRight);
		case 'Up':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ArrowUp);
		case 'End':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$End);
		case 'Home':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Home);
		case 'PageDown':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$PageDown);
		case 'PageUp':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$PageUp);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$oneOf = F2(
	function (fns, key) {
		oneOf:
		while (true) {
			if (!fns.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var fn = fns.a;
				var rest = fns.b;
				var _v1 = fn(key);
				if (!_v1.$) {
					var a = _v1.a;
					return $elm$core$Maybe$Just(a);
				} else {
					var $temp$fns = rest,
						$temp$key = key;
					fns = $temp$fns;
					key = $temp$key;
					continue oneOf;
				}
			}
		}
	});
var $ohanhi$keyboard$Keyboard$AppSwitch = {$: 73};
var $ohanhi$keyboard$Keyboard$Call = {$: 74};
var $ohanhi$keyboard$Keyboard$Camera = {$: 75};
var $ohanhi$keyboard$Keyboard$CameraFocus = {$: 76};
var $ohanhi$keyboard$Keyboard$EndCall = {$: 77};
var $ohanhi$keyboard$Keyboard$GoBack = {$: 78};
var $ohanhi$keyboard$Keyboard$GoHome = {$: 79};
var $ohanhi$keyboard$Keyboard$HeadsetHook = {$: 80};
var $ohanhi$keyboard$Keyboard$LastNumberRedial = {$: 81};
var $ohanhi$keyboard$Keyboard$MannerMode = {$: 83};
var $ohanhi$keyboard$Keyboard$Notification = {$: 82};
var $ohanhi$keyboard$Keyboard$VoiceDial = {$: 84};
var $ohanhi$keyboard$Keyboard$phoneKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'AppSwitch':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$AppSwitch);
		case 'Call':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Call);
		case 'Camera':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Camera);
		case 'CameraFocus':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$CameraFocus);
		case 'EndCall':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$EndCall);
		case 'GoBack':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$GoBack);
		case 'GoHome':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$GoHome);
		case 'HeadsetHook':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$HeadsetHook);
		case 'LastNumberRedial':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$LastNumberRedial);
		case 'Notification':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Notification);
		case 'MannerMode':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$MannerMode);
		case 'VoiceDial':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$VoiceDial);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Again = {$: 58};
var $ohanhi$keyboard$Keyboard$Attn = {$: 59};
var $ohanhi$keyboard$Keyboard$Cancel = {$: 60};
var $ohanhi$keyboard$Keyboard$ContextMenu = {$: 61};
var $ohanhi$keyboard$Keyboard$Escape = {$: 62};
var $ohanhi$keyboard$Keyboard$Execute = {$: 63};
var $ohanhi$keyboard$Keyboard$Find = {$: 64};
var $ohanhi$keyboard$Keyboard$Finish = {$: 65};
var $ohanhi$keyboard$Keyboard$Help = {$: 66};
var $ohanhi$keyboard$Keyboard$Pause = {$: 67};
var $ohanhi$keyboard$Keyboard$Play = {$: 68};
var $ohanhi$keyboard$Keyboard$Props = {$: 69};
var $ohanhi$keyboard$Keyboard$Select = {$: 70};
var $ohanhi$keyboard$Keyboard$ZoomIn = {$: 71};
var $ohanhi$keyboard$Keyboard$ZoomOut = {$: 72};
var $ohanhi$keyboard$Keyboard$uiKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'Again':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Again);
		case 'Attn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Attn);
		case 'Cancel':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Cancel);
		case 'ContextMenu':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ContextMenu);
		case 'Escape':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Escape);
		case 'Execute':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Execute);
		case 'Find':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Find);
		case 'Finish':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Finish);
		case 'Help':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Help);
		case 'Pause':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Pause);
		case 'Play':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Play);
		case 'Props':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Props);
		case 'Select':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Select);
		case 'ZoomIn':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ZoomIn);
		case 'ZoomOut':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$ZoomOut);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$Enter = {$: 15};
var $ohanhi$keyboard$Keyboard$Spacebar = {$: 17};
var $ohanhi$keyboard$Keyboard$Tab = {$: 16};
var $ohanhi$keyboard$Keyboard$whitespaceKey = function (_v0) {
	var value = _v0;
	switch (value) {
		case 'Enter':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Enter);
		case 'Tab':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Tab);
		case 'Spacebar':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Spacebar);
		case ' ':
			return $elm$core$Maybe$Just($ohanhi$keyboard$Keyboard$Spacebar);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $ohanhi$keyboard$Keyboard$anyKeyWith = function (charParser) {
	return $ohanhi$keyboard$Keyboard$oneOf(
		_List_fromArray(
			[$ohanhi$keyboard$Keyboard$whitespaceKey, charParser, $ohanhi$keyboard$Keyboard$modifierKey, $ohanhi$keyboard$Keyboard$navigationKey, $ohanhi$keyboard$Keyboard$editingKey, $ohanhi$keyboard$Keyboard$functionKey, $ohanhi$keyboard$Keyboard$uiKey, $ohanhi$keyboard$Keyboard$phoneKey, $ohanhi$keyboard$Keyboard$mediaKey]));
};
var $ohanhi$keyboard$Keyboard$Character = function (a) {
	return {$: 0, a: a};
};
var $ohanhi$keyboard$Keyboard$characterKeyUpper = function (_v0) {
	var value = _v0;
	return ($elm$core$String$length(value) === 1) ? $elm$core$Maybe$Just(
		$ohanhi$keyboard$Keyboard$Character(
			$elm$core$String$toUpper(value))) : $elm$core$Maybe$Nothing;
};
var $ohanhi$keyboard$Keyboard$anyKeyUpper = $ohanhi$keyboard$Keyboard$anyKeyWith($ohanhi$keyboard$Keyboard$characterKeyUpper);
var $ohanhi$keyboard$Keyboard$RawKey = $elm$core$Basics$identity;
var $ohanhi$keyboard$Keyboard$eventKeyDecoder = A2(
	$elm$json$Json$Decode$field,
	'key',
	A2($elm$json$Json$Decode$map, $elm$core$Basics$identity, $elm$json$Json$Decode$string));
var $robinheghan$keyboard_events$Keyboard$Events$messageSelector = function (decisionMap) {
	var helper = function (maybeKey) {
		if (maybeKey.$ === 1) {
			return $elm$json$Json$Decode$fail('No key we\'re interested in');
		} else {
			var key = maybeKey.a;
			return A2(
				$elm$core$Maybe$withDefault,
				$elm$json$Json$Decode$fail('No key we\'re interested in'),
				A2(
					$elm$core$Maybe$map,
					$elm$json$Json$Decode$succeed,
					A2(
						$elm$core$Maybe$map,
						$elm$core$Tuple$second,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								function (_v1) {
									var k = _v1.a;
									return _Utils_eq(k, key);
								},
								decisionMap)))));
		}
	};
	return A2(
		$elm$json$Json$Decode$andThen,
		helper,
		A2($elm$json$Json$Decode$map, $ohanhi$keyboard$Keyboard$anyKeyUpper, $ohanhi$keyboard$Keyboard$eventKeyDecoder));
};
var $robinheghan$keyboard_events$Keyboard$Events$on = F2(
	function (event, decisionMap) {
		return A2(
			$elm$html$Html$Events$on,
			$robinheghan$keyboard_events$Keyboard$Events$eventToString(event),
			$robinheghan$keyboard_events$Keyboard$Events$messageSelector(decisionMap));
	});
var $author$project$Gwi$Html$Events$onKey = F2(
	function (key, msg) {
		return A2(
			$robinheghan$keyboard_events$Keyboard$Events$on,
			0,
			_List_fromArray(
				[
					_Utils_Tuple2(key, msg)
				]));
	});
var $author$project$Gwi$Html$Events$onBackspace = function (msg) {
	return A2($author$project$Gwi$Html$Events$onKey, $ohanhi$keyboard$Keyboard$Backspace, msg);
};
var $elm$html$Html$Events$onBlur = function (msg) {
	return A2(
		$elm$html$Html$Events$on,
		'blur',
		$elm$json$Json$Decode$succeed(msg));
};
var $author$project$Platform2$AutocompleteInput$onKeyDown = F3(
	function (msgs, selectionIndex, options) {
		var newIndex = function (operator) {
			return $elm$json$Json$Decode$succeed(
				msgs.jC(
					A2(
						$elm$core$Basics$modBy,
						$elm$core$List$length(options),
						A2(operator, selectionIndex, 1))));
		};
		var isArrowKey = function (keyName) {
			switch (keyName) {
				case 'ArrowDown':
					return newIndex($elm$core$Basics$add);
				case 'ArrowUp':
					return newIndex($elm$core$Basics$sub);
				case 'Enter':
					return A2(
						$elm$core$Maybe$withDefault,
						$elm$json$Json$Decode$fail('invalid index'),
						A2(
							$elm$core$Maybe$map,
							A2($elm$core$Basics$composeR, msgs.jD, $elm$json$Json$Decode$succeed),
							$elm$core$List$head(
								A2($elm$core$List$drop, selectionIndex, options))));
				default:
					return $elm$json$Json$Decode$fail('key not handled');
			}
		};
		return A2(
			$elm$html$Html$Events$on,
			'keydown',
			A2(
				$elm$json$Json$Decode$andThen,
				isArrowKey,
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
	});
var $author$project$Platform2$AutocompleteInput$view = F2(
	function (_v0, model) {
		var msg = _v0.a;
		var attributes = _v0.d7;
		var toLabel = _v0.mz;
		var toOption = _v0.mB;
		var moduleClass = _v0.k9;
		var uniqueElementId = _v0.mM;
		var placeholder = _v0.cO;
		var icon = _v0.dq;
		var disabled = _v0.fI;
		var uniqueInputElementId = _Utils_ap(uniqueElementId, $author$project$Platform2$AutocompleteInput$inputElementId);
		var suggestionsView = function (suggestions) {
			return $elm$core$List$isEmpty(suggestions) ? A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['container', 'suggestions']),
						moduleClass)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['container', 'suggestions', 'no-results']),
								moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('No results found')
							]))
					])) : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['container', 'suggestions']),
						moduleClass),
						$elm$html$Html$Attributes$id($author$project$Platform2$AutocompleteInput$suggestionsElementId)
					]),
				A2(
					$elm$core$List$indexedMap,
					F2(
						function (index, suggestion) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
										msg(
											A2($author$project$Platform2$AutocompleteInput$SelectSuggestion, uniqueInputElementId, suggestion))),
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$withStates,
										_List_fromArray(
											[
												_Utils_Tuple2(
												'selected',
												_Utils_eq(index, model.dI))
											]),
										A2(
											$GlobalWebIndex$class_namespaces$WeakCss$addMany,
											_List_fromArray(
												['container', 'suggestions', 'item']),
											moduleClass)),
										$elm$html$Html$Attributes$id(
										$author$project$Platform2$AutocompleteInput$getSuggestionItemElementId(index))
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$map,
										msg,
										A2(toOption, suggestion, index))
									]));
						}),
					suggestions));
		};
		var msgs = {
			jC: A2($elm$core$Basics$composeR, $author$project$Platform2$AutocompleteInput$ChangedIndex, msg),
			jD: function (item) {
				return msg(
					A2(
						$author$project$Platform2$AutocompleteInput$SelectSuggestion,
						toLabel(item),
						item));
			}
		};
		var isEmpty = $elm$core$List$isEmpty(model.u);
		var enterDcoder = function (m) {
			return A2(
				$elm$json$Json$Decode$andThen,
				function (key) {
					if (key === 'Enter') {
						return $elm$json$Json$Decode$succeed(m);
					} else {
						return $elm$json$Json$Decode$fail('Not the key we\'re interested in');
					}
				},
				A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string));
		};
		var selectedAndInputView = A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['container', 'selected-items']),
					moduleClass)
				]),
			_Utils_ap(
				A2(
					$elm$core$List$map,
					function (item) {
						return A2(
							$elm$html$Html$map,
							msg,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['container', 'selected-items', 'item']),
										moduleClass)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										toLabel(item)),
										A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['container', 'selected-items', 'item', 'remove']),
												moduleClass),
												$elm$html$Html$Attributes$disabled(disabled),
												$elm_community$html_extra$Html$Events$Extra$onClickStopPropagation(
												A2($author$project$Platform2$AutocompleteInput$RemoveItemFromSelected, uniqueInputElementId, item))
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Icons$icon,
												_List_fromArray(
													[
														$author$project$Icons$width(29)
													]),
												$author$project$Icons$Platform2$cross)
											]))
									])));
					},
					model.u),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_Utils_ap(
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['container', 'input']),
									moduleClass),
									$elm$html$Html$Attributes$disabled(disabled),
									A2($elm$html$Html$Attributes$attribute, 'autocomplete', 'off'),
									$elm$html$Html$Events$onInput(
									A2(
										$elm$core$Basics$composeL,
										msg,
										$author$project$Platform2$AutocompleteInput$OnInput(
											{j5: uniqueInputElementId}))),
									A2(
									$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
									$elm$core$String$isEmpty(model.cW),
									A2(
										$elm_community$html_extra$Html$Attributes$Extra$attributeMaybe,
										A2(
											$elm$core$Basics$composeL,
											A2($elm$core$Basics$composeL, $author$project$Gwi$Html$Events$onBackspace, msg),
											$author$project$Platform2$AutocompleteInput$RemoveItemFromSelected(uniqueInputElementId)),
										$elm_community$list_extra$List$Extra$last(model.u))),
									$elm$html$Html$Events$onBlur(
									msg(
										$author$project$Platform2$AutocompleteInput$InputBlur(uniqueInputElementId))),
									$elm$html$Html$Attributes$id(uniqueInputElementId),
									$elm$html$Html$Attributes$value(model.cW),
									A2(
									$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
									isEmpty,
									$elm$html$Html$Attributes$placeholder(placeholder)),
									A2(
									$elm$html$Html$Events$on,
									'keyup',
									enterDcoder(
										msg(
											$author$project$Platform2$AutocompleteInput$OnEnter(
												{j5: uniqueInputElementId})))),
									A3(
									$author$project$Platform2$AutocompleteInput$onKeyDown,
									msgs,
									model.dI,
									A2($elm$core$Maybe$withDefault, _List_Nil, model.by))
								]),
							A2(
								$elm$core$List$map,
								$elm$core$Basics$apR(uniqueInputElementId),
								attributes)),
						_List_Nil)
					])));
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'container', moduleClass)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['container', 'input-cont']),
							moduleClass),
							$elm$html$Html$Events$onClick(
							msg(
								$author$project$Platform2$AutocompleteInput$FocusInput(uniqueInputElementId)))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$span,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'search-icon', moduleClass)
								]),
							_List_fromArray(
								[
									A2($author$project$Icons$icon, _List_Nil, icon)
								])),
							selectedAndInputView
						])),
					A2($elm_community$html_extra$Html$Extra$viewMaybe, suggestionsView, model.by)
				]));
	});
var $author$project$Dashboards2$viewShareModalContent = F5(
	function (config, data, flags, _v0, className) {
		var userIsOwner = _v0.mS;
		var shareWithMyOrgView = function (_v43) {
			var newSharedWithAfterChecked = function () {
				var _v30 = data.d;
				switch (_v30.$) {
					case 2:
						if (!_v30.a.a.$) {
							if (!_v30.a.b.b) {
								var _v31 = _v30.a;
								return $author$project$Data$Platform2$PrivateDashboard;
							} else {
								var _v32 = _v30.a;
								var userIds = _v32.b;
								return $author$project$Data$Platform2$NonGwiShared(
									_Utils_Tuple2($elm$core$Maybe$Nothing, userIds));
							}
						} else {
							var _v33 = _v30.a;
							var _v34 = _v33.a;
							var userIds = _v33.b;
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$author$project$Data$Platform2$NonGwiShared(
									_Utils_Tuple2($elm$core$Maybe$Nothing, userIds)),
								function (userOrgId) {
									return $author$project$Data$Platform2$NonGwiShared(
										_Utils_Tuple2(
											$elm$core$Maybe$Just(
												$author$project$Data$Id$fromString(userOrgId)),
											userIds));
								},
								flags.mQ.m);
						}
					case 3:
						return flags.nM(23) ? A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Platform2$PublicDashboard,
							function (userOrgId) {
								return $author$project$Data$Platform2$GwiShared(
									_Utils_Tuple2(
										_List_fromArray(
											[
												$author$project$Data$Id$fromString(userOrgId)
											]),
										_List_Nil));
							},
							flags.mQ.m) : A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Platform2$PrivateDashboard,
							function (userOrgId) {
								return $author$project$Data$Platform2$NonGwiShared(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(
											$author$project$Data$Id$fromString(userOrgId)),
										_List_Nil));
							},
							flags.mQ.m);
					case 0:
						return flags.nM(23) ? A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Platform2$PrivateDashboard,
							function (userOrgId) {
								return $author$project$Data$Platform2$GwiShared(
									_Utils_Tuple2(
										_List_fromArray(
											[
												$author$project$Data$Id$fromString(userOrgId)
											]),
										_List_Nil));
							},
							flags.mQ.m) : A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Platform2$PrivateDashboard,
							function (userOrgId) {
								return $author$project$Data$Platform2$NonGwiShared(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(
											$author$project$Data$Id$fromString(userOrgId)),
										_List_Nil));
							},
							flags.mQ.m);
					case 1:
						if (!_v30.a.a.b) {
							var _v35 = _v30.a;
							var userIds = _v35.b;
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$author$project$Data$Platform2$GwiShared(
									_Utils_Tuple2(_List_Nil, userIds)),
								function (userOrgId) {
									return $author$project$Data$Platform2$GwiShared(
										_Utils_Tuple2(
											_List_fromArray(
												[
													$author$project$Data$Id$fromString(userOrgId)
												]),
											userIds));
								},
								flags.mQ.m);
						} else {
							var _v36 = _v30.a;
							var orgIds = _v36.a;
							var userIds = _v36.b;
							var orgIdsWithUserOrgIdToggledInOut = A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								orgIds,
								function (userOrgId) {
									return A2(
										$elm$core$List$member,
										$author$project$Data$Id$fromString(userOrgId),
										orgIds) ? A2(
										$elm$core$List$filter,
										function (orgId) {
											return !_Utils_eq(
												orgId,
												$author$project$Data$Id$fromString(userOrgId));
										},
										orgIds) : _Utils_ap(
										orgIds,
										_List_fromArray(
											[
												$author$project$Data$Id$fromString(userOrgId)
											]));
								},
								flags.mQ.m);
							return ($elm$core$List$isEmpty(orgIdsWithUserOrgIdToggledInOut) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PrivateDashboard : $author$project$Data$Platform2$GwiShared(
								_Utils_Tuple2(orgIdsWithUserOrgIdToggledInOut, userIds));
						}
					case 4:
						return flags.nM(23) ? A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Platform2$PublicLinkShared,
							function (userOrgId) {
								return $author$project$Data$Platform2$PublicLinkAndGwiShared(
									_Utils_Tuple2(
										_List_fromArray(
											[
												$author$project$Data$Id$fromString(userOrgId)
											]),
										_List_Nil));
							},
							flags.mQ.m) : A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Platform2$PublicLinkShared,
							function (userOrgId) {
								return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(
											$author$project$Data$Id$fromString(userOrgId)),
										_List_Nil));
							},
							flags.mQ.m);
					case 5:
						return $author$project$Data$Platform2$LinkShared;
					case 7:
						if (!_v30.a.a.$) {
							if (!_v30.a.b.b) {
								var _v37 = _v30.a;
								return $author$project$Data$Platform2$PublicLinkShared;
							} else {
								var _v38 = _v30.a;
								var userIds = _v38.b;
								return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
									_Utils_Tuple2($elm$core$Maybe$Nothing, userIds));
							}
						} else {
							var _v39 = _v30.a;
							var _v40 = _v39.a;
							var userIds = _v39.b;
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$author$project$Data$Platform2$PublicLinkAndNonGwiShared(
									_Utils_Tuple2($elm$core$Maybe$Nothing, userIds)),
								function (userOrgId) {
									return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
										_Utils_Tuple2(
											$elm$core$Maybe$Just(
												$author$project$Data$Id$fromString(userOrgId)),
											userIds));
								},
								flags.mQ.m);
						}
					case 8:
						return flags.nM(23) ? A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Platform2$PublicLinkAndPublicDashboard,
							function (userOrgId) {
								return $author$project$Data$Platform2$PublicLinkAndGwiShared(
									_Utils_Tuple2(
										_List_fromArray(
											[
												$author$project$Data$Id$fromString(userOrgId)
											]),
										_List_Nil));
							},
							flags.mQ.m) : A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							$author$project$Data$Platform2$PublicLinkShared,
							function (userOrgId) {
								return $author$project$Data$Platform2$PublicLinkAndNonGwiShared(
									_Utils_Tuple2(
										$elm$core$Maybe$Just(
											$author$project$Data$Id$fromString(userOrgId)),
										_List_Nil));
							},
							flags.mQ.m);
					default:
						if (!_v30.a.a.b) {
							var _v41 = _v30.a;
							var userIds = _v41.b;
							return A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								$author$project$Data$Platform2$PublicLinkAndGwiShared(
									_Utils_Tuple2(_List_Nil, userIds)),
								function (userOrgId) {
									return $author$project$Data$Platform2$PublicLinkAndGwiShared(
										_Utils_Tuple2(
											_List_fromArray(
												[
													$author$project$Data$Id$fromString(userOrgId)
												]),
											userIds));
								},
								flags.mQ.m);
						} else {
							var _v42 = _v30.a;
							var orgIds = _v42.a;
							var userIds = _v42.b;
							var orgIdsWithUserOrgIdToggledInOut = A3(
								$elm_community$maybe_extra$Maybe$Extra$unwrap,
								orgIds,
								function (userOrgId) {
									return A2(
										$elm$core$List$member,
										$author$project$Data$Id$fromString(userOrgId),
										orgIds) ? A2(
										$elm$core$List$filter,
										function (orgId) {
											return !_Utils_eq(
												orgId,
												$author$project$Data$Id$fromString(userOrgId));
										},
										orgIds) : _Utils_ap(
										orgIds,
										_List_fromArray(
											[
												$author$project$Data$Id$fromString(userOrgId)
											]));
								},
								flags.mQ.m);
							return ($elm$core$List$isEmpty(orgIdsWithUserOrgIdToggledInOut) && $elm$core$List$isEmpty(userIds)) ? $author$project$Data$Platform2$PublicLinkShared : $author$project$Data$Platform2$PublicLinkAndGwiShared(
								_Utils_Tuple2(orgIdsWithUserOrgIdToggledInOut, userIds));
						}
				}
			}();
			var sharingMsg = config.a(
				flags.nM(23) ? $author$project$Dashboards2$SelectShared(newSharedWithAfterChecked) : $author$project$Dashboards2$ToggleOwnOrgSharing);
			var checkboxIsDisabled = function () {
				var _v17 = data.d;
				switch (_v17.$) {
					case 3:
						return true;
					case 0:
						return false;
					case 2:
						if (!_v17.a.a.$) {
							var _v18 = _v17.a;
							var _v19 = data.bq;
							if ((_v19.$ === 2) && (!_v19.a.a.$)) {
								var _v20 = _v19.a;
								return true;
							} else {
								return false;
							}
						} else {
							var _v21 = _v17.a;
							var _v22 = _v21.a;
							return false;
						}
					case 1:
						var _v23 = _v17.a;
						var orgIds = _v23.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							false,
							function (userOrgId) {
								return A2(
									$elm$core$List$member,
									$author$project$Data$Id$fromString(userOrgId),
									orgIds);
							},
							flags.mQ.m);
					case 4:
						return false;
					case 5:
						return true;
					case 8:
						return true;
					case 7:
						if (!_v17.a.a.$) {
							var _v24 = _v17.a;
							var _v25 = data.bq;
							if ((_v25.$ === 7) && (!_v25.a.a.$)) {
								var _v26 = _v25.a;
								return true;
							} else {
								return false;
							}
						} else {
							var _v27 = _v17.a;
							var _v28 = _v27.a;
							return false;
						}
					default:
						var _v29 = _v17.a;
						var orgIds = _v29.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							false,
							function (userOrgId) {
								return A2(
									$elm$core$List$member,
									$author$project$Data$Id$fromString(userOrgId),
									orgIds);
							},
							flags.mQ.m);
				}
			}();
			var checkboxIsChecked = function () {
				var _v12 = data.d;
				switch (_v12.$) {
					case 3:
						return false;
					case 0:
						return false;
					case 2:
						var _v13 = _v12.a;
						var maybeOrgId = _v13.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							false,
							$elm$core$Basics$always(true),
							maybeOrgId);
					case 1:
						var _v14 = _v12.a;
						var orgIds = _v14.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							false,
							function (userOrgId) {
								return A2(
									$elm$core$List$member,
									$author$project$Data$Id$fromString(userOrgId),
									orgIds);
							},
							flags.mQ.m);
					case 4:
						return false;
					case 5:
						return false;
					case 7:
						var _v15 = _v12.a;
						var maybeOrgId = _v15.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							false,
							$elm$core$Basics$always(true),
							maybeOrgId);
					case 6:
						var _v16 = _v12.a;
						var orgIds = _v16.a;
						return A3(
							$elm_community$maybe_extra$Maybe$Extra$unwrap,
							false,
							function (userOrgId) {
								return A2(
									$elm$core$List$member,
									$author$project$Data$Id$fromString(userOrgId),
									orgIds);
							},
							flags.mQ.m);
					default:
						return false;
				}
			}();
			var checkboxIcon = _Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) ? $author$project$Icons$Platform2$checkboxCrossed : (checkboxIsChecked ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled);
			return A2(
				$elm$html$Html$label,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$withStates,
						_List_fromArray(
							[
								_Utils_Tuple2('checked', checkboxIsChecked),
								_Utils_Tuple2('disabled', checkboxIsDisabled)
							]),
						A2(
							$GlobalWebIndex$class_namespaces$WeakCss$addMany,
							_List_fromArray(
								['share-modal', 'share-with-my-org']),
							className))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$input,
						_List_fromArray(
							[
								$elm$html$Html$Attributes$type_('checkbox'),
								$elm$html$Html$Attributes$checked(checkboxIsChecked),
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['share-modal', 'share-with-my-org', 'checkbox']),
								className),
								$elm_community$html_extra$Html$Events$Extra$onClickPreventDefaultAndStopPropagation(sharingMsg),
								$elm$html$Html$Attributes$disabled(checkboxIsDisabled)
							]),
						_List_Nil),
						A2(
						$elm$html$Html$span,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['share-modal', 'share-with-my-org', 'checkmark']),
								className)
							]),
						_List_fromArray(
							[
								A2($author$project$Icons$icon, _List_Nil, checkboxIcon)
							])),
						$elm$html$Html$text('Share with everyone'),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						flags.nM(23),
						$elm$html$Html$text(' at ')),
						A2(
						$elm_community$html_extra$Html$Extra$viewIf,
						flags.nM(23),
						A2(
							$elm$html$Html$strong,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['share-modal', 'share-with-my-org', 'org-name']),
									className)
								]),
							_List_fromArray(
								[
									$elm$html$Html$text(
									A2($elm$core$Maybe$withDefault, 'your organisation', flags.mQ.bL))
								])))
					]));
		};
		var makePublicToggleView = A2(
			$elm$html$Html$label,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
					_List_fromArray(
						['share-modal', 'make-public']),
					className)
				]),
			_List_fromArray(
				[
					$elm$html$Html$text('Make dashboard public'),
					A2(
					$elm$html$Html$button,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withStates,
							_List_fromArray(
								[
									_Utils_Tuple2(
									'on',
									_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard))
								]),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['share-modal', 'make-public-toggle']),
								className)),
							$elm$html$Html$Events$onClick(
							config.a($author$project$Dashboards2$TogglePublicSharing))
						]),
					_List_Nil)
				]));
		var generateOadLinkView = function (_v11) {
			var buttonView = A2(
				$elm$html$Html$button,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['share-modal', 'generate-oad-button']),
						$author$project$Dashboards2$moduleClass),
						$elm$html$Html$Events$onClick(
						config.a($author$project$Dashboards2$GenerateOadLink)),
						$elm$html$Html$Attributes$disabled(!userIsOwner)
					]),
				_List_fromArray(
					[
						A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$earth),
						$elm$html$Html$text('Generate open access link')
					]));
			return userIsOwner ? buttonView : $author$project$CoolTip$Platform2$view(
				{
					lm: $elm$core$Maybe$Nothing,
					lB: 0,
					mt: _List_Nil,
					mu: _List_fromArray(
						[buttonView]),
					mE: _List_Nil,
					mF: A2(
						$elm$html$Html$span,
						_List_Nil,
						_List_fromArray(
							[
								$elm$html$Html$text('In order to generate an open access link you'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('need to be the owner of the board. Go back'),
								A2($elm$html$Html$br, _List_Nil, _List_Nil),
								$elm$html$Html$text('and make a copy to become an owner.')
							])),
					mL: $author$project$CoolTip$Normal,
					m2: _List_Nil
				});
		};
		var existingSharingView = function (_v10) {
			var removeBtnView = function (msg) {
				return A2(
					$elm$html$Html$i,
					A3(
						$author$project$Gwi$List$appendIf,
						!(_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard)),
						$elm$html$Html$Events$onClick(
							config.a(msg)),
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['share-modal', 'org', 'icon']),
								$author$project$Dashboards2$moduleClass),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'disabled',
										_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard))
									]))
							])),
					_List_fromArray(
						[
							A2(
							$author$project$Icons$icon,
							_List_fromArray(
								[
									$author$project$Icons$height(10)
								]),
							$author$project$Icons$Platform2$crossSmall)
						]));
			};
			var existingShareeView = F5(
				function (name, removeTooltip, tooltipPosition, activeStates, removeButton) {
					return A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
								activeStates,
								A2(
									$GlobalWebIndex$class_namespaces$WeakCss$addMany,
									_List_fromArray(
										['share-modal', 'org']),
									$author$project$Dashboards2$moduleClass))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text(name),
								$author$project$CoolTip$Platform2$view(
								{
									lm: $elm$core$Maybe$Nothing,
									lB: tooltipPosition,
									mt: _List_Nil,
									mu: _List_fromArray(
										[removeButton]),
									mE: _List_Nil,
									mF: $elm$html$Html$text(removeTooltip),
									mL: $author$project$CoolTip$Normal,
									m2: _List_Nil
								})
							]));
				});
			var originalOrgsView = function () {
				var _v9 = data.aa;
				if (!_v9.b) {
					return _List_Nil;
				} else {
					var orgs = _v9;
					return A2(
						$elm$core$List$map,
						function (org) {
							return A5(
								existingShareeView,
								org.ld,
								'Unshare',
								7,
								_List_fromArray(
									['valid']),
								removeBtnView(
									$author$project$Dashboards2$RemoveOriginalSharedOrg(org)));
						},
						orgs);
				}
			}();
			var originalUsersView = function () {
				var _v8 = data.W;
				if (!_v8.b) {
					return _List_Nil;
				} else {
					var users = _v8;
					return A2(
						$elm$core$List$map,
						function (user) {
							return A5(
								existingShareeView,
								user.j,
								'Unshare',
								7,
								_List_fromArray(
									['valid']),
								removeBtnView(
									$author$project$Dashboards2$RemoveOriginalSharedUser(user)));
						},
						users);
				}
			}();
			return ($elm$core$List$isEmpty(originalOrgsView) && $elm$core$List$isEmpty(originalUsersView)) ? $elm_community$html_extra$Html$Extra$nothing : A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['share-modal', 'current-orgs', 'container']),
						$author$project$Dashboards2$moduleClass),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'disabled',
								_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['share-modal', 'current-orgs', 'container', 'label']),
								$author$project$Dashboards2$moduleClass)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Shared with:')
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['share-modal', 'current-orgs']),
								$author$project$Dashboards2$moduleClass)
							]),
						_Utils_ap(originalUsersView, originalOrgsView))
					]));
		};
		var dividingLineView = function (_v7) {
			return A2(
				$elm$html$Html$hr,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['share-modal', 'hr']),
						className)
					]),
				_List_Nil);
		};
		var bulkAddUserView = function (_v6) {
			return A2(
				$author$project$Platform2$AutocompleteInput$view,
				{
					d7: _List_fromArray(
						[
							function (textInputId) {
							return A2(
								$elm$html$Html$Events$stopPropagationOn,
								'keydown',
								A2(
									$elm$json$Json$Decode$andThen,
									function (key) {
										var removeLast = $elm$core$String$isEmpty(data.cb.cW) ? $elm$json$Json$Decode$succeed(
											_Utils_Tuple2(
												config.a(
													$author$project$Dashboards2$RemoveLastBulkAddUser(textInputId)),
												false)) : $elm$json$Json$Decode$fail('Can\'t backspace');
										if (key === 'Backspace') {
											return removeLast;
										} else {
											return $elm$json$Json$Decode$fail('Not a key we\'re interested in: ' + key);
										}
									},
									A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
						}
						]),
					fI: _Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard),
					dq: $author$project$Icons$Platform2$search,
					k9: A2(
						$GlobalWebIndex$class_namespaces$WeakCss$addMany,
						_List_fromArray(
							['share-modal', 'autocomplete-user']),
						$author$project$Dashboards2$moduleClass),
					a: A2($elm$core$Basics$composeR, $author$project$Dashboards2$UserAutocompleteInputMsg, config.a),
					cO: 'Email address',
					mz: function ($) {
						return $.j;
					},
					mB: F2(
						function (user, index) {
							return A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['share-modal', 'autocomplete-user', 'option', 'content']),
										$author$project$Dashboards2$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['share-modal', 'autocomplete-user', 'option', 'avatar']),
												$author$project$Dashboards2$moduleClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$svg$Svg$svg,
												_List_fromArray(
													[
														$elm$svg$Svg$Attributes$width('24px'),
														$elm$svg$Svg$Attributes$height('24px')
													]),
												_List_fromArray(
													[
														A2(
														$elm$svg$Svg$g,
														_List_fromArray(
															[
																$elm$svg$Svg$Attributes$fill(
																$author$project$Palette$p2AvatarColorFromIndex(index))
															]),
														_List_fromArray(
															[
																A2(
																$elm$svg$Svg$circle,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$cx('12'),
																		$elm$svg$Svg$Attributes$cy('12'),
																		$elm$svg$Svg$Attributes$r('12')
																	]),
																_List_Nil),
																A2(
																$elm$svg$Svg$text_,
																_List_fromArray(
																	[
																		$elm$svg$Svg$Attributes$x('50%'),
																		$elm$svg$Svg$Attributes$y('70%'),
																		$elm$svg$Svg$Attributes$textAnchor('middle'),
																		$elm$svg$Svg$Attributes$stroke('#fff')
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$elm$core$String$toUpper(
																			A3($elm$core$String$slice, 0, 1, user.ke)))
																	]))
															]))
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['share-modal', 'autocomplete-user', 'option', 'headline']),
														$author$project$Dashboards2$moduleClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(user.ke + (' ' + user.pA))
													])),
												A2(
												$elm$html$Html$p,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['share-modal', 'autocomplete-user', 'option', 'subheading']),
														$author$project$Dashboards2$moduleClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(user.j)
													]))
											]))
									]));
						}),
					mM: 'share-modal-autocomplete-user'
				},
				data.cb);
		};
		var bulkAddOrgView = function (_v4) {
			var submitMsg = $elm$core$String$isEmpty(data.F.cW) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(
				function (elementId) {
					return config.a(
						A2($author$project$Dashboards2$ValidateBulkOrgAddIds, data.F.cW, elementId));
				});
			var hasPillsToShow = !$elm$core$List$isEmpty(data.F.u);
			return A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['share-modal', 'bulk-add-org']),
						className),
						$elm$html$Html$Attributes$classList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'disabled',
								_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard))
							]))
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['share-modal', 'bulk-add-org', 'header']),
								className),
								$elm$html$Html$Attributes$disabled(
								_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard)),
								$elm$html$Html$Attributes$classList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'disabled',
										_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard))
									]))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['share-modal', 'bulk-add-org', 'title']),
										className)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Search or bulk-add organisation ID’s')
									])),
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['share-modal', 'bulk-add-org', 'clear-btn']),
										className),
										$elm$html$Html$Attributes$disabled(
										(!hasPillsToShow) || (_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard))),
										$elm$html$Html$Events$onClick(
										config.a($author$project$Dashboards2$ClearBulkOrgAdd))
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Clear all')
									]))
							])),
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['share-modal', 'bulk-add-org', 'input-area']),
								className)
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Platform2$AutocompleteInput$view,
								{
									d7: _List_fromArray(
										[
											function (textInputId) {
											return A2(
												$elm$html$Html$Events$stopPropagationOn,
												'keydown',
												A2(
													$elm$json$Json$Decode$andThen,
													function (key) {
														var submit = function () {
															if (submitMsg.$ === 1) {
																return $elm$json$Json$Decode$fail('Can\'t submit');
															} else {
																var submitMsg_ = submitMsg.a;
																return $elm$json$Json$Decode$succeed(
																	_Utils_Tuple2(
																		submitMsg_(textInputId),
																		true));
															}
														}();
														var removeLast = $elm$core$String$isEmpty(data.F.cW) ? $elm$json$Json$Decode$succeed(
															_Utils_Tuple2(
																config.a(
																	$author$project$Dashboards2$RemoveLastBulkAddOrganisation(textInputId)),
																true)) : $elm$json$Json$Decode$fail('Can\'t backspace');
														switch (key) {
															case 'Enter':
																return submit;
															case 'Backspace':
																return removeLast;
															default:
																return $elm$json$Json$Decode$fail('Not a key we\'re interested in: ' + key);
														}
													},
													A2($elm$json$Json$Decode$field, 'key', $elm$json$Json$Decode$string)));
										}
										]),
									fI: _Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard) || _Utils_eq(data.d, $author$project$Data$Platform2$PublicLinkAndPublicDashboard),
									dq: $author$project$Icons$Platform2$search,
									k9: A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['share-modal', 'autocomplete-org']),
										className),
									a: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$OrgAutocompleteInputMsg),
									cO: 'Search for specific organisations',
									mz: function (organisation) {
										return organisation.ld + (' | ' + $author$project$Data$Id$unwrap(organisation.b));
									},
									mB: F2(
										function (organisation, _v3) {
											return A2(
												$elm$html$Html$span,
												_List_Nil,
												_List_fromArray(
													[
														A2(
														$elm$html$Html$strong,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(organisation.ld)
															])),
														A2(
														$elm$html$Html$span,
														_List_Nil,
														_List_fromArray(
															[
																$elm$html$Html$text(
																' | ' + $author$project$Data$Id$unwrap(organisation.b))
															]))
													]));
										}),
									mM: 'share-modal-autocomplete-org'
								},
								data.F)
							]))
					]));
		};
		return flags.nM(23) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'share-modal', className)
				]),
			_List_fromArray(
				[
					makePublicToggleView,
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['share-modal', 'bulk-add-org-label']),
							className),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'disabled',
									_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Organisations')
						])),
					bulkAddOrgView(0),
					shareWithMyOrgView(0),
					dividingLineView(0),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['share-modal', 'bulk-add-user-label']),
							className),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'disabled',
									_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Individuals')
						])),
					bulkAddUserView(0),
					existingSharingView(0),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					flags.nM(27),
					generateOadLinkView(0))
				])) : (flags.nM(24) ? A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'share-modal', className)
				]),
			_List_fromArray(
				[
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['share-modal', 'bulk-add-org-label']),
							className)
						]),
					_List_fromArray(
						[
							$elm$html$Html$text(
							A2($elm$core$Maybe$withDefault, 'Organisation', flags.mQ.bL))
						])),
					shareWithMyOrgView(0),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					data.kQ,
					A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['share-modal', 'org-has-changed-msg']),
								className)
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('Your organisation was changed. This dashboard is still shared with your old organisation.')
							]))),
					dividingLineView(0),
					A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
							_List_fromArray(
								['share-modal', 'bulk-add-user-label']),
							className),
							$elm$html$Html$Attributes$classList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'disabled',
									_Utils_eq(data.d, $author$project$Data$Platform2$PublicDashboard))
								]))
						]),
					_List_fromArray(
						[
							$elm$html$Html$text('Individuals')
						])),
					bulkAddUserView(0),
					existingSharingView(0),
					A2(
					$elm_community$html_extra$Html$Extra$viewIf,
					flags.nM(27),
					generateOadLinkView(0))
				])) : $elm_community$html_extra$Html$Extra$nothing);
	});
var $author$project$Dashboards2$modalView = F6(
	function (config, flags, zone, store, route, model) {
		var _v0 = model.c;
		switch (_v0.$) {
			case 0:
				return $elm_community$html_extra$Html$Extra$nothing;
			case 1:
				var title = _v0.a.Y;
				var content = _v0.a.U;
				var buttons = _v0.a.aH;
				var closeAction = _v0.a.ft;
				var doNotShowAgain = _v0.a.bF;
				var checkboxClassName = A2(
					$GlobalWebIndex$class_namespaces$WeakCss$addMany,
					_List_fromArray(
						['confirm-modal', 'footer']),
					$author$project$Dashboards2$moduleClass);
				var doNotShowAgainCheckboxView = function () {
					if (doNotShowAgain.$ === 1) {
						var state = doNotShowAgain.a;
						var icon = state ? $author$project$Icons$Platform2$checkboxFilled : $author$project$Icons$Platform2$checkboxUnfilled;
						return A2(
							$elm$html$Html$label,
							_List_fromArray(
								[
									A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'checkbox-label', checkboxClassName)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['checkbox-label', 'name-icon']),
											checkboxClassName)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$input,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['checkbox-label', 'input']),
													checkboxClassName),
													$elm$html$Html$Attributes$checked(state),
													$elm$html$Html$Attributes$type_('checkbox'),
													$elm$html$Html$Events$onClick(
													config.a($author$project$Dashboards2$ToggleDoNotShowAgainInModal))
												]),
											_List_Nil),
											A2(
											$elm$html$Html$span,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['checkbox-label', 'checkbox']),
													checkboxClassName)
												]),
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, icon)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['checkbox-label', 'text']),
													checkboxClassName)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Remember my choice')
												]))
										]))
								]));
					} else {
						return $elm_community$html_extra$Html$Extra$nothing;
					}
				}();
				return A4(
					$author$project$Dashboards2$modalSkeletonView,
					config,
					closeAction,
					0,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['confirm-modal', 'header']),
									$author$project$Dashboards2$moduleClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$h2,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['confirm-modal', 'headline']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text(title)
										]))
								])),
							A2(
							$elm$html$Html$main_,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['confirm-modal', 'content']),
									$author$project$Dashboards2$moduleClass)
								]),
							_List_fromArray(
								[
									A2($elm$html$Html$map, config.a, content)
								])),
							A2(
							$elm$html$Html$footer,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['confirm-modal', 'footer']),
									$author$project$Dashboards2$moduleClass)
								]),
							A2(
								$elm$core$List$cons,
								doNotShowAgainCheckboxView,
								A2(
									$elm$core$List$map,
									function (btn) {
										return A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														[
															'confirm-modal',
															btn.cy ? 'primary-button' : 'action-link'
														]),
													$author$project$Dashboards2$moduleClass),
													$elm$html$Html$Events$onClick(
													config.a(btn.cd))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(btn.Y)
												]));
									},
									buttons)))
						]));
			case 2:
				var errorDisplay = _v0.a.j9;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							_List_fromArray(
								['small']),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['modal', 'overlay']),
								$author$project$Dashboards2$moduleClass)),
							$elm$html$Html$Events$onMouseDown(
							config.a($author$project$Dashboards2$CloseModal))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['modal', 'container']),
									$author$project$Dashboards2$moduleClass),
									A2(
									$elm$html$Html$Events$stopPropagationOn,
									'mousedown',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(config.y, true)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['error-modal', 'header']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['error-modal', 'headline']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Error')
												]))
										])),
									A2(
									$elm$html$Html$map,
									$elm$core$Basics$never,
									A2(
										$elm$html$Html$main_,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['error-modal', 'content']),
												$author$project$Dashboards2$moduleClass)
											]),
										A2(
											$elm$core$List$cons,
											errorDisplay.jv,
											A2(
												$elm$core$List$map,
												function (line) {
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['error-modal', 'message']),
																$author$project$Dashboards2$moduleClass)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text(line)
															]));
												},
												errorDisplay.j$)))),
									A2(
									$elm$html$Html$footer,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['error-modal', 'footer']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['error-modal', 'primary-button']),
													$author$project$Dashboards2$moduleClass),
													$elm$html$Html$Events$onClick(
													config.eL(errorDisplay.ka))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Contact support')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['error-modal', 'primary-button']),
													$author$project$Dashboards2$moduleClass),
													$elm$html$Html$Events$onClick(
													config.a($author$project$Dashboards2$CloseModal))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('OK')
												]))
										]))
								]))
						]));
			case 6:
				var dashboard = _v0.a;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							_List_fromArray(
								['small']),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['modal', 'overlay']),
								$author$project$Dashboards2$moduleClass)),
							$elm$html$Html$Events$onMouseDown(
							config.a($author$project$Dashboards2$CloseModal))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['modal', 'container']),
									$author$project$Dashboards2$moduleClass),
									A2(
									$elm$html$Html$Events$stopPropagationOn,
									'mousedown',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(config.y, true)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['confirm-delete-dashboard-modal', 'header']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-dashboard-modal', 'headline']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('You\'re about to delete')
												]))
										])),
									A2(
									$elm$html$Html$main_,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['confirm-delete-dashboard-modal', 'content']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-dashboard-modal', 'message']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Are you sure you want to delete ' + (dashboard.ld + '?'))
												]))
										])),
									A2(
									$elm$html$Html$footer,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['confirm-delete-dashboard-modal', 'footer']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(
													config.a($author$project$Dashboards2$CloseModal)),
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-dashboard-modal', 'action-link']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-dashboard-modal', 'primary-button']),
													$author$project$Dashboards2$moduleClass),
													$elm$html$Html$Events$onClick(
													config.a(
														$author$project$Dashboards2$DeleteDashboard(dashboard)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Yes, I\'m sure')
												]))
										]))
								]))
						]));
			case 7:
				var dashboards = _v0.a;
				var size = $elm$core$List$length(dashboards);
				var showSpinner = !$turboMaCk$any_set$Set$Any$isEmpty(model.aY);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							_List_fromArray(
								['small']),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['modal', 'overlay']),
								$author$project$Dashboards2$moduleClass)),
							$elm$html$Html$Events$onMouseDown(
							config.a($author$project$Dashboards2$CloseModal))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['modal', 'container']),
									$author$project$Dashboards2$moduleClass),
									A2(
									$elm$html$Html$Events$stopPropagationOn,
									'mousedown',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(config.y, true)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['confirm-delete-dashboard-modal', 'header']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-dashboard-modal', 'headline']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('You\'re about to delete')
												]))
										])),
									A2(
									$elm$html$Html$main_,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['confirm-delete-dashboard-modal', 'content']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-dashboard-modal', 'message']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													'Are you sure you want to delete ' + ($elm$core$String$fromInt(size) + (A2($author$project$Plural$fromInt, size, ' dashboard') + '? Any other user who has access to this will lose access.')))
												]))
										])),
									A2(
									$elm$html$Html$footer,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['confirm-delete-dashboard-modal', 'footer']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(
													config.a($author$project$Dashboards2$CloseModal)),
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-dashboard-modal', 'action-link']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-dashboard-modal', 'primary-button']),
													$author$project$Dashboards2$moduleClass),
													$elm$html$Html$Events$onClick(
													config.a(
														$author$project$Dashboards2$DeleteDashboards(dashboards))),
													$elm$html$Html$Attributes$disabled(showSpinner)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Yes, I\'m sure')
												]))
										])),
									A2(
									$elm_community$html_extra$Html$Extra$viewIfLazy,
									showSpinner,
									function (_v2) {
										return $author$project$Platform2$Spinner$view;
									})
								]))
						]));
			case 8:
				var widget = _v0.a;
				return A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (dashboard) {
						var entity = function () {
							var _v3 = widget.U;
							if (!_v3.$) {
								return 'chart';
							} else {
								return 'text';
							}
						}();
						var message = 'The ' + (entity + ' widget you\'ve added won\'t be showing here anymore. Are you sure you want to delete it?');
						var title = 'You\'re about to delete your ' + entity;
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
									_List_fromArray(
										['small']),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['modal', 'overlay']),
										$author$project$Dashboards2$moduleClass)),
									$elm$html$Html$Events$onMouseDown(
									config.a($author$project$Dashboards2$CloseModal))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['modal', 'container']),
											$author$project$Dashboards2$moduleClass),
											A2(
											$elm$html$Html$Events$stopPropagationOn,
											'mousedown',
											$elm$json$Json$Decode$succeed(
												_Utils_Tuple2(config.y, true)))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-widget-modal', 'header']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['confirm-delete-widget-modal', 'headline']),
															$author$project$Dashboards2$moduleClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(title)
														]))
												])),
											A2(
											$elm$html$Html$main_,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-widget-modal', 'content']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['confirm-delete-widget-modal', 'message']),
															$author$project$Dashboards2$moduleClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text(message)
														]))
												])),
											A2(
											$elm$html$Html$footer,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['confirm-delete-widget-modal', 'footer']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(
															config.a($author$project$Dashboards2$CloseModal)),
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['confirm-delete-widget-modal', 'action-link']),
															$author$project$Dashboards2$moduleClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Cancel')
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['confirm-delete-widget-modal', 'primary-button']),
															$author$project$Dashboards2$moduleClass),
															$elm$html$Html$Events$onClick(
															config.a(
																A2($author$project$Dashboards2$DeleteWidget, widget, dashboard)))
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Yes, I\'m sure')
														]))
												]))
										]))
								]));
					},
					A2(
						$elm$core$Maybe$andThen,
						function (dashboardId) {
							return $krisajenkins$remotedata$RemoteData$toMaybe(
								A2($author$project$Store$Platform2$getDashboardFullyLoaded, dashboardId, store.v));
						},
						$author$project$Dashboards2$Router$getDashboardId(route)));
			case 9:
				var widget = _v0.a.bO;
				var chartType = _v0.a.aI;
				var questions = A2(
					$turboMaCk$any_dict$Dict$Any$filterMap,
					F2(
						function (_v5, v) {
							return $krisajenkins$remotedata$RemoteData$toMaybe(v);
						}),
					store.bt);
				var helpMeChooseChartTypeClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'help-me-choose-chart-type', $author$project$Dashboards2$moduleClass);
				var confirmClickAction = A2(
					$elm$core$Maybe$map,
					A2(
						$elm$core$Basics$composeR,
						$author$project$Dashboards2$SetWidgetChartType(widget),
						config.a),
					chartType);
				var className = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'edit-section', $author$project$Dashboards2$moduleClass);
				var availableChartTypes = flags.nM(23) ? $author$project$D3Charts$Dashboards$ChartType$p2All : $author$project$D3Charts$Dashboards$ChartType$availableForNonGwiCreator;
				var attributesCount = function () {
					var _v4 = widget.U;
					if (!_v4.$) {
						var chartWidget = _v4.a;
						return A2($author$project$Dashboards2$attributesCountFromWidgetData, questions, chartWidget.cl);
					} else {
						return 0;
					}
				}();
				return A4(
					$author$project$Dashboards2$modalSkeletonView,
					config,
					$elm$core$Maybe$Nothing,
					2,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$GlobalWebIndex$class_namespaces$WeakCss$toClass(helpMeChooseChartTypeClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', helpMeChooseChartTypeClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'headline', helpMeChooseChartTypeClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Help me choose')
												]))
										])),
									A2(
									$elm$html$Html$main_,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'main', helpMeChooseChartTypeClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['add-chart', 'grid']),
													className)
												]),
											A2(
												$elm$core$List$map,
												A2(
													$author$project$Dashboards2$chartTypeView,
													config,
													{
														g9: attributesCount,
														hi: className,
														cL: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$SelectWidgetChartTypeInHelpMeChooseModal),
														l6: chartType
													}),
												availableChartTypes))
										])),
									A2(
									$elm$html$Html$footer,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'footer', helpMeChooseChartTypeClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(
													config.a($author$project$Dashboards2$CloseModal)),
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'action-link', helpMeChooseChartTypeClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'primary-button', helpMeChooseChartTypeClass),
													$elm$html$Html$Attributes$disabled(
													_Utils_eq(confirmClickAction, $elm$core$Maybe$Nothing)),
													A2($elm_community$html_extra$Html$Attributes$Extra$attributeMaybe, $elm$html$Html$Events$onClick, confirmClickAction)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Apply')
												]))
										]))
								]))
						]));
			case 10:
				var widget = _v0.a.bO;
				var currentMetric = _v0.a.hr;
				var helpMeChooseMetricClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'help-me-choose-metric', $author$project$Dashboards2$moduleClass);
				return A4(
					$author$project$Dashboards2$modalSkeletonView,
					config,
					$elm$core$Maybe$Nothing,
					2,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$GlobalWebIndex$class_namespaces$WeakCss$toClass(helpMeChooseMetricClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', helpMeChooseMetricClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'headline', helpMeChooseMetricClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Choose a metric')
												]))
										])),
									A2(
									$elm$html$Html$main_,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'main', helpMeChooseMetricClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'grid', helpMeChooseMetricClass)
												]),
											A2(
												$elm$core$List$map,
												function (metric) {
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'radio-button-cont', helpMeChooseMetricClass),
																$elm$html$Html$Events$onClick(
																config.a(
																	$author$project$Dashboards2$SelectWidgetMetricInHelpMeChooseModal(metric)))
															]),
														_List_fromArray(
															[
																$author$project$Platform2$RadioButton$view(
																{
																	hi: A2(
																		$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																		_List_fromArray(
																			['radio-button-cont', 'radio-button']),
																		helpMeChooseMetricClass),
																	oU: $elm$core$Maybe$Nothing,
																	o0: 'widget-metric',
																	h4: $author$project$Data$Metric$getLabel(metric),
																	a: $elm$core$Basics$always(
																		config.a(
																			$author$project$Dashboards2$SelectWidgetMetricInHelpMeChooseModal(metric))),
																	rA: _Utils_eq(currentMetric, metric) ? 0 : 1,
																	c5: $author$project$Data$Metric$getLabel(metric)
																}),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		A2(
																		$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																		_List_fromArray(
																			['radio-button-cont', 'description']),
																		helpMeChooseMetricClass)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Data$Metric$getTooltipText(metric))
																	]))
															]));
												},
												$author$project$Data$Metric$allMetrics))
										])),
									A2(
									$elm$html$Html$footer,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'footer', helpMeChooseMetricClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['footer', 'learn-more-link']),
													helpMeChooseMetricClass),
													$elm$html$Html$Attributes$href('https://gwihelpcenter.zendesk.com/hc/en-us/articles/4407226793362-GWI-metrics-explained'),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$help),
													$elm$html$Html$text('Learn more')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(
													config.a($author$project$Dashboards2$CloseModal)),
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'action-link', helpMeChooseMetricClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'primary-button', helpMeChooseMetricClass),
													$elm$html$Html$Events$onClick(
													config.a(
														A2($author$project$Dashboards2$SetWidgetMetric, widget, currentMetric)))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Apply')
												]))
										]))
								]))
						]));
			case 11:
				var metricInfoClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'help-me-choose-metric', $author$project$Dashboards2$moduleClass);
				return A4(
					$author$project$Dashboards2$modalSkeletonView,
					config,
					$elm$core$Maybe$Nothing,
					2,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									$GlobalWebIndex$class_namespaces$WeakCss$toClass(metricInfoClass)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'header', metricInfoClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'headline', metricInfoClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Metric info')
												]))
										])),
									A2(
									$elm$html$Html$main_,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'main', metricInfoClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'grid', metricInfoClass)
												]),
											A2(
												$elm$core$List$map,
												function (metric) {
													return A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'radio-button-cont', metricInfoClass)
															]),
														_List_fromArray(
															[
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		A2(
																		$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																		_List_fromArray(
																			['radio-button-cont', 'radio-button']),
																		metricInfoClass)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Data$Metric$getLabel(metric))
																	])),
																A2(
																$elm$html$Html$div,
																_List_fromArray(
																	[
																		A2(
																		$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																		_List_fromArray(
																			['radio-button-cont', 'description']),
																		metricInfoClass)
																	]),
																_List_fromArray(
																	[
																		$elm$html$Html$text(
																		$author$project$Data$Metric$getTooltipText(metric))
																	]))
															]));
												},
												$author$project$Data$Metric$allMetrics))
										])),
									A2(
									$elm$html$Html$footer,
									_List_fromArray(
										[
											A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'footer', metricInfoClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$a,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['footer', 'learn-more-link']),
													metricInfoClass),
													$elm$html$Html$Attributes$href('https://gwihelpcenter.zendesk.com/hc/en-us/articles/4407226793362-GWI-metrics-explained'),
													$elm$html$Html$Attributes$target('_blank')
												]),
											_List_fromArray(
												[
													A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$help),
													$elm$html$Html$text('Learn more')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'primary-button', metricInfoClass),
													$elm$html$Html$Events$onClick(
													config.a($author$project$Dashboards2$CloseModal))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Ok')
												]))
										]))
								]))
						]));
			case 4:
				var stagedAudience = _v0.a.bw;
				var originalAudience = _v0.a.lv;
				var decodingError = _v0.a.Z;
				var preexisting = _v0.a.lE;
				var warning = _v0.a.L;
				return A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (dashboard) {
						var audienceBrowserConfig = {
							fg: A3($krisajenkins$remotedata$RemoteData$unwrap, _List_Nil, $turboMaCk$any_dict$Dict$Any$values, store.es),
							be: 'Dashboards',
							hj: A3($author$project$Platform2$AudienceBrowser$compatibleNamespaces, dashboard.es, store.es, store.cB),
							hq: config.bA,
							fM: config.bG,
							hV: false,
							dt: false,
							it: A2(
								$elm$core$List$filterMap,
								function (a) {
									return A2($author$project$Store$Utils$get, store.d9, a.b);
								},
								$turboMaCk$any_set$Set$Any$toList(preexisting)),
							iJ: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$SetDecodingErrorInAB),
							iN: config.a($author$project$Dashboards2$ShowDisabledWarningInAB),
							aS: A2(
								$elm$core$List$filterMap,
								$author$project$Store$Utils$get(store.d9),
								_List_fromArray(
									[stagedAudience])),
							i_: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ToggleAudienceInAB)
						};
						return A4(
							$author$project$Dashboards2$replaceAudienceModalView,
							config,
							flags,
							store,
							{
								ha: audienceBrowserConfig,
								hk: config.a($author$project$Dashboards2$AddAudiencesFromAudienceBrowser),
								hl: _Utils_eq(originalAudience, stagedAudience),
								hm: 'Replace audience in your dashboard',
								Z: decodingError,
								L: warning
							});
					},
					A2(
						$elm$core$Maybe$andThen,
						function (dashboardId) {
							return $krisajenkins$remotedata$RemoteData$toMaybe(
								A2($author$project$Store$Platform2$getDashboardFullyLoaded, dashboardId, store.v));
						},
						$author$project$Dashboards2$Router$getDashboardId(route)));
			case 3:
				var isBase = _v0.a.dt;
				var stagedAudiences = _v0.a.aS;
				var decodingError = _v0.a.Z;
				var warning = _v0.a.L;
				return A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (dashboard) {
						var stagedCount = $elm$core$List$length(stagedAudiences);
						var preexistingAudiences = A2(
							$author$project$Store$Utils$getByIds,
							store.d9,
							A2(
								$elm$core$Maybe$withDefault,
								_List_Nil,
								A2(
									$elm$core$Maybe$map,
									$author$project$Dashboards2$UserFilters$audienceIds,
									$author$project$Dashboards2$getUserFilters(model))));
						var limit = $author$project$Dashboards2$UserFilters$maxNumberOfAudiences;
						var maxAudiencesSelectWarning = (_Utils_cmp(
							$elm$core$List$length(preexistingAudiences) + stagedCount,
							limit) > -1) ? $elm$core$Maybe$Just(
							$elm$html$Html$text(
								'You can apply a maximum of ' + ($elm$core$String$fromInt(limit) + A2($author$project$Plural$fromInt, limit, ' audience')))) : $elm$core$Maybe$Nothing;
						var groupConfig = {
							ne: 0,
							aH: _List_fromArray(
								[
									{
									fI: $elm$core$List$isEmpty(stagedAudiences),
									h4: 'Add ' + ($elm$core$String$fromInt(stagedCount) + A2($author$project$Plural$fromInt, stagedCount, ' audience')),
									cL: config.a($author$project$Dashboards2$AddAudiencesFromAudienceBrowser)
								}
								]),
							n0: config.a($author$project$Dashboards2$ClearAllAudiencesInAB),
							n1: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ToggleAudienceInAB),
							o2: _List_Nil,
							po: true,
							ps: false,
							f2: A2(
								$elm$core$List$map,
								function (item) {
									return {
										kS: item,
										rH: $elm$core$Maybe$Nothing,
										Y: item.ld,
										mL: A2($turboMaCk$any_set$Set$Any$member, 1, item.oN) ? 1 : 2
									};
								},
								stagedAudiences),
							cO: function (num) {
								return (_Utils_cmp(
									num + $elm$core$List$length(preexistingAudiences),
									limit) > -1) ? $elm$core$Maybe$Nothing : ((!num) ? $elm$core$Maybe$Just(
									_List_fromArray(
										[
											_Utils_Tuple2(0, 'Add one or more '),
											_Utils_Tuple2(1, 'audiences'),
											_Utils_Tuple2(0, ' to start querying')
										])) : (((num > 0) && (_Utils_cmp(num, limit) < 0)) ? $elm$core$Maybe$Just(
									_List_fromArray(
										[
											_Utils_Tuple2(0, 'Continue adding '),
											_Utils_Tuple2(1, 'audiences')
										])) : $elm$core$Maybe$Nothing));
							},
							qv: $author$project$Icons$Platform2$groupingPanelPlaceholderDashboards,
							Y: 'Add to your dashboard',
							L: A2(
								$elm_community$maybe_extra$Maybe$Extra$orElse,
								maxAudiencesSelectWarning,
								$author$project$Dashboards2$warningToString(warning))
						};
						var cls = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'add-audience-modal', $author$project$Dashboards2$moduleClass);
						var audienceBrowserConfig = {
							fg: A3($krisajenkins$remotedata$RemoteData$unwrap, _List_Nil, $turboMaCk$any_dict$Dict$Any$values, store.es),
							be: 'Dashboards',
							hj: A3($author$project$Platform2$AudienceBrowser$compatibleNamespaces, dashboard.es, store.es, store.cB),
							hq: config.bA,
							fM: config.bG,
							hV: false,
							dt: isBase,
							it: preexistingAudiences,
							iJ: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$SetDecodingErrorInAB),
							iN: config.a($author$project$Dashboards2$ShowDisabledWarningInAB),
							aS: stagedAudiences,
							i_: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ToggleAudienceInAB)
						};
						var browserView = function (folders) {
							return A3($author$project$Platform2$AudienceBrowser$view, flags, audienceBrowserConfig, folders);
						};
						return A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
									_List_fromArray(
										['large-capped']),
									A2(
										$GlobalWebIndex$class_namespaces$WeakCss$addMany,
										_List_fromArray(
											['modal', 'overlay']),
										$author$project$Dashboards2$moduleClass)),
									$elm$html$Html$Events$onMouseDown(
									config.a($author$project$Dashboards2$CloseModal))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['modal', 'container']),
											$author$project$Dashboards2$moduleClass),
											A2(
											$elm$html$Html$Events$stopPropagationOn,
											'mousedown',
											$elm$json$Json$Decode$succeed(
												_Utils_Tuple2(config.y, true)))
										]),
									_List_fromArray(
										[
											A3(
											$author$project$Platform2$Modal$headerWithTabsView,
											config.a($author$project$Dashboards2$CloseModal),
											cls,
											_List_fromArray(
												[
													{fd: true, dq: $author$project$Icons$Platform2$audiences, cL: $elm$core$Maybe$Nothing, Y: 'Audiences'}
												])),
											A2(
											$elm$html$Html$main_,
											_List_fromArray(
												[
													A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', cls)
												]),
											A2(
												$author$project$Dashboards2$remoteDataView,
												function (folders) {
													return _List_fromArray(
														[
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	A2(
																	$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																	_List_fromArray(
																		['content', 'left-part']),
																	cls)
																]),
															_List_fromArray(
																[
																	browserView(folders)
																])),
															A2(
															$elm$html$Html$div,
															_List_fromArray(
																[
																	A2(
																	$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																	_List_fromArray(
																		['content', 'right-part']),
																	cls)
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Platform2$GroupingPanel$view,
																	A2(
																		$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																		_List_fromArray(
																			['content', 'right-part', 'grouping-panel']),
																		cls),
																	groupConfig)
																])),
															A2(
															$elm_community$html_extra$Html$Extra$viewMaybe,
															function (err) {
																return A2(
																	$elm$html$Html$div,
																	_List_fromArray(
																		[
																			A2(
																			$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																			_List_fromArray(
																				['content', 'error-view']),
																			cls)
																		]),
																	_List_fromArray(
																		[
																			$elm$html$Html$text(err)
																		]));
															},
															decodingError)
														]);
												},
												store.jm))
										]))
								]));
					},
					A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
			case 5:
				var stagedAudience = _v0.a.bw;
				var decodingError = _v0.a.Z;
				var warning = _v0.a.L;
				return A2(
					$elm_community$html_extra$Html$Extra$viewMaybe,
					function (dashboard) {
						var baseAudience = A3($elm_community$maybe_extra$Maybe$Extra$unwrap, _List_Nil, $elm$core$List$singleton, stagedAudience);
						var audienceBrowserConfig = {
							fg: A3($krisajenkins$remotedata$RemoteData$unwrap, _List_Nil, $turboMaCk$any_dict$Dict$Any$values, store.es),
							be: 'Dashboards',
							hj: A3($author$project$Platform2$AudienceBrowser$compatibleNamespaces, dashboard.es, store.es, store.cB),
							hq: config.bA,
							fM: config.bG,
							hV: false,
							dt: false,
							it: _List_Nil,
							iJ: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$SetDecodingErrorInAB),
							iN: config.a($author$project$Dashboards2$ShowDisabledWarningInAB),
							aS: baseAudience,
							i_: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$ToggleAudienceInAB)
						};
						return A4(
							$author$project$Dashboards2$replaceAudienceModalView,
							config,
							flags,
							store,
							{
								ha: audienceBrowserConfig,
								hk: config.a($author$project$Dashboards2$AddAudiencesFromAudienceBrowser),
								hl: _Utils_eq(stagedAudience, $elm$core$Maybe$Nothing),
								hm: 'Apply new base audience',
								Z: decodingError,
								L: warning
							});
					},
					A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model));
			case 12:
				var duplicationInProgress = _v0.a.fK;
				var name = _v0.a.ld;
				var dashboardToDuplicate = _v0.a.ht;
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							_List_fromArray(
								['small']),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['modal', 'overlay']),
								$author$project$Dashboards2$moduleClass)),
							$elm$html$Html$Events$onMouseDown(
							config.a($author$project$Dashboards2$CloseModal))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['modal', 'container']),
									$author$project$Dashboards2$moduleClass),
									A2(
									$elm$html$Html$Events$stopPropagationOn,
									'mousedown',
									$elm$json$Json$Decode$succeed(
										_Utils_Tuple2(config.y, true)))
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['save-modal', 'header']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h2,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['save-modal', 'headline']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Name your new Dashboard')
												]))
										])),
									A2(
									$elm$html$Html$main_,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['save-modal', 'content']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$author$project$Platform2$Input$Text$view,
											{
												go: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$SetDashboardNameForSaving),
												cO: 'Dashboard name'
											},
											A3(
												$author$project$Gwi$List$addIf,
												!duplicationInProgress,
												$author$project$Platform2$Input$Text$onEnter(
													config.a(
														$author$project$Dashboards2$ConfirmSaveDashboardAsCopy(dashboardToDuplicate))),
												_List_fromArray(
													[
														$author$project$Platform2$Input$Text$class(
														A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'save-modal', $author$project$Dashboards2$moduleClass)),
														$author$project$Platform2$Input$Text$value(name),
														$author$project$Platform2$Input$Text$limit($author$project$Dashboards2$maxUserDefinedNameLength)
													])))
										])),
									A2(
									$elm$html$Html$footer,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['save-modal', 'footer']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['save-modal', 'action-link']),
													$author$project$Dashboards2$moduleClass),
													$elm$html$Html$Events$onClick(
													config.a($author$project$Dashboards2$CloseModal))
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Cancel')
												])),
											A2(
											$elm$html$Html$button,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['save-modal', 'primary-button']),
													$author$project$Dashboards2$moduleClass),
													$elm$html$Html$Events$onClick(
													config.a(
														$author$project$Dashboards2$ConfirmSaveDashboardAsCopy(dashboardToDuplicate))),
													$elm$html$Html$Attributes$disabled(duplicationInProgress)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Save')
												]))
										])),
									A2($elm_community$html_extra$Html$Extra$viewIf, duplicationInProgress, $author$project$Platform2$Spinner$view)
								]))
						]));
			case 13:
				var dashboardId = _v0.a;
				var input = _v0.b;
				var submitMsg = _Utils_eq(dashboardId, $author$project$Data$Platform2$newUnsavedDashboardId) ? A3(
					$elm_community$maybe_extra$Maybe$Extra$unwrap,
					config.a($author$project$Dashboards2$NoOp),
					function (newDashboard) {
						return A2(
							config.cU,
							_Utils_update(
								newDashboard,
								{ld: input}),
							4);
					},
					A4($author$project$Dashboards2$routeToSavedDashboard, flags, route, store, model)) : config.a(
					A2($author$project$Dashboards2$RenameDashboard, dashboardId, input));
				var isEmpty = $elm$core$String$isEmpty(input);
				return A2(
					$elm$html$Html$div,
					_List_fromArray(
						[
							A2(
							$GlobalWebIndex$class_namespaces$WeakCss$withActiveStates,
							_List_fromArray(
								['small']),
							A2(
								$GlobalWebIndex$class_namespaces$WeakCss$addMany,
								_List_fromArray(
									['modal', 'overlay']),
								$author$project$Dashboards2$moduleClass)),
							$elm$html$Html$Events$onMouseDown(
							config.a($author$project$Dashboards2$CloseModalAndRedirectIfNeeded))
						]),
					_List_fromArray(
						[
							A2(
							$elm$html$Html$form,
							_List_fromArray(
								[
									$elm$html$Html$Events$onSubmit(submitMsg)
								]),
							_List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['modal', 'container']),
											$author$project$Dashboards2$moduleClass),
											A2(
											$elm$html$Html$Events$stopPropagationOn,
											'mousedown',
											$elm$json$Json$Decode$succeed(
												_Utils_Tuple2(config.y, true)))
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['rename-dashboard-modal', 'header']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$h2,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['rename-dashboard-modal', 'headline']),
															$author$project$Dashboards2$moduleClass)
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Rename dashboard')
														]))
												])),
											A2(
											$elm$html$Html$main_,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['rename-dashboard-modal', 'content']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Platform2$Input$Text$view,
													{
														go: A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$SetRenameInput),
														cO: 'Dashboard name'
													},
													_List_fromArray(
														[
															$author$project$Platform2$Input$Text$class(
															A2(
																$GlobalWebIndex$class_namespaces$WeakCss$addMany,
																_List_fromArray(
																	['rename-dashboard-modal']),
																$author$project$Dashboards2$moduleClass)),
															$author$project$Platform2$Input$Text$value(input),
															$author$project$Platform2$Input$Text$limit($author$project$Dashboards2$maxUserDefinedNameLength)
														])),
													A2(
													$elm_community$html_extra$Html$Extra$viewIf,
													isEmpty,
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['rename-dashboard-modal', 'input', 'error']),
																$author$project$Dashboards2$moduleClass)
															]),
														_List_fromArray(
															[
																$elm$html$Html$text('The dashboard name can\'t be empty')
															])))
												])),
											A2(
											$elm$html$Html$footer,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['rename-dashboard-modal', 'footer']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(
															config.a($author$project$Dashboards2$CloseModalAndRedirectIfNeeded)),
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['rename-dashboard-modal', 'action-link']),
															$author$project$Dashboards2$moduleClass),
															$elm$html$Html$Attributes$type_('button')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Cancel')
														])),
													A2(
													$elm$html$Html$button,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['rename-dashboard-modal', 'primary-button']),
															$author$project$Dashboards2$moduleClass),
															$elm$html$Html$Attributes$disabled(isEmpty),
															$elm$html$Html$Attributes$type_('submit')
														]),
													_List_fromArray(
														[
															$elm$html$Html$text('Rename')
														]))
												]))
										]))
								]))
						]));
			case 14:
				var name = _v0.a.ld;
				var expression = _v0.a.bY;
				var previewExpressionModalClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'preview-audience-modal', $author$project$Dashboards2$moduleClass);
				return A4(
					$author$project$Dashboards2$modalSkeletonView,
					config,
					$elm$core$Maybe$Nothing,
					1,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							config.a,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$GlobalWebIndex$class_namespaces$WeakCss$toClass(previewExpressionModalClass)
									]),
								_List_fromArray(
									[
										A3(
										$author$project$Platform2$Modal$headerWithTabsView,
										$author$project$Dashboards2$CloseModal,
										previewExpressionModalClass,
										_List_fromArray(
											[
												{fd: true, dq: $author$project$Icons$Platform2$fileSearch, cL: $elm$core$Maybe$Nothing, Y: 'Audience preview'}
											])),
										A2(
										$elm$html$Html$main_,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'main', previewExpressionModalClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'name', previewExpressionModalClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(name)
													])),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'expression', previewExpressionModalClass)
													]),
												_List_fromArray(
													[
														A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'expression-content', previewExpressionModalClass)
															]),
														_List_fromArray(
															[
																A3($author$project$Platform2$AudienceExpressionViewer$view, flags, $author$project$Dashboards2$moduleClass, expression)
															]))
													]))
											]))
									])))
						]));
			case 15:
				var edited = _v0.a.ak;
				var isUpdating = _v0.a.eC;
				var insightLink = _v0.a.aP;
				var saveDisabled = function () {
					switch (insightLink.$) {
						case 0:
							return !isUpdating;
						case 1:
							return true;
						default:
							var insight = insightLink.c;
							return !($krisajenkins$remotedata$RemoteData$isSuccess(insight) && edited);
					}
				}();
				var imageUrl = function (relativePath) {
					return $author$project$Config$Main$get(flags.j8).dV.d6 + ('/' + relativePath);
				};
				var insightView_ = A2(
					$elm$core$Basics$composeR,
					$author$project$Dashboards2$remoteDataView(
						function (_v11) {
							var insight = _v11.a;
							var insightCategories = _v11.b;
							var mainImageView = function () {
								var _v13 = A2(
									$elm_community$list_extra$List$Extra$find,
									function ($) {
										return $.pt;
									},
									insight.pa);
								if (!_v13.$) {
									var image = _v13.a;
									return A2(
										$elm$html$Html$img,
										_List_fromArray(
											[
												$elm$html$Html$Attributes$src(
												imageUrl(image.rO)),
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['link-insight-modal', 'insight', 'image', 'img']),
												$author$project$Dashboards2$moduleClass)
											]),
										_List_Nil);
								} else {
									return $elm_community$html_extra$Html$Extra$nothing;
								}
							}();
							var insightCategoriesString = A2(
								$elm$core$String$join,
								', ',
								A2(
									$elm$core$List$map,
									function ($) {
										return $.ld;
									},
									A2(
										$elm$core$List$filterMap,
										function (id) {
											return A2($turboMaCk$any_dict$Dict$Any$get, id, insightCategories);
										},
										insight.nP)));
							return _List_fromArray(
								[
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['link-insight-modal', 'insight', 'image']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[mainImageView])),
									A2(
									$elm$html$Html$div,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['link-insight-modal', 'insight', 'info']),
											$author$project$Dashboards2$moduleClass)
										]),
									_List_fromArray(
										[
											A2(
											$elm$html$Html$h4,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['link-insight-modal', 'insight', 'type']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(
													function () {
														var _v12 = insight.kG;
														switch (_v12) {
															case 0:
																return 'Infographic';
															case 1:
																return 'Report';
															case 2:
																return 'Chart of the week';
															default:
																return 'Powerpoint';
														}
													}())
												])),
											A2(
											$elm$html$Html$h3,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['link-insight-modal', 'insight', 'title']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(insight.ld)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['link-insight-modal', 'insight', 'description']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text(insight.hB)
												])),
											A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['link-insight-modal', 'insight', 'date-categories']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													A2(
													$elm$html$Html$div,
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['link-insight-modal', 'insight', 'date']),
															$author$project$Dashboards2$moduleClass)
														]),
													_List_fromArray(
														[
															A2(
															$author$project$Icons$icon,
															_List_fromArray(
																[
																	$author$project$Icons$width(24)
																]),
															$author$project$Icons$Platform2$calendar),
															$elm$html$Html$text(
															function (date) {
																return 'Published ' + date;
															}(
																A3($ryannhg$date_format$DateFormat$format, $author$project$Time$Format$format_D_MMM_YYYY, zone, insight.qC)))
														])),
													A2(
													$elm_community$html_extra$Html$Extra$viewIf,
													!$elm$core$String$isEmpty(insightCategoriesString),
													A2(
														$elm$html$Html$div,
														_List_fromArray(
															[
																A2(
																$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
																_List_fromArray(
																	['link-insight-modal', 'insight', 'categories']),
																$author$project$Dashboards2$moduleClass)
															]),
														_List_fromArray(
															[
																A2(
																$author$project$Icons$icon,
																_List_fromArray(
																	[
																		$author$project$Icons$width(24)
																	]),
																$author$project$Icons$Platform2$category),
																$elm$html$Html$text(insightCategoriesString)
															])))
												]))
										]))
								]);
						}),
					$elm$html$Html$div(
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['link-insight-modal', 'insight']),
								$author$project$Dashboards2$moduleClass)
							])));
				var getLinkString = F2(
					function (v, id) {
						return ($elm$core$String$isEmpty(v) && (!edited)) ? A2(
							$author$project$Platform2$Router$toUrlString,
							flags,
							$author$project$Platform2$Router$InsightsDetail(id)) : v;
					});
				var _v6 = function () {
					switch (insightLink.$) {
						case 0:
							return _Utils_Tuple3('', false, $elm_community$html_extra$Html$Extra$nothing);
						case 1:
							var v = insightLink.a;
							return _Utils_Tuple3(v, true, $elm_community$html_extra$Html$Extra$nothing);
						default:
							var v = insightLink.a;
							var id = insightLink.b;
							var insight = insightLink.c;
							return _Utils_Tuple3(
								A2(getLinkString, v, id),
								$krisajenkins$remotedata$RemoteData$isFailure(insight),
								insightView_(
									A3($krisajenkins$remotedata$RemoteData$map2, $elm$core$Tuple$pair, insight, store.kF)));
					}
				}();
				var value = _v6.a;
				var isInvalid = _v6.b;
				var insightView = _v6.c;
				return A2(
					$author$project$Dashboards2$genericModalView,
					config,
					{
						aH: _List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['link-insight-modal', 'apply-btn']),
										$author$project$Dashboards2$moduleClass),
										$elm$html$Html$Attributes$disabled(saveDisabled),
										$elm$html$Html$Events$onClick(
										function () {
											var _v8 = _Utils_Tuple2(saveDisabled, insightLink);
											_v8$2:
											while (true) {
												if (!_v8.a) {
													switch (_v8.b.$) {
														case 2:
															if (_v8.b.c.$ === 3) {
																var _v9 = _v8.b;
																var insight = _v9.c.a;
																return config.a(
																	$author$project$Dashboards2$ApplyInsightLink(
																		$elm$core$Maybe$Just(
																			{b: insight.b, mL: insight.kG})));
															} else {
																break _v8$2;
															}
														case 0:
															var _v10 = _v8.b;
															return config.a(
																$author$project$Dashboards2$ApplyInsightLink($elm$core$Maybe$Nothing));
														default:
															break _v8$2;
													}
												} else {
													break _v8$2;
												}
											}
											return config.y;
										}())
									]),
								_List_fromArray(
									[
										$elm$html$Html$text(
										isUpdating ? 'Update' : 'Apply')
									]))
							]),
						U: A2(
							$elm$html$Html$map,
							config.a,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'link-insight-modal', $author$project$Dashboards2$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['link-insight-modal', 'input-cont']),
												$author$project$Dashboards2$moduleClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$input,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$withStates,
														_List_fromArray(
															[
																_Utils_Tuple2('invalid', isInvalid)
															]),
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['link-insight-modal', 'input']),
															$author$project$Dashboards2$moduleClass)),
														$elm$html$Html$Attributes$placeholder('Paste insight link here'),
														$elm$html$Html$Events$onInput($author$project$Dashboards2$OnInputInsightModal),
														$elm$html$Html$Attributes$value(value)
													]),
												_List_Nil),
												A2(
												$elm$html$Html$button,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['link-insight-modal', 'input', 'remove']),
														$author$project$Dashboards2$moduleClass),
														$elm$html$Html$Events$onClick($author$project$Dashboards2$InsightModalRemoveLink)
													]),
												_List_fromArray(
													[
														A2($author$project$Icons$icon, _List_Nil, $author$project$Icons$Platform2$cross)
													]))
											])),
										A2(
										$elm_community$html_extra$Html$Extra$viewIf,
										isInvalid,
										A2(
											$elm$html$Html$div,
											_List_fromArray(
												[
													A2(
													$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
													_List_fromArray(
														['link-insight-modal', 'invalid-msg']),
													$author$project$Dashboards2$moduleClass)
												]),
											_List_fromArray(
												[
													$elm$html$Html$text('Link not recognised')
												]))),
										insightView
									]))),
						ch: _List_Nil,
						cu: 'Link insight',
						cF: _List_Nil,
						cG: 3
					});
			case 16:
				var modalState = _v0.a;
				if (modalState.$ === 1) {
					var modalData = modalState.a;
					var nothingChanged = function () {
						var _v16 = _Utils_Tuple2(modalData.bq, modalData.d);
						_v16$8:
						while (true) {
							switch (_v16.a.$) {
								case 0:
									if (!_v16.b.$) {
										var _v17 = _v16.a;
										var _v18 = _v16.b;
										return true;
									} else {
										break _v16$8;
									}
								case 3:
									if (_v16.b.$ === 3) {
										var _v19 = _v16.a;
										var _v20 = _v16.b;
										return true;
									} else {
										break _v16$8;
									}
								case 1:
									if (_v16.b.$ === 1) {
										var _v21 = _v16.a.a;
										var orgIds = _v21.a;
										var userEmails = _v21.b;
										var _v22 = _v16.b.a;
										var orgIds2 = _v22.a;
										var userEmails2 = _v22.b;
										return A2(
											$elm$core$List$all,
											$elm$core$Basics$identity,
											_List_fromArray(
												[
													_Utils_eq(
													$elm$core$List$length(orgIds),
													$elm$core$List$length(orgIds2)),
													_Utils_eq(
													$elm$core$List$length(userEmails),
													$elm$core$List$length(userEmails2)),
													A2(
													$elm$core$List$all,
													$elm$core$Basics$identity,
													A2(
														$elm$core$List$map,
														function (orgId) {
															return A2($elm$core$List$member, orgId, orgIds2);
														},
														orgIds)),
													A2(
													$elm$core$List$all,
													$elm$core$Basics$identity,
													A2(
														$elm$core$List$map,
														function (userEmail) {
															return A2($elm$core$List$member, userEmail, userEmails2);
														},
														userEmails))
												]));
									} else {
										break _v16$8;
									}
								case 2:
									if (_v16.b.$ === 2) {
										var _v23 = _v16.a.a;
										var maybeOrgId = _v23.a;
										var userEmails = _v23.b;
										var _v24 = _v16.b.a;
										var maybeOrgId2 = _v24.a;
										var userEmails2 = _v24.b;
										return A2(
											$elm$core$List$all,
											$elm$core$Basics$identity,
											_List_fromArray(
												[
													_Utils_eq(maybeOrgId, maybeOrgId2),
													_Utils_eq(
													$elm$core$List$length(userEmails),
													$elm$core$List$length(userEmails2)),
													A2(
													$elm$core$List$all,
													$elm$core$Basics$identity,
													A2(
														$elm$core$List$map,
														function (userEmail) {
															return A2($elm$core$List$member, userEmail, userEmails2);
														},
														userEmails))
												]));
									} else {
										break _v16$8;
									}
								case 8:
									if (_v16.b.$ === 8) {
										var _v25 = _v16.a;
										var _v26 = _v16.b;
										return true;
									} else {
										break _v16$8;
									}
								case 6:
									if (_v16.b.$ === 6) {
										var _v27 = _v16.a.a;
										var orgIds = _v27.a;
										var userEmails = _v27.b;
										var _v28 = _v16.b.a;
										var orgIds2 = _v28.a;
										var userEmails2 = _v28.b;
										return A2(
											$elm$core$List$all,
											$elm$core$Basics$identity,
											_List_fromArray(
												[
													_Utils_eq(
													$elm$core$List$length(orgIds),
													$elm$core$List$length(orgIds2)),
													_Utils_eq(
													$elm$core$List$length(userEmails),
													$elm$core$List$length(userEmails2)),
													A2(
													$elm$core$List$all,
													$elm$core$Basics$identity,
													A2(
														$elm$core$List$map,
														function (orgId) {
															return A2($elm$core$List$member, orgId, orgIds2);
														},
														orgIds)),
													A2(
													$elm$core$List$all,
													$elm$core$Basics$identity,
													A2(
														$elm$core$List$map,
														function (userEmail) {
															return A2($elm$core$List$member, userEmail, userEmails2);
														},
														userEmails))
												]));
									} else {
										break _v16$8;
									}
								case 7:
									if (_v16.b.$ === 7) {
										var _v29 = _v16.a.a;
										var maybeOrgId = _v29.a;
										var userEmails = _v29.b;
										var _v30 = _v16.b.a;
										var maybeOrgId2 = _v30.a;
										var userEmails2 = _v30.b;
										return A2(
											$elm$core$List$all,
											$elm$core$Basics$identity,
											_List_fromArray(
												[
													_Utils_eq(maybeOrgId, maybeOrgId2),
													_Utils_eq(
													$elm$core$List$length(userEmails),
													$elm$core$List$length(userEmails2)),
													A2(
													$elm$core$List$all,
													$elm$core$Basics$identity,
													A2(
														$elm$core$List$map,
														function (userEmail) {
															return A2($elm$core$List$member, userEmail, userEmails2);
														},
														userEmails))
												]));
									} else {
										break _v16$8;
									}
								case 4:
									if (_v16.b.$ === 4) {
										var _v31 = _v16.a;
										var _v32 = _v16.b;
										return true;
									} else {
										break _v16$8;
									}
								default:
									break _v16$8;
							}
						}
						return false;
					}();
					var maybeDashboardId = $author$project$Dashboards2$Router$getDashboardId(route);
					var userIsOwner = A2(
						$elm$core$Maybe$withDefault,
						false,
						A2(
							$elm$core$Maybe$map,
							function (dashboard) {
								return _Utils_eq(dashboard.dG, flags.mQ.b);
							},
							A2(
								$elm$core$Maybe$andThen,
								function (dashboardId) {
									return $krisajenkins$remotedata$RemoteData$toMaybe(
										A2($author$project$Store$Platform2$getDashboard, dashboardId, store.v));
								},
								maybeDashboardId)));
					var disabledShareButton = nothingChanged;
					var disabledBtnCopy = modalData.f9 ? 'Please wait for the bulk add to finish validating' : 'Nothing changed yet';
					var withTooltip = function (content) {
						return A2(
							$author$project$CoolTip$Platform2$viewIf,
							disabledShareButton,
							{lB: 0, mu: content, mG: disabledBtnCopy, mL: $author$project$CoolTip$Global, m2: _List_Nil});
					};
					return A2(
						$author$project$Dashboards2$genericModalWithContentAfterFooterView,
						config,
						{
							jb: A3($author$project$Dashboards2$viewShareModalAfterFooterContent, config, maybeDashboardId, $author$project$Dashboards2$moduleClass),
							aH: _List_fromArray(
								[
									withTooltip(
									A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['share-modal', 'submit']),
												$author$project$Dashboards2$moduleClass),
												$elm$html$Html$Events$onClick(
												config.a(
													$author$project$Dashboards2$ShareDashboard(
														{bV: true, dK: $author$project$Dashboards2$ByNewSharedWith}))),
												$elm$html$Html$Attributes$disabled(disabledShareButton)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Share')
											])))
								]),
							U: A5(
								$author$project$Dashboards2$viewShareModalContent,
								config,
								modalData,
								flags,
								{mS: userIsOwner},
								$author$project$Dashboards2$moduleClass),
							ch: _List_Nil,
							cu: 'Share dashboard',
							cF: _List_fromArray(
								['sharing-modal']),
							cG: 3
						});
				} else {
					return A2(
						$author$project$Dashboards2$genericModalView,
						config,
						{
							aH: _List_fromArray(
								[
									A2(
									$elm$html$Html$button,
									_List_fromArray(
										[
											A2(
											$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
											_List_fromArray(
												['share-modal', 'submit']),
											$author$project$Dashboards2$moduleClass),
											$elm$html$Html$Attributes$disabled(true)
										]),
									_List_fromArray(
										[
											$elm$html$Html$text('Share')
										]))
								]),
							U: $author$project$Platform2$Spinner$view,
							ch: _List_Nil,
							cu: 'Share dashboard',
							cF: _List_fromArray(
								['sharing-modal']),
							cG: 3
						});
				}
			case 17:
				var data = _v0.a;
				var copy = A2($elm$core$Maybe$withDefault, '', data.fx);
				var limitCopy = A2(
					$elm$core$String$join,
					'/',
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[
								$elm$core$String$length(copy),
								$author$project$Dashboards2$descriptionLimit
							])));
				return A2(
					$author$project$Dashboards2$genericModalView,
					config,
					{
						aH: _List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['add-description-modal', 'submit']),
										$author$project$Dashboards2$moduleClass),
										A2(
										$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
										data.ak,
										$elm$html$Html$Events$onClick(
											config.a(
												$author$project$Dashboards2$ApplyDashboardDescription(data.fx)))),
										$elm$html$Html$Attributes$disabled(!data.ak)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							]),
						U: A2(
							$elm$html$Html$map,
							config.a,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'add-description-modal', $author$project$Dashboards2$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['add-description-modal', 'editor']),
												$author$project$Dashboards2$moduleClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$textarea,
												$author$project$Gwi$Html$Attributes$withDisabledGrammarly(
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['add-description-modal', 'editor', 'textarea']),
															$author$project$Dashboards2$moduleClass),
															$elm$html$Html$Attributes$value(copy),
															$elm$html$Html$Attributes$placeholder('Enter description'),
															$elm$html$Html$Events$onInput($author$project$Dashboards2$AddDescriptionOnInput)
														])),
												_List_Nil),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
														_List_fromArray(
															['add-description-modal', 'editor', 'limit']),
														$author$project$Dashboards2$moduleClass)
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(limitCopy)
													]))
											]))
									]))),
						ch: _List_Nil,
						cu: 'Add description to your dashboard',
						cF: _List_Nil,
						cG: 0
					});
			case 18:
				var chartBrowserModel = _v0.a;
				var headerTabs = _List_fromArray(
					[
						{fd: true, dq: $author$project$Icons$Platform2$charts, cL: $elm$core$Maybe$Nothing, Y: 'Select Chart'}
					]);
				var chartBrowserModalClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'chart-browser-modal', $author$project$Dashboards2$moduleClass);
				return A4(
					$author$project$Dashboards2$modalSkeletonView,
					config,
					$elm$core$Maybe$Nothing,
					4,
					_List_fromArray(
						[
							A2(
							$elm$html$Html$map,
							config.a,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										$GlobalWebIndex$class_namespaces$WeakCss$toClass(chartBrowserModalClass)
									]),
								_List_fromArray(
									[
										A3($author$project$Platform2$Modal$headerWithTabsView, $author$project$Dashboards2$CloseModal, chartBrowserModalClass, headerTabs),
										A2(
										$elm$html$Html$main_,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', chartBrowserModalClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$map,
												$author$project$Dashboards2$ChartBrowserMsg,
												A4($author$project$Dashboards2$ChartBrowser$view, flags, store, zone, chartBrowserModel))
											]))
									])))
						]));
			default:
				var data = _v0.a;
				var widget = data.bO;
				var chartWidget = data.dg;
				var saveAction = config.a(
					$author$project$Dashboards2$SaveWidget(
						_Utils_update(
							widget,
							{
								U: $author$project$Data$Platform2$ChartContent(chartWidget)
							})));
				var limitCopy = A2(
					$elm$core$String$join,
					'/',
					A2(
						$elm$core$List$map,
						$elm$core$String$fromInt,
						_List_fromArray(
							[
								$elm$core$String$length(chartWidget.b2),
								$author$project$Dashboards2$addChartNoteLimit
							])));
				return A2(
					$author$project$Dashboards2$genericModalView,
					config,
					{
						aH: _List_fromArray(
							[
								A2(
								$elm$html$Html$button,
								_List_fromArray(
									[
										A2(
										$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
										_List_fromArray(
											['edit-widget-name-description-modal', 'submit']),
										$author$project$Dashboards2$moduleClass),
										A2(
										$elm_community$html_extra$Html$Attributes$Extra$attributeIf,
										data.ak,
										$elm$html$Html$Events$onClick(saveAction)),
										$elm$html$Html$Attributes$disabled(!data.ak)
									]),
								_List_fromArray(
									[
										$elm$html$Html$text('Save')
									]))
							]),
						U: A2(
							$elm$html$Html$map,
							config.a,
							A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'edit-widget-name-description-modal', $author$project$Dashboards2$moduleClass)
									]),
								_List_fromArray(
									[
										A2(
										$elm$html$Html$div,
										_List_Nil,
										_List_fromArray(
											[
												A2(
												$author$project$Platform2$Input$Text$view,
												{go: $author$project$Dashboards2$EditWidgetNameOnInput, cO: 'Chart name'},
												_List_fromArray(
													[
														$author$project$Platform2$Input$Text$class(
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['edit-widget-name-description-modal', 'name-input']),
															$author$project$Dashboards2$moduleClass)),
														$author$project$Platform2$Input$Text$value(chartWidget.ld),
														$author$project$Platform2$Input$Text$id('edit-chart-name-input-id'),
														$author$project$Platform2$Input$Text$limit($author$project$Dashboards2$addChartNameLimit)
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['edit-widget-name-description-modal', 'info']),
												$author$project$Dashboards2$moduleClass)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text('Below could be any extra information someone might need. It could also be an insight. '),
												A2(
												$elm$html$Html$strong,
												_List_Nil,
												_List_fromArray(
													[
														$elm$html$Html$text('The description will appear under the chart title.')
													]))
											])),
										A2(
										$elm$html$Html$div,
										_List_fromArray(
											[
												A2(
												$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
												_List_fromArray(
													['edit-widget-name-description-modal', 'editor']),
												$author$project$Dashboards2$moduleClass)
											]),
										_List_fromArray(
											[
												A2(
												$elm$html$Html$textarea,
												$author$project$Gwi$Html$Attributes$withDisabledGrammarly(
													_List_fromArray(
														[
															A2(
															$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
															_List_fromArray(
																['edit-widget-name-description-modal', 'editor', 'textarea']),
															$author$project$Dashboards2$moduleClass),
															$elm$html$Html$Attributes$value(chartWidget.b2),
															$elm$html$Html$Attributes$placeholder('Optional'),
															$elm$html$Html$Events$onInput($author$project$Dashboards2$EditWidgetDescriptionOnInput)
														])),
												_List_Nil),
												A2(
												$elm$html$Html$div,
												_List_fromArray(
													[
														A2(
														$GlobalWebIndex$class_namespaces$WeakCss$withStates,
														_List_fromArray(
															[
																_Utils_Tuple2(
																'reached',
																_Utils_cmp(
																	$elm$core$String$length(chartWidget.b2),
																	$author$project$Dashboards2$addChartNoteLimit - 10) > -1)
															]),
														A2(
															$GlobalWebIndex$class_namespaces$WeakCss$addMany,
															_List_fromArray(
																['edit-widget-name-description-modal', 'editor', 'limit']),
															$author$project$Dashboards2$moduleClass))
													]),
												_List_fromArray(
													[
														$elm$html$Html$text(limitCopy)
													]))
											]))
									]))),
						ch: _List_Nil,
						cu: 'Edit title/description',
						cF: _List_Nil,
						cG: 0
					});
		}
	});
var $author$project$Dashboards2$notificationClass = A2($GlobalWebIndex$class_namespaces$WeakCss$add, 'notifications', $author$project$Dashboards2$moduleClass);
var $author$project$Dashboards2$routeNotFoundView = function (config) {
	return A2(
		$elm$html$Html$div,
		_List_fromArray(
			[
				A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'not-found', $author$project$Dashboards2$moduleClass)
			]),
		_List_fromArray(
			[
				A2(
				$elm$html$Html$h1,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['not-found', 'header']),
						$author$project$Dashboards2$moduleClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('Oops!')
					])),
				A2(
				$elm$html$Html$p,
				_List_fromArray(
					[
						A2(
						$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
						_List_fromArray(
							['not-found', 'copy']),
						$author$project$Dashboards2$moduleClass)
					]),
				_List_fromArray(
					[
						$elm$html$Html$text('We couldn\'t find what you were looking for.'),
						A2($elm$html$Html$br, _List_Nil, _List_Nil),
						$elm$html$Html$text('Check the address again or go to the '),
						A2(
						$elm$html$Html$a,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
								_List_fromArray(
									['not-found', 'link']),
								$author$project$Dashboards2$moduleClass),
								$elm$html$Html$Events$onClick(
								config.as($author$project$Dashboards2$Router$DashboardsList))
							]),
						_List_fromArray(
							[
								$elm$html$Html$text('homepage')
							]))
					]))
			]));
};
var $author$project$Platform2$Notification$Queue$InnerMsg = function (a) {
	return {$: 2, a: a};
};
var $author$project$Platform2$Notification$Queue$idToString = function (id) {
	if (!id.$) {
		var _int = id.a;
		return 'generic:' + $elm$core$String$fromInt(_int);
	} else {
		var string = id.a;
		return 'userDefined:' + string;
	}
};
var $turboMaCk$queue$Queue$isEmpty = function (_v0) {
	var fl = _v0.a;
	var rl = _v0.b;
	return $elm$core$List$isEmpty(fl) && $elm$core$List$isEmpty(rl);
};
var $author$project$Platform2$Notification$Queue$isEmpty = function (_v0) {
	var notifications = _v0.bn;
	return $turboMaCk$queue$Queue$isEmpty(notifications);
};
var $author$project$Platform2$Notification$notificationNamespace = $GlobalWebIndex$class_namespaces$WeakCss$add('notification');
var $author$project$Platform2$Notification$view = F3(
	function (config, namespace, _v0) {
		var content = _v0.U;
		var state = _v0.rA;
		var button = _v0.df;
		var icon = _v0.dq;
		var closeMsg = _v0.cg;
		var concatenatedNamespaces = $author$project$Platform2$Notification$notificationNamespace(namespace);
		return A2(
			$elm$html$Html$map,
			config.m1,
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'wrapper', namespace)
					]),
				_List_fromArray(
					[
						A2(
						$elm$html$Html$div,
						_List_fromArray(
							[
								A2(
								$GlobalWebIndex$class_namespaces$WeakCss$withStates,
								_List_fromArray(
									[
										_Utils_Tuple2('hiding', state === 1)
									]),
								concatenatedNamespaces),
								A2(
								$elm$html$Html$Attributes$style,
								'transition',
								'opacity ' + ($elm$core$String$fromFloat($author$project$Platform2$Notification$hidingTimeout) + 'ms'))
							]),
						_List_fromArray(
							[
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'icon', concatenatedNamespaces)
									]),
								_List_fromArray(
									[
										A2($author$project$Icons$icon, _List_Nil, icon)
									])),
								A2(
								$elm$html$Html$div,
								_List_fromArray(
									[
										A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'content', concatenatedNamespaces)
									]),
								_List_fromArray(
									[content])),
								A2(
								$elm_community$html_extra$Html$Extra$viewMaybe,
								function (button_) {
									return A2(
										$elm$html$Html$button,
										_List_fromArray(
											[
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'action-button', concatenatedNamespaces),
												$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(button_.cL)
											]),
										_List_fromArray(
											[
												$elm$html$Html$text(button_.h4)
											]));
								},
								button),
								A2(
								$elm_community$html_extra$Html$Extra$viewMaybe,
								function (closeMsg_) {
									return A2(
										$elm$html$Html$a,
										_List_fromArray(
											[
												$elm_community$html_extra$Html$Events$Extra$onClickPreventDefault(closeMsg_),
												A2($GlobalWebIndex$class_namespaces$WeakCss$nest, 'close', concatenatedNamespaces)
											]),
										_List_fromArray(
											[
												A2(
												$author$project$Icons$icon,
												_List_fromArray(
													[
														$author$project$Icons$height(52)
													]),
												$author$project$Icons$Platform2$cross)
											]));
								},
								closeMsg)
							]))
					])));
	});
var $author$project$Platform2$Notification$Queue$view = F2(
	function (namespace, queue) {
		return A2(
			$elm_community$html_extra$Html$Extra$viewIf,
			!$author$project$Platform2$Notification$Queue$isEmpty(queue),
			A2(
				$elm$html$Html$div,
				_List_fromArray(
					[
						$GlobalWebIndex$class_namespaces$WeakCss$toClass(namespace)
					]),
				_List_fromArray(
					[
						A3(
						$elm$html$Html$Keyed$node,
						'div',
						_List_Nil,
						A2(
							$elm$core$List$map,
							function (_v0) {
								var id = _v0.b;
								var notification = _v0.cI;
								return _Utils_Tuple2(
									$author$project$Platform2$Notification$Queue$idToString(id),
									A3(
										$author$project$Platform2$Notification$view,
										{m1: $author$project$Platform2$Notification$Queue$InnerMsg},
										namespace,
										notification));
							},
							$elm$core$List$reverse(
								$author$project$Platform2$Notification$Queue$toList(queue))))
					])));
	});
var $author$project$Dashboards2$view = F6(
	function (config, flags, zone, store, route, model) {
		return A2(
			$elm$html$Html$div,
			_List_fromArray(
				[
					A2(
					$GlobalWebIndex$class_namespaces$WeakCss$withStates,
					_List_fromArray(
						[
							_Utils_Tuple2(
							'dragging',
							A2($author$project$Dashboards2$Detail$isDragging, config.V, model))
						]),
					$author$project$Dashboards2$moduleClass)
				]),
			function () {
				var _v0 = model.dM;
				if (!_v0.$) {
					var audienceId = _v0.a;
					return _List_fromArray(
						[
							A2(
							$elm$html$Html$div,
							_List_fromArray(
								[
									A2(
									$GlobalWebIndex$class_namespaces$WeakCss$nestMany,
									_List_fromArray(
										['audience-builder']),
									$author$project$Dashboards2$moduleClass)
								]),
							_List_fromArray(
								[
									A6($author$project$Dashboards2$audienceBuilderView, config, flags, audienceId, store, route, model)
								]))
						]);
				} else {
					return _Utils_ap(
						function () {
							switch (route.$) {
								case 3:
									return _List_fromArray(
										[$elm_community$html_extra$Html$Extra$nothing]);
								case 4:
									return _List_fromArray(
										[
											$author$project$Dashboards2$routeNotFoundView(config)
										]);
								case 0:
									return A5($author$project$Dashboards2$listView, flags, config, zone, store, model);
								case 1:
									var id = route.a;
									return _List_fromArray(
										[
											A5(
											$author$project$Dashboards2$detailView,
											flags,
											config,
											$author$project$Dashboards2$Detail$SavedDashboardId(id),
											store,
											model)
										]);
								default:
									return _List_fromArray(
										[
											function () {
											var _v2 = A2(
												$elm$core$Maybe$andThen,
												A2(
													$elm$core$Basics$composeR,
													A2($author$project$Dashboards2$getNewEmptyDashboard, flags, store),
													$krisajenkins$remotedata$RemoteData$toMaybe),
												model.dk);
											if (!_v2.$) {
												var dashboard = _v2.a;
												return A5(
													$author$project$Dashboards2$detailView,
													flags,
													config,
													$author$project$Dashboards2$Detail$UnsavedDashboard(dashboard),
													store,
													model);
											} else {
												return $author$project$Platform2$Spinner$view;
											}
										}()
										]);
							}
						}(),
						_List_fromArray(
							[
								A6($author$project$Dashboards2$modalView, config, flags, zone, store, route, model),
								A2($author$project$Dashboards2$metadataView, config, model),
								A2(
								$elm$html$Html$map,
								A2($elm$core$Basics$composeL, config.a, $author$project$Dashboards2$NotificationQueueMsg),
								A2($author$project$Platform2$Notification$Queue$view, $author$project$Dashboards2$notificationClass, model.cJ))
							]));
				}
			}());
	});
var $turboMaCk$glue$Glue$Lazy$view = F3(
	function (_v0, v, model) {
		var rec = _v0;
		return A2(
			$elm$core$Maybe$map,
			A2(
				$elm$core$Basics$composeL,
				$elm$html$Html$map(rec.a),
				v),
			rec.oS(model));
	});
var $author$project$Dashboards2Main$view = function (model) {
	var dashboardsView = F5(
		function (flags, zone, route, platform2Store_, s) {
			return A3(
				$turboMaCk$glue$Glue$Lazy$view,
				$author$project$Dashboards2Main$dashboards,
				A5($author$project$Dashboards2$view, s.aX, flags, zone, platform2Store_, route),
				model);
		});
	return $elm_community$result_extra$Result$Extra$merge(
		A2(
			$elm$core$Result$mapError,
			$author$project$Dashboards2Main$errorView,
			A2(
				$elm$core$Result$andThen,
				function (state) {
					return A2(
						$elm$core$Result$fromMaybe,
						$author$project$Dashboards2Main$NotMounted,
						A5(dashboardsView, state.oN, state.g3, state.af, state.s, state));
				},
				$author$project$Dashboards2Main$handleMounting(model))));
};
var $author$project$Dashboards2Main$main = $elm$browser$Browser$element(
	{pj: $author$project$Dashboards2Main$init_, mq: $author$project$Dashboards2Main$subscriptions, mO: $author$project$Dashboards2Main$update, sb: $author$project$Dashboards2Main$view});
_Platform_export({'Dashboards2Main':{'init':$author$project$Dashboards2Main$main($elm$json$Json$Decode$value)(0)}});}(this));